(function (scope) {
  'use strict';

  function F(arity, fun, wrapper) {
    wrapper.a = arity;
    wrapper.f = fun;
    return wrapper;
  }

  function F2(fun) {
    return F(2, fun, function (a) {
      return function (b) {
        return fun(a, b);
      };
    });
  }

  function F3(fun) {
    return F(3, fun, function (a) {
      return function (b) {
        return function (c) {
          return fun(a, b, c);
        };
      };
    });
  }

  function F4(fun) {
    return F(4, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return fun(a, b, c, d);
          };
        };
      };
    });
  }

  function F5(fun) {
    return F(5, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return fun(a, b, c, d, e);
            };
          };
        };
      };
    });
  }

  function F6(fun) {
    return F(6, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return fun(a, b, c, d, e, f);
              };
            };
          };
        };
      };
    });
  }

  function F7(fun) {
    return F(7, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return fun(a, b, c, d, e, f, g);
                };
              };
            };
          };
        };
      };
    });
  }

  function F8(fun) {
    return F(8, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return function (h) {
                    return fun(a, b, c, d, e, f, g, h);
                  };
                };
              };
            };
          };
        };
      };
    });
  }

  function F9(fun) {
    return F(9, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return function (h) {
                    return function (i) {
                      return fun(a, b, c, d, e, f, g, h, i);
                    };
                  };
                };
              };
            };
          };
        };
      };
    });
  }

  function A2(fun, a, b) {
    return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
  }

  function A3(fun, a, b, c) {
    return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
  }

  function A4(fun, a, b, c, d) {
    return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
  }

  function A5(fun, a, b, c, d, e) {
    return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
  }

  function A6(fun, a, b, c, d, e, f) {
    return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
  }

  function A7(fun, a, b, c, d, e, f, g) {
    return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
  }

  function A8(fun, a, b, c, d, e, f, g, h) {
    return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
  }

  function A9(fun, a, b, c, d, e, f, g, h, i) {
    return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
  }

  var _JsArray_empty = [];

  function _JsArray_singleton(value) {
    return [value];
  }

  function _JsArray_length(array) {
    return array.length;
  }

  var _JsArray_initialize = F3(function (size, offset, func) {
    var result = new Array(size);

    for (var i = 0; i < size; i++) {
      result[i] = func(offset + i);
    }

    return result;
  });

  var _JsArray_initializeFromList = F2(function (max, ls) {
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++) {
      result[i] = ls.a;
      ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
  });

  var _JsArray_unsafeGet = F2(function (index, array) {
    return array[index];
  });

  var _JsArray_unsafeSet = F3(function (index, value, array) {
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++) {
      result[i] = array[i];
    }

    result[index] = value;
    return result;
  });

  var _JsArray_push = F2(function (value, array) {
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++) {
      result[i] = array[i];
    }

    result[length] = value;
    return result;
  });

  var _JsArray_foldl = F3(function (func, acc, array) {
    var length = array.length;

    for (var i = 0; i < length; i++) {
      acc = A2(func, array[i], acc);
    }

    return acc;
  });

  var _JsArray_foldr = F3(function (func, acc, array) {
    for (var i = array.length - 1; i >= 0; i--) {
      acc = A2(func, array[i], acc);
    }

    return acc;
  });

  var _JsArray_map = F2(function (func, array) {
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++) {
      result[i] = func(array[i]);
    }

    return result;
  });

  var _JsArray_indexedMap = F3(function (func, offset, array) {
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++) {
      result[i] = A2(func, offset + i, array[i]);
    }

    return result;
  });

  var _JsArray_slice = F3(function (from, to, array) {
    return array.slice(from, to);
  });

  var _JsArray_appendN = F3(function (n, dest, source) {
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length) {
      itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++) {
      result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++) {
      result[i + destLen] = source[i];
    }

    return result;
  }); // LOG


  var _Debug_log = F2(function (tag, value) {
    return value;
  });

  var _Debug_log_UNUSED = F2(function (tag, value) {
    console.log(tag + ': ' + _Debug_toString(value));
    return value;
  }); // TODOS


  function _Debug_todo(moduleName, region) {
    return function (message) {
      _Debug_crash(8, moduleName, region, message);
    };
  }

  function _Debug_todoCase(moduleName, region, value) {
    return function (message) {
      _Debug_crash(9, moduleName, region, value, message);
    };
  } // TO STRING


  function _Debug_toString(value) {
    return '<internals>';
  }

  function _Debug_toString_UNUSED(value) {
    return _Debug_toAnsiString(false, value);
  }

  function _Debug_toAnsiString(ansi, value) {
    if (typeof value === 'function') {
      return _Debug_internalColor(ansi, '<function>');
    }

    if (typeof value === 'boolean') {
      return _Debug_ctorColor(ansi, value ? 'True' : 'False');
    }

    if (typeof value === 'number') {
      return _Debug_numberColor(ansi, value + '');
    }

    if (value instanceof String) {
      return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
    }

    if (typeof value === 'string') {
      return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
    }

    if (typeof value === 'object' && '$' in value) {
      var tag = value.$;

      if (typeof tag === 'number') {
        return _Debug_internalColor(ansi, '<internals>');
      }

      if (tag[0] === '#') {
        var output = [];

        for (var k in value) {
          if (k === '$') continue;
          output.push(_Debug_toAnsiString(ansi, value[k]));
        }

        return '(' + output.join(',') + ')';
      }

      if (tag === 'Set_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Set') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
      }

      if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Dict') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
      }

      if (tag === 'Array_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Array') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
      }

      if (tag === '::' || tag === '[]') {
        var output = '[';
        value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);

        for (; value.b; value = value.b) // WHILE_CONS
        {
          output += ',' + _Debug_toAnsiString(ansi, value.a);
        }

        return output + ']';
      }

      var output = '';

      for (var i in value) {
        if (i === '$') continue;

        var str = _Debug_toAnsiString(ansi, value[i]);

        var c0 = str[0];
        var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
        output += ' ' + (parenless ? str : '(' + str + ')');
      }

      return _Debug_ctorColor(ansi, tag) + output;
    }

    if (typeof DataView === 'function' && value instanceof DataView) {
      return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
    }

    if (typeof File !== 'undefined' && value instanceof File) {
      return _Debug_internalColor(ansi, '<' + value.name + '>');
    }

    if (typeof value === 'object') {
      var output = [];

      for (var key in value) {
        var field = key[0] === '_' ? key.slice(1) : key;
        output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
      }

      if (output.length === 0) {
        return '{}';
      }

      return '{ ' + output.join(', ') + ' }';
    }

    return _Debug_internalColor(ansi, '<internals>');
  }

  function _Debug_addSlashes(str, isChar) {
    var s = str.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r').replace(/\v/g, '\\v').replace(/\0/g, '\\0');

    if (isChar) {
      return s.replace(/\'/g, '\\\'');
    } else {
      return s.replace(/\"/g, '\\"');
    }
  }

  function _Debug_ctorColor(ansi, string) {
    return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
  }

  function _Debug_numberColor(ansi, string) {
    return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
  }

  function _Debug_stringColor(ansi, string) {
    return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
  }

  function _Debug_charColor(ansi, string) {
    return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
  }

  function _Debug_fadeColor(ansi, string) {
    return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
  }

  function _Debug_internalColor(ansi, string) {
    return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
  }

  function _Debug_toHexDigit(n) {
    return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
  } // CRASH


  function _Debug_crash(identifier) {
    throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
  }

  function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4) {
    switch (identifier) {
      case 0:
        throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

      case 1:
        throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

      case 2:
        var jsonErrorString = fact1;
        throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

      case 3:
        var portName = fact1;
        throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

      case 4:
        var portName = fact1;
        var problem = fact2;
        throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

      case 5:
        throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

      case 6:
        var moduleName = fact1;
        throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

      case 8:
        var moduleName = fact1;
        var region = fact2;
        var message = fact3;
        throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

      case 9:
        var moduleName = fact1;
        var region = fact2;
        var value = fact3;
        var message = fact4;
        throw new Error('TODO in module `' + moduleName + '` from the `case` expression ' + _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    ' + _Debug_toString(value).replace('\n', '\n    ') + '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    '));

      case 10:
        throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

      case 11:
        throw new Error('Cannot perform mod 0. Division by zero error.');
    }
  }

  function _Debug_regionToString(region) {
    if (region.Ef.ri === region.dR.ri) {
      return 'on line ' + region.Ef.ri;
    }

    return 'on lines ' + region.Ef.ri + ' through ' + region.dR.ri;
  } // EQUALITY


  function _Utils_eq(x, y) {
    for (var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)) {}

    return isEqual;
  }

  function _Utils_eqHelp(x, y, depth, stack) {
    if (x === y) {
      return true;
    }

    if (typeof x !== 'object' || x === null || y === null) {
      typeof x === 'function' && _Debug_crash(5);
      return false;
    }

    if (depth > 100) {
      stack.push(_Utils_Tuple2(x, y));
      return true;
    }
    /**_UNUSED/
    if (x.$ === 'Set_elm_builtin')
    {
    	x = $elm$core$Set$toList(x);
    	y = $elm$core$Set$toList(y);
    }
    if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
    {
    	x = $elm$core$Dict$toList(x);
    	y = $elm$core$Dict$toList(y);
    }
    //*/

    /**/


    if (x.$ < 0) {
      x = $elm$core$Dict$toList(x);
      y = $elm$core$Dict$toList(y);
    } //*/


    for (var key in x) {
      if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) {
        return false;
      }
    }

    return true;
  }

  var _Utils_equal = F2(_Utils_eq);

  var _Utils_notEqual = F2(function (a, b) {
    return !_Utils_eq(a, b);
  }); // COMPARISONS
  // Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
  // the particular integer values assigned to LT, EQ, and GT.


  function _Utils_cmp(x, y, ord) {
    if (typeof x !== 'object') {
      return x === y ?
      /*EQ*/
      0 : x < y ?
      /*LT*/
      -1 :
      /*GT*/
      1;
    }
    /**_UNUSED/
    if (x instanceof String)
    {
    	var a = x.valueOf();
    	var b = y.valueOf();
    	return a === b ? 0 : a < b ? -1 : 1;
    }
    //*/

    /**/


    if (typeof x.$ === 'undefined') //*/

      /**_UNUSED/
      if (x.$[0] === '#')
      //*/
      {
        return (ord = _Utils_cmp(x.a, y.a)) ? ord : (ord = _Utils_cmp(x.b, y.b)) ? ord : _Utils_cmp(x.c, y.c);
      } // traverse conses until end of a list or a mismatch


    for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES


    return ord || (x.b ?
    /*GT*/
    1 : y.b ?
    /*LT*/
    -1 :
    /*EQ*/
    0);
  }

  var _Utils_lt = F2(function (a, b) {
    return _Utils_cmp(a, b) < 0;
  });

  var _Utils_le = F2(function (a, b) {
    return _Utils_cmp(a, b) < 1;
  });

  var _Utils_gt = F2(function (a, b) {
    return _Utils_cmp(a, b) > 0;
  });

  var _Utils_ge = F2(function (a, b) {
    return _Utils_cmp(a, b) >= 0;
  });

  var _Utils_compare = F2(function (x, y) {
    var n = _Utils_cmp(x, y);

    return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
  }); // COMMON VALUES


  var _Utils_Tuple0 = 0;
  var _Utils_Tuple0_UNUSED = {
    $: '#0'
  };

  function _Utils_Tuple2(a, b) {
    return {
      a: a,
      b: b
    };
  }

  function _Utils_Tuple2_UNUSED(a, b) {
    return {
      $: '#2',
      a: a,
      b: b
    };
  }

  function _Utils_Tuple3(a, b, c) {
    return {
      a: a,
      b: b,
      c: c
    };
  }

  function _Utils_Tuple3_UNUSED(a, b, c) {
    return {
      $: '#3',
      a: a,
      b: b,
      c: c
    };
  }

  function _Utils_chr(c) {
    return c;
  }

  function _Utils_chr_UNUSED(c) {
    return new String(c);
  } // RECORDS


  function _Utils_update(oldRecord, updatedFields) {
    var newRecord = {};

    for (var key in oldRecord) {
      newRecord[key] = oldRecord[key];
    }

    for (var key in updatedFields) {
      newRecord[key] = updatedFields[key];
    }

    return newRecord;
  } // APPEND


  var _Utils_append = F2(_Utils_ap);

  function _Utils_ap(xs, ys) {
    // append Strings
    if (typeof xs === 'string') {
      return xs + ys;
    } // append Lists


    if (!xs.b) {
      return ys;
    }

    var root = _List_Cons(xs.a, ys);

    xs = xs.b;

    for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
    {
      curr = curr.b = _List_Cons(xs.a, ys);
    }

    return root;
  }

  var _List_Nil = {
    $: 0
  };
  var _List_Nil_UNUSED = {
    $: '[]'
  };

  function _List_Cons(hd, tl) {
    return {
      $: 1,
      a: hd,
      b: tl
    };
  }

  function _List_Cons_UNUSED(hd, tl) {
    return {
      $: '::',
      a: hd,
      b: tl
    };
  }

  var _List_cons = F2(_List_Cons);

  function _List_fromArray(arr) {
    var out = _List_Nil;

    for (var i = arr.length; i--;) {
      out = _List_Cons(arr[i], out);
    }

    return out;
  }

  function _List_toArray(xs) {
    for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
    {
      out.push(xs.a);
    }

    return out;
  }

  var _List_map2 = F3(function (f, xs, ys) {
    for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
    {
      arr.push(A2(f, xs.a, ys.a));
    }

    return _List_fromArray(arr);
  });

  var _List_map3 = F4(function (f, xs, ys, zs) {
    for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
    {
      arr.push(A3(f, xs.a, ys.a, zs.a));
    }

    return _List_fromArray(arr);
  });

  var _List_map4 = F5(function (f, ws, xs, ys, zs) {
    for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
    {
      arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
    }

    return _List_fromArray(arr);
  });

  var _List_map5 = F6(function (f, vs, ws, xs, ys, zs) {
    for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
    {
      arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
    }

    return _List_fromArray(arr);
  });

  var _List_sortBy = F2(function (f, xs) {
    return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
      return _Utils_cmp(f(a), f(b));
    }));
  });

  var _List_sortWith = F2(function (f, xs) {
    return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
      var ord = A2(f, a, b);
      return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
    }));
  }); // MATH


  var _Basics_add = F2(function (a, b) {
    return a + b;
  });

  var _Basics_sub = F2(function (a, b) {
    return a - b;
  });

  var _Basics_mul = F2(function (a, b) {
    return a * b;
  });

  var _Basics_fdiv = F2(function (a, b) {
    return a / b;
  });

  var _Basics_idiv = F2(function (a, b) {
    return a / b | 0;
  });

  var _Basics_pow = F2(Math.pow);

  var _Basics_remainderBy = F2(function (b, a) {
    return a % b;
  }); // https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf


  var _Basics_modBy = F2(function (modulus, x) {
    var answer = x % modulus;
    return modulus === 0 ? _Debug_crash(11) : answer > 0 && modulus < 0 || answer < 0 && modulus > 0 ? answer + modulus : answer;
  }); // TRIGONOMETRY


  var _Basics_pi = Math.PI;
  var _Basics_e = Math.E;
  var _Basics_cos = Math.cos;
  var _Basics_sin = Math.sin;
  var _Basics_tan = Math.tan;
  var _Basics_acos = Math.acos;
  var _Basics_asin = Math.asin;
  var _Basics_atan = Math.atan;

  var _Basics_atan2 = F2(Math.atan2); // MORE MATH


  function _Basics_toFloat(x) {
    return x;
  }

  function _Basics_truncate(n) {
    return n | 0;
  }

  function _Basics_isInfinite(n) {
    return n === Infinity || n === -Infinity;
  }

  var _Basics_ceiling = Math.ceil;
  var _Basics_floor = Math.floor;
  var _Basics_round = Math.round;
  var _Basics_sqrt = Math.sqrt;
  var _Basics_log = Math.log;
  var _Basics_isNaN = isNaN; // BOOLEANS

  function _Basics_not(bool) {
    return !bool;
  }

  var _Basics_and = F2(function (a, b) {
    return a && b;
  });

  var _Basics_or = F2(function (a, b) {
    return a || b;
  });

  var _Basics_xor = F2(function (a, b) {
    return a !== b;
  });

  var _String_cons = F2(function (chr, str) {
    return chr + str;
  });

  function _String_uncons(string) {
    var word = string.charCodeAt(0);
    return !isNaN(word) ? $elm$core$Maybe$Just(0xD800 <= word && word <= 0xDBFF ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2)) : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))) : $elm$core$Maybe$Nothing;
  }

  var _String_append = F2(function (a, b) {
    return a + b;
  });

  function _String_length(str) {
    return str.length;
  }

  var _String_map = F2(function (func, string) {
    var len = string.length;
    var array = new Array(len);
    var i = 0;

    while (i < len) {
      var word = string.charCodeAt(i);

      if (0xD800 <= word && word <= 0xDBFF) {
        array[i] = func(_Utils_chr(string[i] + string[i + 1]));
        i += 2;
        continue;
      }

      array[i] = func(_Utils_chr(string[i]));
      i++;
    }

    return array.join('');
  });

  var _String_filter = F2(function (isGood, str) {
    var arr = [];
    var len = str.length;
    var i = 0;

    while (i < len) {
      var char = str[i];
      var word = str.charCodeAt(i);
      i++;

      if (0xD800 <= word && word <= 0xDBFF) {
        char += str[i];
        i++;
      }

      if (isGood(_Utils_chr(char))) {
        arr.push(char);
      }
    }

    return arr.join('');
  });

  function _String_reverse(str) {
    var len = str.length;
    var arr = new Array(len);
    var i = 0;

    while (i < len) {
      var word = str.charCodeAt(i);

      if (0xD800 <= word && word <= 0xDBFF) {
        arr[len - i] = str[i + 1];
        i++;
        arr[len - i] = str[i - 1];
        i++;
      } else {
        arr[len - i] = str[i];
        i++;
      }
    }

    return arr.join('');
  }

  var _String_foldl = F3(function (func, state, string) {
    var len = string.length;
    var i = 0;

    while (i < len) {
      var char = string[i];
      var word = string.charCodeAt(i);
      i++;

      if (0xD800 <= word && word <= 0xDBFF) {
        char += string[i];
        i++;
      }

      state = A2(func, _Utils_chr(char), state);
    }

    return state;
  });

  var _String_foldr = F3(function (func, state, string) {
    var i = string.length;

    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);

      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }

      state = A2(func, _Utils_chr(char), state);
    }

    return state;
  });

  var _String_split = F2(function (sep, str) {
    return str.split(sep);
  });

  var _String_join = F2(function (sep, strs) {
    return strs.join(sep);
  });

  var _String_slice = F3(function (start, end, str) {
    return str.slice(start, end);
  });

  function _String_trim(str) {
    return str.trim();
  }

  function _String_trimLeft(str) {
    return str.replace(/^\s+/, '');
  }

  function _String_trimRight(str) {
    return str.replace(/\s+$/, '');
  }

  function _String_words(str) {
    return _List_fromArray(str.trim().split(/\s+/g));
  }

  function _String_lines(str) {
    return _List_fromArray(str.split(/\r\n|\r|\n/g));
  }

  function _String_toUpper(str) {
    return str.toUpperCase();
  }

  function _String_toLower(str) {
    return str.toLowerCase();
  }

  var _String_any = F2(function (isGood, string) {
    var i = string.length;

    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);

      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }

      if (isGood(_Utils_chr(char))) {
        return true;
      }
    }

    return false;
  });

  var _String_all = F2(function (isGood, string) {
    var i = string.length;

    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);

      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }

      if (!isGood(_Utils_chr(char))) {
        return false;
      }
    }

    return true;
  });

  var _String_contains = F2(function (sub, str) {
    return str.indexOf(sub) > -1;
  });

  var _String_startsWith = F2(function (sub, str) {
    return str.indexOf(sub) === 0;
  });

  var _String_endsWith = F2(function (sub, str) {
    return str.length >= sub.length && str.lastIndexOf(sub) === str.length - sub.length;
  });

  var _String_indexes = F2(function (sub, str) {
    var subLen = sub.length;

    if (subLen < 1) {
      return _List_Nil;
    }

    var i = 0;
    var is = [];

    while ((i = str.indexOf(sub, i)) > -1) {
      is.push(i);
      i = i + subLen;
    }

    return _List_fromArray(is);
  }); // TO STRING


  function _String_fromNumber(number) {
    return number + '';
  } // INT CONVERSIONS


  function _String_toInt(str) {
    var total = 0;
    var code0 = str.charCodeAt(0);
    var start = code0 == 0x2B
    /* + */
    || code0 == 0x2D
    /* - */
    ? 1 : 0;

    for (var i = start; i < str.length; ++i) {
      var code = str.charCodeAt(i);

      if (code < 0x30 || 0x39 < code) {
        return $elm$core$Maybe$Nothing;
      }

      total = 10 * total + code - 0x30;
    }

    return i == start ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
  } // FLOAT CONVERSIONS


  function _String_toFloat(s) {
    // check if it is a hex, octal, or binary number
    if (s.length === 0 || /[\sxbo]/.test(s)) {
      return $elm$core$Maybe$Nothing;
    }

    var n = +s; // faster isNaN check

    return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
  }

  function _String_fromList(chars) {
    return _List_toArray(chars).join('');
  }

  function _Char_toCode(char) {
    var code = char.charCodeAt(0);

    if (0xD800 <= code && code <= 0xDBFF) {
      return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000;
    }

    return code;
  }

  function _Char_fromCode(code) {
    return _Utils_chr(code < 0 || 0x10FFFF < code ? '\uFFFD' : code <= 0xFFFF ? String.fromCharCode(code) : (code -= 0x10000, String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)));
  }

  function _Char_toUpper(char) {
    return _Utils_chr(char.toUpperCase());
  }

  function _Char_toLower(char) {
    return _Utils_chr(char.toLowerCase());
  }

  function _Char_toLocaleUpper(char) {
    return _Utils_chr(char.toLocaleUpperCase());
  }

  function _Char_toLocaleLower(char) {
    return _Utils_chr(char.toLocaleLowerCase());
  }
  /**_UNUSED/
  function _Json_errorToString(error)
  {
  	return $elm$json$Json$Decode$errorToString(error);
  }
  //*/
  // CORE DECODERS


  function _Json_succeed(msg) {
    return {
      $: 0,
      a: msg
    };
  }

  function _Json_fail(msg) {
    return {
      $: 1,
      a: msg
    };
  }

  function _Json_decodePrim(decoder) {
    return {
      $: 2,
      b: decoder
    };
  }

  var _Json_decodeInt = _Json_decodePrim(function (value) {
    return typeof value !== 'number' ? _Json_expecting('an INT', value) : -2147483647 < value && value < 2147483647 && (value | 0) === value ? $elm$core$Result$Ok(value) : isFinite(value) && !(value % 1) ? $elm$core$Result$Ok(value) : _Json_expecting('an INT', value);
  });

  var _Json_decodeBool = _Json_decodePrim(function (value) {
    return typeof value === 'boolean' ? $elm$core$Result$Ok(value) : _Json_expecting('a BOOL', value);
  });

  var _Json_decodeFloat = _Json_decodePrim(function (value) {
    return typeof value === 'number' ? $elm$core$Result$Ok(value) : _Json_expecting('a FLOAT', value);
  });

  var _Json_decodeValue = _Json_decodePrim(function (value) {
    return $elm$core$Result$Ok(_Json_wrap(value));
  });

  var _Json_decodeString = _Json_decodePrim(function (value) {
    return typeof value === 'string' ? $elm$core$Result$Ok(value) : value instanceof String ? $elm$core$Result$Ok(value + '') : _Json_expecting('a STRING', value);
  });

  function _Json_decodeList(decoder) {
    return {
      $: 3,
      b: decoder
    };
  }

  function _Json_decodeArray(decoder) {
    return {
      $: 4,
      b: decoder
    };
  }

  function _Json_decodeNull(value) {
    return {
      $: 5,
      c: value
    };
  }

  var _Json_decodeField = F2(function (field, decoder) {
    return {
      $: 6,
      d: field,
      b: decoder
    };
  });

  var _Json_decodeIndex = F2(function (index, decoder) {
    return {
      $: 7,
      e: index,
      b: decoder
    };
  });

  function _Json_decodeKeyValuePairs(decoder) {
    return {
      $: 8,
      b: decoder
    };
  }

  function _Json_mapMany(f, decoders) {
    return {
      $: 9,
      f: f,
      g: decoders
    };
  }

  var _Json_andThen = F2(function (callback, decoder) {
    return {
      $: 10,
      b: decoder,
      h: callback
    };
  });

  function _Json_oneOf(decoders) {
    return {
      $: 11,
      g: decoders
    };
  } // DECODING OBJECTS


  var _Json_map1 = F2(function (f, d1) {
    return _Json_mapMany(f, [d1]);
  });

  var _Json_map2 = F3(function (f, d1, d2) {
    return _Json_mapMany(f, [d1, d2]);
  });

  var _Json_map3 = F4(function (f, d1, d2, d3) {
    return _Json_mapMany(f, [d1, d2, d3]);
  });

  var _Json_map4 = F5(function (f, d1, d2, d3, d4) {
    return _Json_mapMany(f, [d1, d2, d3, d4]);
  });

  var _Json_map5 = F6(function (f, d1, d2, d3, d4, d5) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
  });

  var _Json_map6 = F7(function (f, d1, d2, d3, d4, d5, d6) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
  });

  var _Json_map7 = F8(function (f, d1, d2, d3, d4, d5, d6, d7) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
  });

  var _Json_map8 = F9(function (f, d1, d2, d3, d4, d5, d6, d7, d8) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
  }); // DECODE


  var _Json_runOnString = F2(function (decoder, string) {
    try {
      var value = JSON.parse(string);
      return _Json_runHelp(decoder, value);
    } catch (e) {
      return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
    }
  });

  var _Json_run = F2(function (decoder, value) {
    return _Json_runHelp(decoder, _Json_unwrap(value));
  });

  function _Json_runHelp(decoder, value) {
    switch (decoder.$) {
      case 2:
        return decoder.b(value);

      case 5:
        return value === null ? $elm$core$Result$Ok(decoder.c) : _Json_expecting('null', value);

      case 3:
        if (!_Json_isArray(value)) {
          return _Json_expecting('a LIST', value);
        }

        return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

      case 4:
        if (!_Json_isArray(value)) {
          return _Json_expecting('an ARRAY', value);
        }

        return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

      case 6:
        var field = decoder.d;

        if (typeof value !== 'object' || value === null || !(field in value)) {
          return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
        }

        var result = _Json_runHelp(decoder.b, value[field]);

        return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

      case 7:
        var index = decoder.e;

        if (!_Json_isArray(value)) {
          return _Json_expecting('an ARRAY', value);
        }

        if (index >= value.length) {
          return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
        }

        var result = _Json_runHelp(decoder.b, value[index]);

        return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

      case 8:
        if (typeof value !== 'object' || value === null || _Json_isArray(value)) {
          return _Json_expecting('an OBJECT', value);
        }

        var keyValuePairs = _List_Nil; // TODO test perf of Object.keys and switch when support is good enough

        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            var result = _Json_runHelp(decoder.b, value[key]);

            if (!$elm$core$Result$isOk(result)) {
              return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
            }

            keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
          }
        }

        return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

      case 9:
        var answer = decoder.f;
        var decoders = decoder.g;

        for (var i = 0; i < decoders.length; i++) {
          var result = _Json_runHelp(decoders[i], value);

          if (!$elm$core$Result$isOk(result)) {
            return result;
          }

          answer = answer(result.a);
        }

        return $elm$core$Result$Ok(answer);

      case 10:
        var result = _Json_runHelp(decoder.b, value);

        return !$elm$core$Result$isOk(result) ? result : _Json_runHelp(decoder.h(result.a), value);

      case 11:
        var errors = _List_Nil;

        for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
        {
          var result = _Json_runHelp(temp.a, value);

          if ($elm$core$Result$isOk(result)) {
            return result;
          }

          errors = _List_Cons(result.a, errors);
        }

        return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

      case 1:
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

      case 0:
        return $elm$core$Result$Ok(decoder.a);
    }
  }

  function _Json_runArrayDecoder(decoder, value, toElmValue) {
    var len = value.length;
    var array = new Array(len);

    for (var i = 0; i < len; i++) {
      var result = _Json_runHelp(decoder, value[i]);

      if (!$elm$core$Result$isOk(result)) {
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
      }

      array[i] = result.a;
    }

    return $elm$core$Result$Ok(toElmValue(array));
  }

  function _Json_isArray(value) {
    return Array.isArray(value) || typeof FileList !== 'undefined' && value instanceof FileList;
  }

  function _Json_toElmArray(array) {
    return A2($elm$core$Array$initialize, array.length, function (i) {
      return array[i];
    });
  }

  function _Json_expecting(type, value) {
    return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
  } // EQUALITY


  function _Json_equality(x, y) {
    if (x === y) {
      return true;
    }

    if (x.$ !== y.$) {
      return false;
    }

    switch (x.$) {
      case 0:
      case 1:
        return x.a === y.a;

      case 2:
        return x.b === y.b;

      case 5:
        return x.c === y.c;

      case 3:
      case 4:
      case 8:
        return _Json_equality(x.b, y.b);

      case 6:
        return x.d === y.d && _Json_equality(x.b, y.b);

      case 7:
        return x.e === y.e && _Json_equality(x.b, y.b);

      case 9:
        return x.f === y.f && _Json_listEquality(x.g, y.g);

      case 10:
        return x.h === y.h && _Json_equality(x.b, y.b);

      case 11:
        return _Json_listEquality(x.g, y.g);
    }
  }

  function _Json_listEquality(aDecoders, bDecoders) {
    var len = aDecoders.length;

    if (len !== bDecoders.length) {
      return false;
    }

    for (var i = 0; i < len; i++) {
      if (!_Json_equality(aDecoders[i], bDecoders[i])) {
        return false;
      }
    }

    return true;
  } // ENCODE


  var _Json_encode = F2(function (indentLevel, value) {
    return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
  });

  function _Json_wrap_UNUSED(value) {
    return {
      $: 0,
      a: value
    };
  }

  function _Json_unwrap_UNUSED(value) {
    return value.a;
  }

  function _Json_wrap(value) {
    return value;
  }

  function _Json_unwrap(value) {
    return value;
  }

  function _Json_emptyArray() {
    return [];
  }

  function _Json_emptyObject() {
    return {};
  }

  var _Json_addField = F3(function (key, value, object) {
    object[key] = _Json_unwrap(value);
    return object;
  });

  function _Json_addEntry(func) {
    return F2(function (entry, array) {
      array.push(_Json_unwrap(func(entry)));
      return array;
    });
  }

  var _Json_encodeNull = _Json_wrap(null); // TASKS


  function _Scheduler_succeed(value) {
    return {
      $: 0,
      a: value
    };
  }

  function _Scheduler_fail(error) {
    return {
      $: 1,
      a: error
    };
  }

  function _Scheduler_binding(callback) {
    return {
      $: 2,
      b: callback,
      c: null
    };
  }

  var _Scheduler_andThen = F2(function (callback, task) {
    return {
      $: 3,
      b: callback,
      d: task
    };
  });

  var _Scheduler_onError = F2(function (callback, task) {
    return {
      $: 4,
      b: callback,
      d: task
    };
  });

  function _Scheduler_receive(callback) {
    return {
      $: 5,
      b: callback
    };
  } // PROCESSES


  var _Scheduler_guid = 0;

  function _Scheduler_rawSpawn(task) {
    var proc = {
      $: 0,
      e: _Scheduler_guid++,
      f: task,
      g: null,
      h: []
    };

    _Scheduler_enqueue(proc);

    return proc;
  }

  function _Scheduler_spawn(task) {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
    });
  }

  function _Scheduler_rawSend(proc, msg) {
    proc.h.push(msg);

    _Scheduler_enqueue(proc);
  }

  var _Scheduler_send = F2(function (proc, msg) {
    return _Scheduler_binding(function (callback) {
      _Scheduler_rawSend(proc, msg);

      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  });

  function _Scheduler_kill(proc) {
    return _Scheduler_binding(function (callback) {
      var task = proc.f;

      if (task.$ === 2 && task.c) {
        task.c();
      }

      proc.f = null;
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  }
  /* STEP PROCESSES
  
  type alias Process =
    { $ : tag
    , id : unique_id
    , root : Task
    , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
    , mailbox : [msg]
    }
  
  */


  var _Scheduler_working = false;
  var _Scheduler_queue = [];

  function _Scheduler_enqueue(proc) {
    _Scheduler_queue.push(proc);

    if (_Scheduler_working) {
      return;
    }

    _Scheduler_working = true;

    while (proc = _Scheduler_queue.shift()) {
      _Scheduler_step(proc);
    }

    _Scheduler_working = false;
  }

  function _Scheduler_step(proc) {
    while (proc.f) {
      var rootTag = proc.f.$;

      if (rootTag === 0 || rootTag === 1) {
        while (proc.g && proc.g.$ !== rootTag) {
          proc.g = proc.g.i;
        }

        if (!proc.g) {
          return;
        }

        proc.f = proc.g.b(proc.f.a);
        proc.g = proc.g.i;
      } else if (rootTag === 2) {
        proc.f.c = proc.f.b(function (newRoot) {
          proc.f = newRoot;

          _Scheduler_enqueue(proc);
        });
        return;
      } else if (rootTag === 5) {
        if (proc.h.length === 0) {
          return;
        }

        proc.f = proc.f.b(proc.h.shift());
      } else // if (rootTag === 3 || rootTag === 4)
        {
          proc.g = {
            $: rootTag === 3 ? 0 : 1,
            b: proc.f.b,
            i: proc.g
          };
          proc.f = proc.f.d;
        }
    }
  }

  function _Process_sleep(time) {
    return _Scheduler_binding(function (callback) {
      var id = setTimeout(function () {
        callback(_Scheduler_succeed(_Utils_Tuple0));
      }, time);
      return function () {
        clearTimeout(id);
      };
    });
  } // PROGRAMS


  var _Platform_worker = F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.yp, impl.Ff, impl.Ev, function () {
      return function () {};
    });
  }); // INITIALIZE A PROGRAM


  function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
    var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
    $elm$core$Result$isOk(result) || _Debug_crash(2
    /**_UNUSED/, _Json_errorToString(result.a) /**/
    );
    var managers = {};
    var initPair = init(result.a);
    var model = initPair.a;
    var stepper = stepperBuilder(sendToApp, model);

    var ports = _Platform_setupEffects(managers, sendToApp);

    function sendToApp(msg, viewMetadata) {
      var pair = A2(update, msg, model);
      stepper(model = pair.a, viewMetadata);

      _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
    }

    _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

    return ports ? {
      ports: ports
    } : {};
  } // TRACK PRELOADS
  //
  // This is used by code in elm/browser and elm/http
  // to register any HTTP requests that are triggered by init.
  //


  var _Platform_preload;

  function _Platform_registerPreload(url) {
    _Platform_preload.add(url);
  } // EFFECT MANAGERS


  var _Platform_effectManagers = {};

  function _Platform_setupEffects(managers, sendToApp) {
    var ports; // setup all necessary effect managers

    for (var key in _Platform_effectManagers) {
      var manager = _Platform_effectManagers[key];

      if (manager.a) {
        ports = ports || {};
        ports[key] = manager.a(key, sendToApp);
      }

      managers[key] = _Platform_instantiateManager(manager, sendToApp);
    }

    return ports;
  }

  function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
    return {
      b: init,
      c: onEffects,
      d: onSelfMsg,
      e: cmdMap,
      f: subMap
    };
  }

  function _Platform_instantiateManager(info, sendToApp) {
    var router = {
      g: sendToApp,
      h: undefined
    };
    var onEffects = info.c;
    var onSelfMsg = info.d;
    var cmdMap = info.e;
    var subMap = info.f;

    function loop(state) {
      return A2(_Scheduler_andThen, loop, _Scheduler_receive(function (msg) {
        var value = msg.a;

        if (msg.$ === 0) {
          return A3(onSelfMsg, router, value, state);
        }

        return cmdMap && subMap ? A4(onEffects, router, value.i, value.j, state) : A3(onEffects, router, cmdMap ? value.i : value.j, state);
      }));
    }

    return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
  } // ROUTING


  var _Platform_sendToApp = F2(function (router, msg) {
    return _Scheduler_binding(function (callback) {
      router.g(msg);
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  });

  var _Platform_sendToSelf = F2(function (router, msg) {
    return A2(_Scheduler_send, router.h, {
      $: 0,
      a: msg
    });
  }); // BAGS


  function _Platform_leaf(home) {
    return function (value) {
      return {
        $: 1,
        k: home,
        l: value
      };
    };
  }

  function _Platform_batch(list) {
    return {
      $: 2,
      m: list
    };
  }

  var _Platform_map = F2(function (tagger, bag) {
    return {
      $: 3,
      n: tagger,
      o: bag
    };
  }); // PIPE BAGS INTO EFFECT MANAGERS
  //
  // Effects must be queued!
  //
  // Say your init contains a synchronous command, like Time.now or Time.here
  //
  //   - This will produce a batch of effects (FX_1)
  //   - The synchronous task triggers the subsequent `update` call
  //   - This will produce a batch of effects (FX_2)
  //
  // If we just start dispatching FX_2, subscriptions from FX_2 can be processed
  // before subscriptions from FX_1. No good! Earlier versions of this code had
  // this problem, leading to these reports:
  //
  //   https://github.com/elm/core/issues/980
  //   https://github.com/elm/core/pull/981
  //   https://github.com/elm/compiler/issues/1776
  //
  // The queue is necessary to avoid ordering issues for synchronous commands.
  // Why use true/false here? Why not just check the length of the queue?
  // The goal is to detect "are we currently dispatching effects?" If we
  // are, we need to bail and let the ongoing while loop handle things.
  //
  // Now say the queue has 1 element. When we dequeue the final element,
  // the queue will be empty, but we are still actively dispatching effects.
  // So you could get queue jumping in a really tricky category of cases.
  //


  var _Platform_effectsQueue = [];
  var _Platform_effectsActive = false;

  function _Platform_enqueueEffects(managers, cmdBag, subBag) {
    _Platform_effectsQueue.push({
      p: managers,
      q: cmdBag,
      r: subBag
    });

    if (_Platform_effectsActive) return;
    _Platform_effectsActive = true;

    for (var fx; fx = _Platform_effectsQueue.shift();) {
      _Platform_dispatchEffects(fx.p, fx.q, fx.r);
    }

    _Platform_effectsActive = false;
  }

  function _Platform_dispatchEffects(managers, cmdBag, subBag) {
    var effectsDict = {};

    _Platform_gatherEffects(true, cmdBag, effectsDict, null);

    _Platform_gatherEffects(false, subBag, effectsDict, null);

    for (var home in managers) {
      _Scheduler_rawSend(managers[home], {
        $: 'fx',
        a: effectsDict[home] || {
          i: _List_Nil,
          j: _List_Nil
        }
      });
    }
  }

  function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
    switch (bag.$) {
      case 1:
        var home = bag.k;

        var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);

        effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
        return;

      case 2:
        for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
        {
          _Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
        }

        return;

      case 3:
        _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
          s: bag.n,
          t: taggers
        });

        return;
    }
  }

  function _Platform_toEffect(isCmd, home, taggers, value) {
    function applyTaggers(x) {
      for (var temp = taggers; temp; temp = temp.t) {
        x = temp.s(x);
      }

      return x;
    }

    var map = isCmd ? _Platform_effectManagers[home].e : _Platform_effectManagers[home].f;
    return A2(map, applyTaggers, value);
  }

  function _Platform_insert(isCmd, newEffect, effects) {
    effects = effects || {
      i: _List_Nil,
      j: _List_Nil
    };
    isCmd ? effects.i = _List_Cons(newEffect, effects.i) : effects.j = _List_Cons(newEffect, effects.j);
    return effects;
  } // PORTS


  function _Platform_checkPortName(name) {
    if (_Platform_effectManagers[name]) {
      _Debug_crash(3, name);
    }
  } // OUTGOING PORTS


  function _Platform_outgoingPort(name, converter) {
    _Platform_checkPortName(name);

    _Platform_effectManagers[name] = {
      e: _Platform_outgoingPortMap,
      u: converter,
      a: _Platform_setupOutgoingPort
    };
    return _Platform_leaf(name);
  }

  var _Platform_outgoingPortMap = F2(function (tagger, value) {
    return value;
  });

  function _Platform_setupOutgoingPort(name) {
    var subs = [];
    var converter = _Platform_effectManagers[name].u; // CREATE MANAGER

    var init = _Process_sleep(0);

    _Platform_effectManagers[name].b = init;
    _Platform_effectManagers[name].c = F3(function (router, cmdList, state) {
      for (; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
      {
        // grab a separate reference to subs in case unsubscribe is called
        var currentSubs = subs;

        var value = _Json_unwrap(converter(cmdList.a));

        for (var i = 0; i < currentSubs.length; i++) {
          currentSubs[i](value);
        }
      }

      return init;
    }); // PUBLIC API

    function subscribe(callback) {
      subs.push(callback);
    }

    function unsubscribe(callback) {
      // copy subs into a new array in case unsubscribe is called within a
      // subscribed callback
      subs = subs.slice();
      var index = subs.indexOf(callback);

      if (index >= 0) {
        subs.splice(index, 1);
      }
    }

    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe
    };
  } // INCOMING PORTS


  function _Platform_incomingPort(name, converter) {
    _Platform_checkPortName(name);

    _Platform_effectManagers[name] = {
      f: _Platform_incomingPortMap,
      u: converter,
      a: _Platform_setupIncomingPort
    };
    return _Platform_leaf(name);
  }

  var _Platform_incomingPortMap = F2(function (tagger, finalTagger) {
    return function (value) {
      return tagger(finalTagger(value));
    };
  });

  function _Platform_setupIncomingPort(name, sendToApp) {
    var subs = _List_Nil;
    var converter = _Platform_effectManagers[name].u; // CREATE MANAGER

    var init = _Scheduler_succeed(null);

    _Platform_effectManagers[name].b = init;
    _Platform_effectManagers[name].c = F3(function (router, subList, state) {
      subs = subList;
      return init;
    }); // PUBLIC API

    function send(incomingValue) {
      var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
      $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
      var value = result.a;

      for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
      {
        sendToApp(temp.a(value));
      }
    }

    return {
      send: send
    };
  } // EXPORT ELM MODULES
  //
  // Have DEBUG and PROD versions so that we can (1) give nicer errors in
  // debug mode and (2) not pay for the bits needed for that in prod mode.
  //


  function _Platform_export(exports) {
    scope['Elm'] ? _Platform_mergeExportsProd(scope['Elm'], exports) : scope['Elm'] = exports;
  }

  function _Platform_mergeExportsProd(obj, exports) {
    for (var name in exports) {
      name in obj ? name == 'init' ? _Debug_crash(6) : _Platform_mergeExportsProd(obj[name], exports[name]) : obj[name] = exports[name];
    }
  }

  function _Platform_export_UNUSED(exports) {
    scope['Elm'] ? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports) : scope['Elm'] = exports;
  }

  function _Platform_mergeExportsDebug(moduleName, obj, exports) {
    for (var name in exports) {
      name in obj ? name == 'init' ? _Debug_crash(6, moduleName) : _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name]) : obj[name] = exports[name];
    }
  } // HELPERS


  var _VirtualDom_divertHrefToApp;

  var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};

  function _VirtualDom_appendChild(parent, child) {
    parent.appendChild(child);
  }

  var _VirtualDom_init = F4(function (virtualNode, flagDecoder, debugMetadata, args) {
    // NOTE: this function needs _Platform_export available to work

    /**/
    var node = args['node']; //*/

    /**_UNUSED/
    var node = args && args['node'] ? args['node'] : _Debug_crash(0);
    //*/

    node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function () {}), node);
    return {};
  }); // TEXT


  function _VirtualDom_text(string) {
    return {
      $: 0,
      a: string
    };
  } // NODE


  var _VirtualDom_nodeNS = F2(function (namespace, tag) {
    return F2(function (factList, kidList) {
      for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
      {
        var kid = kidList.a;
        descendantsCount += kid.b || 0;
        kids.push(kid);
      }

      descendantsCount += kids.length;
      return {
        $: 1,
        c: tag,
        d: _VirtualDom_organizeFacts(factList),
        e: kids,
        f: namespace,
        b: descendantsCount
      };
    });
  });

  var _VirtualDom_node = _VirtualDom_nodeNS(undefined); // KEYED NODE


  var _VirtualDom_keyedNodeNS = F2(function (namespace, tag) {
    return F2(function (factList, kidList) {
      for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
      {
        var kid = kidList.a;
        descendantsCount += kid.b.b || 0;
        kids.push(kid);
      }

      descendantsCount += kids.length;
      return {
        $: 2,
        c: tag,
        d: _VirtualDom_organizeFacts(factList),
        e: kids,
        f: namespace,
        b: descendantsCount
      };
    });
  });

  var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined); // CUSTOM


  function _VirtualDom_custom(factList, model, render, diff) {
    return {
      $: 3,
      d: _VirtualDom_organizeFacts(factList),
      g: model,
      h: render,
      i: diff
    };
  } // MAP


  var _VirtualDom_map = F2(function (tagger, node) {
    return {
      $: 4,
      j: tagger,
      k: node,
      b: 1 + (node.b || 0)
    };
  }); // LAZY


  function _VirtualDom_thunk(refs, thunk) {
    return {
      $: 5,
      l: refs,
      m: thunk,
      k: undefined
    };
  }

  var _VirtualDom_lazy = F2(function (func, a) {
    return _VirtualDom_thunk([func, a], function () {
      return func(a);
    });
  });

  var _VirtualDom_lazy2 = F3(function (func, a, b) {
    return _VirtualDom_thunk([func, a, b], function () {
      return A2(func, a, b);
    });
  });

  var _VirtualDom_lazy3 = F4(function (func, a, b, c) {
    return _VirtualDom_thunk([func, a, b, c], function () {
      return A3(func, a, b, c);
    });
  });

  var _VirtualDom_lazy4 = F5(function (func, a, b, c, d) {
    return _VirtualDom_thunk([func, a, b, c, d], function () {
      return A4(func, a, b, c, d);
    });
  });

  var _VirtualDom_lazy5 = F6(function (func, a, b, c, d, e) {
    return _VirtualDom_thunk([func, a, b, c, d, e], function () {
      return A5(func, a, b, c, d, e);
    });
  });

  var _VirtualDom_lazy6 = F7(function (func, a, b, c, d, e, f) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
      return A6(func, a, b, c, d, e, f);
    });
  });

  var _VirtualDom_lazy7 = F8(function (func, a, b, c, d, e, f, g) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
      return A7(func, a, b, c, d, e, f, g);
    });
  });

  var _VirtualDom_lazy8 = F9(function (func, a, b, c, d, e, f, g, h) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
      return A8(func, a, b, c, d, e, f, g, h);
    });
  }); // FACTS


  var _VirtualDom_on = F2(function (key, handler) {
    return {
      $: 'a0',
      n: key,
      o: handler
    };
  });

  var _VirtualDom_style = F2(function (key, value) {
    return {
      $: 'a1',
      n: key,
      o: value
    };
  });

  var _VirtualDom_property = F2(function (key, value) {
    return {
      $: 'a2',
      n: key,
      o: value
    };
  });

  var _VirtualDom_attribute = F2(function (key, value) {
    return {
      $: 'a3',
      n: key,
      o: value
    };
  });

  var _VirtualDom_attributeNS = F3(function (namespace, key, value) {
    return {
      $: 'a4',
      n: key,
      o: {
        f: namespace,
        o: value
      }
    };
  }); // XSS ATTACK VECTOR CHECKS


  function _VirtualDom_noScript(tag) {
    return tag == 'script' ? 'p' : tag;
  }

  function _VirtualDom_noOnOrFormAction(key) {
    return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
  }

  function _VirtualDom_noInnerHtmlOrFormAction(key) {
    return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
  }

  function _VirtualDom_noJavaScriptUri(value) {
    return /^javascript:/i.test(value.replace(/\s/g, '')) ? '' : value;
  }

  function _VirtualDom_noJavaScriptUri_UNUSED(value) {
    return /^javascript:/i.test(value.replace(/\s/g, '')) ? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")' : value;
  }

  function _VirtualDom_noJavaScriptOrHtmlUri(value) {
    return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
  }

  function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value) {
    return /^\s*(javascript:|data:text\/html)/i.test(value) ? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")' : value;
  } // MAP FACTS


  var _VirtualDom_mapAttribute = F2(function (func, attr) {
    return attr.$ === 'a0' ? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
  });

  function _VirtualDom_mapHandler(func, handler) {
    var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler); // 0 = Normal
    // 1 = MayStopPropagation
    // 2 = MayPreventDefault
    // 3 = Custom

    return {
      $: handler.$,
      a: !tag ? A2($elm$json$Json$Decode$map, func, handler.a) : A3($elm$json$Json$Decode$map2, tag < 3 ? _VirtualDom_mapEventTuple : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
    };
  }

  var _VirtualDom_mapEventTuple = F2(function (func, tuple) {
    return _Utils_Tuple2(func(tuple.a), tuple.b);
  });

  var _VirtualDom_mapEventRecord = F2(function (func, record) {
    return {
      zu: func(record.zu),
      tH: record.tH,
      sJ: record.sJ
    };
  }); // ORGANIZE FACTS


  function _VirtualDom_organizeFacts(factList) {
    for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
    {
      var entry = factList.a;
      var tag = entry.$;
      var key = entry.n;
      var value = entry.o;

      if (tag === 'a2') {
        key === 'className' ? _VirtualDom_addClass(facts, key, _Json_unwrap(value)) : facts[key] = _Json_unwrap(value);
        continue;
      }

      var subFacts = facts[tag] || (facts[tag] = {});
      tag === 'a3' && key === 'class' ? _VirtualDom_addClass(subFacts, key, value) : subFacts[key] = value;
    }

    return facts;
  }

  function _VirtualDom_addClass(object, key, newClass) {
    var classes = object[key];
    object[key] = classes ? classes + ' ' + newClass : newClass;
  } // RENDER


  function _VirtualDom_render(vNode, eventNode) {
    var tag = vNode.$;

    if (tag === 5) {
      return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
    }

    if (tag === 0) {
      return _VirtualDom_doc.createTextNode(vNode.a);
    }

    if (tag === 4) {
      var subNode = vNode.k;
      var tagger = vNode.j;

      while (subNode.$ === 4) {
        typeof tagger !== 'object' ? tagger = [tagger, subNode.j] : tagger.push(subNode.j);
        subNode = subNode.k;
      }

      var subEventRoot = {
        j: tagger,
        p: eventNode
      };

      var domNode = _VirtualDom_render(subNode, subEventRoot);

      domNode.elm_event_node_ref = subEventRoot;
      return domNode;
    }

    if (tag === 3) {
      var domNode = vNode.h(vNode.g);

      _VirtualDom_applyFacts(domNode, eventNode, vNode.d);

      return domNode;
    } // at this point `tag` must be 1 or 2


    var domNode = vNode.f ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c) : _VirtualDom_doc.createElement(vNode.c);

    if (_VirtualDom_divertHrefToApp && vNode.c == 'a') {
      domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
    }

    _VirtualDom_applyFacts(domNode, eventNode, vNode.d);

    for (var kids = vNode.e, i = 0; i < kids.length; i++) {
      _VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
    }

    return domNode;
  } // APPLY FACTS


  function _VirtualDom_applyFacts(domNode, eventNode, facts) {
    for (var key in facts) {
      var value = facts[key];
      key === 'a1' ? _VirtualDom_applyStyles(domNode, value) : key === 'a0' ? _VirtualDom_applyEvents(domNode, eventNode, value) : key === 'a3' ? _VirtualDom_applyAttrs(domNode, value) : key === 'a4' ? _VirtualDom_applyAttrsNS(domNode, value) : (key !== 'value' && key !== 'checked' || domNode[key] !== value) && (domNode[key] = value);
    }
  } // APPLY STYLES


  function _VirtualDom_applyStyles(domNode, styles) {
    var domNodeStyle = domNode.style;

    for (var key in styles) {
      domNodeStyle[key] = styles[key];
    }
  } // APPLY ATTRS


  function _VirtualDom_applyAttrs(domNode, attrs) {
    for (var key in attrs) {
      var value = attrs[key];
      typeof value !== 'undefined' ? domNode.setAttribute(key, value) : domNode.removeAttribute(key);
    }
  } // APPLY NAMESPACED ATTRS


  function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
    for (var key in nsAttrs) {
      var pair = nsAttrs[key];
      var namespace = pair.f;
      var value = pair.o;
      typeof value !== 'undefined' ? domNode.setAttributeNS(namespace, key, value) : domNode.removeAttributeNS(namespace, key);
    }
  } // APPLY EVENTS


  function _VirtualDom_applyEvents(domNode, eventNode, events) {
    var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

    for (var key in events) {
      var newHandler = events[key];
      var oldCallback = allCallbacks[key];

      if (!newHandler) {
        domNode.removeEventListener(key, oldCallback);
        allCallbacks[key] = undefined;
        continue;
      }

      if (oldCallback) {
        var oldHandler = oldCallback.q;

        if (oldHandler.$ === newHandler.$) {
          oldCallback.q = newHandler;
          continue;
        }

        domNode.removeEventListener(key, oldCallback);
      }

      oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
      domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported && {
        passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2
      });
      allCallbacks[key] = oldCallback;
    }
  } // PASSIVE EVENTS


  var _VirtualDom_passiveSupported;

  try {
    window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
      get: function () {
        _VirtualDom_passiveSupported = true;
      }
    }));
  } catch (e) {} // EVENT HANDLERS


  function _VirtualDom_makeCallback(eventNode, initialHandler) {
    function callback(event) {
      var handler = callback.q;

      var result = _Json_runHelp(handler.a, event);

      if (!$elm$core$Result$isOk(result)) {
        return;
      }

      var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler); // 0 = Normal
      // 1 = MayStopPropagation
      // 2 = MayPreventDefault
      // 3 = Custom

      var value = result.a;
      var message = !tag ? value : tag < 3 ? value.a : value.zu;
      var stopPropagation = tag == 1 ? value.b : tag == 3 && value.tH;
      var currentEventNode = (stopPropagation && event.stopPropagation(), (tag == 2 ? value.b : tag == 3 && value.sJ) && event.preventDefault(), eventNode);
      var tagger;
      var i;

      while (tagger = currentEventNode.j) {
        if (typeof tagger == 'function') {
          message = tagger(message);
        } else {
          for (var i = tagger.length; i--;) {
            message = tagger[i](message);
          }
        }

        currentEventNode = currentEventNode.p;
      }

      currentEventNode(message, stopPropagation); // stopPropagation implies isSync
    }

    callback.q = initialHandler;
    return callback;
  }

  function _VirtualDom_equalEvents(x, y) {
    return x.$ == y.$ && _Json_equality(x.a, y.a);
  } // DIFF
  // TODO: Should we do patches like in iOS?
  //
  // type Patch
  //   = At Int Patch
  //   | Batch (List Patch)
  //   | Change ...
  //
  // How could it not be better?
  //


  function _VirtualDom_diff(x, y) {
    var patches = [];

    _VirtualDom_diffHelp(x, y, patches, 0);

    return patches;
  }

  function _VirtualDom_pushPatch(patches, type, index, data) {
    var patch = {
      $: type,
      r: index,
      s: data,
      t: undefined,
      u: undefined
    };
    patches.push(patch);
    return patch;
  }

  function _VirtualDom_diffHelp(x, y, patches, index) {
    if (x === y) {
      return;
    }

    var xType = x.$;
    var yType = y.$; // Bail if you run into different types of nodes. Implies that the
    // structure has changed significantly and it's not worth a diff.

    if (xType !== yType) {
      if (xType === 1 && yType === 2) {
        y = _VirtualDom_dekey(y);
        yType = 1;
      } else {
        _VirtualDom_pushPatch(patches, 0, index, y);

        return;
      }
    } // Now we know that both nodes are the same $.


    switch (yType) {
      case 5:
        var xRefs = x.l;
        var yRefs = y.l;
        var i = xRefs.length;
        var same = i === yRefs.length;

        while (same && i--) {
          same = xRefs[i] === yRefs[i];
        }

        if (same) {
          y.k = x.k;
          return;
        }

        y.k = y.m();
        var subPatches = [];

        _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);

        subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
        return;

      case 4:
        // gather nested taggers
        var xTaggers = x.j;
        var yTaggers = y.j;
        var nesting = false;
        var xSubNode = x.k;

        while (xSubNode.$ === 4) {
          nesting = true;
          typeof xTaggers !== 'object' ? xTaggers = [xTaggers, xSubNode.j] : xTaggers.push(xSubNode.j);
          xSubNode = xSubNode.k;
        }

        var ySubNode = y.k;

        while (ySubNode.$ === 4) {
          nesting = true;
          typeof yTaggers !== 'object' ? yTaggers = [yTaggers, ySubNode.j] : yTaggers.push(ySubNode.j);
          ySubNode = ySubNode.k;
        } // Just bail if different numbers of taggers. This implies the
        // structure of the virtual DOM has changed.


        if (nesting && xTaggers.length !== yTaggers.length) {
          _VirtualDom_pushPatch(patches, 0, index, y);

          return;
        } // check if taggers are "the same"


        if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) {
          _VirtualDom_pushPatch(patches, 2, index, yTaggers);
        } // diff everything below the taggers


        _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);

        return;

      case 0:
        if (x.a !== y.a) {
          _VirtualDom_pushPatch(patches, 3, index, y.a);
        }

        return;

      case 1:
        _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);

        return;

      case 2:
        _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);

        return;

      case 3:
        if (x.h !== y.h) {
          _VirtualDom_pushPatch(patches, 0, index, y);

          return;
        }

        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);

        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        var patch = y.i(x.g, y.g);
        patch && _VirtualDom_pushPatch(patches, 5, index, patch);
        return;
    }
  } // assumes the incoming arrays are the same length


  function _VirtualDom_pairwiseRefEqual(as, bs) {
    for (var i = 0; i < as.length; i++) {
      if (as[i] !== bs[i]) {
        return false;
      }
    }

    return true;
  }

  function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
    // Bail if obvious indicators have changed. Implies more serious
    // structural changes such that it's not worth it to diff.
    if (x.c !== y.c || x.f !== y.f) {
      _VirtualDom_pushPatch(patches, 0, index, y);

      return;
    }

    var factsDiff = _VirtualDom_diffFacts(x.d, y.d);

    factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
    diffKids(x, y, patches, index);
  } // DIFF FACTS
  // TODO Instead of creating a new diff object, it's possible to just test if
  // there *is* a diff. During the actual patch, do the diff again and make the
  // modifications directly. This way, there's no new allocations. Worth it?


  function _VirtualDom_diffFacts(x, y, category) {
    var diff; // look for changes and removals

    for (var xKey in x) {
      if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4') {
        var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);

        if (subDiff) {
          diff = diff || {};
          diff[xKey] = subDiff;
        }

        continue;
      } // remove if not in the new facts


      if (!(xKey in y)) {
        diff = diff || {};
        diff[xKey] = !category ? typeof x[xKey] === 'string' ? '' : null : category === 'a1' ? '' : category === 'a0' || category === 'a3' ? undefined : {
          f: x[xKey].f,
          o: undefined
        };
        continue;
      }

      var xValue = x[xKey];
      var yValue = y[xKey]; // reference equal, so don't worry about it

      if (xValue === yValue && xKey !== 'value' && xKey !== 'checked' || category === 'a0' && _VirtualDom_equalEvents(xValue, yValue)) {
        continue;
      }

      diff = diff || {};
      diff[xKey] = yValue;
    } // add new stuff


    for (var yKey in y) {
      if (!(yKey in x)) {
        diff = diff || {};
        diff[yKey] = y[yKey];
      }
    }

    return diff;
  } // DIFF KIDS


  function _VirtualDom_diffKids(xParent, yParent, patches, index) {
    var xKids = xParent.e;
    var yKids = yParent.e;
    var xLen = xKids.length;
    var yLen = yKids.length; // FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

    if (xLen > yLen) {
      _VirtualDom_pushPatch(patches, 6, index, {
        v: yLen,
        i: xLen - yLen
      });
    } else if (xLen < yLen) {
      _VirtualDom_pushPatch(patches, 7, index, {
        v: xLen,
        e: yKids
      });
    } // PAIRWISE DIFF EVERYTHING ELSE


    for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++) {
      var xKid = xKids[i];

      _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);

      index += xKid.b || 0;
    }
  } // KEYED DIFF


  function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
    var localPatches = [];
    var changes = {}; // Dict String Entry

    var inserts = []; // Array { index : Int, entry : Entry }
    // type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

    var xKids = xParent.e;
    var yKids = yParent.e;
    var xLen = xKids.length;
    var yLen = yKids.length;
    var xIndex = 0;
    var yIndex = 0;
    var index = rootIndex;

    while (xIndex < xLen && yIndex < yLen) {
      var x = xKids[xIndex];
      var y = yKids[yIndex];
      var xKey = x.a;
      var yKey = y.a;
      var xNode = x.b;
      var yNode = y.b;
      var newMatch = undefined;
      var oldMatch = undefined; // check if keys match

      if (xKey === yKey) {
        index++;

        _VirtualDom_diffHelp(xNode, yNode, localPatches, index);

        index += xNode.b || 0;
        xIndex++;
        yIndex++;
        continue;
      } // look ahead 1 to detect insertions and removals.


      var xNext = xKids[xIndex + 1];
      var yNext = yKids[yIndex + 1];

      if (xNext) {
        var xNextKey = xNext.a;
        var xNextNode = xNext.b;
        oldMatch = yKey === xNextKey;
      }

      if (yNext) {
        var yNextKey = yNext.a;
        var yNextNode = yNext.b;
        newMatch = xKey === yNextKey;
      } // swap x and y


      if (newMatch && oldMatch) {
        index++;

        _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);

        _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);

        index += xNode.b || 0;
        index++;

        _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);

        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 2;
        continue;
      } // insert y


      if (newMatch) {
        index++;

        _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);

        _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);

        index += xNode.b || 0;
        xIndex += 1;
        yIndex += 2;
        continue;
      } // remove x


      if (oldMatch) {
        index++;

        _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);

        index += xNode.b || 0;
        index++;

        _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);

        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 1;
        continue;
      } // remove x, insert y


      if (xNext && xNextKey === yNextKey) {
        index++;

        _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);

        _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);

        index += xNode.b || 0;
        index++;

        _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);

        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 2;
        continue;
      }

      break;
    } // eat up any remaining nodes with removeNode and insertNode


    while (xIndex < xLen) {
      index++;
      var x = xKids[xIndex];
      var xNode = x.b;

      _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);

      index += xNode.b || 0;
      xIndex++;
    }

    while (yIndex < yLen) {
      var endInserts = endInserts || [];
      var y = yKids[yIndex];

      _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);

      yIndex++;
    }

    if (localPatches.length > 0 || inserts.length > 0 || endInserts) {
      _VirtualDom_pushPatch(patches, 8, rootIndex, {
        w: localPatches,
        x: inserts,
        y: endInserts
      });
    }
  } // CHANGES FROM KEYED DIFF


  var _VirtualDom_POSTFIX = '_elmW6BL';

  function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
    var entry = changes[key]; // never seen this key before

    if (!entry) {
      entry = {
        c: 0,
        z: vnode,
        r: yIndex,
        s: undefined
      };
      inserts.push({
        r: yIndex,
        A: entry
      });
      changes[key] = entry;
      return;
    } // this key was removed earlier, a match!


    if (entry.c === 1) {
      inserts.push({
        r: yIndex,
        A: entry
      });
      entry.c = 2;
      var subPatches = [];

      _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);

      entry.r = yIndex;
      entry.s.s = {
        w: subPatches,
        A: entry
      };
      return;
    } // this key has already been inserted or moved, a duplicate!


    _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
  }

  function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
    var entry = changes[key]; // never seen this key before

    if (!entry) {
      var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

      changes[key] = {
        c: 1,
        z: vnode,
        r: index,
        s: patch
      };
      return;
    } // this key was inserted earlier, a match!


    if (entry.c === 0) {
      entry.c = 2;
      var subPatches = [];

      _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

      _VirtualDom_pushPatch(localPatches, 9, index, {
        w: subPatches,
        A: entry
      });

      return;
    } // this key has already been removed or moved, a duplicate!


    _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
  } // ADD DOM NODES
  //
  // Each DOM node has an "index" assigned in order of traversal. It is important
  // to minimize our crawl over the actual DOM, so these indexes (along with the
  // descendantsCount of virtual nodes) let us skip touching entire subtrees of
  // the DOM if we know there are no patches there.


  function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
    _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
  } // assumes `patches` is non-empty and indexes increase monotonically.


  function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
    var patch = patches[i];
    var index = patch.r;

    while (index === low) {
      var patchType = patch.$;

      if (patchType === 1) {
        _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
      } else if (patchType === 8) {
        patch.t = domNode;
        patch.u = eventNode;
        var subPatches = patch.s.w;

        if (subPatches.length > 0) {
          _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
        }
      } else if (patchType === 9) {
        patch.t = domNode;
        patch.u = eventNode;
        var data = patch.s;

        if (data) {
          data.A.s = domNode;
          var subPatches = data.w;

          if (subPatches.length > 0) {
            _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
          }
        }
      } else {
        patch.t = domNode;
        patch.u = eventNode;
      }

      i++;

      if (!(patch = patches[i]) || (index = patch.r) > high) {
        return i;
      }
    }

    var tag = vNode.$;

    if (tag === 4) {
      var subNode = vNode.k;

      while (subNode.$ === 4) {
        subNode = subNode.k;
      }

      return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
    } // tag must be 1 or 2 at this point


    var vKids = vNode.e;
    var childNodes = domNode.childNodes;

    for (var j = 0; j < vKids.length; j++) {
      low++;
      var vKid = tag === 1 ? vKids[j] : vKids[j].b;
      var nextLow = low + (vKid.b || 0);

      if (low <= index && index <= nextLow) {
        i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);

        if (!(patch = patches[i]) || (index = patch.r) > high) {
          return i;
        }
      }

      low = nextLow;
    }

    return i;
  } // APPLY PATCHES


  function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
    if (patches.length === 0) {
      return rootDomNode;
    }

    _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);

    return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
  }

  function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
    for (var i = 0; i < patches.length; i++) {
      var patch = patches[i];
      var localDomNode = patch.t;

      var newNode = _VirtualDom_applyPatch(localDomNode, patch);

      if (localDomNode === rootDomNode) {
        rootDomNode = newNode;
      }
    }

    return rootDomNode;
  }

  function _VirtualDom_applyPatch(domNode, patch) {
    switch (patch.$) {
      case 0:
        return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

      case 4:
        _VirtualDom_applyFacts(domNode, patch.u, patch.s);

        return domNode;

      case 3:
        domNode.replaceData(0, domNode.length, patch.s);
        return domNode;

      case 1:
        return _VirtualDom_applyPatchesHelp(domNode, patch.s);

      case 2:
        if (domNode.elm_event_node_ref) {
          domNode.elm_event_node_ref.j = patch.s;
        } else {
          domNode.elm_event_node_ref = {
            j: patch.s,
            p: patch.u
          };
        }

        return domNode;

      case 6:
        var data = patch.s;

        for (var i = 0; i < data.i; i++) {
          domNode.removeChild(domNode.childNodes[data.v]);
        }

        return domNode;

      case 7:
        var data = patch.s;
        var kids = data.e;
        var i = data.v;
        var theEnd = domNode.childNodes[i];

        for (; i < kids.length; i++) {
          domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
        }

        return domNode;

      case 9:
        var data = patch.s;

        if (!data) {
          domNode.parentNode.removeChild(domNode);
          return domNode;
        }

        var entry = data.A;

        if (typeof entry.r !== 'undefined') {
          domNode.parentNode.removeChild(domNode);
        }

        entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
        return domNode;

      case 8:
        return _VirtualDom_applyPatchReorder(domNode, patch);

      case 5:
        return patch.s(domNode);

      default:
        _Debug_crash(10);

      // 'Ran into an unknown patch!'
    }
  }

  function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
    var parentNode = domNode.parentNode;

    var newNode = _VirtualDom_render(vNode, eventNode);

    if (!newNode.elm_event_node_ref) {
      newNode.elm_event_node_ref = domNode.elm_event_node_ref;
    }

    if (parentNode && newNode !== domNode) {
      parentNode.replaceChild(newNode, domNode);
    }

    return newNode;
  }

  function _VirtualDom_applyPatchReorder(domNode, patch) {
    var data = patch.s; // remove end inserts

    var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch); // removals


    domNode = _VirtualDom_applyPatchesHelp(domNode, data.w); // inserts

    var inserts = data.x;

    for (var i = 0; i < inserts.length; i++) {
      var insert = inserts[i];
      var entry = insert.A;
      var node = entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u);
      domNode.insertBefore(node, domNode.childNodes[insert.r]);
    } // add end inserts


    if (frag) {
      _VirtualDom_appendChild(domNode, frag);
    }

    return domNode;
  }

  function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
    if (!endInserts) {
      return;
    }

    var frag = _VirtualDom_doc.createDocumentFragment();

    for (var i = 0; i < endInserts.length; i++) {
      var insert = endInserts[i];
      var entry = insert.A;

      _VirtualDom_appendChild(frag, entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u));
    }

    return frag;
  }

  function _VirtualDom_virtualize(node) {
    // TEXT NODES
    if (node.nodeType === 3) {
      return _VirtualDom_text(node.textContent);
    } // WEIRD NODES


    if (node.nodeType !== 1) {
      return _VirtualDom_text('');
    } // ELEMENT NODES


    var attrList = _List_Nil;
    var attrs = node.attributes;

    for (var i = attrs.length; i--;) {
      var attr = attrs[i];
      var name = attr.name;
      var value = attr.value;
      attrList = _List_Cons(A2(_VirtualDom_attribute, name, value), attrList);
    }

    var tag = node.tagName.toLowerCase();
    var kidList = _List_Nil;
    var kids = node.childNodes;

    for (var i = kids.length; i--;) {
      kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
    }

    return A3(_VirtualDom_node, tag, attrList, kidList);
  }

  function _VirtualDom_dekey(keyedNode) {
    var keyedKids = keyedNode.e;
    var len = keyedKids.length;
    var kids = new Array(len);

    for (var i = 0; i < len; i++) {
      kids[i] = keyedKids[i].b;
    }

    return {
      $: 1,
      c: keyedNode.c,
      d: keyedNode.d,
      e: kids,
      f: keyedNode.f,
      b: keyedNode.b
    };
  } // ELEMENT


  var _Debugger_element;

  var _Browser_element = _Debugger_element || F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.yp, impl.Ff, impl.Ev, function (sendToApp, initialModel) {
      var view = impl.Fz;
      /**/

      var domNode = args['node']; //*/

      /**_UNUSED/
      var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
      //*/

      var currNode = _VirtualDom_virtualize(domNode);

      return _Browser_makeAnimator(initialModel, function (model) {
        var nextNode = view(model);

        var patches = _VirtualDom_diff(currNode, nextNode);

        domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
        currNode = nextNode;
      });
    });
  }); // DOCUMENT


  var _Debugger_document;

  var _Browser_document = _Debugger_document || F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.yp, impl.Ff, impl.Ev, function (sendToApp, initialModel) {
      var divertHrefToApp = impl.n3 && impl.n3(sendToApp);
      var view = impl.Fz;
      var title = _VirtualDom_doc.title;
      var bodyNode = _VirtualDom_doc.body;

      var currNode = _VirtualDom_virtualize(bodyNode);

      return _Browser_makeAnimator(initialModel, function (model) {
        _VirtualDom_divertHrefToApp = divertHrefToApp;
        var doc = view(model);

        var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.d0);

        var patches = _VirtualDom_diff(currNode, nextNode);

        bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
        currNode = nextNode;
        _VirtualDom_divertHrefToApp = 0;
        title !== doc.t1 && (_VirtualDom_doc.title = title = doc.t1);
      });
    });
  }); // ANIMATION


  var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== 'undefined' ? cancelAnimationFrame : function (id) {
    clearTimeout(id);
  };

  var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : function (callback) {
    return setTimeout(callback, 1000 / 60);
  };

  function _Browser_makeAnimator(model, draw) {
    draw(model);
    var state = 0;

    function updateIfNeeded() {
      state = state === 1 ? 0 : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
    }

    return function (nextModel, isSync) {
      model = nextModel;
      isSync ? (draw(model), state === 2 && (state = 1)) : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded), state = 2);
    };
  } // APPLICATION


  function _Browser_application(impl) {
    var onUrlChange = impl.B5;
    var onUrlRequest = impl.B6;

    var key = function () {
      key.a(onUrlChange(_Browser_getUrl()));
    };

    return _Browser_document({
      n3: function (sendToApp) {
        key.a = sendToApp;

        _Browser_window.addEventListener('popstate', key);

        _Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
        return F2(function (domNode, event) {
          if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download')) {
            event.preventDefault();
            var href = domNode.href;

            var curr = _Browser_getUrl();

            var next = $elm$url$Url$fromString(href).a;
            sendToApp(onUrlRequest(next && curr.nt === next.nt && curr.lE === next.lE && curr.nm.a === next.nm.a ? $elm$browser$Browser$Internal(next) : $elm$browser$Browser$External(href)));
          }
        });
      },
      yp: function (flags) {
        return A3(impl.yp, flags, _Browser_getUrl(), key);
      },
      Fz: impl.Fz,
      Ff: impl.Ff,
      Ev: impl.Ev
    });
  }

  function _Browser_getUrl() {
    return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
  }

  var _Browser_go = F2(function (key, n) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      n && history.go(n);
      key();
    }));
  });

  var _Browser_pushUrl = F2(function (key, url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      history.pushState({}, '', url);
      key();
    }));
  });

  var _Browser_replaceUrl = F2(function (key, url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      history.replaceState({}, '', url);
      key();
    }));
  }); // GLOBAL EVENTS


  var _Browser_fakeNode = {
    addEventListener: function () {},
    removeEventListener: function () {}
  };

  var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;

  var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

  var _Browser_on = F3(function (node, eventName, sendToSelf) {
    return _Scheduler_spawn(_Scheduler_binding(function (callback) {
      function handler(event) {
        _Scheduler_rawSpawn(sendToSelf(event));
      }

      node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && {
        passive: true
      });
      return function () {
        node.removeEventListener(eventName, handler);
      };
    }));
  });

  var _Browser_decodeEvent = F2(function (decoder, event) {
    var result = _Json_runHelp(decoder, event);

    return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
  }); // PAGE VISIBILITY


  function _Browser_visibilityInfo() {
    return typeof _VirtualDom_doc.hidden !== 'undefined' ? {
      x8: 'hidden',
      vT: 'visibilitychange'
    } : typeof _VirtualDom_doc.mozHidden !== 'undefined' ? {
      x8: 'mozHidden',
      vT: 'mozvisibilitychange'
    } : typeof _VirtualDom_doc.msHidden !== 'undefined' ? {
      x8: 'msHidden',
      vT: 'msvisibilitychange'
    } : typeof _VirtualDom_doc.webkitHidden !== 'undefined' ? {
      x8: 'webkitHidden',
      vT: 'webkitvisibilitychange'
    } : {
      x8: 'hidden',
      vT: 'visibilitychange'
    };
  } // ANIMATION FRAMES


  function _Browser_rAF() {
    return _Scheduler_binding(function (callback) {
      var id = _Browser_requestAnimationFrame(function () {
        callback(_Scheduler_succeed(Date.now()));
      });

      return function () {
        _Browser_cancelAnimationFrame(id);
      };
    });
  }

  function _Browser_now() {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(Date.now()));
    });
  } // DOM STUFF


  function _Browser_withNode(id, doStuff) {
    return _Scheduler_binding(function (callback) {
      _Browser_requestAnimationFrame(function () {
        var node = document.getElementById(id);
        callback(node ? _Scheduler_succeed(doStuff(node)) : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
      });
    });
  }

  function _Browser_withWindow(doStuff) {
    return _Scheduler_binding(function (callback) {
      _Browser_requestAnimationFrame(function () {
        callback(_Scheduler_succeed(doStuff()));
      });
    });
  } // FOCUS and BLUR


  var _Browser_call = F2(function (functionName, id) {
    return _Browser_withNode(id, function (node) {
      node[functionName]();
      return _Utils_Tuple0;
    });
  }); // WINDOW VIEWPORT


  function _Browser_getViewport() {
    return {
      th: _Browser_getScene(),
      FA: {
        is: _Browser_window.pageXOffset,
        oK: _Browser_window.pageYOffset,
        FE: _Browser_doc.documentElement.clientWidth,
        x6: _Browser_doc.documentElement.clientHeight
      }
    };
  }

  function _Browser_getScene() {
    var body = _Browser_doc.body;
    var elem = _Browser_doc.documentElement;
    return {
      FE: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
      x6: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
    };
  }

  var _Browser_setViewport = F2(function (x, y) {
    return _Browser_withWindow(function () {
      _Browser_window.scroll(x, y);

      return _Utils_Tuple0;
    });
  }); // ELEMENT VIEWPORT


  function _Browser_getViewportOf(id) {
    return _Browser_withNode(id, function (node) {
      return {
        th: {
          FE: node.scrollWidth,
          x6: node.scrollHeight
        },
        FA: {
          is: node.scrollLeft,
          oK: node.scrollTop,
          FE: node.clientWidth,
          x6: node.clientHeight
        }
      };
    });
  }

  var _Browser_setViewportOf = F3(function (id, x, y) {
    return _Browser_withNode(id, function (node) {
      node.scrollLeft = x;
      node.scrollTop = y;
      return _Utils_Tuple0;
    });
  }); // ELEMENT


  function _Browser_getElement(id) {
    return _Browser_withNode(id, function (node) {
      var rect = node.getBoundingClientRect();
      var x = _Browser_window.pageXOffset;
      var y = _Browser_window.pageYOffset;
      return {
        th: _Browser_getScene(),
        FA: {
          is: x,
          oK: y,
          FE: _Browser_doc.documentElement.clientWidth,
          x6: _Browser_doc.documentElement.clientHeight
        },
        xo: {
          is: x + rect.left,
          oK: y + rect.top,
          FE: rect.width,
          x6: rect.height
        }
      };
    });
  } // LOAD and RELOAD


  function _Browser_reload(skipCache) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function (callback) {
      _VirtualDom_doc.location.reload(skipCache);
    }));
  }

  function _Browser_load(url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function (callback) {
      try {
        _Browser_window.location = url;
      } catch (err) {
        // Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
        // Other browsers reload the page, so let's be consistent about that.
        _VirtualDom_doc.location.reload(false);
      }
    }));
  }

  function _Url_percentEncode(string) {
    return encodeURIComponent(string);
  }

  function _Url_percentDecode(string) {
    try {
      return $elm$core$Maybe$Just(decodeURIComponent(string));
    } catch (e) {
      return $elm$core$Maybe$Nothing;
    }
  }

  var _Bitwise_and = F2(function (a, b) {
    return a & b;
  });

  var _Bitwise_or = F2(function (a, b) {
    return a | b;
  });

  var _Bitwise_xor = F2(function (a, b) {
    return a ^ b;
  });

  function _Bitwise_complement(a) {
    return ~a;
  }

  ;

  var _Bitwise_shiftLeftBy = F2(function (offset, a) {
    return a << offset;
  });

  var _Bitwise_shiftRightBy = F2(function (offset, a) {
    return a >> offset;
  });

  var _Bitwise_shiftRightZfBy = F2(function (offset, a) {
    return a >>> offset;
  });

  function _Time_now(millisToPosix) {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(millisToPosix(Date.now())));
    });
  }

  var _Time_setInterval = F2(function (interval, task) {
    return _Scheduler_binding(function (callback) {
      var id = setInterval(function () {
        _Scheduler_rawSpawn(task);
      }, interval);
      return function () {
        clearInterval(id);
      };
    });
  });

  function _Time_here() {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(A2($elm$time$Time$customZone, -new Date().getTimezoneOffset(), _List_Nil)));
    });
  }

  function _Time_getZoneName() {
    return _Scheduler_binding(function (callback) {
      try {
        var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
      } catch (e) {
        var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
      }

      callback(_Scheduler_succeed(name));
    });
  } // SEND REQUEST


  var _Http_toTask = F3(function (router, toTask, request) {
    return _Scheduler_binding(function (callback) {
      function done(response) {
        callback(toTask(request.xD.a(response)));
      }

      var xhr = new XMLHttpRequest();
      xhr.addEventListener('error', function () {
        done($elm$http$Http$NetworkError_);
      });
      xhr.addEventListener('timeout', function () {
        done($elm$http$Http$Timeout_);
      });
      xhr.addEventListener('load', function () {
        done(_Http_toResponse(request.xD.b, xhr));
      });
      $elm$core$Maybe$isJust(request.t8) && _Http_track(router, xhr, request.t8.a);

      try {
        xhr.open(request.zw, request.Fh, true);
      } catch (e) {
        return done($elm$http$Http$BadUrl_(request.Fh));
      }

      _Http_configureRequest(xhr, request);

      request.d0.a && xhr.setRequestHeader('Content-Type', request.d0.a);
      xhr.send(request.d0.b);
      return function () {
        xhr.c = true;
        xhr.abort();
      };
    });
  }); // CONFIGURE


  function _Http_configureRequest(xhr, request) {
    for (var headers = request.x5; headers.b; headers = headers.b) // WHILE_CONS
    {
      xhr.setRequestHeader(headers.a.a, headers.a.b);
    }

    xhr.timeout = request.ow.a || 0;
    xhr.responseType = request.xD.d;
    xhr.withCredentials = request.uF;
  } // RESPONSES


  function _Http_toResponse(toBody, xhr) {
    return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
  } // METADATA


  function _Http_toMetadata(xhr) {
    return {
      Fh: xhr.responseURL,
      tG: xhr.status,
      En: xhr.statusText,
      x5: _Http_parseHeaders(xhr.getAllResponseHeaders())
    };
  } // HEADERS


  function _Http_parseHeaders(rawHeaders) {
    if (!rawHeaders) {
      return $elm$core$Dict$empty;
    }

    var headers = $elm$core$Dict$empty;
    var headerPairs = rawHeaders.split('\r\n');

    for (var i = headerPairs.length; i--;) {
      var headerPair = headerPairs[i];
      var index = headerPair.indexOf(': ');

      if (index > 0) {
        var key = headerPair.substring(0, index);
        var value = headerPair.substring(index + 2);
        headers = A3($elm$core$Dict$update, key, function (oldValue) {
          return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue) ? value + ', ' + oldValue.a : value);
        }, headers);
      }
    }

    return headers;
  } // EXPECT


  var _Http_expect = F3(function (type, toBody, toValue) {
    return {
      $: 0,
      d: type,
      b: toBody,
      a: toValue
    };
  });

  var _Http_mapExpect = F2(function (func, expect) {
    return {
      $: 0,
      d: expect.d,
      b: expect.b,
      a: function (x) {
        return func(expect.a(x));
      }
    };
  });

  function _Http_toDataView(arrayBuffer) {
    return new DataView(arrayBuffer);
  } // BODY and PARTS


  var _Http_emptyBody = {
    $: 0
  };

  var _Http_pair = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  function _Http_toFormData(parts) {
    for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
    {
      var part = parts.a;
      formData.append(part.a, part.b);
    }

    return formData;
  }

  var _Http_bytesToBlob = F2(function (mime, bytes) {
    return new Blob([bytes], {
      type: mime
    });
  }); // PROGRESS


  function _Http_track(router, xhr, tracker) {
    // TODO check out lengthComputable on loadstart event
    xhr.upload.addEventListener('progress', function (event) {
      if (xhr.c) {
        return;
      }

      _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
        DW: event.loaded,
        aB: event.total
      }))));
    });
    xhr.addEventListener('progress', function (event) {
      if (xhr.c) {
        return;
      }

      _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
        CN: event.loaded,
        aB: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
      }))));
    });
  } // CREATE


  var _Regex_never = /.^/;

  var _Regex_fromStringWith = F2(function (options, string) {
    var flags = 'g';

    if (options.zK) {
      flags += 'm';
    }

    if (options.vK) {
      flags += 'i';
    }

    try {
      return $elm$core$Maybe$Just(new RegExp(string, flags));
    } catch (error) {
      return $elm$core$Maybe$Nothing;
    }
  }); // USE


  var _Regex_contains = F2(function (re, string) {
    return string.match(re) !== null;
  });

  var _Regex_findAtMost = F3(function (n, re, str) {
    var out = [];
    var number = 0;
    var string = str;
    var lastIndex = re.lastIndex;
    var prevLastIndex = -1;
    var result;

    while (number++ < n && (result = re.exec(string))) {
      if (prevLastIndex == re.lastIndex) break;
      var i = result.length - 1;
      var subs = new Array(i);

      while (i > 0) {
        var submatch = result[i];
        subs[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
      }

      out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
      prevLastIndex = re.lastIndex;
    }

    re.lastIndex = lastIndex;
    return _List_fromArray(out);
  });

  var _Regex_replaceAtMost = F4(function (n, re, replacer, string) {
    var count = 0;

    function jsReplacer(match) {
      if (count++ >= n) {
        return match;
      }

      var i = arguments.length - 3;
      var submatches = new Array(i);

      while (i > 0) {
        var submatch = arguments[i];
        submatches[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
      }

      return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
    }

    return string.replace(re, jsReplacer);
  });

  var _Regex_splitAtMost = F3(function (n, re, str) {
    var string = str;
    var out = [];
    var start = re.lastIndex;
    var restoreLastIndex = re.lastIndex;

    while (n--) {
      var result = re.exec(string);
      if (!result) break;
      out.push(string.slice(start, result.index));
      start = re.lastIndex;
    }

    out.push(string.slice(start));
    re.lastIndex = restoreLastIndex;
    return _List_fromArray(out);
  });

  var _Regex_infinity = Infinity; // STRINGS

  var _Parser_isSubString = F5(function (smallString, offset, row, col, bigString) {
    var smallLength = smallString.length;
    var isGood = offset + smallLength <= bigString.length;

    for (var i = 0; isGood && i < smallLength;) {
      var code = bigString.charCodeAt(offset);
      isGood = smallString[i++] === bigString[offset++] && (code === 0x000A
      /* \n */
      ? (row++, col = 1) : (col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1));
    }

    return _Utils_Tuple3(isGood ? offset : -1, row, col);
  }); // CHARS


  var _Parser_isSubChar = F3(function (predicate, offset, string) {
    return string.length <= offset ? -1 : (string.charCodeAt(offset) & 0xF800) === 0xD800 ? predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1 : predicate(_Utils_chr(string[offset])) ? string[offset] === '\n' ? -2 : offset + 1 : -1;
  });

  var _Parser_isAsciiCode = F3(function (code, offset, string) {
    return string.charCodeAt(offset) === code;
  }); // NUMBERS


  var _Parser_chompBase10 = F2(function (offset, string) {
    for (; offset < string.length; offset++) {
      var code = string.charCodeAt(offset);

      if (code < 0x30 || 0x39 < code) {
        return offset;
      }
    }

    return offset;
  });

  var _Parser_consumeBase = F3(function (base, offset, string) {
    for (var total = 0; offset < string.length; offset++) {
      var digit = string.charCodeAt(offset) - 0x30;
      if (digit < 0 || base <= digit) break;
      total = base * total + digit;
    }

    return _Utils_Tuple2(offset, total);
  });

  var _Parser_consumeBase16 = F2(function (offset, string) {
    for (var total = 0; offset < string.length; offset++) {
      var code = string.charCodeAt(offset);

      if (0x30 <= code && code <= 0x39) {
        total = 16 * total + code - 0x30;
      } else if (0x41 <= code && code <= 0x46) {
        total = 16 * total + code - 55;
      } else if (0x61 <= code && code <= 0x66) {
        total = 16 * total + code - 87;
      } else {
        break;
      }
    }

    return _Utils_Tuple2(offset, total);
  }); // FIND STRING


  var _Parser_findSubString = F5(function (smallString, offset, row, col, bigString) {
    var newOffset = bigString.indexOf(smallString, offset);
    var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

    while (offset < target) {
      var code = bigString.charCodeAt(offset++);
      code === 0x000A
      /* \n */
      ? (col = 1, row++) : (col++, (code & 0xF800) === 0xD800 && offset++);
    }

    return _Utils_Tuple3(newOffset, row, col);
  });

  var $elm$core$Maybe$Just = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$core$Maybe$Nothing = {
    $: 1
  };
  var $elm$core$List$cons = _List_cons;
  var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
  var $elm$core$Array$foldr = F3(function (func, baseCase, _v0) {
    var tree = _v0.c;
    var tail = _v0.d;
    var helper = F2(function (node, acc) {
      if (!node.$) {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
      } else {
        var values = node.a;
        return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
      }
    });
    return A3($elm$core$Elm$JsArray$foldr, helper, A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail), tree);
  });

  var $elm$core$Array$toList = function (array) {
    return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
  };

  var $elm$core$Dict$foldr = F3(function (func, acc, t) {
    foldr: while (true) {
      if (t.$ === -2) {
        return acc;
      } else {
        var key = t.b;
        var value = t.c;
        var left = t.d;
        var right = t.e;
        var $temp$func = func,
            $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldr, func, acc, right)),
            $temp$t = left;
        func = $temp$func;
        acc = $temp$acc;
        t = $temp$t;
        continue foldr;
      }
    }
  });

  var $elm$core$Dict$toList = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, list) {
      return A2($elm$core$List$cons, _Utils_Tuple2(key, value), list);
    }), _List_Nil, dict);
  };

  var $elm$core$Dict$keys = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, keyList) {
      return A2($elm$core$List$cons, key, keyList);
    }), _List_Nil, dict);
  };

  var $elm$core$Set$toList = function (_v0) {
    var dict = _v0;
    return $elm$core$Dict$keys(dict);
  };

  var $elm$core$Basics$EQ = 1;
  var $elm$core$Basics$GT = 2;
  var $elm$core$Basics$LT = 0;

  var $elm$core$Result$Err = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$json$Json$Decode$Failure = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $elm$json$Json$Decode$Field = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$json$Json$Decode$Index = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });

  var $elm$core$Result$Ok = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$json$Json$Decode$OneOf = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $elm$core$Basics$False = 1;
  var $elm$core$Basics$add = _Basics_add;
  var $elm$core$String$all = _String_all;
  var $elm$core$Basics$and = _Basics_and;
  var $elm$core$Basics$append = _Utils_append;
  var $elm$json$Json$Encode$encode = _Json_encode;
  var $elm$core$String$fromInt = _String_fromNumber;
  var $elm$core$String$join = F2(function (sep, chunks) {
    return A2(_String_join, sep, _List_toArray(chunks));
  });
  var $elm$core$String$split = F2(function (sep, string) {
    return _List_fromArray(A2(_String_split, sep, string));
  });

  var $elm$json$Json$Decode$indent = function (str) {
    return A2($elm$core$String$join, '\n    ', A2($elm$core$String$split, '\n', str));
  };

  var $elm$core$List$foldl = F3(function (func, acc, list) {
    foldl: while (true) {
      if (!list.b) {
        return acc;
      } else {
        var x = list.a;
        var xs = list.b;
        var $temp$func = func,
            $temp$acc = A2(func, x, acc),
            $temp$list = xs;
        func = $temp$func;
        acc = $temp$acc;
        list = $temp$list;
        continue foldl;
      }
    }
  });

  var $elm$core$List$length = function (xs) {
    return A3($elm$core$List$foldl, F2(function (_v0, i) {
      return i + 1;
    }), 0, xs);
  };

  var $elm$core$List$map2 = _List_map2;
  var $elm$core$Basics$le = _Utils_le;
  var $elm$core$Basics$sub = _Basics_sub;
  var $elm$core$List$rangeHelp = F3(function (lo, hi, list) {
    rangeHelp: while (true) {
      if (_Utils_cmp(lo, hi) < 1) {
        var $temp$lo = lo,
            $temp$hi = hi - 1,
            $temp$list = A2($elm$core$List$cons, hi, list);
        lo = $temp$lo;
        hi = $temp$hi;
        list = $temp$list;
        continue rangeHelp;
      } else {
        return list;
      }
    }
  });
  var $elm$core$List$range = F2(function (lo, hi) {
    return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
  });
  var $elm$core$List$indexedMap = F2(function (f, xs) {
    return A3($elm$core$List$map2, f, A2($elm$core$List$range, 0, $elm$core$List$length(xs) - 1), xs);
  });
  var $elm$core$Char$toCode = _Char_toCode;

  var $elm$core$Char$isLower = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return 97 <= code && code <= 122;
  };

  var $elm$core$Char$isUpper = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return code <= 90 && 65 <= code;
  };

  var $elm$core$Basics$or = _Basics_or;

  var $elm$core$Char$isAlpha = function (_char) {
    return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
  };

  var $elm$core$Char$isDigit = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return code <= 57 && 48 <= code;
  };

  var $elm$core$Char$isAlphaNum = function (_char) {
    return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char);
  };

  var $elm$core$List$reverse = function (list) {
    return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
  };

  var $elm$core$String$uncons = _String_uncons;
  var $elm$json$Json$Decode$errorOneOf = F2(function (i, error) {
    return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
  });

  var $elm$json$Json$Decode$errorToString = function (error) {
    return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
  };

  var $elm$json$Json$Decode$errorToStringHelp = F2(function (error, context) {
    errorToStringHelp: while (true) {
      switch (error.$) {
        case 0:
          var f = error.a;
          var err = error.b;

          var isSimple = function () {
            var _v1 = $elm$core$String$uncons(f);

            if (_v1.$ === 1) {
              return false;
            } else {
              var _v2 = _v1.a;
              var _char = _v2.a;
              var rest = _v2.b;
              return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
            }
          }();

          var fieldName = isSimple ? '.' + f : '[\'' + (f + '\']');
          var $temp$error = err,
              $temp$context = A2($elm$core$List$cons, fieldName, context);
          error = $temp$error;
          context = $temp$context;
          continue errorToStringHelp;

        case 1:
          var i = error.a;
          var err = error.b;
          var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
          var $temp$error = err,
              $temp$context = A2($elm$core$List$cons, indexName, context);
          error = $temp$error;
          context = $temp$context;
          continue errorToStringHelp;

        case 2:
          var errors = error.a;

          if (!errors.b) {
            return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
              if (!context.b) {
                return '!';
              } else {
                return ' at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
              }
            }();
          } else {
            if (!errors.b.b) {
              var err = errors.a;
              var $temp$error = err,
                  $temp$context = context;
              error = $temp$error;
              context = $temp$context;
              continue errorToStringHelp;
            } else {
              var starter = function () {
                if (!context.b) {
                  return 'Json.Decode.oneOf';
                } else {
                  return 'The Json.Decode.oneOf at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
                }
              }();

              var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt($elm$core$List$length(errors)) + ' ways:'));
              return A2($elm$core$String$join, '\n\n', A2($elm$core$List$cons, introduction, A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
            }
          }

        default:
          var msg = error.a;
          var json = error.b;

          var introduction = function () {
            if (!context.b) {
              return 'Problem with the given value:\n\n';
            } else {
              return 'Problem with the value at json' + (A2($elm$core$String$join, '', $elm$core$List$reverse(context)) + ':\n\n    ');
            }
          }();

          return introduction + ($elm$json$Json$Decode$indent(A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
      }
    }
  });
  var $elm$core$Array$branchFactor = 32;
  var $elm$core$Array$Array_elm_builtin = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $elm$core$Elm$JsArray$empty = _JsArray_empty;
  var $elm$core$Basics$ceiling = _Basics_ceiling;
  var $elm$core$Basics$fdiv = _Basics_fdiv;
  var $elm$core$Basics$logBase = F2(function (base, number) {
    return _Basics_log(number) / _Basics_log(base);
  });
  var $elm$core$Basics$toFloat = _Basics_toFloat;
  var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
  var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
  var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;

  var $elm$core$Array$Leaf = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$core$Basics$apL = F2(function (f, x) {
    return f(x);
  });
  var $elm$core$Basics$apR = F2(function (x, f) {
    return f(x);
  });
  var $elm$core$Basics$eq = _Utils_equal;
  var $elm$core$Basics$floor = _Basics_floor;
  var $elm$core$Elm$JsArray$length = _JsArray_length;
  var $elm$core$Basics$gt = _Utils_gt;
  var $elm$core$Basics$max = F2(function (x, y) {
    return _Utils_cmp(x, y) > 0 ? x : y;
  });
  var $elm$core$Basics$mul = _Basics_mul;

  var $elm$core$Array$SubTree = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
  var $elm$core$Array$compressNodes = F2(function (nodes, acc) {
    compressNodes: while (true) {
      var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);

      var node = _v0.a;
      var remainingNodes = _v0.b;
      var newAcc = A2($elm$core$List$cons, $elm$core$Array$SubTree(node), acc);

      if (!remainingNodes.b) {
        return $elm$core$List$reverse(newAcc);
      } else {
        var $temp$nodes = remainingNodes,
            $temp$acc = newAcc;
        nodes = $temp$nodes;
        acc = $temp$acc;
        continue compressNodes;
      }
    }
  });

  var $elm$core$Tuple$first = function (_v0) {
    var x = _v0.a;
    return x;
  };

  var $elm$core$Array$treeFromBuilder = F2(function (nodeList, nodeListSize) {
    treeFromBuilder: while (true) {
      var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);

      if (newNodeSize === 1) {
        return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
      } else {
        var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
            $temp$nodeListSize = newNodeSize;
        nodeList = $temp$nodeList;
        nodeListSize = $temp$nodeListSize;
        continue treeFromBuilder;
      }
    }
  });
  var $elm$core$Array$builderToArray = F2(function (reverseNodeList, builder) {
    if (!builder.bx) {
      return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.bL), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.bL);
    } else {
      var treeLen = builder.bx * $elm$core$Array$branchFactor;
      var depth = $elm$core$Basics$floor(A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
      var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.bO) : builder.bO;
      var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.bx);
      return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.bL) + treeLen, A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep), tree, builder.bL);
    }
  });
  var $elm$core$Basics$idiv = _Basics_idiv;
  var $elm$core$Basics$lt = _Utils_lt;
  var $elm$core$Array$initializeHelp = F5(function (fn, fromIndex, len, nodeList, tail) {
    initializeHelp: while (true) {
      if (fromIndex < 0) {
        return A2($elm$core$Array$builderToArray, false, {
          bO: nodeList,
          bx: len / $elm$core$Array$branchFactor | 0,
          bL: tail
        });
      } else {
        var leaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
        var $temp$fn = fn,
            $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
            $temp$len = len,
            $temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
            $temp$tail = tail;
        fn = $temp$fn;
        fromIndex = $temp$fromIndex;
        len = $temp$len;
        nodeList = $temp$nodeList;
        tail = $temp$tail;
        continue initializeHelp;
      }
    }
  });
  var $elm$core$Basics$remainderBy = _Basics_remainderBy;
  var $elm$core$Array$initialize = F2(function (len, fn) {
    if (len <= 0) {
      return $elm$core$Array$empty;
    } else {
      var tailLen = len % $elm$core$Array$branchFactor;
      var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
      var initialFromIndex = len - tailLen - $elm$core$Array$branchFactor;
      return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
    }
  });
  var $elm$core$Basics$True = 0;

  var $elm$core$Result$isOk = function (result) {
    if (!result.$) {
      return true;
    } else {
      return false;
    }
  };

  var $elm$json$Json$Decode$andThen = _Json_andThen;
  var $elm$json$Json$Decode$map = _Json_map1;
  var $elm$json$Json$Decode$map2 = _Json_map2;
  var $elm$json$Json$Decode$succeed = _Json_succeed;

  var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
    switch (handler.$) {
      case 0:
        return 0;

      case 1:
        return 1;

      case 2:
        return 2;

      default:
        return 3;
    }
  };

  var $elm$browser$Browser$External = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$browser$Browser$Internal = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$core$Basics$identity = function (x) {
    return x;
  };

  var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
  var $elm$url$Url$Http = 0;
  var $elm$url$Url$Https = 1;
  var $elm$url$Url$Url = F6(function (protocol, host, port_, path, query, fragment) {
    return {
      qz: fragment,
      lE: host,
      e2: path,
      nm: port_,
      nt: protocol,
      sR: query
    };
  });
  var $elm$core$String$contains = _String_contains;
  var $elm$core$String$length = _String_length;
  var $elm$core$String$slice = _String_slice;
  var $elm$core$String$dropLeft = F2(function (n, string) {
    return n < 1 ? string : A3($elm$core$String$slice, n, $elm$core$String$length(string), string);
  });
  var $elm$core$String$indexes = _String_indexes;

  var $elm$core$String$isEmpty = function (string) {
    return string === '';
  };

  var $elm$core$String$left = F2(function (n, string) {
    return n < 1 ? '' : A3($elm$core$String$slice, 0, n, string);
  });
  var $elm$core$String$toInt = _String_toInt;
  var $elm$url$Url$chompBeforePath = F5(function (protocol, path, params, frag, str) {
    if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, ':', str);

      if (!_v0.b) {
        return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
      } else {
        if (!_v0.b.b) {
          var i = _v0.a;

          var _v1 = $elm$core$String$toInt(A2($elm$core$String$dropLeft, i + 1, str));

          if (_v1.$ === 1) {
            return $elm$core$Maybe$Nothing;
          } else {
            var port_ = _v1;
            return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, A2($elm$core$String$left, i, str), port_, path, params, frag));
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }
    }
  });
  var $elm$url$Url$chompBeforeQuery = F4(function (protocol, params, frag, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '/', str);

      if (!_v0.b) {
        return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
      } else {
        var i = _v0.a;
        return A5($elm$url$Url$chompBeforePath, protocol, A2($elm$core$String$dropLeft, i, str), params, frag, A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$url$Url$chompBeforeFragment = F3(function (protocol, frag, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '?', str);

      if (!_v0.b) {
        return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
      } else {
        var i = _v0.a;
        return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), frag, A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$url$Url$chompAfterProtocol = F2(function (protocol, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '#', str);

      if (!_v0.b) {
        return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
      } else {
        var i = _v0.a;
        return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$core$String$startsWith = _String_startsWith;

  var $elm$url$Url$fromString = function (str) {
    return A2($elm$core$String$startsWith, 'http://', str) ? A2($elm$url$Url$chompAfterProtocol, 0, A2($elm$core$String$dropLeft, 7, str)) : A2($elm$core$String$startsWith, 'https://', str) ? A2($elm$url$Url$chompAfterProtocol, 1, A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing;
  };

  var $elm$core$Basics$never = function (_v0) {
    never: while (true) {
      var nvr = _v0;
      var $temp$_v0 = nvr;
      _v0 = $temp$_v0;
      continue never;
    }
  };

  var $elm$core$Task$Perform = $elm$core$Basics$identity;
  var $elm$core$Task$succeed = _Scheduler_succeed;
  var $elm$core$Task$init = $elm$core$Task$succeed(0);
  var $elm$core$List$foldrHelper = F4(function (fn, acc, ctr, ls) {
    if (!ls.b) {
      return acc;
    } else {
      var a = ls.a;
      var r1 = ls.b;

      if (!r1.b) {
        return A2(fn, a, acc);
      } else {
        var b = r1.a;
        var r2 = r1.b;

        if (!r2.b) {
          return A2(fn, a, A2(fn, b, acc));
        } else {
          var c = r2.a;
          var r3 = r2.b;

          if (!r3.b) {
            return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
          } else {
            var d = r3.a;
            var r4 = r3.b;
            var res = ctr > 500 ? A3($elm$core$List$foldl, fn, acc, $elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
            return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
          }
        }
      }
    }
  });
  var $elm$core$List$foldr = F3(function (fn, acc, ls) {
    return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
  });
  var $elm$core$List$map = F2(function (f, xs) {
    return A3($elm$core$List$foldr, F2(function (x, acc) {
      return A2($elm$core$List$cons, f(x), acc);
    }), _List_Nil, xs);
  });
  var $elm$core$Task$andThen = _Scheduler_andThen;
  var $elm$core$Task$map = F2(function (func, taskA) {
    return A2($elm$core$Task$andThen, function (a) {
      return $elm$core$Task$succeed(func(a));
    }, taskA);
  });
  var $elm$core$Task$map2 = F3(function (func, taskA, taskB) {
    return A2($elm$core$Task$andThen, function (a) {
      return A2($elm$core$Task$andThen, function (b) {
        return $elm$core$Task$succeed(A2(func, a, b));
      }, taskB);
    }, taskA);
  });

  var $elm$core$Task$sequence = function (tasks) {
    return A3($elm$core$List$foldr, $elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
  };

  var $elm$core$Platform$sendToApp = _Platform_sendToApp;
  var $elm$core$Task$spawnCmd = F2(function (router, _v0) {
    var task = _v0;
    return _Scheduler_spawn(A2($elm$core$Task$andThen, $elm$core$Platform$sendToApp(router), task));
  });
  var $elm$core$Task$onEffects = F3(function (router, commands, state) {
    return A2($elm$core$Task$map, function (_v0) {
      return 0;
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Task$spawnCmd(router), commands)));
  });
  var $elm$core$Task$onSelfMsg = F3(function (_v0, _v1, _v2) {
    return $elm$core$Task$succeed(0);
  });
  var $elm$core$Task$cmdMap = F2(function (tagger, _v0) {
    var task = _v0;
    return A2($elm$core$Task$map, tagger, task);
  });
  _Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);

  var $elm$core$Task$command = _Platform_leaf('Task');

  var $elm$core$Task$perform = F2(function (toMessage, task) {
    return $elm$core$Task$command(A2($elm$core$Task$map, toMessage, task));
  });
  var $elm$browser$Browser$element = _Browser_element;

  var $author$project$ElmFramework$Msg$AppMsg = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnknownPushPermissions = {
    $: 0
  };
  var $elm$core$Platform$Cmd$batch = _Platform_batch;

  var $wernerdegroot$listzipper$List$Zipper$current = function (_v0) {
    var x = _v0.b;
    return x;
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$current = function (_v0) {
    var routeHistory = _v0.a;
    return $wernerdegroot$listzipper$List$Zipper$current(routeHistory);
  };

  var $elm$time$Time$Zone = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$time$Time$customZone = $elm$time$Time$Zone;
  var $author$project$ElmFramework$Lib$MsgAnything$dispatchMessages = F2(function (mainUpdate, _v0) {
    var state = _v0.Ej;
    var commands = _v0.v0;
    var messages = _v0.zv;
    var runMessages = F2(function (currMsg, _v2) {
      var newState = _v2.a;
      var newCmd = _v2.b;
      return function (_v1) {
        var newestState = _v1.a;
        var newestCmd = _v1.b;
        return _Utils_Tuple2(newestState, $elm$core$Platform$Cmd$batch(_List_fromArray([newCmd, newestCmd])));
      }(A2(mainUpdate, currMsg, newState));
    });
    return A3($elm$core$List$foldl, runMessages, _Utils_Tuple2(state, commands), messages);
  });
  var $folkertdev$elm_deque$BoundedDeque$BoundedDeque = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $folkertdev$elm_deque$Internal$empty = {
    cN: _List_Nil,
    c$: _List_Nil,
    cb: 0,
    cc: 0
  };

  var $folkertdev$elm_deque$BoundedDeque$empty = function (size) {
    return A2($folkertdev$elm_deque$BoundedDeque$BoundedDeque, $folkertdev$elm_deque$Internal$empty, size);
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$init = function (isHybrid) {
    return isHybrid ? {
      iS: true,
      iU: true,
      ic: false
    } : {
      iS: false,
      iU: false,
      ic: false
    };
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$init = {
    eR: 0,
    ed: $elm$core$Array$empty,
    b6: 0
  };
  var $elm$json$Json$Encode$null = _Json_encodeNull;

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries = _Platform_outgoingPort('loadSocialLibraries', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $elm$core$Platform$Cmd$map = _Platform_map;
  var $elm$time$Time$Posix = $elm$core$Basics$identity;
  var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
  var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $wernerdegroot$listzipper$List$Zipper$Zipper = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });

  var $wernerdegroot$listzipper$List$Zipper$singleton = function (x) {
    return A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, x, _List_Nil);
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton = function (route) {
    return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, $wernerdegroot$listzipper$List$Zipper$singleton(route), $elm$core$Maybe$Nothing, false);
  };

  var $author$project$ElmFramework$Feature$Pwa$Pwa$PwaInstalled = 2;
  var $author$project$ElmFramework$Feature$Pwa$Pwa$PwaNotInstalled = 0;

  var $author$project$ElmFramework$InitArgs$toEnv = function (envArg) {
    return {
      i$: envArg.i$,
      i0: envArg.i0,
      i3: envArg.i3,
      yQ: envArg.yQ,
      i5: envArg.i5,
      i6: envArg.i6,
      i8: envArg.i8,
      i9: envArg.i9,
      jd: envArg.jd,
      jx: envArg.jx ? 2 : 0,
      jX: envArg.jX,
      Ey: envArg.Ey
    };
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions = {
    $: 4
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivingGeoLocation = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus = {
    $: 0
  };
  var $elm$json$Json$Encode$bool = _Json_wrap;
  var $elm$core$Maybe$destruct = F3(function (_default, func, maybe) {
    if (!maybe.$) {
      var a = maybe.a;
      return func(a);
    } else {
      return _default;
    }
  });
  var $elm$json$Json$Encode$int = _Json_wrap;

  var $elm$json$Json$Encode$object = function (pairs) {
    return _Json_wrap(A3($elm$core$List$foldl, F2(function (_v0, obj) {
      var k = _v0.a;
      var v = _v0.b;
      return A3(_Json_addField, k, v, obj);
    }), _Json_emptyObject(0), pairs));
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$requestGeolocation = _Platform_outgoingPort('requestGeolocation', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('enableHighAccuracy', $elm$json$Json$Encode$bool($.k7)), _Utils_Tuple2('explicitRequest', $elm$json$Json$Encode$bool($.lj)), _Utils_Tuple2('maximumAge', function ($) {
      return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, $);
    }($.mn)), _Utils_Tuple2('timeout', function ($) {
      return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, $);
    }($.ow))]));
  });

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq = function (isExplicitRequest) {
    return $author$project$ElmFramework$Feature$Geolocation$Geolocation$requestGeolocation({
      k7: false,
      lj: isExplicitRequest,
      mn: $elm$core$Maybe$Nothing,
      ow: $elm$core$Maybe$Just(15000)
    });
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$toInitGeoPermissions = F2(function (status, shouldGetGeolocationOnInit) {
    if (!status.$) {
      if (status.a) {
        return _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivingGeoLocation), shouldGetGeolocationOnInit ? $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true) : $elm$core$Platform$Cmd$none);
      } else {
        return _Utils_Tuple2($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions, $elm$core$Platform$Cmd$none);
      }
    } else {
      return _Utils_Tuple2($author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus, $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ElmFramework$Lib$StateCmd$addCmd = F2(function (newCmd, _v0) {
    var state = _v0.a;
    var cmd = _v0.b;
    return _Utils_Tuple2(state, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, newCmd])));
  });
  var $elm$core$Basics$composeL = F3(function (g, f, x) {
    return g(f(x));
  });

  var $elm$core$String$concat = function (strings) {
    return A2($elm$core$String$join, '', strings);
  };

  var $elm$core$List$filter = F2(function (isGood, list) {
    return A3($elm$core$List$foldr, F2(function (x, xs) {
      return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
    }), _List_Nil, list);
  });
  var $elm$core$List$maybeCons = F3(function (f, mx, xs) {
    var _v0 = f(mx);

    if (!_v0.$) {
      var x = _v0.a;
      return A2($elm$core$List$cons, x, xs);
    } else {
      return xs;
    }
  });
  var $elm$core$List$filterMap = F2(function (f, xs) {
    return A3($elm$core$List$foldr, $elm$core$List$maybeCons(f), _List_Nil, xs);
  });
  var $elm$core$Dict$RBEmpty_elm_builtin = {
    $: -2
  };
  var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
  var $elm$core$Dict$Black = 1;
  var $elm$core$Dict$RBNode_elm_builtin = F5(function (a, b, c, d, e) {
    return {
      $: -1,
      a: a,
      b: b,
      c: c,
      d: d,
      e: e
    };
  });
  var $elm$core$Dict$Red = 0;
  var $elm$core$Dict$balance = F5(function (color, key, value, left, right) {
    if (right.$ === -1 && !right.a) {
      var _v1 = right.a;
      var rK = right.b;
      var rV = right.c;
      var rLeft = right.d;
      var rRight = right.e;

      if (left.$ === -1 && !left.a) {
        var _v3 = left.a;
        var lK = left.b;
        var lV = left.c;
        var lLeft = left.d;
        var lRight = left.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, rK, rV, A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft), rRight);
      }
    } else {
      if (left.$ === -1 && !left.a && left.d.$ === -1 && !left.d.a) {
        var _v5 = left.a;
        var lK = left.b;
        var lV = left.c;
        var _v6 = left.d;
        var _v7 = _v6.a;
        var llK = _v6.b;
        var llV = _v6.c;
        var llLeft = _v6.d;
        var llRight = _v6.e;
        var lRight = left.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
      }
    }
  });
  var $elm$core$Basics$compare = _Utils_compare;
  var $elm$core$Dict$insertHelp = F3(function (key, value, dict) {
    if (dict.$ === -2) {
      return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    } else {
      var nColor = dict.a;
      var nKey = dict.b;
      var nValue = dict.c;
      var nLeft = dict.d;
      var nRight = dict.e;

      var _v1 = A2($elm$core$Basics$compare, key, nKey);

      switch (_v1) {
        case 0:
          return A5($elm$core$Dict$balance, nColor, nKey, nValue, A3($elm$core$Dict$insertHelp, key, value, nLeft), nRight);

        case 1:
          return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);

        default:
          return A5($elm$core$Dict$balance, nColor, nKey, nValue, nLeft, A3($elm$core$Dict$insertHelp, key, value, nRight));
      }
    }
  });
  var $elm$core$Dict$insert = F3(function (key, value, dict) {
    var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);

    if (_v0.$ === -1 && !_v0.a) {
      var _v1 = _v0.a;
      var k = _v0.b;
      var v = _v0.c;
      var l = _v0.d;
      var r = _v0.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
    } else {
      var x = _v0;
      return x;
    }
  });

  var $elm$core$Dict$fromList = function (assocs) {
    return A3($elm$core$List$foldl, F2(function (_v0, dict) {
      var key = _v0.a;
      var value = _v0.b;
      return A3($elm$core$Dict$insert, key, value, dict);
    }), $elm$core$Dict$empty, assocs);
  };

  var $author$project$ElmFramework$Lib$Util$ifElse = F3(function (forTrue, forFalse, bool) {
    return bool ? forTrue : forFalse;
  });
  var $elm$core$Maybe$map2 = F3(function (func, ma, mb) {
    if (ma.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var a = ma.a;

      if (mb.$ === 1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var b = mb.a;
        return $elm$core$Maybe$Just(A2(func, a, b));
      }
    }
  });
  var $elm$core$Tuple$mapBoth = F3(function (funcA, funcB, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(funcA(x), funcB(y));
  });
  var $elm$core$Basics$not = _Basics_not;
  var $elm$core$Tuple$pair = F2(function (a, b) {
    return _Utils_Tuple2(a, b);
  });
  var $elm$url$Url$percentDecode = _Url_percentDecode;

  var $elm$core$Tuple$second = function (_v0) {
    var y = _v0.b;
    return y;
  };

  var $author$project$ElmFramework$Lib$Url$fromNavigationLocation = function (location) {
    var splitAndFilterEmpty = F2(function (delimiter, string) {
      return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty), A2($elm$core$String$split, delimiter, string));
    });

    var removeQuestionMarkPrefix = function (string) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, A2($elm$core$String$dropLeft, 1, string), string, A2($elm$core$String$startsWith, '?', string));
    };

    var pathList = A2(splitAndFilterEmpty, '/', location.nb);

    var listToTuple = function (list) {
      var maybeList = A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Just(list), $elm$core$Maybe$Nothing, $elm$core$List$length(list) === 2);

      if (!maybeList.$ && maybeList.a.b && maybeList.a.b.b && !maybeList.a.b.b.b) {
        var _v1 = maybeList.a;
        var key = _v1.a;
        var _v2 = _v1.b;
        var value = _v2.a;
        return $elm$core$Maybe$Just(_Utils_Tuple2(key, value));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    };

    var decodeQueryParams = function (list) {
      var uncurry2 = F2(function (fun, tup) {
        return A2(fun, tup.a, tup.b);
      });
      return A2($elm$core$List$filterMap, uncurry2($elm$core$Maybe$map2($elm$core$Tuple$pair)), A2($elm$core$List$map, A2($elm$core$Tuple$mapBoth, $elm$url$Url$percentDecode, $elm$url$Url$percentDecode), list));
    };

    var addDefaultValueIfEmpty = F2(function (_default, string) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, string, $elm$core$String$concat(_List_fromArray([string, '=', _default])), A2($elm$core$String$contains, '=', string));
    });
    var queryDict = $elm$core$Dict$fromList(decodeQueryParams(A2($elm$core$List$filterMap, listToTuple, A2($elm$core$List$map, splitAndFilterEmpty('='), A2($elm$core$List$map, addDefaultValueIfEmpty('true'), A2(splitAndFilterEmpty, '&', removeQuestionMarkPrefix(location.nU)))))));
    return {
      e2: pathList,
      h$: queryDict
    };
  };

  var $elm$core$Maybe$map = F2(function (f, maybe) {
    if (!maybe.$) {
      var value = maybe.a;
      return $elm$core$Maybe$Just(f(value));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PushState = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$ReplaceState = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $wernerdegroot$listzipper$List$Zipper$before = function (_v0) {
    var ls = _v0.a;
    return $elm$core$List$reverse(ls);
  };

  var $wernerdegroot$listzipper$List$Zipper$from = F3(function (bef, curr, aft) {
    return A3($wernerdegroot$listzipper$List$Zipper$Zipper, $elm$core$List$reverse(bef), curr, aft);
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$newRoute = F2(function (route, _v0) {
    var routeHistory = _v0.a;
    return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, A3($wernerdegroot$listzipper$List$Zipper$from, _Utils_ap($wernerdegroot$listzipper$List$Zipper$before(routeHistory), _List_fromArray([$wernerdegroot$listzipper$List$Zipper$current(routeHistory)])), route, _List_Nil), $elm$core$Maybe$Nothing, false);
  });
  var $elm$core$Basics$always = F2(function (a, _v0) {
    return a;
  });
  var $wernerdegroot$listzipper$List$Zipper$mapCurrent = F2(function (f, _v0) {
    var ls = _v0.a;
    var x = _v0.b;
    var rs = _v0.c;
    return A3($wernerdegroot$listzipper$List$Zipper$Zipper, ls, f(x), rs);
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceRoute = F2(function (route, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, A2($wernerdegroot$listzipper$List$Zipper$mapCurrent, $elm$core$Basics$always(route), routeHistory), $elm$core$Maybe$Nothing, isBack);
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex = function (zipperHistory) {
    return $elm$core$List$length($wernerdegroot$listzipper$List$Zipper$before(zipperHistory));
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex = function (_v0) {
    var routeHistory = _v0.a;
    return $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(routeHistory);
  };

  var $elm$json$Json$Encode$list = F2(function (func, entries) {
    return _Json_wrap(A3($elm$core$List$foldl, _Json_addEntry(func), _Json_emptyArray(0), entries));
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routingCommands = _Platform_outgoingPort('routingCommands', $elm$json$Json$Encode$list($elm$core$Basics$identity));

  var $elm$json$Json$Encode$string = _Json_wrap;

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands = function (commands) {
    var toCommand = function (cmd) {
      switch (cmd.$) {
        case 0:
          var routeState = cmd.a;
          return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('kind', $elm$json$Json$Encode$string('pushState')), _Utils_Tuple2('stateIndex', $elm$json$Json$Encode$int(routeState.ea)), _Utils_Tuple2('title', $elm$json$Json$Encode$string(routeState.t1)), _Utils_Tuple2('url', $elm$json$Json$Encode$string(routeState.Fh))]));

        case 1:
          var routeState = cmd.a;
          return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('kind', $elm$json$Json$Encode$string('replaceState')), _Utils_Tuple2('stateIndex', $elm$json$Json$Encode$int(routeState.ea)), _Utils_Tuple2('title', $elm$json$Json$Encode$string(routeState.t1)), _Utils_Tuple2('url', $elm$json$Json$Encode$string(routeState.Fh))]));

        default:
          var _int = cmd.a;
          return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('kind', $elm$json$Json$Encode$string('go')), _Utils_Tuple2('steps', $elm$json$Json$Encode$int(_int))]));
      }
    };

    return $author$project$ElmFramework$Feature$Navigation$RouteHistory$routingCommands(A2($elm$core$List$map, toCommand, commands));
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo = function (config) {
    var theRoutingCommands = _List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$ReplaceState({
      ea: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.e7),
      t1: config.CW,
      Fh: config.CX
    }), $author$project$ElmFramework$Feature$Navigation$RouteHistory$PushState({
      ea: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.e7) + 1,
      t1: config.Dq,
      Fh: config.Ds
    })]);

    var routeHistory = A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$newRoute, config.Dn, A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceRoute, config.CV, config.e7));
    return _Utils_Tuple2(routeHistory, $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(theRoutingCommands));
  };

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError = _Platform_outgoingPort('generalError', $elm$json$Json$Encode$string);

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toGeneralErrorString = function (description) {
    return '' + description;
  };

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr = F2(function (description, err) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toGeneralErrorString(description) + (': ' + err));
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute = function (config) {
    return config.n4 ? _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceRoute, config.tc, config.e7), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$ReplaceState({
      ea: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.e7),
      t1: config.t1,
      Fh: config.Fh
    })]))) : _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$newRoute, config.tc, config.e7), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$PushState({
      ea: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.e7) + 1,
      t1: config.t1,
      Fh: config.Fh
    })])));
  };

  var $author$project$ElmFramework$Feature$Platform$Platform$setTitleAndDescription = _Platform_outgoingPort('setTitleAndDescription', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('description', $elm$json$Json$Encode$string($.E)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.t1))]));
  });

  var $elm$core$Dict$isEmpty = function (dict) {
    if (dict.$ === -2) {
      return true;
    } else {
      return false;
    }
  };

  var $elm$url$Url$percentEncode = _Url_percentEncode;

  var $author$project$ElmFramework$Lib$Url$toUrlString = function (url) {
    var foldToQueryString = F3(function (key, value, result) {
      var prepend = A3($author$project$ElmFramework$Lib$Util$ifElse, '', '&', result === '?');
      var encodedValue = $elm$url$Url$percentEncode(value);
      var encodedKey = $elm$url$Url$percentEncode(key);
      return $elm$core$String$concat(_List_fromArray([result, prepend, encodedKey, '=', encodedValue]));
    });

    var toQueryString = function (queryParams) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, '', A3($elm$core$Dict$foldr, foldToQueryString, '?', queryParams), $elm$core$Dict$isEmpty(queryParams));
    };

    return $elm$core$String$concat(_List_fromArray([A2($elm$core$String$join, '/', url.e2), toQueryString(url.h$)]));
  };

  var $elm$core$Maybe$withDefault = F2(function (_default, maybe) {
    if (!maybe.$) {
      var value = maybe.a;
      return value;
    } else {
      return _default;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$Routing$toInitialRoute = F3(function (config, programArgs, appState) {
    var setTitleAndDesc = function (route) {
      return $author$project$ElmFramework$Feature$Platform$Platform$setTitleAndDescription(A2(config.Dr, appState, route));
    };

    var reportUnsupportedFirstRoute = function (_v0) {
      var history = _v0.a;
      var cmd = _v0.b;
      return _Utils_Tuple2(history, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, programArgs.k4.zN.nb === '/' ? $elm$core$Platform$Cmd$none : A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'replaceWithHomeRouteAndReportErr', programArgs.k4.zN.nb)])));
    };

    var replaceWithHomeRoute = A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(config.yb), $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
      tc: config.yb,
      e7: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.yb),
      n4: true,
      t1: A2(config.Dr, appState, config.yb).t1,
      Fh: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(config.yb))
    }));
    var replaceWithHomeAndRouteToAuthRoute = A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(config.u$), $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo({
      CV: config.yb,
      CW: A2(config.Dr, appState, config.yb).t1,
      CX: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(config.yb)),
      e7: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.yb),
      Dn: config.u$,
      Dq: A2(config.Dr, appState, config.u$).t1,
      Ds: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(config.u$))
    }));
    var replaceWithDefaultRouteAndReportErr = config.Dm(config.yb) ? reportUnsupportedFirstRoute(replaceWithHomeAndRouteToAuthRoute) : reportUnsupportedFirstRoute(replaceWithHomeRoute);

    var decideFirstAndSecondRoute = function (route) {
      return config.Dm(route) && _Utils_eq(config.yE(appState), $elm$core$Maybe$Just(false)) ? A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(config.u$), $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo({
        CV: route,
        CW: A2(config.Dr, appState, route).t1,
        CX: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(route)),
        e7: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(route),
        Dn: config.u$,
        Dq: A2(config.Dr, appState, config.u$).t1,
        Ds: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(config.u$))
      })) : _Utils_eq(route, config.yb) ? replaceWithHomeRoute : A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(route), $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo({
        CV: config.yb,
        CW: A2(config.Dr, appState, config.yb).t1,
        CX: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(config.yb)),
        e7: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.yb),
        Dn: route,
        Dq: A2(config.Dr, appState, route).t1,
        Ds: $author$project$ElmFramework$Lib$Url$toUrlString(config.Ds(route))
      }));
    };

    return A2($elm$core$Maybe$withDefault, replaceWithDefaultRouteAndReportErr, A2($elm$core$Maybe$map, decideFirstAndSecondRoute, config.Fi($author$project$ElmFramework$Lib$Url$fromNavigationLocation(programArgs.k4.zN))));
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteTo = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$ElmFramework$Msg$RoutingMsg = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $wernerdegroot$listzipper$List$Zipper$fromList = function (xs) {
    if (!xs.b) {
      return $elm$core$Maybe$Nothing;
    } else {
      var y = xs.a;
      var ys = xs.b;
      return $elm$core$Maybe$Just(A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, y, ys));
    }
  };

  var $wernerdegroot$listzipper$List$Zipper$after = function (_v0) {
    var rs = _v0.c;
    return rs;
  };

  var $author$project$ElmFramework$Lib$Util$listify = function (a) {
    return _List_fromArray([a]);
  };

  var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(function (_default, f, m) {
    if (m.$ === 1) {
      return _default;
    } else {
      var a = m.a;
      return f(a);
    }
  });
  var $author$project$ElmFramework$StateWatcher$canRecurse = F2(function (zipper, maybeStateWatcherPair) {
    var _v0 = $wernerdegroot$listzipper$List$Zipper$fromList(_Utils_ap($wernerdegroot$listzipper$List$Zipper$before(zipper), _Utils_ap($wernerdegroot$listzipper$List$Zipper$after(zipper), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$ElmFramework$Lib$Util$listify, maybeStateWatcherPair))));

    if (!_v0.$) {
      var newZipper = _v0.a;
      return $elm$core$Maybe$Just(_Utils_Tuple2(newZipper, $elm$core$Maybe$Just($wernerdegroot$listzipper$List$Zipper$current(zipper))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $wernerdegroot$listzipper$List$Zipper$next = function (_v0) {
    var ls = _v0.a;
    var x = _v0.b;
    var rs = _v0.c;

    if (!rs.b) {
      return $elm$core$Maybe$Nothing;
    } else {
      var y = rs.a;
      var ys = rs.b;
      return $elm$core$Maybe$Just(A3($wernerdegroot$listzipper$List$Zipper$Zipper, A2($elm$core$List$cons, x, ls), y, ys));
    }
  };

  var $author$project$ElmFramework$StateWatcher$run = function (acc) {
    run: while (true) {
      var _v0 = $wernerdegroot$listzipper$List$Zipper$current(acc.uo);

      var watcher = _v0.un;
      var latestState = _v0.eU;
      var oldState = A2($elm$core$Maybe$withDefault, acc.qs, latestState);

      var _v1 = A2(watcher, oldState, acc.eU);

      if (!_v1.$) {
        var _v2 = _v1.a;
        var newState = _v2.a;
        var cmd = _v2.b;
        var addNewStateToCurrentWatcher = A2($wernerdegroot$listzipper$List$Zipper$mapCurrent, function (c) {
          return _Utils_update(c, {
            eU: $elm$core$Maybe$Just(newState)
          });
        }, acc.uo);

        var _v3 = A2($author$project$ElmFramework$StateWatcher$canRecurse, addNewStateToCurrentWatcher, acc.lh);

        if (!_v3.$) {
          var _v4 = _v3.a;
          var watchers = _v4.a;
          var excludedWatcher = _v4.b;

          var $temp$acc = _Utils_update(acc, {
            iC: $elm$core$Platform$Cmd$batch(_List_fromArray([acc.iC, cmd])),
            lh: excludedWatcher,
            eU: newState,
            uo: watchers
          });

          acc = $temp$acc;
          continue run;
        } else {
          return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([acc.iC, cmd])));
        }
      } else {
        var _v5 = $wernerdegroot$listzipper$List$Zipper$next(acc.uo);

        if (!_v5.$) {
          var watchers = _v5.a;

          var $temp$acc = _Utils_update(acc, {
            uo: watchers
          });

          acc = $temp$acc;
          continue run;
        } else {
          return _Utils_Tuple2(acc.eU, acc.iC);
        }
      }
    }
  };

  var $author$project$ElmFramework$Msg$EnoughInitialCpuIdle = {
    $: 8
  };
  var $author$project$ElmFramework$Feature$Pwa$Pwa$PwaReadyToInstall = 1;

  var $author$project$ElmFramework$Msg$ReceiveGeolocation = function (a) {
    return {
      $: 19,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$RestartApp = {
    $: 1
  };

  var $author$project$ElmFramework$Msg$ToasterMsg = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation = {
    $: 0
  };

  var $author$project$ElmFramework$Feature$Platform$Platform$enoughInitialCpuIdle = _Platform_outgoingPort('enoughInitialCpuIdle', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$AskingForLocation = {
    $: 1
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$toGeolocation = function (_v0) {
    var lat = _v0.rb;
    var lng = _v0.rj;
    return {
      kb: 0,
      l4: lat,
      mj: lng
    };
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$locateMe = F2(function (tag, geolocationAndPermissions) {
    if (geolocationAndPermissions.$ === 2) {
      if (geolocationAndPermissions.b.$ === 2) {
        var geoPoint = geolocationAndPermissions.b.a;
        return _Utils_Tuple2(geolocationAndPermissions, A2($elm$core$Task$perform, tag, $elm$core$Task$succeed({
          iT: $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$toGeolocation(geoPoint)),
          dV: true
        })));
      } else {
        var evenInBack = geolocationAndPermissions.a;
        return _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBack, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivingGeoLocation), $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
      }
    } else {
      return _Utils_Tuple2($author$project$ElmFramework$Feature$Geolocation$Geolocation$AskingForLocation, $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
    }
  });
  var $elm$core$List$any = F2(function (isOkay, list) {
    any: while (true) {
      if (!list.b) {
        return false;
      } else {
        var x = list.a;
        var xs = list.b;

        if (isOkay(x)) {
          return true;
        } else {
          var $temp$isOkay = isOkay,
              $temp$list = xs;
          isOkay = $temp$isOkay;
          list = $temp$list;
          continue any;
        }
      }
    }
  });
  var $elm$core$List$member = F2(function (x, xs) {
    return A2($elm$core$List$any, function (a) {
      return _Utils_eq(a, x);
    }, xs);
  });
  var $folkertdev$elm_deque$Internal$member = F2(function (elem, deque) {
    return A2($elm$core$List$member, elem, deque.cN) || A2($elm$core$List$member, elem, deque.c$);
  });
  var $folkertdev$elm_deque$BoundedDeque$member = F2(function (elem, _v0) {
    var deque = _v0.a;
    return A2($folkertdev$elm_deque$Internal$member, elem, deque);
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$DropWhileAndRouteTo = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Msg$LocateMe = {
    $: 0
  };

  var $author$project$ElmFramework$Msg$MultiMsg = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteBack = {
    $: 5
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteBackTo = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteForward = {
    $: 6
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteForwardTo = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });

  var $author$project$ElmFramework$Msg$Share = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$NewToast = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Icon$Messages = 2;

  var $author$project$ElmFramework$Feature$Toaster$Toaster$ActionTap = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $elm$html$Html$Attributes$stringProperty = F2(function (key, string) {
    return A2(_VirtualDom_property, key, $elm$json$Json$Encode$string(string));
  });
  var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');

  var $elm$html$Html$Attributes$classList = function (classes) {
    return $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
  };

  var $elm$html$Html$div = _VirtualDom_node('div');

  var $elm$html$Html$i = _VirtualDom_node('i');

  var $elm$virtual_dom$VirtualDom$attribute = F2(function (key, value) {
    return A2(_VirtualDom_attribute, _VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
  });
  var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
  var $author$project$ElmFramework$Lib$Util$noOpAttr = A2($elm$html$Html$Attributes$attribute, 'no-op-attr', 'no-op-attr');

  var $elm$virtual_dom$VirtualDom$Custom = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
  var $elm$html$Html$Events$custom = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Custom(decoder));
  });

  var $author$project$ElmFramework$Lib$Util$noBubble = function (msg) {
    return $elm$json$Json$Decode$succeed({
      zu: msg,
      sJ: true,
      tH: true
    });
  };

  var $author$project$ElmFramework$Lib$Util$onTap = function (msg) {
    return A2($elm$html$Html$Events$custom, 'customTap', $author$project$ElmFramework$Lib$Util$noBubble(msg));
  };

  var $author$project$Icon$iconConstructor = F3(function (maybeMsg, iconName, classes) {
    return A2($elm$html$Html$i, _List_fromArray([$elm$html$Html$Attributes$class('icon-' + iconName), $elm$html$Html$Attributes$class('icon'), $elm$html$Html$Attributes$class(classes), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpAttr, $author$project$ElmFramework$Lib$Util$onTap, maybeMsg)]), _List_Nil);
  });

  var $author$project$Icon$toStrFromIcon = function (theIcon) {
    switch (theIcon) {
      case 0:
        return 'info';

      case 1:
        return 'check';

      case 2:
        return 'messages';

      default:
        return 'report';
    }
  };

  var $author$project$Icon$iconConstructorFromIcon = F3(function (maybeMsg, theIcon, classes) {
    return A3($author$project$Icon$iconConstructor, maybeMsg, $author$project$Icon$toStrFromIcon(theIcon), classes);
  });
  var $author$project$Icon$iconNoOp = $author$project$Icon$iconConstructorFromIcon($elm$core$Maybe$Nothing);

  var $elm$virtual_dom$VirtualDom$node = function (tag) {
    return _VirtualDom_node(_VirtualDom_noScript(tag));
  };

  var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
  var $author$project$ElmFramework$Lib$Ui$Lay$Lay$inlineFlexRow = F2(function (classes, children) {
    return A3($elm$html$Html$node, 'lay-inlineFlex-row', _List_fromArray([$elm$html$Html$Attributes$class(classes)]), children);
  });

  var $elm$core$List$isEmpty = function (xs) {
    if (!xs.b) {
      return true;
    } else {
      return false;
    }
  };

  var $elm$html$Html$li = _VirtualDom_node('li');

  var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
  var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;

  var $author$project$ElmFramework$Feature$Toaster$Toasts$listMessageView = function (msg) {
    return A2($elm$html$Html$li, _List_fromArray([$elm$html$Html$Attributes$class('marTop0h fontSize1 breakWord')]), _List_fromArray([$elm$html$Html$text(msg)]));
  };

  var $elm$html$Html$span = _VirtualDom_node('span');

  var $elm$html$Html$ul = _VirtualDom_node('ul');

  var $author$project$ElmFramework$Feature$Toaster$Toasts$toast = F5(function (maybeActionMsg, icon, color, msg, messages) {
    var tapHandler = function () {
      if (!maybeActionMsg.$) {
        var actionMsg = maybeActionMsg.a;
        return $author$project$ElmFramework$Lib$Util$onTap($author$project$ElmFramework$Feature$Toaster$Toaster$ActionTap(actionMsg));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpAttr;
      }
    }();

    return {
      o2: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute top1 right0 bottom0 left0 toastBackground')]), _List_Nil),
      pD: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('center padTop1'), tapHandler]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$Lay$Lay$inlineFlexRow, 'flexAlignCenter pad2 ' + color, _List_fromArray([A2($author$project$Icon$iconNoOp, icon, 'inlineBlock fontSize4 marRight1'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('fontSize2 weight700 lineHeightNormal breakWord')]), _List_fromArray([$elm$html$Html$text(msg)])), A2($elm$html$Html$ul, _List_fromArray([$elm$html$Html$Attributes$class('pad0 mar0 noListStyle'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('hidden', $elm$core$List$isEmpty(messages))]))]), A2($elm$core$List$map, $author$project$ElmFramework$Feature$Toaster$Toasts$listMessageView, messages))]))]))])),
      ts: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('shadeBlur absoluteSpread toastBackgroundShade o2')]), _List_Nil)
    };
  });

  var $author$project$ElmFramework$Feature$Toaster$Toasts$chat = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 2, 'secondary10');
  };

  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastChat = F3(function (actionMsg, userName, message) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$chat, $elm$core$Maybe$Just(actionMsg), userName, _List_fromArray([message]))));
  });
  var $author$project$Icon$Report = 3;

  var $author$project$ElmFramework$Feature$Toaster$Toasts$error = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 3, 'primary0');
  };

  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr = F3(function (maybeActionMsg, notifMsg, messages) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$error, maybeActionMsg, notifMsg, messages)));
  });
  var $author$project$Icon$Info = 0;

  var $author$project$ElmFramework$Feature$Toaster$Toasts$info = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 0, 'secondary10');
  };

  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastInfo = F3(function (maybeActionMsg, notifMsg, messages) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$info, maybeActionMsg, notifMsg, messages)));
  });
  var $author$project$Icon$Check = 1;

  var $author$project$ElmFramework$Feature$Toaster$Toasts$success = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 1, 'secondary10');
  };

  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess = F3(function (maybeActionMsg, notifMsg, messages) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$success, maybeActionMsg, notifMsg, messages)));
  });
  var $author$project$ElmFramework$MsgCmd$msgCmd = {
    wO: F2(function (dropper, route) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$DropWhileAndRouteTo, dropper, route));
    }),
    zf: $author$project$ElmFramework$Msg$LocateMe,
    zJ: $author$project$ElmFramework$Msg$MultiMsg,
    C4: $author$project$ElmFramework$Msg$RestartApp,
    Df: $author$project$ElmFramework$Msg$RoutingMsg($author$project$ElmFramework$Feature$Navigation$Msg$RouteBack),
    Dg: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, $author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault($elm$core$Maybe$Nothing)),
    Dh: F2(function (_default, dropper) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, $elm$core$Maybe$Just(_default), dropper));
    }),
    Di: function (_v0) {
      var _default = _v0.a;
      var dropper = _v0.b;
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, _default, dropper));
    },
    Dj: function (route) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackTo, $elm$core$Maybe$Just(route), route));
    },
    Dk: $author$project$ElmFramework$Msg$RoutingMsg($author$project$ElmFramework$Feature$Navigation$Msg$RouteForward),
    Dl: function (route) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteForwardTo, $elm$core$Maybe$Just(route), route));
    },
    Dn: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, false, false)),
    Do: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, true, false)),
    Dp: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, true, true)),
    D1: $author$project$ElmFramework$Msg$Share,
    E$: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastChat,
    ec: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr,
    E0: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastInfo,
    E1: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess
  };
  var $elm$core$Tuple$mapSecond = F2(function (func, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(x, func(y));
  });
  var $elm$core$List$drop = F2(function (n, list) {
    drop: while (true) {
      if (n <= 0) {
        return list;
      } else {
        if (!list.b) {
          return list;
        } else {
          var x = list.a;
          var xs = list.b;
          var $temp$n = n - 1,
              $temp$list = xs;
          n = $temp$n;
          list = $temp$list;
          continue drop;
        }
      }
    }
  });
  var $elm$core$List$takeReverse = F3(function (n, list, kept) {
    takeReverse: while (true) {
      if (n <= 0) {
        return kept;
      } else {
        if (!list.b) {
          return kept;
        } else {
          var x = list.a;
          var xs = list.b;
          var $temp$n = n - 1,
              $temp$list = xs,
              $temp$kept = A2($elm$core$List$cons, x, kept);
          n = $temp$n;
          list = $temp$list;
          kept = $temp$kept;
          continue takeReverse;
        }
      }
    }
  });
  var $elm$core$List$takeTailRec = F2(function (n, list) {
    return $elm$core$List$reverse(A3($elm$core$List$takeReverse, n, list, _List_Nil));
  });
  var $elm$core$List$takeFast = F3(function (ctr, n, list) {
    if (n <= 0) {
      return _List_Nil;
    } else {
      var _v0 = _Utils_Tuple2(n, list);

      _v0$1: while (true) {
        _v0$5: while (true) {
          if (!_v0.b.b) {
            return list;
          } else {
            if (_v0.b.b.b) {
              switch (_v0.a) {
                case 1:
                  break _v0$1;

                case 2:
                  var _v2 = _v0.b;
                  var x = _v2.a;
                  var _v3 = _v2.b;
                  var y = _v3.a;
                  return _List_fromArray([x, y]);

                case 3:
                  if (_v0.b.b.b.b) {
                    var _v4 = _v0.b;
                    var x = _v4.a;
                    var _v5 = _v4.b;
                    var y = _v5.a;
                    var _v6 = _v5.b;
                    var z = _v6.a;
                    return _List_fromArray([x, y, z]);
                  } else {
                    break _v0$5;
                  }

                default:
                  if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                    var _v7 = _v0.b;
                    var x = _v7.a;
                    var _v8 = _v7.b;
                    var y = _v8.a;
                    var _v9 = _v8.b;
                    var z = _v9.a;
                    var _v10 = _v9.b;
                    var w = _v10.a;
                    var tl = _v10.b;
                    return ctr > 1000 ? A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
                  } else {
                    break _v0$5;
                  }

              }
            } else {
              if (_v0.a === 1) {
                break _v0$1;
              } else {
                break _v0$5;
              }
            }
          }
        }

        return list;
      }

      var _v1 = _v0.b;
      var x = _v1.a;
      return _List_fromArray([x]);
    }
  });
  var $elm$core$List$take = F2(function (n, list) {
    return A3($elm$core$List$takeFast, 0, n, list);
  });

  var $folkertdev$elm_deque$Internal$rebalance = function (deque) {
    var sizeF = deque.cb;
    var sizeR = deque.cc;
    var front = deque.cN;
    var rear = deque.c$;
    var size1 = (sizeF + sizeR) / 2 | 0;
    var size2 = sizeF + sizeR - size1;
    var balanceConstant = 4;

    if (sizeF + sizeR < 2) {
      return deque;
    } else {
      if (_Utils_cmp(sizeF, balanceConstant * sizeR + 1) > 0) {
        var newRear = _Utils_ap(rear, $elm$core$List$reverse(A2($elm$core$List$drop, size1, front)));

        var newFront = A2($elm$core$List$take, size1, front);
        return {
          cN: newFront,
          c$: newRear,
          cb: size1,
          cc: size2
        };
      } else {
        if (_Utils_cmp(sizeR, balanceConstant * sizeF + 1) > 0) {
          var newRear = A2($elm$core$List$take, size1, rear);

          var newFront = _Utils_ap(front, $elm$core$List$reverse(A2($elm$core$List$drop, size1, rear)));

          return {
            cN: newFront,
            c$: newRear,
            cb: size1,
            cc: size2
          };
        } else {
          return deque;
        }
      }
    }
  };

  var $folkertdev$elm_deque$Internal$popBack = function (deque) {
    var front = deque.cN;
    var rear = deque.c$;

    var _v0 = _Utils_Tuple2(front, rear);

    if (!_v0.b.b) {
      if (!_v0.a.b) {
        return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
      } else {
        if (!_v0.a.b.b) {
          var _v1 = _v0.a;
          var x = _v1.a;
          return _Utils_Tuple2($elm$core$Maybe$Just(x), $folkertdev$elm_deque$Internal$empty);
        } else {
          return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
        }
      }
    } else {
      var _v2 = _v0.b;
      var r = _v2.a;
      var rs = _v2.b;
      return _Utils_Tuple2($elm$core$Maybe$Just(r), $folkertdev$elm_deque$Internal$rebalance({
        cN: deque.cN,
        c$: rs,
        cb: deque.cb,
        cc: deque.cc - 1
      }));
    }
  };

  var $folkertdev$elm_deque$BoundedDeque$popBack = function (_v0) {
    var deque = _v0.a;
    var maxSize = _v0.b;
    return A2($elm$core$Tuple$mapSecond, function (newDeque) {
      return A2($folkertdev$elm_deque$BoundedDeque$BoundedDeque, newDeque, maxSize);
    }, $folkertdev$elm_deque$Internal$popBack(deque));
  };

  var $folkertdev$elm_deque$BoundedDeque$reachedMaxSize = function (_v0) {
    var sizeF = _v0.a.cb;
    var sizeR = _v0.a.cc;
    var maxSize = _v0.b;
    return _Utils_eq(sizeF + sizeR, maxSize);
  };

  var $folkertdev$elm_deque$BoundedDeque$pushFront = F2(function (elem, deque) {
    var maxSize = deque.b;

    if (!maxSize) {
      return deque;
    } else {
      var _v0 = $folkertdev$elm_deque$BoundedDeque$reachedMaxSize(deque) ? $folkertdev$elm_deque$BoundedDeque$popBack(deque).b : deque;

      var newDeque = _v0.a;
      var newMaxSize = _v0.b;
      var newerDeque = {
        cN: A2($elm$core$List$cons, elem, newDeque.cN),
        c$: newDeque.c$,
        cb: newDeque.cb + 1,
        cc: newDeque.cc
      };
      return A2($folkertdev$elm_deque$BoundedDeque$BoundedDeque, $folkertdev$elm_deque$Internal$rebalance(newerDeque), newMaxSize);
    }
  });

  var $author$project$ElmFramework$Feature$Platform$Platform$reloadApp = _Platform_outgoingPort('reloadApp', $elm$json$Json$Encode$bool);

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportMessage = function (description) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toGeneralErrorString(description));
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed = _Platform_outgoingPort('setLocationAccessAllowed', $elm$json$Json$Encode$bool);

  var $author$project$ElmFramework$Feature$Clipboard$Clipboard$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);

  var $author$project$ElmFramework$Feature$Share$Share$shareThroughHybridApi = _Platform_outgoingPort('shareThroughHybridApi', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('body', $elm$json$Json$Encode$string($.d0)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.t1)), _Utils_Tuple2('url', $elm$json$Json$Encode$string($.Fh))]));
  });

  var $author$project$ElmFramework$Feature$Share$Share$shareThroughWebApi = _Platform_outgoingPort('shareThroughWebApi', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('body', $elm$json$Json$Encode$string($.d0)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.t1)), _Utils_Tuple2('url', $elm$json$Json$Encode$string($.Fh))]));
  });

  var $author$project$ElmFramework$Feature$Share$Share$shareDialog = F4(function (_v0, title, body, url) {
    var isHybrid = _v0.yQ;
    var supportsWebShare = _v0.Ey;
    return isHybrid ? _Utils_Tuple2($author$project$ElmFramework$Feature$Share$Share$shareThroughHybridApi({
      d0: body,
      t1: title,
      Fh: url
    }), false) : supportsWebShare ? _Utils_Tuple2($author$project$ElmFramework$Feature$Share$Share$shareThroughWebApi({
      d0: body,
      t1: title,
      Fh: url
    }), false) : _Utils_Tuple2($author$project$ElmFramework$Feature$Clipboard$Clipboard$copyToClipboard(url), true);
  });
  var $elm$core$Process$sleep = _Process_sleep;

  var $author$project$ElmFramework$Feature$Pwa$Pwa$toPwaInstallStatus = function (isInstalled) {
    return isInstalled ? 2 : 0;
  };

  var $author$project$ElmFramework$Lib$MsgAnything$topmostHandler = F2(function (mainUpdate, _v0) {
    var updated = _v0.Fg;
    var stateSetter = _v0.Ek;
    var msgTag = _v0.zI;
    var runOutMsg = F2(function (outMsg, _v4) {
      var latestParentState = _v4.a;
      var parentCmd = _v4.b;
      return function (_v3) {
        var latestestParentState = _v3.a;
        var latestParentCmd = _v3.b;
        return _Utils_Tuple2(latestestParentState, $elm$core$Platform$Cmd$batch(_List_fromArray([latestParentCmd, parentCmd])));
      }(A2(mainUpdate, outMsg, latestParentState));
    });

    var _v1 = function (_v2) {
      var newChildState = _v2.a;
      var cmd = _v2.b;
      var theOutMsgs = _v2.c;
      return _Utils_Tuple3(stateSetter(newChildState), A2($elm$core$Platform$Cmd$map, msgTag, cmd), theOutMsgs);
    }(updated);

    var newParentState = _v1.a;
    var taggedChildCmd = _v1.b;
    var outMsgs = _v1.c;
    return A3($elm$core$List$foldl, runOutMsg, _Utils_Tuple2(newParentState, taggedChildCmd), outMsgs);
  });
  var $author$project$ElmFramework$Feature$Analytics$Analytics$VirtualPageView = F2(function (url, title) {
    return {
      t1: title,
      Fh: url
    };
  });

  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendVirtualPageView = _Platform_outgoingPort('sendVirtualPageView', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('title', $elm$json$Json$Encode$string($.t1)), _Utils_Tuple2('url', $elm$json$Json$Encode$string($.Fh))]));
  });

  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendDetailedEvent = _Platform_outgoingPort('sendDetailedEvent', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('event', $elm$json$Json$Encode$string($.lc)), _Utils_Tuple2('eventAction', $elm$json$Json$Encode$string($.ld)), _Utils_Tuple2('eventCategory', $elm$json$Json$Encode$string($.le)), _Utils_Tuple2('eventLabel', $elm$json$Json$Encode$string($.lf)), _Utils_Tuple2('eventValue', $elm$json$Json$Encode$int($.lg))]));
  });

  var $author$project$ElmFramework$Feature$Analytics$Analytics$simpleEvent = function (eventName) {
    return $author$project$ElmFramework$Feature$Analytics$Analytics$sendDetailedEvent({
      lc: eventName,
      ld: eventName,
      le: '',
      lf: '',
      lg: 0
    });
  };

  var $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents = {
    uA: $author$project$ElmFramework$Feature$Analytics$Analytics$simpleEvent('addedToHomeScreen'),
    xu: $author$project$ElmFramework$Feature$Analytics$Analytics$simpleEvent('enablePushNotifications'),
    FB: F2(function (url, title) {
      return $author$project$ElmFramework$Feature$Analytics$Analytics$sendVirtualPageView(A2($author$project$ElmFramework$Feature$Analytics$Analytics$VirtualPageView, url, title));
    })
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$NewRoute = F3(function (a, b, c) {
    return {
      $: 2,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$Routing$UserWantsBack = {
    $: 0
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$UserWantsForward = {
    $: 1
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$Go = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$NavigatingBackward = 1;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });

  var $wernerdegroot$listzipper$List$Zipper$previous = function (_v0) {
    var ls = _v0.a;
    var x = _v0.b;
    var rs = _v0.c;

    if (!ls.b) {
      return $elm$core$Maybe$Nothing;
    } else {
      var y = ls.a;
      var ys = ls.b;
      return $elm$core$Maybe$Just(A3($wernerdegroot$listzipper$List$Zipper$Zipper, ys, y, A2($elm$core$List$cons, x, rs)));
    }
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile = F3(function (direction, theDropper, theRouteHistory) {
    var moveAStep = function () {
      if (!direction) {
        return $wernerdegroot$listzipper$List$Zipper$next;
      } else {
        return $wernerdegroot$listzipper$List$Zipper$previous;
      }
    }();

    var drop = F2(function (currStep, currHistory) {
      drop: while (true) {
        var _v0 = moveAStep(currHistory);

        if (!_v0.$) {
          var movedHistory = _v0.a;

          if (theDropper($wernerdegroot$listzipper$List$Zipper$current(movedHistory))) {
            var $temp$currStep = currStep + 1,
                $temp$currHistory = movedHistory;
            currStep = $temp$currStep;
            currHistory = $temp$currHistory;
            continue drop;
          } else {
            return $elm$core$Maybe$Just(_Utils_Tuple2(movedHistory, currStep + 1));
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }
    });
    return A2(drop, 0, theRouteHistory);
  });

  var $elm$core$Basics$negate = function (n) {
    return -n;
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhileAndRouteTo = F3(function (dropper, route, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;

    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 1, dropper, routeHistory);

    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Just(route), false)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$ElmFramework$Feature$Platform$Platform$exitApp = _Platform_outgoingPort('exitApp', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$NothingSpecial = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccess = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccessAndRouteTo = F3(function (a, b, c) {
    return {
      $: 1,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsBack = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsForward = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$handlePopState = F2(function (popStateIndex, _v0) {
    var routeHistory = _v0.a;
    var maybePendingPopState = _v0.b;
    var isBack_curr = _v0.c;

    if (!maybePendingPopState.$) {
      if (!maybePendingPopState.a.$) {
        var _v2 = maybePendingPopState.a;
        var shouldSilent = _v2.a;
        var pendingHistory = _v2.b;
        var maybeRouteToAfterSuccessfulPopState = _v2.c;
        var isBack_new = _v2.d;

        if (_Utils_eq(popStateIndex, $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(pendingHistory))) {
          if (maybeRouteToAfterSuccessfulPopState.$ === 1) {
            return A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccess, shouldSilent, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, pendingHistory, $elm$core$Maybe$Nothing, isBack_new));
          } else {
            var route = maybeRouteToAfterSuccessfulPopState.a;
            return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccessAndRouteTo, shouldSilent, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, pendingHistory, $elm$core$Maybe$Nothing, false), route);
          }
        } else {
          return $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('Unexpected pendingIndex:' + $elm$core$String$fromInt($author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(pendingHistory)));
        }
      } else {
        var _v4 = maybePendingPopState.a;
        var pendingTargetStateIndex = _v4.a;
        var isBack_new = _v4.b;
        return _Utils_eq(popStateIndex, $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(routeHistory)) ? _Utils_cmp(pendingTargetStateIndex, popStateIndex) > 0 ? $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsForward(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Nothing, isBack_new)) : _Utils_cmp(pendingTargetStateIndex, popStateIndex) < 0 ? $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsBack(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Nothing, isBack_new)) : $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('PendingRouteCorrectionPopStateResponse: index same as current: ' + $elm$core$String$fromInt(popStateIndex)) : $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('PendingRouteCorrectionPopStateResponse: Unexpected popStateIndex:' + $elm$core$String$fromInt(popStateIndex));
      }
    } else {
      var currIndex = $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, maybePendingPopState, isBack_curr));
      return _Utils_cmp(popStateIndex, currIndex) < 0 ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$NothingSpecial, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse, popStateIndex, true)), isBack_curr), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(currIndex - popStateIndex)]))) : _Utils_cmp(popStateIndex, currIndex) > 0 ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$NothingSpecial, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse, popStateIndex, false)), isBack_curr), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-(popStateIndex - currIndex))]))) : $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('index same as current: ' + $elm$core$String$fromInt(popStateIndex));
    }
  });

  var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
    if (m.$ === 1) {
      return false;
    } else {
      return true;
    }
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction = function (_v0) {
    var maybePending = _v0.b;
    return $elm_community$maybe_extra$Maybe$Extra$isJust(maybePending);
  };

  var $elm$core$Basics$neq = _Utils_notEqual;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackTo = F2(function (targetRoute, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;

    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 1, $elm$core$Basics$neq(targetRoute), routeHistory);

    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, true)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping = F2(function (dropper, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;

    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 1, dropper, routeHistory);

    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, true)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$NavigatingForward = 0;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardTo = F2(function (targetRoute, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;

    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 0, $elm$core$Basics$neq(targetRoute), routeHistory);

    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, false)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardWhileDropping = F2(function (dropper, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;

    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 0, dropper, routeHistory);

    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, false)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$ElmFramework$Feature$Navigation$Routing$routeTo = function (_v0) {
    var config = _v0.dy;
    var newRoute = _v0.dE;
    var shouldReplace = _v0.n4;
    var state = _v0.Ej;
    var isUnauthenticated_and_routeNeedsAuth = _Utils_eq(config.Dt.yE(state.o_), $elm$core$Maybe$Just(false)) && config.Dt.Dm(newRoute);

    if (isUnauthenticated_and_routeNeedsAuth) {
      return $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
        tc: config.Dt.u$,
        e7: state.tc,
        n4: false,
        t1: A2(config.Dt.Dr, state.o_, config.Dt.u$).t1,
        Fh: $author$project$ElmFramework$Lib$Url$toUrlString(config.Dt.Ds(config.Dt.u$))
      });
    } else {
      return $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
        tc: newRoute,
        e7: state.tc,
        n4: shouldReplace,
        t1: A2(config.Dt.Dr, state.o_, newRoute).t1,
        Fh: $author$project$ElmFramework$Lib$Url$toUrlString(config.Dt.Ds(newRoute))
      });
    }
  };

  var $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg = function (_v0) {
    var config = _v0.dy;
    var newRoute = _v0.dE;
    var shouldReplace = _v0.n4;
    var shouldSilent = _v0.tu;
    var state = _v0.Ej;

    var _v1 = $author$project$ElmFramework$Feature$Navigation$Routing$routeTo({
      dy: config,
      dE: newRoute,
      n4: shouldReplace,
      tu: shouldSilent,
      Ej: state
    });

    var routeHistory = _v1.a;
    var cmd = _v1.b;
    return _Utils_Tuple3(routeHistory, cmd, $elm$core$Maybe$Just(A3($author$project$ElmFramework$Feature$Navigation$Routing$NewRoute, shouldSilent, state.tc, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(routeHistory))));
  };

  var $author$project$ElmFramework$Feature$Navigation$Routing$update = F3(function (config, msg, state) {
    switch (msg.$) {
      case 0:
        var shouldReplace = msg.a;
        var shouldSilent = msg.b;
        var route = msg.c;
        return $author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc) ? _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
          dy: config,
          dE: route,
          n4: shouldReplace,
          tu: shouldSilent,
          Ej: state
        });

      case 1:
        var dropper = msg.a;
        var route = msg.b;

        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc)) {
          return _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhileAndRouteTo, dropper, route, state.tc);

          if (!_v1.$) {
            var _v2 = _v1.a;
            var newRouteHistory = _v2.a;
            var cmd = _v2.b;
            return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'DropWhileAndRouteTo', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }

      case 2:
        var maybeDefault = msg.a;
        var dropper = msg.b;

        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc)) {
          return _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          var _v3 = _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping, dropper, state.tc), maybeDefault);

          if (!_v3.a.$) {
            var _v4 = _v3.a.a;
            var newRouteHistory = _v4.a;
            var cmd = _v4.b;
            return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            if (!_v3.b.$) {
              var _v5 = _v3.a;
              var defaultRoute = _v3.b.a;
              return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
                dy: config,
                dE: defaultRoute,
                n4: false,
                tu: false,
                Ej: state
              });
            } else {
              var _v6 = _v3.a;
              var _v7 = _v3.b;
              return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteBackWhileDropping', 'not enough lee-way'), $elm$core$Maybe$Nothing);
            }
          }
        }

      case 3:
        var maybeDefault = msg.a;
        var targetRoute = msg.b;

        var _v8 = _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackTo, targetRoute, state.tc), maybeDefault);

        if (!_v8.a.$) {
          var _v9 = _v8.a.a;
          var newRouteHistory = _v9.a;
          var cmd = _v9.b;
          return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
        } else {
          if (!_v8.b.$) {
            var _v10 = _v8.a;
            var defaultRoute = _v8.b.a;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              dy: config,
              dE: defaultRoute,
              n4: true,
              tu: false,
              Ej: state
            });
          } else {
            var _v11 = _v8.a;
            var _v12 = _v8.b;
            return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteBackTo', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }

      case 4:
        var maybeDefault = msg.a;
        var targetRoute = msg.b;

        var _v13 = _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardTo, targetRoute, state.tc), maybeDefault);

        if (!_v13.a.$) {
          var _v14 = _v13.a.a;
          var newRouteHistory = _v14.a;
          var cmd = _v14.b;
          return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
        } else {
          if (!_v13.b.$) {
            var _v15 = _v13.a;
            var defaultRoute = _v13.b.a;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              dy: config,
              dE: defaultRoute,
              n4: true,
              tu: false,
              Ej: state
            });
          } else {
            var _v16 = _v13.a;
            var _v17 = _v13.b;
            return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteBackTo', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }

      case 5:
        var isAuthenticated = _Utils_eq(config.Dt.yE(state.o_), $elm$core$Maybe$Just(true));

        var goingBack = isAuthenticated ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping, config.Dt.yD, state.tc) : A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping, config.Dt.Dm, state.tc);

        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc)) {
          return _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          if (!goingBack.$) {
            var _v19 = goingBack.a;
            var newHistory = _v19.a;
            var cmd = _v19.b;
            return _Utils_Tuple3(newHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            return _Utils_Tuple3(state.tc, $author$project$ElmFramework$Feature$Platform$Platform$exitApp(0), $elm$core$Maybe$Nothing);
          }
        }

      case 6:
        var isAuthenticated = _Utils_eq(config.Dt.yE(state.o_), $elm$core$Maybe$Just(true));

        var goingForward = isAuthenticated ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardWhileDropping, config.Dt.yD, state.tc) : A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardWhileDropping, config.Dt.Dm, state.tc);

        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc)) {
          return _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          if (!goingForward.$) {
            var _v21 = goingForward.a;
            var newHistory = _v21.a;
            var cmd = _v21.b;
            return _Utils_Tuple3(newHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteForward', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }

      case 7:
        var payload = msg.a;

        var _v22 = A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$handlePopState, payload.ea, state.tc);

        switch (_v22.$) {
          case 0:
            var shouldSilent = _v22.a;
            var newRouteHistory = _v22.b;
            return _Utils_Tuple3(newRouteHistory, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(A3($author$project$ElmFramework$Feature$Navigation$Routing$NewRoute, shouldSilent, state.tc, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newRouteHistory))));

          case 1:
            var shouldSilent = _v22.a;
            var newRouteHistory = _v22.b;
            var newRoute = _v22.c;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              dy: config,
              dE: newRoute,
              n4: false,
              tu: shouldSilent,
              Ej: _Utils_update(state, {
                tc: newRouteHistory
              })
            });

          case 2:
            var err = _v22.a;
            return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'PopStateError for pathname:' + payload.rm.nb, err), $elm$core$Maybe$Nothing);

          case 3:
            var routeHistory = _v22.a;
            return _Utils_Tuple3(routeHistory, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$Routing$UserWantsBack));

          case 4:
            var routeHistory = _v22.a;
            return _Utils_Tuple3(routeHistory, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$Routing$UserWantsForward));

          default:
            var routeHistory = _v22.a;
            var cmd = _v22.b;
            return _Utils_Tuple3(routeHistory, cmd, $elm$core$Maybe$Nothing);
        }

      case 8:
        var navigationLocation = msg.a.zN;
        var shouldReplace = msg.a.n4;
        var shouldSilent = msg.a.tu;

        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc)) {
          return _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          var _v23 = config.Dt.Fi($author$project$ElmFramework$Lib$Url$fromNavigationLocation(navigationLocation));

          if (!_v23.$) {
            var route = _v23.a;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              dy: config,
              dE: route,
              n4: shouldReplace,
              tu: shouldSilent,
              Ej: state
            });
          } else {
            return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'NavToFromLoopback: unexpected pathname:', navigationLocation.nb), $elm$core$Maybe$Nothing);
          }
        }

      case 9:
        return _Utils_Tuple3(state.tc, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$Routing$UserWantsBack));

      case 10:
        return _Utils_Tuple3(state.tc, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'HardwareForward', 'unimplemented'), $elm$core$Maybe$Nothing);

      default:
        return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
          dy: config,
          dE: config.Dt.u$,
          n4: false,
          tu: false,
          Ej: state
        });
    }
  });

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookAuthSuccess = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleAuthSuccess = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosed = {
    $: 3
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpened = {
    $: 2
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple2(_Utils_update(state, {
          iU: true
        }), $elm$core$Maybe$Nothing);

      case 1:
        return _Utils_Tuple2(_Utils_update(state, {
          iS: true
        }), $elm$core$Maybe$Nothing);

      case 2:
        return _Utils_Tuple2(_Utils_update(state, {
          ic: false
        }), $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosed));

      case 3:
        return _Utils_Tuple2(_Utils_update(state, {
          ic: true
        }), $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpened));

      case 4:
        var googleAuthSuccess = msg.a;
        return _Utils_Tuple2(state, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleAuthSuccess(googleAuthSuccess)));

      default:
        var facebookAuthSuccess = msg.a;
        return _Utils_Tuple2(state, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookAuthSuccess(facebookAuthSuccess)));
    }
  });

  var $author$project$ElmFramework$Feature$Toaster$Toaster$ToastTimerDone = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$areTooManyToasts = F2(function (theToastsHeight, windowHeight) {
    return _Utils_cmp(theToastsHeight, windowHeight / 3 | 0) > 0;
  });
  var $elm$core$Basics$composeR = F3(function (f, g, x) {
    return g(f(x));
  });
  var $elm$core$Array$fromListHelp = F3(function (list, nodeList, nodeListSize) {
    fromListHelp: while (true) {
      var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);

      var jsArray = _v0.a;
      var remainingItems = _v0.b;

      if (_Utils_cmp($elm$core$Elm$JsArray$length(jsArray), $elm$core$Array$branchFactor) < 0) {
        return A2($elm$core$Array$builderToArray, true, {
          bO: nodeList,
          bx: nodeListSize,
          bL: jsArray
        });
      } else {
        var $temp$list = remainingItems,
            $temp$nodeList = A2($elm$core$List$cons, $elm$core$Array$Leaf(jsArray), nodeList),
            $temp$nodeListSize = nodeListSize + 1;
        list = $temp$list;
        nodeList = $temp$nodeList;
        nodeListSize = $temp$nodeListSize;
        continue fromListHelp;
      }
    }
  });

  var $elm$core$Array$fromList = function (list) {
    if (!list.b) {
      return $elm$core$Array$empty;
    } else {
      return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
    }
  };

  var $elm$core$Array$filter = F2(function (isGood, array) {
    return $elm$core$Array$fromList(A3($elm$core$Array$foldr, F2(function (x, xs) {
      return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
    }), _List_Nil, array));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$ToastHidingDone = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$Util$timeInterval = {
    wz: 1000 * 60 * 60 * 24,
    yc: 1000 * 60 * 60,
    zE: 1000 * 60,
    tj: 1000
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$hideOldestVisibleToast = function (model) {
    var sleeper = A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$ElmFramework$Feature$Toaster$Toaster$ToastHidingDone), $elm$core$Process$sleep(2 * $author$project$ElmFramework$Lib$Util$timeInterval.tj));
    return model.b6 > 0 ? _Utils_Tuple3(_Utils_update(model, {
      eR: model.eR + 1,
      b6: model.b6 - 1
    }), sleeper, _List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
  };

  var $elm$core$Array$length = function (_v0) {
    var len = _v0.a;
    return len;
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$isToastIdxVisible = F2(function (_v0, toastIdx) {
    var toasts = _v0.ed;
    var visibleToasts = _v0.b6;
    return _Utils_cmp($elm$core$Array$length(toasts) - visibleToasts - 1, toastIdx) < 0;
  });
  var $elm$core$Elm$JsArray$push = _JsArray_push;
  var $elm$core$Bitwise$and = _Bitwise_and;
  var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
  var $elm$core$Array$bitMask = 4294967295 >>> 32 - $elm$core$Array$shiftStep;
  var $elm$core$Basics$ge = _Utils_ge;
  var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
  var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
  var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
  var $elm$core$Array$insertTailInTree = F4(function (shift, index, tail, tree) {
    var pos = $elm$core$Array$bitMask & index >>> shift;

    if (_Utils_cmp(pos, $elm$core$Elm$JsArray$length(tree)) > -1) {
      if (shift === 5) {
        return A2($elm$core$Elm$JsArray$push, $elm$core$Array$Leaf(tail), tree);
      } else {
        var newSub = $elm$core$Array$SubTree(A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
        return A2($elm$core$Elm$JsArray$push, newSub, tree);
      }
    } else {
      var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);

      if (!value.$) {
        var subTree = value.a;
        var newSub = $elm$core$Array$SubTree(A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
        return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
      } else {
        var newSub = $elm$core$Array$SubTree(A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$singleton(value)));
        return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
      }
    }
  });
  var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
  var $elm$core$Array$unsafeReplaceTail = F2(function (newTail, _v0) {
    var len = _v0.a;
    var startShift = _v0.b;
    var tree = _v0.c;
    var tail = _v0.d;
    var originalTailLen = $elm$core$Elm$JsArray$length(tail);
    var newTailLen = $elm$core$Elm$JsArray$length(newTail);
    var newArrayLen = len + (newTailLen - originalTailLen);

    if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
      var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;

      if (overflow) {
        var newShift = startShift + $elm$core$Array$shiftStep;
        var newTree = A4($elm$core$Array$insertTailInTree, newShift, len, newTail, $elm$core$Elm$JsArray$singleton($elm$core$Array$SubTree(tree)));
        return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
      } else {
        return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree), $elm$core$Elm$JsArray$empty);
      }
    } else {
      return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
    }
  });
  var $elm$core$Array$push = F2(function (a, array) {
    var tail = array.d;
    return A2($elm$core$Array$unsafeReplaceTail, A2($elm$core$Elm$JsArray$push, a, tail), array);
  });
  var $elm$core$Array$getHelp = F3(function (shift, index, tree) {
    getHelp: while (true) {
      var pos = $elm$core$Array$bitMask & index >>> shift;

      var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);

      if (!_v0.$) {
        var subTree = _v0.a;
        var $temp$shift = shift - $elm$core$Array$shiftStep,
            $temp$index = index,
            $temp$tree = subTree;
        shift = $temp$shift;
        index = $temp$index;
        tree = $temp$tree;
        continue getHelp;
      } else {
        var values = _v0.a;
        return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
      }
    }
  });

  var $elm$core$Array$tailIndex = function (len) {
    return len >>> 5 << 5;
  };

  var $elm$core$Array$get = F2(function (index, _v0) {
    var len = _v0.a;
    var startShift = _v0.b;
    var tree = _v0.c;
    var tail = _v0.d;
    return index < 0 || _Utils_cmp(index, len) > -1 ? $elm$core$Maybe$Nothing : _Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1 ? $elm$core$Maybe$Just(A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(A3($elm$core$Array$getHelp, startShift, index, tree));
  });
  var $elm$core$Array$setHelp = F4(function (shift, index, value, tree) {
    var pos = $elm$core$Array$bitMask & index >>> shift;

    var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);

    if (!_v0.$) {
      var subTree = _v0.a;
      var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
      return A3($elm$core$Elm$JsArray$unsafeSet, pos, $elm$core$Array$SubTree(newSub), tree);
    } else {
      var values = _v0.a;
      var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
      return A3($elm$core$Elm$JsArray$unsafeSet, pos, $elm$core$Array$Leaf(newLeaf), tree);
    }
  });
  var $elm$core$Array$set = F3(function (index, value, array) {
    var len = array.a;
    var startShift = array.b;
    var tree = array.c;
    var tail = array.d;
    return index < 0 || _Utils_cmp(index, len) > -1 ? array : _Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1 ? A4($elm$core$Array$Array_elm_builtin, len, startShift, tree, A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4($elm$core$Array$Array_elm_builtin, len, startShift, A4($elm$core$Array$setHelp, startShift, index, value, tree), tail);
  });
  var $author$project$ElmFramework$Lib$Util$updateArray = F3(function (n, f, a) {
    var element = A2($elm$core$Array$get, n, a);

    if (element.$ === 1) {
      return a;
    } else {
      var element_ = element.a;
      return A3($elm$core$Array$set, n, f(element_), a);
    }
  });
  var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
  var $elm$core$Array$foldl = F3(function (func, baseCase, _v0) {
    var tree = _v0.c;
    var tail = _v0.d;
    var helper = F2(function (node, acc) {
      if (!node.$) {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
      } else {
        var values = node.a;
        return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
      }
    });
    return A3($elm$core$Elm$JsArray$foldl, func, A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree), tail);
  });
  var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
  var $elm$core$Elm$JsArray$slice = _JsArray_slice;
  var $elm$core$Array$appendHelpBuilder = F2(function (tail, builder) {
    var tailLen = $elm$core$Elm$JsArray$length(tail);
    var notAppended = $elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.bL) - tailLen;
    var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.bL, tail);
    return notAppended < 0 ? {
      bO: A2($elm$core$List$cons, $elm$core$Array$Leaf(appended), builder.bO),
      bx: builder.bx + 1,
      bL: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
    } : !notAppended ? {
      bO: A2($elm$core$List$cons, $elm$core$Array$Leaf(appended), builder.bO),
      bx: builder.bx + 1,
      bL: $elm$core$Elm$JsArray$empty
    } : {
      bO: builder.bO,
      bx: builder.bx,
      bL: appended
    };
  });
  var $elm$core$Array$sliceLeft = F2(function (from, array) {
    var len = array.a;
    var tree = array.c;
    var tail = array.d;

    if (!from) {
      return array;
    } else {
      if (_Utils_cmp(from, $elm$core$Array$tailIndex(len)) > -1) {
        return A4($elm$core$Array$Array_elm_builtin, len - from, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, A3($elm$core$Elm$JsArray$slice, from - $elm$core$Array$tailIndex(len), $elm$core$Elm$JsArray$length(tail), tail));
      } else {
        var skipNodes = from / $elm$core$Array$branchFactor | 0;
        var helper = F2(function (node, acc) {
          if (!node.$) {
            var subTree = node.a;
            return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
          } else {
            var leaf = node.a;
            return A2($elm$core$List$cons, leaf, acc);
          }
        });
        var leafNodes = A3($elm$core$Elm$JsArray$foldr, helper, _List_fromArray([tail]), tree);
        var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);

        if (!nodesToInsert.b) {
          return $elm$core$Array$empty;
        } else {
          var head = nodesToInsert.a;
          var rest = nodesToInsert.b;
          var firstSlice = from - skipNodes * $elm$core$Array$branchFactor;
          var initialBuilder = {
            bO: _List_Nil,
            bx: 0,
            bL: A3($elm$core$Elm$JsArray$slice, firstSlice, $elm$core$Elm$JsArray$length(head), head)
          };
          return A2($elm$core$Array$builderToArray, true, A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
        }
      }
    }
  });
  var $elm$core$Array$fetchNewTail = F4(function (shift, end, treeEnd, tree) {
    fetchNewTail: while (true) {
      var pos = $elm$core$Array$bitMask & treeEnd >>> shift;

      var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);

      if (!_v0.$) {
        var sub = _v0.a;
        var $temp$shift = shift - $elm$core$Array$shiftStep,
            $temp$end = end,
            $temp$treeEnd = treeEnd,
            $temp$tree = sub;
        shift = $temp$shift;
        end = $temp$end;
        treeEnd = $temp$treeEnd;
        tree = $temp$tree;
        continue fetchNewTail;
      } else {
        var values = _v0.a;
        return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
      }
    }
  });
  var $elm$core$Array$hoistTree = F3(function (oldShift, newShift, tree) {
    hoistTree: while (true) {
      if (_Utils_cmp(oldShift, newShift) < 1 || !$elm$core$Elm$JsArray$length(tree)) {
        return tree;
      } else {
        var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);

        if (!_v0.$) {
          var sub = _v0.a;
          var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
              $temp$newShift = newShift,
              $temp$tree = sub;
          oldShift = $temp$oldShift;
          newShift = $temp$newShift;
          tree = $temp$tree;
          continue hoistTree;
        } else {
          return tree;
        }
      }
    }
  });
  var $elm$core$Array$sliceTree = F3(function (shift, endIdx, tree) {
    var lastPos = $elm$core$Array$bitMask & endIdx >>> shift;

    var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);

    if (!_v0.$) {
      var sub = _v0.a;
      var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
      return !$elm$core$Elm$JsArray$length(newSub) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3($elm$core$Elm$JsArray$unsafeSet, lastPos, $elm$core$Array$SubTree(newSub), A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
    } else {
      return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
    }
  });
  var $elm$core$Array$sliceRight = F2(function (end, array) {
    var len = array.a;
    var startShift = array.b;
    var tree = array.c;
    var tail = array.d;

    if (_Utils_eq(end, len)) {
      return array;
    } else {
      if (_Utils_cmp(end, $elm$core$Array$tailIndex(len)) > -1) {
        return A4($elm$core$Array$Array_elm_builtin, end, startShift, tree, A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
      } else {
        var endIdx = $elm$core$Array$tailIndex(end);
        var depth = $elm$core$Basics$floor(A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, A2($elm$core$Basics$max, 1, endIdx - 1)));
        var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
        return A4($elm$core$Array$Array_elm_builtin, end, newShift, A3($elm$core$Array$hoistTree, startShift, newShift, A3($elm$core$Array$sliceTree, startShift, endIdx, tree)), A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
      }
    }
  });
  var $elm$core$Array$translateIndex = F2(function (index, _v0) {
    var len = _v0.a;
    var posIndex = index < 0 ? len + index : index;
    return posIndex < 0 ? 0 : _Utils_cmp(posIndex, len) > 0 ? len : posIndex;
  });
  var $elm$core$Array$slice = F3(function (from, to, array) {
    var correctTo = A2($elm$core$Array$translateIndex, to, array);
    var correctFrom = A2($elm$core$Array$translateIndex, from, array);
    return _Utils_cmp(correctFrom, correctTo) > 0 ? $elm$core$Array$empty : A2($elm$core$Array$sliceLeft, correctFrom, A2($elm$core$Array$sliceRight, correctTo, array));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$toastsHeight = F3(function (toasts, fromIndex, toIndex) {
    var heightSumCalculator = F2(function (_v0, sum) {
      var maybeHeight = _v0.b;
      return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, sum, $elm$core$Basics$add(sum), maybeHeight);
    });
    return A3($elm$core$Array$foldl, heightSumCalculator, 0, A3($elm$core$Array$slice, fromIndex, toIndex, toasts));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$visibleToastsHeight = F2(function (toasts, visibleToasts) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toaster$toastsHeight, toasts, -visibleToasts, $elm$core$Array$length(toasts));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$update = F3(function (_v0, msg, model) {
    var windowHeight = _v0.ur;

    switch (msg.$) {
      case 0:
        var toastIdx = msg.a;
        return A2($author$project$ElmFramework$Feature$Toaster$Toaster$isToastIdxVisible, model, toastIdx) ? $author$project$ElmFramework$Feature$Toaster$Toaster$hideOldestVisibleToast(model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var _v2 = _Utils_Tuple2(model.b6, model.eR - 1);

        if (!_v2.a && !_v2.b) {
          return _Utils_Tuple3($author$project$ElmFramework$Feature$Toaster$Toaster$init, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(_Utils_update(model, {
            eR: model.eR - 1
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 2:
        var toastIdx = msg.a;
        var height = msg.b.x6;
        var toasts = A3($author$project$ElmFramework$Lib$Util$updateArray, toastIdx, function (_v3) {
          var t = _v3.a;
          return _Utils_Tuple2(t, $elm$core$Maybe$Just(height));
        }, model.ed);
        var visibleHeight = A2($author$project$ElmFramework$Feature$Toaster$Toaster$visibleToastsHeight, toasts, model.b6);
        var visibleToasts = model.b6 > 1 && A2($author$project$ElmFramework$Feature$Toaster$Toaster$areTooManyToasts, visibleHeight, windowHeight) ? model.b6 - 1 : model.b6;
        return _Utils_Tuple3(_Utils_update(model, {
          ed: toasts,
          b6: visibleToasts
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        return $author$project$ElmFramework$Feature$Toaster$Toaster$hideOldestVisibleToast(model);

      case 4:
        var actionMsg = msg.a;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([actionMsg]));

      default:
        var toastItem = msg.a;
        var doubleToast = !!$elm$core$Array$length(A2($elm$core$Array$filter, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$eq(toastItem)), model.ed));

        if (doubleToast) {
          return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          var toasts = A2($elm$core$Array$push, _Utils_Tuple2(toastItem, $elm$core$Maybe$Nothing), model.ed);
          var cbMsg = $author$project$ElmFramework$Feature$Toaster$Toaster$ToastTimerDone($elm$core$Array$length(toasts) - 1);
          var cmd = A2($elm$core$Task$perform, $elm$core$Basics$always(cbMsg), $elm$core$Process$sleep(5 * $author$project$ElmFramework$Lib$Util$timeInterval.tj));
          return _Utils_Tuple3(_Utils_update(model, {
            ed: toasts,
            b6: model.b6 + 1
          }), cmd, _List_Nil);
        }

    }
  });
  var $author$project$ElmFramework$Update$updaterRecursive = F3(function (config, msg, state) {
    switch (msg.$) {
      case 10:
        var appMsg = msg.a;
        return A2($author$project$ElmFramework$Lib$MsgAnything$topmostHandler, $author$project$ElmFramework$Update$updaterRecursive(config), {
          zI: $author$project$ElmFramework$Msg$AppMsg,
          Ek: function (childState) {
            return _Utils_update(state, {
              o_: childState
            });
          },
          Fg: A2(config.Ff, appMsg, state)
        });

      case 5:
        var theMsg = msg.a;

        var _v1 = A3($author$project$ElmFramework$Feature$Navigation$Routing$update, config, theMsg, state);

        var newRouteHistory = _v1.a;
        var cmd = _v1.b;
        var outMsg = _v1.c;

        if (!outMsg.$) {
          switch (outMsg.a.$) {
            case 0:
              var _v3 = outMsg.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                v0: cmd,
                zv: A2(config.Dt.Fq, state.o_, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newRouteHistory)),
                Ej: _Utils_update(state, {
                  tc: newRouteHistory
                })
              });

            case 1:
              var _v4 = outMsg.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                v0: cmd,
                zv: A2(config.Dt.Fr, state.o_, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newRouteHistory)),
                Ej: _Utils_update(state, {
                  tc: newRouteHistory
                })
              });

            default:
              var _v5 = outMsg.a;
              var shouldSilent = _v5.a;
              var oldHistory = _v5.b;
              var newRoute = _v5.c;
              return shouldSilent ? _Utils_Tuple2(_Utils_update(state, {
                tc: newRouteHistory
              }), cmd) : A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                v0: cmd,
                zv: A3(config.Dt.Bf, state, oldHistory, newRoute),
                Ej: _Utils_update(state, {
                  tc: newRouteHistory
                })
              });
          }
        } else {
          return _Utils_Tuple2(_Utils_update(state, {
            tc: newRouteHistory
          }), cmd);
        }

      case 11:
        var pressedKeys = msg.a;
        var mainMsgs = msg.b;
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          v0: $elm$core$Platform$Cmd$none,
          zv: mainMsgs,
          Ej: _Utils_update(state, {
            sI: pressedKeys
          })
        });

      case 13:
        var theMsg = msg.a;
        return A2($author$project$ElmFramework$Lib$MsgAnything$topmostHandler, $author$project$ElmFramework$Update$updaterRecursive(config), {
          zI: $author$project$ElmFramework$Msg$ToasterMsg,
          Ek: function (childState) {
            return _Utils_update(state, {
              E2: childState
            });
          },
          Fg: A3($author$project$ElmFramework$Feature$Toaster$Toaster$update, {
            ur: state.vz.x6
          }, theMsg, state.E2)
        });

      case 12:
        var visibility = msg.a;

        if (visibility === 1) {
          return _Utils_Tuple2(_Utils_update(state, {
            sI: _List_Nil
          }), $elm$core$Platform$Cmd$none);
        } else {
          return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
        }

      case 14:
        var browser = msg.a;
        return _Utils_Tuple2(_Utils_update(state, {
          vz: browser
        }), $elm$core$Platform$Cmd$none);

      case 0:
        return function (_v7) {
          var geoPermission = _v7.a;
          var cmd = _v7.b;
          return _Utils_Tuple2(_Utils_update(state, {
            xS: geoPermission
          }), cmd);
        }(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$locateMe, $author$project$ElmFramework$Msg$ReceiveGeolocation, state.xS));

      case 1:
        return _Utils_Tuple2(state, $author$project$ElmFramework$Feature$Platform$Platform$reloadApp(false));

      case 16:
        var permissionsResult = msg.a;

        if (permissionsResult.$ === 1) {
          var err = permissionsResult.a;
          return _Utils_Tuple2(state, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'permissionsResult problem: ', err));
        } else {
          var permissions = permissionsResult.a;

          var _v9 = function () {
            var _v10 = _Utils_Tuple2(state.xS, permissions);

            if (_v10.b.$ === 2) {
              if (_v10.a.$ === 2) {
                var _v11 = _v10.a;
                var oldStatus = _v11.b;
                var _v12 = _v10.b;
                var newBackground = _v12.a;
                return _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, newBackground, oldStatus), $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
              } else {
                var _v13 = _v10.b;
                return _Utils_Tuple2(permissions, $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
              }
            } else {
              return _Utils_Tuple2(permissions, $elm$core$Platform$Cmd$none);
            }
          }();

          var newGeo = _v9.a;
          var cmd = _v9.b;
          return _Utils_Tuple2(_Utils_update(state, {
            xS: newGeo
          }), cmd);
        }

      case 19:
        var geolocationResult = msg.a.iT;
        var isExplicitlyRequested = msg.a.dV;

        var _v14 = _Utils_Tuple2(geolocationResult, isExplicitlyRequested);

        if (!_v14.a.$) {
          if (_v14.b) {
            var latitude = _v14.a.a.l4;
            var longitude = _v14.a.a.mj;

            var geolocation = function () {
              var _v15 = state.xS;

              if (_v15.$ === 2) {
                var background = _v15.a;
                return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, background, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation({
                  rb: latitude,
                  rj: longitude
                }));
              } else {
                return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation({
                  rb: latitude,
                  rj: longitude
                }));
              }
            }();

            var newState = _Utils_update(state, {
              xS: geolocation
            });

            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              v0: $author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed(true),
              zv: A2(config.AZ, {
                rb: latitude,
                rj: longitude
              }, newState),
              Ej: newState
            });
          } else {
            var latitude = _v14.a.a.l4;
            var longitude = _v14.a.a.mj;

            var backgroundAccess = function () {
              var _v16 = state.xS;

              if (_v16.$ === 2) {
                var background = _v16.a;
                return background;
              } else {
                return false;
              }
            }();

            var newState = _Utils_update(state, {
              xS: A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, backgroundAccess, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation({
                rb: latitude,
                rj: longitude
              }))
            });

            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              v0: $author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed(true),
              zv: A2(config.Be, {
                rb: latitude,
                rj: longitude
              }, newState),
              Ej: newState
            });
          }
        } else {
          switch (_v14.a.a.$) {
            case 0:
              var err = _v14.a.a.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                v0: $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed(false), A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: PermissionDenied', err)])),
                zv: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, config.Cq(state).xT, _List_fromArray([err]))]),
                Ej: _Utils_update(state, {
                  xS: $author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions
                })
              });

            case 2:
              var err = _v14.a.a.a;
              var phrases = config.Cq(state);
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                v0: A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: Timeout', err),
                zv: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, phrases.xW, _List_fromArray([phrases.xV]))]),
                Ej: _Utils_update(state, {
                  xS: function () {
                    var _v17 = state.xS;

                    if (_v17.$ === 2) {
                      if (_v17.b.$ === 2) {
                        return state.xS;
                      } else {
                        var evenInBackground = _v17.a;
                        return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBackground, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                      }
                    } else {
                      return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                    }
                  }()
                })
              });

            case 1:
              var err = _v14.a.a.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                v0: A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: LocationUnavailable', err),
                zv: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, config.Cq(state).xU, _List_fromArray([err]))]),
                Ej: _Utils_update(state, {
                  xS: function () {
                    var _v18 = state.xS;

                    if (_v18.$ === 2) {
                      if (_v18.b.$ === 2) {
                        return state.xS;
                      } else {
                        var evenInBackground = _v18.a;
                        return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBackground, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                      }
                    } else {
                      return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                    }
                  }()
                })
              });

            default:
              var err = _v14.a.a.a;
              return _Utils_Tuple2(_Utils_update(state, {
                xS: function () {
                  var _v19 = state.xS;

                  if (_v19.$ === 2) {
                    if (_v19.b.$ === 2) {
                      return state.xS;
                    } else {
                      var evenInBackground = _v19.a;
                      return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBackground, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                    }
                  } else {
                    return $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus;
                  }
                }()
              }), A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: UnknownGeoErr:', err));
          }
        }

      case 17:
        var result = msg.a;

        if (!result.$) {
          var pushPermissions = result.a;

          var newState = _Utils_update(state, {
            CH: pushPermissions
          });

          return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
            v0: function () {
              if (pushPermissions.$ === 3 && pushPermissions.b) {
                return $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.xu;
              } else {
                return $elm$core$Platform$Cmd$none;
              }
            }(),
            zv: A2(config.Bm, pushPermissions, newState),
            Ej: newState
          });
        } else {
          var err = result.a;
          return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
            v0: $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportMessage(err),
            zv: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, config.Cq(state).CG, _List_fromArray([err]))]),
            Ej: state
          });
        }

      case 20:
        var env = state.xz;
        return _Utils_Tuple2(_Utils_update(state, {
          xz: _Utils_update(env, {
            jX: false
          })
        }), $elm$core$Platform$Cmd$none);

      case 21:
        var env = state.xz;
        return _Utils_Tuple2(_Utils_update(state, {
          xz: _Utils_update(env, {
            jx: 1
          })
        }), $elm$core$Platform$Cmd$none);

      case 22:
        var isInstalled = msg.a;
        var env = state.xz;
        return _Utils_Tuple2(_Utils_update(state, {
          xz: _Utils_update(env, {
            jx: $author$project$ElmFramework$Feature$Pwa$Pwa$toPwaInstallStatus(isInstalled)
          })
        }), isInstalled ? $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.uA : $elm$core$Platform$Cmd$none);

      case 23:
        var phrases = config.Cq(state);
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          v0: $elm$core$Platform$Cmd$none,
          zv: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Just($author$project$ElmFramework$Msg$RestartApp), phrases.uJ, _List_fromArray([phrases.uI]))]),
          Ej: state
        });

      case 15:
        var posix = msg.a;
        return _Utils_Tuple2(_Utils_update(state, {
          EM: posix
        }), $elm$core$Platform$Cmd$none);

      case 2:
        var title = msg.a.t1;
        var body = msg.a.d0;
        var url = msg.a.Fh;
        var toastMsg = A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, config.Cq(state).D2, _List_Nil);

        var _v22 = A4($author$project$ElmFramework$Feature$Share$Share$shareDialog, state.xz, title, body, url);

        var shareCmd = _v22.a;
        var isCopiedToClipboard = _v22.b;

        var _v23 = isCopiedToClipboard ? A3($author$project$ElmFramework$Update$updaterRecursive, config, toastMsg, state) : _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);

        var newState = _v23.a;
        var toastCmd = _v23.b;
        return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([shareCmd, toastCmd])));

      case 6:
        var event = msg.a;

        switch (event.$) {
          case 0:
            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              v0: $elm$core$Platform$Cmd$none,
              zv: A2(config.Bx, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc)),
              Ej: state
            });

          case 1:
            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              v0: $elm$core$Platform$Cmd$none,
              zv: A2(config.Bi, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc)),
              Ej: state
            });

          default:
            var theEvent = event.a;
            return _Utils_Tuple2(state, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleLifecycleEvent: unexpected event: ' + theEvent));
        }

      case 7:
        return _Utils_Tuple2(state, A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$ElmFramework$Msg$EnoughInitialCpuIdle), $elm$core$Process$sleep(5000)));

      case 8:
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          v0: $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Platform$Platform$enoughInitialCpuIdle(0), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries(0)])),
          zv: A2(config.AX, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc)),
          Ej: state
        });

      case 9:
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          v0: $elm$core$Platform$Cmd$none,
          zv: A2(config.Ak, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc)),
          Ej: state
        });

      case 18:
        var pushMessage = msg.a;
        return A2($folkertdev$elm_deque$BoundedDeque$member, pushMessage, state.CD) ? _Utils_Tuple2(state, $elm$core$Platform$Cmd$none) : A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          v0: $elm$core$Platform$Cmd$none,
          zv: config.Bl(pushMessage),
          Ej: _Utils_update(state, {
            CD: A2($folkertdev$elm_deque$BoundedDeque$pushFront, pushMessage, state.CD)
          })
        });

      case 24:
        var theMsg = msg.a;

        var _v25 = A2($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$update, theMsg, state.D9);

        if (!_v25.b.$) {
          var newState = _v25.a;
          var socialAuthEvent = _v25.b.a;
          return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
            v0: $elm$core$Platform$Cmd$none,
            zv: A3(config.BO, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc), socialAuthEvent),
            Ej: _Utils_update(state, {
              D9: newState
            })
          });
        } else {
          var newState = _v25.a;
          var _v26 = _v25.b;
          return _Utils_Tuple2(_Utils_update(state, {
            D9: newState
          }), $elm$core$Platform$Cmd$none);
        }

      case 3:
        var msgs = msg.a;
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          v0: $elm$core$Platform$Cmd$none,
          zv: msgs,
          Ej: state
        });

      default:
        return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
    }
  });

  var $author$project$ElmFramework$Update$executeStateWatchers = function (cfg) {
    var dispatchMessages = F2(function (topState, _v1) {
      var appState = _v1.a;
      var appCmd = _v1.b;
      var topMsgs = _v1.c;
      return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(cfg.mk), {
        v0: A2($elm$core$Platform$Cmd$map, $author$project$ElmFramework$Msg$AppMsg, appCmd),
        zv: topMsgs,
        Ej: _Utils_update(topState, {
          o_: appState
        })
      });
    });

    var toWatchPair = function (appLevelStateWatcher) {
      return {
        eU: $elm$core$Maybe$Nothing,
        un: F2(function (old, _new) {
          return A2($elm$core$Maybe$map, dispatchMessages(_new), appLevelStateWatcher({
            d7: _new,
            eY: old
          }));
        })
      };
    };

    var _v0 = $wernerdegroot$listzipper$List$Zipper$fromList(A2($elm$core$List$map, toWatchPair, cfg.mk.El));

    if (!_v0.$) {
      var watchers = _v0.a;
      return $author$project$ElmFramework$StateWatcher$run({
        iC: $elm$core$Platform$Cmd$none,
        lh: $elm$core$Maybe$Nothing,
        qs: cfg.rJ,
        eU: cfg.mu,
        uo: watchers
      });
    } else {
      return _Utils_Tuple2(cfg.mu, $elm$core$Platform$Cmd$none);
    }
  };

  var $author$project$ElmFramework$Update$maybeRedirect = F2(function (config, state) {
    var _v0 = A2(config.Dt.CR, state.o_, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc));

    if (!_v0.$) {
      var redirectTo = _v0.a;

      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
        tc: redirectTo.tc,
        e7: state.tc,
        n4: redirectTo.n4,
        t1: A2(config.Dt.Dr, state.o_, redirectTo.tc).t1,
        Fh: $author$project$ElmFramework$Lib$Url$toUrlString(config.Dt.Ds(redirectTo.tc))
      });

      var routeHistory = _v1.a;
      var routeCmds = _v1.b;
      return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
        v0: routeCmds,
        zv: A3(config.Dt.Bf, state, state.tc, redirectTo.tc),
        Ej: _Utils_update(state, {
          tc: routeHistory
        })
      });
    } else {
      return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
    }
  });

  var $author$project$ElmFramework$Feature$Platform$Platform$setNotificationBadgeCount = _Platform_outgoingPort('setNotificationBadgeCount', $elm$json$Json$Encode$int);

  var $author$project$ElmFramework$Feature$Platform$Platform$toSetNotificationBadgeCount = function (count) {
    return $author$project$ElmFramework$Feature$Platform$Platform$setNotificationBadgeCount(A2($elm$core$Basics$max, 0, count));
  };

  var $author$project$ElmFramework$Update$update = F3(function (config, msg, state) {
    var _v0 = A3($author$project$ElmFramework$Update$updaterRecursive, config, msg, state);

    var newState = _v0.a;
    var cmd = _v0.b;

    var _v1 = function () {
      var isAuthenticatedInNewState = config.Dt.yE(newState.o_);
      var authStateChanged = !_Utils_eq(config.Dt.yE(state.o_), isAuthenticatedInNewState);

      if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.tc)) {
        return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$none);
      } else {
        if (authStateChanged) {
          if (!isAuthenticatedInNewState.$) {
            if (isAuthenticatedInNewState.a) {
              return config.Dt.yD($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newState.tc)) ? A3($author$project$ElmFramework$Update$updaterRecursive, config, $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, $elm$core$Maybe$Nothing, config.Dt.yD)), newState) : A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
            } else {
              return config.Dt.Dm($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newState.tc)) ? A3($author$project$ElmFramework$Update$updaterRecursive, config, $author$project$ElmFramework$Msg$RoutingMsg(A3($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, false, false, config.Dt.u$)), newState) : A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
            }
          } else {
            return A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
          }
        } else {
          return A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
        }
      }
    }();

    var newStateWithUpdatedRouting = _v1.a;
    var updatedRoutingCmd = _v1.b;

    var _v3 = $author$project$ElmFramework$Update$executeStateWatchers({
      mk: config,
      mu: newStateWithUpdatedRouting,
      rJ: state
    });

    var newStateUpdatedByStateWatchers = _v3.a;
    var stateWatchersCmd = _v3.b;
    var setBadgeCountCmd = !_Utils_eq(config.u6(state.o_), config.u6(newState.o_)) ? $author$project$ElmFramework$Feature$Platform$Platform$toSetNotificationBadgeCount(config.u6(newState.o_)) : $elm$core$Platform$Cmd$none;

    var setTitleAndDescriptionCmd = function () {
      var oldMeta = A2(config.Dt.Dr, state.o_, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc));
      var newMeta = A2(config.Dt.Dr, newState.o_, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newState.tc));
      return !_Utils_eq(oldMeta, newMeta) ? $author$project$ElmFramework$Feature$Platform$Platform$setTitleAndDescription(newMeta) : $elm$core$Platform$Cmd$none;
    }();

    return _Utils_Tuple2(newStateUpdatedByStateWatchers, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, setBadgeCountCmd, setTitleAndDescriptionCmd, updatedRoutingCmd, stateWatchersCmd])));
  });
  var $author$project$ElmFramework$Main$init = F2(function (config, programArgs) {
    var loadSocialLibrariesForHybrid = programArgs.k4.xz.yQ ? $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries(0) : $elm$core$Platform$Cmd$none;
    var definiteInitialHistory = $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.Dt.yb);

    var _v0 = A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$toInitGeoPermissions, programArgs.k4.xR, config.xY);

    var geoPermissions = _v0.a;
    var geoPermissionsCmd = _v0.b;

    var _v1 = config.yp(programArgs);

    var appState = _v1.a;
    var appCmd = _v1.b;

    var _v2 = A3($author$project$ElmFramework$Feature$Navigation$Routing$toInitialRoute, config.Dt, programArgs, appState);

    var initialRouteHistory = _v2.a;
    var initialRouteCmd = _v2.b;
    var initCmds = $elm$core$Platform$Cmd$batch(_List_fromArray([A2($elm$core$Platform$Cmd$map, $author$project$ElmFramework$Msg$AppMsg, appCmd), initialRouteCmd, geoPermissionsCmd, loadSocialLibrariesForHybrid]));
    var initState = {
      o_: appState,
      vz: programArgs.k4.vz,
      xz: $author$project$ElmFramework$InitArgs$toEnv(programArgs.k4.xz),
      xS: geoPermissions,
      sI: _List_Nil,
      CD: $folkertdev$elm_deque$BoundedDeque$empty(15),
      CH: $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnknownPushPermissions,
      tc: initialRouteHistory,
      D9: $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$init(programArgs.k4.xz.yQ),
      EM: $elm$time$Time$millisToPosix(programArgs.k4.wo),
      E2: $author$project$ElmFramework$Feature$Toaster$Toaster$init,
      by: A2($elm$time$Time$customZone, programArgs.k4.EQ, _List_Nil)
    };
    return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$update(config), {
      v0: initCmds,
      zv: A3(config.Dt.Bf, initState, definiteInitialHistory, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(initialRouteHistory)),
      Ej: initState
    });
  });
  var $author$project$ElmFramework$Msg$AppLoaded = {
    $: 7
  };
  var $author$project$ElmFramework$Msg$AppUpdated = {
    $: 23
  };
  var $author$project$ElmFramework$Msg$KeyEvent = F2(function (a, b) {
    return {
      $: 11,
      a: a,
      b: b
    };
  });

  var $author$project$ElmFramework$Msg$LifeCycleEvent = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$OnPushMessage = function (a) {
    return {
      $: 18,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$PushNotificationsPermissionsStatus = function (a) {
    return {
      $: 17,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$ReceiveBeforeInstallPromptEvent = {
    $: 21
  };

  var $author$project$ElmFramework$Msg$ReceiveDetailedGeolocationPermissions = function (a) {
    return {
      $: 16,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$ReceiveInstallPwaResult = function (a) {
    return {
      $: 22,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$SocialAuthMsg = function (a) {
    return {
      $: 24,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$UpdateCurrTime = function (a) {
    return {
      $: 15,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$UserCouldNotProvidePaymentCard = {
    $: 20
  };

  var $author$project$ElmFramework$Msg$VisibilityChange = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$ElmFramework$Msg$WeAreOnline = {
    $: 9
  };

  var $author$project$ElmFramework$Msg$WindowResize = function (a) {
    return {
      $: 14,
      a: a
    };
  };

  var $elm$json$Json$Decode$null = _Json_decodeNull;

  var $author$project$ElmFramework$Feature$Platform$Platform$appLoaded = _Platform_incomingPort('appLoaded', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$Pwa$Pwa$appUpdated = _Platform_incomingPort('appUpdated', $elm$json$Json$Decode$null(0));

  var $elm$core$Platform$Sub$batch = _Platform_batch;
  var $ohanhi$keyboard$Keyboard$Escape = {
    $: 62
  };

  var $wernerdegroot$listzipper$List$Zipper$isFirst = function (_v0) {
    var ls = _v0.a;
    return $elm$core$List$isEmpty(ls);
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$isFirst = function (_v0) {
    var routeHistory = _v0.a;
    return $wernerdegroot$listzipper$List$Zipper$isFirst(routeHistory);
  };

  var $ohanhi$keyboard$Keyboard$rawValue = function (_v0) {
    var key = _v0;
    return key;
  };

  var $author$project$ElmFramework$Main$escKeyboardHandler = F2(function (config, state) {
    var isMobileOs = function (_v2) {
      var isAndroid = _v2.i0;
      var isIos = _v2.i8;
      return isAndroid || isIos;
    }(state.xz);

    var isFirstRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$isFirst(state.tc);

    var escParser = function (rawKey) {
      return $ohanhi$keyboard$Keyboard$rawValue(rawKey) === 'Escape' ? $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape) : $elm$core$Maybe$Nothing;
    };

    var escEventHandler = F2(function (pressedKeys, maybeKeyChange) {
      var _v0 = _Utils_Tuple2(pressedKeys, maybeKeyChange);

      if (!_v0.a.b && !_v0.b.$ && _v0.b.a.$ === 1 && _v0.b.a.a.$ === 62) {
        var _v1 = _v0.b.a.a;
        return A2(config.Dt.Fq, state.o_, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc));
      } else {
        return _List_Nil;
      }
    });
    return !isMobileOs && !isFirstRoute ? _List_fromArray([{
      qd: escEventHandler,
      st: escParser
    }]) : _List_Nil;
  });
  var $elm$time$Time$Every = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$time$Time$State = F2(function (taggers, processes) {
    return {
      sN: processes,
      tT: taggers
    };
  });
  var $elm$time$Time$init = $elm$core$Task$succeed(A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
  var $elm$core$Dict$get = F2(function (targetKey, dict) {
    get: while (true) {
      if (dict.$ === -2) {
        return $elm$core$Maybe$Nothing;
      } else {
        var key = dict.b;
        var value = dict.c;
        var left = dict.d;
        var right = dict.e;

        var _v1 = A2($elm$core$Basics$compare, targetKey, key);

        switch (_v1) {
          case 0:
            var $temp$targetKey = targetKey,
                $temp$dict = left;
            targetKey = $temp$targetKey;
            dict = $temp$dict;
            continue get;

          case 1:
            return $elm$core$Maybe$Just(value);

          default:
            var $temp$targetKey = targetKey,
                $temp$dict = right;
            targetKey = $temp$targetKey;
            dict = $temp$dict;
            continue get;
        }
      }
    }
  });
  var $elm$time$Time$addMySub = F2(function (_v0, state) {
    var interval = _v0.a;
    var tagger = _v0.b;

    var _v1 = A2($elm$core$Dict$get, interval, state);

    if (_v1.$ === 1) {
      return A3($elm$core$Dict$insert, interval, _List_fromArray([tagger]), state);
    } else {
      var taggers = _v1.a;
      return A3($elm$core$Dict$insert, interval, A2($elm$core$List$cons, tagger, taggers), state);
    }
  });
  var $elm$core$Process$kill = _Scheduler_kill;
  var $elm$core$Dict$foldl = F3(function (func, acc, dict) {
    foldl: while (true) {
      if (dict.$ === -2) {
        return acc;
      } else {
        var key = dict.b;
        var value = dict.c;
        var left = dict.d;
        var right = dict.e;
        var $temp$func = func,
            $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldl, func, acc, left)),
            $temp$dict = right;
        func = $temp$func;
        acc = $temp$acc;
        dict = $temp$dict;
        continue foldl;
      }
    }
  });
  var $elm$core$Dict$merge = F6(function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
    var stepState = F3(function (rKey, rValue, _v0) {
      stepState: while (true) {
        var list = _v0.a;
        var result = _v0.b;

        if (!list.b) {
          return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
        } else {
          var _v2 = list.a;
          var lKey = _v2.a;
          var lValue = _v2.b;
          var rest = list.b;

          if (_Utils_cmp(lKey, rKey) < 0) {
            var $temp$rKey = rKey,
                $temp$rValue = rValue,
                $temp$_v0 = _Utils_Tuple2(rest, A3(leftStep, lKey, lValue, result));

            rKey = $temp$rKey;
            rValue = $temp$rValue;
            _v0 = $temp$_v0;
            continue stepState;
          } else {
            if (_Utils_cmp(lKey, rKey) > 0) {
              return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
            } else {
              return _Utils_Tuple2(rest, A4(bothStep, lKey, lValue, rValue, result));
            }
          }
        }
      }
    });

    var _v3 = A3($elm$core$Dict$foldl, stepState, _Utils_Tuple2($elm$core$Dict$toList(leftDict), initialResult), rightDict);

    var leftovers = _v3.a;
    var intermediateResult = _v3.b;
    return A3($elm$core$List$foldl, F2(function (_v4, result) {
      var k = _v4.a;
      var v = _v4.b;
      return A3(leftStep, k, v, result);
    }), intermediateResult, leftovers);
  });
  var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;

  var $elm$time$Time$Name = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$time$Time$Offset = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$time$Time$setInterval = _Time_setInterval;
  var $elm$core$Process$spawn = _Scheduler_spawn;
  var $elm$time$Time$spawnHelp = F3(function (router, intervals, processes) {
    if (!intervals.b) {
      return $elm$core$Task$succeed(processes);
    } else {
      var interval = intervals.a;
      var rest = intervals.b;
      var spawnTimer = $elm$core$Process$spawn(A2($elm$time$Time$setInterval, interval, A2($elm$core$Platform$sendToSelf, router, interval)));

      var spawnRest = function (id) {
        return A3($elm$time$Time$spawnHelp, router, rest, A3($elm$core$Dict$insert, interval, id, processes));
      };

      return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
    }
  });
  var $elm$time$Time$onEffects = F3(function (router, subs, _v0) {
    var processes = _v0.sN;
    var rightStep = F3(function (_v6, id, _v7) {
      var spawns = _v7.a;
      var existing = _v7.b;
      var kills = _v7.c;
      return _Utils_Tuple3(spawns, existing, A2($elm$core$Task$andThen, function (_v5) {
        return kills;
      }, $elm$core$Process$kill(id)));
    });
    var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
    var leftStep = F3(function (interval, taggers, _v4) {
      var spawns = _v4.a;
      var existing = _v4.b;
      var kills = _v4.c;
      return _Utils_Tuple3(A2($elm$core$List$cons, interval, spawns), existing, kills);
    });
    var bothStep = F4(function (interval, taggers, id, _v3) {
      var spawns = _v3.a;
      var existing = _v3.b;
      var kills = _v3.c;
      return _Utils_Tuple3(spawns, A3($elm$core$Dict$insert, interval, id, existing), kills);
    });

    var _v1 = A6($elm$core$Dict$merge, leftStep, bothStep, rightStep, newTaggers, processes, _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, $elm$core$Task$succeed(0)));

    var spawnList = _v1.a;
    var existingDict = _v1.b;
    var killTask = _v1.c;
    return A2($elm$core$Task$andThen, function (newProcesses) {
      return $elm$core$Task$succeed(A2($elm$time$Time$State, newTaggers, newProcesses));
    }, A2($elm$core$Task$andThen, function (_v2) {
      return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
    }, killTask));
  });

  var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);

  var $elm$time$Time$onSelfMsg = F3(function (router, interval, state) {
    var _v0 = A2($elm$core$Dict$get, interval, state.tT);

    if (_v0.$ === 1) {
      return $elm$core$Task$succeed(state);
    } else {
      var taggers = _v0.a;

      var tellTaggers = function (time) {
        return $elm$core$Task$sequence(A2($elm$core$List$map, function (tagger) {
          return A2($elm$core$Platform$sendToApp, router, tagger(time));
        }, taggers));
      };

      return A2($elm$core$Task$andThen, function (_v1) {
        return $elm$core$Task$succeed(state);
      }, A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
    }
  });
  var $elm$time$Time$subMap = F2(function (f, _v0) {
    var interval = _v0.a;
    var tagger = _v0.b;
    return A2($elm$time$Time$Every, interval, A2($elm$core$Basics$composeL, f, tagger));
  });
  _Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);

  var $elm$time$Time$subscription = _Platform_leaf('Time');

  var $elm$time$Time$every = F2(function (interval, tagger) {
    return $elm$time$Time$subscription(A2($elm$time$Time$Every, interval, tagger));
  });
  var $elm$json$Json$Decode$bool = _Json_decodeBool;

  var $author$project$ElmFramework$Feature$Pwa$Pwa$installPwaResult = _Platform_incomingPort('installPwaResult', $elm$json$Json$Decode$bool);

  var $elm$json$Json$Decode$string = _Json_decodeString;

  var $author$project$ElmFramework$Feature$Platform$Platform$lifeCycleEvent = _Platform_incomingPort('lifeCycleEvent', $elm$json$Json$Decode$string);

  var $author$project$ElmFramework$Feature$Platform$Platform$Pause = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$Resume = {
    $: 0
  };

  var $author$project$ElmFramework$Feature$Platform$Platform$Unexpected = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Platform$Platform$toLifeCycleEvent = function (eventString) {
    switch (eventString) {
      case 'Resume':
        return $author$project$ElmFramework$Feature$Platform$Platform$Resume;

      case 'Pause':
        return $author$project$ElmFramework$Feature$Platform$Platform$Pause;

      default:
        var unexpected = eventString;
        return $author$project$ElmFramework$Feature$Platform$Platform$Unexpected(unexpected);
    }
  };

  var $author$project$ElmFramework$Feature$Platform$Platform$listenLifeCycleEvents = function (tag) {
    return $author$project$ElmFramework$Feature$Platform$Platform$lifeCycleEvent(A2($elm$core$Basics$composeL, tag, $author$project$ElmFramework$Feature$Platform$Platform$toLifeCycleEvent));
  };

  var $elm$core$Platform$Sub$map = _Platform_map;
  var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoErr = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $elm$json$Json$Decode$decodeValue = _Json_run;

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$LocationUnavailable = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$PermissionDenied = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$Timeout = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $elm$json$Json$Decode$fail = _Json_fail;
  var $elm$json$Json$Decode$field = _Json_decodeField;
  var $elm$json$Json$Decode$oneOf = _Json_oneOf;

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$geolocationErrorDecoder = function () {
    var unionType = F2(function (discriminant, constructor) {
      return A3($elm$json$Json$Decode$map2, F2(function (_v0, val) {
        return constructor(val);
      }), A2($elm$json$Json$Decode$andThen, function (kind) {
        return _Utils_eq(kind, discriminant) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('geo error: bad kind: ' + kind);
      }, A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'details', $elm$json$Json$Decode$string));
    });
    return $elm$json$Json$Decode$oneOf(_List_fromArray([A2(unionType, 'PermissionDenied', $author$project$ElmFramework$Feature$Geolocation$Geolocation$PermissionDenied), A2(unionType, 'LocationUnavailable', $author$project$ElmFramework$Feature$Geolocation$Geolocation$LocationUnavailable), A2(unionType, 'Timeout', $author$project$ElmFramework$Feature$Geolocation$Geolocation$Timeout)]));
  }();

  var $elm$core$Result$mapError = F2(function (f, result) {
    if (!result.$) {
      var v = result.a;
      return $elm$core$Result$Ok(v);
    } else {
      var e = result.a;
      return $elm$core$Result$Err(f(e));
    }
  });
  var $elm$json$Json$Decode$value = _Json_decodeValue;

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationFailure = _Platform_incomingPort('receiveGeolocationFailure', A2($elm$json$Json$Decode$andThen, function (isExplicitlyRequested) {
    return A2($elm$json$Json$Decode$andThen, function (geolocationError) {
      return $elm$json$Json$Decode$succeed({
        lw: geolocationError,
        dV: isExplicitlyRequested
      });
    }, A2($elm$json$Json$Decode$field, 'geolocationError', $elm$json$Json$Decode$value));
  }, A2($elm$json$Json$Decode$field, 'isExplicitlyRequested', $elm$json$Json$Decode$bool)));

  var $elm$json$Json$Decode$float = _Json_decodeFloat;

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationSuccess = _Platform_incomingPort('receiveGeolocationSuccess', A2($elm$json$Json$Decode$andThen, function (isExplicitlyRequested) {
    return A2($elm$json$Json$Decode$andThen, function (geolocationSuccess) {
      return $elm$json$Json$Decode$succeed({
        lx: geolocationSuccess,
        dV: isExplicitlyRequested
      });
    }, A2($elm$json$Json$Decode$field, 'geolocationSuccess', A2($elm$json$Json$Decode$andThen, function (longitude) {
      return A2($elm$json$Json$Decode$andThen, function (latitude) {
        return A2($elm$json$Json$Decode$andThen, function (accuracy) {
          return $elm$json$Json$Decode$succeed({
            kb: accuracy,
            l4: latitude,
            mj: longitude
          });
        }, A2($elm$json$Json$Decode$field, 'accuracy', $elm$json$Json$Decode$float));
      }, A2($elm$json$Json$Decode$field, 'latitude', $elm$json$Json$Decode$float));
    }, A2($elm$json$Json$Decode$field, 'longitude', $elm$json$Json$Decode$float))));
  }, A2($elm$json$Json$Decode$field, 'isExplicitlyRequested', $elm$json$Json$Decode$bool)));

  var $author$project$ElmFramework$Lib$Util$unwrapResult = function (result) {
    if (!result.$) {
      var a = result.a;
      return a;
    } else {
      var a = result.a;
      return a;
    }
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveGeolocation = function (tag) {
    var successToPayload = function (_v1) {
      var geolocationSuccess = _v1.lx;
      var isExplicitlyRequested = _v1.dV;
      return {
        iT: $elm$core$Result$Ok(geolocationSuccess),
        dV: isExplicitlyRequested
      };
    };

    var failureToPayload = function (_v0) {
      var geolocationError = _v0.lw;
      var isExplicitlyRequested = _v0.dV;
      return {
        iT: $elm$core$Result$Err($author$project$ElmFramework$Lib$Util$unwrapResult(A2($elm$core$Result$mapError, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoErr, $elm$json$Json$Decode$errorToString), A2($elm$json$Json$Decode$decodeValue, $author$project$ElmFramework$Feature$Geolocation$Geolocation$geolocationErrorDecoder, geolocationError)))),
        dV: isExplicitlyRequested
      };
    };

    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationSuccess(A2($elm$core$Basics$composeR, successToPayload, tag)), $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationFailure(A2($elm$core$Basics$composeR, failureToPayload, tag))]));
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedAlwaysGeoPermissions = {
    $: 3
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$decodeLocationPermissions = function (locationPermissions) {
    switch (locationPermissions) {
      case 'NOT_REQUESTED':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus);

      case 'GRANTED':
        return $elm$core$Result$Ok(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, true, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation));

      case 'GRANTED_WHEN_IN_USE':
        return $elm$core$Result$Ok(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation));

      case 'RESTRICTED':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedAlwaysGeoPermissions);

      case 'DENIED_ALWAYS':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedAlwaysGeoPermissions);

      case 'DENIED':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions);

      default:
        return $elm$core$Result$Err('decodeLocationPermissions: unexpected locationPermissions: ' + locationPermissions);
    }
  };

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveLocationPermissions = _Platform_incomingPort('receiveLocationPermissions', $elm$json$Json$Decode$string);

  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveLocationPermissions = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveLocationPermissions(A2($elm$core$Basics$composeR, $author$project$ElmFramework$Feature$Geolocation$Geolocation$decodeLocationPermissions, tag))]));
  };

  var $elm$browser$Browser$Events$Document = 0;
  var $elm$browser$Browser$Events$MySub = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $elm$browser$Browser$Events$State = F2(function (subs, pids) {
    return {
      sy: pids,
      tP: subs
    };
  });
  var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));

  var $elm$browser$Browser$Events$nodeToKey = function (node) {
    if (!node) {
      return 'd_';
    } else {
      return 'w_';
    }
  };

  var $elm$browser$Browser$Events$addKey = function (sub) {
    var node = sub.a;
    var name = sub.b;
    return _Utils_Tuple2(_Utils_ap($elm$browser$Browser$Events$nodeToKey(node), name), sub);
  };

  var $elm$browser$Browser$Events$Event = F2(function (key, event) {
    return {
      lc: event,
      q9: key
    };
  });
  var $elm$browser$Browser$Events$spawn = F3(function (router, key, _v0) {
    var node = _v0.a;
    var name = _v0.b;

    var actualNode = function () {
      if (!node) {
        return _Browser_doc;
      } else {
        return _Browser_window;
      }
    }();

    return A2($elm$core$Task$map, function (value) {
      return _Utils_Tuple2(key, value);
    }, A3(_Browser_on, actualNode, name, function (event) {
      return A2($elm$core$Platform$sendToSelf, router, A2($elm$browser$Browser$Events$Event, key, event));
    }));
  });
  var $elm$core$Dict$union = F2(function (t1, t2) {
    return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
  });
  var $elm$browser$Browser$Events$onEffects = F3(function (router, subs, state) {
    var stepRight = F3(function (key, sub, _v6) {
      var deads = _v6.a;
      var lives = _v6.b;
      var news = _v6.c;
      return _Utils_Tuple3(deads, lives, A2($elm$core$List$cons, A3($elm$browser$Browser$Events$spawn, router, key, sub), news));
    });
    var stepLeft = F3(function (_v4, pid, _v5) {
      var deads = _v5.a;
      var lives = _v5.b;
      var news = _v5.c;
      return _Utils_Tuple3(A2($elm$core$List$cons, pid, deads), lives, news);
    });
    var stepBoth = F4(function (key, pid, _v2, _v3) {
      var deads = _v3.a;
      var lives = _v3.b;
      var news = _v3.c;
      return _Utils_Tuple3(deads, A3($elm$core$Dict$insert, key, pid, lives), news);
    });
    var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);

    var _v0 = A6($elm$core$Dict$merge, stepLeft, stepBoth, stepRight, state.sy, $elm$core$Dict$fromList(newSubs), _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));

    var deadPids = _v0.a;
    var livePids = _v0.b;
    var makeNewPids = _v0.c;
    return A2($elm$core$Task$andThen, function (pids) {
      return $elm$core$Task$succeed(A2($elm$browser$Browser$Events$State, newSubs, A2($elm$core$Dict$union, livePids, $elm$core$Dict$fromList(pids))));
    }, A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$sequence(makeNewPids);
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
  });
  var $elm$browser$Browser$Events$onSelfMsg = F3(function (router, _v0, state) {
    var key = _v0.q9;
    var event = _v0.lc;

    var toMessage = function (_v2) {
      var subKey = _v2.a;
      var _v3 = _v2.b;
      var node = _v3.a;
      var name = _v3.b;
      var decoder = _v3.c;
      return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
    };

    var messages = A2($elm$core$List$filterMap, toMessage, state.tP);
    return A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$succeed(state);
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Platform$sendToApp(router), messages)));
  });
  var $elm$browser$Browser$Events$subMap = F2(function (func, _v0) {
    var node = _v0.a;
    var name = _v0.b;
    var decoder = _v0.c;
    return A3($elm$browser$Browser$Events$MySub, node, name, A2($elm$json$Json$Decode$map, func, decoder));
  });
  _Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);

  var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');

  var $elm$browser$Browser$Events$on = F3(function (node, name, decoder) {
    return $elm$browser$Browser$Events$subscription(A3($elm$browser$Browser$Events$MySub, node, name, decoder));
  });
  var $elm$browser$Browser$Events$Hidden = 1;
  var $elm$browser$Browser$Events$Visible = 0;
  var $elm$browser$Browser$Events$withHidden = F2(function (func, isHidden) {
    return func(isHidden ? 1 : 0);
  });

  var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
    var info = _Browser_visibilityInfo(0);

    return A3($elm$browser$Browser$Events$on, 0, info.vT, A2($elm$json$Json$Decode$map, $elm$browser$Browser$Events$withHidden(func), A2($elm$json$Json$Decode$field, 'target', A2($elm$json$Json$Decode$field, info.x8, $elm$json$Json$Decode$bool))));
  };

  var $author$project$ElmFramework$Feature$Pwa$Pwa$receiveBeforeInstallPromptEvent = _Platform_incomingPort('receiveBeforeInstallPromptEvent', $elm$json$Json$Decode$null(0));

  var $elm$json$Json$Decode$list = _Json_decodeList;

  var $author$project$ElmFramework$Feature$Toaster$Notifier$listenNotif = _Platform_incomingPort('listenNotif', A2($elm$json$Json$Decode$andThen, function (title) {
    return A2($elm$json$Json$Decode$andThen, function (kind) {
      return A2($elm$json$Json$Decode$andThen, function (bodies) {
        return $elm$json$Json$Decode$succeed({
          eK: bodies,
          f9: kind,
          t1: title
        });
      }, A2($elm$json$Json$Decode$field, 'bodies', $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
    }, A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string)));

  var $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind = {
    iQ: 'error',
    iW: 'info',
    jV: 'success'
  };

  var $author$project$ElmFramework$Feature$Toaster$Notifier$receiveNotifs = function (config) {
    var transformer = function (notif) {
      return _Utils_eq(notif.f9, $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind.jV) ? A2(config.jV, notif.t1, notif.eK) : _Utils_eq(notif.f9, $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind.iQ) ? A2(config.iQ, notif.t1, notif.eK) : A2(config.iW, notif.t1, notif.eK);
    };

    return $author$project$ElmFramework$Feature$Toaster$Notifier$listenNotif(transformer);
  };

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushMsg = _Platform_incomingPort('receivePushMsg', $elm$json$Json$Decode$value);

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookSdkLoaded = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleSdkLoaded = {
    $: 0
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveFacebookAuthSuccess = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveGoogleAuthSuccess = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosedInternal = {
    $: 2
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpenedInternal = {
    $: 3
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$facebookSdkLoaded = _Platform_incomingPort('facebookSdkLoaded', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleSdkLoaded = _Platform_incomingPort('googleSdkLoaded', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveFacebookAuth = _Platform_incomingPort('receiveFacebookAuth', A2($elm$json$Json$Decode$andThen, function (authResponse) {
    return $elm$json$Json$Decode$succeed({
      o1: authResponse
    });
  }, A2($elm$json$Json$Decode$field, 'authResponse', A2($elm$json$Json$Decode$andThen, function (userID) {
    return A2($elm$json$Json$Decode$andThen, function (accessToken) {
      return $elm$json$Json$Decode$succeed({
        ux: accessToken,
        Fn: userID
      });
    }, A2($elm$json$Json$Decode$field, 'accessToken', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'userID', $elm$json$Json$Decode$string)))));

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveGoogleAuth = _Platform_incomingPort('receiveGoogleAuth', A2($elm$json$Json$Decode$andThen, function (serverAuthCode) {
    return $elm$json$Json$Decode$succeed({
      tr: serverAuthCode
    });
  }, A2($elm$json$Json$Decode$field, 'serverAuthCode', $elm$json$Json$Decode$string)));

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowClosed = _Platform_incomingPort('socialWindowClosed', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowOpened = _Platform_incomingPort('socialWindowOpened', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialAuthEventsSubscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleSdkLoaded($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleSdkLoaded)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$facebookSdkLoaded($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookSdkLoaded)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowClosed($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosedInternal)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowOpened($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpenedInternal)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveGoogleAuth($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveGoogleAuthSuccess), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveFacebookAuth($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveFacebookAuthSuccess)]));
  var $author$project$ElmFramework$Feature$Navigation$Msg$AuthError = {
    $: 11
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$HardwareBack = {
    $: 9
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$HardwareForward = {
    $: 10
  };

  var $author$project$ElmFramework$Feature$Navigation$Msg$NavToFromLoopback = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Navigation$Msg$PopState = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopbackSub = _Platform_incomingPort('authErrorLoopbackSub', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavBack = _Platform_incomingPort('hardwareNavBack', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavForward = _Platform_incomingPort('hardwareNavForward', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$navToLoopbackSub = _Platform_incomingPort('navToLoopbackSub', A2($elm$json$Json$Decode$andThen, function (shouldSilent) {
    return A2($elm$json$Json$Decode$andThen, function (shouldReplace) {
      return A2($elm$json$Json$Decode$andThen, function (navigationLocation) {
        return $elm$json$Json$Decode$succeed({
          zN: navigationLocation,
          n4: shouldReplace,
          tu: shouldSilent
        });
      }, A2($elm$json$Json$Decode$field, 'navigationLocation', A2($elm$json$Json$Decode$andThen, function (search) {
        return A2($elm$json$Json$Decode$andThen, function (protocol) {
          return A2($elm$json$Json$Decode$andThen, function (port_) {
            return A2($elm$json$Json$Decode$andThen, function (pathname) {
              return A2($elm$json$Json$Decode$andThen, function (origin) {
                return A2($elm$json$Json$Decode$andThen, function (href) {
                  return A2($elm$json$Json$Decode$andThen, function (hostname) {
                    return A2($elm$json$Json$Decode$andThen, function (host) {
                      return A2($elm$json$Json$Decode$andThen, function (hash) {
                        return $elm$json$Json$Decode$succeed({
                          lB: hash,
                          lE: host,
                          lF: hostname,
                          lG: href,
                          m$: origin,
                          nb: pathname,
                          nm: port_,
                          nt: protocol,
                          nU: search
                        });
                      }, A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
                  }, A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
          }, A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
        }, A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
      }, A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
    }, A2($elm$json$Json$Decode$field, 'shouldReplace', $elm$json$Json$Decode$bool));
  }, A2($elm$json$Json$Decode$field, 'shouldSilent', $elm$json$Json$Decode$bool)));

  var $elm$json$Json$Decode$int = _Json_decodeInt;

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$popState = _Platform_incomingPort('popState', A2($elm$json$Json$Decode$andThen, function (stateIndex) {
    return A2($elm$json$Json$Decode$andThen, function (location) {
      return $elm$json$Json$Decode$succeed({
        rm: location,
        ea: stateIndex
      });
    }, A2($elm$json$Json$Decode$field, 'location', A2($elm$json$Json$Decode$andThen, function (search) {
      return A2($elm$json$Json$Decode$andThen, function (protocol) {
        return A2($elm$json$Json$Decode$andThen, function (port_) {
          return A2($elm$json$Json$Decode$andThen, function (pathname) {
            return A2($elm$json$Json$Decode$andThen, function (origin) {
              return A2($elm$json$Json$Decode$andThen, function (href) {
                return A2($elm$json$Json$Decode$andThen, function (hostname) {
                  return A2($elm$json$Json$Decode$andThen, function (host) {
                    return A2($elm$json$Json$Decode$andThen, function (hash) {
                      return $elm$json$Json$Decode$succeed({
                        lB: hash,
                        lE: host,
                        lF: hostname,
                        lG: href,
                        m$: origin,
                        nb: pathname,
                        nm: port_,
                        nt: protocol,
                        nU: search
                      });
                    }, A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
                  }, A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
          }, A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
        }, A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
      }, A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
  }, A2($elm$json$Json$Decode$field, 'stateIndex', $elm$json$Json$Decode$int)));

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$subscriptions = function (config) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$popState(config.Ct), $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavBack($elm$core$Basics$always(config.x2)), $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavForward($elm$core$Basics$always(config.x3)), $author$project$ElmFramework$Feature$Navigation$RouteHistory$navToLoopbackSub(config.zM)]));
  };

  var $author$project$ElmFramework$Feature$Navigation$Routing$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$subscriptions({
    x2: $author$project$ElmFramework$Feature$Navigation$Msg$HardwareBack,
    x3: $author$project$ElmFramework$Feature$Navigation$Msg$HardwareForward,
    zM: $author$project$ElmFramework$Feature$Navigation$Msg$NavToFromLoopback,
    Ct: $author$project$ElmFramework$Feature$Navigation$Msg$PopState
  }), $author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopbackSub($elm$core$Basics$always($author$project$ElmFramework$Feature$Navigation$Msg$AuthError))]));

  var $ohanhi$keyboard$Keyboard$Down = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $ohanhi$keyboard$Keyboard$Up = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $ohanhi$keyboard$Keyboard$RawKey = $elm$core$Basics$identity;
  var $ohanhi$keyboard$Keyboard$eventKeyDecoder = A2($elm$json$Json$Decode$field, 'key', A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string));
  var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');

  var $ohanhi$keyboard$Keyboard$downs = function (toMsg) {
    return $elm$browser$Browser$Events$onKeyDown(A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
  };

  var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');

  var $ohanhi$keyboard$Keyboard$ups = function (toMsg) {
    return $elm$browser$Browser$Events$onKeyUp(A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
  };

  var $ohanhi$keyboard$Keyboard$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$ohanhi$keyboard$Keyboard$downs($ohanhi$keyboard$Keyboard$Down), $ohanhi$keyboard$Keyboard$ups($ohanhi$keyboard$Keyboard$Up)]));
  var $elm$core$List$append = F2(function (xs, ys) {
    if (!ys.b) {
      return xs;
    } else {
      return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
    }
  });

  var $elm$core$List$concat = function (lists) {
    return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
  };

  var $ohanhi$keyboard$Keyboard$oneOf = F2(function (fns, key) {
    oneOf: while (true) {
      if (!fns.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var fn = fns.a;
        var rest = fns.b;

        var _v1 = fn(key);

        if (!_v1.$) {
          var a = _v1.a;
          return $elm$core$Maybe$Just(a);
        } else {
          var $temp$fns = rest,
              $temp$key = key;
          fns = $temp$fns;
          key = $temp$key;
          continue oneOf;
        }
      }
    }
  });

  var $ohanhi$keyboard$Keyboard$KeyDown = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $ohanhi$keyboard$Keyboard$KeyUp = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $ohanhi$keyboard$Keyboard$insert = F3(function (keyParser, rawKey, list) {
    var _v0 = keyParser(rawKey);

    if (!_v0.$) {
      var key = _v0.a;
      return A2($elm$core$List$cons, key, A2($elm$core$List$filter, $elm$core$Basics$neq(key), list));
    } else {
      return list;
    }
  });
  var $ohanhi$keyboard$Keyboard$remove = F3(function (keyParser, rawKey, list) {
    var _v0 = keyParser(rawKey);

    if (!_v0.$) {
      var key = _v0.a;
      return A2($elm$core$List$filter, $elm$core$Basics$neq(key), list);
    } else {
      return list;
    }
  });
  var $ohanhi$keyboard$Keyboard$updateWithKeyChange = F3(function (keyParser, msg, state) {
    if (!msg.$) {
      var key = msg.a;
      var nextState = A3($ohanhi$keyboard$Keyboard$insert, keyParser, key, state);
      var change = !_Utils_eq($elm$core$List$length(nextState), $elm$core$List$length(state)) ? A2($elm$core$Maybe$map, $ohanhi$keyboard$Keyboard$KeyDown, keyParser(key)) : $elm$core$Maybe$Nothing;
      return _Utils_Tuple2(nextState, change);
    } else {
      var key = msg.a;
      var nextState = A3($ohanhi$keyboard$Keyboard$remove, keyParser, key, state);
      var change = !_Utils_eq($elm$core$List$length(nextState), $elm$core$List$length(state)) ? A2($elm$core$Maybe$map, $ohanhi$keyboard$Keyboard$KeyUp, keyParser(key)) : $elm$core$Maybe$Nothing;
      return _Utils_Tuple2(nextState, change);
    }
  });
  var $author$project$ElmFramework$Lib$Keyboard$toMsg = F4(function (tag, keyboardHandlers, oldPressedKeys, theMsg) {
    var keyParser = $ohanhi$keyboard$Keyboard$oneOf(A2($elm$core$List$map, function ($) {
      return $.st;
    }, keyboardHandlers));

    var _v0 = A3($ohanhi$keyboard$Keyboard$updateWithKeyChange, keyParser, theMsg, oldPressedKeys);

    var pressedKeys = _v0.a;
    var keyChange = _v0.b;
    var messages = $elm$core$List$concat(A2($elm$core$List$map, A2($elm$core$Basics$composeR, function ($) {
      return $.qd;
    }, function (handler) {
      return A2(handler, pressedKeys, keyChange);
    }), keyboardHandlers));
    return A2(tag, pressedKeys, messages);
  });
  var $elm$json$Json$Decode$index = _Json_decodeIndex;

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushStatus = _Platform_incomingPort('receivePushStatus', A2($elm$json$Json$Decode$andThen, function (_v0) {
    return A2($elm$json$Json$Decode$andThen, function (_v1) {
      return A2($elm$json$Json$Decode$andThen, function (_v2) {
        return $elm$json$Json$Decode$succeed(_Utils_Tuple3(_v0, _v1, _v2));
      }, A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)]))));
    }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)]))));
  }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$DisabledPushPermissions = {
    $: 2
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$EnabledPushPermissions = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnregisteredPushPermissions = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnsupportedPushPermissions = {
    $: 4
  };

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$toPushStatusResult = function (_v0) {
    var status = _v0.a;
    var maybeToken = _v0.b;
    var isMaybeReq = _v0.c;

    var _v1 = _Utils_Tuple2(status, maybeToken);

    _v1$4: while (true) {
      switch (_v1.a) {
        case 'Unregistered':
          return $elm$core$Result$Ok($author$project$ElmFramework$Feature$PushMessages$PushMessages$UnregisteredPushPermissions);

        case 'Disabled':
          return $elm$core$Result$Ok($author$project$ElmFramework$Feature$PushMessages$PushMessages$DisabledPushPermissions);

        case 'Unsupported':
          return $elm$core$Result$Ok($author$project$ElmFramework$Feature$PushMessages$PushMessages$UnsupportedPushPermissions);

        case 'Enabled':
          if (!_v1.b.$) {
            var token = _v1.b.a;
            return $elm$core$Result$Ok(A2($author$project$ElmFramework$Feature$PushMessages$PushMessages$EnabledPushPermissions, token, A2($elm$core$Maybe$withDefault, false, isMaybeReq)));
          } else {
            break _v1$4;
          }

        default:
          break _v1$4;
      }
    }

    return $elm$core$Result$Err(status);
  };

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$toReceivePushStatusSub = function (tag) {
    return $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushStatus(A2($elm$core$Basics$composeL, tag, $author$project$ElmFramework$Feature$PushMessages$PushMessages$toPushStatusResult));
  };

  var $author$project$ElmFramework$Feature$Payments$Payments$userCouldNotProvidePaymentCard = _Platform_incomingPort('userCouldNotProvidePaymentCard', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$Platform$Platform$weAreOnline = _Platform_incomingPort('weAreOnline', $elm$json$Json$Decode$null(0));

  var $author$project$ElmFramework$Feature$Browser$Browser$windowResize = _Platform_incomingPort('windowResize', A2($elm$json$Json$Decode$andThen, function (width) {
    return A2($elm$json$Json$Decode$andThen, function (unitSize) {
      return A2($elm$json$Json$Decode$andThen, function (pixelRatio) {
        return A2($elm$json$Json$Decode$andThen, function (height) {
          return $elm$json$Json$Decode$succeed({
            x6: height,
            sA: pixelRatio,
            j6: unitSize,
            FE: width
          });
        }, A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
      }, A2($elm$json$Json$Decode$field, 'pixelRatio', $elm$json$Json$Decode$float));
    }, A2($elm$json$Json$Decode$field, 'unitSize', $elm$json$Json$Decode$int));
  }, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)));

  var $author$project$ElmFramework$Main$subscriptions = F2(function (config, state) {
    var keyboardHandlers = function () {
      var _v0 = _Utils_ap(config.y_(state), A2($author$project$ElmFramework$Main$escKeyboardHandler, config, state));

      if (!_v0.b) {
        return $elm$core$Platform$Sub$none;
      } else {
        var theKeyboardHandlers = _v0;
        return A2($elm$core$Platform$Sub$map, A3($author$project$ElmFramework$Lib$Keyboard$toMsg, $author$project$ElmFramework$Msg$KeyEvent, theKeyboardHandlers, state.sI), $ohanhi$keyboard$Keyboard$subscriptions);
      }
    }();

    return $elm$core$Platform$Sub$batch(_List_fromArray([A2($elm$core$Platform$Sub$map, $author$project$ElmFramework$Msg$AppMsg, config.Ev(state)), keyboardHandlers, $elm$browser$Browser$Events$onVisibilityChange($author$project$ElmFramework$Msg$VisibilityChange), $author$project$ElmFramework$Feature$Browser$Browser$windowResize($author$project$ElmFramework$Msg$WindowResize), A2($elm$time$Time$every, config.EN, $author$project$ElmFramework$Msg$UpdateCurrTime), $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveLocationPermissions($author$project$ElmFramework$Msg$ReceiveDetailedGeolocationPermissions), $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveGeolocation($author$project$ElmFramework$Msg$ReceiveGeolocation), $author$project$ElmFramework$Feature$PushMessages$PushMessages$toReceivePushStatusSub($author$project$ElmFramework$Msg$PushNotificationsPermissionsStatus), $author$project$ElmFramework$Feature$Payments$Payments$userCouldNotProvidePaymentCard($elm$core$Basics$always($author$project$ElmFramework$Msg$UserCouldNotProvidePaymentCard)), $author$project$ElmFramework$Feature$Pwa$Pwa$receiveBeforeInstallPromptEvent($elm$core$Basics$always($author$project$ElmFramework$Msg$ReceiveBeforeInstallPromptEvent)), $author$project$ElmFramework$Feature$Pwa$Pwa$installPwaResult($author$project$ElmFramework$Msg$ReceiveInstallPwaResult), $author$project$ElmFramework$Feature$Pwa$Pwa$appUpdated($elm$core$Basics$always($author$project$ElmFramework$Msg$AppUpdated)), $author$project$ElmFramework$Feature$Platform$Platform$appLoaded($elm$core$Basics$always($author$project$ElmFramework$Msg$AppLoaded)), $author$project$ElmFramework$Feature$Platform$Platform$weAreOnline($elm$core$Basics$always($author$project$ElmFramework$Msg$WeAreOnline)), $author$project$ElmFramework$Feature$Platform$Platform$listenLifeCycleEvents($author$project$ElmFramework$Msg$LifeCycleEvent), $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushMsg($author$project$ElmFramework$Msg$OnPushMessage), $author$project$ElmFramework$Feature$Toaster$Notifier$receiveNotifs({
      iQ: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr($elm$core$Maybe$Nothing),
      iW: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastInfo($elm$core$Maybe$Nothing),
      jV: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess($elm$core$Maybe$Nothing)
    }), A2($elm$core$Platform$Sub$map, $author$project$ElmFramework$Msg$SocialAuthMsg, $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialAuthEventsSubscriptions), A2($elm$core$Platform$Sub$map, $author$project$ElmFramework$Msg$RoutingMsg, $author$project$ElmFramework$Feature$Navigation$Routing$subscriptions)]));
  });
  var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
  var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;

  var $author$project$ElmFramework$View$topBarOffset = function (isHybridIos) {
    return isHybridIos ? 20 : 0;
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$Tap = {
    $: 3
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$hiddenToastsHeight = F2(function (toasts, visibleToasts) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toaster$toastsHeight, toasts, 0, $elm$core$Array$length(toasts) - visibleToasts);
  });

  var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
    return _VirtualDom_keyedNode(_VirtualDom_noScript(tag));
  };

  var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;

  var $elm$virtual_dom$VirtualDom$Normal = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$html$Html$Events$on = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Normal(decoder));
  });
  var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
  var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
  var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
  var $elm$core$Array$indexedMap = F2(function (func, _v0) {
    var len = _v0.a;
    var tree = _v0.c;
    var tail = _v0.d;
    var initialBuilder = {
      bO: _List_Nil,
      bx: 0,
      bL: A3($elm$core$Elm$JsArray$indexedMap, func, $elm$core$Array$tailIndex(len), tail)
    };
    var helper = F2(function (node, builder) {
      if (!node.$) {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
      } else {
        var leaf = node.a;
        var offset = builder.bx * $elm$core$Array$branchFactor;
        var mappedLeaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
        return {
          bO: A2($elm$core$List$cons, mappedLeaf, builder.bO),
          bx: builder.bx + 1,
          bL: builder.bL
        };
      }
    });
    return A2($elm$core$Array$builderToArray, true, A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$ReceiveToastHeight = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$eventFull = F2(function (eventHandlers, attrs) {
    var toAttrs = function (_v0) {
      var eventEmitterAttributes = _v0;
      return eventEmitterAttributes;
    };

    var normalizedHandlers = $elm$core$List$concat(A2($elm$core$List$map, toAttrs, eventHandlers));

    var defaultAttrs = _List_fromArray([$elm$html$Html$Attributes$class('block')]);

    return A2($elm$html$Html$node, 'event-full', _Utils_ap(defaultAttrs, _Utils_ap(normalizedHandlers, attrs)));
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$EventEmitter = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$Ui$EventFull$Size = F4(function (width, height, contentWidth, contentHeight) {
    return {
      wd: contentHeight,
      we: contentWidth,
      x6: height,
      FE: width
    };
  });
  var $elm$json$Json$Decode$map4 = _Json_map4;

  var $author$project$ElmFramework$Lib$Util$preventer = function (decoder) {
    return A2($elm$json$Json$Decode$map, function (msg) {
      return {
        zu: msg,
        sJ: true,
        tH: true
      };
    }, decoder);
  };

  var $author$project$ElmFramework$Lib$Util$onLocal = F2(function (eventName, decoder) {
    return A2($elm$html$Html$Events$custom, eventName, $author$project$ElmFramework$Lib$Util$preventer(decoder));
  });

  var $author$project$ElmFramework$Lib$Ui$EventFull$onSizeEmitter = function (tag) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'onSize', A2($elm$json$Json$Decode$map, tag, A2($elm$json$Json$Decode$field, 'detail', A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Ui$EventFull$Size, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'contentWidth', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'contentHeight', $elm$json$Json$Decode$int)))));
  };

  var $author$project$ElmFramework$Lib$Ui$EventFull$onFirstChildSize = function (tag) {
    return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-first-child-size', 'true'), $author$project$ElmFramework$Lib$Ui$EventFull$onSizeEmitter(tag)]);
  };

  var $author$project$ElmFramework$Feature$Toaster$Toaster$toastView = F4(function (idx, _v0, isHidden, topBarOffset) {
    var shade = _v0.ts;
    var content = _v0.pD;
    var background = _v0.o2;
    var moveOver = isHidden ? topBarOffset : 0;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('aToast'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('outOfSight', isHidden)])), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-' + ($elm$core$String$fromInt(moveOver) + 'px)'))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative'), A2($elm$html$Html$Attributes$style, 'margin-top', '-' + ($elm$core$String$fromInt(topBarOffset) + 'px'))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', $elm$core$String$fromInt(topBarOffset) + 'px')]), _List_Nil), background, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('shade absoluteSpread')]), _List_fromArray([shade])), A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onFirstChildSize($author$project$ElmFramework$Feature$Toaster$Toaster$ReceiveToastHeight(idx))]), _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([content]))]))]));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$toKeyedToasts = F3(function (toasts, visibleToasts, topBarOffset) {
    var oldestVisibleToastIndex = $elm$core$Array$length(toasts) - visibleToasts;
    var foldToKeyed = F2(function (_v1, keyedList) {
      var toastIndex = _v1.a;
      var toast = _v1.b;
      return A2($elm$core$List$cons, _Utils_Tuple2($elm$core$String$fromInt(toastIndex), A4($author$project$ElmFramework$Feature$Toaster$Toaster$toastView, toastIndex, toast, _Utils_cmp(toastIndex, oldestVisibleToastIndex) < 0, topBarOffset)), keyedList);
    });
    return $elm$core$List$reverse(A3($elm$core$Array$foldl, foldToKeyed, _List_Nil, A2($elm$core$Array$indexedMap, F2(function (idx, _v0) {
      var toast = _v0.a;
      return _Utils_Tuple2(idx, toast);
    }), toasts)));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$view = F2(function (_v0, topBarOffset) {
    var toasts = _v0.ed;
    var visibleToasts = _v0.b6;
    var offset = A2($author$project$ElmFramework$Feature$Toaster$Toaster$hiddenToastsHeight, toasts, visibleToasts);
    return A3($elm$html$Html$node, 'toaster', _List_fromArray([$elm$html$Html$Attributes$class('absolute right0 left0 z10'), A2($elm$html$Html$Attributes$style, 'top', $elm$core$String$fromInt(topBarOffset) + 'px'), A2($elm$html$Html$Events$on, 'mousedown', $elm$json$Json$Decode$succeed($author$project$ElmFramework$Feature$Toaster$Toaster$Tap))]), _List_fromArray([A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([$elm$html$Html$Attributes$class('toastsSlidingWrap relative'), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-' + ($elm$core$String$fromInt(offset) + 'px)'))]), A3($author$project$ElmFramework$Feature$Toaster$Toaster$toKeyedToasts, toasts, visibleToasts, topBarOffset))]));
  });
  var $author$project$ElmFramework$View$view = F2(function (config, state) {
    return A3($elm$html$Html$node, 'elm-framework', _List_Nil, _List_fromArray([config.Fz(state), A2($elm$html$Html$map, $author$project$ElmFramework$Msg$ToasterMsg, A2($author$project$ElmFramework$Feature$Toaster$Toaster$view, state.E2, $author$project$ElmFramework$View$topBarOffset(state.xz.i6)))]));
  });

  var $author$project$ElmFramework$Main$app = function (config) {
    return $elm$browser$Browser$element({
      yp: $author$project$ElmFramework$Main$init(config),
      Ev: $author$project$ElmFramework$Main$subscriptions(config),
      Ff: $author$project$ElmFramework$Update$update(config),
      Fz: $author$project$ElmFramework$View$view(config)
    });
  };

  var $author$project$Msg$BlockMsg = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$Msg$BlocksMsg = function (a) {
    return {
      $: 11,
      a: a
    };
  };

  var $author$project$Msg$BudgetMsg = function (a) {
    return {
      $: 19,
      a: a
    };
  };

  var $author$project$Msg$CashboardMsg = function (a) {
    return {
      $: 18,
      a: a
    };
  };

  var $author$project$Model$Geo$GpsTypeGeolocation = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Msg$OnboardingCompanyMsg = function (a) {
    return {
      $: 17,
      a: a
    };
  };

  var $author$project$Remote$Msg$RefreshUserToken = F2(function (a, b) {
    return {
      $: 14,
      a: a,
      b: b
    };
  });

  var $author$project$Msg$RemoteMsg = function (a) {
    return {
      $: 14,
      a: a
    };
  };

  var $author$project$Msg$ScenarioMsg = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Msg$SettingsMsg = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Msg$UserProfileMsg = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Msg$GlobalMsg = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Global$Model$FromPersistence = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$UiWrappers$MainAppWrapModel$LeftExpanded = 2;
  var $author$project$ElmFramework$Lib$Util$T4 = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $elm$core$Maybe$andThen = F2(function (callback, maybeValue) {
    if (!maybeValue.$) {
      var value = maybeValue.a;
      return callback(value);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $elm$json$Json$Decode$decodeString = _Json_runOnString;
  var $author$project$ElmFramework$Lib$Util$decodeString = F2(function (decoder, string) {
    return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeString, decoder, string));
  });
  var $author$project$Language$LanguageDetails = F5(function (longName, shortName, countryFlagEmoji, longNameNative, countryShortName) {
    return {
      kO: countryFlagEmoji,
      kQ: countryShortName,
      zh: longName,
      mi: longNameNative,
      D3: shortName
    };
  });
  var $elm$json$Json$Decode$map5 = _Json_map5;
  var $author$project$Model$CommonStaticFile$languageDetailsDecoder = A6($elm$json$Json$Decode$map5, $author$project$Language$LanguageDetails, A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'shortName', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'countryFlagEmoji', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'longNameNative', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'countryShortName', $elm$json$Json$Decode$string));
  var $author$project$Model$CommonStaticFile$decodeJustTheLanguage = $author$project$ElmFramework$Lib$Util$decodeString(A2($elm$json$Json$Decode$field, 'language', $author$project$Model$CommonStaticFile$languageDetailsDecoder));

  var $author$project$Persistence$setCommonStaticFile = _Platform_outgoingPort('setCommonStaticFile', $elm$json$Json$Encode$string);

  var $elm$core$Result$toMaybe = function (result) {
    if (!result.$) {
      var v = result.a;
      return $elm$core$Maybe$Just(v);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Global$Global$decideCurrLanguage = F2(function (maybePreFetchedCommonStaticFile, maybePersistedCommonStaticFile) {
    var decodeLang = function (maybeString) {
      return A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, $author$project$Model$CommonStaticFile$decodeJustTheLanguage, maybeString));
    };

    var _v0 = A4($author$project$ElmFramework$Lib$Util$T4, decodeLang(maybePreFetchedCommonStaticFile), decodeLang(maybePersistedCommonStaticFile), maybePreFetchedCommonStaticFile, maybePersistedCommonStaticFile);

    _v0$3: while (true) {
      if (!_v0.c.$) {
        if (!_v0.a.$ && !_v0.b.$) {
          var preFetchedLang = _v0.a.a;
          var persistedLang = _v0.b.a;
          var preFetchedFile = _v0.c.a;
          return _Utils_eq(preFetchedLang.zh, persistedLang.zh) ? _Utils_Tuple2(maybePreFetchedCommonStaticFile, _Utils_eq(maybePersistedCommonStaticFile, maybePreFetchedCommonStaticFile) ? $elm$core$Platform$Cmd$none : $author$project$Persistence$setCommonStaticFile(preFetchedFile)) : _Utils_Tuple2(maybePersistedCommonStaticFile, $elm$core$Platform$Cmd$none);
        } else {
          if (_v0.d.$ === 1) {
            var preFetchedFile = _v0.c.a;
            var _v1 = _v0.d;
            return _Utils_Tuple2(maybePreFetchedCommonStaticFile, $author$project$Persistence$setCommonStaticFile(preFetchedFile));
          } else {
            break _v0$3;
          }
        }
      } else {
        if (!_v0.d.$) {
          var _v2 = _v0.c;
          return _Utils_Tuple2(maybePersistedCommonStaticFile, $elm$core$Platform$Cmd$none);
        } else {
          break _v0$3;
        }
      }
    }

    return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
  });
  var $author$project$Language$authDefault = {
    kq: '______________',
    kr: '______________',
    kE: '______________',
    kF: '______________',
    kK: 'Account registered successfully, you can now login into app',
    kL: '______________',
    lk: 'Facebook',
    lr: 'Forgot Password?',
    ls: '______________',
    lu: '______________',
    lv: '______________',
    ly: 'Google',
    lH: 'I\'ve read and I accept the ',
    lI: 'Terms & Policies',
    mt: 'New password',
    nx: 'Register',
    ny: '[ I\'m New ]',
    nz: 'Enter your details',
    nC: 'Let\'s get productive',
    nD: 'Register',
    nH: '______________',
    nI: '______________',
    nJ: '______________',
    nK: '______________',
    n8: '______________',
    n9: '[ I have a Profile ]',
    oa: 'Enter your details',
    oc: 'Welcome back',
    od: 'Sign In',
    of: '______________',
    og: '______________',
    oy: 'Twitter'
  };
  var $author$project$Language$baseDefault = {
    kJ: 'Confirm',
    k5: 'Email',
    k8: 'Let us notify you when relevant information occurs',
    k9: 'Enable Notifications',
    lp: 'First name',
    l3: 'Last name',
    na: 'Password',
    op: 'Submit'
  };
  var $author$project$Language$calendarDefault = {
    kk: 'April',
    kl: 'Apr',
    kn: 'August',
    ko: 'Aug',
    kW: 'December',
    kX: 'Dec',
    ll: 'February',
    lm: 'Feb',
    lY: 'January',
    lZ: 'Jan',
    l_: 'July',
    l$: 'Jul',
    l0: 'June',
    l1: 'Jun',
    ml: 'March',
    mm: 'Mar',
    mo: 'May',
    mp: 'May',
    my: 'November',
    mz: 'Nov',
    mA: 'October',
    mB: 'Oct',
    n0: 'September',
    n1: 'Sep'
  };
  var $author$project$Language$chatDefault = {
    nf: 'This person does not accept messages',
    nv: '{{name}} sent an image'
  };
  var $author$project$Language$defaultPhrases = {
    u_: $author$project$Language$authDefault,
    kt: $author$project$Language$baseDefault,
    kA: $author$project$Language$calendarDefault,
    kD: $author$project$Language$chatDefault
  };
  var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;

  var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
    return {
      bT: $elm$core$Dict$empty,
      dn: toKey
    };
  };

  var $author$project$Model$CommonStaticFile$LanguageDetailsWithCommonStaticFile = F2(function (language, commonStatic) {
    return {
      v4: commonStatic,
      l2: language
    };
  });

  var $author$project$Language$AuthPhrases = function (signInHeadTitle) {
    return function (signInHeadSubtitle) {
      return function (signInContentTitle) {
        return function (registerHeadTitle) {
          return function (registerHeadSubtitle) {
            return function (registerContentTitle) {
              return function (registerBtnLabel) {
                return function (registerBtnLabelDescription) {
                  return function (iAcceptTheTermsOfUse1) {
                    return function (iAcceptTheTermsOfUse2) {
                      return function (authSuccessTitle) {
                        return function (authSuccessSubtitle) {
                          return function (forgotPasswordTitle) {
                            return function (forgotPasswordSubtitle) {
                              return function (forgotPasswordProvideCode) {
                                return function (forgotPassworQuestiondBtnLabel) {
                                  return function (newPasswordInputLabel) {
                                    return function (registrationVerificationTitle) {
                                      return function (registrationVerificationLine1) {
                                        return function (registrationVerificationLine2) {
                                          return function (chooseSignInMethodTitle) {
                                            return function (chooseSignInMethodSubtitle) {
                                              return function (signUpToContinue) {
                                                return function (signUpToContinueReason) {
                                                  return function (confirmationCodeInputLabel) {
                                                    return function (resendConfirmationCodeBtnLabel) {
                                                      return function (confirmRegistrationSuccessMsg) {
                                                        return function (signInBtnLabel) {
                                                          return function (signInBtnLabelExplanation) {
                                                            return function (facebook) {
                                                              return function (google) {
                                                                return function (twitter) {
                                                                  return {
                                                                    kq: authSuccessSubtitle,
                                                                    kr: authSuccessTitle,
                                                                    kE: chooseSignInMethodSubtitle,
                                                                    kF: chooseSignInMethodTitle,
                                                                    kK: confirmRegistrationSuccessMsg,
                                                                    kL: confirmationCodeInputLabel,
                                                                    lk: facebook,
                                                                    lr: forgotPassworQuestiondBtnLabel,
                                                                    ls: forgotPasswordProvideCode,
                                                                    lu: forgotPasswordSubtitle,
                                                                    lv: forgotPasswordTitle,
                                                                    ly: google,
                                                                    lH: iAcceptTheTermsOfUse1,
                                                                    lI: iAcceptTheTermsOfUse2,
                                                                    mt: newPasswordInputLabel,
                                                                    nx: registerBtnLabel,
                                                                    ny: registerBtnLabelDescription,
                                                                    nz: registerContentTitle,
                                                                    nC: registerHeadSubtitle,
                                                                    nD: registerHeadTitle,
                                                                    nH: registrationVerificationLine1,
                                                                    nI: registrationVerificationLine2,
                                                                    nJ: registrationVerificationTitle,
                                                                    nK: resendConfirmationCodeBtnLabel,
                                                                    n8: signInBtnLabel,
                                                                    n9: signInBtnLabelExplanation,
                                                                    oa: signInContentTitle,
                                                                    oc: signInHeadSubtitle,
                                                                    od: signInHeadTitle,
                                                                    of: signUpToContinue,
                                                                    og: signUpToContinueReason,
                                                                    oy: twitter
                                                                  };
                                                                };
                                                              };
                                                            };
                                                          };
                                                        };
                                                      };
                                                    };
                                                  };
                                                };
                                              };
                                            };
                                          };
                                        };
                                      };
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };

  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(function (pathDecoder, valDecoder, fallback) {
    var nullOr = function (decoder) {
      return $elm$json$Json$Decode$oneOf(_List_fromArray([decoder, $elm$json$Json$Decode$null(fallback)]));
    };

    var handleResult = function (input) {
      var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);

      if (!_v0.$) {
        var rawValue = _v0.a;

        var _v1 = A2($elm$json$Json$Decode$decodeValue, nullOr(valDecoder), rawValue);

        if (!_v1.$) {
          var finalResult = _v1.a;
          return $elm$json$Json$Decode$succeed(finalResult);
        } else {
          var finalErr = _v1.a;
          return $elm$json$Json$Decode$fail($elm$json$Json$Decode$errorToString(finalErr));
        }
      } else {
        return $elm$json$Json$Decode$succeed(fallback);
      }
    };

    return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
  });
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(function (key, valDecoder, fallback, decoder) {
    return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value), valDecoder, fallback), decoder);
  });
  var $author$project$Language$authDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'twitter', $elm$json$Json$Decode$string, $author$project$Language$authDefault.oy, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'google', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ly, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'facebook', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lk, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInBtnLabelExplanation', $elm$json$Json$Decode$string, $author$project$Language$authDefault.n9, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.n8, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'resendConfirmationCodeBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nK, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'confirmRegistrationSuccessMsg', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kK, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'confirmationCodeInputLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kL, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signUpToContinueReason', $elm$json$Json$Decode$string, $author$project$Language$authDefault.og, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signUpToContinue', $elm$json$Json$Decode$string, $author$project$Language$authDefault.of, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'chooseSignInMethodSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kE, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'chooseSignInMethodTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kF, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registrationVerificationLine2', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nI, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registrationVerificationLine1', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nH, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registrationVerificationTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nJ, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'newPasswordInputLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.mt, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lr, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordProvideCode', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ls, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lu, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lv, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'authSuccessSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kq, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'authSuccessTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kr, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'iAcceptTheTermsOfUse2', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lI, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'iAcceptTheTermsOfUse1', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lH, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerBtnLabelDescription', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ny, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nx, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerContentTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nz, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerHeadSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nC, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerHeadTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.nD, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInContentTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.oa, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInHeadSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.oc, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInHeadTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.od, $elm$json$Json$Decode$succeed($author$project$Language$AuthPhrases)))))))))))))))))))))))))))))))));
  var $author$project$Language$BasePhrases = F8(function (emailInputLabel, passwordInputLabel, submitBtnLabel, confirmBtnLabel, enablePushNotificationsLabel, enablePushNotificationsDescription, firstNameInputLabel, lastNameInputLabel) {
    return {
      kJ: confirmBtnLabel,
      k5: emailInputLabel,
      k8: enablePushNotificationsDescription,
      k9: enablePushNotificationsLabel,
      lp: firstNameInputLabel,
      l3: lastNameInputLabel,
      na: passwordInputLabel,
      op: submitBtnLabel
    };
  });
  var $author$project$Language$baseDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'lastNameInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.l3, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'firstNameInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.lp, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'enablePushNotificationsDescription', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.k8, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'enablePushNotificationsLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.k9, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'confirmBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.kJ, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'submitBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.op, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'passwordInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.na, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'emailInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.k5, $elm$json$Json$Decode$succeed($author$project$Language$BasePhrases)))))))));

  var $author$project$Language$CalendarPhrases = function (january) {
    return function (february) {
      return function (march) {
        return function (april) {
          return function (may) {
            return function (june) {
              return function (july) {
                return function (august) {
                  return function (september) {
                    return function (october) {
                      return function (november) {
                        return function (december) {
                          return function (january_short) {
                            return function (february_short) {
                              return function (march_short) {
                                return function (april_short) {
                                  return function (may_short) {
                                    return function (june_short) {
                                      return function (july_short) {
                                        return function (august_short) {
                                          return function (september_short) {
                                            return function (october_short) {
                                              return function (november_short) {
                                                return function (december_short) {
                                                  return {
                                                    kk: april,
                                                    kl: april_short,
                                                    kn: august,
                                                    ko: august_short,
                                                    kW: december,
                                                    kX: december_short,
                                                    ll: february,
                                                    lm: february_short,
                                                    lY: january,
                                                    lZ: january_short,
                                                    l_: july,
                                                    l$: july_short,
                                                    l0: june,
                                                    l1: june_short,
                                                    ml: march,
                                                    mm: march_short,
                                                    mo: may,
                                                    mp: may_short,
                                                    my: november,
                                                    mz: november_short,
                                                    mA: october,
                                                    mB: october_short,
                                                    n0: september,
                                                    n1: september_short
                                                  };
                                                };
                                              };
                                            };
                                          };
                                        };
                                      };
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };

  var $author$project$Language$calendarDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'december_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kX, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'november_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.mz, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'october_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.mB, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'september_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.n1, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'august_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.ko, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'july_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.l$, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'june_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.l1, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'may_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.mp, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'april_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kl, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'march_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.mm, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'february_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.lm, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'january_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.lZ, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'december', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kW, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'november', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.my, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'october', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.mA, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'september', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.n0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'august', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kn, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'july', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.l_, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'june', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.l0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'may', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.mo, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'april', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kk, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'march', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.ml, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'february', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.ll, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'january', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.lY, $elm$json$Json$Decode$succeed($author$project$Language$CalendarPhrases)))))))))))))))))))))))));
  var $author$project$Language$ChatPhrases = F2(function (receivedImage, personDoesNotAcceptMessages) {
    return {
      nf: personDoesNotAcceptMessages,
      nv: receivedImage
    };
  });
  var $author$project$Language$chatDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'personDoesNotAcceptMessages', $elm$json$Json$Decode$string, $author$project$Language$chatDefault.nf, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'receivedImage', $elm$json$Json$Decode$string, $author$project$Language$chatDefault.nv, $elm$json$Json$Decode$succeed($author$project$Language$ChatPhrases)));
  var $elm$core$Result$withDefault = F2(function (def, result) {
    if (!result.$) {
      var a = result.a;
      return a;
    } else {
      return def;
    }
  });
  var $author$project$Language$decodePhrasesGroup = F3(function (_default, decoder, commonFileStaticJsonString) {
    return A2($elm$core$Result$withDefault, _default, A2($author$project$ElmFramework$Lib$Util$decodeString, A2($elm$json$Json$Decode$field, 'phrases', decoder), commonFileStaticJsonString));
  });

  var $author$project$Language$toPhrases = function (staticFileJsonString) {
    return {
      u_: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$authDefault, $author$project$Language$authDecoder, staticFileJsonString),
      kt: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$baseDefault, $author$project$Language$baseDecoder, staticFileJsonString),
      kA: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$calendarDefault, $author$project$Language$calendarDecoder, staticFileJsonString),
      kD: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$chatDefault, $author$project$Language$chatDecoder, staticFileJsonString)
    };
  };

  var $author$project$Model$CommonStaticFile$decodeCommonStatic = function (staticJsonString) {
    return $elm$core$Result$Ok({
      Cq: $author$project$Language$toPhrases(staticJsonString),
      Em: staticJsonString
    });
  };

  var $author$project$ElmFramework$Lib$Util$resultToDecoder = function (res) {
    if (!res.$) {
      var decoded = res.a;
      return $elm$json$Json$Decode$succeed(decoded);
    } else {
      var err = res.a;
      return $elm$json$Json$Decode$fail(err);
    }
  };

  var $author$project$Model$CommonStaticFile$persistedCommonStaticDecoder = A3($elm$json$Json$Decode$map2, $author$project$Model$CommonStaticFile$LanguageDetailsWithCommonStaticFile, A2($elm$json$Json$Decode$field, 'language', $author$project$Model$CommonStaticFile$languageDetailsDecoder), A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Util$resultToDecoder, $author$project$Model$CommonStaticFile$decodeCommonStatic), A2($elm$json$Json$Decode$field, 'commonStaticFile', $elm$json$Json$Decode$string)));

  var $author$project$Model$CommonStaticFile$decodePersistedCommonStatic = function (string) {
    return A2($author$project$ElmFramework$Lib$Util$decodeString, $author$project$Model$CommonStaticFile$persistedCommonStaticDecoder, string);
  };

  var $author$project$Language$defaultLanguage = {
    kO: '🇬🇧',
    kQ: 'GB',
    zh: 'English',
    mi: 'English',
    D3: 'en'
  };
  var $elm$core$Result$map = F2(function (func, ra) {
    if (!ra.$) {
      var a = ra.a;
      return $elm$core$Result$Ok(func(a));
    } else {
      var e = ra.a;
      return $elm$core$Result$Err(e);
    }
  });

  var $author$project$Model$CommonStaticFile$toCommonStaticTuple = function (val) {
    return A2($elm$core$Result$withDefault, _Utils_Tuple2($author$project$Language$defaultLanguage, $author$project$Language$defaultPhrases), A2($elm$core$Result$map, function (_v0) {
      var language = _v0.l2;
      var commonStatic = _v0.v4;
      return _Utils_Tuple2(language, commonStatic.Cq);
    }, $author$project$Model$CommonStaticFile$decodePersistedCommonStatic(val)));
  };

  var $author$project$Model$ProgramArgs$ApiEndpoint = $elm$core$Basics$identity;

  var $author$project$Model$ProgramArgs$toConfig = function (configArgs) {
    return {
      oZ: configArgs.oZ,
      uK: configArgs.uK,
      xH: configArgs.xH,
      xL: {
        oY: configArgs.xL.oY
      },
      x$: {
        Cs: configArgs.x$.Cs
      },
      Cy: configArgs.Cy,
      EG: configArgs.EG
    };
  };

  var $author$project$Types$User$unwrapUserId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Global$Global$init = function (_v0) {
    var appArgs = _v0.uH;
    var theConfig = $author$project$Model$ProgramArgs$toConfig(appArgs.v9);

    var _v1 = function () {
      var _v2 = A2($author$project$Global$Global$decideCurrLanguage, appArgs.Cw, appArgs.Cp);

      var maybeChosenStaticFile = _v2.a;
      var persistCmd = _v2.b;
      return function (record) {
        return _Utils_Tuple2(record, persistCmd);
      }(A2($elm$core$Maybe$withDefault, {
        l2: $elm$core$Maybe$Nothing,
        Cq: $author$project$Language$defaultPhrases
      }, A2($elm$core$Maybe$map, function (_v3) {
        var lan = _v3.a;
        var thePhrases = _v3.b;
        return {
          l2: $elm$core$Maybe$Just($author$project$Global$Model$FromPersistence(lan)),
          Cq: thePhrases
        };
      }, A2($elm$core$Maybe$map, $author$project$Model$CommonStaticFile$toCommonStaticTuple, maybeChosenStaticFile))));
    }();

    var language = _v1.a.l2;
    var phrases = _v1.a.Cq;
    var persistCommonStaticCmd = _v1.b;
    return _Utils_Tuple2({
      gZ: $elm$core$Maybe$Nothing,
      dy: theConfig,
      kS: language,
      lS: $elm$core$Maybe$Nothing,
      y4: _List_fromArray([{
        kO: '🇪🇸',
        kQ: 'ES',
        zh: 'Spanish',
        mi: 'Español',
        D3: 'es'
      }, {
        kO: '🇬🇧',
        kQ: 'GB',
        zh: 'English',
        mi: 'English',
        D3: 'en'
      }, {
        kO: '🇲🇰',
        kQ: 'MK',
        zh: 'Macedonian',
        mi: 'Македонски',
        D3: 'mk'
      }]),
      l7: 2,
      rr: $elm$core$Maybe$Nothing,
      zt: $elm$core$Maybe$Nothing,
      Cq: phrases,
      nl: '',
      oC: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$User$unwrapUserId),
      gR: $elm$core$Maybe$Nothing
    }, $elm$core$Platform$Cmd$batch(_List_fromArray([persistCommonStaticCmd])));
  };

  var $author$project$PushMessages$PushMessages$init = {};
  var $krisajenkins$remotedata$RemoteData$NotAsked = {
    $: 0
  };

  var $author$project$Remote$Msg$ReceivedUserSessionStatusFromInit = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Remote$Model$Unauthenticated = {
    $: 0
  };
  var $author$project$Remote$Model$UserAuthenticating = {
    $: 1
  };
  var $elm$core$Task$onError = _Scheduler_onError;
  var $elm$core$Task$attempt = F2(function (resultToMessage, task) {
    return $elm$core$Task$command(A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), A2($elm$core$Task$andThen, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task)));
  });
  var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
  var $elm$core$Set$empty = $elm$core$Dict$empty;
  var $author$project$Types$UserSession$AuthRaw = F3(function (idToken, refreshToken, expiresIn) {
    return {
      hr: expiresIn,
      d5: idToken,
      e6: refreshToken
    };
  });

  var $author$project$Remote$Model$Authenticated = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Remote$Model$Onboarded = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$GetUserProfile = 9;
  var $author$project$ElmFramework$Lib$Firebase$Auth$GetUserProfileOutput = F5(function (userId, email, emailVerified, displayName, photoUrl) {
    return {
      k0: displayName,
      iP: email,
      xs: emailVerified,
      nh: photoUrl,
      oD: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ErrorBody = F2(function (statusCode, errorMessage) {
    return {
      qc: errorMessage,
      tG: statusCode
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ADMIN_ONLY_OPERATION = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$BLOCKING_FUNCTION_ERROR_RESPONSE = {
    $: 68
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CAPTCHA_CHECK_FAILED = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CORS_UNSUPPORTED = {
    $: 2
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_MISMATCH = {
    $: 3
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_TOO_OLD_LOGIN_AGAIN = {
    $: 4
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$DYNAMIC_LINK_NOT_ACTIVATED = {
    $: 5
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_CHANGE_NEEDS_VERIFICATION = {
    $: 6
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_EXISTS = {
    $: 7
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_NOT_FOUND = {
    $: 8
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EXPIRED_OOB_CODE = {
    $: 9
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$FEDERATED_USER_ID_ALREADY_LINKED = {
    $: 10
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_CREDENTIAL = {
    $: 11
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_ID = {
    $: 12
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CERT_HASH = {
    $: 13
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CODE = {
    $: 14
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CONTINUE_URI = {
    $: 15
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CUSTOM_TOKEN = {
    $: 16
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_DYNAMIC_LINK_DOMAIN = {
    $: 17
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_EMAIL = {
    $: 18
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDENTIFIER = {
    $: 21
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDP_RESPONSE = {
    $: 20
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_ID_TOKEN = {
    $: 19
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MESSAGE_PAYLOAD = {
    $: 22
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MFA_PENDING_CREDENTIAL = {
    $: 23
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OAUTH_CLIENT_ID = {
    $: 24
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OOB_CODE = {
    $: 25
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PASSWORD = {
    $: 26
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PENDING_TOKEN = {
    $: 27
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PHONE_NUMBER = {
    $: 28
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PROVIDER_ID = {
    $: 29
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_RECIPIENT_EMAIL = {
    $: 30
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SENDER = {
    $: 31
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SESSION_INFO = {
    $: 32
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TEMPORARY_PROOF = {
    $: 33
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TENANT_ID = {
    $: 34
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MFA_ENROLLMENT_NOT_FOUND = {
    $: 35
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_ANDROID_PACKAGE_NAME = {
    $: 36
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_APP_CREDENTIAL = {
    $: 37
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CODE = {
    $: 38
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CONTINUE_URI = {
    $: 39
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CUSTOM_TOKEN = {
    $: 40
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_IOS_BUNDLE_ID = {
    $: 41
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_ENROLLMENT_ID = {
    $: 42
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_PENDING_CREDENTIAL = {
    $: 43
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OOB_CODE = {
    $: 44
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OR_INVALID_NONCE = {
    $: 45
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PASSWORD = {
    $: 46
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PHONE_NUMBER = {
    $: 47
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_SESSION_INFO = {
    $: 48
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$OPERATION_NOT_ALLOWED = {
    $: 49
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$PASSWORD_LOGIN_DISABLED = {
    $: 50
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$QUOTA_EXCEEDED = {
    $: 51
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$REJECTED_CREDENTIAL = {
    $: 53
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$RESET_PASSWORD_EXCEED_LIMIT = {
    $: 52
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_EXISTS = {
    $: 54
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_LIMIT_EXCEEDED = {
    $: 55
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$SESSION_EXPIRED = {
    $: 56
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$TENANT_ID_MISMATCH = {
    $: 57
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$TOKEN_EXPIRED = {
    $: 58
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$TOO_MANY_ATTEMPTS_TRY_LATER = {
    $: 59
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNAUTHORIZED_DOMAIN = {
    $: 63
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$UNKNOWN_ERROR = function (a) {
    return {
      $: 69,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_FIRST_FACTOR = {
    $: 60
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_TENANT_OPERATION = {
    $: 61
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNVERIFIED_EMAIL = {
    $: 62
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$USER_CANCELLED = {
    $: 64
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$USER_DISABLED = {
    $: 65
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$USER_NOT_FOUND = {
    $: 66
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$WEAK_PASSWORD = {
    $: 67
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$decodeErrorCode = function (errorCode) {
    switch (errorCode) {
      case 'ADMIN_ONLY_OPERATION':
        return $author$project$ElmFramework$Lib$Firebase$Auth$ADMIN_ONLY_OPERATION;

      case 'CAPTCHA_CHECK_FAILED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CAPTCHA_CHECK_FAILED;

      case 'CORS_UNSUPPORTED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CORS_UNSUPPORTED;

      case 'CREDENTIAL_MISMATCH':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_MISMATCH;

      case 'CREDENTIAL_TOO_OLD_LOGIN_AGAIN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_TOO_OLD_LOGIN_AGAIN;

      case 'DYNAMIC_LINK_NOT_ACTIVATED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$DYNAMIC_LINK_NOT_ACTIVATED;

      case 'EMAIL_CHANGE_NEEDS_VERIFICATION':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_CHANGE_NEEDS_VERIFICATION;

      case 'EMAIL_EXISTS':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_EXISTS;

      case 'EMAIL_NOT_FOUND':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_NOT_FOUND;

      case 'EXPIRED_OOB_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EXPIRED_OOB_CODE;

      case 'FEDERATED_USER_ID_ALREADY_LINKED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$FEDERATED_USER_ID_ALREADY_LINKED;

      case 'INVALID_APP_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_CREDENTIAL;

      case 'INVALID_APP_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_ID;

      case 'INVALID_CERT_HASH':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CERT_HASH;

      case 'INVALID_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CODE;

      case 'INVALID_CONTINUE_URI':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CONTINUE_URI;

      case 'INVALID_CUSTOM_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CUSTOM_TOKEN;

      case 'INVALID_DYNAMIC_LINK_DOMAIN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_DYNAMIC_LINK_DOMAIN;

      case 'INVALID_EMAIL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_EMAIL;

      case 'INVALID_ID_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_ID_TOKEN;

      case 'INVALID_IDP_RESPONSE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDP_RESPONSE;

      case 'INVALID_IDENTIFIER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDENTIFIER;

      case 'INVALID_MESSAGE_PAYLOAD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MESSAGE_PAYLOAD;

      case 'INVALID_MFA_PENDING_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MFA_PENDING_CREDENTIAL;

      case 'INVALID_OAUTH_CLIENT_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OAUTH_CLIENT_ID;

      case 'INVALID_OOB_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OOB_CODE;

      case 'INVALID_PASSWORD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PASSWORD;

      case 'INVALID_PENDING_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PENDING_TOKEN;

      case 'INVALID_PHONE_NUMBER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PHONE_NUMBER;

      case 'INVALID_PROVIDER_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PROVIDER_ID;

      case 'INVALID_RECIPIENT_EMAIL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_RECIPIENT_EMAIL;

      case 'INVALID_SENDER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SENDER;

      case 'INVALID_SESSION_INFO':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SESSION_INFO;

      case 'INVALID_TEMPORARY_PROOF':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TEMPORARY_PROOF;

      case 'INVALID_TENANT_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TENANT_ID;

      case 'MFA_ENROLLMENT_NOT_FOUND':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MFA_ENROLLMENT_NOT_FOUND;

      case 'MISSING_ANDROID_PACKAGE_NAME':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_ANDROID_PACKAGE_NAME;

      case 'MISSING_APP_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_APP_CREDENTIAL;

      case 'MISSING_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CODE;

      case 'MISSING_CONTINUE_URI':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CONTINUE_URI;

      case 'MISSING_CUSTOM_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CUSTOM_TOKEN;

      case 'MISSING_IOS_BUNDLE_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_IOS_BUNDLE_ID;

      case 'MISSING_MFA_ENROLLMENT_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_ENROLLMENT_ID;

      case 'MISSING_MFA_PENDING_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_PENDING_CREDENTIAL;

      case 'MISSING_OOB_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OOB_CODE;

      case 'MISSING_OR_INVALID_NONCE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OR_INVALID_NONCE;

      case 'MISSING_PASSWORD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PASSWORD;

      case 'MISSING_PHONE_NUMBER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PHONE_NUMBER;

      case 'MISSING_SESSION_INFO':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_SESSION_INFO;

      case 'OPERATION_NOT_ALLOWED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$OPERATION_NOT_ALLOWED;

      case 'PASSWORD_LOGIN_DISABLED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$PASSWORD_LOGIN_DISABLED;

      case 'QUOTA_EXCEEDED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$QUOTA_EXCEEDED;

      case 'RESET_PASSWORD_EXCEED_LIMIT':
        return $author$project$ElmFramework$Lib$Firebase$Auth$RESET_PASSWORD_EXCEED_LIMIT;

      case 'REJECTED_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$REJECTED_CREDENTIAL;

      case 'SECOND_FACTOR_EXISTS':
        return $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_EXISTS;

      case 'SECOND_FACTOR_LIMIT_EXCEEDED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_LIMIT_EXCEEDED;

      case 'SESSION_EXPIRED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$SESSION_EXPIRED;

      case 'TENANT_ID_MISMATCH':
        return $author$project$ElmFramework$Lib$Firebase$Auth$TENANT_ID_MISMATCH;

      case 'TOKEN_EXPIRED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$TOKEN_EXPIRED;

      case 'TOO_MANY_ATTEMPTS_TRY_LATER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$TOO_MANY_ATTEMPTS_TRY_LATER;

      case 'UNSUPPORTED_FIRST_FACTOR':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_FIRST_FACTOR;

      case 'UNSUPPORTED_TENANT_OPERATION':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_TENANT_OPERATION;

      case 'UNVERIFIED_EMAIL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNVERIFIED_EMAIL;

      case 'UNAUTHORIZED_DOMAIN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNAUTHORIZED_DOMAIN;

      case 'USER_CANCELLED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$USER_CANCELLED;

      case 'USER_DISABLED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$USER_DISABLED;

      case 'USER_NOT_FOUND':
        return $author$project$ElmFramework$Lib$Firebase$Auth$USER_NOT_FOUND;

      case 'WEAK_PASSWORD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$WEAK_PASSWORD;

      case 'BLOCKING_FUNCTION_ERROR_RESPONSE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$BLOCKING_FUNCTION_ERROR_RESPONSE;

      default:
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNKNOWN_ERROR(errorCode);
    }
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$getErrorMessage = function (errorCode) {
    switch (errorCode.$) {
      case 0:
        return 'Admin only operation';

      case 1:
        return 'Captcha check failed';

      case 2:
        return 'Cors unsupported';

      case 3:
        return 'Credential mismatch';

      case 4:
        return 'Credential too old login again';

      case 5:
        return 'Dynamic link not activated';

      case 6:
        return 'Email change needs verification';

      case 7:
        return 'Email exists';

      case 8:
        return 'Email not found';

      case 9:
        return 'Expired oob code';

      case 10:
        return 'Federated user id already linked';

      case 11:
        return 'Invalid app credential';

      case 12:
        return 'Invalid app id';

      case 13:
        return 'Invalid cert hash';

      case 14:
        return 'Invalid code';

      case 15:
        return 'Invalid continue uri';

      case 16:
        return 'Invalid custom token';

      case 17:
        return 'Invalid dynamic link domain';

      case 18:
        return 'Invalid email';

      case 19:
        return 'Invalid id token';

      case 20:
        return 'Invalid idp response';

      case 21:
        return 'Invalid identifier';

      case 22:
        return 'Invalid message payload';

      case 23:
        return 'Invalid mfa pending credential';

      case 24:
        return 'Invalid oauth client id';

      case 25:
        return 'Invalid oob code';

      case 26:
        return 'Invalid password';

      case 27:
        return 'Invalid pending token';

      case 28:
        return 'Invalid phone number';

      case 29:
        return 'Invalid provider id';

      case 30:
        return 'Invalid recipient email';

      case 31:
        return 'Invalid sender';

      case 32:
        return 'Invalid session info';

      case 33:
        return 'Invalid temporary proof';

      case 34:
        return 'Invalid tenant id';

      case 35:
        return 'Mfa enrollment not found';

      case 36:
        return 'Missing android package name';

      case 37:
        return 'Missing app credential';

      case 38:
        return 'Missing code';

      case 39:
        return 'Missing continue uri';

      case 40:
        return 'Missing custom token';

      case 41:
        return 'Missing ios bundle id';

      case 42:
        return 'Missing mfa enrollment id';

      case 43:
        return 'Missing mfa pending credential';

      case 44:
        return 'Missing oob code';

      case 45:
        return 'Missing or invalid nonce';

      case 46:
        return 'Missing password';

      case 47:
        return 'Missing phone number';

      case 48:
        return 'Missing session info';

      case 49:
        return 'Operation not allowed';

      case 50:
        return 'Password login disabled';

      case 51:
        return 'Quota exceeded';

      case 52:
        return 'Reset password exceed limit';

      case 53:
        return 'Rejected credential';

      case 54:
        return 'Second factor exists';

      case 55:
        return 'Second factor limit exceeded';

      case 56:
        return 'Session expired';

      case 57:
        return 'Tenant id mismatch';

      case 58:
        return 'Token expired';

      case 59:
        return 'Too many attempts try later';

      case 60:
        return 'Unsupported first factor';

      case 61:
        return 'Unsupported tenant operation';

      case 62:
        return 'Unverified email';

      case 63:
        return 'Unauthorized domain';

      case 64:
        return 'User cancelled';

      case 65:
        return 'User disabled';

      case 66:
        return 'User not found';

      case 67:
        return 'Weak password';

      case 69:
        var error = errorCode.a;
        return error;

      default:
        return 'Our systems are taking longer than usual. Please try again.';
    }
  };

  var $elm$core$List$head = function (list) {
    if (list.b) {
      var x = list.a;
      var xs = list.b;
      return $elm$core$Maybe$Just(x);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$parseFullErrorMessage = function (error) {
    if (error === 'Error code: 47') {
      return 'There was an error while signing you in. Please try again later or contact Puffin support.';
    } else {
      return error;
    }
  };

  var $elm$core$String$words = _String_words;

  var $author$project$ElmFramework$Lib$Firebase$Auth$parseError = function (fullError) {
    var words = $elm$core$String$words(fullError);

    var maybeAdditionalInfo = function (maybeSecondWord) {
      if (!maybeSecondWord.$) {
        var secondWord = maybeSecondWord.a;
        return secondWord === ':' ? $elm$core$Maybe$Just(A2($elm$core$String$join, ' ', A2($elm$core$List$drop, 2, words))) : $elm$core$Maybe$Nothing;
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }($elm$core$List$head(A2($elm$core$List$drop, 1, words)));

    var errorCode = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(words));

    if (!maybeAdditionalInfo.$) {
      var errorText = maybeAdditionalInfo.a;
      return errorText;
    } else {
      var _v1 = $author$project$ElmFramework$Lib$Firebase$Auth$decodeErrorCode(errorCode);

      if (_v1.$ === 69) {
        return $author$project$ElmFramework$Lib$Firebase$Auth$parseFullErrorMessage(fullError);
      } else {
        return $author$project$ElmFramework$Lib$Firebase$Auth$getErrorMessage($author$project$ElmFramework$Lib$Firebase$Auth$decodeErrorCode(errorCode));
      }
    }
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$handleJsonResponse = F2(function (decoder, response) {
    switch (response.$) {
      case 0:
        var url = response.a;
        return $elm$core$Result$Err('Bad url: ' + url);

      case 1:
        return $elm$core$Result$Err('Timeout');

      case 3:
        var statusCode = response.a.tG;
        var body = response.b;

        var errorBodyMessage = function (errorBodyDecodedResult) {
          if (!errorBodyDecodedResult.$) {
            var errorMessage = errorBodyDecodedResult.a.qc;
            return errorMessage;
          } else {
            return 'Unknown error, bad status: ' + $elm$core$String$fromInt(statusCode);
          }
        };

        var errorBodyDecoder = A2($elm$json$Json$Decode$field, 'error', A3($elm$json$Json$Decode$map2, $author$project$ElmFramework$Lib$Firebase$Auth$ErrorBody, A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$map, $author$project$ElmFramework$Lib$Firebase$Auth$parseError, A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string))));
        var errorBodyString = errorBodyMessage(A2($elm$json$Json$Decode$decodeString, errorBodyDecoder, body));
        return $elm$core$Result$Err(errorBodyString);

      case 2:
        return $elm$core$Result$Err('Network error');

      default:
        var body = response.b;

        var _v2 = A2($elm$json$Json$Decode$decodeString, decoder, body);

        if (_v2.$ === 1) {
          return $elm$core$Result$Err('Failed to decode server\'s json response');
        } else {
          var decodedResponse = _v2.a;
          return $elm$core$Result$Ok(decodedResponse);
        }

    }
  });
  var $elm$http$Http$BadStatus_ = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });

  var $elm$http$Http$BadUrl_ = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$http$Http$GoodStatus_ = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$NetworkError_ = {
    $: 2
  };

  var $elm$http$Http$Receiving = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$http$Http$Sending = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$http$Http$Timeout_ = {
    $: 1
  };

  var $elm$core$Maybe$isJust = function (maybe) {
    if (!maybe.$) {
      return true;
    } else {
      return false;
    }
  };

  var $elm$core$Dict$getMin = function (dict) {
    getMin: while (true) {
      if (dict.$ === -1 && dict.d.$ === -1) {
        var left = dict.d;
        var $temp$dict = left;
        dict = $temp$dict;
        continue getMin;
      } else {
        return dict;
      }
    }
  };

  var $elm$core$Dict$moveRedLeft = function (dict) {
    if (dict.$ === -1 && dict.d.$ === -1 && dict.e.$ === -1) {
      if (dict.e.d.$ === -1 && !dict.e.d.a) {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v1 = dict.d;
        var lClr = _v1.a;
        var lK = _v1.b;
        var lV = _v1.c;
        var lLeft = _v1.d;
        var lRight = _v1.e;
        var _v2 = dict.e;
        var rClr = _v2.a;
        var rK = _v2.b;
        var rV = _v2.c;
        var rLeft = _v2.d;
        var _v3 = rLeft.a;
        var rlK = rLeft.b;
        var rlV = rLeft.c;
        var rlL = rLeft.d;
        var rlR = rLeft.e;
        var rRight = _v2.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, rlK, rlV, A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), rlL), A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
      } else {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v4 = dict.d;
        var lClr = _v4.a;
        var lK = _v4.b;
        var lV = _v4.c;
        var lLeft = _v4.d;
        var lRight = _v4.e;
        var _v5 = dict.e;
        var rClr = _v5.a;
        var rK = _v5.b;
        var rV = _v5.c;
        var rLeft = _v5.d;
        var rRight = _v5.e;

        if (clr === 1) {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        }
      }
    } else {
      return dict;
    }
  };

  var $elm$core$Dict$moveRedRight = function (dict) {
    if (dict.$ === -1 && dict.d.$ === -1 && dict.e.$ === -1) {
      if (dict.d.d.$ === -1 && !dict.d.d.a) {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v1 = dict.d;
        var lClr = _v1.a;
        var lK = _v1.b;
        var lV = _v1.c;
        var _v2 = _v1.d;
        var _v3 = _v2.a;
        var llK = _v2.b;
        var llV = _v2.c;
        var llLeft = _v2.d;
        var llRight = _v2.e;
        var lRight = _v1.e;
        var _v4 = dict.e;
        var rClr = _v4.a;
        var rK = _v4.b;
        var rV = _v4.c;
        var rLeft = _v4.d;
        var rRight = _v4.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, lRight, A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
      } else {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v5 = dict.d;
        var lClr = _v5.a;
        var lK = _v5.b;
        var lV = _v5.c;
        var lLeft = _v5.d;
        var lRight = _v5.e;
        var _v6 = dict.e;
        var rClr = _v6.a;
        var rK = _v6.b;
        var rV = _v6.c;
        var rLeft = _v6.d;
        var rRight = _v6.e;

        if (clr === 1) {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        }
      }
    } else {
      return dict;
    }
  };

  var $elm$core$Dict$removeHelpPrepEQGT = F7(function (targetKey, dict, color, key, value, left, right) {
    if (left.$ === -1 && !left.a) {
      var _v1 = left.a;
      var lK = left.b;
      var lV = left.c;
      var lLeft = left.d;
      var lRight = left.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, color, lK, lV, lLeft, A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
    } else {
      _v2$2: while (true) {
        if (right.$ === -1 && right.a === 1) {
          if (right.d.$ === -1) {
            if (right.d.a === 1) {
              var _v3 = right.a;
              var _v4 = right.d;
              var _v5 = _v4.a;
              return $elm$core$Dict$moveRedRight(dict);
            } else {
              break _v2$2;
            }
          } else {
            var _v6 = right.a;
            var _v7 = right.d;
            return $elm$core$Dict$moveRedRight(dict);
          }
        } else {
          break _v2$2;
        }
      }

      return dict;
    }
  });

  var $elm$core$Dict$removeMin = function (dict) {
    if (dict.$ === -1 && dict.d.$ === -1) {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var lColor = left.a;
      var lLeft = left.d;
      var right = dict.e;

      if (lColor === 1) {
        if (lLeft.$ === -1 && !lLeft.a) {
          var _v3 = lLeft.a;
          return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
        } else {
          var _v4 = $elm$core$Dict$moveRedLeft(dict);

          if (_v4.$ === -1) {
            var nColor = _v4.a;
            var nKey = _v4.b;
            var nValue = _v4.c;
            var nLeft = _v4.d;
            var nRight = _v4.e;
            return A5($elm$core$Dict$balance, nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
          } else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
          }
        }
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
      }
    } else {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    }
  };

  var $elm$core$Dict$removeHelp = F2(function (targetKey, dict) {
    if (dict.$ === -2) {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    } else {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;

      if (_Utils_cmp(targetKey, key) < 0) {
        if (left.$ === -1 && left.a === 1) {
          var _v4 = left.a;
          var lLeft = left.d;

          if (lLeft.$ === -1 && !lLeft.a) {
            var _v6 = lLeft.a;
            return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
          } else {
            var _v7 = $elm$core$Dict$moveRedLeft(dict);

            if (_v7.$ === -1) {
              var nColor = _v7.a;
              var nKey = _v7.b;
              var nValue = _v7.c;
              var nLeft = _v7.d;
              var nRight = _v7.e;
              return A5($elm$core$Dict$balance, nColor, nKey, nValue, A2($elm$core$Dict$removeHelp, targetKey, nLeft), nRight);
            } else {
              return $elm$core$Dict$RBEmpty_elm_builtin;
            }
          }
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
        }
      } else {
        return A2($elm$core$Dict$removeHelpEQGT, targetKey, A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
      }
    }
  });
  var $elm$core$Dict$removeHelpEQGT = F2(function (targetKey, dict) {
    if (dict.$ === -1) {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;

      if (_Utils_eq(targetKey, key)) {
        var _v1 = $elm$core$Dict$getMin(right);

        if (_v1.$ === -1) {
          var minKey = _v1.b;
          var minValue = _v1.c;
          return A5($elm$core$Dict$balance, color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
        } else {
          return $elm$core$Dict$RBEmpty_elm_builtin;
        }
      } else {
        return A5($elm$core$Dict$balance, color, key, value, left, A2($elm$core$Dict$removeHelp, targetKey, right));
      }
    } else {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    }
  });
  var $elm$core$Dict$remove = F2(function (key, dict) {
    var _v0 = A2($elm$core$Dict$removeHelp, key, dict);

    if (_v0.$ === -1 && !_v0.a) {
      var _v1 = _v0.a;
      var k = _v0.b;
      var v = _v0.c;
      var l = _v0.d;
      var r = _v0.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
    } else {
      var x = _v0;
      return x;
    }
  });
  var $elm$core$Dict$update = F3(function (targetKey, alter, dictionary) {
    var _v0 = alter(A2($elm$core$Dict$get, targetKey, dictionary));

    if (!_v0.$) {
      var value = _v0.a;
      return A3($elm$core$Dict$insert, targetKey, value, dictionary);
    } else {
      return A2($elm$core$Dict$remove, targetKey, dictionary);
    }
  });
  var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);

  var $author$project$ElmFramework$Lib$Firebase$Auth$createHttpJsonResolver = function (decoder) {
    return $elm$http$Http$stringResolver($author$project$ElmFramework$Lib$Firebase$Auth$handleJsonResponse(decoder));
  };

  var $elm$http$Http$jsonBody = function (value) {
    return A2(_Http_pair, 'application/json', A2($elm$json$Json$Encode$encode, 0, value));
  };

  var $author$project$Util$Retry$default = {
    lR: 15.0 * 1000,
    h4: 3
  };
  var $elm$core$Task$fail = _Scheduler_fail;
  var $author$project$Util$Retry$onError = F4(function (config, errorFn, task, error) {
    if (errorFn(error) && config.h4 > 0) {
      var next = A2($elm$core$Task$onError, A3($author$project$Util$Retry$onError, _Utils_update(config, {
        h4: config.h4 - 1
      }), errorFn, task), task);
      return A2($elm$core$Task$andThen, $elm$core$Basics$always(next), $elm$core$Process$sleep(config.lR));
    } else {
      return $elm$core$Task$fail(error);
    }
  });
  var $author$project$Util$Retry$retryWith = F3(function (config, errorFn, task) {
    return A2($elm$core$Task$onError, A3($author$project$Util$Retry$onError, config, errorFn, task), task);
  });

  var $author$project$Util$Retry$shouldRetryAuthError = function (error) {
    return A2($elm$core$String$contains, 'Cloud function deadline exceeded.', error) ? true : false;
  };

  var $author$project$Util$Retry$retryAuth = A2($author$project$Util$Retry$retryWith, $author$project$Util$Retry$default, $author$project$Util$Retry$shouldRetryAuthError);

  var $elm$http$Http$resultToTask = function (result) {
    if (!result.$) {
      var a = result.a;
      return $elm$core$Task$succeed(a);
    } else {
      var x = result.a;
      return $elm$core$Task$fail(x);
    }
  };

  var $elm$http$Http$task = function (r) {
    return A3(_Http_toTask, 0, $elm$http$Http$resultToTask, {
      uF: false,
      d0: r.d0,
      xD: r.C$,
      x5: r.x5,
      zw: r.zw,
      ow: r.ow,
      t8: $elm$core$Maybe$Nothing,
      Fh: r.Fh
    });
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask = F3(function (url, requestEncoder, responseDecoder) {
    return $author$project$Util$Retry$retryAuth($elm$http$Http$task({
      d0: $elm$http$Http$jsonBody(requestEncoder),
      x5: _List_Nil,
      zw: 'POST',
      C$: $author$project$ElmFramework$Lib$Firebase$Auth$createHttpJsonResolver(responseDecoder),
      ow: $elm$core$Maybe$Nothing,
      Fh: url
    }));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl = F2(function (apiKey, action) {
    var tokenUrl = 'https://securetoken.googleapis.com/v1';

    var makeTokenUrl = function (actionKey) {
      return tokenUrl + ('/' + actionKey);
    };

    var identityUrl = 'https://identitytoolkit.googleapis.com/v1';

    var makeIdentityUrl = function (actionKey) {
      return identityUrl + ('/' + actionKey);
    };

    var actionUrl = function () {
      switch (action) {
        case 0:
          return makeIdentityUrl('accounts:signUp');

        case 9:
          return makeIdentityUrl('accounts:lookup');

        case 10:
          return makeIdentityUrl('accounts:update');

        case 1:
          return makeIdentityUrl('accounts:signInWithPassword');

        case 2:
          return makeIdentityUrl('accounts:sendOobCode');

        case 3:
          return makeIdentityUrl('accounts:update');

        case 4:
          return makeIdentityUrl('accounts:sendOobCode');

        case 5:
          return makeIdentityUrl('accounts:resetPassword');

        case 7:
          return makeIdentityUrl('accounts:resetPassword');

        case 8:
          return makeIdentityUrl('accounts:update');

        case 6:
          return makeIdentityUrl('accounts:resetPassword');

        default:
          return makeTokenUrl('token');
      }
    }();

    return actionUrl + ('?key=' + apiKey);
  });

  var $elm$json$Json$Decode$maybe = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder), $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)]));
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$getUserProfile = F2(function (apiKey, _v0) {
    var idToken = _v0.d5;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 9);
    var responseDecoder = A2($elm$json$Json$Decode$andThen, function (user) {
      if (user.$ === 1) {
        return $elm$json$Json$Decode$fail('No user found for the id token');
      } else {
        var u = user.a;
        return $elm$json$Json$Decode$succeed(u);
      }
    }, A2($elm$json$Json$Decode$map, $elm$core$List$head, A2($elm$json$Json$Decode$field, 'users', $elm$json$Json$Decode$list(A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$GetUserProfileOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'photoUrl', $elm$json$Json$Decode$string)))))));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Types$UserSession$IdToken = $elm$core$Basics$identity;
  var $author$project$Types$User$UserId = $elm$core$Basics$identity;

  var $elm$json$Json$Decode$nullable = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)]));
  };

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(function (fieldName, args, fields) {
    return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(function (shift, seed, hash, charsProcessed) {
    return {
      fH: charsProcessed,
      lB: hash,
      e9: seed,
      gC: shift
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(function (b, a) {
    return (a & 65535) * b + (((a >>> 16) * b & 65535) << 16);
  });
  var $elm$core$Bitwise$or = _Bitwise_or;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(function (b, a) {
    return a << b | a >>> 32 - b;
  });
  var $elm$core$Bitwise$xor = _Bitwise_xor;

  var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
    var acc = !!data.lB ? data.e9 ^ A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c2, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy, 15, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.lB))) : data.e9;
    var h0 = acc ^ data.fH;
    var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ h0 >>> 16);
    var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ h1 >>> 13);
    return (h2 ^ h2 >>> 16) >>> 0;
  };

  var $elm$core$String$foldl = _String_foldl;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(function (h1, k1) {
    return A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 5, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy, 13, h1 ^ A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c2, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy, 15, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(function (c, data) {
    var res = data.lB | (255 & $elm$core$Char$toCode(c)) << data.gC;
    var _v0 = data.gC;

    if (_v0 === 24) {
      return {
        fH: data.fH + 1,
        lB: 0,
        e9: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.e9, res),
        gC: 0
      };
    } else {
      return {
        fH: data.fH + 1,
        lB: res,
        e9: data.e9,
        gC: data.gC + 8
      };
    }
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(function (seed, str) {
    return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(A3($elm$core$String$foldl, $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold, A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0), str));
  });

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
    switch (value.$) {
      case 0:
        var enumValue = value.a;
        return enumValue;

      case 1:
        var json = value.a;
        return A2($elm$json$Json$Encode$encode, 0, json);

      case 2:
        var values = value.a;
        return '[' + (A2($elm$core$String$join, ', ', A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');

      default:
        var keyValuePairs = value.a;
        return '{' + (A2($elm$core$String$join, ', ', A2($elm$core$List$map, function (_v1) {
          var key = _v1.a;
          var objectValue = _v1.b;
          return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
        }, keyValuePairs)) + '}');
    }
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
    var name = _v0.a;
    var value = _v0.b;
    return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
    if (!args.b) {
      return '';
    } else {
      var nonemptyArgs = args;
      return '(' + (A2($elm$core$String$join, ', ', A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
    }
  };

  var $elm$core$List$singleton = function (value) {
    return _List_fromArray([value]);
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
    return A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0), function () {
      if (!field.$) {
        var name = field.a;
        var _arguments = field.b;
        var children = field.c;
        return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
      } else {
        var typeString = field.a.Fc;
        var fieldName = field.a.qm;
        var _arguments = field.b;
        return fieldName === '__typename' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($elm$core$String$concat(A2($elm$core$List$append, _List_fromArray([typeString]), $elm$core$List$singleton($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
      }
    }());
  };

  var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
    if (!field.$) {
      var fieldName = field.a;
      var argumentList = field.b;
      var fieldList = field.c;
      return fieldName;
    } else {
      var typeString = field.a.Fc;
      var fieldName = field.a.qm;
      var argumentList = field.b;
      return fieldName;
    }
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
    return A2($elm$core$Maybe$map, function (aliasHash) {
      return _Utils_ap($dillonkearns$elm_graphql$Graphql$RawField$name(field), $elm$core$String$fromInt(aliasHash));
    }, $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
    return A2($elm$core$Maybe$withDefault, $dillonkearns$elm_graphql$Graphql$RawField$name(field), $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(function (fieldName, args, _v0, decoderTransform) {
    var fields = _v0.a;
    var decoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)]), A2($elm$json$Json$Decode$field, $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)), decoderTransform(decoder)));
  });

  var $author$project$Api$GraphqlSchema$Object$CurrentUserPayloadSuccess$auth = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'auth', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(function (fragmentTypeName, _v0) {
    var fields = _v0.a;
    var decoder = _v0.b;
    return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
  });
  var $elm$core$String$dropRight = F2(function (n, string) {
    return n < 1 ? string : A3($elm$core$String$slice, 0, -n, string);
  });
  var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(function (replacements, _v0) {
    var match = _v0.zk;
    var ordinalString = A2($elm$core$Basics$composeL, $elm$core$String$dropLeft(1), $elm$core$String$dropRight(1))(match);
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, function (value) {
      return A2($elm$core$Array$get, value, replacements);
    }, $elm$core$String$toInt(ordinalString)));
  });
  var $elm$regex$Regex$Match = F4(function (match, index, number, submatches) {
    return {
      lP: index,
      zk: match,
      rE: number,
      Eu: submatches
    };
  });
  var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;

  var $elm$regex$Regex$fromString = function (string) {
    return A2($elm$regex$Regex$fromStringWith, {
      vK: false,
      zK: false
    }, string);
  };

  var $elm$regex$Regex$never = _Regex_never;
  var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $elm$regex$Regex$fromString('\\{\\d+\\}'));

  var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);

  var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(function (string, args) {
    var asArray = $elm$core$Array$fromList(args);
    return A3($elm$regex$Regex$replace, $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex, $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray), string);
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(function (typeSpecificSelections, typeName) {
    return A2($lukewestby$elm_string_interpolate$String$Interpolate$interpolate, 'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?', _List_fromArray([typeName, A2($elm$core$String$join, ', ', A2($elm$core$List$map, function (_v0) {
      var fragmentType = _v0.a;
      var fields = _v0.b;
      var decoder = _v0.c;
      return fragmentType;
    }, typeSpecificSelections))]));
  });
  var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, {
    qm: '__typename',
    Fc: ''
  }, _List_Nil);

  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
    var selections = A2($elm$core$List$map, function (_v1) {
      var typeName = _v1.a;
      var fields = _v1.b;
      var decoder = _v1.c;
      return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
    }, typeSpecificSelections);
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections), A2($elm$json$Json$Decode$andThen, function (typeName) {
      return A2($elm$core$Maybe$withDefault, $elm$json$Json$Decode$fail(A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)), A2($elm$core$Dict$get, typeName, $elm$core$Dict$fromList(A2($elm$core$List$map, function (_v0) {
        var thisTypeName = _v0.a;
        var fields = _v0.b;
        var decoder = _v0.c;
        return _Utils_Tuple2(thisTypeName, decoder);
      }, typeSpecificSelections))));
    }, A2($elm$json$Json$Decode$field, $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename), $elm$json$Json$Decode$string)));
  };

  var $author$project$Api$GraphqlSchema$Union$CurrentUserPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CurrentUserPayloadSuccess', selections____.Av), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IdentityUndefinedError', selections____.mK)]));
  };

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(function (mapFunction, _v0) {
    var selectionFields = _v0.a;
    var selectionDecoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, selectionFields, A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
  });
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$empty = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_Nil, $elm$json$Json$Decode$succeed(0));
  var $author$project$Api$GraphqlSchema$Union$CurrentUserPayload$maybeFragments = {
    Av: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
      return $elm$core$Maybe$Nothing;
    }, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
    mK: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v1) {
      return $elm$core$Maybe$Nothing;
    }, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty)
  };

  var $author$project$Api$GraphqlSchema$Query$me = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'me', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;

  var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($elm$json$Json$Decode$field, 'data', decoder_);
  };

  var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(function (baseUrl, query) {
    return {
      g4: baseUrl,
      wJ: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
      xD: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
      x5: _List_Nil,
      gs: $elm$core$Maybe$Nothing,
      h$: _List_Nil,
      ow: $elm$core$Maybe$Nothing,
      fi: false
    };
  });
  var $elm$http$Http$Header = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$header = $elm$http$Http$Header;
  var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(function (key, value, _v0) {
    var request = _v0;
    return _Utils_update(request, {
      x5: A2($elm$core$List$cons, A2($elm$http$Http$header, key, value), request.x5)
    });
  });
  var $author$project$Api$Api$requestCore = F4(function (requester, _v0, maybeIdToken, query) {
    var apiEndpoint = _v0;

    var withAccessToken = function (theQuery) {
      return A2($elm$core$Maybe$withDefault, theQuery, A2($elm$core$Maybe$map, function (_v1) {
        var token = _v1;
        return A3($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'Authorization', 'Bearer ' + token, theQuery);
      }, maybeIdToken));
    };

    return withAccessToken(A2(requester, apiEndpoint, query));
  });

  var $author$project$Util$Retry$shouldRetryGraphQlError = function (error) {
    if (error.$ === 1) {
      var err = error.a;

      if (err.$ === 3) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  var $author$project$Util$Retry$retryApi = A2($author$project$Util$Retry$retryWith, $author$project$Util$Retry$default, $author$project$Util$Retry$shouldRetryGraphQlError);

  var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors = function (successOrError) {
    if (!successOrError.$) {
      var value = successOrError.a;
      return $elm$core$Task$succeed(value);
    } else {
      var _v1 = successOrError.a;
      var possiblyParsedData = _v1.a;
      var graphqlErrorGraphqlErrorList = _v1.b;
      return $elm$core$Task$fail(A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, graphqlErrorGraphqlErrorList));
    }
  };

  var $elm$core$Task$mapError = F2(function (convert, task) {
    return A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert), task);
  });

  var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });

  var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {
    $: 2
  };
  var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {
    $: 1
  };

  var $dillonkearns$elm_graphql$Graphql$Http$jsonResolver = function (decoder) {
    return $elm$http$Http$stringResolver(function (response) {
      switch (response.$) {
        case 0:
          var url = response.a;
          return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));

        case 1:
          return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);

        case 2:
          return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);

        case 3:
          var metadata = response.a;
          var body = response.b;
          return $elm$core$Result$Err(A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));

        default:
          var metadata = response.a;
          var body = response.b;

          var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);

          if (!_v1.$) {
            var value = _v1.a;
            return $elm$core$Result$Ok(value);
          } else {
            var err = _v1.a;
            return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
          }

      }
    });
  };

  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
  var $elm$http$Http$emptyBody = _Http_emptyBody;
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;

  var $dillonkearns$elm_graphql$Graphql$Document$Indent$spaces = function (n) {
    return n > 0 ? ' ' + $dillonkearns$elm_graphql$Graphql$Document$Indent$spaces(n - 1) : '';
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
    return $dillonkearns$elm_graphql$Graphql$Document$Indent$spaces(indentationLevel * 2);
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
    return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
  };

  var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F3(function (aliasName, mIndentationLevel, field) {
    var prefix = function () {
      if (!aliasName.$) {
        var aliasName_ = aliasName.a;
        return _Utils_ap(aliasName_, function () {
          if (!mIndentationLevel.$) {
            return ': ';
          } else {
            return ':';
          }
        }());
      } else {
        return '';
      }
    }();

    return A2($elm$core$Maybe$map, function (string) {
      return _Utils_ap($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)), _Utils_ap(prefix, string));
    }, function () {
      if (!field.$) {
        var fieldName = field.a;
        var args = field.b;
        var children = field.c;

        if (mIndentationLevel.$ === 1) {
          return $elm$core$Maybe$Just(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, children))) + '}');
        } else {
          var indentationLevel = mIndentationLevel.a;
          return $elm$core$Maybe$Just(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Just(indentationLevel), children))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
        }
      } else {
        var fieldName = field.a.qm;
        var args = field.b;
        return $elm$core$Maybe$Just(_Utils_ap(fieldName, $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
      }
    }());
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(function (indentationLevel, children) {
    return A2($elm$core$String$join, function () {
      if (!indentationLevel.$) {
        return '\n';
      } else {
        return ' ';
      }
    }(), A2($elm$core$List$filterMap, $elm$core$Basics$identity, A2($elm$core$List$map, function (field) {
      return A3($dillonkearns$elm_graphql$Graphql$Document$Field$serialize, $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field), A2($elm$core$Maybe$map, $elm$core$Basics$add(1), indentationLevel), field);
    }, $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(children))));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(function (operationType, queries) {
    return A2($lukewestby$elm_string_interpolate$String$Interpolate$interpolate, '{0} {\n{1}\n}', _List_fromArray([operationType, A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Just(0), queries)]));
  });

  var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
  };

  var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
  };

  var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(function (operationName, _v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(function (operationType, operationName, queries) {
    return A2($lukewestby$elm_string_interpolate$String$Interpolate$interpolate, '{0} {1} {\n{2}\n}', _List_fromArray([operationType, operationName, A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Just(0), queries)]));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(function (operationName, _v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
  });
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(function (old, _new) {
    return A2($elm$core$Basics$composeR, $elm$core$String$split(old), $elm$core$String$join(_new));
  });
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2($elm$core$Basics$composeR, $elm$url$Url$percentEncode, A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));

  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
    var key = _v0.a;
    var value = _v0.b;
    return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
    return A2($elm$core$String$join, '&', A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(function (queryParams, url) {
    return $elm$core$List$isEmpty(queryParams) ? url : url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams));
  });
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
    var _v0 = function () {
      if (!maybeOperationName.$) {
        var operationName = maybeOperationName.a;
        return _Utils_Tuple2(A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument), _List_fromArray([_Utils_Tuple2('operationName', operationName)]));
      } else {
        return _Utils_Tuple2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument), _List_Nil);
      }
    }();

    var serializedQueryForGetRequest = _v0.a;
    var operationNameParamForGetRequest = _v0.b;
    var urlForGetRequest = A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, _Utils_ap(queryParams, _Utils_ap(_List_fromArray([_Utils_Tuple2('query', serializedQueryForGetRequest)]), operationNameParamForGetRequest)), url);

    if (_Utils_eq(forceMethod, $elm$core$Maybe$Just(1)) || _Utils_cmp($elm$core$String$length(urlForGetRequest), $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1 && !_Utils_eq(forceMethod, $elm$core$Maybe$Just(0))) {
      var _v2 = function () {
        if (!maybeOperationName.$) {
          var operationName = maybeOperationName.a;
          return _Utils_Tuple2(A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument), _List_fromArray([_Utils_Tuple2('operationName', $elm$json$Json$Encode$string(operationName))]));
        } else {
          return _Utils_Tuple2($dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument), _List_Nil);
        }
      }();

      var serializedQuery = _v2.a;
      var operationNameParamForPostRequest = _v2.b;
      return {
        d0: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_Utils_ap(_List_fromArray([_Utils_Tuple2('query', $elm$json$Json$Encode$string(serializedQuery))]), operationNameParamForPostRequest))),
        zw: 1,
        Fh: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, _List_Nil, url)
      };
    } else {
      return {
        d0: $elm$http$Http$emptyBody,
        zw: 0,
        Fh: urlForGetRequest
      };
    }
  });

  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(function (message, locations, details) {
    return {
      wJ: details,
      zg: locations,
      zu: message
    };
  });
  var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;

  var $elm$json$Json$Decode$dict = function (decoder) {
    return A2($elm$json$Json$Decode$map, $elm$core$Dict$fromList, $elm$json$Json$Decode$keyValuePairs(decoder));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(function (line, column) {
    return {
      v$: column,
      ri: line
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3($elm$json$Json$Decode$map2, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location, A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
  var $elm$json$Json$Decode$map3 = _Json_map3;
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2($elm$json$Json$Decode$field, 'errors', $elm$json$Json$Decode$list(A4($elm$json$Json$Decode$map3, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError, A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'locations', $elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))), A2($elm$json$Json$Decode$map, $elm$core$Dict$remove('locations'), A2($elm$json$Json$Decode$map, $elm$core$Dict$remove('message'), $elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));

  var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
    return A2($elm$json$Json$Decode$map, $elm$core$Result$Err, A2($elm$json$Json$Decode$map, $elm$core$Tuple$pair(data), $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
    nullJsonValue: while (true) {
      var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');

      if (!_v0.$) {
        var value = _v0.a;
        return value;
      } else {
        var $temp$a = 0;
        a = $temp$a;
        continue nullJsonValue;
      }
    }
  };

  var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$andThen, $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData, A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)), A2($elm$json$Json$Decode$andThen, $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData, A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData, A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))), A2($elm$json$Json$Decode$andThen, $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData, $elm$json$Json$Decode$succeed($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData($dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))]));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder), A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)]));
  };

  var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
  };

  var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(function (operationName, _v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
  });

  var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
    var request = _v0;
    var _v1 = request.wJ;

    if (!_v1.$) {
      var forcedRequestMethod = _v1.a;
      var querySelectionSet = _v1.b;
      var queryRequestDetails = A5($dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build, function () {
        if (!forcedRequestMethod.$) {
          if (!forcedRequestMethod.a) {
            var _v4 = forcedRequestMethod.a;
            return $elm$core$Maybe$Just(0);
          } else {
            var _v5 = forcedRequestMethod.a;
            return $elm$core$Maybe$Nothing;
          }
        } else {
          return $elm$core$Maybe$Just(1);
        }
      }(), request.g4, request.h$, request.gs, querySelectionSet);
      return {
        d0: queryRequestDetails.d0,
        wB: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.xD),
        x5: request.x5,
        zw: function () {
          var _v2 = queryRequestDetails.zw;

          if (!_v2) {
            return 'GET';
          } else {
            return 'Post';
          }
        }(),
        ow: request.ow,
        Fh: queryRequestDetails.Fh
      };
    } else {
      var mutationSelectionSet = _v1.a;

      var serializedMutation = function () {
        var _v6 = request.gs;

        if (!_v6.$) {
          var operationName = _v6.a;
          return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
        } else {
          return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
        }
      }();

      return {
        d0: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('query', $elm$json$Json$Encode$string(serializedMutation))]))),
        wB: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.xD),
        x5: request.x5,
        zw: 'POST',
        ow: request.ow,
        Fh: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.h$, request.g4)
      };
    }
  };

  var $dillonkearns$elm_graphql$Graphql$Http$resolver = function (request) {
    return $dillonkearns$elm_graphql$Graphql$Http$jsonResolver($dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(request).wB);
  };

  var $elm$http$Http$riskyTask = function (r) {
    return A3(_Http_toTask, 0, $elm$http$Http$resultToTask, {
      uF: true,
      d0: r.d0,
      xD: r.C$,
      x5: r.x5,
      zw: r.zw,
      ow: r.ow,
      t8: $elm$core$Maybe$Nothing,
      Fh: r.Fh
    });
  };

  var $dillonkearns$elm_graphql$Graphql$Http$toTask = function (fullRequest) {
    var request = fullRequest;
    return A2($elm$core$Task$andThen, $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$HttpError, function (readyRequest) {
      return (request.fi ? $elm$http$Http$riskyTask : $elm$http$Http$task)({
        d0: readyRequest.d0,
        x5: readyRequest.x5,
        zw: readyRequest.zw,
        C$: $dillonkearns$elm_graphql$Graphql$Http$resolver(fullRequest),
        ow: readyRequest.ow,
        Fh: readyRequest.Fh
      });
    }($dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest))));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$withOperationName = F2(function (operationName, _v0) {
    var request = _v0;
    return _Utils_update(request, {
      gs: $elm$core$Maybe$Just(operationName)
    });
  });
  var $author$project$Api$Api$requestTask = F5(function (operationName, requester, apiEndpoint, maybeAccessToken, query) {
    var withName = function () {
      if (!operationName.$) {
        var name = operationName.a;
        return $dillonkearns$elm_graphql$Graphql$Http$withOperationName(name);
      } else {
        return $elm$core$Basics$identity;
      }
    }();

    return $author$project$Util$Retry$retryApi($dillonkearns$elm_graphql$Graphql$Http$toTask(withName(A4($author$project$Api$Api$requestCore, requester, apiEndpoint, maybeAccessToken, query))));
  });
  var $author$project$Api$Api$queryRequestTask = A2($author$project$Api$Api$requestTask, $elm$core$Maybe$Nothing, $dillonkearns$elm_graphql$Graphql$Http$queryRequest);

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_Nil, $elm$json$Json$Decode$succeed(constructor));
  };

  var $elm$json$Json$Decode$array = _Json_decodeArray;
  var $elm$json$Json$Encode$array = F2(function (func, entries) {
    return _Json_wrap(A3($elm$core$Array$foldl, _Json_addEntry(func), _Json_emptyArray(0), entries));
  });

  var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
    return 'TODO deadEndsToString';
  };

  var $elm$parser$Parser$Advanced$Bad = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$Good = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
  var $elm$parser$Parser$Advanced$andThen = F2(function (callback, _v0) {
    var parseA = _v0;
    return function (s0) {
      var _v1 = parseA(s0);

      if (_v1.$ === 1) {
        var p = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      } else {
        var p1 = _v1.a;
        var a = _v1.b;
        var s1 = _v1.c;

        var _v2 = callback(a);

        var parseB = _v2;

        var _v3 = parseB(s1);

        if (_v3.$ === 1) {
          var p2 = _v3.a;
          var x = _v3.b;
          return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
        } else {
          var p2 = _v3.a;
          var b = _v3.b;
          var s2 = _v3.c;
          return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
        }
      }
    };
  });
  var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
  var $elm$parser$Parser$ExpectingEnd = {
    $: 10
  };
  var $elm$parser$Parser$Advanced$AddRight = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$DeadEnd = F4(function (row, col, problem, contextStack) {
    return {
      py: col,
      wf: contextStack,
      sL: problem,
      td: row
    };
  });
  var $elm$parser$Parser$Advanced$Empty = {
    $: 0
  };
  var $elm$parser$Parser$Advanced$fromState = F2(function (s, x) {
    return A2($elm$parser$Parser$Advanced$AddRight, $elm$parser$Parser$Advanced$Empty, A4($elm$parser$Parser$Advanced$DeadEnd, s.td, s.py, x, s.au));
  });

  var $elm$parser$Parser$Advanced$end = function (x) {
    return function (s) {
      return _Utils_eq($elm$core$String$length(s.jU), s.mC) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, x));
    };
  };

  var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
  var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
  var $elm$parser$Parser$Advanced$chompWhileHelp = F5(function (isGood, offset, row, col, s0) {
    chompWhileHelp: while (true) {
      var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.jU);

      if (_Utils_eq(newOffset, -1)) {
        return A3($elm$parser$Parser$Advanced$Good, _Utils_cmp(s0.mC, offset) < 0, 0, {
          py: col,
          au: s0.au,
          aC: s0.aC,
          mC: offset,
          td: row,
          jU: s0.jU
        });
      } else {
        if (_Utils_eq(newOffset, -2)) {
          var $temp$isGood = isGood,
              $temp$offset = offset + 1,
              $temp$row = row + 1,
              $temp$col = 1,
              $temp$s0 = s0;
          isGood = $temp$isGood;
          offset = $temp$offset;
          row = $temp$row;
          col = $temp$col;
          s0 = $temp$s0;
          continue chompWhileHelp;
        } else {
          var $temp$isGood = isGood,
              $temp$offset = newOffset,
              $temp$row = row,
              $temp$col = col + 1,
              $temp$s0 = s0;
          isGood = $temp$isGood;
          offset = $temp$offset;
          row = $temp$row;
          col = $temp$col;
          s0 = $temp$s0;
          continue chompWhileHelp;
        }
      }
    }
  });

  var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
    return function (s) {
      return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.mC, s.td, s.py, s);
    };
  };

  var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
  var $elm$parser$Parser$Advanced$mapChompedString = F2(function (func, _v0) {
    var parse = _v0;
    return function (s0) {
      var _v1 = parse(s0);

      if (_v1.$ === 1) {
        var p = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      } else {
        var p = _v1.a;
        var a = _v1.b;
        var s1 = _v1.c;
        return A3($elm$parser$Parser$Advanced$Good, p, A2(func, A3($elm$core$String$slice, s0.mC, s1.mC, s0.jU), a), s1);
      }
    };
  });

  var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
    return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
  };

  var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;

  var $elm$parser$Parser$Problem = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $elm$parser$Parser$Advanced$problem = function (x) {
    return function (s) {
      return A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, x));
    };
  };

  var $elm$parser$Parser$problem = function (msg) {
    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(msg));
  };

  var $elm$core$Basics$round = _Basics_round;

  var $elm$parser$Parser$Advanced$succeed = function (a) {
    return function (s) {
      return A3($elm$parser$Parser$Advanced$Good, false, a, s);
    };
  };

  var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
  var $elm$core$String$toFloat = _String_toFloat;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2($elm$parser$Parser$andThen, function (str) {
    if ($elm$core$String$length(str) <= 9) {
      var _v0 = $elm$core$String$toFloat('0.' + str);

      if (!_v0.$) {
        var floatVal = _v0.a;
        return $elm$parser$Parser$succeed($elm$core$Basics$round(floatVal * 1000));
      } else {
        return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
      }
    } else {
      return $elm$parser$Parser$problem('Expected at most 9 digits, but got ' + $elm$core$String$fromInt($elm$core$String$length(str)));
    }
  }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
    return $elm$time$Time$millisToPosix(monthYearDayMs + hour * 60 * 60 * 1000 + (minute - utcOffsetMinutes) * 60 * 1000 + second * 1000 + ms);
  });
  var $elm$parser$Parser$Advanced$map2 = F3(function (func, _v0, _v1) {
    var parseA = _v0;
    var parseB = _v1;
    return function (s0) {
      var _v2 = parseA(s0);

      if (_v2.$ === 1) {
        var p = _v2.a;
        var x = _v2.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      } else {
        var p1 = _v2.a;
        var a = _v2.b;
        var s1 = _v2.c;

        var _v3 = parseB(s1);

        if (_v3.$ === 1) {
          var p2 = _v3.a;
          var x = _v3.b;
          return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
        } else {
          var p2 = _v3.a;
          var b = _v3.b;
          var s2 = _v3.c;
          return A3($elm$parser$Parser$Advanced$Good, p1 || p2, A2(func, a, b), s2);
        }
      }
    };
  });
  var $elm$parser$Parser$Advanced$ignorer = F2(function (keepParser, ignoreParser) {
    return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
  });
  var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
  var $elm$parser$Parser$Advanced$keeper = F2(function (parseFunc, parseArg) {
    return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
  });
  var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
  var $elm$parser$Parser$Advanced$Append = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$oneOfHelp = F3(function (s0, bag, parsers) {
    oneOfHelp: while (true) {
      if (!parsers.b) {
        return A2($elm$parser$Parser$Advanced$Bad, false, bag);
      } else {
        var parse = parsers.a;
        var remainingParsers = parsers.b;

        var _v1 = parse(s0);

        if (!_v1.$) {
          var step = _v1;
          return step;
        } else {
          var step = _v1;
          var p = step.a;
          var x = step.b;

          if (p) {
            return step;
          } else {
            var $temp$s0 = s0,
                $temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
                $temp$parsers = remainingParsers;
            s0 = $temp$s0;
            bag = $temp$bag;
            parsers = $temp$parsers;
            continue oneOfHelp;
          }
        }
      }
    }
  });

  var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
    return function (s) {
      return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
    };
  };

  var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;

  var $elm$parser$Parser$Done = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$parser$Parser$Loop = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$core$String$append = _String_append;
  var $elm$parser$Parser$UnexpectedChar = {
    $: 11
  };
  var $elm$parser$Parser$Advanced$chompIf = F2(function (isGood, expecting) {
    return function (s) {
      var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.mC, s.jU);
      return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : _Utils_eq(newOffset, -2) ? A3($elm$parser$Parser$Advanced$Good, true, 0, {
        py: 1,
        au: s.au,
        aC: s.aC,
        mC: s.mC + 1,
        td: s.td + 1,
        jU: s.jU
      }) : A3($elm$parser$Parser$Advanced$Good, true, 0, {
        py: s.py + 1,
        au: s.au,
        aC: s.aC,
        mC: newOffset,
        td: s.td,
        jU: s.jU
      });
    };
  });

  var $elm$parser$Parser$chompIf = function (isGood) {
    return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
  };

  var $elm$parser$Parser$Advanced$loopHelp = F4(function (p, state, callback, s0) {
    loopHelp: while (true) {
      var _v0 = callback(state);

      var parse = _v0;

      var _v1 = parse(s0);

      if (!_v1.$) {
        var p1 = _v1.a;
        var step = _v1.b;
        var s1 = _v1.c;

        if (!step.$) {
          var newState = step.a;
          var $temp$p = p || p1,
              $temp$state = newState,
              $temp$callback = callback,
              $temp$s0 = s1;
          p = $temp$p;
          state = $temp$state;
          callback = $temp$callback;
          s0 = $temp$s0;
          continue loopHelp;
        } else {
          var result = step.a;
          return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
        }
      } else {
        var p1 = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
      }
    }
  });
  var $elm$parser$Parser$Advanced$loop = F2(function (state, callback) {
    return function (s) {
      return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
    };
  });
  var $elm$parser$Parser$Advanced$map = F2(function (func, _v0) {
    var parse = _v0;
    return function (s0) {
      var _v1 = parse(s0);

      if (!_v1.$) {
        var p = _v1.a;
        var a = _v1.b;
        var s1 = _v1.c;
        return A3($elm$parser$Parser$Advanced$Good, p, func(a), s1);
      } else {
        var p = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      }
    };
  });
  var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;

  var $elm$parser$Parser$Advanced$Done = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$parser$Parser$Advanced$Loop = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$parser$Parser$toAdvancedStep = function (step) {
    if (!step.$) {
      var s = step.a;
      return $elm$parser$Parser$Advanced$Loop(s);
    } else {
      var a = step.a;
      return $elm$parser$Parser$Advanced$Done(a);
    }
  };

  var $elm$parser$Parser$loop = F2(function (state, callback) {
    return A2($elm$parser$Parser$Advanced$loop, state, function (s) {
      return A2($elm$parser$Parser$map, $elm$parser$Parser$toAdvancedStep, callback(s));
    });
  });

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
    var helper = function (str) {
      if (_Utils_eq($elm$core$String$length(str), quantity)) {
        var _v0 = $elm$core$String$toInt(str);

        if (!_v0.$) {
          var intVal = _v0.a;
          return A2($elm$parser$Parser$map, $elm$parser$Parser$Done, $elm$parser$Parser$succeed(intVal));
        } else {
          return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
        }
      } else {
        return A2($elm$parser$Parser$map, function (nextChar) {
          return $elm$parser$Parser$Loop(A2($elm$core$String$append, str, nextChar));
        }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
      }
    };

    return A2($elm$parser$Parser$loop, '', helper);
  };

  var $elm$parser$Parser$ExpectingSymbol = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $elm$parser$Parser$Advanced$Token = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;

  var $elm$parser$Parser$Advanced$token = function (_v0) {
    var str = _v0.a;
    var expecting = _v0.b;
    var progress = !$elm$core$String$isEmpty(str);
    return function (s) {
      var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.mC, s.td, s.py, s.jU);

      var newOffset = _v1.a;
      var newRow = _v1.b;
      var newCol = _v1.c;
      return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3($elm$parser$Parser$Advanced$Good, progress, 0, {
        py: newCol,
        au: s.au,
        aC: s.aC,
        mC: newOffset,
        td: newRow,
        jU: s.jU
      });
    };
  };

  var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;

  var $elm$parser$Parser$symbol = function (str) {
    return $elm$parser$Parser$Advanced$symbol(A2($elm$parser$Parser$Advanced$Token, str, $elm$parser$Parser$ExpectingSymbol(str)));
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
    return $elm$parser$Parser$problem('Invalid day: ' + $elm$core$String$fromInt(day));
  };

  var $elm$core$Basics$modBy = _Basics_modBy;

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
    return !A2($elm$core$Basics$modBy, 4, year) && (!!A2($elm$core$Basics$modBy, 100, year) || !A2($elm$core$Basics$modBy, 400, year));
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
    var y = y1 - 1;
    return (y / 4 | 0) - (y / 100 | 0) + (y / 400 | 0);
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
    var year = _v0.a;
    var month = _v0.b;
    var dayInMonth = _v0.c;

    if (dayInMonth < 0) {
      return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
    } else {
      var succeedWith = function (extraMs) {
        var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
        var days = month < 3 || !$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year) ? dayInMonth - 1 : dayInMonth;
        var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
        return $elm$parser$Parser$succeed(extraMs + yearMs + dayMs);
      };

      switch (month) {
        case 1:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);

        case 2:
          return dayInMonth > 29 || dayInMonth === 29 && !$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);

        case 3:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);

        case 4:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);

        case 5:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);

        case 6:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);

        case 7:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);

        case 8:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);

        case 9:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);

        case 10:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);

        case 11:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);

        case 12:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);

        default:
          return $elm$parser$Parser$problem('Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
      }
    }
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2($elm$parser$Parser$andThen, $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(F3(function (year, month, day) {
    return _Utils_Tuple3(year, month, day);
  })), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))));

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
    var utcOffsetMinutesFromParts = F3(function (multiplier, hours, minutes) {
      return multiplier * (hours * 60) + minutes;
    });
    return A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$map, function (_v0) {
      return 0;
    }, $elm$parser$Parser$symbol('Z')), A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(utcOffsetMinutesFromParts), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$map, function (_v1) {
      return 1;
    }, $elm$parser$Parser$symbol('+')), A2($elm$parser$Parser$map, function (_v2) {
      return -1;
    }, $elm$parser$Parser$symbol('-'))]))), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2), $elm$parser$Parser$succeed(0)]))), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$end)])));
  }();

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2($elm$parser$Parser$andThen, function (datePart) {
    return $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)), $elm$parser$Parser$symbol('T')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('.')), $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs), $elm$parser$Parser$succeed(0)]))), A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)), $elm$parser$Parser$end)]));
  }, $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
  var $elm$parser$Parser$DeadEnd = F3(function (row, col, problem) {
    return {
      py: col,
      sL: problem,
      td: row
    };
  });

  var $elm$parser$Parser$problemToDeadEnd = function (p) {
    return A3($elm$parser$Parser$DeadEnd, p.td, p.py, p.sL);
  };

  var $elm$parser$Parser$Advanced$bagToList = F2(function (bag, list) {
    bagToList: while (true) {
      switch (bag.$) {
        case 0:
          return list;

        case 1:
          var bag1 = bag.a;
          var x = bag.b;
          var $temp$bag = bag1,
              $temp$list = A2($elm$core$List$cons, x, list);
          bag = $temp$bag;
          list = $temp$list;
          continue bagToList;

        default:
          var bag1 = bag.a;
          var bag2 = bag.b;
          var $temp$bag = bag1,
              $temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
          bag = $temp$bag;
          list = $temp$list;
          continue bagToList;
      }
    }
  });
  var $elm$parser$Parser$Advanced$run = F2(function (_v0, src) {
    var parse = _v0;

    var _v1 = parse({
      py: 1,
      au: _List_Nil,
      aC: 1,
      mC: 0,
      td: 1,
      jU: src
    });

    if (!_v1.$) {
      var value = _v1.b;
      return $elm$core$Result$Ok(value);
    } else {
      var bag = _v1.b;
      return $elm$core$Result$Err(A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
    }
  });
  var $elm$parser$Parser$run = F2(function (parser, source) {
    var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);

    if (!_v0.$) {
      var a = _v0.a;
      return $elm$core$Result$Ok(a);
    } else {
      var problems = _v0.a;
      return $elm$core$Result$Err(A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
    }
  });

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
    return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2($elm$json$Json$Decode$andThen, function (str) {
    var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);

    if (_v0.$ === 1) {
      var deadEnds = _v0.a;
      return $elm$json$Json$Decode$fail($elm$parser$Parser$deadEndsToString(deadEnds));
    } else {
      var time = _v0.a;
      return $elm$json$Json$Decode$succeed(time);
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Scalar$BigInt = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Date = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Decimal = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Instant = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Int4_ = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$LocalDate = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Numeric = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Period = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Timestamp = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Timestamptz = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Uuid = $elm$core$Basics$identity;
  var $elm$core$String$fromFloat = _String_fromNumber;
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$string, A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float), A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$map, function (bool) {
    if (bool) {
      return 'true';
    } else {
      return 'false';
    }
  }, $elm$json$Json$Decode$bool)]));
  var $author$project$Api$GraphqlSchema$Scalar$defaultCodecs = {
    px: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v0) {
        var raw = _v0;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    el: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v1) {
        var raw = _v1;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    eN: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v2) {
        var raw = _v2;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    vX: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v3) {
        var raw = _v3;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    em: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v4) {
        var raw = _v4;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    b8: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v5) {
        var raw = _v5;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    en: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v6) {
        var raw = _v6;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    hd: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v7) {
        var raw = _v7;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    eo: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v8) {
        var raw = _v8;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    ep: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v9) {
        var raw = _v9;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    L: {
      wB: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      cI: function (_v10) {
        var raw = _v10;
        return $elm$json$Json$Encode$string(raw);
      }
    }
  };
  var $author$project$Api$GraphqlSchema$Scalar$Codecs = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$Scalar$defineCodecs = function (definitions) {
    return definitions;
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
    switch (month) {
      case 0:
        return 1;

      case 1:
        return 2;

      case 2:
        return 3;

      case 3:
        return 4;

      case 4:
        return 5;

      case 5:
        return 6;

      case 6:
        return 7;

      case 7:
        return 8;

      case 8:
        return 9;

      case 9:
        return 10;

      case 10:
        return 11;

      default:
        return 12;
    }
  };

  var $elm$time$Time$flooredDiv = F2(function (numerator, denominator) {
    return $elm$core$Basics$floor(numerator / denominator);
  });

  var $elm$time$Time$posixToMillis = function (_v0) {
    var millis = _v0;
    return millis;
  };

  var $elm$time$Time$toAdjustedMinutesHelp = F3(function (defaultOffset, posixMinutes, eras) {
    toAdjustedMinutesHelp: while (true) {
      if (!eras.b) {
        return posixMinutes + defaultOffset;
      } else {
        var era = eras.a;
        var olderEras = eras.b;

        if (_Utils_cmp(era.Ef, posixMinutes) < 0) {
          return posixMinutes + era.mC;
        } else {
          var $temp$defaultOffset = defaultOffset,
              $temp$posixMinutes = posixMinutes,
              $temp$eras = olderEras;
          defaultOffset = $temp$defaultOffset;
          posixMinutes = $temp$posixMinutes;
          eras = $temp$eras;
          continue toAdjustedMinutesHelp;
        }
      }
    }
  });
  var $elm$time$Time$toAdjustedMinutes = F2(function (_v0, time) {
    var defaultOffset = _v0.a;
    var eras = _v0.b;
    return A3($elm$time$Time$toAdjustedMinutesHelp, defaultOffset, A2($elm$time$Time$flooredDiv, $elm$time$Time$posixToMillis(time), 60000), eras);
  });

  var $elm$time$Time$toCivil = function (minutes) {
    var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
    var era = (rawDay >= 0 ? rawDay : rawDay - 146096) / 146097 | 0;
    var dayOfEra = rawDay - era * 146097;
    var yearOfEra = (dayOfEra - (dayOfEra / 1460 | 0) + (dayOfEra / 36524 | 0) - (dayOfEra / 146096 | 0)) / 365 | 0;
    var dayOfYear = dayOfEra - (365 * yearOfEra + (yearOfEra / 4 | 0) - (yearOfEra / 100 | 0));
    var mp = (5 * dayOfYear + 2) / 153 | 0;
    var month = mp + (mp < 10 ? 3 : -9);
    var year = yearOfEra + era * 400;
    return {
      wz: dayOfYear - ((153 * mp + 2) / 5 | 0) + 1,
      zG: month,
      FP: year + (month <= 2 ? 1 : 0)
    };
  };

  var $elm$time$Time$toDay = F2(function (zone, time) {
    return $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).wz;
  });
  var $elm$time$Time$toHour = F2(function (zone, time) {
    return A2($elm$core$Basics$modBy, 24, A2($elm$time$Time$flooredDiv, A2($elm$time$Time$toAdjustedMinutes, zone, time), 60));
  });
  var $elm$time$Time$toMillis = F2(function (_v0, time) {
    return A2($elm$core$Basics$modBy, 1000, $elm$time$Time$posixToMillis(time));
  });
  var $elm$time$Time$toMinute = F2(function (zone, time) {
    return A2($elm$core$Basics$modBy, 60, A2($elm$time$Time$toAdjustedMinutes, zone, time));
  });
  var $elm$time$Time$Apr = 3;
  var $elm$time$Time$Aug = 7;
  var $elm$time$Time$Dec = 11;
  var $elm$time$Time$Feb = 1;
  var $elm$time$Time$Jan = 0;
  var $elm$time$Time$Jul = 6;
  var $elm$time$Time$Jun = 5;
  var $elm$time$Time$Mar = 2;
  var $elm$time$Time$May = 4;
  var $elm$time$Time$Nov = 10;
  var $elm$time$Time$Oct = 9;
  var $elm$time$Time$Sep = 8;
  var $elm$time$Time$toMonth = F2(function (zone, time) {
    var _v0 = $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).zG;

    switch (_v0) {
      case 1:
        return 0;

      case 2:
        return 1;

      case 3:
        return 2;

      case 4:
        return 3;

      case 5:
        return 4;

      case 6:
        return 5;

      case 7:
        return 6;

      case 8:
        return 7;

      case 9:
        return 8;

      case 10:
        return 9;

      case 11:
        return 10;

      default:
        return 11;
    }
  });
  var $elm$core$String$cons = _String_cons;

  var $elm$core$String$fromChar = function (_char) {
    return A2($elm$core$String$cons, _char, '');
  };

  var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
  var $elm$core$String$repeatHelp = F3(function (n, chunk, result) {
    return n <= 0 ? result : A3($elm$core$String$repeatHelp, n >> 1, _Utils_ap(chunk, chunk), !(n & 1) ? result : _Utils_ap(result, chunk));
  });
  var $elm$core$String$repeat = F2(function (n, chunk) {
    return A3($elm$core$String$repeatHelp, n, chunk, '');
  });
  var $elm$core$String$padLeft = F3(function (n, _char, string) {
    return _Utils_ap(A2($elm$core$String$repeat, n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)), string);
  });
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(function (digits, time) {
    return A3($elm$core$String$padLeft, digits, '0', $elm$core$String$fromInt(time));
  });
  var $elm$time$Time$toSecond = F2(function (_v0, time) {
    return A2($elm$core$Basics$modBy, 60, A2($elm$time$Time$flooredDiv, $elm$time$Time$posixToMillis(time), 1000));
  });
  var $elm$time$Time$toYear = F2(function (zone, time) {
    return $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).FP;
  });
  var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
    return A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 4, A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 3, A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
  };

  var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);

  var $JoshuaHall$elm_fraction$Fraction$DenominatorError = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $JoshuaHall$elm_fraction$Fraction$Fraction = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $JoshuaHall$elm_fraction$Fraction$NumeratorError = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $JoshuaHall$elm_fraction$Fraction$invalidDenominator = 0;
  var $elm$random$Random$minInt = -2147483648;
  var $JoshuaHall$elm_fraction$Fraction$minimumSupportedInt = $elm$random$Random$minInt + 1;
  var $JoshuaHall$elm_fraction$Fraction$createWithFeedback = F2(function (numerator, denominator) {
    return _Utils_eq(denominator, $JoshuaHall$elm_fraction$Fraction$invalidDenominator) ? $elm$core$Result$Err($JoshuaHall$elm_fraction$Fraction$DenominatorError('Invalid denominator.')) : _Utils_cmp(numerator, $JoshuaHall$elm_fraction$Fraction$minimumSupportedInt) < 0 ? $elm$core$Result$Err($JoshuaHall$elm_fraction$Fraction$NumeratorError('Numerator is below ' + ($elm$core$String$fromInt($JoshuaHall$elm_fraction$Fraction$minimumSupportedInt) + '.'))) : _Utils_cmp(denominator, $JoshuaHall$elm_fraction$Fraction$minimumSupportedInt) < 0 ? $elm$core$Result$Err($JoshuaHall$elm_fraction$Fraction$DenominatorError('Denominator is below ' + ($elm$core$String$fromInt($JoshuaHall$elm_fraction$Fraction$minimumSupportedInt) + '.'))) : $elm$core$Result$Ok(A2($JoshuaHall$elm_fraction$Fraction$Fraction, numerator, denominator));
  });
  var $JoshuaHall$elm_fraction$Fraction$create = F2(function (numerator, denominator) {
    return $elm$core$Result$toMaybe(A2($JoshuaHall$elm_fraction$Fraction$createWithFeedback, numerator, denominator));
  });
  var $elm$core$Basics$pow = _Basics_pow;

  var $author$project$Ui$TimeTransformation$Util$floatStringToFraction = function (floatString) {
    var sanitizedString = function () {
      var _v3 = _Utils_Tuple3(A2($elm$core$String$contains, '.', floatString), $elm$regex$Regex$fromString('0+$'), $elm$regex$Regex$fromString('\\.$'));

      if (_v3.a && !_v3.b.$ && !_v3.c.$) {
        var r1 = _v3.b.a;
        var r2 = _v3.c.a;
        return A3($elm$regex$Regex$replace, r2, $elm$core$Basics$always(''), A3($elm$regex$Regex$replace, r1, $elm$core$Basics$always(''), floatString));
      } else {
        return floatString;
      }
    }();

    var _v0 = function () {
      var _v1 = A2($elm$core$String$split, '.', sanitizedString);

      _v1$2: while (true) {
        if (_v1.b) {
          if (_v1.b.b) {
            if (!_v1.b.b.b) {
              var first = _v1.a;
              var _v2 = _v1.b;
              var second = _v2.a;
              var sanitizedSecond = A2($elm$core$Maybe$withDefault, second, A2($elm$core$Maybe$map, function (r) {
                return A3($elm$regex$Regex$replace, r, $elm$core$Basics$always('0'), second);
              }, $elm$regex$Regex$fromString('0+$')));
              return _Utils_Tuple2($elm$core$String$toInt(_Utils_ap(first, sanitizedSecond)), A2($elm$core$Basics$pow, 10, $elm$core$String$length(sanitizedSecond)));
            } else {
              break _v1$2;
            }
          } else {
            var first = _v1.a;
            return _Utils_Tuple2($elm$core$String$toInt(first), 1);
          }
        } else {
          break _v1$2;
        }
      }

      return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
    }();

    var numerator = _v0.a;
    var denominator = _v0.b;
    return A2($elm$core$Maybe$andThen, function (num) {
      return A2($JoshuaHall$elm_fraction$Fraction$create, num, denominator);
    }, numerator);
  };

  var $author$project$Types$SimpleDate$SimpleDate = F3(function (year, month, day) {
    return {
      wz: day,
      zG: month,
      FP: year
    };
  });
  var $elm$core$Maybe$map3 = F4(function (func, ma, mb, mc) {
    if (ma.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var a = ma.a;

      if (mb.$ === 1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var b = mb.a;

        if (mc.$ === 1) {
          return $elm$core$Maybe$Nothing;
        } else {
          var c = mc.a;
          return $elm$core$Maybe$Just(A3(func, a, b, c));
        }
      }
    }
  });

  var $author$project$Types$SimpleDate$fromDateString = function (string) {
    var _v0 = A2($elm$core$String$split, '-', string);

    if (_v0.b && _v0.b.b && _v0.b.b.b && !_v0.b.b.b.b) {
      var yearString = _v0.a;
      var _v1 = _v0.b;
      var monthString = _v1.a;
      var _v2 = _v1.b;
      var dayString = _v2.a;
      var maybeYear = $elm$core$String$toInt(yearString);

      var maybeMonth = function () {
        switch (monthString) {
          case '01':
            return $elm$core$Maybe$Just(0);

          case '02':
            return $elm$core$Maybe$Just(1);

          case '03':
            return $elm$core$Maybe$Just(2);

          case '04':
            return $elm$core$Maybe$Just(3);

          case '05':
            return $elm$core$Maybe$Just(4);

          case '06':
            return $elm$core$Maybe$Just(5);

          case '07':
            return $elm$core$Maybe$Just(6);

          case '08':
            return $elm$core$Maybe$Just(7);

          case '09':
            return $elm$core$Maybe$Just(8);

          case '10':
            return $elm$core$Maybe$Just(9);

          case '11':
            return $elm$core$Maybe$Just(10);

          case '12':
            return $elm$core$Maybe$Just(11);

          default:
            return $elm$core$Maybe$Nothing;
        }
      }();

      var maybeDay = $elm$core$String$toInt(dayString);
      return A4($elm$core$Maybe$map3, $author$project$Types$SimpleDate$SimpleDate, maybeYear, maybeMonth, maybeDay);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$SimpleDate$toDateString = function (_v0) {
    var year = _v0.FP;
    var month = _v0.zG;
    var day = _v0.wz;
    var yearString = $elm$core$String$fromInt(year);

    var monthString = function () {
      switch (month) {
        case 0:
          return '01';

        case 1:
          return '02';

        case 2:
          return '03';

        case 3:
          return '04';

        case 4:
          return '05';

        case 5:
          return '06';

        case 6:
          return '07';

        case 7:
          return '08';

        case 8:
          return '09';

        case 9:
          return '10';

        case 10:
          return '11';

        default:
          return '12';
      }
    }();

    var dayString = A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(day));
    return A2($elm$core$String$join, '-', _List_fromArray([yearString, monthString, dayString]));
  };

  var $author$project$Api$ScalarCodecs$simpleDateClosedRangeToString = function (_v0) {
    var start = _v0.Ef;
    var endInclusive = _v0.xw;
    var startDateString = $author$project$Types$SimpleDate$toDateString(start);
    var endDateString = $author$project$Types$SimpleDate$toDateString(endInclusive);
    return startDateString + ('..' + endDateString);
  };

  var $author$project$Types$SimpleDateRange$SimpleDateClosedRange = F2(function (start, endInclusive) {
    return {
      xw: endInclusive,
      Ef: start
    };
  });
  var $elm_community$list_extra$List$Extra$getAt = F2(function (idx, xs) {
    return idx < 0 ? $elm$core$Maybe$Nothing : $elm$core$List$head(A2($elm$core$List$drop, idx, xs));
  });

  var $author$project$Api$ScalarCodecs$stringToSimpleDateClosedRange = function (p) {
    var dates = A2($elm$core$String$split, '..', p);
    var endDate = A2($elm$core$Maybe$andThen, $author$project$Types$SimpleDate$fromDateString, A2($elm_community$list_extra$List$Extra$getAt, 1, dates));
    var startDate = A2($elm$core$Maybe$andThen, $author$project$Types$SimpleDate$fromDateString, A2($elm_community$list_extra$List$Extra$getAt, 0, dates));
    return A3($elm$core$Maybe$map2, $author$project$Types$SimpleDateRange$SimpleDateClosedRange, startDate, endDate);
  };

  var $author$project$ElmFramework$Lib$Util$toDecoderFromMaybe = F2(function (string, maybe) {
    if (!maybe.$) {
      var thing = maybe.a;
      return $elm$json$Json$Decode$succeed(thing);
    } else {
      return $elm$json$Json$Decode$fail(string);
    }
  });

  var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
    return A2($elm$core$List$foldr, F2(function (x, xs) {
      return p(x) && $elm$core$List$isEmpty(xs) ? _List_Nil : A2($elm$core$List$cons, x, xs);
    }), _List_Nil);
  };

  var $elm$core$String$fromList = _String_fromList;
  var $elm$core$String$foldr = _String_foldr;

  var $elm$core$String$toList = function (string) {
    return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
  };

  var $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString = function (floatString) {
    var _v0 = A2($elm$core$String$split, '.', floatString);

    _v0$2: while (true) {
      if (_v0.b) {
        if (!_v0.b.b) {
          var single = _v0.a;
          return single;
        } else {
          if (!_v0.b.b.b) {
            var first = _v0.a;
            var _v1 = _v0.b;
            var second = _v1.a;
            var strippedZeros = $elm$core$String$fromList(A2($elm_community$list_extra$List$Extra$dropWhileRight, $elm$core$Basics$eq('0'), $elm$core$String$toList(second)));
            var sec = $elm$core$String$isEmpty(strippedZeros) ? '' : '.' + strippedZeros;
            return _Utils_ap(first, sec);
          } else {
            break _v0$2;
          }
        }
      } else {
        break _v0$2;
      }
    }

    return 'NaN';
  };

  var $elm$core$Basics$abs = function (n) {
    return n < 0 ? -n : n;
  };

  var $myrho$elm_round$Round$addSign = F2(function (signed, str) {
    var isNotZero = A2($elm$core$List$any, function (c) {
      return c !== '0' && c !== '.';
    }, $elm$core$String$toList(str));
    return _Utils_ap(signed && isNotZero ? '-' : '', str);
  });
  var $elm$core$Char$fromCode = _Char_fromCode;

  var $myrho$elm_round$Round$increaseNum = function (_v0) {
    var head = _v0.a;
    var tail = _v0.b;

    if (head === '9') {
      var _v1 = $elm$core$String$uncons(tail);

      if (_v1.$ === 1) {
        return '01';
      } else {
        var headtail = _v1.a;
        return A2($elm$core$String$cons, '0', $myrho$elm_round$Round$increaseNum(headtail));
      }
    } else {
      var c = $elm$core$Char$toCode(head);
      return c >= 48 && c < 57 ? A2($elm$core$String$cons, $elm$core$Char$fromCode(c + 1), tail) : '0';
    }
  };

  var $elm$core$Basics$isInfinite = _Basics_isInfinite;
  var $elm$core$Basics$isNaN = _Basics_isNaN;
  var $elm$core$String$padRight = F3(function (n, _char, string) {
    return _Utils_ap(string, A2($elm$core$String$repeat, n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)));
  });
  var $elm$core$String$reverse = _String_reverse;

  var $myrho$elm_round$Round$splitComma = function (str) {
    var _v0 = A2($elm$core$String$split, '.', str);

    if (_v0.b) {
      if (_v0.b.b) {
        var before = _v0.a;
        var _v1 = _v0.b;
        var after = _v1.a;
        return _Utils_Tuple2(before, after);
      } else {
        var before = _v0.a;
        return _Utils_Tuple2(before, '0');
      }
    } else {
      return _Utils_Tuple2('0', '0');
    }
  };

  var $elm$core$Tuple$mapFirst = F2(function (func, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(func(x), y);
  });

  var $myrho$elm_round$Round$toDecimal = function (fl) {
    var _v0 = A2($elm$core$String$split, 'e', $elm$core$String$fromFloat($elm$core$Basics$abs(fl)));

    if (_v0.b) {
      if (_v0.b.b) {
        var num = _v0.a;
        var _v1 = _v0.b;
        var exp = _v1.a;
        var e = A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));

        var _v2 = $myrho$elm_round$Round$splitComma(num);

        var before = _v2.a;
        var after = _v2.b;

        var total = _Utils_ap(before, after);

        var zeroed = e < 0 ? A2($elm$core$Maybe$withDefault, '0', A2($elm$core$Maybe$map, function (_v3) {
          var a = _v3.a;
          var b = _v3.b;
          return a + ('.' + b);
        }, A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst($elm$core$String$fromChar), $elm$core$String$uncons(_Utils_ap(A2($elm$core$String$repeat, $elm$core$Basics$abs(e), '0'), total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
        return _Utils_ap(fl < 0 ? '-' : '', zeroed);
      } else {
        var num = _v0.a;
        return _Utils_ap(fl < 0 ? '-' : '', num);
      }
    } else {
      return '';
    }
  };

  var $myrho$elm_round$Round$roundFun = F3(function (functor, s, fl) {
    if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
      return $elm$core$String$fromFloat(fl);
    } else {
      var signed = fl < 0;

      var _v0 = $myrho$elm_round$Round$splitComma($myrho$elm_round$Round$toDecimal($elm$core$Basics$abs(fl)));

      var before = _v0.a;
      var after = _v0.b;
      var r = $elm$core$String$length(before) + s;

      var normalized = _Utils_ap(A2($elm$core$String$repeat, -r + 1, '0'), A3($elm$core$String$padRight, r, '0', _Utils_ap(before, after)));

      var totalLen = $elm$core$String$length(normalized);
      var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
      var increase = A2(functor, signed, A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
      var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
      var num = increase ? $elm$core$String$reverse(A2($elm$core$Maybe$withDefault, '1', A2($elm$core$Maybe$map, $myrho$elm_round$Round$increaseNum, $elm$core$String$uncons($elm$core$String$reverse(remains))))) : remains;
      var numLen = $elm$core$String$length(num);
      var numZeroed = num === '0' ? num : s <= 0 ? _Utils_ap(num, A2($elm$core$String$repeat, $elm$core$Basics$abs(s), '0')) : _Utils_cmp(s, $elm$core$String$length(after)) < 0 ? A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num)) : _Utils_ap(before + '.', A3($elm$core$String$padRight, s, '0', after));
      return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
    }
  });
  var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(F2(function (signed, str) {
    var _v0 = $elm$core$String$uncons(str);

    if (_v0.$ === 1) {
      return false;
    } else {
      if ('5' === _v0.a.a) {
        if (_v0.a.b === '') {
          var _v1 = _v0.a;
          return !signed;
        } else {
          var _v2 = _v0.a;
          return true;
        }
      } else {
        var _v3 = _v0.a;
        var _int = _v3.a;
        return function (i) {
          return i > 53 && signed || i >= 53 && !signed;
        }($elm$core$Char$toCode(_int));
      }
    }
  }));

  var $JoshuaHall$elm_fraction$Fraction$toFloat = function (_v0) {
    var numerator = _v0.a;
    var denominator = _v0.b;
    return numerator / denominator;
  };

  var $author$project$Ui$TimeTransformation$Util$toStringFromFraction = function (fraction) {
    return $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(fraction)));
  };

  var $author$project$Api$ScalarCodecs$codecs = $author$project$Api$GraphqlSchema$Scalar$defineCodecs({
    px: {
      wB: $elm$json$Json$Decode$int,
      cI: $elm$json$Json$Encode$int
    },
    el: {
      wB: A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$fromDateString, $author$project$ElmFramework$Lib$Util$toDecoderFromMaybe('Couldn\'t decode date into SimpleDate')), $elm$json$Json$Decode$string),
      cI: A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$toDateString, $elm$json$Json$Encode$string)
    },
    eN: {
      wB: A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Ui$TimeTransformation$Util$floatStringToFraction, $author$project$ElmFramework$Lib$Util$toDecoderFromMaybe('Couldn\'t decode decimal into fraction')), $elm$json$Json$Decode$string),
      cI: A2($elm$core$Basics$composeR, $author$project$Ui$TimeTransformation$Util$toStringFromFraction, $elm$json$Json$Encode$string)
    },
    vX: {
      wB: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
      cI: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode
    },
    em: {
      wB: $elm$json$Json$Decode$array($elm$json$Json$Decode$int),
      cI: $elm$json$Json$Encode$array($elm$json$Json$Encode$int)
    },
    b8: {
      wB: A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$fromDateString, $author$project$ElmFramework$Lib$Util$toDecoderFromMaybe('Couldn\'t decode LocalDate into SimpleDate')), $elm$json$Json$Decode$string),
      cI: A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$toDateString, $elm$json$Json$Encode$string)
    },
    en: {
      wB: A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Ui$TimeTransformation$Util$floatStringToFraction, $author$project$ElmFramework$Lib$Util$toDecoderFromMaybe('Couldn\'t decode Numeric into Fraction')), $elm$json$Json$Decode$string),
      cI: A2($elm$core$Basics$composeR, $author$project$Ui$TimeTransformation$Util$toStringFromFraction, $elm$json$Json$Encode$string)
    },
    hd: {
      wB: A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Api$ScalarCodecs$stringToSimpleDateClosedRange, $author$project$ElmFramework$Lib$Util$toDecoderFromMaybe('Couldn\'t decode Period into SimpleDateClosedRange')), $elm$json$Json$Decode$string),
      cI: A2($elm$core$Basics$composeR, $author$project$Api$ScalarCodecs$simpleDateClosedRangeToString, $elm$json$Json$Encode$string)
    },
    eo: {
      wB: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
      cI: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode
    },
    ep: {
      wB: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
      cI: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode
    },
    L: $author$project$Api$GraphqlSchema$Scalar$defaultCodecs.L
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(function (details, args) {
    return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(function (typeString, fieldName, args, decoder) {
    var newLeaf = A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf, {
      qm: fieldName,
      Fc: typeString
    }, args);
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_fromArray([newLeaf]), A2($elm$json$Json$Decode$field, $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf), decoder));
  });

  var $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs = function (_v0) {
    var unwrappedCodecs = _v0;
    return unwrappedCodecs;
  };

  var $author$project$Api$GraphqlSchema$Object$AuthUser$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'userId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$Schema$uuidToString = function (_v0) {
    var value = _v0;
    return value;
  };

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(function (_v0, _v1) {
    var selectionFields1 = _v0.a;
    var selectionDecoder1 = _v0.b;
    var selectionFields2 = _v1.a;
    var selectionDecoder2 = _v1.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _Utils_ap(selectionFields1, selectionFields2), A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
  });
  var $author$project$Api$Api$getApiUser = F2(function (apiEndpoint, idToken) {
    var userPayloadSelection = function () {
      var authSelection = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, A2($elm$core$Basics$composeR, $author$project$Api$Schema$uuidToString, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$AuthUser$userId);
      return $author$project$Api$GraphqlSchema$Object$CurrentUserPayloadSuccess$auth(authSelection);
    }();

    var userPayloadOptions = $author$project$Api$GraphqlSchema$Union$CurrentUserPayload$maybeFragments;
    var getUserId = $author$project$Api$GraphqlSchema$Union$CurrentUserPayload$fragments(_Utils_update(userPayloadOptions, {
      Av: userPayloadSelection
    }));
    return A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$me(A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, getUserId, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity))));
  });
  var $turboMaCk$any_dict$Dict$Any$fromList = F2(function (f, xs) {
    return {
      bT: $elm$core$Dict$fromList(A2($elm$core$List$map, function (_v0) {
        var k = _v0.a;
        var v = _v0.b;
        return _Utils_Tuple2(f(k), _Utils_Tuple2(k, v));
      }, xs)),
      dn: f
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$AccountAnalyst = 0;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$AccountManager = 1;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$Admin = 2;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$Anonymous = 3;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$BizAdmin = 4;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$BizOwner = 5;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$BizViewer = 6;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$User = 7;
  var $author$project$Api$GraphqlSchema$Enum$Role_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ACCOUNT_ANALYST':
        return $elm$json$Json$Decode$succeed(0);

      case 'ACCOUNT_MANAGER':
        return $elm$json$Json$Decode$succeed(1);

      case 'ADMIN':
        return $elm$json$Json$Decode$succeed(2);

      case 'ANONYMOUS':
        return $elm$json$Json$Decode$succeed(3);

      case 'BIZ_ADMIN':
        return $elm$json$Json$Decode$succeed(4);

      case 'BIZ_OWNER':
        return $elm$json$Json$Decode$succeed(5);

      case 'BIZ_VIEWER':
        return $elm$json$Json$Decode$succeed(6);

      case 'USER':
        return $elm$json$Json$Decode$succeed(7);

      default:
        return $elm$json$Json$Decode$fail('Invalid Role_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$User$global_role = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Role_enum.Role_enum', 'global_role', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Role_enum$decoder);

  var $author$project$Types$Company$unwrapCompanyId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Types$Company$toCompanyDict = function (companies) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Company$unwrapCompanyId, A2($elm$core$List$map, function (c) {
      return _Utils_Tuple2(c.F, c);
    }, companies));
  };

  var $author$project$Api$GraphqlSchema$Object$User$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$User$enabled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'enabled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$User$first_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'first_name', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$User$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$User$last_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'last_name', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));

  var $author$project$Api$Schema$mapUuid = function (tag) {
    return $dillonkearns$elm_graphql$Graphql$SelectionSet$map(function (_v0) {
      var id = _v0;
      return tag(id);
    });
  };

  var $author$project$Api$GraphqlSchema$Object$User$phone_number = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'phone_number', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$User$photo_url = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'photo_url', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$user = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User$enabled, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User$phone_number, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User$photo_url, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User$email, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Maybe$withDefault(''), $author$project$Api$GraphqlSchema$Object$User$last_name), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Maybe$withDefault(''), $author$project$Api$GraphqlSchema$Object$User$first_name), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$User$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F7(function (id, firstName, lastName, email, photoUrl, phoneNumber, enabled) {
    return {
      u2: function () {
        if (!photoUrl.$) {
          var url = photoUrl.a;
          return _List_fromArray([{
            x6: 0,
            Fh: url,
            FE: 0
          }]);
        } else {
          return _List_Nil;
        }
      }(),
      iP: email,
      xs: enabled,
      hu: firstName,
      F: id,
      hI: lastName,
      ng: phoneNumber
    };
  })))))))));
  var $author$project$Types$UserCompany$UserCompanyWithData = F3(function (userId, company, role) {
    return {
      j: company,
      gz: role,
      oD: userId
    };
  });

  var $author$project$Api$GraphqlSchema$Object$User_company$company = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'company', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Types$Company$CompanyId = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Object$Company$address_city = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'address_city', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$GraphqlSchema$Object$Company$address_country = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address_country', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$Company$address_country_subdivision_code = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'address_country_subdivision_code', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Company$address_gmaps_place_uid = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'address_gmaps_place_uid', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Company$address_number = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'address_number', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Company$address_postal_code = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'address_postal_code', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Company$address_street = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'address_street', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Types$Country$CountryCode = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Object$Country$code = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'code', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Country$full_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'full_name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$country = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Country$full_name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Country$code, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (code, fullName) {
    return {
      pw: code,
      xO: fullName
    };
  }))));
  var $author$project$Api$GraphqlSchema$Object$Company$created_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'created_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$GraphqlSchema$Object$Company$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Company$inter_division_show_both_tx = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'inter_division_show_both_tx', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$Company$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$Currency_enum$Usd = 0;
  var $author$project$Api$GraphqlSchema$Enum$Currency_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    if (string === 'USD') {
      return $elm$json$Json$Decode$succeed(0);
    } else {
      return $elm$json$Json$Decode$fail('Invalid Currency_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Company$reporting_currency = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Currency_enum.Currency_enum', 'reporting_currency', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Currency_enum$decoder);
  var $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$Monthly = 0;
  var $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$Weekly = 1;
  var $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'MONTHLY':
        return $elm$json$Json$Decode$succeed(0);

      case 'WEEKLY':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Reporting_interval_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Company$reporting_default_interval = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Reporting_interval_enum.Reporting_interval_enum', 'reporting_default_interval', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Company$reporting_wk_ending = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'reporting_wk_ending', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$L = 0;
  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$M = 1;
  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$S = 2;
  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$Xl = 3;
  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$Xxl = 4;
  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'L':
        return $elm$json$Json$Decode$succeed(0);

      case 'M':
        return $elm$json$Json$Decode$succeed(1);

      case 'S':
        return $elm$json$Json$Decode$succeed(2);

      case 'XL':
        return $elm$json$Json$Decode$succeed(3);

      case 'XXL':
        return $elm$json$Json$Decode$succeed(4);

      default:
        return $elm$json$Json$Decode$fail('Invalid Company_size_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Company$size = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Company_size_enum.Company_size_enum', 'size', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Company_size_enum$decoder);
  var $author$project$Types$TimeZone$TimeZoneId = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Object$TimeZone$currentOffset = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'currentOffset', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$currentOffsetFormatted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'currentOffsetFormatted', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayName', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$displayNameShort = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayNameShort', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$dstOffset = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'dstOffset', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$inDaylightTime = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'inDaylightTime', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$standardOffset = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'standardOffset', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$TimeZone$standardOffsetFormatted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'standardOffsetFormatted', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$timeZone = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$standardOffsetFormatted, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$standardOffset, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$inDaylightTime, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$id, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$dstOffset, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$displayNameShort, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$displayName, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$currentOffsetFormatted, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeZone$currentOffset, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F9(function (currentOffset, currentOffsetFormatted, displayName, displayNameShort, dstOffset, id, inDaylightTime, standardOffset, standardOffsetFormatted) {
    return {
      wr: currentOffset,
      ws: currentOffsetFormatted,
      k0: displayName,
      wL: displayNameShort,
      xh: dstOffset,
      F: id,
      yo: inDaylightTime,
      Ed: standardOffset,
      Ee: standardOffsetFormatted
    };
  })))))))))));
  var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {
    $: 1
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional = F3(function (fieldName, maybeValue, toValue) {
    switch (maybeValue.$) {
      case 0:
        var value = maybeValue.a;
        return $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, toValue(value)));

      case 1:
        return $elm$core$Maybe$Nothing;

      default:
        return $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, $dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
    }
  });

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$string(value));
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
  };

  var $author$project$Api$GraphqlSchema$Scalar$unwrapEncoder = F2(function (getter, _v0) {
    var unwrappedCodecs = _v0;
    return A2($elm$core$Basics$composeR, getter(unwrappedCodecs).cI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
  });
  var $author$project$Api$GraphqlSchema$Object$Company$timezoneDetails = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      uY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      l2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'asOf', filledInOptionals____.uY, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.vX;
    }, $author$project$Api$ScalarCodecs$codecs)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'language', filledInOptionals____.l2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'timezoneDetails', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $elm$time$Time$Fri = 4;
  var $elm$time$Time$Mon = 0;
  var $elm$time$Time$Sat = 5;
  var $elm$time$Time$Sun = 6;
  var $elm$time$Time$Thu = 3;
  var $elm$time$Time$Tue = 1;
  var $elm$time$Time$Wed = 2;

  var $author$project$Api$Util$toWeekdayFromInt = function (_int) {
    switch (_int) {
      case 1:
        return 0;

      case 2:
        return 1;

      case 3:
        return 2;

      case 4:
        return 3;

      case 5:
        return 4;

      case 6:
        return 5;

      case 7:
        return 6;

      default:
        return 0;
    }
  };

  var $author$project$Types$Scenario$ScenarioId = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Object$Company_top_scenario$base_scenario_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'base_scenario_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Company_top_scenario$budget_scenario_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'budget_scenario_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$Schema$mapField = $dillonkearns$elm_graphql$Graphql$SelectionSet$map;
  var $author$project$Api$Schema$withMap = F3(function (field, mapper, query) {
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapField, mapper, field), query);
  });
  var $author$project$Api$Schema$withMaybeUuid = F3(function (field, tag, query) {
    return A3($author$project$Api$Schema$withMap, field, $elm$core$Maybe$map(function (_v0) {
      var id = _v0;
      return tag(id);
    }), query);
  });
  var $author$project$Api$Schema$topScenario = A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Company_top_scenario$budget_scenario_id, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Company_top_scenario$base_scenario_id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (bsId, bdsid) {
    return {
      kv: bsId,
      ky: bdsid
    };
  }))));

  var $author$project$Api$GraphqlSchema$Object$Company$top_scenarios = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'top_scenarios', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$Schema$company = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$reporting_currency, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$reporting_wk_ending, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$size, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$top_scenarios($author$project$Api$Schema$topScenario), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$timezoneDetails, $elm$core$Basics$identity, $author$project$Api$Schema$timeZone), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$reporting_default_interval, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$inter_division_show_both_tx, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_street, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_postal_code, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_number, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_gmaps_place_uid, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_country_subdivision_code, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_country($author$project$Api$Schema$country), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Maybe$Just, $author$project$Api$GraphqlSchema$Object$Company$address_city), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$created_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$id, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(function (companyId) {
    return function (name) {
      return function (createdAt) {
        return function (addressCity) {
          return function (countryVal) {
            return function (countrySubdivisionCode) {
              return function (placesId) {
                return function (addressNo) {
                  return function (placesCode) {
                    return function (addressStreet) {
                      return function (interDivision) {
                        return function (reporting) {
                          return function (timeZoneDetails) {
                            return function (topScenarios) {
                              return function (size) {
                                return function (reportingWeekEnding) {
                                  return function (reportingCurrency) {
                                    return {
                                      bW: {
                                        pu: addressCity,
                                        pF: $elm$core$Maybe$Just(countryVal),
                                        pH: countrySubdivisionCode,
                                        qD: placesId,
                                        rE: addressNo,
                                        sF: $elm$core$Maybe$Just(placesCode),
                                        tI: addressStreet
                                      },
                                      pa: A2($elm$core$Maybe$andThen, function ($) {
                                        return $.kv;
                                      }, topScenarios),
                                      pe: A2($elm$core$Maybe$andThen, function ($) {
                                        return $.ky;
                                      }, topScenarios),
                                      pg: $krisajenkins$remotedata$RemoteData$NotAsked,
                                      iK: createdAt,
                                      eO: $krisajenkins$remotedata$RemoteData$NotAsked,
                                      F: $author$project$Api$Schema$uuidToString(companyId),
                                      b_: interDivision,
                                      q_: $krisajenkins$remotedata$RemoteData$NotAsked,
                                      zL: name,
                                      b0: reportingCurrency,
                                      b1: reporting,
                                      b2: $author$project$Api$Util$toWeekdayFromInt(reportingWeekEnding),
                                      nT: $krisajenkins$remotedata$RemoteData$NotAsked,
                                      db: $krisajenkins$remotedata$RemoteData$NotAsked,
                                      ti: $krisajenkins$remotedata$RemoteData$NotAsked,
                                      aB: size,
                                      t$: timeZoneDetails
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  }))))))))))))))))));
  var $author$project$Api$GraphqlSchema$Object$User_company$role = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Role_enum.Role_enum', 'role', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Role_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$User_company$user_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'user_id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Schema$withUuid = F3(function (field, tag, query) {
    return A3($author$project$Api$Schema$withMap, field, function (_v0) {
      var id = _v0;
      return tag(id);
    }, query);
  });
  var $author$project$Api$Schema$userCompanyWithData = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User_company$role, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User_company$company($author$project$Api$Schema$company), A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$User_company$user_id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserCompany$UserCompanyWithData))));
  var $author$project$Types$UserCompany$UserCompany = F3(function (userId, companyId, role) {
    return {
      b9: companyId,
      gz: role,
      oD: userId
    };
  });

  var $author$project$Types$UserCompany$userCompanyWithDataToUserCompany = function (_v0) {
    var userId = _v0.oD;
    var company = _v0.j;
    var role = _v0.gz;
    return A3($author$project$Types$UserCompany$UserCompany, userId, company.F, role);
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$bool(value));
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(function (enumToString, value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(enumToString(value));
  });

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$list = F2(function (toValue, value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$List(A2($elm$core$List$map, toValue, value));
  });

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(A2($elm$core$List$filterMap, function (_v0) {
      var key = _v0.a;
      var value = _v0.b;

      if (!value.$) {
        var actualValue = value.a;
        return $elm$core$Maybe$Just(_Utils_Tuple2(key, actualValue));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, maybeValues));
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(function (optionalValue, toValue) {
    switch (optionalValue.$) {
      case 0:
        var value = optionalValue.a;
        return $elm$core$Maybe$Just(toValue(value));

      case 1:
        return $elm$core$Maybe$Nothing;

      default:
        return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
    }
  });

  var $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'CASH';

      case 1:
        return 'CREDIT_CARD';

      default:
        return 'LOC';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_subtype_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString = function (enum____) {
    if (!enum____) {
      return 'CASH';
    } else {
      return 'CREDIT';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_type_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Accounting_system_enum$toString = function (enum____) {
    if (!enum____) {
      return 'QUICKBOOKS_ONLINE';
    } else {
      return 'XERO';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Accounting_system_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Accounting_system_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Accounting_system_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Accounting_system_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString = function (enum____) {
    if (!enum____) {
      return 'ACCRUAL';
    } else {
      return 'CASH';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasis_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Basis_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Basis_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Basis_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Basis_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString = function (enum____) {
    if (!enum____) {
      return 'MONEY';
    } else {
      return 'THING';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_of_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Block_type_enum$toString = function (enum____) {
    if (!enum____) {
      return 'BASIC';
    } else {
      return 'DERIVATIVE';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_type_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_type_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_type_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_type_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_type_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Comment_status_enum$toString = function (enum____) {
    if (!enum____) {
      return 'ACTIVE';
    } else {
      return 'ARCHIVED';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_status_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_status_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_status_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_status_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_status_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'L';

      case 1:
        return 'M';

      case 2:
        return 'S';

      case 3:
        return 'XL';

      default:
        return 'XXL';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCompany_size_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_ilike', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))), _Utils_Tuple2('_iregex', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_like', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ge, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_nilike', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gk, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))), _Utils_Tuple2('_niregex', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_nlike', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gm, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_nregex', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gn, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_nsimilar', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.go, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_regex', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gv, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('_similar', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCountry_bool_exp = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCountry_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCountry_bool_exp))), _Utils_Tuple2('code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pw, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('full_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xP, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_bool_exp = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_bool_exp))), _Utils_Tuple2('code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pw, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('country_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cB, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('full_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xP, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString = function (enum____) {
    return 'USD';
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCurrency_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Currency_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Currency_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Currency_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Currency_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.el;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$toString = function (enum____) {
    if (!enum____) {
      return 'ALLOCATION_CLASS';
    } else {
      return 'BLOCK';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_of_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$toString))))]));
  };

  var $elm$json$Json$Encode$float = _Json_wrap;

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$float = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$float(value));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeFloat_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$float))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$float)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'MONTH';

      case 1:
        return 'QUARTER';

      case 2:
        return 'WEEK';

      default:
        return 'YEAR';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_period_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInt4_comparison_exp_ = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.em;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$int = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$int(value));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Invite_status_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'PENDING';

      case 1:
        return 'REDEEMED';

      default:
        return 'REVOKED';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInvite_status_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Invite_status_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Invite_status_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Invite_status_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Invite_status_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.en;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'DAY';

      case 1:
        return 'HALF_MONTH';

      case 2:
        return 'MONTH';

      case 3:
        return 'QUARTER';

      case 4:
        return 'WEEK';

      default:
        return 'YEAR';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_period_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString = function (enum____) {
    if (!enum____) {
      return 'MONTHLY';
    } else {
      return 'WEEKLY';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReporting_interval_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Review_status_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'PENDING';

      case 1:
        return 'PUBLISHED';

      default:
        return 'REVIEW';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReview_status_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Review_status_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Review_status_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Review_status_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Review_status_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Role_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'ACCOUNT_ANALYST';

      case 1:
        return 'ACCOUNT_MANAGER';

      case 2:
        return 'ADMIN';

      case 3:
        return 'ANONYMOUS';

      case 4:
        return 'BIZ_ADMIN';

      case 5:
        return 'BIZ_OWNER';

      case 6:
        return 'BIZ_VIEWER';

      default:
        return 'USER';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeRole_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Role_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Role_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Role_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Role_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Sync_status_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'ERROR';

      case 1:
        return 'PENDING';

      default:
        return 'SYNCED';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSync_status_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Sync_status_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Sync_status_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Sync_status_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Sync_status_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'ASSET';

      case 1:
        return 'EQUITY';

      case 2:
        return 'EXPENSE_COGS';

      case 3:
        return 'EXPENSE_OPERATING';

      case 4:
        return 'EXPENSE_OTHER';

      case 5:
        return 'INCOME';

      case 6:
        return 'INCOME_OTHER';

      default:
        return 'LIABILITY';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSystem_allocation_class_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Time_transform_algorithm_enum$toString = function (enum____) {
    if (!enum____) {
      return 'DAYS';
    } else {
      return 'SMART';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_algorithm_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_algorithm_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_algorithm_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_algorithm_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_algorithm_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'AMOUNT';

      case 1:
        return 'AMOUNT_FIXED';

      default:
        return 'PERCENT';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_unit_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Time_transform_relative_to_enum$toString = function (enum____) {
    if (!enum____) {
      return 'PERIOD_END';
    } else {
      return 'PERIOD_START';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_relative_to_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_relative_to_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_relative_to_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_relative_to_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_relative_to_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eo;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ep;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Update_type_enum$toString = function (enum____) {
    if (!enum____) {
      return 'SYSTEM';
    } else {
      return 'USER';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdate_type_enum_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Update_type_enum$toString))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Update_type_enum$toString)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Update_type_enum$toString))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Update_type_enum$toString))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_eq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_gte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.H, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_in', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('_is_null', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('_lt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.I, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_lte', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_neq', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('_nin', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp = function (_v28) {
    var input____ = _v28;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp))), _Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o$, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp = function (_v27) {
    var input____ = _v27;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp))), _Utils_Tuple2('accounting_system_account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aG, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp)), _Utils_Tuple2('allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ag, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('balances', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('currency', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bq, $author$project$Api$GraphqlSchema$InputObject$encodeCurrency_enum_comparison_exp)), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('last_balance_update_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('last_balance_update_by_system', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a5, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('last_balance_update_by_type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Api$GraphqlSchema$InputObject$encodeUpdate_type_enum_comparison_exp)), _Utils_Tuple2('last_balance_update_by_user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a6, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('subtype', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bn, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_subtype_enum_comparison_exp)), _Utils_Tuple2('type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_type_enum_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp = function (_v26) {
    var input____ = _v26;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp))), _Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('accounting_system_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aH, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp)), _Utils_Tuple2('accounting_system_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('accounting_system_division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.af, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp)), _Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp = function (_v25) {
    var input____ = _v25;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp))), _Utils_Tuple2('accounting_system_account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aG, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp)), _Utils_Tuple2('accounting_system_division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.af, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp)), _Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ag, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp = function (_v24) {
    var input____ = _v24;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp))), _Utils_Tuple2('access_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('access_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aF, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('accounting_system_accounts', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fk, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_bool_exp)), _Utils_Tuple2('accounting_system_classes', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fm, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp)), _Utils_Tuple2('accounting_system_integration', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cg, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_bool_exp)), _Utils_Tuple2('accounting_system_integration_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aJ, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('connected_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aU, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('last_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a8, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('last_sync_attempt_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a9, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('next_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ba, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('refresh_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bf, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('refresh_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bg, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('sync_enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dh, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('sync_status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.di, $author$project$Api$GraphqlSchema$InputObject$encodeSync_status_enum_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_bool_exp = function (_v23) {
    var input____ = _v23;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_bool_exp))), _Utils_Tuple2('accounting_system', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cf, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_enum_comparison_exp)), _Utils_Tuple2('accounting_system_divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fo, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp = function (_v22) {
    var input____ = _v22;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp))), _Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('accounting_system_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aH, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('fqcn', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('parent', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('parent_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bb, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('system_allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dj, $author$project$Api$GraphqlSchema$InputObject$encodeSystem_allocation_class_enum_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp = function (_v21) {
    var input____ = _v21;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp))), _Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('growth_pattern', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cP, $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_bool_exp)), _Utils_Tuple2('growth_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aj, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp)), _Utils_Tuple2('repeat_pattern', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_bool_exp)), _Utils_Tuple2('repeat_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bh, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('seasonality', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bK, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp)), _Utils_Tuple2('seasonality_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bl, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('thing_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.al, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp = function (_v20) {
    var input____ = _v20;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp))), _Utils_Tuple2('basic_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cu, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('derivative_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aX, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aj, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('of', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_of_enum_comparison_exp)), _Utils_Tuple2('scenarios', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.db, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp)), _Utils_Tuple2('start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('thing_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.al, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp)), _Utils_Tuple2('type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_type_enum_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp = function (_v19) {
    var input____ = _v19;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp))), _Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('comment_divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fM, $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('createdBy', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cC, $author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('date_from', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aV, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('date_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('replyTo', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bi, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)), _Utils_Tuple2('reply_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bj, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('review', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c7, $author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp)), _Utils_Tuple2('review_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bk, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dw, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $author$project$Api$GraphqlSchema$InputObject$encodeComment_status_enum_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_bool_exp = function (_v18) {
    var input____ = _v18;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeComment_division_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeComment_division_bool_exp))), _Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)), _Utils_Tuple2('comment_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aT, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp = function (_v17) {
    var input____ = _v17;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp))), _Utils_Tuple2('accounting_system_integrations', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fq, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_bool_exp)), _Utils_Tuple2('accounts', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ch, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('address_city', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bz, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('address_country', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cj, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_bool_exp)), _Utils_Tuple2('address_country_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bA, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('address_country_subdivision', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ck, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_bool_exp)), _Utils_Tuple2('address_country_subdivision_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bB, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('address_gmaps_place_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bC, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('address_number', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bD, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('address_postal_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bE, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('address_street', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bF, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('allocation_classes', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cm, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('blocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.vk, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('comments', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bH, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eO, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('inter_division_show_both_tx', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cQ, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('invites', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f4, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('reporting_currency', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c4, $author$project$Api$GraphqlSchema$InputObject$encodeCurrency_enum_comparison_exp)), _Utils_Tuple2('reporting_default_interval', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Api$GraphqlSchema$InputObject$encodeReporting_interval_enum_comparison_exp)), _Utils_Tuple2('reporting_wk_ending', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c6, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('reviews', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c9, $author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp)), _Utils_Tuple2('scenarios', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.db, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('seasonalities', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gA, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp)), _Utils_Tuple2('size', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aB, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_size_enum_comparison_exp)), _Utils_Tuple2('timezone', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dm, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('top_scenarios', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.$7, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_bool_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('user_companies', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ds, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_bool_exp = function (_v16) {
    var input____ = _v16;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_bool_exp))), _Utils_Tuple2('base_scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cr, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('base_scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cs, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('budget_scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cz, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('budget_scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cA, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp = function (_v15) {
    var input____ = _v15;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp))), _Utils_Tuple2('base_allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.co, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('base_allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aP, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('base_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cq, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('base_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aQ, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('derivative_money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cE, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_bool_exp)), _Utils_Tuple2('derivative_of', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cF, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_of_enum_comparison_exp)), _Utils_Tuple2('end_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aj, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp)), _Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $author$project$Api$GraphqlSchema$InputObject$encodeFloat_comparison_exp)), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $author$project$Api$GraphqlSchema$InputObject$encodeFloat_comparison_exp)), _Utils_Tuple2('thing_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.al, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp)), _Utils_Tuple2('time_transform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bo, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp)), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_bool_exp = function (_v14) {
    var input____ = _v14;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_bool_exp))), _Utils_Tuple2('base_basis', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cp, $author$project$Api$GraphqlSchema$InputObject$encodeBasis_enum_comparison_exp)), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('derivative_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aX, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp = function (_v13) {
    var input____ = _v13;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp))), _Utils_Tuple2('accounting_system_division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.af, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_bool_exp)), _Utils_Tuple2('accounts', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ch, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('allocation_classes', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cm, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('industry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.an, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_bool_exp = function (_v12) {
    var input____ = _v12;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_bool_exp))), _Utils_Tuple2('basic_blocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cv, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp)), _Utils_Tuple2('every', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ao, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('period', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ap, $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_period_enum_comparison_exp)), _Utils_Tuple2('rate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bR, $author$project$Api$GraphqlSchema$InputObject$encodeFloat_comparison_exp)), _Utils_Tuple2('start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp = function (_v11) {
    var input____ = _v11;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('expires_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('first_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ah, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('last_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ai, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('last_sent_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a7, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('redeemed_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.be, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamp_comparison_exp)), _Utils_Tuple2('role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gz, $author$project$Api$GraphqlSchema$InputObject$encodeRole_enum_comparison_exp)), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_status_enum_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fl, $author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp)), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp = function (_v10) {
    var input____ = _v10;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp))), _Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ag, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('basis', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pb, $author$project$Api$GraphqlSchema$InputObject$encodeBasis_enum_comparison_exp)), _Utils_Tuple2('basis_transform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cx, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp)), _Utils_Tuple2('basis_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aR, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('internal', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bN, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('internal_opposite_account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)), _Utils_Tuple2('internal_opposite_account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a2, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('internal_opposite_allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cS, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)), _Utils_Tuple2('internal_opposite_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a3, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('unit', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $author$project$Api$GraphqlSchema$InputObject$encodeCurrency_enum_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_bool_exp = function (_v9) {
    var input____ = _v9;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_bool_exp))), _Utils_Tuple2('basic_blocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cv, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_bool_exp)), _Utils_Tuple2('end_at_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cJ, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('end_at_date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cK, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('every', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ao, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('period', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ap, $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_period_enum_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp = function (_v8) {
    var input____ = _v8;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp))), _Utils_Tuple2('approval_requested_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aL, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('approval_requested_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aM, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('approved_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aN, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('approved_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aO, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('comments', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bH, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dw, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $author$project$Api$GraphqlSchema$InputObject$encodeReview_status_enum_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp = function (_v7) {
    var input____ = _v7;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp))), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aS, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('quickEditOfScenarioBlock', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cZ, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp)), _Utils_Tuple2('quick_edit_of_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bc, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('quick_edit_user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bd, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dw, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp = function (_v6) {
    var input____ = _v6;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp))), _Utils_Tuple2('blocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.vk, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp)), _Utils_Tuple2('comments', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bH, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('description', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('draft', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('published', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.sQ, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('reviews', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c9, $author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp)), _Utils_Tuple2('start_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bm, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('updated_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bp, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp = function (_v5) {
    var input____ = _v5;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('month_adjustments', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cV, $author$project$Api$GraphqlSchema$InputObject$encodeInt4_comparison_exp_)), _Utils_Tuple2('preset_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Cx, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp = function (_v4) {
    var input____ = _v4;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeThing_block_bool_exp))), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('unit', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_bool_exp = function (_v3) {
    var input____ = _v3;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_bool_exp))), _Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('entered_as', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('entered_on_date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a_, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $author$project$Api$GraphqlSchema$InputObject$encodeNumeric_comparison_exp)), _Utils_Tuple2('relative_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_relative_to_enum_comparison_exp)), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $author$project$Api$GraphqlSchema$InputObject$encodeInt_comparison_exp)), _Utils_Tuple2('time_transform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bo, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp)), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('unit', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_unit_enum_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp = function (_v2) {
    var input____ = _v2;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_bool_exp))), _Utils_Tuple2('algorithm', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cl, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_algorithm_enum_comparison_exp)), _Utils_Tuple2('allocations', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dw, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_bool_exp)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('derivative_blocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fQ, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_bool_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('money_blocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gg, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_bool_exp)), _Utils_Tuple2('ref_interval_end_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c0, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('ref_interval_start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Api$GraphqlSchema$InputObject$encodeDate_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp = function (_v1) {
    var input____ = _v1;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('first_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ah, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('global_role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cO, $author$project$Api$GraphqlSchema$InputObject$encodeRole_enum_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('last_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ai, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('phone_number', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cX, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('photo_url', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cY, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Api$GraphqlSchema$InputObject$encodeTimestamptz_comparison_exp)), _Utils_Tuple2('user_companies', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ds, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_bool_exp)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('external', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xF, $author$project$Api$GraphqlSchema$InputObject$encodeBoolean_comparison_exp)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp)), _Utils_Tuple2('role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gz, $author$project$Api$GraphqlSchema$InputObject$encodeRole_enum_comparison_exp)), _Utils_Tuple2('user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fl, $author$project$Api$GraphqlSchema$InputObject$encodeUser_bool_exp)), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $author$project$Api$GraphqlSchema$InputObject$encodeUuid_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Order_by$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'asc';

      case 1:
        return 'asc_nulls_first';

      case 2:
        return 'asc_nulls_last';

      case 3:
        return 'desc';

      case 4:
        return 'desc_nulls_first';

      default:
        return 'desc_nulls_last';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_system', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a6, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_system', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a6, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('fqcn', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('parent_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('fqcn', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('parent_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('date_from', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('date_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reply_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('review_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bk, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('date_from', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('date_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reply_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('review_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bk, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeComment_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeComment_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCountry_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pw, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('full_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pw, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('country_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cB, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('full_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('industry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.an, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('industry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.an, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInvite_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('expires_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('first_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ah, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ai, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sent_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('redeemed_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.be, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInvite_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('expires_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('first_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ah, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ai, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sent_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('redeemed_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.be, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeInvite_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReview_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('approval_requested_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approval_requested_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aM, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approved_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approved_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReview_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('approval_requested_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approval_requested_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aM, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approved_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approved_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReview_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeReview_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeReview_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('description', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('start_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bm, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bp, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('description', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('start_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bm, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bp, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aS, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('quick_edit_of_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('quick_edit_user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aS, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('quick_edit_of_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('quick_edit_user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('preset_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Cx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('preset_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Cx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by = function (_v2) {
    var input____ = _v2;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system_integrations_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fr, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_aggregate_order_by)), _Utils_Tuple2('accounts_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ci, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_aggregate_order_by)), _Utils_Tuple2('address_city', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('address_country', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cj, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_order_by)), _Utils_Tuple2('address_country_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bA, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('address_country_subdivision', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ck, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_subdivision_order_by)), _Utils_Tuple2('address_country_subdivision_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bB, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('address_gmaps_place_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('address_number', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('address_postal_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('address_street', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_classes_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cn, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_aggregate_order_by)), _Utils_Tuple2('blocks_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cy, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_aggregate_order_by)), _Utils_Tuple2('comments_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bI, $author$project$Api$GraphqlSchema$InputObject$encodeComment_aggregate_order_by)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('divisions_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fS, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_aggregate_order_by)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('inter_division_show_both_tx', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('invites_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f5, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_aggregate_order_by)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reporting_currency', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reporting_default_interval', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reporting_wk_ending', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c6, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reviews_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.da, $author$project$Api$GraphqlSchema$InputObject$encodeReview_aggregate_order_by)), _Utils_Tuple2('scenarios_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dc, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_aggregate_order_by)), _Utils_Tuple2('seasonalities_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gB, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_aggregate_order_by)), _Utils_Tuple2('size', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aB, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('timezone', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dm, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('top_scenarios', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.$7, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_order_by)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_companies_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dt, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_aggregate_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCompany_top_scenario_order_by = function (_v1) {
    var input____ = _v1;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cr, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), _Utils_Tuple2('base_scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('budget_scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cz, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), _Utils_Tuple2('budget_scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cA, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blocks_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cy, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_aggregate_order_by)), _Utils_Tuple2('comments_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bI, $author$project$Api$GraphqlSchema$InputObject$encodeComment_aggregate_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('description', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('draft', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('published', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.sQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('reviews_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.da, $author$project$Api$GraphqlSchema$InputObject$encodeReview_aggregate_order_by)), _Utils_Tuple2('start_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bm, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bp, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('first_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ah, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('global_role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ai, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('phone_number', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cX, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('photo_url', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_companies_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dt, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_aggregate_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('external', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fl, $author$project$Api$GraphqlSchema$InputObject$encodeUser_order_by)), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$User_company_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'external';

      case 2:
        return 'id';

      case 3:
        return 'role';

      default:
        return 'user_id';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$User$user_companies = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$User_company_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUser_company_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user_companies', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Schema$userWithCompanies = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$User$user_companies, $elm$core$Basics$identity, $author$project$Api$Schema$userCompanyWithData), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User$global_role, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$Schema$user, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F3(function (userData, role, companies) {
    return {
      v5: $author$project$Types$Company$toCompanyDict(A2($elm$core$List$map, function ($) {
        return $.j;
      }, companies)),
      x_: role,
      Fl: userData,
      ue: A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Company$unwrapCompanyId, A2($elm$core$List$map, function (uc) {
        return _Utils_Tuple2(uc.j.F, $author$project$Types$UserCompany$userCompanyWithDataToUserCompany(uc));
      }, companies))
    };
  })))));
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(function (fieldName, raw, encode) {
    return A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, encode(raw));
  });
  var $author$project$Api$GraphqlSchema$Query$user_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });

  var $author$project$Api$Schema$uuidFromString = function (value) {
    return value;
  };

  var $author$project$Api$Api$getApiUserWithCompanies = F3(function (apiEndpoint, idToken, _v0) {
    var userId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$user_by_pk, {
      F: $author$project$Api$Schema$uuidFromString(userId)
    }, $author$project$Api$Schema$userWithCompanies));
  });
  var $author$project$Types$User$emptyUserDict = $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$User$unwrapUserId);
  var $author$project$ElmFramework$Lib$PivotDict$PivotDict = $elm$core$Basics$identity;

  var $author$project$ElmFramework$Lib$Util$uniq = function (list) {
    var consIfNotMember = F2(function (el, subList) {
      return A2($elm$core$List$member, el, subList) ? subList : A2($elm$core$List$cons, el, subList);
    });
    return A3($elm$core$List$foldr, consIfNotMember, _List_Nil, list);
  };

  var $author$project$ElmFramework$Lib$PivotDict$fromList = function (cfg) {
    var toSubDictId2 = function (id) {
      var toPair = function (rec) {
        return _Utils_eq(cfg.eE(rec), id) ? $elm$core$Maybe$Just(_Utils_Tuple2(cfg.eF(rec), rec)) : $elm$core$Maybe$Nothing;
      };

      return A2($turboMaCk$any_dict$Dict$Any$fromList, cfg.eB, A2($elm$core$List$filterMap, toPair, cfg.aA));
    };

    var toSubDictId1 = function (id) {
      var toPair = function (rec) {
        return _Utils_eq(cfg.eF(rec), id) ? $elm$core$Maybe$Just(_Utils_Tuple2(cfg.eE(rec), rec)) : $elm$core$Maybe$Nothing;
      };

      return A2($turboMaCk$any_dict$Dict$Any$fromList, cfg.d8, A2($elm$core$List$filterMap, toPair, cfg.aA));
    };

    return {
      cG: A2($turboMaCk$any_dict$Dict$Any$fromList, cfg.d8, A2($elm$core$List$map, function (id1) {
        return _Utils_Tuple2(id1, toSubDictId2(id1));
      }, $author$project$ElmFramework$Lib$Util$uniq(A2($elm$core$List$map, cfg.eE, cfg.aA)))),
      dz: A2($turboMaCk$any_dict$Dict$Any$fromList, cfg.eB, A2($elm$core$List$map, function (id2) {
        return _Utils_Tuple2(id2, toSubDictId1(id2));
      }, $author$project$ElmFramework$Lib$Util$uniq(A2($elm$core$List$map, cfg.eF, cfg.aA)))),
      d8: cfg.d8,
      eB: cfg.eB,
      eE: cfg.eE,
      eF: cfg.eF
    };
  };

  var $elm$core$Dict$values = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, valueList) {
      return A2($elm$core$List$cons, value, valueList);
    }), _List_Nil, dict);
  };

  var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
    var dict = _v0.bT;
    return $elm$core$Dict$values(dict);
  };

  var $turboMaCk$any_dict$Dict$Any$values = A2($elm$core$Basics$composeL, $elm$core$List$map($elm$core$Tuple$second), $turboMaCk$any_dict$Dict$Any$toList);
  var $author$project$Types$UserSession$toSessionFromUserWithCompanies = F2(function (auth, _v0) {
    var user = _v0.Fl;
    var globalRole = _v0.x_;
    var userCompanies = _v0.ue;
    var companies = _v0.v5;
    return {
      u_: auth,
      v5: companies,
      x_: globalRole,
      Fl: user,
      ue: $author$project$ElmFramework$Lib$PivotDict$fromList({
        aA: $turboMaCk$any_dict$Dict$Any$values(userCompanies),
        d8: $author$project$Types$User$unwrapUserId,
        eB: $author$project$Types$Company$unwrapCompanyId,
        eE: function ($) {
          return $.oD;
        },
        eF: function ($) {
          return $.b9;
        }
      }),
      Ft: $author$project$Types$User$emptyUserDict
    };
  });
  var $author$project$Types$UserSession$RefreshToken = $elm$core$Basics$identity;

  var $author$project$Types$UserSession$wrapAuth = function (authRaw) {
    return {
      hr: authRaw.hr,
      d5: authRaw.d5,
      e6: authRaw.e6
    };
  };

  var $author$project$Api$Api$getUserSession = F3(function (apiEndpoint, authRaw, userInfo) {
    var idToken = authRaw.d5;
    var refreshToken = authRaw.e6;
    var expiresIn = authRaw.hr;

    var resultToUserSession = function (maybeUser) {
      if (maybeUser.$ === 1) {
        return $elm$core$Task$fail('Unable to connect to backend, please try again or contact support');
      } else {
        var userWithCompanies = maybeUser.a;
        return $elm$core$Task$succeed(A2($author$project$Types$UserSession$toSessionFromUserWithCompanies, $author$project$Types$UserSession$wrapAuth(authRaw), userWithCompanies));
      }
    };

    return A2($elm$core$Task$andThen, function (maybeUserId) {
      if (maybeUserId.$ === 1) {
        return $elm$core$Task$fail('Unable to connect to backend, please try again or contact support');
      } else {
        var uId = maybeUserId.a;
        return A2($elm$core$Task$andThen, resultToUserSession, A2($elm$core$Task$mapError, $elm$core$Basics$always('Unable to connect to backend, please try again or contact support'), A3($author$project$Api$Api$getApiUserWithCompanies, apiEndpoint, idToken, uId)));
      }
    }, A2($elm$core$Task$mapError, $elm$core$Basics$always('Unable to connect to backend, please try again or contact support '), A2($author$project$Api$Api$getApiUser, apiEndpoint, idToken)));
  });
  var $elm$json$Json$Decode$at = F2(function (fields, decoder) {
    return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
  });

  var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$core$Result$andThen = F2(function (callback, result) {
    if (!result.$) {
      var value = result.a;
      return callback(value);
    } else {
      var msg = result.a;
      return $elm$core$Result$Err(msg);
    }
  });
  var $simonh1000$elm_jwt$Jwt$TokenHeaderError = {
    $: 2
  };

  var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $truqu$elm_base64$Base64$Decode$pad = function (input) {
    var _v0 = $elm$core$String$length(input) % 4;

    switch (_v0) {
      case 3:
        return input + '=';

      case 2:
        return input + '==';

      default:
        return input;
    }
  };

  var $truqu$elm_base64$Base64$Decode$charToInt = function (_char) {
    switch (_char) {
      case 'A':
        return 0;

      case 'B':
        return 1;

      case 'C':
        return 2;

      case 'D':
        return 3;

      case 'E':
        return 4;

      case 'F':
        return 5;

      case 'G':
        return 6;

      case 'H':
        return 7;

      case 'I':
        return 8;

      case 'J':
        return 9;

      case 'K':
        return 10;

      case 'L':
        return 11;

      case 'M':
        return 12;

      case 'N':
        return 13;

      case 'O':
        return 14;

      case 'P':
        return 15;

      case 'Q':
        return 16;

      case 'R':
        return 17;

      case 'S':
        return 18;

      case 'T':
        return 19;

      case 'U':
        return 20;

      case 'V':
        return 21;

      case 'W':
        return 22;

      case 'X':
        return 23;

      case 'Y':
        return 24;

      case 'Z':
        return 25;

      case 'a':
        return 26;

      case 'b':
        return 27;

      case 'c':
        return 28;

      case 'd':
        return 29;

      case 'e':
        return 30;

      case 'f':
        return 31;

      case 'g':
        return 32;

      case 'h':
        return 33;

      case 'i':
        return 34;

      case 'j':
        return 35;

      case 'k':
        return 36;

      case 'l':
        return 37;

      case 'm':
        return 38;

      case 'n':
        return 39;

      case 'o':
        return 40;

      case 'p':
        return 41;

      case 'q':
        return 42;

      case 'r':
        return 43;

      case 's':
        return 44;

      case 't':
        return 45;

      case 'u':
        return 46;

      case 'v':
        return 47;

      case 'w':
        return 48;

      case 'x':
        return 49;

      case 'y':
        return 50;

      case 'z':
        return 51;

      case '0':
        return 52;

      case '1':
        return 53;

      case '2':
        return 54;

      case '3':
        return 55;

      case '4':
        return 56;

      case '5':
        return 57;

      case '6':
        return 58;

      case '7':
        return 59;

      case '8':
        return 60;

      case '9':
        return 61;

      case '+':
        return 62;

      case '/':
        return 63;

      default:
        return 0;
    }
  };

  var $truqu$elm_base64$Base64$Decode$intToString = A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar);
  var $truqu$elm_base64$Base64$Decode$add = F2(function (_char, _v0) {
    var curr = _v0.a;
    var need = _v0.b;
    var res = _v0.c;

    var shiftAndAdd = function (_int) {
      return 63 & _int | curr << 6;
    };

    return !need ? !(128 & _char) ? _Utils_Tuple3(0, 0, _Utils_ap(res, $truqu$elm_base64$Base64$Decode$intToString(_char))) : (224 & _char) === 192 ? _Utils_Tuple3(31 & _char, 1, res) : (240 & _char) === 224 ? _Utils_Tuple3(15 & _char, 2, res) : _Utils_Tuple3(7 & _char, 3, res) : need === 1 ? _Utils_Tuple3(0, 0, _Utils_ap(res, $truqu$elm_base64$Base64$Decode$intToString(shiftAndAdd(_char)))) : _Utils_Tuple3(shiftAndAdd(_char), need - 1, res);
  });
  var $truqu$elm_base64$Base64$Decode$toUTF16 = F2(function (_char, acc) {
    return _Utils_Tuple3(0, 0, A2($truqu$elm_base64$Base64$Decode$add, 255 & _char >>> 0, A2($truqu$elm_base64$Base64$Decode$add, 255 & _char >>> 8, A2($truqu$elm_base64$Base64$Decode$add, 255 & _char >>> 16, acc))));
  });
  var $truqu$elm_base64$Base64$Decode$chomp = F2(function (char_, _v0) {
    var curr = _v0.a;
    var cnt = _v0.b;
    var utf8ToUtf16 = _v0.c;

    var _char = $truqu$elm_base64$Base64$Decode$charToInt(char_);

    if (cnt === 3) {
      return A2($truqu$elm_base64$Base64$Decode$toUTF16, curr | _char, utf8ToUtf16);
    } else {
      return _Utils_Tuple3(_char << (3 - cnt) * 6 | curr, cnt + 1, utf8ToUtf16);
    }
  });

  var $truqu$elm_base64$Base64$Decode$initial = _Utils_Tuple3(0, 0, _Utils_Tuple3(0, 0, ''));

  var $elm$core$String$endsWith = _String_endsWith;
  var $truqu$elm_base64$Base64$Decode$stripNulls = F2(function (input, output) {
    return A2($elm$core$String$endsWith, '==', input) ? A2($elm$core$String$dropRight, 2, output) : A2($elm$core$String$endsWith, '=', input) ? A2($elm$core$String$dropRight, 1, output) : output;
  });
  var $elm$regex$Regex$contains = _Regex_contains;
  var $truqu$elm_base64$Base64$Decode$validBase64Regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $elm$regex$Regex$fromString('^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$'));

  var $truqu$elm_base64$Base64$Decode$validate = function (input) {
    return A2($elm$regex$Regex$contains, $truqu$elm_base64$Base64$Decode$validBase64Regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err('Invalid base64');
  };

  var $truqu$elm_base64$Base64$Decode$wrapUp = function (_v0) {
    var _v1 = _v0.c;
    var need = _v1.b;
    var res = _v1.c;
    return need > 0 ? $elm$core$Result$Err('Invalid UTF-16') : $elm$core$Result$Ok(res);
  };

  var $truqu$elm_base64$Base64$Decode$validateAndDecode = function (input) {
    return A2($elm$core$Result$map, $truqu$elm_base64$Base64$Decode$stripNulls(input), A2($elm$core$Result$andThen, A2($elm$core$Basics$composeR, A2($elm$core$String$foldl, $truqu$elm_base64$Base64$Decode$chomp, $truqu$elm_base64$Base64$Decode$initial), $truqu$elm_base64$Base64$Decode$wrapUp), $truqu$elm_base64$Base64$Decode$validate(input)));
  };

  var $truqu$elm_base64$Base64$Decode$decode = A2($elm$core$Basics$composeR, $truqu$elm_base64$Base64$Decode$pad, $truqu$elm_base64$Base64$Decode$validateAndDecode);
  var $truqu$elm_base64$Base64$decode = $truqu$elm_base64$Base64$Decode$decode;

  var $simonh1000$elm_jwt$Jwt$fixlength = function (s) {
    var _v0 = A2($elm$core$Basics$modBy, 4, $elm$core$String$length(s));

    switch (_v0) {
      case 0:
        return $elm$core$Result$Ok(s);

      case 2:
        return $elm$core$Result$Ok($elm$core$String$concat(_List_fromArray([s, '=='])));

      case 3:
        return $elm$core$Result$Ok($elm$core$String$concat(_List_fromArray([s, '='])));

      default:
        return $elm$core$Result$Err($simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
    }
  };

  var $elm$core$Result$map2 = F3(function (func, ra, rb) {
    if (ra.$ === 1) {
      var x = ra.a;
      return $elm$core$Result$Err(x);
    } else {
      var a = ra.a;

      if (rb.$ === 1) {
        var x = rb.a;
        return $elm$core$Result$Err(x);
      } else {
        var b = rb.a;
        return $elm$core$Result$Ok(A2(func, a, b));
      }
    }
  });
  var $elm$core$String$map = _String_map;

  var $simonh1000$elm_jwt$Jwt$unurl = function () {
    var fix = function (c) {
      switch (c) {
        case '-':
          return '+';

        case '_':
          return '/';

        default:
          return c;
      }
    };

    return $elm$core$String$map(fix);
  }();

  var $simonh1000$elm_jwt$Jwt$getTokenParts = function (token) {
    var verifyJson = F2(function (errorHandler, str) {
      return A2($elm$core$Result$mapError, errorHandler, A2($elm$core$Result$map, function (_v9) {
        return str;
      }, A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, str)));
    });
    var processor = A2($elm$core$Basics$composeR, $simonh1000$elm_jwt$Jwt$unurl, A2($elm$core$Basics$composeR, $elm$core$String$split('.'), $elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));

    var _v0 = processor(token);

    _v0$1: while (true) {
      if (_v0.b && _v0.b.b && _v0.b.b.b && !_v0.b.b.b.b) {
        if (!_v0.a.$) {
          if (!_v0.b.a.$) {
            var header = _v0.a.a;
            var _v1 = _v0.b;
            var body = _v1.a.a;
            var _v2 = _v1.b;
            var header_ = A2($elm$core$Result$andThen, verifyJson(function (_v4) {
              return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
            }), A2($elm$core$Result$mapError, function (_v3) {
              return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
            }, $truqu$elm_base64$Base64$decode(header)));
            var body_ = A2($elm$core$Result$andThen, verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError), A2($elm$core$Result$mapError, $simonh1000$elm_jwt$Jwt$TokenProcessingError, $truqu$elm_base64$Base64$decode(body)));
            return A3($elm$core$Result$map2, F2(function (a, b) {
              return _Utils_Tuple2(a, b);
            }), header_, body_);
          } else {
            break _v0$1;
          }
        } else {
          if (_v0.b.a.$ === 1) {
            break _v0$1;
          } else {
            var err = _v0.a.a;
            var _v7 = _v0.b;
            var _v8 = _v7.b;
            return $elm$core$Result$Err(err);
          }
        }
      } else {
        return $elm$core$Result$Err($simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
      }
    }

    var _v5 = _v0.b;
    var err = _v5.a.a;
    var _v6 = _v5.b;
    return $elm$core$Result$Err(err);
  };

  var $simonh1000$elm_jwt$Jwt$decodeToken = F2(function (dec, token) {
    return A2($elm$core$Result$andThen, A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeString(dec), $elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)), A2($elm$core$Result$map, $elm$core$Tuple$second, $simonh1000$elm_jwt$Jwt$getTokenParts(token)));
  });

  var $author$project$Types$User$decodeRoleFromToken = function (idToken) {
    var roleDecoder = A2($elm$json$Json$Decode$at, _List_fromArray(['https://hasura.io/jwt/claims', 'x-hasura-default-role']), $elm$json$Json$Decode$string);
    return A2($simonh1000$elm_jwt$Jwt$decodeToken, roleDecoder, idToken);
  };

  var $author$project$Types$User$hasClaims = function (idToken) {
    var _v0 = $author$project$Types$User$decodeRoleFromToken(idToken);

    if (!_v0.$) {
      var role = _v0.a;

      if (role === 'anonymous') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  var $author$project$Types$User$firstNameFromDisplayName = function (displayName) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$split(' '), A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$getAt(0), $elm$core$Maybe$withDefault(''))), displayName));
  };

  var $author$project$Types$User$lastNameFromDisplayName = function (displayName) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$split(' '), A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$getAt(1), $elm$core$Maybe$withDefault(''))), displayName));
  };

  var $author$project$Types$User$userInfoToPlainUser = function (userInfo) {
    return {
      u2: function () {
        var _v0 = userInfo.nh;

        if (!_v0.$) {
          var url = _v0.a;
          return _List_fromArray([{
            x6: 0,
            Fh: url,
            FE: 0
          }]);
        } else {
          return _List_Nil;
        }
      }(),
      iP: userInfo.iP,
      xs: userInfo.xs,
      hu: $author$project$Types$User$firstNameFromDisplayName(userInfo.k0),
      F: userInfo.oD,
      hI: $author$project$Types$User$lastNameFromDisplayName(userInfo.k0),
      ng: $elm$core$Maybe$Nothing
    };
  };

  var $author$project$Api$Api$getUserSessionStatus = function (_v0) {
    var apiKey = _v0.oY;
    var apiUrl = _v0.oZ;
    var authRaw = _v0.o0;
    var _v1 = authRaw;
    var idToken = _v1.d5;
    var refreshToken = _v1.e6;
    var expiresIn = _v1.hr;
    return A2($elm$core$Task$andThen, function (userProfile) {
      var userHasClaims = $author$project$Types$User$hasClaims(idToken);
      return userHasClaims ? A2($elm$core$Task$andThen, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $author$project$Remote$Model$Onboarded), A3($author$project$Api$Api$getUserSession, apiUrl, {
        hr: expiresIn,
        d5: idToken,
        e6: refreshToken
      }, userProfile)) : $elm$core$Task$succeed($author$project$Remote$Model$Authenticated({
        u_: $author$project$Types$UserSession$wrapAuth(A3($author$project$Types$UserSession$AuthRaw, idToken, refreshToken, expiresIn)),
        Fl: $author$project$Types$User$userInfoToPlainUser(userProfile)
      }));
    }, A2($author$project$ElmFramework$Lib$Firebase$Auth$getUserProfile, apiKey, {
      d5: idToken
    }));
  };

  var $elm$core$Set$insert = F2(function (key, _v0) {
    var dict = _v0;
    return A3($elm$core$Dict$insert, key, 0, dict);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$FetchNewTokensFromRefreshToken = 11;
  var $author$project$ElmFramework$Lib$Firebase$Auth$FetchNewTokensOutput = F4(function (userId, idToken, refreshToken, expiresIn) {
    return {
      hr: expiresIn,
      d5: idToken,
      e6: refreshToken,
      oD: userId
    };
  });

  var $author$project$ElmFramework$Lib$Firebase$Auth$decodeIntFromString = function (str) {
    var _v0 = $elm$core$String$toInt(str);

    if (_v0.$ === 1) {
      return $elm$json$Json$Decode$fail('Not an int');
    } else {
      var i = _v0.a;
      return $elm$json$Json$Decode$succeed(i);
    }
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Firebase$Auth$decodeIntFromString, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Firebase$Auth$fetchNewTokensFromRefreshToken = F2(function (apiKey, _v0) {
    var refreshToken = _v0.e6;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 11);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$FetchNewTokensOutput, A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'id_token', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refresh_token', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expires_in', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var grantType = 'refresh_token';
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('refresh_token', $elm$json$Json$Encode$string(refreshToken)), _Utils_Tuple2('grant_type', $elm$json$Json$Encode$string(grantType))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Remote$Remote$refreshTokens = F2(function (apiKey, currentRefreshToken) {
    return A2($author$project$ElmFramework$Lib$Firebase$Auth$fetchNewTokensFromRefreshToken, apiKey, {
      e6: currentRefreshToken
    });
  });
  var $author$project$Remote$Remote$requests = {
    k6: 'email-recovery',
    p8: 'email-verification',
    B9: 'onboardCompany',
    jz: 'user-token-refresh',
    jB: 'register-new-user',
    jF: 'reset-password',
    s1: 'reset-password-code-verification',
    gy: 'user-session-refresh',
    jO: 'send-password-reset-code'
  };

  var $author$project$Remote$Remote$init = function (_v0) {
    var configArgs = _v0.v9;
    var persisted = _v0.Co;

    var _v1 = A2($elm$core$Maybe$withDefault, _Utils_Tuple3($author$project$Remote$Model$Unauthenticated, A2($elm$core$Task$perform, $author$project$Remote$Msg$ReceivedUserSessionStatusFromInit, $elm$core$Task$succeed($elm$core$Result$Ok($author$project$Remote$Model$Unauthenticated))), $elm$core$Set$empty), A2($elm$core$Maybe$map, function (persistedAuth) {
      return _Utils_Tuple3($author$project$Remote$Model$UserAuthenticating, A2($elm$core$Task$attempt, $author$project$Remote$Msg$ReceivedUserSessionStatusFromInit, A2($elm$core$Task$andThen, function (_v2) {
        var idToken = _v2.d5;
        var refreshToken = _v2.e6;
        var expiresIn = _v2.hr;
        return $author$project$Api$Api$getUserSessionStatus({
          oY: configArgs.xL.oY,
          oZ: configArgs.oZ,
          o0: {
            hr: expiresIn,
            d5: idToken,
            e6: refreshToken
          }
        });
      }, A2($author$project$Remote$Remote$refreshTokens, configArgs.xL.oY, persistedAuth.e6))), A2($elm$core$Set$insert, $author$project$Remote$Remote$requests.gy, $elm$core$Set$empty));
    }, persisted.u_));

    var authState = _v1.a;
    var initialCmd = _v1.b;
    var initialReqs = _v1.c;
    var initState = {
      qP: $krisajenkins$remotedata$RemoteData$NotAsked,
      gp: _List_Nil,
      hY: initialReqs,
      tb: $krisajenkins$remotedata$RemoteData$NotAsked,
      EL: $author$project$Remote$Model$Unauthenticated
    };
    return _Utils_Tuple2(_Utils_update(initState, {
      EL: authState
    }), initialCmd);
  };

  var $author$project$Types$EditingUsers$init = {
    iP: '',
    hI: '',
    mq: $elm$core$Maybe$Nothing,
    zL: '',
    nO: $elm$core$Maybe$Nothing,
    nV: '',
    nW: ''
  };
  var $author$project$Types$UserProfile$init = {
    gZ: $elm$core$Maybe$Nothing,
    iF: '',
    iG: '',
    wq: '',
    hI: '',
    zL: '',
    rC: '',
    jk: '',
    ng: '',
    jC: '',
    ig: false,
    ih: false,
    ii: false
  };
  var $turboMaCk$any_set$Set$Any$AnySet = $elm$core$Basics$identity;
  var $turboMaCk$any_set$Set$Any$empty = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$empty);
  var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;

  var $justinmimbs$date$Date$isLeapYear = function (y) {
    return !A2($elm$core$Basics$modBy, 4, y) && !!A2($elm$core$Basics$modBy, 100, y) || !A2($elm$core$Basics$modBy, 400, y);
  };

  var $justinmimbs$date$Date$daysInMonth = F2(function (y, m) {
    switch (m) {
      case 0:
        return 31;

      case 1:
        return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;

      case 2:
        return 31;

      case 3:
        return 30;

      case 4:
        return 31;

      case 5:
        return 30;

      case 6:
        return 31;

      case 7:
        return 31;

      case 8:
        return 30;

      case 9:
        return 31;

      case 10:
        return 30;

      default:
        return 31;
    }
  });

  var $justinmimbs$date$Date$monthToNumber = function (m) {
    switch (m) {
      case 0:
        return 1;

      case 1:
        return 2;

      case 2:
        return 3;

      case 3:
        return 4;

      case 4:
        return 5;

      case 5:
        return 6;

      case 6:
        return 7;

      case 7:
        return 8;

      case 8:
        return 9;

      case 9:
        return 10;

      case 10:
        return 11;

      default:
        return 12;
    }
  };

  var $justinmimbs$date$Date$numberToMonth = function (mn) {
    var _v0 = A2($elm$core$Basics$max, 1, mn);

    switch (_v0) {
      case 1:
        return 0;

      case 2:
        return 1;

      case 3:
        return 2;

      case 4:
        return 3;

      case 5:
        return 4;

      case 6:
        return 5;

      case 7:
        return 6;

      case 8:
        return 7;

      case 9:
        return 8;

      case 10:
        return 9;

      case 11:
        return 10;

      default:
        return 11;
    }
  };

  var $justinmimbs$date$Date$toCalendarDateHelp = F3(function (y, m, d) {
    toCalendarDateHelp: while (true) {
      var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
      var mn = $justinmimbs$date$Date$monthToNumber(m);

      if (mn < 12 && _Utils_cmp(d, monthDays) > 0) {
        var $temp$y = y,
            $temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
            $temp$d = d - monthDays;
        y = $temp$y;
        m = $temp$m;
        d = $temp$d;
        continue toCalendarDateHelp;
      } else {
        return {
          wz: d,
          zG: m,
          FP: y
        };
      }
    }
  });
  var $justinmimbs$date$Date$floorDiv = F2(function (a, b) {
    return $elm$core$Basics$floor(a / b);
  });

  var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
    var y = y1 - 1;
    var leapYears = A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100) + A2($justinmimbs$date$Date$floorDiv, y, 400);
    return 365 * y + leapYears;
  };

  var $justinmimbs$date$Date$divWithRemainder = F2(function (a, b) {
    return _Utils_Tuple2(A2($justinmimbs$date$Date$floorDiv, a, b), A2($elm$core$Basics$modBy, b, a));
  });

  var $justinmimbs$date$Date$year = function (_v0) {
    var rd = _v0;

    var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);

    var n400 = _v1.a;
    var r400 = _v1.b;

    var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);

    var n100 = _v2.a;
    var r100 = _v2.b;

    var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);

    var n4 = _v3.a;
    var r4 = _v3.b;

    var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);

    var n1 = _v4.a;
    var r1 = _v4.b;
    var n = !r1 ? 0 : 1;
    return n400 * 400 + n100 * 100 + n4 * 4 + n1 + n;
  };

  var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
    var rd = _v0;
    var y = $justinmimbs$date$Date$year(rd);
    return {
      m_: rd - $justinmimbs$date$Date$daysBeforeYear(y),
      FP: y
    };
  };

  var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
    var rd = _v0;
    var date = $justinmimbs$date$Date$toOrdinalDate(rd);
    return A3($justinmimbs$date$Date$toCalendarDateHelp, date.FP, 0, date.m_);
  };

  var $justinmimbs$date$Date$day = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toCalendarDate, function ($) {
    return $.wz;
  });
  var $justinmimbs$date$Date$month = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toCalendarDate, function ($) {
    return $.zG;
  });
  var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
  var $justinmimbs$date$Date$ordinalDay = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toOrdinalDate, function ($) {
    return $.m_;
  });
  var $justinmimbs$date$Date$padSignedInt = F2(function (length, _int) {
    return _Utils_ap(_int < 0 ? '-' : '', A3($elm$core$String$padLeft, length, '0', $elm$core$String$fromInt($elm$core$Basics$abs(_int))));
  });

  var $justinmimbs$date$Date$monthToQuarter = function (m) {
    return ($justinmimbs$date$Date$monthToNumber(m) + 2) / 3 | 0;
  };

  var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
  var $elm$core$String$right = F2(function (n, string) {
    return n < 1 ? '' : A3($elm$core$String$slice, -n, $elm$core$String$length(string), string);
  });

  var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
    var rd = _v0;

    var _v1 = A2($elm$core$Basics$modBy, 7, rd);

    if (!_v1) {
      return 7;
    } else {
      var n = _v1;
      return n;
    }
  };

  var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
    var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
    return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
  };

  var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
    var _v0 = A2($elm$core$Basics$max, 1, wdn);

    switch (_v0) {
      case 1:
        return 0;

      case 2:
        return 1;

      case 3:
        return 2;

      case 4:
        return 3;

      case 5:
        return 4;

      case 6:
        return 5;

      default:
        return 6;
    }
  };

  var $justinmimbs$date$Date$toWeekDate = function (_v0) {
    var rd = _v0;
    var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
    var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
    var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
    return {
      up: 1 + ((rd - week1Day1) / 7 | 0),
      uq: wy,
      FC: $justinmimbs$date$Date$numberToWeekday(wdn)
    };
  };

  var $justinmimbs$date$Date$weekNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toWeekDate, function ($) {
    return $.up;
  });
  var $justinmimbs$date$Date$weekYear = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toWeekDate, function ($) {
    return $.uq;
  });
  var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
  var $elm$core$Basics$min = F2(function (x, y) {
    return _Utils_cmp(x, y) < 0 ? x : y;
  });

  var $justinmimbs$date$Date$ordinalSuffix = function (n) {
    var nn = A2($elm$core$Basics$modBy, 100, n);

    var _v0 = A2($elm$core$Basics$min, nn < 20 ? nn : A2($elm$core$Basics$modBy, 10, nn), 4);

    switch (_v0) {
      case 1:
        return 'st';

      case 2:
        return 'nd';

      case 3:
        return 'rd';

      default:
        return 'th';
    }
  };

  var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
    return _Utils_ap($elm$core$String$fromInt(n), $justinmimbs$date$Date$ordinalSuffix(n));
  };

  var $justinmimbs$date$Date$formatField = F4(function (language, _char, length, date) {
    switch (_char) {
      case 'y':
        if (length === 2) {
          return A2($elm$core$String$right, 2, A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$year(date))));
        } else {
          return A2($justinmimbs$date$Date$padSignedInt, length, $justinmimbs$date$Date$year(date));
        }

      case 'Y':
        if (length === 2) {
          return A2($elm$core$String$right, 2, A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$weekYear(date))));
        } else {
          return A2($justinmimbs$date$Date$padSignedInt, length, $justinmimbs$date$Date$weekYear(date));
        }

      case 'Q':
        switch (length) {
          case 1:
            return $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));

          case 2:
            return $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));

          case 3:
            return 'Q' + $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));

          case 4:
            return $justinmimbs$date$Date$withOrdinalSuffix($justinmimbs$date$Date$quarter(date));

          case 5:
            return $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));

          default:
            return '';
        }

      case 'M':
        switch (length) {
          case 1:
            return $elm$core$String$fromInt($justinmimbs$date$Date$monthNumber(date));

          case 2:
            return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$monthNumber(date)));

          case 3:
            return language.jj($justinmimbs$date$Date$month(date));

          case 4:
            return language.ms($justinmimbs$date$Date$month(date));

          case 5:
            return A2($elm$core$String$left, 1, language.jj($justinmimbs$date$Date$month(date)));

          default:
            return '';
        }

      case 'w':
        switch (length) {
          case 1:
            return $elm$core$String$fromInt($justinmimbs$date$Date$weekNumber(date));

          case 2:
            return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$weekNumber(date)));

          default:
            return '';
        }

      case 'd':
        switch (length) {
          case 1:
            return $elm$core$String$fromInt($justinmimbs$date$Date$day(date));

          case 2:
            return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$day(date)));

          case 3:
            return language.kV($justinmimbs$date$Date$day(date));

          default:
            return '';
        }

      case 'D':
        switch (length) {
          case 1:
            return $elm$core$String$fromInt($justinmimbs$date$Date$ordinalDay(date));

          case 2:
            return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$ordinalDay(date)));

          case 3:
            return A3($elm$core$String$padLeft, 3, '0', $elm$core$String$fromInt($justinmimbs$date$Date$ordinalDay(date)));

          default:
            return '';
        }

      case 'E':
        switch (length) {
          case 1:
            return language.fh($justinmimbs$date$Date$weekday(date));

          case 2:
            return language.fh($justinmimbs$date$Date$weekday(date));

          case 3:
            return language.fh($justinmimbs$date$Date$weekday(date));

          case 4:
            return language.oJ($justinmimbs$date$Date$weekday(date));

          case 5:
            return A2($elm$core$String$left, 1, language.fh($justinmimbs$date$Date$weekday(date)));

          case 6:
            return A2($elm$core$String$left, 2, language.fh($justinmimbs$date$Date$weekday(date)));

          default:
            return '';
        }

      case 'e':
        switch (length) {
          case 1:
            return $elm$core$String$fromInt($justinmimbs$date$Date$weekdayNumber(date));

          case 2:
            return $elm$core$String$fromInt($justinmimbs$date$Date$weekdayNumber(date));

          default:
            return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
        }

      default:
        return '';
    }
  });
  var $justinmimbs$date$Date$formatWithTokens = F3(function (language, tokens, date) {
    return A3($elm$core$List$foldl, F2(function (token, formatted) {
      if (!token.$) {
        var _char = token.a;
        var length = token.b;
        return _Utils_ap(A4($justinmimbs$date$Date$formatField, language, _char, length, date), formatted);
      } else {
        var str = token.a;
        return _Utils_ap(str, formatted);
      }
    }), '', tokens);
  });

  var $justinmimbs$date$Pattern$Literal = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$parser$Parser$Expecting = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$parser$Parser$toToken = function (str) {
    return A2($elm$parser$Parser$Advanced$Token, str, $elm$parser$Parser$Expecting(str));
  };

  var $elm$parser$Parser$token = function (str) {
    return $elm$parser$Parser$Advanced$token($elm$parser$Parser$toToken(str));
  };

  var $justinmimbs$date$Pattern$escapedQuote = A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal('\'')), $elm$parser$Parser$token('\'\''));
  var $justinmimbs$date$Pattern$Field = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $elm$parser$Parser$Advanced$getOffset = function (s) {
    return A3($elm$parser$Parser$Advanced$Good, false, s.mC, s);
  };

  var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;

  var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
    var _v0 = $elm$core$String$toList(str);

    if (_v0.b && !_v0.b.b) {
      var _char = _v0.a;
      return A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(F2(function (x, y) {
        return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
      })), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$getOffset, $elm$parser$Parser$chompWhile($elm$core$Basics$eq(_char)))), $elm$parser$Parser$getOffset);
    } else {
      return $elm$parser$Parser$problem('expected exactly one char');
    }
  };

  var $justinmimbs$date$Pattern$field = A2($elm$parser$Parser$andThen, $justinmimbs$date$Pattern$fieldRepeats, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
  var $justinmimbs$date$Pattern$finalize = A2($elm$core$List$foldl, F2(function (token, tokens) {
    var _v0 = _Utils_Tuple2(token, tokens);

    if (_v0.a.$ === 1 && _v0.b.b && _v0.b.a.$ === 1) {
      var x = _v0.a.a;
      var _v1 = _v0.b;
      var y = _v1.a.a;
      var rest = _v1.b;
      return A2($elm$core$List$cons, $justinmimbs$date$Pattern$Literal(_Utils_ap(x, y)), rest);
    } else {
      return A2($elm$core$List$cons, token, tokens);
    }
  }), _List_Nil);

  var $elm$parser$Parser$Advanced$lazy = function (thunk) {
    return function (s) {
      var _v0 = thunk(0);

      var parse = _v0;
      return parse(s);
    };
  };

  var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;

  var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
    return _char !== '\'' && !$elm$core$Char$isAlpha(_char);
  };

  var $justinmimbs$date$Pattern$literal = A2($elm$parser$Parser$map, $justinmimbs$date$Pattern$Literal, $elm$parser$Parser$getChompedString(A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)), $elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));

  var $justinmimbs$date$Pattern$quotedHelp = function (result) {
    return $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$andThen, function (str) {
      return $justinmimbs$date$Pattern$quotedHelp(_Utils_ap(result, str));
    }, $elm$parser$Parser$getChompedString(A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Basics$neq('\''))), $elm$parser$Parser$chompWhile($elm$core$Basics$neq('\''))))), A2($elm$parser$Parser$andThen, function (_v0) {
      return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
    }, $elm$parser$Parser$token('\'\'')), $elm$parser$Parser$succeed(result)]));
  };

  var $justinmimbs$date$Pattern$quoted = A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal), $elm$parser$Parser$chompIf($elm$core$Basics$eq('\''))), A2($elm$parser$Parser$ignorer, $justinmimbs$date$Pattern$quotedHelp(''), $elm$parser$Parser$oneOf(_List_fromArray([$elm$parser$Parser$chompIf($elm$core$Basics$eq('\'')), $elm$parser$Parser$end]))));

  var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
    return $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$andThen, function (token) {
      return $justinmimbs$date$Pattern$patternHelp(A2($elm$core$List$cons, token, tokens));
    }, $elm$parser$Parser$oneOf(_List_fromArray([$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))), $elm$parser$Parser$lazy(function (_v0) {
      return $elm$parser$Parser$succeed($justinmimbs$date$Pattern$finalize(tokens));
    })]));
  };

  var $justinmimbs$date$Pattern$fromString = function (str) {
    return A2($elm$core$Result$withDefault, _List_fromArray([$justinmimbs$date$Pattern$Literal(str)]), A2($elm$parser$Parser$run, $justinmimbs$date$Pattern$patternHelp(_List_Nil), str));
  };

  var $justinmimbs$date$Date$formatWithLanguage = F2(function (language, pattern) {
    var tokens = $elm$core$List$reverse($justinmimbs$date$Pattern$fromString(pattern));
    return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
  });

  var $justinmimbs$date$Date$monthToName = function (m) {
    switch (m) {
      case 0:
        return 'January';

      case 1:
        return 'February';

      case 2:
        return 'March';

      case 3:
        return 'April';

      case 4:
        return 'May';

      case 5:
        return 'June';

      case 6:
        return 'July';

      case 7:
        return 'August';

      case 8:
        return 'September';

      case 9:
        return 'October';

      case 10:
        return 'November';

      default:
        return 'December';
    }
  };

  var $justinmimbs$date$Date$weekdayToName = function (wd) {
    switch (wd) {
      case 0:
        return 'Monday';

      case 1:
        return 'Tuesday';

      case 2:
        return 'Wednesday';

      case 3:
        return 'Thursday';

      case 4:
        return 'Friday';

      case 5:
        return 'Saturday';

      default:
        return 'Sunday';
    }
  };

  var $justinmimbs$date$Date$language_en = {
    kV: $justinmimbs$date$Date$withOrdinalSuffix,
    ms: $justinmimbs$date$Date$monthToName,
    jj: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthToName, $elm$core$String$left(3)),
    oJ: $justinmimbs$date$Date$weekdayToName,
    fh: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayToName, $elm$core$String$left(3))
  };

  var $justinmimbs$date$Date$format = function (pattern) {
    return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
  };

  var $elm$core$Basics$clamp = F3(function (low, high, number) {
    return _Utils_cmp(number, low) < 0 ? low : _Utils_cmp(number, high) > 0 ? high : number;
  });
  var $justinmimbs$date$Date$daysBeforeMonth = F2(function (y, m) {
    var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;

    switch (m) {
      case 0:
        return 0;

      case 1:
        return 31;

      case 2:
        return 59 + leapDays;

      case 3:
        return 90 + leapDays;

      case 4:
        return 120 + leapDays;

      case 5:
        return 151 + leapDays;

      case 6:
        return 181 + leapDays;

      case 7:
        return 212 + leapDays;

      case 8:
        return 243 + leapDays;

      case 9:
        return 273 + leapDays;

      case 10:
        return 304 + leapDays;

      default:
        return 334 + leapDays;
    }
  });
  var $justinmimbs$date$Date$fromCalendarDate = F3(function (y, m, d) {
    return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + A3($elm$core$Basics$clamp, 1, A2($justinmimbs$date$Date$daysInMonth, y, m), d);
  });
  var $justinmimbs$date$Date$fromPosix = F2(function (zone, posix) {
    return A3($justinmimbs$date$Date$fromCalendarDate, A2($elm$time$Time$toYear, zone, posix), A2($elm$time$Time$toMonth, zone, posix), A2($elm$time$Time$toDay, zone, posix));
  });
  var $author$project$Ui$DateInput$DateInput$getDateInputState = F2(function (timeZone, selectedDate) {
    return A2($elm$core$Maybe$map, function (date) {
      return A2($justinmimbs$date$Date$format, 'dd-MM-yyyy', A2($justinmimbs$date$Date$fromPosix, timeZone, date));
    }, selectedDate);
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$Closed = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$DatePicker = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$init = {
    f$: $elm$core$Maybe$Nothing,
    eA: $elm$core$Maybe$Nothing,
    Y: $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$Closed,
    du: 0
  };
  var $author$project$Ui$DateInput$DateInput$initClosedDateInput = F2(function (zone, value) {
    return {
      ca: {
        iM: A2($author$project$Ui$DateInput$DateInput$getDateInputState, zone, value),
        d1: $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$init
      },
      Fw: value
    };
  });
  var $author$project$Ui$Accounts$Add$Model$init = F2(function (time, zone) {
    return {
      o3: $elm$core$Maybe$Nothing,
      bq: $elm$core$Maybe$Nothing,
      iL: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, zone, $elm$core$Maybe$Just(time)),
      R: $elm$core$Maybe$Nothing,
      pU: '',
      rs: $elm$core$Maybe$Nothing,
      zL: $elm$core$Maybe$Nothing,
      P: $elm$core$Maybe$Nothing
    };
  });
  var $author$project$Ui$Accounts$Edit$Model$init = {
    R: $elm$core$Maybe$Nothing,
    pU: '',
    rs: $elm$core$Maybe$Nothing,
    zL: $elm$core$Maybe$Nothing,
    P: $elm$core$Maybe$Nothing
  };

  var $author$project$Types$FinancialAccount$unwrapFinancialAccountId = function (_v0) {
    var x = _v0;
    return x;
  };

  var $author$project$Ui$Accounts$Model$init = function (_v0) {
    var zone = _v0.by;
    var time = _v0.EM;
    return {
      oN: $elm$core$Maybe$Nothing,
      oS: A2($author$project$Ui$Accounts$Add$Model$init, time, zone),
      pZ: '',
      p_: $author$project$Ui$Accounts$Edit$Model$init,
      qK: $elm$core$Maybe$Nothing,
      tv: $turboMaCk$any_set$Set$Any$empty($author$project$Types$FinancialAccount$unwrapFinancialAccountId),
      j_: ''
    };
  };

  var $author$project$Ui$Auth$Model$EnterForgotPasswordEmail = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$Auth$Auth$init = {
    lt: $author$project$Ui$Auth$Model$EnterForgotPasswordEmail(''),
    hG: false,
    m8: '',
    m9: '',
    su: '',
    jA: false,
    nA: '',
    nB: '',
    nE: '',
    nF: '',
    sU: '',
    nG: '',
    ob: '',
    oe: ''
  };

  var $author$project$Types$MoneyOrThing$Money = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$ViewModelStringTo$ViewModelStringTo = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$ViewModelStringTo$empty = F2(function (name, parser) {
    return {
      zL: name,
      st: parser,
      Fw: ''
    };
  });
  var $elm$core$Result$fromMaybe = F2(function (err, maybe) {
    if (!maybe.$) {
      var v = maybe.a;
      return $elm$core$Result$Ok(v);
    } else {
      return $elm$core$Result$Err(err);
    }
  });
  var $JoshuaHall$elm_fraction$Fraction$createUnsafe = F2(function (numerator, denominator) {
    return A2($JoshuaHall$elm_fraction$Fraction$Fraction, numerator, denominator);
  });
  var $author$project$Types$Fraction$toFractionFromString = F2(function (decimalDelimiter, input) {
    var _v0 = A2($elm$core$String$split, $elm$core$String$fromChar(decimalDelimiter), input);

    _v0$2: while (true) {
      if (_v0.b) {
        if (_v0.b.b) {
          if (!_v0.b.b.b) {
            var left = _v0.a;
            var _v1 = _v0.b;
            var right = _v1.a;

            var rightNoTrailingZeroes = function () {
              var _v3 = $elm$regex$Regex$fromString('0+$');

              if (!_v3.$) {
                var regex = _v3.a;
                return A3($elm$regex$Regex$replace, regex, $elm$core$Basics$always(''), right);
              } else {
                return right;
              }
            }();

            var numeratorString = _Utils_ap(left, rightNoTrailingZeroes);

            var denominator = A2($elm$core$Basics$pow, 10, $elm$core$String$length(rightNoTrailingZeroes));

            var _v2 = $elm$core$String$toInt(numeratorString);

            if (!_v2.$) {
              var numerator = _v2.a;
              return $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, numerator, denominator));
            } else {
              return $elm$core$Maybe$Nothing;
            }
          } else {
            break _v0$2;
          }
        } else {
          var whole = _v0.a;
          return A2($elm$core$Maybe$map, function (_int) {
            return A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, _int, 1);
          }, $elm$core$String$toInt(whole));
        }
      } else {
        break _v0$2;
      }
    }

    return $elm$core$Maybe$Nothing;
  });
  var $author$project$ElmFramework$Lib$ViewModelStringToFraction$parser = A2($elm$core$Basics$composeR, $author$project$Types$Fraction$toFractionFromString('.'), $elm$core$Result$fromMaybe(''));

  var $author$project$ElmFramework$Lib$ViewModelStringToFraction$empty = function (name) {
    return A2($author$project$ElmFramework$Lib$ViewModelStringTo$empty, name, $author$project$ElmFramework$Lib$ViewModelStringToFraction$parser);
  };

  var $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$Month = 0;

  var $author$project$ElmFramework$Lib$ViewModelStringToInt$empty = function (name) {
    return A2($author$project$ElmFramework$Lib$ViewModelStringTo$empty, name, A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm$core$Result$fromMaybe('')));
  };

  var $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$empty = {
    ao: $author$project$ElmFramework$Lib$ViewModelStringToInt$empty('Every'),
    ap: 0,
    bR: $author$project$ElmFramework$Lib$ViewModelStringToFraction$empty('Growth Rate'),
    bw: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Nothing)
  };
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$Day = 0;
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init = {
    kR: '',
    xi: $elm$core$Maybe$Nothing,
    k3: '',
    yK: false,
    f8: false,
    rm: _List_Nil,
    ia: $elm$core$Maybe$Nothing
  };
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected = F2(function (maybeSelected, state) {
    return _Utils_update(state, {
      ia: maybeSelected
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$empty = {
    hn: {
      k: $elm$core$Maybe$Nothing,
      iL: $elm$core$Maybe$Nothing
    },
    ao: $author$project$ElmFramework$Lib$ViewModelStringToInt$empty('Every'),
    ap: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(0), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init)
  };
  var $author$project$ElmFramework$Lib$Util$flip = F3(function (_function, a, b) {
    return A2(_function, b, a);
  });
  var $author$project$ElmFramework$Lib$ViewModelStringTo$fromString = F3(function (name, parser, initValue) {
    return {
      zL: name,
      st: parser,
      Fw: initValue
    };
  });
  var $author$project$ElmFramework$Lib$ViewModelStringToInt$fromInt = F2(function (name, _int) {
    return A3($author$project$ElmFramework$Lib$ViewModelStringTo$fromString, name, A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm$core$Result$fromMaybe('')), $elm$core$String$fromInt(_int));
  });

  var $author$project$Types$SimpleDate$monthToString = function (month) {
    switch (month) {
      case 0:
        return 'Jan';

      case 1:
        return 'Feb';

      case 2:
        return 'Mar';

      case 3:
        return 'Apr';

      case 4:
        return 'May';

      case 5:
        return 'Jun';

      case 6:
        return 'Jul';

      case 7:
        return 'Aug';

      case 8:
        return 'Sep';

      case 9:
        return 'Oct';

      case 10:
        return 'Nov';

      default:
        return 'Dec';
    }
  };

  var $author$project$Types$MonthAdjustments$empty = $elm$core$Array$fromList(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$numberToMonth, A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$monthToString, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$ElmFramework$Lib$ViewModelStringToInt$fromInt, 100))), A2($elm$core$List$range, 1, 12)));
  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$empty = {
    dW: $author$project$Types$MonthAdjustments$empty,
    sH: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    gu: ''
  };
  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$empty = {
    g5: $author$project$ElmFramework$Lib$ViewModelStringToFraction$empty('Base Value'),
    fZ: $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$empty,
    h2: $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$empty,
    bK: $author$project$Types$EditingBuildingBlock$EditingSeasonality$empty
  };
  var $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$empty = {
    fB: $elm$core$Maybe$Nothing
  };
  var $author$project$Api$Types$CharacterizeTimeTransformResponse$empty = {
    ve: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$SimpleDate$toDateString),
    ox: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$SimpleDate$toDateString)
  };

  var $author$project$ElmFramework$Lib$ViewModelStringToFloat$empty = function (name) {
    return A2($author$project$ElmFramework$Lib$ViewModelStringTo$empty, name, A2($elm$core$Basics$composeR, $elm$core$String$toFloat, $elm$core$Result$fromMaybe('')));
  };

  var $author$project$Ui$TimeTransformation$InputGraph$InputStatus$Idle = {
    $: 0
  };
  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$Idle = {
    $: 0
  };
  var $author$project$Ui$TimeTransformation$Model$empty = {
    yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$Idle,
    iY: '',
    yx: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$SimpleDate$toDateString),
    Cj: $elm$core$Maybe$Nothing,
    DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$Idle
  };
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$empty = {
    hk: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    ho: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Nothing),
    r: $author$project$ElmFramework$Lib$ViewModelStringToFloat$empty('Multiplier'),
    t: $author$project$ElmFramework$Lib$ViewModelStringToFloat$empty('Per'),
    gM: $author$project$Ui$TimeTransformation$Model$empty,
    j5: $author$project$Api$Types$CharacterizeTimeTransformResponse$empty
  };
  var $author$project$Api$GraphqlSchema$Enum$Basis_enum$Accrual = 0;
  var $author$project$Ui$FinancialAccountDropdownSelector$init = {
    W: '',
    ia: $elm$core$Maybe$Nothing
  };
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$empty = {
    kf: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    bS: $author$project$Ui$FinancialAccountDropdownSelector$init,
    pb: 0,
    fE: $author$project$Ui$TimeTransformation$Model$empty,
    iy: $author$project$Api$Types$CharacterizeTimeTransformResponse$empty,
    iZ: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    bU: $author$project$Ui$FinancialAccountDropdownSelector$init,
    f6: false
  };
  var $author$project$Types$EditingBuildingBlock$EditingThingPayload$empty = {};
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$empty = {
    g7: $elm$core$Maybe$Nothing,
    fD: $author$project$Types$EditingBuildingBlock$EditingBasicPayload$empty,
    fP: $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$empty,
    d2: $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$empty,
    hO: $author$project$Types$MoneyOrThing$Money(0),
    cU: $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$empty,
    zL: A2($author$project$ElmFramework$Lib$ViewModelStringTo$empty, 'Building Block Name', $elm$core$Result$Ok),
    bw: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Nothing),
    eD: $author$project$Types$EditingBuildingBlock$EditingThingPayload$empty
  };

  var $author$project$Types$Scenario$unwrapScenarioId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Ui$Block$Model$init = {
    gV: false,
    gZ: $elm$core$Maybe$Nothing,
    kh: false,
    ku: false,
    p$: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Scenario$unwrapScenarioId),
    bv: $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$empty,
    lz: false,
    sX: $elm$core$Maybe$Nothing,
    nX: false,
    ty: $elm$core$Result$Err('')
  };

  var $author$project$Types$Review$unwrapReviewId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Types$Filters$empty = {
    ft: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    iv: false,
    g0: $turboMaCk$any_set$Set$Any$empty($author$project$Types$User$unwrapUserId),
    hc: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    br: $elm$core$Maybe$Nothing,
    h0: $elm$core$Maybe$Nothing,
    gw: $elm$core$Maybe$Nothing,
    c9: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Review$unwrapReviewId),
    db: $turboMaCk$any_set$Set$Any$empty(A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Types$Scenario$unwrapScenarioId), $elm$core$Maybe$withDefault(''))),
    j_: ''
  };

  var $author$project$Types$BuildingBlock$unwrapBuildingBlockId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Ui$Blocks$Model$init = {
    o9: $elm$core$Maybe$Nothing,
    qo: $author$project$Types$Filters$empty,
    sl: $elm$core$Maybe$Nothing,
    to: $turboMaCk$any_set$Set$Any$empty($author$project$Types$BuildingBlock$unwrapBuildingBlockId),
    ul: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init
  };

  var $author$project$Ui$NestedTable$NestedTable$serializePath = function (path) {
    return A2($elm$core$String$join, '-', A2($elm$core$List$map, $elm$core$String$fromInt, path));
  };

  var $author$project$Ui$NestedTable$NestedTable$noExpandedRows = $turboMaCk$any_set$Set$Any$empty($author$project$Ui$NestedTable$NestedTable$serializePath);
  var $author$project$Ui$Budget$Model$init = {
    pp: $elm$core$Maybe$Nothing,
    qi: $author$project$Ui$NestedTable$NestedTable$noExpandedRows,
    qG: $elm$core$Maybe$Nothing,
    qN: $elm$core$Maybe$Nothing,
    C0: $elm$core$Maybe$Nothing,
    ut: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init
  };
  var $author$project$Types$Sorters$SortByDateCreatedDesc = 0;

  var $author$project$Types$Division$unwrapDivisionId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Ui$Cashboard$Comment$Model$init = {
    iL: $elm$core$Maybe$Nothing,
    eO: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId),
    qo: $author$project$Types$Filters$empty,
    f$: $elm$core$Maybe$Nothing,
    EH: ''
  };
  var $author$project$Ui$Cashboard$Model$init = {
    pd: $author$project$Types$Filters$empty,
    pp: $elm$core$Maybe$Nothing,
    v1: $author$project$Ui$Cashboard$Comment$Model$init,
    xl: _List_Nil,
    qi: $author$project$Ui$NestedTable$NestedTable$noExpandedRows,
    ya: $elm$core$Maybe$Nothing,
    qN: $elm$core$Maybe$Nothing,
    rD: '',
    sn: $elm$core$Maybe$Nothing,
    sE: false,
    sY: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
    C0: $elm$core$Maybe$Nothing,
    s3: $author$project$Types$Filters$empty,
    s4: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(0), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init)
  };
  var $author$project$Types$CashOrCredit$Cash = 0;
  var $justinmimbs$time_extra$Time$Extra$Day = 11;
  var $author$project$Route$LegalRoute$LegalRouteTermsOfUse = 0;

  var $author$project$Ui$ComponentsPreview$Msg$NestedSelectOptionCreated = function (a) {
    return {
      $: 31,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$NestedSelectOptionDeleted = function (a) {
    return {
      $: 30,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$NestedSelectOptionEdited = F2(function (a, b) {
    return {
      $: 29,
      a: a,
      b: b
    };
  });
  var $author$project$Types$SelectScenariosOrBlocks$SelectScenarios = 0;
  var $justinmimbs$date$Date$Days = 3;
  var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
  var $justinmimbs$time_extra$Time$Extra$Month = 2;
  var $justinmimbs$date$Date$Months = 1;
  var $justinmimbs$date$Date$add = F3(function (unit, n, _v0) {
    var rd = _v0;

    switch (unit) {
      case 0:
        return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);

      case 1:
        var date = $justinmimbs$date$Date$toCalendarDate(rd);
        var wholeMonths = 12 * (date.FP - 1) + ($justinmimbs$date$Date$monthToNumber(date.zG) - 1) + n;
        var m = $justinmimbs$date$Date$numberToMonth(A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
        var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
        return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + A2($elm$core$Basics$min, date.wz, A2($justinmimbs$date$Date$daysInMonth, y, m));

      case 2:
        return rd + 7 * n;

      default:
        return rd + n;
    }
  });

  var $justinmimbs$date$Date$toRataDie = function (_v0) {
    var rd = _v0;
    return rd;
  };

  var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
    var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
    return daysSinceEpoch * 86400000;
  };

  var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(function (hour, minute, second, millisecond) {
    return hour * 3600000 + minute * 60000 + second * 1000 + millisecond;
  });
  var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(function (zone, posix) {
    return A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A2($elm$time$Time$toHour, zone, posix), A2($elm$time$Time$toMinute, zone, posix), A2($elm$time$Time$toSecond, zone, posix), A2($elm$time$Time$toMillis, zone, posix));
  });
  var $justinmimbs$time_extra$Time$Extra$toOffset = F2(function (zone, posix) {
    var millis = $elm$time$Time$posixToMillis(posix);
    var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
    return (localMillis - millis) / 60000 | 0;
  });
  var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(function (zone, date, time) {
    var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
    var offset0 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, $elm$time$Time$millisToPosix(millis));
    var posix1 = $elm$time$Time$millisToPosix(millis - offset0 * 60000);
    var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);

    if (_Utils_eq(offset0, offset1)) {
      return posix1;
    } else {
      var posix2 = $elm$time$Time$millisToPosix(millis - offset1 * 60000);
      var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
      return _Utils_eq(offset1, offset2) ? posix2 : posix1;
    }
  });
  var $justinmimbs$time_extra$Time$Extra$add = F4(function (interval, n, zone, posix) {
    add: while (true) {
      switch (interval) {
        case 15:
          return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(posix) + n);

        case 14:
          var $temp$interval = 15,
              $temp$n = n * 1000,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;

        case 13:
          var $temp$interval = 15,
              $temp$n = n * 60000,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;

        case 12:
          var $temp$interval = 15,
              $temp$n = n * 3600000,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;

        case 11:
          return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A3($justinmimbs$date$Date$add, 3, n, A2($justinmimbs$date$Date$fromPosix, zone, posix)), A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));

        case 2:
          return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A3($justinmimbs$date$Date$add, 1, n, A2($justinmimbs$date$Date$fromPosix, zone, posix)), A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));

        case 0:
          var $temp$interval = 2,
              $temp$n = n * 12,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;

        case 1:
          var $temp$interval = 2,
              $temp$n = n * 3,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;

        case 3:
          var $temp$interval = 11,
              $temp$n = n * 7,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;

        default:
          var weekday = interval;
          var $temp$interval = 11,
              $temp$n = n * 7,
              $temp$zone = zone,
              $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
      }
    }
  });

  var $turboMaCk$any_set$Set$Any$fromList = function (toComparable) {
    return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$fromList(toComparable)), $elm$core$List$map(function (a) {
      return _Utils_Tuple2(a, 0);
    }));
  };

  var $author$project$Ui$TimeTransformation$TimeTransformation$init = $author$project$Ui$TimeTransformation$Model$empty;

  var $author$project$Ui$RangeDateInput$RangeDateInput$DatePickerChanged = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$NeverVisible = 0;
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$SingleDatePicker = 0;

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$dayToNameString = function (day) {
    switch (day) {
      case 0:
        return 'Mo';

      case 1:
        return 'Tu';

      case 2:
        return 'We';

      case 3:
        return 'Th';

      case 4:
        return 'Fr';

      case 5:
        return 'Sa';

      default:
        return 'Su';
    }
  };

  var $author$project$Ui$RangeDateInput$RangeDateInput$monthToName = function (m) {
    switch (m) {
      case 0:
        return 'January';

      case 1:
        return 'February';

      case 2:
        return 'March';

      case 3:
        return 'April';

      case 4:
        return 'May';

      case 5:
        return 'June';

      case 6:
        return 'July';

      case 7:
        return 'August';

      case 8:
        return 'September';

      case 9:
        return 'October';

      case 10:
        return 'November';

      default:
        return 'December';
    }
  };

  var $author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputSettings = function (zone) {
    return {
      pk: 0,
      kU: F2(function (timeZone, date) {
        return A2($justinmimbs$date$Date$format, 'dd-MM-yyyy', A2($justinmimbs$date$Date$fromPosix, timeZone, date));
      }),
      lq: 0,
      qv: $elm$core$Maybe$Nothing,
      qx: $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$dayToNameString,
      qy: $author$project$Ui$RangeDateInput$RangeDateInput$monthToName,
      es: $author$project$Ui$RangeDateInput$RangeDateInput$DatePickerChanged,
      i2: F2(function (_v0, _v1) {
        return false;
      }),
      tw: false,
      n7: false,
      j$: 0,
      by: zone
    };
  };

  var $author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputState = F2(function (timeZone, value) {
    return _Utils_Tuple2(A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.Ef;
    }, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromPosix(timeZone), $justinmimbs$date$Date$format('dd-MM-yyyy'))), value), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.dR;
    }, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromPosix(timeZone), $justinmimbs$date$Date$format('dd-MM-yyyy'))), value));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$Closed = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$DatePicker = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$init = {
    eP: $elm$core$Maybe$Nothing,
    f$: $elm$core$Maybe$Nothing,
    fa: $elm$core$Maybe$Nothing,
    Y: $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$Closed,
    du: _Utils_Tuple2(0, 1)
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$Open = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $justinmimbs$time_extra$Time$Extra$Week = 3;
  var $justinmimbs$date$Date$Day = 11;
  var $justinmimbs$date$Date$Friday = 8;
  var $justinmimbs$date$Date$Monday = 4;
  var $justinmimbs$date$Date$Month = 2;
  var $justinmimbs$date$Date$Quarter = 1;
  var $justinmimbs$date$Date$Saturday = 9;
  var $justinmimbs$date$Date$Sunday = 10;
  var $justinmimbs$date$Date$Thursday = 7;
  var $justinmimbs$date$Date$Tuesday = 5;
  var $justinmimbs$date$Date$Wednesday = 6;
  var $justinmimbs$date$Date$Week = 3;
  var $justinmimbs$date$Date$Year = 0;

  var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
    switch (wd) {
      case 0:
        return 1;

      case 1:
        return 2;

      case 2:
        return 3;

      case 3:
        return 4;

      case 4:
        return 5;

      case 5:
        return 6;

      default:
        return 7;
    }
  };

  var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(function (wd, date) {
    return A2($elm$core$Basics$modBy, 7, $justinmimbs$date$Date$weekdayNumber(date) + 7 - $justinmimbs$date$Date$weekdayToNumber(wd));
  });
  var $justinmimbs$date$Date$firstOfMonth = F2(function (y, m) {
    return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + 1;
  });

  var $justinmimbs$date$Date$firstOfYear = function (y) {
    return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
  };

  var $justinmimbs$date$Date$quarterToMonth = function (q) {
    return $justinmimbs$date$Date$numberToMonth(q * 3 - 2);
  };

  var $justinmimbs$date$Date$floor = F2(function (interval, date) {
    var rd = date;

    switch (interval) {
      case 0:
        return $justinmimbs$date$Date$firstOfYear($justinmimbs$date$Date$year(date));

      case 1:
        return A2($justinmimbs$date$Date$firstOfMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$quarterToMonth($justinmimbs$date$Date$quarter(date)));

      case 2:
        return A2($justinmimbs$date$Date$firstOfMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date));

      case 3:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);

      case 4:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);

      case 5:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);

      case 6:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);

      case 7:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);

      case 8:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);

      case 9:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);

      case 10:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);

      default:
        return date;
    }
  });
  var $justinmimbs$time_extra$Time$Extra$floorDate = F3(function (dateInterval, zone, posix) {
    return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A2($justinmimbs$date$Date$floor, dateInterval, A2($justinmimbs$date$Date$fromPosix, zone, posix)), 0);
  });
  var $justinmimbs$time_extra$Time$Extra$floor = F3(function (interval, zone, posix) {
    switch (interval) {
      case 15:
        return posix;

      case 14:
        return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A2($justinmimbs$date$Date$fromPosix, zone, posix), A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A2($elm$time$Time$toHour, zone, posix), A2($elm$time$Time$toMinute, zone, posix), A2($elm$time$Time$toSecond, zone, posix), 0));

      case 13:
        return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A2($justinmimbs$date$Date$fromPosix, zone, posix), A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A2($elm$time$Time$toHour, zone, posix), A2($elm$time$Time$toMinute, zone, posix), 0, 0));

      case 12:
        return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A2($justinmimbs$date$Date$fromPosix, zone, posix), A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A2($elm$time$Time$toHour, zone, posix), 0, 0, 0));

      case 11:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);

      case 2:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);

      case 0:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);

      case 1:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);

      case 3:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);

      case 4:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);

      case 5:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);

      case 6:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);

      case 7:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);

      case 8:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);

      case 9:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);

      default:
        return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
    }
  });
  var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(function (zone, posix) {
    return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
  });
  var $justinmimbs$time_extra$Time$Extra$toMonths = F2(function (zone, posix) {
    var wholeMonths = 12 * (A2($elm$time$Time$toYear, zone, posix) - 1) + ($justinmimbs$date$Date$monthToNumber(A2($elm$time$Time$toMonth, zone, posix)) - 1);
    var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
    return wholeMonths + fractionalMonth;
  });
  var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(function (zone, posix) {
    return $justinmimbs$date$Date$toRataDie(A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
  });
  var $elm$core$Basics$truncate = _Basics_truncate;
  var $justinmimbs$time_extra$Time$Extra$diff = F4(function (interval, zone, posix1, posix2) {
    diff: while (true) {
      switch (interval) {
        case 15:
          return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);

        case 14:
          return A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000 | 0;

        case 13:
          return A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000 | 0;

        case 12:
          return A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000 | 0;

        case 11:
          return A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1) | 0;

        case 2:
          return A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1) | 0;

        case 0:
          return A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12 | 0;

        case 1:
          return A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3 | 0;

        case 3:
          return A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7 | 0;

        default:
          var weekday = interval;
          var $temp$interval = 3,
              $temp$zone = zone,
              $temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
              $temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
          interval = $temp$interval;
          zone = $temp$zone;
          posix1 = $temp$posix1;
          posix2 = $temp$posix2;
          continue diff;
      }
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$calculateViewOffset = F3(function (zone, referenceTime, subjectTime) {
    var flooredReference = A3($justinmimbs$time_extra$Time$Extra$floor, 2, zone, referenceTime);

    if (subjectTime.$ === 1) {
      return 0;
    } else {
      var time = subjectTime.a;
      var flooredSubject = A3($justinmimbs$time_extra$Time$Extra$floor, 2, zone, time);
      return _Utils_cmp($elm$time$Time$posixToMillis(flooredReference), $elm$time$Time$posixToMillis(flooredSubject)) < 1 ? A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, flooredReference, flooredSubject) : 0 - A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, flooredSubject, flooredReference);
    }
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$getTimePickerSettings = function (settings) {
    var _v0 = settings.j$;
    return $elm$core$Maybe$Nothing;
  };

  var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(function (zone, _v0) {
    var year = _v0.FP;
    var month = _v0.zG;
    var day = _v0.wz;
    var hour = _v0.yc;
    var minute = _v0.zE;
    var second = _v0.tj;
    var millisecond = _v0.zz;
    return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A3($justinmimbs$date$Date$fromCalendarDate, year, month, day), A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A3($elm$core$Basics$clamp, 0, 23, hour), A3($elm$core$Basics$clamp, 0, 59, minute), A3($elm$core$Basics$clamp, 0, 59, second), A3($elm$core$Basics$clamp, 0, 999, millisecond)));
  });
  var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(function (zone, posix) {
    return {
      wz: A2($elm$time$Time$toDay, zone, posix),
      yc: A2($elm$time$Time$toHour, zone, posix),
      zz: A2($elm$time$Time$toMillis, zone, posix),
      zE: A2($elm$time$Time$toMinute, zone, posix),
      zG: A2($elm$time$Time$toMonth, zone, posix),
      tj: A2($elm$time$Time$toSecond, zone, posix),
      FP: A2($elm$time$Time$toYear, zone, posix)
    };
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$setTimeOfDay = F4(function (zone, hour, minute, timeToUpdate) {
    var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);

    var newParts = _Utils_update(parts, {
      yc: hour,
      zE: minute
    });

    return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$pickerDayFromPosix = F4(function (zone, isDisabledFn, allowableTimesFn, posix) {
    var flooredPosix = A3($justinmimbs$time_extra$Time$Extra$floor, 11, zone, posix);
    var allowableTimes = A2($elm$core$Maybe$withDefault, {
      p9: 23,
      qa: 59,
      tC: 0,
      tD: 0
    }, A2($elm$core$Maybe$map, function (fn) {
      return A2(fn, zone, flooredPosix);
    }, allowableTimesFn));
    return {
      k_: A2(isDisabledFn, zone, A3($justinmimbs$time_extra$Time$Extra$floor, 11, zone, flooredPosix)),
      dR: A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$setTimeOfDay, zone, allowableTimes.p9, allowableTimes.qa, flooredPosix),
      Ef: A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$setTimeOfDay, zone, allowableTimes.tC, allowableTimes.tD, flooredPosix)
    };
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$generatePickerDay = F2(function (settings, time) {
    return A2($elm$core$Maybe$withDefault, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$pickerDayFromPosix, settings.by, settings.i2, $elm$core$Maybe$Nothing, time), A2($elm$core$Maybe$map, function (timePickerSettings) {
      return A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$pickerDayFromPosix, settings.by, settings.i2, $elm$core$Maybe$Just(timePickerSettings.ki), time);
    }, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$getTimePickerSettings(settings)));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$openPicker = F5(function (settings, baseTime, start, end, _v0) {
    var model = _v0;
    var viewOffset = A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$calculateViewOffset, settings.by, baseTime, start);

    var timePickerVisible = function () {
      var _v1 = settings.j$;
      return false;
    }();

    var startSelectionTuple = A2($elm$core$Maybe$map, function (s) {
      return _Utils_Tuple2(A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$generatePickerDay, settings, s), s);
    }, start);
    var endSelectionTuple = A2($elm$core$Maybe$map, function (e) {
      return _Utils_Tuple2(A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$generatePickerDay, settings, e), e);
    }, end);
    return _Utils_update(model, {
      eP: endSelectionTuple,
      fa: startSelectionTuple,
      Y: A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$Open, timePickerVisible, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$generatePickerDay, settings, baseTime)),
      du: _Utils_Tuple2(viewOffset, viewOffset + 1)
    });
  });

  var $author$project$Ui$RangeDateInput$RangeDateInput$initRangeDateInput = function (_v0) {
    var zone = _v0.by;
    var baseTime = _v0.vd;
    var value = _v0.Fw;
    return {
      ca: {
        iM: A2($author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputState, zone, value),
        d1: A5($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$openPicker, $author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputSettings(zone), baseTime, A2($elm$core$Maybe$map, function ($) {
          return $.Ef;
        }, value), A2($elm$core$Maybe$map, function ($) {
          return $.dR;
        }, value), $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$init)
      },
      Fw: value
    };
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList = F2(function (options, createAction) {
    return {
      wh: createAction,
      e0: options
    };
  });

  var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');

  var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');

  var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
  var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');

  var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');

  var $author$project$IconSvg$blocks_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M32 32H22.4V22.4H32V32ZM17.6 32H8V22.4H17.6V32ZM32 17.6H22.4V8H32V17.6ZM12.8 17.6C10.149 17.6 8 15.451 8 12.8C8 10.149 10.149 8 12.8 8C15.451 8 17.6 10.149 17.6 12.8C17.6 14.073 17.0943 15.2939 16.1941 16.1941C15.2939 17.0943 14.073 17.6 12.8 17.6Z')]), _List_Nil)]));
  };

  var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');

  var $author$project$IconSvg$blocks = function (classes) {
    return $author$project$IconSvg$blocks_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$Option = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$newIconOption = F6(function (onEdit, onDelete, selectable, maybeChildList, value, icon) {
    return {
      vU: maybeChildList,
      kN: $elm$core$Maybe$Just(icon),
      Ax: onDelete,
      hV: onEdit,
      jM: selectable,
      Fw: value
    };
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$newOption = F5(function (onEdit, onDelete, selectable, maybeChildren, value) {
    return {
      vU: maybeChildren,
      kN: $elm$core$Maybe$Nothing,
      Ax: onDelete,
      hV: onEdit,
      jM: selectable,
      Fw: value
    };
  });
  var $author$project$Types$Mock$mockNestedSelectOptionList = F3(function (editMsg, deleteMsg, createMsg) {
    var toIconOption = F2(function (val, icon) {
      return A6($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$newIconOption, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, false, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_Nil, $elm$core$Maybe$Nothing)), val, icon);
    });
    var mapMsg = F2(function (msg, val) {
      return A2($elm$core$Maybe$map, function (m) {
        return m(val);
      }, msg);
    });
    var toOption = F2(function (val, _v0) {
      var selectable = _v0.jM;
      var children = _v0.vU;
      return A5($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$newOption, A2(mapMsg, editMsg, val), A2(mapMsg, deleteMsg, val), selectable, children, val);
    });
    return A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_fromArray([A2(toOption, 'Wholesale', {
      vU: $elm$core$Maybe$Nothing,
      jM: true
    }), A2(toOption, 'WholesaleLonger', {
      vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_fromArray([A2(toOption, 'Revenue', {
        vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_Nil, $elm$core$Maybe$Nothing)),
        jM: true
      }), A2(toOption, 'RevenueLonger', {
        vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_fromArray([A2(toOption, 'MilksLonger', {
          vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_fromArray([A2(toOption, 'Egg', {
            vU: $elm$core$Maybe$Nothing,
            jM: true
          }), A2(toOption, 'Egg', {
            vU: $elm$core$Maybe$Nothing,
            jM: true
          }), A2(toOption, 'Egg', {
            vU: $elm$core$Maybe$Nothing,
            jM: true
          })]), $elm$core$Maybe$Nothing)),
          jM: true
        }), A2(toOption, 'Milks', {
          vU: $elm$core$Maybe$Nothing,
          jM: true
        }), A2(toOption, 'Milks', {
          vU: $elm$core$Maybe$Nothing,
          jM: true
        }), A2(toIconOption, 'Financial Block', $author$project$IconSvg$blocks('w3 marRight1 primary30Fill')), A2(toIconOption, 'Non-Financial Block', $author$project$IconSvg$blocks('w3 marRight1 gray20Fill'))]), $elm$core$Maybe$Nothing)),
        jM: false
      }), A2(toOption, 'Revenue', {
        vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_Nil, $elm$core$Maybe$Nothing)),
        jM: true
      })]), $elm$core$Maybe$Nothing)),
      jM: false
    }), A2(toOption, 'Wholesale', {
      vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_Nil, $elm$core$Maybe$Nothing)),
      jM: false
    }), A2(toOption, 'Wholesale', {
      vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _List_Nil, $elm$core$Maybe$Nothing)),
      jM: false
    }), A2(toIconOption, 'Unallocated Blocks', $author$project$IconSvg$blocks('w3 marRight1 gray20Fill'))]), A2($elm$core$Maybe$map, function (msg) {
      return {
        vF: '+ Add Category',
        gi: msg
      };
    }, createMsg));
  });

  var $author$project$Msg$ComponentsPreviewMsg = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$TopMsg$msgComponentsPreview = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ComponentsPreviewMsg);

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$init = function (_v0) {
    var zone = _v0.by;
    var time = _v0.EM;
    var timeTransformationState = $author$project$Ui$TimeTransformation$TimeTransformation$init;
    return {
      kc: 0,
      ft: 30,
      kB: 0,
      iL: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, zone, $elm$core$Maybe$Just(time)),
      pX: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
      qA: $elm$core$Maybe$Nothing,
      hD: $elm$core$Maybe$Nothing,
      yw: '',
      i1: $elm$core$Maybe$Nothing,
      l8: 0,
      dX: A3($author$project$Types$Mock$mockNestedSelectOptionList, $elm$core$Maybe$Just(F2(function (a, b) {
        return $author$project$TopMsg$msgComponentsPreview(A2($author$project$Ui$ComponentsPreview$Msg$NestedSelectOptionEdited, a, b));
      })), $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$NestedSelectOptionDeleted)), $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$NestedSelectOptionCreated))),
      d6: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
      hQ: $author$project$Ui$NestedTable$NestedTable$noExpandedRows,
      h_: false,
      jy: $author$project$Ui$RangeDateInput$RangeDateInput$initRangeDateInput({
        vd: time,
        Fw: $elm$core$Maybe$Just({
          dR: A4($justinmimbs$time_extra$Time$Extra$add, 11, 6, zone, time),
          Ef: time
        }),
        by: zone
      }),
      jN: $elm$core$Maybe$Nothing,
      jS: 0,
      ty: '',
      tJ: $elm$core$Maybe$Nothing,
      jY: $elm$core$Maybe$Just(A2($turboMaCk$any_dict$Dict$Any$fromList, $elm$core$Basics$identity, _List_fromArray([_Utils_Tuple2('1', 'One'), _Utils_Tuple2('2', 'Two'), _Utils_Tuple2('3', 'Three')]))),
      eC: A2($turboMaCk$any_set$Set$Any$fromList, $elm$core$Basics$identity, _List_fromArray(['1', '3'])),
      fc: false,
      $9: timeTransformationState
    };
  };

  var $author$project$Ui$Legal$Model$init = {
    l8: 0
  };
  var $author$project$Ui$OnboardingCompany$Model$ChooseAccountingApp = {
    $: 0
  };
  var $author$project$Types$EditingCompany$OneToTen = 0;
  var $author$project$Types$EditingCompany$init = {
    ke: $elm$core$Maybe$Nothing,
    uG: false,
    pu: '',
    kP: $elm$core$Maybe$Nothing,
    iI: '',
    wE: 1,
    xy: 6,
    zL: '',
    rE: '',
    zY: 0,
    b0: 0,
    jJ: '',
    nZ: $elm$core$Maybe$Nothing,
    DN: $elm$core$Maybe$Nothing,
    DQ: $elm$core$Maybe$Nothing,
    Ej: '',
    tI: '',
    ov: $elm$core$Maybe$Nothing,
    j0: '',
    FS: ''
  };
  var $author$project$Ui$OnboardingCompany$Model$init = {
    kT: $author$project$Ui$OnboardingCompany$Model$ChooseAccountingApp,
    Ca: $author$project$Types$EditingCompany$init,
    sj: false,
    sk: false
  };
  var $author$project$Api$GraphqlSchema$Enum$Account_type_enum$Cash = 0;
  var $author$project$Types$Scenario$SixMonths = 0;
  var $author$project$Types$EditingScenario$EditingScenario$empty = F2(function (zone, time) {
    return {
      bX: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$BuildingBlock$unwrapBuildingBlockId),
      E: '',
      rf: 0,
      zL: '',
      de: false,
      df: false,
      tB: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, zone, $elm$core$Maybe$Just(time))
    };
  });

  var $author$project$Ui$Scenario$Model$init = function (_v0) {
    var zone = _v0.by;
    var time = _v0.EM;
    return {
      pd: $author$project$Types$Filters$empty,
      p5: A2($author$project$Types$EditingScenario$EditingScenario$empty, zone, time),
      qi: $author$project$Ui$NestedTable$NestedTable$noExpandedRows,
      qk: true,
      rz: _List_Nil,
      nq: 0,
      nr: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId),
      ns: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(1), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init),
      sP: $elm$core$Maybe$Nothing
    };
  };

  var $author$project$Ui$Scenarios$Model$init = {
    pN: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId),
    qo: $author$project$Types$Filters$empty,
    h_: false,
    um: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init
  };
  var $author$project$Ui$Settings$Model$init = {
    xj: $author$project$Types$EditingCompany$init,
    xk: $elm$core$Maybe$Nothing,
    rB: _List_Nil
  };
  var $author$project$Ui$Support$Support$init = {
    iP: '',
    zu: '',
    zL: ''
  };
  var $author$project$UiWrappers$MainAppWrapSpecific$Model$init = {
    ph: '',
    qh: true
  };

  var $author$project$MainModule$init = function (programArgs) {
    var appArgs = programArgs.uH;
    var elmFrameworkArgs = programArgs.k4;

    var _v0 = $author$project$Remote$Remote$init(appArgs);

    var remoteState = _v0.a;
    var remoteCmd = _v0.b;

    var _v1 = $author$project$Global$Global$init(programArgs);

    var global = _v1.a;
    var globalCmd = _v1.b;
    var theState = {
      uz: $author$project$Ui$Accounts$Model$init({
        EM: $elm$time$Time$millisToPosix(elmFrameworkArgs.wo),
        by: A2($elm$time$Time$customZone, programArgs.k4.EQ, _List_Nil)
      }),
      u1: $author$project$Ui$Auth$Auth$init,
      vh: $author$project$Ui$Block$Model$init,
      vl: $author$project$Ui$Blocks$Model$init,
      vC: $author$project$Ui$Budget$Model$init,
      vO: $author$project$Ui$Cashboard$Model$init,
      v8: $author$project$Ui$ComponentsPreview$ComponentsPreview$init({
        EM: $elm$time$Time$millisToPosix(elmFrameworkArgs.wo),
        by: A2($elm$time$Time$customZone, programArgs.k4.EQ, _List_Nil)
      }),
      xn: $author$project$Types$EditingUsers$init,
      qC: global,
      zb: $author$project$Ui$Legal$Model$init,
      zi: $author$project$UiWrappers$MainAppWrapSpecific$Model$init,
      Cb: $author$project$Ui$OnboardingCompany$Model$init,
      CE: $author$project$PushMessages$PushMessages$init,
      CT: remoteState,
      DB: $author$project$Ui$Scenario$Model$init({
        EM: $elm$time$Time$millisToPosix(elmFrameworkArgs.wo),
        by: A2($elm$time$Time$customZone, programArgs.k4.EQ, _List_Nil)
      }),
      DC: $author$project$Ui$Scenarios$Model$init,
      D0: $author$project$Ui$Settings$Model$init,
      Ex: $author$project$Ui$Support$Support$init,
      Fo: $author$project$Types$UserProfile$init
    };
    return _Utils_Tuple2(theState, $elm$core$Platform$Cmd$batch(_List_fromArray([A2($elm$core$Platform$Cmd$map, $author$project$Msg$GlobalMsg, globalCmd), A2($elm$core$Platform$Cmd$map, $author$project$Msg$RemoteMsg, remoteCmd)])));
  };

  var $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$map = function (cfg) {
    var childToParentMapper = F2(function (appState, _v0) {
      var childState = _v0.a;
      var cmd = _v0.b;
      var msgs = _v0.c;
      return _Utils_Tuple3(A2(cfg.ps, appState, childState), A2($elm$core$Platform$Cmd$map, cfg.ry, cmd), msgs);
    });

    var toWatcher = function (childWatcher) {
      return function (payload) {
        return A2($elm$core$Maybe$map, childToParentMapper(payload.d7.o_), A2(childWatcher, payload, {
          d7: cfg.t4(payload.d7),
          eY: cfg.t4(payload.eY)
        }));
      };
    };

    return A2($elm$core$List$map, toWatcher, cfg.uo);
  };

  var $author$project$MulticastMessages$onNewGeolocation = function (anyTypeOfGeolocation) {
    return _List_Nil;
  };

  var $author$project$Msg$LegalMsg = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Global$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$PushMessages$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Legal$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $author$project$Msg$PushMessagesMsg = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$MainModule$onNewRouteMsgs = F3(function (_v0, oldHistory, route) {
    return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteMsg(A2($author$project$Remote$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$LegalMsg(A2($author$project$Ui$Legal$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$PushMessagesMsg(A2($author$project$PushMessages$Msg$OnRoute, oldHistory, route)))]);
  });
  var $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUpSingle = F2(function (_v0, _v1) {
    var handler = _v0.hz;
    var old = _v1.eY;
    var _new = _v1.d7;

    var _v2 = _Utils_Tuple2(handler(old), handler(_new));

    if (_v2.a.$ === 1 && !_v2.b.$) {
      var _v3 = _v2.a;
      var val = _v2.b.a;
      return $elm$core$Maybe$Just(val);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp = function (_v0) {
    var watchers = _v0.uo;
    var msgMapper = _v0.ry;
    var childStateSetter = _v0.ps;

    var toSingleHandler = function (watcher) {
      return $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUpSingle({
        hz: function (topState) {
          var _v1 = watcher(topState);

          if (!_v1.$) {
            var _v2 = _v1.a;
            var childState = _v2.a;
            var childCmd = _v2.b;
            var topMsgs = _v2.c;
            return $elm$core$Maybe$Just(_Utils_Tuple3(A2(childStateSetter, topState.o_, childState), A2($elm$core$Platform$Cmd$map, msgMapper, childCmd), topMsgs));
          } else {
            return $elm$core$Maybe$Nothing;
          }
        }
      });
    };

    return A2($elm$core$List$map, toSingleHandler, watchers);
  };

  var $author$project$Global$Msg$ReportErr = F2(function (a, b) {
    return {
      $: 9,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Lib$Util$decodeValue = F2(function (decoder, value) {
    return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeValue, decoder, value));
  });
  var $author$project$PushMessages$Model$PushMsg = F4(function (receivingCircumstances, title, body, payload) {
    return {
      d0: body,
      Cm: payload,
      CO: receivingCircumstances,
      t1: title
    };
  });

  var $author$project$PushMessages$Model$GeneralPushPayload = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$PushMessages$Model$NotificationPayload = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$PushMessages$Model$AvatarTransformationSuccess = $elm$core$Basics$identity;
  var $author$project$Types$Image$Image = F3(function (width, height, url) {
    return {
      x6: height,
      Fh: url,
      FE: width
    };
  });
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(function (key, valDecoder, decoder) {
    return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$field, key, valDecoder), decoder);
  });
  var $author$project$Types$Image$imageDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'height', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'width', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Types$Image$Image))));
  var $author$project$ElmFramework$Lib$Util$discriminantDecoder = F2(function (discriminantName, discriminantValue) {
    var checkValue = function (val) {
      return _Utils_eq(val, discriminantValue) ? $elm$json$Json$Decode$succeed(val) : $elm$json$Json$Decode$fail('unexpected ' + (discriminantName + (' for ' + (discriminantValue + (': ' + val)))));
    };

    return A2($elm$json$Json$Decode$andThen, checkValue, A2($elm$json$Json$Decode$field, discriminantName, $elm$json$Json$Decode$string));
  });

  var $author$project$PushMessages$GeneralPushPayloadDecoder$decodeSpecId = function (specId) {
    return A2($author$project$ElmFramework$Lib$Util$discriminantDecoder, 'specId', specId);
  };

  var $author$project$ElmFramework$Lib$Util$kindDecoder = function (kind) {
    return A2($author$project$ElmFramework$Lib$Util$discriminantDecoder, 'kind', kind);
  };

  var $author$project$PushMessages$GeneralPushPayloadDecoder$imageTransformationSuccessKindDecoder = $author$project$ElmFramework$Lib$Util$kindDecoder('ImageTransformationSuccess');
  var $author$project$PushMessages$GeneralPushPayloadDecoder$imageTransformationSuccessDecoder = F2(function (constructor, specId) {
    return A3($elm$json$Json$Decode$map3, F2(function (_v0, _v1) {
      return constructor;
    }), $author$project$PushMessages$GeneralPushPayloadDecoder$imageTransformationSuccessKindDecoder, $author$project$PushMessages$GeneralPushPayloadDecoder$decodeSpecId(specId));
  });
  var $author$project$PushMessages$GeneralPushPayloadDecoder$transformationKind = {
    u2: 'avatar',
    xB: 'exercise-video',
    Cz: 'progress-pic-back',
    CA: 'progress-pic-front',
    CB: 'progress-pic-side'
  };
  var $author$project$PushMessages$GeneralPushPayloadDecoder$avatarTransformationSuccessDecoder = A3($author$project$PushMessages$GeneralPushPayloadDecoder$imageTransformationSuccessDecoder, $elm$core$Basics$identity, $author$project$PushMessages$GeneralPushPayloadDecoder$transformationKind.u2, A2($elm$json$Json$Decode$field, 'transformations', $elm$json$Json$Decode$list($author$project$Types$Image$imageDecoder)));
  var $author$project$PushMessages$GeneralPushPayloadDecoder$generalPushPayloadDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([$author$project$PushMessages$GeneralPushPayloadDecoder$avatarTransformationSuccessDecoder]));
  var $author$project$Types$UserNotification$NotificationPayloadPayload = F4(function (message, createdAt, isRead, kind) {
    return {
      iK: createdAt,
      lU: isRead,
      f9: kind,
      zu: message
    };
  });
  var $author$project$PushMessages$NotificationPayloadDecoder$notificationPayloadKind = $elm$json$Json$Decode$oneOf(_List_Nil);
  var $author$project$PushMessages$NotificationPayloadDecoder$notificationPayloadDecoder = A5($elm$json$Json$Decode$map4, $author$project$Types$UserNotification$NotificationPayloadPayload, A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, A2($elm$json$Json$Decode$field, 'createdAt', $elm$json$Json$Decode$int)), A2($elm$json$Json$Decode$field, 'isRead', $elm$json$Json$Decode$bool), A2($elm$json$Json$Decode$field, 'payload', $author$project$PushMessages$NotificationPayloadDecoder$notificationPayloadKind));
  var $author$project$PushMessages$Decoders$pushPayloadDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$map, $author$project$PushMessages$Model$NotificationPayload, $author$project$PushMessages$NotificationPayloadDecoder$notificationPayloadDecoder), A2($elm$json$Json$Decode$map, $author$project$PushMessages$Model$GeneralPushPayload, $author$project$PushMessages$GeneralPushPayloadDecoder$generalPushPayloadDecoder)]));
  var $author$project$PushMessages$Model$NotifTapped = 2;
  var $author$project$PushMessages$Model$NotifWhenAppFocused = 0;
  var $author$project$PushMessages$Model$NotifWhenAppInBackground = 1;

  var $author$project$PushMessages$Decoders$toReceivingCircumstances = function (string) {
    switch (string) {
      case 'focused':
        return $elm$json$Json$Decode$succeed(0);

      case 'background':
        return $elm$json$Json$Decode$succeed(1);

      case 'tapped':
        return $elm$json$Json$Decode$succeed(2);

      default:
        var res = string;
        return $elm$json$Json$Decode$fail('unexpected receivingCircumstances: ' + res);
    }
  };

  var $author$project$PushMessages$Decoders$pushMsgDecoder = A5($elm$json$Json$Decode$map4, $author$project$PushMessages$Model$PushMsg, A2($elm$json$Json$Decode$andThen, $author$project$PushMessages$Decoders$toReceivingCircumstances, A2($elm$json$Json$Decode$field, 'receivingCircumstances', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'notification', 'title']), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'notification', 'body']), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Util$decodeString($author$project$PushMessages$Decoders$pushPayloadDecoder), $author$project$ElmFramework$Lib$Util$resultToDecoder), A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'data', 'payload']), $elm$json$Json$Decode$string)));
  var $author$project$PushMessages$Decoders$toPushNotification = $author$project$ElmFramework$Lib$Util$decodeValue($author$project$PushMessages$Decoders$pushMsgDecoder);

  var $author$project$PushMsgRouter$pushMsgRouter = function (pushMsg) {
    var _v0 = $author$project$PushMessages$Decoders$toPushNotification(pushMsg);

    if (!_v0.$) {
      var thePushMsg = _v0.a;
      var _v1 = thePushMsg.Cm;

      if (!_v1.$) {
        var payload = _v1.a;

        var messageSpecificContext = function () {
          var _v2 = payload.f9;
          return _List_Nil;
        }();

        return _Utils_ap(_List_Nil, messageSpecificContext);
      } else {
        var payload = _v1.a;
        return _List_Nil;
      }
    } else {
      var error = _v0.a;
      return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReportErr, 'pushMsgRouter', error)))]);
    }
  };

  var $author$project$Route$Route$Auth = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Route$Route$SignInWithCredentials = {
    $: 1
  };
  var $author$project$Route$Route$authEntryRoute = $author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials);
  var $author$project$Route$Route$Pending = {
    $: 1
  };
  var $author$project$Route$Route$homeRoute = $author$project$Route$Route$Pending;

  var $author$project$Route$RouteUtil$isAuthRoute = function (route) {
    if (!route.$) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Remote$Model$isAuthenticated = function (remote) {
    var _v0 = remote.EL;

    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Just(false);

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        return $elm$core$Maybe$Just(true);

      default:
        return $elm$core$Maybe$Just(true);
    }
  };

  var $author$project$Global$Msg$OnUserWantsBack = {
    $: 2
  };
  var $author$project$MainModule$onUserWantsBack = F2(function (state, route) {
    if ($elm_community$maybe_extra$Maybe$Extra$isJust(state.qC.gZ)) {
      return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg($author$project$Global$Msg$OnUserWantsBack))]);
    } else {
      switch (route.$) {
        case 0:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 1:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 3:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 8:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 2:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 7:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 10:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 9:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 11:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 12:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 13:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 14:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 15:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 4:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        case 5:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);

        default:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]);
      }
    }
  });
  var $author$project$MainModule$onUserWantsForward = F2(function (state, route) {
    switch (route.$) {
      case 0:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 1:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 3:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 8:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 7:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 2:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 10:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 9:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 11:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 12:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 13:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 14:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 15:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 4:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      case 5:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);

      default:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dk]);
    }
  });
  var $author$project$Route$OnboardingCompanyRoute$CompanyInfo = 0;

  var $author$project$Route$Route$OnboardingCompany = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Types$UserSession$unwrapIdToken = function (_v0) {
    var token = _v0;
    return token;
  };

  var $author$project$MainModule$redirect = F2(function (appState, route) {
    var userIsNotOnboardedYet = function () {
      var _v0 = appState.CT.EL;

      if (_v0.$ === 2) {
        var authUser = _v0.a;
        var userHasClaims = $author$project$Types$User$hasClaims($author$project$Types$UserSession$unwrapIdToken(authUser.u_.d5));
        return userHasClaims ? false : true;
      } else {
        return false;
      }
    }();

    var routeIsNotOnboarding = !_Utils_eq(route, $author$project$Route$Route$OnboardingCompany(0));
    var restrictRouteToOnboarding = userIsNotOnboardedYet && routeIsNotOnboarding;
    return restrictRouteToOnboarding ? $elm$core$Maybe$Just({
      tc: $author$project$Route$Route$OnboardingCompany(0),
      n4: true
    }) : $elm$core$Maybe$Nothing;
  });

  var $author$project$Route$RouteUtil$requiresAuthentication = function (route) {
    switch (route.$) {
      case 0:
        return false;

      case 1:
        return true;

      case 3:
        return false;

      case 8:
        return false;

      case 2:
        return false;

      case 7:
        return false;

      case 10:
        return false;

      case 9:
        return false;

      case 4:
        return true;

      case 5:
        return true;

      case 6:
        return true;

      case 11:
        return false;

      case 12:
        return false;

      case 13:
        return false;

      case 14:
        return false;

      default:
        return false;
    }
  };

  var $author$project$Route$Route$AcceptInvitation = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Route$Route$AcceptTermsOfUseDialog = 0;
  var $author$project$Route$Route$AccountCreationSuccess = {
    $: 4
  };

  var $author$project$Route$Route$AuthAction = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$Route$ComponentsPreview = {
    $: 9
  };

  var $author$project$Route$Route$ConfirmRegistration = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Route$Route$ForgotPassword = {
    $: 2
  };

  var $author$project$Route$Route$FromNotification = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$Types$Invitation$InviteCode = $elm$core$Basics$identity;

  var $author$project$Route$Route$Legal = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Route$LegalRoute$LegalRoutePrivacyPolicy = 1;
  var $author$project$Route$Route$OtherNotificationInRoute = 0;

  var $author$project$Route$Route$Register = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Route$Route$SelectedCompany = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });
  var $author$project$Route$Route$Support = {
    $: 8
  };

  var $author$project$Route$Route$UserProfile = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Route$RouteMappers$keysGetters = {
    Cm: $elm$core$Dict$get('payload'),
    DF: $elm$core$Dict$get('search-phrase')
  };

  var $author$project$Route$CompanyRoute$Blocks = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Route$CompanyRoute$Budget = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Route$CompanyRoute$Cashboard = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $author$project$Route$CompanyRoute$FinancialAccounts = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Route$CompanyRoute$Scenarios = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$CompanyRoute$Settings = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Types$BudgetQuery$BudgetQuery = F4(function (divisions, basis, comparisonScenarioId, yAxisSource) {
    return {
      pb: basis,
      pA: comparisonScenarioId,
      eO: divisions,
      ka: yAxisSource
    };
  });
  var $author$project$Types$Division$DivisionId = $elm$core$Basics$identity;

  var $author$project$Types$BudgetQuery$deserializeDivisions = function (string) {
    return A2($elm$core$Maybe$map, $elm$core$List$map($elm$core$Basics$identity), $elm$core$Result$toMaybe(A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$list($elm$json$Json$Decode$string), string)));
  };

  var $author$project$Api$GraphqlSchema$Enum$Basis_enum$Cash = 1;

  var $author$project$Api$GraphqlSchema$Enum$Basis_enum$fromString = function (enumString____) {
    switch (enumString____) {
      case 'ACCRUAL':
        return $elm$core$Maybe$Just(0);

      case 'CASH':
        return $elm$core$Maybe$Just(1);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$BudgetQuery$keys = {
    pb: 'basis',
    eO: 'divisions',
    nk: 'plot-by',
    Dw: 'scenario'
  };
  var $elm$core$Maybe$map4 = F5(function (func, ma, mb, mc, md) {
    if (ma.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var a = ma.a;

      if (mb.$ === 1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var b = mb.a;

        if (mc.$ === 1) {
          return $elm$core$Maybe$Nothing;
        } else {
          var c = mc.a;

          if (md.$ === 1) {
            return $elm$core$Maybe$Nothing;
          } else {
            var d = md.a;
            return $elm$core$Maybe$Just(A4(func, a, b, c, d));
          }
        }
      }
    }
  });
  var $author$project$Ui$Chart$BudgetChart$GrossProfit = 1;
  var $author$project$Ui$Chart$BudgetChart$NetProfit = 3;
  var $author$project$Ui$Chart$BudgetChart$OperatingProfit = 2;
  var $author$project$Ui$Chart$BudgetChart$Revenue = 0;

  var $author$project$Ui$Chart$BudgetChart$yAxisSourceFromString = function (string) {
    switch (string) {
      case 'Revenue':
        return $elm$core$Maybe$Just(0);

      case 'GrossProfit':
        return $elm$core$Maybe$Just(1);

      case 'OperatingProfit':
        return $elm$core$Maybe$Just(2);

      case 'NetProfit':
        return $elm$core$Maybe$Just(3);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$BudgetQuery$fromDict = function (dict) {
    return A5($elm$core$Maybe$map4, $author$project$Types$BudgetQuery$BudgetQuery, A2($elm$core$Maybe$andThen, $author$project$Types$BudgetQuery$deserializeDivisions, A2($elm$core$Dict$get, $author$project$Types$BudgetQuery$keys.eO, dict)), A2($elm$core$Maybe$andThen, $author$project$Api$GraphqlSchema$Enum$Basis_enum$fromString, A2($elm$core$Dict$get, $author$project$Types$BudgetQuery$keys.pb, dict)), A2($elm$core$Maybe$map, $elm$core$Basics$identity, A2($elm$core$Dict$get, $author$project$Types$BudgetQuery$keys.Dw, dict)), A2($elm$core$Maybe$andThen, $author$project$Ui$Chart$BudgetChart$yAxisSourceFromString, A2($elm$core$Dict$get, $author$project$Types$BudgetQuery$keys.nk, dict)));
  };

  var $author$project$Types$CashboardQuery$CashboardQuery = F4(function (accountType, divisions, reportingInterval, scenario) {
    return {
      it: accountType,
      eO: divisions,
      jD: reportingInterval,
      Dw: scenario
    };
  });

  var $author$project$Types$CashboardQuery$deserializeDivisions = function (string) {
    return A2($elm$core$Maybe$map, $elm$core$List$map($elm$core$Basics$identity), $elm$core$Result$toMaybe(A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$list($elm$json$Json$Decode$string), string)));
  };

  var $author$project$Api$GraphqlSchema$Enum$Account_type_enum$Credit = 1;

  var $author$project$Api$GraphqlSchema$Enum$Account_type_enum$fromString = function (enumString____) {
    switch (enumString____) {
      case 'CASH':
        return $elm$core$Maybe$Just(0);

      case 'CREDIT':
        return $elm$core$Maybe$Just(1);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$fromString = function (enumString____) {
    switch (enumString____) {
      case 'MONTHLY':
        return $elm$core$Maybe$Just(0);

      case 'WEEKLY':
        return $elm$core$Maybe$Just(1);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$CashboardQuery$keys = {
    it: 'account-type',
    eO: 'divisions',
    Dw: 'scenario',
    ot: 'time-interval'
  };

  var $author$project$Types$CashboardQuery$fromDict = function (dict) {
    return A5($elm$core$Maybe$map4, $author$project$Types$CashboardQuery$CashboardQuery, A2($elm$core$Maybe$andThen, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$fromString, A2($elm$core$Dict$get, $author$project$Types$CashboardQuery$keys.it, dict)), A2($elm$core$Maybe$andThen, $author$project$Types$CashboardQuery$deserializeDivisions, A2($elm$core$Dict$get, $author$project$Types$CashboardQuery$keys.eO, dict)), A2($elm$core$Maybe$andThen, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$fromString, A2($elm$core$Dict$get, $author$project$Types$CashboardQuery$keys.ot, dict)), A2($elm$core$Maybe$map, $elm$core$Basics$identity, A2($elm$core$Dict$get, $author$project$Types$CashboardQuery$keys.Dw, dict)));
  };

  var $author$project$ElmFramework$Lib$Url$path = function (thePath) {
    return {
      e2: thePath,
      h$: $elm$core$Dict$empty
    };
  };

  var $author$project$Route$BlocksRoute$BlockBasicDetails = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$BlocksRoute$BlocksBasic = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Route$BlocksRoute$BlocksClassification = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Route$BlocksRoute$BlocksClassificationDetails = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$BuildingBlockId = $elm$core$Basics$identity;

  var $author$project$Route$BlocksRoute$CreateBlock = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Route$BlocksRoute$EditBlock = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });
  var $author$project$Route$EditBuildingBlockRoute$DeleteBlock = 1;
  var $author$project$Route$EditBuildingBlockRoute$EditBuildingBlockRoute = 0;

  var $author$project$Route$EditBuildingBlockRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$2: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'edit-building-block':
            return $elm$core$Maybe$Just(0);

          case 'delete-block':
            return $elm$core$Maybe$Just(1);

          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$BlocksRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$8: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'blocks-basic':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$BlocksRoute$BlocksBasic(false));
            } else {
              if (_v0.b.a === 'filters' && !_v0.b.b.b) {
                var _v1 = _v0.b;
                return $elm$core$Maybe$Just($author$project$Route$BlocksRoute$BlocksBasic(true));
              } else {
                break _v0$8;
              }
            }

          case 'blocks-basic-details':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v2 = _v0.b;
              var id = _v2.a;
              return $elm$core$Maybe$Just($author$project$Route$BlocksRoute$BlockBasicDetails(id));
            } else {
              break _v0$8;
            }

          case 'blocks-classification-details':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v3 = _v0.b;
              var id = _v3.a;
              return $elm$core$Maybe$Just($author$project$Route$BlocksRoute$BlocksClassificationDetails(id));
            } else {
              break _v0$8;
            }

          case 'blocks-classification':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$BlocksRoute$BlocksClassification(false));
            } else {
              if (_v0.b.a === 'filters' && !_v0.b.b.b) {
                var _v4 = _v0.b;
                return $elm$core$Maybe$Just($author$project$Route$BlocksRoute$BlocksClassification(true));
              } else {
                break _v0$8;
              }
            }

          case 'create-block':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$BlocksRoute$CreateBlock, $author$project$Route$EditBuildingBlockRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'edit-block':
            if (_v0.b.b) {
              var _v5 = _v0.b;
              var buildingBlockId = _v5.a;
              var rest = _v5.b;
              return A2($elm$core$Maybe$map, $author$project$Route$BlocksRoute$EditBlock(buildingBlockId), $author$project$Route$EditBuildingBlockRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));
            } else {
              break _v0$8;
            }

          default:
            break _v0$8;
        }
      } else {
        break _v0$8;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$BudgetRoute$BudgetHome = 0;
  var $author$project$Route$BudgetRoute$ChooseBudgetScenario = 1;

  var $author$project$Route$BudgetRoute$toRoute = function (url) {
    var _v0 = url.e2;

    if (!_v0.b) {
      return $elm$core$Maybe$Just(0);
    } else {
      if (_v0.a === 'choose-budget-scenario' && !_v0.b.b) {
        return $elm$core$Maybe$Just(1);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }
  };

  var $author$project$Route$CashboardRoute$BuildingBlocks = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$CashboardRoute$CashboardHome = {
    $: 0
  };
  var $author$project$Route$CashboardRoute$ChooseScenario = {
    $: 1
  };

  var $author$project$Route$CashboardRoute$Comments = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Route$CashboardRoute$Reviews = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Route$BuildingBlocksRoute$BuildingBlocksFilters = 1;
  var $author$project$Route$BuildingBlocksRoute$BuildingBlocksRoute = 0;

  var $author$project$Route$BuildingBlocksRoute$toRoute = function (url) {
    var _v0 = url.e2;

    if (!_v0.b) {
      return $elm$core$Maybe$Just(0);
    } else {
      if (_v0.a === 'building-blocks-filters' && !_v0.b.b) {
        return $elm$core$Maybe$Just(1);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }
  };

  var $author$project$Types$Comment$CommentId = $elm$core$Basics$identity;

  var $author$project$Route$CommentsRoute$CommentReplies = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Route$CommentsRoute$CommentsFilters = {
    $: 2
  };
  var $author$project$Route$CommentsRoute$CommentsRoute = {
    $: 0
  };

  var $author$project$Route$CommentsRoute$CreateComment = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Route$CommentsRoute$DeleteComment = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Route$CommentsRoute$EditComment = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Route$CreateCommentRoute$ChooseReview = {
    $: 0
  };

  var $author$project$Route$CreateCommentRoute$ConfirmDeletingReview = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$CreateCommentRoute$CreateCommentForReview = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Route$CreateCommentRoute$CreateIndependentComment = {
    $: 4
  };
  var $author$project$Route$CreateCommentRoute$CreateReview = {
    $: 1
  };
  var $author$project$Types$Review$ReviewId = $elm$core$Basics$identity;

  var $author$project$Route$CreateCommentRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$5: while (true) {
      if (_v0.b) {
        if (_v0.b.b) {
          if (!_v0.b.b.b) {
            switch (_v0.a) {
              case 'confirm-delete-review':
                var _v1 = _v0.b;
                var reviewId = _v1.a;
                return $elm$core$Maybe$Just($author$project$Route$CreateCommentRoute$ConfirmDeletingReview(reviewId));

              case 'create-comment-for-review':
                var _v2 = _v0.b;
                var reviewId = _v2.a;
                return $elm$core$Maybe$Just($author$project$Route$CreateCommentRoute$CreateCommentForReview(reviewId));

              default:
                break _v0$5;
            }
          } else {
            break _v0$5;
          }
        } else {
          switch (_v0.a) {
            case 'choose-review':
              return $elm$core$Maybe$Just($author$project$Route$CreateCommentRoute$ChooseReview);

            case 'create-review':
              return $elm$core$Maybe$Just($author$project$Route$CreateCommentRoute$CreateReview);

            case 'create-independent-comment':
              return $elm$core$Maybe$Just($author$project$Route$CreateCommentRoute$CreateIndependentComment);

            default:
              break _v0$5;
          }
        }
      } else {
        break _v0$5;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$CommentsRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$6: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'comments':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$CommentsRoute$CommentsRoute);
            } else {
              break _v0$6;
            }

          case 'comment-replies':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v1 = _v0.b;
              var commentId = _v1.a;
              return $elm$core$Maybe$Just($author$project$Route$CommentsRoute$CommentReplies(commentId));
            } else {
              break _v0$6;
            }

          case 'comments-filters':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$CommentsRoute$CommentsFilters);
            } else {
              break _v0$6;
            }

          case 'create-comment':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CommentsRoute$CreateComment, $author$project$Route$CreateCommentRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'edit-comment':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v2 = _v0.b;
              var commentId = _v2.a;
              return $elm$core$Maybe$Just($author$project$Route$CommentsRoute$EditComment(commentId));
            } else {
              break _v0$6;
            }

          case 'delete-comment':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v3 = _v0.b;
              var commentId = _v3.a;
              return $elm$core$Maybe$Just($author$project$Route$CommentsRoute$DeleteComment(commentId));
            } else {
              break _v0$6;
            }

          default:
            break _v0$6;
        }
      } else {
        break _v0$6;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$ReviewsRoute$Review = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Route$ReviewsRoute$Reviews = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Route$ReviewRoute$ApproveReview = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Route$ReviewRoute$EditComment = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$ReviewRoute$ReviewRoute = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Route$ReviewRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$3: while (true) {
      if (_v0.b && _v0.b.b && !_v0.b.b.b) {
        switch (_v0.a) {
          case 'review':
            var _v1 = _v0.b;
            var reviewId = _v1.a;
            return $elm$core$Maybe$Just($author$project$Route$ReviewRoute$ReviewRoute(reviewId));

          case 'approve-review':
            var _v2 = _v0.b;
            var reviewId = _v2.a;
            return $elm$core$Maybe$Just($author$project$Route$ReviewRoute$ApproveReview(reviewId));

          case 'edit-comment':
            var _v3 = _v0.b;
            var commentId = _v3.a;
            return $elm$core$Maybe$Just($author$project$Route$ReviewRoute$EditComment(commentId));

          default:
            break _v0$3;
        }
      } else {
        break _v0$3;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$ReviewsRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$2: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'reviews':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v1 = _v0.b;
              var reviewId = _v1.a;
              return $elm$core$Maybe$Just($author$project$Route$ReviewsRoute$Reviews(reviewId));
            } else {
              break _v0$2;
            }

          case 'review':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$ReviewsRoute$Review, $author$project$Route$ReviewRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$CashboardRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$5: while (true) {
      if (!_v0.b) {
        return $elm$core$Maybe$Just($author$project$Route$CashboardRoute$CashboardHome);
      } else {
        switch (_v0.a) {
          case 'choose-scenario':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$CashboardRoute$ChooseScenario);
            } else {
              break _v0$5;
            }

          case 'building-blocks':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CashboardRoute$BuildingBlocks, $author$project$Route$BuildingBlocksRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'comments':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CashboardRoute$Comments, $author$project$Route$CommentsRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'reviews':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CashboardRoute$Reviews, $author$project$Route$ReviewsRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          default:
            break _v0$5;
        }
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$FinancialAccountsRoute$AddFinancialAccount = {
    $: 1
  };

  var $author$project$Route$FinancialAccountsRoute$EditFinancialAccount = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$FinancialAccount$FinancialAccountId = $elm$core$Basics$identity;
  var $author$project$Route$FinancialAccountsRoute$FinancialAccountsRoute = {
    $: 0
  };

  var $author$project$Route$FinancialAccountsRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$3: while (true) {
      if (_v0.b) {
        if (!_v0.b.b) {
          switch (_v0.a) {
            case 'financial-accounts':
              return $elm$core$Maybe$Just($author$project$Route$FinancialAccountsRoute$FinancialAccountsRoute);

            case 'add-financial-account':
              return $elm$core$Maybe$Just($author$project$Route$FinancialAccountsRoute$AddFinancialAccount);

            default:
              break _v0$3;
          }
        } else {
          if (_v0.a === 'edit-financial-account' && !_v0.b.b.b) {
            var _v1 = _v0.b;
            var financialAccountId = _v1.a;
            return $elm$core$Maybe$Just($author$project$Route$FinancialAccountsRoute$EditFinancialAccount(financialAccountId));
          } else {
            break _v0$3;
          }
        }
      } else {
        break _v0$3;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$ScenariosRoute$CreateScenario = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Route$ScenariosRoute$Drafts = {
    $: 1
  };
  var $author$project$Route$ScenariosRoute$EditScenario = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Route$ScenariosRoute$Scenarios = {
    $: 0
  };
  var $author$project$Route$EditScenarioRoute$BuildingBlockFilters = 1;
  var $author$project$Route$EditScenarioRoute$ChooseBuildingBlocks = 2;
  var $author$project$Route$EditScenarioRoute$EditMasterBlock = 3;
  var $author$project$Route$EditScenarioRoute$EditScenario = 0;

  var $author$project$Route$EditScenarioRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$4: while (true) {
      if (!_v0.b) {
        return $elm$core$Maybe$Just(0);
      } else {
        if (!_v0.b.b) {
          switch (_v0.a) {
            case 'building-block-filters':
              return $elm$core$Maybe$Just(1);

            case 'choose-building-blocks':
              return $elm$core$Maybe$Just(2);

            case 'edit-master-block':
              return $elm$core$Maybe$Just(3);

            default:
              break _v0$4;
          }
        } else {
          break _v0$4;
        }
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$ScenariosRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$4: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'scenarios':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$ScenariosRoute$Scenarios);
            } else {
              break _v0$4;
            }

          case 'drafts':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$ScenariosRoute$Drafts);
            } else {
              break _v0$4;
            }

          case 'create-scenario':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$ScenariosRoute$CreateScenario, $author$project$Route$EditScenarioRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'edit-scenario':
            if (_v0.b.b) {
              var _v1 = _v0.b;
              var id = _v1.a;
              var rest = _v1.b;
              return A2($elm$core$Maybe$map, $author$project$Route$ScenariosRoute$EditScenario(id), $author$project$Route$EditScenarioRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));
            } else {
              break _v0$4;
            }

          default:
            break _v0$4;
        }
      } else {
        break _v0$4;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$SettingsRoute$CompanyInfo = 0;
  var $author$project$Route$SettingsRoute$CompanyUsers = 2;
  var $author$project$Route$SettingsRoute$Divisions = 3;
  var $author$project$Route$SettingsRoute$Preferences = 1;

  var $author$project$Route$SettingsRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$4: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'company-info':
            return $elm$core$Maybe$Just(0);

          case 'preferences':
            return $elm$core$Maybe$Just(1);

          case 'company-users':
            return $elm$core$Maybe$Just(2);

          case 'divisions':
            return $elm$core$Maybe$Just(3);

          default:
            break _v0$4;
        }
      } else {
        break _v0$4;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$CompanyRoute$toRoute = F2(function (companyId, url) {
    var _v0 = url.e2;

    _v0$6: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'cashboard':
            var rest = _v0.b;
            var cashboardQuery = $author$project$Types$CashboardQuery$fromDict(url.h$);
            return A3($elm$core$Maybe$map2, $author$project$Route$CompanyRoute$Cashboard, cashboardQuery, $author$project$Route$CashboardRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'budget':
            var rest = _v0.b;
            var budgetQuery = $author$project$Types$BudgetQuery$fromDict(url.h$);
            return A3($elm$core$Maybe$map2, $author$project$Route$CompanyRoute$Budget, budgetQuery, $author$project$Route$BudgetRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'scenarios':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CompanyRoute$Scenarios, $author$project$Route$ScenariosRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'financial-accounts':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CompanyRoute$FinancialAccounts, $author$project$Route$FinancialAccountsRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'settings':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CompanyRoute$Settings, $author$project$Route$SettingsRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          case 'blocks':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$CompanyRoute$Blocks, $author$project$Route$BlocksRoute$toRoute($author$project$ElmFramework$Lib$Url$path(rest)));

          default:
            break _v0$6;
        }
      } else {
        break _v0$6;
      }
    }

    return $elm$core$Maybe$Nothing;
  });
  var $author$project$Route$OnboardingCompanyRoute$AddUsers = 1;
  var $author$project$Route$OnboardingCompanyRoute$CreateScenario = 3;
  var $author$project$Route$OnboardingCompanyRoute$Division = 2;

  var $author$project$Route$OnboardingCompanyRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$4: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'company-info':
            return $elm$core$Maybe$Just(0);

          case 'add-users':
            return $elm$core$Maybe$Just(1);

          case 'data-sync':
            return $elm$core$Maybe$Just(2);

          case 'create-scenario':
            return $elm$core$Maybe$Just(3);

          default:
            break _v0$4;
        }
      } else {
        break _v0$4;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$UserProfileRoute$ChangeEmail = {
    $: 1
  };
  var $author$project$Route$UserProfileRoute$ChangePassword = {
    $: 2
  };

  var $author$project$Route$UserProfileRoute$ConfirmCredentials = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Route$UserProfileRoute$DeleteAccount = {
    $: 3
  };
  var $author$project$Route$UserProfileRoute$UserProfileRoute = {
    $: 0
  };

  var $author$project$Route$UserProfileRoute$toRoute = function (url) {
    var _v0 = url.e2;

    _v0$7: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'user-profile':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$UserProfileRoute);

          case 'change-email':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$ChangeEmail);

          case 'change-password':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$ChangePassword);

          case 'delete-account':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$DeleteAccount);

          case 'confirm-credentials-change-email':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$ConfirmCredentials($author$project$Route$UserProfileRoute$ChangeEmail));

          case 'confirm-credentials-change-password':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$ConfirmCredentials($author$project$Route$UserProfileRoute$ChangePassword));

          case 'confirm-credentials-change-delete-account':
            return $elm$core$Maybe$Just($author$project$Route$UserProfileRoute$ConfirmCredentials($author$project$Route$UserProfileRoute$DeleteAccount));

          default:
            break _v0$7;
        }
      } else {
        break _v0$7;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Route$RouteMappers$routeFor = function (url) {
    var _v0 = url.e2;

    _v0$17: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'register':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$Register($elm$core$Maybe$Nothing)));
            } else {
              if (_v0.b.a === 'accept-terms' && !_v0.b.b.b) {
                var _v1 = _v0.b;
                return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$Register($elm$core$Maybe$Just(0))));
              } else {
                break _v0$17;
              }
            }

          case 'sign-in':
            if (_v0.b.b && _v0.b.a === 'credentials' && !_v0.b.b.b) {
              var _v2 = _v0.b;
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials));
            } else {
              break _v0$17;
            }

          case 'forgot-password':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword));
            } else {
              break _v0$17;
            }

          case 'confirm-registration':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ConfirmRegistration($elm$core$Maybe$Nothing)));
            } else {
              if (_v0.b.b.b && !_v0.b.b.b.b) {
                var _v3 = _v0.b;
                var username = _v3.a;
                var _v4 = _v3.b;
                var code = _v4.a;
                return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ConfirmRegistration($elm$core$Maybe$Just({
                  pw: code,
                  ug: username
                }))));
              } else {
                break _v0$17;
              }
            }

          case 'account-created':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$AccountCreationSuccess));
            } else {
              break _v0$17;
            }

          case 'auth':
            if (_v0.b.b && _v0.b.a === 'action' && !_v0.b.b.b) {
              var _v5 = _v0.b;
              var mode = A2($elm$core$Dict$get, 'mode', url.h$);
              var code = A2($elm$core$Dict$get, 'oobCode', url.h$);
              var args = A3($elm$core$Maybe$map2, F2(function (m, c) {
                return {
                  gW: m,
                  pw: c
                };
              }), mode, code);
              return $elm$core$Maybe$Just($author$project$Route$Route$AuthAction(args));
            } else {
              break _v0$17;
            }

          case 'support':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Support);
            } else {
              break _v0$17;
            }

          case 'legal':
            if (_v0.b.b && !_v0.b.b.b) {
              switch (_v0.b.a) {
                case 'terms-of-use':
                  var _v6 = _v0.b;
                  return $elm$core$Maybe$Just($author$project$Route$Route$Legal(0));

                case 'privacy-policy':
                  var _v7 = _v0.b;
                  return $elm$core$Maybe$Just($author$project$Route$Route$Legal(1));

                default:
                  break _v0$17;
              }
            } else {
              break _v0$17;
            }

          case 'accept-invitation':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v8 = _v0.b;
              var id = _v8.a;
              return $elm$core$Maybe$Just($author$project$Route$Route$AcceptInvitation(id));
            } else {
              break _v0$17;
            }

          case 'from-notification':
            if (!_v0.b.b) {
              var notifTypeDecoders = $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$succeed(0)]));
              return A2($elm$core$Maybe$map, $author$project$Route$Route$FromNotification, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Util$decodeString(notifTypeDecoders), $elm$core$Result$toMaybe), A2($elm$core$Maybe$andThen, $elm$url$Url$percentDecode, $author$project$Route$RouteMappers$keysGetters.Cm(url.h$))));
            } else {
              break _v0$17;
            }

          case 'components-preview':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$ComponentsPreview);
            } else {
              break _v0$17;
            }

          case 'onboarding-company':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$OnboardingCompany, $author$project$Route$OnboardingCompanyRoute$toRoute(_Utils_update(url, {
              e2: rest
            })));

          case 'company':
            if (_v0.b.b) {
              var _v9 = _v0.b;
              var companyId = _v9.a;
              var rest = _v9.b;
              return A2($elm$core$Maybe$map, $author$project$Route$Route$SelectedCompany(companyId), A2($author$project$Route$CompanyRoute$toRoute, companyId, _Utils_update(url, {
                e2: rest
              })));
            } else {
              break _v0$17;
            }

          case 'profile':
            var rest = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$UserProfile, $author$project$Route$UserProfileRoute$toRoute(_Utils_update(url, {
              e2: rest
            })));

          default:
            break _v0$17;
        }
      } else {
        break _v0$17;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Types$WebPageMetadata$cons = F2(function (theTitle, webPageMetadata) {
    return _Utils_update(webPageMetadata, {
      t1: _Utils_ap(theTitle, webPageMetadata.t1)
    });
  });

  var $author$project$Types$WebPageMetadata$title = function (theTitle) {
    return {
      E: '',
      sm: _List_Nil,
      t1: theTitle
    };
  };

  var $author$project$Route$SubRoute1Util$toMetadata = F2(function (state, subRoute1) {
    if (!subRoute1.$) {
      return $author$project$Types$WebPageMetadata$title('Sub Route 1 Variant 1');
    } else {
      return $author$project$Types$WebPageMetadata$title('Sub Route 1 Variant 2');
    }
  });
  var $author$project$Route$SubRoute2Util$toMetadata = F2(function (state, subRoute2) {
    if (!subRoute2.$) {
      return $author$project$Types$WebPageMetadata$title('Sub Route 2 Variant 1');
    } else {
      var subRoute1 = subRoute2.a;
      return A2($author$project$Types$WebPageMetadata$cons, 'Sub Route 2 Variant 2 > ', A2($author$project$Route$SubRoute1Util$toMetadata, state, subRoute1));
    }
  });
  var $author$project$Route$ToMetadata$toMetadata = F2(function (state, route) {
    switch (route.$) {
      case 2:
        return $author$project$Types$WebPageMetadata$title('Authentication Actions');

      case 0:
        switch (route.a.$) {
          case 0:
            if (route.a.a.$ === 1) {
              var _v1 = route.a.a;
              return $author$project$Types$WebPageMetadata$title('Register');
            } else {
              var _v2 = route.a.a.a;
              return $author$project$Types$WebPageMetadata$title('Register');
            }

          case 1:
            var _v3 = route.a;
            return $author$project$Types$WebPageMetadata$title('Sign In');

          case 2:
            var _v4 = route.a;
            return $author$project$Types$WebPageMetadata$title('Forgot Password');

          case 3:
            if (route.a.a.$ === 1) {
              var _v5 = route.a.a;
              return $author$project$Types$WebPageMetadata$title('Confirm Registration');
            } else {
              return $author$project$Types$WebPageMetadata$title('Confirm Registration From Link');
            }

          default:
            var _v6 = route.a;
            return $author$project$Types$WebPageMetadata$title('Account Created');
        }

      case 1:
        return $author$project$Types$WebPageMetadata$title('Loading..');

      case 3:
        return $author$project$Types$WebPageMetadata$title('Accept Invitation');

      case 8:
        return $author$project$Types$WebPageMetadata$title('Support');

      case 7:
        return $author$project$Types$WebPageMetadata$title('Legal');

      case 10:
        return $author$project$Types$WebPageMetadata$title('From notification');

      case 9:
        return $author$project$Types$WebPageMetadata$title('Components');

      case 11:
        return $author$project$Types$WebPageMetadata$title('Simple Route');

      case 12:
        return $author$project$Types$WebPageMetadata$title('Route With Sub Resource');

      case 13:
        return $author$project$Types$WebPageMetadata$title('Route With Query');

      case 14:
        var subRoute1 = route.b;
        return A2($author$project$Types$WebPageMetadata$cons, 'Route With Sub Route 1 > ', A2($author$project$Route$SubRoute1Util$toMetadata, state, subRoute1));

      case 15:
        var subRoute2 = route.b;
        return A2($author$project$Types$WebPageMetadata$cons, 'Route With Sub Sub Route > ', A2($author$project$Route$SubRoute2Util$toMetadata, state, subRoute2));

      case 4:
        return $author$project$Types$WebPageMetadata$title('Onboarding Company');

      case 5:
        return $author$project$Types$WebPageMetadata$title('Company');

      default:
        return $author$project$Types$WebPageMetadata$title('Profile');
    }
  });
  var $author$project$ElmFramework$Lib$Url$appendQueryParams = F2(function (queryParams, url) {
    return _Utils_update(url, {
      h$: queryParams
    });
  });
  var $author$project$ElmFramework$Lib$Url$cons = F2(function (base, url) {
    return _Utils_update(url, {
      e2: _Utils_ap(base, url.e2)
    });
  });

  var $author$project$Types$QueryType$toStringFromCustomQuery = function (customQuery) {
    if (!customQuery) {
      return 'CustomQuery1';
    } else {
      return 'CustomQuery2';
    }
  };

  var $author$project$Types$BudgetQuery$serializeDivisions = function (list) {
    return A2($elm$json$Json$Encode$encode, 0, A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, A2($elm$core$List$map, $author$project$Types$Division$unwrapDivisionId, list)));
  };

  var $author$project$Ui$Chart$BudgetChart$yAxisSourceToString = function (yAxisSource) {
    switch (yAxisSource) {
      case 0:
        return 'Revenue';

      case 1:
        return 'GrossProfit';

      case 2:
        return 'OperatingProfit';

      default:
        return 'NetProfit';
    }
  };

  var $author$project$Types$BudgetQuery$toDict = function (q) {
    return $elm$core$Dict$fromList(_List_fromArray([_Utils_Tuple2($author$project$Types$BudgetQuery$keys.eO, $author$project$Types$BudgetQuery$serializeDivisions(q.eO)), _Utils_Tuple2($author$project$Types$BudgetQuery$keys.pb, $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString(q.pb)), _Utils_Tuple2($author$project$Types$BudgetQuery$keys.Dw, $author$project$Types$Scenario$unwrapScenarioId(q.pA)), _Utils_Tuple2($author$project$Types$BudgetQuery$keys.nk, $author$project$Ui$Chart$BudgetChart$yAxisSourceToString(q.ka))]));
  };

  var $author$project$Types$CashboardQuery$serializeDivisions = function (list) {
    return A2($elm$json$Json$Encode$encode, 0, A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, A2($elm$core$List$map, $author$project$Types$Division$unwrapDivisionId, list)));
  };

  var $author$project$Types$CashboardQuery$toDict = function (q) {
    return $elm$core$Dict$fromList(_List_fromArray([_Utils_Tuple2($author$project$Types$CashboardQuery$keys.it, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString(q.it)), _Utils_Tuple2($author$project$Types$CashboardQuery$keys.eO, $author$project$Types$CashboardQuery$serializeDivisions(q.eO)), _Utils_Tuple2($author$project$Types$CashboardQuery$keys.ot, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString(q.jD)), _Utils_Tuple2($author$project$Types$CashboardQuery$keys.Dw, $author$project$Types$Scenario$unwrapScenarioId(q.Dw))]));
  };

  var $author$project$Route$EditBuildingBlockRoute$toUrl = function (route) {
    if (!route) {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['edit-building-block']));
    } else {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['delete-block']));
    }
  };

  var $author$project$Route$BlocksRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        if (route.a) {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['blocks-basic', 'filters']));
        } else {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['blocks-basic']));
        }

      case 2:
        var id = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['blocks-basic-details', id]));

      case 3:
        var id = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['blocks-classification-details', id]));

      case 1:
        if (route.a) {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['blocks-classification', 'filters']));
        } else {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['blocks-classification']));
        }

      case 4:
        var editBuildingBlockRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['create-block']), $author$project$Route$EditBuildingBlockRoute$toUrl(editBuildingBlockRoute));

      default:
        var buildingBlockId = route.a;
        var editBuildingBlockRoute = route.b;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['edit-block', buildingBlockId]), $author$project$Route$EditBuildingBlockRoute$toUrl(editBuildingBlockRoute));
    }
  };

  var $author$project$Route$BudgetRoute$toUrl = function (route) {
    if (!route) {
      return $author$project$ElmFramework$Lib$Url$path(_List_Nil);
    } else {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['choose-budget-scenario']));
    }
  };

  var $author$project$Route$BuildingBlocksRoute$toUrl = function (route) {
    if (!route) {
      return $author$project$ElmFramework$Lib$Url$path(_List_Nil);
    } else {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['building-blocks-filters']));
    }
  };

  var $author$project$Route$CreateCommentRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['choose-review']));

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['create-review']));

      case 2:
        var reviewId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-delete-review', reviewId]));

      case 3:
        var reviewId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['create-comment-for-review', reviewId]));

      default:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['create-independent-comment']));
    }
  };

  var $author$project$Route$CommentsRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['comments']));

      case 1:
        var commentId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['comment-replies', commentId]));

      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['comments-filters']));

      case 3:
        var createCommentRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['create-comment']), $author$project$Route$CreateCommentRoute$toUrl(createCommentRoute));

      case 4:
        var commentId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['edit-comment', commentId]));

      default:
        var commentId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['delete-comment', commentId]));
    }
  };

  var $author$project$Route$ReviewRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        var reviewId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['review', reviewId]));

      case 1:
        var reviewId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['approve-review', reviewId]));

      default:
        var commentId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['edit-comment', commentId]));
    }
  };

  var $author$project$Route$ReviewsRoute$toUrl = function (route) {
    if (!route.$) {
      var reviewId = route.a;
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['reviews', reviewId]));
    } else {
      var reviewRoute = route.a;
      return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['review']), $author$project$Route$ReviewRoute$toUrl(reviewRoute));
    }
  };

  var $author$project$Route$CashboardRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_Nil);

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['choose-scenario']));

      case 2:
        var buildingBlocksRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['building-blocks']), $author$project$Route$BuildingBlocksRoute$toUrl(buildingBlocksRoute));

      case 3:
        var commentsRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['comments']), $author$project$Route$CommentsRoute$toUrl(commentsRoute));

      default:
        var reviewsRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['reviews']), $author$project$Route$ReviewsRoute$toUrl(reviewsRoute));
    }
  };

  var $author$project$Route$FinancialAccountsRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['financial-accounts']));

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['add-financial-account']));

      case 2:
        var financialAccountId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['edit-financial-account', financialAccountId]));

      default:
        var financialAccountId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['delete-financial-account', financialAccountId]));
    }
  };

  var $author$project$Route$EditScenarioRoute$toUrl = function (route) {
    switch (route) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_Nil);

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['building-block-filters']));

      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['choose-building-blocks']));

      case 3:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['edit-master-block']));

      default:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-cancel-scenario-edit']));
    }
  };

  var $author$project$Route$ScenariosRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['scenarios']));

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['drafts']));

      case 2:
        var editScenarioRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['create-scenario']), $author$project$Route$EditScenarioRoute$toUrl(editScenarioRoute));

      default:
        var id = route.a;
        var editScenarioRoute = route.b;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['edit-scenario', id]), $author$project$Route$EditScenarioRoute$toUrl(editScenarioRoute));
    }
  };

  var $author$project$Route$SettingsRoute$toUrl = function (route) {
    switch (route) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['company-info']));

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['preferences']));

      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['company-users']));

      default:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['divisions']));
    }
  };

  var $author$project$Route$CompanyRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        var cashboardQuery = route.a;
        var cashboardRoute = route.b;
        return A2($author$project$ElmFramework$Lib$Url$appendQueryParams, $author$project$Types$CashboardQuery$toDict(cashboardQuery), A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['cashboard']), $author$project$Route$CashboardRoute$toUrl(cashboardRoute)));

      case 1:
        var budgetQuery = route.a;
        var budgetRoute = route.b;
        return A2($author$project$ElmFramework$Lib$Url$appendQueryParams, $author$project$Types$BudgetQuery$toDict(budgetQuery), A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['budget']), $author$project$Route$BudgetRoute$toUrl(budgetRoute)));

      case 2:
        var scenariosRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['scenarios']), $author$project$Route$ScenariosRoute$toUrl(scenariosRoute));

      case 4:
        var financialAccountsRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['financial-accounts']), $author$project$Route$FinancialAccountsRoute$toUrl(financialAccountsRoute));

      case 5:
        var settingsRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['settings']), $author$project$Route$SettingsRoute$toUrl(settingsRoute));

      default:
        var blocksRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['blocks']), $author$project$Route$BlocksRoute$toUrl(blocksRoute));
    }
  };

  var $author$project$Route$OnboardingCompanyRoute$toUrl = function (route) {
    switch (route) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['company-info']));

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['add-users']));

      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['data-sync']));

      default:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['create-scenario']));
    }
  };

  var $author$project$Route$SubRoute1$toUrl = function (subRoute1) {
    if (!subRoute1.$) {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['sub-route-1-variant-1']));
    } else {
      var a = subRoute1.a.uw;
      var b = subRoute1.a.u4;
      var c = subRoute1.a.vH;
      var d = subRoute1.a.ww;
      return {
        e2: _List_fromArray(['sub-route-1-variant-2']),
        h$: $elm$core$Dict$fromList(_List_fromArray([_Utils_Tuple2('a', a), _Utils_Tuple2('b', $elm$core$String$fromInt(b)), _Utils_Tuple2('c', $elm$core$String$fromInt($elm$time$Time$posixToMillis(c))), _Utils_Tuple2('d', $author$project$Types$QueryType$toStringFromCustomQuery(d))]))
      };
    }
  };

  var $author$project$Route$SubRoute2$toUrl = function (subRoute2) {
    if (!subRoute2.$) {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['sub-route-2-variant-1']));
    } else {
      var subRoute1 = subRoute2.a;
      return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['sub-route-2-variant-2']), $author$project$Route$SubRoute1$toUrl(subRoute1));
    }
  };

  var $author$project$Route$UserProfileRoute$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['user-profile']));

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['change-email']));

      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['change-password']));

      case 3:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['delete-account']));

      default:
        var subRoute = route.a;

        switch (subRoute.$) {
          case 1:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-credentials-change-email']));

          case 2:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-credentials-change-password']));

          case 3:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-credentials-change-delete-account']));

          default:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-credentials']));
        }

    }
  };

  var $author$project$Route$RouteMappers$urlFor = function (route) {
    switch (route.$) {
      case 2:
        if (!route.a.$) {
          var action = route.a.a.gW;
          var code = route.a.a.pw;
          return A2($author$project$ElmFramework$Lib$Url$appendQueryParams, $elm$core$Dict$fromList(_List_fromArray([_Utils_Tuple2('mode', action), _Utils_Tuple2('oobCode', code)])), $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['auth', 'action'])));
        } else {
          var _v5 = route.a;
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['auth', 'action']));
        }

      case 0:
        switch (route.a.$) {
          case 0:
            if (route.a.a.$ === 1) {
              var _v1 = route.a.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['register']));
            } else {
              var _v2 = route.a.a.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['register', 'accept-terms']));
            }

          case 1:
            var _v3 = route.a;
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['sign-in', 'credentials']));

          case 2:
            var _v4 = route.a;
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['forgot-password']));

          case 3:
            if (route.a.a.$ === 1) {
              var _v6 = route.a.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-registration']));
            } else {
              var username = route.a.a.a.ug;
              var code = route.a.a.a.pw;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-registration', username, code]));
            }

          default:
            var _v7 = route.a;
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['account-created']));
        }

      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['pending']));

      case 3:
        var id = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['accept-invitation', id]));

      case 8:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['support']));

      case 7:
        var subRoute = route.a;

        switch (subRoute) {
          case 0:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['legal', 'terms-of-use']));

          case 1:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['legal', 'privacy-policy']));

          default:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['legal', 'cookies']));
        }

      case 10:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['from-notification']));

      case 9:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['components-preview']));

      case 11:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['simple-route']));

      case 12:
        var userId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['route-with-subresource', userId]));

      case 13:
        var a = route.a.uw;
        var b = route.a.u4;
        var c = route.a.vH;
        var d = route.a.ww;
        return {
          e2: _List_fromArray(['route-with-query']),
          h$: $elm$core$Dict$fromList(_List_fromArray([_Utils_Tuple2('a', a), _Utils_Tuple2('b', $elm$core$String$fromInt(b)), _Utils_Tuple2('c', $elm$core$String$fromInt($elm$time$Time$posixToMillis(c))), _Utils_Tuple2('d', $author$project$Types$QueryType$toStringFromCustomQuery(d))]))
        };

      case 14:
        var subRoute1 = route.b;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['route-with-sub-route-1']), $author$project$Route$SubRoute1$toUrl(subRoute1));

      case 15:
        var subRoute2 = route.b;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['route-with-sub-sub-route']), $author$project$Route$SubRoute2$toUrl(subRoute2));

      case 4:
        var onboardingCompanyRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['onboarding-company']), $author$project$Route$OnboardingCompanyRoute$toUrl(onboardingCompanyRoute));

      case 5:
        var companyId = route.a;
        var companyRoute = route.b;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['company', companyId]), $author$project$Route$CompanyRoute$toUrl(companyRoute));

      default:
        var userProfileRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['profile']), $author$project$Route$UserProfileRoute$toUrl(userProfileRoute));
    }
  };

  var $author$project$MainModule$routingConfig = function () {
    var toTitleDescription = function (_v0) {
      var title = _v0.t1;
      var description = _v0.E;
      return {
        E: description,
        t1: title
      };
    };

    return {
      u$: $author$project$Route$Route$authEntryRoute,
      yb: $author$project$Route$Route$homeRoute,
      yD: $author$project$Route$RouteUtil$isAuthRoute,
      yE: function (appState) {
        return $author$project$Remote$Model$isAuthenticated(appState.CT);
      },
      Bf: $author$project$MainModule$onNewRouteMsgs,
      CR: $author$project$MainModule$redirect,
      Dm: $author$project$Route$RouteUtil$requiresAuthentication,
      Dr: F2(function (state, route) {
        return toTitleDescription(A2($author$project$Route$ToMetadata$toMetadata, state, route));
      }),
      Ds: $author$project$Route$RouteMappers$urlFor,
      Fi: $author$project$Route$RouteMappers$routeFor,
      Fq: $author$project$MainModule$onUserWantsBack,
      Fr: $author$project$MainModule$onUserWantsForward
    };
  }();

  var $author$project$ElmFramework$Msg$sendAppMsg = function (anAppMsg) {
    return $author$project$ElmFramework$Msg$AppMsg(anAppMsg);
  };

  var $author$project$Msg$sendRemoteMsg = function (remoteMsg) {
    return $author$project$ElmFramework$Msg$sendAppMsg($author$project$Msg$RemoteMsg(remoteMsg));
  };

  var $author$project$Remote$RequestMsg$GetAllBuildingBlocksDetails = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $elm_community$maybe_extra$Maybe$Extra$andThen2 = F3(function (func, ma, mb) {
    if (!ma.$) {
      var a = ma.a;

      if (!mb.$) {
        var b = mb.a;
        return A2(func, a, b);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $elm$core$List$all = F2(function (isOkay, list) {
    return !A2($elm$core$List$any, A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay), list);
  });

  var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
    if (data.$ === 1) {
      return true;
    } else {
      return false;
    }
  };

  var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
    if (data.$ === 3) {
      var x = data.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Types$BuildingBlock$areDetailsLoadingOrLoaded = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isSuccess(remoteData);

      case 1:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isSuccess(remoteData);

      case 2:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isSuccess(remoteData);

      default:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isSuccess(remoteData);
    }
  };

  var $author$project$Types$Company$areAllBlocksDetailsLoadedOrLoading = function (company) {
    var _v0 = company.pg;

    if (_v0.$ === 3) {
      var blocks = _v0.a;
      return A2($elm$core$List$all, $author$project$Types$BuildingBlock$areDetailsLoadingOrLoaded, $turboMaCk$any_dict$Dict$Any$values(blocks));
    } else {
      return false;
    }
  };

  var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
    if (data.$ === 2) {
      var x = data.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Types$BuildingBlock$areDetailsLoadingError = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isFailure(remoteData);

      case 1:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isFailure(remoteData);

      case 2:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isFailure(remoteData);

      default:
        var remoteData = _v0.a;
        return $krisajenkins$remotedata$RemoteData$isLoading(remoteData) || $krisajenkins$remotedata$RemoteData$isFailure(remoteData);
    }
  };

  var $author$project$Types$Company$areAnyBlocksDetailsLoadingError = function (company) {
    var _v0 = company.pg;

    if (_v0.$ === 3) {
      var blocks = _v0.a;
      return A2($elm$core$List$any, $author$project$Types$BuildingBlock$areDetailsLoadingError, $turboMaCk$any_dict$Dict$Any$values(blocks));
    } else {
      return false;
    }
  };

  var $turboMaCk$any_dict$Dict$Any$get = F2(function (k, _v0) {
    var dict = _v0.bT;
    var toKey = _v0.dn;
    return A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Dict$get, toKey(k), dict));
  });

  var $author$project$Msg$RemoteRequestMsg = function (a) {
    return {
      $: 15,
      a: a
    };
  };

  var $author$project$TopMsg$requestMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg);

  var $author$project$Remote$Model$toSession = function (remote) {
    var _v0 = remote.EL;

    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        return $elm$core$Maybe$Nothing;

      default:
        var thisUserSession = _v0.a;
        return $elm$core$Maybe$Just(thisUserSession);
    }
  };

  var $author$project$Remote$StateWatch$getBuildingBlocksDetailsForCompany = function (topState) {
    var routeShowingBlocksDetailsForCompany = function () {
      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      _v1$3: while (true) {
        if (_v1.$ === 5) {
          switch (_v1.b.$) {
            case 3:
              var companyId = _v1.a;
              return $elm$core$Maybe$Just(companyId);

            case 2:
              var companyId = _v1.a;
              var scenariosRoute = _v1.b.a;

              switch (scenariosRoute.$) {
                case 3:
                  return $elm$core$Maybe$Just(companyId);

                case 2:
                  return $elm$core$Maybe$Just(companyId);

                default:
                  return $elm$core$Maybe$Nothing;
              }

            case 0:
              var companyId = _v1.a;
              var _v3 = _v1.b;
              var cashboardRoute = _v3.b;

              if (cashboardRoute.$ === 2) {
                return $elm$core$Maybe$Just(companyId);
              } else {
                return $elm$core$Maybe$Nothing;
              }

            default:
              break _v1$3;
          }
        } else {
          break _v1$3;
        }
      }

      return $elm$core$Maybe$Nothing;
    }();

    var remote = topState.o_.CT;
    var maybeSession = $author$project$Remote$Model$toSession(remote);
    var maybeCompanyFromRoute = A3($elm_community$maybe_extra$Maybe$Extra$andThen2, F2(function (session, companyId) {
      return A2($turboMaCk$any_dict$Dict$Any$get, companyId, session.v5);
    }), maybeSession, routeShowingBlocksDetailsForCompany);
    var blocksDetailsLoadedOrLoadingOrError = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (company) {
      return $author$project$Types$Company$areAllBlocksDetailsLoadedOrLoading(company) || $author$project$Types$Company$areAnyBlocksDetailsLoadingError(company);
    }, maybeCompanyFromRoute));

    var _v0 = _Utils_Tuple3(maybeSession, maybeCompanyFromRoute, blocksDetailsLoadedOrLoadingOrError);

    if (!_v0.a.$ && !_v0.b.$ && !_v0.c) {
      var company = _v0.b.a;
      return $elm$core$Maybe$Just(_Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetAllBuildingBlocksDetails(company.F))])));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Remote$RequestMsg$GetCompanyDetails = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$Company$isCompanyLoadedOrLoading = function (company) {
    return $krisajenkins$remotedata$RemoteData$isSuccess(company.db) || $krisajenkins$remotedata$RemoteData$isLoading(company.db);
  };

  var $author$project$Types$Company$isCompanyLoadingError = function (company) {
    return $krisajenkins$remotedata$RemoteData$isFailure(company.db);
  };

  var $author$project$Route$RouteUtil$toCompanyId = function (route) {
    if (route.$ === 5) {
      var id = route.a;
      return $elm$core$Maybe$Just(id);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Remote$StateWatch$getCompanyDetails = function (topState) {
    var remote = topState.o_.CT;
    var maybeSession = $author$project$Remote$Model$toSession(remote);
    var maybeCompanyIdFromRoute = $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc));
    var companyLoadedOrLoadingOrError = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (company) {
      return $author$project$Types$Company$isCompanyLoadedOrLoading(company) || $author$project$Types$Company$isCompanyLoadingError(company);
    }, A3($elm_community$maybe_extra$Maybe$Extra$andThen2, F2(function (session, companyId) {
      return A2($turboMaCk$any_dict$Dict$Any$get, companyId, session.v5);
    }), maybeSession, maybeCompanyIdFromRoute)));

    var _v0 = _Utils_Tuple3(maybeCompanyIdFromRoute, maybeSession, companyLoadedOrLoadingOrError);

    if (!_v0.a.$ && !_v0.b.$ && !_v0.c) {
      var companyId = _v0.a.a;
      return $elm$core$Maybe$Just(_Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetCompanyDetails(companyId))])));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Remote$RequestMsg$GetAuthMetadata = {
    $: 5
  };

  var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
    if (!data.$) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Remote$Model$toAuth = function (remote) {
    var _v0 = remote.EL;

    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        var authUser = _v0.a;
        return $elm$core$Maybe$Just(authUser.u_);

      default:
        var thisUserSession = _v0.a;
        return $elm$core$Maybe$Just(thisUserSession.u_);
    }
  };

  var $elm_community$maybe_extra$Maybe$Extra$cons = F2(function (item, list) {
    if (!item.$) {
      var v = item.a;
      return A2($elm$core$List$cons, v, list);
    } else {
      return list;
    }
  });
  var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);

  var $author$project$Remote$StateWatch$getInitData = function (topState) {
    var remote = topState.o_.CT;
    var getAuthMetadata = $krisajenkins$remotedata$RemoteData$isNotAsked(remote.tb) ? $elm$core$Maybe$Just($author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetAuthMetadata)) : $elm$core$Maybe$Nothing;
    return $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Remote$Model$toAuth(remote)) ? $elm$core$Maybe$Just(_Utils_Tuple3(remote, $elm$core$Platform$Cmd$none, $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([getAuthMetadata])))) : $elm$core$Maybe$Nothing;
  };

  var $author$project$Remote$StateWatch$stateWatchers = _List_fromArray([$author$project$Remote$StateWatch$getCompanyDetails, $author$project$Remote$StateWatch$getBuildingBlocksDetailsForCompany, $author$project$Remote$StateWatch$getInitData]);

  var $author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Types$BuildingBlockHydrated$BasicThingHydrated = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated = F3(function (a, b, c) {
    return {
      $: 2,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Types$BuildingBlockHydrated$DerivativeThingHydrated = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });

  var $author$project$Types$BuildingBlockHydrated$toHydratedType = function (blockType) {
    switch (blockType.$) {
      case 0:
        if (blockType.a.$ === 3) {
          var _v1 = blockType.a.a;
          var a = _v1.a;
          var b = _v1.b;
          return $elm$core$Maybe$Just(A2($author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated, a, b));
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 1:
        if (blockType.a.$ === 3) {
          var _v2 = blockType.a.a;
          var a = _v2.a;
          var b = _v2.b;
          return $elm$core$Maybe$Just(A2($author$project$Types$BuildingBlockHydrated$BasicThingHydrated, a, b));
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 2:
        if (blockType.a.$ === 3) {
          var _v3 = blockType.a.a;
          var a = _v3.a;
          var b = _v3.b;
          var c = _v3.c;
          return $elm$core$Maybe$Just(A3($author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated, a, b, c));
        } else {
          return $elm$core$Maybe$Nothing;
        }

      default:
        if (blockType.a.$ === 3) {
          var _v4 = blockType.a.a;
          var a = _v4.a;
          var b = _v4.b;
          return $elm$core$Maybe$Just(A2($author$project$Types$BuildingBlockHydrated$DerivativeThingHydrated, a, b));
        } else {
          return $elm$core$Maybe$Nothing;
        }

    }
  };

  var $author$project$Types$BuildingBlockHydrated$fromBuildingBlock = function (buildingBlock) {
    var toHydratedBlock = function (blockType) {
      return {
        kw: blockType,
        iK: buildingBlock.iK,
        F: buildingBlock.F,
        zL: buildingBlock.zL,
        bw: buildingBlock.bw
      };
    };

    return A2($elm$core$Maybe$map, toHydratedBlock, $author$project$Types$BuildingBlockHydrated$toHydratedType(buildingBlock.kw));
  };

  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$Basic = 0;
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$Derivative = 1;

  var $author$project$Types$MoneyOrThing$Thing = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$ViewModelStringToFraction$fromFraction = F2(function (name, fraction) {
    return A3($author$project$ElmFramework$Lib$ViewModelStringTo$fromString, name, $author$project$ElmFramework$Lib$ViewModelStringToFraction$parser, A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(fraction)));
  });
  var $justinmimbs$time_extra$Time$Extra$Parts = F7(function (year, month, day, hour, minute, second, millisecond) {
    return {
      wz: day,
      yc: hour,
      zz: millisecond,
      zE: minute,
      zG: month,
      tj: second,
      FP: year
    };
  });
  var $author$project$Types$SimpleDate$toPosix = F2(function (zone, _v0) {
    var year = _v0.FP;
    var month = _v0.zG;
    var day = _v0.wz;
    return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, A7($justinmimbs$time_extra$Time$Extra$Parts, year, month, day, 0, 0, 0, 0));
  });

  var $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$fromGrowthPattern = function (growthPattern) {
    return {
      ao: A2($author$project$ElmFramework$Lib$ViewModelStringToInt$fromInt, 'Every', growthPattern.ao),
      ap: growthPattern.ap,
      bR: A2($author$project$ElmFramework$Lib$ViewModelStringToFraction$fromFraction, 'Rate', growthPattern.bR),
      bw: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Just(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, growthPattern.bw)))
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$fromRepeatPattern = function (repeatPattern) {
    return {
      hn: function () {
        var _v0 = repeatPattern.hn;

        if (!_v0.$) {
          var c = _v0.a;
          return {
            k: $elm$core$Maybe$Just($elm$core$String$fromInt(c)),
            iL: $elm$core$Maybe$Nothing
          };
        } else {
          var d = _v0.a;
          return {
            k: $elm$core$Maybe$Nothing,
            iL: $elm$core$Maybe$Just(A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Just(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, d))))
          };
        }
      }(),
      ao: A2($author$project$ElmFramework$Lib$ViewModelStringToInt$fromInt, 'Every', repeatPattern.ao),
      ap: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(repeatPattern.ap), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init)
    };
  };

  var $author$project$Types$MonthAdjustments$fromArray = function (array) {
    return A2($elm$core$Array$indexedMap, F2(function (index, value) {
      return A3($author$project$ElmFramework$Lib$Util$flip, $author$project$ElmFramework$Lib$ViewModelStringToInt$fromInt, value, $author$project$Types$SimpleDate$monthToString($justinmimbs$date$Date$numberToMonth(index + 1)));
    }), array);
  };

  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$fromSeasonalityInBlock = function (seasonalityInBlock) {
    if (!seasonalityInBlock.$) {
      var seasonalityId = seasonalityInBlock.a;
      return {
        dW: $author$project$Types$MonthAdjustments$empty,
        sH: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(seasonalityId), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init),
        gu: ''
      };
    } else {
      var array = seasonalityInBlock.a;
      return {
        dW: $author$project$Types$MonthAdjustments$fromArray(array),
        sH: $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init,
        gu: ''
      };
    }
  };

  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$fromBasicPayload = function (_v0) {
    var baseValue = _v0.g5;
    var seasonality = _v0.bK;
    var growthPattern = _v0.fZ;
    var repeatPattern = _v0.h2;
    return {
      g5: A2($author$project$ElmFramework$Lib$ViewModelStringToFraction$fromFraction, 'Base Value', baseValue),
      fZ: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$empty, $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$fromGrowthPattern, growthPattern),
      h2: $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$fromRepeatPattern(repeatPattern),
      bK: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Types$EditingBuildingBlock$EditingSeasonality$empty, $author$project$Types$EditingBuildingBlock$EditingSeasonality$fromSeasonalityInBlock, seasonality)
    };
  };

  var $author$project$ElmFramework$Lib$ViewModelStringToFloat$fromFloat = F2(function (name, _float) {
    return A3($author$project$ElmFramework$Lib$ViewModelStringTo$fromString, name, A2($elm$core$Basics$composeR, $elm$core$String$toFloat, $elm$core$Result$fromMaybe('')), $elm$core$String$fromFloat(_float));
  });

  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$IdleWithSelection = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$Model$toKeyValFromTimeTransformAllocation = function (allocation) {
    return _Utils_Tuple2(allocation.iL, allocation.qU);
  };

  var $author$project$Ui$TimeTransformation$Model$fromTimeTransformationBackend = function (_v0) {
    var refInterval = _v0.sT;
    var timeTransformationAllocations = _v0.t_;
    return {
      yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$Idle,
      iY: '',
      yx: A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$SimpleDate$toDateString, A2($elm$core$List$map, $author$project$Ui$TimeTransformation$Model$toKeyValFromTimeTransformAllocation, timeTransformationAllocations)),
      Cj: $elm$core$Maybe$Nothing,
      DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$IdleWithSelection({
        xv: refInterval.xw,
        Eg: refInterval.Ef
      })
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$fromDerivativePayload = function (_v0) {
    var endOn = _v0.ho;
    var multiplier = _v0.r;
    var per = _v0.t;
    var timeTransform = _v0.gM;
    var derivativeOf = _v0.hk;
    return {
      hk: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(derivativeOf), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init),
      ho: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Just(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, endOn))),
      r: A2($author$project$ElmFramework$Lib$ViewModelStringToFloat$fromFloat, 'Multiplier', multiplier),
      t: A2($author$project$ElmFramework$Lib$ViewModelStringToFloat$fromFloat, 'Per', per),
      gM: A2($elm$core$Maybe$withDefault, $author$project$Ui$TimeTransformation$Model$empty, A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$Model$fromTimeTransformationBackend, timeTransform)),
      j5: $author$project$Api$Types$CharacterizeTimeTransformResponse$empty
    };
  };

  var $author$project$Ui$FinancialAccountDropdownSelector$fromSelection = function (financialAccountId) {
    return {
      W: '',
      ia: $elm$core$Maybe$Just(financialAccountId)
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$fromMoneyPayload = function (_v0) {
    var unit = _v0.V;
    var basis = _v0.pb;
    var basisTransform = _v0.fE;
    var allocationClassData = _v0.kg;
    return {
      kf: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
        return $.iu;
      }, function ($) {
        return $.kf;
      }), allocationClassData), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init),
      bS: A2($elm$core$Maybe$withDefault, $author$project$Ui$FinancialAccountDropdownSelector$init, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
        return $.iu;
      }, A2($elm$core$Basics$composeR, function ($) {
        return $.lo;
      }, $author$project$Ui$FinancialAccountDropdownSelector$fromSelection)), allocationClassData)),
      pb: basis,
      fE: A2($elm$core$Maybe$withDefault, $author$project$Ui$TimeTransformation$Model$empty, A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$Model$fromTimeTransformationBackend, basisTransform)),
      iy: $author$project$Api$Types$CharacterizeTimeTransformResponse$empty,
      iZ: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
        return $.qZ;
      }, $elm$core$Maybe$map(function ($) {
        return $.kf;
      })), allocationClassData), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init),
      bU: A2($elm$core$Maybe$withDefault, $author$project$Ui$FinancialAccountDropdownSelector$init, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
        return $.qZ;
      }, $elm$core$Maybe$map(A2($elm$core$Basics$composeR, function ($) {
        return $.lo;
      }, $author$project$Ui$FinancialAccountDropdownSelector$fromSelection))), allocationClassData)),
      f6: $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm$core$Maybe$andThen, function ($) {
        return $.qZ;
      }, allocationClassData))
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$fromBuildingBlock = function (_v0) {
    var name = _v0.zL;
    var createdAt = _v0.iK;
    var blockType = _v0.kw;
    var startOn = _v0.bw;

    var moneyOrThing = function () {
      switch (blockType.$) {
        case 0:
          var money = blockType.b;
          return $author$project$Types$MoneyOrThing$Money(money.V);

        case 1:
          var thing = blockType.b;
          return $author$project$Types$MoneyOrThing$Thing(thing.V);

        case 2:
          var money = blockType.b;
          return $author$project$Types$MoneyOrThing$Money(money.V);

        default:
          var thing = blockType.b;
          return $author$project$Types$MoneyOrThing$Thing(thing.V);
      }
    }();

    var basicOrDerivative = $elm$core$Maybe$Just(function () {
      switch (blockType.$) {
        case 0:
          return 0;

        case 1:
          return 0;

        case 2:
          return 1;

        default:
          return 1;
      }
    }());
    return {
      g7: basicOrDerivative,
      fD: function () {
        switch (blockType.$) {
          case 0:
            var basicPayload = blockType.a;
            return $author$project$Types$EditingBuildingBlock$EditingBasicPayload$fromBasicPayload(basicPayload);

          case 1:
            var basicPayload = blockType.a;
            return $author$project$Types$EditingBuildingBlock$EditingBasicPayload$fromBasicPayload(basicPayload);

          case 2:
            return $author$project$Types$EditingBuildingBlock$EditingBasicPayload$empty;

          default:
            return $author$project$Types$EditingBuildingBlock$EditingBasicPayload$empty;
        }
      }(),
      fP: function () {
        switch (blockType.$) {
          case 0:
            return $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$empty;

          case 1:
            return $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$empty;

          case 2:
            var baseBasis = blockType.c.fB;
            return {
              fB: baseBasis
            };

          default:
            return $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$empty;
        }
      }(),
      d2: function () {
        switch (blockType.$) {
          case 0:
            return $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$empty;

          case 1:
            return $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$empty;

          case 2:
            var derivativePayload = blockType.a;
            return $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$fromDerivativePayload(derivativePayload);

          default:
            var derivativePayload = blockType.a;
            return $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$fromDerivativePayload(derivativePayload);
        }
      }(),
      hO: moneyOrThing,
      cU: function () {
        switch (blockType.$) {
          case 0:
            var moneyPayload = blockType.b;
            return $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$fromMoneyPayload(moneyPayload);

          case 1:
            return $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$empty;

          case 2:
            var moneyPayload = blockType.b;
            return $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$fromMoneyPayload(moneyPayload);

          default:
            return $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$empty;
        }
      }(),
      zL: A3($author$project$ElmFramework$Lib$ViewModelStringTo$fromString, 'Building Block Name', $elm$core$Result$Ok, name),
      bw: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, $elm$time$Time$utc, $elm$core$Maybe$Just(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, startOn))),
      eD: function () {
        switch (blockType.$) {
          case 0:
            return $author$project$Types$EditingBuildingBlock$EditingThingPayload$empty;

          case 1:
            return {};

          case 2:
            return $author$project$Types$EditingBuildingBlock$EditingThingPayload$empty;

          default:
            return {};
        }
      }()
    };
  };

  var $author$project$Route$RouteUtil$isAnyEditBlockRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 3 && route.b.a.$ === 5) {
      var _v1 = route.b.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$previous = function (_v0) {
    var routeHistory = _v0.a;
    return A2($elm$core$Maybe$map, $wernerdegroot$listzipper$List$Zipper$current, $wernerdegroot$listzipper$List$Zipper$previous(routeHistory));
  };

  var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $krisajenkins$remotedata$RemoteData$Loading = {
    $: 1
  };

  var $krisajenkins$remotedata$RemoteData$Success = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $krisajenkins$remotedata$RemoteData$map = F2(function (f, data) {
    switch (data.$) {
      case 3:
        var value = data.a;
        return $krisajenkins$remotedata$RemoteData$Success(f(value));

      case 1:
        return $krisajenkins$remotedata$RemoteData$Loading;

      case 0:
        return $krisajenkins$remotedata$RemoteData$NotAsked;

      default:
        var error = data.a;
        return $krisajenkins$remotedata$RemoteData$Failure(error);
    }
  });
  var $krisajenkins$remotedata$RemoteData$withDefault = F2(function (_default, data) {
    if (data.$ === 3) {
      var x = data.a;
      return x;
    } else {
      return _default;
    }
  });
  var $krisajenkins$remotedata$RemoteData$toMaybe = A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just), $krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));

  var $author$project$Ui$Block$StateWatch$setEditingBlock = function (topState) {
    var theBlockFromCurrRoute = function () {
      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      if (_v1.$ === 5 && _v1.b.$ === 3 && _v1.b.a.$ === 5) {
        var companyId = _v1.a;
        var _v2 = _v1.b.a;
        var buildingBlockId = _v2.a;
        return A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlockHydrated$fromBuildingBlock, A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(buildingBlockId), A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
          return $.pg;
        }, $krisajenkins$remotedata$RemoteData$toMaybe), A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(companyId), A2($elm$core$Maybe$map, function ($) {
          return $.v5;
        }, $author$project$Remote$Model$toSession(topState.o_.CT))))));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var state = topState.o_.vh;
    var previousRouteIsEditBlockRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$RouteUtil$isAnyEditBlockRoute, $author$project$ElmFramework$Feature$Navigation$RouteHistory$previous(topState.tc)));

    var _v0 = _Utils_Tuple2(previousRouteIsEditBlockRoute, theBlockFromCurrRoute);

    if (!_v0.a && !_v0.b.$) {
      var block = _v0.b.a;
      return $elm$core$Maybe$Just(_Utils_Tuple3(_Utils_update(state, {
        bv: $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$fromBuildingBlock(block)
      }), $elm$core$Platform$Cmd$none, _List_Nil));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Block$StateWatch$stateWatchers = _List_fromArray([$author$project$Ui$Block$StateWatch$setEditingBlock]);

  var $elm$core$Dict$filter = F2(function (isGood, dict) {
    return A3($elm$core$Dict$foldl, F3(function (k, v, d) {
      return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
    }), $elm$core$Dict$empty, dict);
  });
  var $turboMaCk$any_dict$Dict$Any$filter = F2(function (f, _v0) {
    var inner = _v0;
    return _Utils_update(inner, {
      bT: A2($elm$core$Dict$filter, F2(function (_v1, _v2) {
        var k = _v2.a;
        var v = _v2.b;
        return A2(f, k, v);
      }), inner.bT)
    });
  });
  var $turboMaCk$any_dict$Dict$Any$keys = A2($elm$core$Basics$composeL, $elm$core$List$map($elm$core$Tuple$first), $turboMaCk$any_dict$Dict$Any$toList);
  var $author$project$Ui$Budget$StateWatch$maybeScenariosWithoutScenarioId = F2(function (scenarioId, company) {
    return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$filter(F2(function (k, _v0) {
      return !_Utils_eq(k, scenarioId);
    })), $turboMaCk$any_dict$Dict$Any$keys), $krisajenkins$remotedata$RemoteData$toMaybe(company.db));
  });
  var $author$project$Types$BudgetQuery$setComparisonScenarioId = F2(function (val, query) {
    return _Utils_update(query, {
      pA: val
    });
  });
  var $author$project$Ui$Budget$StateWatch$handleScenarios = F2(function (budgetQuery, company) {
    var _v0 = company.pe;

    if (!_v0.$) {
      var budgetScenarioId = _v0.a;
      var isScenarioEq = F2(function (scenario1, scenario2) {
        return _Utils_eq($author$project$Types$Scenario$unwrapScenarioId(scenario1), $author$project$Types$Scenario$unwrapScenarioId(scenario2));
      });

      var handleGetFirstNonBudgetScenario = function (_v3) {
        return A2($elm$core$Maybe$andThen, function (scenarioIds) {
          if (!scenarioIds.b) {
            return $elm$core$Maybe$Just(_Utils_Tuple2(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)), 'Please create a scenario to compare the budget scenario with'));
          } else {
            var id = scenarioIds.a;
            return $elm$core$Maybe$Just(_Utils_Tuple2(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Budget, A2($author$project$Types$BudgetQuery$setComparisonScenarioId, id, budgetQuery), 0)), ''));
          }
        }, A2($author$project$Ui$Budget$StateWatch$maybeScenariosWithoutScenarioId, budgetScenarioId, company));
      };

      var _v1 = company.pa;

      if (!_v1.$) {
        var baseScenarioId = _v1.a;
        return A2(isScenarioEq, budgetScenarioId, baseScenarioId) ? handleGetFirstNonBudgetScenario(0) : $elm$core$Maybe$Nothing;
      } else {
        return handleGetFirstNonBudgetScenario(0);
      }
    } else {
      return $elm$core$Maybe$Just(_Utils_Tuple2(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)), 'Please choose or create a budget scenario first'));
    }
  });

  var $author$project$Ui$Budget$StateWatch$setBudget = function (topState) {
    var _v0 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

    if (_v0.$ === 5 && _v0.b.$ === 1) {
      var companyId = _v0.a;
      var _v1 = _v0.b;
      var budgetQuery = _v1.a;
      return A2($elm$core$Maybe$map, function (_v2) {
        var route = _v2.a;
        var message = _v2.b;
        return _Utils_Tuple3(topState.o_.vC, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, $author$project$ElmFramework$MsgCmd$msgCmd.Do(route), A3($author$project$ElmFramework$Lib$Util$ifElse, _List_Nil, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, message, _List_Nil)]), $elm$core$String$isEmpty(message))));
      }, A2($elm$core$Maybe$andThen, $author$project$Ui$Budget$StateWatch$handleScenarios(budgetQuery), A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(companyId), A2($elm$core$Maybe$map, function ($) {
        return $.v5;
      }, $author$project$Remote$Model$toSession(topState.o_.CT)))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Budget$StateWatch$stateWatchers = _List_fromArray([$author$project$Ui$Budget$StateWatch$setBudget]);

  var $author$project$Types$CashboardQuery$fromCompany = F2(function (scenarioId, company) {
    return {
      it: 0,
      eO: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map(function ($) {
        return $.F;
      }), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO)))),
      jD: company.b1,
      Dw: scenarioId
    };
  });
  var $author$project$ElmFramework$Lib$PivotDict$getById1 = F2(function (id1, _v0) {
    var dict1 = _v0.cG;
    var serializeId2 = _v0.eB;
    return $turboMaCk$any_dict$Dict$Any$values(A2($elm$core$Maybe$withDefault, $turboMaCk$any_dict$Dict$Any$empty(serializeId2), A2($turboMaCk$any_dict$Dict$Any$get, id1, dict1)));
  });
  var $author$project$Types$UserSession$toCompany = F2(function (companyId, thisUserSession) {
    return A2($turboMaCk$any_dict$Dict$Any$get, companyId, thisUserSession.v5);
  });

  var $author$project$Types$UserSession$toFirstCompanyIdForThisUser = function (thisUserSession) {
    return A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$UserSession$toCompany, id, thisUserSession);
    }, A2($elm$core$Maybe$map, function ($) {
      return $.b9;
    }, $elm$core$List$head(A2($author$project$ElmFramework$Lib$PivotDict$getById1, thisUserSession.Fl.F, thisUserSession.ue))));
  };

  var $author$project$Ui$Idle$StateWatch$redirectFromIdle = function (_v0) {
    var route = _v0.tc;
    var appState = _v0.o_;

    var _v1 = _Utils_Tuple2($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route), $author$project$Remote$Model$toSession(appState.CT));

    if (_v1.a.$ === 1 && !_v1.b.$) {
      var _v2 = _v1.a;
      var session = _v1.b.a;

      var _v3 = $author$project$Types$UserSession$toFirstCompanyIdForThisUser(session);

      if (_v3.$ === 1) {
        return $elm$core$Maybe$Just(_Utils_Tuple3(0, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$OnboardingCompany(0))])));
      } else {
        var company = _v3.a;
        var _v4 = company.pa;

        if (_v4.$ === 1) {
          return $elm$core$Maybe$Just(_Utils_Tuple3(0, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))])));
        } else {
          var scenarioId = _v4.a;
          return $elm$core$Maybe$Just(_Utils_Tuple3(0, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$fromCompany, scenarioId, company), $author$project$Route$CashboardRoute$CashboardHome)))])));
        }
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Idle$StateWatch$stateWatchers = _List_fromArray([$author$project$Ui$Idle$StateWatch$redirectFromIdle]);

  var $author$project$Types$EditingCompany$FiftyToHundred = 3;
  var $author$project$Types$EditingCompany$HundredPlus = 4;
  var $author$project$Types$EditingCompany$TenToTwentyFive = 1;
  var $author$project$Types$EditingCompany$TwentyFiveToFifty = 2;

  var $author$project$Types$EditingCompany$fromCompany = function (company) {
    return {
      ke: $elm$core$Maybe$Nothing,
      uG: company.b_,
      pu: A2($elm$core$Maybe$withDefault, '', company.bW.pu),
      kP: $elm$core$Maybe$Nothing,
      iI: '',
      wE: company.b1,
      xy: company.b2,
      zL: company.zL,
      rE: A2($elm$core$Maybe$withDefault, '', company.bW.rE),
      zY: function () {
        var _v0 = company.aB;

        switch (_v0) {
          case 2:
            return 0;

          case 1:
            return 1;

          case 0:
            return 2;

          case 3:
            return 3;

          default:
            return 4;
        }
      }(),
      b0: 0,
      jJ: '',
      nZ: $elm$core$Maybe$Nothing,
      DN: company.bW.pF,
      DQ: company.t$,
      Ej: A2($elm$core$Maybe$withDefault, '', company.bW.pH),
      tI: A2($elm$core$Maybe$withDefault, '', company.bW.tI),
      ov: $elm$core$Maybe$Nothing,
      j0: '',
      FS: A2($elm$core$Maybe$withDefault, '', company.bW.sF)
    };
  };

  var $author$project$Route$RouteUtil$isSettingsRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 5) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$Settings$StateWatch$setSettings = function (topState) {
    var state = topState.o_.D0;
    var previousRouteIsSettingsRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$RouteUtil$isSettingsRoute, $author$project$ElmFramework$Feature$Navigation$RouteHistory$previous(topState.tc)));

    var editingCompanyFromCurrentRoute = function () {
      var _v3 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      if (_v3.$ === 5 && _v3.b.$ === 5) {
        var companyId = _v3.a;
        return A2($elm$core$Maybe$map, $author$project$Types$EditingCompany$fromCompany, A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(companyId), A2($elm$core$Maybe$map, function ($) {
          return $.v5;
        }, $author$project$Remote$Model$toSession(topState.o_.CT))));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var currentRouteIsSettings = function () {
      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      if (_v1.$ === 5) {
        var companyRoute = _v1.b;

        if (companyRoute.$ === 5) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }();

    var _v0 = _Utils_Tuple3(currentRouteIsSettings, previousRouteIsSettingsRoute, editingCompanyFromCurrentRoute);

    if (_v0.a && !_v0.b && !_v0.c.$) {
      var editingCompany = _v0.c.a;
      return $elm$core$Maybe$Just(_Utils_Tuple3(_Utils_update(state, {
        xj: editingCompany
      }), $elm$core$Platform$Cmd$none, _List_Nil));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Settings$StateWatch$stateWatchers = _List_fromArray([$author$project$Ui$Settings$StateWatch$setSettings]);

  var $author$project$Types$UserProfile$fromSession = function (_v0) {
    var user = _v0.Fl;
    return {
      gZ: $elm$core$Maybe$Nothing,
      iF: user.iP,
      iG: '',
      wq: user.iP,
      hI: user.hI,
      zL: user.hu,
      rC: '',
      jk: '',
      ng: A2($elm$core$Maybe$withDefault, '', user.ng),
      jC: '',
      ig: false,
      ih: false,
      ii: false
    };
  };

  var $author$project$Route$RouteUtil$isUserProfileRoute = function (route) {
    if (route.$ === 6) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$UserProfile$StateWatch$setUserProfile = function (topState) {
    var userProfileFromSession = A2($elm$core$Maybe$map, $author$project$Types$UserProfile$fromSession, $author$project$Remote$Model$toSession(topState.o_.CT));
    var previousRouteIsUserProfileRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$RouteUtil$isUserProfileRoute, $author$project$ElmFramework$Feature$Navigation$RouteHistory$previous(topState.tc)));

    var currentRouteIsUserProfile = function () {
      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      if (_v1.$ === 6) {
        return true;
      } else {
        return false;
      }
    }();

    var _v0 = _Utils_Tuple3(currentRouteIsUserProfile, previousRouteIsUserProfileRoute, userProfileFromSession);

    if (_v0.a && !_v0.b && !_v0.c.$) {
      var userProfile = _v0.c.a;
      return $elm$core$Maybe$Just(_Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_Nil));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$UserProfile$StateWatch$stateWatchers = _List_fromArray([$author$project$Ui$UserProfile$StateWatch$setUserProfile]);

  var $author$project$Global$Msg$ReceivePreFetchedCommonStaticFile = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Global$Msg$ReceiveVault = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Global$Model$emptyVault = {
    sx: _List_Nil
  };

  var $author$project$Global$Model$VaultModel = function (paymentCards) {
    return {
      sx: paymentCards
    };
  };

  var $author$project$Model$Payments$PaymentCardNoCode = F3(function (cardNo, expMonth, expYear) {
    return {
      pl: cardNo,
      qf: expMonth,
      qg: expYear
    };
  });
  var $author$project$Model$Payments$paymentCardDecoder = A4($elm$json$Json$Decode$map3, $author$project$Model$Payments$PaymentCardNoCode, A2($elm$json$Json$Decode$field, 'cardNo', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expMonth', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expYear', $elm$json$Json$Decode$string));
  var $author$project$Global$Model$vaultDecoder = A2($elm$json$Json$Decode$map, $author$project$Global$Model$VaultModel, A2($elm$json$Json$Decode$field, 'paymentCards', $elm$json$Json$Decode$list($author$project$Model$Payments$paymentCardDecoder)));

  var $author$project$Global$Model$decodeVault = function (_v0) {
    var isSupported = _v0.yX;
    var vault = _v0.gR;
    return isSupported ? $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, $author$project$Global$Model$emptyVault, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeL, $elm$core$Result$toMaybe, $elm$json$Json$Decode$decodeString($author$project$Global$Model$vaultDecoder)), vault))) : $elm$core$Maybe$Nothing;
  };

  var $author$project$Persistence$receivePreFetchedCommonStaticFile = _Platform_incomingPort('receivePreFetchedCommonStaticFile', $elm$json$Json$Decode$string);

  var $author$project$Global$Ports$receiveVault = _Platform_incomingPort('receiveVault', A2($elm$json$Json$Decode$andThen, function (vault) {
    return A2($elm$json$Json$Decode$andThen, function (isSupported) {
      return $elm$json$Json$Decode$succeed({
        yX: isSupported,
        gR: vault
      });
    }, A2($elm$json$Json$Decode$field, 'isSupported', $elm$json$Json$Decode$bool));
  }, A2($elm$json$Json$Decode$field, 'vault', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)])))));

  var $author$project$Global$Global$subscriptions = function (_v0) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$Persistence$receivePreFetchedCommonStaticFile(A2($elm$core$Basics$composeL, $author$project$Global$Msg$ReceivePreFetchedCommonStaticFile, $author$project$Model$CommonStaticFile$decodePersistedCommonStatic)), $author$project$Global$Ports$receiveVault(A2($elm$core$Basics$composeL, $author$project$Global$Msg$ReceiveVault, $author$project$Global$Model$decodeVault))]));
  };

  var $author$project$Remote$Msg$ReceivedQuickBooksIntegrationResult = function (a) {
    return {
      $: 19,
      a: a
    };
  };

  var $author$project$Remote$Msg$SubscriptionError = function (a) {
    return {
      $: 17,
      a: a
    };
  };

  var $author$project$Remote$Msg$SubscriptionMessage = function (a) {
    return {
      $: 16,
      a: a
    };
  };

  var $author$project$Types$GqlSubscriptions$UnknownData = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$GqlSubscriptions$DivisionUpdate = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Types$GqlSubscriptions$InvitationUpdate = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });

  var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$Company_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildCompany_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      fq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ck: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      vk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      eO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      db: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      aB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      dm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      $7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ds: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      fq: optionals____.fq,
      ch: optionals____.ch,
      bz: optionals____.bz,
      cj: optionals____.cj,
      bA: optionals____.bA,
      ck: optionals____.ck,
      bB: optionals____.bB,
      bC: optionals____.bC,
      bD: optionals____.bD,
      bE: optionals____.bE,
      bF: optionals____.bF,
      cm: optionals____.cm,
      c: optionals____.c,
      vk: optionals____.vk,
      bH: optionals____.bH,
      a: optionals____.a,
      eO: optionals____.eO,
      F: optionals____.F,
      cQ: optionals____.cQ,
      f4: optionals____.f4,
      zL: optionals____.zL,
      d: optionals____.d,
      Ch: optionals____.Ch,
      c4: optionals____.c4,
      c5: optionals____.c5,
      c6: optionals____.c6,
      c9: optionals____.c9,
      db: optionals____.db,
      gA: optionals____.gA,
      aB: optionals____.aB,
      dm: optionals____.dm,
      $7: optionals____.$7,
      b: optionals____.b,
      ds: optionals____.ds
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$Division_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildDivision_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      af: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      an: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      af: optionals____.af,
      ch: optionals____.ch,
      cm: optionals____.cm,
      c: optionals____.c,
      j: optionals____.j,
      iD: optionals____.iD,
      a: optionals____.a,
      z: optionals____.z,
      F: optionals____.F,
      an: optionals____.an,
      zL: optionals____.zL,
      d: optionals____.d,
      Ch: optionals____.Ch,
      b: optionals____.b
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$User_company_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildUser_company_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      xF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Fl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      T: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      c: optionals____.c,
      j: optionals____.j,
      iD: optionals____.iD,
      xF: optionals____.xF,
      F: optionals____.F,
      d: optionals____.d,
      Ch: optionals____.Ch,
      gz: optionals____.gz,
      Fl: optionals____.Fl,
      T: optionals____.T
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('access_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('access_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_integration_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('connected_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aU, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sync_attempt_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('next_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ba, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('refresh_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('refresh_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bg, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('access_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('access_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_integration_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('connected_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aU, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sync_attempt_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('next_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ba, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('refresh_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('refresh_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bg, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_divisions_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fp, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_aggregate_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_order_by = function (_v1) {
    var input____ = _v1;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('access_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('access_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_accounts_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fl, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_aggregate_order_by)), _Utils_Tuple2('accounting_system_classes_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fn, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_aggregate_order_by)), _Utils_Tuple2('accounting_system_integration', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cg, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_integration_order_by)), _Utils_Tuple2('accounting_system_integration_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('connected_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aU, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sync_attempt_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('next_sync_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ba, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('refresh_token', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('refresh_token_expiry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bg, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.di, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system_division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.af, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_order_by)), _Utils_Tuple2('accounts_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ci, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_aggregate_order_by)), _Utils_Tuple2('allocation_classes_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cn, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_aggregate_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('employee_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('industry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.an, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Division_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'created_at';

      case 2:
        return 'employee_count';

      case 3:
        return 'id';

      case 4:
        return 'industry';

      case 5:
        return 'name';

      default:
        return 'updated_at';
    }
  };

  var $author$project$Api$GraphqlSchema$Subscription$division = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Division_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'division', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Types$Division$Division = F7(function (id, name, industry, employees, financialAccounts, allocationClasses, overlayDivision) {
    return {
      oX: allocationClasses,
      xt: employees,
      qp: financialAccounts,
      F: id,
      an: industry,
      zL: name,
      ju: overlayDivision
    };
  });
  var $author$project$Types$AccountingSystemDivision$AccountingSystemDivision = F4(function (id, name, syncEnabled, lastSyncStatus) {
    return {
      F: id,
      y7: lastSyncStatus,
      zL: name,
      EC: syncEnabled
    };
  });
  var $author$project$Types$AccountingSystemDivision$AccountingSystemDivisionId = $elm$core$Basics$identity;
  var $author$project$Types$AccountingSystemDivision$Error = 0;
  var $author$project$Types$AccountingSystemDivision$Pending = 1;
  var $author$project$Types$AccountingSystemDivision$Synced = 2;
  var $author$project$Api$GraphqlSchema$Object$Accounting_system_division$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Accounting_system_division$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Accounting_system_division$sync_enabled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'sync_enabled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Enum$Sync_status_enum$Error = 0;
  var $author$project$Api$GraphqlSchema$Enum$Sync_status_enum$Pending = 1;
  var $author$project$Api$GraphqlSchema$Enum$Sync_status_enum$Synced = 2;
  var $author$project$Api$GraphqlSchema$Enum$Sync_status_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ERROR':
        return $elm$json$Json$Decode$succeed(0);

      case 'PENDING':
        return $elm$json$Json$Decode$succeed(1);

      case 'SYNCED':
        return $elm$json$Json$Decode$succeed(2);

      default:
        return $elm$json$Json$Decode$fail('Invalid Sync_status_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Accounting_system_division$sync_status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Sync_status_enum.Sync_status_enum', 'sync_status', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Sync_status_enum$decoder);

  var $author$project$Api$Schema$accountingSystemDivision = function () {
    var toStatus = function (status) {
      switch (status) {
        case 0:
          return 0;

        case 1:
          return 1;

        default:
          return 2;
      }
    };

    var builder = F4(function (id, name, status, syncEnabled) {
      return A4($author$project$Types$AccountingSystemDivision$AccountingSystemDivision, id, name, syncEnabled, toStatus(status));
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Accounting_system_division$sync_enabled, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Accounting_system_division$sync_status, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Accounting_system_division$name, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Accounting_system_division$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(builder)))));
  }();

  var $author$project$Api$GraphqlSchema$Object$Division$accounting_system_division = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'accounting_system_division', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by = function (_v3) {
    var input____ = _v3;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system_account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aG, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_order_by)), _Utils_Tuple2('allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ag, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balance_minmax_advice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balances_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fz, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_aggregate_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('currency', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_system', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_balance_update_by_user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a6, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('subtype', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bn, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_order_by = function (_v2) {
    var input____ = _v2;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by)), _Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aH, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_order_by)), _Utils_Tuple2('accounting_system_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.af, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_order_by)), _Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_order_by = function (_v1) {
    var input____ = _v1;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accounting_system_account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aG, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_account_order_by)), _Utils_Tuple2('accounting_system_division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.af, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_division_order_by)), _Utils_Tuple2('accounting_system_division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('accounting_system_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.u, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ag, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by)), _Utils_Tuple2('accounting_system_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aH, $author$project$Api$GraphqlSchema$InputObject$encodeAccounting_system_class_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('fqcn', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('parent', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), _Utils_Tuple2('parent_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('system_allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Account_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'allocation_class_id';

      case 1:
        return 'balance_minmax_advice';

      case 2:
        return 'company_id';

      case 3:
        return 'created_at';

      case 4:
        return 'currency';

      case 5:
        return 'division_id';

      case 6:
        return 'enabled';

      case 7:
        return 'id';

      case 8:
        return 'last_balance_update_at';

      case 9:
        return 'last_balance_update_by_system';

      case 10:
        return 'last_balance_update_by_type';

      case 11:
        return 'last_balance_update_by_user';

      case 12:
        return 'name';

      case 13:
        return 'subtype';

      case 14:
        return 'type';

      default:
        return 'updated_at';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Division$accounts = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'accounts', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Types$AllocationClass$AllocationClass = F5(function (id, name, systemAllocationClass, parent, financialAccount) {
    return {
      lo: financialAccount,
      F: id,
      zL: name,
      cW: parent,
      EE: systemAllocationClass
    };
  });
  var $author$project$Types$AllocationClass$AllocationClassId = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$Object$Allocation_class$account = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'account', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$GraphqlSchema$InputObject$Account_balance_order_by = $elm$core$Basics$identity;
  var $author$project$Types$AccountType$Cash = {
    $: 0
  };

  var $author$project$Types$AccountType$Credit = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$AccountType$CreditCard = 0;
  var $author$project$Api$GraphqlSchema$Enum$Order_by$Desc = 3;

  var $author$project$Types$FinancialAccount$LastBalanceUpdatedBySystem = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$FinancialAccount$LastBalanceUpdatedByUser = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$AccountType$LineOfCredit = 1;
  var $author$project$Types$Balance$Balance = F4(function (at, activeBalance, syncBalance, overrideBalance) {
    return {
      gY: activeBalance,
      o$: at,
      Cl: overrideBalance,
      jZ: syncBalance
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Account_balance$at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $author$project$Api$GraphqlSchema$Object$Account_balance$balance = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Numeric', 'balance', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB);
  var $author$project$Api$GraphqlSchema$Object$Account_balance$sync_balance = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Numeric)', 'sync_balance', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB));
  var $author$project$Api$GraphqlSchema$Object$Account_balance$user_specified_balance = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Numeric)', 'user_specified_balance', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB));
  var $author$project$Api$Schema$accountBalance = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Account_balance$user_specified_balance, $elm$core$Maybe$map($JoshuaHall$elm_fraction$Fraction$toFloat), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Account_balance$sync_balance, $elm$core$Maybe$map($JoshuaHall$elm_fraction$Fraction$toFloat), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Account_balance$balance, $JoshuaHall$elm_fraction$Fraction$toFloat, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account_balance$at, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Balance$Balance)))));
  var $author$project$Api$GraphqlSchema$Object$Account$balance_minmax_advice = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Numeric)', 'balance_minmax_advice', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB));

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by)), _Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('sync_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ED, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user_specified_balance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fs, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Account_balance_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'account_id';

      case 1:
        return 'at';

      case 2:
        return 'balance';

      case 3:
        return 'sync_balance';

      default:
        return 'user_specified_balance';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Account$balances = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_balance_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'balances', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Account$currency = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Currency_enum.Currency_enum', 'currency', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Currency_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Account$enabled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'enabled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$OrderedCollection$OrderedCollection = $elm$core$Basics$identity;
  var $elm_community$list_extra$List$Extra$find = F2(function (predicate, list) {
    find: while (true) {
      if (!list.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var first = list.a;
        var rest = list.b;

        if (predicate(first)) {
          return $elm$core$Maybe$Just(first);
        } else {
          var $temp$predicate = predicate,
              $temp$list = rest;
          predicate = $temp$predicate;
          list = $temp$list;
          continue find;
        }
      }
    }
  });
  var $author$project$ElmFramework$Lib$Util$uniqBy = F2(function (toId, list) {
    var consIfNotMember = F2(function (el, subList) {
      return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$eq(toId(el))), subList)) ? subList : A2($elm$core$List$cons, el, subList);
    });
    return A3($elm$core$List$foldr, consIfNotMember, _List_Nil, list);
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$fromList = F3(function (toId, serializeId, list) {
    var uniqList = A2($author$project$ElmFramework$Lib$Util$uniqBy, toId, list);
    var dict = A2($turboMaCk$any_dict$Dict$Any$fromList, serializeId, A2($elm$core$List$map, function (i) {
      return _Utils_Tuple2(toId(i), i);
    }, uniqList));
    return {
      bT: dict,
      aA: uniqList,
      dd: serializeId,
      b5: toId
    };
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$fromList = F4(function (toId, serializeId, maybePointer, items) {
    return {
      aq: A3($author$project$ElmFramework$Lib$OrderedCollection$fromList, toId, serializeId, items),
      Y: maybePointer
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Account$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Timestamp)', 'last_balance_update_at', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eo.wB));
  var $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_by_system = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'last_balance_update_by_system', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Enum$Update_type_enum$System = 0;
  var $author$project$Api$GraphqlSchema$Enum$Update_type_enum$User = 1;
  var $author$project$Api$GraphqlSchema$Enum$Update_type_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'SYSTEM':
        return $elm$json$Json$Decode$succeed(0);

      case 'USER':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Update_type_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_by_type = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Enum.Update_type_enum.Update_type_enum)', 'last_balance_update_by_type', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Enum$Update_type_enum$decoder));
  var $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_by_user = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'last_balance_update_by_user', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Account$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$Cash = 0;
  var $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$CreditCard = 1;
  var $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$Loc = 2;
  var $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'CASH':
        return $elm$json$Json$Decode$succeed(0);

      case 'CREDIT_CARD':
        return $elm$json$Json$Decode$succeed(1);

      case 'LOC':
        return $elm$json$Json$Decode$succeed(2);

      default:
        return $elm$json$Json$Decode$fail('Invalid Account_subtype_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Account$subtype = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Account_subtype_enum.Account_subtype_enum', 'subtype', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$decoder);
  var $author$project$Api$GraphqlSchema$Enum$Account_type_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'CASH':
        return $elm$json$Json$Decode$succeed(0);

      case 'CREDIT':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Account_type_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Account$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Account_type_enum.Account_type_enum', 'type', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$decoder);

  var $author$project$Api$Schema$financialAccount = function () {
    var balancesQuery = function (args) {
      return _Utils_update(args, {
        zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
        Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([{
          uy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          oP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          o$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3),
          o3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          ED: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          Fs: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        }]))
      });
    };

    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$enabled, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Account$balances, balancesQuery, $author$project$Api$Schema$accountBalance), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_by_user, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_by_system, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_by_type, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$last_balance_update_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$currency, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$balance_minmax_advice, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$subtype, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$type_, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Account$id, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(function (id) {
      return function (name) {
        return function (accType) {
          return function (accSubType) {
            return function (balanceMinMaxAdvice) {
              return function (currency) {
                return function (lastBalanceUpdateAt) {
                  return function (lastBalanceUpdateBy) {
                    return function (lastBalanceUpdatedBySystem) {
                      return function (lastBalanceUpdatedByUserId) {
                        return function (balances) {
                          return function (enabled) {
                            var lastBalanceUpdated = A2($elm$core$Maybe$andThen, function (_v2) {
                              var at = _v2.a;
                              var by = _v2.b;

                              if (!by) {
                                return A2($elm$core$Maybe$map, function (system) {
                                  return {
                                    o$: at,
                                    pj: $author$project$Types$FinancialAccount$LastBalanceUpdatedBySystem(system)
                                  };
                                }, lastBalanceUpdatedBySystem);
                              } else {
                                return A2($elm$core$Maybe$map, function (userId) {
                                  return {
                                    o$: at,
                                    pj: $author$project$Types$FinancialAccount$LastBalanceUpdatedByUser($author$project$Api$Schema$uuidToString(userId))
                                  };
                                }, lastBalanceUpdatedByUserId);
                              }
                            }, A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, lastBalanceUpdateAt, lastBalanceUpdateBy));

                            var accountType = function () {
                              if (!accType) {
                                return $author$project$Types$AccountType$Cash;
                              } else {
                                return $author$project$Types$AccountType$Credit(function () {
                                  switch (accSubType) {
                                    case 0:
                                      return 0;

                                    case 1:
                                      return 0;

                                    default:
                                      return 1;
                                  }
                                }());
                              }
                            }();

                            return {
                              it: accountType,
                              dx: balanceMinMaxAdvice,
                              fy: $krisajenkins$remotedata$RemoteData$Success(A4($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$fromList, function ($) {
                                return $.o$;
                              }, $author$project$Types$SimpleDate$toDateString, $elm$core$Maybe$Nothing, balances)),
                              bq: currency,
                              la: enabled,
                              F: $author$project$Api$Schema$uuidToString(id),
                              y5: lastBalanceUpdated,
                              zL: name
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    })))))))))))));
  }();

  var $author$project$Api$GraphqlSchema$Object$Allocation_class$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$Schema$maybeMapUuid = function (tag) {
    return $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Maybe$map(function (_v0) {
      var id = _v0;
      return tag(id);
    }));
  };

  var $author$project$Api$GraphqlSchema$Object$Allocation_class$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Allocation_class$parent_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'parent_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$Asset = 0;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$Equity = 1;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$ExpenseCogs = 2;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$ExpenseOperating = 3;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$ExpenseOther = 4;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$Income = 5;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$IncomeOther = 6;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$Liability = 7;
  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ASSET':
        return $elm$json$Json$Decode$succeed(0);

      case 'EQUITY':
        return $elm$json$Json$Decode$succeed(1);

      case 'EXPENSE_COGS':
        return $elm$json$Json$Decode$succeed(2);

      case 'EXPENSE_OPERATING':
        return $elm$json$Json$Decode$succeed(3);

      case 'EXPENSE_OTHER':
        return $elm$json$Json$Decode$succeed(4);

      case 'INCOME':
        return $elm$json$Json$Decode$succeed(5);

      case 'INCOME_OTHER':
        return $elm$json$Json$Decode$succeed(6);

      case 'LIABILITY':
        return $elm$json$Json$Decode$succeed(7);

      default:
        return $elm$json$Json$Decode$fail('Invalid System_allocation_class_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Allocation_class$system_allocation_class = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.System_allocation_class_enum.System_allocation_class_enum', 'system_allocation_class', _List_Nil, $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$decoder);
  var $author$project$Api$Schema$allocationClass = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Maybe$map(function ($) {
    return $.F;
  }), $author$project$Api$GraphqlSchema$Object$Allocation_class$account($author$project$Api$Schema$financialAccount)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$maybeMapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Allocation_class$parent_id), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Allocation_class$system_allocation_class, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Allocation_class$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Allocation_class$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$AllocationClass$AllocationClass))))));

  var $author$project$Api$GraphqlSchema$Enum$Allocation_class_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'division_id';

      case 2:
        return 'fqcn';

      case 3:
        return 'id';

      case 4:
        return 'name';

      case 5:
        return 'parent_id';

      default:
        return 'system_allocation_class';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Division$allocation_classes = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Allocation_class_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'allocation_classes', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });

  var $author$project$Types$AllocationClass$unwrapAllocationClassId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Types$AllocationClass$createAllocationClassDict = function (allocationClasses) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$AllocationClass$unwrapAllocationClassId, A2($elm$core$List$map, function (alc) {
      return _Utils_Tuple2(alc.F, alc);
    }, allocationClasses));
  };

  var $author$project$Types$FinancialAccount$createFinancialAccountDict = function (financialAccounts) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$FinancialAccount$unwrapFinancialAccountId, A2($elm$core$List$map, function (fa) {
      return _Utils_Tuple2(fa.F, fa);
    }, financialAccounts));
  };

  var $author$project$Api$GraphqlSchema$Object$Division$employee_count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Int)', 'employee_count', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
  var $author$project$Api$GraphqlSchema$Object$Division$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Division$industry = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'industry', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Division$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$division = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Division$accounting_system_division($author$project$Api$Schema$accountingSystemDivision), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$AllocationClass$createAllocationClassDict, A2($author$project$Api$GraphqlSchema$Object$Division$allocation_classes, $elm$core$Basics$identity, $author$project$Api$Schema$allocationClass)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$FinancialAccount$createFinancialAccountDict, A2($author$project$Api$GraphqlSchema$Object$Division$accounts, $elm$core$Basics$identity, $author$project$Api$Schema$financialAccount)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Division$employee_count, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Division$industry, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Division$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Division$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Division$Division))))))));

  var $author$project$Api$GraphqlSchema$InputObject$buildUuid_comparison_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      e: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      G: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      H: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      I: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      J: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      h: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      i: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      e: optionals____.e,
      G: optionals____.G,
      H: optionals____.H,
      f: optionals____.f,
      g: optionals____.g,
      I: optionals____.I,
      J: optionals____.J,
      h: optionals____.h,
      i: optionals____.i
    };
  };

  var $author$project$Api$Schema$equalsUuidComparison = function (uuid) {
    return $author$project$Api$GraphqlSchema$InputObject$buildUuid_comparison_exp(function (z) {
      return _Utils_update(z, {
        e: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(uuid)
      });
    });
  };

  var $author$project$Types$GqlSubscriptions$divisionSubscription = F2(function (_v0, _v1) {
    var companyId = _v0;
    var userId = _v1;
    var userWithId = $author$project$Api$GraphqlSchema$InputObject$buildUser_company_bool_exp(function (z) {
      return _Utils_update(z, {
        iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison(companyId)),
        T: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison(userId))
      });
    });
    var companyWithUserId = $author$project$Api$GraphqlSchema$InputObject$buildCompany_bool_exp(function (z) {
      return _Utils_update(z, {
        ds: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(userWithId)
      });
    });
    var divisionWithCompany = $author$project$Api$GraphqlSchema$InputObject$buildDivision_bool_exp(function (z) {
      return _Utils_update(z, {
        j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(companyWithUserId)
      });
    });
    return A2($author$project$Api$GraphqlSchema$Subscription$division, function (defaults) {
      return _Utils_update(defaults, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(divisionWithCompany)
      });
    }, $author$project$Api$Schema$division);
  });
  var $author$project$Api$GraphqlSchema$InputObject$Invite_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildInvite_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      n: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ah: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ai: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      be: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Fl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      T: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      c: optionals____.c,
      j: optionals____.j,
      iD: optionals____.iD,
      a: optionals____.a,
      n: optionals____.n,
      iP: optionals____.iP,
      a$: optionals____.a$,
      ah: optionals____.ah,
      F: optionals____.F,
      ai: optionals____.ai,
      a7: optionals____.a7,
      d: optionals____.d,
      Ch: optionals____.Ch,
      be: optionals____.be,
      gz: optionals____.gz,
      Y: optionals____.Y,
      b: optionals____.b,
      Fl: optionals____.Fl,
      T: optionals____.T
    };
  };

  var $author$project$Types$Invitation$Invitation = F8(function (id, email, role, firstName, lastName, lastSentAt, createdAt, status) {
    return {
      iK: createdAt,
      iP: email,
      hu: firstName,
      F: id,
      hI: lastName,
      y6: lastSentAt,
      gz: role,
      Y: status
    };
  });
  var $author$project$Types$Invitation$InvitationId = $elm$core$Basics$identity;
  var $author$project$Types$Invitation$Pending = {
    $: 0
  };
  var $author$project$Types$Invitation$Redeemed = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Types$Invitation$Revoked = {
    $: 2
  };
  var $author$project$Api$GraphqlSchema$Object$Invite$created_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'created_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$GraphqlSchema$Object$Invite$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'email', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Invite$first_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'first_name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Invite$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Invite$last_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'last_name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Invite$last_sent_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Timestamp)', 'last_sent_at', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eo.wB));
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$map3 = F4(function (combine, _v0, _v1, _v2) {
    var selectionFields1 = _v0.a;
    var selectionDecoder1 = _v0.b;
    var selectionFields2 = _v1.a;
    var selectionDecoder2 = _v1.b;
    var selectionFields3 = _v2.a;
    var selectionDecoder3 = _v2.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, $elm$core$List$concat(_List_fromArray([selectionFields1, selectionFields2, selectionFields3])), A4($elm$json$Json$Decode$map3, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3));
  });
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail = F2(function (mapFunction, _v0) {
    var field = _v0.a;
    var decoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, field, A2($elm$json$Json$Decode$andThen, function (result) {
      if (!result.$) {
        var value = result.a;
        return $elm$json$Json$Decode$succeed(value);
      } else {
        var errorMessage = result.a;
        return $elm$json$Json$Decode$fail('Check your code for calls to mapOrFail, your map function returned an `Err` with the message: ' + errorMessage);
      }
    }, A2($elm$json$Json$Decode$map, mapFunction, decoder)));
  });
  var $author$project$Api$GraphqlSchema$Object$Invite$redeemed_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Timestamp)', 'redeemed_at', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eo.wB));
  var $author$project$Api$GraphqlSchema$Object$Invite$role = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Role_enum.Role_enum', 'role', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Role_enum$decoder);
  var $author$project$Api$GraphqlSchema$Enum$Invite_status_enum$Pending = 0;
  var $author$project$Api$GraphqlSchema$Enum$Invite_status_enum$Redeemed = 1;
  var $author$project$Api$GraphqlSchema$Enum$Invite_status_enum$Revoked = 2;
  var $author$project$Api$GraphqlSchema$Enum$Invite_status_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'PENDING':
        return $elm$json$Json$Decode$succeed(0);

      case 'REDEEMED':
        return $elm$json$Json$Decode$succeed(1);

      case 'REVOKED':
        return $elm$json$Json$Decode$succeed(2);

      default:
        return $elm$json$Json$Decode$fail('Invalid Invite_status_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Invite$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Invite_status_enum.Invite_status_enum', 'status', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Invite_status_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Invite$user_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'user_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));

  var $author$project$Api$Schema$invitation = function () {
    var inviteStatusToInvitationStatus = F3(function (status, redeemedAt, userId) {
      switch (status) {
        case 0:
          return $elm$core$Result$Ok($author$project$Types$Invitation$Pending);

        case 1:
          var _v1 = _Utils_Tuple2(redeemedAt, userId);

          _v1$2: while (true) {
            if (!_v1.a.$) {
              if (!_v1.b.$) {
                var date = _v1.a.a;
                var uId = _v1.b.a;
                return $elm$core$Result$Ok(A2($author$project$Types$Invitation$Redeemed, date, $author$project$Api$Schema$uuidToString(uId)));
              } else {
                break _v1$2;
              }
            } else {
              if (!_v1.b.$) {
                var _v2 = _v1.a;
                var uId = _v1.b.a;
                return $elm$core$Result$Ok(A2($author$project$Types$Invitation$Redeemed, $elm$time$Time$millisToPosix(0), $author$project$Api$Schema$uuidToString(uId)));
              } else {
                break _v1$2;
              }
            }
          }

          return $elm$core$Result$Err('Bad redeemed data, redeem date / user id not found');

        default:
          return $elm$core$Result$Ok($author$project$Types$Invitation$Revoked);
      }
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Basics$identity, A4($dillonkearns$elm_graphql$Graphql$SelectionSet$map3, inviteStatusToInvitationStatus, $author$project$Api$GraphqlSchema$Object$Invite$status, $author$project$Api$GraphqlSchema$Object$Invite$redeemed_at, $author$project$Api$GraphqlSchema$Object$Invite$user_id)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Invite$created_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Invite$last_sent_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Invite$last_name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Invite$first_name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Invite$role, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Invite$email, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Invite$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Invitation$Invitation)))))))));
  }();

  var $author$project$Api$GraphqlSchema$InputObject$encodeInvite_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('expires_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('first_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ah, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ai, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('last_sent_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('redeemed_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.be, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('user', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fl, $author$project$Api$GraphqlSchema$InputObject$encodeUser_order_by)), _Utils_Tuple2('user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Invite_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'created_at';

      case 2:
        return 'created_by';

      case 3:
        return 'email';

      case 4:
        return 'expires_at';

      case 5:
        return 'first_name';

      case 6:
        return 'id';

      case 7:
        return 'last_name';

      case 8:
        return 'last_sent_at';

      case 9:
        return 'redeemed_at';

      case 10:
        return 'role';

      case 11:
        return 'status';

      case 12:
        return 'updated_at';

      default:
        return 'user_id';
    }
  };

  var $author$project$Api$GraphqlSchema$Subscription$invite = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Invite_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeInvite_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'invite', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Types$GqlSubscriptions$inviteSubscription = F2(function (_v0, _v1) {
    var companyId = _v0;
    var userId = _v1;
    var userWithId = $author$project$Api$GraphqlSchema$InputObject$buildUser_company_bool_exp(function (z) {
      return _Utils_update(z, {
        iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison(companyId)),
        T: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison(userId))
      });
    });
    var companyWithUserId = $author$project$Api$GraphqlSchema$InputObject$buildCompany_bool_exp(function (z) {
      return _Utils_update(z, {
        ds: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(userWithId)
      });
    });
    var inviteWithCompany = $author$project$Api$GraphqlSchema$InputObject$buildInvite_bool_exp(function (z) {
      return _Utils_update(z, {
        j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(companyWithUserId)
      });
    });
    return A2($author$project$Api$GraphqlSchema$Subscription$invite, function (defaults) {
      return _Utils_update(defaults, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(inviteWithCompany)
      });
    }, $author$project$Api$Schema$invitation);
  });
  var $author$project$Types$GqlSubscriptions$subscriptionsDataDecoder = F2(function (userId, subscriptionId) {
    if (A2($elm$core$String$startsWith, 'invite', subscriptionId)) {
      var companyId = A2($elm$core$String$dropLeft, $elm$core$String$length('invite'), subscriptionId);
      return A2($elm$json$Json$Decode$map, $author$project$Types$GqlSubscriptions$InvitationUpdate(companyId), $dillonkearns$elm_graphql$Graphql$Document$decoder(A2($author$project$Types$GqlSubscriptions$inviteSubscription, companyId, userId)));
    } else {
      if (A2($elm$core$String$startsWith, 'division', subscriptionId)) {
        var companyId = A2($elm$core$String$dropLeft, $elm$core$String$length('division'), subscriptionId);
        return A2($elm$json$Json$Decode$map, $author$project$Types$GqlSubscriptions$DivisionUpdate(companyId), $dillonkearns$elm_graphql$Graphql$Document$decoder(A2($author$project$Types$GqlSubscriptions$divisionSubscription, companyId, userId)));
      } else {
        return $elm$json$Json$Decode$succeed($author$project$Types$GqlSubscriptions$UnknownData('Unknown subscriptionId found ' + subscriptionId));
      }
    }
  });

  var $author$project$Types$GqlSubscriptions$decodeGqlSubData = function (_v0) {
    var userId = _v0.oD;
    var subscriptionId = _v0.$8;
    var data = _v0.wx;
    return A2($elm$core$Result$withDefault, $author$project$Types$GqlSubscriptions$UnknownData('Failed to decode data for subscriptionId ' + subscriptionId), A2($elm$json$Json$Decode$decodeValue, A2($author$project$Types$GqlSubscriptions$subscriptionsDataDecoder, userId, subscriptionId), data));
  };

  var $author$project$Types$GqlSubscriptions$UnknownError = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$GqlSubscriptions$FailAccountingSystemDivision = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$GqlSubscriptions$subscriptionErrorDecoder = function (subscriptionId) {
    var generalErrorMessageDecoder = A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string);

    if (subscriptionId === 'accounting_system_division') {
      return A2($elm$json$Json$Decode$map, $author$project$Types$GqlSubscriptions$FailAccountingSystemDivision, generalErrorMessageDecoder);
    } else {
      return $elm$json$Json$Decode$succeed($author$project$Types$GqlSubscriptions$UnknownError('Unknown subscriptionId found ' + subscriptionId));
    }
  };

  var $author$project$Types$GqlSubscriptions$decodeGqlSubError = function (_v0) {
    var subscriptionId = _v0.$8;
    var error = _v0.iQ;
    return A2($elm$core$Result$withDefault, $author$project$Types$GqlSubscriptions$UnknownError('Failed to decode error for subscriptionId ' + subscriptionId), A2($elm$json$Json$Decode$decodeValue, $author$project$Types$GqlSubscriptions$subscriptionErrorDecoder(subscriptionId), error));
  };

  var $author$project$Remote$Remote$getRefreshUserTokenSubscription = F2(function (expiresInSeconds, refreshToken) {
    return A2($elm$time$Time$every, expiresInSeconds * 0.9 * $author$project$ElmFramework$Lib$Util$timeInterval.tj, $elm$core$Basics$always(A2($author$project$Remote$Msg$RefreshUserToken, $elm$core$Maybe$Nothing, refreshToken)));
  });

  var $author$project$Remote$Remote$graphqlSubError = _Platform_incomingPort('graphqlSubError', A2($elm$json$Json$Decode$andThen, function (subscriptionId) {
    return A2($elm$json$Json$Decode$andThen, function (error) {
      return $elm$json$Json$Decode$succeed({
        iQ: error,
        $8: subscriptionId
      });
    }, A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$value));
  }, A2($elm$json$Json$Decode$field, 'subscriptionId', $elm$json$Json$Decode$string)));

  var $author$project$Remote$Remote$graphqlSubResult = _Platform_incomingPort('graphqlSubResult', A2($elm$json$Json$Decode$andThen, function (subscriptionId) {
    return A2($elm$json$Json$Decode$andThen, function (data) {
      return $elm$json$Json$Decode$succeed({
        wx: data,
        $8: subscriptionId
      });
    }, A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value));
  }, A2($elm$json$Json$Decode$field, 'subscriptionId', $elm$json$Json$Decode$string)));

  var $author$project$Remote$Remote$receiveQuickBooksIntegrationResult = _Platform_incomingPort('receiveQuickBooksIntegrationResult', $elm$json$Json$Decode$value);

  var $author$project$Remote$Remote$subscriptions = function (state) {
    var _v0 = function () {
      var _v1 = state.EL;

      switch (_v1.$) {
        case 2:
          var auth = _v1.a.u_;
          return _Utils_Tuple2(A2($author$project$Remote$Remote$getRefreshUserTokenSubscription, auth.hr, auth.e6), $elm$core$Maybe$Nothing);

        case 3:
          var auth = _v1.a.u_;
          var user = _v1.a.Fl;
          return _Utils_Tuple2(A2($author$project$Remote$Remote$getRefreshUserTokenSubscription, auth.hr, auth.e6), $elm$core$Maybe$Just(user.F));

        default:
          return _Utils_Tuple2($elm$core$Platform$Sub$none, $elm$core$Maybe$Nothing);
      }
    }();

    var refreshSessionSub = _v0.a;
    var userId = _v0.b;
    return $elm$core$Platform$Sub$batch(_Utils_ap(_List_fromArray([refreshSessionSub, $author$project$Remote$Remote$receiveQuickBooksIntegrationResult($author$project$Remote$Msg$ReceivedQuickBooksIntegrationResult)]), function () {
      if (userId.$ === 1) {
        return _List_Nil;
      } else {
        var id = userId.a;
        return _List_fromArray([$author$project$Remote$Remote$graphqlSubResult(function (_v3) {
          var subscriptionId = _v3.$8;
          var data = _v3.wx;
          return $author$project$Remote$Msg$SubscriptionMessage($author$project$Types$GqlSubscriptions$decodeGqlSubData({
            wx: data,
            $8: subscriptionId,
            oD: id
          }));
        }), $author$project$Remote$Remote$graphqlSubError(A2($elm$core$Basics$composeL, $author$project$Remote$Msg$SubscriptionError, $author$project$Types$GqlSubscriptions$decodeGqlSubError))]);
      }
    }()));
  };

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$subscriptions = function (_v0) {
    var zone = _v0.by;
    var appState = _v0.o_;
    return $elm$core$Platform$Sub$none;
  };

  var $author$project$Ui$OnboardingCompany$Msg$EditingCompanyMsg = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$Msg$ReceivedPlacePredictions = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$ElmFramework$Feature$Places$Places$receivePlacePredictions = _Platform_incomingPort('receivePlacePredictions', A2($elm$json$Json$Decode$andThen, function (placePredictions) {
    return A2($elm$json$Json$Decode$andThen, function (input) {
      return $elm$json$Json$Decode$succeed({
        W: input,
        sD: placePredictions
      });
    }, A2($elm$json$Json$Decode$field, 'input', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'placePredictions', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$list(A2($elm$json$Json$Decode$andThen, function (placeId) {
    return A2($elm$json$Json$Decode$andThen, function (placeDescription) {
      return $elm$json$Json$Decode$succeed({
        sB: placeDescription,
        sC: placeId
      });
    }, A2($elm$json$Json$Decode$field, 'placeDescription', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'placeId', $elm$json$Json$Decode$string))))])))));

  var $author$project$ElmFramework$Feature$Places$Places$subscriptions = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Places$Places$receivePlacePredictions(tag)]));
  };

  var $author$project$Ui$EditingCompany$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Places$Places$subscriptions($author$project$Ui$EditingCompany$Msg$ReceivedPlacePredictions)]));
  var $author$project$Ui$OnboardingCompany$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([A2($elm$core$Platform$Sub$map, $author$project$Ui$OnboardingCompany$Msg$EditingCompanyMsg, $author$project$Ui$EditingCompany$Subscriptions$subscriptions)]));

  var $author$project$Ui$Settings$Msg$EditingCompanyMsg = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Settings$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([A2($elm$core$Platform$Sub$map, $author$project$Ui$Settings$Msg$EditingCompanyMsg, $author$project$Ui$EditingCompany$Subscriptions$subscriptions)]));

  var $author$project$MainModule$subscriptions = function (topModel) {
    var appState = topModel.o_;
    return $elm$core$Platform$Sub$batch(_List_fromArray([A2($elm$core$Platform$Sub$map, $author$project$Msg$RemoteMsg, $author$project$Remote$Remote$subscriptions(appState.CT)), A2($elm$core$Platform$Sub$map, $author$project$Msg$GlobalMsg, $author$project$Global$Global$subscriptions(appState.qC)), A2($elm$core$Platform$Sub$map, $author$project$Msg$OnboardingCompanyMsg, $author$project$Ui$OnboardingCompany$Subscriptions$subscriptions), A2($elm$core$Platform$Sub$map, $author$project$Msg$SettingsMsg, $author$project$Ui$Settings$Subscriptions$subscriptions), A2($elm$core$Platform$Sub$map, $author$project$Msg$ComponentsPreviewMsg, $author$project$Ui$ComponentsPreview$ComponentsPreview$subscriptions(topModel))]));
  };

  var $author$project$Remote$RequestMsg$GetIndustries = {
    $: 7
  };

  var $author$project$Ui$OnboardingCompany$StateWatch$fetchIndustries = function (topState) {
    var state = topState.o_.Cb;
    var isAuthenticated = $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Remote$Model$toAuth(topState.o_.CT));

    var isAppropriateRoute = function () {
      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      _v1$2: while (true) {
        switch (_v1.$) {
          case 4:
            if (_v1.a === 2) {
              var _v2 = _v1.a;
              return true;
            } else {
              break _v1$2;
            }

          case 5:
            if (_v1.b.$ === 5 && _v1.b.a === 3) {
              var _v3 = _v1.b.a;
              return true;
            } else {
              break _v1$2;
            }

          default:
            break _v1$2;
        }
      }

      return false;
    }();

    var _v0 = _Utils_Tuple3(isAppropriateRoute, isAuthenticated, $krisajenkins$remotedata$RemoteData$isSuccess(topState.o_.CT.qP));

    if (_v0.a && _v0.b && !_v0.c) {
      return $elm$core$Maybe$Just(_Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetIndustries)])));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$OnboardingCompany$StateWatch$switchUpStateWatchers = _List_fromArray([$author$project$Ui$OnboardingCompany$StateWatch$fetchIndustries]);

  var $author$project$Types$EditingScenario$EditingScenario$fromScenario = F3(function (zone, company, scenario) {
    return {
      bX: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$BuildingBlock$unwrapBuildingBlockId),
      E: scenario.E,
      rf: scenario.rf,
      zL: scenario.zL,
      de: _Utils_eq(company.pa, $elm$core$Maybe$Just(scenario.F)),
      df: _Utils_eq(company.pe, $elm$core$Maybe$Just(scenario.F)),
      tB: A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, zone, $elm$core$Maybe$Just(A2($author$project$Types$SimpleDate$toPosix, zone, scenario.tB)))
    };
  });
  var $author$project$Types$Company$toScenario = F2(function (scenarioId, company) {
    return A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(scenarioId), $krisajenkins$remotedata$RemoteData$toMaybe(company.db));
  });

  var $author$project$Ui$Scenario$StateWatch$setEditingScenario = function (topState) {
    var toScenarioFromCurrRoute = function () {
      var _v2 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

      if (_v2.$ === 5 && _v2.b.$ === 2 && _v2.b.a.$ === 3) {
        var companyId = _v2.a;
        var _v3 = _v2.b.a;
        var scenarioId = _v3.a;
        return A2($elm$core$Maybe$andThen, function (company) {
          return A2($elm$core$Maybe$map, function (scenario) {
            return _Utils_Tuple2(company, scenario);
          }, A2($author$project$Types$Company$toScenario, scenarioId, company));
        }, A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(companyId), A2($elm$core$Maybe$map, function ($) {
          return $.v5;
        }, $author$project$Remote$Model$toSession(topState.o_.CT))));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var state = topState.o_.DB;
    var previousRouteIsEditBlockRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$RouteUtil$isAnyEditBlockRoute, $author$project$ElmFramework$Feature$Navigation$RouteHistory$previous(topState.tc)));

    var _v0 = _Utils_Tuple2(previousRouteIsEditBlockRoute, toScenarioFromCurrRoute);

    if (!_v0.a && !_v0.b.$) {
      var _v1 = _v0.b.a;
      var company = _v1.a;
      var scenario = _v1.b;
      return $elm$core$Maybe$Just(_Utils_Tuple3(_Utils_update(state, {
        p5: A3($author$project$Types$EditingScenario$EditingScenario$fromScenario, topState.by, company, scenario)
      }), $elm$core$Platform$Cmd$none, _List_Nil));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Scenario$StateWatch$switchUpStateWatchers = _List_fromArray([$author$project$Ui$Scenario$StateWatch$setEditingScenario]);

  var $author$project$Remote$Model$toRefreshToken = function (_v0) {
    var thisUserAuth = _v0.EL;

    switch (thisUserAuth.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        var auth = thisUserAuth.a.u_;
        return $elm$core$Maybe$Just(auth.e6);

      default:
        var thisUserSession = thisUserAuth.a;
        return $elm$core$Maybe$Just(thisUserSession.u_.e6);
    }
  };

  var $author$project$Msg$AccountsMsg = function (a) {
    return {
      $: 20,
      a: a
    };
  };

  var $author$project$Msg$AuthMsg = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Msg$EditingUsersMsg = function (a) {
    return {
      $: 21,
      a: a
    };
  };

  var $author$project$Msg$MainAppWrapSpecificMsg = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Msg$RemoteResponseMsg = F2(function (a, b) {
    return {
      $: 16,
      a: a,
      b: b
    };
  });

  var $author$project$Msg$ScenariosMsg = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Msg$SupportMsg = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Util$outMsgHandlerTopmost = function (_v0) {
    var updated = _v0.Fg;
    var msgTag = _v0.zI;
    var stateSetter = _v0.Ek;
    return function (_v1) {
      var childState = _v1.a;
      var childCmd = _v1.b;
      var msgs = _v1.c;
      return _Utils_Tuple3(stateSetter(childState), A2($elm$core$Platform$Cmd$map, msgTag, childCmd), msgs);
    }(updated);
  };

  var $author$project$Model$Geo$IpTypeGeolocation = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$UiWrappers$MainAppWrapModel$LeftShrunken = 1;
  var $author$project$Global$Msg$ReceiveCommonStaticFile = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });

  var $author$project$Global$Ports$clearVault = _Platform_outgoingPort('clearVault', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$Global$Global$defaultIpGeolocation = {
    pu: $elm$core$Maybe$Just('Skopje'),
    cB: 'MK',
    wg: 'Macedonia',
    xQ: {
      rb: 42.0062,
      rj: 21.4125
    },
    yB: '',
    l2: $elm$core$Maybe$Just('mk'),
    FT: $elm$core$Maybe$Just('1000')
  };

  var $author$project$Language$encodeLangDetails = function (lang) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('longName', $elm$json$Json$Encode$string(lang.zh)), _Utils_Tuple2('shortName', $elm$json$Json$Encode$string(lang.D3)), _Utils_Tuple2('countryFlagEmoji', $elm$json$Json$Encode$string(lang.kO)), _Utils_Tuple2('longNameNative', $elm$json$Json$Encode$string(lang.mi)), _Utils_Tuple2('countryShortName', $elm$json$Json$Encode$string(lang.kQ))]));
  };

  var $author$project$Model$CommonStaticFile$encodeCommonStaticFile = F2(function (lang, phrasesString) {
    return A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('language', $author$project$Language$encodeLangDetails(lang)), _Utils_Tuple2('commonStaticFile', $elm$json$Json$Encode$string(phrasesString))])));
  });

  var $author$project$Model$Payments$encodePaymentCard = function (card) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('cardNo', $elm$json$Json$Encode$string(card.pl)), _Utils_Tuple2('expMonth', $elm$json$Json$Encode$string(card.qf)), _Utils_Tuple2('expYear', $elm$json$Json$Encode$string(card.qg))]));
  };

  var $author$project$Global$Model$encodeVault = function (vault) {
    return A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('paymentCards', A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, A2($elm$core$List$map, $author$project$Model$Payments$encodePaymentCard, vault.sx)))])));
  };

  var $author$project$Remote$RequestMsg$Logout = {
    $: 72
  };
  var $author$project$Ui$Auth$Msg$OnUnauth = {
    $: 47
  };

  var $author$project$MulticastMessages$onUnauth = _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$AuthMsg($author$project$Ui$Auth$Msg$OnUnauth)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg($author$project$Remote$RequestMsg$Logout))]);

  var $turboMaCk$any_dict$Dict$Any$removeAll = function (_v0) {
    var inner = _v0;
    return {
      bT: $elm$core$Dict$empty,
      dn: inner.dn
    };
  };

  var $turboMaCk$any_dict$Dict$Any$remove = F2(function (k, _v0) {
    var inner = _v0;
    return _Utils_update(inner, {
      bT: A2($elm$core$Dict$remove, inner.dn(k), inner.bT)
    });
  });
  var $author$project$Global$Model$removeUsers = F2(function (userIds, global) {
    var remover = F2(function (id, acc) {
      return A2($turboMaCk$any_dict$Dict$Any$remove, id, acc);
    });
    return _Utils_update(global, {
      oC: A3($elm$core$List$foldl, remover, global.oC, userIds)
    });
  });

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr = function (httpErr) {
    switch (httpErr.$) {
      case 3:
        var code = httpErr.a;
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.BadStatus: ' + $elm$core$String$fromInt(code));

      case 4:
        var body = httpErr.a;
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.BadBody: ' + body);

      case 2:
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.NetworkError');

      case 0:
        var string = httpErr.a;
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.BadUrl: ' + string);

      default:
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.Timeout');
    }
  };

  var $author$project$Global$RouteAuthHandler$routeAuthHandler = function (cfg) {
    var _v0 = cfg.tc;
    return _Utils_Tuple3(cfg.Ej, $elm$core$Platform$Cmd$none, _List_Nil);
  };

  var $author$project$Global$Ports$setVault = _Platform_outgoingPort('setVault', $elm$json$Json$Encode$string);

  var $author$project$Ui$Auth$Auth$unauthenticate = _Platform_outgoingPort('unauthenticate', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$Global$Global$update = F5(function (currTime, currRoute, maybeSession, msg, global) {
    var config = global.dy;
    var phrases = global.Cq;

    switch (msg.$) {
      case 1:
        var theNewRoute = msg.b;

        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Global$RouteAuthHandler$routeAuthHandler({
            wo: currTime,
            qC: global,
            tc: theNewRoute,
            Ej: global,
            uf: session
          });
        } else {
          return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 0:
        var session = msg.a;
        return $author$project$Global$RouteAuthHandler$routeAuthHandler({
          wo: currTime,
          qC: global,
          tc: currRoute,
          Ej: global,
          uf: session
        });

      case 4:
        return _Utils_Tuple3(_Utils_update(global, {
          oC: $turboMaCk$any_dict$Dict$Any$removeAll(global.oC),
          gR: A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Global$Model$emptyVault), global.gR)
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$Global$Ports$clearVault(0), $author$project$Ui$Auth$Auth$unauthenticate(0)])), $author$project$MulticastMessages$onUnauth);

      case 3:
        var result = msg.a;

        if (!result.$) {
          var geolocation = result.a;
          return _Utils_Tuple3(_Utils_update(global, {
            lS: $elm$core$Maybe$Just($elm$core$Result$Ok(geolocation))
          }), $elm$core$Platform$Cmd$none, $author$project$MulticastMessages$onNewGeolocation($author$project$Model$Geo$IpTypeGeolocation(geolocation)));
        } else {
          var err = result.a;
          return _Utils_Tuple3(_Utils_update(global, {
            lS: $elm$core$Maybe$Just($elm$core$Result$Ok($author$project$Global$Global$defaultIpGeolocation))
          }), $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(err), $author$project$MulticastMessages$onNewGeolocation($author$project$Model$Geo$IpTypeGeolocation($author$project$Global$Global$defaultIpGeolocation)));
        }

      case 5:
        var paymentCard = msg.a;
        var _v3 = global.gR;

        if (!_v3.$) {
          var vault = _v3.a;

          var newVault = _Utils_update(vault, {
            sx: A2($elm$core$List$cons, paymentCard, vault.sx)
          });

          return _Utils_Tuple3(_Utils_update(global, {
            gR: $elm$core$Maybe$Just(newVault)
          }), $author$project$Global$Ports$setVault($author$project$Global$Model$encodeVault(newVault)), _List_Nil);
        } else {
          return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 6:
        var maybeVault = msg.a;
        return _Utils_Tuple3(_Utils_update(global, {
          gR: maybeVault
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        var lang = msg.a;
        var commonStatic = msg.b;
        return _Utils_Tuple3(_Utils_update(global, {
          kS: $elm$core$Maybe$Just($author$project$Global$Model$FromPersistence(lang)),
          Cq: commonStatic.Cq
        }), $author$project$Persistence$setCommonStaticFile(A2($author$project$Model$CommonStaticFile$encodeCommonStaticFile, lang, commonStatic.Em)), _List_Nil);

      case 8:
        var result = msg.a;

        if (!result.$) {
          var language = result.a.l2;
          var commonStatic = result.a.v4;
          var _v5 = global.kS;

          if (!_v5.$) {
            if (!_v5.a.$) {
              return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, language, commonStatic)))]));
            } else {
              var currLang = _v5.a.a;
              return _Utils_eq(currLang.zh, language.zh) ? _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, language, commonStatic)))])) : _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
            }
          } else {
            return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, language, commonStatic)))]));
          }
        } else {
          var err = result.a;
          return _Utils_Tuple3(global, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, err, ''), _List_Nil);
        }

      case 9:
        var label = msg.a;
        var err = msg.b;
        return _Utils_Tuple3(global, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError(label + (': ' + err)), _List_Nil);

      case 10:
        var maybeInviteCode = msg.a;
        return _Utils_Tuple3(_Utils_update(global, {
          rr: maybeInviteCode
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 11:
        var users = msg.a;
        return _Utils_Tuple3(A2($author$project$Global$Model$removeUsers, users, global), $elm$core$Platform$Cmd$none, _List_Nil);

      case 12:
        var dialogWindow = msg.a;
        return _Utils_Tuple3(_Utils_update(global, {
          gZ: $elm$core$Maybe$Just(dialogWindow)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        return $elm_community$maybe_extra$Maybe$Extra$isJust(global.gZ) ? _Utils_Tuple3(_Utils_update(global, {
          gZ: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));

      case 13:
        return _Utils_Tuple3(_Utils_update(global, {
          gZ: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 14:
        var val = msg.a;
        return _Utils_Tuple3(_Utils_update(global, {
          nl: A3($author$project$ElmFramework$Lib$Util$ifElse, '', val, _Utils_eq(val, global.nl))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 16:
        return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var newStatus = function () {
          var _v6 = global.l7;

          switch (_v6) {
            case 0:
              return 2;

            case 1:
              return 2;

            default:
              return 1;
          }
        }();

        return _Utils_Tuple3(_Utils_update(global, {
          l7: newStatus
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });

  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications = _Platform_outgoingPort('enablePushNotifications', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$PushMessages$PushMessages$update = F5(function (currRoute, global, maybeIdToken, msg, state) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        return _Utils_Tuple3($author$project$PushMessages$PushMessages$init, $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications(0), _List_Nil);
    }
  });
  var $author$project$Ui$UserProfile$Msg$ChangeEmail = F2(function (a, b) {
    return {
      $: 6,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$OnboardingCompany$Msg$ChangedDataSyncState = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Remote$Msg$EmailRecovery = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Remote$Msg$EmailVerification = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Auth$Model$EmailedForgotPasswordCode = {
    $: 2
  };

  var $author$project$Remote$Msg$ForgotPasswordCodeSent = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$Remote$Msg$ForgotPasswordCodeVerificationResult = function (a) {
    return {
      $: 11,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$GetAllDivisionDetails = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Global$Msg$NoOp = {
    $: 16
  };

  var $author$project$Remote$Msg$OnVerifyEmail = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Remote$Msg$ReceivedUserSessionStatusFromSignIn = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$RedeemInviteWithExistingUser = function (a) {
    return {
      $: 11,
      a: a
    };
  };

  var $author$project$Remote$Msg$RegisterNewUserResult = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Remote$Msg$ResetPasswordResult = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Ui$Auth$Model$SendingForgotPasswordCode = {
    $: 1
  };

  var $author$project$Global$Msg$SetInviteCode = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$Global$Msg$ShowDialog = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SwitchForgotPasswordState = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Global$Model$SyncAccountError = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Remote$Msg$UserTokenRefreshed = F2(function (a, b) {
    return {
      $: 15,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Auth$Model$VerifiedForgotPasswordCode = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailRecovery = 8;
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailRecoveryOutput = F4(function (recoveredEmail, displayName, photoUrl, emailVerified) {
    return {
      k0: displayName,
      xs: emailVerified,
      nh: photoUrl,
      CP: recoveredEmail
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$confirmEmailRecovery = F2(function (apiKey, _v0) {
    var code = _v0.pw;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 8);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailRecoveryOutput, A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'photoUrl', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(code))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailVerificationCode = 3;
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailVerificationCodeOutput = F4(function (email, displayName, photoUrl, emailVerified) {
    return {
      k0: displayName,
      iP: email,
      xs: emailVerified,
      nh: photoUrl
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$confirmEmailVerificationCode = F2(function (apiKey, _v0) {
    var verificationCode = _v0.uj;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 3);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailVerificationCodeOutput, A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'photoUrl', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(verificationCode))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmPasswordResetCode = 6;
  var $author$project$ElmFramework$Lib$Firebase$Auth$confirmPasswordResetCode = F2(function (apiKey, _v0) {
    var passwordResetCode = _v0.sw;
    var newPassword = _v0.jk;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 6);
    var responseDecoder = $elm$json$Json$Decode$succeed(0);
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('newPassword', $elm$json$Json$Encode$string(newPassword)), _Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(passwordResetCode))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });

  var $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'subscription', fields);
  };

  var $author$project$Types$GqlSubscriptions$graphqlSubscriptions = function (_v0) {
    var userId = _v0.a;
    var companyIdList = _v0.b;

    var encodeInviteSubscription = function (_v2) {
      var companyId = _v2;
      return {
        Eq: $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(A2($author$project$Types$GqlSubscriptions$inviteSubscription, companyId, userId)),
        $8: 'invite' + companyId
      };
    };

    var inviteSubscriptions = A2($elm$core$List$map, encodeInviteSubscription, companyIdList);

    var encodeDivisionSubscription = function (_v1) {
      var companyId = _v1;
      return {
        Eq: $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(A2($author$project$Types$GqlSubscriptions$divisionSubscription, companyId, userId)),
        $8: 'division' + companyId
      };
    };

    var divisionSubscriptions = A2($elm$core$List$map, encodeDivisionSubscription, companyIdList);
    return _Utils_ap(divisionSubscriptions, inviteSubscriptions);
  };

  var $author$project$Remote$Model$insertOngoingRequest = F2(function (_v0, request) {
    var ongoingRequests_legacy = _v0.hY;
    return A2($elm$core$Set$insert, request, ongoingRequests_legacy);
  });
  var $elm$core$Dict$member = F2(function (key, dict) {
    var _v0 = A2($elm$core$Dict$get, key, dict);

    if (!_v0.$) {
      return true;
    } else {
      return false;
    }
  });
  var $elm$core$Set$member = F2(function (key, _v0) {
    var dict = _v0;
    return A2($elm$core$Dict$member, key, dict);
  });
  var $author$project$Remote$Model$isRequestOngoing = F2(function (_v0, request) {
    var ongoingRequests_legacy = _v0.hY;
    return A2($elm$core$Set$member, request, ongoingRequests_legacy);
  });
  var $author$project$Remote$Model$isRequestNotOngoing = F2(function (remote, request) {
    return !A2($author$project$Remote$Model$isRequestOngoing, remote, request);
  });

  var $author$project$Remote$Model$isUnauthenticated = function (_v0) {
    var thisUserAuth = _v0.EL;
    return _Utils_eq(thisUserAuth, $author$project$Remote$Model$Unauthenticated);
  };

  var $turboMaCk$any_dict$Dict$Any$update = F3(function (k, f, _v0) {
    var inner = _v0;
    var updateDict = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Maybe$map(function (b) {
      return _Utils_Tuple2(k, b);
    }), f), $elm$core$Maybe$map($elm$core$Tuple$second));
    return _Utils_update(inner, {
      bT: A3($elm$core$Dict$update, inner.dn(k), updateDict, inner.bT)
    });
  });
  var $author$project$Types$UserSession$mapCompany = F3(function (mapper, companyId, thisUserSession) {
    return _Utils_update(thisUserSession, {
      v5: A3($turboMaCk$any_dict$Dict$Any$update, companyId, $elm$core$Maybe$map(mapper), thisUserSession.v5)
    });
  });
  var $author$project$Remote$Model$mapSession = F2(function (mapper, remote) {
    var _v0 = remote.EL;

    switch (_v0.$) {
      case 0:
        return remote;

      case 1:
        return remote;

      case 2:
        return remote;

      default:
        var thisUserSession = _v0.a;
        return _Utils_update(remote, {
          EL: $author$project$Remote$Model$Onboarded(mapper(thisUserSession))
        });
    }
  });
  var $author$project$TopMsg$msgGlobal = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$GlobalMsg);
  var $author$project$TopMsg$msgUserProfile = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$UserProfileMsg);

  var $author$project$Remote$Remote$newUserAuthenticated = _Platform_outgoingPort('newUserAuthenticated', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('expiresIn', $elm$json$Json$Encode$int($.hr)), _Utils_Tuple2('idToken', $elm$json$Json$Encode$string($.d5)), _Utils_Tuple2('refreshToken', $elm$json$Json$Encode$string($.e6))]));
  });

  var $author$project$Remote$Remote$newUserSession = _Platform_outgoingPort('newUserSession', function ($) {
    return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, function ($) {
      return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('expiresIn', $elm$json$Json$Encode$int($.hr)), _Utils_Tuple2('idToken', $elm$json$Json$Encode$string($.d5)), _Utils_Tuple2('refreshToken', $elm$json$Json$Encode$string($.e6))]));
    }, $);
  });

  var $author$project$Api$GraphqlSchema$Union$OnEmailVerifyPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'EmailNotVerifiedError', selections____.AW), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OnEmailVerifySuccess', selections____.Bg), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Object$EmailNotVerifiedError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$GenericError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$InvalidInputError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(function (baseUrl, mutationSelectionSet) {
    return {
      g4: baseUrl,
      wJ: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
      xD: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
      x5: _List_Nil,
      gs: $elm$core$Maybe$Nothing,
      h$: _List_Nil,
      ow: $elm$core$Maybe$Nothing,
      fi: false
    };
  });
  var $author$project$Api$Api$mutationRequestTask = A2($author$project$Api$Api$requestTask, $elm$core$Maybe$Nothing, $dillonkearns$elm_graphql$Graphql$Http$mutationRequest);

  var $author$project$Api$GraphqlSchema$Object$UserMutation$onVerifyEmail = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'onVerifyEmail', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Mutation$userLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'userLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$onVerifyEmail = F4(function (userId, url, tag, idToken) {
    var onVerifyEmailResponse = $author$project$Api$GraphqlSchema$Union$OnEmailVerifyPayload$fragments({
      AW: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$EmailNotVerifiedError$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      Bg: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$userLogic, {
      F: $author$project$Types$User$unwrapUserId(userId)
    }, $author$project$Api$GraphqlSchema$Object$UserMutation$onVerifyEmail(onVerifyEmailResponse))));
  });

  var $author$project$Remote$Remote$openQuickBooksIntegration = _Platform_outgoingPort('openQuickBooksIntegration', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('companyId', $elm$json$Json$Encode$string($.b9)), _Utils_Tuple2('divisionId', function ($) {
      return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
    }($.dB)), _Utils_Tuple2('token', $elm$json$Json$Encode$string($.t6))]));
  });

  var $author$project$Remote$Remote$refreshUserToken = F3(function (apiKey, refreshToken, tag) {
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$map, function (refreshedTokens) {
      return $author$project$Types$UserSession$wrapAuth(A3($author$project$Types$UserSession$AuthRaw, refreshedTokens.d5, refreshedTokens.e6, refreshedTokens.hr));
    }, A2($author$project$ElmFramework$Lib$Firebase$Auth$fetchNewTokensFromRefreshToken, apiKey, {
      e6: refreshToken
    })));
  });
  var $elm$core$Set$remove = F2(function (key, _v0) {
    var dict = _v0;
    return A2($elm$core$Dict$remove, key, dict);
  });
  var $author$project$Remote$Model$removeOngoingRequest = F2(function (_v0, request) {
    var ongoingRequests_legacy = _v0.hY;
    return A2($elm$core$Set$remove, request, ongoingRequests_legacy);
  });
  var $author$project$Types$Company$replaceDivisions = F2(function (updatedDivisionsList, company) {
    var updatedDivisionsDict = A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Division$unwrapDivisionId, A2($elm$core$List$map, function (division) {
      return _Utils_Tuple2(division.F, division);
    }, updatedDivisionsList));
    return _Utils_update(company, {
      eO: $krisajenkins$remotedata$RemoteData$Success(updatedDivisionsDict)
    });
  });

  var $author$project$Types$Invitation$unwrapInvitationId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Types$Company$replaceInvitations = F2(function (updatedInvitationsList, company) {
    var updatedInvitationsDict = A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Invitation$unwrapInvitationId, A2($elm$core$List$map, function (invitation) {
      return _Utils_Tuple2(invitation.F, invitation);
    }, updatedInvitationsList));
    return _Utils_update(company, {
      q_: $krisajenkins$remotedata$RemoteData$Success(updatedInvitationsDict)
    });
  });

  var $author$project$Msg$sendAuthMsg = function (uiAuthMsg) {
    return $author$project$ElmFramework$Msg$sendAppMsg($author$project$Msg$AuthMsg(uiAuthMsg));
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$SendEmailVerificationCode = 2;
  var $author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode = F2(function (apiKey, _v0) {
    var idToken = _v0.d5;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 2);
    var responseDecoder = $elm$json$Json$Decode$succeed(0);
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken)), _Utils_Tuple2('requestType', $elm$json$Json$Encode$string('VERIFY_EMAIL'))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });

  var $author$project$Msg$sendOnboardingCompanyMsg = function (uiOnboardingCompanyMsg) {
    return $author$project$ElmFramework$Msg$sendAppMsg($author$project$Msg$OnboardingCompanyMsg(uiOnboardingCompanyMsg));
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$SendPasswordResetCode = 4;
  var $author$project$ElmFramework$Lib$Firebase$Auth$sendPasswordResetCode = F2(function (apiKey, _v0) {
    var email = _v0.iP;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 4);
    var responseDecoder = $elm$json$Json$Decode$succeed(0);
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', $elm$json$Json$Encode$string(email)), _Utils_Tuple2('requestType', $elm$json$Json$Encode$string('PASSWORD_RESET'))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });

  var $author$project$Remote$Remote$setupGraphqlSubs = _Platform_outgoingPort('setupGraphqlSubs', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('authToken', $elm$json$Json$Encode$string($.ks)), _Utils_Tuple2('queriesToSubscribe', $elm$json$Json$Encode$list(function ($) {
      return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('subQuery', $elm$json$Json$Encode$string($.Eq)), _Utils_Tuple2('subscriptionId', $elm$json$Json$Encode$string($.$8))]));
    })($.nu))]));
  });

  var $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPassword = 1;
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPasswordOutput = F5(function (userId, email, idToken, refreshToken, expiresIn) {
    return {
      iP: email,
      hr: expiresIn,
      d5: idToken,
      e6: refreshToken,
      oD: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$signInViaEmailAndPassword = F2(function (apiKey, _v0) {
    var email = _v0.iP;
    var password = _v0.sv;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 1);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPasswordOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', $elm$json$Json$Encode$string(email)), _Utils_Tuple2('password', $elm$json$Json$Encode$string(password)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignUpViaEmailAndPassword = 0;
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignUpViaEmailAndPasswordOutput = F4(function (userId, idToken, refreshToken, expiresIn) {
    return {
      hr: expiresIn,
      d5: idToken,
      e6: refreshToken,
      oD: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$signUpViaEmailAndPassword = F2(function (apiKey, _v0) {
    var email = _v0.iP;
    var password = _v0.sv;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 0);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$SignUpViaEmailAndPasswordOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', $elm$json$Json$Encode$string(email)), _Utils_Tuple2('password', $elm$json$Json$Encode$string(password)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });

  var $author$project$Types$User$toFullName = function (_v0) {
    var firstName = _v0.hu;
    var lastName = _v0.hI;

    var _v1 = _Utils_Tuple2(firstName, lastName);

    if (_v1.a === '') {
      if (_v1.b === '') {
        return '';
      } else {
        var theLastName = _v1.b;
        return theLastName;
      }
    } else {
      if (_v1.b === '') {
        var theFirstName = _v1.a;
        return theFirstName;
      } else {
        var theFirstName = _v1.a;
        var theLastName = _v1.b;
        return theFirstName + (' ' + theLastName);
      }
    }
  };

  var $author$project$Types$UserSession$unwrapRefreshToken = function (_v0) {
    var token = _v0;
    return token;
  };

  var $author$project$Types$UserSession$unwrapAuth = function (auth) {
    return {
      hr: auth.hr,
      d5: $author$project$Types$UserSession$unwrapIdToken(auth.d5),
      e6: $author$project$Types$UserSession$unwrapRefreshToken(auth.e6)
    };
  };

  var $author$project$Remote$Model$updateUserAuth = F2(function (remoteState, newUserAuth) {
    return _Utils_update(remoteState, {
      EL: newUserAuth
    });
  });
  var $author$project$Remote$Model$updateTokens = F2(function (newAuthTokens, remoteState) {
    var _v0 = remoteState.EL;

    switch (_v0.$) {
      case 0:
        return remoteState;

      case 1:
        return remoteState;

      case 2:
        var authDetails = _v0.a;
        return A2($author$project$Remote$Model$updateUserAuth, remoteState, $author$project$Remote$Model$Authenticated(_Utils_update(authDetails, {
          u_: newAuthTokens
        })));

      default:
        var thisUserSession = _v0.a;
        return A2($author$project$Remote$Model$updateUserAuth, remoteState, $author$project$Remote$Model$Onboarded(_Utils_update(thisUserSession, {
          u_: newAuthTokens
        })));
    }
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$UpdateUserProfile = 10;
  var $author$project$ElmFramework$Lib$Firebase$Auth$UpdateUserProfileOutput = F5(function (userId, email, displayName, emailVerified, photoUrl) {
    return {
      k0: displayName,
      iP: email,
      xs: emailVerified,
      nh: photoUrl,
      oD: userId
    };
  });

  var $author$project$ElmFramework$Lib$Firebase$Auth$maybeStringEncoder = function (stringValue) {
    return $elm$json$Json$Encode$string(A2($elm$core$Maybe$withDefault, '', stringValue));
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$updateUserProfile = F2(function (apiKey, _v0) {
    var idToken = _v0.d5;
    var displayName = _v0.k0;
    var photoUrl = _v0.nh;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 10);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$UpdateUserProfileOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'photoUrl', $elm$json$Json$Decode$string)));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken)), _Utils_Tuple2('displayName', $elm$json$Json$Encode$string(displayName)), _Utils_Tuple2('photoUrl', $author$project$ElmFramework$Lib$Firebase$Auth$maybeStringEncoder(photoUrl))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$VerifyEmailRecoveryCode = 7;
  var $author$project$ElmFramework$Lib$Firebase$Auth$VerifyEmailRecoveryCodeOutput = F2(function (oldEmail, currentEmail) {
    return {
      wq: currentEmail,
      zZ: oldEmail
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$verifyEmailRecoveryCode = F2(function (apiKey, _v0) {
    var code = _v0.pw;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 7);
    var responseDecoder = A3($elm$json$Json$Decode$map2, $author$project$ElmFramework$Lib$Firebase$Auth$VerifyEmailRecoveryCodeOutput, A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'newEmail', $elm$json$Json$Decode$string));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(code))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$VerifyPasswordResetCode = 5;

  var $author$project$ElmFramework$Lib$Firebase$Auth$VerifyPasswordResetCodeOutput = function (email) {
    return {
      iP: email
    };
  };

  var $author$project$ElmFramework$Lib$Firebase$Auth$verifyPasswordResetCode = F2(function (apiKey, _v0) {
    var resetCode = _v0.s0;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 5);
    var responseDecoder = A2($elm$json$Json$Decode$map, $author$project$ElmFramework$Lib$Firebase$Auth$VerifyPasswordResetCodeOutput, A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(resetCode))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Remote$Remote$update = F5(function (currTime, currRoute, msg, state, global) {
    var config = global.dy;
    var firebaseApiKey = config.xL.oY;
    var apiEndpoint = config.oZ;

    switch (msg.$) {
      case 20:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var email = msg.a.iP;
        var password = msg.a.sv;
        var firstName = msg.a.hu;
        var lastName = msg.a.hI;
        return A2($author$project$Remote$Model$isRequestNotOngoing, state, $author$project$Remote$Remote$requests.jB) && $author$project$Remote$Model$isUnauthenticated(state) ? _Utils_Tuple3(_Utils_update(state, {
          hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.jB),
          EL: $author$project$Remote$Model$UserAuthenticating
        }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$RegisterNewUserResult, A2($elm$core$Task$andThen, function (_v1) {
          var idToken = _v1.d5;
          return A2($elm$core$Task$andThen, function (_v2) {
            return A2($author$project$ElmFramework$Lib$Firebase$Auth$updateUserProfile, firebaseApiKey, {
              k0: $author$project$Types$User$toFullName({
                hu: firstName,
                hI: lastName
              }),
              d5: idToken,
              nh: $elm$core$Maybe$Nothing
            });
          }, A2($author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode, firebaseApiKey, {
            d5: idToken
          }));
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$signUpViaEmailAndPassword, firebaseApiKey, {
          iP: email,
          sv: password
        }))), _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var result = msg.a;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.jB),
          EL: $author$project$Remote$Model$Unauthenticated
        });

        if (result.$ === 1) {
          var err = result.a;
          return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
            EL: $author$project$Remote$Model$Unauthenticated
          }), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil)]));
        } else {
          return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$Auth($author$project$Route$Route$AccountCreationSuccess))]));
        }

      case 5:
        var email = msg.a.iP;
        var password = msg.a.sv;
        return A2($author$project$Remote$Model$isRequestNotOngoing, state, $author$project$Remote$Remote$requests.gy) && $author$project$Remote$Model$isUnauthenticated(state) ? _Utils_Tuple3(_Utils_update(state, {
          hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.gy),
          EL: $author$project$Remote$Model$UserAuthenticating
        }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$ReceivedUserSessionStatusFromSignIn, A2($elm$core$Task$andThen, function (_v4) {
          var idToken = _v4.d5;
          var refreshToken = _v4.e6;
          var expiresIn = _v4.hr;
          return $author$project$Api$Api$getUserSessionStatus({
            oY: config.xL.oY,
            oZ: config.oZ,
            o0: {
              hr: expiresIn,
              d5: idToken,
              e6: refreshToken
            }
          });
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$signInViaEmailAndPassword, firebaseApiKey, {
          iP: email,
          sv: password
        }))), _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        var email = msg.a;
        return A2($author$project$Remote$Model$isRequestNotOngoing, state, $author$project$Remote$Remote$requests.jO) && $author$project$Remote$Model$isUnauthenticated(state) ? _Utils_Tuple3(_Utils_update(state, {
          hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.jO)
        }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$ForgotPasswordCodeSent, A2($author$project$ElmFramework$Lib$Firebase$Auth$sendPasswordResetCode, firebaseApiKey, {
          iP: email
        })), _List_fromArray([$author$project$Msg$sendAuthMsg($author$project$Ui$Auth$Msg$SwitchForgotPasswordState($author$project$Ui$Auth$Model$SendingForgotPasswordCode))])) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var res = msg.a;

        if (res.$ === 1) {
          var err = res.a;
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Couldn\'t verify email: ' + err, _List_Nil)]));
        } else {
          var maybeAuthData = function () {
            var _v8 = state.EL;

            switch (_v8.$) {
              case 2:
                var authUser = _v8.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(authUser.u_.d5, authUser.Fl.F));

              case 3:
                var session = _v8.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(session.u_.d5, session.Fl.F));

              default:
                return $elm$core$Maybe$Nothing;
            }
          }();

          var onVerifyEmail = function () {
            if (!maybeAuthData.$) {
              var _v7 = maybeAuthData.a;
              var idToken = _v7.a;
              var userId = _v7.b;
              return A4($author$project$Api$Api$onVerifyEmail, userId, apiEndpoint, $author$project$Remote$Msg$OnVerifyEmail, idToken);
            } else {
              return $elm$core$Platform$Cmd$none;
            }
          }();

          return _Utils_Tuple3(state, onVerifyEmail, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Nothing, 'Email Verified successfully', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials))]));
        }

      case 7:
        var gqlResult = msg.a;

        if (!gqlResult.$) {
          var result = gqlResult.a;

          if (!result.$) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          } else {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 10:
        var res = msg.a;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.jO)
        });

        if (!res.$) {
          return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$Msg$sendAuthMsg($author$project$Ui$Auth$Msg$SwitchForgotPasswordState($author$project$Ui$Auth$Model$EmailedForgotPasswordCode))]));
        } else {
          var err = res.a;
          return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil), $author$project$Msg$sendAuthMsg($author$project$Ui$Auth$Msg$SwitchForgotPasswordState($author$project$Ui$Auth$Model$EnterForgotPasswordEmail('')))]));
        }

      case 11:
        var res = msg.a;

        if (res.$ === 1) {
          var err = res.a;
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Couldn\'t verify reset password code: ' + err, _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials))]));
        } else {
          var verifiedPasswordResetCode = res.a.uk;
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Nothing, 'Code verified successfully, please enter a new password', _List_Nil), $author$project$Msg$sendAuthMsg($author$project$Ui$Auth$Msg$SwitchForgotPasswordState($author$project$Ui$Auth$Model$VerifiedForgotPasswordCode(verifiedPasswordResetCode))), $author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword))]));
        }

      case 12:
        var passwordResetCode = msg.a.sw;
        var newPassword = msg.a.jk;
        return A2($author$project$Remote$Model$isRequestNotOngoing, state, $author$project$Remote$Remote$requests.jF) && $author$project$Remote$Model$isUnauthenticated(state) ? _Utils_Tuple3(_Utils_update(state, {
          hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.jF)
        }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$ResetPasswordResult, A2($author$project$ElmFramework$Lib$Firebase$Auth$confirmPasswordResetCode, firebaseApiKey, {
          jk: newPassword,
          sw: passwordResetCode
        })), _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 13:
        var res = msg.a;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.jF)
        });

        if (!res.$) {
          return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Nothing, 'Password reset successfully, please sign in with your new password', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials))]));
        } else {
          var err = res.a;
          return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Nothing, 'Failed to reset password, error: ' + (err + ', please try again'), _List_Nil)]));
        }

      case 14:
        var andThen = msg.a;
        var refreshToken = msg.b;
        return A2($author$project$Remote$Model$isRequestNotOngoing, state, $author$project$Remote$Remote$requests.jz) ? _Utils_Tuple3(_Utils_update(state, {
          hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.jz)
        }), A3($author$project$Remote$Remote$refreshUserToken, firebaseApiKey, refreshToken, $author$project$Remote$Msg$UserTokenRefreshed(andThen)), _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 15:
        var maybeAndThen = msg.a;
        var res = msg.b;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.jz)
        });

        if (!res.$) {
          var newAuth = res.a;

          var topMsgs = function () {
            if (!maybeAndThen.$) {
              var andThen = maybeAndThen.a;
              var newEmail = andThen;
              return _List_fromArray([$author$project$TopMsg$msgUserProfile(A2($author$project$Ui$UserProfile$Msg$ChangeEmail, newAuth, newEmail))]);
            } else {
              return _List_Nil;
            }
          }();

          return _Utils_Tuple3(A2($author$project$Remote$Model$updateTokens, newAuth, newStateAfterRequest), $author$project$Remote$Remote$newUserSession($elm$core$Maybe$Just($author$project$Types$UserSession$unwrapAuth(newAuth))), topMsgs);
        } else {
          return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
            EL: $author$project$Remote$Model$Unauthenticated
          }), $author$project$Remote$Remote$newUserSession($elm$core$Maybe$Nothing), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Failed to refresh user tokens, please sign in again', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials))]));
        }

      case 8:
        var result = msg.a;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.k6)
        });

        if (!result.$) {
          var recoveredEmail = result.a.CP;
          var preRecoveryEmail = result.a.sG;
          return _Utils_Tuple3(function () {
            var _v18 = newStateAfterRequest.EL;

            switch (_v18.$) {
              case 0:
                return newStateAfterRequest;

              case 1:
                return newStateAfterRequest;

              case 2:
                return newStateAfterRequest;

              default:
                var userSession = _v18.a;
                var user = userSession.Fl;

                var newUser = _Utils_update(user, {
                  iP: recoveredEmail
                });

                var updatedUserSession = _Utils_update(userSession, {
                  Fl: newUser
                });

                return _Utils_update(newStateAfterRequest, {
                  EL: $author$project$Remote$Model$Onboarded(updatedUserSession)
                });
            }
          }(), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Nothing, 'Your account\'s sign in email was successfully reverted from ' + (preRecoveryEmail + (' to ' + (recoveredEmail + '. In case your account was compromised, use forgot password to reset your password and then log back in.'))), _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$homeRoute)]));
        } else {
          var err = result.a;
          return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Failed to recover email. ' + err, _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do($author$project$Route$Route$homeRoute)]));
        }

      case 0:
        var newRoute = msg.b;

        _v19$2: while (true) {
          switch (newRoute.$) {
            case 2:
              if (!newRoute.a.$) {
                var action = newRoute.a.a.gW;
                var code = newRoute.a.a.pw;

                var _v20 = function () {
                  switch (action) {
                    case 'resetPassword':
                      return _Utils_Tuple2(_Utils_update(state, {
                        hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.s1)
                      }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$ForgotPasswordCodeVerificationResult, A2($elm$core$Task$map, function (_v22) {
                        var email = _v22.iP;
                        return {
                          iP: email,
                          uk: code
                        };
                      }, A2($author$project$ElmFramework$Lib$Firebase$Auth$verifyPasswordResetCode, firebaseApiKey, {
                        s0: code
                      }))));

                    case 'verifyEmail':
                      return _Utils_Tuple2(_Utils_update(state, {
                        hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.p8)
                      }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$EmailVerification, A2($author$project$ElmFramework$Lib$Firebase$Auth$confirmEmailVerificationCode, firebaseApiKey, {
                        uj: code
                      })));

                    case 'recoverEmail':
                      return _Utils_Tuple2(_Utils_update(state, {
                        hY: A2($author$project$Remote$Model$insertOngoingRequest, state, $author$project$Remote$Remote$requests.k6)
                      }), A2($elm$core$Task$attempt, $author$project$Remote$Msg$EmailRecovery, A2($elm$core$Task$andThen, function (_v23) {
                        var currentEmail = _v23.wq;
                        return A2($elm$core$Task$map, function (_v24) {
                          var recoveredEmail = _v24.CP;
                          return {
                            sG: currentEmail,
                            CP: recoveredEmail
                          };
                        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$confirmEmailRecovery, firebaseApiKey, {
                          pw: code
                        }));
                      }, A2($author$project$ElmFramework$Lib$Firebase$Auth$verifyEmailRecoveryCode, firebaseApiKey, {
                        pw: code
                      }))));

                    default:
                      return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
                  }
                }();

                var newState = _v20.a;
                var command = _v20.b;
                return _Utils_Tuple3(newState, command, _List_Nil);
              } else {
                break _v19$2;
              }

            case 3:
              var inviteCode = newRoute.a;
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$SetInviteCode($elm$core$Maybe$Just(inviteCode)))]));

            default:
              break _v19$2;
          }
        }

        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 18:
        var companyId = msg.a;
        var divisionId = msg.b;

        var _v25 = $author$project$Remote$Model$toAuth(state);

        if (!_v25.$) {
          var auth = _v25.a;
          return _Utils_Tuple3(state, $author$project$Remote$Remote$openQuickBooksIntegration({
            b9: $author$project$Types$Company$unwrapCompanyId(companyId),
            dB: A2($elm$core$Maybe$map, $author$project$Types$Division$unwrapDivisionId, divisionId),
            t6: $author$project$Types$UserSession$unwrapIdToken(auth.d5)
          }), _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Not authenticated', _List_Nil), $author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$ChangedDataSyncState($author$project$Ui$OnboardingCompany$Model$ChooseAccountingApp))]));
        }

      case 19:
        var result = msg.a;
        var decoder = A2($elm$json$Json$Decode$andThen, function (resultType) {
          switch (resultType) {
            case 'Error':
              return A3($elm$json$Json$Decode$map2, F2(function (em, et) {
                return $elm$core$Result$Err({
                  qc: em,
                  xA: et
                });
              }), A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'errorType', $elm$json$Json$Decode$string));

            case 'Success':
              return A2($elm$json$Json$Decode$map, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Result$Ok), A2($elm$json$Json$Decode$field, 'companyId', $elm$json$Json$Decode$string));

            default:
              return $elm$json$Json$Decode$fail('Bad result type');
          }
        }, A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));

        var _v26 = A2($elm$json$Json$Decode$decodeValue, decoder, result);

        if (!_v26.$) {
          var data = _v26.a;

          if (!data.$) {
            var companyId = data.a;
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E1, $elm$core$Maybe$Nothing, 'Successfully linked up with quickbooks', _List_Nil), $author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$ChangedDataSyncState($author$project$Ui$OnboardingCompany$Model$ChooseAccountingApp)), $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetAllDivisionDetails(companyId))]));
          } else {
            var errorMessage = data.a.qc;
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Failed to link up with quickbooks: ' + errorMessage, _List_Nil), $author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$ChangedDataSyncState($author$project$Ui$OnboardingCompany$Model$ChooseAccountingApp))]));
          }
        } else {
          var message = A2($elm$core$Maybe$withDefault, A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Failed to understand quickbooks response, decoding failure', _List_Nil), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Global$Model$SyncAccountError, A2($elm$core$Basics$composeR, $author$project$Global$Msg$ShowDialog, $author$project$TopMsg$msgGlobal)), $author$project$Route$RouteUtil$toCompanyId(currRoute)));
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([message, $author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$ChangedDataSyncState($author$project$Ui$OnboardingCompany$Model$ChooseAccountingApp))]));
        }

      case 16:
        var subMsg = msg.a;

        switch (subMsg.$) {
          case 0:
            var companyId = subMsg.a;
            var divisionList = subMsg.b;

            var updater = function (session) {
              return A3($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$replaceDivisions(divisionList), companyId, session);
            };

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updater, state), $elm$core$Platform$Cmd$none, _List_Nil);

          case 1:
            var companyId = subMsg.a;
            var invitationList = subMsg.b;

            var updater = function (session) {
              return A3($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$replaceInvitations(invitationList), companyId, session);
            };

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updater, state), $elm$core$Platform$Cmd$none, _List_Nil);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 17:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Failed to sync background data', _List_Nil)]));

      case 2:
        var userSessionStatusResult = msg.a;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.gy)
        });

        var errorSigningIn = function (err) {
          return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
            EL: $author$project$Remote$Model$Unauthenticated
          }), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil)]));
        };

        if (!userSessionStatusResult.$) {
          var userSessionStatus = userSessionStatusResult.a;

          switch (userSessionStatus.$) {
            case 2:
              var authUser = userSessionStatus.a;
              return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
                EL: userSessionStatus
              }), $author$project$Remote$Remote$newUserAuthenticated($author$project$Types$UserSession$unwrapAuth(authUser.u_)), _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(0))]));

            case 3:
              var thisUserSession = userSessionStatus.a;
              var companyIdList = A2($elm$core$List$map, function ($) {
                return $.b9;
              }, A2($author$project$ElmFramework$Lib$PivotDict$getById1, thisUserSession.Fl.F, thisUserSession.ue));
              return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
                EL: userSessionStatus
              }), $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$Remote$Remote$newUserAuthenticated($author$project$Types$UserSession$unwrapAuth(thisUserSession.u_)), $author$project$Remote$Remote$setupGraphqlSubs({
                ks: $author$project$Types$UserSession$unwrapAuth(thisUserSession.u_).d5,
                nu: $author$project$Types$GqlSubscriptions$graphqlSubscriptions(_Utils_Tuple2(thisUserSession.Fl.F, companyIdList))
              })])), _List_Nil);

            default:
              return errorSigningIn('Invalid state');
          }
        } else {
          var err = userSessionStatusResult.a;
          return errorSigningIn(err);
        }

      default:
        var userSessionStatusResult = msg.a;

        var newStateAfterRequest = _Utils_update(state, {
          hY: A2($author$project$Remote$Model$removeOngoingRequest, state, $author$project$Remote$Remote$requests.gy)
        });

        var errorSigningIn = function (err) {
          return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
            EL: $author$project$Remote$Model$Unauthenticated
          }), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil)]));
        };

        if (!userSessionStatusResult.$) {
          var userSessionStatus = userSessionStatusResult.a;

          switch (userSessionStatus.$) {
            case 2:
              var authUser = userSessionStatus.a;
              var _v34 = global.rr;

              if (!_v34.$) {
                var inviteCode = _v34.a;
                return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
                  EL: userSessionStatus
                }), $author$project$Remote$Remote$newUserAuthenticated($author$project$Types$UserSession$unwrapAuth(authUser.u_)), _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RedeemInviteWithExistingUser(inviteCode))]));
              } else {
                return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
                  EL: userSessionStatus
                }), $author$project$Remote$Remote$newUserAuthenticated($author$project$Types$UserSession$unwrapAuth(authUser.u_)), _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(0))]));
              }

            case 3:
              var thisUserSession = userSessionStatus.a;

              var redeemInvite = function () {
                var _v35 = global.rr;

                if (!_v35.$) {
                  var inviteCode = _v35.a;
                  return $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RedeemInviteWithExistingUser(inviteCode));
                } else {
                  return $author$project$TopMsg$msgGlobal($author$project$Global$Msg$NoOp);
                }
              }();

              var companyIdList = A2($elm$core$List$map, function ($) {
                return $.b9;
              }, A2($author$project$ElmFramework$Lib$PivotDict$getById1, thisUserSession.Fl.F, thisUserSession.ue));
              return _Utils_Tuple3(_Utils_update(newStateAfterRequest, {
                EL: userSessionStatus
              }), $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$Remote$Remote$newUserAuthenticated($author$project$Types$UserSession$unwrapAuth(thisUserSession.u_)), $author$project$Remote$Remote$setupGraphqlSubs({
                ks: $author$project$Types$UserSession$unwrapAuth(thisUserSession.u_).d5,
                nu: $author$project$Types$GqlSubscriptions$graphqlSubscriptions(_Utils_Tuple2(thisUserSession.Fl.F, companyIdList))
              })])), _List_fromArray([redeemInvite]));

            default:
              var _v36 = global.rr;

              if (!_v36.$) {
                return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Auth($author$project$Route$Route$Register($elm$core$Maybe$Nothing)))]));
              } else {
                return _Utils_Tuple3(newStateAfterRequest, $elm$core$Platform$Cmd$none, _List_Nil);
              }

          }
        } else {
          var err = userSessionStatusResult.a;
          return errorSigningIn(err);
        }

    }
  });
  var $author$project$Global$Model$EditAccountBalance = F5(function (a, b, c, d, e) {
    return {
      $: 7,
      a: a,
      b: b,
      c: c,
      d: d,
      e: e
    };
  });
  var $author$project$Remote$RequestMsg$GetFinancialAccountBalancesForPeriod = F3(function (a, b, c) {
    return {
      $: 38,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$GetFinancialAccountBalancesForPeriodReq = F2(function (financialAccountId, startFromDate) {
    return {
      xK: financialAccountId,
      Eh: startFromDate
    };
  });

  var $author$project$Ui$Accounts$Msg$OnAddAccountMsg = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Msg$OnEditAccountMsg = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Types$SimpleDate$fromPosix = F2(function (zone, posix) {
    var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, posix);

    var year = _v0.FP;
    var month = _v0.zG;
    var day = _v0.wz;
    return A3($author$project$Types$SimpleDate$SimpleDate, year, month, day);
  });
  var $turboMaCk$any_dict$Dict$Any$insert = F3(function (k, v, _v0) {
    var inner = _v0;
    return _Utils_update(inner, {
      bT: A3($elm$core$Dict$insert, inner.dn(k), _Utils_Tuple2(k, v), inner.bT)
    });
  });
  var $turboMaCk$any_set$Set$Any$insert = F2(function (a, _v0) {
    var dict = _v0;
    return A3($turboMaCk$any_dict$Dict$Any$insert, a, 0, dict);
  });
  var $author$project$Ui$Accounts$Update$mapAddModel = F2(function (model, _v0) {
    var addAccountModel = _v0.a;
    var cmd = _v0.b;
    var msg = _v0.c;
    return _Utils_Tuple3(_Utils_update(model, {
      oS: addAccountModel
    }), cmd, msg);
  });
  var $author$project$Ui$Accounts$Update$mapCmd = F2(function (toMsg, _v0) {
    var model = _v0.a;
    var cmd = _v0.b;
    var msg = _v0.c;
    return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, toMsg, cmd), msg);
  });
  var $author$project$Ui$Accounts$Update$mapEditModel = F2(function (model, _v0) {
    var editAccountModel = _v0.a;
    var cmd = _v0.b;
    var msg = _v0.c;
    return _Utils_Tuple3(_Utils_update(model, {
      p_: editAccountModel
    }), cmd, msg);
  });
  var $turboMaCk$any_set$Set$Any$remove = F2(function (a, _v0) {
    var dict = _v0;
    return A2($turboMaCk$any_dict$Dict$Any$remove, a, dict);
  });
  var $author$project$Api$Types$AddAccountReq$AddAccountReq = F7(function (accountType, accountName, division, startingBalance, currency, balanceMinMaxAdvice, startingBalanceDate) {
    return {
      oO: accountName,
      it: accountType,
      dx: balanceMinMaxAdvice,
      bq: currency,
      R: division,
      tE: startingBalance,
      tF: startingBalanceDate
    };
  });
  var $author$project$Remote$RequestMsg$AddFinancialAccount = F2(function (a, b) {
    return {
      $: 33,
      a: a,
      b: b
    };
  });
  var $elm_community$result_extra$Result$Extra$andMap = F2(function (ra, rb) {
    var _v0 = _Utils_Tuple2(ra, rb);

    if (_v0.b.$ === 1) {
      var x = _v0.b.a;
      return $elm$core$Result$Err(x);
    } else {
      var o = _v0.a;
      var fn = _v0.b.a;
      return A2($elm$core$Result$map, fn, o);
    }
  });
  var $elm$core$String$trim = _String_trim;
  var $author$project$Types$Time$epochYear = 1970;

  var $author$project$Types$Time$invalidDay = function (day) {
    return $elm$parser$Parser$problem('Invalid day: ' + $elm$core$String$fromInt(day));
  };

  var $author$project$Types$Time$isLeapYear = function (year) {
    return !A2($elm$core$Basics$modBy, 4, year) && (!!A2($elm$core$Basics$modBy, 100, year) || !A2($elm$core$Basics$modBy, 400, year));
  };

  var $author$project$Types$Time$leapYearsBefore = function (y1) {
    var y = y1 - 1;
    return (y / 4 | 0) - (y / 100 | 0) + (y / 400 | 0);
  };

  var $author$project$Types$Time$msPerDay = 86400000;
  var $author$project$Types$Time$msPerYear = 31536000000;

  var $author$project$Types$Time$dayMonthYearToMsParser = function (_v0) {
    var dayInMonth = _v0.a;
    var month = _v0.b;
    var year = _v0.c;

    if (dayInMonth < 0) {
      return $author$project$Types$Time$invalidDay(dayInMonth);
    } else {
      var succeedWith = function (extraMs) {
        var yearMs = $author$project$Types$Time$msPerYear * (year - $author$project$Types$Time$epochYear);
        var days = month < 3 || !$author$project$Types$Time$isLeapYear(year) ? dayInMonth - 1 : dayInMonth;
        var dayMs = $author$project$Types$Time$msPerDay * (days + ($author$project$Types$Time$leapYearsBefore(year) - $author$project$Types$Time$leapYearsBefore($author$project$Types$Time$epochYear)));
        return $elm$parser$Parser$succeed(extraMs + yearMs + dayMs);
      };

      switch (month) {
        case 1:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(0);

        case 2:
          return dayInMonth > 29 || dayInMonth === 29 && !$author$project$Types$Time$isLeapYear(year) ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(2678400000);

        case 3:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(5097600000);

        case 4:
          return dayInMonth > 30 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(7776000000);

        case 5:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(10368000000);

        case 6:
          return dayInMonth > 30 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(13046400000);

        case 7:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(15638400000);

        case 8:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(18316800000);

        case 9:
          return dayInMonth > 30 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(20995200000);

        case 10:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(23587200000);

        case 11:
          return dayInMonth > 30 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(26265600000);

        case 12:
          return dayInMonth > 31 ? $author$project$Types$Time$invalidDay(dayInMonth) : succeedWith(28857600000);

        default:
          return $elm$parser$Parser$problem('Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
      }
    }
  };

  var $author$project$Types$Time$paddedInt = function (quantity) {
    var helper = function (str) {
      if (_Utils_eq($elm$core$String$length(str), quantity)) {
        var _v0 = $elm$core$String$toInt(str);

        if (!_v0.$) {
          var intVal = _v0.a;
          return A2($elm$parser$Parser$map, $elm$parser$Parser$Done, $elm$parser$Parser$succeed(intVal));
        } else {
          return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
        }
      } else {
        return A2($elm$parser$Parser$map, function (nextChar) {
          return $elm$parser$Parser$Loop(A2($elm$core$String$append, str, nextChar));
        }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
      }
    };

    return A2($elm$parser$Parser$loop, '', helper);
  };

  var $author$project$Types$Time$dayMonthYearParser = A2($elm$parser$Parser$andThen, function (p) {
    return A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$time$Time$millisToPosix(p)), $elm$parser$Parser$end);
  }, A2($elm$parser$Parser$andThen, $author$project$Types$Time$dayMonthYearToMsParser, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(F3(function (day, month, year) {
    return _Utils_Tuple3(day, month, year);
  })), $author$project$Types$Time$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $author$project$Types$Time$paddedInt(2)), $author$project$Types$Time$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $author$project$Types$Time$paddedInt(4)), $author$project$Types$Time$paddedInt(4)])))));

  var $author$project$Types$Time$fromDayMonthYearString = function (str) {
    return A2($elm$parser$Parser$run, $author$project$Types$Time$dayMonthYearParser, str);
  };

  var $author$project$Ui$DateInput$DateInput$DatePickerChanged = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$NeverVisible = 0;

  var $author$project$Ui$DateInput$DateInput$monthToName = function (m) {
    switch (m) {
      case 0:
        return 'January';

      case 1:
        return 'February';

      case 2:
        return 'March';

      case 3:
        return 'April';

      case 4:
        return 'May';

      case 5:
        return 'June';

      case 6:
        return 'July';

      case 7:
        return 'August';

      case 8:
        return 'September';

      case 9:
        return 'October';

      case 10:
        return 'November';

      default:
        return 'December';
    }
  };

  var $author$project$Ui$DateInput$DateInput$getDateInputSettings = function (zone) {
    return {
      kU: F2(function (_v0, _v1) {
        return '';
      }),
      lq: 0,
      qv: $elm$core$Maybe$Nothing,
      qx: $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$dayToNameString,
      qy: $author$project$Ui$DateInput$DateInput$monthToName,
      es: $author$project$Ui$DateInput$DateInput$DatePickerChanged,
      i2: F2(function (_v2, _v3) {
        return false;
      }),
      tw: false,
      n7: false,
      j$: 0,
      by: zone
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$Open = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$getTimePickerSettings = function (settings) {
    var _v0 = settings.j$;
    return $elm$core$Maybe$Nothing;
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$generatePickerDay = F2(function (settings, time) {
    return A2($elm$core$Maybe$withDefault, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$pickerDayFromPosix, settings.by, settings.i2, $elm$core$Maybe$Nothing, time), A2($elm$core$Maybe$map, function (timePickerSettings) {
      return A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$pickerDayFromPosix, settings.by, settings.i2, $elm$core$Maybe$Just(timePickerSettings.ki), time);
    }, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$getTimePickerSettings(settings)));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$openPicker = F4(function (settings, baseTime, pickedTime, _v0) {
    var model = _v0;
    var viewOffset = A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$calculateViewOffset, settings.by, baseTime, pickedTime);

    var timePickerVisible = function () {
      var _v1 = settings.j$;
      return false;
    }();

    var selectionTuple = A2($elm$core$Maybe$map, function (pt) {
      return _Utils_Tuple2(A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$generatePickerDay, settings, pt), pt);
    }, pickedTime);
    return _Utils_update(model, {
      eA: selectionTuple,
      Y: A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$Open, timePickerVisible, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$generatePickerDay, settings, baseTime)),
      du: viewOffset
    });
  });

  var $author$project$Ui$DateInput$DateInput$updateDateInput = function (_v0) {
    var model = _v0.zF;
    var dateInputMsg = _v0.wy;
    var zone = _v0.by;
    var baseTime = _v0.vd;

    switch (dateInputMsg.$) {
      case 0:
        var _v2 = dateInputMsg.a;
        var newPicker = _v2.a;
        var maybeNewTime = _v2.b;

        var newSelectedDate = function () {
          if (maybeNewTime.$ === 1) {
            return model.Fw;
          } else {
            var justNewTime = maybeNewTime;
            return justNewTime;
          }
        }();

        return {
          ca: {
            iM: A2($author$project$Ui$DateInput$DateInput$getDateInputState, zone, newSelectedDate),
            d1: A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$init, newPicker, !_Utils_eq(newSelectedDate, model.Fw))
          },
          Fw: newSelectedDate
        };

      case 2:
        var openedDatePicker = A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$openPicker, $author$project$Ui$DateInput$DateInput$getDateInputSettings(zone), baseTime, model.Fw, model.ca.d1);
        var internalState = model.ca;
        return _Utils_update(model, {
          ca: _Utils_update(internalState, {
            d1: openedDatePicker
          })
        });

      case 3:
        var internalState = model.ca;
        return _Utils_update(model, {
          ca: _Utils_update(internalState, {
            d1: $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$init
          })
        });

      default:
        var newDateInput = dateInputMsg.a;

        var newSelectedDate = function () {
          var _v4 = $author$project$Types$Time$fromDayMonthYearString(newDateInput);

          if (!_v4.$) {
            var posix = _v4.a;
            return $elm$core$Maybe$Just(posix);
          } else {
            return $elm$core$Maybe$Nothing;
          }
        }();

        var newPickerWithSelectedDate = A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$openPicker, $author$project$Ui$DateInput$DateInput$getDateInputSettings(zone), baseTime, newSelectedDate, model.ca.d1);
        return {
          ca: {
            iM: $elm$core$Maybe$Just(newDateInput),
            d1: newPickerWithSelectedDate
          },
          Fw: newSelectedDate
        };
    }
  };

  var $author$project$Ui$Accounts$Add$Update$update = F4(function (time, zone, model, msg) {
    var nonEmptyOrNothing = function (string) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(string), $elm$core$String$isEmpty($elm$core$String$trim(string)));
    };

    switch (msg.$) {
      case 0:
        var type_ = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          P: $elm$core$Maybe$Just(type_)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var currency = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          bq: $elm$core$Maybe$Just(currency)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var name = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          zL: nonEmptyOrNothing(name)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var division = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          R: $elm$core$Maybe$Just(division)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          pU: input
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          o3: nonEmptyOrNothing(input)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          rs: nonEmptyOrNothing(input)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        var dateMsg = msg.a;
        var date = $author$project$Ui$DateInput$DateInput$updateDateInput({
          vd: time,
          wy: dateMsg,
          zF: model.iL,
          by: zone
        });
        return _Utils_Tuple3(_Utils_update(model, {
          iL: date
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 8:
        return _Utils_Tuple3(A2($author$project$Ui$Accounts$Add$Model$init, time, zone), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));

      default:
        var companyId = msg.a;
        var maybeRequest = A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'Please choose an opening date', A2($elm$core$Maybe$map, $author$project$Types$SimpleDate$fromPosix(zone), model.iL.Fw)), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$andThen, A2($elm$core$Basics$composeR, $author$project$Types$Fraction$toFractionFromString('.'), $elm$core$Result$fromMaybe('Please provide a valid number for target balance')), $elm$core$Result$Ok(A2($elm$core$Maybe$withDefault, '0', model.rs))), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'Please choose a currency', model.bq), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$andThen, A2($elm$core$Basics$composeR, $author$project$Types$Fraction$toFractionFromString('.'), $elm$core$Result$fromMaybe('Please provide a valid number for opening balance')), A2($elm$core$Result$fromMaybe, 'Please provide an opening balance', model.o3)), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'Please choose a division', A2($elm$core$Maybe$map, function ($) {
          return $.F;
        }, model.R)), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'Please provide an account name', model.zL), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'Please choose an account type', model.P), $elm$core$Result$Ok($author$project$Api$Types$AddAccountReq$AddAccountReq))))))));

        var message = function () {
          if (!maybeRequest.$) {
            var request = maybeRequest.a;
            return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$AddFinancialAccount, companyId, request));
          } else {
            var err = maybeRequest.a;
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
          }
        }();

        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([message]));
    }
  });
  var $author$project$Remote$RequestMsg$EditFinancialAccount = F3(function (a, b, c) {
    return {
      $: 34,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$EditFinancialAccountReq$EditFinancialAccountReq = F7(function (accountType, accountName, division, balanceMinMaxAdvice, currency, isEnabled, id) {
    return {
      oO: accountName,
      it: accountType,
      dx: balanceMinMaxAdvice,
      bq: currency,
      R: division,
      F: id,
      yO: isEnabled
    };
  });
  var $author$project$Ui$Accounts$Edit$Update$update = F2(function (model, msg) {
    switch (msg.$) {
      case 0:
        var type_ = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          P: $elm$core$Maybe$Just(type_)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var name = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          zL: $elm$core$Maybe$Just(name)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var division = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          R: $elm$core$Maybe$Just(division)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          pU: input
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          rs: $elm$core$Maybe$Just(input)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        return _Utils_Tuple3($author$project$Ui$Accounts$Edit$Model$init, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));

      default:
        var companyId = msg.a;
        var divisionId = msg.b;
        var accountId = msg.c;
        var requestResult = A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok(accountId), A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok($elm$core$Maybe$Nothing), A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok($elm$core$Maybe$Nothing), A2($elm_community$result_extra$Result$Extra$andMap, _Utils_eq(model.rs, $elm$core$Maybe$Nothing) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : A2($elm$core$Result$map, $elm$core$Maybe$Just, A2($elm$core$Result$fromMaybe, 'Please provide a valid number for target balance', A2($elm$core$Maybe$andThen, $author$project$Types$Fraction$toFractionFromString('.'), model.rs))), A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok(A2($elm$core$Maybe$withDefault, divisionId, A2($elm$core$Maybe$map, function ($) {
          return $.F;
        }, model.R))), A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok(model.zL), A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok(model.P), $elm$core$Result$Ok($author$project$Api$Types$EditFinancialAccountReq$EditFinancialAccountReq))))))));

        var message = function () {
          if (!requestResult.$) {
            var request = requestResult.a;
            return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$EditFinancialAccount, true, companyId, request));
          } else {
            var err = requestResult.a;
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
          }
        }();

        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([message]));
    }
  });
  var $author$project$Ui$Accounts$Update$update = F5(function (time, zone, _v0, model, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var text = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          j_: text
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var companyId = msg.a;
        var divisionId = msg.b;
        var accountId = msg.c;
        var todaySimpleDate = A2($author$project$Types$SimpleDate$fromPosix, zone, time);

        var oneYearAgoSimpleDate = _Utils_update(todaySimpleDate, {
          FP: todaySimpleDate.FP - 1
        });

        return _Utils_Tuple3(_Utils_update(model, {
          tv: A2($turboMaCk$any_set$Set$Any$insert, accountId, model.tv)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$GetFinancialAccountBalancesForPeriod, companyId, divisionId, A2($author$project$Api$Types$GetFinancialAccountBalancesForPeriodReq, accountId, $elm$core$Maybe$Just(oneYearAgoSimpleDate))))]));

      case 3:
        var accountId = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          tv: A2($turboMaCk$any_set$Set$Any$remove, accountId, model.tv)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var addMsg = msg.a;
        return A2($author$project$Ui$Accounts$Update$mapAddModel, model, A2($author$project$Ui$Accounts$Update$mapCmd, $author$project$Ui$Accounts$Msg$OnAddAccountMsg, A4($author$project$Ui$Accounts$Add$Update$update, time, zone, model.oS, addMsg)));

      case 5:
        var editMsg = msg.a;
        return A2($author$project$Ui$Accounts$Update$mapEditModel, model, A2($author$project$Ui$Accounts$Update$mapCmd, $author$project$Ui$Accounts$Msg$OnEditAccountMsg, A2($author$project$Ui$Accounts$Edit$Update$update, model.p_, editMsg)));

      case 6:
        var companyId = msg.a;
        var divisionId = msg.b;
        var accountId = msg.c;
        var balance = msg.d;
        return _Utils_Tuple3(_Utils_update(model, {
          pZ: $elm$core$String$fromFloat(balance.gY)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A5($author$project$Global$Model$EditAccountBalance, $elm$core$Maybe$Nothing, companyId, divisionId, accountId, balance)))]));

      case 7:
        var balance = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          qK: $elm$core$Maybe$Just(balance)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 8:
        return _Utils_Tuple3(_Utils_update(model, {
          qK: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        var string = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          pZ: string
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var record = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          oN: $elm$core$Maybe$Just(record)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });

  var $simonh1000$elm_jwt$Jwt$errorToString = function (jwtErr) {
    switch (jwtErr.$) {
      case 0:
        var err = jwtErr.a;
        return 'JWT Token Processing error: ' + err;

      case 1:
        var err = jwtErr.a;
        return 'JWT Token Decoding error: ' + $elm$json$Json$Decode$errorToString(err);

      default:
        return 'JWT Token Header is corrupted';
    }
  };

  var $author$project$Ui$Auth$Selectors$idTokenDecoder = function () {
    var toIdTokenDecoded = F4(function (_v3, username, email, sub) {
      var maybeLang = _v3.a;
      var maybeCountry = _v3.b;
      return {
        iP: email,
        rk: maybeCountry,
        rl: maybeLang,
        tN: sub,
        ug: username
      };
    });

    var localeToTuple = function (maybeLocale) {
      var _v0 = A2($elm$core$Maybe$map, $elm$core$String$split('-'), maybeLocale);

      if (!_v0.$ && _v0.a.b && _v0.a.b.b && !_v0.a.b.b.b) {
        var _v1 = _v0.a;
        var lan = _v1.a;
        var _v2 = _v1.b;
        var country = _v2.a;
        return _Utils_Tuple2($elm$core$Maybe$Just(lan), $elm$core$Maybe$Just(country));
      } else {
        return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
      }
    };

    return A5($elm$json$Json$Decode$map4, toIdTokenDecoded, A2($elm$json$Json$Decode$map, localeToTuple, $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string))), A2($elm$json$Json$Decode$field, 'cognito:username', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'sub', $elm$json$Json$Decode$string));
  }();

  var $author$project$Ui$Auth$Selectors$decodeIdToken = function (_v0) {
    var idToken = _v0;
    return A2($elm$core$Result$mapError, $simonh1000$elm_jwt$Jwt$errorToString, A2($simonh1000$elm_jwt$Jwt$decodeToken, $author$project$Ui$Auth$Selectors$idTokenDecoder, idToken));
  };

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$facebookLogin = _Platform_outgoingPort('facebookLogin', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleLogin = _Platform_outgoingPort('googleLogin', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$Ui$Auth$Auth$mapUser = F2(function (mapper, state) {
    return state;
  });
  var $author$project$Ui$Auth$Selectors$toDecodedIdTokenFromIdToken = $elm$core$Maybe$andThen(A2($elm$core$Basics$composeR, $author$project$Ui$Auth$Selectors$decodeIdToken, $elm$core$Result$toMaybe));

  var $author$project$Ui$Auth$Selectors$toIdToken = function (_v0) {
    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Ui$Auth$Selectors$toDecodedIdToken = function (state) {
    return $author$project$Ui$Auth$Selectors$toDecodedIdTokenFromIdToken($author$project$Ui$Auth$Selectors$toIdToken(state));
  };

  var $author$project$Ui$Auth$Auth$newUserAuthSessionStateHandler = F4(function (global, state, auth, isRegistration) {
    var isNewSessionForCurrentUser = function () {
      var _v0 = _Utils_Tuple2(A2($elm$core$Maybe$map, function ($) {
        return $.tN;
      }, $author$project$Ui$Auth$Selectors$toDecodedIdToken(state)), A2($elm$core$Maybe$map, function ($) {
        return $.tN;
      }, $author$project$Ui$Auth$Selectors$toDecodedIdTokenFromIdToken($elm$core$Maybe$Just(auth.d5))));

      if (_v0.a.$ === 1) {
        var _v1 = _v0.a;
        return true;
      } else {
        if (!_v0.b.$) {
          var oldSub = _v0.a.a;
          var newSub = _v0.b.a;
          return _Utils_eq(oldSub, newSub);
        } else {
          var _v2 = _v0.b;
          return false;
        }
      }
    }();

    return isNewSessionForCurrentUser ? _Utils_Tuple3(_Utils_update(state, {
      m8: '',
      m9: '',
      nA: '',
      nB: '',
      nE: '',
      nF: '',
      sU: '',
      nG: '',
      ob: '',
      oe: ''
    }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
  });

  var $author$project$Ui$Auth$Auth$sessionRefreshSuccess = _Platform_outgoingPort('sessionRefreshSuccess', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('expiresIn', $elm$json$Json$Encode$int($.hr)), _Utils_Tuple2('idToken', $elm$json$Json$Encode$string($.d5)), _Utils_Tuple2('refreshToken', $elm$json$Json$Encode$string($.e6))]));
  });

  var $author$project$Ui$Auth$Auth$setUserAndSettings = F3(function (user, settings, state) {
    return state;
  });

  var $author$project$Ui$Auth$Auth$thisUserResult = _Platform_outgoingPort('thisUserResult', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('auth', function ($) {
      return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('expiresIn', $elm$json$Json$Encode$int($.hr)), _Utils_Tuple2('idToken', $elm$json$Json$Encode$string($.d5)), _Utils_Tuple2('refreshToken', $elm$json$Json$Encode$string($.e6))]));
    }($.u_)), _Utils_Tuple2('user', function ($) {
      return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', function ($) {
        return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
      }($.iP)), _Utils_Tuple2('firstName', $elm$json$Json$Encode$string($.hu)), _Utils_Tuple2('id', $elm$json$Json$Encode$string($.F)), _Utils_Tuple2('lastName', $elm$json$Json$Encode$string($.hI)), _Utils_Tuple2('username', $elm$json$Json$Encode$string($.ug))]));
    }($.Fl))]));
  });

  var $author$project$Ui$Auth$Auth$toSavePushNotifDeviceCmd = F3(function (config, pushPermissions, state) {
    return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
  });
  var $author$project$Ui$Auth$Auth$updateSettings = F3(function (global, newSettings, state) {
    return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
  });
  var $author$project$Ui$Auth$Auth$toggleNotificationsUpdate = F5(function (global, maybeThisDeviceReceivesPush, wantsDisabledNotifications, settings, state) {
    return _Utils_eq(maybeThisDeviceReceivesPush, $elm$core$Maybe$Just(true)) ? A3($author$project$Ui$Auth$Auth$updateSettings, global, settings, state) : _Utils_Tuple2(state, $author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications(0));
  });
  var $author$project$ElmFramework$Lib$Util$unwrapResultWithHandler = F2(function (handler, result) {
    if (!result.$) {
      var res = result.a;
      return res;
    } else {
      var err = result.a;
      return handler(err);
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$appendCmdInTuple3 = F2(function (nextCmd, _v0) {
    var model = _v0.a;
    var cmd = _v0.b;
    var outMsg = _v0.c;
    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, nextCmd])), outMsg);
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList = F2(function (onFinal, _v0) {
    var nextState = _v0.a;
    var nextCmd = _v0.b;
    var nextOutMsg = _v0.c;
    return function (_v1) {
      var finalState = _v1.a;
      var finalCmd = _v1.b;
      var finalOutMsg = _v1.c;
      return _Utils_Tuple3(finalState, $elm$core$Platform$Cmd$batch(_List_fromArray([nextCmd, finalCmd])), _Utils_ap(nextOutMsg, finalOutMsg));
    }(onFinal(nextState));
  });

  var $author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopback = _Platform_outgoingPort('authErrorLoopback', function ($) {
    return $elm$json$Json$Encode$null;
  });

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds = $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopback(0)]));

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError = _Platform_outgoingPort('detailedError', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('extra', $elm$core$Basics$identity($.hs)), _Utils_Tuple2('msg', $elm$json$Json$Encode$string($.gi))]));
  });

  var $author$project$ElmFramework$Feature$Toaster$Notifier$emitNotif = _Platform_outgoingPort('emitNotif', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('bodies', $elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.eK)), _Utils_Tuple2('kind', $elm$json$Json$Encode$string($.f9)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.t1))]));
  });

  var $author$project$ElmFramework$Feature$Toaster$Notifier$info = F2(function (title, bodies) {
    return $author$project$ElmFramework$Feature$Toaster$Notifier$emitNotif({
      eK: bodies,
      f9: $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind.iW,
      t1: title
    });
  });
  var $elm$core$String$replace = F3(function (before, after, string) {
    return A2($elm$core$String$join, after, A2($elm$core$String$split, before, string));
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$graphqlErrToCmd = F2(function (shouldToast, _v0) {
    var message = _v0.zu;
    var details = _v0.wJ;
    var massagedMessage = A3($elm$core$String$replace, 'Unexpected error value: ', '', message);
    return message === 'Authentication Error' ? $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds : $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
      hs: $elm$json$Json$Encode$object($elm$core$Dict$toList(details)),
      gi: message
    }), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, massagedMessage, _List_Nil), $elm$core$Platform$Cmd$none, shouldToast)]));
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$StructuredHttpError = F3(function (status, message, errors) {
    return {
      lb: errors,
      zu: message,
      Y: status
    };
  });
  var $elm$core$Dict$map = F2(function (func, dict) {
    if (dict.$ === -2) {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    } else {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, color, key, A2(func, key, value), A2($elm$core$Dict$map, func, left), A2($elm$core$Dict$map, func, right));
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toErrorMessage = F2(function (fieldId, errMessage) {
    return fieldId + (': ' + errMessage);
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyErrorsDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$map, $elm$core$Dict$map(F2(function (fieldId, errMessage) {
    return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toErrorMessage, fieldId, errMessage);
  })), $elm$json$Json$Decode$dict($elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$map, $elm$core$Dict$map(F2(function (fieldId, fieldErrors) {
    return A2($elm$core$String$join, '\n', A2($elm$core$List$map, function (_v0) {
      var errMessage = _v0.b;
      return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toErrorMessage, fieldId, errMessage);
    }, $elm$core$Dict$toList(fieldErrors)));
  })), $elm$json$Json$Decode$dict($elm$json$Json$Decode$dict($elm$json$Json$Decode$string))), $elm$json$Json$Decode$succeed($elm$core$Dict$empty)]));
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyDecoder = A4($elm$json$Json$Decode$map3, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$StructuredHttpError, $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string), $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$field, 'errors', $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyErrorsDecoder), A2($elm$json$Json$Decode$field, 'err', $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyErrorsDecoder), $elm$json$Json$Decode$succeed($elm$core$Dict$empty)])));

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$sendStructuredHttpError = function (structuredHttpError) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
      hs: $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('errors', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, $elm$core$Dict$values(structuredHttpError.lb)))])),
      gi: structuredHttpError.zu
    });
  };

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleHttpBadStatus = F3(function (shouldToast, meta, body) {
    var _v0 = A2($author$project$ElmFramework$Lib$Util$decodeString, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyDecoder, body);

    if (!_v0.$) {
      var decodedResponse = _v0.a;
      return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$sendStructuredHttpError(decodedResponse), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, decodedResponse.zu, $elm$core$Dict$values(decodedResponse.lb)), $elm$core$Platform$Cmd$none, shouldToast)]));
    } else {
      return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
        hs: $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('body', $elm$json$Json$Encode$string(body))])),
        gi: 'unexpected http status: ' + ($elm$core$String$fromInt(meta.tG) + (' ' + meta.En))
      });
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlHttpErr = F2(function (shouldToast, httpErr) {
    switch (httpErr.$) {
      case 3:
        var meta = httpErr.a;
        var body = httpErr.b;
        return meta.tG === 401 ? $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds : A3($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleHttpBadStatus, shouldToast, meta, body);

      case 4:
        var jdErr = httpErr.a;
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: BadPayload: ' + $elm$json$Json$Decode$errorToString(jdErr)), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'Bad payload / Unexpected response', _List_fromArray([A2($elm$core$String$left, 200, $elm$json$Json$Decode$errorToString(jdErr))])), $elm$core$Platform$Cmd$none, shouldToast)]));

      case 2:
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: NetworkError'), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'NetworkError', _List_Nil), $elm$core$Platform$Cmd$none, shouldToast)]));

      case 1:
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: Timeout'), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'Request timed out', _List_fromArray(['Try again maybe?'])), $elm$core$Platform$Cmd$none, shouldToast)]));

      default:
        var string = httpErr.a;
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: BadUrl: ' + string), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'Bad URL', _List_fromArray([string])), $elm$core$Platform$Cmd$none, shouldToast)]));
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr = F2(function (shouldToast, err) {
    if (!err.$) {
      var errors = err.b;
      return $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$graphqlErrToCmd(shouldToast), errors));
    } else {
      var theErr = err.a;
      return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlHttpErr, shouldToast, theErr);
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWith = F2(function (result, config) {
    if (!result.$) {
      var value = result.a;
      return config.dS(config.e$(value));
    } else {
      var error = result.a;
      return config.dS(config.eZ(error));
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgList = F2(function (result, operations) {
    return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWith, result, {
      dS: $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList(operations.dS),
      eZ: function (error) {
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$appendCmdInTuple3, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr, true, error), operations.eZ(error));
      },
      e$: operations.e$
    });
  });

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleHttpErr = function (httpErr) {
    if (httpErr.$ === 3) {
      var code = httpErr.a;
      return code === 401 ? $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(httpErr)])) : $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(httpErr);
    } else {
      return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(httpErr);
    }
  };

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithHttpResultToOutMsgList = F2(function (result, operations) {
    return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWith, result, {
      dS: $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList(operations.dS),
      eZ: function (error) {
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$appendCmdInTuple3, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleHttpErr(error), operations.eZ(error));
      },
      e$: operations.e$
    });
  });
  var $author$project$Ui$Auth$Auth$update = F6(function (env, pushNotificationsPermissions, currRoute, global, msg, state) {
    var config = global.dy;

    switch (msg.$) {
      case 29:
        var newRoute = msg.b;

        if (!newRoute.$) {
          var authRoute = newRoute.a;

          var _v2 = function () {
            if (authRoute.$ === 3 && !authRoute.a.$) {
              return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
            } else {
              return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
            }
          }();

          var newState = _v2.a;
          var newCmd = _v2.b;
          return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries(0), newCmd])), _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 2:
        var email = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ob: email
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var password = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          oe: password
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var firstName = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nB: firstName
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var lastName = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nE: lastName
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var email = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nA: email
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        var password = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nF: password
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        return _Utils_Tuple3(_Utils_update(state, {
          jA: !state.jA
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 10:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 11:
        var theMsg = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$LegalMsg(theMsg))]));

      case 12:
        var forgotPasswordScreenState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          lt: forgotPasswordScreenState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 13:
        var maybeSession = $elm$core$Maybe$Nothing;

        if (!maybeSession.$) {
          return _Utils_Tuple3(_Utils_update(state, {
            hG: true
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Failed to identify user', _List_Nil)]));
        }

      case 14:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 20:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 15:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 16:
        var result = msg.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgList, result, {
          dS: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              hG: false
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v5) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (_v6) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }
        });

      case 8:
        var code = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nG: code
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 17:
        var code = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          m8: code
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 18:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          m9: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 19:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          su: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 21:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 22:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 23:
        var hasAcceptedTermsAndService = state.jA || _Utils_eq(currRoute, $author$project$Route$Route$Auth($author$project$Route$Route$Register($elm$core$Maybe$Just(0))));

        return hasAcceptedTermsAndService ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Auth($author$project$Route$Route$Register($elm$core$Maybe$Just(0))))]));

      case 25:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 27:
        var user = msg.a;
        return _Utils_Tuple3(A2($author$project$Ui$Auth$Auth$mapUser, $elm$core$Basics$always(user), state), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var aRoute = msg.a;

        if (!aRoute.$) {
          var authStep = aRoute.a;

          if (authStep.$ === 1) {
            return _Utils_Tuple3(_Utils_update(state, {
              lt: $author$project$Ui$Auth$Model$EnterForgotPasswordEmail('')
            }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(aRoute)]));
          } else {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(aRoute)]));
          }
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(aRoute)]));
        }

      case 0:
        var aRoute = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Do(aRoute)]));

      case 30:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, 'Sorry, not ready yet', _List_Nil)]));

      case 31:
        return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$facebookLogin(0), _List_Nil);

      case 32:
        return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleLogin(0), _List_Nil);

      case 33:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));

      case 34:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dg($author$project$Route$RouteUtil$isAuthRoute)]));

      case 24:
        var event = msg.a;

        switch (event.$) {
          case 0:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

          case 1:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

          case 2:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 26:
        var result = msg.a;

        if (!result.$) {
          var auth = result.a;
          return function (_v11) {
            var newState = _v11.a;
            var cmd = _v11.b;
            var outMsgs = _v11.c;
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, $author$project$Ui$Auth$Auth$sessionRefreshSuccess($author$project$Types$UserSession$unwrapAuth(auth))])), outMsgs);
          }(A4($author$project$Ui$Auth$Auth$newUserAuthSessionStateHandler, global, state, auth, false));
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 28:
        var auth = msg.a;
        var result = msg.b;
        var unauthState = state;

        var isUnauthenticated = function () {
          if (result.$ === 1 && result.a.$ === 1 && result.a.a.$ === 3) {
            var _v16 = result.a.a;
            var statusCode = _v16.a.tG;
            return statusCode === 401;
          } else {
            return false;
          }
        }();

        var failsToFetchSelf = false;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgList, result, {
          dS: function (nextState) {
            return _Utils_Tuple3(nextState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: $elm$core$Basics$always(_Utils_Tuple3(unauthState, $elm$core$Platform$Cmd$none, _List_Nil)),
          e$: function (_v12) {
            var user = _v12.Fl;
            var thisUserResultCmd = A2($author$project$ElmFramework$Lib$Util$unwrapResultWithHandler, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError, A2($elm$core$Result$map, $author$project$Ui$Auth$Auth$thisUserResult, A2($elm$core$Result$map, function (_v14) {
              var email = _v14.iP;
              var username = _v14.ug;
              return {
                u_: $author$project$Types$UserSession$unwrapAuth(auth),
                Fl: {
                  iP: email,
                  hu: user.hu,
                  F: $author$project$Types$User$unwrapUserId(user.F),
                  hI: user.hI,
                  ug: username
                }
              };
            }, $author$project$Ui$Auth$Selectors$decodeIdToken(auth.d5))));
            return function (_v13) {
              var newState = _v13.a;
              var cmd = _v13.b;
              return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([thisUserResultCmd, cmd])), _List_Nil);
            }(A3($author$project$Ui$Auth$Auth$toSavePushNotifDeviceCmd, config, pushNotificationsPermissions, state));
          }
        });

      case 35:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 36:
        var permissions = msg.a;
        return function (_v17) {
          var newState = _v17.a;
          var cmd = _v17.b;
          return _Utils_Tuple3(newState, cmd, _List_Nil);
        }(A3($author$project$Ui$Auth$Auth$toSavePushNotifDeviceCmd, config, permissions, state));

      case 37:
        var anyTypeOfGeolocation = msg.a;

        if (!anyTypeOfGeolocation.$) {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 41:
        var user = msg.a;
        var settings = msg.b;
        return function (newState) {
          return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
        }(A3($author$project$Ui$Auth$Auth$setUserAndSettings, user, settings, state));

      case 42:
        var settings = msg.a;
        return function (_v19) {
          var newState = _v19.a;
          var cmd = _v19.b;
          return _Utils_Tuple3(newState, cmd, _List_Nil);
        }(A3($author$project$Ui$Auth$Auth$updateSettings, global, settings, state));

      case 43:
        var result = msg.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgList, result, {
          dS: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              hG: false
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: $elm$core$Basics$always(_Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil)),
          e$: function (_v20) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }
        });

      case 44:
        var maybeThisDeviceReceivesPush = msg.a;
        var wantsDisabledNotifications = msg.b;
        var settings = msg.c;
        return function (_v21) {
          var newState = _v21.a;
          var cmd = _v21.b;
          return _Utils_Tuple3(newState, cmd, _List_Nil);
        }(A5($author$project$Ui$Auth$Auth$toggleNotificationsUpdate, global, maybeThisDeviceReceivesPush, wantsDisabledNotifications, settings, state));

      case 45:
        var maybeThisDeviceReceivesPush = msg.a;
        return _Utils_eq(maybeThisDeviceReceivesPush, $elm$core$Maybe$Just(true)) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(state, $author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications(0), _List_Nil);

      case 46:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $author$project$MulticastMessages$onUnauth);

      case 47:
        return _Utils_Tuple3($author$project$Ui$Auth$Auth$init, $elm$core$Platform$Cmd$none, _List_Nil);

      case 48:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 49:
        var result = msg.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgList, result, {
          dS: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              hG: false
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: $elm$core$Basics$always(_Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil)),
          e$: $elm$core$Basics$always(_Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $author$project$MulticastMessages$onUnauth))
        });

      case 50:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 51:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 52:
        var languageDetails = msg.a;
        var commonStaticResult = msg.b;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithHttpResultToOutMsgList, commonStaticResult, {
          dS: function (nextState) {
            return _Utils_Tuple3(nextState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: $elm$core$Basics$always(_Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil)),
          e$: function (commonStaticFile) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, languageDetails, commonStaticFile)))]));
          }
        });

      case 53:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));

      case 38:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 39:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, 'Uploading avatar failed', _List_Nil)]));

      case 40:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 55:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(0))]));

      case 54:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(1))]));

      case 56:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });

  var $author$project$Ui$Block$Msg$EditingBlockMsg = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Api$Types$CharacterizeTimeTransformReq$isDerivative = function (baseDescriptor) {
    switch (baseDescriptor.$) {
      case 0:
        return true;

      case 1:
        return false;

      case 2:
        return false;

      default:
        return false;
    }
  };

  var $author$project$Api$Types$CharacterizeTimeTransformResponse$toValueOnDateDictFromFlowElem = function (valueOnDateDict) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$SimpleDate$toDateString, A2($elm$core$List$map, function (i) {
      return _Utils_Tuple2(i.o$, i.CI);
    }, valueOnDateDict));
  };

  var $author$project$Api$Types$CharacterizeTimeTransformResponse$setBaseTimeSeries = F2(function (flowElems, characterizeTimeTransformResponse) {
    return _Utils_update(characterizeTimeTransformResponse, {
      ve: $author$project$Api$Types$CharacterizeTimeTransformResponse$toValueOnDateDictFromFlowElem(flowElems)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setBasisTransformResponse = F2(function (payload, resp) {
    return _Utils_update(payload, {
      j5: resp
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasisTransformResponse = F2(function (payload, resp) {
    return _Utils_update(payload, {
      iy: resp
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload = F2(function (block, val) {
    return _Utils_update(block, {
      d2: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload = F2(function (block, val) {
    return _Utils_update(block, {
      cU: val
    });
  });
  var $author$project$Api$Types$BaseFlowReq$BaseFlowReq = F3(function (moneyOrThingBlock, baseDescriptor, startOn) {
    return {
      o8: baseDescriptor,
      rv: moneyOrThingBlock,
      bw: startOn
    };
  });

  var $author$project$Api$Types$CharacterizeTimeTransformReq$BasePattern = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$Types$CharacterizeTimeTransformReq$DerivativeBlock = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$Types$GrowthPatternDescriptorInput$fromGrowthPattern = function (growthPattern) {
    return {
      ao: growthPattern.ao,
      ap: growthPattern.ap,
      bR: $JoshuaHall$elm_fraction$Fraction$toFloat(growthPattern.bR),
      bw: growthPattern.bw
    };
  };

  var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
    if (!maybeValue.$) {
      var value = maybeValue.a;
      return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
    } else {
      return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
    }
  };

  var $author$project$Api$Types$RepeatPatternDescriptorInput$fromRepeatPattern = function (repeatPattern) {
    var endAt = function () {
      var _v0 = repeatPattern.hn;

      if (!_v0.$) {
        var _int = _v0.a;
        return {
          k: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_int),
          iL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };
      } else {
        var simpleDate = _v0.a;
        return {
          k: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          iL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(simpleDate)
        };
      }
    }();

    return {
      hn: endAt,
      ao: repeatPattern.ao,
      ap: repeatPattern.ap
    };
  };

  var $author$project$Api$Types$CreateBlockReq$toBasicDescriptor = function (payload) {
    var toSeasonality = function (req) {
      if (!req.$) {
        var id = req.a;
        return {
          pT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(id)
        };
      } else {
        var monthAdjustments = req.a;
        return {
          pT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            dW: monthAdjustments,
            dH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          }),
          F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };
      }
    };

    return {
      g5: payload.g5,
      fZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$Types$GrowthPatternDescriptorInput$fromGrowthPattern, payload.fZ)),
      h2: $author$project$Api$Types$RepeatPatternDescriptorInput$fromRepeatPattern(payload.h2),
      bK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, toSeasonality, payload.bK))
    };
  };

  var $author$project$Api$Types$CreateBlockReq$BasicPayloadReq = F4(function (baseValue, seasonality, growthPattern, repeatPattern) {
    return {
      g5: baseValue,
      fZ: growthPattern,
      h2: repeatPattern,
      bK: seasonality
    };
  });

  var $author$project$Api$Types$SeasonalityInBlockReq$ExistingSeasonality = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$Types$SeasonalityInBlockReq$NewSeasonality = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$core$Result$map4 = F5(function (func, ra, rb, rc, rd) {
    if (ra.$ === 1) {
      var x = ra.a;
      return $elm$core$Result$Err(x);
    } else {
      var a = ra.a;

      if (rb.$ === 1) {
        var x = rb.a;
        return $elm$core$Result$Err(x);
      } else {
        var b = rb.a;

        if (rc.$ === 1) {
          var x = rc.a;
          return $elm$core$Result$Err(x);
        } else {
          var c = rc.a;

          if (rd.$ === 1) {
            var x = rd.a;
            return $elm$core$Result$Err(x);
          } else {
            var d = rd.a;
            return $elm$core$Result$Ok(A4(func, a, b, c, d));
          }
        }
      }
    }
  });
  var $author$project$ElmFramework$Lib$ViewModelStringTo$cantRecognize = F3(function (name, err, currVal) {
    var extraInfo = $elm$core$String$isEmpty(err) ? '' : '. ' + err;
    return 'Sorry, can\'t recognize \'' + (currVal + ('\' for \'' + (name + ('\'' + extraInfo))));
  });

  var $author$project$ElmFramework$Lib$ViewModelStringTo$parse = function (_v0) {
    var value = _v0.Fw;
    var parser = _v0.st;
    var name = _v0.zL;

    if (value === '') {
      return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
    } else {
      var content = value;

      var _v2 = parser(content);

      if (!_v2.$) {
        var parsed = _v2.a;
        return $elm$core$Result$Ok($elm$core$Maybe$Just(parsed));
      } else {
        var err = _v2.a;
        var extraInfo = $elm$core$String$isEmpty(err) ? '' : '. ' + err;
        return $elm$core$Result$Err(A3($author$project$ElmFramework$Lib$ViewModelStringTo$cantRecognize, name, extraInfo, value));
      }
    }
  };

  var $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty = function (_v0) {
    var value = _v0.Fw;
    var parser = _v0.st;
    var name = _v0.zL;

    if (value === '') {
      return $elm$core$Result$Err('Please provide ' + name);
    } else {
      var content = value;

      var _v2 = parser(content);

      if (!_v2.$) {
        var parsed = _v2.a;
        return $elm$core$Result$Ok(parsed);
      } else {
        var err = _v2.a;
        return $elm$core$Result$Err(A3($author$project$ElmFramework$Lib$ViewModelStringTo$cantRecognize, name, err, value));
      }
    }
  };

  var $elm_community$maybe_extra$Maybe$Extra$combine = A2($elm$core$List$foldr, $elm$core$Maybe$map2($elm$core$List$cons), $elm$core$Maybe$Just(_List_Nil));

  var $author$project$Types$MonthAdjustments$toList = function (monthAdjustments) {
    return $elm_community$maybe_extra$Maybe$Extra$combine(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty, $elm$core$Result$toMaybe), $elm$core$Array$toList(monthAdjustments)));
  };

  var $author$project$Types$RepeatPattern$Count = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$RepeatPattern$Date = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$core$Result$map3 = F4(function (func, ra, rb, rc) {
    if (ra.$ === 1) {
      var x = ra.a;
      return $elm$core$Result$Err(x);
    } else {
      var a = ra.a;

      if (rb.$ === 1) {
        var x = rb.a;
        return $elm$core$Result$Err(x);
      } else {
        var b = rb.a;

        if (rc.$ === 1) {
          var x = rc.a;
          return $elm$core$Result$Err(x);
        } else {
          var c = rc.a;
          return $elm$core$Result$Ok(A3(func, a, b, c));
        }
      }
    }
  });
  var $elm_community$result_extra$Result$Extra$or = F2(function (ra, rb) {
    if (ra.$ === 1) {
      return rb;
    } else {
      return ra;
    }
  });
  var $author$project$Ui$DateInput$DateInput$toSimpleDate = F2(function (zone, state) {
    return A2($elm$core$Maybe$map, $author$project$Types$SimpleDate$fromPosix(zone), state.Fw);
  });

  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$toRepeatPattern = function (editingBasicPayload) {
    var periodResult = A2($elm$core$Result$fromMaybe, 'Please provide a period for the repeat pattern', editingBasicPayload.h2.ap.ia);
    var everyResult = A2($elm$core$Result$mapError, $elm$core$Basics$always('Please provide a value for \'Every\' in the repeat pattern'), $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(editingBasicPayload.h2.ao));

    var endAtResult = function () {
      var fromDate = A2($elm$core$Result$map, $author$project$Types$RepeatPattern$Date, A2($elm$core$Result$fromMaybe, 'Please provide an ending date for the repeat pattern', A2($elm$core$Maybe$andThen, $author$project$Ui$DateInput$DateInput$toSimpleDate($elm$time$Time$utc), editingBasicPayload.h2.hn.iL)));
      var fromCount = A2($elm$core$Result$map, $author$project$Types$RepeatPattern$Count, A2($elm$core$Result$fromMaybe, 'Please provide an ending count for the repeat pattern', A2($elm$core$Maybe$andThen, $elm$core$String$toInt, editingBasicPayload.h2.hn.k)));
      return A2($elm_community$result_extra$Result$Extra$or, fromCount, fromDate);
    }();

    return A4($elm$core$Result$map3, F3(function (every, period, endAt) {
      return {
        hn: endAt,
        ao: every,
        ap: period
      };
    }), everyResult, periodResult, endAtResult);
  };

  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq = F2(function (company, editingBasicPayload) {
    var seasonalityResult = function () {
      var getPayloadValues = function (_v14) {
        return $author$project$Types$MonthAdjustments$toList(editingBasicPayload.bK.dW);
      };

      var _v9 = editingBasicPayload.bK.sH.ia;

      if (!_v9.$) {
        var seasonalityId = _v9.a;
        var maybeSeasonalityPreset = A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(seasonalityId), $krisajenkins$remotedata$RemoteData$toMaybe(company.ti));

        if (!maybeSeasonalityPreset.$) {
          var seasonalityPreset = maybeSeasonalityPreset.a;

          var getPresetValues = function (_v12) {
            return $elm$core$Array$toList(seasonalityPreset.dW);
          };

          var _v11 = getPayloadValues(0);

          if (!_v11.$) {
            var payloadValues = _v11.a;
            return _Utils_eq(getPresetValues(0), payloadValues) ? $elm$core$Result$Ok($elm$core$Maybe$Just($author$project$Api$Types$SeasonalityInBlockReq$ExistingSeasonality(seasonalityId))) : $elm$core$Result$Err('Save seasonality pre-set changes or revert to original pre-set values');
          } else {
            return $elm$core$Result$Err('One or more seasonality values is invalid');
          }
        } else {
          return $elm$core$Result$Err('Selected seasonality cannot be found');
        }
      } else {
        var _v13 = getPayloadValues(0);

        if (!_v13.$) {
          var payloadValues = _v13.a;
          return $elm$core$Result$Ok($elm$core$Maybe$Just($author$project$Api$Types$SeasonalityInBlockReq$NewSeasonality(payloadValues)));
        } else {
          return $elm$core$Result$Err('One or more seasonality values is invalid');
        }
      }
    }();

    var growthPatternResult = function () {
      var _v0 = _Utils_Tuple3($author$project$ElmFramework$Lib$ViewModelStringTo$parse(editingBasicPayload.fZ.ao), $author$project$ElmFramework$Lib$ViewModelStringTo$parse(editingBasicPayload.fZ.bR), editingBasicPayload.fZ.bw.Fw);

      _v0$3: while (true) {
        if (_v0.a.$ === 1) {
          var err = _v0.a.a;
          return $elm$core$Result$Err(err);
        } else {
          if (_v0.a.a.$ === 1) {
            if (_v0.b.$ === 1) {
              break _v0$3;
            } else {
              if (!_v0.b.a.$) {
                var _v5 = _v0.a.a;
                return $elm$core$Result$Err('Please provide a value for \'Every\' in the growth pattern');
              } else {
                if (_v0.c.$ === 1) {
                  var _v1 = _v0.a.a;
                  var _v2 = _v0.b.a;
                  var _v3 = _v0.c;
                  return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
                } else {
                  var _v6 = _v0.a.a;
                  var _v7 = _v0.b.a;
                  return $elm$core$Result$Err('Please provide a value for \'Every\' in the growth pattern');
                }
              }
            }
          } else {
            if (_v0.b.$ === 1) {
              break _v0$3;
            } else {
              if (!_v0.b.a.$) {
                if (!_v0.c.$) {
                  var every = _v0.a.a.a;
                  var rate = _v0.b.a.a;
                  var startOn = _v0.c.a;
                  return $elm$core$Result$Ok($elm$core$Maybe$Just({
                    ao: every,
                    ap: editingBasicPayload.fZ.ap,
                    bR: rate,
                    bw: A2($author$project$Types$SimpleDate$fromPosix, $elm$time$Time$utc, startOn)
                  }));
                } else {
                  var _v8 = _v0.c;
                  return $elm$core$Result$Err('Please provide a starting date for the growth pattern');
                }
              } else {
                var _v4 = _v0.b.a;
                return $elm$core$Result$Err('Please provide a value for the growth pattern rate');
              }
            }
          }
        }
      }

      var err = _v0.b.a;
      return $elm$core$Result$Err(err);
    }();

    var baseValueResult = $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(editingBasicPayload.g5);
    return A5($elm$core$Result$map4, $author$project$Api$Types$CreateBlockReq$BasicPayloadReq, baseValueResult, seasonalityResult, growthPatternResult, $author$project$Types$EditingBuildingBlock$EditingBasicPayload$toRepeatPattern(editingBasicPayload));
  });

  var $author$project$Api$Types$BackendFraction$encodeBackendFraction = function (_v0) {
    var numerator = _v0.s;
    var denominator = _v0.q;
    return A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('numerator', $elm$json$Json$Encode$int(numerator)), _Utils_Tuple2('denominator', $elm$json$Json$Encode$int(denominator))])));
  };

  var $JoshuaHall$elm_fraction$Fraction$getDenominator = function (_v0) {
    var denominator = _v0.b;
    return denominator;
  };

  var $JoshuaHall$elm_fraction$Fraction$getNumerator = function (_v0) {
    var numerator = _v0.a;
    return numerator;
  };

  var $author$project$Api$Types$BackendFraction$fromFraction = function (fraction) {
    return {
      q: $JoshuaHall$elm_fraction$Fraction$getDenominator(fraction),
      s: $JoshuaHall$elm_fraction$Fraction$getNumerator(fraction)
    };
  };

  var $author$project$Api$Types$TimeTransformationReq$toTimeTransformInput = function (req) {
    var toAllocation = function (allocation) {
      var theAllocation = function () {
        var _v1 = allocation.qU;

        if (!_v1.$) {
          var fraction = _v1.a;
          return {
            p: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(fraction),
            fw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            fY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          };
        } else {
          var fraction = _v1.a;
          return {
            p: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            fw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            fY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$BackendFraction$fromFraction(fraction))
          };
        }
      }();

      var enteredAs = function () {
        var toEnteredAs = function (fraction) {
          return $author$project$Api$Types$BackendFraction$encodeBackendFraction($author$project$Api$Types$BackendFraction$fromFraction(fraction));
        };

        var _v0 = allocation.qU;

        if (!_v0.$) {
          var fraction = _v0.a;
          return toEnteredAs(fraction);
        } else {
          var fraction = _v0.a;
          return toEnteredAs(fraction);
        }
      }();

      return {
        g$: theAllocation,
        hp: enteredAs,
        hS: allocation.iL
      };
    };

    return {
      dw: A2($elm$core$List$map, toAllocation, req.t_),
      h1: req.sT,
      gD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    };
  };

  var $author$project$Api$Types$CreateBlockReq$toDerivativeDescriptor = F2(function (includeTimeTransformInput, payload) {
    var timeTransform = includeTimeTransformInput ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$Types$TimeTransformationReq$toTimeTransformInput, payload.gM)) : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;

    var derivativeOf = function () {
      var _v0 = payload.hk;

      if (!_v0.$) {
        var buildingBlockId = _v0.a;
        return {
          fA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          fC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$BuildingBlock$unwrapBuildingBlockId(buildingBlockId))
        };
      } else {
        var allocationClassId = _v0.a;
        return {
          fA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$AllocationClass$unwrapAllocationClassId(allocationClassId)),
          fC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };
      }
    }();

    return {
      hk: derivativeOf,
      ho: payload.ho,
      r: payload.r,
      t: payload.t,
      gM: timeTransform
    };
  });

  var $author$project$Ui$DerivativeBlockNestedSelect$toSelection = function ($) {
    return $.ia;
  };

  var $author$project$Types$SimpleDate$toMillis = A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$toPosix($elm$time$Time$utc), $elm$time$Time$posixToMillis);
  var $author$project$Types$SimpleDate$isLaterOrEqualWith = F2(function (date1, date2) {
    return _Utils_cmp($author$project$Types$SimpleDate$toMillis(date2), $author$project$Types$SimpleDate$toMillis(date1)) > -1;
  });

  var $author$project$Ui$TimeTransformation$Model$toTimeTransformReq = function (state) {
    var allocations = A2($elm$core$List$map, function (_v2) {
      var date = _v2.a;
      var val = _v2.b;
      return {
        iL: date,
        qU: val
      };
    }, $turboMaCk$any_dict$Dict$Any$toList(state.yx));

    var toReq = function (_v1) {
      var startDate = _v1.Eg;
      var endDate = _v1.xv;
      return $elm$core$List$isEmpty(allocations) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just({
        sT: {
          xw: endDate,
          Ef: startDate
        },
        t_: allocations
      });
    };

    var _v0 = state.DS;

    switch (_v0.$) {
      case 4:
        var selectionInterval = _v0.a;
        return toReq(selectionInterval);

      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        var existingSelection = _v0.a.qe;
        return A2($elm$core$Maybe$andThen, toReq, existingSelection);

      case 2:
        var existingSelection = _v0.a.qe;
        return A2($elm$core$Maybe$andThen, toReq, existingSelection);

      default:
        var selectionStart = _v0.a.DR;
        var currentValue = _v0.a.wu;
        return A2($author$project$Types$SimpleDate$isLaterOrEqualWith, selectionStart, currentValue) ? toReq({
          xv: currentValue,
          Eg: selectionStart
        }) : toReq({
          xv: selectionStart,
          Eg: currentValue
        });
    }
  };

  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq = function (edp) {
    return A5($elm$core$Result$map4, F4(function (endOn, multiplier, per, derivativeOf) {
      return {
        hk: derivativeOf,
        ho: endOn,
        r: multiplier,
        t: per,
        gM: $author$project$Ui$TimeTransformation$Model$toTimeTransformReq(edp.gM)
      };
    }), A2($elm$core$Result$fromMaybe, 'Please provide ending date', A2($author$project$Ui$DateInput$DateInput$toSimpleDate, $elm$time$Time$utc, edp.ho)), $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(edp.r), A2($elm$core$Result$andThen, function (_float) {
      return _float <= 0 ? $elm$core$Result$Err('The \"Per\" base unit must be a value higher than 0') : $elm$core$Result$Ok(_float);
    }, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(edp.t)), A2($elm$core$Result$fromMaybe, 'Please provide the derivative block or allocation class', $author$project$Ui$DerivativeBlockNestedSelect$toSelection(edp.hk)));
  };

  var $author$project$Ui$Block$Model$toBaseFlowDescriptor = F2(function (company, block) {
    var _v0 = block.g7;

    if (!_v0.$) {
      if (!_v0.a) {
        var _v1 = _v0.a;
        return A2($elm$core$Maybe$map, $author$project$Api$Types$CharacterizeTimeTransformReq$BasePattern, A2($elm$core$Maybe$map, $author$project$Api$Types$CreateBlockReq$toBasicDescriptor, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, company, block.fD))));
      } else {
        var _v2 = _v0.a;
        return A2($elm$core$Maybe$map, $author$project$Api$Types$CharacterizeTimeTransformReq$DerivativeBlock, A2($elm$core$Maybe$map, $author$project$Api$Types$CreateBlockReq$toDerivativeDescriptor(false), $elm$core$Result$toMaybe($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq(block.d2))));
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Api$GraphqlSchema$Enum$Block_of_enum$Money = 0;
  var $author$project$Api$GraphqlSchema$Enum$Block_of_enum$Thing = 1;

  var $author$project$Types$MoneyOrThing$toBlockOfEnum = function (moneyOrThing) {
    if (!moneyOrThing.$) {
      return 0;
    } else {
      return 1;
    }
  };

  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn = F2(function (zone, editingBuildingBlock) {
    return A2($author$project$Ui$DateInput$DateInput$toSimpleDate, zone, editingBuildingBlock.bw);
  });
  var $author$project$Ui$Block$Model$toBaseFlowReq = F2(function (company, state) {
    return A4($elm$core$Maybe$map3, $author$project$Api$Types$BaseFlowReq$BaseFlowReq, $elm$core$Maybe$Just($author$project$Types$MoneyOrThing$toBlockOfEnum(state.bv.hO)), A2($author$project$Ui$Block$Model$toBaseFlowDescriptor, company, state.bv), A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, $elm$time$Time$utc, state.bv));
  });
  var $author$project$Api$Types$CharacterizeTimeTransformReq$CharacterizeTimeTransformReq = F4(function (moneyOrThingBlock, inputFlowDescriptor, startOn, timeTransform) {
    return {
      qT: inputFlowDescriptor,
      rv: moneyOrThingBlock,
      bw: startOn,
      gM: timeTransform
    };
  });
  var $author$project$Ui$Block$Model$toBasicMoneyCharacterizeReq = F2(function (company, state) {
    var toBasicBlockDescriptor = function (block) {
      var _v0 = block.g7;

      if (!_v0.$ && !_v0.a) {
        var _v1 = _v0.a;
        return A2($elm$core$Maybe$map, $author$project$Api$Types$CharacterizeTimeTransformReq$BasePattern, A2($elm$core$Maybe$map, $author$project$Api$Types$CreateBlockReq$toBasicDescriptor, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, company, block.fD))));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    };

    return A5($elm$core$Maybe$map4, $author$project$Api$Types$CharacterizeTimeTransformReq$CharacterizeTimeTransformReq, $elm$core$Maybe$Just($author$project$Types$MoneyOrThing$toBlockOfEnum(state.bv.hO)), toBasicBlockDescriptor(state.bv), A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, $elm$time$Time$utc, state.bv), $author$project$Ui$TimeTransformation$Model$toTimeTransformReq(state.bv.cU.fE));
  });
  var $author$project$Api$GraphqlSchema$InputObject$DerivativeBlockDescriptorInput = F5(function (derivativeOf, endOn, multiplier, per, timeTransform) {
    return {
      hk: derivativeOf,
      ho: endOn,
      r: multiplier,
      t: per,
      gM: timeTransform
    };
  });
  var $elm$core$Maybe$map5 = F6(function (func, ma, mb, mc, md, me) {
    if (ma.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var a = ma.a;

      if (mb.$ === 1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var b = mb.a;

        if (mc.$ === 1) {
          return $elm$core$Maybe$Nothing;
        } else {
          var c = mc.a;

          if (md.$ === 1) {
            return $elm$core$Maybe$Nothing;
          } else {
            var d = md.a;

            if (me.$ === 1) {
              return $elm$core$Maybe$Nothing;
            } else {
              var e = me.a;
              return $elm$core$Maybe$Just(A5(func, a, b, c, d, e));
            }
          }
        }
      }
    }
  });

  var $author$project$Ui$Block$Model$toDerivativeCharacterizeReq = function (state) {
    var toDerivativeDescriptor = function (block) {
      var maybeDerivativeOf = function () {
        var _v0 = block.g7;

        if (!_v0.$ && _v0.a === 1) {
          var _v1 = _v0.a;

          var _v2 = $author$project$Ui$DerivativeBlockNestedSelect$toSelection(block.d2.hk);

          if (!_v2.$) {
            if (!_v2.a.$) {
              var blockId = _v2.a.a;
              return $elm$core$Maybe$Just({
                fA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
                fC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId))
              });
            } else {
              var classId = _v2.a.a;
              return $elm$core$Maybe$Just({
                fA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$AllocationClass$unwrapAllocationClassId(classId)),
                fC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
              });
            }
          } else {
            return $elm$core$Maybe$Nothing;
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }();

      return A2($elm$core$Maybe$map, $author$project$Api$Types$CharacterizeTimeTransformReq$DerivativeBlock, A6($elm$core$Maybe$map5, $author$project$Api$GraphqlSchema$InputObject$DerivativeBlockDescriptorInput, maybeDerivativeOf, A2($author$project$Ui$DateInput$DateInput$toSimpleDate, $elm$time$Time$utc, block.d2.ho), $elm$core$Result$toMaybe($author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(block.d2.r)), A2($elm$core$Maybe$andThen, function (_float) {
        return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(_float), _float <= 0);
      }, $elm$core$Result$toMaybe($author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(block.d2.t))), $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent)));
    };

    return A5($elm$core$Maybe$map4, $author$project$Api$Types$CharacterizeTimeTransformReq$CharacterizeTimeTransformReq, $elm$core$Maybe$Just($author$project$Types$MoneyOrThing$toBlockOfEnum(state.bv.hO)), toDerivativeDescriptor(state.bv), A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, $elm$time$Time$utc, state.bv), $author$project$Ui$TimeTransformation$Model$toTimeTransformReq(state.bv.d2.gM));
  };

  var $author$project$Api$Types$CharacterizeTimeTransformReq$TimeTransform = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Block$Model$toDerivativeMoneyCharacterizeReq = function (state) {
    var toDerivativeDescriptor = A2($elm$core$Maybe$map, $author$project$Api$Types$CharacterizeTimeTransformReq$TimeTransform, $author$project$Ui$Block$Model$toDerivativeCharacterizeReq(state));
    return A5($elm$core$Maybe$map4, $author$project$Api$Types$CharacterizeTimeTransformReq$CharacterizeTimeTransformReq, $elm$core$Maybe$Just($author$project$Types$MoneyOrThing$toBlockOfEnum(state.bv.hO)), toDerivativeDescriptor, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, $elm$time$Time$utc, state.bv), $author$project$Ui$TimeTransformation$Model$toTimeTransformReq(state.bv.cU.fE));
  };

  var $author$project$Types$EditingBuildingBlock$Msg$DerivativeTimeTransformMsg = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$EditingBuildingBlock$Msg$MoneyBasisTransformMsg = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasisTransform = F2(function (editingMoneyPayload, val) {
    return _Utils_update(editingMoneyPayload, {
      fE: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setTimeTransform = F2(function (payload, val) {
    return _Utils_update(payload, {
      gM: val
    });
  });

  var $author$project$Ui$TimeTransformation$Msg$InputGraphMsg = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$Msg$SelectionGraphMsg = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$TimeTransformationBackend$CurrencyValue = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$InputStatus$HoveringItem = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$InputStatus$IdleWithSelection = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$InputStatus$MovedDate = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$TimeTransformation$InputGraph$InputStatus$PressedDate = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$TimeTransformationBackend$Ratio = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $lynn$elm_arithmetic$Arithmetic$gcd = F2(function (a, b) {
    var gcd_ = F2(function (x, y) {
      gcd_: while (true) {
        if (!y) {
          return x;
        } else {
          var $temp$x = y,
              $temp$y = A2($elm$core$Basics$modBy, y, x);
          x = $temp$x;
          y = $temp$y;
          continue gcd_;
        }
      }
    });
    return A2(gcd_, $elm$core$Basics$abs(a), $elm$core$Basics$abs(b));
  });
  var $lynn$elm_arithmetic$Arithmetic$lcm = F2(function (a, b) {
    return $elm$core$Basics$abs((a / A2($lynn$elm_arithmetic$Arithmetic$gcd, a, b) | 0) * b);
  });
  var $JoshuaHall$elm_fraction$Fraction$convertToSameDenominator = F2(function (fraction1, fraction2) {
    var denominator2 = $JoshuaHall$elm_fraction$Fraction$getDenominator(fraction2);
    var denominator1 = $JoshuaHall$elm_fraction$Fraction$getDenominator(fraction1);

    if (_Utils_eq(denominator1, denominator2)) {
      return _Utils_Tuple2(fraction1, fraction2);
    } else {
      var denominatorLcm = A2($lynn$elm_arithmetic$Arithmetic$lcm, denominator1, denominator2);
      return _Utils_Tuple2(A2($JoshuaHall$elm_fraction$Fraction$Fraction, $JoshuaHall$elm_fraction$Fraction$getNumerator(fraction1) * (denominatorLcm / denominator1 | 0), denominatorLcm), A2($JoshuaHall$elm_fraction$Fraction$Fraction, $JoshuaHall$elm_fraction$Fraction$getNumerator(fraction2) * (denominatorLcm / denominator2 | 0), denominatorLcm));
    }
  });
  var $JoshuaHall$elm_fraction$Fraction$equal = F2(function (fraction1, fraction2) {
    var _v0 = A2($JoshuaHall$elm_fraction$Fraction$convertToSameDenominator, fraction1, fraction2);

    var _v1 = _v0.a;
    var numerator1 = _v1.a;
    var _v2 = _v0.b;
    var numerator2 = _v2.a;
    return _Utils_eq(numerator1, numerator2);
  });
  var $JoshuaHall$elm_fraction$Fraction$add = F2(function (fraction1, fraction2) {
    var _v0 = A2($JoshuaHall$elm_fraction$Fraction$convertToSameDenominator, fraction1, fraction2);

    var _v1 = _v0.a;
    var numerator1 = _v1.a;
    var denominator1 = _v1.b;
    var _v2 = _v0.b;
    var numerator2 = _v2.a;
    return A2($JoshuaHall$elm_fraction$Fraction$Fraction, numerator1 + numerator2, denominator1);
  });
  var $author$project$Types$SimpleDate$isWithinInterval = F3(function (from, to, candidate) {
    var millis = $author$project$Types$SimpleDate$toMillis(candidate);
    return _Utils_cmp($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, from)), millis) < 1 && _Utils_cmp(millis, $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, to))) < 1;
  });

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$toSelectedInterval = function (status) {
    switch (status.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        var existingSelection = status.a.qe;
        return existingSelection;

      case 2:
        var existingSelection = status.a.qe;
        return existingSelection;

      case 3:
        var selectionStart = status.a.DR;
        var currentValue = status.a.wu;
        var selectionStartMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selectionStart));
        var currentMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, currentValue));
        return $elm$core$Maybe$Just(_Utils_cmp(selectionStartMillis, currentMillis) > 0 ? {
          xv: selectionStart,
          Eg: currentValue
        } : {
          xv: currentValue,
          Eg: selectionStart
        });

      default:
        var selectedInterval = status.a;
        return $elm$core$Maybe$Just(selectedInterval);
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$getSumOfValuesInSelectedInterval = F2(function (state, values) {
    return A2($elm$core$Maybe$map, function (_v0) {
      var startDate = _v0.Eg;
      var endDate = _v0.xv;
      return A3($elm$core$List$foldl, A2($elm$core$Basics$composeL, $JoshuaHall$elm_fraction$Fraction$add, $elm$core$Tuple$second), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), A2($elm$core$List$filter, A2($elm$core$Basics$composeL, A2($author$project$Types$SimpleDate$isWithinInterval, startDate, endDate), $elm$core$Tuple$first), $turboMaCk$any_dict$Dict$Any$toList(values)));
    }, $author$project$Ui$TimeTransformation$SelectionGraph$Util$toSelectedInterval(state.DS));
  });
  var $JoshuaHall$elm_fraction$Fraction$multiply = F2(function (_v0, _v1) {
    var numerator1 = _v0.a;
    var denominator1 = _v0.b;
    var numerator2 = _v1.a;
    var denominator2 = _v1.b;
    return A2($JoshuaHall$elm_fraction$Fraction$Fraction, numerator1 * numerator2, denominator1 * denominator2);
  });
  var $author$project$Ui$TimeTransformation$InputGraph$Util$getValueSumOfInputValues = F2(function (sumOfValues, state) {
    return A3($elm$core$List$foldl, F2(function (_v0, acc) {
      var inputValue = _v0.b;

      if (!inputValue.$) {
        var value = inputValue.a;
        return A2($JoshuaHall$elm_fraction$Fraction$add, acc, value);
      } else {
        var ratio = inputValue.a;
        return A2($JoshuaHall$elm_fraction$Fraction$add, acc, A2($JoshuaHall$elm_fraction$Fraction$multiply, ratio, sumOfValues));
      }
    }), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), $turboMaCk$any_dict$Dict$Any$toList(state.yx));
  });
  var $author$project$Types$Fraction$gt = F2(function (fraction1, fraction2) {
    var _v0 = A3($elm$core$Tuple$mapBoth, $JoshuaHall$elm_fraction$Fraction$getNumerator, $JoshuaHall$elm_fraction$Fraction$getNumerator, A2($JoshuaHall$elm_fraction$Fraction$convertToSameDenominator, fraction1, fraction2));

    var numerator1 = _v0.a;
    var numerator2 = _v0.b;
    return _Utils_cmp(numerator1, numerator2) > 0;
  });
  var $author$project$Types$Fraction$max = F2(function (fraction1, fraction2) {
    return A2($author$project$Types$Fraction$gt, fraction1, fraction2) ? fraction1 : fraction2;
  });

  var $author$project$ElmFramework$Lib$Dom$DomPorts$select = _Platform_outgoingPort('select', $elm$json$Json$Encode$string);

  var $JoshuaHall$elm_fraction$Fraction$subtract = F2(function (fraction1, fraction2) {
    var _v0 = A2($JoshuaHall$elm_fraction$Fraction$convertToSameDenominator, fraction1, fraction2);

    var _v1 = _v0.a;
    var numerator1 = _v1.a;
    var denominator1 = _v1.b;
    var _v2 = _v0.b;
    var numerator2 = _v2.a;
    return A2($JoshuaHall$elm_fraction$Fraction$Fraction, numerator1 - numerator2, denominator1);
  });
  var $author$project$Ui$TimeTransformation$InputGraph$InputGraph$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        var simpleDate = msg.a;
        var _v1 = state.yv;

        switch (_v1.$) {
          case 0:
            return _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$PressedDate(simpleDate)
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            return _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$PressedDate(simpleDate)
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            return _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$PressedDate(simpleDate)
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 1:
        var simpleDate = msg.a;
        var _v2 = state.yv;

        switch (_v2.$) {
          case 0:
            return _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$HoveringItem({
                hC: simpleDate,
                DO: $elm$core$Maybe$Nothing
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            var selectedDate = _v2.a.DO;
            return _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$HoveringItem({
                hC: simpleDate,
                DO: selectedDate
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            var previousDate = _v2.a;
            var maybeInputValue = A2($turboMaCk$any_dict$Dict$Any$get, previousDate, state.yx);

            var _v3 = function () {
              if (!maybeInputValue.$) {
                var inputValue = maybeInputValue.a;
                return _Utils_Tuple2(A2($author$project$Ui$TimeTransformation$InputGraph$InputStatus$MovedDate, simpleDate, $elm$core$Maybe$Just(inputValue)), A2($turboMaCk$any_dict$Dict$Any$remove, previousDate, state.yx));
              } else {
                return _Utils_Tuple2($author$project$Ui$TimeTransformation$InputGraph$InputStatus$HoveringItem({
                  hC: simpleDate,
                  DO: $elm$core$Maybe$Nothing
                }), state.yx);
              }
            }();

            var inputStatus = _v3.a;
            var updatedInputValues = _v3.b;
            return _Utils_Tuple3(_Utils_update(state, {
              yv: inputStatus,
              yx: updatedInputValues
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            var maybeValue = _v2.b;
            return _Utils_Tuple3(_Utils_update(state, {
              yv: A2($author$project$Ui$TimeTransformation$InputGraph$InputStatus$MovedDate, simpleDate, maybeValue)
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            var selectedDate = _v2.a;
            return _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$HoveringItem({
                hC: simpleDate,
                DO: $elm$core$Maybe$Just(selectedDate)
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 4:
        var valuesDict = msg.a;
        var _v5 = state.yv;

        switch (_v5.$) {
          case 0:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            var selectedDate = _v5.a;

            var _v6 = function () {
              var _v7 = A2($turboMaCk$any_dict$Dict$Any$get, selectedDate, state.yx);

              if (!_v7.$) {
                if (!_v7.a.$) {
                  var value = _v7.a.a;
                  return _Utils_Tuple2($author$project$Ui$TimeTransformation$Util$toStringFromFraction(value), 'input-graph-value-input');
                } else {
                  var ratio = _v7.a.a;
                  return _Utils_Tuple2($author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString($author$project$Ui$TimeTransformation$Util$toStringFromFraction(A2($JoshuaHall$elm_fraction$Fraction$multiply, ratio, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 100, 1)))), 'input-graph-percent-input');
                }
              } else {
                return _Utils_Tuple2('', 'input-graph-value-input');
              }
            }();

            var defaultInputString = _v6.a;
            var inputId = _v6.b;

            var _v8 = _Utils_Tuple3(_Utils_update(state, {
              yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$IdleWithSelection(selectedDate),
              iY: defaultInputString
            }), $author$project$ElmFramework$Lib$Dom$DomPorts$select(inputId), $elm$core$Maybe$Nothing);

            var defaultModel = _v8.a;
            var defaultCmd = _v8.b;
            var defaultOutMsg = _v8.c;

            if ($elm$core$String$isEmpty(defaultInputString)) {
              var _v9 = A2($author$project$Ui$TimeTransformation$InputGraph$Util$getSumOfValuesInSelectedInterval, state, valuesDict);

              if (!_v9.$) {
                var sumOfValues = _v9.a;

                if (A2($JoshuaHall$elm_fraction$Fraction$equal, sumOfValues, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1))) {
                  return _Utils_Tuple3(defaultModel, defaultCmd, defaultOutMsg);
                } else {
                  var remainingFromTotal = A2($author$project$Types$Fraction$max, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), A2($JoshuaHall$elm_fraction$Fraction$subtract, sumOfValues, A2($author$project$Ui$TimeTransformation$InputGraph$Util$getValueSumOfInputValues, sumOfValues, state)));

                  var _v10 = A2($JoshuaHall$elm_fraction$Fraction$equal, remainingFromTotal, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1)) ? _Utils_Tuple2(state.yx, '') : _Utils_Tuple2(A3($turboMaCk$any_dict$Dict$Any$insert, selectedDate, $author$project$Types$TimeTransformationBackend$CurrencyValue(remainingFromTotal), state.yx), $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(remainingFromTotal))));

                  var updatedInputValues = _v10.a;
                  var newInputString = _v10.b;
                  return _Utils_Tuple3(_Utils_update(defaultModel, {
                    iY: newInputString,
                    yx: updatedInputValues
                  }), defaultCmd, defaultOutMsg);
                }
              } else {
                return _Utils_Tuple3(defaultModel, defaultCmd, defaultOutMsg);
              }
            } else {
              return _Utils_Tuple3(defaultModel, defaultCmd, defaultOutMsg);
            }

          case 3:
            var selectedDate = _v5.a;
            var maybeValue = _v5.b;

            var updatedInputValues = function () {
              if (!maybeValue.$) {
                var value = maybeValue.a;
                return A3($turboMaCk$any_dict$Dict$Any$insert, selectedDate, value, state.yx);
              } else {
                return state.yx;
              }
            }();

            var inputStatus = $author$project$Ui$TimeTransformation$InputGraph$InputStatus$HoveringItem({
              hC: selectedDate,
              DO: $elm$core$Maybe$Nothing
            });
            return _Utils_Tuple3(_Utils_update(state, {
              yv: inputStatus,
              yx: updatedInputValues
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 5:
        return _Utils_Tuple3(_Utils_update(state, {
          yv: $author$project$Ui$TimeTransformation$InputGraph$InputStatus$Idle
        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

      case 6:
        var _v12 = state.yv;

        switch (_v12.$) {
          case 0:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            var selectedDate = _v12.a.DO;
            var inputStatus = A2($elm$core$Maybe$withDefault, $author$project$Ui$TimeTransformation$InputGraph$InputStatus$Idle, A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$InputGraph$InputStatus$IdleWithSelection, selectedDate));
            return _Utils_Tuple3(_Utils_update(state, {
              yv: inputStatus
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 2:
        var date = msg.a;
        var value = msg.b;
        var fractionValue = $author$project$Ui$TimeTransformation$Util$floatStringToFraction(value);

        var updatedInputValues = function () {
          if (!fractionValue.$) {
            var fraction = fractionValue.a;
            return A2($JoshuaHall$elm_fraction$Fraction$equal, fraction, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1)) ? A2($turboMaCk$any_dict$Dict$Any$remove, date, state.yx) : A3($turboMaCk$any_dict$Dict$Any$insert, date, $author$project$Types$TimeTransformationBackend$CurrencyValue(fraction), state.yx);
          } else {
            return value === '' ? A2($turboMaCk$any_dict$Dict$Any$remove, date, state.yx) : state.yx;
          }
        }();

        return _Utils_Tuple3(_Utils_update(state, {
          iY: value,
          yx: updatedInputValues
        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

      case 3:
        var date = msg.a;
        var value = msg.b;
        var fractionValue = A2($elm$core$Maybe$map, function (fr) {
          return A2($JoshuaHall$elm_fraction$Fraction$multiply, fr, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 100));
        }, $author$project$Ui$TimeTransformation$Util$floatStringToFraction(value));

        var updatedInputValues = function () {
          if (!fractionValue.$) {
            var fraction = fractionValue.a;
            return A3($turboMaCk$any_dict$Dict$Any$insert, date, $author$project$Types$TimeTransformationBackend$Ratio(fraction), state.yx);
          } else {
            return A2($turboMaCk$any_dict$Dict$Any$remove, date, state.yx);
          }
        }();

        return _Utils_Tuple3(_Utils_update(state, {
          iY: value,
          yx: updatedInputValues
        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
    }
  });

  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$HoveringSelection = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$Selecting = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$StartingSelection = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionGraph$toModifiedOrNewSelection = F2(function (maybeExistingSelection, _v0) {
    var previousValue = _v0.sK;
    var currentValue = _v0.wu;
    var storedMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, previousValue));

    if (!maybeExistingSelection.$) {
      var interval = maybeExistingSelection.a;
      var startMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, interval.Eg));
      var endMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, interval.xv));
      return _Utils_eq(storedMillis, startMillis) ? {
        wu: currentValue,
        DR: interval.xv
      } : _Utils_eq(storedMillis, endMillis) ? {
        wu: currentValue,
        DR: interval.Eg
      } : {
        wu: currentValue,
        DR: previousValue
      };
    } else {
      return {
        wu: currentValue,
        DR: previousValue
      };
    }
  });
  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionGraph$toNewSelectionAfterClick = F2(function (interval, newSelectedDate) {
    var startMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, interval.Eg));
    var endMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, interval.xv));
    var currentMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, newSelectedDate));
    var centerMillis = $elm$core$Basics$floor(startMillis + (endMillis - startMillis) / 2);
    return _Utils_cmp(currentMillis, centerMillis) < 1 ? {
      xv: interval.xv,
      Eg: newSelectedDate
    } : {
      xv: newSelectedDate,
      Eg: interval.Eg
    };
  });
  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionGraph$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        var simpleDate = msg.a;
        var _v1 = state.DS;

        switch (_v1.$) {
          case 0:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            var existingSelection = _v1.a.qe;
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$StartingSelection({
                qe: existingSelection,
                eX: simpleDate
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 1:
        var simpleDate = msg.a;
        var _v2 = state.DS;

        switch (_v2.$) {
          case 0:
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$HoveringSelection({
                qe: $elm$core$Maybe$Nothing,
                eX: simpleDate
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            var existingSelection = _v2.a.qe;
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$HoveringSelection({
                qe: existingSelection,
                eX: simpleDate
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            var existingSelection = _v2.a.qe;
            var newSelectionValue = _v2.a.eX;
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$Selecting(A2($author$project$Ui$TimeTransformation$SelectionGraph$SelectionGraph$toModifiedOrNewSelection, existingSelection, {
                wu: simpleDate,
                sK: newSelectionValue
              }))
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            var selectionStart = _v2.a.DR;
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$Selecting({
                wu: simpleDate,
                DR: selectionStart
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            var selectionInterval = _v2.a;
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$HoveringSelection({
                qe: $elm$core$Maybe$Just(selectionInterval),
                eX: simpleDate
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 2:
        var _v3 = state.DS;

        switch (_v3.$) {
          case 0:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            var existingSelection = _v3.a.qe;
            var newSelectionValue = _v3.a.eX;

            var selectionStatus = function () {
              if (!existingSelection.$) {
                var interval = existingSelection.a;
                return $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$IdleWithSelection(A2($author$project$Ui$TimeTransformation$SelectionGraph$SelectionGraph$toNewSelectionAfterClick, interval, newSelectionValue));
              } else {
                return $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$IdleWithSelection({
                  xv: newSelectionValue,
                  Eg: newSelectionValue
                });
              }
            }();

            return _Utils_Tuple3(_Utils_update(state, {
              DS: selectionStatus
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            var selectionStart = _v3.a.DR;
            var currentValue = _v3.a.wu;
            var selectionStartMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selectionStart));
            var currentMillis = $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, currentValue));
            var interval = _Utils_cmp(selectionStartMillis, currentMillis) > 0 ? {
              xv: selectionStart,
              Eg: currentValue
            } : {
              xv: currentValue,
              Eg: selectionStart
            };
            return _Utils_Tuple3(_Utils_update(state, {
              DS: $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$HoveringSelection({
                qe: $elm$core$Maybe$Just(interval),
                eX: currentValue
              })
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      case 3:
        var _v5 = state.DS;

        switch (_v5.$) {
          case 0:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 1:
            var existingSelection = _v5.a.qe;
            var selectionStatus = A2($elm$core$Maybe$withDefault, $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$Idle, A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$IdleWithSelection, existingSelection));
            return _Utils_Tuple3(_Utils_update(state, {
              DS: selectionStatus
            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 2:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          case 3:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);

          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }

      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
    }
  });
  var $author$project$Ui$TimeTransformation$TimeTransformation$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        var selectionGraphMsg = msg.a;

        var _v1 = A2($author$project$Ui$TimeTransformation$SelectionGraph$SelectionGraph$update, selectionGraphMsg, state);

        var timeTransformationModel = _v1.a;
        var selectionGraphCmdMsg = _v1.b;
        var outMsg = _v1.c;
        return _Utils_Tuple3(timeTransformationModel, A2($elm$core$Platform$Cmd$map, $author$project$Ui$TimeTransformation$Msg$SelectionGraphMsg, selectionGraphCmdMsg), outMsg);

      case 1:
        var inputGraphMsg = msg.a;

        var _v2 = A2($author$project$Ui$TimeTransformation$InputGraph$InputGraph$update, inputGraphMsg, state);

        var timeTransformationModel = _v2.a;
        var inputGraphCmdMsg = _v2.b;
        var outMsg = _v2.c;
        return _Utils_Tuple3(timeTransformationModel, A2($elm$core$Platform$Cmd$map, $author$project$Ui$TimeTransformation$Msg$InputGraphMsg, inputGraphCmdMsg), outMsg);

      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
    }
  });
  var $author$project$Types$EditingBuildingBlock$Update$update = F2(function (msg, block) {
    if (!msg.$) {
      var theMsg = msg.a;

      var _v1 = A2($author$project$Ui$TimeTransformation$TimeTransformation$update, theMsg, block.cU.fE);

      var newTransform = _v1.a;
      var cmd = _v1.b;
      return _Utils_Tuple2(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload, block, A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasisTransform, block.cU, newTransform)), A2($elm$core$Platform$Cmd$map, $author$project$Types$EditingBuildingBlock$Msg$MoneyBasisTransformMsg, cmd));
    } else {
      var theMsg = msg.a;

      var _v2 = A2($author$project$Ui$TimeTransformation$TimeTransformation$update, theMsg, block.d2.gM);

      var newTransform = _v2.a;
      var cmd = _v2.b;
      return _Utils_Tuple2(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload, block, A2($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setTimeTransform, block.d2, newTransform)), A2($elm$core$Platform$Cmd$map, $author$project$Types$EditingBuildingBlock$Msg$DerivativeTimeTransformMsg, cmd));
    }
  });

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportAndToastMessage = function (string) {
    return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError(string), A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, string, _List_Nil)]));
  };

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError = F2(function (result, operations) {
    if (!result.$) {
      if (!result.a.$) {
        var val = result.a.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList, operations.dS, operations.e$(val));
      } else {
        var errString = result.a.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList, operations.dS, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$appendCmdInTuple3, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportAndToastMessage(errString), operations.AY(errString)));
      }
    } else {
      var error = result.a;
      return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList, operations.dS, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$appendCmdInTuple3, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr, true, error), operations.eZ(error)));
    }
  });
  var $author$project$Ui$Block$Update$update = F4(function (topState, _v0, state, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 13:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var block = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          bv: block
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 12:
        var newState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          p$: newState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 0:
        return _Utils_Tuple3(_Utils_update(state, {
          ku: !state.ku
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(_Utils_update(state, {
          lz: !state.lz
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        return _Utils_Tuple3(_Utils_update(state, {
          nX: !state.nX
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        return _Utils_Tuple3(_Utils_update(state, {
          kh: !state.kh
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        return _Utils_Tuple3(_Utils_update(state, {
          gV: !state.gV
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 11:
        var result = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ty: result
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var theMsg = msg.a;

        var _v2 = A2($author$project$Types$EditingBuildingBlock$Update$update, theMsg, state.bv);

        var newBlock = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple3(_Utils_update(state, {
          bv: newBlock
        }), A2($elm$core$Platform$Cmd$map, $author$project$Ui$Block$Msg$EditingBlockMsg, cmd), _List_Nil);

      case 7:
        var req = msg.a;
        var result = msg.b;
        var maybeCompany = A3($elm_community$maybe_extra$Maybe$Extra$andThen2, $turboMaCk$any_dict$Dict$Any$get, $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)), A2($elm$core$Maybe$map, function ($) {
          return $.v5;
        }, $author$project$Remote$Model$toSession(topState.o_.CT)));
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function (company) {
          return _Utils_eq(A2($author$project$Ui$Block$Model$toBaseFlowReq, company, state), $elm$core$Maybe$Just(req)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
            dS: function (newState) {
              return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
            },
            eZ: function (_v3) {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
            },
            AY: function (_v4) {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
            },
            e$: function (resp) {
              var editingBlock = $author$project$Api$Types$CharacterizeTimeTransformReq$isDerivative(req.o8) ? A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload, state.bv, A2($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setBasisTransformResponse, state.bv.d2, A2($author$project$Api$Types$CharacterizeTimeTransformResponse$setBaseTimeSeries, resp.ve, state.bv.d2.j5))) : A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload, state.bv, A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasisTransformResponse, state.bv.cU, A2($author$project$Api$Types$CharacterizeTimeTransformResponse$setBaseTimeSeries, resp.ve, state.bv.cU.iy)));
              return _Utils_Tuple3(_Utils_update(state, {
                bv: editingBlock
              }), $elm$core$Platform$Cmd$none, _List_Nil);
            }
          }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }, maybeCompany));

      case 8:
        var company = msg.a;
        var req = msg.b;
        var result = msg.c;
        return _Utils_eq(A2($author$project$Ui$Block$Model$toBasicMoneyCharacterizeReq, company, state), $elm$core$Maybe$Just(req)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v5) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v6) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            var editingBlock = A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload, state.bv, A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasisTransformResponse, state.bv.cU, resp));
            return _Utils_Tuple3(_Utils_update(state, {
              bv: editingBlock
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        var req = msg.a;
        var result = msg.b;
        return _Utils_eq($author$project$Ui$Block$Model$toDerivativeCharacterizeReq(state), $elm$core$Maybe$Just(req)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v7) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v8) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            var editingBlock = A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload, state.bv, A2($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setBasisTransformResponse, state.bv.d2, resp));
            return _Utils_Tuple3(_Utils_update(state, {
              bv: editingBlock
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var req = msg.a;
        var result = msg.b;
        return _Utils_eq($author$project$Ui$Block$Model$toDerivativeMoneyCharacterizeReq(state), $elm$core$Maybe$Just(req)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v9) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v10) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            var editingBlock = A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload, state.bv, A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasisTransformResponse, state.bv.cU, resp));
            return _Utils_Tuple3(_Utils_update(state, {
              bv: editingBlock
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Remote$RequestMsg$CloneBlock = F2(function (a, b) {
    return {
      $: 68,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Scenario$Msg$SetBlocks = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $turboMaCk$any_set$Set$Any$removeAll = function (_v0) {
    var dict = _v0;
    return $turboMaCk$any_dict$Dict$Any$removeAll(dict);
  };

  var $author$project$Api$Types$CharacterizeTimeTransformReq$BlockId = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Blocks$Util$toBlockIdFromRoute = function (topState) {
    var _v0 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

    _v0$2: while (true) {
      if (_v0.$ === 5 && _v0.b.$ === 3) {
        switch (_v0.b.a.$) {
          case 2:
            var companyId = _v0.a;
            var blockId = _v0.b.a.a;
            return $elm$core$Maybe$Just(_Utils_Tuple2(companyId, blockId));

          case 3:
            var companyId = _v0.a;
            var blockId = _v0.b.a.a;
            return $elm$core$Maybe$Just(_Utils_Tuple2(companyId, blockId));

          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $author$project$Types$BuildingBlock$toBlockOfEnum = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        return 0;

      case 1:
        return 1;

      case 2:
        return 0;

      default:
        return 1;
    }
  };

  var $author$project$Types$Company$toBuildingBlock = F2(function (buildingBlockId, company) {
    return A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(buildingBlockId), $krisajenkins$remotedata$RemoteData$toMaybe(company.pg));
  });

  var $author$project$Ui$Blocks$Util$toBaseFlowReq = function (topState) {
    var toBlock = F2(function (_v1, thisUserSession) {
      var companyId = _v1.a;
      var blockId = _v1.b;
      return A2($elm$core$Maybe$andThen, $author$project$Types$Company$toBuildingBlock(blockId), A2($author$project$Types$UserSession$toCompany, companyId, thisUserSession));
    });
    var maybeBlock = A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, A3($elm$core$Maybe$map2, toBlock, $author$project$Ui$Blocks$Util$toBlockIdFromRoute(topState), $author$project$Remote$Model$toSession(topState.o_.CT)));

    if (!maybeBlock.$) {
      var block = maybeBlock.a;
      return $elm$core$Maybe$Just({
        o8: $author$project$Api$Types$CharacterizeTimeTransformReq$BlockId(block.F),
        rv: $author$project$Types$BuildingBlock$toBlockOfEnum(block),
        bw: block.bw
      });
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $turboMaCk$any_dict$Dict$Any$member = F2(function (k, _v0) {
    var dict = _v0.bT;
    var toKey = _v0.dn;
    return A2($elm$core$Dict$member, toKey(k), dict);
  });
  var $turboMaCk$any_set$Set$Any$member = F2(function (a, _v0) {
    var dict = _v0;
    return A2($turboMaCk$any_dict$Dict$Any$member, a, dict);
  });
  var $turboMaCk$any_set$Set$Any$toggle = F2(function (a, set) {
    return A2($turboMaCk$any_set$Set$Any$member, a, set) ? A2($turboMaCk$any_set$Set$Any$remove, a, set) : A2($turboMaCk$any_set$Set$Any$insert, a, set);
  });
  var $author$project$Types$Filters$update = F2(function (msg, filters) {
    switch (msg.$) {
      case 0:
        var authors = msg.a;
        return _Utils_update(filters, {
          g0: authors
        });

      case 1:
        var state = msg.a;
        return _Utils_update(filters, {
          hc: state
        });

      case 2:
        var scenarios = msg.a;
        return _Utils_update(filters, {
          db: scenarios
        });

      case 3:
        var reviews = msg.a;
        return _Utils_update(filters, {
          c9: reviews
        });

      case 4:
        var state = msg.a;
        return _Utils_update(filters, {
          iv: state
        });

      case 5:
        var text = msg.a;
        return _Utils_update(filters, {
          j_: text
        });

      case 6:
        var state = msg.a;
        return _Utils_update(filters, {
          ft: state
        });

      default:
        return _Utils_update($author$project$Types$Filters$empty, {
          j_: filters.j_
        });
    }
  });
  var $author$project$Ui$Blocks$Update$update = F4(function (topState, _v0, state, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 0:
        var filtersMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qo: A2($author$project$Types$Filters$update, filtersMsg, state.qo)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var id = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          to: A2($turboMaCk$any_set$Set$Any$toggle, id, state.to)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var companyId = msg.a;
        var blockId = msg.b;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CloneBlock, companyId, blockId))]));

      case 3:
        return _Utils_Tuple3(_Utils_update(state, {
          to: $turboMaCk$any_set$Set$Any$removeAll(state.to)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var companyId = msg.a;
        var blocks = msg.b;
        return _Utils_Tuple3(_Utils_update(state, {
          to: $turboMaCk$any_set$Set$Any$removeAll(state.to)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(0)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ScenarioMsg($author$project$Ui$Scenario$Msg$SetBlocks(blocks)))]));

      case 5:
        var nestedSelectState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ul: nestedSelectState
        }), $elm$core$Platform$Cmd$none, !_Utils_eq(state.ul.ia, nestedSelectState.ia) ? A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $author$project$ElmFramework$MsgCmd$msgCmd.Dn, $elm$core$List$singleton)), nestedSelectState.ia)) : _List_Nil);

      default:
        var blockId = msg.a;
        var req = msg.b;
        var response = msg.c;
        return _Utils_eq($author$project$Ui$Blocks$Util$toBaseFlowReq(topState), $elm$core$Maybe$Just(req)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, response, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v2) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v3) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            return _Utils_Tuple3(_Utils_update(state, {
              o9: $elm$core$Maybe$Just(_Utils_Tuple2(blockId, resp))
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Util$BudgetQueryInRoute$mapBudgetQueryInRoute = F2(function (mapper, route) {
    if (route.$ === 5 && route.b.$ === 1) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Budget, mapper(query), subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  });
  var $author$project$Types$BudgetQuery$setYAxisSource = F2(function (val, query) {
    return _Utils_update(query, {
      ka: val
    });
  });
  var $author$project$Util$BudgetQueryInRoute$setYAxisSource = F2(function (route, yAxisSource) {
    return A2($author$project$Util$BudgetQueryInRoute$mapBudgetQueryInRoute, $author$project$Types$BudgetQuery$setYAxisSource(yAxisSource), route);
  });

  var $author$project$Route$RouteUtil$toBudgetQuery = function (route) {
    if (route.$ === 5 && route.b.$ === 1) {
      var _v1 = route.b;
      var query = _v1.a;
      return $elm$core$Maybe$Just(query);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Budget$Update$update = F4(function (currRoute, _v0, state, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 9:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var nestedSelectState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ut: nestedSelectState
        }), $elm$core$Platform$Cmd$none, _Utils_eq(state.ut.ia, nestedSelectState.ia) ? _List_Nil : A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$Util$BudgetQueryInRoute$setYAxisSource(currRoute)), nestedSelectState.ia)));

      case 0:
        var budgetQuery = msg.a;
        var result = msg.b;
        return _Utils_eq($author$project$Route$RouteUtil$toBudgetQuery(currRoute), $elm$core$Maybe$Just(budgetQuery)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v2) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v3) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            return _Utils_Tuple3(_Utils_update(state, {
              C0: $elm$core$Maybe$Just(resp)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(_Utils_update(state, {
          C0: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var path = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qi: A2($turboMaCk$any_set$Set$Any$toggle, path, state.qi)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var periodFinancials = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qG: $elm$core$Maybe$Just(periodFinancials.ap)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var periodFinancials = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qN: $elm$core$Maybe$Just(periodFinancials)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        var comment = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qG: comment.ap
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        return _Utils_Tuple3(_Utils_update(state, {
          qN: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });

  var $author$project$Ui$Cashboard$Msg$CommentMessage = function (a) {
    return {
      $: 15,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Model$EditAllocation = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Model$EditBasePattern = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Model$EditGrowth = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Model$EditSeasonality = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$Block$Msg$SetEditingBlock = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$UpdateBlock = F4(function (a, b, c, d) {
    return {
      $: 66,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Api$Types$EditBlockReq$Edit = {
    $: 1
  };

  var $author$project$Api$Types$EditBlockReq$fromCreateBlockReqWithDefaultMultipleScenariosAction = function (createBlockReq) {
    return {
      kw: createBlockReq.kw,
      yC: createBlockReq.yC,
      hP: $author$project$Api$Types$EditBlockReq$Edit,
      zL: createBlockReq.zL,
      bw: createBlockReq.bw
    };
  };

  var $author$project$ElmFramework$Lib$PivotDict$getItem = F3(function (id1, id2, _v0) {
    var dict1 = _v0.cG;
    return A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(id2), A2($turboMaCk$any_dict$Dict$Any$get, id1, dict1));
  });
  var $author$project$Types$Company$toScenarioBlockRelationShip = F3(function (scenarioId, blockId, company) {
    return A2($elm$core$Maybe$andThen, A2($author$project$ElmFramework$Lib$PivotDict$getItem, scenarioId, blockId), $krisajenkins$remotedata$RemoteData$toMaybe(company.nT));
  });
  var $author$project$Types$Company$isQuickEdit = F3(function (company, scenarioId, buildingBlockId) {
    return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm$core$Maybe$andThen, function ($) {
      return $.q5;
    }, A3($author$project$Types$Company$toScenarioBlockRelationShip, scenarioId, buildingBlockId, company)));
  });
  var $author$project$Ui$Cashboard$Update$mapCmd = F2(function (toMsg, _v0) {
    var model = _v0.a;
    var cmd = _v0.b;
    var msg = _v0.c;
    return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, toMsg, cmd), msg);
  });
  var $author$project$Ui$Cashboard$Update$mapCommentModel = F2(function (model, _v0) {
    var commentState = _v0.a;
    var cmd = _v0.b;
    var msg = _v0.c;
    return _Utils_Tuple3(_Utils_update(model, {
      v1: commentState
    }), cmd, msg);
  });
  var $author$project$TopMsg$msgBlock = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BlockMsg);
  var $author$project$Util$CashboardQueryInRoute$mapCashboardQueryInRoute = F2(function (mapper, route) {
    if (route.$ === 5 && !route.b.$) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Cashboard, mapper(query), subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  });
  var $author$project$Types$CashboardQuery$setReportingInterval = F2(function (val, query) {
    return _Utils_update(query, {
      jD: val
    });
  });
  var $author$project$Util$CashboardQueryInRoute$setReportingInterval = F2(function (route, interval) {
    return A2($author$project$Util$CashboardQueryInRoute$mapCashboardQueryInRoute, $author$project$Types$CashboardQuery$setReportingInterval(interval), route);
  });

  var $author$project$Route$RouteUtil$toCashboardQuery = function (route) {
    if (route.$ === 5 && !route.b.$) {
      var _v1 = route.b;
      var query = _v1.a;
      return $elm$core$Maybe$Just(query);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Api$Types$CreateBlockReq$BasicMoney = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$Types$CreateBlockReq$BasicThing = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$Types$CreateBlockReq$DerivativeMoney = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Api$Types$CreateBlockReq$DerivativeThing = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$toDerivativeMoneyPayload = function (payload) {
    return $elm$core$Result$Ok({
      fB: payload.fB
    });
  };

  var $author$project$Ui$ClassAllocationNestedSelect$toSelection = function ($) {
    return $.ia;
  };

  var $author$project$Ui$FinancialAccountDropdownSelector$toSelection = function (state) {
    return state.ia;
  };

  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toMoneyPayloadReq = F2(function (_v0, currency) {
    var basis = _v0.pb;
    var basisTransform = _v0.fE;
    var allocationClass = _v0.kf;
    var allocationFinancialAccount = _v0.bS;
    var internalOppositeAllocationClass = _v0.iZ;
    var internalOppositeFinancialAccount = _v0.bU;
    var isInternalTransaction = _v0.f6;

    var internalOppositePair = function () {
      var _v9 = _Utils_Tuple2($author$project$Ui$ClassAllocationNestedSelect$toSelection(internalOppositeAllocationClass), $author$project$Ui$FinancialAccountDropdownSelector$toSelection(internalOppositeFinancialAccount));

      if (_v9.a.$ === 1) {
        var _v10 = _v9.a;
        return $elm$core$Result$Err('Please choose an opposite allocation class');
      } else {
        if (_v9.b.$ === 1) {
          var _v11 = _v9.b;
          return $elm$core$Result$Err('Please choose an opposite allocation account');
        } else {
          var _class = _v9.a.a;
          var account = _v9.b.a;
          return $elm$core$Result$Ok({
            kf: _class,
            lo: account
          });
        }
      }
    }();

    var allocationClassDataResult = function () {
      var _v1 = _Utils_Tuple3($author$project$Ui$ClassAllocationNestedSelect$toSelection(allocationClass), $author$project$Ui$FinancialAccountDropdownSelector$toSelection(allocationFinancialAccount), isInternalTransaction);

      if (_v1.a.$ === 1) {
        if (!_v1.b.$) {
          var _v4 = _v1.a;
          return $elm$core$Result$Err('Please choose an allocation class');
        } else {
          if (!_v1.c) {
            var _v2 = _v1.a;
            var _v3 = _v1.b;
            return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
          } else {
            var _v6 = _v1.a;
            var _v7 = _v1.b;
            return $elm$core$Result$Err('Please choose an allocation class and account for the internal transaction');
          }
        }
      } else {
        if (_v1.b.$ === 1) {
          var _v5 = _v1.b;
          return $elm$core$Result$Err('Please choose an allocation class account');
        } else {
          if (!_v1.c) {
            var _class = _v1.a.a;
            var account = _v1.b.a;
            return $elm$core$Result$Ok($elm$core$Maybe$Just({
              iu: {
                kf: _class,
                lo: account
              },
              qZ: $elm$core$Maybe$Nothing
            }));
          } else {
            var _class = _v1.a.a;
            var account = _v1.b.a;

            if (!internalOppositePair.$) {
              var pair = internalOppositePair.a;
              return $elm$core$Result$Ok($elm$core$Maybe$Just({
                iu: {
                  kf: _class,
                  lo: account
                },
                qZ: $elm$core$Maybe$Just(pair)
              }));
            } else {
              var err = internalOppositePair.a;
              return $elm$core$Result$Err(err);
            }
          }
        }
      }
    }();

    return A2($elm$core$Result$map, function (maybeAllocationClassData) {
      return {
        kg: maybeAllocationClassData,
        pb: basis,
        fE: $author$project$Ui$TimeTransformation$Model$toTimeTransformReq(basisTransform),
        V: currency
      };
    }, allocationClassDataResult);
  });
  var $author$project$Types$EditingBuildingBlock$EditingThingPayload$toThingPayload = F2(function (payload, thingDesc) {
    return $elm$core$Result$Ok({
      V: thingDesc
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toCreateBuildingBlockReq = F2(function (company, editing) {
    var toCreateBlockReq = F3(function (blockName, startOn, blockType) {
      return {
        kw: blockType,
        yC: true,
        zL: blockName,
        bw: startOn
      };
    });

    var blockTypeResult = function () {
      var _v0 = _Utils_Tuple2(editing.g7, editing.hO);

      if (_v0.a.$ === 1) {
        var _v1 = _v0.a;
        return $elm$core$Result$Err('Please choose between basic and derivative block');
      } else {
        if (!_v0.a.a) {
          if (!_v0.b.$) {
            var _v2 = _v0.a.a;
            var currency = _v0.b.a;
            return A3($elm$core$Result$map2, F2(function (basic, money) {
              return $author$project$Api$Types$CreateBlockReq$BasicMoney(_Utils_Tuple2(basic, money));
            }), A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, company, editing.fD), A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toMoneyPayloadReq, editing.cU, currency));
          } else {
            var _v3 = _v0.a.a;
            var thingDesc = _v0.b.a;
            return A3($elm$core$Result$map2, F2(function (basic, thing) {
              return $author$project$Api$Types$CreateBlockReq$BasicThing(_Utils_Tuple2(basic, thing));
            }), A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, company, editing.fD), A2($author$project$Types$EditingBuildingBlock$EditingThingPayload$toThingPayload, editing.eD, thingDesc));
          }
        } else {
          if (!_v0.b.$) {
            var _v4 = _v0.a.a;
            var currency = _v0.b.a;
            return A4($elm$core$Result$map3, F3(function (derivative, money, derivativeMoney) {
              return $author$project$Api$Types$CreateBlockReq$DerivativeMoney(_Utils_Tuple3(derivative, money, derivativeMoney));
            }), $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq(editing.d2), A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toMoneyPayloadReq, editing.cU, currency), $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$toDerivativeMoneyPayload(editing.fP));
          } else {
            var _v5 = _v0.a.a;
            var thingDesc = _v0.b.a;
            return A3($elm$core$Result$map2, F2(function (derivative, thing) {
              return $author$project$Api$Types$CreateBlockReq$DerivativeThing(_Utils_Tuple2(derivative, thing));
            }), $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq(editing.d2), A2($author$project$Types$EditingBuildingBlock$EditingThingPayload$toThingPayload, editing.eD, thingDesc));
          }
        }
      }
    }();

    return A4($elm$core$Result$map3, toCreateBlockReq, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(editing.zL), A2($elm$core$Result$fromMaybe, 'Please provide a starting date', A2($author$project$Ui$DateInput$DateInput$toSimpleDate, $elm$time$Time$utc, editing.bw)), blockTypeResult);
  });

  var $author$project$Ui$Cashboard$Msg$OnMouseEnterComment = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$TopMsg$msgCashboard = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg);
  var $author$project$Ui$RangeDateInput$RangeDateInput$parseDateString = F2(function (zone, dateString) {
    var dateParts = $elm$core$Array$fromList(A2($elm$core$String$split, '-', dateString));
    return A4($elm$core$Maybe$map3, F3(function (d, m, y) {
      return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, {
        wz: d,
        yc: 0,
        zz: 0,
        zE: 0,
        zG: $justinmimbs$date$Date$numberToMonth(m),
        tj: 0,
        FP: y
      });
    }), A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Array$get, 0, dateParts)), A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Array$get, 1, dateParts)), A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Array$get, 2, dateParts)));
  });

  var $author$project$Ui$RangeDateInput$RangeDateInput$updateRangeDateInput = function (_v0) {
    var model = _v0.zF;
    var dateInputMsg = _v0.wy;
    var zone = _v0.by;
    var baseTime = _v0.vd;

    if (!dateInputMsg.$) {
      var _v2 = dateInputMsg.a;
      var newPicker = _v2.a;
      var maybeNewDateRange = _v2.b;
      var newSelectedDate = A2($elm$core$Maybe$withDefault, model.Fw, A2($elm$core$Maybe$map, function (_v3) {
        var s = _v3.a;
        var e = _v3.b;
        return $elm$core$Maybe$Just({
          dR: e,
          Ef: s
        });
      }, maybeNewDateRange));
      return {
        ca: {
          iM: A2($author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputState, zone, newSelectedDate),
          d1: newPicker
        },
        Fw: newSelectedDate
      };
    } else {
      if (!dateInputMsg.a) {
        var _v4 = dateInputMsg.a;
        var newDateInput = dateInputMsg.b;
        var newStartDate = A2($author$project$Ui$RangeDateInput$RangeDateInput$parseDateString, zone, newDateInput);
        var newPickerWithSelectedDate = A5($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$openPicker, $author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputSettings(zone), baseTime, newStartDate, A2($elm$core$Maybe$map, function ($) {
          return $.dR;
        }, model.Fw), model.ca.d1);
        return {
          ca: {
            iM: A2($elm$core$Tuple$mapFirst, $elm$core$Basics$always($elm$core$Maybe$Just(newDateInput)), model.ca.iM),
            d1: newPickerWithSelectedDate
          },
          Fw: function () {
            if (!newStartDate.$) {
              var validDate = newStartDate.a;
              return A2($elm$core$Maybe$map, function (v) {
                return _Utils_update(v, {
                  Ef: validDate
                });
              }, model.Fw);
            } else {
              return model.Fw;
            }
          }()
        };
      } else {
        var _v6 = dateInputMsg.a;
        var newDateInput = dateInputMsg.b;
        var newEndDate = A2($author$project$Ui$RangeDateInput$RangeDateInput$parseDateString, zone, newDateInput);
        var newPickerWithSelectedDate = A5($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$openPicker, $author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputSettings(zone), baseTime, A2($elm$core$Maybe$map, function ($) {
          return $.Ef;
        }, model.Fw), newEndDate, model.ca.d1);
        return {
          ca: {
            iM: A2($elm$core$Tuple$mapSecond, $elm$core$Basics$always($elm$core$Maybe$Just(newDateInput)), model.ca.iM),
            d1: newPickerWithSelectedDate
          },
          Fw: function () {
            if (!newEndDate.$) {
              var validDate = newEndDate.a;
              return A2($elm$core$Maybe$map, function (v) {
                return _Utils_update(v, {
                  dR: validDate
                });
              }, model.Fw);
            } else {
              return model.Fw;
            }
          }()
        };
      }
    }
  };

  var $author$project$Ui$Cashboard$Comment$Update$update = F2(function (message, state) {
    switch (message.$) {
      case 0:
        return _Utils_Tuple3($author$project$Ui$Cashboard$Comment$Model$init, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var text = message.a;
        return _Utils_Tuple3(_Utils_update(state, {
          EH: text
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var zone = message.a;
        var time = message.b;
        var newState = _Utils_eq(state.iL, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just($author$project$Ui$RangeDateInput$RangeDateInput$initRangeDateInput({
          vd: time,
          Fw: $elm$core$Maybe$Nothing,
          by: zone
        })) : $elm$core$Maybe$Nothing;
        return _Utils_Tuple3(_Utils_update(state, {
          iL: newState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var zone = message.a;
        var time = message.b;
        var dateMsg = message.c;
        return _Utils_Tuple3(_Utils_update(state, {
          iL: A2($elm$core$Maybe$map, function (rangeDate) {
            return $author$project$Ui$RangeDateInput$RangeDateInput$updateRangeDateInput({
              vd: time,
              wy: dateMsg,
              zF: rangeDate,
              by: zone
            });
          }, state.iL)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var divisions = message.a;
        return _Utils_Tuple3(_Utils_update(state, {
          eO: divisions
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var filtersMsg = message.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qo: A2($author$project$Types$Filters$update, filtersMsg, state.qo)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var maybeComment = message.a;
        return _Utils_Tuple3(_Utils_update(state, {
          f$: A2($elm$core$Maybe$map, function ($) {
            return $.F;
          }, maybeComment)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$OnMouseEnterComment(maybeComment))]));
    }
  });
  var $author$project$Ui$Cashboard$Update$update = F4(function (currRoute, _v0, state, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 0:
        var cashboardQuery = msg.a;
        var result = msg.b;
        return _Utils_eq($author$project$Route$RouteUtil$toCashboardQuery(currRoute), $elm$core$Maybe$Just(cashboardQuery)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v2) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v3) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            return _Utils_Tuple3(_Utils_update(state, {
              C0: $elm$core$Maybe$Just(resp)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(_Utils_update(state, {
          C0: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var path = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qi: A2($turboMaCk$any_set$Set$Any$toggle, path, state.qi)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 19:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var periodDetails = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ya: $elm$core$Maybe$Just(periodDetails.ap)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var periodDetails = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qN: $elm$core$Maybe$Just(periodDetails)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var maybeComment = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ya: A2($elm$core$Maybe$andThen, function ($) {
            return $.ap;
          }, maybeComment)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var comment = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ya: comment.ap
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        return _Utils_Tuple3(_Utils_update(state, {
          qN: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 8:
        var filtersMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          s3: A2($author$project$Types$Filters$update, filtersMsg, state.s3)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        var sorter = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          s4: sorter
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 10:
        var name = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          rD: name
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 11:
        var filtersMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          pd: A2($author$project$Types$Filters$update, filtersMsg, state.pd)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 12:
        var nestedSelectState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          sY: nestedSelectState
        }), $elm$core$Platform$Cmd$none, _Utils_eq(state.sY.ia, nestedSelectState.ia) ? _List_Nil : A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$Util$CashboardQueryInRoute$setReportingInterval(currRoute)), nestedSelectState.ia)));

      case 13:
        var quickEditPattern = msg.a;
        var toCmd = A2($elm$core$Basics$composeR, $author$project$Types$BuildingBlockHydrated$fromBuildingBlock, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$fromBuildingBlock), A2($elm$core$Basics$composeR, $elm$core$Maybe$map(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$SetEditingBlock)), A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$List$singleton), $elm$core$Maybe$withDefault(_List_Nil)))));

        var _v4 = function () {
          switch (quickEditPattern.$) {
            case 0:
              var block = quickEditPattern.a;
              return _Utils_Tuple2($author$project$Ui$Cashboard$Model$EditSeasonality(block.F), toCmd(block));

            case 1:
              var block = quickEditPattern.a;
              return _Utils_Tuple2($author$project$Ui$Cashboard$Model$EditGrowth(block.F), toCmd(block));

            case 2:
              var block = quickEditPattern.a;
              return _Utils_Tuple2($author$project$Ui$Cashboard$Model$EditBasePattern(block.F), toCmd(block));

            default:
              var block = quickEditPattern.a;
              return _Utils_Tuple2($author$project$Ui$Cashboard$Model$EditAllocation(block.F), toCmd(block));
          }
        }();

        var overlay = _v4.a;
        var cmd = _v4.b;
        return _Utils_Tuple3(_Utils_update(state, {
          sn: $elm$core$Maybe$Just(overlay)
        }), $elm$core$Platform$Cmd$none, cmd);

      case 14:
        var scenarioId = msg.a;
        var blockId = msg.b;
        var editingBlock = msg.c;
        var company = msg.d;

        var maybeScenarioId = function () {
          var isQuickEdit = A3($author$project$Types$Company$isQuickEdit, company, scenarioId, blockId);
          return isQuickEdit ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(scenarioId);
        }();

        var requestResult = A2($elm$core$Result$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, A3($author$project$Remote$RequestMsg$UpdateBlock, company.F, maybeScenarioId, blockId)), A2($elm$core$Result$map, $author$project$Api$Types$EditBlockReq$fromCreateBlockReqWithDefaultMultipleScenariosAction, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toCreateBuildingBlockReq, company, editingBlock)));

        var request = function () {
          if (!requestResult.$) {
            var val = requestResult.a;
            return val;
          } else {
            var err = requestResult.a;
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
          }
        }();

        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([request]));

      case 16:
        var overlay = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          sn: overlay
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 15:
        var commentMessage = msg.a;
        return A2($author$project$Ui$Cashboard$Update$mapCommentModel, state, A2($author$project$Ui$Cashboard$Update$mapCmd, $author$project$Ui$Cashboard$Msg$CommentMessage, A2($author$project$Ui$Cashboard$Comment$Update$update, commentMessage, state.v1)));

      case 17:
        var newState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          xl: newState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var record = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          pp: $elm$core$Maybe$Just(record)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });

  var $author$project$Ui$ComponentsPreview$Msg$TimeTransformationMsg = function (a) {
    return {
      $: 36,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$defaultInputSearchDropdownResults = _List_fromArray(['USD', '250g Bag', 'Clicks', 'Customers', 'Visits', '500g Bag']);

  var $elm_community$maybe_extra$Maybe$Extra$or = F2(function (ma, mb) {
    if (ma.$ === 1) {
      return mb;
    } else {
      return ma;
    }
  });

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$unwrapOption = function (_v0) {
    var option = _v0;
    return option;
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$locationToOptions = F2(function (location, maybeOptions) {
    return $elm$core$List$isEmpty(location) ? maybeOptions : A2($elm$core$Maybe$andThen, function (optionList) {
      var maybeLocatedOptions = A3($elm$core$List$foldr, F2(function (locationIndex, maybeOptionList) {
        return A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$unwrapOption, function ($) {
          return $.vU;
        }), A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
          return $.e0;
        }, $elm_community$list_extra$List$Extra$getAt(locationIndex)), maybeOptionList));
      }), $elm$core$Maybe$Just(optionList), location);
      return A2($elm_community$maybe_extra$Maybe$Extra$or, maybeLocatedOptions, maybeOptions);
    }, maybeOptions);
  });
  var $elm_community$list_extra$List$Extra$updateAt = F3(function (index, fn, list) {
    if (index < 0) {
      return list;
    } else {
      var tail = A2($elm$core$List$drop, index, list);
      var head = A2($elm$core$List$take, index, list);

      if (tail.b) {
        var x = tail.a;
        var xs = tail.b;
        return _Utils_ap(head, A2($elm$core$List$cons, fn(x), xs));
      } else {
        return list;
      }
    }
  });
  var $elm_community$list_extra$List$Extra$setAt = F2(function (index, value) {
    return A2($elm_community$list_extra$List$Extra$updateAt, index, $elm$core$Basics$always(value));
  });
  var $elm$core$String$toLower = _String_toLower;
  var $author$project$Ui$NestedTable$NestedTable$toggleRow = F2(function (expandedRows, rowPath) {
    return A2($turboMaCk$any_set$Set$Any$toggle, rowPath, expandedRows);
  });
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$update = F4(function (_v0, maybeSession, msg, state) {
    var time = _v0.EM;
    var zone = _v0.by;
    var appState = _v0.o_;

    var filterResults = function (filterString) {
      return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$String$startsWith($elm$core$String$toLower(filterString)), $elm$core$String$toLower), $author$project$Ui$ComponentsPreview$ComponentsPreview$defaultInputSearchDropdownResults);
    };

    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var weekdays = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          i1: $elm$core$Maybe$Just(weekdays)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          yw: input
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 8:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 10:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 11:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 12:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 13:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 14:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 17:
        var gender = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qA: gender
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 18:
        var age = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ft: age
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 19:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          tJ: $elm$core$Maybe$Just(input)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 20:
        if (!maybeSession.$) {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, 'OnVideo error', _List_fromArray(['not authenticated']))]));
        }

      case 21:
        var floatString = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          jS: A2($elm$core$Maybe$withDefault, 0.0, $elm$core$String$toFloat(floatString))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 22:
        var string = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ty: string
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 23:
        return _Utils_Tuple3(_Utils_update(state, {
          fc: !state.fc
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        return _Utils_Tuple3(_Utils_update(state, {
          h_: !state.h_
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 33:
        var option = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          l8: option
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 24:
        var value = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          jN: $elm$core$Maybe$Just(value)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 25:
        var newState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          pX: newState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 26:
        var inputValueString = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          hD: $elm$core$Maybe$Just(A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$Ui$ComponentsPreview$ComponentsPreview$defaultInputSearchDropdownResults, filterResults(inputValueString), $elm$core$String$isEmpty(inputValueString)))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 27:
        var inputValueString = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          hD: $elm$core$Maybe$Just($elm$core$List$reverse(A2($elm$core$List$cons, inputValueString, $elm$core$List$reverse(filterResults(inputValueString)))))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 28:
        var nestedSelectState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          d6: nestedSelectState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 29:
        var val = msg.a;
        var inputString = msg.b;
        var setAtRecursive = F3(function (location, values, originalList) {
          if (!location.b) {
            return _Utils_update(originalList, {
              e0: values
            });
          } else {
            var x = location.a;
            var xs = location.b;
            var maybeOption = A2($elm_community$list_extra$List$Extra$getAt, x, originalList.e0);

            if (!maybeOption.$) {
              var option = maybeOption.a;
              var _v5 = option.vU;

              if (!_v5.$) {
                var children = _v5.a;
                return _Utils_update(originalList, {
                  e0: A3($elm_community$list_extra$List$Extra$setAt, x, _Utils_update(option, {
                    vU: $elm$core$Maybe$Just(A3(setAtRecursive, xs, values, children))
                  }), originalList.e0)
                });
              } else {
                return originalList;
              }
            } else {
              return originalList;
            }
          }
        });
        return _Utils_Tuple3(_Utils_update(state, {
          dX: A2($elm$core$Maybe$withDefault, state.dX, A2($elm$core$Maybe$map, function (newOptions) {
            return A3(setAtRecursive, state.d6.rm, newOptions, state.dX);
          }, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
            return $.e0;
          }, $elm$core$List$map(function (_v6) {
            var option = _v6;
            return _Utils_eq(option.Fw, val) ? _Utils_update(option, {
              Fw: inputString
            }) : option;
          })), A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$locationToOptions, state.d6.rm, $elm$core$Maybe$Just(state.dX)))))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 30:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 31:
        var string = msg.a;
        var setAtRecursive = F3(function (location, values, originalList) {
          if (!location.b) {
            return _Utils_update(originalList, {
              e0: values
            });
          } else {
            var x = location.a;
            var xs = location.b;
            var maybeOption = A2($elm_community$list_extra$List$Extra$getAt, x, originalList.e0);

            if (!maybeOption.$) {
              var option = maybeOption.a;
              var _v9 = option.vU;

              if (!_v9.$) {
                var children = _v9.a;
                return _Utils_update(originalList, {
                  e0: A3($elm_community$list_extra$List$Extra$setAt, x, _Utils_update(option, {
                    vU: $elm$core$Maybe$Just(A3(setAtRecursive, xs, values, children))
                  }), originalList.e0)
                });
              } else {
                return originalList;
              }
            } else {
              return originalList;
            }
          }
        });
        var nestedSelectState = state.d6;
        return _Utils_Tuple3(_Utils_update(state, {
          dX: A2($elm$core$Maybe$withDefault, state.dX, A2($elm$core$Maybe$map, function (newOptions) {
            return A3(setAtRecursive, state.d6.rm, newOptions, state.dX);
          }, A2($elm$core$Maybe$map, function (optionList) {
            return _Utils_ap(optionList.e0, _List_fromArray([{
              vU: $elm$core$Maybe$Nothing,
              kN: $elm$core$Maybe$Nothing,
              Ax: $elm$core$Maybe$Nothing,
              hV: $elm$core$Maybe$Nothing,
              jM: true,
              Fw: string
            }]));
          }, A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$locationToOptions, state.d6.rm, $elm$core$Maybe$Just(state.dX))))),
          d6: _Utils_update(nestedSelectState, {
            kR: '',
            yK: false
          })
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 32:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 36:
        var theMsg = msg.a;

        var _v10 = A2($author$project$Ui$TimeTransformation$TimeTransformation$update, theMsg, state.$9);

        var timeTransformationModel = _v10.a;
        var timeTransformationCmd = _v10.b;
        return _Utils_Tuple3(_Utils_update(state, {
          $9: timeTransformationModel
        }), A2($elm$core$Platform$Cmd$map, $author$project$Ui$ComponentsPreview$Msg$TimeTransformationMsg, timeTransformationCmd), _List_Nil);

      case 41:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 37:
        var rowPath = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          hQ: A2($author$project$Ui$NestedTable$NestedTable$toggleRow, state.hQ, rowPath)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 34:
        var cashOrCredit = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          kB: cashOrCredit
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 35:
        var activeOrDraftScenarios = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          kc: activeOrDraftScenarios
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 15:
        var dateMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          iL: $author$project$Ui$DateInput$DateInput$updateDateInput({
            vd: time,
            wy: dateMsg,
            zF: state.iL,
            by: zone
          })
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 16:
        var dateMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          jy: $author$project$Ui$RangeDateInput$RangeDateInput$updateRangeDateInput({
            vd: time,
            wy: dateMsg,
            zF: state.jy,
            by: zone
          })
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 38:
        return _Utils_Tuple3(_Utils_update(state, {
          eC: A2($elm$core$Maybe$withDefault, state.eC, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $turboMaCk$any_set$Set$Any$fromList($elm$core$Basics$identity), $turboMaCk$any_dict$Dict$Any$keys), state.jY))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 39:
        return _Utils_Tuple3(_Utils_update(state, {
          eC: A2($elm$core$Maybe$withDefault, state.eC, A2($elm$core$Maybe$map, function (_v11) {
            return $turboMaCk$any_set$Set$Any$empty($elm$core$Basics$identity);
          }, state.jY))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var key = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          eC: A2($turboMaCk$any_set$Set$Any$toggle, key, state.eC)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });

  var $author$project$Global$Model$EditInvitation = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Global$Model$EditUser = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Global$Model$ResendInviteDialog = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$EditingUsers$Update$resetForm = function (editingUsers) {
    return _Utils_update(editingUsers, {
      iP: '',
      hI: '',
      mq: $elm$core$Maybe$Nothing,
      zL: '',
      nV: ''
    });
  };

  var $author$project$Ui$EditingUsers$Update$update = F2(function (_v0, msg) {
    var time = _v0.EM;
    var global = _v0.qC;
    var editingUsers = _v0.xm;

    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(editingUsers, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var nextEditingUsers = msg.a;
        return _Utils_Tuple3(nextEditingUsers, $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var user = msg.a.Fl;
        var companyId = msg.a.b9;
        var initialRole = msg.a.yq;
        return _Utils_Tuple3(_Utils_update(editingUsers, {
          nO: $elm$core$Maybe$Just(initialRole),
          nW: ''
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$EditUser({
          b9: companyId,
          Fl: user
        })))]));

      case 3:
        var companyId = msg.a.b9;
        var invitation = msg.a.i_;
        var email = msg.a.iP;
        return _Utils_Tuple3(_Utils_update(editingUsers, {
          nO: $elm$core$Maybe$Just(invitation.gz),
          nW: ''
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$EditInvitation({
          b9: companyId,
          iP: email,
          i_: invitation
        })))]));

      case 4:
        var companyId = msg.a.b9;
        var invitation = msg.a.i_;
        var email = msg.a.iP;
        return _Utils_Tuple3(_Utils_update(editingUsers, {
          nO: $elm$core$Maybe$Just(invitation.gz),
          nW: ''
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$ResendInviteDialog({
          b9: companyId,
          iP: email,
          i_: invitation
        })))]));

      default:
        return _Utils_Tuple3($author$project$Ui$EditingUsers$Update$resetForm(editingUsers), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$Legal$Legal$update = F4(function (global, maybeIdToken, msg, state) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));

      case 2:
        var route = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(route)]));

      case 3:
        var route = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Do(route)]));

      default:
        var option = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          l8: option
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Remote$Msg$OpenQuickBooksAccounting = F2(function (a, b) {
    return {
      $: 18,
      a: a,
      b: b
    };
  });
  var $author$project$Types$Mock$company = {
    bW: {
      pu: $elm$core$Maybe$Nothing,
      pF: $elm$core$Maybe$Nothing,
      pH: $elm$core$Maybe$Nothing,
      qD: $elm$core$Maybe$Nothing,
      rE: $elm$core$Maybe$Nothing,
      sF: $elm$core$Maybe$Nothing,
      tI: $elm$core$Maybe$Nothing
    },
    pa: $elm$core$Maybe$Nothing,
    pe: $elm$core$Maybe$Nothing,
    pg: $krisajenkins$remotedata$RemoteData$NotAsked,
    iK: $elm$time$Time$millisToPosix(34254),
    eO: $krisajenkins$remotedata$RemoteData$NotAsked,
    F: 'company-id',
    b_: false,
    q_: $krisajenkins$remotedata$RemoteData$NotAsked,
    zL: 'Company name',
    b0: 0,
    b1: 0,
    b2: 0,
    nT: $krisajenkins$remotedata$RemoteData$NotAsked,
    db: $krisajenkins$remotedata$RemoteData$NotAsked,
    ti: $krisajenkins$remotedata$RemoteData$NotAsked,
    aB: 2,
    t$: $elm$core$Maybe$Nothing
  };

  var $author$project$Ui$OnboardingCompany$Update$getNextRoute = function (currentOnboardingRoute) {
    switch (currentOnboardingRoute) {
      case 0:
        return 1;

      case 1:
        return 2;

      case 2:
        return 3;

      default:
        return 3;
    }
  };

  var $author$project$Ui$OnboardingCompany$Update$getPreviousRoute = function (currentOnboardingRoute) {
    switch (currentOnboardingRoute) {
      case 0:
        return 0;

      case 1:
        return 0;

      case 2:
        return 1;

      default:
        return 2;
    }
  };

  var $author$project$Views$Routed$OnboardingCompanyBranch$toLatestCompany = function (sessionStatus) {
    if (sessionStatus.$ === 3) {
      var session = sessionStatus.a;
      return $author$project$Types$UserSession$toFirstCompanyIdForThisUser(session);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$EditingCompany$Msg$ReceivedAddressDetails = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$EditingCompany$Msg$ReceivedCountryCheckAfterAddressPredictions = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$Msg$ReceivedCountryPredictions = function (a) {
    return {
      $: 11,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$Msg$ReceivedTimeZonePredictions = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Geocoding$Locality = 11;

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName = function (_v0) {
    var shortName = _v0.D3;
    var longName = _v0.zh;
    return A3($elm$core$Maybe$map2, F2(function (shortName_, longName_) {
      return _Utils_Tuple2(shortName_, longName_);
    }), shortName, longName);
  };

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getCity = function (_v0) {
    var addressComponents = _v0.fs;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.gP;
    }, $elm$core$List$member(11)), addressComponents)));
  };

  var $author$project$ElmFramework$Lib$Geocoding$Country = 4;

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getCountry = function (_v0) {
    var addressComponents = _v0.fs;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.gP;
    }, $elm$core$List$member(4)), addressComponents)));
  };

  var $author$project$ElmFramework$Feature$Places$Places$getPlacePredictions = _Platform_outgoingPort('getPlacePredictions', $elm$json$Json$Encode$string);

  var $author$project$ElmFramework$Lib$Geocoding$PostalCode = 21;

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getPostalCode = function (_v0) {
    var addressComponents = _v0.fs;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.gP;
    }, $elm$core$List$member(21)), addressComponents)));
  };

  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel1 = 5;

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getState = function (_v0) {
    var addressComponents = _v0.fs;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.gP;
    }, $elm$core$List$member(5)), addressComponents)));
  };

  var $author$project$ElmFramework$Lib$Geocoding$Route = 1;
  var $author$project$ElmFramework$Lib$Geocoding$StreetAddress = 0;

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetAddress = function (_v0) {
    var addressComponents = _v0.fs;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.gP;
    }, $elm$core$List$any(function (addressType) {
      return A2($elm$core$List$member, addressType, _List_fromArray([0, 1]));
    })), addressComponents)));
  };

  var $author$project$ElmFramework$Lib$Geocoding$StreetNumber = 26;

  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetNumber = function (_v0) {
    var addressComponents = _v0.fs;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.gP;
    }, $elm$core$List$member(26)), addressComponents)));
  };

  var $author$project$ElmFramework$Lib$Geocoding$PlaceId = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$Geocoding$ReverseGeocodingRequest = F5(function (requestInfo, language, resultType, locationType, apiKey) {
    return {
      oY: apiKey,
      l2: language,
      mh: locationType,
      s_: requestInfo,
      s2: resultType
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestForPlaceId = F2(function (key, placeId) {
    return A5($author$project$ElmFramework$Lib$Geocoding$ReverseGeocodingRequest, placeId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, key);
  });
  var $author$project$Api$GraphqlSchema$InputObject$Country_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildCountry_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      pw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      xP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      c: optionals____.c,
      pw: optionals____.pw,
      xP: optionals____.xP,
      d: optionals____.d,
      Ch: optionals____.Ch
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$buildString_comparison_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      e: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      G: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      H: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      q$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ge: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      I: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      J: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      h: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      i: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      go: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gv: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      e: optionals____.e,
      G: optionals____.G,
      H: optionals____.H,
      f0: optionals____.f0,
      f: optionals____.f,
      q$: optionals____.q$,
      g: optionals____.g,
      ge: optionals____.ge,
      I: optionals____.I,
      J: optionals____.J,
      h: optionals____.h,
      gk: optionals____.gk,
      i: optionals____.i,
      gl: optionals____.gl,
      gm: optionals____.gm,
      gn: optionals____.gn,
      go: optionals____.go,
      gv: optionals____.gv,
      gE: optionals____.gE
    };
  };

  var $author$project$Api$GraphqlSchema$Enum$Country_select_column$toString = function (enum____) {
    if (!enum____) {
      return 'code';
    } else {
      return 'full_name';
    }
  };

  var $author$project$Api$GraphqlSchema$Query$country = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Country_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCountry_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeCountry_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'country', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Api$searchCountries = F4(function (apiEndpoint, idToken, text, tag) {
    var orArgument = $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([$author$project$Api$GraphqlSchema$InputObject$buildCountry_bool_exp(function (buildCountryOptionalArguments2) {
      return _Utils_update(buildCountryOptionalArguments2, {
        xP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildString_comparison_exp(function (o) {
          return _Utils_update(o, {
            q$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(text)
          });
        }))
      });
    }), $author$project$Api$GraphqlSchema$InputObject$buildCountry_bool_exp(function (buildCountryOptionalArguments3) {
      return _Utils_update(buildCountryOptionalArguments3, {
        pw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildString_comparison_exp(function (o2) {
          return _Utils_update(o2, {
            q$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(text)
          });
        }))
      });
    })]));
    var whereArgument = $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildCountry_bool_exp(function (buildCountryOptionalArguments) {
      return _Utils_update(buildCountryOptionalArguments, {
        Ch: orArgument
      });
    }));

    var optionalArguments = function (countryOptionalArguments) {
      return _Utils_update(countryOptionalArguments, {
        zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10),
        gU: whereArgument
      });
    };

    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$country, optionalArguments, $author$project$Api$Schema$country)));
  });
  var $author$project$Api$GraphqlSchema$Object$TimeZonesQuery$search = F3(function (fillInOptionals____, requiredArgs____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      uY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      C7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'asOf', filledInOptionals____.uY, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.vX;
    }, $author$project$Api$ScalarCodecs$codecs)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'results', filledInOptionals____.C7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'search', _Utils_ap(optionalArgs____, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'text', requiredArgs____.EH, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)])), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });

  var $author$project$Api$GraphqlSchema$Query$timeZones = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'timeZones', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$searchTimeZones = F5(function (apiEndpoint, idToken, currTime, text, tag) {
    var timeZonesSelectionSet = A3($author$project$Api$GraphqlSchema$Object$TimeZonesQuery$search, $elm$core$Basics$always({
      uY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(currTime),
      C7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10)
    }), {
      EH: text
    }, $author$project$Api$Schema$timeZone);
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$timeZones(timeZonesSelectionSet)));
  });
  var $elm$http$Http$expectStringResponse = F2(function (toMsg, toResult) {
    return A3(_Http_expect, '', $elm$core$Basics$identity, A2($elm$core$Basics$composeR, toResult, toMsg));
  });

  var $elm$http$Http$BadBody = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $elm$http$Http$BadStatus = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $elm$http$Http$BadUrl = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$http$Http$NetworkError = {
    $: 2
  };
  var $elm$http$Http$Timeout = {
    $: 1
  };
  var $elm$http$Http$resolve = F2(function (toResult, response) {
    switch (response.$) {
      case 0:
        var url = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadUrl(url));

      case 1:
        return $elm$core$Result$Err($elm$http$Http$Timeout);

      case 2:
        return $elm$core$Result$Err($elm$http$Http$NetworkError);

      case 3:
        var metadata = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.tG));

      default:
        var body = response.b;
        return A2($elm$core$Result$mapError, $elm$http$Http$BadBody, toResult(body));
    }
  });
  var $elm$http$Http$expectJson = F2(function (toMsg, decoder) {
    return A2($elm$http$Http$expectStringResponse, toMsg, $elm$http$Http$resolve(function (string) {
      return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeString, decoder, string));
    }));
  });

  var $elm$http$Http$Request = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$http$Http$State = F2(function (reqs, subs) {
    return {
      sZ: reqs,
      tP: subs
    };
  });
  var $elm$http$Http$init = $elm$core$Task$succeed(A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
  var $elm$http$Http$updateReqs = F3(function (router, cmds, reqs) {
    updateReqs: while (true) {
      if (!cmds.b) {
        return $elm$core$Task$succeed(reqs);
      } else {
        var cmd = cmds.a;
        var otherCmds = cmds.b;

        if (!cmd.$) {
          var tracker = cmd.a;

          var _v2 = A2($elm$core$Dict$get, tracker, reqs);

          if (_v2.$ === 1) {
            var $temp$router = router,
                $temp$cmds = otherCmds,
                $temp$reqs = reqs;
            router = $temp$router;
            cmds = $temp$cmds;
            reqs = $temp$reqs;
            continue updateReqs;
          } else {
            var pid = _v2.a;
            return A2($elm$core$Task$andThen, function (_v3) {
              return A3($elm$http$Http$updateReqs, router, otherCmds, A2($elm$core$Dict$remove, tracker, reqs));
            }, $elm$core$Process$kill(pid));
          }
        } else {
          var req = cmd.a;
          return A2($elm$core$Task$andThen, function (pid) {
            var _v4 = req.t8;

            if (_v4.$ === 1) {
              return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
            } else {
              var tracker = _v4.a;
              return A3($elm$http$Http$updateReqs, router, otherCmds, A3($elm$core$Dict$insert, tracker, pid, reqs));
            }
          }, $elm$core$Process$spawn(A3(_Http_toTask, router, $elm$core$Platform$sendToApp(router), req)));
        }
      }
    }
  });
  var $elm$http$Http$onEffects = F4(function (router, cmds, subs, state) {
    return A2($elm$core$Task$andThen, function (reqs) {
      return $elm$core$Task$succeed(A2($elm$http$Http$State, reqs, subs));
    }, A3($elm$http$Http$updateReqs, router, cmds, state.sZ));
  });
  var $elm$http$Http$maybeSend = F4(function (router, desiredTracker, progress, _v0) {
    var actualTracker = _v0.a;
    var toMsg = _v0.b;
    return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(A2($elm$core$Platform$sendToApp, router, toMsg(progress))) : $elm$core$Maybe$Nothing;
  });
  var $elm$http$Http$onSelfMsg = F3(function (router, _v0, state) {
    var tracker = _v0.a;
    var progress = _v0.b;
    return A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$succeed(state);
    }, $elm$core$Task$sequence(A2($elm$core$List$filterMap, A3($elm$http$Http$maybeSend, router, tracker, progress), state.tP)));
  });

  var $elm$http$Http$Cancel = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $elm$http$Http$cmdMap = F2(function (func, cmd) {
    if (!cmd.$) {
      var tracker = cmd.a;
      return $elm$http$Http$Cancel(tracker);
    } else {
      var r = cmd.a;
      return $elm$http$Http$Request({
        uF: r.uF,
        d0: r.d0,
        xD: A2(_Http_mapExpect, func, r.xD),
        x5: r.x5,
        zw: r.zw,
        ow: r.ow,
        t8: r.t8,
        Fh: r.Fh
      });
    }
  });
  var $elm$http$Http$MySub = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$subMap = F2(function (func, _v0) {
    var tracker = _v0.a;
    var toMsg = _v0.b;
    return A2($elm$http$Http$MySub, tracker, A2($elm$core$Basics$composeR, toMsg, func));
  });
  _Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);

  var $elm$http$Http$command = _Platform_leaf('Http');

  var $elm$http$Http$subscription = _Platform_leaf('Http');

  var $elm$http$Http$request = function (r) {
    return $elm$http$Http$command($elm$http$Http$Request({
      uF: false,
      d0: r.d0,
      xD: r.xD,
      x5: r.x5,
      zw: r.zw,
      ow: r.ow,
      t8: r.t8,
      Fh: r.Fh
    }));
  };

  var $elm$http$Http$get = function (r) {
    return $elm$http$Http$request({
      d0: $elm$http$Http$emptyBody,
      xD: r.xD,
      x5: _List_Nil,
      zw: 'GET',
      ow: $elm$core$Maybe$Nothing,
      t8: $elm$core$Maybe$Nothing,
      Fh: r.Fh
    });
  };

  var $author$project$ElmFramework$Lib$Geocoding$Response = F2(function (status, results) {
    return {
      C7: results,
      Y: status
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$GeocodingResult = F5(function (addressComponents, formattedAddress, geometry, types, placeId) {
    return {
      fs: addressComponents,
      xN: formattedAddress,
      xX: geometry,
      sC: placeId,
      gP: types
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$AddressComponent = F3(function (longName, shortName, types) {
    return {
      zh: longName,
      D3: shortName,
      gP: types
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$OtherComponent = 37;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel2 = 6;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel3 = 7;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel4 = 8;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel5 = 9;
  var $author$project$ElmFramework$Lib$Geocoding$Airport = 23;
  var $author$project$ElmFramework$Lib$Geocoding$BusStation = 33;
  var $author$project$ElmFramework$Lib$Geocoding$ColloquialArea = 10;
  var $author$project$ElmFramework$Lib$Geocoding$Establishment = 29;
  var $author$project$ElmFramework$Lib$Geocoding$Floor = 27;
  var $author$project$ElmFramework$Lib$Geocoding$Intersection = 2;
  var $author$project$ElmFramework$Lib$Geocoding$NaturalFeature = 22;
  var $author$project$ElmFramework$Lib$Geocoding$Neighborhood = 18;
  var $author$project$ElmFramework$Lib$Geocoding$Park = 24;
  var $author$project$ElmFramework$Lib$Geocoding$Parking = 31;
  var $author$project$ElmFramework$Lib$Geocoding$PointOfInterest = 30;
  var $author$project$ElmFramework$Lib$Geocoding$Political = 3;
  var $author$project$ElmFramework$Lib$Geocoding$PostBox = 25;
  var $author$project$ElmFramework$Lib$Geocoding$PostalCodeSuffix = 36;
  var $author$project$ElmFramework$Lib$Geocoding$PostalTown = 32;
  var $author$project$ElmFramework$Lib$Geocoding$Premise = 19;
  var $author$project$ElmFramework$Lib$Geocoding$Room = 28;
  var $author$project$ElmFramework$Lib$Geocoding$Sublocality = 12;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel1 = 13;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel2 = 14;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel3 = 15;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel4 = 16;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel5 = 17;
  var $author$project$ElmFramework$Lib$Geocoding$Subpremise = 20;
  var $author$project$ElmFramework$Lib$Geocoding$TrainStation = 34;
  var $author$project$ElmFramework$Lib$Geocoding$TransitStation = 35;

  var $author$project$ElmFramework$Lib$Geocoding$componentTypeList = _List_fromArray([_Utils_Tuple2('street_address', 0), _Utils_Tuple2('route', 1), _Utils_Tuple2('intersection', 2), _Utils_Tuple2('political', 3), _Utils_Tuple2('country', 4), _Utils_Tuple2('administrative_area_level_1', 5), _Utils_Tuple2('administrative_area_level_2', 6), _Utils_Tuple2('administrative_area_level_3', 7), _Utils_Tuple2('administrative_area_level_4', 8), _Utils_Tuple2('administrative_area_level_5', 9), _Utils_Tuple2('colloquial_area', 10), _Utils_Tuple2('locality', 11), _Utils_Tuple2('sublocality', 12), _Utils_Tuple2('sublocality_level_1', 13), _Utils_Tuple2('sublocality_level_2', 14), _Utils_Tuple2('sublocality_level_3', 15), _Utils_Tuple2('sublocality_level_4', 16), _Utils_Tuple2('sublocality_level_5', 17), _Utils_Tuple2('neighborhood', 18), _Utils_Tuple2('premise', 19), _Utils_Tuple2('subpremise', 20), _Utils_Tuple2('postal_code', 21), _Utils_Tuple2('natural_feature', 22), _Utils_Tuple2('airport', 23), _Utils_Tuple2('park', 24), _Utils_Tuple2('post_box', 25), _Utils_Tuple2('street_number', 26), _Utils_Tuple2('floor', 27), _Utils_Tuple2('room', 28), _Utils_Tuple2('establishment', 29), _Utils_Tuple2('point_of_interest', 30), _Utils_Tuple2('parking', 31), _Utils_Tuple2('postal_town', 32), _Utils_Tuple2('bus_station', 33), _Utils_Tuple2('train_station', 34), _Utils_Tuple2('transit_station', 35), _Utils_Tuple2('postal_code_suffix', 36)]);

  var $author$project$ElmFramework$Lib$Geocoding$componentTypeMap = $elm$core$Dict$fromList($author$project$ElmFramework$Lib$Geocoding$componentTypeList);

  var $author$project$ElmFramework$Lib$Geocoding$stringToComponentType = function (str) {
    return A2($elm$core$Maybe$withDefault, 37, A2($elm$core$Dict$get, str, $author$project$ElmFramework$Lib$Geocoding$componentTypeMap));
  };

  var $author$project$ElmFramework$Lib$Geocoding$mapComponentType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$ElmFramework$Lib$Geocoding$stringToComponentType);
  var $author$project$ElmFramework$Lib$Geocoding$typeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Geocoding$mapComponentType, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Geocoding$typeListDecoder = $elm$json$Json$Decode$list($author$project$ElmFramework$Lib$Geocoding$typeDecoder);
  var $author$project$ElmFramework$Lib$Geocoding$addressComponentDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $author$project$ElmFramework$Lib$Geocoding$typeListDecoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'short_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'long_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$AddressComponent))));
  var $author$project$ElmFramework$Lib$Geocoding$addressComponentListDecoder = $elm$json$Json$Decode$list($author$project$ElmFramework$Lib$Geocoding$addressComponentDecoder);
  var $author$project$ElmFramework$Lib$Geocoding$Geometry = F3(function (location, locationType, viewport) {
    return {
      rm: location,
      mh: locationType,
      FA: viewport
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$Location = F2(function (latitude, longitude) {
    return {
      l4: latitude,
      mj: longitude
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$locationDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lng', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lat', $elm$json$Json$Decode$float, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Location)));
  var $author$project$ElmFramework$Lib$Geocoding$OtherLocationType = 4;
  var $author$project$ElmFramework$Lib$Geocoding$Approximate = 3;
  var $author$project$ElmFramework$Lib$Geocoding$GeometricCenter = 2;
  var $author$project$ElmFramework$Lib$Geocoding$RangeInterpolated = 1;
  var $author$project$ElmFramework$Lib$Geocoding$Rooftop = 0;

  var $author$project$ElmFramework$Lib$Geocoding$locationTypeList = _List_fromArray([_Utils_Tuple2('ROOFTOP', 0), _Utils_Tuple2('RANGE_INTERPOLATED', 1), _Utils_Tuple2('GEOMETRIC_CENTER', 2), _Utils_Tuple2('APPROXIMATE', 3)]);

  var $author$project$ElmFramework$Lib$Geocoding$locationTypeMap = $elm$core$Dict$fromList($author$project$ElmFramework$Lib$Geocoding$locationTypeList);

  var $author$project$ElmFramework$Lib$Geocoding$stringToLocationType = function (str) {
    return A2($elm$core$Maybe$withDefault, 4, A2($elm$core$Dict$get, str, $author$project$ElmFramework$Lib$Geocoding$locationTypeMap));
  };

  var $author$project$ElmFramework$Lib$Geocoding$mapLocationType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$ElmFramework$Lib$Geocoding$stringToLocationType);
  var $author$project$ElmFramework$Lib$Geocoding$locationTypeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Geocoding$mapLocationType, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Geocoding$Viewport = F2(function (northeast, southwest) {
    return {
      zV: northeast,
      Ea: southwest
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$viewportDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'southwest', $author$project$ElmFramework$Lib$Geocoding$locationDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'northeast', $author$project$ElmFramework$Lib$Geocoding$locationDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Viewport)));
  var $author$project$ElmFramework$Lib$Geocoding$geometryDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'viewport', $author$project$ElmFramework$Lib$Geocoding$viewportDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_type', $author$project$ElmFramework$Lib$Geocoding$locationTypeDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $author$project$ElmFramework$Lib$Geocoding$locationDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Geometry))));
  var $author$project$ElmFramework$Lib$Geocoding$resultDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'place_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $author$project$ElmFramework$Lib$Geocoding$typeListDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'geometry', $author$project$ElmFramework$Lib$Geocoding$geometryDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'formatted_address', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_components', $author$project$ElmFramework$Lib$Geocoding$addressComponentListDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$GeocodingResult))))));
  var $author$project$ElmFramework$Lib$Geocoding$resultListDecoder = $elm$json$Json$Decode$list($author$project$ElmFramework$Lib$Geocoding$resultDecoder);
  var $author$project$ElmFramework$Lib$Geocoding$GeocodingOk = 0;
  var $author$project$ElmFramework$Lib$Geocoding$InvalidRequest = 4;
  var $author$project$ElmFramework$Lib$Geocoding$OverQueryLimit = 2;
  var $author$project$ElmFramework$Lib$Geocoding$RequestDenied = 3;
  var $author$project$ElmFramework$Lib$Geocoding$UnknownError = 5;
  var $author$project$ElmFramework$Lib$Geocoding$ZeroResults = 1;

  var $author$project$ElmFramework$Lib$Geocoding$mapStatus = function (str) {
    switch (str) {
      case 'OK':
        return $elm$json$Json$Decode$succeed(0);

      case 'ZERO_RESULTS':
        return $elm$json$Json$Decode$succeed(1);

      case 'OVER_QUERY_LIMIT':
        return $elm$json$Json$Decode$succeed(2);

      case 'REQUEST_DENIED':
        return $elm$json$Json$Decode$succeed(3);

      case 'INVALID_REQUEST':
        return $elm$json$Json$Decode$succeed(4);

      case 'UNKNOWN_ERROR':
        return $elm$json$Json$Decode$succeed(5);

      default:
        return $elm$json$Json$Decode$fail('really, really, unknown error');
    }
  };

  var $author$project$ElmFramework$Lib$Geocoding$statusDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Geocoding$mapStatus, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Geocoding$responseDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'results', $author$project$ElmFramework$Lib$Geocoding$resultListDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$ElmFramework$Lib$Geocoding$statusDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Response)));
  var $author$project$ElmFramework$Lib$Geocoding$geocodingUrl = 'https://maps.googleapis.com/maps/api/geocode/json';

  var $author$project$ElmFramework$Lib$Geocoding$componentTypeToString = function (component) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$first, $elm$core$List$head(A2($elm$core$List$filter, function (_v0) {
      var c = _v0.b;
      return _Utils_eq(component, c);
    }, $author$project$ElmFramework$Lib$Geocoding$componentTypeList))));
  };

  var $author$project$ElmFramework$Lib$Geocoding$locationTypeToString = function (locationType) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$first, $elm$core$List$head(A2($elm$core$List$filter, function (_v0) {
      var loc = _v0.b;
      return _Utils_eq(locationType, loc);
    }, $author$project$ElmFramework$Lib$Geocoding$locationTypeList))));
  };

  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestInfoParameter = function (info) {
    var id = info;
    return _Utils_Tuple2('place_id', id);
  };

  var $author$project$ElmFramework$Lib$Geocoding$singleton = function (x) {
    return _List_fromArray([x]);
  };

  var $author$project$ElmFramework$Lib$Geocoding$toReverseRequestParameters = function (req) {
    return $elm$core$List$concat(_List_fromArray([_List_fromArray([_Utils_Tuple2('key', req.oY)]), _List_fromArray([$author$project$ElmFramework$Lib$Geocoding$reverseRequestInfoParameter(req.s_)]), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$singleton, $elm$core$Tuple$pair('language')), req.l2)), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$singleton, $elm$core$Tuple$pair('result_type')), $elm$core$String$join('|')), $elm$core$List$map($author$project$ElmFramework$Lib$Geocoding$componentTypeToString)), req.s2)), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$singleton, $elm$core$Tuple$pair('location_type')), $elm$core$String$join('|')), $elm$core$List$map($author$project$ElmFramework$Lib$Geocoding$locationTypeToString)), req.mh))]));
  };

  var $author$project$ElmFramework$Lib$Geocoding$replace = F2(function (old, _new) {
    return A2($elm$core$Basics$composeR, $elm$core$String$split(old), $elm$core$String$join(_new));
  });
  var $author$project$ElmFramework$Lib$Geocoding$queryEscape = A2($elm$core$Basics$composeR, $elm$url$Url$percentEncode, A2($author$project$ElmFramework$Lib$Geocoding$replace, '%20', '+'));

  var $author$project$ElmFramework$Lib$Geocoding$queryPair = function (_v0) {
    var key = _v0.a;
    var value = _v0.b;
    return $author$project$ElmFramework$Lib$Geocoding$queryEscape(key) + ('=' + $author$project$ElmFramework$Lib$Geocoding$queryEscape(value));
  };

  var $author$project$ElmFramework$Lib$Geocoding$joinUrlEncoded = function (args) {
    return A2($elm$core$String$join, '&', A2($elm$core$List$map, $author$project$ElmFramework$Lib$Geocoding$queryPair, args));
  };

  var $author$project$ElmFramework$Lib$Geocoding$url = F2(function (base, params) {
    return $elm$core$List$isEmpty(params) ? base : base + ('?' + $author$project$ElmFramework$Lib$Geocoding$joinUrlEncoded(params));
  });
  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestUrl = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$url($author$project$ElmFramework$Lib$Geocoding$geocodingUrl), $author$project$ElmFramework$Lib$Geocoding$toReverseRequestParameters);
  var $author$project$ElmFramework$Lib$Geocoding$sendReverseRequest = F2(function (toMessage, req) {
    return $elm$http$Http$get({
      xD: A2($elm$http$Http$expectJson, toMessage, $author$project$ElmFramework$Lib$Geocoding$responseDecoder),
      Fh: $author$project$ElmFramework$Lib$Geocoding$reverseRequestUrl(req)
    });
  });
  var $author$project$Ui$EditingCompany$Update$update = F2(function (_v0, msg) {
    var time = _v0.EM;
    var global = _v0.qC;
    var editingCompany = _v0.xj;

    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var nextEditingCompany = msg.a;
        return _Utils_Tuple3(nextEditingCompany, $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var searchText = msg.a;
        var cmd = A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Platform$Cmd$none, $author$project$ElmFramework$Feature$Places$Places$getPlacePredictions(searchText), $elm$core$String$isEmpty(searchText));
        return _Utils_Tuple3(editingCompany, cmd, _List_Nil);

      case 3:
        var input = msg.a.W;
        var placePredictions = msg.a.sD;

        if (_Utils_eq(input, editingCompany.jJ)) {
          if (placePredictions.$ === 1) {
            return _Utils_Tuple3(_Utils_update(editingCompany, {
              ke: $elm$core$Maybe$Nothing,
              nZ: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          } else {
            var addresses = placePredictions.a;
            return _Utils_Tuple3(_Utils_update(editingCompany, {
              ke: $elm$core$Maybe$Just(addresses)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        } else {
          return _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil);
        }

      case 4:
        var session = msg.a;
        var selectedAddress = msg.b;
        return _Utils_Tuple3(_Utils_update(editingCompany, {
          jJ: selectedAddress.sB,
          nZ: $elm$core$Maybe$Just(selectedAddress)
        }), A2($author$project$ElmFramework$Lib$Geocoding$sendReverseRequest, $author$project$Ui$EditingCompany$Msg$ReceivedAddressDetails(session), A2($author$project$ElmFramework$Lib$Geocoding$reverseRequestForPlaceId, global.dy.xL.oY, selectedAddress.sC)), _List_Nil);

      case 7:
        var sessionStatus = msg.a;
        var result = msg.b;

        if (result.$ === 1) {
          return _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          var status = result.a.Y;
          var results = result.a.C7;

          if (!status) {
            var placeResult = $elm$core$List$head(results);
            var postalCode = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$getPostalCode, placeResult)));
            var state = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$getState, placeResult)));
            var street = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetAddress, placeResult)));
            var number = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetNumber, placeResult)));
            var country = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$getCountry, placeResult)));
            var city = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$getCity, placeResult)));
            return _Utils_Tuple3(_Utils_update(editingCompany, {
              pu: city,
              iI: country,
              rE: number,
              Ej: state,
              tI: street,
              FS: postalCode
            }), function () {
              switch (sessionStatus.$) {
                case 2:
                  var auth = sessionStatus.a.u_;
                  return A4($author$project$Api$Api$searchCountries, global.dy.oZ, auth.d5, country, $author$project$Ui$EditingCompany$Msg$ReceivedCountryCheckAfterAddressPredictions);

                case 3:
                  var session = sessionStatus.a;
                  return A4($author$project$Api$Api$searchCountries, global.dy.oZ, session.u_.d5, country, $author$project$Ui$EditingCompany$Msg$ReceivedCountryCheckAfterAddressPredictions);

                default:
                  return $elm$core$Platform$Cmd$none;
              }
            }(), _List_Nil);
          } else {
            return _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }

      case 6:
        var sessionStatus = msg.a;
        var text = msg.b;
        return _Utils_Tuple3(editingCompany, function () {
          switch (sessionStatus.$) {
            case 2:
              var auth = sessionStatus.a.u_;
              return A5($author$project$Api$Api$searchTimeZones, global.dy.oZ, auth.d5, time, text, $author$project$Ui$EditingCompany$Msg$ReceivedTimeZonePredictions);

            case 3:
              var session = sessionStatus.a;
              return A5($author$project$Api$Api$searchTimeZones, global.dy.oZ, session.u_.d5, time, text, $author$project$Ui$EditingCompany$Msg$ReceivedTimeZonePredictions);

            default:
              return $elm$core$Platform$Cmd$none;
          }
        }(), _List_Nil);

      case 8:
        var timezonesResult = msg.a;
        return A2($elm$core$Result$withDefault, _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Result$map, function (timezones) {
          return _Utils_Tuple3(_Utils_update(editingCompany, {
            ov: $elm$core$Maybe$Just(timezones)
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }, timezonesResult));

      case 5:
        var timezone = msg.a;
        return _Utils_Tuple3(_Utils_update(editingCompany, {
          DQ: $elm$core$Maybe$Just(timezone)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 10:
        var sessionStatus = msg.a;
        var text = msg.b;
        return _Utils_Tuple3(editingCompany, function () {
          switch (sessionStatus.$) {
            case 2:
              var auth = sessionStatus.a.u_;
              return A4($author$project$Api$Api$searchCountries, global.dy.oZ, auth.d5, text, $author$project$Ui$EditingCompany$Msg$ReceivedCountryPredictions);

            case 3:
              var session = sessionStatus.a;
              return A4($author$project$Api$Api$searchCountries, global.dy.oZ, session.u_.d5, text, $author$project$Ui$EditingCompany$Msg$ReceivedCountryPredictions);

            default:
              return $elm$core$Platform$Cmd$none;
          }
        }(), _List_Nil);

      case 11:
        var countriesResult = msg.a;
        return A2($elm$core$Result$withDefault, _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Result$map, function (countries) {
          return _Utils_Tuple3(_Utils_update(editingCompany, {
            kP: $elm$core$Maybe$Just(countries)
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }, countriesResult));

      case 9:
        var country = msg.a;
        return _Utils_Tuple3(_Utils_update(editingCompany, {
          DN: $elm$core$Maybe$Just(country)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var countriesResult = msg.a;

        if (!countriesResult.$) {
          var countries = countriesResult.a;
          return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr, $elm$core$Maybe$Nothing, 'Country could not be initialized, please select it manually.', _List_Nil)])), A2($elm$core$Maybe$map, function (country) {
            return _Utils_Tuple3(_Utils_update(editingCompany, {
              DN: $elm$core$Maybe$Just(country)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }, $elm$core$List$head(countries)));
        } else {
          return _Utils_Tuple3(editingCompany, $elm$core$Platform$Cmd$none, _List_Nil);
        }

    }
  });
  var $author$project$Ui$OnboardingCompany$Update$update = F4(function (time, global, model, msg) {
    var config = global.dy;
    var onboardingCompany = model.Ca;

    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var editCompanyMessage = msg.a;

        var _v1 = A2($author$project$Ui$EditingCompany$Update$update, {
          xj: model.Ca,
          qC: global,
          EM: time
        }, editCompanyMessage);

        var nextCompanyInfo = _v1.a;
        var cmd = _v1.b;
        var topMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
          Ca: nextCompanyInfo
        }), A2($elm$core$Platform$Cmd$map, $author$project$Ui$OnboardingCompany$Msg$EditingCompanyMsg, cmd), topMsgs);

      case 2:
        var currRoute = msg.a;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany($author$project$Ui$OnboardingCompany$Update$getNextRoute(currRoute)))]));

      case 3:
        var userSessionStatus = msg.a;

        var _v2 = $author$project$Views$Routed$OnboardingCompanyBranch$toLatestCompany(userSessionStatus);

        if (!_v2.$) {
          var company = _v2.a;

          var newRouteTopMsgs = function () {
            var _v3 = company.pa;

            if (!_v3.$) {
              var scenarioId = _v3.a;
              return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$fromCompany, scenarioId, company), $author$project$Route$CashboardRoute$CashboardHome)));
            } else {
              return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))]));
            }
          }();

          return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([newRouteTopMsgs]));
        } else {
          return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Fail to fetch company for user', _List_Nil)]));
        }

      case 4:
        var currRoute = msg.a;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany($author$project$Ui$OnboardingCompany$Update$getPreviousRoute(currRoute)))]));

      default:
        var state = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          kT: state
        }), $elm$core$Platform$Cmd$none, function () {
          if (state.$ === 1) {
            var accountingApp = state.a;
            return _List_fromArray([$author$project$Msg$sendRemoteMsg(A2($author$project$Remote$Msg$OpenQuickBooksAccounting, $author$project$Types$Mock$company.F, $elm$core$Maybe$Nothing))]);
          } else {
            return _List_Nil;
          }
        }());
    }
  });

  var $author$project$Types$EditingScenario$EditingScenario$AddBlock = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$EditingScenario$EditingScenario$setBlocks = F2(function (editingScenario, buildingBlockIds) {
    return _Utils_update(editingScenario, {
      bX: A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$BuildingBlock$unwrapBuildingBlockId, A2($elm$core$List$map, function (id) {
        return _Utils_Tuple2(id, $author$project$Types$EditingScenario$EditingScenario$AddBlock({
          yO: true
        }));
      }, buildingBlockIds))
    });
  });

  var $author$project$Types$BuildingBlock$createBuildingBlocksDict = function (buildingBlocks) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$BuildingBlock$unwrapBuildingBlockId, A2($elm$core$List$map, function (bb) {
      return _Utils_Tuple2(bb.F, bb);
    }, buildingBlocks));
  };

  var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;

  var $author$project$Types$Filters$ageToMillis = function (age) {
    var day = 24 * 60 * 60 * 1000;

    switch (age) {
      case 0:
        return 7 * day;

      case 1:
        return 30 * day;

      default:
        return 90 * day;
    }
  };

  var $author$project$Types$Filters$ageChecker = F3(function (createdAt, now, allowedAge) {
    var age = $elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(createdAt);
    return _Utils_cmp(age, $author$project$Types$Filters$ageToMillis(allowedAge)) < 1;
  });
  var $author$project$ElmFramework$Lib$PivotDict$getById2 = F2(function (id2, _v0) {
    var dict2 = _v0.dz;
    var serializeId1 = _v0.d8;
    return $turboMaCk$any_dict$Dict$Any$values(A2($elm$core$Maybe$withDefault, $turboMaCk$any_dict$Dict$Any$empty(serializeId1), A2($turboMaCk$any_dict$Dict$Any$get, id2, dict2)));
  });

  var $turboMaCk$any_dict$Dict$Any$isEmpty = function (_v0) {
    var dict = _v0.bT;
    return $elm$core$Dict$isEmpty(dict);
  };

  var $turboMaCk$any_set$Set$Any$isEmpty = function (_v0) {
    var dict = _v0;
    return $turboMaCk$any_dict$Dict$Any$isEmpty(dict);
  };

  var $author$project$Types$Filters$textSearchChecker = F2(function (text, textSearch) {
    return A2($elm$core$String$contains, $elm$core$String$toLower(textSearch), $elm$core$String$toLower(text));
  });

  var $author$project$ElmFramework$Lib$PivotDict$toList = function (_v0) {
    var payload = _v0;
    return $elm$core$List$concat(A2($elm$core$List$map, $turboMaCk$any_dict$Dict$Any$values, $turboMaCk$any_dict$Dict$Any$values(payload.cG)));
  };

  var $author$project$Types$Filters$theQuickEditsFilter = F3(function (quickEditsFilter, relationships, buildingBlocks) {
    if (!quickEditsFilter.$) {
      var thisUserId = quickEditsFilter.a;

      var quickEditsByAnotherUser = function () {
        var isQuickEditByAnotherUser = function (rel) {
          var _v3 = rel.q5;

          if (!_v3.$) {
            var _v4 = _v3.a;
            var byUser = _v4.b;
            return !_Utils_eq(byUser, thisUserId) ? $elm$core$Maybe$Just(rel.dM) : $elm$core$Maybe$Nothing;
          } else {
            return $elm$core$Maybe$Nothing;
          }
        };

        return A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$BuildingBlock$unwrapBuildingBlockId, A2($elm$core$List$filterMap, isQuickEditByAnotherUser, $author$project$ElmFramework$Lib$PivotDict$toList(relationships)));
      }();

      var originalsModifiedByThisUser = function () {
        var isOriginalModifiedByThisUser = function (rel) {
          var _v1 = rel.q5;

          if (!_v1.$) {
            var _v2 = _v1.a;
            var originalBlockId = _v2.a;
            var byUser = _v2.b;
            return _Utils_eq(byUser, thisUserId) ? $elm$core$Maybe$Just(originalBlockId) : $elm$core$Maybe$Nothing;
          } else {
            return $elm$core$Maybe$Nothing;
          }
        };

        return A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$BuildingBlock$unwrapBuildingBlockId, A2($elm$core$List$filterMap, isOriginalModifiedByThisUser, $author$project$ElmFramework$Lib$PivotDict$toList(relationships)));
      }();

      var theFilterer = function (block) {
        var isQuickEditByAnotherUser = A2($turboMaCk$any_set$Set$Any$member, block.F, quickEditsByAnotherUser);
        var isOriginalModifiedByThisUser = A2($turboMaCk$any_set$Set$Any$member, block.F, originalsModifiedByThisUser);
        return !isOriginalModifiedByThisUser && !isQuickEditByAnotherUser;
      };

      return A2($elm$core$List$filter, theFilterer, buildingBlocks);
    } else {
      var quickEditBlocks = A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$BuildingBlock$unwrapBuildingBlockId, A2($elm$core$List$filterMap, function (_v5) {
        var blockId = _v5.dM;
        var isQuickEdit = _v5.q5;
        return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Just(blockId), $elm$core$Maybe$Nothing, $elm_community$maybe_extra$Maybe$Extra$isJust(isQuickEdit));
      }, $author$project$ElmFramework$Lib$PivotDict$toList(relationships)));

      var theFilterer = function (block) {
        var isQuickEdit = A2($turboMaCk$any_set$Set$Any$member, block.F, quickEditBlocks);
        return !isQuickEdit;
      };

      return A2($elm$core$List$filter, theFilterer, buildingBlocks);
    }
  });
  var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(function (fma, mb) {
    if (mb.$ === 1) {
      return fma(0);
    } else {
      return mb;
    }
  });

  var $author$project$Types$BuildingBlock$toMoneyPayload = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        if (_v0.a.$ === 3) {
          var _v1 = _v0.a.a;
          var moneyPayload = _v1.b;
          return $elm$core$Maybe$Just(moneyPayload);
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 2:
        if (_v0.a.$ === 3) {
          var _v2 = _v0.a.a;
          var moneyPayload = _v2.b;
          return $elm$core$Maybe$Just(moneyPayload);
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 1:
        return $elm$core$Maybe$Nothing;

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$BuildingBlock$toAllocationClassId = function (buildingBlock) {
    return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.iu;
    }, function ($) {
      return $.kf;
    }), A2($elm$core$Maybe$andThen, function ($) {
      return $.kg;
    }, $author$project$Types$BuildingBlock$toMoneyPayload(buildingBlock)));
  };

  var $author$project$Types$BuildingBlock$toInternalOppositeAllocationClassId = function (buildingBlock) {
    return A2($elm$core$Maybe$map, function ($) {
      return $.kf;
    }, A2($elm$core$Maybe$andThen, function ($) {
      return $.qZ;
    }, A2($elm$core$Maybe$andThen, function ($) {
      return $.kg;
    }, $author$project$Types$BuildingBlock$toMoneyPayload(buildingBlock))));
  };

  var $author$project$Types$BuildingBlock$toAnyAllocationClass = function (buildingBlock) {
    return A2($elm_community$maybe_extra$Maybe$Extra$orElseLazy, function (_v0) {
      return $author$project$Types$BuildingBlock$toInternalOppositeAllocationClassId(buildingBlock);
    }, $author$project$Types$BuildingBlock$toAllocationClassId(buildingBlock));
  };

  var $author$project$Types$Filters$toChecker = F2(function (query, decider) {
    if (!query.$) {
      var theQuery = query.a;
      return decider(theQuery);
    } else {
      return true;
    }
  });

  var $turboMaCk$any_set$Set$Any$toList = function (_v0) {
    var dict = _v0;
    return $turboMaCk$any_dict$Dict$Any$keys(dict);
  };

  var $author$project$Types$Filters$filterBuildingBLocks = F4(function (filters, scenarioBlockRelationships, now, blocks) {
    var toTheQuickEditsFilter = A3($elm$core$Maybe$map2, $author$project$Types$Filters$theQuickEditsFilter, filters.h0, $krisajenkins$remotedata$RemoteData$toMaybe(scenarioBlockRelationships));
    var scenarioChecker = F2(function (blockId, maybeScenarioId) {
      if (!maybeScenarioId.$) {
        var scenarioId = maybeScenarioId.a;
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$always(true), A2($elm$core$Maybe$andThen, A2($author$project$ElmFramework$Lib$PivotDict$getItem, scenarioId, blockId), $krisajenkins$remotedata$RemoteData$toMaybe(scenarioBlockRelationships))));
      } else {
        return $elm$core$List$isEmpty(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$ElmFramework$Lib$PivotDict$getById2(blockId), $krisajenkins$remotedata$RemoteData$toMaybe(scenarioBlockRelationships))));
      }
    });
    var authorChecker = F2(function (blockId, filterId) {
      return _Utils_eq(blockId, filterId);
    });

    var filterer = function (block) {
      return A2($author$project$Types$Filters$textSearchChecker, block.zL, filters.j_) && A2($author$project$Types$Filters$toChecker, filters.hc.ia, $elm$core$Basics$always(_Utils_eq(filters.hc.ia, $author$project$Types$BuildingBlock$toAnyAllocationClass(block)))) && ($turboMaCk$any_set$Set$Any$isEmpty(filters.db) || A2($elm$core$List$member, true, A2($elm$core$List$map, scenarioChecker(block.F), $turboMaCk$any_set$Set$Any$toList(filters.db)))) && ($turboMaCk$any_set$Set$Any$isEmpty(filters.g0) || A2($elm$core$List$member, true, A2($elm$core$List$map, authorChecker(block.cC), $turboMaCk$any_set$Set$Any$toList(filters.g0)))) && A2($author$project$Types$Filters$toChecker, filters.ft.ia, A2($elm$core$Maybe$withDefault, $elm$core$Basics$always(true), A2($elm$core$Maybe$map, $author$project$Types$Filters$ageChecker(block.iK), now)));
    };

    return A3($elm$core$Maybe$withDefault, $elm$core$Basics$identity, toTheQuickEditsFilter, A2($elm$core$List$filter, filterer, blocks));
  });
  var $elm$core$List$sortBy = _List_sortBy;
  var $author$project$Types$Sorters$sort = F2(function (sorter, blocks) {
    if (!sorter) {
      return $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, function ($) {
        return $.iK;
      }, $elm$time$Time$posixToMillis), blocks));
    } else {
      return A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, function ($) {
        return $.zL;
      }, $elm$core$String$toLower), blocks);
    }
  });
  var $author$project$Types$Company$toBuildingBlocksFiltered = F4(function (filters, sorter, now, company) {
    var toSortedBlocks = function (blocks) {
      if (!sorter.$) {
        var sorter_ = sorter.a;
        return A2($author$project$Types$Sorters$sort, sorter_, blocks);
      } else {
        return blocks;
      }
    };

    return A2($elm$core$Maybe$map, toSortedBlocks, A2($elm$core$Maybe$map, A3($author$project$Types$Filters$filterBuildingBLocks, filters, company.nT, now), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.pg))));
  });
  var $author$project$Types$Company$toBuildingBlocksAndRelationshipsForScenario = F4(function (maybeFilters, now, scenarioId, company) {
    var finder = F2(function (blocks, scenarioBlocks) {
      var toPair = function (relationship) {
        return A2($elm$core$Maybe$map, function (block) {
          return _Utils_Tuple2(block, relationship);
        }, A2($turboMaCk$any_dict$Dict$Any$get, relationship.dM, blocks));
      };

      return A2($elm$core$List$filterMap, toPair, A2($author$project$ElmFramework$Lib$PivotDict$getById1, scenarioId, scenarioBlocks));
    });

    var buildingBlocks = function () {
      if (!maybeFilters.$) {
        var filters = maybeFilters.a;
        return $krisajenkins$remotedata$RemoteData$succeed($author$project$Types$BuildingBlock$createBuildingBlocksDict(A2($elm$core$Maybe$withDefault, _List_Nil, A4($author$project$Types$Company$toBuildingBlocksFiltered, filters, $elm$core$Maybe$Nothing, now, company))));
      } else {
        return company.pg;
      }
    }();

    return A3($elm$core$Maybe$map2, finder, $krisajenkins$remotedata$RemoteData$toMaybe(buildingBlocks), $krisajenkins$remotedata$RemoteData$toMaybe(company.nT));
  });

  var $author$project$Types$EditingScenario$EditingScenario$isAddBlockOverride = function (_v0) {
    var id = _v0.a;
    var blockOverride = _v0.b;

    if (!blockOverride.$) {
      var record = blockOverride.a;
      return $elm$core$Maybe$Just({
        dM: id,
        yO: record.yO
      });
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$EditingScenario$EditingScenario$toAddBlockOverrides = function (editingScenario) {
    return A2($elm$core$List$filterMap, $author$project$Types$EditingScenario$EditingScenario$isAddBlockOverride, $turboMaCk$any_dict$Dict$Any$toList(editingScenario.bX));
  };

  var $elm_community$list_extra$List$Extra$uniqueHelp = F4(function (f, existing, remaining, accumulator) {
    uniqueHelp: while (true) {
      if (!remaining.b) {
        return $elm$core$List$reverse(accumulator);
      } else {
        var first = remaining.a;
        var rest = remaining.b;
        var computedFirst = f(first);

        if (A2($elm$core$Set$member, computedFirst, existing)) {
          var $temp$f = f,
              $temp$existing = existing,
              $temp$remaining = rest,
              $temp$accumulator = accumulator;
          f = $temp$f;
          existing = $temp$existing;
          remaining = $temp$remaining;
          accumulator = $temp$accumulator;
          continue uniqueHelp;
        } else {
          var $temp$f = f,
              $temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
              $temp$remaining = rest,
              $temp$accumulator = A2($elm$core$List$cons, first, accumulator);
          f = $temp$f;
          existing = $temp$existing;
          remaining = $temp$remaining;
          accumulator = $temp$accumulator;
          continue uniqueHelp;
        }
      }
    }
  });
  var $elm_community$list_extra$List$Extra$uniqueBy = F2(function (f, list) {
    return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
  });
  var $author$project$Types$EditingScenario$EditingScenario$toDesiredBlocks = F2(function (maybeEditingExistingScenario, editingScenario) {
    var fromRelationships = function (relationships) {
      var fromOverride = function (rel) {
        var _v1 = A2($turboMaCk$any_dict$Dict$Any$get, rel.dM, editingScenario.bX);

        if (!_v1.$) {
          if (!_v1.a.$) {
            var isEnabled = _v1.a.a.yO;
            return $elm$core$Maybe$Just({
              dM: rel.dM,
              yO: isEnabled
            });
          } else {
            var _v2 = _v1.a;
            return $elm$core$Maybe$Nothing;
          }
        } else {
          return $elm$core$Maybe$Just({
            dM: rel.dM,
            yO: rel.la
          });
        }
      };

      return A2($elm$core$List$filterMap, fromOverride, relationships);
    };

    var fromOverrides = A2($elm$core$List$filter, function ($) {
      return $.yO;
    }, $author$project$Types$EditingScenario$EditingScenario$toAddBlockOverrides(editingScenario));

    if (!maybeEditingExistingScenario.$) {
      var relationships = maybeEditingExistingScenario.a;
      return A2($elm_community$list_extra$List$Extra$uniqueBy, A2($elm$core$Basics$composeR, function ($) {
        return $.dM;
      }, $author$project$Types$BuildingBlock$unwrapBuildingBlockId), _Utils_ap(fromRelationships(relationships), fromOverrides));
    } else {
      return fromOverrides;
    }
  });
  var $author$project$Ui$Scenario$Model$toCashboardQueryDirect = F4(function (zone, route, state, session) {
    var toQuery = F3(function (startAt, theEnabledBlocks, interval) {
      return {
        it: state.nq,
        vk: theEnabledBlocks,
        eO: $turboMaCk$any_set$Set$Any$toList(state.nr),
        rf: state.p5.rf,
        jD: interval,
        tB: startAt
      };
    });

    var maybeEditingExistingScenario_relationships = function () {
      if (route.$ === 5 && route.b.$ === 2 && route.b.a.$ === 3) {
        var companyId = route.a;
        var _v1 = route.b.a;
        var scenarioId = _v1.a;
        return A2($elm$core$Maybe$map, $elm$core$List$map($elm$core$Tuple$second), A2($elm$core$Maybe$andThen, A3($author$project$Types$Company$toBuildingBlocksAndRelationshipsForScenario, $elm$core$Maybe$Just(state.pd), $elm$core$Maybe$Nothing, scenarioId), A2($author$project$Types$UserSession$toCompany, companyId, session)));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var enabledBlocks = function () {
      var toEnabledBlock = function (desiredBlock) {
        return desiredBlock.yO ? $elm$core$Maybe$Just(desiredBlock.dM) : $elm$core$Maybe$Nothing;
      };

      return A2($elm$core$List$filterMap, toEnabledBlock, A2($author$project$Types$EditingScenario$EditingScenario$toDesiredBlocks, maybeEditingExistingScenario_relationships, state.p5));
    }();

    return A4($elm$core$Maybe$map3, toQuery, A2($author$project$Ui$DateInput$DateInput$toSimpleDate, zone, state.p5.tB), A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(enabledBlocks), $elm$core$List$isEmpty(enabledBlocks)), state.ns.ia);
  });
  var $author$project$Ui$Scenario$Update$update = F7(function (time, zone, currRoute, _v0, maybeSession, state, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 0:
        var blocks = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          p5: A2($author$project$Types$EditingScenario$EditingScenario$setBlocks, state.p5, $turboMaCk$any_set$Set$Any$toList(blocks))
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(_Utils_update(state, {
          p5: A2($author$project$Types$EditingScenario$EditingScenario$empty, zone, time)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var editingScenario = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          p5: editingScenario
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var divisionIds = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nr: A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Division$unwrapDivisionId, divisionIds)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var divisionId = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nr: A2($turboMaCk$any_set$Set$Any$toggle, divisionId, state.nr)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var nestedSelectState = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ns: nestedSelectState
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 7:
        var account_type_enum = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nq: account_type_enum
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 8:
        var path = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qi: A2($turboMaCk$any_set$Set$Any$toggle, path, state.qi)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var cashboardQuery = msg.a;
        var result = msg.b;
        var currentStateCashboardQuery = A2($elm$core$Maybe$andThen, A3($author$project$Ui$Scenario$Model$toCashboardQueryDirect, zone, currRoute, state), maybeSession);
        return _Utils_eq(currentStateCashboardQuery, $elm$core$Maybe$Just(cashboardQuery)) ? A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgListWithExpectedError, result, {
          dS: function (newState) {
            return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: function (_v2) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          AY: function (_v3) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          e$: function (resp) {
            return _Utils_Tuple3(_Utils_update(state, {
              sP: $elm$core$Maybe$Just(resp)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 9:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 12:
        return _Utils_Tuple3(_Utils_update(state, {
          qk: !state.qk
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 10:
        var _v4 = msg.a;
        var index = _v4.a;
        var stringValue = _v4.b;
        return _Utils_Tuple3(_Utils_update(state, {
          rz: A2($elm$core$List$cons, _Utils_Tuple2(index, stringValue), state.rz)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 11:
        var stepsBack = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          rz: A2($elm$core$List$drop, stepsBack, state.rz)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var filtersMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          pd: A2($author$project$Types$Filters$update, filtersMsg, state.pd)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Remote$RequestMsg$DuplicateScenario = F3(function (a, b, c) {
    return {
      $: 44,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$DuplicateScenarioReq$DuplicateScenarioReq = F2(function (scenarioId, published) {
    return {
      sQ: published,
      e8: scenarioId
    };
  });
  var $author$project$Ui$Scenarios$Msg$OnDuplicateSuccess = F3(function (a, b, c) {
    return {
      $: 5,
      a: a,
      b: b,
      c: c
    };
  });
  var $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm$core$Basics$apR);
  var $author$project$Ui$Scenarios$Update$update = F4(function (time, _v0, model, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        return _Utils_Tuple3(_Utils_update(model, {
          h_: !model.h_
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var filtersMsg = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          qo: A2($author$project$Types$Filters$update, filtersMsg, model.qo)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 3:
        var divisions = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          pN: divisions
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var companyId = msg.a;
        var scenarioId = msg.b;
        var edit = msg.c;
        var maybeRequest = A2($elm_community$maybe_extra$Maybe$Extra$andMap, $elm$core$Maybe$Just(!edit), A2($elm_community$maybe_extra$Maybe$Extra$andMap, $elm$core$Maybe$Just(scenarioId), $elm$core$Maybe$Just($author$project$Api$Types$DuplicateScenarioReq$DuplicateScenarioReq)));

        var messages = function () {
          if (!maybeRequest.$) {
            var request = maybeRequest.a;
            return _List_fromArray([$author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$DuplicateScenario, $author$project$Ui$Scenarios$Msg$OnDuplicateSuccess(edit), companyId, request))]);
          } else {
            return _List_Nil;
          }
        }();

        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, messages);

      case 5:
        var edit = msg.a;
        var companyId = msg.b;
        var scenarioId = msg.c;
        var messages = edit ? _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, scenarioId, 0))))]) : _List_Nil;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, messages);

      default:
        var nestedSelectState = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          um: nestedSelectState
        }), $elm$core$Platform$Cmd$none, !_Utils_eq(model.um.ia, nestedSelectState.ia) ? A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $author$project$ElmFramework$MsgCmd$msgCmd.Dn, $elm$core$List$singleton)), nestedSelectState.ia)) : _List_Nil);
    }
  });
  var $author$project$Global$Model$EditSyncingDivisions = F2(function (a, b) {
    return {
      $: 16,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Settings$Msg$EditingDivisionMsg = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$EditingDivision$Model$fromDivision = function (division) {
    return {
      xt: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, division.xt)),
      an: {
        nU: '',
        Fw: division.an
      },
      zL: division.zL
    };
  };

  var $author$project$Ui$EditingDivision$Update$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        var name = msg.a;
        return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_update(state, {
          zL: name
        })), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var selected = msg.a;
        return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_update(state, {
          an: selected
        })), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var count = msg.a;
        return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_update(state, {
          xt: count
        })), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$Settings$Update$update = F4(function (time, global, model, msg) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var editCompanyMsg = msg.a;

        var _v1 = A2($author$project$Ui$EditingCompany$Update$update, {
          xj: model.xj,
          qC: global,
          EM: time
        }, editCompanyMsg);

        var nextEditingCompany = _v1.a;
        var cmd = _v1.b;
        var topMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
          xj: nextEditingCompany
        }), A2($elm$core$Platform$Cmd$map, $author$project$Ui$Settings$Msg$EditingCompanyMsg, cmd), topMsgs);

      case 2:
        var editDivisionMsg = msg.a;

        var _v2 = A2($elm$core$Maybe$withDefault, _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, $author$project$Ui$EditingDivision$Update$update(editDivisionMsg), model.xk));

        var nextEditingDivision = _v2.a;
        var cmd = _v2.b;
        var topMsgs = _v2.c;
        return _Utils_Tuple3(_Utils_update(model, {
          xk: nextEditingDivision
        }), A2($elm$core$Platform$Cmd$map, $author$project$Ui$Settings$Msg$EditingDivisionMsg, cmd), topMsgs);

      case 3:
        var editingDivision = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          xk: editingDivision
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);

      case 6:
        var newDivisions = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          rB: newDivisions
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      default:
        var companyId = msg.a;
        var _v3 = model.rB;

        if (_v3.b) {
          var next = _v3.a;
          var remaining = _v3.b;
          return _Utils_Tuple3(_Utils_update(model, {
            xk: $elm$core$Maybe$Just($author$project$Ui$EditingDivision$Model$fromDivision(next)),
            rB: remaining
          }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$EditSyncingDivisions, companyId, next)))]));
        } else {
          return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }

    }
  });
  var $author$project$Ui$Support$Support$update = F4(function (global, maybeSession, msg, state) {
    switch (msg.$) {
      case 0:
        var name = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          zL: name
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var email = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          iP: email
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 2:
        var message = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          zu: message
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var route = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(route)]));

      case 3:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);

      case 5:
        var result = msg.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithGraphqlResultToOutMsgList, result, {
          dS: function (nextState) {
            return _Utils_Tuple3(nextState, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          eZ: $elm$core$Basics$always(_Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil)),
          e$: $elm$core$Basics$always(_Utils_Tuple3($author$project$Ui$Support$Support$init, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'global.phrases.support.success_____', _List_Nil)])))
        });

      default:
        var cmd = msg.a;
        return _Utils_Tuple3(state, cmd, _List_Nil);
    }
  });

  var $author$project$Remote$RequestMsg$AuthRefreshed = function (a) {
    return {
      $: 73,
      a: a
    };
  };

  var $author$project$Remote$Msg$ChangeEmail = $elm$core$Basics$identity;
  var $author$project$Types$UserProfile$ConfirmationOnSentEmail = 0;

  var $author$project$Ui$UserProfile$Msg$EmailChangeEmailSent = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Ui$UserProfile$Msg$OpenConfirmationDialog = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$UserProfile$Msg$PasswordChanged = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Ui$UserProfile$Msg$ReceivedUserSessionStatusFromConfirmCredentials = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Msg$Unauthenticate = {
    $: 4
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$ChangeUserEmailOutput = F5(function (userId, email, idToken, refreshToken, expiresIn) {
    return {
      iP: email,
      hr: expiresIn,
      d5: idToken,
      e6: refreshToken,
      oD: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$changeUserEmail = F2(function (apiKey, _v0) {
    var newEmail = _v0.rC;
    var idToken = _v0.d5;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 10);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$ChangeUserEmailOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken)), _Utils_Tuple2('email', $elm$json$Json$Encode$string(newEmail)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ChangeUserPasswordOutput = F5(function (userId, email, idToken, refreshToken, expiresIn) {
    return {
      iP: email,
      hr: expiresIn,
      d5: idToken,
      e6: refreshToken,
      oD: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$changeUserPassword = F2(function (apiKey, _v0) {
    var newPassword = _v0.jk;
    var idToken = _v0.d5;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 10);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$ChangeUserPasswordOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken)), _Utils_Tuple2('password', $elm$json$Json$Encode$string(newPassword)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$TopMsg$msgRemote = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteMsg);
  var $author$project$Ui$UserProfile$Update$update = F4(function (time, _v0, userProfile, msg) {
    var config = _v0.dy;

    switch (msg.$) {
      case 0:
        var dialog = msg.a;
        return _Utils_Tuple3(_Utils_update(userProfile, {
          gZ: $elm$core$Maybe$Just(dialog)
        }), $elm$core$Platform$Cmd$none, _List_Nil);

      case 1:
        var nextUserProfile = msg.a;
        return _Utils_Tuple3(nextUserProfile, $elm$core$Platform$Cmd$none, _List_Nil);

      case 4:
        var session = msg.a;
        var newPassword = msg.b;
        return _Utils_Tuple3(userProfile, A2($elm$core$Task$attempt, $author$project$Ui$UserProfile$Msg$PasswordChanged, A2($author$project$ElmFramework$Lib$Firebase$Auth$changeUserPassword, config.xL.oY, {
          d5: $author$project$Types$UserSession$unwrapIdToken(session.u_.d5),
          jk: newPassword
        })), _List_Nil);

      case 5:
        var res = msg.a;

        if (!res.$) {
          var idToken = res.a.d5;
          var refreshToken = res.a.e6;
          var expiresIn = res.a.hr;
          return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dj($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$UserProfileRoute)), A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'Password Changed Successfully!', _List_Nil), $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$AuthRefreshed({
            hr: expiresIn,
            d5: idToken,
            e6: refreshToken
          }))]));
        } else {
          var error = res.a;
          return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr, $elm$core$Maybe$Nothing, error, _List_Nil)]));
        }

      case 6:
        var auth = msg.a;
        var newEmail = msg.b;
        return _Utils_Tuple3(userProfile, A2($elm$core$Task$attempt, $author$project$Ui$UserProfile$Msg$EmailChangeEmailSent, A2($elm$core$Task$andThen, function (result) {
          if (result.$ === 1) {
            var err = result.a;
            return $elm$core$Task$fail(err);
          } else {
            var res = result.a;
            return $elm$core$Task$succeed(res);
          }
        }, A2($elm$core$Task$andThen, function (emailChangedResult) {
          var _v3 = emailChangedResult;
          var idToken = _v3.d5;
          var refreshToken = _v3.e6;
          var expiresIn = _v3.hr;
          var newAuth = $author$project$Types$UserSession$wrapAuth({
            hr: expiresIn,
            d5: idToken,
            e6: refreshToken
          });
          return A2($elm$core$Task$andThen, function (_v4) {
            return $elm$core$Task$succeed($elm$core$Result$Ok({
              xr: emailChangedResult,
              rA: newAuth
            }));
          }, A2($author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode, config.xL.oY, {
            d5: idToken
          }));
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$changeUserEmail, config.xL.oY, {
          d5: $author$project$Types$UserSession$unwrapIdToken(auth.d5),
          rC: newEmail
        })))), _List_Nil);

      case 7:
        var session = msg.a;
        var newEmail = msg.b;
        return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgRemote(A2($author$project$Remote$Msg$RefreshUserToken, $elm$core$Maybe$Just(newEmail), session.u_.e6))]));

      case 8:
        var res = msg.a;

        if (!res.$) {
          var newAuth = res.a.rA;
          return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgUserProfile($author$project$Ui$UserProfile$Msg$OpenConfirmationDialog(0)), $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$AuthRefreshed(newAuth))]));
        } else {
          var error = res.a;
          return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr, $elm$core$Maybe$Nothing, error, _List_Nil)]));
        }

      case 9:
        return _Utils_Tuple3(_Utils_update(userProfile, {
          gZ: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$UserProfileRoute))]));

      case 10:
        return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$Unauthenticate)]));

      case 2:
        var email = msg.a.iP;
        var password = msg.a.sv;
        var nextRoute = msg.a.zR;
        return _Utils_Tuple3(userProfile, A2($elm$core$Task$attempt, $author$project$Ui$UserProfile$Msg$ReceivedUserSessionStatusFromConfirmCredentials(nextRoute), A2($elm$core$Task$andThen, function (_v7) {
          var idToken = _v7.d5;
          var refreshToken = _v7.e6;
          var expiresIn = _v7.hr;
          return $author$project$Api$Api$getUserSessionStatus({
            oY: config.xL.oY,
            oZ: config.oZ,
            o0: {
              hr: expiresIn,
              d5: idToken,
              e6: refreshToken
            }
          });
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$signInViaEmailAndPassword, config.xL.oY, {
          iP: email,
          sv: password
        }))), _List_Nil);

      default:
        var userProfileRoute = msg.a;
        var result = msg.b;

        if (!result.$) {
          var userSessionStatus = result.a;

          if (userSessionStatus.$ === 3) {
            return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgRemote($author$project$Remote$Msg$ReceivedUserSessionStatusFromSignIn(result)), $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile(userProfileRoute))]));
          } else {
            return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr, $elm$core$Maybe$Nothing, 'Error getting user session', _List_Nil)]));
          }
        } else {
          var err = result.a;
          return _Utils_Tuple3(userProfile, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr, $elm$core$Maybe$Nothing, err, _List_Nil)]));
        }

    }
  });
  var $author$project$UiWrappers$MainAppWrapSpecific$Update$update = F2(function (msg, state) {
    if (!msg.$) {
      var string = msg.a;
      return _Utils_Tuple3(_Utils_update(state, {
        ph: string
      }), $elm$core$Platform$Cmd$none, _List_Nil);
    } else {
      return _Utils_Tuple3(_Utils_update(state, {
        qh: !state.qh
      }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Remote$ResponseMsg$AddBlockToScenario = F2(function (a, b) {
    return {
      $: 49,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$AddFinancialAccount = F3(function (a, b, c) {
    return {
      $: 32,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$ApproveReview = F2(function (a, b) {
    return {
      $: 62,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CloneBlock = F2(function (a, b) {
    return {
      $: 67,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CloneScenarioPreservingQuickEdits = F2(function (a, b) {
    return {
      $: 56,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$ConnectAccountingSystemDivision = F3(function (a, b, c) {
    return {
      $: 38,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$CreateAllocationClass = F3(function (a, b, c) {
    return {
      $: 29,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$CreateBlock = F2(function (a, b) {
    return {
      $: 64,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateComment = F2(function (a, b) {
    return {
      $: 57,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateDivision = F2(function (a, b) {
    return {
      $: 24,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateReview = F2(function (a, b) {
    return {
      $: 60,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateScenario = F2(function (a, b) {
    return {
      $: 41,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateSeasonalityPreset = F3(function (a, b, c) {
    return {
      $: 68,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteAllocationClass = F2(function (a, b) {
    return {
      $: 31,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteBlock = F2(function (a, b) {
    return {
      $: 66,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteComment = F2(function (a, b) {
    return {
      $: 59,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteCompany = F2(function (a, b) {
    return {
      $: 16,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteDivision = F2(function (a, b) {
    return {
      $: 26,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteFinancialAccount = F4(function (a, b, c, d) {
    return {
      $: 34,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });

  var $author$project$Remote$ResponseMsg$DeleteMyAccount = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$DeleteReview = F2(function (a, b) {
    return {
      $: 63,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteScenario = F3(function (a, b, c) {
    return {
      $: 44,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$DeleteSeasonalityPreset = F2(function (a, b) {
    return {
      $: 70,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DisableScenario = F3(function (a, b, c) {
    return {
      $: 46,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$DiscardAllScenarioQuickEdits = F2(function (a, b) {
    return {
      $: 55,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DiscardScenarioQuickEdits = F2(function (a, b) {
    return {
      $: 54,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$DisconnectAccountingSystemDivision = F3(function (a, b, c) {
    return {
      $: 39,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$DisconnectDivision = F3(function (a, b, c) {
    return {
      $: 27,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$DuplicateScenario = F3(function (a, b, c) {
    return {
      $: 43,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$EditComment = F2(function (a, b) {
    return {
      $: 58,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$EditFinancialAccount = F4(function (a, b, c, d) {
    return {
      $: 33,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Remote$ResponseMsg$EditScenarioBlockRelationship = F2(function (a, b) {
    return {
      $: 51,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$EnableScenario = F3(function (a, b, c) {
    return {
      $: 45,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$GetAllBuildingBlocksDetails = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$GetAllDivisionDetails = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$GetAllScenariosDetails = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });

  var $author$project$Remote$ResponseMsg$GetAuthMetadata = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$GetBuildingBlockDetails = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$GetCompanyDetails = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$GetFinancialAccountBalancesForPeriod = F4(function (a, b, c, d) {
    return {
      $: 37,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });

  var $author$project$Remote$ResponseMsg$GetIndustries = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$GetPresetSeasonalities = F2(function (a, b) {
    return {
      $: 6,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$InviteUserToCompany = F2(function (a, b) {
    return {
      $: 17,
      a: a,
      b: b
    };
  });

  var $author$project$Remote$ResponseMsg$OnboardCompany = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$OnboardCompanyWithUser = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$OverrideFinancialAccountBalanceOnDate = F6(function (a, b, c, d, e, f) {
    return {
      $: 35,
      a: a,
      b: b,
      c: c,
      d: d,
      e: e,
      f: f
    };
  });
  var $author$project$Remote$ResponseMsg$QuickEditBlockInScenario = F2(function (a, b) {
    return {
      $: 52,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$ReconnectAccountingSystemDivision = F3(function (a, b, c) {
    return {
      $: 40,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$Remote$ResponseMsg$RedeemInvite = function (a) {
    return {
      $: 11,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$RemoveBlockFromScenario = F4(function (a, b, c, d) {
    return {
      $: 50,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Remote$ResponseMsg$RemoveUserFromCompany = F3(function (a, b, c) {
    return {
      $: 22,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$RequestReviewApproval = F2(function (a, b) {
    return {
      $: 61,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$ResendInvitation = F2(function (a, b) {
    return {
      $: 21,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$ResetFinancialAccountBalanceOnDate = F5(function (a, b, c, d, e) {
    return {
      $: 36,
      a: a,
      b: b,
      c: c,
      d: d,
      e: e
    };
  });
  var $author$project$Remote$ResponseMsg$RevokeInvitation = F3(function (a, b, c) {
    return {
      $: 20,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$SaveBlockQuickEditsForScenario = F4(function (a, b, c, d) {
    return {
      $: 53,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Remote$ResponseMsg$SetAsBaseScenario = F3(function (a, b, c) {
    return {
      $: 47,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$SetAsBudgetScenario = F3(function (a, b, c) {
    return {
      $: 48,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$SyncDivision = F2(function (a, b) {
    return {
      $: 28,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateAllocationClass = F3(function (a, b, c) {
    return {
      $: 30,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateBlock = F2(function (a, b) {
    return {
      $: 65,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateCompany = F2(function (a, b) {
    return {
      $: 15,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateCompanyInOnboarding = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateDivision = F2(function (a, b) {
    return {
      $: 25,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateInvitation = F2(function (a, b) {
    return {
      $: 18,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateInvitationAndResend = F2(function (a, b) {
    return {
      $: 19,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateScenario = F2(function (a, b) {
    return {
      $: 42,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateSeasonalityPreset = F3(function (a, b, c) {
    return {
      $: 69,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$Remote$ResponseMsg$UpdateSelf = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$UpdateUser = function (a) {
    return {
      $: 14,
      a: a
    };
  };

  var $author$project$Remote$ResponseMsg$UpdateUserInCompany = F2(function (a, b) {
    return {
      $: 23,
      a: a,
      b: b
    };
  });
  var $author$project$Types$ScenarioBlock$ScenarioBlockId = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$encodeAddBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$addBlock = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'addBlock', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeAddBlockInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$AddBlockSuccess$addedBlockIds = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'addedBlockIds', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$AddedBlockIds$blockChange = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'blockChange', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$createTaskFromResult = F2(function (taskCreatingFn, result) {
    if (result.$ === 1) {
      var err = result.a;
      return $elm$core$Task$succeed($elm$core$Result$Err(err));
    } else {
      var taskArg = result.a;
      return taskCreatingFn(taskArg);
    }
  });

  var $author$project$Api$GraphqlSchema$Union$AddBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AddBlockSuccess', selections____.z2), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $dillonkearns$elm_graphql$Graphql$Http$mapError = F2(function (mapFn, error) {
    if (!error.$) {
      var possiblyParsedData = error.a;
      var graphqlErrorList = error.b;

      if (!possiblyParsedData.$) {
        var parsedData = possiblyParsedData.a;
        return A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData(mapFn(parsedData)), graphqlErrorList);
      } else {
        var unparsedData = possiblyParsedData.a;
        return A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(unparsedData), graphqlErrorList);
      }
    } else {
      var httpError = error.a;
      return $dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError);
    }
  });
  var $author$project$Api$GraphqlSchema$Object$BlockNotFound$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$Api$sanitizeErrType = function (err) {
    if (!err.$) {
      var graphqlErrors = err.b;
      return A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData($elm$json$Json$Encode$null), graphqlErrors);
    } else {
      var httpError = err.a;
      return $dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError);
    }
  };

  var $author$project$Api$GraphqlSchema$Object$BlockChange$scenarioBlockId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'scenarioBlockId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Mutation$scenarioLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenarioLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail = function (_v0) {
    var fields = _v0.a;
    var decoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, fields, A2($elm$json$Json$Decode$andThen, function (result) {
      if (!result.$) {
        var value = result.a;
        return $elm$json$Json$Decode$succeed(value);
      } else {
        return $elm$json$Json$Decode$fail('Expected non-null but got null, check for calls to nonNullOrFail in your code. Ideally your schema should indicate that this is non-nullable so you don\'t need to use nonNullOrFail at all.');
      }
    }, decoder));
  };

  var $author$project$Types$ScenarioBlock$ScenarioBlockRelationship = F5(function (id, scenarioId, blockId, enabled, isQuickEdit) {
    return {
      dM: blockId,
      la: enabled,
      F: id,
      q5: isQuickEdit,
      e8: scenarioId
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Scenario_block$block_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'block_id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Scenario_block$enabled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'enabled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$Scenario_block$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Scenario_block$quick_edit_of_block_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'quick_edit_of_block_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Scenario_block$quick_edit_user_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'quick_edit_user_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Scenario_block$scenario_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'scenario_id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$Schema$scenarioBlockRelationship = function () {
    var isQuickEditPair = A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Scenario_block$quick_edit_user_id, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Scenario_block$quick_edit_of_block_id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Maybe$map2($elm$core$Tuple$pair))));
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, isQuickEditPair, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario_block$enabled, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Scenario_block$block_id, $elm$core$Basics$identity, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Scenario_block$scenario_id, $elm$core$Basics$identity, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Scenario_block$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$ScenarioBlock$ScenarioBlockRelationship))))));
  }();

  var $author$project$Api$GraphqlSchema$Query$scenario_block_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenario_block_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });

  var $author$project$Types$ScenarioBlock$unwrapScenarioBlockId = function (_v0) {
    var sbi = _v0;
    return sbi;
  };

  var $author$project$Api$Schema$toScenarioBlockSelectionSet = function (id) {
    return $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A2($author$project$Api$GraphqlSchema$Query$scenario_block_by_pk, {
      F: $author$project$Types$ScenarioBlock$unwrapScenarioBlockId(id)
    }, $author$project$Api$Schema$scenarioBlockRelationship));
  };

  var $author$project$Api$Api$addBlockToScenario = F5(function (_v0, _v1, tag, url, idToken) {
    var scenarioId = _v0;
    var blockId = _v1;

    var toGetScenarioBlockRelationshipTask = function (scenarioBlockId) {
      return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), $author$project$Api$Schema$toScenarioBlockSelectionSet(scenarioBlockId))));
    };

    var addBlockToScenarioResponse = function () {
      var scenarioBlockId = A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$AddedBlockIds$blockChange($author$project$Api$GraphqlSchema$Object$BlockChange$scenarioBlockId), $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity));
      return $author$project$Api$GraphqlSchema$Union$AddBlockPayload$fragments({
        z2: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$AddBlockSuccess$addedBlockIds(scenarioBlockId)),
        ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
        M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
        N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
        O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
        bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
      });
    }();

    var addBlockToScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: scenarioId
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$addBlock, {
      W: {
        dM: blockId
      }
    }, addBlockToScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(toGetScenarioBlockRelationshipTask), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, addBlockToScenarioTask)));
  });
  var $author$project$Api$GraphqlSchema$Mutation$accountCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'accountCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateAccountSuccess$accountId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'accountId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$CreateAccountSuccess$allocationClassId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'allocationClassId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateAccountInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balanceMinMaxAdvice', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dx))), _Utils_Tuple2('currency', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString, input____.bq))), _Utils_Tuple2('divisionId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dB))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('openingBalance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gq, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('openingDate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gr, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('subType', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString, input____.dI))), _Utils_Tuple2('type', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString, input____.P)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AccountCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateAccountInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateAccountPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateAccountSuccess', selections____.Al), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$map2 = F3(function (combine, _v0, _v1) {
    var selectionFields1 = _v0.a;
    var selectionDecoder1 = _v0.b;
    var selectionFields2 = _v1.a;
    var selectionDecoder2 = _v1.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _Utils_ap(selectionFields1, selectionFields2), A3($elm$json$Json$Decode$map2, combine, selectionDecoder1, selectionDecoder2));
  });

  var $author$project$Types$AccountType$toAccount_subtype_enum = function (accountType) {
    if (!accountType.$) {
      return 0;
    } else {
      var subType = accountType.a;

      if (!subType) {
        return 1;
      } else {
        return 2;
      }
    }
  };

  var $author$project$Types$AccountType$toAccount_type_enum = function (accountType) {
    return _Utils_eq(accountType, $author$project$Types$AccountType$Cash) ? 0 : 1;
  };

  var $author$project$Api$Types$AddAccountReq$toAddAccountInput = function (req) {
    return {
      dx: req.dx,
      bq: req.bq,
      dB: $author$project$Types$Division$unwrapDivisionId(req.R),
      zL: req.oO,
      gq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe($elm$core$Maybe$Just(req.tE)),
      gr: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe($elm$core$Maybe$Just(req.tF)),
      dI: $author$project$Types$AccountType$toAccount_subtype_enum(req.it),
      P: $author$project$Types$AccountType$toAccount_type_enum(req.it)
    };
  };

  var $author$project$Api$GraphqlSchema$Query$account_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'account_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getFinancialAccountTask = F3(function (url, idToken, _v0) {
    var financialAccountId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Financial account not found: ' + financialAccountId), A2($author$project$Api$GraphqlSchema$Query$account_by_pk, {
      F: financialAccountId
    }, $author$project$Api$Schema$financialAccount)));
  });
  var $author$project$Api$Api$toGetFinancialAccountTask = F3(function (url, idToken, financialAccountId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getFinancialAccountTask, url, idToken, financialAccountId)));
  });
  var $author$project$Api$Api$addFinancialAccount = F5(function (_v0, req, tag, url, idToken) {
    var companyId = _v0;
    var addAccountResponse = $author$project$Api$GraphqlSchema$Union$CreateAccountPayload$fragments({
      Al: A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (_v1, _v2) {
        var accountId = _v1;
        var allocationId = _v2;
        return $elm$core$Result$Ok(_Utils_Tuple2(accountId, allocationId));
      }), $author$project$Api$GraphqlSchema$Object$CreateAccountSuccess$accountId, $author$project$Api$GraphqlSchema$Object$CreateAccountSuccess$allocationClassId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var addAccountTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountCreate, {
      b9: companyId
    }, A2($author$project$Api$GraphqlSchema$Object$AccountCreateMutation$create, {
      W: $author$project$Api$Types$AddAccountReq$toAddAccountInput(req)
    }, addAccountResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($author$project$Api$Api$toGetFinancialAccountTask, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, addAccountTask)));
  });

  var $author$project$Api$GraphqlSchema$Object$ReviewMutation$approve = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'approve', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$ApproveReviewPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApproveReviewSuccess', selections____.z4), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ReviewNotFoundError', selections____.mR), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ReviewStatusError', selections____.r1)]));
  };

  var $author$project$Api$GraphqlSchema$Object$ReviewNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$ReviewStatusError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Mutation$reviewLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reviewLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Types$Review$InReview = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$Review$Pending = {
    $: 0
  };

  var $author$project$Types$Review$Published = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Object$Review$approval_requested_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Timestamptz)', 'approval_requested_at', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB));
  var $author$project$Api$GraphqlSchema$Object$Review$approval_requested_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'approval_requested_by', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Review$approved_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Timestamptz)', 'approved_at', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB));
  var $author$project$Api$GraphqlSchema$Object$Review$approved_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'approved_by', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Review$created_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'created_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$GraphqlSchema$Object$Review$created_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'created_by', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Review$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Review$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$Review_status_enum$Pending = 0;
  var $author$project$Api$GraphqlSchema$Enum$Review_status_enum$Published = 1;
  var $author$project$Api$GraphqlSchema$Enum$Review_status_enum$Review = 2;
  var $author$project$Api$GraphqlSchema$Enum$Review_status_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'PENDING':
        return $elm$json$Json$Decode$succeed(0);

      case 'PUBLISHED':
        return $elm$json$Json$Decode$succeed(1);

      case 'REVIEW':
        return $elm$json$Json$Decode$succeed(2);

      default:
        return $elm$json$Json$Decode$fail('Invalid Review_status_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Review$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Review_status_enum.Review_status_enum', 'status', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Review_status_enum$decoder);

  var $author$project$Api$Schema$review = function () {
    var toStatus = F5(function (statusEnum, requestedBy, requestedAt, approvedBy, approvedAt) {
      var _v0 = _Utils_Tuple2(statusEnum, _Utils_Tuple2(_Utils_Tuple2(requestedBy, requestedAt), _Utils_Tuple2(approvedBy, approvedAt)));

      switch (_v0.a) {
        case 0:
          var _v1 = _v0.a;
          return $elm$core$Result$Ok($author$project$Types$Review$Pending);

        case 1:
          if (!_v0.b.b.a.$ && !_v0.b.b.b.$) {
            var _v2 = _v0.a;
            var _v3 = _v0.b;
            var _v4 = _v3.b;
            var by = _v4.a.a;
            var at = _v4.b.a;
            return $elm$core$Result$Ok($author$project$Types$Review$Published({
              uN: at,
              uO: by
            }));
          } else {
            var _v8 = _v0.a;
            return $elm$core$Result$Err('Unable to decode status Published');
          }

        default:
          if (!_v0.b.a.a.$ && !_v0.b.a.b.$) {
            var _v5 = _v0.a;
            var _v6 = _v0.b;
            var _v7 = _v6.a;
            var by = _v7.a.a;
            var at = _v7.b.a;
            return $elm$core$Result$Ok($author$project$Types$Review$InReview({
              uL: at,
              uM: by
            }));
          } else {
            var _v9 = _v0.a;
            return $elm$core$Result$Err('Unable to decode status Review');
          }

      }
    });
    var toReview = F9(function (reviewId, name, createdBy, createdAt, statusEnum, requestedBy, requestedAt, approvedBy, approvedAt) {
      var toTheReview = function (status) {
        return {
          iK: createdAt,
          cC: createdBy,
          F: reviewId,
          zL: name,
          Y: status
        };
      };

      return A2($elm$core$Result$map, toTheReview, A5(toStatus, statusEnum, requestedBy, requestedAt, approvedBy, approvedAt));
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Review$approved_at, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Review$approved_by, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Review$approval_requested_at, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Review$approval_requested_by, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Review$status, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Review$created_at, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Review$created_by, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Review$name, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Review$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(toReview)))))))))));
  }();

  var $author$project$Api$GraphqlSchema$Query$review_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'review_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getReviewTask = F3(function (_v0, url, idToken) {
    var reviewId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Review not found: ' + reviewId), A2($author$project$Api$GraphqlSchema$Query$review_by_pk, {
      F: reviewId
    }, $author$project$Api$Schema$review)));
  });
  var $author$project$Api$Api$toGetReviewTask = F3(function (url, idToken, reviewId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getReviewTask, reviewId, url, idToken)));
  });
  var $author$project$Api$ScalarCodecs$toUuid = F2(function (unwrapper, val) {
    return unwrapper(val);
  });
  var $author$project$Api$Api$approveReview = F4(function (reviewId, tag, url, idToken) {
    var approveReviewResponse = $author$project$Api$GraphqlSchema$Union$ApproveReviewPayload$fragments({
      z4: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      mR: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ReviewNotFoundError$message),
      r1: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ReviewStatusError$message)
    });
    var approveReviewTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$reviewLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Review$unwrapReviewId, reviewId)
    }, $author$project$Api$GraphqlSchema$Object$ReviewMutation$approve(approveReviewResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$toGetReviewTask, url, idToken, reviewId))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, approveReviewTask)));
  });
  var $author$project$Api$GraphqlSchema$Mutation$blockLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'blockLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCloneBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('useCloneInScenarios', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))(input____.Fj)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$BlockMutation$clone = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'clone', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCloneBlockInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CloneBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CloneBlockSuccess', selections____.Ag), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Query$company_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'company_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getCompanyTask = F3(function (_v0, url, idToken) {
    var companyId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Company not found: ' + companyId), A2($author$project$Api$GraphqlSchema$Query$company_by_pk, {
      F: companyId
    }, $author$project$Api$Schema$company)));
  });
  var $author$project$Api$Api$toGetCompanyTask = F3(function (url, idToken, theCompanyId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getCompanyTask, theCompanyId, url, idToken)));
  });
  var $author$project$Api$Api$cloneBlock = F5(function (companyId, blockId, tag, url, idToken) {
    var duplicateBlockResponse = $author$project$Api$GraphqlSchema$Union$CloneBlockPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      Ag: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var duplicateBlockTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$blockLogic, {
      F: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId)
    }, A2($author$project$Api$GraphqlSchema$Object$BlockMutation$clone, {
      W: {
        Fj: _List_Nil
      }
    }, duplicateBlockResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$toGetCompanyTask, url, idToken, companyId))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, duplicateBlockTask)));
  });

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$cloneScenarioPreservingQuickEdits = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cloneScenarioPreservingQuickEdits', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$CloneScenarioPreservingQuickEditsPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CloneScenarioPreservingQuickEditsSuccess', selections____.Ah), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$Types$GetCompanyDetailsResult$GetCompanyDetailsResult = function (company) {
    return {
      j: company
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$Scenario_block_bool_exp = $elm$core$Basics$identity;
  var $author$project$Types$BuildingBlock$BuildingBlock = F7(function (id, name, createdAt, updatedAt, blockType, startOn, createdBy) {
    return {
      kw: blockType,
      iK: createdAt,
      cC: createdBy,
      F: id,
      zL: name,
      bw: startOn,
      oB: updatedAt
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Block$created_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'created_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$GraphqlSchema$Object$Block$created_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'created_by', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Types$BuildingBlock$BasicMoney = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$BasicThing = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$DerivativeMoney = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$DerivativeThing = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$fromBlockTypeEnum = F2(function (blockType, blockOf) {
    var _v0 = _Utils_Tuple2(blockType, blockOf);

    if (!_v0.a) {
      if (!_v0.b) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return $author$project$Types$BuildingBlock$BasicMoney($krisajenkins$remotedata$RemoteData$NotAsked);
      } else {
        var _v3 = _v0.a;
        var _v4 = _v0.b;
        return $author$project$Types$BuildingBlock$BasicThing($krisajenkins$remotedata$RemoteData$NotAsked);
      }
    } else {
      if (!_v0.b) {
        var _v5 = _v0.a;
        var _v6 = _v0.b;
        return $author$project$Types$BuildingBlock$DerivativeMoney($krisajenkins$remotedata$RemoteData$NotAsked);
      } else {
        var _v7 = _v0.a;
        var _v8 = _v0.b;
        return $author$project$Types$BuildingBlock$DerivativeThing($krisajenkins$remotedata$RemoteData$NotAsked);
      }
    }
  });
  var $author$project$Api$GraphqlSchema$Object$Block$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Block$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$Block_of_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'MONEY':
        return $elm$json$Json$Decode$succeed(0);

      case 'THING':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Block_of_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Block$of_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Block_of_enum.Block_of_enum', 'of', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Block_of_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Block$start_on = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'start_on', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $author$project$Api$GraphqlSchema$Enum$Block_type_enum$Basic = 0;
  var $author$project$Api$GraphqlSchema$Enum$Block_type_enum$Derivative = 1;
  var $author$project$Api$GraphqlSchema$Enum$Block_type_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'BASIC':
        return $elm$json$Json$Decode$succeed(0);

      case 'DERIVATIVE':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Block_type_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Block$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Block_type_enum.Block_type_enum', 'type', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Block_type_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Block$updated_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'updated_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$Schema$block = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Block$created_by), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$start_on, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, $author$project$Types$BuildingBlock$fromBlockTypeEnum, $author$project$Api$GraphqlSchema$Object$Block$type_, $author$project$Api$GraphqlSchema$Object$Block$of_), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$updated_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$created_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Block$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$BuildingBlock$BuildingBlock))))))));

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('growth_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('repeat_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('seasonality_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('growth_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('repeat_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('seasonality_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('basic_blocks_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cw, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_aggregate_order_by)), _Utils_Tuple2('every', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ao, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('period', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ap, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('rate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('basic_blocks_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cw, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_aggregate_order_by)), _Utils_Tuple2('end_at_count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('end_at_date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('every', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ao, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('period', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ap, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('month_adjustments', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('preset_name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Cx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('base_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('end_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('base_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('end_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('basis_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal_opposite_account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal_opposite_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('basis_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal_opposite_account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal_opposite_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_avg_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('entered_as', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('entered_on_date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('entered_as', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('entered_on_date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_stddev_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_stddev_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_stddev_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_sum_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_var_pop_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_var_samp_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_variance_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('avg', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_avg_order_by)), _Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_min_order_by)), _Utils_Tuple2('stddev', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_stddev_order_by)), _Utils_Tuple2('stddev_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____._, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_stddev_pop_order_by)), _Utils_Tuple2('stddev_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_stddev_samp_order_by)), _Utils_Tuple2('sum', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_sum_order_by)), _Utils_Tuple2('var_pop', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_var_pop_order_by)), _Utils_Tuple2('var_samp', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_var_samp_order_by)), _Utils_Tuple2('variance', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ae, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_variance_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('algorithm', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocations_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fv, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_aggregate_order_by)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('derivative_blocks_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fR, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_aggregate_order_by)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('money_blocks_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gh, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_aggregate_order_by)), _Utils_Tuple2('ref_interval_end_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('ref_interval_start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_order_by = function (_v5) {
    var input____ = _v5;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_value', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.x, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('growth_pattern', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cP, $author$project$Api$GraphqlSchema$InputObject$encodeGrowth_pattern_order_by)), _Utils_Tuple2('growth_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aj, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_order_by)), _Utils_Tuple2('repeat_pattern', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Api$GraphqlSchema$InputObject$encodeRepeat_pattern_order_by)), _Utils_Tuple2('repeat_pattern_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('seasonality', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bK, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_order_by)), _Utils_Tuple2('seasonality_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('thing_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.al, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_order_by)), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by = function (_v4) {
    var input____ = _v4;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('basic_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cu, $author$project$Api$GraphqlSchema$InputObject$encodeBasic_block_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('derivative_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aX, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_order_by)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aj, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_order_by)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('of', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenarios_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dc, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_aggregate_order_by)), _Utils_Tuple2('start_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('thing_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.al, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_order_by)), _Utils_Tuple2('type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_order_by = function (_v3) {
    var input____ = _v3;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.co, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), _Utils_Tuple2('base_allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('base_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cq, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('base_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('derivative_money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cE, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_order_by)), _Utils_Tuple2('derivative_of', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('end_on', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('money_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aj, $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_order_by)), _Utils_Tuple2('multiplier', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.r, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('per', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('thing_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.al, $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_order_by)), _Utils_Tuple2('time_transform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bo, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_order_by)), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_money_block_order_by = function (_v2) {
    var input____ = _v2;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('base_basis', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cp, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('derivative_block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aX, $author$project$Api$GraphqlSchema$InputObject$encodeDerivative_block_order_by)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeMoney_block_order_by = function (_v1) {
    var input____ = _v1;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.uy, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by)), _Utils_Tuple2('account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ag, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), _Utils_Tuple2('allocation_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('basis', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('basis_transform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cx, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_order_by)), _Utils_Tuple2('basis_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal_opposite_account', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_order_by)), _Utils_Tuple2('internal_opposite_account_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('internal_opposite_allocation_class', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cS, $author$project$Api$GraphqlSchema$InputObject$encodeAllocation_class_order_by)), _Utils_Tuple2('internal_opposite_class_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('unit', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeThing_block_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('unit', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Block_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'created_at';

      case 2:
        return 'created_by';

      case 3:
        return 'id';

      case 4:
        return 'name';

      case 5:
        return 'of';

      case 6:
        return 'start_on';

      case 7:
        return 'type';

      default:
        return 'updated_at';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Company$blocks = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'blocks', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });

  var $author$project$Types$Division$createDivisionDict = function (divisions) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Division$unwrapDivisionId, A2($elm$core$List$map, function (div) {
      return _Utils_Tuple2(div.F, div);
    }, divisions));
  };

  var $author$project$Types$Invitation$createInvitationsDict = function (invitations) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Invitation$unwrapInvitationId, A2($elm$core$List$map, function (inv) {
      return _Utils_Tuple2(inv.F, inv);
    }, invitations));
  };

  var $author$project$Types$Scenario$createScenarioDict = function (scenarios) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Scenario$unwrapScenarioId, A2($elm$core$List$map, function (scn) {
      return _Utils_Tuple2(scn.F, scn);
    }, scenarios));
  };

  var $author$project$Types$Seasonality$unwrapSeasonalityId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Types$SeasonalityPreset$createSeasonalityPresetDict = function (seasonalities) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Seasonality$unwrapSeasonalityId, A2($elm$core$List$map, function (s) {
      return _Utils_Tuple2(s.F, s);
    }, seasonalities));
  };

  var $author$project$Api$GraphqlSchema$Object$Company$divisions = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Division_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'divisions', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Company$invites = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Invite_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeInvite_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeInvite_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'invites', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$InputObject$Seasonality_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildSeasonality_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Cx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      c: optionals____.c,
      j: optionals____.j,
      iD: optionals____.iD,
      F: optionals____.F,
      cV: optionals____.cV,
      d: optionals____.d,
      Ch: optionals____.Ch,
      Cx: optionals____.Cx
    };
  };

  var $author$project$Api$Schema$stringIsNotNull = $author$project$Api$GraphqlSchema$InputObject$buildString_comparison_exp(function (strOptFields) {
    return _Utils_update(strOptFields, {
      g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(false)
    });
  });
  var $author$project$Api$Schema$isPresetSeasonality = $author$project$Api$GraphqlSchema$InputObject$buildSeasonality_bool_exp(function (seasonalityOptFields) {
    return _Utils_update(seasonalityOptFields, {
      Cx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$stringIsNotNull)
    });
  });
  var $author$project$Api$GraphqlSchema$Object$Comment$comment = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'comment', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Comment_division$division_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'division_id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Schema$commentDivisionId = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Comment_division$division_id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity));

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_max_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_min_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_aggregate_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('max', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_max_order_by)), _Utils_Tuple2('min', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m, $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_min_order_by))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeReview_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('approval_requested_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approval_requested_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aM, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approved_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('approved_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('comments_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bI, $author$project$Api$GraphqlSchema$InputObject$encodeComment_aggregate_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dw, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('comment_divisions_aggregate', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fN, $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_aggregate_order_by)), _Utils_Tuple2('company', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j, $author$project$Api$GraphqlSchema$InputObject$encodeCompany_order_by)), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('createdBy', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cC, $author$project$Api$GraphqlSchema$InputObject$encodeUser_order_by)), _Utils_Tuple2('created_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('created_by', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.n, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('date_from', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('date_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('replyTo', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bi, $author$project$Api$GraphqlSchema$InputObject$encodeComment_order_by)), _Utils_Tuple2('reply_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('review', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c7, $author$project$Api$GraphqlSchema$InputObject$encodeReview_order_by)), _Utils_Tuple2('review_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bk, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dw, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('updated_at', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $author$project$Api$GraphqlSchema$InputObject$encodeComment_order_by)), _Utils_Tuple2('comment_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('division', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.R, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), _Utils_Tuple2('division_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Comment_division_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'comment_id';

      case 1:
        return 'division_id';

      default:
        return 'id';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Comment$comment_divisions = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_division_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeComment_division_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeComment_division_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'comment_divisions', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Comment$created_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'created_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$GraphqlSchema$Object$Comment$created_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'created_by', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Comment$date_from = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Date)', 'date_from', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB));
  var $author$project$Api$GraphqlSchema$Object$Comment$date_to = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Date)', 'date_to', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB));
  var $author$project$Api$GraphqlSchema$Object$Comment$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Comment$reply_to = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'reply_to', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Comment$review_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'review_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Enum$Comment_status_enum$Active = 0;
  var $author$project$Api$GraphqlSchema$Enum$Comment_status_enum$Archived = 1;
  var $author$project$Api$GraphqlSchema$Enum$Comment_status_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ACTIVE':
        return $elm$json$Json$Decode$succeed(0);

      case 'ARCHIVED':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Comment_status_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Comment$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Comment_status_enum.Comment_status_enum', 'status', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Comment_status_enum$decoder);

  var $author$project$Api$Schema$comment = function () {
    var toComment = function (commentId) {
      return function (userId) {
        return function (createdAt) {
          return function (dateFrom) {
            return function (dateTo) {
              return function (replyTo) {
                return function (reviewId) {
                  return function (theComment) {
                    return function (divisionIds) {
                      return function (status) {
                        return {
                          U: theComment,
                          iK: createdAt,
                          cC: userId,
                          eO: A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Division$unwrapDivisionId, divisionIds),
                          F: commentId,
                          ap: A3($elm$core$Maybe$map2, $author$project$Types$SimpleDateRange$SimpleDateClosedRange, dateFrom, dateTo),
                          bi: replyTo,
                          c8: reviewId,
                          Y: status
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };

    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Comment$status, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Comment$comment_divisions, $elm$core$Basics$identity, $author$project$Api$Schema$commentDivisionId), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Comment$comment, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Comment$review_id, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$Comment$reply_to, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Comment$date_to, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Comment$date_from, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Comment$created_at, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Comment$created_by, $elm$core$Basics$identity, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Comment$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(toComment)))))))))));
  }();

  var $author$project$Api$GraphqlSchema$Enum$Comment_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'comment';

      case 1:
        return 'company_id';

      case 2:
        return 'created_at';

      case 3:
        return 'created_by';

      case 4:
        return 'date_from';

      case 5:
        return 'date_to';

      case 6:
        return 'id';

      case 7:
        return 'reply_to';

      case 8:
        return 'review_id';

      case 9:
        return 'scenario_id';

      case 10:
        return 'status';

      default:
        return 'updated_at';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Scenario$comments = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeComment_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeComment_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'comments', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Scenario$created_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'created_by', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Scenario$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'description', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Scenario$draft = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'draft', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$Scenario$enabled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'enabled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$Scenario$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Scenario$length = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'length', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$Scenario$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Types$Scenario$NineMonths = 1;
  var $author$project$Types$Scenario$OneYear = 2;
  var $author$project$Types$Scenario$TwoYears = 3;

  var $author$project$Types$Scenario$noOfMonthsToScenario = function (scenarioLength) {
    switch (scenarioLength) {
      case 6:
        return $elm$core$Maybe$Just(0);

      case 9:
        return $elm$core$Maybe$Just(1);

      case 12:
        return $elm$core$Maybe$Just(2);

      case 24:
        return $elm$core$Maybe$Just(3);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Scenario$published = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'published', _List_Nil, $elm$json$Json$Decode$bool);

  var $author$project$Api$GraphqlSchema$Enum$Review_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'approval_requested_at';

      case 1:
        return 'approval_requested_by';

      case 2:
        return 'approved_at';

      case 3:
        return 'approved_by';

      case 4:
        return 'company_id';

      case 5:
        return 'created_at';

      case 6:
        return 'created_by';

      case 7:
        return 'id';

      case 8:
        return 'name';

      case 9:
        return 'scenario_id';

      default:
        return 'status';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Scenario$reviews = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Review_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeReview_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeReview_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reviews', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Scenario$start_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'start_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);

  var $author$project$Types$Comment$unwrapCommentId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Types$Comment$toCommentDictFromList = function (comments) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Comment$unwrapCommentId, A2($elm$core$List$map, function (r) {
      return _Utils_Tuple2(r.F, r);
    }, comments));
  };

  var $author$project$Types$Review$toReviewDictFromList = function (reviews) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Review$unwrapReviewId, A2($elm$core$List$map, function (r) {
      return _Utils_Tuple2(r.F, r);
    }, reviews));
  };

  var $author$project$Api$GraphqlSchema$Object$Scenario$updated_at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Timestamptz', 'updated_at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ep.wB);
  var $author$project$Api$GraphqlSchema$Object$Scenario$updated_by = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'updated_by', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));

  var $author$project$Api$Schema$scenario = function () {
    var toScenario = function (id) {
      return function (name) {
        return function (description) {
          return function (isDraft) {
            return function (isActive) {
              return function (isPublished) {
                return function (createdBy) {
                  return function (updatedBy) {
                    return function (updatedAt) {
                      return function (startAt) {
                        return function (length) {
                          return function (reviews) {
                            return function (comments) {
                              return {
                                bH: $author$project$Types$Comment$toCommentDictFromList(comments),
                                cC: createdBy,
                                E: description,
                                F: id,
                                yC: isActive,
                                yN: isDraft,
                                yU: isPublished,
                                rf: length,
                                zL: name,
                                c9: $author$project$Types$Review$toReviewDictFromList(reviews),
                                tB: startAt,
                                Fg: A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, updatedBy, $elm$core$Maybe$Just(updatedAt))
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };

    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Scenario$comments, $elm$core$Basics$identity, $author$project$Api$Schema$comment), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Scenario$reviews, $elm$core$Basics$identity, $author$project$Api$Schema$review), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$Scenario$noOfMonthsToScenario, $author$project$Api$GraphqlSchema$Object$Scenario$length)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario$start_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario$updated_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$maybeMapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Scenario$updated_by), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Scenario$created_by), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario$published, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario$enabled, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario$draft, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Scenario$description, $elm$core$Maybe$withDefault(''), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Scenario$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Scenario$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(toScenario))))))))))))));
  }();

  var $author$project$Api$GraphqlSchema$Enum$Scenario_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'created_at';

      case 2:
        return 'created_by';

      case 3:
        return 'description';

      case 4:
        return 'draft';

      case 5:
        return 'enabled';

      case 6:
        return 'id';

      case 7:
        return 'length';

      case 8:
        return 'name';

      case 9:
        return 'published';

      case 10:
        return 'start_at';

      case 11:
        return 'updated_at';

      default:
        return 'updated_by';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Company$scenarios = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Scenario_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenarios', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });

  var $author$project$Api$GraphqlSchema$Enum$Seasonality_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'company_id';

      case 1:
        return 'id';

      case 2:
        return 'month_adjustments';

      default:
        return 'preset_name';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Company$seasonalities = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Seasonality_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'seasonalities', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Types$Seasonality$SeasonalityId = $elm$core$Basics$identity;
  var $author$project$Types$SeasonalityPreset$SeasonalityPreset = F3(function (id, presetName, monthAdjustments) {
    return {
      F: id,
      dW: monthAdjustments,
      dH: presetName
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Seasonality$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$Seasonality$month_adjustments = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Int4_', 'month_adjustments', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).em.wB);
  var $author$project$Api$GraphqlSchema$Object$Seasonality$preset_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'preset_name', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$seasonalityPreset = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Seasonality$month_adjustments, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail($author$project$Api$GraphqlSchema$Object$Seasonality$preset_name), A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Seasonality$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$SeasonalityPreset$SeasonalityPreset))));

  var $author$project$Types$ScenarioBlock$toScenarioBlockDict = function (scenarioBlockRelationships) {
    return $author$project$ElmFramework$Lib$PivotDict$fromList({
      aA: scenarioBlockRelationships,
      d8: $author$project$Types$Scenario$unwrapScenarioId,
      eB: $author$project$Types$BuildingBlock$unwrapBuildingBlockId,
      eE: function ($) {
        return $.e8;
      },
      eF: function ($) {
        return $.dM;
      }
    });
  };

  var $author$project$Api$Types$UserCompanyWithUser$UserCompanyWithUser = F3(function (user, companyId, role) {
    return {
      b9: companyId,
      gz: role,
      Fl: user
    };
  });
  var $author$project$Api$GraphqlSchema$Object$User_company$company_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'company_id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Object$User_company$user = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Schema$userCompanyWithUser = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User_company$role, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$User_company$company_id, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$User_company$user($author$project$Api$Schema$user), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$UserCompanyWithUser$UserCompanyWithUser))));
  var $author$project$Api$GraphqlSchema$Object$Company$user_companies = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$User_company_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUser_company_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeUser_company_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user_companies', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Schema$companyWithDetailsIncomplete = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$seasonalities, function (optArgs) {
    return _Utils_update(optArgs, {
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$isPresetSeasonality)
    });
  }, $author$project$Api$Schema$seasonalityPreset), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$reporting_currency, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$reporting_wk_ending, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$size, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$user_companies, $elm$core$Basics$identity, $author$project$Api$Schema$userCompanyWithUser), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$top_scenarios($author$project$Api$Schema$topScenario), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$scenarios, $elm$core$Basics$identity, $author$project$Api$Schema$scenario), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$blocks, $elm$core$Basics$identity, $author$project$Api$Schema$block), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$invites, $elm$core$Basics$identity, $author$project$Api$Schema$invitation), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$divisions, $elm$core$Basics$identity, $author$project$Api$Schema$division), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Company$timezoneDetails, $elm$core$Basics$identity, $author$project$Api$Schema$timeZone), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$reporting_default_interval, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$inter_division_show_both_tx, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_street, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_postal_code, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_number, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_gmaps_place_uid, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_country_subdivision_code, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$address_country($author$project$Api$Schema$country), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Maybe$Just, $author$project$Api$GraphqlSchema$Object$Company$address_city), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$created_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Company$id, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(function (companyId) {
    return function (name) {
      return function (createdAt) {
        return function (addressCity) {
          return function (countryVal) {
            return function (countrySubdivisionCode) {
              return function (placesId) {
                return function (addressNo) {
                  return function (placesCode) {
                    return function (addressStreet) {
                      return function (interDivision) {
                        return function (reporting) {
                          return function (timeZoneDetails) {
                            return function (divisions) {
                              return function (invites) {
                                return function (blocks) {
                                  return function (scenarios) {
                                    return function (topScenarios) {
                                      return function (userCompanies) {
                                        return function (size) {
                                          return function (reportingWeekEnding) {
                                            return function (reportingCurrency) {
                                              return function (seasonalityPresets) {
                                                return {
                                                  bW: {
                                                    pu: addressCity,
                                                    pF: $elm$core$Maybe$Just(countryVal),
                                                    pH: countrySubdivisionCode,
                                                    qD: placesId,
                                                    rE: addressNo,
                                                    sF: $elm$core$Maybe$Just(placesCode),
                                                    tI: addressStreet
                                                  },
                                                  pa: A2($elm$core$Maybe$andThen, function ($) {
                                                    return $.kv;
                                                  }, topScenarios),
                                                  pe: A2($elm$core$Maybe$andThen, function ($) {
                                                    return $.ky;
                                                  }, topScenarios),
                                                  pg: $author$project$Types$BuildingBlock$createBuildingBlocksDict(blocks),
                                                  iK: createdAt,
                                                  eO: $author$project$Types$Division$createDivisionDict(divisions),
                                                  F: $author$project$Api$Schema$uuidToString(companyId),
                                                  b_: interDivision,
                                                  q_: $author$project$Types$Invitation$createInvitationsDict(invites),
                                                  zL: name,
                                                  b0: reportingCurrency,
                                                  b1: reporting,
                                                  b2: function () {
                                                    switch (reportingWeekEnding) {
                                                      case 1:
                                                        return 0;

                                                      case 2:
                                                        return 1;

                                                      case 3:
                                                        return 2;

                                                      case 4:
                                                        return 3;

                                                      case 5:
                                                        return 4;

                                                      case 6:
                                                        return 5;

                                                      case 7:
                                                        return 6;

                                                      default:
                                                        return 0;
                                                    }
                                                  }(),
                                                  nT: $author$project$Types$ScenarioBlock$toScenarioBlockDict(_List_Nil),
                                                  db: $author$project$Types$Scenario$createScenarioDict(scenarios),
                                                  ti: $author$project$Types$SeasonalityPreset$createSeasonalityPresetDict(seasonalityPresets),
                                                  aB: size,
                                                  t$: timeZoneDetails,
                                                  ue: userCompanies
                                                };
                                              };
                                            };
                                          };
                                        };
                                      };
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  }))))))))))))))))))))))));

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_order_by = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('block', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.y, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), _Utils_Tuple2('block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aS, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('company_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('quickEditOfScenarioBlock', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cZ, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_order_by)), _Utils_Tuple2('quick_edit_of_block_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('quick_edit_user_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('scenario', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dw, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), _Utils_Tuple2('scenario_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.A, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Scenario_block_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'block_id';

      case 1:
        return 'company_id';

      case 2:
        return 'enabled';

      case 3:
        return 'id';

      case 4:
        return 'quick_edit_of_block_id';

      case 5:
        return 'quick_edit_user_id';

      default:
        return 'scenario_id';
    }
  };

  var $author$project$Api$GraphqlSchema$Query$scenario_block = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Scenario_block_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_block_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenario_block', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Util$uuidComparison = {
    e: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    G: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    H: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    f: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    I: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    J: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    h: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
    i: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
  };

  var $author$project$Api$Schema$companyWithDetails = function (_v0) {
    var companyId = _v0;
    var toCompany = F2(function (scenarioBlocks, comp) {
      return _Utils_update(comp, {
        nT: $author$project$Types$ScenarioBlock$toScenarioBlockDict(scenarioBlocks)
      });
    });
    var queryByCompany = {
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      aS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_Utils_update($author$project$Api$Util$uuidComparison, {
        e: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(companyId)
      })),
      la: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Dw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      A: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    };

    var scenarioBlocksQuery = function (q) {
      return _Utils_update(q, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryByCompany)
      });
    };

    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Query$company_by_pk, {
      F: $author$project$Api$Schema$uuidFromString(companyId)
    }, $author$project$Api$Schema$companyWithDetailsIncomplete), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Query$scenario_block, scenarioBlocksQuery, $author$project$Api$Schema$scenarioBlockRelationship), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (scenarioBlocks, maybeCompany) {
      return A2($elm$core$Result$fromMaybe, 'Company not found', A2($elm$core$Maybe$map, toCompany(scenarioBlocks), maybeCompany));
    }))));
  };

  var $author$project$Api$Api$getCompanyDetailsTask = F3(function (companyId, url, idToken) {
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$Schema$companyWithDetails(companyId), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$map($author$project$Api$Types$GetCompanyDetailsResult$GetCompanyDetailsResult))));
  });
  var $author$project$Api$GraphqlSchema$Object$CloneScenarioPreservingQuickEditsSuccess$newScenarioId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'newScenarioId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Api$cloneScenarioPreservingQuickEdits = F5(function (companyId, scenarioId, tag, url, idToken) {
    var resultToIdTuple = function (id) {
      return A2($elm$core$Basics$composeR, $elm$core$Task$map($elm$core$Result$map($elm$core$Tuple$pair(id))), $elm$core$Task$mapError($dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map($elm$core$Tuple$pair(id)))));
    };

    var cloneScenarioPreservingQuickEditsResponse = $author$project$Api$GraphqlSchema$Union$CloneScenarioPreservingQuickEditsPayload$fragments({
      Ah: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Result$Ok), $author$project$Api$GraphqlSchema$Object$CloneScenarioPreservingQuickEditsSuccess$newScenarioId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var cloneScenarioPreservingQuickEditsTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(scenarioId)
    }, $author$project$Api$GraphqlSchema$Object$ScenarioMutation$cloneScenarioPreservingQuickEdits(cloneScenarioPreservingQuickEditsResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(function (id) {
      return A2(resultToIdTuple, id, A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken));
    }), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, cloneScenarioPreservingQuickEditsTask)));
  });
  var $author$project$Api$Api$connectAccountingSystemDivision = F5(function (_v0, _v1, _v2, _v3, _v4) {
    return $elm$core$Platform$Cmd$none;
  });
  var $author$project$Api$GraphqlSchema$Mutation$allocationClassCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'allocationClassCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateAllocationClassSuccess$allocationClassId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'allocationClassId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateAllocationClassInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('parentId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dG)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AllocationClassCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateAllocationClassInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateAllocationClassPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateAllocationClassSuccess', selections____.Am), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Types$CreateAllocationClassReq$toCreateAllocationClassInput = function (req) {
    return {
      zL: req.zL,
      dG: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$AllocationClass$unwrapAllocationClassId, req.dG)
    };
  };

  var $author$project$Api$Api$createAllocationClass = F5(function (companyId, req, tag, url, idToken) {
    var addClassResponse = $author$project$Api$GraphqlSchema$Union$CreateAllocationClassPayload$fragments({
      Am: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
        var id = _v0;
        return $elm$core$Result$Ok(id);
      }, $author$project$Api$GraphqlSchema$Object$CreateAllocationClassSuccess$allocationClassId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var addClassTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$allocationClassCreate, {
      b9: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Company$unwrapCompanyId, companyId)
    }, A2($author$project$Api$GraphqlSchema$Object$AllocationClassCreateMutation$create, {
      W: $author$project$Api$Types$CreateAllocationClassReq$toCreateAllocationClassInput(req)
    }, addClassResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, addClassTask)));
  });

  var $author$project$Api$GraphqlSchema$Mutation$blockCreate = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'blockCreate', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBlockDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('companyId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.b9))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('of', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString, input____.bP))), _Utils_Tuple2('startOn', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.bw))), _Utils_Tuple2('type', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Block_type_enum$toString, input____.P)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocationFractionInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('denominator', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.px;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.q))), _Utils_Tuple2('numerator', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.px;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.s)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocationValueInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('amountFixed', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fw, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('fraction', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fY, $author$project$Api$GraphqlSchema$InputObject$encodeAllocationFractionInput))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAllocationInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('allocation', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeAllocationValueInput(input____.g$))), _Utils_Tuple2('enteredAs', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hp))), _Utils_Tuple2('onDate', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.hS)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeTimeTransformInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('allocations', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAllocationInput)(input____.dw))), _Utils_Tuple2('refPeriod', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hd;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.h1))), _Utils_Tuple2('shiftAlgorithm', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_algorithm_enum$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeMoneyBlockDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accountId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fj, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('allocationClassId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fu, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('basis', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString, input____.pb))), _Utils_Tuple2('basisTransform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fE, $author$project$Api$GraphqlSchema$InputObject$encodeTimeTransformInput)), _Utils_Tuple2('internal', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.bN))), _Utils_Tuple2('internalOppositeAccountId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f2, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('internalOppositeAllocationClassId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f3, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('unit', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString, input____.V)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeThingBlockDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('unit', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.V)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfBlockOfDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('moneyBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gf, $author$project$Api$GraphqlSchema$InputObject$encodeMoneyBlockDescriptorInput)), _Utils_Tuple2('thingBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gL, $author$project$Api$GraphqlSchema$InputObject$encodeThingBlockDescriptorInput))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeGrowthPatternDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('every', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.ao))), _Utils_Tuple2('period', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString, input____.ap))), _Utils_Tuple2('rate', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$float(input____.bR))), _Utils_Tuple2('startOn', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.bw)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSeasonalityDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('monthAdjustments', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)(input____.dW))), _Utils_Tuple2('presetName', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dH, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfSeasonalityIdOrDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('descriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pT, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonalityDescriptorInput)), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfEndAtDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iL, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeRepeatPatternDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('endAt', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfEndAtDescriptorInput(input____.hn))), _Utils_Tuple2('every', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.ao))), _Utils_Tuple2('period', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString, input____.ap)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeBasicBlockDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('baseValue', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.g5))), _Utils_Tuple2('growthPattern', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fZ, $author$project$Api$GraphqlSchema$InputObject$encodeGrowthPatternDescriptorInput)), _Utils_Tuple2('repeatPattern', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeRepeatPatternDescriptorInput(input____.h2))), _Utils_Tuple2('seasonality', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bK, $author$project$Api$GraphqlSchema$InputObject$encodeOneOfSeasonalityIdOrDescriptorInput))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfDerivativeOfInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('baseAllocationClassId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fA, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('baseBlockId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fC, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivativeBlockDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('derivativeOf', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfDerivativeOfInput(input____.hk))), _Utils_Tuple2('endOn', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.ho))), _Utils_Tuple2('multiplier', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$float(input____.r))), _Utils_Tuple2('per', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$float(input____.t))), _Utils_Tuple2('timeTransform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gM, $author$project$Api$GraphqlSchema$InputObject$encodeTimeTransformInput))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeDerivativeMoneyBlockDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('baseBasis', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fB, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Basis_enum$toString))), _Utils_Tuple2('derivativeBlockDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeDerivativeBlockDescriptorInput(input____.bM)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfBlockTypeDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('basicBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ct, $author$project$Api$GraphqlSchema$InputObject$encodeBasicBlockDescriptorInput)), _Utils_Tuple2('derivativeBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bM, $author$project$Api$GraphqlSchema$InputObject$encodeDerivativeBlockDescriptorInput)), _Utils_Tuple2('derivativeMoneyBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fO, $author$project$Api$GraphqlSchema$InputObject$encodeDerivativeMoneyBlockDescriptorInput))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeBlockDescriptorInput(input____.dL))), _Utils_Tuple2('blockOfDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfBlockOfDescriptorInput(input____.dN))), _Utils_Tuple2('blockTypeDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfBlockTypeDescriptorInput(input____.dO)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$BlockCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateBlockInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateBlockSuccess', selections____.An), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Types$BuildingBlockWithDetails$BuildingBlockWithDetails = F7(function (id, name, createdAt, updatedAt, blockType, startOn, createdBy) {
    return {
      kw: blockType,
      iK: createdAt,
      cC: createdBy,
      F: id,
      zL: name,
      bw: startOn,
      oB: updatedAt
    };
  });
  var $author$project$Types$BuildingBlock$BasicPayload = F4(function (baseValue, seasonality, growthPattern, repeatPattern) {
    return {
      g5: baseValue,
      fZ: growthPattern,
      h2: repeatPattern,
      bK: seasonality
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Basic_block$base_value = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Numeric', 'base_value', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB);
  var $author$project$Types$GrowthPattern$GrowthPattern = F4(function (every, period, rate, startOn) {
    return {
      ao: every,
      ap: period,
      bR: rate,
      bw: startOn
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Growth_pattern$every = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'every', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$Quarter = 1;
  var $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$Week = 2;
  var $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$Year = 3;
  var $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'MONTH':
        return $elm$json$Json$Decode$succeed(0);

      case 'QUARTER':
        return $elm$json$Json$Decode$succeed(1);

      case 'WEEK':
        return $elm$json$Json$Decode$succeed(2);

      case 'YEAR':
        return $elm$json$Json$Decode$succeed(3);

      default:
        return $elm$json$Json$Decode$fail('Invalid Growth_period_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Growth_pattern$period = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Growth_period_enum.Growth_period_enum', 'period', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Growth_pattern$rate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'rate', _List_Nil, $elm$json$Json$Decode$float);
  var $author$project$Api$GraphqlSchema$Object$Growth_pattern$start_on = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'start_on', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $author$project$Types$Fraction$toFractionFromFloat = A2($elm$core$Basics$composeR, $elm$core$String$fromFloat, $author$project$Types$Fraction$toFractionFromString('.'));
  var $author$project$Api$Schema$growthPattern = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Growth_pattern$start_on, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$Fraction$toFractionFromFloat, $author$project$Api$GraphqlSchema$Object$Growth_pattern$rate)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Growth_pattern$period, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Growth_pattern$every, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$GrowthPattern$GrowthPattern)))));

  var $author$project$Api$GraphqlSchema$Object$Basic_block$growth_pattern = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'growth_pattern', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Types$RepeatPattern$RepeatPattern = F3(function (every, period, endAt) {
    return {
      hn: endAt,
      ao: every,
      ap: period
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Repeat_pattern$end_at_count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Int)', 'end_at_count', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
  var $author$project$Api$GraphqlSchema$Object$Repeat_pattern$end_at_date = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Date)', 'end_at_date', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB));
  var $author$project$Api$GraphqlSchema$Object$Repeat_pattern$every = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'every', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$HalfMonth = 1;
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$Month = 2;
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$Quarter = 3;
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$Week = 4;
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$Year = 5;
  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'DAY':
        return $elm$json$Json$Decode$succeed(0);

      case 'HALF_MONTH':
        return $elm$json$Json$Decode$succeed(1);

      case 'MONTH':
        return $elm$json$Json$Decode$succeed(2);

      case 'QUARTER':
        return $elm$json$Json$Decode$succeed(3);

      case 'WEEK':
        return $elm$json$Json$Decode$succeed(4);

      case 'YEAR':
        return $elm$json$Json$Decode$succeed(5);

      default:
        return $elm$json$Json$Decode$fail('Invalid Repeat_period_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Repeat_pattern$period = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Repeat_period_enum.Repeat_period_enum', 'period', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$decoder);
  var $author$project$Api$Schema$repeatPattern = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (endAtDate, endAtCount) {
    var _v0 = _Utils_Tuple2(endAtDate, endAtCount);

    if (!_v0.a.$) {
      var e = _v0.a.a;
      return $elm$core$Maybe$Just($author$project$Types$RepeatPattern$Date(e));
    } else {
      if (!_v0.b.$) {
        var _v1 = _v0.a;
        var c = _v0.b.a;
        return $elm$core$Maybe$Just($author$project$Types$RepeatPattern$Count(c));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }
  }), $author$project$Api$GraphqlSchema$Object$Repeat_pattern$end_at_date, $author$project$Api$GraphqlSchema$Object$Repeat_pattern$end_at_count)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Repeat_pattern$period, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Repeat_pattern$every, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$RepeatPattern$RepeatPattern))));

  var $author$project$Api$GraphqlSchema$Object$Basic_block$repeat_pattern = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'repeat_pattern', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$Basic_block$seasonality = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'seasonality', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Types$SeasonalityInBlock$SeasonalityPreset = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$SeasonalityInBlock$SeasonalityValue = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$Schema$seasonalityInBlock = function () {
    var mapToSeasonalityInBlock = F3(function (seasonalityId, maybePresetName, monthAdjustments) {
      if (!maybePresetName.$) {
        return $author$project$Types$SeasonalityInBlock$SeasonalityPreset(seasonalityId);
      } else {
        return $author$project$Types$SeasonalityInBlock$SeasonalityValue(monthAdjustments);
      }
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Seasonality$month_adjustments, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Seasonality$preset_name, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$Seasonality$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(mapToSeasonalityInBlock))));
  }();

  var $author$project$Api$Schema$basicBlock = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Basic_block$repeat_pattern($author$project$Api$Schema$repeatPattern), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Basic_block$growth_pattern($author$project$Api$Schema$growthPattern), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Basic_block$seasonality($author$project$Api$Schema$seasonalityInBlock), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Basic_block$base_value, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$BuildingBlock$BasicPayload)))));

  var $author$project$Api$GraphqlSchema$Object$Block$basic_block = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'basic_block', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Types$BuildingBlock$BaseAllocationClass = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$BaseBlock = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Object$Derivative_block$base_allocation_class_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'base_allocation_class_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Derivative_block$base_block_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'base_block_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));

  var $author$project$Types$BuildingBlock$DerivativeMoneyPayload = function (baseBasis) {
    return {
      fB: baseBasis
    };
  };

  var $author$project$Api$GraphqlSchema$Enum$Basis_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ACCRUAL':
        return $elm$json$Json$Decode$succeed(0);

      case 'CASH':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Basis_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Derivative_money_block$base_basis = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Enum.Basis_enum.Basis_enum)', 'base_basis', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Enum$Basis_enum$decoder));
  var $author$project$Api$Schema$derivativeMoneyBlock = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Derivative_money_block$base_basis, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$BuildingBlock$DerivativeMoneyPayload));

  var $author$project$Api$GraphqlSchema$Object$Derivative_block$derivative_money_block = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'derivative_money_block', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$AllocationClass = 0;
  var $author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$Block = 1;
  var $author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ALLOCATION_CLASS':
        return $elm$json$Json$Decode$succeed(0);

      case 'BLOCK':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid Derivative_of_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Derivative_block$derivative_of = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Derivative_of_enum.Derivative_of_enum', 'derivative_of', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Derivative_of_enum$decoder);
  var $author$project$Api$GraphqlSchema$Object$Derivative_block$end_on = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'end_on', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $author$project$Api$GraphqlSchema$Object$Derivative_block$multiplier = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'multiplier', _List_Nil, $elm$json$Json$Decode$float);
  var $author$project$Api$GraphqlSchema$Object$Derivative_block$per = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'per', _List_Nil, $elm$json$Json$Decode$float);
  var $author$project$Types$TimeTransformationBackend$TimeTransformationBackend = F2(function (refInterval, timeTransformationAllocations) {
    return {
      sT: refInterval,
      t_: timeTransformationAllocations
    };
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('amount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.p, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('denominator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('entered_as', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('entered_on_date', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('numerator', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('relative_to', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_day_of_month', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_days', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.C, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('shift_months', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('time_transform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bo, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_order_by)), _Utils_Tuple2('time_transform_id', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString))), _Utils_Tuple2('unit', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_select_column$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'amount';

      case 1:
        return 'denominator';

      case 2:
        return 'entered_as';

      case 3:
        return 'entered_on_date';

      case 4:
        return 'id';

      case 5:
        return 'numerator';

      case 6:
        return 'relative_to';

      case 7:
        return 'shift_day_of_month';

      case 8:
        return 'shift_days';

      case 9:
        return 'shift_months';

      case 10:
        return 'time_transform_id';

      default:
        return 'unit';
    }
  };

  var $author$project$Api$GraphqlSchema$Object$Time_transform$allocations = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeTime_transform_allocation_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'allocations', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Time_transform$ref_interval_end_on = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'ref_interval_end_on', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $author$project$Api$GraphqlSchema$Object$Time_transform$ref_interval_start_on = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'ref_interval_start_on', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $author$project$Types$TimeTransformationBackend$TimeTransformAllocation = F2(function (date, inputType) {
    return {
      iL: date,
      qU: inputType
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Numeric)', 'amount', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB));
  var $author$project$Api$GraphqlSchema$InputObject$AllocationFractionInput = F2(function (denominator, numerator) {
    return {
      q: denominator,
      s: numerator
    };
  });
  var $author$project$Api$Types$BackendFraction$backendFractionDecoder = A3($elm$json$Json$Decode$map2, $author$project$Api$GraphqlSchema$InputObject$AllocationFractionInput, A2($elm$json$Json$Decode$field, 'denominator', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'numerator', $elm$json$Json$Decode$int));
  var $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$denominator = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Numeric)', 'denominator', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB));

  var $author$project$ElmFramework$Lib$Fraction$reciprocalUnsafe = function (fraction) {
    return A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, $JoshuaHall$elm_fraction$Fraction$getDenominator(fraction), $JoshuaHall$elm_fraction$Fraction$getNumerator(fraction));
  };

  var $author$project$ElmFramework$Lib$Fraction$divideUnsafe = F2(function (fraction1, fraction2) {
    return A2($JoshuaHall$elm_fraction$Fraction$multiply, fraction1, $author$project$ElmFramework$Lib$Fraction$reciprocalUnsafe(fraction2));
  });
  var $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$entered_as = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'entered_as', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$entered_on_date = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Date', 'entered_on_date', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).el.wB);
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$map5 = F6(function (combine, _v0, _v1, _v2, _v3, _v4) {
    var selectionFields1 = _v0.a;
    var selectionDecoder1 = _v0.b;
    var selectionFields2 = _v1.a;
    var selectionDecoder2 = _v1.b;
    var selectionFields3 = _v2.a;
    var selectionDecoder3 = _v2.b;
    var selectionFields4 = _v3.a;
    var selectionDecoder4 = _v3.b;
    var selectionFields5 = _v4.a;
    var selectionDecoder5 = _v4.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, $elm$core$List$concat(_List_fromArray([selectionFields1, selectionFields2, selectionFields3, selectionFields4, selectionFields5])), A6($elm$json$Json$Decode$map5, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3, selectionDecoder4, selectionDecoder5));
  });
  var $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$numerator = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Numeric)', 'numerator', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).en.wB));
  var $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$Amount = 0;
  var $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$AmountFixed = 1;
  var $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$Percent = 2;
  var $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'AMOUNT':
        return $elm$json$Json$Decode$succeed(0);

      case 'AMOUNT_FIXED':
        return $elm$json$Json$Decode$succeed(1);

      case 'PERCENT':
        return $elm$json$Json$Decode$succeed(2);

      default:
        return $elm$json$Json$Decode$fail('Invalid Time_transform_allocation_unit_enum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$unit = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Time_transform_allocation_unit_enum.Time_transform_allocation_unit_enum', 'unit', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Time_transform_allocation_unit_enum$decoder);

  var $author$project$Api$Schema$timeTransformAllocation = function () {
    var toRatioValue = F2(function (n, d) {
      return A2($author$project$ElmFramework$Lib$Fraction$divideUnsafe, n, d);
    });

    var toEnteredAs = function (enteredAs) {
      return A2($elm$core$Maybe$map, $author$project$Types$TimeTransformationBackend$CurrencyValue, A2($elm$core$Maybe$andThen, function (_v1) {
        var numerator = _v1.s;
        var denominator = _v1.q;
        return A2($JoshuaHall$elm_fraction$Fraction$create, numerator, denominator);
      }, $elm$core$Result$toMaybe(A2($elm$json$Json$Decode$decodeString, $author$project$Api$Types$BackendFraction$backendFractionDecoder, enteredAs))));
    };

    var toAmountValueWithRatioFallback = F3(function (n, d, enteredAs) {
      return A2($elm$core$Maybe$withDefault, $author$project$Types$TimeTransformationBackend$Ratio(A2($author$project$ElmFramework$Lib$Fraction$divideUnsafe, n, d)), toEnteredAs(enteredAs));
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Basics$identity, A6($dillonkearns$elm_graphql$Graphql$SelectionSet$map5, F5(function (unit, maybeAmount, maybeNum, maybeDenom, enteredAs) {
      switch (unit) {
        case 0:
          return A2($elm$core$Result$fromMaybe, 'timeTransformAllocation: Amount fraction isn\'t provided', A3($elm$core$Maybe$map2, F2(function (num, denom) {
            return A3(toAmountValueWithRatioFallback, num, denom, enteredAs);
          }), maybeNum, maybeDenom));

        case 2:
          return A2($elm$core$Result$fromMaybe, 'timeTransformAllocation: Percent fraction isn\'t provided', A3($elm$core$Maybe$map2, F2(function (num, denom) {
            return $author$project$Types$TimeTransformationBackend$Ratio(A2(toRatioValue, num, denom));
          }), maybeNum, maybeDenom));

        default:
          return A2($elm$core$Result$fromMaybe, 'timeTransformAllocation: Amount isn\'t provided', A2($elm$core$Maybe$map, $author$project$Types$TimeTransformationBackend$CurrencyValue, maybeAmount));
      }
    }), $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$unit, $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$amount, $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$numerator, $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$denominator, $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$entered_as)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Time_transform_allocation$entered_on_date, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$TimeTransformationBackend$TimeTransformAllocation)));
  }();

  var $author$project$Api$Schema$timeTransformBackend = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$GraphqlSchema$Object$Time_transform$allocations, $elm$core$Basics$identity, $author$project$Api$Schema$timeTransformAllocation), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, $author$project$Types$SimpleDateRange$SimpleDateClosedRange, $author$project$Api$GraphqlSchema$Object$Time_transform$ref_interval_start_on, $author$project$Api$GraphqlSchema$Object$Time_transform$ref_interval_end_on), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$TimeTransformationBackend$TimeTransformationBackend)));

  var $author$project$Api$GraphqlSchema$Object$Derivative_block$time_transform = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'time_transform', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$Schema$derivativeBlock = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A4($dillonkearns$elm_graphql$Graphql$SelectionSet$map3, F3(function (derivative, baseAllocationId, baseBlockId) {
    if (!derivative) {
      return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Schema$uuidToString, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Types$BuildingBlock$BaseAllocationClass)), baseAllocationId);
    } else {
      return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Schema$uuidToString, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Types$BuildingBlock$BaseBlock)), baseBlockId);
    }
  }), $author$project$Api$GraphqlSchema$Object$Derivative_block$derivative_of, $author$project$Api$GraphqlSchema$Object$Derivative_block$base_allocation_class_id, $author$project$Api$GraphqlSchema$Object$Derivative_block$base_block_id)), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Derivative_block$time_transform($author$project$Api$Schema$timeTransformBackend), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Derivative_block$per, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Derivative_block$multiplier, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Derivative_block$end_on, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Derivative_block$derivative_money_block($author$project$Api$Schema$derivativeMoneyBlock), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F6(function (dbb, endOn, multiplier, per, timeTransform, derivativeOf) {
    return {
      pR: dbb,
      hk: derivativeOf,
      ho: endOn,
      r: multiplier,
      t: per,
      gM: timeTransform
    };
  }))))))));

  var $author$project$Api$GraphqlSchema$Object$Block$derivative_block = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'derivative_block', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$Types$BuildingBlockWithDetails$BasicMoney = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$Types$BuildingBlockWithDetails$BasicThing = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$Types$BuildingBlockWithDetails$DerivativeMoney = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Api$Types$BuildingBlockWithDetails$DerivativeThing = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Types$BuildingBlock$emptyDerivativeMoneyPayload = {
    fB: $elm$core$Maybe$Nothing
  };
  var $author$project$Api$Types$BuildingBlockWithDetails$fromBlockTypeEnum = F7(function (blockType, blockOf, basicPayload, moneyPayload, thingPayload, derivativePayload, derivativeMoneyPayload) {
    var _v0 = _Utils_Tuple2(blockType, blockOf);

    if (!_v0.a) {
      if (!_v0.b) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return A3($elm$core$Maybe$map2, F2(function (bP, mP) {
          return $author$project$Api$Types$BuildingBlockWithDetails$BasicMoney(_Utils_Tuple2(bP, mP));
        }), basicPayload, moneyPayload);
      } else {
        var _v3 = _v0.a;
        var _v4 = _v0.b;
        return A3($elm$core$Maybe$map2, F2(function (bP, tP) {
          return $author$project$Api$Types$BuildingBlockWithDetails$BasicThing(_Utils_Tuple2(bP, tP));
        }), basicPayload, thingPayload);
      }
    } else {
      if (!_v0.b) {
        var _v5 = _v0.a;
        var _v6 = _v0.b;
        return A3($elm$core$Maybe$map2, F2(function (dP, mP) {
          return $author$project$Api$Types$BuildingBlockWithDetails$DerivativeMoney(_Utils_Tuple3(dP, mP, A2($elm$core$Maybe$withDefault, $author$project$Types$BuildingBlock$emptyDerivativeMoneyPayload, derivativeMoneyPayload)));
        }), derivativePayload, moneyPayload);
      } else {
        var _v7 = _v0.a;
        var _v8 = _v0.b;
        return A3($elm$core$Maybe$map2, F2(function (dP, tP) {
          return $author$project$Api$Types$BuildingBlockWithDetails$DerivativeThing(_Utils_Tuple2(dP, tP));
        }), derivativePayload, thingPayload);
      }
    }
  });
  var $author$project$Types$BuildingBlock$MoneyPayload = F4(function (unit, basis, basisTransform, allocationClassData) {
    return {
      kg: allocationClassData,
      pb: basis,
      fE: basisTransform,
      V: unit
    };
  });
  var $author$project$Types$BuildingBlock$AllocationClassData = F2(function (allocationAccountPair, internalOpposite) {
    return {
      iu: allocationAccountPair,
      qZ: internalOpposite
    };
  });
  var $author$project$Types$BuildingBlock$AllocationAccountPair = F2(function (allocationClass, financialAccount) {
    return {
      kf: allocationClass,
      lo: financialAccount
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Money_block$account_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'account_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Money_block$allocation_class_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'allocation_class_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$Schema$allocationAccountPair = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$maybeMapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Money_block$account_id), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$maybeMapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Money_block$allocation_class_id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Maybe$map2($author$project$Types$BuildingBlock$AllocationAccountPair))));
  var $author$project$Api$GraphqlSchema$Object$Money_block$internal_opposite_account_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'internal_opposite_account_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$GraphqlSchema$Object$Money_block$internal_opposite_class_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'internal_opposite_class_id', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$Schema$internalOppositePair = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$maybeMapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Money_block$internal_opposite_account_id), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$maybeMapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Money_block$internal_opposite_class_id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Maybe$map2($author$project$Types$BuildingBlock$AllocationAccountPair))));
  var $author$project$Api$Schema$allocationClassData = A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (acp, iop) {
    return A2($elm$core$Maybe$map, function (yacp) {
      return A2($author$project$Types$BuildingBlock$AllocationClassData, yacp, iop);
    }, acp);
  }), $author$project$Api$Schema$allocationAccountPair, $author$project$Api$Schema$internalOppositePair);
  var $author$project$Api$GraphqlSchema$Object$Money_block$basis = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Basis_enum.Basis_enum', 'basis', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Basis_enum$decoder);

  var $author$project$Api$GraphqlSchema$Object$Money_block$basis_transform = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'basis_transform', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$GraphqlSchema$Object$Money_block$unit = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Currency_enum.Currency_enum', 'unit', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Currency_enum$decoder);
  var $author$project$Api$Schema$moneyBlock = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$Schema$allocationClassData, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Money_block$basis_transform($author$project$Api$Schema$timeTransformBackend), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Money_block$basis, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Money_block$unit, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$BuildingBlock$MoneyPayload)))));

  var $author$project$Api$GraphqlSchema$Object$Block$money_block = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'money_block', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Types$BuildingBlock$ThingPayload = function (unit) {
    return {
      V: unit
    };
  };

  var $author$project$Api$GraphqlSchema$Object$Thing_block$unit = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'unit', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$thingBlock = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Thing_block$unit, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$BuildingBlock$ThingPayload));

  var $author$project$Api$GraphqlSchema$Object$Block$thing_block = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'thing_block', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$Schema$blockWithDetails = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Block$created_by), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$start_on, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$derivative_block($author$project$Api$Schema$derivativeBlock), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$thing_block($author$project$Api$Schema$thingBlock), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$money_block($author$project$Api$Schema$moneyBlock), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$basic_block($author$project$Api$Schema$basicBlock), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$of_, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$type_, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F6(function (type_, of_, basicBlock_, moneyBlock_, thingBlock_, derivateBlock_) {
    return A7($author$project$Api$Types$BuildingBlockWithDetails$fromBlockTypeEnum, type_, of_, basicBlock_, moneyBlock_, thingBlock_, A2($elm$core$Maybe$map, function (db) {
      return {
        hk: db.hk,
        ho: db.ho,
        r: db.r,
        t: db.t,
        gM: db.gM
      };
    }, derivateBlock_), A2($elm$core$Maybe$andThen, function ($) {
      return $.pR;
    }, derivateBlock_));
  }))))))))), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$updated_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$created_at, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Block$name, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Block$id), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$BuildingBlockWithDetails$BuildingBlockWithDetails))))))));
  var $author$project$Api$GraphqlSchema$Query$block_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'block_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getBuildingBlockDetailsTask = F3(function (url, idToken, _v0) {
    var buildingBlockId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$block_by_pk, {
      F: buildingBlockId
    }, $author$project$Api$Schema$blockWithDetails));
  });
  var $author$project$Api$GraphqlSchema$Object$CreateBlockSuccess$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Types$CreateBlockReq$toDerivativeMoneyDescriptor = F2(function (derivativePayload, derivativeMoneyPayload) {
    return {
      fB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(derivativeMoneyPayload.fB),
      bM: A2($author$project$Api$Types$CreateBlockReq$toDerivativeDescriptor, true, derivativePayload)
    };
  });

  var $author$project$Api$Types$CreateBlockReq$toMoneyDescriptor = function (payload) {
    var derived = function () {
      var _v0 = payload.kg;

      if (!_v0.$) {
        var allocationClass = _v0.a;
        var _v1 = allocationClass.qZ;

        if (!_v1.$) {
          var internalOpposite = _v1.a;
          return {
            fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$FinancialAccount$unwrapFinancialAccountId(allocationClass.iu.lo)),
            fu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$AllocationClass$unwrapAllocationClassId(allocationClass.iu.kf)),
            f2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$FinancialAccount$unwrapFinancialAccountId(internalOpposite.lo)),
            f3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$AllocationClass$unwrapAllocationClassId(internalOpposite.kf))
          };
        } else {
          return {
            fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$FinancialAccount$unwrapFinancialAccountId(allocationClass.iu.lo)),
            fu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$AllocationClass$unwrapAllocationClassId(allocationClass.iu.kf)),
            f2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            f3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          };
        }
      } else {
        return {
          fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          fu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          f2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          f3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };
      }
    }();

    return {
      fj: derived.fj,
      fu: derived.fu,
      pb: payload.pb,
      fE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$Types$TimeTransformationReq$toTimeTransformInput, payload.fE)),
      bN: $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm$core$Maybe$andThen, function ($) {
        return $.qZ;
      }, payload.kg)),
      f2: derived.f2,
      f3: derived.f3,
      V: payload.V
    };
  };

  var $author$project$Api$Types$CreateBlockReq$toThingDescriptor = function (payload) {
    return {
      V: payload.V
    };
  };

  var $author$project$Api$Types$CreateBlockReq$toCreateBlockInput = F2(function (_v0, req) {
    var companyId = _v0;

    var blockInput = function () {
      var _v1 = req.kw;

      switch (_v1.$) {
        case 0:
          var _v2 = _v1.a;
          var basicPayload = _v2.a;
          var moneyPayloadReq = _v2.b;
          return {
            g6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CreateBlockReq$toBasicDescriptor(basicPayload)),
            g7: 0,
            hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CreateBlockReq$toMoneyDescriptor(moneyPayloadReq)),
            hO: 0,
            ij: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          };

        case 1:
          var _v3 = _v1.a;
          var basicPayload = _v3.a;
          var thingPayload = _v3.b;
          return {
            g6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CreateBlockReq$toBasicDescriptor(basicPayload)),
            g7: 0,
            hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hO: 1,
            ij: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CreateBlockReq$toThingDescriptor(thingPayload))
          };

        case 2:
          var _v4 = _v1.a;
          var derivativePayloadReq = _v4.a;
          var moneyPayloadReq = _v4.b;
          var derivativeMoneyPayload = _v4.c;
          return {
            g6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            g7: 1,
            hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($author$project$Api$Types$CreateBlockReq$toDerivativeMoneyDescriptor, derivativePayloadReq, derivativeMoneyPayload)),
            hN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CreateBlockReq$toMoneyDescriptor(moneyPayloadReq)),
            hO: 0,
            ij: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          };

        default:
          var _v5 = _v1.a;
          var derivativePayloadReq = _v5.a;
          var thingPayload = _v5.b;
          return {
            g6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            g7: 1,
            hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($author$project$Api$Types$CreateBlockReq$toDerivativeDescriptor, true, derivativePayloadReq)),
            hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            hO: 1,
            ij: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CreateBlockReq$toThingDescriptor(thingPayload))
          };
      }
    }();

    return {
      dL: {
        b9: companyId,
        zL: req.zL,
        bP: blockInput.hO,
        bw: req.bw,
        P: blockInput.g7
      },
      dN: {
        gf: blockInput.hN,
        gL: blockInput.ij
      },
      dO: {
        ct: blockInput.g6,
        bM: blockInput.hi,
        fO: blockInput.hj
      }
    };
  });
  var $author$project$Api$Api$createBlock = F5(function (companyId, req, tag, url, idToken) {
    var toBlockDetailsTask = function (blockId) {
      return A2($elm$core$Task$map, $elm$core$Result$fromMaybe('Cannot find building block'), A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$fromMaybe('Cannot find building block')), A3($author$project$Api$Api$getBuildingBlockDetailsTask, url, idToken, blockId)));
    };

    var buildingBLockIdSelectionSet = $author$project$Api$GraphqlSchema$Union$CreateBlockPayload$fragments({
      An: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$CreateBlockSuccess$id),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var createBlockTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$blockCreate(A2($author$project$Api$GraphqlSchema$Object$BlockCreateMutation$create, {
      W: A2($author$project$Api$Types$CreateBlockReq$toCreateBlockInput, companyId, req)
    }, buildingBLockIdSelectionSet)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(toBlockDetailsTask), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, createBlockTask)));
  });
  var $author$project$Api$GraphqlSchema$Mutation$commentCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'commentCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateCommentSuccess$commentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'commentId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateCommentInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.U))), _Utils_Tuple2('dates', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cD, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hd;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('replyTo', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bi, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('reviewId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c8, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('scenarioId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.e8)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$CommentCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateCommentInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateCommentPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateCommentSuccess', selections____.Ao), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Types$CreateCommentReq$toCreateCommentInput = function (req) {
    return {
      U: req.U,
      cD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.cD),
      eO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $elm$core$List$map($author$project$Api$ScalarCodecs$toUuid($author$project$Types$Division$unwrapDivisionId)), req.eO)),
      bi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$ScalarCodecs$toUuid($author$project$Types$Comment$unwrapCommentId), req.bi)),
      c8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$ScalarCodecs$toUuid($author$project$Types$Review$unwrapReviewId), req.c8)),
      e8: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Scenario$unwrapScenarioId, req.e8)
    };
  };

  var $author$project$Api$GraphqlSchema$Query$comment_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'comment_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getCommentTask = F3(function (url, idToken, _v0) {
    var commentId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Comment not found: ' + commentId), A2($author$project$Api$GraphqlSchema$Query$comment_by_pk, {
      F: commentId
    }, $author$project$Api$Schema$comment)));
  });
  var $author$project$Api$Api$toGetCommentTask = F3(function (url, idToken, commentId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getCommentTask, url, idToken, commentId)));
  });
  var $author$project$Api$Api$createComment = F5(function (companyId, req, tag, url, idToken) {
    var createCommentResponse = $author$project$Api$GraphqlSchema$Union$CreateCommentPayload$fragments({
      Ao: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
        var commentId = _v0;
        return $elm$core$Result$Ok(commentId);
      }, $author$project$Api$GraphqlSchema$Object$CreateCommentSuccess$commentId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var createCommentTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$commentCreate, {
      b9: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Company$unwrapCompanyId, companyId)
    }, A2($author$project$Api$GraphqlSchema$Object$CommentCreateMutation$create, {
      W: $author$project$Api$Types$CreateCommentReq$toCreateCommentInput(req)
    }, createCommentResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map($elm$core$Tuple$pair(req.e8))), A2($elm$core$Task$map, $elm$core$Result$map($elm$core$Tuple$pair(req.e8)), A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetCommentTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, createCommentTask)))));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateDivisionInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employeeCount', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.dC))), _Utils_Tuple2('industry', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.an))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$DivisionCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateDivisionInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Mutation$divisionCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'divisionCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateDivisionSuccess$divisionId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'divisionId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$CreateDivisionPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateDivisionSuccess', selections____.Ap), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$createDivision = F5(function (_v0, req, tag, url, idToken) {
    var companyId = _v0;
    var createDivisionResponse = $author$project$Api$GraphqlSchema$Union$CreateDivisionPayload$fragments({
      Ap: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Result$Ok), $author$project$Api$GraphqlSchema$Object$CreateDivisionSuccess$divisionId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var createDivisionTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$divisionCreate, {
      b9: companyId
    }, A2($author$project$Api$GraphqlSchema$Object$DivisionCreateMutation$create, {
      W: req
    }, createDivisionResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, createDivisionTask)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateReviewInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('scenarioId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.e8)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ReviewCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateReviewInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateReviewPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateReviewSuccess', selections____.As), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Mutation$reviewCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reviewCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateReviewSuccess$reviewId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'reviewId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Api$createReview = F6(function (companyId, scenarioId, name, tag, url, idToken) {
    var createReviewResponse = $author$project$Api$GraphqlSchema$Union$CreateReviewPayload$fragments({
      As: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
        var reviewId = _v0;
        return $elm$core$Result$Ok(reviewId);
      }, $author$project$Api$GraphqlSchema$Object$CreateReviewSuccess$reviewId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var createReviewTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$reviewCreate, {
      b9: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Company$unwrapCompanyId, companyId)
    }, A2($author$project$Api$GraphqlSchema$Object$ReviewCreateMutation$create, {
      W: {
        zL: name,
        e8: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Scenario$unwrapScenarioId, scenarioId)
      }
    }, createReviewResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map($elm$core$Tuple$pair(scenarioId))), A2($elm$core$Task$map, $elm$core$Result$map($elm$core$Tuple$pair(scenarioId)), A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetReviewTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, createReviewTask)))));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCashboardScenarioBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM))), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('quickEditOfBlockId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.CK, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('quickEditUserId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.CL, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenarioDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('companyId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.b9))), _Utils_Tuple2('description', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.E))), _Utils_Tuple2('draft', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.br))), _Utils_Tuple2('enabled', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.la))), _Utils_Tuple2('length', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.rf))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('published', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.sQ))), _Utils_Tuple2('startAt', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.tB)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateScenarioInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('scenarioBlocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCashboardScenarioBlockInput))), _Utils_Tuple2('scenarioDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeScenarioDescriptorInput(input____.h6))), _Utils_Tuple2('setAsBase', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.de, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('setAsBudget', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.df, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateScenarioInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateScenarioPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateScenarioSuccess', selections____.At), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Object$CreateScenarioSuccess$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Mutation$scenarioCreate = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenarioCreate', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Types$CreateScenarioReq$toCashboardScenarioBlockInput = function (addBlock) {
    return {
      dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(addBlock.dM),
      la: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(addBlock.yO),
      CK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      CL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    };
  };

  var $author$project$Types$Scenario$scenarioLengthToNoOfMonths = function (scenarioLength) {
    switch (scenarioLength) {
      case 0:
        return 6;

      case 1:
        return 9;

      case 2:
        return 12;

      default:
        return 24;
    }
  };

  var $author$project$Api$Types$CreateScenarioReq$toScenarioDescriptorInput = F2(function (req, companyId) {
    return {
      b9: $author$project$Types$Company$unwrapCompanyId(companyId),
      E: req.E,
      br: req.br,
      la: req.la,
      rf: $author$project$Types$Scenario$scenarioLengthToNoOfMonths(req.rf),
      zL: req.zL,
      sQ: req.sQ,
      tB: req.tB
    };
  });
  var $author$project$Api$Types$CreateScenarioReq$toCreateScenarioInput = F2(function (req, companyId) {
    return {
      Dy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($elm$core$List$map, $author$project$Api$Types$CreateScenarioReq$toCashboardScenarioBlockInput, req.vk)),
      h6: A2($author$project$Api$Types$CreateScenarioReq$toScenarioDescriptorInput, req, companyId),
      de: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(req.de),
      df: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(req.df)
    };
  });
  var $author$project$Api$Api$createScenario = F5(function (companyId, req, tag, url, idToken) {
    var createScenarioResponse = $author$project$Api$GraphqlSchema$Union$CreateScenarioPayload$fragments({
      At: A2($author$project$Api$Schema$mapField, function (_v0) {
        var id = _v0;
        return $elm$core$Result$Ok(id);
      }, $author$project$Api$GraphqlSchema$Object$CreateScenarioSuccess$id),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var createScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$scenarioCreate(A2($author$project$Api$GraphqlSchema$Object$ScenarioCreateMutation$create, {
      W: A2($author$project$Api$Types$CreateScenarioReq$toCreateScenarioInput, req, companyId)
    }, createScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(function (id) {
      return A2($elm$core$Task$map, $elm$core$Result$map(function (details) {
        return _Utils_Tuple2(id, details);
      }), A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken));
    }), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, createScenarioTask))));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodePresetSeasonalityDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('monthAdjustments', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)(input____.dW))), _Utils_Tuple2('presetName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.dH)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateSeasonalityInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('descriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodePresetSeasonalityDescriptorInput(input____.pT)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$SeasonalityCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateSeasonalityInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateSeasonalityPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateSeasonalitySuccess', selections____.Au), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Mutation$seasonalityCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'seasonalityCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateSeasonalitySuccess$seasonalityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'seasonalityId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Query$seasonality_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'seasonality_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getSeasonalityPresetTask = F3(function (_v0, url, idToken) {
    var seasonalityId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Seasonality not found: ' + seasonalityId), A2($author$project$Api$GraphqlSchema$Query$seasonality_by_pk, {
      F: seasonalityId
    }, $author$project$Api$Schema$seasonalityPreset)));
  });
  var $author$project$Api$Api$toGetSeasonalityPresetTask = F3(function (url, idToken, seasonalityId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getSeasonalityPresetTask, seasonalityId, url, idToken)));
  });

  var $elm_community$array_extra$Array$Extra$mapToList = function (f) {
    return A2($elm$core$Array$foldr, A2($elm$core$Basics$composeR, f, $elm$core$List$cons), _List_Nil);
  };

  var $author$project$Api$Types$CreateSeasonalityReq$toSeasonalityPresetDescriptorInput = function (newSeasonalityPresetReq) {
    return {
      dW: A2($elm_community$array_extra$Array$Extra$mapToList, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty, A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm$core$Maybe$withDefault(100))), newSeasonalityPresetReq.dW),
      dH: newSeasonalityPresetReq.zL
    };
  };

  var $author$project$Api$Api$createSeasonalityPreset = F5(function (companyId, req, tag, url, idToken) {
    var createSeasonalityResponse = $author$project$Api$GraphqlSchema$Union$CreateSeasonalityPayload$fragments({
      Au: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
        var seasonalityId = _v0;
        return $elm$core$Result$Ok(seasonalityId);
      }, $author$project$Api$GraphqlSchema$Object$CreateSeasonalitySuccess$seasonalityId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var createSeasonalityTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$seasonalityCreate, {
      b9: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Company$unwrapCompanyId, companyId)
    }, A2($author$project$Api$GraphqlSchema$Object$SeasonalityCreateMutation$create, {
      W: {
        pT: $author$project$Api$Types$CreateSeasonalityReq$toSeasonalityPresetDescriptorInput(req)
      }
    }, createSeasonalityResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetSeasonalityPresetTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, createSeasonalityTask)));
  });
  var $author$project$Api$GraphqlSchema$Mutation$allocationClassLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'allocationClassLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$AllocationClassMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteAllocationClassPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteAllocationClassSuccess', selections____.AA), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$deleteAllocationClass = F5(function (companyId, allocationClassId, tag, url, idToken) {
    var deleteClassResponse = $author$project$Api$GraphqlSchema$Union$DeleteAllocationClassPayload$fragments({
      AA: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var deleteClassTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$allocationClassLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$AllocationClass$unwrapAllocationClassId, allocationClassId)
    }, $author$project$Api$GraphqlSchema$Object$AllocationClassMutation$delete(deleteClassResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteClassTask)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeDeleteBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('force', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.qw)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$BlockMutation$delete = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeDeleteBlockInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$DeleteBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteBlockFailureDependencies', selections____.AB), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteBlockSuccess', selections____.AC), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$deleteBlock = F5(function (companyId, _v0, tag, url, idToken) {
    var id = _v0.F;
    var force = _v0.qw;
    var fragments = $author$project$Api$GraphqlSchema$Union$DeleteBlockPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      AB: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Err('Sorry, can\'t delete the block. It is connected to other entities in the system.')),
      AC: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok('Success')),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var deleteBlockTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$blockLogic, {
      F: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(id)
    }, A2($author$project$Api$GraphqlSchema$Object$BlockMutation$delete, {
      W: {
        qw: force
      }
    }, fragments)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteBlockTask)));
  });
  var $author$project$Api$GraphqlSchema$Mutation$commentLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'commentLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$CommentMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteCommentPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CommentNotFoundError', selections____.rM), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteCommentSuccess', selections____.AE), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Object$CommentNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Api$deleteComment = F4(function (commentId, tag, url, idToken) {
    var deleteCommentResponse = $author$project$Api$GraphqlSchema$Union$DeleteCommentPayload$fragments({
      rM: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$CommentNotFoundError$message),
      AE: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(commentId)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var deleteCommentTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$commentLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Comment$unwrapCommentId, commentId)
    }, $author$project$Api$GraphqlSchema$Object$CommentMutation$delete(deleteCommentResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteCommentTask));
  });
  var $author$project$Api$GraphqlSchema$Mutation$companyLogic = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'id', filledInOptionals____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'companyLogic', optionalArgs____, object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$CompanyMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteCompanyPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteCompanySuccess', selections____.AF), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$deleteCompany = F4(function (_v0, tag, url, idToken) {
    var companyId = _v0;
    var deleteCompanyResponse = $author$project$Api$GraphqlSchema$Union$DeleteCompanyPayload$fragments({
      AF: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var deleteCompanyTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$companyLogic, function (args) {
      return _Utils_update(args, {
        F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(companyId)
      });
    }, $author$project$Api$GraphqlSchema$Object$CompanyMutation$delete(deleteCompanyResponse)));
    return A2($elm$core$Task$attempt, tag, deleteCompanyTask);
  });

  var $author$project$Api$GraphqlSchema$Object$DivisionMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Mutation$divisionLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'divisionLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$DeleteDivisionPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteDivisionSuccess', selections____.AG), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DivisionNotFoundError', selections____.rP), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Object$DivisionNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Api$deleteDivision = F5(function (companyId, _v0, tag, url, idToken) {
    var divisionId = _v0;
    var deleteDivisionResponse = $author$project$Api$GraphqlSchema$Union$DeleteDivisionPayload$fragments({
      AG: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      rP: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$DivisionNotFoundError$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var deleteDivisionTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$divisionLogic, {
      F: divisionId
    }, $author$project$Api$GraphqlSchema$Object$DivisionMutation$delete(deleteDivisionResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteDivisionTask)));
  });
  var $author$project$Api$GraphqlSchema$Mutation$accountLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'accountLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$AccountMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteAccountPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteAccountSuccess', selections____.Az), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$deleteFinancialAccount = F4(function (_v0, tag, url, idToken) {
    var financialAccountId = _v0;
    var deleteAccountResponse = $author$project$Api$GraphqlSchema$Union$DeleteAccountPayload$fragments({
      Az: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var deleteAccountTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountLogic, {
      F: financialAccountId
    }, $author$project$Api$GraphqlSchema$Object$AccountMutation$delete(deleteAccountResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteAccountTask));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeDisableUserInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('companyId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$UserMutation$disable = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'disable', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeDisableUserInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$DisableUserPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DisableUserSuccess', selections____.AN), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$deleteMyAccount = F4(function (userId, url, tag, idToken) {
    var disableUserResponse = $author$project$Api$GraphqlSchema$Union$DisableUserPayload$fragments({
      AN: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$userLogic, {
      F: $author$project$Types$User$unwrapUserId(userId)
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$disable, {
      W: {
        b9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
      }
    }, disableUserResponse))));
  });

  var $author$project$Api$GraphqlSchema$Object$ReviewMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteReviewPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteReviewSuccess', selections____.AI), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ReviewNotFoundError', selections____.mR)]));
  };

  var $author$project$Api$Api$deleteReview = F4(function (reviewId, tag, url, idToken) {
    var deleteReviewResponse = $author$project$Api$GraphqlSchema$Union$DeleteReviewPayload$fragments({
      AI: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(reviewId)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      mR: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ReviewNotFoundError$message)
    });
    var deleteReviewTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$reviewLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Review$unwrapReviewId, reviewId)
    }, $author$project$Api$GraphqlSchema$Object$ReviewMutation$delete(deleteReviewResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteReviewTask));
  });

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteScenarioPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteScenarioSuccess', selections____.AK), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$Api$deleteScenario = F4(function (req, tag, url, idToken) {
    var deleteScenarioResponse = $author$project$Api$GraphqlSchema$Union$DeleteScenarioPayload$fragments({
      AK: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok({})),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var deleteScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(req.e8)
    }, $author$project$Api$GraphqlSchema$Object$ScenarioMutation$delete(deleteScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteScenarioTask));
  });

  var $author$project$Api$GraphqlSchema$Object$SeasonalityMutation$delete = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'delete', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$DeleteSeasonalityPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteSeasonalitySuccess', selections____.AL), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SeasonalityNotFoundError', selections____.r4)]));
  };

  var $author$project$Api$GraphqlSchema$Object$SeasonalityNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Mutation$seasonalityLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'seasonalityLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$deleteSeasonalityPreset = F4(function (seasonalityId, tag, url, idToken) {
    var deleteSeasonalityResponse = $author$project$Api$GraphqlSchema$Union$DeleteSeasonalityPayload$fragments({
      AL: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(seasonalityId)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      r4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SeasonalityNotFoundError$message)
    });
    var deleteSeasonalityTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$seasonalityLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Seasonality$unwrapSeasonalityId, seasonalityId)
    }, $author$project$Api$GraphqlSchema$Object$SeasonalityMutation$delete(deleteSeasonalityResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, deleteSeasonalityTask));
  });

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$discardAllQuickEdits = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'discardAllQuickEdits', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$QuickEditDiscardAllPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'QuickEditDiscardAllSuccess', selections____.Bn), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$Api$discardAllScenarioQuickEdits = F5(function (companyId, scenarioId, tag, url, idToken) {
    var discardAllScenarioQuickEditsResponse = $author$project$Api$GraphqlSchema$Union$QuickEditDiscardAllPayload$fragments({
      Bn: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var discardAllScenarioQuickEditsTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(scenarioId)
    }, $author$project$Api$GraphqlSchema$Object$ScenarioMutation$discardAllQuickEdits(discardAllScenarioQuickEditsResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, discardAllScenarioQuickEditsTask)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeQuickEditDiscardInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$discardQuickEdits = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'discardQuickEdits', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeQuickEditDiscardInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$QuickEditDiscardPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'QuickEditDiscardSuccess', selections____.Bo), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$Api$discardScenarioQuickEdits = F6(function (companyId, scenarioId, blockId, tag, url, idToken) {
    var discardScenarioQuickEditsResponse = $author$project$Api$GraphqlSchema$Union$QuickEditDiscardPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      Bo: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var discardScenarioQuickEditsTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(scenarioId)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$discardQuickEdits, {
      W: {
        dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId)
      }
    }, discardScenarioQuickEditsResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, discardScenarioQuickEditsTask)));
  });
  var $author$project$Api$Api$disconnectAccountingSystemDivision = F5(function (_v0, _v1, _v2, _v3, _v4) {
    return $elm$core$Platform$Cmd$none;
  });
  var $author$project$Api$GraphqlSchema$Mutation$accountingSystemDivisionLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'accountingSystemDivisionLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$AccountSystemDivisionMutation$disconnect = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'disconnect', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$AccountingSystemDivisionDisconnectPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AccountingSystemDivisionDisconnectResult', selections____.z$), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Object$AccountingSystemDivisionDisconnectResult$success = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'success', _List_Nil, $elm$json$Json$Decode$bool);

  var $author$project$Types$AccountingSystemDivision$unwrapAccountingSystemDivisionId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Api$Api$disconnectDivision = F5(function (companyId, accountingDivisionId, tag, url, idToken) {
    var disconnectDivisionResponse = $author$project$Api$GraphqlSchema$Union$AccountingSystemDivisionDisconnectPayload$fragments({
      z$: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$AccountingSystemDivisionDisconnectResult$success),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var disconnectDivisionTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountingSystemDivisionLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$AccountingSystemDivision$unwrapAccountingSystemDivisionId, accountingDivisionId)
    }, $author$project$Api$GraphqlSchema$Object$AccountSystemDivisionMutation$disconnect(disconnectDivisionResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, disconnectDivisionTask)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCloneScenarioInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('published', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.sQ)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$clone = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'clone', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCloneScenarioInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CloneScenarioPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CloneScenarioSuccess', selections____.Ai), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$GraphqlSchema$Object$CloneScenarioSuccess$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Query$scenario_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenario_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getScenarioTask = F3(function (_v0, url, idToken) {
    var scenarioId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Scenario not found: ' + scenarioId), A2($author$project$Api$GraphqlSchema$Query$scenario_by_pk, {
      F: scenarioId
    }, $author$project$Api$Schema$scenario)));
  });
  var $author$project$Api$Api$toGetScenarioTask = F3(function (url, idToken, scenarioId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getScenarioTask, scenarioId, url, idToken)));
  });
  var $author$project$Api$Api$duplicateScenario = F5(function (companyId, req, tag, url, idToken) {
    var duplicateScenarioResponse = $author$project$Api$GraphqlSchema$Union$CloneScenarioPayload$fragments({
      Ai: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Result$Ok), $author$project$Api$GraphqlSchema$Object$CloneScenarioSuccess$id),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var duplicateScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(req.e8)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$clone, {
      W: {
        sQ: req.sQ
      }
    }, duplicateScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(function (scenario) {
      return A2($elm$core$Task$map, $elm$core$Result$map(function (details) {
        return _Utils_Tuple2(scenario.F, details);
      }), A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken));
    }), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetScenarioTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, duplicateScenarioTask))))));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeEditCommentInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('dates', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cD, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hd;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('replyTo', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bi, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('reviewId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c8, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('status', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Comment_status_enum$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$CommentMutation$edit = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'edit', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeEditCommentInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$EditCommentPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CommentNotFoundError', selections____.rM), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'EditCommentSuccess', selections____.AS), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Types$EditCommentReq$toEditCommentInput = function (req) {
    return {
      U: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(req.U),
      cD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.cD),
      eO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $elm$core$List$map($author$project$Api$ScalarCodecs$toUuid($author$project$Types$Division$unwrapDivisionId)), A2($elm$core$Maybe$map, $turboMaCk$any_set$Set$Any$toList, req.eO))),
      bi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$ScalarCodecs$toUuid($author$project$Types$Comment$unwrapCommentId), req.bi)),
      c8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$ScalarCodecs$toUuid($author$project$Types$Review$unwrapReviewId), req.c8)),
      Y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.Y)
    };
  };

  var $author$project$Api$Api$editComment = F5(function (commentId, req, tag, url, idToken) {
    var editCommentResponse = $author$project$Api$GraphqlSchema$Union$EditCommentPayload$fragments({
      rM: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$CommentNotFoundError$message),
      AS: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(commentId)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var editCommentTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$commentLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Comment$unwrapCommentId, commentId)
    }, A2($author$project$Api$GraphqlSchema$Object$CommentMutation$edit, {
      W: $author$project$Api$Types$EditCommentReq$toEditCommentInput(req)
    }, editCommentResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetCommentTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, editCommentTask)));
  });
  var $author$project$Api$GraphqlSchema$Object$UpdateAccountSuccess$accountId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'accountId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$UpdateAccountSuccess$allocationClassId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'allocationClassId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$UpdateAccountPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateAccountSuccess', selections____.B$)]));
  };

  var $author$project$Api$Types$EditFinancialAccountReq$toUpdateAccountInput = function (req) {
    return {
      dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.dx),
      bq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.bq),
      dB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$Division$unwrapDivisionId(req.R)),
      la: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.yO),
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.oO),
      dI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Types$AccountType$toAccount_subtype_enum, req.it)),
      P: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Types$AccountType$toAccount_type_enum, req.it))
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateAccountInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balanceMinMaxAdvice', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dx, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('currency', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Currency_enum$toString))), _Utils_Tuple2('divisionId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dB, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('subType', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_subtype_enum$toString))), _Utils_Tuple2('type', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AccountMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateAccountInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$editFinancialAccount = F4(function (req, tag, url, idToken) {
    var editAccountResponse = $author$project$Api$GraphqlSchema$Union$UpdateAccountPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      B$: A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (_v0, _v1) {
        var accountId = _v0;
        var allocationId = _v1;
        return $elm$core$Result$Ok(_Utils_Tuple2(accountId, allocationId));
      }), $author$project$Api$GraphqlSchema$Object$UpdateAccountSuccess$accountId, $author$project$Api$GraphqlSchema$Object$UpdateAccountSuccess$allocationClassId)
    });
    var editAccountTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountLogic, {
      F: $author$project$Types$FinancialAccount$unwrapFinancialAccountId(req.F)
    }, A2($author$project$Api$GraphqlSchema$Object$AccountMutation$update, {
      W: $author$project$Api$Types$EditFinancialAccountReq$toUpdateAccountInput(req)
    }, editAccountResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($author$project$Api$Api$toGetFinancialAccountTask, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, editAccountTask)));
  });
  var $author$project$Api$GraphqlSchema$Enum$BlockSetEnableDependencyAction$Cascade = 0;
  var $author$project$Api$Types$BlockChange$BlockChange = F3(function (blockId, dependencyOfBlockId, scenarioBlockId) {
    return {
      dM: blockId,
      wG: dependencyOfBlockId,
      Dx: scenarioBlockId
    };
  });
  var $author$project$Api$GraphqlSchema$Object$BlockChange$blockId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'blockId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$BlockChange$dependencyOfBlockId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'dependencyOfBlockId', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));
  var $author$project$Api$Schema$blockChange = A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$BlockChange$scenarioBlockId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMaybeUuid, $author$project$Api$GraphqlSchema$Object$BlockChange$dependencyOfBlockId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withUuid, $author$project$Api$GraphqlSchema$Object$BlockChange$blockId, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$BlockChange$BlockChange))));

  var $author$project$Api$GraphqlSchema$Object$SetBlockEnabledSuccess$changedBlocks = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'changedBlocks', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$GraphqlSchema$Union$SetBlockEnabledPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SetBlockEnabledHasDependents', selections____.BL), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SetBlockEnabledSuccess', selections____.BM)]));
  };

  var $author$project$Api$GraphqlSchema$Object$SetBlockEnabledHasDependents$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$GraphqlSchema$Enum$BlockSetEnableDependencyAction$toString = function (enum____) {
    if (!enum____) {
      return 'CASCADE';
    } else {
      return 'ERROR';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSetBlockEnabledInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM))), _Utils_Tuple2('dependentAction', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.wH, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$BlockSetEnableDependencyAction$toString))), _Utils_Tuple2('enabled', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.la)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$setBlockEnabled = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'setBlockEnabled', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeSetBlockEnabledInput)]), object____, $elm$core$Basics$identity);
  });

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$list = function (selections) {
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$List$reverse, A3($elm$core$List$foldl, $dillonkearns$elm_graphql$Graphql$SelectionSet$map2($elm$core$List$cons), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
      return _List_Nil;
    }, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty), selections));
  };

  var $author$project$Api$Schema$scenarioBlockRelationshipsFromIds = function (scenarioBlockIds) {
    return $dillonkearns$elm_graphql$Graphql$SelectionSet$list(A2($elm$core$List$map, $author$project$Api$Schema$toScenarioBlockSelectionSet, scenarioBlockIds));
  };

  var $author$project$Api$Api$toGetScenarioBlockRelationshipsTask = F3(function (url, idToken, relationshipsIds) {
    return A2($elm$core$Task$map, $elm$core$Result$Ok, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), $author$project$Api$Schema$scenarioBlockRelationshipsFromIds(relationshipsIds))));
  });
  var $author$project$Api$Api$editScenarioBlockRelationship = F5(function (_v0, req, tag, url, idToken) {
    var editScenarioBlockRelationshipResponse = $author$project$Api$GraphqlSchema$Union$SetBlockEnabledPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message),
      BL: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SetBlockEnabledHasDependents$message),
      BM: A2($author$project$Api$Schema$mapField, function (changes) {
        return $elm$core$Result$Ok(A2($elm$core$List$map, function ($) {
          return $.Dx;
        }, changes));
      }, $author$project$Api$GraphqlSchema$Object$SetBlockEnabledSuccess$changedBlocks($author$project$Api$Schema$blockChange))
    });
    var editScenarioBlockRelationshipTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(req.e8)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$setBlockEnabled, {
      W: {
        dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(req.dM),
        wH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0),
        la: req.yO
      }
    }, editScenarioBlockRelationshipResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetScenarioBlockRelationshipsTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, editScenarioBlockRelationshipTask)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeEditSeasonalityInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('descriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodePresetSeasonalityDescriptorInput(input____.pT)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$SeasonalityMutation$edit = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'edit', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeEditSeasonalityInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$EditSeasonalityPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'EditSeasonalitySuccess', selections____.AV), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SeasonalityNotFoundError', selections____.r4)]));
  };

  var $author$project$Api$Types$UpdateSeasonalityReq$toSeasonalityPresetDescriptorInput = function (newSeasonalityPresetReq) {
    return {
      dW: A2($elm_community$array_extra$Array$Extra$mapToList, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty, A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm$core$Maybe$withDefault(100))), newSeasonalityPresetReq.dW),
      dH: newSeasonalityPresetReq.zL
    };
  };

  var $author$project$Api$Api$editSeasonalityPreset = F5(function (seasonalityId, req, tag, url, idToken) {
    var editCommentResponse = $author$project$Api$GraphqlSchema$Union$EditSeasonalityPayload$fragments({
      AV: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(seasonalityId)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      r4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SeasonalityNotFoundError$message)
    });
    var editCommentTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$seasonalityLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Seasonality$unwrapSeasonalityId, seasonalityId)
    }, A2($author$project$Api$GraphqlSchema$Object$SeasonalityMutation$edit, {
      W: {
        pT: $author$project$Api$Types$UpdateSeasonalityReq$toSeasonalityPresetDescriptorInput(req)
      }
    }, editCommentResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetSeasonalityPresetTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, editCommentTask)));
  });

  var $author$project$Api$Types$GetAllBuildingBlocksDetailsResult$GetAllBuildingBlocksDetailsResult = function (blocks) {
    return {
      vk: blocks
    };
  };

  var $author$project$Api$GraphqlSchema$Query$block = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Block_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeBlock_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeBlock_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'block', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$InputObject$Block_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildBlock_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      cu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      n: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      aX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      aj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      db: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      al: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      P: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      c: optionals____.c,
      cu: optionals____.cu,
      j: optionals____.j,
      iD: optionals____.iD,
      a: optionals____.a,
      n: optionals____.n,
      aX: optionals____.aX,
      F: optionals____.F,
      aj: optionals____.aj,
      zL: optionals____.zL,
      d: optionals____.d,
      bP: optionals____.bP,
      Ch: optionals____.Ch,
      db: optionals____.db,
      ak: optionals____.ak,
      al: optionals____.al,
      P: optionals____.P,
      b: optionals____.b
    };
  };

  var $author$project$Api$Api$getAllBuildingBlockDetails = F4(function (_v0, tag, url, idToken) {
    var companyId = _v0;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($author$project$Api$Types$GetAllBuildingBlocksDetailsResult$GetAllBuildingBlocksDetailsResult), A2($elm$core$Task$map, $elm$core$Result$Ok, A2($elm$core$Task$map, $author$project$Api$Types$GetAllBuildingBlocksDetailsResult$GetAllBuildingBlocksDetailsResult, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$block, function (zz) {
      return _Utils_update(zz, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildBlock_bool_exp(function (x) {
          return _Utils_update(x, {
            iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison($author$project$Api$Schema$uuidFromString(companyId)))
          });
        }))
      });
    }, $author$project$Api$Schema$blockWithDetails)))))));
  });
  var $author$project$Api$GraphqlSchema$Query$division = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Division_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeDivision_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeDivision_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'division', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Api$getAllDivisionDetails = F4(function (_v0, tag, url, idToken) {
    var companyId = _v0;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$division, function (zz) {
      return _Utils_update(zz, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildDivision_bool_exp(function (x) {
          return _Utils_update(x, {
            iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison($author$project$Api$Schema$uuidFromString(companyId)))
          });
        }))
      });
    }, $author$project$Api$Schema$division)))));
  });
  var $author$project$Api$GraphqlSchema$InputObject$Scenario_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildScenario_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      vk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      j: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      n: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      br: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      la: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      rf: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      sQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bp: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      c: optionals____.c,
      vk: optionals____.vk,
      bH: optionals____.bH,
      j: optionals____.j,
      iD: optionals____.iD,
      a: optionals____.a,
      n: optionals____.n,
      E: optionals____.E,
      br: optionals____.br,
      la: optionals____.la,
      F: optionals____.F,
      rf: optionals____.rf,
      zL: optionals____.zL,
      d: optionals____.d,
      Ch: optionals____.Ch,
      sQ: optionals____.sQ,
      c9: optionals____.c9,
      bm: optionals____.bm,
      b: optionals____.b,
      bp: optionals____.bp
    };
  };

  var $author$project$Api$GraphqlSchema$Query$scenario = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Scenario_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeScenario_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeScenario_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenario', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Api$getAllScenariosDetails = F4(function (_v0, tag, url, idToken) {
    var companyId = _v0;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$scenario, function (zz) {
      return _Utils_update(zz, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildScenario_bool_exp(function (x) {
          return _Utils_update(x, {
            iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison($author$project$Api$Schema$uuidFromString(companyId)))
          });
        }))
      });
    }, $author$project$Api$Schema$scenario)))));
  });

  var $author$project$Api$GraphqlSchema$Query$authMetadata = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'authMetadata', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$RolePayload$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Role_enum.Role_enum', 'name', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Role_enum$decoder);
  var $author$project$Api$GraphqlSchema$Enum$Permission$AccessMain = 0;
  var $author$project$Api$GraphqlSchema$Enum$Permission$AccountCreate = 1;
  var $author$project$Api$GraphqlSchema$Enum$Permission$AccountDelete = 2;
  var $author$project$Api$GraphqlSchema$Enum$Permission$AccountUpdate = 3;
  var $author$project$Api$GraphqlSchema$Enum$Permission$AllocationClassCreate = 4;
  var $author$project$Api$GraphqlSchema$Enum$Permission$AllocationClassDelete = 5;
  var $author$project$Api$GraphqlSchema$Enum$Permission$AllocationClassUpdate = 6;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CommentCreate = 7;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CommentDelete = 8;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyDelete = 9;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUpdate = 10;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserAssociateOther = 11;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserAssociateSelf = 12;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserDeleteAccountAnalyst = 13;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserDeleteAccountManager = 14;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserDeleteAll = 15;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserDeleteBizAdmin = 16;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserDeleteBizOwner = 17;
  var $author$project$Api$GraphqlSchema$Enum$Permission$CompanyUserDeleteBizViewer = 18;
  var $author$project$Api$GraphqlSchema$Enum$Permission$DivisionCreate = 19;
  var $author$project$Api$GraphqlSchema$Enum$Permission$DivisionDelete = 20;
  var $author$project$Api$GraphqlSchema$Enum$Permission$DivisionUpdate = 21;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ReviewApprove = 22;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ReviewCreate = 23;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ReviewDelete = 24;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentAccountAnalyst = 25;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentAccountManager = 26;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentAdmin = 27;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentBizAdmin = 28;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentBizOwner = 29;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentBizViewer = 30;
  var $author$project$Api$GraphqlSchema$Enum$Permission$RoleAssignmentUser = 31;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioCreate = 32;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioCreatedByBizUpdate = 33;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioCreatedByConsultingUpdate = 34;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioCreatedByOtherUpdate = 35;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioCreatedBySelfUpdate = 36;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioEnableDisable = 37;
  var $author$project$Api$GraphqlSchema$Enum$Permission$ScenarioSetTop = 38;
  var $author$project$Api$GraphqlSchema$Enum$Permission$UserUpdateAll = 39;
  var $author$project$Api$GraphqlSchema$Enum$Permission$UserUpdateBiz = 40;
  var $author$project$Api$GraphqlSchema$Enum$Permission$UserUpdateSelf = 41;
  var $author$project$Api$GraphqlSchema$Enum$Permission$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ACCESS_MAIN':
        return $elm$json$Json$Decode$succeed(0);

      case 'ACCOUNT_CREATE':
        return $elm$json$Json$Decode$succeed(1);

      case 'ACCOUNT_DELETE':
        return $elm$json$Json$Decode$succeed(2);

      case 'ACCOUNT_UPDATE':
        return $elm$json$Json$Decode$succeed(3);

      case 'ALLOCATION_CLASS_CREATE':
        return $elm$json$Json$Decode$succeed(4);

      case 'ALLOCATION_CLASS_DELETE':
        return $elm$json$Json$Decode$succeed(5);

      case 'ALLOCATION_CLASS_UPDATE':
        return $elm$json$Json$Decode$succeed(6);

      case 'COMMENT_CREATE':
        return $elm$json$Json$Decode$succeed(7);

      case 'COMMENT_DELETE':
        return $elm$json$Json$Decode$succeed(8);

      case 'COMPANY_DELETE':
        return $elm$json$Json$Decode$succeed(9);

      case 'COMPANY_UPDATE':
        return $elm$json$Json$Decode$succeed(10);

      case 'COMPANY_USER_ASSOCIATE_OTHER':
        return $elm$json$Json$Decode$succeed(11);

      case 'COMPANY_USER_ASSOCIATE_SELF':
        return $elm$json$Json$Decode$succeed(12);

      case 'COMPANY_USER_DELETE_ACCOUNT_ANALYST':
        return $elm$json$Json$Decode$succeed(13);

      case 'COMPANY_USER_DELETE_ACCOUNT_MANAGER':
        return $elm$json$Json$Decode$succeed(14);

      case 'COMPANY_USER_DELETE_ALL':
        return $elm$json$Json$Decode$succeed(15);

      case 'COMPANY_USER_DELETE_BIZ_ADMIN':
        return $elm$json$Json$Decode$succeed(16);

      case 'COMPANY_USER_DELETE_BIZ_OWNER':
        return $elm$json$Json$Decode$succeed(17);

      case 'COMPANY_USER_DELETE_BIZ_VIEWER':
        return $elm$json$Json$Decode$succeed(18);

      case 'DIVISION_CREATE':
        return $elm$json$Json$Decode$succeed(19);

      case 'DIVISION_DELETE':
        return $elm$json$Json$Decode$succeed(20);

      case 'DIVISION_UPDATE':
        return $elm$json$Json$Decode$succeed(21);

      case 'REVIEW_APPROVE':
        return $elm$json$Json$Decode$succeed(22);

      case 'REVIEW_CREATE':
        return $elm$json$Json$Decode$succeed(23);

      case 'REVIEW_DELETE':
        return $elm$json$Json$Decode$succeed(24);

      case 'ROLE_ASSIGNMENT_ACCOUNT_ANALYST':
        return $elm$json$Json$Decode$succeed(25);

      case 'ROLE_ASSIGNMENT_ACCOUNT_MANAGER':
        return $elm$json$Json$Decode$succeed(26);

      case 'ROLE_ASSIGNMENT_ADMIN':
        return $elm$json$Json$Decode$succeed(27);

      case 'ROLE_ASSIGNMENT_BIZ_ADMIN':
        return $elm$json$Json$Decode$succeed(28);

      case 'ROLE_ASSIGNMENT_BIZ_OWNER':
        return $elm$json$Json$Decode$succeed(29);

      case 'ROLE_ASSIGNMENT_BIZ_VIEWER':
        return $elm$json$Json$Decode$succeed(30);

      case 'ROLE_ASSIGNMENT_USER':
        return $elm$json$Json$Decode$succeed(31);

      case 'SCENARIO_CREATE':
        return $elm$json$Json$Decode$succeed(32);

      case 'SCENARIO_CREATED_BY_BIZ_UPDATE':
        return $elm$json$Json$Decode$succeed(33);

      case 'SCENARIO_CREATED_BY_CONSULTING_UPDATE':
        return $elm$json$Json$Decode$succeed(34);

      case 'SCENARIO_CREATED_BY_OTHER_UPDATE':
        return $elm$json$Json$Decode$succeed(35);

      case 'SCENARIO_CREATED_BY_SELF_UPDATE':
        return $elm$json$Json$Decode$succeed(36);

      case 'SCENARIO_ENABLE_DISABLE':
        return $elm$json$Json$Decode$succeed(37);

      case 'SCENARIO_SET_TOP':
        return $elm$json$Json$Decode$succeed(38);

      case 'USER_UPDATE_ALL':
        return $elm$json$Json$Decode$succeed(39);

      case 'USER_UPDATE_BIZ':
        return $elm$json$Json$Decode$succeed(40);

      case 'USER_UPDATE_SELF':
        return $elm$json$Json$Decode$succeed(41);

      default:
        return $elm$json$Json$Decode$fail('Invalid Permission type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RolePayload$permissions = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List Enum.Permission.Permission)', 'permissions', _List_Nil, $elm$json$Json$Decode$list($author$project$Api$GraphqlSchema$Enum$Permission$decoder));

  var $author$project$Api$GraphqlSchema$Object$PermissionsQuery$role = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'role', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$Api$getAuthMetadata = F3(function (tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$authMetadata(A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, $elm$core$List$map2($elm$core$Tuple$pair), $author$project$Api$GraphqlSchema$Object$PermissionsQuery$role($author$project$Api$GraphqlSchema$Object$RolePayload$name), $author$project$Api$GraphqlSchema$Object$PermissionsQuery$role($author$project$Api$GraphqlSchema$Object$RolePayload$permissions)))))));
  });

  var $author$project$Api$Types$GetBuildingBlockDetailsResult$GetBuildingBlockDetailsResult = function (buildingBlock) {
    return {
      pf: buildingBlock
    };
  };

  var $author$project$Api$Api$getBuildingBlockDetails = F5(function (_v0, blockId, tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map($author$project$Api$Types$GetBuildingBlockDetailsResult$GetBuildingBlockDetailsResult)), A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$fromMaybe('')), A2($elm$core$Task$map, $elm$core$Result$map($author$project$Api$Types$GetBuildingBlockDetailsResult$GetBuildingBlockDetailsResult), A2($elm$core$Task$map, $elm$core$Result$fromMaybe(''), A3($author$project$Api$Api$getBuildingBlockDetailsTask, url, idToken, blockId))))));
  });
  var $author$project$Api$Api$getCompanyDetails = F4(function (companyId, tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken));
  });

  var $author$project$Api$Types$GetFinancialAccountBalancesForPeriodResult = function (balances) {
    return {
      fy: balances
    };
  };

  var $author$project$Api$GraphqlSchema$Query$account_balance = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Account_balance_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeAccount_balance_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'account_balance', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$InputObject$Account_balance_bool_exp = $elm$core$Basics$identity;

  var $author$project$Api$GraphqlSchema$InputObject$buildAccount_balance_bool_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      uy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      oP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      o$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      o3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      d: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      ED: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Fs: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      uy: optionals____.uy,
      oP: optionals____.oP,
      c: optionals____.c,
      o$: optionals____.o$,
      o3: optionals____.o3,
      d: optionals____.d,
      Ch: optionals____.Ch,
      ED: optionals____.ED,
      Fs: optionals____.Fs
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$buildDate_comparison_exp = function (fillOptionals____) {
    var optionals____ = fillOptionals____({
      e: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      G: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      H: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      I: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      J: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      h: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      i: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    return {
      e: optionals____.e,
      G: optionals____.G,
      H: optionals____.H,
      f: optionals____.f,
      g: optionals____.g,
      I: optionals____.I,
      J: optionals____.J,
      h: optionals____.h,
      i: optionals____.i
    };
  };

  var $author$project$Api$Schema$greaterThanOrEqualsDateComparison = function (date) {
    return $author$project$Api$GraphqlSchema$InputObject$buildDate_comparison_exp(function (z) {
      return _Utils_update(z, {
        H: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(date)
      });
    });
  };

  var $author$project$Api$Api$getFinancialAccountBalancesForPeriod = F5(function (_v0, _v1, tag, url, idToken) {
    var financialAccountId = _v1.xK;
    var startFromDate = _v1.Eh;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($author$project$Api$Types$GetFinancialAccountBalancesForPeriodResult), A2($elm$core$Task$map, $elm$core$Result$Ok, A2($elm$core$Task$map, $author$project$Api$Types$GetFinancialAccountBalancesForPeriodResult, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$account_balance, function (x) {
      return _Utils_update(x, {
        Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([{
          uy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          oP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          o$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3),
          o3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          ED: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          Fs: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        }])),
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildAccount_balance_bool_exp(function (xx) {
          return _Utils_update(xx, {
            oP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison($author$project$Api$Schema$uuidFromString($author$project$Types$FinancialAccount$unwrapFinancialAccountId(financialAccountId)))),
            o$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$Schema$greaterThanOrEqualsDateComparison, startFromDate))
          });
        }))
      });
    }, $author$project$Api$Schema$accountBalance)))))));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeIndustry_bool_exp = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('_and', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeIndustry_bool_exp))), _Utils_Tuple2('_not', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Api$GraphqlSchema$InputObject$encodeIndustry_bool_exp)), _Utils_Tuple2('_or', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Ch, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeIndustry_bool_exp))), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $author$project$Api$GraphqlSchema$InputObject$encodeString_comparison_exp))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeIndustry_order_by = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Order_by$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Industry_select_column$toString = function (enum____) {
    return 'name';
  };

  var $author$project$Api$GraphqlSchema$Query$industry = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Industry_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeIndustry_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeIndustry_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'industry', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$GraphqlSchema$Object$Industry$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Api$getIndustries = F3(function (tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$industry, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$Industry$name)))));
  });
  var $author$project$Api$GraphqlSchema$Query$seasonality = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      k1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      zc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      mC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Ci: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'distinct_on', filledInOptionals____.k1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Seasonality_select_column$toString))), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.zc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.mC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'order_by', filledInOptionals____.Ci, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_order_by)), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.gU, $author$project$Api$GraphqlSchema$InputObject$encodeSeasonality_bool_exp)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'seasonality', optionalArgs____, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  });
  var $author$project$Api$Schema$stringIsNull = $author$project$Api$GraphqlSchema$InputObject$buildString_comparison_exp(function (strOptFields) {
    return _Utils_update(strOptFields, {
      g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(true)
    });
  });
  var $author$project$Api$Api$getPresetSeasonalities = F4(function (_v0, tag, url, idToken) {
    var companyId = _v0;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$seasonality, function (zz) {
      return _Utils_update(zz, {
        gU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$buildSeasonality_bool_exp(function (x) {
          return _Utils_update(x, {
            iD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$equalsUuidComparison($author$project$Api$Schema$uuidFromString(companyId))),
            Cx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Schema$stringIsNull)
          });
        }))
      });
    }, $author$project$Api$Schema$seasonalityPreset)))));
  });
  var $author$project$Remote$Model$initClean = {
    qP: $krisajenkins$remotedata$RemoteData$NotAsked,
    gp: _List_Nil,
    hY: $elm$core$Set$empty,
    tb: $krisajenkins$remotedata$RemoteData$NotAsked,
    EL: $author$project$Remote$Model$Unauthenticated
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateInviteInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('firstName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hu))), _Utils_Tuple2('lastName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hI))), _Utils_Tuple2('role', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Role_enum$toString, input____.gz)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$InviteCreateMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCreateInviteInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$CreateInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateInviteSuccess', selections____.Aq), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteExistsError', selections____.A6), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$Query$invite_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'invite_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getInvite = F3(function (idToken, apiEndpoint, _v0) {
    var inviteId = _v0;
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$fromMaybe('Invite not found')), A2($elm$core$Task$map, $elm$core$Result$fromMaybe('Invite not found'), A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$invite_by_pk, {
      F: $author$project$Api$Schema$uuidFromString(inviteId)
    }, $author$project$Api$Schema$invitation))));
  });
  var $author$project$Api$GraphqlSchema$Mutation$inviteCreate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'inviteCreate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$CreateInviteSuccess$inviteId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'inviteId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$InviteExistsError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$Types$InviteUserReq$toCreateInviteInput = function (req) {
    return {
      iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(req.iP),
      hu: req.hu,
      hI: req.hI,
      gz: req.gz
    };
  };

  var $author$project$Api$Api$inviteUserToCompany = F5(function (_v0, req, tag, url, idToken) {
    var companyId = _v0;

    var toGetInvite = function (invitationId) {
      return A3($author$project$Api$Api$getInvite, idToken, url, invitationId);
    };

    var inviteUserToCompanyResponse = $author$project$Api$GraphqlSchema$Union$CreateInvitePayload$fragments({
      Aq: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$CreateInviteSuccess$inviteId),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      A6: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteExistsError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var inviteUserToCompanyTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$inviteCreate, {
      b9: companyId
    }, A2($author$project$Api$GraphqlSchema$Object$InviteCreateMutation$create, {
      W: $author$project$Api$Types$InviteUserReq$toCreateInviteInput(req)
    }, inviteUserToCompanyResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(toGetInvite), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, inviteUserToCompanyTask)));
  });
  var $author$project$Remote$Model$isRequestAlreadyOngoing = F2(function (remote, requestMsg) {
    return A2($elm$core$List$any, A2($elm$core$Basics$composeR, function ($) {
      return $.jE;
    }, $elm$core$Basics$eq(requestMsg)), remote.gp);
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeAddressInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('address_city', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('address_country_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bA, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('address_country_subdivision_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bB, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('address_gmaps_place_uid', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('address_number', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('address_postal_code', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('address_street', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOnboardCompanyInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('address', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeAddressInput(input____.bW))), _Utils_Tuple2('interDivisionShowBothTx', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.b_))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('reportingCurrency', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString, input____.b0))), _Utils_Tuple2('reportingDefaultInterval', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString, input____.b1))), _Utils_Tuple2('reportingWeekEnding', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.b2))), _Utils_Tuple2('size', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString, input____.aB))), _Utils_Tuple2('timeZone', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.b4))), _Utils_Tuple2('userId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oD, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$CompanyMutation$onboard = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'onboard', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeOnboardCompanyInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$OnboardCompanySuccess$companyId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'companyId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$OnboardCompanyPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OnboardCompanySuccess', selections____.mM), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Schema$onboardCompanyPayload = $author$project$Api$GraphqlSchema$Union$OnboardCompanyPayload$fragments({
    M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
    N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
    mM: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$OnboardCompanySuccess$companyId),
    O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
  });

  var $author$project$Api$Types$AddressReq$toAddressInput = function (addressReq) {
    return {
      bz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.pu),
      bA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.pG),
      bB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.pH),
      bC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.qD),
      bD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.rE),
      bE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.sF),
      bF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(addressReq.tI)
    };
  };

  var $author$project$Api$Util$toIntFromWeekday = function (weekday) {
    switch (weekday) {
      case 0:
        return 1;

      case 1:
        return 2;

      case 2:
        return 3;

      case 3:
        return 4;

      case 4:
        return 5;

      case 5:
        return 6;

      default:
        return 7;
    }
  };

  var $author$project$Types$TimeZone$unwrapTimeZoneId = function (_v0) {
    var id = _v0;
    return id;
  };

  var $author$project$Api$Types$OnboardCompanyForExistingUserReq$toOnboardCompanyForExistingUserInput = function (req) {
    return {
      bW: $author$project$Api$Types$AddressReq$toAddressInput(req.bW),
      b_: req.b_,
      zL: req.zL,
      b0: req.b0,
      b1: req.b1,
      b2: $author$project$Api$Util$toIntFromWeekday(req.b2),
      aB: req.aB,
      b4: $author$project$Types$TimeZone$unwrapTimeZoneId(req.dm.F),
      oD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$User$unwrapUserId, req.oD))
    };
  };

  var $author$project$Api$Api$onboardCompany = F4(function (req, tag, url, idToken) {
    var input = $author$project$Api$Types$OnboardCompanyForExistingUserReq$toOnboardCompanyForExistingUserInput(req);
    var onboardCompanySelectionSet = A2($author$project$Api$GraphqlSchema$Object$CompanyMutation$onboard, {
      W: input
    }, $author$project$Api$Schema$onboardCompanyPayload);
    var getUserWithCompaniesTask = A2($elm$core$Task$map, $elm$core$Result$fromMaybe('User not found'), A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$fromMaybe('User not found')), A3($author$project$Api$Api$getApiUserWithCompanies, url, idToken, req.oD)));
    var companyLogicMutation = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$companyLogic, $elm$core$Basics$identity, onboardCompanySelectionSet));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(getUserWithCompaniesTask)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, companyLogicMutation)));
  });

  var $author$project$Api$Api$stringToGraphQlError = function (error) {
    return A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData($elm$json$Json$Encode$null), _List_fromArray([{
      wJ: $elm$core$Dict$empty,
      zg: $elm$core$Maybe$Nothing,
      zu: error
    }]));
  };

  var $author$project$Api$Api$getUserSessionStatusWithFreshTokens = F3(function (apiKey, maybeRefreshToken, url) {
    if (!maybeRefreshToken.$) {
      var currentRefreshToken = maybeRefreshToken.a;
      return A2($elm$core$Task$andThen, function (_v1) {
        var idToken = _v1.d5;
        var refreshToken = _v1.e6;
        var expiresIn = _v1.hr;
        var authRaw = {
          hr: expiresIn,
          d5: idToken,
          e6: refreshToken
        };
        return A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, function (userSessionStatus) {
          return $elm$core$Task$succeed($elm$core$Result$Ok(userSessionStatus));
        }, A2($elm$core$Task$mapError, $author$project$Api$Api$stringToGraphQlError, $author$project$Api$Api$getUserSessionStatus({
          oY: apiKey,
          oZ: url,
          o0: authRaw
        }))));
      }, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$mapError, $author$project$Api$Api$stringToGraphQlError, A2($author$project$ElmFramework$Lib$Firebase$Auth$fetchNewTokensFromRefreshToken, apiKey, {
        e6: $author$project$Types$UserSession$unwrapRefreshToken(currentRefreshToken)
      }))));
    } else {
      return $elm$core$Task$fail($author$project$Api$Api$stringToGraphQlError('Failed to refresh tokens'));
    }
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateUserInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('email', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('firstName', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.hu, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('lastName', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.hI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('phoneNumber', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ng, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('photoUrl', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOnboardCompanyUserInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('address', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeAddressInput(input____.bW))), _Utils_Tuple2('interDivisionShowBothTx', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.b_))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('reportingCurrency', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString, input____.b0))), _Utils_Tuple2('reportingDefaultInterval', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString, input____.b1))), _Utils_Tuple2('reportingWeekEnding', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.b2))), _Utils_Tuple2('size', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString, input____.aB))), _Utils_Tuple2('timeZone', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.b4))), _Utils_Tuple2('user', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeCreateUserInput(input____.Fl)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$CompanyMutation$onboardCompanyUser = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'onboardCompanyUser', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeOnboardCompanyUserInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$OnboardCompanyUserSuccess$companyId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'companyId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$OnboardCompanyUserPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OnboardCompanyUserSuccess', selections____.mN), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OnboardedUserAlreadyExists', selections____.mO)]));
  };

  var $author$project$Api$GraphqlSchema$Object$OnboardedUserAlreadyExists$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$OnboardCompanyUserSuccess$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'userId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$Schema$onboardCompanyUserPayload = function () {
    var onOnboardedUserAlreadyExists = A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$OnboardedUserAlreadyExists$message);
    var onOnboardCompanyUserSuccess = A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (x, y) {
      return $elm$core$Result$Ok(A2($elm$core$Tuple$pair, x, y));
    }), A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$OnboardCompanyUserSuccess$companyId), A2($author$project$Api$Schema$mapUuid, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$OnboardCompanyUserSuccess$userId));
    return $author$project$Api$GraphqlSchema$Union$OnboardCompanyUserPayload$fragments({
      mN: onOnboardCompanyUserSuccess,
      mO: onOnboardedUserAlreadyExists
    });
  }();

  var $author$project$Api$Types$OnboardCompanyAndUserReq$toOnboardCompanyAndUserInput = function (req) {
    return {
      bW: $author$project$Api$Types$AddressReq$toAddressInput(req.bW),
      b_: req.b_,
      zL: req.zL,
      b0: req.b0,
      b1: req.b1,
      b2: $author$project$Api$Util$toIntFromWeekday(req.b2),
      aB: req.aB,
      b4: $author$project$Types$TimeZone$unwrapTimeZoneId(req.dm.F),
      Fl: req.Fl
    };
  };

  var $author$project$Api$Api$onboardCompanyWithUser = F6(function (apiKey, args, tag, url, refreshToken, idToken) {
    var input = $author$project$Api$Types$OnboardCompanyAndUserReq$toOnboardCompanyAndUserInput(args);
    var onboardCompanyUser = A2($author$project$Api$GraphqlSchema$Object$CompanyMutation$onboardCompanyUser, {
      W: input
    }, $author$project$Api$Schema$onboardCompanyUserPayload);
    var companyLogicMutation = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$companyLogic, $elm$core$Basics$identity, onboardCompanyUser));
    var task = A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(function (_v0) {
      return A3($author$project$Api$Api$getUserSessionStatusWithFreshTokens, apiKey, refreshToken, url);
    }), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, companyLogicMutation));
    return A2($elm$core$Task$attempt, tag, task);
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeOverrideAccountBalanceInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('balance', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.eN;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.o3))), _Utils_Tuple2('date', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.iL)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AccountMutation$overrideBalanceOnDate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'overrideBalanceOnDate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeOverrideAccountBalanceInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$overrideFinancialAccountBalanceOnDate = F6(function (_v0, _v1, _v2, tag, url, idToken) {
    var id = _v2.F;
    var date = _v2.iL;
    var value = _v2.Fw;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError(A2($elm$core$Basics$always, $elm$core$Result$Ok, 0)), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountLogic, {
      F: $author$project$Api$Schema$uuidFromString($author$project$Types$FinancialAccount$unwrapFinancialAccountId(id))
    }, A2($author$project$Api$GraphqlSchema$Object$AccountMutation$overrideBalanceOnDate, {
      W: {
        o3: value,
        iL: date
      }
    }, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty))))));
  });

  var $author$project$Api$GraphqlSchema$Union$QuickEditBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'QuickEditBlockPayloadSuccess', selections____.rX), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeQuickEditBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$quickEditBlock = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'quickEditBlock', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeQuickEditBlockInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$quickEditBlockInScenario = F6(function (companyId, scenarioId, blockId, tag, url, idToken) {
    var quickEditBlockInScenarioResponse = $author$project$Api$GraphqlSchema$Union$QuickEditBlockPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      rX: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var quickEditBlockInScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(scenarioId)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$quickEditBlock, {
      W: {
        dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId)
      }
    }, quickEditBlockInScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, quickEditBlockInScenarioTask)));
  });
  var $author$project$Api$Api$reconnectAccountingSystemDivision = F5(function (_v0, _v1, _v2, _v3, _v4) {
    return $elm$core$Platform$Cmd$none;
  });

  var $author$project$Api$GraphqlSchema$Union$RedeemInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteExpiredError', selections____.A7), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteNotFoundError', selections____.jo), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteStatusError', selections____.jp), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteUserExistsError', selections____.A8), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteUserLoggedInUserMismatch', selections____.A9), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RedeemInviteSuccess', selections____.Br)]));
  };

  var $author$project$Api$GraphqlSchema$Mutation$inviteRedeem = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'inviteRedeem', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$InviteExpiredError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$InviteNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$InviteStatusError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$InviteUserExistsError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$InviteUserLoggedInUserMismatch$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$GraphqlSchema$InputObject$encodeRedeemInviteInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('code', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.pw)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$InviteRedeemMutation$redeem = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'redeem', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'createUserInput', requiredArgs____.wi, $author$project$Api$GraphqlSchema$InputObject$encodeCreateUserInput), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'redeemInviteInput', requiredArgs____.CQ, $author$project$Api$GraphqlSchema$InputObject$encodeRedeemInviteInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Types$Invitation$unwrapInviteCode = function (_v0) {
    var code = _v0;
    return code;
  };

  var $author$project$Api$GraphqlSchema$Object$RedeemInviteSuccess$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'userId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Api$redeemInviteTask = F4(function (inviteCode, url, idToken, userProfile) {
    var redeemInviteInput = {
      wi: {
        iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(userProfile.iP),
        hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$User$firstNameFromDisplayName(userProfile.k0)),
        hI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$User$lastNameFromDisplayName(userProfile.k0)),
        ng: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
        nh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
      },
      CQ: {
        pw: $author$project$Types$Invitation$unwrapInviteCode(inviteCode)
      }
    };
    return A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$inviteRedeem(A2($author$project$Api$GraphqlSchema$Object$InviteRedeemMutation$redeem, redeemInviteInput, $author$project$Api$GraphqlSchema$Union$RedeemInvitePayload$fragments({
      A7: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteExpiredError$message),
      jo: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteNotFoundError$message),
      jp: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteStatusError$message),
      A8: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteUserExistsError$message),
      A9: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteUserLoggedInUserMismatch$message),
      Br: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$RedeemInviteSuccess$userId)
    }))));
  });
  var $author$project$Api$Api$redeemInviteWithExistingUser = F6(function (apiKey, refreshToken, inviteCode, tag, url, idToken) {
    var getUserProfileTask = A2($author$project$ElmFramework$Lib$Firebase$Auth$getUserProfile, apiKey, {
      d5: $author$project$Types$UserSession$unwrapIdToken(idToken)
    });
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $elm$core$Basics$always(A3($author$project$Api$Api$getUserSessionStatusWithFreshTokens, apiKey, refreshToken, url)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, A3($author$project$Api$Api$redeemInviteTask, inviteCode, url, idToken), A2($elm$core$Task$mapError, $author$project$Api$Api$stringToGraphQlError, getUserProfileTask)))));
  });
  var $author$project$Api$Api$redeemInviteWithRegistation = F5(function (apiKey, inviteCode, _v0, url, tag) {
    var firstName = _v0.hu;
    var lastName = _v0.hI;
    var email = _v0.iP;
    var password = _v0.sv;

    var transformExistingUserError = function (originalError) {
      return originalError === 'Email exists' ? 'User exists: please sign in first and then accept the invitation' : originalError;
    };

    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, function (_v1) {
      var idToken = _v1.d5;
      var refreshToken = _v1.e6;
      return A2($elm$core$Task$andThen, $elm$core$Basics$always(A3($author$project$Api$Api$getUserSessionStatusWithFreshTokens, apiKey, $elm$core$Maybe$Just(refreshToken), url)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, A3($author$project$Api$Api$redeemInviteTask, inviteCode, url, idToken), A2($elm$core$Task$mapError, $author$project$Api$Api$stringToGraphQlError, A2($author$project$ElmFramework$Lib$Firebase$Auth$updateUserProfile, apiKey, {
        k0: $author$project$Types$User$toFullName({
          hu: firstName,
          hI: lastName
        }),
        d5: idToken,
        nh: $elm$core$Maybe$Nothing
      })))));
    }, A2($elm$core$Task$mapError, $author$project$Api$Api$stringToGraphQlError, A2($elm$core$Task$mapError, transformExistingUserError, A2($author$project$ElmFramework$Lib$Firebase$Auth$signUpViaEmailAndPassword, apiKey, {
      iP: email,
      sv: password
    })))));
  });

  var $author$project$Api$GraphqlSchema$Union$RemoveBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RemoveBlockHasDependents', selections____.Bs), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RemoveBlockSuccess', selections____.Bt), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$GraphqlSchema$Object$RemoveBlockHasDependents$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$GraphqlSchema$InputObject$encodeRemoveBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$removeBlock = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'removeBlock', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeRemoveBlockInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$removeBlockFromScenario = F7(function (_v0, scenarioId, blockId, scenarioBlockId, tag, url, idToken) {
    var removeBlockFromScenarioResponse = $author$project$Api$GraphqlSchema$Union$RemoveBlockPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      Bs: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RemoveBlockHasDependents$message),
      Bt: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var removeBlockFromScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(scenarioId)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$removeBlock, {
      W: {
        dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId)
      }
    }, removeBlockFromScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, removeBlockFromScenarioTask));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeDeleteUserCompanyInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('companyId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.b9)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$UserMutation$deleteUserCompany = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'deleteUserCompany', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeDeleteUserCompanyInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$DeleteUserCompanyPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DeleteUserCompanySuccess', selections____.AM), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$removeUserFromCompany = F5(function (_v0, _v1, tag, url, idToken) {
    var companyId = _v0;
    var userId = _v1;
    var removeUserResponse = $author$project$Api$GraphqlSchema$Union$DeleteUserCompanyPayload$fragments({
      AM: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var removeUserTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$userLogic, {
      F: userId
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$deleteUserCompany, {
      W: {
        b9: companyId
      }
    }, removeUserResponse)));
    return A2($elm$core$Task$attempt, tag, removeUserTask);
  });
  var $author$project$Api$GraphqlSchema$Object$RequestApproveReviewSuccess$emailSentTo = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List Api.ScalarCodecs.Uuid)', 'emailSentTo', _List_Nil, $elm$json$Json$Decode$list($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));

  var $author$project$Api$GraphqlSchema$Union$RequestApproveReviewPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RequestApproveReviewSuccess', selections____.Bu), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ReviewNotFoundError', selections____.mR), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ReviewStatusError', selections____.r1)]));
  };

  var $author$project$Api$GraphqlSchema$Object$ReviewMutation$requestApproval = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'requestApproval', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$requestReviewApproval = F4(function (reviewId, tag, url, idToken) {
    var requestReviewApprovalResponse = $author$project$Api$GraphqlSchema$Union$RequestApproveReviewPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      Bu: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
        return $elm$core$Result$Ok(0);
      }, $author$project$Api$GraphqlSchema$Object$RequestApproveReviewSuccess$emailSentTo),
      mR: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ReviewNotFoundError$message),
      r1: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ReviewStatusError$message)
    });
    var requestReviewApprovalTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$reviewLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Review$unwrapReviewId, reviewId)
    }, $author$project$Api$GraphqlSchema$Object$ReviewMutation$requestApproval(requestReviewApprovalResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A2($elm$core$Task$andThen, $elm$core$Basics$always(A3($author$project$Api$Api$getReviewTask, reviewId, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, requestReviewApprovalTask)))));
  });

  var $author$project$Api$GraphqlSchema$Union$ResendInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteNotFoundError', selections____.jo), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteStatusError', selections____.jp), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ResendInviteSuccess', selections____.Bw), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TooManyInviteResendRequests', selections____.B_)]));
  };

  var $author$project$Api$GraphqlSchema$Object$ResendInviteSuccess$inviteId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'inviteId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Mutation$inviteLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'inviteLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$TooManyInviteResendRequests$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$GraphqlSchema$Object$InviteMutation$resend = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'resend', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$resendInvitationTask = F3(function (url, idToken, _v0) {
    var inviteId = _v0;
    return A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$inviteLogic, {
      F: $author$project$Api$Schema$uuidFromString(inviteId)
    }, $author$project$Api$GraphqlSchema$Object$InviteMutation$resend($author$project$Api$GraphqlSchema$Union$ResendInvitePayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      jo: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteNotFoundError$message),
      jp: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteStatusError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      Bw: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$ResendInviteSuccess$inviteId),
      B_: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$TooManyInviteResendRequests$message)
    }))));
  });
  var $author$project$Api$Api$resendInvitation = F4(function (_v0, tag, url, idToken) {
    var inviteId = _v0;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$getInvite, idToken, url)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A3($author$project$Api$Api$resendInvitationTask, url, idToken, inviteId))));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeResetAccountBalanceInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('date', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.iL)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AccountMutation$resetBalanceOnDate = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'resetBalanceOnDate', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeResetAccountBalanceInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$resetFinancialAccountBalanceOnDate = F6(function (_v0, _v1, _v2, tag, url, idToken) {
    var date = _v2.iL;
    var id = _v2.F;
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError(A2($elm$core$Basics$always, $elm$core$Result$Ok, 0)), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountLogic, {
      F: $author$project$Api$Schema$uuidFromString($author$project$Types$FinancialAccount$unwrapFinancialAccountId(id))
    }, A2($author$project$Api$GraphqlSchema$Object$AccountMutation$resetBalanceOnDate, {
      W: {
        iL: date
      }
    }, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty))))));
  });

  var $author$project$Api$GraphqlSchema$Union$RevokeInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteNotFoundError', selections____.jo), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteStatusError', selections____.jp), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RevokeInviteSuccess', selections____.Bz)]));
  };

  var $author$project$Api$GraphqlSchema$Object$RevokeInviteSuccess$inviteId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'inviteId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Object$InviteMutation$revoke = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'revoke', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$revokeInvitation = F4(function (_v0, tag, url, idToken) {
    var invitationId = _v0;
    var revokeInviteResponse = $author$project$Api$GraphqlSchema$Union$RevokeInvitePayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      jo: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteNotFoundError$message),
      jp: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteStatusError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      Bz: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$RevokeInviteSuccess$inviteId)
    });
    var revokeInviteTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$inviteLogic, {
      F: invitationId
    }, $author$project$Api$GraphqlSchema$Object$InviteMutation$revoke(revokeInviteResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map($elm$core$Basics$always(0))), A2($elm$core$Task$map, $elm$core$Result$map($elm$core$Basics$always(0)), revokeInviteTask)));
  });

  var $author$project$Api$GraphqlSchema$Union$QuickEditSavePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'QuickEditSaveSuccess', selections____.Bp), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeQuickEditSaveInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.dM))), _Utils_Tuple2('useEditsInScenarios', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))(input____.ud)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$saveQuickEdits = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'saveQuickEdits', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeQuickEditSaveInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$saveBlockQuickEditsForScenario = F5(function (companyId, req, tag, url, idToken) {
    var saveScenarioQuickEditsResponse = $author$project$Api$GraphqlSchema$Union$QuickEditSavePayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      Bp: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });
    var saveScenarioQuickEditsTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(req.e8)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$saveQuickEdits, {
      W: {
        dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(req.dM),
        ud: A2($elm$core$List$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Types$Scenario$unwrapScenarioId), req.ud)
      }
    }, saveScenarioQuickEditsResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, saveScenarioQuickEditsTask)));
  });
  var $author$project$Api$GraphqlSchema$Object$UpdateTopScenarioSuccess$baseScenarioId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'baseScenarioId', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));

  var $author$project$Api$GraphqlSchema$Union$UpdateTopScenarioPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateTopScenarioSuccess', selections____.sh)]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$setAsBase = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'setAsBase', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$setAsBaseScenario = F4(function (_v0, tag, url, idToken) {
    var scenarioId = _v0;
    var setAsBaseScenarioResponse = $author$project$Api$GraphqlSchema$Union$UpdateTopScenarioPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message),
      sh: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$always($elm$core$Result$Ok(0)), $author$project$Api$GraphqlSchema$Object$UpdateTopScenarioSuccess$baseScenarioId)
    });
    var setAsBaseScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: scenarioId
    }, $author$project$Api$GraphqlSchema$Object$ScenarioMutation$setAsBase(setAsBaseScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, setAsBaseScenarioTask));
  });
  var $author$project$Api$GraphqlSchema$Object$UpdateTopScenarioSuccess$budgetScenarioId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Uuid)', 'budgetScenarioId', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB));

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$setAsBudget = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'setAsBudget', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Api$setAsBudgetScenario = F4(function (_v0, tag, url, idToken) {
    var scenarioId = _v0;
    var setAsBudgetScenarioResponse = $author$project$Api$GraphqlSchema$Union$UpdateTopScenarioPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message),
      sh: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$always($elm$core$Result$Ok(0)), $author$project$Api$GraphqlSchema$Object$UpdateTopScenarioSuccess$budgetScenarioId)
    });
    var setAsBudgetScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: scenarioId
    }, $author$project$Api$GraphqlSchema$Object$ScenarioMutation$setAsBudget(setAsBudgetScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, setAsBudgetScenarioTask));
  });

  var $author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess = function (remoteData) {
    switch (remoteData.$) {
      case 0:
        return $krisajenkins$remotedata$RemoteData$Loading;

      case 1:
        return $krisajenkins$remotedata$RemoteData$Loading;

      case 2:
        return $krisajenkins$remotedata$RemoteData$Loading;

      default:
        var a = remoteData.a;
        return $krisajenkins$remotedata$RemoteData$Success(a);
    }
  };

  var $author$project$Types$Company$setAsLoading = function (company) {
    return _Utils_update(company, {
      pg: $author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(company.pg),
      eO: $author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(company.eO),
      q_: $author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(company.q_),
      nT: $author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(company.nT),
      db: $author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(company.db)
    });
  };

  var $turboMaCk$any_dict$Dict$Any$map = F2(function (f, _v0) {
    var dict = _v0.bT;
    var toKey = _v0.dn;
    return {
      bT: A2($elm$core$Dict$map, F2(function (_v1, _v2) {
        var k = _v2.a;
        var v = _v2.b;
        return _Utils_Tuple2(k, A2(f, k, v));
      }), dict),
      dn: toKey
    };
  });
  var $author$project$ElmFramework$Lib$AnyDictExtra$mapValues = F2(function (mapper, anyDict) {
    return A2($turboMaCk$any_dict$Dict$Any$map, F2(function (_v0, v) {
      return mapper(v);
    }), anyDict);
  });

  var $author$project$Types$BuildingBlock$setAsLoading = function (buildingBlock) {
    return _Utils_update(buildingBlock, {
      kw: function () {
        var _v0 = buildingBlock.kw;

        switch (_v0.$) {
          case 0:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$BasicMoney($author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(remoteData));

          case 1:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$BasicThing($author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(remoteData));

          case 2:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$DerivativeMoney($author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(remoteData));

          default:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$DerivativeThing($author$project$ElmFramework$Lib$RemoteDataExtra$setAsLoadingIfNoSuccess(remoteData));
        }
      }()
    });
  };

  var $author$project$Types$Company$setBuildingBlocksAsLoadingDetails = function (company) {
    return _Utils_update(company, {
      pg: A2($krisajenkins$remotedata$RemoteData$map, $author$project$ElmFramework$Lib$AnyDictExtra$mapValues($author$project$Types$BuildingBlock$setAsLoading), company.pg)
    });
  };

  var $author$project$Api$GraphqlSchema$Union$SetEnabledPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SetEnabledSuccess', selections____.BN)]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeSetEnabledInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('enabled', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.la)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$setEnabled = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'setEnabled', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeSetEnabledInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$setScenarioEnabled = F6(function (_v0, _v1, enabledValue, tag, url, idToken) {
    var scenarioId = _v1;
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Api$Schema$uuidFromString(scenarioId)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$setEnabled, {
      W: {
        la: enabledValue
      }
    }, $author$project$Api$GraphqlSchema$Union$SetEnabledPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message),
      BN: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0))
    })))));
  });

  var $author$project$Api$GraphqlSchema$Union$AccountingSystemDivisionSetSyncPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AccountingSystemDivisionSetSyncResult', selections____.z0), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeAccountSystemDivisionSetSyncInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('sync', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.EB)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AccountSystemDivisionMutation$setDivisionSync = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'setDivisionSync', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeAccountSystemDivisionSetSyncInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$AccountingSystemDivisionSetSyncResult$success = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'success', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$Api$syncDivision = F6(function (companyId, _v0, sync, tag, url, idToken) {
    var accountingDivisionId = _v0;
    var syncDivisionResponse = $author$project$Api$GraphqlSchema$Union$AccountingSystemDivisionSetSyncPayload$fragments({
      z0: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$AccountingSystemDivisionSetSyncResult$success),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
    var syncDivisionTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$accountingSystemDivisionLogic, {
      F: accountingDivisionId
    }, A2($author$project$Api$GraphqlSchema$Object$AccountSystemDivisionMutation$setDivisionSync, {
      W: {
        EB: sync
      }
    }, syncDivisionResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, syncDivisionTask)));
  });

  var $author$project$Remote$Model$toIdToken = function (remote) {
    var _v0 = remote.EL;

    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        var auth = _v0.a.u_;
        return $elm$core$Maybe$Just(auth.d5);

      default:
        var thisUserSession = _v0.a;
        return $elm$core$Maybe$Just(thisUserSession.u_.d5);
    }
  };

  var $author$project$ElmFramework$Lib$RemoteModel$create_sendAuthenticatedRequest = F2(function (cfg, params) {
    var state = cfg.Ej;
    var toAccessToken = cfg.t2;

    var _v0 = toAccessToken(state);

    if (!_v0.$) {
      var token = _v0.a;

      var internallyUpdatedRemoteState = _Utils_update(state, {
        gp: A2($elm$core$List$cons, {
          eS: params.eS,
          jE: cfg.h3
        }, state.gp)
      });

      return _Utils_Tuple3(params.rn(internallyUpdatedRemoteState), params.iC(token), _List_Nil);
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_sendRequest = F2(function (cfg, params) {
    var state = cfg.Ej;
    return _Utils_Tuple3(_Utils_update(state, {
      gp: A2($elm$core$List$cons, {
        eS: params.eS,
        jE: cfg.h3
      }, state.gp)
    }), params.iC, _List_Nil);
  });

  var $author$project$ElmFramework$Lib$RemoteModel$toRequestHelpers = function (cfg) {
    return {
      DU: $author$project$ElmFramework$Lib$RemoteModel$create_sendAuthenticatedRequest(cfg),
      DV: $author$project$ElmFramework$Lib$RemoteModel$create_sendRequest(cfg)
    };
  };

  var $author$project$Api$GraphqlSchema$Object$UpdateAllocationClassSuccess$allocationClassId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'allocationClassId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$UpdateAllocationClassPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateAllocationClassSuccess', selections____.B0)]));
  };

  var $author$project$Api$GraphqlSchema$Query$allocation_class_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'allocation_class_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getAllocationClassTask = F3(function (url, idToken, _v0) {
    var id = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Allocation class not found: ' + id), A2($author$project$Api$GraphqlSchema$Query$allocation_class_by_pk, {
      F: id
    }, $author$project$Api$Schema$allocationClass)));
  });
  var $author$project$Api$Api$toGetAllocationClassTask = F3(function (url, idToken, id) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getAllocationClassTask, url, idToken, id)));
  });

  var $author$project$Api$Types$UpdateAllocationClassReq$toUpdateAllocationClassInput = function (req) {
    return {
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.zL),
      dG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Api$ScalarCodecs$toUuid($author$project$Types$AllocationClass$unwrapAllocationClassId), req.dG))
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateAllocationClassInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('parentId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dG, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$AllocationClassMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateAllocationClassInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateAllocationClass = F4(function (req, tag, url, idToken) {
    var updateClassResponse = $author$project$Api$GraphqlSchema$Union$UpdateAllocationClassPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      B0: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
        var id = _v0;
        return $elm$core$Result$Ok(id);
      }, $author$project$Api$GraphqlSchema$Object$UpdateAllocationClassSuccess$allocationClassId)
    });
    var updateClassTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$allocationClassLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$AllocationClass$unwrapAllocationClassId, req.F)
    }, A2($author$project$Api$GraphqlSchema$Object$AllocationClassMutation$update, {
      W: $author$project$Api$Types$UpdateAllocationClassReq$toUpdateAllocationClassInput(req)
    }, updateClassResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetAllocationClassTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, updateClassTask)));
  });
  var $author$project$Api$Types$UpdateBlockResponse$CloneAndUpdateBlockSuccess = {
    $: 1
  };

  var $author$project$Api$Types$UpdateBlockResponse$CloneAndUpdateBlockSuccessHydrated = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$Types$UpdateBlockResponse$UpdateBlockSuccess = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$Types$UpdateBlockResponse$UpdateBlockSuccessHydrated = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Enum$EditBlockMultipleScenariosAction$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'CLONE';

      case 1:
        return 'EDIT';

      default:
        return 'ERROR';
    }
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeEditBlockMultipleScenariosDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('action', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$EditBlockMultipleScenariosAction$toString, input____.gW))), _Utils_Tuple2('useCloneInScenarios', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeEditBlockInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('blockDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeBlockDescriptorInput(input____.dL))), _Utils_Tuple2('blockOfDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfBlockOfDescriptorInput(input____.dN))), _Utils_Tuple2('blockTypeDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfBlockTypeDescriptorInput(input____.dO))), _Utils_Tuple2('multipleScenariosAction', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeEditBlockMultipleScenariosDescriptorInput(input____.hP)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$BlockMutation$edit = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'edit', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeEditBlockInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$EditBlockPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockNotFound', selections____.ev), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BlockUsedInMultipleScenariosError', selections____.z8), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CloneAndEditBlockSuccess', selections____.Af), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'EditBlockSuccess', selections____.AQ), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Api$getBuildingBlockDetailsNonNullTask = F3(function (url, idToken, _v0) {
    var buildingBlockId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), $dillonkearns$elm_graphql$Graphql$SelectionSet$nonNullOrFail(A2($author$project$Api$GraphqlSchema$Query$block_by_pk, {
      F: buildingBlockId
    }, $author$project$Api$Schema$blockWithDetails)));
  });
  var $author$project$Api$GraphqlSchema$Object$EditBlockSuccess$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'id', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$BlockUsedInMultipleScenariosError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$QuickEditBlockPayloadSuccess$quickEditBlockId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'quickEditBlockId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Enum$EditBlockMultipleScenariosAction$Clone = 0;
  var $author$project$Api$GraphqlSchema$Enum$EditBlockMultipleScenariosAction$Edit = 1;

  var $author$project$Api$Types$EditBlockReq$toMultipleScenariosActionInput = function (multipleScenariosAction) {
    if (!multipleScenariosAction.$) {
      var scenarioIds = multipleScenariosAction.a;
      return {
        gW: 0,
        Fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($elm$core$List$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Types$Scenario$unwrapScenarioId), scenarioIds))
      };
    } else {
      return {
        gW: 1,
        Fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
      };
    }
  };

  var $author$project$Api$Types$EditBlockReq$toEditBlockInput = F2(function (companyId, editBlockReq) {
    var createBlockInput = A2($author$project$Api$Types$CreateBlockReq$toCreateBlockInput, companyId, {
      kw: editBlockReq.kw,
      yC: editBlockReq.yC,
      zL: editBlockReq.zL,
      bw: editBlockReq.bw
    });
    return {
      dL: createBlockInput.dL,
      dN: createBlockInput.dN,
      dO: createBlockInput.dO,
      hP: $author$project$Api$Types$EditBlockReq$toMultipleScenariosActionInput(editBlockReq.hP)
    };
  });
  var $author$project$Api$Api$updateBlock = F7(function (companyId, maybeScenarioId, blockId, req, tag, url, idToken) {
    var toTask = function (updateBlockResponse) {
      if (!updateBlockResponse.$) {
        var buildingBlockId = updateBlockResponse.a;
        return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError(A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $author$project$Api$Types$UpdateBlockResponse$UpdateBlockSuccessHydrated)), A2($elm$core$Task$map, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $author$project$Api$Types$UpdateBlockResponse$UpdateBlockSuccessHydrated), A3($author$project$Api$Api$getBuildingBlockDetailsNonNullTask, url, idToken, buildingBlockId)));
      } else {
        return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map($author$project$Api$Types$UpdateBlockResponse$CloneAndUpdateBlockSuccessHydrated)), A2($elm$core$Task$map, $elm$core$Result$map($author$project$Api$Types$UpdateBlockResponse$CloneAndUpdateBlockSuccessHydrated), A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken)));
      }
    };

    var quickEditBlockInScenarioResponse = $author$project$Api$GraphqlSchema$Union$QuickEditBlockPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      rX: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v1) {
        var id = _v1;
        return $elm$core$Result$Ok(id);
      }, $author$project$Api$GraphqlSchema$Object$QuickEditBlockPayloadSuccess$quickEditBlockId),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    });

    var quickEditBlockInScenarioTask = function (scenarioId) {
      return A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
        F: $author$project$Types$Scenario$unwrapScenarioId(scenarioId)
      }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$quickEditBlock, {
        W: {
          dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId)
        }
      }, quickEditBlockInScenarioResponse)));
    };

    var fragments = $author$project$Api$GraphqlSchema$Union$EditBlockPayload$fragments({
      ev: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockNotFound$message),
      z8: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BlockUsedInMultipleScenariosError$message),
      Af: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok($author$project$Api$Types$UpdateBlockResponse$CloneAndUpdateBlockSuccess)),
      AQ: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $author$project$Api$Types$UpdateBlockResponse$UpdateBlockSuccess), $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$EditBlockSuccess$id),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });

    var updateBlockTask = function (thisBlockId) {
      return A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$blockLogic, {
        F: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(thisBlockId)
      }, A2($author$project$Api$GraphqlSchema$Object$BlockMutation$edit, {
        W: A2($author$project$Api$Types$EditBlockReq$toEditBlockInput, companyId, req)
      }, fragments)));
    };

    if (!maybeScenarioId.$) {
      var scenarioId = maybeScenarioId.a;
      return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(toTask($author$project$Api$Types$UpdateBlockResponse$CloneAndUpdateBlockSuccess))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(updateBlockTask), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, quickEditBlockInScenarioTask(scenarioId))))));
    } else {
      return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(toTask), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, updateBlockTask(blockId))));
    }
  });
  var $author$project$Api$GraphqlSchema$Object$UpdateCompanySuccess$companyId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'companyId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$UpdateCompanyPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateCompanySuccess', selections____.B1)]));
  };

  var $author$project$Api$Types$UpdateCompanyReq$toUpdateCompanyInput = function (req) {
    return {
      bW: $author$project$Api$Types$AddressReq$toAddressInput(req.bW),
      b_: req.b_,
      zL: req.zL,
      b0: req.b0,
      b1: req.b1,
      b2: $author$project$Api$Util$toIntFromWeekday(req.b2),
      aB: req.aB,
      b4: $author$project$Types$TimeZone$unwrapTimeZoneId(req.dm)
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateCompanyInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('address', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeAddressInput(input____.bW))), _Utils_Tuple2('interDivisionShowBothTx', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.b_))), _Utils_Tuple2('name', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.zL))), _Utils_Tuple2('reportingCurrency', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString, input____.b0))), _Utils_Tuple2('reportingDefaultInterval', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString, input____.b1))), _Utils_Tuple2('reportingWeekEnding', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.b2))), _Utils_Tuple2('size', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Company_size_enum$toString, input____.aB))), _Utils_Tuple2('timeZone', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.b4)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$CompanyMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateCompanyInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateCompany = F5(function (_v0, req, tag, url, idToken) {
    var companyId = _v0;
    var updateCompanyResponse = $author$project$Api$GraphqlSchema$Union$UpdateCompanyPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      B1: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$UpdateCompanySuccess$companyId)
    });
    var updateCompanyTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$companyLogic, function (args) {
      return _Utils_update(args, {
        F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(companyId)
      });
    }, A2($author$project$Api$GraphqlSchema$Object$CompanyMutation$update, {
      W: $author$project$Api$Types$UpdateCompanyReq$toUpdateCompanyInput(req)
    }, updateCompanyResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetCompanyTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, updateCompanyTask)));
  });
  var $author$project$Api$GraphqlSchema$Object$UpdateDivisionSuccess$divisionId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'divisionId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$Union$UpdateDivisionPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'DivisionNotFoundError', selections____.rP), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateDivisionSuccess', selections____.B2)]));
  };

  var $author$project$Api$GraphqlSchema$Query$division_by_pk = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'division_by_pk', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  });
  var $author$project$Api$Api$getDivisionTask = F3(function (url, idToken, _v0) {
    var divisionId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('Division not found: ' + divisionId), A2($author$project$Api$GraphqlSchema$Query$division_by_pk, {
      F: divisionId
    }, $author$project$Api$Schema$division)));
  });
  var $author$project$Api$Api$toGetDivisionTask = F3(function (url, idToken, divisionId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getDivisionTask, url, idToken, divisionId)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateDivisionInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('employeeCount', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('industry', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.an, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };

  var $author$project$Api$GraphqlSchema$Object$DivisionMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateDivisionInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateDivision = F5(function (_v0, req, tag, url, idToken) {
    var divisionId = _v0;
    var updateDivisionResponse = $author$project$Api$GraphqlSchema$Union$UpdateDivisionPayload$fragments({
      rP: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$DivisionNotFoundError$message),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      B2: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Result$Ok), $author$project$Api$GraphqlSchema$Object$UpdateDivisionSuccess$divisionId)
    });
    var updateDivisionTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$divisionLogic, {
      F: divisionId
    }, A2($author$project$Api$GraphqlSchema$Object$DivisionMutation$update, {
      W: req
    }, updateDivisionResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetDivisionTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, updateDivisionTask)));
  });

  var $author$project$Api$GraphqlSchema$Union$UpdateInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteNotFoundError', selections____.jo), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InviteStatusError', selections____.jp), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateInviteSuccess', selections____.B3)]));
  };

  var $author$project$Api$GraphqlSchema$Object$UpdateInviteSuccess$inviteId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'inviteId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateInviteInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('role', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Role_enum$toString, input____.gz)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$InviteMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateInviteInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateInviteTask = F4(function (_v0, _v1, url, idToken) {
    var role = _v0.gz;
    var invitationId = _v1;
    var updateInviteRes = $author$project$Api$GraphqlSchema$Union$UpdateInvitePayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      jo: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteNotFoundError$message),
      jp: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InviteStatusError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      B3: A2($author$project$Api$Schema$mapUuid, A2($elm$core$Basics$composeL, $elm$core$Result$Ok, $elm$core$Basics$identity), $author$project$Api$GraphqlSchema$Object$UpdateInviteSuccess$inviteId)
    });
    var updateInvite = A2($author$project$Api$GraphqlSchema$Object$InviteMutation$update, {
      W: {
        gz: role
      }
    }, updateInviteRes);
    return A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$inviteLogic, {
      F: $author$project$Api$Schema$uuidFromString(invitationId)
    }, updateInvite));
  });
  var $author$project$Api$Api$updateInvitation = F6(function (_v0, invitationId, updateInvitationRequest, tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$getInvite, idToken, url)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A4($author$project$Api$Api$updateInviteTask, updateInvitationRequest, invitationId, url, idToken))));
  });
  var $author$project$Api$Api$updateInvitationAndResend = F6(function (_v0, invitationId, updateInvitationRequest, tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$getInvite, idToken, url)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$resendInvitationTask, url, idToken)), A4($author$project$Api$Api$updateInviteTask, updateInvitationRequest, invitationId, url, idToken)))));
  });

  var $author$project$Api$GraphqlSchema$Union$UpdateScenarioPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateScenarioSuccess', selections____.B4)]));
  };

  var $author$project$Api$Types$UpdateScenarioReq$toUpdateScenarioInput = function (req) {
    return {
      Dy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $elm$core$List$map($author$project$Api$Types$CreateScenarioReq$toCashboardScenarioBlockInput), req.vk)),
      h7: {
        E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.E),
        br: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.br),
        la: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.la),
        rf: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, $author$project$Types$Scenario$scenarioLengthToNoOfMonths, req.rf)),
        zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.zL),
        sQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.sQ),
        tB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.tB)
      },
      de: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.de),
      df: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(req.df)
    };
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenarioUpdateDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('description', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('draft', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('enabled', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.la, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('length', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.rf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)), _Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.zL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('published', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.sQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('startAt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.tB, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateScenarioInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('scenarioBlocks', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Dy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCashboardScenarioBlockInput))), _Utils_Tuple2('scenarioUpdateDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeScenarioUpdateDescriptorInput(input____.h7))), _Utils_Tuple2('setAsBase', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.de, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('setAsBudget', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.df, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateScenarioInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateScenario = F5(function (companyId, req, tag, url, idToken) {
    var updateScenarioResponse = $author$project$Api$GraphqlSchema$Union$UpdateScenarioPayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message),
      B4: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0))
    });
    var updateScenarioTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$scenarioLogic, {
      F: $author$project$Types$Scenario$unwrapScenarioId(req.F)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioMutation$update, {
      W: $author$project$Api$Types$UpdateScenarioReq$toUpdateScenarioInput(req)
    }, updateScenarioResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult($elm$core$Basics$always(A3($author$project$Api$Api$getCompanyDetailsTask, companyId, url, idToken))), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, updateScenarioTask)));
  });
  var $author$project$Api$Api$getUserTask = F3(function (url, idToken, _v0) {
    var userId = _v0;
    return A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail, $elm$core$Result$fromMaybe('User not found: ' + userId), A2($author$project$Api$GraphqlSchema$Query$user_by_pk, {
      F: userId
    }, $author$project$Api$Schema$user)));
  });
  var $author$project$Api$Api$toGetUserTask = F3(function (url, idToken, userId) {
    return A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$Ok), A2($elm$core$Task$map, $elm$core$Result$Ok, A3($author$project$Api$Api$getUserTask, url, idToken, userId)));
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateUserInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('companyId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('firstName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hu))), _Utils_Tuple2('lastName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hI))), _Utils_Tuple2('phoneNumber', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ng))), _Utils_Tuple2('photoUrl', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.nh)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$UserMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateUserInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Union$UserUpdatePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserUpdateSuccess', selections____.B8)]));
  };

  var $author$project$Api$GraphqlSchema$Object$UserUpdateSuccess$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'userId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Api$updateUserResponse = $author$project$Api$GraphqlSchema$Union$UserUpdatePayload$fragments({
    M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
    N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
    O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
    B8: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (_v0) {
      var userId = _v0;
      return $elm$core$Result$Ok(userId);
    }, $author$project$Api$GraphqlSchema$Object$UserUpdateSuccess$userId)
  });
  var $author$project$Api$Api$updateSelf = F4(function (_v0, tag, url, idToken) {
    var firstName = _v0.hu;
    var lastName = _v0.hI;
    var phoneNumber = _v0.ng;

    var updateUser_ = function (userId) {
      return A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$userLogic, {
        F: $author$project$Types$User$unwrapUserId(userId)
      }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$update, {
        W: {
          b9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          hu: firstName,
          hI: lastName,
          ng: phoneNumber,
          nh: ''
        }
      }, $author$project$Api$Api$updateUserResponse)));
    };

    var getUserIdAndUpdateUser = A2($elm$core$Task$andThen, function (userId) {
      if (userId.$ === 1) {
        return $elm$core$Task$succeed($elm$core$Result$Err('User id not found'));
      } else {
        var uId = userId.a;
        return $elm$core$Task$succeed($elm$core$Result$Ok(uId));
      }
    }, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($author$project$Api$Api$getApiUser, url, idToken)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetUserTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(updateUser_), getUserIdAndUpdateUser))));
  });

  var $author$project$Api$Types$UpdateUserReq$toUpdateUserInput = function (req) {
    return {
      b9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Types$Company$unwrapCompanyId, $elm$core$Basics$identity), req.b9)),
      hu: req.hu,
      hI: req.hI,
      ng: req.ng,
      nh: req.nh
    };
  };

  var $author$project$Api$Api$updateUser = F4(function (req, tag, url, idToken) {
    var updateUserTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$userLogic, {
      F: $author$project$Types$User$unwrapUserId(req.oD)
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$update, {
      W: $author$project$Api$Types$UpdateUserReq$toUpdateUserInput(req)
    }, $author$project$Api$Api$updateUserResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$andThen, $author$project$Api$Api$createTaskFromResult(A2($author$project$Api$Api$toGetUserTask, url, idToken)), A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, updateUserTask)));
  });

  var $author$project$Api$GraphqlSchema$Union$UserCompanyUpdatePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserCompanyUpdateSuccess', selections____.B7)]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateCompanyRoleInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('companyId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.b9))), _Utils_Tuple2('external', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.xF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('role', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$Role_enum$toString)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$UserMutation$updateUserCompany = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updateUserCompany', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateCompanyRoleInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$UserCompanyUpdateSuccess$userCompanyId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'userCompanyId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$GraphqlSchema$Object$UserCompanyUpdateSuccess$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Uuid', 'userId', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).L.wB);
  var $author$project$Api$Api$updateUserInCompany = F6(function (_v0, _v1, updateUserInput, tag, url, idToken) {
    var companyId = _v0;
    var userId = _v1;
    var updateUserInCompanyResponse = $author$project$Api$GraphqlSchema$Union$UserCompanyUpdatePayload$fragments({
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      B7: A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (_v2, _v3) {
        var compId = _v2;
        return $elm$core$Result$Ok(compId);
      }), $author$project$Api$GraphqlSchema$Object$UserCompanyUpdateSuccess$userCompanyId, $author$project$Api$GraphqlSchema$Object$UserCompanyUpdateSuccess$userId)
    });
    var updateUserInCompanyTask = A3($author$project$Api$Api$mutationRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$userLogic, {
      F: userId
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$updateUserCompany, {
      W: {
        b9: companyId,
        xF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
        gz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(updateUserInput.gz)
      }
    }, updateUserInCompanyResponse)));

    var toUserCompany = function (compId) {
      return {
        b9: compId,
        gz: updateUserInput.gz,
        oD: userId
      };
    };

    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Result$map(toUserCompany)), A2($elm$core$Task$map, $elm$core$Result$map(toUserCompany), updateUserInCompanyTask)));
  });
  var $author$project$Remote$UpdateRequest$updateRequest = F3(function (global, requestMsg, state) {
    var url = global.dy.oZ;
    var helpers = $author$project$ElmFramework$Lib$RemoteModel$toRequestHelpers({
      kp: $author$project$Route$Route$authEntryRoute,
      h3: requestMsg,
      Ej: state,
      t2: $author$project$Remote$Model$toIdToken
    });

    if (A2($author$project$Remote$Model$isRequestAlreadyOngoing, state, requestMsg)) {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    } else {
      switch (requestMsg.$) {
        case 0:
          var companyId = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$getCompanyDetails, companyId, $author$project$Remote$ResponseMsg$GetCompanyDetails(companyId), url),
            eS: false,
            rn: $author$project$Remote$Model$mapSession(A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setAsLoading, companyId))
          });

        case 1:
          var companyId = requestMsg.a;
          var blockId = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$getBuildingBlockDetails, companyId, blockId, $author$project$Remote$ResponseMsg$GetBuildingBlockDetails(companyId), url),
            eS: false,
            rn: $elm$core$Basics$identity
          });

        case 2:
          var companyId = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$getAllBuildingBlockDetails, companyId, $author$project$Remote$ResponseMsg$GetAllBuildingBlocksDetails(companyId), url),
            eS: false,
            rn: $author$project$Remote$Model$mapSession(A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setBuildingBlocksAsLoadingDetails, companyId))
          });

        case 3:
          var companyId = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$getAllScenariosDetails, companyId, $author$project$Remote$ResponseMsg$GetAllScenariosDetails(companyId), url),
            eS: false,
            rn: $elm$core$Basics$identity
          });

        case 4:
          var companyId = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$getAllDivisionDetails, companyId, $author$project$Remote$ResponseMsg$GetAllDivisionDetails(companyId), url),
            eS: false,
            rn: $elm$core$Basics$identity
          });

        case 5:
          return helpers.DU({
            iC: A2($author$project$Api$Api$getAuthMetadata, $author$project$Remote$ResponseMsg$GetAuthMetadata, url),
            eS: false,
            rn: function (state_) {
              return _Utils_update(state_, {
                tb: $krisajenkins$remotedata$RemoteData$Loading
              });
            }
          });

        case 6:
          var companyId = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$getPresetSeasonalities, companyId, $author$project$Remote$ResponseMsg$GetPresetSeasonalities(companyId), url),
            eS: false,
            rn: $elm$core$Basics$identity
          });

        case 7:
          return helpers.DU({
            iC: A2($author$project$Api$Api$getIndustries, $author$project$Remote$ResponseMsg$GetIndustries, url),
            eS: false,
            rn: function (state_) {
              return _Utils_update(state_, {
                qP: $krisajenkins$remotedata$RemoteData$Loading
              });
            }
          });

        case 8:
          var onboardingReq = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$onboardCompany, onboardingReq, $author$project$Remote$ResponseMsg$OnboardCompany, url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 9:
          var onboardingCompanyAndUserReq = requestMsg.a;
          return helpers.DU({
            iC: A5($author$project$Api$Api$onboardCompanyWithUser, global.dy.xL.oY, onboardingCompanyAndUserReq, $author$project$Remote$ResponseMsg$OnboardCompanyWithUser, url, $author$project$Remote$Model$toRefreshToken(state)),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 10:
          var companyId = requestMsg.a;
          var updateCompanyReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$updateCompany, companyId, updateCompanyReq, $author$project$Remote$ResponseMsg$UpdateCompanyInOnboarding(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 11:
          var inviteCode = requestMsg.a;
          return helpers.DU({
            iC: A5($author$project$Api$Api$redeemInviteWithExistingUser, global.dy.xL.oY, $author$project$Remote$Model$toRefreshToken(state), inviteCode, $author$project$Remote$ResponseMsg$RedeemInvite, url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 12:
          var newUserDetails = requestMsg.a;
          var inviteCode = requestMsg.b;
          return helpers.DV({
            iC: A5($author$project$Api$Api$redeemInviteWithRegistation, global.dy.xL.oY, inviteCode, newUserDetails, url, $author$project$Remote$ResponseMsg$RedeemInvite),
            eS: true,
            C_: 'redeemInviteWithRegistation'
          });

        case 13:
          var selfUpdateReq = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$updateSelf, selfUpdateReq, $author$project$Remote$ResponseMsg$UpdateSelf, url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 15:
          var updateUserReq = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$updateUser, updateUserReq, $author$project$Remote$ResponseMsg$UpdateUser, url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 14:
          var deleteRequest = function (userId) {
            return helpers.DU({
              iC: A3($author$project$Api$Api$deleteMyAccount, userId, url, $author$project$Remote$ResponseMsg$DeleteMyAccount),
              eS: true,
              rn: $elm$core$Basics$identity
            });
          };

          var _v1 = state.EL;

          switch (_v1.$) {
            case 2:
              var authUser = _v1.a;
              return deleteRequest(authUser.Fl.F);

            case 3:
              var thisUserSession = _v1.a;
              return deleteRequest(thisUserSession.Fl.F);

            default:
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Error getting user session', _List_Nil)]));
          }

        case 72:
          return _Utils_Tuple3($author$project$Remote$Model$initClean, $elm$core$Platform$Cmd$none, _List_Nil);

        case 73:
          var auth = requestMsg.a;

          var newThisUserAuth = function () {
            var _v2 = state.EL;

            switch (_v2.$) {
              case 0:
                return state.EL;

              case 1:
                return state.EL;

              case 2:
                var authUser = _v2.a;
                return $author$project$Remote$Model$Authenticated(_Utils_update(authUser, {
                  u_: auth
                }));

              default:
                var thisUserSession = _v2.a;
                return $author$project$Remote$Model$Onboarded(_Utils_update(thisUserSession, {
                  u_: auth
                }));
            }
          }();

          return _Utils_Tuple3(_Utils_update(state, {
            EL: newThisUserAuth
          }), $author$project$Remote$Remote$newUserSession($elm$core$Maybe$Just($author$project$Types$UserSession$unwrapAuth(auth))), _List_Nil);

        case 17:
          var companyId = requestMsg.a;
          return helpers.DU({
            iC: A3($author$project$Api$Api$deleteCompany, companyId, $author$project$Remote$ResponseMsg$DeleteCompany(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 16:
          var companyId = requestMsg.a;
          var updateCompanyReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$updateCompany, companyId, updateCompanyReq, $author$project$Remote$ResponseMsg$UpdateCompany(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 18:
          var companyId = requestMsg.a;
          var inviteUserReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$inviteUserToCompany, companyId, inviteUserReq, $author$project$Remote$ResponseMsg$InviteUserToCompany(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 19:
          var companyId = requestMsg.a;
          var invitationId = requestMsg.b;
          var updateInvitationReq = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$updateInvitation, companyId, invitationId, updateInvitationReq, $author$project$Remote$ResponseMsg$UpdateInvitation(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 20:
          var companyId = requestMsg.a;
          var invitationId = requestMsg.b;
          var updateInvitationReq = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$updateInvitationAndResend, companyId, invitationId, updateInvitationReq, $author$project$Remote$ResponseMsg$UpdateInvitationAndResend(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 21:
          var companyId = requestMsg.a;
          var invitationId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$revokeInvitation, invitationId, A2($author$project$Remote$ResponseMsg$RevokeInvitation, companyId, invitationId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 22:
          var companyId = requestMsg.a;
          var invitationId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$resendInvitation, invitationId, $author$project$Remote$ResponseMsg$ResendInvitation(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 23:
          var companyId = requestMsg.a;
          var userId = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$removeUserFromCompany, companyId, userId, A2($author$project$Remote$ResponseMsg$RemoveUserFromCompany, companyId, userId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 24:
          var companyId = requestMsg.a;
          var userId = requestMsg.b;
          var req = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$updateUserInCompany, companyId, userId, req, $author$project$Remote$ResponseMsg$UpdateUserInCompany(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 25:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$createDivision, companyId, req, $author$project$Remote$ResponseMsg$CreateDivision(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 26:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          var req = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$updateDivision, divisionId, req, $author$project$Remote$ResponseMsg$UpdateDivision(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 27:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$deleteDivision, companyId, divisionId, $author$project$Remote$ResponseMsg$DeleteDivision(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 28:
          var companyId = requestMsg.a;
          var accountingSystemDivisionId = requestMsg.b;
          var maybeDivisionId = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$disconnectDivision, companyId, accountingSystemDivisionId, A2($author$project$Remote$ResponseMsg$DisconnectDivision, companyId, maybeDivisionId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 29:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          var sync = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$syncDivision, companyId, divisionId, sync, $author$project$Remote$ResponseMsg$SyncDivision(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 30:
          var maybeOnCreate = requestMsg.a;
          var companyId = requestMsg.b;
          var req = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$createAllocationClass, companyId, req, A2($author$project$Remote$ResponseMsg$CreateAllocationClass, maybeOnCreate, companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 31:
          var maybeOnUpdate = requestMsg.a;
          var companyId = requestMsg.b;
          var req = requestMsg.c;
          return helpers.DU({
            iC: A3($author$project$Api$Api$updateAllocationClass, req, A2($author$project$Remote$ResponseMsg$UpdateAllocationClass, maybeOnUpdate, companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 32:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$deleteAllocationClass, companyId, req, $author$project$Remote$ResponseMsg$DeleteAllocationClass(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 33:
          var companyId = requestMsg.a;
          var addAccountReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$addFinancialAccount, companyId, addAccountReq, A2($author$project$Remote$ResponseMsg$AddFinancialAccount, companyId, addAccountReq.R), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 34:
          var routeBack = requestMsg.a;
          var companyId = requestMsg.b;
          var editFinancialAccountReq = requestMsg.c;
          return helpers.DU({
            iC: A3($author$project$Api$Api$editFinancialAccount, editFinancialAccountReq, A3($author$project$Remote$ResponseMsg$EditFinancialAccount, routeBack, companyId, editFinancialAccountReq.R), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 35:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          var financialAccountId = requestMsg.c;
          return helpers.DU({
            iC: A3($author$project$Api$Api$deleteFinancialAccount, financialAccountId, A3($author$project$Remote$ResponseMsg$DeleteFinancialAccount, companyId, divisionId, financialAccountId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 36:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          var overrideFinancialAccountBalanceOnDateReq = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$overrideFinancialAccountBalanceOnDate, companyId, divisionId, overrideFinancialAccountBalanceOnDateReq, A5($author$project$Remote$ResponseMsg$OverrideFinancialAccountBalanceOnDate, companyId, divisionId, overrideFinancialAccountBalanceOnDateReq.F, overrideFinancialAccountBalanceOnDateReq.iL, $JoshuaHall$elm_fraction$Fraction$toFloat(overrideFinancialAccountBalanceOnDateReq.Fw)), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 37:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          var resetFinancialAccountBalanceOnDateReq = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$resetFinancialAccountBalanceOnDate, companyId, divisionId, resetFinancialAccountBalanceOnDateReq, A4($author$project$Remote$ResponseMsg$ResetFinancialAccountBalanceOnDate, companyId, divisionId, resetFinancialAccountBalanceOnDateReq.F, resetFinancialAccountBalanceOnDateReq.iL), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 38:
          var companyId = requestMsg.a;
          var divisionId = requestMsg.b;
          var getFinancialAccountBalancesForPeriodReq = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$getFinancialAccountBalancesForPeriod, companyId, getFinancialAccountBalancesForPeriodReq, A3($author$project$Remote$ResponseMsg$GetFinancialAccountBalancesForPeriod, companyId, divisionId, getFinancialAccountBalancesForPeriodReq.xK), url),
            eS: false,
            rn: $elm$core$Basics$identity
          });

        case 39:
          var companyId = requestMsg.a;
          var connectAccountingSystemDivisionReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$connectAccountingSystemDivision, companyId, connectAccountingSystemDivisionReq, A2($author$project$Remote$ResponseMsg$ConnectAccountingSystemDivision, companyId, connectAccountingSystemDivisionReq.dB), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 40:
          var companyId = requestMsg.a;
          var disconnectAccountingSystemDivisionReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$disconnectAccountingSystemDivision, companyId, disconnectAccountingSystemDivisionReq, A2($author$project$Remote$ResponseMsg$DisconnectAccountingSystemDivision, companyId, disconnectAccountingSystemDivisionReq.dB), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 41:
          var companyId = requestMsg.a;
          var reconnectAccountingSystemDivisionReq = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$reconnectAccountingSystemDivision, companyId, reconnectAccountingSystemDivisionReq, A2($author$project$Remote$ResponseMsg$ReconnectAccountingSystemDivision, companyId, reconnectAccountingSystemDivisionReq.dB), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 42:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$createScenario, companyId, req, $author$project$Remote$ResponseMsg$CreateScenario(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 43:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$updateScenario, companyId, req, $author$project$Remote$ResponseMsg$UpdateScenario(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 44:
          var callback = requestMsg.a;
          var companyId = requestMsg.b;
          var req = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$duplicateScenario, companyId, req, A2($author$project$Remote$ResponseMsg$DuplicateScenario, callback, companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 45:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$deleteScenario, req, A2($author$project$Remote$ResponseMsg$DeleteScenario, companyId, req.e8), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 46:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          return helpers.DU({
            iC: A5($author$project$Api$Api$setScenarioEnabled, companyId, scenarioId, true, A2($author$project$Remote$ResponseMsg$EnableScenario, companyId, scenarioId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 47:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          return helpers.DU({
            iC: A5($author$project$Api$Api$setScenarioEnabled, companyId, scenarioId, false, A2($author$project$Remote$ResponseMsg$DisableScenario, companyId, scenarioId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 48:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$setAsBaseScenario, scenarioId, A2($author$project$Remote$ResponseMsg$SetAsBaseScenario, companyId, scenarioId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 49:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$setAsBudgetScenario, scenarioId, A2($author$project$Remote$ResponseMsg$SetAsBudgetScenario, companyId, scenarioId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 50:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          var blockId = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$addBlockToScenario, scenarioId, blockId, $author$project$Remote$ResponseMsg$AddBlockToScenario(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 51:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          var blockId = requestMsg.c;
          var scenarioBlockId = requestMsg.d;
          return helpers.DU({
            iC: A6($author$project$Api$Api$removeBlockFromScenario, companyId, scenarioId, blockId, scenarioBlockId, A3($author$project$Remote$ResponseMsg$RemoveBlockFromScenario, companyId, scenarioId, blockId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 52:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$editScenarioBlockRelationship, companyId, req, $author$project$Remote$ResponseMsg$EditScenarioBlockRelationship(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 53:
          var companyId = requestMsg.a;
          var scenarioBlockId = requestMsg.b;
          var blockId = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$quickEditBlockInScenario, companyId, scenarioBlockId, blockId, $author$project$Remote$ResponseMsg$QuickEditBlockInScenario(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 54:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$saveBlockQuickEditsForScenario, companyId, req, A3($author$project$Remote$ResponseMsg$SaveBlockQuickEditsForScenario, companyId, req.e8, req.dM), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 55:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          var blockId = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$discardScenarioQuickEdits, companyId, scenarioId, blockId, $author$project$Remote$ResponseMsg$DiscardScenarioQuickEdits(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 56:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$discardAllScenarioQuickEdits, companyId, scenarioId, $author$project$Remote$ResponseMsg$DiscardAllScenarioQuickEdits(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 57:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$cloneScenarioPreservingQuickEdits, companyId, scenarioId, $author$project$Remote$ResponseMsg$CloneScenarioPreservingQuickEdits(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 58:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$createComment, companyId, req, $author$project$Remote$ResponseMsg$CreateComment(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 59:
          var companyId = requestMsg.a;
          var commentId = requestMsg.b;
          var req = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$editComment, commentId, req, $author$project$Remote$ResponseMsg$EditComment(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 60:
          var companyId = requestMsg.a;
          var commentId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$deleteComment, commentId, $author$project$Remote$ResponseMsg$DeleteComment(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 61:
          var companyId = requestMsg.a;
          var scenarioId = requestMsg.b;
          var name = requestMsg.c;
          return helpers.DU({
            iC: A5($author$project$Api$Api$createReview, companyId, scenarioId, name, $author$project$Remote$ResponseMsg$CreateReview(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 63:
          var companyId = requestMsg.a;
          var reviewId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$approveReview, reviewId, $author$project$Remote$ResponseMsg$ApproveReview(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 62:
          var companyId = requestMsg.a;
          var reviewId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$requestReviewApproval, reviewId, $author$project$Remote$ResponseMsg$RequestReviewApproval(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 64:
          var companyId = requestMsg.a;
          var reviewId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$deleteReview, reviewId, $author$project$Remote$ResponseMsg$DeleteReview(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 65:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$createBlock, companyId, req, $author$project$Remote$ResponseMsg$CreateBlock(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 66:
          var companyId = requestMsg.a;
          var maybeScenarioId = requestMsg.b;
          var blockId = requestMsg.c;
          var req = requestMsg.d;
          return helpers.DU({
            iC: A6($author$project$Api$Api$updateBlock, companyId, maybeScenarioId, blockId, req, $author$project$Remote$ResponseMsg$UpdateBlock(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 67:
          var companyId = requestMsg.a;
          var req = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$deleteBlock, companyId, req, $author$project$Remote$ResponseMsg$DeleteBlock(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 68:
          var companyId = requestMsg.a;
          var blockId = requestMsg.b;
          return helpers.DU({
            iC: A4($author$project$Api$Api$cloneBlock, companyId, blockId, $author$project$Remote$ResponseMsg$CloneBlock(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 69:
          var maybeOnCreate = requestMsg.a;
          var companyId = requestMsg.b;
          var createSeasonalityPresetReq = requestMsg.c;
          return helpers.DU({
            iC: A4($author$project$Api$Api$createSeasonalityPreset, companyId, createSeasonalityPresetReq, A2($author$project$Remote$ResponseMsg$CreateSeasonalityPreset, maybeOnCreate, companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        case 70:
          var maybeOnUpdate = requestMsg.a;
          var companyId = requestMsg.b;
          var seasonalityId = requestMsg.c;
          var editSeasonalityPresetReq = requestMsg.d;
          return helpers.DU({
            iC: A4($author$project$Api$Api$editSeasonalityPreset, seasonalityId, editSeasonalityPresetReq, A2($author$project$Remote$ResponseMsg$UpdateSeasonalityPreset, maybeOnUpdate, companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });

        default:
          var companyId = requestMsg.a;
          var seasonalityId = requestMsg.b;
          return helpers.DU({
            iC: A3($author$project$Api$Api$deleteSeasonalityPreset, seasonalityId, $author$project$Remote$ResponseMsg$DeleteSeasonalityPreset(companyId), url),
            eS: true,
            rn: $elm$core$Basics$identity
          });
      }
    }
  });
  var $author$project$Ui$Accounts$Add$Msg$Canceled = {
    $: 8
  };
  var $author$project$Ui$Accounts$Edit$Msg$Canceled = {
    $: 5
  };
  var $author$project$Ui$EditingUsers$Msg$ClearForm = {
    $: 5
  };
  var $author$project$Ui$Scenario$Msg$ClearInputs = {
    $: 1
  };

  var $author$project$Ui$OnboardingCompany$Msg$ClickedNext = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$DeleteDivision = F2(function (a, b) {
    return {
      $: 27,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Lib$RemoteModel$GeneralErrHandler_DefaultToast = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Settings$Msg$HandleNewDivisions = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Global$Msg$HideDialog = {
    $: 13
  };
  var $author$project$Ui$Cashboard$Comment$Msg$Reset = {
    $: 0
  };
  var $author$project$Remote$RequestMsg$SetAsBaseScenario = F2(function (a, b) {
    return {
      $: 48,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Block$Msg$SetEditMasterblockScenarios = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$SetEditingMasterBlocks = function (a) {
    return {
      $: 17,
      a: a
    };
  };

  var $author$project$Ui$Settings$Msg$SetNewDivisions = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$SetNewReviewName = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$SetOverlay = function (a) {
    return {
      $: 16,
      a: a
    };
  };

  var $author$project$Types$Company$addBlock = F2(function (block, company) {
    return _Utils_update(company, {
      pg: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$insert, block.F, block), company.pg)
    });
  });
  var $author$project$Types$Scenario$addComment = F2(function (comment, scenario) {
    return _Utils_update(scenario, {
      bH: A3($turboMaCk$any_dict$Dict$Any$insert, comment.F, comment, scenario.bH)
    });
  });

  var $author$project$ElmFramework$Lib$RemoteDataExtra$mapOrDefaultRemoteData = function (_v0) {
    var mapper = _v0.zj;
    var _default = _v0.wC;
    var remoteData = _v0.CU;
    return $krisajenkins$remotedata$RemoteData$Success(A2($krisajenkins$remotedata$RemoteData$withDefault, _default, A2($krisajenkins$remotedata$RemoteData$map, mapper, remoteData)));
  };

  var $turboMaCk$any_dict$Dict$Any$singleton = F3(function (k, v, f) {
    return A3($turboMaCk$any_dict$Dict$Any$insert, k, v, $turboMaCk$any_dict$Dict$Any$empty(f));
  });

  var $author$project$Types$Invitation$singletonInvitationDict = function (invitation) {
    return A3($turboMaCk$any_dict$Dict$Any$singleton, invitation.F, invitation, $author$project$Types$Invitation$unwrapInvitationId);
  };

  var $author$project$Types$Company$addInvitation = F2(function (invitation, company) {
    return _Utils_update(company, {
      q_: $author$project$ElmFramework$Lib$RemoteDataExtra$mapOrDefaultRemoteData({
        wC: $author$project$Types$Invitation$singletonInvitationDict(invitation),
        zj: A2($turboMaCk$any_dict$Dict$Any$insert, invitation.F, invitation),
        CU: company.q_
      })
    });
  });
  var $author$project$Types$Scenario$addReview = F2(function (review, scenario) {
    return _Utils_update(scenario, {
      c9: A3($turboMaCk$any_dict$Dict$Any$insert, review.F, review, scenario.c9)
    });
  });
  var $turboMaCk$any_dict$Dict$Any$foldl = F3(function (f, acc, _v0) {
    var dict = _v0.bT;
    return A3($elm$core$Dict$foldl, F2(function (_v1, _v2) {
      var k = _v2.a;
      var v = _v2.b;
      return A2(f, k, v);
    }), acc, dict);
  });
  var $turboMaCk$any_dict$Dict$Any$union = F2(function (_v0, _v1) {
    var inner = _v0;
    var dict = _v1.bT;
    return _Utils_update(inner, {
      bT: A2($elm$core$Dict$union, inner.bT, dict)
    });
  });
  var $author$project$ElmFramework$Lib$PivotDict$union = F2(function (_v0, _v1) {
    var payload1 = _v0;
    var payload2 = _v1;
    var subDictUpdater = F2(function (newSubDict, maybeOldSubDict) {
      if (!maybeOldSubDict.$) {
        var oldSubDict = maybeOldSubDict.a;
        return $elm$core$Maybe$Just(A2($turboMaCk$any_dict$Dict$Any$union, newSubDict, oldSubDict));
      } else {
        return $elm$core$Maybe$Just(newSubDict);
      }
    });
    var foldMainDict = F3(function (id, subDict, dictOld) {
      return A3($turboMaCk$any_dict$Dict$Any$update, id, subDictUpdater(subDict), dictOld);
    });
    return _Utils_update(payload1, {
      cG: A3($turboMaCk$any_dict$Dict$Any$foldl, foldMainDict, payload1.cG, payload2.cG),
      dz: A3($turboMaCk$any_dict$Dict$Any$foldl, foldMainDict, payload1.dz, payload2.dz)
    });
  });
  var $author$project$ElmFramework$Lib$PivotDict$addItems = F2(function (list, pivotDict) {
    var payload = pivotDict;
    var newPivotDict = $author$project$ElmFramework$Lib$PivotDict$fromList({
      aA: list,
      d8: payload.d8,
      eB: payload.eB,
      eE: payload.eE,
      eF: payload.eF
    });
    return A2($author$project$ElmFramework$Lib$PivotDict$union, pivotDict, newPivotDict);
  });
  var $author$project$ElmFramework$Lib$PivotDict$addItem = F2(function (record, pivotDict) {
    return A2($author$project$ElmFramework$Lib$PivotDict$addItems, _List_fromArray([record]), pivotDict);
  });
  var $author$project$Types$Company$addScenarioBlock = F2(function (scenarioBlock, company) {
    return _Utils_update(company, {
      nT: A2($krisajenkins$remotedata$RemoteData$map, $author$project$ElmFramework$Lib$PivotDict$addItem(scenarioBlock), company.nT)
    });
  });
  var $elm$core$Dict$diff = F2(function (t1, t2) {
    return A3($elm$core$Dict$foldl, F3(function (k, v, t) {
      return A2($elm$core$Dict$remove, k, t);
    }), t1, t2);
  });
  var $turboMaCk$any_dict$Dict$Any$diff = F2(function (_v0, _v1) {
    var inner = _v0;
    var dict = _v1.bT;
    return _Utils_update(inner, {
      bT: A2($elm$core$Dict$diff, inner.bT, dict)
    });
  });

  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$fromSeasonalityPreset = function (seasonalityPreset) {
    return {
      dW: $author$project$Types$MonthAdjustments$fromArray(seasonalityPreset.dW),
      sH: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(seasonalityPreset.F), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init),
      gu: ''
    };
  };

  var $author$project$TopMsg$msgOnboardingCompany = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$OnboardingCompanyMsg);
  var $author$project$Remote$UpdateResponse$handleOnboarding = F2(function (userSessionStatus, state) {
    if (userSessionStatus.$ === 3) {
      return _Utils_Tuple3(_Utils_update(state, {
        EL: userSessionStatus
      }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgOnboardingCompany($author$project$Ui$OnboardingCompany$Msg$ClickedNext(0))]));
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Error getting session', _List_Nil)]));
    }
  });

  var $author$project$Ui$OnboardingCompany$Msg$RouteToOnboardedHome = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Remote$UpdateResponse$handleRedeemInvite = F2(function (userSessionStatus, state) {
    if (userSessionStatus.$ === 3) {
      return _Utils_Tuple3(_Utils_update(state, {
        EL: userSessionStatus
      }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgOnboardingCompany($author$project$Ui$OnboardingCompany$Msg$RouteToOnboardedHome(userSessionStatus)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$SetInviteCode($elm$core$Maybe$Nothing))]));
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Error getting session', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$SetInviteCode($elm$core$Maybe$Nothing))]));
    }
  });
  var $author$project$Types$UserSession$insertUserCompany = F2(function (userCompany, thisUserSession) {
    return _Utils_update(thisUserSession, {
      ue: A2($author$project$ElmFramework$Lib$PivotDict$addItems, _List_fromArray([userCompany]), thisUserSession.ue)
    });
  });

  var $author$project$Route$CommentsRoute$isCommentRepliesRoute = function (subRoute) {
    if (subRoute.$ === 1) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$CommentsRoute$isEditCommentRoute = function (subRoute) {
    if (subRoute.$ === 4) {
      return true;
    } else {
      return false;
    }
  };

  var $elm_community$list_extra$List$Extra$updateIf = F3(function (predicate, update, list) {
    return A2($elm$core$List$map, function (item) {
      return predicate(item) ? update(item) : item;
    }, list);
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$update = F3(function (id, updater, _v0) {
    var payload = _v0;
    var dict = payload.bT;
    var list = payload.aA;
    var toId = payload.b5;

    var newList = function () {
      var _v1 = updater(A2($turboMaCk$any_dict$Dict$Any$get, id, dict));

      if (!_v1.$) {
        var updated = _v1.a;
        return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$eq(id)), list)) ? A3($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$eq(id)), $elm$core$Basics$always(updated), list) : A2($elm$core$List$cons, updated, list);
      } else {
        return A2($elm$core$List$filter, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$neq(id)), list);
      }
    }();

    return _Utils_update(payload, {
      bT: A3($turboMaCk$any_dict$Dict$Any$update, id, updater, dict),
      aA: newList
    });
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$update = F3(function (id, mapper, endlessList) {
    return _Utils_update(endlessList, {
      aq: A3($author$project$ElmFramework$Lib$OrderedCollection$update, id, mapper, endlessList.aq)
    });
  });
  var $author$project$Types$FinancialAccount$mapBalance = F3(function (date, mapper, financialAccount) {
    var updater = A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$update, date, $elm$core$Maybe$map(mapper));
    return _Utils_update(financialAccount, {
      fy: A2($krisajenkins$remotedata$RemoteData$map, updater, financialAccount.fy)
    });
  });
  var $author$project$Types$Company$mapBuildingBlock = F3(function (mapper, id, company) {
    return _Utils_update(company, {
      pg: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$update, id, $elm$core$Maybe$map(mapper)), company.pg)
    });
  });
  var $author$project$Types$Company$mapDivision = F3(function (mapper, id, company) {
    return _Utils_update(company, {
      eO: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$update, id, $elm$core$Maybe$map(mapper)), company.eO)
    });
  });
  var $author$project$Types$Division$mapFinancialAccount = F3(function (mapper, financialAccountId, division) {
    return _Utils_update(division, {
      qp: A3($turboMaCk$any_dict$Dict$Any$update, financialAccountId, $elm$core$Maybe$map(mapper), division.qp)
    });
  });
  var $author$project$Types$Company$mapInvitation = F3(function (mapper, id, company) {
    return _Utils_update(company, {
      q_: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$update, id, $elm$core$Maybe$map(mapper)), company.q_)
    });
  });
  var $author$project$Types$Company$mapScenario = F3(function (mapper, id, company) {
    return _Utils_update(company, {
      db: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$update, id, $elm$core$Maybe$map(mapper)), company.db)
    });
  });
  var $author$project$Types$UserSession$mapSelf = F2(function (mapper, thisUserSession) {
    return _Utils_update(thisUserSession, {
      Fl: mapper(thisUserSession.Fl)
    });
  });
  var $author$project$TopMsg$msgAccounts = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AccountsMsg);
  var $author$project$TopMsg$msgEditingUsers = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$EditingUsersMsg);
  var $author$project$TopMsg$msgScenarios = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ScenariosMsg);
  var $author$project$TopMsg$msgSettings = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$SettingsMsg);
  var $author$project$Types$Balance$overrideBalance = F2(function (theAmount, balance) {
    return _Utils_update(balance, {
      gY: theAmount,
      jZ: $elm$core$Maybe$Just(balance.gY)
    });
  });
  var $author$project$Types$Company$removeComment = F2(function (commentId, company) {
    return _Utils_update(company, {
      db: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v0, scenario) {
        return _Utils_update(scenario, {
          bH: A2($turboMaCk$any_dict$Dict$Any$remove, commentId, scenario.bH)
        });
      })), company.db)
    });
  });
  var $author$project$ElmFramework$Lib$PivotDict$keysById2 = F2(function (id2, _v0) {
    var dict2 = _v0.dz;
    var serializeId1 = _v0.d8;
    return $turboMaCk$any_dict$Dict$Any$keys(A2($elm$core$Maybe$withDefault, $turboMaCk$any_dict$Dict$Any$empty(serializeId1), A2($turboMaCk$any_dict$Dict$Any$get, id2, dict2)));
  });
  var $author$project$ElmFramework$Lib$PivotDict$removeAllById2 = F2(function (id2, _v0) {
    var payload = _v0;
    var reducer = F2(function (id1, dict1) {
      return A3($turboMaCk$any_dict$Dict$Any$update, id1, $elm$core$Maybe$map($turboMaCk$any_dict$Dict$Any$remove(id2)), dict1);
    });

    var _v1 = A2($author$project$ElmFramework$Lib$PivotDict$keysById2, id2, payload);

    if (!_v1.b) {
      return payload;
    } else {
      var ids = _v1;
      return _Utils_update(payload, {
        cG: A3($elm$core$List$foldl, reducer, payload.cG, ids),
        dz: A2($turboMaCk$any_dict$Dict$Any$remove, id2, payload.dz)
      });
    }
  });
  var $author$project$Types$UserSession$removeCompany = F2(function (companyId, thisUserSession) {
    return _Utils_update(thisUserSession, {
      v5: A2($turboMaCk$any_dict$Dict$Any$remove, companyId, thisUserSession.v5),
      ue: A2($author$project$ElmFramework$Lib$PivotDict$removeAllById2, companyId, thisUserSession.ue)
    });
  });
  var $author$project$Types$Division$removeFinancialAccount = F2(function (financialAccountId, division) {
    return _Utils_update(division, {
      qp: A2($turboMaCk$any_dict$Dict$Any$remove, financialAccountId, division.qp)
    });
  });
  var $author$project$Types$Company$removeFinancialAccount = F2(function (financialAccountId, company) {
    return _Utils_update(company, {
      eO: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v0, division) {
        return A2($author$project$Types$Division$removeFinancialAccount, financialAccountId, division);
      })), company.eO)
    });
  });

  var $author$project$Types$Division$removeOverlayDivision = function (division) {
    return _Utils_update(division, {
      ju: $elm$core$Maybe$Nothing
    });
  };

  var $author$project$Types$Company$removeReview = F2(function (reviewId, company) {
    return _Utils_update(company, {
      db: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v0, scenario) {
        return _Utils_update(scenario, {
          c9: A2($turboMaCk$any_dict$Dict$Any$remove, reviewId, scenario.c9)
        });
      })), company.db)
    });
  });
  var $author$project$Types$Company$removeScenario = F2(function (scenarioId, company) {
    return _Utils_update(company, {
      db: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$remove(scenarioId), company.db)
    });
  });
  var $author$project$ElmFramework$Lib$PivotDict$removeItem = F3(function (id1, id2, _v0) {
    var payload = _v0;
    return _Utils_update(payload, {
      cG: A3($turboMaCk$any_dict$Dict$Any$update, id1, $elm$core$Maybe$map($turboMaCk$any_dict$Dict$Any$remove(id2)), payload.cG),
      dz: A3($turboMaCk$any_dict$Dict$Any$update, id2, $elm$core$Maybe$map($turboMaCk$any_dict$Dict$Any$remove(id1)), payload.dz)
    });
  });
  var $author$project$Types$Company$removeScenarioBlock = F3(function (scenarioId, blockId, company) {
    return _Utils_update(company, {
      nT: A2($krisajenkins$remotedata$RemoteData$map, A2($author$project$ElmFramework$Lib$PivotDict$removeItem, scenarioId, blockId), company.nT)
    });
  });
  var $author$project$Types$Company$removeSeasonalityPreset = F2(function (seasonalityId, company) {
    return _Utils_update(company, {
      ti: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$remove(seasonalityId), company.ti)
    });
  });
  var $author$project$Types$UserSession$removeUserCompany = F3(function (userId, companyId, thisUserSession) {
    return _Utils_update(thisUserSession, {
      ue: A3($author$project$ElmFramework$Lib$PivotDict$removeItem, userId, companyId, thisUserSession.ue)
    });
  });

  var $author$project$Types$Balance$resetBalance = function (balance) {
    return _Utils_update(balance, {
      gY: A2($elm$core$Maybe$withDefault, balance.gY, balance.jZ),
      jZ: $elm$core$Maybe$Nothing
    });
  };

  var $author$project$Types$Invitation$revokeInvitation = function (invitation) {
    return _Utils_update(invitation, {
      Y: $author$project$Types$Invitation$Revoked
    });
  };

  var $author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess = F2(function (err, remoteData) {
    switch (remoteData.$) {
      case 0:
        return $krisajenkins$remotedata$RemoteData$Failure(err);

      case 1:
        return $krisajenkins$remotedata$RemoteData$Failure(err);

      case 2:
        return $krisajenkins$remotedata$RemoteData$Failure(err);

      default:
        var a = remoteData.a;
        return $krisajenkins$remotedata$RemoteData$Success(a);
    }
  });

  var $author$project$Types$BuildingBlock$setAsLoadingError = function (buildingBlock) {
    return _Utils_update(buildingBlock, {
      kw: function () {
        var _v0 = buildingBlock.kw;

        switch (_v0.$) {
          case 0:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$BasicMoney(A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, remoteData));

          case 1:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$BasicThing(A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, remoteData));

          case 2:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$DerivativeMoney(A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, remoteData));

          default:
            var remoteData = _v0.a;
            return $author$project$Types$BuildingBlock$DerivativeThing(A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, remoteData));
        }
      }()
    });
  };

  var $author$project$Types$Company$setAsBuildingBLocksDetailsLoadingError = function (company) {
    return _Utils_update(company, {
      pg: A2($krisajenkins$remotedata$RemoteData$map, $author$project$ElmFramework$Lib$AnyDictExtra$mapValues($author$project$Types$BuildingBlock$setAsLoadingError), company.pg)
    });
  };

  var $author$project$Types$Company$setAsLoadingError = function (company) {
    return _Utils_update(company, {
      pg: A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, company.pg),
      eO: A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, company.eO),
      q_: A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, company.q_),
      nT: A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, company.nT),
      db: A2($author$project$ElmFramework$Lib$RemoteDataExtra$setAsFailureIfNoSuccess, 0, company.db)
    });
  };

  var $author$project$Types$Company$setBaseScenario = F2(function (scenarioId, company) {
    return _Utils_update(company, {
      pa: $elm$core$Maybe$Just(scenarioId)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload = F2(function (block, val) {
    return _Utils_update(block, {
      fD: val
    });
  });
  var $author$project$Types$Company$setBudgetScenario = F2(function (scenarioId, company) {
    return _Utils_update(company, {
      pe: $elm$core$Maybe$Just(scenarioId)
    });
  });
  var $author$project$Types$Company$setBuildingBlocks = F2(function (blocks, company) {
    return _Utils_update(company, {
      pg: $krisajenkins$remotedata$RemoteData$Success(blocks)
    });
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue = F2(function (inputString, state) {
    return _Utils_update(state, {
      kR: inputString
    });
  });
  var $author$project$Types$Company$setDivisions = F2(function (divisions, company) {
    return _Utils_update(company, {
      eO: $krisajenkins$remotedata$RemoteData$Success(divisions)
    });
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditing = F2(function (maybeEditing, state) {
    return _Utils_update(state, {
      xi: maybeEditing
    });
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue = F2(function (inputString, state) {
    return _Utils_update(state, {
      k3: inputString
    });
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating = F2(function (isCreating, state) {
    return _Utils_update(state, {
      yK: isCreating
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$setMonthAdjustments = F2(function (editingSeasonality, monthAdjustments) {
    return _Utils_update(editingSeasonality, {
      dW: monthAdjustments
    });
  });
  var $author$project$Types$Division$setOverlayDivision = F2(function (accountingSystemDivision, division) {
    return _Utils_update(division, {
      ju: $elm$core$Maybe$Just(accountingSystemDivision)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPreset = F2(function (editingSeasonality, nestedSelectState) {
    return _Utils_update(editingSeasonality, {
      sH: nestedSelectState
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPresetNameInputString = F2(function (editingSeasonality, inputString) {
    return _Utils_update(editingSeasonality, {
      gu: inputString
    });
  });
  var $author$project$Types$CashboardQuery$setScenario = F2(function (val, query) {
    return _Utils_update(query, {
      Dw: val
    });
  });
  var $author$project$Util$CashboardQueryInRoute$setScenario = F2(function (route, scenarioId) {
    return A2($author$project$Util$CashboardQueryInRoute$mapCashboardQueryInRoute, $author$project$Types$CashboardQuery$setScenario(scenarioId), route);
  });
  var $author$project$Types$Company$setScenarios = F2(function (scenarios, company) {
    return _Utils_update(company, {
      db: $krisajenkins$remotedata$RemoteData$Success(scenarios)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setSeasonality = F2(function (editingBasicPayload, editingSeasonality) {
    return _Utils_update(editingBasicPayload, {
      bK: editingSeasonality
    });
  });
  var $author$project$Types$Company$setSeasonalityPresets = F2(function (seasonalityPresets, company) {
    return _Utils_update(company, {
      ti: $krisajenkins$remotedata$RemoteData$Success(seasonalityPresets)
    });
  });

  var $author$project$Api$Types$BuildingBlockWithDetails$toType = function (blockType) {
    switch (blockType.$) {
      case 0:
        var data = blockType.a;
        return $author$project$Types$BuildingBlock$BasicMoney($krisajenkins$remotedata$RemoteData$Success(data));

      case 1:
        var data = blockType.a;
        return $author$project$Types$BuildingBlock$BasicThing($krisajenkins$remotedata$RemoteData$Success(data));

      case 2:
        var data = blockType.a;
        return $author$project$Types$BuildingBlock$DerivativeMoney($krisajenkins$remotedata$RemoteData$Success(data));

      default:
        var data = blockType.a;
        return $author$project$Types$BuildingBlock$DerivativeThing($krisajenkins$remotedata$RemoteData$Success(data));
    }
  };

  var $author$project$Api$Types$BuildingBlockWithDetails$toBuildingBlock = function (buildingBlock) {
    return {
      kw: $author$project$Api$Types$BuildingBlockWithDetails$toType(buildingBlock.kw),
      iK: buildingBlock.iK,
      cC: buildingBlock.cC,
      F: buildingBlock.F,
      zL: buildingBlock.zL,
      bw: buildingBlock.bw,
      oB: buildingBlock.oB
    };
  };

  var $author$project$Types$BuildingBlock$toBuildingBlockDictFromList = function (list) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$BuildingBlock$unwrapBuildingBlockId, A2($elm$core$List$map, function (i) {
      return _Utils_Tuple2(i.F, i);
    }, list));
  };

  var $author$project$Api$Types$GetAllBuildingBlocksDetailsResult$toBlocksDict = function (_v0) {
    var blocks = _v0.vk;
    return $author$project$Types$BuildingBlock$toBuildingBlockDictFromList(A2($elm$core$List$map, $author$project$Api$Types$BuildingBlockWithDetails$toBuildingBlock, blocks));
  };

  var $author$project$Api$Types$GetBuildingBlockDetailsResult$toBuildingBlock = function (_v0) {
    var buildingBlock = _v0.pf;
    return $author$project$Api$Types$BuildingBlockWithDetails$toBuildingBlock(buildingBlock);
  };

  var $author$project$Route$Route$toCashboardRoute = function (route) {
    if (route.$ === 5) {
      var companyRoute = route.b;

      if (!companyRoute.$) {
        var cashboardRoute = companyRoute.b;
        return $elm$core$Maybe$Just(cashboardRoute);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Route$CashboardRoute$toCommentsRoute = function (subRoute) {
    if (subRoute.$ === 3) {
      var commentsRoute = subRoute.a;
      return $elm$core$Maybe$Just(commentsRoute);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Api$Types$GetCompanyDetailsResult$toCompany = function (_v0) {
    var company = _v0.j;
    return {
      bW: company.bW,
      pa: company.pa,
      pe: company.pe,
      pg: $krisajenkins$remotedata$RemoteData$Success(company.pg),
      iK: company.iK,
      eO: $krisajenkins$remotedata$RemoteData$Success(company.eO),
      F: company.F,
      b_: company.b_,
      q_: $krisajenkins$remotedata$RemoteData$Success(company.q_),
      zL: company.zL,
      b0: company.b0,
      b1: company.b1,
      b2: company.b2,
      nT: $krisajenkins$remotedata$RemoteData$Success(company.nT),
      db: $krisajenkins$remotedata$RemoteData$Success(company.db),
      ti: $krisajenkins$remotedata$RemoteData$Success(company.ti),
      aB: company.aB,
      t$: company.t$
    };
  };

  var $author$project$ElmFramework$Lib$Util$dropFirstThatSatisfies = F2(function (predicate, list) {
    if (!list.b) {
      return _List_Nil;
    } else {
      var a = list.a;
      var rest = list.b;
      return predicate(a) ? rest : A2($elm$core$List$cons, a, A2($author$project$ElmFramework$Lib$Util$dropFirstThatSatisfies, predicate, rest));
    }
  });

  var $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest = function (cfg) {
    var state = cfg.Ej;
    return _Utils_update(state, {
      gp: A2($author$project$ElmFramework$Lib$Util$dropFirstThatSatisfies, A2($elm$core$Basics$composeR, function ($) {
        return $.jE;
      }, $elm$core$Basics$eq(cfg.h3)), state.gp)
    });
  };

  var $author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState = F2(function (fromState, _v0) {
    var state = _v0.a;
    var cmd = _v0.b;
    var list = _v0.c;

    var _v1 = fromState(state);

    var newState = _v1.a;
    var newCmd = _v1.b;
    var newList = _v1.c;
    return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([newCmd, cmd])), _Utils_ap(list, newList));
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponse = F2(function (cfg, params) {
    var state = cfg.Ej;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);

    var handledTuple = function () {
      var _v0 = params.ez;

      if (!_v0.$) {
        var value = _v0.a;
        return A2(params.e$, value, newState);
      } else {
        var error = _v0.a;
        return A2(params.jn, error, newState);
      }
    }();

    return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, params.jm, handledTuple);
  });

  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString = function (record) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
      hs: $elm$json$Json$Encode$string(record.wJ),
      gi: record.gi
    });
  };

  var $author$project$ElmFramework$Lib$RemoteModel$handleHttpBadStatus = F4(function (cfg, meta, responseBody, remoteState) {
    var _v0 = cfg.qB;
    var string = _v0.a;
    var strings = _v0.b;
    return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString({
      wJ: responseBody,
      gi: 'Response error'
    }), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, string, strings)]));
  });
  var $author$project$ElmFramework$Lib$RemoteModel$handleGqlHttpError = F3(function (cfg, httpError, remoteState) {
    switch (httpError.$) {
      case 0:
        var string = httpError.a;
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.BadUrl: ' + string), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Bad URL', _List_fromArray([string]))]));

      case 1:
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.Timeout'), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Request timed out', _List_fromArray(['Try again maybe?']))]));

      case 2:
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.NetworkError'), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Network error', _List_fromArray(['Please check whether your network is on and functional']))]));

      case 3:
        var meta = httpError.a;
        var responseBody = httpError.b;
        return meta.tG === 401 ? _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString({
          wJ: responseBody,
          gi: 'Graphql.Http.BadStatus: Not Authenticated: 401'
        }), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Error: Not authenticated', _List_fromArray(['Please log in first'])), $author$project$ElmFramework$MsgCmd$msgCmd.Dn(cfg.kp)])) : A4($author$project$ElmFramework$Lib$RemoteModel$handleHttpBadStatus, cfg, meta, responseBody, remoteState);

      default:
        var jdErr = httpError.a;
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.BadPayload: ' + $elm$json$Json$Decode$errorToString(jdErr)), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Bad payload / Unexpected response', _List_fromArray([A2($elm$core$String$left, 200, $elm$json$Json$Decode$errorToString(jdErr))]))]));
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError = F3(function (cfg, error, remoteState) {
    var toastAndReportGraphqlError = function (gqlErr) {
      return _Utils_Tuple2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError(gqlErr.zu), A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, gqlErr.zu, _List_Nil));
    };

    if (!error.$) {
      var graphqlErrors = error.b;
      return function (errs) {
        return _Utils_Tuple3(remoteState, A3($elm$core$List$foldl, F2(function (_v1, acc) {
          var reportCmd = _v1.a;
          return $elm$core$Platform$Cmd$batch(_List_fromArray([reportCmd, acc]));
        }), $elm$core$Platform$Cmd$none, errs), A2($elm$core$List$map, $elm$core$Tuple$second, errs));
      }(A2($elm$core$List$map, toastAndReportGraphqlError, graphqlErrors));
    } else {
      var httpError = error.a;
      return A3($author$project$ElmFramework$Lib$RemoteModel$handleGqlHttpError, cfg, httpError, remoteState);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseSuccess = F2(function (cfg, params) {
    var state = cfg.Ej;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var _v0 = params.ez;

    if (!_v0.$) {
      var value = _v0.a;
      return A2(params.e$, value, newState);
    } else {
      var error = _v0.a;
      return A3($author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError, cfg, error, newState);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr = F2(function (cfg, params) {
    var state = cfg.Ej;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);

    var handledTuple = function () {
      var _v0 = params.ez;

      if (!_v0.$) {
        if (!_v0.a.$) {
          var value = _v0.a.a;
          return A2(params.e$, value, newState);
        } else {
          var err = _v0.a.a;
          return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil)]));
        }
      } else {
        var error = _v0.a;
        return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, A2($author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError, cfg, error), A2(params.jn, error, newState));
      }
    }();

    return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, params.jm, handledTuple);
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr_success = F2(function (cfg, params) {
    var state = cfg.Ej;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var _v0 = params.ez;

    if (!_v0.$) {
      if (!_v0.a.$) {
        var value = _v0.a.a;
        return A2(params.e$, value, newState);
      } else {
        var err = _v0.a.a;
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil)]));
      }
    } else {
      var error = _v0.a;
      return A3($author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError, cfg, error, newState);
    }
  });

  var $author$project$ElmFramework$Lib$RemoteModel$toResponseHandlers = function (cfg) {
    return {
      C0: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponse(cfg),
      C1: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseSuccess(cfg),
      C2: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr(cfg),
      C3: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr_success(cfg)
    };
  };

  var $author$project$Global$Model$EditMasterBlock = F4(function (a, b, c, d) {
    return {
      $: 2,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $elm_community$list_extra$List$Extra$remove = F2(function (x, xs) {
    if (!xs.b) {
      return _List_Nil;
    } else {
      var y = xs.a;
      var ys = xs.b;
      return _Utils_eq(x, y) ? ys : A2($elm$core$List$cons, y, A2($elm_community$list_extra$List$Extra$remove, x, ys));
    }
  });
  var $author$project$TopMsg$toSaveQuickEditForMultipleScenariosMsg = F4(function (company, scenarioId, block, scenariosWithOriginalBlock) {
    var unselected = A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Scenario$unwrapScenarioId, A2($elm_community$list_extra$List$Extra$remove, scenarioId, scenariosWithOriginalBlock));
    return function (msg) {
      return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([msg, $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$SetEditMasterblockScenarios(unselected))]));
    }($author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A4($author$project$Global$Model$EditMasterBlock, company, block.F, $elm$core$Maybe$Just(scenarioId), scenariosWithOriginalBlock))));
  });
  var $author$project$Types$Company$updateAllocationClass = F2(function (allocationClass, company) {
    return _Utils_update(company, {
      eO: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v0, division) {
        return _Utils_update(division, {
          oX: A3($turboMaCk$any_dict$Dict$Any$update, allocationClass.F, $elm$core$Basics$always($elm$core$Maybe$Just(allocationClass)), division.oX)
        });
      })), company.eO)
    });
  });
  var $author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData = F2(function (_new, old) {
    var _v0 = _Utils_Tuple2(_new, old);

    if (_v0.a.$ === 3) {
      var a = _v0.a.a;
      return $krisajenkins$remotedata$RemoteData$Success(a);
    } else {
      if (_v0.b.$ === 3) {
        var b = _v0.b.a;
        return $krisajenkins$remotedata$RemoteData$Success(b);
      } else {
        return _new;
      }
    }
  });
  var $author$project$Types$BuildingBlock$updateBuildingBlock = F2(function (_new, old) {
    return _Utils_update(_new, {
      kw: function () {
        var _v0 = _Utils_Tuple2(_new.kw, old.kw);

        _v0$4: while (true) {
          switch (_v0.a.$) {
            case 0:
              if (!_v0.b.$) {
                var newRemote = _v0.a.a;
                var oldRemote = _v0.b.a;
                return $author$project$Types$BuildingBlock$BasicMoney(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, newRemote, oldRemote));
              } else {
                break _v0$4;
              }

            case 1:
              if (_v0.b.$ === 1) {
                var newRemote = _v0.a.a;
                var oldRemote = _v0.b.a;
                return $author$project$Types$BuildingBlock$BasicThing(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, newRemote, oldRemote));
              } else {
                break _v0$4;
              }

            case 2:
              if (_v0.b.$ === 2) {
                var newRemote = _v0.a.a;
                var oldRemote = _v0.b.a;
                return $author$project$Types$BuildingBlock$DerivativeMoney(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, newRemote, oldRemote));
              } else {
                break _v0$4;
              }

            default:
              if (_v0.b.$ === 3) {
                var newRemote = _v0.a.a;
                var oldRemote = _v0.b.a;
                return $author$project$Types$BuildingBlock$DerivativeThing(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, newRemote, oldRemote));
              } else {
                break _v0$4;
              }

          }
        }

        return _new.kw;
      }()
    });
  });
  var $author$project$Types$Company$updateComment = F2(function (comment, company) {
    return _Utils_update(company, {
      db: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v0, scenario) {
        return _Utils_update(scenario, {
          bH: A3($turboMaCk$any_dict$Dict$Any$update, comment.F, $elm$core$Basics$always($elm$core$Maybe$Just(comment)), scenario.bH)
        });
      })), company.db)
    });
  });
  var $author$project$Types$BuildingBlock$emptyBuildingBlockDict = $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$BuildingBlock$unwrapBuildingBlockId);
  var $turboMaCk$any_dict$Dict$Any$merge = F5(function (f, g, h, _v0, _v1) {
    var inner = _v0;
    var dict = _v1.bT;
    var l = F3(function (fc, _v5, _v6) {
      var k = _v6.a;
      var v = _v6.b;
      return A2(fc, k, v);
    });
    return A5($elm$core$Dict$merge, l(f), F3(function (_v2, _v3, _v4) {
      var k = _v3.a;
      var a = _v3.b;
      var b = _v4.b;
      return A3(g, k, a, b);
    }), l(h), inner.bT, dict);
  });
  var $author$project$ElmFramework$Lib$RemoteDataExtra$toSuccessful = F2(function (remoteDataNew, remoteDataOld) {
    var _v0 = _Utils_Tuple2($krisajenkins$remotedata$RemoteData$isSuccess(remoteDataNew), $krisajenkins$remotedata$RemoteData$isSuccess(remoteDataOld));

    if (!_v0.a && _v0.b) {
      return remoteDataOld;
    } else {
      return remoteDataNew;
    }
  });
  var $author$project$Types$BuildingBlock$mergeBlocks = F2(function (_new, old) {
    var blockType = function () {
      var _v0 = _Utils_Tuple2(_new.kw, old.kw);

      switch (_v0.a.$) {
        case 0:
          if (!_v0.b.$) {
            var remoteNew = _v0.a.a;
            var remoteOld = _v0.b.a;
            return $author$project$Types$BuildingBlock$BasicMoney(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toSuccessful, remoteNew, remoteOld));
          } else {
            return _new.kw;
          }

        case 1:
          if (_v0.b.$ === 1) {
            var remoteNew = _v0.a.a;
            var remoteOld = _v0.b.a;
            return $author$project$Types$BuildingBlock$BasicThing(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toSuccessful, remoteNew, remoteOld));
          } else {
            return _new.kw;
          }

        case 2:
          if (_v0.b.$ === 2) {
            var remoteNew = _v0.a.a;
            var remoteOld = _v0.b.a;
            return $author$project$Types$BuildingBlock$DerivativeMoney(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toSuccessful, remoteNew, remoteOld));
          } else {
            return _new.kw;
          }

        default:
          if (_v0.b.$ === 3) {
            var remoteNew = _v0.a.a;
            var remoteOld = _v0.b.a;
            return $author$project$Types$BuildingBlock$DerivativeThing(A2($author$project$ElmFramework$Lib$RemoteDataExtra$toSuccessful, remoteNew, remoteOld));
          } else {
            return _new.kw;
          }

      }
    }();

    return _Utils_update(_new, {
      kw: blockType
    });
  });
  var $author$project$Types$BuildingBlock$mergeBlocksDicts = F2(function (newDict, oldDict) {
    var onlyRight = F3(function (id, block, dict) {
      return dict;
    });
    var onlyLeft = F3(function (id, block, dict) {
      return A3($turboMaCk$any_dict$Dict$Any$insert, id, block, dict);
    });
    var both = F4(function (id, _new, old, dict) {
      return A3($turboMaCk$any_dict$Dict$Any$insert, id, A2($author$project$Types$BuildingBlock$mergeBlocks, _new, old), dict);
    });
    return A6($turboMaCk$any_dict$Dict$Any$merge, onlyLeft, both, onlyRight, newDict, oldDict, $author$project$Types$BuildingBlock$emptyBuildingBlockDict);
  });
  var $author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteDataWith = F3(function (merger, _new, old) {
    var _v0 = _Utils_Tuple2(_new, old);

    if (_v0.b.$ === 3) {
      if (_v0.a.$ === 3) {
        var a = _v0.a.a;
        var aOld = _v0.b.a;
        return $krisajenkins$remotedata$RemoteData$Success(A2(merger, a, aOld));
      } else {
        var b = _v0.b.a;
        return $krisajenkins$remotedata$RemoteData$Success(b);
      }
    } else {
      return _new;
    }
  });
  var $author$project$Types$Company$updateCompany = F2(function (_new, old) {
    return {
      bW: _new.bW,
      pa: _new.pa,
      pe: _new.pe,
      pg: A3($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteDataWith, $author$project$Types$BuildingBlock$mergeBlocksDicts, _new.pg, old.pg),
      iK: _new.iK,
      eO: A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, _new.eO, old.eO),
      F: _new.F,
      b_: _new.b_,
      q_: A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, _new.q_, old.q_),
      zL: _new.zL,
      b0: _new.b0,
      b1: _new.b1,
      b2: _new.b2,
      nT: A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, _new.nT, old.nT),
      db: A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, _new.db, old.db),
      ti: A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, _new.ti, old.ti),
      aB: _new.aB,
      t$: _new.t$
    };
  });
  var $author$project$Types$Company$updateReview = F2(function (review, company) {
    return _Utils_update(company, {
      db: A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v0, scenario) {
        return _Utils_update(scenario, {
          c9: A3($turboMaCk$any_dict$Dict$Any$update, review.F, $elm$core$Basics$always($elm$core$Maybe$Just(review)), scenario.c9)
        });
      })), company.db)
    });
  });
  var $author$project$Types$UserSession$setUserCompanyRelationships = F2(function (_v0, session) {
    var users = _v0.Ft;
    var userCompanies = _v0.ue;
    return _Utils_update(session, {
      ue: A2($author$project$ElmFramework$Lib$PivotDict$union, userCompanies, session.ue),
      Ft: A2($turboMaCk$any_dict$Dict$Any$union, users, session.Ft)
    });
  });

  var $author$project$Types$UserCompany$fromList = function (userCompanies) {
    return $author$project$ElmFramework$Lib$PivotDict$fromList({
      aA: userCompanies,
      d8: $author$project$Types$User$unwrapUserId,
      eB: $author$project$Types$Company$unwrapCompanyId,
      eE: function ($) {
        return $.oD;
      },
      eF: function ($) {
        return $.b9;
      }
    });
  };

  var $author$project$Types$User$toUserDictFromList = function (users) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$User$unwrapUserId, A2($elm$core$List$map, function (u) {
      return _Utils_Tuple2(u.F, u);
    }, users));
  };

  var $author$project$Api$Types$GetCompanyDetailsResult$toUsersAndRelationships = function (_v0) {
    var company = _v0.j;

    var toUserCompany = function (uc) {
      return {
        b9: uc.b9,
        gz: uc.gz,
        oD: uc.Fl.F
      };
    };

    return {
      ue: $author$project$Types$UserCompany$fromList(A2($elm$core$List$map, toUserCompany, company.ue)),
      Ft: $author$project$Types$User$toUserDictFromList(A2($elm$core$List$map, function ($) {
        return $.Fl;
      }, company.ue))
    };
  };

  var $author$project$Types$UserSession$updateSession = F3(function (companyId, companyWithDetails, session) {
    return A2($author$project$Types$UserSession$setUserCompanyRelationships, $author$project$Api$Types$GetCompanyDetailsResult$toUsersAndRelationships(companyWithDetails), A3($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateCompany($author$project$Api$Types$GetCompanyDetailsResult$toCompany(companyWithDetails)), companyId, session));
  });
  var $author$project$Types$Division$merge = F2(function (_new, old) {
    return _new;
  });
  var $author$project$Types$Company$upsertDivision = F2(function (division, company) {
    var updater = function (maybeOldDivision) {
      if (!maybeOldDivision.$) {
        var oldDivision = maybeOldDivision.a;
        return $elm$core$Maybe$Just(A2($author$project$Types$Division$merge, division, oldDivision));
      } else {
        return $elm$core$Maybe$Just(division);
      }
    };

    return _Utils_update(company, {
      eO: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$update, division.F, updater), company.eO)
    });
  });
  var $author$project$Types$FinancialAccount$merge = F2(function (_new, old) {
    return _Utils_update(_new, {
      fy: A2($author$project$ElmFramework$Lib$RemoteDataExtra$toNewerRemoteData, _new.fy, old.fy)
    });
  });
  var $author$project$Types$Division$upsertFinancialAccount = F2(function (financialAccount, division) {
    var updater = function (maybeOldFinancialAccount) {
      if (!maybeOldFinancialAccount.$) {
        var oldAccount = maybeOldFinancialAccount.a;
        return $elm$core$Maybe$Just(A2($author$project$Types$FinancialAccount$merge, financialAccount, oldAccount));
      } else {
        return $elm$core$Maybe$Just(financialAccount);
      }
    };

    return _Utils_update(division, {
      qp: A3($turboMaCk$any_dict$Dict$Any$update, financialAccount.F, updater, division.qp)
    });
  });
  var $author$project$Types$Company$upsertSeasonalityPreset = F2(function (seasonality, company) {
    return _Utils_update(company, {
      ti: A2($krisajenkins$remotedata$RemoteData$map, A2($turboMaCk$any_dict$Dict$Any$insert, seasonality.F, seasonality), company.ti)
    });
  });
  var $author$project$Remote$UpdateResponse$updateResponse = F4(function (topState, requestMsg, responseMsg, oldState) {
    var handle = $author$project$ElmFramework$Lib$RemoteModel$toResponseHandlers({
      kp: $author$project$Route$Route$authEntryRoute,
      qB: A2($author$project$ElmFramework$Lib$RemoteModel$GeneralErrHandler_DefaultToast, 'Unexpected response', _List_fromArray(['Try again, maybe?'])),
      h3: requestMsg,
      Ej: oldState
    });

    switch (responseMsg.$) {
      case 0:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v1, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setAsLoadingError, companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 1:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v2, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapBuildingBlock, $author$project$Types$BuildingBlock$updateBuildingBlock($author$project$Api$Types$GetBuildingBlockDetailsResult$toBuildingBlock(r)), r.pf.F), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 2:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v3, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setAsBuildingBLocksDetailsLoadingError, companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setBuildingBlocks($author$project$Api$Types$GetAllBuildingBlocksDetailsResult$toBlocksDict(r)), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 3:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v4, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setAsLoadingError, companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setScenarios($author$project$Types$Scenario$createScenarioDict(r)), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 4:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v5, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setAsLoadingError, companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            var divisionsNew = $author$project$Types$Division$createDivisionDict(r);
            var setNewDivisionsMsg = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSettings, $author$project$Ui$Settings$Msg$SetNewDivisions), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$diff(divisionsNew), A2($elm$core$Maybe$andThen, $krisajenkins$remotedata$RemoteData$toMaybe, A2($elm$core$Maybe$map, function ($) {
              return $.eO;
            }, A2($elm$core$Maybe$andThen, $author$project$Types$UserSession$toCompany(companyId), $author$project$Remote$Model$toSession(topState.o_.CT)))))))));
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setDivisions(divisionsNew), companyId), state), $elm$core$Platform$Cmd$none, _Utils_ap(setNewDivisionsMsg, _List_fromArray([$author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$HandleNewDivisions(companyId))])));
          }),
          ez: gqlResult
        });

      case 5:
        var gqlResult = responseMsg.a;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v6, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              tb: $krisajenkins$remotedata$RemoteData$Failure(0)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              tb: $krisajenkins$remotedata$RemoteData$succeed(r)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 6:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v7, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setAsLoadingError, companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setSeasonalityPresets($author$project$Types$SeasonalityPreset$createSeasonalityPresetDict(r)), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 7:
        var gqlResult = responseMsg.a;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v8, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              qP: $krisajenkins$remotedata$RemoteData$Failure(0)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (r, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              qP: $krisajenkins$remotedata$RemoteData$succeed(r)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 8:
        var gqlResult = responseMsg.a;
        return handle.C3({
          e$: F2(function (r, state) {
            var _v9 = $author$project$Remote$Model$toAuth(state);

            if (!_v9.$) {
              var auth = _v9.a;
              return _Utils_Tuple3(_Utils_update(state, {
                EL: $author$project$Remote$Model$Onboarded(A2($author$project$Types$UserSession$toSessionFromUserWithCompanies, auth, r))
              }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$ClickedNext(0))]));
            } else {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
            }
          }),
          ez: gqlResult
        });

      case 9:
        var gqlResult = responseMsg.a;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v10, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: $author$project$Remote$UpdateResponse$handleOnboarding,
          ez: gqlResult
        });

      case 10:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (comp, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateCompany(comp), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'Changes saved successfully!', _List_Nil), $author$project$TopMsg$msgOnboardingCompany($author$project$Ui$OnboardingCompany$Msg$ClickedNext(0))]));
          }),
          ez: gqlResult
        });

      case 11:
        var gqlResult = responseMsg.a;
        return handle.C3({
          e$: $author$project$Remote$UpdateResponse$handleRedeemInvite,
          ez: gqlResult
        });

      case 12:
        var gqlResult = responseMsg.a;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v11, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (usr, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, $author$project$Types$UserSession$mapSelf($elm$core$Basics$always(usr)), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'Changes Saved Successfully!', _List_Nil)]));
          }),
          ez: gqlResult
        });

      case 14:
        var gqlResult = responseMsg.a;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v12, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (usr, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, $author$project$Types$UserSession$mapSelf($elm$core$Basics$always(usr)), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 13:
        var gqlResult = responseMsg.a;
        return handle.C3({
          e$: F2(function (_v13, _v14) {
            return _Utils_Tuple3($author$project$Remote$Model$initClean, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$Unauthenticate)]));
          }),
          ez: gqlResult
        });

      case 16:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (_v15, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, $author$project$Types$UserSession$removeCompany(companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 15:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (comp, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateCompany(comp), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'Changes saved successfully!', _List_Nil)]));
          }),
          ez: gqlResult
        });

      case 17:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (inv, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addInvitation(inv), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgEditingUsers($author$project$Ui$EditingUsers$Msg$ClearForm)]));
          }),
          ez: gqlResult
        });

      case 18:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (inv, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addInvitation(inv), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'The invitation was updated successfully!', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 19:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (inv, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addInvitation(inv), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'The invitation was resent successfully!', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 20:
        var companyId = responseMsg.a;
        var invitationId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v16, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapInvitation, $author$project$Types$Invitation$revokeInvitation, invitationId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'The invitation was revoked successfully!', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 21:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (inv, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addInvitation(inv), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'Invitation was resent successfully!', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 22:
        var companyId = responseMsg.a;
        var userId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v17, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$removeUserCompany, userId, companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'The user was removed successfully!', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 23:
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, $author$project$Types$UserSession$insertUserCompany(r), state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess, $elm$core$Maybe$Nothing, 'The user role was updated successfully!', _List_Nil), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 24:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 25:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (division, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$upsertDivision(division), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), $author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$HandleNewDivisions(companyId))]));
          }),
          ez: gqlResult
        });

      case 26:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 27:
        var companyId = responseMsg.a;
        var maybeDivisionId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            var msg = A2($elm$core$Maybe$withDefault, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]), A2($elm$core$Maybe$map, $elm$core$List$singleton, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, $author$project$Remote$RequestMsg$DeleteDivision(companyId)), maybeDivisionId)));
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, msg);
          }),
          ez: gqlResult
        });

      case 28:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 29:
        var maybeOnCreate = responseMsg.a;
        var companyId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, function () {
              if (!maybeOnCreate.$) {
                var onCreate = maybeOnCreate.a;

                if (!onCreate) {
                  var _v20 = _Utils_Tuple3(topState.o_.vh.bv, topState.o_.vh.bv.cU, topState.o_.vh.bv.cU.kf);

                  var editingBlock = _v20.a;
                  var moneyPayload = _v20.b;
                  var allocationClass = _v20.c;
                  return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$BlockMsg($author$project$Ui$Block$Msg$SetEditingBlock(_Utils_update(editingBlock, {
                    cU: _Utils_update(moneyPayload, {
                      kf: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating, false, allocationClass))
                    })
                  }))))]);
                } else {
                  var _v21 = _Utils_Tuple3(topState.o_.vh.bv, topState.o_.vh.bv.cU, topState.o_.vh.bv.cU.iZ);

                  var editingBlock = _v21.a;
                  var moneyPayload = _v21.b;
                  var internalOppositeAllocationClass = _v21.c;
                  return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$BlockMsg($author$project$Ui$Block$Msg$SetEditingBlock(_Utils_update(editingBlock, {
                    cU: _Utils_update(moneyPayload, {
                      iZ: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating, false, internalOppositeAllocationClass))
                    })
                  }))))]);
                }
              } else {
                return _List_Nil;
              }
            }());
          }),
          ez: gqlResult
        });

      case 30:
        var maybeOnUpdate = responseMsg.a;
        var companyId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (allocationClass, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateAllocationClass(allocationClass), companyId), state), $elm$core$Platform$Cmd$none, function () {
              if (!maybeOnUpdate.$) {
                var onUpdate = maybeOnUpdate.a;

                if (!onUpdate) {
                  var _v24 = _Utils_Tuple3(topState.o_.vh.bv, topState.o_.vh.bv.cU, topState.o_.vh.bv.cU.kf);

                  var editingBlock = _v24.a;
                  var moneyPayload = _v24.b;
                  var allocationClassState = _v24.c;
                  return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$BlockMsg($author$project$Ui$Block$Msg$SetEditingBlock(_Utils_update(editingBlock, {
                    cU: _Utils_update(moneyPayload, {
                      kf: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditing, $elm$core$Maybe$Nothing, allocationClassState))
                    })
                  }))))]);
                } else {
                  var _v25 = _Utils_Tuple3(topState.o_.vh.bv, topState.o_.vh.bv.cU, topState.o_.vh.bv.cU.iZ);

                  var editingBlock = _v25.a;
                  var moneyPayload = _v25.b;
                  var internalOppositeAllocationClass = _v25.c;
                  return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$BlockMsg($author$project$Ui$Block$Msg$SetEditingBlock(_Utils_update(editingBlock, {
                    cU: _Utils_update(moneyPayload, {
                      iZ: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating, false, internalOppositeAllocationClass))
                    })
                  }))))]);
                }
              } else {
                return _List_Nil;
              }
            }());
          }),
          ez: gqlResult
        });

      case 31:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 32:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v26, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (f, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, $author$project$Types$Division$upsertFinancialAccount(f), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgAccounts($author$project$Ui$Accounts$Msg$OnAddAccountMsg($author$project$Ui$Accounts$Add$Msg$Canceled))]));
          }),
          ez: gqlResult
        });

      case 33:
        var routeBack = responseMsg.a;
        var companyId = responseMsg.b;
        var divisionId = responseMsg.c;
        var gqlResult = responseMsg.d;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v27, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (f, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($elm$core$Basics$composeR, $author$project$Types$Company$removeFinancialAccount(f.F), A2($author$project$Types$Company$mapDivision, $author$project$Types$Division$upsertFinancialAccount(f), divisionId)), companyId), state), $elm$core$Platform$Cmd$none, A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([$author$project$TopMsg$msgAccounts($author$project$Ui$Accounts$Msg$OnEditAccountMsg($author$project$Ui$Accounts$Edit$Msg$Canceled))]), _List_Nil, routeBack));
          }),
          ez: gqlResult
        });

      case 34:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var financialAccountId = responseMsg.c;
        var gqlResult = responseMsg.d;
        return handle.C3({
          e$: F2(function (_v28, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, $author$project$Types$Division$removeFinancialAccount(financialAccountId), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));
          }),
          ez: gqlResult
        });

      case 35:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var financialAccountId = responseMsg.c;
        var date = responseMsg.d;
        var amount = responseMsg.e;
        var gqlResult = responseMsg.f;
        return handle.C3({
          e$: F2(function (_v29, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, A2($author$project$Types$Division$mapFinancialAccount, A2($author$project$Types$FinancialAccount$mapBalance, date, $author$project$Types$Balance$overrideBalance(amount)), financialAccountId), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 36:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var financialAccountId = responseMsg.c;
        var date = responseMsg.d;
        var gqlResult = responseMsg.e;
        return handle.C3({
          e$: F2(function (_v30, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, A2($author$project$Types$Division$mapFinancialAccount, A2($author$project$Types$FinancialAccount$mapBalance, date, $author$project$Types$Balance$resetBalance), financialAccountId), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 37:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var financialAccountId = responseMsg.c;
        var gqlResult = responseMsg.d;
        return handle.C3({
          e$: F2(function (r, state) {
            var balances = A4($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$fromList, function (b) {
              return b.o$;
            }, $author$project$Types$SimpleDate$toDateString, $elm$core$Maybe$Nothing, r.fy);

            var updateBalances = function (financialAcc) {
              return _Utils_update(financialAcc, {
                fy: $krisajenkins$remotedata$RemoteData$succeed(balances)
              });
            };

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, A2($author$project$Types$Division$mapFinancialAccount, updateBalances, financialAccountId), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 38:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, $author$project$Types$Division$setOverlayDivision(r.oQ), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 39:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v31, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, $author$project$Types$Division$removeOverlayDivision, divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 40:
        var companyId = responseMsg.a;
        var divisionId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapDivision, $author$project$Types$Division$setOverlayDivision(r.oQ), divisionId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 41:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (_v32, state) {
            var scenarioId = _v32.a;
            var companyWithDetails = _v32.b;
            var setAsBase = _Utils_eq(companyWithDetails.j.pa, $elm$core$Maybe$Nothing) ? _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SetAsBaseScenario, companyId, scenarioId))]) : _List_Nil;

            var ensureBaseScenario = function (_v33) {
              var company = _v33.j;
              return _Utils_eq(company.pa, $elm$core$Maybe$Nothing) ? {
                j: _Utils_update(company, {
                  pa: $elm$core$Maybe$Just(scenarioId)
                })
              } : {
                j: company
              };
            };

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, ensureBaseScenario(companyWithDetails)), state), $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ScenarioMsg($author$project$Ui$Scenario$Msg$ClearInputs)), $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$fromCompany, scenarioId, $author$project$Api$Types$GetCompanyDetailsResult$toCompany(companyWithDetails)), $author$project$Route$CashboardRoute$CashboardHome)))]), setAsBase));
          }),
          ez: gqlResult
        });

      case 42:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dj(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ScenarioMsg($author$project$Ui$Scenario$Msg$ClearInputs))]));
          }),
          ez: gqlResult
        });

      case 43:
        var callback = responseMsg.a;
        var companyId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C2({
          jm: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          jn: F2(function (_v34, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          e$: F2(function (_v35, state) {
            var scenarioId = _v35.a;
            var companyWithDetails = _v35.b;
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgScenarios(A2(callback, companyId, scenarioId)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 44:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v36, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$removeScenario(scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 47:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v37, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setBaseScenario(scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 48:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v38, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$setBudgetScenario(scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 49:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addScenarioBlock(r), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 50:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var blockId = responseMsg.c;
        var gqlResult = responseMsg.d;
        return handle.C3({
          e$: F2(function (_v39, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$removeScenarioBlock, scenarioId, blockId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 51:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (relationships, state) {
            var addScenarioBlockRelationships = function (company) {
              return A3($elm$core$List$foldl, $author$project$Types$Company$addScenarioBlock, company, relationships);
            };

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, addScenarioBlockRelationships, companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 52:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 53:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var blockId = responseMsg.c;
        var gqlResult = responseMsg.d;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            var editMasterBlockMessages = function () {
              var isEditMasterBlockResponse = function () {
                var _v43 = topState.o_.qC.gZ;

                if (!_v43.$ && _v43.a.$ === 2) {
                  var _v44 = _v43.a;
                  var overlayBlockId = _v44.b;
                  return _Utils_eq(overlayBlockId, blockId);
                } else {
                  return false;
                }
              }();

              if (!isEditMasterBlockResponse) {
                return _List_Nil;
              } else {
                var setNewState = function (newState) {
                  return $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetEditingMasterBlocks(newState));
                };

                var company = $author$project$Api$Types$GetCompanyDetailsResult$toCompany(companyWithDetails);
                var msg = F2(function (block, scenarioIds) {
                  return A4($author$project$TopMsg$toSaveQuickEditForMultipleScenariosMsg, company, scenarioId, block, scenarioIds);
                });
                var _v40 = topState.o_.vO.xl;

                if (!_v40.b) {
                  return _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$SetEditMasterblockScenarios($turboMaCk$any_set$Set$Any$empty($author$project$Types$Scenario$unwrapScenarioId)))]);
                } else {
                  if (!_v40.b.b) {
                    var _v41 = _v40.a;
                    var block = _v41.a;
                    var scenarioIds = _v41.b;
                    return _List_fromArray([setNewState(_List_Nil), A2(msg, block, scenarioIds)]);
                  } else {
                    var _v42 = _v40.a;
                    var block = _v42.a;
                    var scenarioIds = _v42.b;
                    var remaining = _v40.b;
                    return _List_fromArray([setNewState(remaining), A2(msg, block, scenarioIds)]);
                  }
                }
              }
            }();

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Nothing)), editMasterBlockMessages));
          }),
          ez: gqlResult
        });

      case 54:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 55:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 56:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (_v45, state) {
            var scenarioId = _v45.a;
            var companyWithDetails = _v45.b;
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Nothing)), A2($author$project$Util$CashboardQueryInRoute$setScenario, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc), scenarioId)]));
          }),
          ez: gqlResult
        });

      case 57:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (_v46, state) {
            var scenarioId = _v46.a;
            var comment = _v46.b;

            var msg = function () {
              var isCommentRepliesRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$CommentsRoute$isCommentRepliesRoute, A2($elm$core$Maybe$andThen, $author$project$Route$CashboardRoute$toCommentsRoute, $author$project$Route$Route$toCashboardRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)))));
              return isCommentRepliesRoute ? $author$project$TopMsg$msgGlobal($author$project$Global$Msg$NoOp) : $author$project$ElmFramework$MsgCmd$msgCmd.Df;
            }();

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapScenario, $author$project$Types$Scenario$addComment(comment), scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$Reset)), msg]));
          }),
          ez: gqlResult
        });

      case 58:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (comment, state) {
            var messages = function () {
              var isEditCommentRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$CommentsRoute$isEditCommentRoute, A2($elm$core$Maybe$andThen, $author$project$Route$CashboardRoute$toCommentsRoute, $author$project$Route$Route$toCashboardRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)))));
              return isEditCommentRoute ? _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]) : _List_Nil;
            }();

            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateComment(comment), companyId), state), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$Reset)), messages));
          }),
          ez: gqlResult
        });

      case 59:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (commentId, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$removeComment(commentId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));
          }),
          ez: gqlResult
        });

      case 60:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (_v47, state) {
            var scenarioId = _v47.a;
            var reviewId = _v47.b;
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapScenario, $author$project$Types$Scenario$addReview(reviewId), scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetNewReviewName('')), $author$project$ElmFramework$MsgCmd$msgCmd.Df]));
          }),
          ez: gqlResult
        });

      case 61:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (review, state) {
            var toCashboardRoute = F2(function (route, query) {
              return A3($elm$core$Basics$composeL, $author$project$Route$Route$SelectedCompany(companyId), $author$project$Route$CompanyRoute$Cashboard(query), route);
            });
            var msg = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, A2($elm$core$Maybe$map, $author$project$ElmFramework$MsgCmd$msgCmd.Do, A2($elm$core$Maybe$map, toCashboardRoute($author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$ChooseReview))), $author$project$Route$RouteUtil$toCashboardQuery($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc))))));
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateReview(review), companyId), state), $elm$core$Platform$Cmd$none, msg);
          }),
          ez: gqlResult
        });

      case 62:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (review, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$updateReview(review), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 63:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (reviewId, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$removeReview(reviewId), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Df]));
          }),
          ez: gqlResult
        });

      case 64:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addBlock($author$project$Api$Types$BuildingBlockWithDetails$toBuildingBlock(r)), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksBasic(false))))]));
          }),
          ez: gqlResult
        });

      case 65:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (r, state) {
            var msg = function () {
              var _v49 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

              if (_v49.$ === 5) {
                var companyRoute = _v49.b;

                switch (companyRoute.$) {
                  case 3:
                    return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksBasic(false)))), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$SetEditMasterblockScenarios($turboMaCk$any_set$Set$Any$empty($author$project$Types$Scenario$unwrapScenarioId)))]);

                  case 0:
                    return _List_fromArray([$author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Nothing)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$SetEditingBlock($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$empty))]);

                  default:
                    return _List_Nil;
                }
              } else {
                return _List_Nil;
              }
            }();

            if (!r.$) {
              var blockWithDetails = r.a;
              return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$addBlock($author$project$Api$Types$BuildingBlockWithDetails$toBuildingBlock(blockWithDetails)), companyId), state), $elm$core$Platform$Cmd$none, msg);
            } else {
              var companyWithDetails = r.a;
              return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, msg);
            }
          }),
          ez: gqlResult
        });

      case 66:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (companyWithDetails, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$updateSession, companyId, companyWithDetails), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });

      case 67:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $elm$core$Basics$always(r), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 46:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v51, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapScenario, function (scenario) {
              return _Utils_update(scenario, {
                yC: false
              });
            }, scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 45:
        var companyId = responseMsg.a;
        var scenarioId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (_v52, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, A2($author$project$Types$Company$mapScenario, function (scenario) {
              return _Utils_update(scenario, {
                yC: true
              });
            }, scenarioId), companyId), state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ez: gqlResult
        });

      case 68:
        var maybeOnCreate = responseMsg.a;
        var companyId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (r, state) {
            var setSliderInputValues = function (editingSeasonality) {
              return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Types$EditingBuildingBlock$EditingSeasonality$setMonthAdjustments(editingSeasonality), function ($) {
                return $.dW;
              }), $author$project$Types$EditingBuildingBlock$EditingSeasonality$fromSeasonalityPreset);
            };

            var setSelectedSeasonalityPreset = function (editingSeasonality) {
              return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPreset(editingSeasonality), A2($author$project$ElmFramework$Lib$Util$flip, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, editingSeasonality.sH)), $elm$core$Maybe$map(function ($) {
                return $.F;
              }));
            };

            var setPresetNameInputString = function (editingSeasonality) {
              return $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPresetNameInputString(editingSeasonality);
            };

            var setEditingSeasonality = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$SetEditingBlock), $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(topState.o_.vh.bv)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setSeasonality(topState.o_.vh.bv.fD));
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$upsertSeasonalityPreset(r), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), setEditingSeasonality(A3($author$project$ElmFramework$Lib$Util$flip, setPresetNameInputString, '', function () {
              if (!maybeOnCreate.$) {
                var onCreate = maybeOnCreate.a;
                return A3($author$project$ElmFramework$Lib$Util$flip, setSelectedSeasonalityPreset, $elm$core$Maybe$Just(r), A3($author$project$ElmFramework$Lib$Util$flip, setSliderInputValues, r, topState.o_.vh.bv.fD.bK));
              } else {
                return topState.o_.vh.bv.fD.bK;
              }
            }()))]));
          }),
          ez: gqlResult
        });

      case 69:
        var maybeOnUpdate = responseMsg.a;
        var companyId = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$upsertSeasonalityPreset(r), companyId), state), $elm$core$Platform$Cmd$none, function () {
              if (!maybeOnUpdate.$) {
                var onUpdate = maybeOnUpdate.a;

                if (!onUpdate) {
                  return _List_fromArray([$author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$SetEditingBlock(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload, topState.o_.vh.bv, A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$setSeasonality, topState.o_.vh.bv.fD, A2($author$project$Types$EditingBuildingBlock$EditingSeasonality$setPreset, topState.o_.vh.bv.fD.bK, A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditing, $elm$core$Maybe$Nothing, topState.o_.vh.bv.fD.bK.sH)))))))]);
                } else {
                  return _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]);
                }
              } else {
                return _List_Nil;
              }
            }());
          }),
          ez: gqlResult
        });

      default:
        var companyId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.C3({
          e$: F2(function (r, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, A2($author$project$Types$UserSession$mapCompany, $author$project$Types$Company$removeSeasonalityPreset(r), companyId), state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ez: gqlResult
        });
    }
  });
  var $author$project$Update$update = F2(function (msg, state) {
    var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.tc);
    var appState = state.o_;

    switch (msg.$) {
      case 0:
        var route = msg.a;
        return _Utils_Tuple3(state.o_, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(route)]));

      case 3:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$GlobalMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              qC: childState
            });
          },
          Fg: A5($author$project$Global$Global$update, state.EM, currRoute, $elm$core$Maybe$Nothing, theMsg, appState.qC)
        });

      case 4:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$AuthMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              u1: childState
            });
          },
          Fg: A6($author$project$Ui$Auth$Auth$update, state.xz, state.CH, currRoute, appState.qC, theMsg, appState.u1)
        });

      case 6:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$SupportMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              Ex: childState
            });
          },
          Fg: A4($author$project$Ui$Support$Support$update, appState.qC, $elm$core$Maybe$Nothing, theMsg, appState.Ex)
        });

      case 5:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$LegalMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              zb: childState
            });
          },
          Fg: A4($author$project$Ui$Legal$Legal$update, appState.qC, $elm$core$Maybe$Nothing, theMsg, appState.zb)
        });

      case 2:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$PushMessagesMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              CE: childState
            });
          },
          Fg: A5($author$project$PushMessages$PushMessages$update, currRoute, appState.qC, $elm$core$Maybe$Nothing, theMsg, appState.CE)
        });

      case 1:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$MainAppWrapSpecificMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              zi: childState
            });
          },
          Fg: A2($author$project$UiWrappers$MainAppWrapSpecific$Update$update, theMsg, appState.zi)
        });

      case 7:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$ComponentsPreviewMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              v8: childState
            });
          },
          Fg: A4($author$project$Ui$ComponentsPreview$ComponentsPreview$update, state, $elm$core$Maybe$Nothing, theMsg, appState.v8)
        });

      case 17:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$OnboardingCompanyMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              Cb: childState
            });
          },
          Fg: A4($author$project$Ui$OnboardingCompany$Update$update, state.EM, appState.qC, appState.Cb, theMsg)
        });

      case 8:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$ScenariosMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              DC: childState
            });
          },
          Fg: A4($author$project$Ui$Scenarios$Update$update, state.EM, appState.qC, appState.DC, theMsg)
        });

      case 9:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$ScenarioMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              DB: childState
            });
          },
          Fg: A7($author$project$Ui$Scenario$Update$update, state.EM, state.by, currRoute, appState.qC, $author$project$Remote$Model$toSession(appState.CT), appState.DB, theMsg)
        });

      case 10:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$BlockMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              vh: childState
            });
          },
          Fg: A4($author$project$Ui$Block$Update$update, state, appState.qC, appState.vh, theMsg)
        });

      case 11:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$BlocksMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              vl: childState
            });
          },
          Fg: A4($author$project$Ui$Blocks$Update$update, state, appState.qC, appState.vl, theMsg)
        });

      case 12:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$SettingsMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              D0: childState
            });
          },
          Fg: A4($author$project$Ui$Settings$Update$update, state.EM, appState.qC, appState.D0, theMsg)
        });

      case 18:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$CashboardMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              vO: childState
            });
          },
          Fg: A4($author$project$Ui$Cashboard$Update$update, currRoute, appState.qC, appState.vO, theMsg)
        });

      case 13:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$UserProfileMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              Fo: childState
            });
          },
          Fg: A4($author$project$Ui$UserProfile$Update$update, state.EM, appState.qC, appState.Fo, theMsg)
        });

      case 14:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$RemoteMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              CT: childState
            });
          },
          Fg: A5($author$project$Remote$Remote$update, state.EM, currRoute, theMsg, appState.CT, appState.qC)
        });

      case 15:
        var requestMsg = msg.a;

        var _v1 = A3($author$project$Remote$UpdateRequest$updateRequest, appState.qC, requestMsg, appState.CT);

        var remote = _v1.a;
        var cmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(appState, {
          CT: remote
        }), A2($elm$core$Platform$Cmd$map, $author$project$Msg$RemoteResponseMsg(requestMsg), cmd), outMsgs);

      case 16:
        var requestMsg = msg.a;
        var responseMsg = msg.b;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$RemoteResponseMsg(requestMsg),
          Ek: function (childState) {
            return _Utils_update(appState, {
              CT: childState
            });
          },
          Fg: A4($author$project$Remote$UpdateResponse$updateResponse, state, requestMsg, responseMsg, appState.CT)
        });

      case 19:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$BudgetMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              vC: childState
            });
          },
          Fg: A4($author$project$Ui$Budget$Update$update, currRoute, appState.qC, appState.vC, theMsg)
        });

      case 20:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$AccountsMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              uz: childState
            });
          },
          Fg: A5($author$project$Ui$Accounts$Update$update, state.EM, state.by, appState.qC, appState.uz, theMsg)
        });

      default:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          zI: $author$project$Msg$EditingUsersMsg,
          Ek: function (childState) {
            return _Utils_update(appState, {
              xn: childState
            });
          },
          Fg: A2($author$project$Ui$EditingUsers$Update$update, {
            xm: appState.xn,
            qC: appState.qC,
            EM: state.EM
          }, theMsg)
        });
    }
  });

  var $author$project$ElmFramework$Lib$Ui$Button$Button = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Button$NeutralColor = 1;
  var $author$project$Ui$Button$PrimaryColor = 0;

  var $elm$html$Html$button = _VirtualDom_node('button');

  var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
  var $author$project$ElmFramework$Lib$Ui$Button$button = F3(function (buttonKind, attrList, childList) {
    var _v0 = function () {
      switch (buttonKind.$) {
        case 0:
          return _Utils_Tuple2($elm$html$Html$button, _List_fromArray([$elm$html$Html$Attributes$type_('submit')]));

        case 1:
          var msg = buttonKind.a;
          return _Utils_Tuple2($elm$html$Html$button, _List_fromArray([$elm$html$Html$Attributes$type_('button'), $author$project$ElmFramework$Lib$Util$onTap(msg)]));

        default:
          return _Utils_Tuple2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'onclick', 'return false')]));
      }
    }();

    var btnEl = _v0.a;
    var handlerAttrs = _v0.b;
    return A2(btnEl, _Utils_ap(attrList, handlerAttrs), childList);
  });
  var $elm$html$Html$Attributes$boolProperty = F2(function (key, bool) {
    return A2(_VirtualDom_property, key, $elm$json$Json$Encode$bool(bool));
  });
  var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');

  var $author$project$Ui$Button$basicButtonVeryBasic = function (config) {
    var classes = {
      vV: '',
      kI: 'flexCenter'
    };

    var theIcon = function () {
      var _v1 = config.yh;

      if (!_v1.$) {
        if (!_v1.a.$) {
          var anIcon = _v1.a.a;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold padLeft3 padRight3'), $elm$html$Html$Attributes$class(classes.kI)]), _List_fromArray([anIcon('w3 primary0Fill marRight1'), $elm$html$Html$text(config.y$)]));
        } else {
          var anIcon = _v1.a.a;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular padLeft2 padRight2'), $elm$html$Html$Attributes$class(classes.kI)]), _List_fromArray([$elm$html$Html$text(config.y$), anIcon('w3 primary30Fill marLeft1')]));
        }
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold padLeft3 padRight3'), $elm$html$Html$Attributes$class(classes.vV)]), _List_fromArray([$elm$html$Html$text(config.y$)]));
      }
    }();

    var btnClasses = function () {
      var _v0 = config.vY;

      switch (_v0) {
        case 0:
          return 'primary20Back primary0';

        case 1:
          return 'gray10Back primary30';

        case 2:
          return 'primary0Back secondary0';

        case 3:
          return 'gray10Back gray40';

        case 4:
          return 'secondary80Back primary0';

        default:
          return 'gray60';
      }
    }();

    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.f9, _List_fromArray([$elm$html$Html$Attributes$class(btnClasses), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, '', '', config.yM)), $elm$html$Html$Attributes$class(' radius0 noBorder opacityTransition '), $elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$disabled(config.yM)]), _List_fromArray([theIcon]));
  };

  var $author$project$Ui$Button$basicButton = function (config) {
    return $author$project$Ui$Button$basicButtonVeryBasic({
      kG: config.kG + ' minH6',
      vY: config.vY,
      yh: config.yh,
      yM: config.yM,
      f9: config.f9,
      y$: config.y$
    });
  };

  var $author$project$UiWrappers$WindowModal$lineSeparator = A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '1px'), $elm$html$Html$Attributes$class('gray10Back')]), _List_Nil);

  var $author$project$ElmFramework$Lib$Util$spacer = function (classes) {
    return A3($elm$html$Html$node, 'spacer', _List_fromArray([$elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$class('block')]), _List_Nil);
  };

  var $author$project$IconSvg$close_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31 11.2157L28.7843 9L20 17.7843L11.2157 9L9 11.2157L17.7843 20L9 28.7843L11.2157 31L20 22.2157L28.7843 31L31 28.7843L22.2157 20L31 11.2157Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$close = function (classes) {
    return $author$project$IconSvg$close_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr = F2(function (attrs, content) {
    return A3($elm$html$Html$node, 'prevent-click-propagation', attrs, content);
  });

  var $author$project$UiWrappers$WindowModal$theModal = function (cfg) {
    return A2($author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock relative primary0Back left z2')]), _Utils_ap(_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative flexCenter pad3 padLeft10 padRight10')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(cfg.t1)])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.Aj), _List_fromArray([$elm$html$Html$Attributes$class('absolute right0 bottom0 top0 w10 flexCenter')]), _List_fromArray([$author$project$IconSvg$close('w3 gray40Fill')]))])), $author$project$UiWrappers$WindowModal$lineSeparator]), cfg.pD));
  };

  var $author$project$UiWrappers$WindowModal$windowModal = function (cfg) {
    return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread'), $author$project$ElmFramework$Lib$Util$onTap(cfg.Aj)]), cfg.iw), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread primary30Back o2')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexColumn scrollTarget')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop6 padBottom6 marTopAuto marBottomAuto center')]), _List_fromArray([$author$project$UiWrappers$WindowModal$theModal(cfg)]))]))]));
  };

  var $author$project$UiWrappers$DialogModal$dialogModal = function (cfg) {
    return $author$project$UiWrappers$WindowModal$windowModal({
      iw: _List_fromArray([$elm$html$Html$Attributes$class('z5')]),
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft3 padRight3')]), cfg.pD), $author$project$UiWrappers$WindowModal$lineSeparator, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad3 flexRow')]), _List_fromArray([$author$project$Ui$Button$basicButton({
        kG: 'minW24',
        vY: 1,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.aw),
        y$: cfg.as
      }), $author$project$ElmFramework$Lib$Util$spacer('flex1 minW3'), $author$project$Ui$Button$basicButton({
        kG: 'minW24',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.av),
        y$: cfg.ar
      })]))]),
      Aj: cfg.Aj,
      t1: cfg.t1
    });
  };

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary30'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$Ui$OverLaysView$confirmRemoveUserCompanyUsersOverlay = function (_v0) {
    var companyUserType = _v0.pz;
    var removeMsg = _v0.sV;

    var verbText = function () {
      if (!companyUserType.$) {
        return 'Revoke';
      } else {
        return 'Remove';
      }
    }();

    var subjectText = function () {
      if (!companyUserType.$) {
        return 'Invitation';
      } else {
        return 'User';
      }
    }();

    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: verbText + (' ' + subjectText),
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter padRight9 padLeft9')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'marTop4 marBottom2 maxW46 center padRight3 padLeft3 ',
        y$: 'Are you sure you want to ' + ($elm$core$String$toLower(verbText) + (' this ' + ($elm$core$String$toLower(subjectText) + '?')))
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'marBottom5 gray40 ',
        y$: 'This action cannot be undone.'
      })]))]),
      av: $author$project$TopMsg$requestMsg(removeMsg),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: verbText + (' ' + subjectText)
    });
  };

  var $author$project$Remote$RequestMsg$CreateSeasonalityPreset = F3(function (a, b, c) {
    return {
      $: 69,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$CreateSeasonalityReq$CreateSeasonalityPresetReq = F2(function (name, monthAdjustments) {
    return {
      dW: monthAdjustments,
      zL: name
    };
  });
  var $author$project$Remote$RequestMsg$EditBasicBlockSeasonalityPresetFinishCreate = 0;
  var $author$project$ElmFramework$Lib$Ui$Input$Text = 0;
  var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');

  var $elm$html$Html$input = _VirtualDom_node('input');

  var $elm$html$Html$Events$alwaysStop = function (x) {
    return _Utils_Tuple2(x, true);
  };

  var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm$html$Html$Events$stopPropagationOn = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
  });
  var $elm$html$Html$Events$targetValue = A2($elm$json$Json$Decode$at, _List_fromArray(['target', 'value']), $elm$json$Json$Decode$string);

  var $elm$html$Html$Events$onInput = function (tagger) {
    return A2($elm$html$Html$Events$stopPropagationOn, 'input', A2($elm$json$Json$Decode$map, $elm$html$Html$Events$alwaysStop, A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
  };

  var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
  var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');

  var $author$project$ElmFramework$Lib$Ui$Input$toAutocompleteString = function (maybeAutoComplete) {
    if (maybeAutoComplete.$ === 1) {
      return 'off';
    } else {
      switch (maybeAutoComplete.a) {
        case 0:
          var _v1 = maybeAutoComplete.a;
          return 'email';

        case 1:
          var _v2 = maybeAutoComplete.a;
          return 'new-password';

        case 2:
          var _v3 = maybeAutoComplete.a;
          return 'current-password';

        case 3:
          var _v4 = maybeAutoComplete.a;
          return 'given-name';

        default:
          var _v5 = maybeAutoComplete.a;
          return 'family-name';
      }
    }
  };

  var $author$project$ElmFramework$Lib$Ui$Input$toInputTypeString = function (inputType) {
    switch (inputType) {
      case 0:
        return 'text';

      case 1:
        return 'email';

      default:
        return 'password';
    }
  };

  var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');

  var $author$project$ElmFramework$Lib$Ui$Input$input_custom = function (config) {
    return A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class(config.kG), A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$ElmFramework$Lib$Util$noOpAttr, $elm$html$Html$Attributes$id(config.F), $elm$core$String$isEmpty(config.F)), $elm$html$Html$Attributes$type_($author$project$ElmFramework$Lib$Ui$Input$toInputTypeString(config.qU)), $elm$html$Html$Attributes$required(config.gx), $elm$html$Html$Attributes$disabled(config.k_), $elm$html$Html$Attributes$placeholder(config.e3), $elm$html$Html$Attributes$value(config.Fw), $elm$html$Html$Events$onInput(config.e_), A2($elm$html$Html$Attributes$attribute, 'autocomplete', $author$project$ElmFramework$Lib$Ui$Input$toAutocompleteString(config.fx))]), _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$Input$input = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Input$input_custom({
      fx: config.fx,
      kG: config.kG,
      k_: config.k_,
      F: '',
      qU: config.qU,
      e_: config.e_,
      e3: config.e3,
      gx: config.gx,
      Fw: config.Fw
    });
  };

  var $author$project$ElmFramework$Lib$Util$noOpEl = A3($elm$html$Html$node, 'no-op-el', _List_Nil, _List_Nil);

  var $author$project$Ui$InputComponent$inputField = function (config) {
    var descriptionAboveInput = function () {
      var _v0 = config.E;

      if (!_v0.$) {
        var description = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bottom0h gray40 heading5Bold')]), _List_fromArray([$elm$html$Html$text(description)]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var classes = config.qW ? 'padLeft2 padRight2 borderHairlineWidth gray20Border placeholderGray40 heading4Bold borderSolid fullWidth h6 radius0 primary0Back primary30' : 'heading3Regular placeholderGray40 primary30';
    var borderEl = !config.qW ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('doubleHairLineHeight primary30Back maxW46 marBottom4')]), _List_Nil) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.vV)]), _List_fromArray([descriptionAboveInput, $author$project$ElmFramework$Lib$Ui$Input$input({
      fx: config.fx,
      kG: 'fullWidth ' + classes,
      k_: config.k_,
      qU: config.qU,
      e_: config.e_,
      e3: config.e3,
      gx: config.gx,
      Fw: config.Fw
    }), borderEl]));
  };

  var $author$project$Ui$OverLaysView$createSeasonalityPresetDialog = F3(function (topState, companyId, monthAdjustments) {
    var inputString = topState.o_.vh.bv.fD.bK.gu;

    var _v0 = _Utils_Tuple3(topState.o_.vh.bv, topState.o_.vh.bv.fD, topState.o_.vh.bv.fD.bK);

    var editingBlock = _v0.a;
    var basicPayload = _v0.b;
    var seasonality = _v0.c;
    var setSeasonalityPresetNameString = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$SetEditingBlock), $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(editingBlock)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setSeasonality(basicPayload)), $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPresetNameInputString(seasonality));
    var onClose = $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([setSeasonalityPresetNameString(''), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Save',
      as: 'Cancel',
      pD: _List_fromArray([$author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: ' fullWidth marBottom3 marTop4',
        E: $elm$core$Maybe$Just('Seasonality Pre-set Name'),
        k_: false,
        qU: 0,
        qW: true,
        e_: setSeasonalityPresetNameString,
        e3: '',
        gx: false,
        Fw: inputString
      })]),
      av: $elm$core$String$isEmpty(inputString) ? A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Preset requires a name', _List_Nil) : $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$CreateSeasonalityPreset, $elm$core$Maybe$Just(0), companyId, A2($author$project$Api$Types$CreateSeasonalityReq$CreateSeasonalityPresetReq, inputString, monthAdjustments))),
      aw: onClose,
      Aj: onClose,
      t1: 'Create Seasonality Preset'
    });
  });
  var $author$project$Remote$RequestMsg$DeleteBlock = F2(function (a, b) {
    return {
      $: 67,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OverLaysView$deleteBlockConfirmationDialog = F2(function (company, blockId) {
    var blockName = A2($elm$core$Maybe$withDefault, 'this block', A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, A2($author$project$Types$Company$toBuildingBlock, blockId, company)));
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Delete This Block',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: A3($elm$core$String$replace, '{{blockName}}', blockName, 'Are you sure you want to delete \"{{blockName}}\"?')
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
        y$: 'This action cannot be undone.'
      })]))]),
      av: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteBlock, company.F, {
        qw: false,
        F: blockId
      })),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Delete Block?'
    });
  });
  var $author$project$Remote$RequestMsg$DeleteAllocationClass = F2(function (a, b) {
    return {
      $: 32,
      a: a,
      b: b
    };
  });

  var $elm_community$list_extra$List$Extra$count = function (predicate) {
    return A2($elm$core$List$foldl, F2(function (x, acc) {
      return predicate(x) ? acc + 1 : acc;
    }), 0);
  };

  var $elm_community$list_extra$List$Extra$findMap = F2(function (f, list) {
    findMap: while (true) {
      if (!list.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var a = list.a;
        var tail = list.b;

        var _v1 = f(a);

        if (!_v1.$) {
          var b = _v1.a;
          return $elm$core$Maybe$Just(b);
        } else {
          var $temp$f = f,
              $temp$list = tail;
          f = $temp$f;
          list = $temp$list;
          continue findMap;
        }
      }
    }
  });
  var $author$project$Types$Division$toAllocationClass = F2(function (allocationClassId, division) {
    return A2($turboMaCk$any_dict$Dict$Any$get, allocationClassId, division.oX);
  });
  var $author$project$Types$Company$toAllocationClass = F2(function (allocationClassId, company) {
    var toTuple = function (division) {
      return A2($elm$core$Maybe$map, function (_class) {
        return _Utils_Tuple2(division, _class);
      }, A2($author$project$Types$Division$toAllocationClass, allocationClassId, division));
    };

    return A2($elm$core$Maybe$andThen, $elm_community$list_extra$List$Extra$findMap(toTuple), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO)));
  });

  var $author$project$Types$Company$toBuildingBlocks = function (company) {
    return A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.pg));
  };

  var $author$project$Ui$OverLaysView$deleteCategoryDialog = F2(function (company, allocationClassId) {
    var usageCount = function (_v0) {
      return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm_community$list_extra$List$Extra$count($elm$core$Basics$eq(allocationClassId)), $elm$core$List$filterMap($author$project$Types$BuildingBlock$toAllocationClassId)), $author$project$Types$Company$toBuildingBlocks(company));
    };

    var allocationClassName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
      return $.zL;
    }), A2($author$project$Types$Company$toAllocationClass, allocationClassId, company)));
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Delete Category',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeftAuto marRightAuto center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: A3($elm$core$String$replace, '{{allocationClassName}}', allocationClassName, 'Are you sure you want to delete \"{{allocationClassName}}\"?')
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
        y$: A2($elm$core$Maybe$withDefault, 'Are you sure you wish to delete this category?', A2($elm$core$Maybe$andThen, function (count) {
          return count > 0 ? $elm$core$Maybe$Just('This category is used in ' + ($elm$core$String$fromInt(count) + (' other blocks. ' + ('If it is deleted, the parent category will be used for those blocks instead. ' + 'Are you sure you wish to delete it?')))) : $elm$core$Maybe$Nothing;
        }, usageCount(0)))
      })]))]),
      av: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteAllocationClass, company.F, allocationClassId)),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: A3($elm$core$String$replace, '{{allocationClassName}}', allocationClassName, 'Delete {{allocationClassName}}')
    });
  });
  var $author$project$Remote$RequestMsg$DisconnectDivision = F3(function (a, b, c) {
    return {
      $: 28,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Types$Division$Error = 1;
  var $author$project$Types$Division$Normal = 0;
  var $author$project$Types$Division$QuickBooks = 3;
  var $author$project$Types$Division$Syncing = 2;

  var $author$project$Types$Division$toDivisionStatus = function (division) {
    var _v0 = A2($elm$core$Maybe$map, function ($) {
      return $.y7;
    }, division.ju);

    if (_v0.$ === 1) {
      return 0;
    } else {
      var syncStatus = _v0.a;

      switch (syncStatus) {
        case 2:
          return 3;

        case 1:
          return 2;

        default:
          return 1;
      }
    }
  };

  var $author$project$Ui$OverLaysView$deleteDivisionConfirmationDialog = F2(function (companyId, division) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Delete This Division',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Are you sure you want to delete this division?'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
        y$: 'All related accounts and classifications will also be deleted.'
      })]))]),
      av: function () {
        var _v0 = _Utils_Tuple2(division.ju, $author$project$Types$Division$toDivisionStatus(division));

        if (!_v0.a.$ && _v0.b === 3) {
          var overlayDivision = _v0.a.a;
          var _v1 = _v0.b;
          return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$DisconnectDivision, companyId, overlayDivision.F, $elm$core$Maybe$Just(division.F)));
        } else {
          return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteDivision, companyId, division.F));
        }
      }(),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Delete Division?'
    });
  });
  var $author$project$Remote$RequestMsg$DeleteScenario = F2(function (a, b) {
    return {
      $: 45,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OverLaysView$deleteScenarioConfirmationDialog = F2(function (companyId, scenario) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Delete This Scenario',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: A3($elm$core$String$replace, '{{scenarioName}}', scenario.zL, 'Are you sure you want to delete \"{{scenarioName}}\"?')
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
        y$: 'This action cannot be undone.'
      })]))]),
      av: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteScenario, companyId, {
        e8: scenario.F
      })),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Delete Scenario?'
    });
  });
  var $author$project$Remote$RequestMsg$DeleteSeasonalityPreset = F2(function (a, b) {
    return {
      $: 71,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OverLaysView$deleteSeasonalityPresetDialog = F3(function (topState, companyId, seasonalityId) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Delete',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeftAuto marRightAuto center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Are you sure you want to delete this pre-set?'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2',
        y$: 'This action cannot be undone.'
      })]))]),
      av: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteSeasonalityPreset, companyId, seasonalityId)),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Delete Seasonality Preset'
    });
  });
  var $author$project$Ui$Scenarios$Msg$OnDuplicate = F3(function (a, b, c) {
    return {
      $: 4,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$OverLaysView$duplicateScenarioConfirmationDialog = F2(function (companyId, scenario) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Yes',
      as: 'No',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: A3($elm$core$String$replace, '{{scenarioName}}', scenario.zL, 'Do you want to edit \"{{scenarioName}}\" before publishing it?')
      })]))]),
      av: $author$project$TopMsg$msgScenarios(A3($author$project$Ui$Scenarios$Msg$OnDuplicate, companyId, scenario.F, true)),
      aw: $author$project$TopMsg$msgScenarios(A3($author$project$Ui$Scenarios$Msg$OnDuplicate, companyId, scenario.F, false)),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Duplicate Scenario?'
    });
  });

  var $author$project$Ui$Accounts$Msg$OnEditAccountBalanceInput = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$OverrideFinancialAccountBalanceOnDate = F3(function (a, b, c) {
    return {
      $: 36,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$OverrideFinancialAccountBalanceOnDateReq = F3(function (id, date, value) {
    return {
      iL: date,
      F: id,
      Fw: value
    };
  });
  var $author$project$Global$Model$ResetAccountBalance = 0;
  var $author$project$Ui$Button$WhiteColor = 2;

  var $author$project$UiWrappers$DialogModal$dialogModalExtraAction = function (cfg) {
    return $author$project$UiWrappers$WindowModal$windowModal({
      iw: _List_fromArray([$elm$html$Html$Attributes$class('z5')]),
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft3 padRight3')]), cfg.pD), $author$project$UiWrappers$WindowModal$lineSeparator, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad3 flexRow')]), _List_fromArray([$author$project$Ui$Button$basicButton({
        kG: '',
        vY: 2,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.A_),
        y$: cfg.xG
      }), $author$project$ElmFramework$Lib$Util$spacer('flex1 minW15'), $author$project$Ui$Button$basicButton({
        kG: 'minW24',
        vY: 1,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.aw),
        y$: cfg.as
      }), $author$project$ElmFramework$Lib$Util$spacer('flex1 minW3'), $author$project$Ui$Button$basicButton({
        kG: 'minW24',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.av),
        y$: cfg.ar
      })]))]),
      Aj: cfg.Aj,
      t1: cfg.t1
    });
  };

  var $author$project$Types$SimpleDate$monthToLongString = function (month) {
    switch (month) {
      case 0:
        return 'January';

      case 1:
        return 'February';

      case 2:
        return 'March';

      case 3:
        return 'April';

      case 4:
        return 'May';

      case 5:
        return 'Jun';

      case 6:
        return 'July';

      case 7:
        return 'August';

      case 8:
        return 'September';

      case 9:
        return 'October';

      case 10:
        return 'November';

      default:
        return 'December';
    }
  };

  var $author$project$Types$SimpleDate$toFullDateString = F2(function (separator, simpleDate) {
    var year = $elm$core$String$fromInt(simpleDate.FP);
    var month = $author$project$Types$SimpleDate$monthToLongString(simpleDate.zG);
    var day = A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(simpleDate.wz));
    return A2($elm$core$String$join, separator, _List_fromArray([day, month, year]));
  });
  var $author$project$Ui$OverLaysView$editAccountBalanceFinancialAccountsDialog = F5(function (topState, companyId, divisionId, accountId, balance) {
    var inputString = topState.o_.uz.pZ;
    return $author$project$UiWrappers$DialogModal$dialogModalExtraAction({
      ar: 'Save Balance',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter marTop4 marBottom2')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Regular primary30 marBottom1')]), _List_fromArray([$elm$html$Html$text('Edit Account Balance on')])), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: A2($author$project$Types$SimpleDate$toFullDateString, ', ', balance.o$)
      })])), $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: ' fullWidth marBottom3',
        E: $elm$core$Maybe$Just('Balance'),
        k_: false,
        qU: 0,
        qW: true,
        e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, $author$project$Ui$Accounts$Msg$OnEditAccountBalanceInput),
        e3: '0.00',
        gx: false,
        Fw: inputString
      })]),
      xG: 'Reset Balance',
      av: function () {
        var _v0 = $author$project$Ui$TimeTransformation$Util$floatStringToFraction(inputString);

        if (!_v0.$) {
          var fraction = _v0.a;
          return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$OverrideFinancialAccountBalanceOnDate, companyId, divisionId, A3($author$project$Api$Types$OverrideFinancialAccountBalanceOnDateReq, accountId, balance.o$, fraction)));
        } else {
          return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Invalid balance value', _List_Nil);
        }
      }(),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      A_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A5($author$project$Global$Model$EditAccountBalance, $elm$core$Maybe$Just(0), companyId, divisionId, accountId, balance))),
      t1: 'Edit Account Balance'
    });
  });
  var $author$project$Remote$RequestMsg$CreateDivision = F2(function (a, b) {
    return {
      $: 25,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$EditingDivision$Msg$SetEmployeeCount = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$EditingDivision$Msg$SetIndustry = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$EditingDivision$Msg$SetName = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$UpdateDivision = F3(function (a, b, c) {
    return {
      $: 26,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $elm_community$string_extra$String$Extra$regexFromString = A2($elm$core$Basics$composeR, $elm$regex$Regex$fromString, $elm$core$Maybe$withDefault($elm$regex$Regex$never));

  var $elm_community$string_extra$String$Extra$clean = function (string) {
    return $elm$core$String$trim(A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('\\s\\s+'), $elm$core$Basics$always(' '), string));
  };

  var $author$project$IconSvg$down_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M10.82 12L20 21.2713L29.18 12L32 14.8543L20 27L8 14.8543L10.82 12Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$down = function (classes) {
    return $author$project$IconSvg$down_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
    if (m.$ === 1) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$ElmFramework$Lib$Ui$InputSearchDropdown$onDebouncedInput = function (tag) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'debouncedInput', A2($elm$json$Json$Decode$map, tag, A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string)));
  };

  var $author$project$ElmFramework$Lib$Ui$InputSearchDropdown$inputSearchDropdown = function (config) {
    var toListItem = function (item) {
      var itemText = config.t3(item);

      var _v2 = function () {
        var _v3 = A2($elm$core$String$startsWith, $elm$core$String$toLower(config.Fw), $elm$core$String$toLower(itemText));

        if (_v3) {
          return _Utils_Tuple2(A2($elm$core$String$left, $elm$core$String$length(config.Fw), itemText), A2($elm$core$String$right, A2($elm$core$Basics$max, $elm$core$String$length(itemText) - $elm$core$String$length(config.Fw), 0), itemText));
        } else {
          return _Utils_Tuple2('', itemText);
        }
      }();

      var highlightedString = _v2.a;
      var restOfString = _v2.b;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.w2), $author$project$ElmFramework$Lib$Util$onTap(config.BE(item))]), _List_fromArray([config.yh(item), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.w6)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.wQ)]), _List_fromArray([$elm$html$Html$text(highlightedString)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.wP)]), _List_fromArray([$elm$html$Html$text(restOfString)]))]))]));
    };

    var theInput = $author$project$ElmFramework$Lib$Ui$Input$input({
      fx: config.fx,
      kG: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block relative', A3($author$project$ElmFramework$Lib$Util$ifElse, ' o0 ', ' ', $elm_community$maybe_extra$Maybe$Extra$isJust(config.ia)), config.ys]))),
      k_: config.yM,
      qU: config.qU,
      e_: config.e_,
      e3: config.e3,
      gx: config.yW,
      Fw: config.Fw
    });

    var dropdownTitleEl = function () {
      var title = $elm$core$String$isEmpty(config.pY) || !_Utils_eq(config.ia, $elm$core$Maybe$Nothing) ? $author$project$ElmFramework$Lib$Util$noOpEl : A3($elm$html$Html$node, 'dropdown-title', _List_fromArray([$elm$html$Html$Attributes$class(config.xf)]), _List_fromArray([$elm$html$Html$text(config.pY)]));
      var clearAll = A3($elm$core$Maybe$map2, F2(function (msg, _v1) {
        return A3($elm$html$Html$node, 'dropdown-title', _List_fromArray([$elm$html$Html$Attributes$class('pad2 gray40 whiteBack flexRow flexAlignCenter spaceBetween pointer heading4Bold borderBottomHairline h7'), $author$project$ElmFramework$Lib$Util$onTap(msg)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 flex1 left')]), _List_fromArray([$elm$html$Html$text('Clear Selection')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('padRight2')]), _List_fromArray([$author$project$IconSvg$close('w3 h3 gray40Fill')]))]));
      }), config.Ac, config.ia);
      return A2($elm$core$Maybe$withDefault, title, clearAll);
    }();

    var dropdownWrap = A3($elm$html$Html$node, 'dropdown-wrapper', _List_fromArray([$elm$html$Html$Attributes$class('absolute left0 right0 noOverflow marBottom4'), $elm$html$Html$Attributes$class(config.xg)]), _List_fromArray([A3($elm$html$Html$node, 'dropdown-selected-option', _List_fromArray([$elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', $elm_community$maybe_extra$Maybe$Extra$isNothing(config.ia))])), $elm$html$Html$Attributes$class(config.xe)]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, config.t3, config.ia)))]))])), A3($elm$html$Html$node, 'dropdown-element', _List_fromArray([$elm$html$Html$Attributes$class(config.xa), $elm$html$Html$Attributes$class('yesPointerEvents')]), _List_fromArray([dropdownTitleEl, A3($elm$html$Html$node, 'dropdown-body', _List_fromArray([$elm$html$Html$Attributes$class(config.wR)]), function () {
      var _v0 = config.C7;

      if (!_v0.$) {
        var results = _v0.a;
        return A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([config.zS]), A2($elm$core$List$map, toListItem, results), $elm$core$List$isEmpty(results));
      } else {
        return _List_fromArray([config.Eb]);
      }
    }())]))]));
    var dropdownIconWrap = A3($elm$html$Html$node, 'dropdown-icon-wrapper', _List_fromArray([$elm$html$Html$Attributes$class('block absolute top0 right0 centerY noPointerEvents'), $elm$html$Html$Attributes$class(config.xd)]), _List_fromArray([A3($elm$html$Html$node, 'dropdown-icon', _List_fromArray([$elm$html$Html$Attributes$class('block'), $elm$html$Html$Attributes$class(config.xc)]), _List_fromArray([config.xb]))]));
    return A3($elm$html$Html$node, 'input-search-dropdown', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block relative', ' ', config.kG]))))]), _List_fromArray([A3($elm$html$Html$node, 'debounced-input', _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'debounce-time', $elm$core$String$fromInt(config.wA)), $elm$html$Html$Attributes$class(config.yy), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpAttr, $author$project$ElmFramework$Lib$Ui$InputSearchDropdown$onDebouncedInput, config.Aw)]), _List_fromArray([theInput, dropdownWrap, dropdownIconWrap]))]));
  };

  var $author$project$Ui$SimpleSpinner$spinner = function (classes) {
    return A3($elm$html$Html$node, 'simple-spinner', _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_Nil);
  };

  var $author$project$Ui$SimpleSpinner$simpleSpinner = $author$project$Ui$SimpleSpinner$spinner('block circle w4 h4 borderWidth5 borderSolid gray10Border primary20BorderTop');

  var $author$project$Ui$InputSearchDropdown$inputSearchDropdown = function (config) {
    var toBodyClasses = function () {
      var _v0 = config.C7;

      if (!_v0.$) {
        var results = _v0.a;
        return A3($author$project$ElmFramework$Lib$Util$ifElse, 'heading4Bold gray40 padLeft2 padRight2 padTop1h padBottom1h', '', $elm$core$List$isEmpty(results));
      } else {
        return '';
      }
    }();

    return $author$project$ElmFramework$Lib$Ui$InputSearchDropdown$inputSearchDropdown({
      fx: $elm$core$Maybe$Nothing,
      kG: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['primary30', ' ', config.kG]))),
      wA: 200,
      wP: '',
      wQ: 'heading4Bold',
      wR: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block whiteBack', ' ', toBodyClasses]))),
      w2: 'flexRow alignCenter padTop1h padBottom1h padLeft2 padRight2 pointer',
      w6: 'padLeft2',
      xa: 'block',
      xb: $author$project$IconSvg$down('w3 primary30Fill'),
      xc: '',
      xd: 'padRight2',
      xe: 'flexRow flexAlignCenter heading4Bold h6 fullWidth padLeft2 padRight1 borderHairlineWidth borderSolid gray20Border radius0 noPointerEvents',
      pY: config.pY,
      xf: 'block padTop2 padBottom1h padLeft2 gray40 whiteBack heading5Regular',
      xg: 'top0 radius0 heading4Regular maxH6',
      yh: config.C5,
      ys: 'heading4Bold h6 fullWidth padLeft2 padRight2 placeholderGray40 borderHairlineWidth borderSolid gray20Border radius0',
      qU: 0,
      yy: '',
      yM: config.yM,
      yW: config.yW,
      zS: config.zS,
      Ac: config.Ac,
      Aw: config.Aw,
      e_: config.e_,
      BE: config.BE,
      e3: config.e3,
      C7: config.C7,
      ia: config.ia,
      Eb: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 padBottom2')]), _List_fromArray([$author$project$Ui$SimpleSpinner$simpleSpinner])),
      t3: config.C6,
      Fw: config.Fw
    });
  };

  var $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic = function (config) {
    var noResultsFoundElement = A2($elm$core$Maybe$withDefault, A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('block')]), _List_fromArray([$elm$html$Html$text('No results found')])), A2($elm$core$Maybe$map, function (createNew) {
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('block')]), _List_fromArray([$elm$html$Html$text($elm$core$String$concat(_List_fromArray(['No results found for ', config.Fw])))])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('Would you like to ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('underline pointer'), $author$project$ElmFramework$Lib$Util$onTap(createNew(config.Fw))]), _List_fromArray([$elm$html$Html$text('create one')])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('?')]))]));
    }, config.Ar));
    return $author$project$Ui$InputSearchDropdown$inputSearchDropdown({
      kG: config.kG,
      pY: config.pY,
      yM: config.yM,
      yW: config.yW,
      zS: noResultsFoundElement,
      Ac: config.Ac,
      Ar: config.Ar,
      Aw: config.Aw,
      e_: config.e_,
      BE: config.BE,
      e3: config.e3,
      C5: config.C5,
      C6: config.C6,
      C7: config.C7,
      ia: config.ia,
      Fw: config.Fw
    });
  };

  var $author$project$Api$GraphqlSchema$InputObject$CreateDivisionInput = F3(function (employeeCount, industry, name) {
    return {
      dC: employeeCount,
      an: industry,
      zL: name
    };
  });

  var $author$project$Ui$EditingDivision$Model$toCreateDivisionInput = function (editingDivision) {
    return A4($elm$core$Result$map3, $author$project$Api$GraphqlSchema$InputObject$CreateDivisionInput, A2($elm$core$Result$fromMaybe, 'Unrecognized \'Employees count\'', $elm$core$String$toInt(editingDivision.xt)), A2($elm$core$Result$fromMaybe, 'Please select an industry', editingDivision.an.Fw), $elm$core$Result$Ok(editingDivision.zL));
  };

  var $author$project$Ui$EditingDivision$Model$toUpdateDivisionInput = function (editingDivision) {
    return {
      dC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe($elm$core$String$toInt(editingDivision.xt)),
      an: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(editingDivision.an.Fw),
      zL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(editingDivision.zL)
    };
  };

  var $author$project$Ui$OverLaysView$editDivisionOverlay = F4(function (topState, companyId, division, isNewSyncing) {
    var _v0 = topState.o_.D0.xk;

    if (_v0.$ === 1) {
      return $author$project$ElmFramework$Lib$Util$noOpEl;
    } else {
      var editingDivision = _v0.a;

      var overlayDivisionName = function (classes) {
        return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (label) {
          return $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
            vV: classes,
            y$: label
          });
        }, A2($elm$core$Maybe$map, function ($) {
          return $.zL;
        }, A2($elm$core$Maybe$andThen, function ($) {
          return $.ju;
        }, division))));
      };

      var onCancelTap = isNewSyncing ? $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), $author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$HandleNewDivisions(companyId))])) : $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog);

      var onAcceptTap = function () {
        if ($elm$core$String$isEmpty(editingDivision.zL)) {
          return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please provide a division name.', _List_Nil);
        } else {
          if (_Utils_eq(editingDivision.an.Fw, $elm$core$Maybe$Just(''))) {
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please select an industry.', _List_Nil);
          } else {
            if (_Utils_eq($elm$core$String$toInt(editingDivision.xt), $elm$core$Maybe$Nothing)) {
              return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please provide the number of employees.', _List_Nil);
            } else {
              if (!division.$) {
                var id = division.a.F;
                return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$UpdateDivision, companyId, id, $author$project$Ui$EditingDivision$Model$toUpdateDivisionInput(editingDivision)));
              } else {
                var _v6 = $author$project$Ui$EditingDivision$Model$toCreateDivisionInput(editingDivision);

                if (!_v6.$) {
                  var input = _v6.a;
                  return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CreateDivision, companyId, input));
                } else {
                  var err = _v6.a;
                  return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
                }
              }
            }
          }
        }
      }();

      var industries = A2($elm$core$Maybe$withDefault, _List_Nil, $krisajenkins$remotedata$RemoteData$toMaybe(topState.o_.CT.qP));

      var description = function (classes) {
        return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (label) {
          return $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
            vV: classes,
            y$: label
          });
        }, function () {
          var _v3 = A2($elm$core$Maybe$map, $author$project$Types$Division$toDivisionStatus, division);

          if (!_v3.$) {
            if (_v3.a === 2) {
              var _v4 = _v3.a;
              return $elm$core$Maybe$Just('The division has been added and we are now syncing data to Puffin. In the meantime, please add or edit the following information.');
            } else {
              return $elm$core$Maybe$Nothing;
            }
          } else {
            return $elm$core$Maybe$Just('Basic Info');
          }
        }()));
      };

      var _v1 = function () {
        if (isNewSyncing) {
          return _Utils_Tuple3('New Division Added', 'Skip', 'Save Division');
        } else {
          var _v2 = A2($elm$core$Maybe$map, $author$project$Types$Division$toDivisionStatus, division);

          if (_v2.$ === 1) {
            return _Utils_Tuple3('Add Division', 'Cancel', 'Save');
          } else {
            return _Utils_Tuple3('Edit Division', 'Cancel', 'Save');
          }
        }
      }();

      var title = _v1.a;
      var cancelLabel = _v1.b;
      var acceptLabel = _v1.c;
      return $author$project$UiWrappers$DialogModal$dialogModal({
        ar: acceptLabel,
        as: cancelLabel,
        pD: _List_fromArray([description('w70 center marAuto marTop3'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceAround marTop2 marBottom4 marLeft8 marRight8')]), _List_fromArray([$author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'flex1',
          E: $elm$core$Maybe$Just('Name'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSettings, $author$project$Ui$Settings$Msg$EditingDivisionMsg), $author$project$Ui$EditingDivision$Msg$SetName),
          e3: '',
          gx: false,
          Fw: editingDivision.zL
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 marLeft2')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text('Industry')])), $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
          kG: '',
          pY: 'Industry',
          yM: false,
          yW: false,
          Ac: $elm$core$Maybe$Nothing,
          Ar: $elm$core$Maybe$Nothing,
          Aw: $elm$core$Maybe$Nothing,
          e_: function (string) {
            return $author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$EditingDivisionMsg($author$project$Ui$EditingDivision$Msg$SetIndustry({
              nU: string,
              Fw: editingDivision.an.Fw
            })));
          },
          BE: function (selected) {
            return $author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$EditingDivisionMsg($author$project$Ui$EditingDivision$Msg$SetIndustry({
              nU: editingDivision.an.nU,
              Fw: $elm$core$Maybe$Just(selected)
            })));
          },
          e3: 'Industry',
          C5: $elm$core$Basics$always($author$project$ElmFramework$Lib$Util$noOpEl),
          C6: $elm$core$Basics$identity,
          C7: $elm$core$Maybe$Just(A2($elm$core$List$filter, function (industry) {
            return A2($elm$core$String$contains, editingDivision.an.nU, $elm$core$String$toLower(industry));
          }, industries)),
          ia: editingDivision.an.Fw,
          Fw: editingDivision.an.nU
        })])), $author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'flex1 marLeft2',
          E: $elm$core$Maybe$Just('Number of Employees'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSettings, $author$project$Ui$Settings$Msg$EditingDivisionMsg), $author$project$Ui$EditingDivision$Msg$SetEmployeeCount),
          e3: '00',
          gx: false,
          Fw: editingDivision.xt
        })])), overlayDivisionName('gray40 center marBottom4')]),
        av: onAcceptTap,
        aw: onCancelTap,
        Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
        t1: title
      });
    }
  });

  var $author$project$Ui$EditingUsers$Msg$SetEditingUsers = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$UpdateInvitation = F3(function (a, b, c) {
    return {
      $: 19,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$Ui$DisabledInputBtn$disabledInput = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray40 heading5Bold')]), _List_fromArray([$elm$html$Html$text(cfg.zL)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween gray10Back gray40 heading4Bold radius0  padTop1h padBottom1h padRight2 padLeft2 ')]), _List_fromArray([$elm$html$Html$text(cfg.EH)]))]));
  };

  var $author$project$Types$Role$inviteUserList = _List_fromArray([4, 6]);

  var $author$project$Types$EditingUsers$setRoleInDialog = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      nO: $elm$core$Maybe$Just(val)
    });
  });
  var $author$project$Types$EditingUsers$setSearchRoleInDialog = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      nW: val
    });
  });

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$Types$Role$toString = function (role) {
    switch (role) {
      case 0:
        return 'Account Analyst';

      case 1:
        return 'Account Manager';

      case 2:
        return 'Administrator';

      case 7:
        return 'User';

      case 3:
        return 'Anonymous';

      case 4:
        return 'Business Administrator';

      case 5:
        return 'Business Owner';

      default:
        return 'Business Viewer';
    }
  };

  var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');

  var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');

  var $author$project$IconSvg$update_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M32 8V17.3333H22.6667L26.6 13.4C24.9067 11.72 22.5733 10.6667 20 10.6667C14.8533 10.6667 10.6667 14.8533 10.6667 20C10.6667 25.1467 14.8533 29.3333 20 29.3333C25.1467 29.3333 29.3333 25.1467 29.3333 20H32C32 26.6267 26.6267 32 20 32C13.3733 32 8 26.6267 8 20C8 13.3733 13.3733 8 20 8C23.32 8 26.32 9.34667 28.48 11.52L32 8ZM18.6667 21.3333V14.6667H20.6667V20.2L25.36 22.9867L24.3333 24.6933L18.6667 21.3333Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$update = function (classes) {
    return $author$project$IconSvg$update_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$OverLaysView$editInvitationCompanyUsersOverLay = F2(function (_v0, editingUsers) {
    var companyId = _v0.b9;
    var invitation = _v0.i_;
    var email = _v0.iP;

    var editUserMsg = function () {
      var _v2 = editingUsers.nO;

      if (!_v2.$) {
        var role = _v2.a;
        return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$UpdateInvitation, companyId, invitation.F, {
          gz: role
        }));
      } else {
        return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please select a role', _List_Nil);
      }
    }();

    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Save',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3 minW64')]), _List_fromArray([$author$project$Ui$DisabledInputBtn$disabledInput({
        vV: '',
        zL: 'User E-mail',
        EH: email
      })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marBottom6')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
        vV: 'gray40',
        y$: 'Role'
      }), $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
        kG: '',
        pY: 'Recently Used',
        yM: false,
        yW: false,
        Ac: $elm$core$Maybe$Nothing,
        Ar: $elm$core$Maybe$Nothing,
        Aw: $elm$core$Maybe$Nothing,
        e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers), $author$project$Types$EditingUsers$setSearchRoleInDialog(editingUsers)),
        BE: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers), $author$project$Types$EditingUsers$setRoleInDialog(editingUsers)),
        e3: 'Select User Role',
        C5: function (_v1) {
          return $author$project$IconSvg$update('h3 w3 gray20Fill');
        },
        C6: $author$project$Types$Role$toString,
        C7: $elm$core$Maybe$Just($author$project$Types$Role$inviteUserList),
        ia: editingUsers.nO,
        Fw: editingUsers.nW
      })]))]),
      av: editUserMsg,
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Edit User'
    });
  });
  var $author$project$Remote$RequestMsg$SaveBlockQuickEditsForScenario = F2(function (a, b) {
    return {
      $: 54,
      a: a,
      b: b
    };
  });
  var $turboMaCk$any_set$Set$Any$diff = F2(function (_v0, _v1) {
    var d1 = _v0;
    var d2 = _v1;
    return A2($turboMaCk$any_dict$Dict$Any$diff, d1, d2);
  });

  var $author$project$Route$RouteUtil$isCashboardRoute = function (route) {
    if (route.$ === 5 && !route.b.$) {
      var _v1 = route.b;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Api$Types$EditBlockReq$Clone = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Api$Types$EditBlockReq$setCloning = F2(function (scenarioIds, req) {
    return _Utils_update(req, {
      hP: $author$project$Api$Types$EditBlockReq$Clone(scenarioIds)
    });
  });
  var $author$project$ElmFramework$Lib$Ui$SwitchDropdown$CustomLabels = $elm$core$Basics$identity;
  var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');

  var $author$project$ElmFramework$Lib$Ui$Switch$checkedStyleLayer = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread maxRadius opacityTransition'), $elm$html$Html$Attributes$class(config.pr), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !config.hE)]))]), _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$Switch$ratioToPercentageString = function (_float) {
    return $elm$core$String$fromFloat(_float * 100) + '%';
  };

  var $author$project$ElmFramework$Lib$Ui$Switch$toCheckedOffset = function (ratio) {
    return (1 - ratio) / ratio * 100;
  };

  var $author$project$ElmFramework$Lib$Ui$Switch$handle = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0 left0 square transformTransition'), A2($elm$html$Html$Attributes$style, 'width', $author$project$ElmFramework$Lib$Ui$Switch$ratioToPercentageString(config.jQ)), config.hE ? A2($elm$html$Html$Attributes$style, 'transform', 'translateX(' + ($elm$core$String$fromFloat($author$project$ElmFramework$Lib$Ui$Switch$toCheckedOffset(config.jQ)) + '%)')) : A2($elm$html$Html$Attributes$style, 'transform', 'translateX(0%)')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread circle'), $elm$html$Html$Attributes$class(config.ub), A2($elm$html$Html$Attributes$style, 'transform', 'scale(' + ($elm$core$String$fromFloat(config.lA) + ')'))]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread circle'), $elm$html$Html$Attributes$class(config.pq), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !config.hE)])), A2($elm$html$Html$Attributes$style, 'transform', 'scale(' + ($elm$core$String$fromFloat(config.lA) + ')'))]), _List_Nil)]));
  };

  var $author$project$ElmFramework$Lib$Ui$Switch$heightSetter = function (sizeRatio) {
    return A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'padding-top', $author$project$ElmFramework$Lib$Ui$Switch$ratioToPercentageString(sizeRatio))]), _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$Switch$uncheckedStyleLayer = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread maxRadius'), $elm$html$Html$Attributes$class(config.uc)]), _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$Switch$switch = function (config) {
    return A3($elm$html$Html$node, 'switch-el', _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock relative noFontSize pointer'), $elm$html$Html$Attributes$class(config.vV), $author$project$ElmFramework$Lib$Util$onTap(config.tU)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Switch$heightSetter(config.jQ), $author$project$ElmFramework$Lib$Ui$Switch$uncheckedStyleLayer(config), $author$project$ElmFramework$Lib$Ui$Switch$checkedStyleLayer(config), $author$project$ElmFramework$Lib$Ui$Switch$handle(config), A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$type_('checkbox'), $elm$html$Html$Attributes$class('absolute top0 left0 z1 o0 fullWidth fullHeight pointer'), $elm$html$Html$Attributes$checked(config.hE), $elm$html$Html$Attributes$required(config.yW)]), _List_Nil)]));
  };

  var $author$project$Ui$Switch$switch = function (config) {
    var _v0 = _Utils_Tuple2('gray10Back', 'primary20Back');

    var uncheckedLayerClasses = _v0.a;
    var checkedLayerClasses = _v0.b;
    return $author$project$ElmFramework$Lib$Ui$Switch$switch({
      pq: 'whiteBack',
      pr: checkedLayerClasses,
      vV: 'w6 ' + config.vV,
      lA: 0.67,
      hE: config.hE,
      yW: config.yW,
      jQ: 0.5,
      tU: config.tU,
      ub: 'primary30Back',
      uc: uncheckedLayerClasses
    });
  };

  var $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownBodyView = function (config) {
    return A3($elm$html$Html$node, 'dropdown-body', _List_fromArray([$elm$html$Html$Attributes$class(config.kG)]), function () {
      var _v0 = config.e0;

      if (!_v0.$) {
        var options = _v0.a;
        return A2($elm$core$List$map, config.Cg, $turboMaCk$any_dict$Dict$Any$toList(options));
      } else {
        return _List_fromArray([config.Ec]);
      }
    }());
  };

  var $elm$html$Html$label = _VirtualDom_node('label');

  var $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownOptionView = function (config) {
    return A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class(config.kG)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.y0)]), _List_fromArray([$elm$html$Html$text(config.Fw)])), config.EA]));
  };

  var $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownTitleView = function (config) {
    return A3($elm$html$Html$node, 'dropdown-title', _List_fromArray([$elm$html$Html$Attributes$class(config.kG)]), config.ES);
  };

  var $elm$core$Dict$sizeHelp = F2(function (n, dict) {
    sizeHelp: while (true) {
      if (dict.$ === -2) {
        return n;
      } else {
        var left = dict.d;
        var right = dict.e;
        var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
            $temp$dict = left;
        n = $temp$n;
        dict = $temp$dict;
        continue sizeHelp;
      }
    }
  });

  var $elm$core$Dict$size = function (dict) {
    return A2($elm$core$Dict$sizeHelp, 0, dict);
  };

  var $turboMaCk$any_dict$Dict$Any$size = function (_v0) {
    var dict = _v0.bT;
    return $elm$core$Dict$size(dict);
  };

  var $turboMaCk$any_set$Set$Any$size = function (_v0) {
    var dict = _v0;
    return $turboMaCk$any_dict$Dict$Any$size(dict);
  };

  var $author$project$ElmFramework$Lib$Ui$SwitchDropdown$toSelectStringBehaviour = function (config) {
    var selectedValuesView = function (value) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.Fx)]), _List_fromArray([$elm$html$Html$text(value)]));
    };

    var placeholderWhileLoadingView = function (_v5) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.nj)]), _List_fromArray([$elm$html$Html$text(config.ni)]));
    };

    var placeholderView = function (_v4) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.Cr)]), _List_fromArray([$elm$html$Html$text(config.e3)]));
    };

    var baseBehaviour = function (_v3) {
      var allLabel = _v3.uE;
      var noneLabel = _v3.zT;
      var _v1 = config.e0;

      if (_v1.$ === 1) {
        return placeholderWhileLoadingView(0);
      } else {
        var options = _v1.a;

        if ($turboMaCk$any_set$Set$Any$isEmpty(config.ia)) {
          return placeholderView(0);
        } else {
          var defaultBehaviourStringValue = _Utils_eq($turboMaCk$any_set$Set$Any$size(config.ia), $turboMaCk$any_dict$Dict$Any$size(options)) ? allLabel : !$turboMaCk$any_set$Set$Any$size(config.ia) ? noneLabel : A2($elm$core$String$join, ', ', A2($elm$core$List$map, config.t3, $turboMaCk$any_dict$Dict$Any$values(A2($turboMaCk$any_dict$Dict$Any$filter, F2(function (key, _v2) {
            return A2($turboMaCk$any_set$Set$Any$member, key, config.ia);
          }), options))));
          return $elm$core$String$isEmpty(defaultBehaviourStringValue) ? placeholderView(0) : selectedValuesView(defaultBehaviourStringValue);
        }
      }
    };

    var _v0 = config.n$;
    var labels = _v0;
    return baseBehaviour(labels);
  };

  var $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownView = function (config) {
    return A3($elm$html$Html$node, 'custom-select', _List_fromArray([$elm$html$Html$Attributes$class('block relative'), $elm$html$Html$Attributes$class(config.kG), A2($elm$html$Html$Attributes$attribute, 'classes-when-opened', config.vW)]), _List_fromArray([A3($elm$html$Html$node, 'dropdown-wrapper', _List_fromArray([$elm$html$Html$Attributes$class('block absolute maxH0 noOverflow'), $elm$html$Html$Attributes$class(config.xg)]), _List_fromArray([A3($elm$html$Html$node, 'dropdown-element', _List_fromArray([$elm$html$Html$Attributes$class('block'), $elm$html$Html$Attributes$class(config.xa)]), _List_fromArray([config.ER, config.vu]))])), A3($elm$html$Html$node, 'select-element', _List_fromArray([$elm$html$Html$Attributes$class('relative  flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(config.DJ)]), A2($elm$core$List$cons, $author$project$ElmFramework$Lib$Ui$SwitchDropdown$toSelectStringBehaviour({
      e0: config.e0,
      e3: config.e3,
      Cr: config.Cr,
      ni: config.ni,
      nj: config.nj,
      ia: config.ia,
      n$: config.n$,
      t3: config.t3,
      Fx: config.Fx
    }), _List_fromArray([A3($elm$html$Html$node, 'open-icon', _List_fromArray([$elm$html$Html$Attributes$class('block flexRow flexAlignCenter noPointerEvents')]), _List_fromArray([config.Cd]))])))]));
  };

  var $author$project$Ui$Button$button = function (config) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.f9, _List_fromArray([$elm$html$Html$Attributes$class(config.kG)]), _List_fromArray([config.pD]));
  };

  var $author$project$Ui$Button$textButton = function (cfg) {
    return $author$project$Ui$Button$button({
      kG: cfg.vV,
      pD: $elm$html$Html$text(cfg.kz),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.gi)
    });
  };

  var $author$project$Ui$SwitchDropdown$switchDropdown = function (config) {
    var titleTextButton = F2(function (label, msg) {
      return $author$project$Ui$Button$textButton({
        kz: label,
        vV: 'pad2 heading4Bold',
        gi: msg
      });
    });

    var dropdownTitle = function () {
      var middleButton = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (_v1) {
        var title = _v1.a;
        var msg = _v1.b;
        return A2(titleTextButton, title, msg);
      }, config.zy));
      return $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownTitleView({
        kG: 'flexRow flexAlignCenter spaceBetween',
        ES: _List_fromArray([A2(titleTextButton, 'Select All', config.BF), middleButton, A2(titleTextButton, 'Clear All', config.Ad)])
      });
    }();

    var dropdownBody = $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownBodyView({
      kG: 'block',
      Cg: function (_v0) {
        var id = _v0.a;
        var option = _v0.b;
        return $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownOptionView({
          kG: 'flexRow spaceBetween pointer padLeft2 padRight2 padTop1h padBottom1h flexAlignCenter',
          y0: 'heading4Regular',
          EA: $author$project$Ui$Switch$switch({
            vV: '',
            hE: A2($turboMaCk$any_set$Set$Any$member, id, config.ia),
            yW: true,
            tU: A2(config.BX, id, option)
          }),
          Fw: config.t3(option)
        });
      },
      e0: config.e0,
      Ec: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 padBottom2')]), _List_fromArray([$author$project$Ui$SimpleSpinner$simpleSpinner]))
    });
    return $author$project$ElmFramework$Lib$Ui$SwitchDropdown$switchDropdownView({
      vu: dropdownBody,
      kG: 'h6 heading4Bold borderHairlineWidth borderSolid gray20Border radius0 ' + config.kG,
      vW: 'z4',
      xa: 'whiteBack',
      xg: 'left0 top0 padTop6 radius0 fullWidth heading4Regular primary30',
      Cd: $author$project$IconSvg$down('w3 h3 primary30Fill z1'),
      e0: config.e0,
      e3: config.e3,
      Cr: 'gray40',
      ni: config.e3,
      nj: 'gray40',
      DJ: 'padLeft2 padRight2 fullWidth fullHeight spaceBetween pointer',
      ia: config.ia,
      n$: {
        uE: config.uE,
        zT: config.zT
      },
      ER: dropdownTitle,
      t3: config.t3,
      Fx: 'primary30 ellipsis basis'
    });
  };

  var $author$project$Ui$OverLaysView$editMasterBuildingBlockOverLay = F5(function (company, topState, blockId, maybeScenarioId, scenarioIds) {
    var unselected = topState.o_.vh.p$;
    var selectedNothing = A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Scenario$unwrapScenarioId, scenarioIds);
    var selected = A2($turboMaCk$any_set$Set$Any$diff, selectedNothing, unselected);
    var scenarioDict = A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Scenario$unwrapScenarioId, A2($elm$core$List$map, function (id) {
      return _Utils_Tuple2(id, id);
    }, scenarioIds));
    var onChange = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$SetEditMasterblockScenarios);
    var scenarioMultiSelect = $author$project$Ui$SwitchDropdown$switchDropdown({
      uE: 'All Scenarios',
      kG: 'flex1',
      zy: A2($elm$core$Maybe$map, function (id) {
        return _Utils_Tuple2('This Scenario Only', onChange(A2($turboMaCk$any_set$Set$Any$toggle, id, selectedNothing)));
      }, maybeScenarioId),
      zT: 'No Scenario Selected',
      Ad: onChange(selectedNothing),
      BF: onChange($turboMaCk$any_set$Set$Any$empty($author$project$Types$Scenario$unwrapScenarioId)),
      BX: F2(function (id, _v1) {
        return onChange(A2($turboMaCk$any_set$Set$Any$toggle, id, unselected));
      }),
      e0: $elm$core$Maybe$Just(scenarioDict),
      e3: 'Scenarios',
      ia: selected,
      t3: function (id) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function ($) {
          return $.zL;
        }, A2($author$project$Types$Company$toScenario, id, company)));
      }
    });
    var onCancel = $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog);

    var onAccept = function () {
      var isCashboardRoute = $author$project$Route$RouteUtil$isCashboardRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc));

      var maybeRequest = function () {
        var _v0 = _Utils_Tuple2(isCashboardRoute, maybeScenarioId);

        if (_v0.a) {
          if (!_v0.b.$) {
            var scenarioId = _v0.b.a;
            return $elm$core$Maybe$Just($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SaveBlockQuickEditsForScenario, company.F, {
              dM: blockId,
              e8: scenarioId,
              ud: $turboMaCk$any_set$Set$Any$toList(selected)
            })));
          } else {
            return $elm$core$Maybe$Nothing;
          }
        } else {
          return $elm$core$Result$toMaybe(A2($elm$core$Result$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, A3($author$project$Remote$RequestMsg$UpdateBlock, company.F, maybeScenarioId, blockId)), A2($elm$core$Result$map, A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Basics$identity, $author$project$Api$Types$EditBlockReq$setCloning($turboMaCk$any_set$Set$Any$toList(selected)), $turboMaCk$any_set$Set$Any$isEmpty(unselected)), A2($elm$core$Result$map, $author$project$Api$Types$EditBlockReq$fromCreateBlockReqWithDefaultMultipleScenariosAction, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toCreateBuildingBlockReq, company, topState.o_.vh.bv)))));
        }
      }();

      return A2($elm$core$Maybe$withDefault, A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Could not build request', _List_Nil), maybeRequest);
    }();

    var blockName = A2($elm$core$Maybe$withDefault, 'This block', A2($elm$core$Maybe$map, function (name) {
      return '\"' + (name + '\"');
    }, A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, A2($author$project$Types$Company$toBuildingBlock, blockId, company))));
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Save Changes',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop4 marLeft12 marRight12 marBottom12')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'center maxW46',
        y$: blockName + ' is being used on more than one scenario.'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'padTop3 padBottom2 primary30 center',
        y$: 'Select where you would like the changes applied to:'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
        vV: 'primary30',
        y$: 'Apply Changes to:'
      }), scenarioMultiSelect]))]),
      av: onAccept,
      aw: onCancel,
      Aj: onCancel,
      t1: 'Editing Master Block'
    });
  });
  var $author$project$Remote$RequestMsg$UpdateUserInCompany = F3(function (a, b, c) {
    return {
      $: 24,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$OverLaysView$editUserCompanyUsersOverLay = F2(function (_v0, editingUsers) {
    var user = _v0.Fl;
    var companyId = _v0.b9;

    var editUserMsg = function () {
      var _v2 = editingUsers.nO;

      if (!_v2.$) {
        var role = _v2.a;
        return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$UpdateUserInCompany, companyId, user.F, {
          gz: role
        }));
      } else {
        return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please select a role', _List_Nil);
      }
    }();

    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Save',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3 minW64')]), _List_fromArray([$author$project$Ui$DisabledInputBtn$disabledInput({
        vV: '',
        zL: 'User E-mail',
        EH: user.iP
      })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marBottom6')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
        vV: 'gray40',
        y$: 'Role'
      }), $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
        kG: '',
        pY: 'Recently Used',
        yM: false,
        yW: false,
        Ac: $elm$core$Maybe$Nothing,
        Ar: $elm$core$Maybe$Nothing,
        Aw: $elm$core$Maybe$Nothing,
        e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers), $author$project$Types$EditingUsers$setSearchRoleInDialog(editingUsers)),
        BE: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers), $author$project$Types$EditingUsers$setRoleInDialog(editingUsers)),
        e3: 'Select User Role',
        C5: function (_v1) {
          return $author$project$IconSvg$update('h3 w3 gray20Fill');
        },
        C6: $author$project$Types$Role$toString,
        C7: $elm$core$Maybe$Just($author$project$Types$Role$inviteUserList),
        ia: editingUsers.nO,
        Fw: editingUsers.nW
      })]))]),
      av: editUserMsg,
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Edit User'
    });
  });
  var $author$project$Remote$RequestMsg$UpdateInvitationAndResend = F3(function (a, b, c) {
    return {
      $: 20,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$OverLaysView$resendInviteCompanyUsersOverLay = F2(function (_v0, editingUsers) {
    var companyId = _v0.b9;
    var invitation = _v0.i_;
    var email = _v0.iP;

    var resendInviteMsg = function () {
      var _v2 = editingUsers.nO;

      if (!_v2.$) {
        var role = _v2.a;
        return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$UpdateInvitationAndResend, companyId, invitation.F, {
          gz: role
        }));
      } else {
        return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please select a role', _List_Nil);
      }
    }();

    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Invite User',
      as: 'Cancel',
      pD: function () {
        var title = function (titleText) {
          return $author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
            vV: 'gray40',
            y$: titleText
          });
        };

        var roleInput = $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
          kG: '',
          pY: 'Recently Used',
          yM: false,
          yW: false,
          Ac: $elm$core$Maybe$Nothing,
          Ar: $elm$core$Maybe$Nothing,
          Aw: $elm$core$Maybe$Nothing,
          e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers), $author$project$Types$EditingUsers$setSearchRoleInDialog(editingUsers)),
          BE: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers), $author$project$Types$EditingUsers$setRoleInDialog(editingUsers)),
          e3: 'Select User Role',
          C5: function (_v1) {
            return $author$project$IconSvg$update('h3 w3 gray20Fill');
          },
          C6: $author$project$Types$Role$toString,
          C7: $elm$core$Maybe$Just($author$project$Types$Role$inviteUserList),
          ia: editingUsers.nO,
          Fw: ''
        });
        var roleContainer = $elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class('flexColumn marBottom6')]));

        var emailInput = function (emailAddress) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3')]), _List_fromArray([$author$project$Ui$DisabledInputBtn$disabledInput({
            vV: '',
            zL: 'User E-mail',
            EH: emailAddress
          })]));
        };

        return _List_fromArray([emailInput(email), roleContainer(_List_fromArray([title('Role'), roleInput]))]);
      }(),
      av: resendInviteMsg,
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Resend Invitation'
    });
  });
  var $author$project$Remote$RequestMsg$ResetFinancialAccountBalanceOnDate = F3(function (a, b, c) {
    return {
      $: 37,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$ResetFinancialAccountBalanceOnDateReq = F2(function (id, date) {
    return {
      iL: date,
      F: id
    };
  });
  var $author$project$Ui$OverLaysView$resetAccountInfoFinancialAccountsDialog = F4(function (companyId, divisionId, accountId, balance) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Reset Info',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW46 flexColumn flexAlignCenter justifyCenter marRight9 marLeft9 marTop4 marBottom5 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'center marBottom2',
        y$: 'Are you sure you want to reset to latest automatic sync?'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 center',
        y$: 'This will override your latest updates.'
      })]))]),
      av: $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$ResetFinancialAccountBalanceOnDate, companyId, divisionId, A2($author$project$Api$Types$ResetFinancialAccountBalanceOnDateReq, accountId, balance.o$))),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A5($author$project$Global$Model$EditAccountBalance, $elm$core$Maybe$Nothing, companyId, divisionId, accountId, balance))),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A5($author$project$Global$Model$EditAccountBalance, $elm$core$Maybe$Nothing, companyId, divisionId, accountId, balance))),
      t1: 'Reset Info'
    });
  });
  var $author$project$Remote$RequestMsg$HideUpdateSeasonalityPresetDialog = 1;
  var $author$project$Remote$RequestMsg$UpdateSeasonalityPreset = F4(function (a, b, c, d) {
    return {
      $: 70,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Api$Types$UpdateSeasonalityReq$UpdateSeasonalityPresetReq = F2(function (name, monthAdjustments) {
    return {
      dW: monthAdjustments,
      zL: name
    };
  });
  var $author$project$Ui$OverLaysView$saveSeasonalityPresetDialog = F5(function (topState, companyId, seasonalityId, presetName, monthAdjustments) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Save',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeftAuto marRightAuto center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Are you sure you want to update this pre-set?'
      })]))]),
      av: $author$project$TopMsg$requestMsg(A4($author$project$Remote$RequestMsg$UpdateSeasonalityPreset, $elm$core$Maybe$Just(1), companyId, seasonalityId, A2($author$project$Api$Types$UpdateSeasonalityReq$UpdateSeasonalityPresetReq, presetName, monthAdjustments))),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Save Seasonality Preset'
    });
  });

  var $author$project$Ui$OverLaysView$syncAccountError = function (companyId) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Try Again',
      as: 'Cancel & Back',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Oops, something went wrong'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
        y$: 'It looks like we couldn\'t sync your account.'
      })]))]),
      av: $author$project$TopMsg$msgRemote(A2($author$project$Remote$Msg$OpenQuickBooksAccounting, companyId, $elm$core$Maybe$Nothing)),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Error'
    });
  };

  var $author$project$Ui$OverLaysView$unLinkDivisionConfirmation = F3(function (companyId, accountingDivisionId, divisionId) {
    return $author$project$UiWrappers$DialogModal$dialogModal({
      ar: 'Stop Syncing',
      as: 'Cancel',
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Are you sure you want to stop syncing this Division with Quickbooks?'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
        vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
        y$: 'The Chart of Accounts and the Account Balances for this Division will no longer be synchronized with Quickbooks. Also, re-syncing with the same Quickbooks Account in the future may create duplicate data.'
      })]))]),
      av: $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$DisconnectDivision, companyId, accountingDivisionId, divisionId)),
      aw: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      Aj: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
      t1: 'Stop Syncing'
    });
  });

  var $author$project$MainModule$modal = function (topState) {
    var editingUsers = topState.o_.xn;
    var _v0 = topState.o_.qC.gZ;

    if (!_v0.$) {
      var dialogType = _v0.a;

      switch (dialogType.$) {
        case 0:
          var company = dialogType.a.j;
          var allocationClassId = dialogType.a.fu;
          return A2($author$project$Ui$OverLaysView$deleteCategoryDialog, company, allocationClassId);

        case 3:
          var resendInviteData = dialogType.a;
          return A2($author$project$Ui$OverLaysView$resendInviteCompanyUsersOverLay, resendInviteData, editingUsers);

        case 4:
          var editUserData = dialogType.a;
          return A2($author$project$Ui$OverLaysView$editUserCompanyUsersOverLay, editUserData, editingUsers);

        case 5:
          var editInvitationData = dialogType.a;
          return A2($author$project$Ui$OverLaysView$editInvitationCompanyUsersOverLay, editInvitationData, editingUsers);

        case 6:
          var removeData = dialogType.a;
          return $author$project$Ui$OverLaysView$confirmRemoveUserCompanyUsersOverlay(removeData);

        case 1:
          var company = dialogType.a;
          var block = dialogType.b;
          return A2($author$project$Ui$OverLaysView$deleteBlockConfirmationDialog, company, block);

        case 2:
          var company = dialogType.a;
          var blockId = dialogType.b;
          var scenarioId = dialogType.c;
          var scenarioIds = dialogType.d;
          return A5($author$project$Ui$OverLaysView$editMasterBuildingBlockOverLay, company, topState, blockId, scenarioId, scenarioIds);

        case 7:
          var maybeSubDialog = dialogType.a;
          var companyId = dialogType.b;
          var divisionId = dialogType.c;
          var financialAccountId = dialogType.d;
          var balance = dialogType.e;
          return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A5($author$project$Ui$OverLaysView$editAccountBalanceFinancialAccountsDialog, topState, companyId, divisionId, financialAccountId, balance), function () {
            if (!maybeSubDialog.$) {
              var subDialog = maybeSubDialog.a;
              return _List_fromArray([A4($author$project$Ui$OverLaysView$resetAccountInfoFinancialAccountsDialog, companyId, divisionId, financialAccountId, balance)]);
            } else {
              return _List_Nil;
            }
          }()));

        case 8:
          var companyId = dialogType.a;
          var seasonalityId = dialogType.b;
          var presetName = dialogType.c;
          var monthAdjustments = dialogType.d;
          return A5($author$project$Ui$OverLaysView$saveSeasonalityPresetDialog, topState, companyId, seasonalityId, presetName, monthAdjustments);

        case 9:
          var companyId = dialogType.a;
          var seasonalityId = dialogType.b;
          return A3($author$project$Ui$OverLaysView$deleteSeasonalityPresetDialog, topState, companyId, seasonalityId);

        case 10:
          var companyId = dialogType.a;
          var monthAdjustments = dialogType.b;
          return A3($author$project$Ui$OverLaysView$createSeasonalityPresetDialog, topState, companyId, monthAdjustments);

        case 14:
          var companyId = dialogType.a;
          var division = dialogType.b;
          return A4($author$project$Ui$OverLaysView$editDivisionOverlay, topState, companyId, $elm$core$Maybe$Just(division), false);

        case 15:
          var companyId = dialogType.a;
          return A4($author$project$Ui$OverLaysView$editDivisionOverlay, topState, companyId, $elm$core$Maybe$Nothing, false);

        case 16:
          var companyId = dialogType.a;
          var division = dialogType.b;
          return A4($author$project$Ui$OverLaysView$editDivisionOverlay, topState, companyId, $elm$core$Maybe$Just(division), true);

        case 11:
          var companyId = dialogType.a;
          var division = dialogType.b;
          return A2($author$project$Ui$OverLaysView$deleteDivisionConfirmationDialog, companyId, division);

        case 12:
          var companyId = dialogType.a;
          var accountingDivisionId = dialogType.b;
          var divisionId = dialogType.c;
          return A3($author$project$Ui$OverLaysView$unLinkDivisionConfirmation, companyId, accountingDivisionId, divisionId);

        case 13:
          var companyId = dialogType.a;
          return $author$project$Ui$OverLaysView$syncAccountError(companyId);

        case 17:
          var companyId = dialogType.a;
          var scenario = dialogType.b;
          return A2($author$project$Ui$OverLaysView$duplicateScenarioConfirmationDialog, companyId, scenario);

        default:
          var companyId = dialogType.a;
          var scenario = dialogType.b;
          return A2($author$project$Ui$OverLaysView$deleteScenarioConfirmationDialog, companyId, scenario);
      }
    } else {
      return $author$project$ElmFramework$Lib$Util$noOpEl;
    }
  };

  var $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle = function (config) {
    var showSubtitle = function () {
      var _v0 = config.tQ;

      if (!_v0.$) {
        switch (_v0.a.$) {
          case 0:
            var theSubtitle = _v0.a.a;
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop2 gray60 bodyRegular')]), _List_fromArray([$elm$html$Html$text(theSubtitle)]));

          case 1:
            var theSubtitle = _v0.a.a;
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop2 primary30 heading4Regular')]), _List_fromArray([$elm$html$Html$text(theSubtitle)]));

          default:
            var theSubtitle = _v0.a.a;
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2 marBottom2 black heading4Regular')]), _List_fromArray([$elm$html$Html$text(theSubtitle)]));
        }
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.pv), $elm$html$Html$Attributes$class('heading2Bold primary30')]), _List_fromArray([$elm$html$Html$text(config.t1)])), showSubtitle]));
  };

  var $author$project$Ui$Auth$Msg$RouteTo = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Views$Routed$AuthBranch$routeToAuthStep = function (authStep) {
    return $author$project$Msg$sendAuthMsg($author$project$Ui$Auth$Msg$RouteTo($author$project$Route$Route$Auth(authStep)));
  };

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$signInRegisterOption = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn center heading4Bold marTop4')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray40 padBottom1')]), _List_fromArray([$elm$html$Html$text(config.tX)])), $author$project$Ui$Button$textButton({
      kz: config.kz,
      vV: 'primary20',
      gi: config.gi
    })]));
  };

  var $author$project$Views$Routed$AuthBranch$confirmRegistrationContent = function (_v0) {
    var appState = _v0.o_;
    var signInInstead = $author$project$Ui$ComponentsPreview$ComponentsPreview$signInRegisterOption({
      kz: 'Sign In',
      gi: $author$project$Views$Routed$AuthBranch$routeToAuthStep($author$project$Route$Route$SignInWithCredentials),
      tX: ''
    });

    var mainTitle = function (title) {
      return $author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
        pv: '',
        vV: '',
        tQ: $elm$core$Maybe$Nothing,
        t1: title
      });
    };

    var _v1 = appState;
    var authState = _v1.u1;
    var _v2 = authState;
    var registerEmail = _v2.nA;
    var subtitleText = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular center gray40 marTop3')]), _List_fromArray([$elm$html$Html$text('Account with email '), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary30')]), _List_fromArray([$elm$html$Html$text(registerEmail)])), $elm$html$Html$text(' successfully created.')]));
    return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('phoneWidthCenter center')]), _List_fromArray([mainTitle('Account created'), subtitleText, signInInstead]))]);
  };

  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteEmail = 0;
  var $author$project$Ui$Button$ButtonContentIconMild = 2;
  var $author$project$ElmFramework$Lib$Ui$Input$Email = 1;

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$GrayColorSubtitle = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Remote$Msg$SendForgotPasswordCode = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$Button$Submit = {
    $: 0
  };

  var $author$project$IconSvg$arrowLeft_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 32L22.115 29.885L13.745 21.5L32 21.5L32 18.5L13.745 18.5L22.13 10.13L20 8L8 20L20 32Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$arrowLeft = function (classes) {
    return $author$project$IconSvg$arrowLeft_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Views$Routed$AuthBranch$authContainer = function (content) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('phoneWidthCenter pad3')]), content);
  };

  var $elm$html$Html$form = _VirtualDom_node('form');

  var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
    return _Utils_Tuple2(msg, true);
  };

  var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $elm$html$Html$Events$preventDefaultOn = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
  });

  var $elm$html$Html$Events$onSubmit = function (msg) {
    return A2($elm$html$Html$Events$preventDefaultOn, 'submit', A2($elm$json$Json$Decode$map, $elm$html$Html$Events$alwaysPreventDefault, $elm$json$Json$Decode$succeed(msg)));
  };

  var $author$project$Views$Routed$AuthBranch$authForm = function (cfg) {
    return A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('phoneWidthCenter pad3'), $elm$html$Html$Events$onSubmit(cfg.r8)]), cfg.pD);
  };

  var $author$project$Ui$Button$buttonIconContentBasic = function (cfg) {
    var spacing = A2($elm$core$Maybe$withDefault, '0h', cfg.qO);

    var _v0 = function () {
      var _v1 = cfg.tM;

      switch (_v1) {
        case 0:
          return _Utils_Tuple2('primary20 heading4Regular', 'primary20Fill marRight' + spacing);

        case 1:
          return _Utils_Tuple2('heading4Bold gray40', 'gray40Fill marRight' + spacing);

        default:
          return _Utils_Tuple2('gray60 heading4Regular', 'gray60Fill marRight' + spacing);
      }
    }();

    var btnClasses = _v0.a;
    var iconClasses = _v0.b;
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.ew), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(btnClasses), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([cfg.yh('w3 ' + iconClasses), $elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteNewPassword = 1;
  var $author$project$ElmFramework$Lib$Ui$Input$Password = 2;

  var $author$project$Remote$Msg$ResetPassword = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SetPassResetNewPassword = function (a) {
    return {
      $: 18,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SetPassResetNewPasswordRepeat = function (a) {
    return {
      $: 19,
      a: a
    };
  };

  var $author$project$Views$Routed$AuthBranch$createNewPassword = F2(function (topState, verifiedPasswordResetCode) {
    return _List_fromArray([$author$project$Views$Routed$AuthBranch$authForm({
      pD: _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
        pv: '',
        vV: '',
        tQ: $elm$core$Maybe$Nothing,
        t1: 'CREATE YOUR NEW PASSWORD'
      }), $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Just(1),
        vV: 'marTop2',
        E: $elm$core$Maybe$Just('New password'),
        k_: false,
        qU: 2,
        qW: true,
        e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetPassResetNewPassword),
        e3: 'Enter new password',
        gx: true,
        Fw: topState.o_.u1.m9
      }), $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Just(1),
        vV: 'marTop1',
        E: $elm$core$Maybe$Just('New password'),
        k_: false,
        qU: 2,
        qW: true,
        e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetPassResetNewPasswordRepeat),
        e3: 'Re-enter new password',
        gx: true,
        Fw: topState.o_.u1.su
      }), $author$project$Ui$Button$basicButton({
        kG: 'fullWidth primary0 marTop3',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
        y$: 'UPDATE PASSWORD'
      })]),
      r8: _Utils_eq(topState.o_.u1.su, topState.o_.u1.m9) ? $author$project$Msg$sendRemoteMsg($author$project$Remote$Msg$ResetPassword({
        jk: topState.o_.u1.m9,
        sw: verifiedPasswordResetCode
      })) : A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Password\'s don\'t match', _List_Nil)
    })]);
  });
  var $author$project$ElmFramework$Lib$Ui$DramaticView$NoElement = {
    $: 0
  };

  var $author$project$ElmFramework$Lib$Ui$DramaticView$Shown = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DramaticView$dramaticViewCore = F2(function (maybeStyles, element) {
    var toEnteringStyles = function (styles) {
      return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'entering-styles', styles)]);
    };

    var enteringStyles = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, toEnteringStyles, maybeStyles);

    var classes = _List_fromArray([$elm$html$Html$Attributes$class('inheritRadius')]);

    var _v0 = function () {
      if (!element.$) {
        return _Utils_Tuple2(_List_Nil, _List_Nil);
      } else {
        var theElement = element.a;
        return _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$attribute, 'child-state', 'shown')]), _List_fromArray([theElement]));
      }
    }();

    var shouldShow = _v0.a;
    var content = _v0.b;
    return A3($elm$html$Html$node, 'dramatic-view', _Utils_ap(classes, _Utils_ap(shouldShow, enteringStyles)), content);
  });

  var $author$project$ElmFramework$Lib$Ui$DramaticView$dramaticView = function (maybeEl) {
    var element = function () {
      if (!maybeEl.$) {
        var el = maybeEl.a;
        return $author$project$ElmFramework$Lib$Ui$DramaticView$Shown(el);
      } else {
        return $author$project$ElmFramework$Lib$Ui$DramaticView$NoElement;
      }
    }();

    return A2($author$project$ElmFramework$Lib$Ui$DramaticView$dramaticViewCore, $elm$core$Maybe$Nothing, element);
  };

  var $author$project$Ui$Curtain$spinnerEl = function (isBright) {
    var colorClass = isBright ? 'whiteBack' : 'blackBack';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('spinnerContainer relative circle')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-a')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-b')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-c')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-d')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-e')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-f')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-g')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-h')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)]))]));
  };

  var $author$project$Ui$Curtain$curtain = F2(function (isBright, shouldShow) {
    var backgroundColorClass = isBright ? 'brightBack' : 'darkBack';
    return A3($elm$html$Html$node, 'curtain', _List_fromArray([$elm$html$Html$Attributes$class('inheritRadius')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$DramaticView$dramaticView(shouldShow ? $elm$core$Maybe$Just(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('curtainPane z10 o0 flexCenter absoluteSpread inheritRadius'), $elm$html$Html$Attributes$class(backgroundColorClass)]), _List_fromArray([$author$project$Ui$Curtain$spinnerEl(!isBright)]))) : $elm$core$Maybe$Nothing)]));
  });

  var $author$project$Views$Routed$AuthBranch$forgotPasswordView = function (topState) {
    var appState = topState.o_;
    var _v0 = appState;
    var authState = _v0.u1;
    var _v1 = authState;
    var forgotPasswordScreenState = _v1.lt;

    switch (forgotPasswordScreenState.$) {
      case 2:
        return _List_fromArray([$author$project$Views$Routed$AuthBranch$authContainer(_List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
          pv: '',
          vV: 'marTop15',
          tQ: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$TitleTypes$GrayColorSubtitle('Please check your email to reset your password.')),
          t1: 'An email has been sent to you!'
        }), $author$project$Ui$Button$basicButton({
          kG: 'fullWidth primary0 marTop4 marBottom15',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Views$Routed$AuthBranch$routeToAuthStep($author$project$Route$Route$SignInWithCredentials)),
          y$: 'Back to Sign In'
        })]))]);

      case 0:
        var enteredEmail = forgotPasswordScreenState.a;
        return _List_fromArray([$author$project$Views$Routed$AuthBranch$authForm({
          pD: _List_fromArray([$author$project$Ui$Button$buttonIconContentBasic({
            vV: '',
            yh: $author$project$IconSvg$arrowLeft,
            qO: $elm$core$Maybe$Nothing,
            y$: 'Back',
            ew: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
            tM: 2
          }), $author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
            pv: '',
            vV: 'marTop15',
            tQ: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$TitleTypes$GrayColorSubtitle('Please enter your email address below to receive a password reset link.')),
            t1: 'Forgot your Password?'
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Just(0),
            vV: 'marTop2',
            E: $elm$core$Maybe$Just('E-mail'),
            k_: false,
            qU: 1,
            qW: true,
            e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SwitchForgotPasswordState), $author$project$Ui$Auth$Model$EnterForgotPasswordEmail),
            e3: 'E-mail',
            gx: true,
            Fw: enteredEmail
          }), $author$project$Ui$Button$basicButton({
            kG: 'fullWidth primary0 marTop6 marBottom15',
            vY: 0,
            yh: $elm$core$Maybe$Nothing,
            yM: false,
            f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
            y$: 'Reset Password'
          })]),
          r8: $author$project$Msg$sendRemoteMsg($author$project$Remote$Msg$SendForgotPasswordCode(enteredEmail))
        })]);

      case 3:
        var verifiedPasswordResetCode = forgotPasswordScreenState.a;
        return A2($author$project$Views$Routed$AuthBranch$createNewPassword, topState, verifiedPasswordResetCode);

      default:
        return _List_fromArray([A2($author$project$Ui$Curtain$curtain, false, true)]);
    }
  };

  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteFirstName = 3;
  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteLastName = 4;
  var $author$project$Remote$RequestMsg$RedeemInviteWithRegistration = F2(function (a, b) {
    return {
      $: 12,
      a: a,
      b: b
    };
  });

  var $author$project$Remote$Msg$RegisterNewUser = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SetRegisterEmail = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SetRegisterFirstName = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SetRegisterLastName = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$SetRegisterPassword = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Ui$Auth$Msg$ToggleRegisterAcceptTermsAndService = {
    $: 9
  };

  var $author$project$Views$Routed$AuthBranch$registrationContent = function (_v0) {
    var appState = _v0.o_;
    var _v1 = appState;
    var authState = _v1.u1;
    var remote = _v1.CT;
    var _v2 = remote;
    var thisUserAuth = _v2.EL;
    var _v3 = authState;
    var registerFirstName = _v3.nB;
    var registerLastName = _v3.nE;
    var registerEmail = _v3.nA;
    var registerPassword = _v3.nF;
    var registerAcceptTermsAndService = _v3.jA;

    switch (thisUserAuth.$) {
      case 1:
        return _List_fromArray([A2($author$project$Ui$Curtain$curtain, false, true)]);

      case 2:
        return _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_Nil)]);

      case 3:
        return _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_Nil)]);

      default:
        var newUserInput = {
          iP: registerEmail,
          hu: registerFirstName,
          hI: registerLastName,
          sv: registerPassword
        };

        var submitMsg = function () {
          var _v5 = appState.qC.rr;

          if (!_v5.$) {
            var inviteCode = _v5.a;
            return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RedeemInviteWithRegistration, newUserInput, inviteCode));
          } else {
            return $author$project$TopMsg$msgRemote($author$project$Remote$Msg$RegisterNewUser(newUserInput));
          }
        }();

        return _List_fromArray([$author$project$Views$Routed$AuthBranch$authForm({
          pD: _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
            pv: '',
            vV: '',
            tQ: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$TitleTypes$GrayColorSubtitle('Social and ecological entrepreneurs, change-makers, movers, dreamers. We are here for you!  ')),
            t1: 'Create an Account'
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Just(3),
            vV: 'marTop2',
            E: $elm$core$Maybe$Just('First Name'),
            k_: false,
            qU: 0,
            qW: true,
            e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetRegisterFirstName),
            e3: 'First Name',
            gx: true,
            Fw: registerFirstName
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Just(4),
            vV: 'marTop1',
            E: $elm$core$Maybe$Just('Last Name'),
            k_: false,
            qU: 0,
            qW: true,
            e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetRegisterLastName),
            e3: 'Last Name',
            gx: true,
            Fw: registerLastName
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Just(0),
            vV: 'marTop1',
            E: $elm$core$Maybe$Just('Email'),
            k_: false,
            qU: 1,
            qW: true,
            e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetRegisterEmail),
            e3: 'Email',
            gx: true,
            Fw: registerEmail
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Just(1),
            vV: 'padTop1',
            E: $elm$core$Maybe$Just('Create Password'),
            k_: false,
            qU: 2,
            qW: true,
            e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetRegisterPassword),
            e3: 'Create Password',
            gx: true,
            Fw: registerPassword
          }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop8')]), _List_fromArray([$author$project$Ui$Switch$switch({
            vV: '',
            hE: registerAcceptTermsAndService,
            yW: true,
            tU: $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$AuthMsg($author$project$Ui$Auth$Msg$ToggleRegisterAcceptTermsAndService))
          }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold gray40 padLeft2')]), _List_fromArray([$elm$html$Html$text('I accept '), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$author$project$Ui$Button$button({
            kG: 'primary20',
            pD: $elm$html$Html$text('Privacy Policy'),
            f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(1)))
          })])), $elm$html$Html$text(' and '), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$author$project$Ui$Button$button({
            kG: 'primary20',
            pD: $elm$html$Html$text('Terms of use'),
            f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(0)))
          })]))]))])), $author$project$Ui$Button$basicButton({
            kG: 'fullWidth primary0 marTop4',
            vY: 0,
            yh: $elm$core$Maybe$Nothing,
            yM: false,
            f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
            y$: 'Register'
          }), $author$project$Ui$ComponentsPreview$ComponentsPreview$signInRegisterOption({
            kz: 'Sign In Instead',
            gi: $author$project$Views$Routed$AuthBranch$routeToAuthStep($author$project$Route$Route$SignInWithCredentials),
            tX: 'Already have an account?'
          })]),
          r8: submitMsg
        })]);
    }
  };

  var $author$project$Ui$Auth$Msg$AuthWithGoogle = {
    $: 32
  };
  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteCurrPassword = 2;

  var $author$project$Ui$Button$CommonIcon = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Remote$Msg$SignInViaEmail = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$IconSvg$logoGoogle_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.7631 17.75C31.9164 18.5524 32 19.3925 32 20.2699C32.0001 27.125 27.3169 32.0001 20.2452 32.0001C13.4798 32.0001 8 26.6299 8 20C8 13.3701 13.4798 8 20.2452 8C23.5516 8 26.314 9.1924 28.4343 11.1274L24.9821 14.5101V14.5024C23.6965 13.3023 22.0666 12.6874 20.2452 12.6874C16.2045 12.6874 12.9212 16.0324 12.9212 19.9927C12.9212 23.9521 16.2044 27.3051 20.2452 27.3051C23.9112 27.3051 26.4059 25.25 26.9194 22.4302H20.2452V17.75H31.7631Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$logoGoogle = function (classes) {
    return $author$project$IconSvg$logoGoogle_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Views$Routed$AuthBranch$signInWithCredentials = function (_v0) {
    var appState = _v0.o_;
    var _v1 = appState;
    var authState = _v1.u1;
    var _v2 = authState;
    var registerEmail = _v2.nA;
    var registerPassword = _v2.nF;
    return _List_fromArray([$author$project$Views$Routed$AuthBranch$authForm({
      pD: _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
        pv: '',
        vV: '',
        tQ: $elm$core$Maybe$Nothing,
        t1: 'Sign In to your account'
      }), $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Just(0),
        vV: 'marTop1',
        E: $elm$core$Maybe$Just('E-mail'),
        k_: false,
        qU: 1,
        qW: true,
        e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetRegisterEmail),
        e3: 'E-mail',
        gx: true,
        Fw: registerEmail
      }), $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Just(2),
        vV: 'marTop1',
        E: $elm$core$Maybe$Just('Password'),
        k_: false,
        qU: 2,
        qW: true,
        e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg), $author$project$Ui$Auth$Msg$SetRegisterPassword),
        e3: 'Password',
        gx: true,
        Fw: registerPassword
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('right')]), _List_fromArray([$author$project$Ui$Button$button({
        kG: 'primary20 marTop2 heading5Bold',
        pD: $elm$html$Html$text('I forgot my password'),
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Views$Routed$AuthBranch$routeToAuthStep($author$project$Route$Route$ForgotPassword))
      })])), $author$project$Ui$Button$basicButton({
        kG: 'fullWidth primary0 marTop4',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
        y$: 'Sign In'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold center gray40 marTop3')]), _List_fromArray([$elm$html$Html$text('OR SIGN IN WITH')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop3')]), _List_fromArray([$author$project$Ui$Button$basicButton({
        kG: 'primary0 googleBack fullWidth',
        vY: 0,
        yh: $elm$core$Maybe$Just($author$project$Ui$Button$CommonIcon($author$project$IconSvg$logoGoogle)),
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Msg$sendAuthMsg($author$project$Ui$Auth$Msg$AuthWithGoogle)),
        y$: 'Google'
      })])), $author$project$Ui$ComponentsPreview$ComponentsPreview$signInRegisterOption({
        kz: 'Register for an Account',
        gi: $author$project$Views$Routed$AuthBranch$routeToAuthStep($author$project$Route$Route$Register($elm$core$Maybe$Nothing)),
        tX: 'Don\'t have an account yet?'
      })]),
      r8: $author$project$Msg$sendRemoteMsg($author$project$Remote$Msg$SignInViaEmail({
        iP: registerEmail,
        sv: registerPassword
      }))
    })]);
  };

  var $author$project$AssetsImg$assets = {
    yk: require('/home/runner/work/puffin-frontend/puffin-frontend/src/assets/images/img/Image1.jpg'),
    yl: require('/home/runner/work/puffin-frontend/puffin-frontend/src/assets/images/img/image1.png'),
    ym: require('/home/runner/work/puffin-frontend/puffin-frontend/src/assets/images/img/Image2.jpg')
  };

  var $elm$html$Html$img = _VirtualDom_node('img');

  var $elm$html$Html$Attributes$src = function (url) {
    return A2($elm$html$Html$Attributes$stringProperty, 'src', _VirtualDom_noJavaScriptOrHtmlUri(url));
  };

  var $author$project$UiWrappers$VerticalSplit$verticalSplit = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexRow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1'), $elm$html$Html$Attributes$class(cfg.hJ)]), cfg.hK), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1'), $elm$html$Html$Attributes$class(cfg.jG)]), cfg.jH)]));
  };

  var $author$project$UiWrappers$VerticalSplit$verticalSplitIllustrated = function (cfg) {
    return $author$project$UiWrappers$VerticalSplit$verticalSplit({
      hJ: 'flexColumn scrollTarget primary10Back ' + cfg.hJ,
      hK: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTopAuto marBottomAuto')]), cfg.hK)]),
      jG: 'flexCenter primary30Back',
      jH: _List_fromArray([A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src($author$project$AssetsImg$assets.ym), A2($elm$html$Html$Attributes$style, 'max-width', '80%'), A2($elm$html$Html$Attributes$style, 'max-height', '90%')]), _List_Nil)])
    });
  };

  var $author$project$Views$Routed$AuthBranch$viewLayer = function (content) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$VerticalSplit$verticalSplitIllustrated({
        hJ: '',
        hK: content
      })
    });
  };

  var $author$project$Views$Routed$AuthBranch$authBranch = F2(function (authStep, topState) {
    switch (authStep.$) {
      case 0:
        var maybeRegisterSubStep = authStep.a;

        if (!maybeRegisterSubStep.$) {
          var _v2 = maybeRegisterSubStep.a;
          return _List_Nil;
        } else {
          return _List_fromArray([$author$project$Views$Routed$AuthBranch$viewLayer($author$project$Views$Routed$AuthBranch$registrationContent(topState))]);
        }

      case 1:
        return _List_fromArray([$author$project$Views$Routed$AuthBranch$viewLayer($author$project$Views$Routed$AuthBranch$signInWithCredentials(topState))]);

      case 2:
        return _List_fromArray([$author$project$Views$Routed$AuthBranch$viewLayer($author$project$Views$Routed$AuthBranch$forgotPasswordView(topState))]);

      case 3:
        return _List_fromArray([$author$project$Views$Routed$AuthBranch$viewLayer(_List_fromArray([$elm$html$Html$text('kromid')]))]);

      default:
        return _List_fromArray([$author$project$Views$Routed$AuthBranch$viewLayer($author$project$Views$Routed$AuthBranch$confirmRegistrationContent(topState))]);
    }
  });

  var $author$project$Ui$EditingCompany$Msg$SetEditingCompany = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$UpdateCompany = F2(function (a, b) {
    return {
      $: 16,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$CreateBlock = F2(function (a, b) {
    return {
      $: 65,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Model$DeleteBlock = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Blocks$Msg$OnDuplicate = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Blocks$Msg$OnSelectBlock = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$Sorters$SortAlphabetically = 1;

  var $author$project$Global$Msg$TogglePopupMenu = function (a) {
    return {
      $: 14,
      a: a
    };
  };

  var $author$project$IconSvg$add_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M32 21.7143H21.7143V32H18.2857V21.7143H8V18.2857H18.2857V8H21.7143V18.2857H32V21.7143Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$add = function (classes) {
    return $author$project$IconSvg$add_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$Blocks$Msg$ClearSelectedBLocks = {
    $: 3
  };

  var $author$project$UiWrappers$MainAppWrap$CreateScenarioBottomBar = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$Blocks$Msg$StartCreatingScenarioWithBlocks = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $author$project$Views$Routed$BlocksBranch$bottomBar = F2(function (selectedBlocks, companyId) {
    return $turboMaCk$any_set$Set$Any$isEmpty(selectedBlocks) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$CreateScenarioBottomBar({
      k: $turboMaCk$any_set$Set$Any$size(selectedBlocks),
      rL: $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$BlocksMsg($author$project$Ui$Blocks$Msg$ClearSelectedBLocks)),
      rN: $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$BlocksMsg(A2($author$project$Ui$Blocks$Msg$StartCreatingScenarioWithBlocks, companyId, selectedBlocks)))
    }));
  });
  var $elm$core$List$concatMap = F2(function (f, list) {
    return $elm$core$List$concat(A2($elm$core$List$map, f, list));
  });
  var $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg = F3(function (wrapClasses, classes, imgUrl) {
    return A3($elm$html$Html$node, 'patient-background-image', _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'wait-for-image', imgUrl), $elm$html$Html$Attributes$class(wrapClasses)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread coverBack hidden fadeInAnimation'), $elm$html$Html$Attributes$class(classes)]), _List_Nil)]));
  });

  var $author$project$Ui$EmptyStateView$emptyStateView = function (cfg) {
    var button = function () {
      var _v0 = cfg.pi;

      if (!_v0.$) {
        var _v1 = _v0.a;
        var buttonLabel = _v1.a;
        var buttonMsg = _v1.b;
        return $author$project$Ui$Button$basicButton({
          kG: 'primary0 marTop4',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(buttonMsg),
          y$: buttonLabel
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter relative')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg, 'w46 h46', 'maxW46', $author$project$AssetsImg$assets.yl), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft14')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
      pv: '',
      vV: '',
      tQ: cfg.tQ,
      t1: cfg.t1
    }), button]))]));
  };

  var $author$project$Ui$PopoverMenu$PopoverBtnThemeNormal = 0;
  var $author$project$Ui$PopoverMenu$PopoverBtnThemeSpecial = 1;
  var $author$project$ElmFramework$Lib$Ui$Tooltip$Top = 0;

  var $author$project$IconSvg$dots_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M18 30C18 28.8954 18.8954 28 20 28C21.1046 28 22 28.8954 22 30C22 31.1046 21.1046 32 20 32C18.8954 32 18 31.1046 18 30ZM18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20ZM18 10C18 8.89543 18.8954 8 20 8C21.1046 8 22 8.89543 22 10C22 11.1046 21.1046 12 20 12C18.8954 12 18 11.1046 18 10Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$dots = function (classes) {
    return $author$project$IconSvg$dots_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$graph_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 24 16')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M21.1926 0C19.6339 0 18.3675 1.26642 18.3675 2.82509C18.3675 3.57786 18.6686 4.26863 19.1469 4.77343L16.4989 9.24576C16.1181 9.8834 15.6399 10.2465 15.1882 10.2465C14.7277 10.2465 14.2494 9.8834 13.8775 9.24576L11.8406 5.80959C11.1764 4.68487 10.2465 4.06494 9.22804 4.06494C8.20959 4.06494 7.28856 4.68487 6.62435 5.80959L3.54244 10.9993C3.31218 10.9373 3.07306 10.9107 2.82509 10.9107C1.26642 10.9107 0 12.1771 0 13.7358C0 15.2945 1.26642 16.5609 2.82509 16.5609C4.38376 16.5609 5.65018 15.2945 5.65018 13.7358C5.65018 12.9653 5.34022 12.2657 4.84428 11.7609L7.90849 6.58007C8.2893 5.94244 8.76753 5.57934 9.21919 5.57934C9.6797 5.57934 10.1579 5.94244 10.5299 6.58007L12.5668 10.0162C13.231 11.141 14.1609 11.7609 15.1793 11.7609C16.1978 11.7609 17.1188 11.141 17.783 10.0162L20.4221 5.55277C20.6613 5.62362 20.9181 5.65904 21.1749 5.65904C22.7336 5.65904 24 4.39262 24 2.83395C24 1.27528 22.7513 0 21.1926 0ZM2.82509 15.0554C2.09889 15.0554 1.50554 14.462 1.50554 13.7358C1.50554 13.0096 2.09889 12.4162 2.82509 12.4162C3.55129 12.4162 4.14465 13.0096 4.14465 13.7358C4.14465 14.462 3.56015 15.0554 2.82509 15.0554ZM21.1926 4.14465C20.4664 4.14465 19.8731 3.55129 19.8731 2.82509C19.8731 2.09889 20.4576 1.50554 21.1926 1.50554C21.9277 1.50554 22.5122 2.09889 22.5122 2.82509C22.5122 3.55129 21.9188 4.14465 21.1926 4.14465Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$graph = function (classes) {
    return $author$project$IconSvg$graph_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');

  var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');

  var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');

  var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');

  var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');

  var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');

  var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');

  var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');

  var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');

  var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');

  var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');

  var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');

  var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');

  var $author$project$IconSvg$radioActive_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 24 24'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('1'), $elm$svg$Svg$Attributes$y('1'), $elm$svg$Svg$Attributes$width('22'), $elm$svg$Svg$Attributes$height('22'), $elm$svg$Svg$Attributes$rx('11'), $elm$svg$Svg$Attributes$fill('#FAFAFA'), $elm$svg$Svg$Attributes$stroke('#5E2CDF'), $elm$svg$Svg$Attributes$strokeWidth('2')]), _List_Nil), A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$cx('12'), $elm$svg$Svg$Attributes$cy('12'), $elm$svg$Svg$Attributes$r('4'), $elm$svg$Svg$Attributes$fill('#5E2CDF')]), _List_Nil)]));
  };

  var $author$project$IconSvg$radioActive = function (classes) {
    return $author$project$IconSvg$radioActive_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$radioInActive_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 24 24'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('1'), $elm$svg$Svg$Attributes$y('1'), $elm$svg$Svg$Attributes$width('22'), $elm$svg$Svg$Attributes$height('22'), $elm$svg$Svg$Attributes$rx('11'), $elm$svg$Svg$Attributes$stroke('#CED5DF'), $elm$svg$Svg$Attributes$strokeWidth('2')]), _List_Nil)]));
  };

  var $author$project$IconSvg$radioInActive = function (classes) {
    return $author$project$IconSvg$radioInActive_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$FinancialBlock$scenarioLabel = function (cfg) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.ew), _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock secondary0 secondary10Back heading5Bold padRight2 padLeft2 padTop1 padBottom1 radius1 mar0h')]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$IconSvg$scenarios_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M32 17.5676V10H24.4324V12.9189H23.3514C21.0811 12.9189 19.2432 14.7568 19.2432 17.027C19.2432 18.4324 18.1622 19.5135 16.7568 19.5135H15.4595C15.027 17.8919 13.5135 16.5946 11.7838 16.5946C9.72973 16.5946 8 18.3243 8 20.3784C8 22.4324 9.72973 24.1622 11.7838 24.1622C13.6216 24.1622 15.027 22.8649 15.4595 21.2432H16.7568C18.1622 21.2432 19.2432 22.3243 19.2432 23.7297C19.2432 26 21.0811 27.8378 23.3514 27.8378H24.4324V30.7568H32V23.1892H24.4324V26.2162H23.3514C21.9459 26.2162 20.8649 25.1351 20.8649 23.7297C20.8649 22.3243 20.2162 21.1351 19.1351 20.3784C20.1081 19.6216 20.8649 18.4324 20.8649 17.027C20.8649 15.6216 21.9459 14.5405 23.3514 14.5405H24.4324V17.5676H32ZM11.7838 22.5405C10.5946 22.5405 9.62162 21.5676 9.62162 20.3784C9.62162 19.1892 10.5946 18.2162 11.7838 18.2162C12.973 18.2162 13.9459 19.1892 13.9459 20.3784C13.9459 21.5676 12.973 22.5405 11.7838 22.5405ZM26.1622 24.8108H30.4865V29.1351H26.1622V24.8108ZM26.1622 11.6216H30.4865V15.9459H26.1622V11.6216Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$scenarios = function (classes) {
    return $author$project$IconSvg$scenarios_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$ElmFramework$Lib$Ui$EventFull$onClickAwayEmitter = function (msg) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'onClickAway', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$ElmFramework$Lib$Ui$EventFull$onClickAway = function (msg) {
    return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-click-away', 'true'), $author$project$ElmFramework$Lib$Ui$EventFull$onClickAwayEmitter(msg)]);
  };

  var $author$project$Ui$PopoverMenu$popoverBtn = function (cfg) {
    var theme = function () {
      var _v0 = cfg.tY;

      if (!_v0) {
        return $elm$html$Html$Attributes$class('');
      } else {
        return $elm$html$Html$Attributes$class('secondary50');
      }
    }();

    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.ew), _List_fromArray([$elm$html$Html$Attributes$class('block pad1 left whiteSpaceNoWrap popOverBtnHover fullWidth '), theme]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$Ui$PopoverMenu$popoverMenu = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back primary30 heading5Regular pad1  absolute slightShadow z1'), $elm$html$Html$Attributes$class(cfg.vV)]), A2($elm$core$List$map, $author$project$Ui$PopoverMenu$popoverBtn, cfg.vG));
  };

  var $author$project$Ui$PopoverMenu$showHidePopoverMenu = function (cfg) {
    return cfg.f8 && !_Utils_eq(cfg.vG, _List_Nil) ? A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onClickAway(cfg.E3)]), _List_Nil, _List_fromArray([$author$project$Ui$PopoverMenu$popoverMenu({
      vG: cfg.vG,
      vV: cfg.vV
    })])) : $elm$html$Html$text('');
  };

  var $author$project$Ui$Tooltip$bodyAttrs = _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 padRight2 padTop0h padBottom0h primary30Back primary0 heading5Regular')]);

  var $author$project$ElmFramework$Lib$Ui$Tooltip$tooltip = function (cfg) {
    return A3($elm$html$Html$node, 'elm-framework-tooltip', _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr, _List_fromArray([$elm$html$Html$Attributes$class('block absolute fullTop halfLeft w0 h0')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('toolTipContainer absolute'), A2($elm$html$Html$Attributes$style, 'margin-right', $elm$core$String$fromInt(-cfg.zq) + 'rem')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('theTooltip relative center noFontSize lineH0'), A2($elm$html$Html$Attributes$style, 'left', '-50%')]), _List_fromArray([A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('inlineBlock'), cfg.uQ), cfg.uR), A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class(''), cfg.vm), cfg.vn)]))]))]))]));
  };

  var $author$project$ElmFramework$Lib$Ui$Tooltip$trianglePointingTop = function (classes) {
    return _List_fromArray([$elm$html$Html$Attributes$class('borderWidthBottom10 borderWidthLeft10 borderWidthRight10 borderWidthTop0 borderSolid'), $elm$html$Html$Attributes$class('transparentBorderRight transparentBorderLeft'), $elm$html$Html$Attributes$class(classes)]);
  };

  var $author$project$Ui$Tooltip$tooltip = F2(function (defaultSide, string) {
    return $author$project$ElmFramework$Lib$Ui$Tooltip$tooltip({
      uQ: $author$project$ElmFramework$Lib$Ui$Tooltip$trianglePointingTop('primary30Border'),
      uR: _List_Nil,
      uS: _List_Nil,
      uT: _List_Nil,
      uU: _List_Nil,
      uV: _List_Nil,
      uW: _List_Nil,
      uX: _List_Nil,
      vm: $author$project$Ui$Tooltip$bodyAttrs,
      vn: _List_fromArray([$elm$html$Html$text(string)]),
      vo: $author$project$Ui$Tooltip$bodyAttrs,
      vp: _List_fromArray([$elm$html$Html$text(string)]),
      vq: $author$project$Ui$Tooltip$bodyAttrs,
      vr: _List_fromArray([$elm$html$Html$text(string)]),
      vs: $author$project$Ui$Tooltip$bodyAttrs,
      vt: _List_fromArray([$elm$html$Html$text(string)]),
      vV: '',
      wD: defaultSide,
      zq: 24
    });
  });

  var $author$project$Ui$FinancialBlock$financialBlock = function (cfg) {
    var scenariosEl = $elm$core$List$isEmpty(cfg.db) ? $author$project$ElmFramework$Lib$Util$noOpEl : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 marTop-2 marRight-0h marBottom-0h marLeft-0h scrollTargetX whiteSpaceNoWrap noScrollbar ')]), A2($elm$core$List$map, $author$project$Ui$FinancialBlock$scenarioLabel, cfg.db));

    var scenarioBtn = function (tooltipString) {
      var nodeKind = A2($elm$core$Maybe$withDefault, $elm$html$Html$div, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Ui$Button$Button, $author$project$ElmFramework$Lib$Ui$Button$button), cfg.jr));
      return A2(nodeKind, _List_fromArray([$elm$html$Html$Attributes$class('flexRow relative flexAlignCenter justifyCenter')]), _List_fromArray([$author$project$IconSvg$scenarios('rotate90 w3 secondary90Fill '), A2($author$project$Ui$Tooltip$tooltip, 0, tooltipString)]));
    };

    var radioIcon = function () {
      var element = cfg.ja ? $author$project$IconSvg$radioActive('w2') : $author$project$IconSvg$radioInActive('w2');
      return _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.BE), _List_Nil, _List_fromArray([element]))]);
    }();

    var popoverMenuPart = $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: _List_fromArray([{
        y$: 'Edit Block',
        ew: cfg.hW,
        tY: 0
      }, {
        y$: 'Duplicate Block',
        ew: cfg.hU,
        tY: 0
      }, {
        y$: 'Delete Block',
        ew: cfg.hT,
        tY: 1
      }]),
      vV: 'absolute right0 top4 z1',
      f8: cfg.yS,
      E3: cfg.jq
    });
    var blockStyle = cfg.i4 ? 'primary30Fill' : 'gray20Fill';
    return cfg.jb ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius0 flexAlignCenter flexRow pad2 borderSolid borderHairlineWidth gray10Border relative whiteBack marTop2'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex2 flexRow flexAlignCenter padRight0')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, radioIcon), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marLeft1')]), _List_fromArray([$author$project$IconSvg$blocks('w2 ' + blockStyle)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('padLeft1 heading4Bold primary30 noOverflow')]), _List_fromArray([$elm$html$Html$text(cfg.zL)]))])), $author$project$ElmFramework$Lib$Util$spacer('flex1'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft1 w3 h3')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, scenarioBtn, cfg.jI))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex3 marLeft3 heading5Regular gray60')]), _List_fromArray([$elm$html$Html$text(cfg.iz)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex3 marLeft6 noOverflow whiteSpaceNoWrap')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), A2($elm$core$List$map, $author$project$Ui$FinancialBlock$scenarioLabel, cfg.db))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute right2 flexRow gradient20Back padLeft4')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.js), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter justifyCenter padRight2 padLeft2 padTop1 padBottom1 radius1 marRight1 secondary10Back')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3')]), _List_fromArray([$author$project$IconSvg$graph('w2 primary20Fill')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold secondary0')]), _List_fromArray([$elm$html$Html$text('Details')]))])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.jq), _List_Nil, _List_fromArray([$author$project$IconSvg$dots('w4 primary30Fill')])), popoverMenuPart]))])) : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn radius0 whiteBack borderSolid borderHairlineWidth gray10Border'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 gray10Back flexRow flexAlignCenter spaceBetween')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marRight1')]), radioIcon), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marRight1')]), _List_fromArray([$author$project$IconSvg$blocks('w2 ' + blockStyle)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 marRight1 ')]), _List_fromArray([$elm$html$Html$text(cfg.zL)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marRight1 w3 h3')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, scenarioBtn, cfg.jI))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.jq), _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$IconSvg$dots('w4 primary30Fill')])), popoverMenuPart]))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 pad2 heading5Regular gray60')]), _List_fromArray([$elm$html$Html$text(cfg.iz)])), scenariosEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('borderBottomHairline')]), _List_Nil), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.js), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter justifyCenter fullWidth padTop2 padBottom2')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marRight1 w3')]), _List_fromArray([$author$project$IconSvg$graph('w2 primary20Fill')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold primary20')]), _List_fromArray([$elm$html$Html$text('View Block details')]))]))]));
  };

  var $elm$core$List$partition = F2(function (pred, list) {
    var step = F2(function (x, _v0) {
      var trues = _v0.a;
      var falses = _v0.b;
      return pred(x) ? _Utils_Tuple2(A2($elm$core$List$cons, x, trues), falses) : _Utils_Tuple2(trues, A2($elm$core$List$cons, x, falses));
    });
    return A3($elm$core$List$foldr, step, _Utils_Tuple2(_List_Nil, _List_Nil), list);
  });
  var $elm_community$list_extra$List$Extra$gatherWith = F2(function (testFn, list) {
    var helper = F2(function (scattered, gathered) {
      if (!scattered.b) {
        return $elm$core$List$reverse(gathered);
      } else {
        var toGather = scattered.a;
        var population = scattered.b;

        var _v1 = A2($elm$core$List$partition, testFn(toGather), population);

        var gathering = _v1.a;
        var remaining = _v1.b;
        return A2(helper, remaining, A2($elm$core$List$cons, _Utils_Tuple2(toGather, gathering), gathered));
      }
    });
    return A2(helper, list, _List_Nil);
  });
  var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(function (extract, list) {
    return A2($elm_community$list_extra$List$Extra$gatherWith, F2(function (a, b) {
      return _Utils_eq(extract(a), extract(b));
    }), list);
  });
  var $turboMaCk$any_dict$Dict$Any$getKey = F2(function (k, _v0) {
    var dict = _v0.bT;
    var toKey = _v0.dn;
    return A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Dict$get, toKey(k), dict));
  });
  var $turboMaCk$any_set$Set$Any$get = F2(function (a, _v0) {
    var dict = _v0;
    return A2($turboMaCk$any_dict$Dict$Any$getKey, a, dict);
  });
  var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(function (size, step, xs) {
    var xs_ = A2($elm$core$List$drop, step, xs);
    var okayXs = $elm$core$List$length(xs) > 0;
    var okayArgs = size > 0 && step > 0;
    return okayArgs && okayXs ? A2($elm$core$List$cons, A2($elm$core$List$take, size, xs), A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
  });
  var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(function (size, xs) {
    return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
  });

  var $author$project$Types$BuildingBlock$isFinancial = function (block) {
    var _v0 = block.kw;

    switch (_v0.$) {
      case 0:
        return true;

      case 2:
        return true;

      default:
        return false;
    }
  };

  var $author$project$TopMsg$msgBlocks = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BlocksMsg);
  var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(function (ma, mb) {
    if (mb.$ === 1) {
      return ma;
    } else {
      return mb;
    }
  });
  var $author$project$Views$Routed$BlocksBranch$parentNameOrClassName = F2(function (parentBlock, company) {
    var allocationClassName = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
      return $.zL;
    }), A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toAllocationClass, id, company);
    }, A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlock$toAllocationClassId, parentBlock)));
    return A2($elm_community$maybe_extra$Maybe$Extra$orElse, allocationClassName, A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, parentBlock));
  });
  var $elm$core$List$repeatHelp = F3(function (result, n, value) {
    repeatHelp: while (true) {
      if (n <= 0) {
        return result;
      } else {
        var $temp$result = A2($elm$core$List$cons, value, result),
            $temp$n = n - 1,
            $temp$value = value;
        result = $temp$result;
        n = $temp$n;
        value = $temp$value;
        continue repeatHelp;
      }
    }
  });
  var $elm$core$List$repeat = F2(function (n, value) {
    return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
  });

  var $author$project$Types$Filters$textSearchActive = function (filters) {
    return !$elm$core$String$isEmpty($elm$core$String$trim(filters.j_));
  };

  var $author$project$Types$BuildingBlock$toDerivativeOf = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);

      case 1:
        return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);

      case 2:
        var remoteData = _v0.a;
        return A2($elm$core$Maybe$map, function (_v1) {
          var derivativePayload = _v1.a;
          return $elm$core$Maybe$Just(derivativePayload.hk);
        }, $krisajenkins$remotedata$RemoteData$toMaybe(remoteData));

      default:
        var remoteData = _v0.a;
        return A2($elm$core$Maybe$map, function (_v2) {
          var derivativePayload = _v2.a;
          return $elm$core$Maybe$Just(derivativePayload.hk);
        }, $krisajenkins$remotedata$RemoteData$toMaybe(remoteData));
    }
  };

  var $author$project$Types$BuildingBlock$toParentId = function (block) {
    var _v0 = $author$project$Types$BuildingBlock$toDerivativeOf(block);

    if (!_v0.$) {
      var derivative = _v0.a;

      if (!derivative.$ && !derivative.a.$) {
        var parentBlockId = derivative.a.a;
        return $elm$core$Maybe$Just(parentBlockId);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$Company$toParentBuildingBlock = F2(function (block, company) {
    return A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toBuildingBlock, id, company);
    }, $author$project$Types$BuildingBlock$toParentId(block));
  });
  var $author$project$Types$Company$toScenariosFromIds = F2(function (ids, company) {
    var toScenarios = function (scenarios) {
      return A2($elm$core$List$filterMap, function (id) {
        return A2($turboMaCk$any_dict$Dict$Any$get, id, scenarios);
      }, ids);
    };

    return A2($elm$core$Maybe$map, toScenarios, $krisajenkins$remotedata$RemoteData$toMaybe(company.db));
  });
  var $author$project$Types$Company$toScenariosForBlock = F2(function (buildingBlockId, company) {
    return A2($elm$core$Maybe$andThen, function (rel) {
      return A2($author$project$Types$Company$toScenariosFromIds, A2($elm$core$List$map, function ($) {
        return $.e8;
      }, rel), company);
    }, A2($elm$core$Maybe$map, $author$project$ElmFramework$Lib$PivotDict$getById2(buildingBlockId), $krisajenkins$remotedata$RemoteData$toMaybe(company.nT)));
  });
  var $elm_community$string_extra$String$Extra$breaker = F3(function (width, string, acc) {
    breaker: while (true) {
      if (string === '') {
        return $elm$core$List$reverse(acc);
      } else {
        var $temp$width = width,
            $temp$string = A2($elm$core$String$dropLeft, width, string),
            $temp$acc = A2($elm$core$List$cons, A3($elm$core$String$slice, 0, width, string), acc);
        width = $temp$width;
        string = $temp$string;
        acc = $temp$acc;
        continue breaker;
      }
    }
  });
  var $elm_community$string_extra$String$Extra$break = F2(function (width, string) {
    return !width || string === '' ? _List_fromArray([string]) : A3($elm_community$string_extra$String$Extra$breaker, width, string, _List_Nil);
  });

  var $author$project$Ui$TimeTransformation$Util$numStringToUsLocale = function (numString) {
    var toUsLocale = function (num) {
      return A3($elm$core$String$replace, '-,', '-', $elm$core$String$reverse(A2($elm$core$String$join, ',', A2($elm_community$string_extra$String$Extra$break, 3, $elm$core$String$reverse(num)))));
    };

    var _v0 = A2($elm$core$String$split, '.', numString);

    _v0$2: while (true) {
      if (_v0.b) {
        if (!_v0.b.b) {
          var _int = _v0.a;
          return toUsLocale(_int);
        } else {
          if (!_v0.b.b.b) {
            var first = _v0.a;
            var _v1 = _v0.b;
            var second = _v1.a;
            return toUsLocale(first) + ('.' + second);
          } else {
            break _v0$2;
          }
        }
      } else {
        break _v0$2;
      }
    }

    return 'NaN';
  };

  var $author$project$Types$Currency$toFormattedFromString = F2(function (currency, string) {
    return A3($elm$core$String$replace, '$-', '-$', A2($elm$core$String$append, '$', string));
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromBaseValue = F2(function (baseValueFraction, blockTypeHydrated) {
    var baseValue = $JoshuaHall$elm_fraction$Fraction$toFloat(baseValueFraction);
    var baseValueString = $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromFloat($elm$core$Basics$abs(baseValue)));
    var plusMinus = baseValue > 0 ? '+' : baseValue < 0 ? '-' : '';

    switch (blockTypeHydrated.$) {
      case 0:
        var moneyPayload = blockTypeHydrated.b;
        return A3($elm$core$String$replace, '{{+/-}}', plusMinus, A3($elm$core$String$replace, '{{baseValue}}', A2($author$project$Types$Currency$toFormattedFromString, moneyPayload.V, baseValueString), '{{+/-}}{{baseValue}}'));

      case 1:
        var thingPayload = blockTypeHydrated.b;
        return A3($elm$core$String$replace, '{{unit}}', thingPayload.V, A3($elm$core$String$replace, '{{+/-}}', plusMinus, A3($elm$core$String$replace, '{{baseValue}}', baseValueString, '{{+/-}}{{baseValue}} {{unit}}')));

      case 2:
        var moneyPayload = blockTypeHydrated.b;
        return A3($elm$core$String$replace, '{{+/-}}', plusMinus, A3($elm$core$String$replace, '{{baseValue}}', A2($author$project$Types$Currency$toFormattedFromString, moneyPayload.V, baseValueString), '{{+/-}}{{baseValue}}'));

      default:
        var thingPayload = blockTypeHydrated.b;
        return A3($elm$core$String$replace, '{{unit}}', thingPayload.V, A3($elm$core$String$replace, '{{+/-}}', plusMinus, A3($elm$core$String$replace, '{{baseValue}}', baseValueString, '{{+/-}}{{baseValue}} {{unit}}')));
    }
  });
  var $author$project$Ui$Summary$Summary$everyPeriod = F2(function (every, period) {
    var periodString = function (a) {
      return _Utils_ap(a, A3($author$project$ElmFramework$Lib$Util$ifElse, 's', '', every !== 1));
    }(A3($elm$core$String$replace, '_', ' ', $elm$core$String$toLower(period)));

    var everyString = A3($elm$core$String$replace, '1', '', $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromInt(every)));
    return everyString + (' ' + periodString);
  });

  var $author$project$Types$RepeatPattern$toSummaryFromEndAt = function (endAt) {
    if (!endAt.$) {
      var times = endAt.a;
      return 'after ' + ($elm$core$String$fromInt(times) + (' time' + A3($author$project$ElmFramework$Lib$Util$ifElse, 's', '', times !== 1)));
    } else {
      var date = endAt.a;
      return $author$project$Types$SimpleDate$toDateString(date);
    }
  };

  var $author$project$Ui$Summary$Summary$toSummaryFromRepeatPattern = F2(function (startOn, pattern) {
    return A3($elm$core$String$replace, '{{startOn}}', $author$project$Types$SimpleDate$toDateString(startOn), A3($elm$core$String$replace, '{{endCustom}}', $author$project$Types$RepeatPattern$toSummaryFromEndAt(pattern.hn), A3($elm$core$String$replace, '{{everyPeriod}}', A2($author$project$Ui$Summary$Summary$everyPeriod, pattern.ao, $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$toString(pattern.ap)), 'Every {{everyPeriod}}, from {{startOn}} until {{endCustom}}')));
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromBasePattern = F4(function (startOn, baseValue, repeatPattern, blockTypeHydrated) {
    return A2($elm$core$String$join, ' ', _List_fromArray([A2($author$project$Ui$Summary$Summary$toSummaryFromBaseValue, baseValue, blockTypeHydrated), A2($author$project$Ui$Summary$Summary$toSummaryFromRepeatPattern, startOn, repeatPattern)]));
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromDerivativeOf = F2(function (company, derivativeOf) {
    if (!derivativeOf.$) {
      var buildingBlockId = derivativeOf.a;

      var _v1 = A2($author$project$Types$Company$toBuildingBlock, buildingBlockId, company);

      if (!_v1.$) {
        var block = _v1.a;
        return A3($elm$core$String$replace, '{{parentName}}', block.zL, '{{parentName}}');
      } else {
        return 'another block';
      }
    } else {
      var allocationClassId = derivativeOf.a;

      var _v2 = A2($author$project$Types$Company$toAllocationClass, allocationClassId, company);

      if (!_v2.$) {
        var _v3 = _v2.a;
        var allocationClass = _v3.b;
        return A3($elm$core$String$replace, '{{className}}', allocationClass.zL, '{{className}}');
      } else {
        return 'allocation class';
      }
    }
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromTimeTransformation = F2(function (maybeTransformation, blockTypeHydrated) {
    var toBasicTimeTransformation = function (moneyPayload) {
      return $elm_community$maybe_extra$Maybe$Extra$isJust(maybeTransformation) ? A3($elm$core$String$replace, '{{moneyPayload.basis}}', $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString(moneyPayload.pb), 'with transform from {{moneyPayload.basis}}') : A3($elm$core$String$replace, '{{moneyPayload.basis}}', $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString(moneyPayload.pb), 'without transform from {{moneyPayload.basis}}');
    };

    switch (blockTypeHydrated.$) {
      case 0:
        var moneyPayload = blockTypeHydrated.b;
        return $elm$core$Maybe$Just(toBasicTimeTransformation(moneyPayload));

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        var moneyPayload = blockTypeHydrated.b;
        return $elm_community$maybe_extra$Maybe$Extra$isJust(maybeTransformation) ? $elm$core$Maybe$Just('with time transform, ' + toBasicTimeTransformation(moneyPayload)) : $elm$core$Maybe$Just('without time transform, ' + toBasicTimeTransformation(moneyPayload));

      default:
        return $elm_community$maybe_extra$Maybe$Extra$isJust(maybeTransformation) ? $elm$core$Maybe$Just('with time transform') : $elm$core$Maybe$Just('without time transform');
    }
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload = F4(function (company, startOn, blockTypeHydrated, _v0) {
    var endOn = _v0.ho;
    var multiplier = _v0.r;
    var per = _v0.t;
    var timeTransform = _v0.gM;
    var derivativeOf = _v0.hk;
    return A3($elm$core$String$replace, '{{derivativeOf}}', A2($author$project$Ui$Summary$Summary$toSummaryFromDerivativeOf, company, derivativeOf), A3($elm$core$String$replace, '{{timeTransform}}', A2($elm$core$Maybe$withDefault, '', A2($author$project$Ui$Summary$Summary$toSummaryFromTimeTransformation, timeTransform, blockTypeHydrated)), A3($elm$core$String$replace, '{{per}}', $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromFloat(per)), A3($elm$core$String$replace, '{{multiplier}}', $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromFloat(multiplier)), A3($elm$core$String$replace, '{{endOn}}', $author$project$Types$SimpleDate$toDateString(endOn), A3($elm$core$String$replace, '{{startOn}}', $author$project$Types$SimpleDate$toDateString(startOn), 'factor {{multiplier}} per {{per}} {{derivativeOf}}, from {{startOn}} until {{endOn}} {{timeTransform}}'))))));
  });

  var $author$project$Ui$Summary$Summary$toSummaryFromThingPayload = function (_v0) {
    var unit = _v0.V;
    return A3($elm$core$String$replace, '{{unit}}', unit, '{{unit}}');
  };

  var $author$project$Ui$Summary$Summary$toShortSummaryFromBlock = F2(function (company, buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        if (_v0.a.$ === 3) {
          var _v1 = _v0.a.a;
          var basicPayload = _v1.a;
          var moneyPayload = _v1.b;
          return A2($elm$core$String$join, ', ', _List_fromArray([A4($author$project$Ui$Summary$Summary$toSummaryFromBasePattern, buildingBlock.bw, basicPayload.g5, basicPayload.h2, A2($author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated, basicPayload, moneyPayload))]));
        } else {
          return 'Basic-money block';
        }

      case 1:
        if (_v0.a.$ === 3) {
          var _v2 = _v0.a.a;
          var basicPayload = _v2.a;
          var thingPayload = _v2.b;
          return A2($elm$core$String$join, ', ', _List_fromArray([A4($author$project$Ui$Summary$Summary$toSummaryFromBasePattern, buildingBlock.bw, basicPayload.g5, basicPayload.h2, A2($author$project$Types$BuildingBlockHydrated$BasicThingHydrated, basicPayload, thingPayload))]));
        } else {
          return 'Basic-thing block';
        }

      case 2:
        if (_v0.a.$ === 3) {
          var _v3 = _v0.a.a;
          var derivativePayload = _v3.a;
          var moneyPayload = _v3.b;
          var derivativeMoneyPayload = _v3.c;
          return A2($elm$core$String$join, ', ', _List_fromArray([A4($author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload, company, buildingBlock.bw, A3($author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated, derivativePayload, moneyPayload, derivativeMoneyPayload), derivativePayload)]));
        } else {
          return 'Derivative-money block';
        }

      default:
        if (_v0.a.$ === 3) {
          var _v4 = _v0.a.a;
          var derivativePayload = _v4.a;
          var thingPayload = _v4.b;
          return A2($elm$core$String$join, ', ', _List_fromArray([$author$project$Ui$Summary$Summary$toSummaryFromThingPayload(thingPayload), A4($author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload, company, buildingBlock.bw, A2($author$project$Types$BuildingBlockHydrated$DerivativeThingHydrated, derivativePayload, thingPayload), derivativePayload)]));
        } else {
          return 'Derivative-thing block';
        }

    }
  });

  var $author$project$Ui$Summary$Summary$toSummaryFromGrowthPattern = function (pattern) {
    return A3($elm$core$String$replace, '{{startOn}}', $author$project$Types$SimpleDate$toDateString(pattern.bw), A3($elm$core$String$replace, '{{rate}}', $author$project$Ui$TimeTransformation$Util$toStringFromFraction(pattern.bR), A3($elm$core$String$replace, '{{everyPeriod}}', A2($author$project$Ui$Summary$Summary$everyPeriod, pattern.ao, $author$project$Api$GraphqlSchema$Enum$Growth_period_enum$toString(pattern.ap)), 'growing {{rate}}% every {{everyPeriod}} starting on {{startOn}}')));
  };

  var $author$project$Types$SeasonalityInBlock$toAdjustmentsCount = function (monthAdjustments) {
    return {
      oU: $elm$core$Array$length(A2($elm$core$Array$filter, $elm$core$Basics$gt(100), monthAdjustments)),
      oV: $elm$core$Array$length(A2($elm$core$Array$filter, $elm$core$Basics$lt(100), monthAdjustments))
    };
  };

  var $author$project$Types$SeasonalityInBlock$toSummaryFromSeasonalityValue = function (seasonalityValue) {
    var _v0 = $author$project$Types$SeasonalityInBlock$toAdjustmentsCount(seasonalityValue);

    var adjustedUp = _v0.oV;
    var adjustedDown = _v0.oU;

    var _v1 = _Utils_Tuple2(adjustedUp > 0, adjustedDown > 0);

    if (_v1.a) {
      if (_v1.b) {
        return $elm$core$Maybe$Just(A3($elm$core$String$replace, '{{down}}', $elm$core$String$fromInt(adjustedDown), A3($elm$core$String$replace, '{{up}}', $elm$core$String$fromInt(adjustedUp), '{{up}} months up, and {{down}} months down')));
      } else {
        return $elm$core$Maybe$Just(A3($elm$core$String$replace, '{{up}}', $elm$core$String$fromInt(adjustedUp), '{{up}} months up'));
      }
    } else {
      if (_v1.b) {
        return $elm$core$Maybe$Just(A3($elm$core$String$replace, '{{down}}', $elm$core$String$fromInt(adjustedDown), '{{down}} months down'));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }
  };

  var $author$project$Ui$Summary$Summary$toSummaryFromSeasonality = F2(function (company, seasonalityInBlock) {
    if (!seasonalityInBlock.$) {
      var seasonalityId = seasonalityInBlock.a;
      var presetName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function ($) {
        return $.dH;
      }, A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(seasonalityId), $krisajenkins$remotedata$RemoteData$toMaybe(company.ti))));
      return A3($elm$core$String$replace, '{{presetName}}', presetName, 'Seasonality preset {{presetName}}');
    } else {
      var array = seasonalityInBlock.a;

      var _v1 = $author$project$Types$SeasonalityInBlock$toSummaryFromSeasonalityValue(array);

      if (!_v1.$) {
        var summary = _v1.a;
        return A3($elm$core$String$replace, '{{seasonalitySummary}}', summary, 'Seasonality with {{seasonalitySummary}}');
      } else {
        return 'No seasonality';
      }
    }
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromBasicPayload = F4(function (company, startOn, blockTypeHydrated, payload) {
    return A2($elm$core$String$join, ', ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([$elm$core$Maybe$Just(A4($author$project$Ui$Summary$Summary$toSummaryFromBasePattern, startOn, payload.g5, payload.h2, blockTypeHydrated)), A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromSeasonality(company), payload.bK), A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromGrowthPattern, payload.fZ)])));
  });

  var $author$project$Ui$Summary$Summary$toSummaryFromDerivativeMoneyPayload = function (_v0) {
    var baseBasis = _v0.fB;

    if (!baseBasis.$) {
      var theBaseBasis = baseBasis.a;
      return $elm$core$Maybe$Just(A3($elm$core$String$replace, '{{baseBasis}}', $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString(theBaseBasis), 'with base basis {{baseBasis}}'));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$Company$toFinancialAccount = F2(function (financialAccountId, company) {
    var findFinancialAccount = function (division) {
      return A2($elm$core$Maybe$map, function (account) {
        return _Utils_Tuple2(division, account);
      }, A2($turboMaCk$any_dict$Dict$Any$get, financialAccountId, division.qp));
    };

    return A2($elm$core$Maybe$andThen, $elm_community$list_extra$List$Extra$findMap(findFinancialAccount), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO)));
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromAllocationClassData = F2(function (company, _v0) {
    var allocationAccountPair = _v0.iu;
    var internalOpposite = _v0.qZ;

    var maybeInternalOppositeText = function (pair) {
      var _v7 = _Utils_Tuple2(A2($author$project$Types$Company$toAllocationClass, pair.kf, company), A2($author$project$Types$Company$toFinancialAccount, pair.lo, company));

      if (!_v7.a.$ && !_v7.b.$) {
        var _v8 = _v7.a.a;
        var _class = _v8.b;
        var _v9 = _v7.b.a;
        var account = _v9.b;
        return $elm$core$Maybe$Just(A3($elm$core$String$replace, '{{accountName}}', account.zL, A3($elm$core$String$replace, '{{allocationClassName}}', _class.zL, 'to internal {{allocationClassName}} - {{accountName}}')));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    };

    var maybeAllocationClassText = function () {
      var _v4 = _Utils_Tuple2(A2($author$project$Types$Company$toAllocationClass, allocationAccountPair.kf, company), A2($author$project$Types$Company$toFinancialAccount, allocationAccountPair.lo, company));

      if (!_v4.a.$ && !_v4.b.$) {
        var _v5 = _v4.a.a;
        var _class = _v5.b;
        var _v6 = _v4.b.a;
        var account = _v6.b;
        return $elm$core$Maybe$Just(A3($elm$core$String$replace, '{{accountName}}', account.zL, A3($elm$core$String$replace, '{{allocationClassName}}', _class.zL, '{{allocationClassName}} - {{accountName}}')));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var _v1 = _Utils_Tuple2(maybeAllocationClassText, A2($elm$core$Maybe$andThen, maybeInternalOppositeText, internalOpposite));

    if (!_v1.a.$) {
      if (!_v1.b.$) {
        var allocationClassText = _v1.a.a;
        var internalOppositeText = _v1.b.a;
        return $elm$core$Maybe$Just(allocationClassText + (' ' + internalOppositeText));
      } else {
        var allocationClassText = _v1.a.a;
        var _v2 = _v1.b;
        return $elm$core$Maybe$Just(allocationClassText);
      }
    } else {
      var _v3 = _v1.a;
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromMoneyPayload = F3(function (company, blockTypeHydrated, _v0) {
    var unit = _v0.V;
    var basis = _v0.pb;
    var basisTransform = _v0.fE;
    var allocationClassData = _v0.kg;
    return A2($elm$core$String$join, ', ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A2($author$project$Ui$Summary$Summary$toSummaryFromTimeTransformation, basisTransform, blockTypeHydrated), A2($elm$core$Maybe$andThen, $author$project$Ui$Summary$Summary$toSummaryFromAllocationClassData(company), allocationClassData)])));
  });
  var $author$project$Ui$Summary$Summary$toSummaryFromBlock = F2(function (company, buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        if (_v0.a.$ === 3) {
          var _v1 = _v0.a.a;
          var basicPayload = _v1.a;
          var moneyPayload = _v1.b;
          return A2($elm$core$String$join, ', ', _List_fromArray([A4($author$project$Ui$Summary$Summary$toSummaryFromBasicPayload, company, buildingBlock.bw, A2($author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated, basicPayload, moneyPayload), basicPayload), A3($author$project$Ui$Summary$Summary$toSummaryFromMoneyPayload, company, A2($author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated, basicPayload, moneyPayload), moneyPayload)]));
        } else {
          return 'Basic-money block';
        }

      case 1:
        if (_v0.a.$ === 3) {
          var _v2 = _v0.a.a;
          var basicPayload = _v2.a;
          var thingPayload = _v2.b;
          return A2($elm$core$String$join, ', ', _List_fromArray([A4($author$project$Ui$Summary$Summary$toSummaryFromBasicPayload, company, buildingBlock.bw, A2($author$project$Types$BuildingBlockHydrated$BasicThingHydrated, basicPayload, thingPayload), basicPayload)]));
        } else {
          return 'Basic-thing block';
        }

      case 2:
        if (_v0.a.$ === 3) {
          var _v3 = _v0.a.a;
          var derivativePayload = _v3.a;
          var moneyPayload = _v3.b;
          var derivativeMoneyPayload = _v3.c;
          return A2($elm$core$String$join, ', ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([$elm$core$Maybe$Just(A4($author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload, company, buildingBlock.bw, A3($author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated, derivativePayload, moneyPayload, derivativeMoneyPayload), derivativePayload)), $elm$core$Maybe$Just(A3($author$project$Ui$Summary$Summary$toSummaryFromMoneyPayload, company, A3($author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated, derivativePayload, moneyPayload, derivativeMoneyPayload), moneyPayload)), $author$project$Ui$Summary$Summary$toSummaryFromDerivativeMoneyPayload(derivativeMoneyPayload)])));
        } else {
          return 'Derivative-money block';
        }

      default:
        if (_v0.a.$ === 3) {
          var _v4 = _v0.a.a;
          var derivativePayload = _v4.a;
          var thingPayload = _v4.b;
          return A2($elm$core$String$join, ', ', _List_fromArray([$author$project$Ui$Summary$Summary$toSummaryFromThingPayload(thingPayload), A4($author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload, company, buildingBlock.bw, A2($author$project$Types$BuildingBlockHydrated$DerivativeThingHydrated, derivativePayload, thingPayload), derivativePayload)]));
        } else {
          return 'Derivative-thing block';
        }

    }
  });

  var $author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits = function (_v0) {
    var width = _v0.FE;
    var unitSize = _v0.j6;
    return width / unitSize;
  };

  var $author$project$Ui$Blocks$Msg$OnFilterUpdate = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$Blocks$Msg$OnViewBlocksByDropdownChanged = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Ui$SlideSelectMultiple$PrimaryDarkSelectWhiteBack = 0;
  var $author$project$Types$SelectScenariosOrBlocks$SelectBlocks = 1;

  var $author$project$Types$Filters$UpdateTextSearch = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$IconSvg$check_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M15.6271 25.9903L9.93746 20.082L8 22.0798L15.6271 30L32 12.9978L30.0762 11L15.6271 25.9903Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$check = function (classes) {
    return $author$project$IconSvg$check_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$delete_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M23.8929 8L25.25 9.33332H30V12H11V9.33332H15.75L17.1071 8H23.8929ZM12.3564 29.3333C12.3564 30.8 13.5779 32 15.0707 32H25.9279C27.4207 32 28.6422 30.8 28.6422 29.3333V13.3334H12.3564V29.3333ZM15.0713 16.0002H25.9284V29.3334H15.0713V16.0002Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$delete = function (classes) {
    return $author$project$IconSvg$delete_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$edit_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M28.3253 8.88706L31.1106 11.6724C32.2487 12.8065 32.2942 14.6201 31.249 15.8105L31.1127 15.9559L27.9027 19.157L27.9069 19.1617L26.4783 20.5903L26.4724 20.5843L16.2182 30.817C15.4607 31.573 14.4342 31.9976 13.364 31.9976H10.0203C8.90451 31.9976 8 31.0931 8 29.9774V26.5893C8 25.5172 8.42606 24.4891 9.18438 23.7312L24.0389 8.88636C25.2232 7.70427 27.1414 7.70459 28.3253 8.88706ZM20.8338 14.9457L10.6125 25.1603C10.2333 25.5392 10.0203 26.0532 10.0203 26.5893V29.4723C10.0203 29.7512 10.2464 29.9774 10.5253 29.9774H13.364C13.8991 29.9774 14.4123 29.7651 14.7911 29.387L25.039 19.1509L20.8338 14.9457ZM25.467 10.3154L22.2631 13.5174L26.4693 17.7236L29.7745 14.424C30.0755 14.0286 30.0451 13.4627 29.682 13.1009L26.8967 10.3156L26.8022 10.2323C26.4052 9.92395 25.8312 9.95183 25.467 10.3154Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$edit = function (classes) {
    return $author$project$IconSvg$edit_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$clearAll = F2(function (tag, state) {
    return A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, $elm$core$Basics$always(A3($elm$html$Html$node, 'dropdown-title', _List_fromArray([$elm$html$Html$Attributes$class('pad2 gray40 flexRow flexAlignCenter spaceBetween pointer heading4Bold borderBottomHairline h7'), $author$project$ElmFramework$Lib$Util$onTap(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Nothing, state)))]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('flex1 left')]), _List_fromArray([$elm$html$Html$text('Clear Selection')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('padRight2')]), _List_fromArray([$author$project$IconSvg$close('w3 h3 gray40Fill')]))]))), state.ia));
  });

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$createButtonView = function (cfg) {
    var state = cfg.Ej;
    var tag = cfg.b3;
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating, true, state))), _List_fromArray([$elm$html$Html$Attributes$class(cfg.iJ)]), _List_fromArray([$elm$html$Html$text(cfg.pI)]));
  };

  var $author$project$ElmFramework$Lib$Util$OnEnter = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Util$OnEsc = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$Input$customAttributesInput = function (config) {
    return A2($elm$html$Html$input, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$type_($author$project$ElmFramework$Lib$Ui$Input$toInputTypeString(config.qU)), $elm$html$Html$Attributes$required(config.gx), $elm$html$Html$Attributes$disabled(config.k_), $elm$html$Html$Attributes$placeholder(config.e3), $elm$html$Html$Attributes$value(config.Fw), $elm$html$Html$Events$onInput(config.e_), A2($elm$html$Html$Attributes$attribute, 'autocomplete', $author$project$ElmFramework$Lib$Ui$Input$toAutocompleteString(config.fx))]), config.uZ), _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(cfg.kG), $author$project$ElmFramework$Lib$Util$onTap(cfg.ew)]), _List_fromArray([cfg.yh]));
  };

  var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
  var $author$project$ElmFramework$Lib$Util$keyCodeDecoder = F2(function (keyCode, keyHandler) {
    if (!keyHandler.$) {
      var msg = keyHandler.a;
      return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$json$Json$Decode$succeed(msg), $elm$json$Json$Decode$fail(''), keyCode === 13);
    } else {
      var msg = keyHandler.a;
      return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$json$Json$Decode$succeed(msg), $elm$json$Json$Decode$fail(''), keyCode === 27);
    }
  });

  var $author$project$ElmFramework$Lib$Util$onKeyDownSpecific = function (keyHandlers) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'keydown', A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$json$Json$Decode$oneOf, A2($author$project$ElmFramework$Lib$Util$flip, $elm$core$List$map, keyHandlers)), $author$project$ElmFramework$Lib$Util$keyCodeDecoder), $elm$html$Html$Events$keyCode));
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$createInputView = function (cfg) {
    var state = cfg.Ej;
    var tag = cfg.b3;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(cfg.dJ)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1'), $elm$html$Html$Attributes$class(cfg.yy)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Input$customAttributesInput({
      uZ: _List_fromArray([$author$project$ElmFramework$Lib$Util$onKeyDownSpecific(_List_fromArray([$author$project$ElmFramework$Lib$Util$OnEnter(cfg.mH(state.kR)), $author$project$ElmFramework$Lib$Util$OnEsc(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating, false, state))))]))]),
      fx: $elm$core$Maybe$Nothing,
      kG: cfg.ys,
      k_: false,
      qU: 0,
      e_: A2($elm$core$Basics$composeR, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue, state), tag),
      e3: '',
      gx: true,
      Fw: state.kR
    }), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
      kG: cfg.iB,
      yh: cfg.ej,
      ew: tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setCreatingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsCreating, false, state)))
    })])), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
      kG: cfg.iH,
      yh: cfg.eq,
      ew: cfg.mH(state.kR)
    })]));
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$dropdownBody = F2(function (cfg, listItems) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var options = cfg.e0;
    return A3($elm$html$Html$node, 'dropdown-body', _List_fromArray([$elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2(cfg.q3, state.f8)])), $elm$html$Html$Attributes$class(cfg.dJ)]), function () {
      var _v0 = A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$locationToOptions, state.rm, options);

      if (!_v0.$) {
        var optionList = _v0.a;
        return _Utils_ap($elm$core$List$isEmpty(optionList.e0) ? _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(cfg.mv)]), _List_fromArray([$elm$html$Html$text('No results found')]))]) : listItems(optionList.e0), _List_fromArray([A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function (_v1) {
          var msg = _v1.gi;
          var buttonText = _v1.vF;
          return state.yK ? $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$createInputView({
            ej: cfg.ej,
            iB: cfg.pJ,
            eq: cfg.eq,
            iH: cfg.pL,
            ys: cfg.pK,
            yy: cfg.pM,
            mH: msg,
            Ej: state,
            b3: tag,
            dJ: cfg.pO
          }) : $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$createButtonView({
            iJ: cfg.iJ,
            pI: buttonText,
            Ej: state,
            b3: tag
          });
        }, optionList.wh))]));
      } else {
        return _List_fromArray([cfg.Eb]);
      }
    }());
  });
  var $elm$core$List$intersperse = F2(function (sep, xs) {
    if (!xs.b) {
      return _List_Nil;
    } else {
      var hd = xs.a;
      var tl = xs.b;
      var step = F2(function (x, rest) {
        return A2($elm$core$List$cons, sep, A2($elm$core$List$cons, x, rest));
      });
      var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
      return A2($elm$core$List$cons, hd, spersed);
    }
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$locationToOptionStrings = F3(function (location, maybeOptions, toString) {
    return $elm$core$List$isEmpty(location) ? _List_Nil : A3($elm$core$List$foldr, F2(function (locationIndex, acc) {
      return A2($elm$core$Maybe$withDefault, {
        vU: $elm$core$Maybe$Nothing,
        ir: _List_Nil
      }, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$unwrapOption, function (record) {
        return {
          vU: record.vU,
          ir: A2($elm$core$List$cons, toString(record.Fw), acc.ir)
        };
      }), A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
        return $.e0;
      }, $elm_community$list_extra$List$Extra$getAt(locationIndex)), acc.vU)));
    }), {
      vU: maybeOptions,
      ir: _List_Nil
    }, location).ir;
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$navigateBackBy = F2(function (amount, state) {
    return _Utils_update(state, {
      rm: A2($elm$core$List$drop, amount, state.rm)
    });
  });

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$dropdownTitle = function (cfg) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var options = cfg.e0;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block'), $elm$html$Html$Attributes$class(cfg.kG)]), $elm$core$List$isEmpty(state.rm) ? _List_Nil : _List_fromArray([A3($elm$html$Html$node, 'dropdown-nav-back', _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter pointer'), $author$project$ElmFramework$Lib$Util$onTap(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$navigateBackBy, 1, state)))]), _List_fromArray([cfg.g3])), A3($elm$html$Html$node, 'dropdown-nav-bread-crumbs', _List_fromArray([$elm$html$Html$Attributes$class('flexRow rtl scrollTargetX noScrollbar padRight2')]), A2($elm$core$List$intersperse, A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('padLeft1 padRight1')]), _List_fromArray([$elm$html$Html$text('<')])), A2($elm$core$List$indexedMap, F2(function (index, optionString) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('pointer whiteSpaceNoWrap'), $author$project$ElmFramework$Lib$Util$onTap(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$navigateBackBy, index, state)))]), _List_fromArray([$elm$html$Html$text(optionString)]));
    }), A3($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$locationToOptionStrings, state.rm, options, cfg.t3))))]));
  };

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$editingListItemView = F2(function (cfg, _v0) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var option = _v0;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(cfg.dJ)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1'), $elm$html$Html$Attributes$class(cfg.yy)]), _List_fromArray([function () {
      var _v1 = option.kN;

      if (!_v1.$) {
        var html = _v1.a;
        return html;
      } else {
        return $elm$html$Html$text('');
      }
    }(), $author$project$ElmFramework$Lib$Ui$Input$customAttributesInput({
      uZ: _List_fromArray([$author$project$ElmFramework$Lib$Util$onKeyDownSpecific(_List_fromArray([$author$project$ElmFramework$Lib$Util$OnEnter(cfg.hV(state.k3)), $author$project$ElmFramework$Lib$Util$OnEsc(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditing, $elm$core$Maybe$Nothing, state))))]))]),
      fx: $elm$core$Maybe$Nothing,
      kG: cfg.ys,
      k_: false,
      qU: 0,
      e_: A2($elm$core$Basics$composeR, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue, state), tag),
      e3: '',
      gx: true,
      Fw: state.k3
    }), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
      kG: cfg.iB,
      yh: cfg.ej,
      ew: tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue, '', A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditing, $elm$core$Maybe$Nothing, state)))
    })])), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
      kG: cfg.iH,
      yh: cfg.eq,
      ew: cfg.hV(state.k3)
    })]));
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$expandIndex = F2(function (index, state) {
    return _Utils_update(state, {
      rm: A2($elm$core$List$cons, index, state.rm)
    });
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsOpen = F2(function (isOpen, state) {
    return _Utils_update(state, {
      f8: isOpen
    });
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$listItemView = F3(function (cfg, index, _v0) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var option = _v0;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(cfg.dJ)]), $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([$elm$core$Maybe$Just(A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('flexRow flex1'), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2(cfg.j9, $elm_community$maybe_extra$Maybe$Extra$isJust(option.kN)), _Utils_Tuple2(cfg.j7, option.jM), _Utils_Tuple2('noPointerEvents', !option.jM), _Utils_Tuple2(cfg.j8, !option.jM)])), option.jM ? _List_fromArray([$author$project$ElmFramework$Lib$Util$onTap(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsOpen, false, A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Just(option.Fw), state))))]) : _List_Nil)), _List_fromArray([function () {
      var _v1 = option.kN;

      if (!_v1.$) {
        var html = _v1.a;
        return html;
      } else {
        return $elm$html$Html$text('');
      }
    }(), $elm$html$Html$text(cfg.t3(option.Fw))]))), A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
      kG: cfg.fT,
      yh: cfg.hm,
      ew: tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditingInputValue, cfg.t3(option.Fw), A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setEditing, $elm$core$Maybe$Just(option.Fw), state)))
    })), option.hV), A2($elm$core$Maybe$map, function (onDelete) {
      return $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
        kG: cfg.fT,
        yh: cfg.hg,
        ew: onDelete
      });
    }, option.Ax), A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$iconView({
      kG: cfg.fT,
      yh: cfg.hq,
      ew: tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$expandIndex, index, state))
    })), option.vU)])));
  });
  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$listItem = F3(function (cfg, index, _v0) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var option = _v0;

    var defaultListItemView = function (_v1) {
      return A3($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$listItemView, {
        hg: cfg.hg,
        kY: cfg.kY,
        hm: cfg.hm,
        fT: cfg.fT,
        hq: cfg.hq,
        li: cfg.li,
        Ej: state,
        b3: tag,
        fd: cfg.fd,
        t3: cfg.t3,
        j7: cfg.j7,
        j8: cfg.j8,
        j9: cfg.j9,
        dJ: cfg.dJ
      }, index, option);
    };

    return A2($elm$core$Maybe$withDefault, defaultListItemView(0), A3($elm$core$Maybe$map2, F2(function (editingValue, onEdit) {
      return A2(cfg.fd, option.Fw, editingValue) ? A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$editingListItemView, {
        ej: cfg.ej,
        iB: cfg.p1,
        eq: cfg.eq,
        iH: cfg.p2,
        ys: cfg.p3,
        yy: cfg.p4,
        hV: onEdit,
        Ej: state,
        b3: tag,
        fd: cfg.fd,
        t3: cfg.t3,
        dJ: cfg.p7
      }, option) : defaultListItemView(0);
    }), state.xi, option.hV));
  });

  var $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$nestedSelect = function (cfg) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var options = cfg.e0;
    return A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, state.f8 ? _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onClickAway(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsOpen, false, state)))]) : _List_Nil, _List_fromArray([$elm$html$Html$Attributes$class('block relative'), $elm$html$Html$Attributes$class(cfg.dJ), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2(cfg.vW, state.f8)]))]), _List_fromArray([state.f8 ? A3($elm$html$Html$node, 'dropdown-wrapper', _List_fromArray([$elm$html$Html$Attributes$class('block absolute noOverflow slightShadow'), $elm$html$Html$Attributes$class(cfg.xg)]), _List_fromArray([A3($elm$html$Html$node, 'dropdown-element', _List_fromArray([$elm$html$Html$Attributes$class('block'), $elm$html$Html$Attributes$class(cfg.xa)]), _List_fromArray([cfg.yI ? A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$clearAll, tag, state) : $elm$html$Html$text(''), $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$dropdownTitle({
      g3: cfg.g3,
      kG: cfg.xf,
      e0: options,
      Ej: state,
      b3: tag,
      t3: cfg.t3
    }), A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$dropdownBody, {
      g3: cfg.g3,
      ej: cfg.vI,
      eq: cfg.wa,
      iJ: cfg.wS,
      pJ: cfg.wT,
      pK: cfg.wW,
      pL: cfg.wV,
      pM: cfg.wX,
      pO: cfg.wU,
      q3: cfg.w1,
      mv: cfg.mv,
      e0: options,
      Eb: cfg.Eb,
      Ej: state,
      b3: tag,
      t3: cfg.t3,
      dJ: cfg.wR
    }, $elm$core$List$indexedMap($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$listItem({
      ej: cfg.vJ,
      eq: cfg.wb,
      hg: cfg.hg,
      kY: cfg.w3,
      hm: cfg.hm,
      fT: cfg.w4,
      p1: cfg.wY,
      p2: cfg.w_,
      p3: cfg.w$,
      p4: cfg.w0,
      p7: cfg.wZ,
      hq: cfg.hq,
      li: cfg.w5,
      Ej: state,
      b3: tag,
      fd: cfg.fd,
      t3: cfg.t3,
      j7: cfg.w7,
      j8: cfg.w8,
      j9: cfg.w9,
      dJ: cfg.w2
    })))]))])) : $elm$html$Html$text(''), A3($elm$html$Html$node, 'select-element', _List_fromArray([$elm$html$Html$Attributes$class('relative flexRow flexAlignCenter'), $elm$html$Html$Attributes$class(cfg.DJ), $author$project$ElmFramework$Lib$Util$onTap(tag(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setIsOpen, !state.f8, state)))]), A2($elm$core$List$cons, function () {
      var _v0 = state.ia;

      if (_v0.$ === 1) {
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(cfg.Cr)]), _List_fromArray([$elm$html$Html$text(cfg.e3)]));
      } else {
        var val = _v0.a;
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(cfg.Fx)]), _List_fromArray([$elm$html$Html$text(cfg.t3(val))]));
      }
    }(), _List_fromArray([A3($elm$html$Html$node, 'open-icon', _List_fromArray([$elm$html$Html$Attributes$class('block flexRow flexAlignCenter noPointerEvents transformTransition'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('rotate180', state.f8)]))]), _List_fromArray([cfg.Cd]))])))]));
  };

  var $author$project$Ui$NestedSelect$nestedSelect = function (cfg) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    var options = cfg.e0;

    var showSelectDescription = function () {
      var _v0 = cfg.nY;

      if (!_v0.$) {
        var description = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text(description)]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([showSelectDescription, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelect$nestedSelect({
      g3: $author$project$IconSvg$arrowLeft('w3 h3 primary30Fill marLeft1 marTop2 marBottom2 marRight2'),
      vI: $author$project$IconSvg$close('w2 h2 gray40Fill'),
      vJ: $author$project$IconSvg$close('w2 h2 gray40Fill'),
      vW: 'z4',
      wa: $author$project$IconSvg$check('w3 h3 primary30Fill'),
      wb: $author$project$IconSvg$check('w3 h3 primary30Fill'),
      hg: $author$project$IconSvg$delete('w3 h3 primary30Fill'),
      wR: 'block',
      wS: 'padLeft2 padRight2 padTop1h padBottom1h heading4Regular gray40 fullWidth',
      wT: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      wU: 'padLeft2 padRight2 padTop1h padBottom1h spaceBetween',
      wV: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      wW: 'flex1 padLeft2 padRight0 padTop1h padBottom1h heading4Bold',
      wX: 'borderHairlineWidth borderSolid secondary0Border radius0',
      wY: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      wZ: 'padLeft2 padRight2 padTop1h padBottom1h spaceBetween',
      w_: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      w$: 'flex1 padLeft2 padRight0 padTop1h padBottom1h heading4Bold',
      w0: 'borderHairlineWidth borderSolid secondary0Border radius0',
      w1: 'maxH50 overflowYAuto',
      w2: 'spaceBetween',
      w3: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      w4: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      w5: 'padLeft2 padRight2 padTop1h padBottom1h pointer',
      w7: 'padLeft2 padRight2 padTop1h padBottom1h left pointer',
      w8: 'padLeft2 padRight2 padTop1h padBottom1h left cursorDefault',
      w9: 'heading4Bold',
      xa: 'whiteBack',
      xf: 'flexRow flexAlignCenter',
      xg: 'left0 top0 padTop6 radius0 fullWidth heading4Regular primary30',
      hm: $author$project$IconSvg$edit('w3 h3 primary30Fill'),
      hq: $author$project$IconSvg$down('w3 h3 rotate-90 primary30Fill z1'),
      yI: cfg.yI,
      mv: 'block padLeft2 padRight2 padTop1h padBottom1h',
      Cd: $author$project$IconSvg$down('w3 h3 primary30Fill z1'),
      e0: options,
      e3: cfg.e3,
      Cr: 'gray40',
      DJ: 'padLeft2 padRight2 fullWidth fullHeight spaceBetween pointer',
      Eb: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 padBottom2')]), _List_fromArray([$author$project$Ui$SimpleSpinner$simpleSpinner])),
      Ej: state,
      b3: tag,
      fd: cfg.fd,
      t3: cfg.t3,
      Fx: 'primary30',
      dJ: 'h6 fullWidth heading4Bold borderHairlineWidth borderSolid gray20Border radius0 ' + cfg.zO
    })]));
  };

  var $author$project$Ui$DropdownSelect$toOption = function (a) {
    return {
      vU: $elm$core$Maybe$Nothing,
      kN: $elm$core$Maybe$Nothing,
      Ax: $elm$core$Maybe$Nothing,
      hV: $elm$core$Maybe$Nothing,
      jM: true,
      Fw: a
    };
  };

  var $author$project$Ui$DropdownSelect$dropdownSelect = function (cfg) {
    return $author$project$Ui$NestedSelect$nestedSelect({
      vV: cfg.vV,
      yI: cfg.yI,
      zO: '',
      e0: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, A2($elm$core$List$map, $author$project$Ui$DropdownSelect$toOption, cfg.e0), $elm$core$Maybe$Nothing)),
      e3: cfg.e3,
      nY: $elm$core$Maybe$Nothing,
      Ej: cfg.Ej,
      b3: cfg.b3,
      fd: cfg.fd,
      t3: cfg.EU
    });
  };

  var $author$project$IconSvg$filter_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M30.9991 8C31.5519 8 32 8.44782 32 9.00023C32 9.27402 31.8877 9.53585 31.6893 9.72464L23.2997 17.7066C23.1013 17.8954 22.989 18.1573 22.989 18.431V30.9998C22.989 31.5522 22.5408 32 21.9881 32C21.7904 32 21.5973 31.9415 21.4328 31.832L17.4292 29.1647C17.1507 28.9792 16.9835 28.6669 16.9835 28.3325V18.4301C16.9835 18.1569 16.8716 17.8955 16.6739 17.7068L8.3096 9.72355C7.90985 9.34201 7.8953 8.70887 8.2771 8.30939C8.46595 8.11179 8.72748 8 9.00091 8H30.9991ZM28.1206 9.99946H11.872C11.7891 9.99946 11.7219 10.0666 11.7219 10.1495C11.7219 10.1905 11.7387 10.2297 11.7683 10.258L18.0565 16.2601C18.6003 16.7791 18.9276 17.4812 18.9784 18.226L18.9853 18.4301V27.6627C18.9853 27.7463 19.0271 27.8244 19.0967 27.8708L20.5981 28.8715C20.713 28.9481 20.8684 28.9171 20.9451 28.8022C20.9725 28.7611 20.9871 28.7128 20.9871 28.6635V18.431C20.9871 17.6781 21.2703 16.9553 21.776 16.4039L21.9194 16.2578L28.2241 10.2581C28.2842 10.201 28.2865 10.106 28.2293 10.046C28.201 10.0163 28.1617 9.99946 28.1206 9.99946Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$filter = function (classes) {
    return $author$project$IconSvg$filter_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$FilterButton$filterButton = F2(function (filterState, filterMsg) {
    return _Utils_eq(filterState, $author$project$Types$Filters$empty) ? $author$project$Ui$Button$button({
      kG: 'circle primary0Back borderSolid borderHairlineWidth gray20Border w6 h6',
      pD: $author$project$IconSvg$filter('primary30Fill w3'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(filterMsg)
    }) : $author$project$Ui$Button$button({
      kG: 'circle primary30Back w6 h6',
      pD: $author$project$IconSvg$filter('primary0Fill w3'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(filterMsg)
    });
  });

  var $author$project$Types$SelectScenariosOrBlocks$fromRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 2) {
      return 0;
    } else {
      return 1;
    }
  };

  var $author$project$Ui$Input$inputWithIcon = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth h6 padLeft5 padRight1 placeholderGray40 heading4Bold borderHairlineWidth borderSolid gray20Border radius0 primary30'), $elm$html$Html$Attributes$value(cfg.Fw), $elm$html$Html$Events$onInput(cfg.b3), $elm$html$Html$Attributes$type_(cfg.P), $elm$html$Html$Attributes$required(cfg.gx), $elm$html$Html$Attributes$placeholder(cfg.e3)]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute left1 top0 bottom0 flexCenter noPointerEvents')]), _List_fromArray([cfg.yh('w3 gray20Fill')]))]));
  };

  var $author$project$IconSvg$search_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M24.0686 23.0943H25.1527L32 29.9554L29.9554 32L23.0943 25.1527V24.0686L22.7238 23.6844C21.1595 25.0292 19.1286 25.8388 16.9194 25.8388C11.9931 25.8388 8 21.8456 8 16.9194C8 11.9931 11.9931 8 16.9194 8C21.8456 8 25.8388 11.9931 25.8388 16.9194C25.8388 19.1286 25.0292 21.1595 23.6844 22.7238L24.0686 23.0943ZM10.7444 16.9194C10.7444 20.3362 13.5026 23.0943 16.9194 23.0943C20.3362 23.0943 23.0943 20.3362 23.0943 16.9194C23.0943 13.5026 20.3362 10.7444 16.9194 10.7444C13.5026 10.7444 10.7444 13.5026 10.7444 16.9194Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$search = function (classes) {
    return $author$project$IconSvg$search_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $elm_community$list_extra$List$Extra$findIndexHelp = F3(function (index, predicate, list) {
    findIndexHelp: while (true) {
      if (!list.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var x = list.a;
        var xs = list.b;

        if (predicate(x)) {
          return $elm$core$Maybe$Just(index);
        } else {
          var $temp$index = index + 1,
              $temp$predicate = predicate,
              $temp$list = xs;
          index = $temp$index;
          predicate = $temp$predicate;
          list = $temp$list;
          continue findIndexHelp;
        }
      }
    }
  });
  var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toHotSpot = F2(function (onSelectTag, _v0) {
    var id = _v0.F;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 pointer'), $author$project$ElmFramework$Lib$Util$onTap(onSelectTag(id))]), _List_Nil);
  });

  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOffStateView = function (_v0) {
    var offState = _v0.rG;
    var _v1 = offState;
    var attrs = _v1.a;
    var content = _v1.b;
    return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('flex1 flexCenter')]), attrs), content);
  };

  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOnStateView = function (_v0) {
    var onState = _v0.r7;
    var _v1 = onState;
    var attrs = _v1.a;
    var content = _v1.b;
    return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('flex1 flexCenter')]), attrs), content);
  };

  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$radioSliderList = function (config) {
    var unselectedItems = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexRow ')]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOffStateView, config.hH));
    var itemsCount = $elm$core$List$length(config.hH);
    var itemPortion = 100 / itemsCount;
    var hotSpots = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexRow ')]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toHotSpot(config.BE), config.hH));
    var currItemIndex = A2($elm$core$Maybe$withDefault, 0, A2($elm_community$list_extra$List$Extra$findIndex, function (_v0) {
      var id = _v0.F;
      return _Utils_eq(id, config.wm);
    }, config.hH));
    var selectedItem = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('selectedItem relative noOverflow'), $elm$html$Html$Attributes$class(config.DP), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat(itemPortion) + '%'), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(' + ($elm$core$String$fromInt(currItemIndex) + '00%) translateZ(1px)'))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('selectedItems flexRow'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromInt(itemsCount) + '00%'), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-' + ($elm$core$String$fromFloat(currItemIndex * itemPortion) + '%)'))]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOnStateView, config.hH))]));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.kG)]), _List_fromArray([A3($elm$html$Html$node, 'radio-slider', _List_fromArray([$elm$html$Html$Attributes$class('block relative')]), _List_fromArray([unselectedItems, selectedItem, hotSpots]))]));
  };

  var $author$project$Ui$SlideSelectMultiple$slideSelectMultiple = function (cfg) {
    var colorToggleOption = function () {
      var _v1 = cfg.v_;

      if (!_v1.$) {
        switch (_v1.a) {
          case 0:
            var _v2 = _v1.a;
            return {
              vV: 'borderSolid borderHairlineWidth gray10Border radius0 minH6 ',
              rG: 'primary30 primary0Back noBorder ',
              r7: 'primary30Back primary0 minH6 '
            };

          case 1:
            var _v3 = _v1.a;
            return {
              vV: 'borderSolid borderHairlineWidth gray10Border radius0 minH4 ',
              rG: 'primary30 primary0Back noBorder ',
              r7: 'primary30Back primary0 minH4 '
            };

          case 2:
            var _v4 = _v1.a;
            return {
              vV: 'radius0',
              rG: 'gray40 gray10Back ',
              r7: 'primary20Back minH4 '
            };

          default:
            var _v5 = _v1.a;
            return {
              vV: 'borderSolid borderHairlineWidth gray10Border radius0 minH4 ',
              rG: 'gray10Back primary30 ',
              r7: 'primary0Back primary30 '
            };
        }
      } else {
        return {
          vV: '',
          rG: '',
          r7: ''
        };
      }
    }();

    var toItem = function (_v0) {
      var itemId = _v0.a;
      var label = _v0.b;
      return {
        F: itemId,
        rG: _Utils_Tuple2(_List_fromArray([$elm$html$Html$Attributes$class(colorToggleOption.rG)]), _List_fromArray([$elm$html$Html$text(label)])),
        r7: _Utils_Tuple2(_List_fromArray([$elm$html$Html$Attributes$class(colorToggleOption.r7), $elm$html$Html$Attributes$class(cfg.BP)]), _List_fromArray([$elm$html$Html$text(label)]))
      };
    };

    return $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$radioSliderList({
      kG: 'heading4Bold ' + (colorToggleOption.vV + cfg.vV),
      wm: cfg.wm,
      hH: A2($elm$core$List$map, toItem, cfg.hH),
      BE: cfg.BE,
      DP: 'radius0 primary0 '
    });
  };

  var $author$project$Types$SelectScenariosOrBlocks$toRoute = F2(function (companyId, scenariosOrBlocks) {
    if (!scenariosOrBlocks) {
      return A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios));
    } else {
      return A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksBasic(false)));
    }
  });
  var $author$project$Views$Routed$BlocksBranch$topContentElements = F3(function (company, topState, filterMsg) {
    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary30')]), _List_fromArray([$elm$html$Html$text('Scenarios & Blocks')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop5 marBottom7')]), _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
      vV: 'w46',
      v_: $elm$core$Maybe$Just(0),
      wm: $author$project$Types$SelectScenariosOrBlocks$fromRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)),
      hH: _List_fromArray([_Utils_Tuple2(0, 'Scenarios'), _Utils_Tuple2(1, 'Blocks')]),
      BE: function (curr) {
        return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Types$SelectScenariosOrBlocks$toRoute, company.F, curr));
      },
      BP: 'minH6'
    }), $author$project$ElmFramework$Lib$Util$spacer('flex1'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([$author$project$Ui$Input$inputWithIcon({
      vV: 'flex1 whiteBack w34',
      yh: $author$project$IconSvg$search,
      e3: 'Search for a Block',
      gx: false,
      b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlocks, $author$project$Ui$Blocks$Msg$OnFilterUpdate), $author$project$Types$Filters$UpdateTextSearch),
      P: 'text',
      Fw: topState.o_.vl.qo.j_
    }), $author$project$ElmFramework$Lib$Util$spacer('w2'), function () {
      var classificationRoute = A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksClassification(false)));
      var basicRoute = A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksBasic(false)));

      var options = _List_fromArray([_Utils_Tuple2('Alphabetically A-Z', basicRoute), _Utils_Tuple2('By Classification', classificationRoute)]);

      var selected = A2($elm_community$list_extra$List$Extra$find, function (_v0) {
        var route = _v0.b;
        return _Utils_eq(route, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc));
      }, options);
      return $author$project$Ui$DropdownSelect$dropdownSelect({
        vV: 'marRight2 w26',
        yI: false,
        e0: options,
        e3: 'Select a Block',
        Ej: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, selected, topState.o_.vl.ul),
        b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlocks, $author$project$Ui$Blocks$Msg$OnViewBlocksByDropdownChanged),
        fd: $elm$core$Basics$eq,
        EU: $elm$core$Tuple$first
      });
    }(), A2($author$project$Ui$FilterButton$filterButton, topState.o_.vl.qo, filterMsg)]))]))]));
  });
  var $author$project$UiWrappers$MainAppWrapModel$LeftHidden = 0;
  var $author$project$UiWrappers$MainAppWrapSpecific$Msg$ToggleLeftSidebar = {
    $: 1
  };
  var $elm_community$maybe_extra$Maybe$Extra$filter = F2(function (f, m) {
    var _v0 = A2($elm$core$Maybe$map, f, m);

    if (!_v0.$ && _v0.a) {
      return m;
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Ui$Button$GrayColor = 5;

  var $author$project$UiWrappers$MainAppWrap$bottomBar = function (cfg) {
    var _v0 = cfg.vw;

    if (!_v0.$) {
      if (!_v0.a.$) {
        var count = _v0.a.a.k;
        var onClearSelection = _v0.a.a.rL;
        var onCreateScenario = _v0.a.a.rN;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back borderTopHairline')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow desktopWidthCenter pad2 flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(count))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft0h primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text(A3($author$project$ElmFramework$Lib$Util$ifElse, 'Block Selected', 'Blocks Selected', count === 1))])), $author$project$ElmFramework$Lib$Util$spacer('w7'), $author$project$Ui$Button$basicButton({
          kG: '',
          vY: 5,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onClearSelection),
          y$: 'Clear Selection'
        }), $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$Ui$Button$basicButton({
          kG: 'minW28',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onCreateScenario),
          y$: count === 1 ? 'Create a new scenario with this block' : 'Create a new scenario with these blocks'
        })]))]));
      } else {
        var count = _v0.a.a.k;
        var onRevert = _v0.a.a.r0;
        var onSave = _v0.a.a.r2;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back borderTopHairline flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow desktopWidthCenter pad2 flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(count))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft0h primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text('Block' + (A3($author$project$ElmFramework$Lib$Util$ifElse, 's have', ' has', count > 1) + ' been modified.'))])), $author$project$ElmFramework$Lib$Util$spacer('w7'), $author$project$Ui$Button$basicButton({
          kG: '',
          vY: 5,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onRevert),
          y$: 'Revert Change' + A3($author$project$ElmFramework$Lib$Util$ifElse, 's', '', count > 1)
        }), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButton({
          kG: '',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onSave),
          y$: 'Save Change' + A3($author$project$ElmFramework$Lib$Util$ifElse, 's', '', count > 1)
        })]))]));
      }
    } else {
      return $author$project$ElmFramework$Lib$Util$noOpEl;
    }
  };

  var $author$project$Ui$Button$ButtonContentIconMedium = 1;

  var $author$project$IconSvg$accounts_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M29.3691 9.00681L35.8611 15.4989C36.8133 16.451 36.8133 18.0091 35.8611 19.0478L24.7813 30.1276C23.8292 31.0798 22.2711 31.0798 21.3189 30.1276L14.8269 23.6355C13.8747 22.6834 13.8747 21.1253 14.8269 20.1731L25.9066 9.00681C26.8588 8.05464 28.4169 8.05464 29.3691 9.00681ZM26.8588 9.95897L15.6925 21.0387C15.2597 21.4715 15.2597 22.2506 15.6925 22.5968L19.934 26.8383L32.7449 14.2004L28.5034 9.95897C27.9841 9.52617 27.2916 9.52617 26.8588 9.95897ZM23.8292 29.1754L34.9089 18.0091C35.3417 17.5763 35.3417 16.8838 34.9955 16.451L33.6105 15.066L20.7996 27.7905L22.1845 29.1754C22.7039 29.6082 23.3964 29.6082 23.8292 29.1754ZM11.3645 30.041C11.8838 30.4738 12.5763 30.4738 13.0091 30.041L15.3462 27.7039L16.2984 28.6561L13.9613 30.9932C13.0091 31.9454 11.451 31.9454 10.4989 30.9932L4.00681 24.5012C3.05464 23.549 3.05464 21.9909 4.00681 21.0387L15.1731 9.87241C16.1253 8.92025 17.6834 8.92025 18.6355 9.87241L20.0205 11.2574L19.0683 12.2095L17.6834 10.8246C17.164 10.3918 16.4715 10.3918 16.0387 10.8246L4.78585 21.8178C4.35305 22.3371 4.35305 23.0296 4.78585 23.4624L9.37356 28.0501L12.4897 24.934L13.4419 25.8861L10.3257 29.0023L11.3645 30.041Z')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M36.0681 19.2548L24.9883 30.3345C23.9218 31.401 22.1784 31.401 21.112 30.3345L14.6199 23.8425C13.5535 22.7761 13.5535 21.0329 14.6197 19.9664C14.6198 19.9663 14.6196 19.9664 14.6197 19.9664L25.6997 8.79985C26.7661 7.73338 28.5095 7.73338 29.576 8.79985L36.0681 15.2919C37.1392 16.3631 37.1269 18.1001 36.0768 19.2456L36.0681 19.2548ZM14.8269 20.1731C13.8747 21.1253 13.8747 22.6834 14.8269 23.6355L21.3189 30.1276C22.2711 31.0798 23.8292 31.0798 24.7813 30.1276L35.8611 19.0478C36.8133 18.0091 36.8133 16.451 35.8611 15.4989L29.3691 9.00681C28.4169 8.05464 26.8588 8.05464 25.9066 9.00681L14.8269 20.1731ZM26.8588 9.95897L15.6925 21.0387C15.2597 21.4715 15.2597 22.2506 15.6925 22.5968L19.934 26.8383L32.7449 14.2004L28.5034 9.95897C27.9841 9.52617 27.2916 9.52617 26.8588 9.95897ZM28.3064 10.1758C27.8862 9.83261 27.3726 9.85905 27.0658 10.1659L27.065 10.1667L15.8994 21.2457C15.8994 21.2458 15.8995 21.2456 15.8994 21.2457C15.7445 21.4007 15.6606 21.6261 15.6606 21.8502C15.6606 22.076 15.7442 22.2634 15.8753 22.3683L15.888 22.3784L19.9354 26.4258L32.3296 14.199L28.3064 10.1758ZM34.7012 17.803L34.702 17.8021C35.0193 17.4849 35.0255 16.9697 34.7762 16.6456L33.6098 15.4793L21.2142 27.7912L22.3816 28.9586C22.8015 29.3016 23.3148 29.2754 23.6217 28.969C23.6219 28.9688 23.6215 28.9691 23.6217 28.969L34.7012 17.803ZM23.8292 29.1754C23.3964 29.6082 22.7039 29.6082 22.1845 29.1754L20.7996 27.7905L33.6105 15.066L34.9955 16.451C35.3417 16.8838 35.3417 17.5763 34.9089 18.0091L23.8292 29.1754ZM10.3257 29.0023L11.3645 30.041C11.8838 30.4738 12.5763 30.4738 13.0091 30.041L15.3462 27.7039L16.2984 28.6561L13.9613 30.9932C13.0091 31.9454 11.451 31.9454 10.4989 30.9932L4.00681 24.5012C3.05464 23.549 3.05464 21.9909 4.00681 21.0387L15.1731 9.87241C16.1253 8.92025 17.6834 8.92025 18.6355 9.87241L20.0205 11.2574L19.0683 12.2095L17.6834 10.8246C17.164 10.3918 16.4715 10.3918 16.0387 10.8246L4.78585 21.8178C4.35305 22.3371 4.35305 23.0296 4.78585 23.4624L9.37356 28.0501L12.4897 24.934L13.4419 25.8861L10.3257 29.0023ZM9.37356 27.6362L12.4897 24.52L13.8558 25.8861L10.7396 29.0023L11.5615 29.8242C11.9817 30.1674 12.4953 30.1409 12.8021 29.8341L15.3462 27.29L16.7123 28.6561L14.1682 31.2002C13.1018 32.2666 11.3584 32.2666 10.2919 31.2002L3.79985 24.7081C2.73338 23.6416 2.73338 21.8982 3.79985 20.8318L14.9662 9.66546C16.0326 8.59899 17.776 8.59899 18.8425 9.66546L20.4344 11.2574L19.0683 12.6235L17.4863 11.0414C17.0661 10.6982 16.5526 10.7247 16.2457 11.0315L16.2433 11.034L5.00165 22.0161C4.65954 22.436 4.68624 22.9489 4.99281 23.2555L9.37356 27.6362Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$accounts = function (classes) {
    return $author$project$IconSvg$accounts_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$budget_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M19.9462 8C11.6667 8 5 14.6667 5 22.9462C5 25.5269 5.64516 28.1075 7.04301 30.4731C7.25806 30.9032 7.7957 31.0108 8.22581 30.7957C8.22581 30.7957 8.87097 30.4731 9.51613 30.043L11.4516 28.9677L10.5914 27.3548L9.83871 27.7849L8.22581 28.7527C7.47312 27.2473 7.04301 25.5269 6.93548 23.8064H8.87097H9.73118V22.086H7.36559H6.82796C6.93548 20.3656 7.36559 18.6452 8.11828 17.1398L8.65591 17.4624L10.5914 18.5376L11.4516 17.0323L10.6989 16.6021L8.97849 15.6344C9.94624 14.2366 11.129 12.9462 12.6344 11.9785L13.6021 13.5914L14.0323 14.3441L14.6774 13.914L15.4301 13.4839L14.3548 11.5484L14.1398 11.1183C15.6452 10.3656 17.3656 9.93548 19.086 9.82796V10.3656V11.7634V12.6237H19.9462H20.8064V11.6559V10.3656V9.82796C22.5269 9.93548 24.2473 10.3656 25.7527 11.1183L25.4301 11.5484L24.3548 13.4839L25.8602 14.3441L26.2903 13.5914L27.2581 11.9785C28.6559 12.9462 29.9462 14.129 30.914 15.6344L29.3011 16.6021L28.4409 17.0323L29.3011 18.5376L31.2366 17.4624L31.7742 17.1398C32.5269 18.6452 32.957 20.3656 33.0645 22.086H32.5269H30.2688V23.8064H31.2366H33.172C33.0645 25.5269 32.6344 27.2473 31.8817 28.7527L31.3441 28.4301L29.4086 27.3548L28.5484 28.8602L29.1935 29.2903L29.3011 29.3978L31.7742 30.7957C32.2043 31.0108 32.7419 30.9032 32.957 30.4731C34.2473 28.2151 35 25.6344 35 22.9462C34.8925 14.6667 28.2258 8 19.9462 8ZM16.6125 24.4514C17.0427 24.8815 17.4728 25.3116 17.7953 25.7417L18.6556 24.8815C18.9781 25.0965 19.4082 25.204 19.8384 25.204C21.3437 25.204 22.6341 24.0212 22.6341 22.4083C22.6341 21.9782 22.5265 21.5481 22.3115 21.2255L25.8599 17.6772L24.5695 16.3868L21.1287 19.9352C20.8061 19.7202 20.376 19.6126 19.9459 19.6126C18.4405 19.6126 17.1502 20.7954 17.1502 22.4083C17.1502 22.8385 17.2577 23.2686 17.4728 23.5911L16.6125 24.4514ZM19.9459 21.4406C20.4835 21.4406 20.9136 21.8707 20.9136 22.4083C20.9136 22.946 20.4835 23.3761 19.9459 23.3761C19.4082 23.3761 18.9781 22.946 18.9781 22.4083C18.9781 21.8707 19.4082 21.4406 19.9459 21.4406ZM16.2903 29.6132H17.1505H22.7419H23.6021V31.3336H22.7419H17.1505H16.2903V29.6132Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$budget = function (classes) {
    return $author$project$IconSvg$budget_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$cashboard_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8.09371 28.2781H20.4614C24.6193 28.2781 28.7749 28.2781 32.9328 28.2758C33.6352 28.2758 33.9982 27.9246 33.9982 27.2339C34.0006 22.5056 34.0006 17.7749 33.9982 13.0442C33.9982 12.3512 33.6376 12 32.9375 12H8.06306C7.34886 12 6.99765 12.3536 7.00001 13.0772V27.1986C7.00001 27.9363 7.34415 28.2781 8.09371 28.2781ZM8.82441 13.8126H32.1809V26.4655H8.82441V13.8126ZM15.9918 20.1253C15.98 22.6144 18.0213 24.6839 20.4915 24.6863C22.9618 24.6886 25.0054 22.6285 25.003 20.1347C24.9983 17.6527 22.9783 15.6044 20.5198 15.5926C18.0472 15.5785 16.0036 17.6268 15.9918 20.1253ZM20.5127 22.8808C19.0348 22.8855 17.8115 21.648 17.8091 20.1465C17.8068 18.645 19.0278 17.3958 20.4986 17.3958C21.9718 17.3958 23.1857 18.6403 23.1833 20.1489C23.181 21.6362 21.9694 22.876 20.5127 22.8808ZM28.5693 22.8823V17.3926C28.4856 17.3926 28.4014 17.3929 28.3169 17.3931H28.3167C28.1465 17.3937 27.9749 17.3942 27.8032 17.3926C27.214 17.3855 26.8085 17.0249 26.8015 16.4993C26.792 15.9642 27.181 15.5989 27.7773 15.5918C28.3242 15.5847 28.8734 15.5847 29.4202 15.5918C30.0331 15.6012 30.3796 15.943 30.3796 16.5511C30.3843 18.9436 30.3843 21.336 30.3796 23.7285C30.3796 24.3201 30.0354 24.6713 29.4509 24.6831C28.8804 24.6949 28.31 24.6949 27.7396 24.6831C27.1715 24.6713 26.7897 24.2895 26.8015 23.7686C26.8109 23.2689 27.2045 22.8964 27.742 22.8823C27.9137 22.8792 28.0865 22.8802 28.2703 22.8812H28.2705C28.3666 22.8817 28.4657 22.8823 28.5693 22.8823ZM12.6985 22.8814C12.6118 22.8821 12.5235 22.8827 12.4328 22.8827V17.3954C12.5235 17.3954 12.612 17.3961 12.6989 17.3967C12.8966 17.3982 13.086 17.3996 13.2743 17.393C13.8093 17.3718 14.1935 16.99 14.1935 16.4856C14.1912 15.9788 13.814 15.6064 13.2672 15.5946C12.685 15.5828 12.1028 15.5804 11.5206 15.5946C10.9549 15.6087 10.6131 15.9576 10.6131 16.5327C10.6084 18.9369 10.6084 21.3412 10.6131 23.7454C10.6131 24.3159 10.9572 24.6694 11.5229 24.6836C12.1051 24.6977 12.6873 24.6953 13.2695 24.6836C13.8187 24.6718 14.1935 24.297 14.1935 23.7902C14.1935 23.2834 13.814 22.9039 13.2743 22.8851C13.0844 22.8785 12.8956 22.88 12.6985 22.8814Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$cashboard = function (classes) {
    return $author$project$IconSvg$cashboard_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$MainAppMenu$feedbackContactTermsConditionsButtons = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop4 padLeft3 padBottom0h flexColumn')]), _List_fromArray([$author$project$Ui$Button$textButton({
      kz: 'Feedback',
      vV: 'heading4Regular gray40 left',
      gi: cfg.ql
    }), $author$project$Ui$Button$textButton({
      kz: 'Contact',
      vV: 'heading4Regular gray40 left padTop4',
      gi: cfg.pC
    }), $author$project$Ui$Button$textButton({
      kz: 'Terms & Conditions',
      vV: 'heading4Regular gray40 left padTop4',
      gi: cfg.tV
    })]));
  };

  var $author$project$Route$RouteUtil$isAccountsRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 4) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$RouteUtil$isBudgetRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 1) {
      var _v1 = route.b;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$RouteUtil$isScenariosRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 2) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$Button$mainAppMenuExpandedButton = function (config) {
    var selected = config.lV ? {
      vV: 'secondary70Back'
    } : {
      vV: 'primary0Back'
    };
    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Button$button({
      kG: A2($elm$core$String$join, ' ', _List_fromArray(['fullWidth minH6 radius0 noBorder heading4Bold padLeft4 padRight4 primary20', selected.vV, config.vV])),
      pD: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([config.yh('w4 primary20Fill marRight1'), $elm$html$Html$text(config.y$)])),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(config.ew)
    })]));
  };

  var $author$project$Ui$MainAppMenu$onTapBranchLink = F3(function (session, currRoute, companyRoute) {
    var maybeCompany = A2($elm_community$maybe_extra$Maybe$Extra$orElseLazy, function (_v1) {
      return $author$project$Types$UserSession$toFirstCompanyIdForThisUser(session);
    }, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$UserSession$toCompany, id, session);
    }, $author$project$Route$RouteUtil$toCompanyId(currRoute)));

    if (!maybeCompany.$) {
      var company = maybeCompany.a;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, companyRoute));
    } else {
      return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Strange, you don\'t have a company yet. How come?', _List_Nil);
    }
  });
  var $author$project$Types$BudgetQuery$fromCompany = F2(function (scenarioId, company) {
    return {
      pb: 1,
      pA: scenarioId,
      eO: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map(function ($) {
        return $.F;
      }), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO)))),
      ka: 0
    };
  });
  var $author$project$Ui$MainAppMenu$onTapBudget = F2(function (currRoute, session) {
    var maybeCompany = A2($elm_community$maybe_extra$Maybe$Extra$orElseLazy, function (_v3) {
      return $author$project$Types$UserSession$toFirstCompanyIdForThisUser(session);
    }, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$UserSession$toCompany, id, session);
    }, $author$project$Route$RouteUtil$toCompanyId(currRoute)));
    var maybeBaseScenarioId = A2($elm$core$Maybe$andThen, function ($) {
      return $.pa;
    }, maybeCompany);

    var _v0 = _Utils_Tuple2(maybeCompany, maybeBaseScenarioId);

    if (!_v0.a.$) {
      if (!_v0.b.$) {
        var company = _v0.a.a;
        var baseScenarioId = _v0.b.a;
        return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Budget, A2($author$project$Types$BudgetQuery$fromCompany, baseScenarioId, company), 0)));
      } else {
        var company = _v0.a.a;
        var _v1 = _v0.b;
        return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please create a budget scenario first', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))]));
      }
    } else {
      var _v2 = _v0.a;
      return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Strange, you don\'t have a company yet. How come?', _List_Nil);
    }
  });
  var $author$project$Ui$MainAppMenu$onTapCashboard = F2(function (currRoute, session) {
    var maybeCompany = A2($elm_community$maybe_extra$Maybe$Extra$orElseLazy, function (_v3) {
      return $author$project$Types$UserSession$toFirstCompanyIdForThisUser(session);
    }, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$UserSession$toCompany, id, session);
    }, $author$project$Route$RouteUtil$toCompanyId(currRoute)));
    var maybeBaseScenarioId = A2($elm$core$Maybe$andThen, function ($) {
      return $.pa;
    }, maybeCompany);

    var _v0 = _Utils_Tuple2(maybeCompany, maybeBaseScenarioId);

    if (!_v0.a.$) {
      if (!_v0.b.$) {
        var company = _v0.a.a;
        var baseScenarioId = _v0.b.a;
        return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$fromCompany, baseScenarioId, company), $author$project$Route$CashboardRoute$CashboardHome)));
      } else {
        var company = _v0.a.a;
        var _v1 = _v0.b;
        return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please create a scenario first', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))]));
      }
    } else {
      var _v2 = _v0.a;
      return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Strange, you don\'t have a company yet. How come?', _List_Nil);
    }
  });

  var $author$project$IconSvg$settings_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M21.8271 32H17.4591C16.8952 32 16.4073 31.6076 16.2867 31.0568L15.7983 28.796C15.1467 28.5105 14.5289 28.1535 13.9563 27.7316L11.7519 28.4336C11.2143 28.605 10.6299 28.3788 10.3479 27.89L8.15907 24.1088C7.88017 23.6198 7.97626 23.003 8.39067 22.622L10.1007 21.062C10.0229 20.3553 10.0229 19.6423 10.1007 18.9356L8.39067 17.3792C7.97565 16.998 7.87952 16.3805 8.15907 15.8912L10.3431 12.1076C10.6251 11.6188 11.2095 11.3926 11.7471 11.564L13.9515 12.266C14.2443 12.049 14.5492 11.8487 14.8647 11.666C15.1675 11.4952 15.4791 11.3406 15.7983 11.2028L16.2879 8.9444C16.408 8.39356 16.8953 8.00059 17.4591 8H21.8271C22.3908 8.00059 22.8782 8.39356 22.9983 8.9444L23.4927 11.204C23.8296 11.3522 24.1578 11.5197 24.4755 11.7056C24.7718 11.877 25.0582 12.0649 25.3335 12.2684L27.5391 11.5664C28.0763 11.3956 28.66 11.6218 28.9419 12.11L31.1259 15.8936C31.4048 16.3826 31.3087 16.9994 30.8943 17.3804L29.1843 18.9404C29.262 19.6471 29.262 20.3601 29.1843 21.0668L30.8943 22.6268C31.3087 23.0078 31.4048 23.6246 31.1259 24.1136L28.9419 27.8972C28.66 28.3854 28.0763 28.6116 27.5391 28.4408L25.3335 27.7388C25.0544 27.9444 24.7644 28.1346 24.4647 28.3088C24.1501 28.4911 23.8256 28.6557 23.4927 28.802L22.9983 31.0568C22.8777 31.6072 22.3905 31.9995 21.8271 32ZM14.3871 25.0748L15.3711 25.7948C15.5929 25.9582 15.8241 26.1084 16.0635 26.2448C16.2887 26.3752 16.5206 26.4938 16.7583 26.6L17.8779 27.0908L18.4263 29.6H20.8623L21.4107 27.0896L22.5303 26.5988C23.019 26.3833 23.4829 26.1153 23.9139 25.7996L24.8991 25.0796L27.3483 25.8596L28.5663 23.75L26.6667 22.0184L26.8011 20.804C26.8601 20.2728 26.8601 19.7368 26.8011 19.2056L26.6667 17.9912L28.5675 16.256L27.3483 14.1452L24.8991 14.9252L23.9139 14.2052C23.4828 13.8881 23.019 13.6181 22.5303 13.4L21.4107 12.9092L20.8623 10.4H18.4263L17.8755 12.9104L16.7583 13.4C16.5204 13.5045 16.2885 13.6218 16.0635 13.7516C15.8256 13.8876 15.5956 14.037 15.3747 14.1992L14.3895 14.9192L11.9415 14.1392L10.7211 16.256L12.6207 17.9852L12.4863 19.2008C12.4272 19.732 12.4272 20.268 12.4863 20.7992L12.6207 22.0136L10.7211 23.7452L11.9391 25.8548L14.3871 25.0748ZM19.6383 24.8C16.9873 24.8 14.8383 22.651 14.8383 20C14.8383 17.349 16.9873 15.2 19.6383 15.2C22.2892 15.2 24.4383 17.349 24.4383 20C24.435 22.6496 22.2879 24.7967 19.6383 24.8ZM19.6383 17.6C18.3271 17.6013 17.2597 18.6546 17.2409 19.9656C17.2222 21.2766 18.2589 22.36 19.5695 22.3989C20.88 22.4378 21.9793 21.4178 22.0383 20.108V20.588V20C22.0383 18.6745 20.9637 17.6 19.6383 17.6Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$settings = function (classes) {
    return $author$project$IconSvg$settings_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$MainAppMenu$mainAppMenuExpanded = function (cfg) {
    var wrapWithParent = function (el) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop6')]), _List_fromArray([el]));
    };

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.vV), $elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_fromArray([$author$project$Ui$Button$buttonIconContentBasic({
      vV: 'fullWidth flexCenter minH6 marTop4h',
      yh: $author$project$IconSvg$arrowLeft,
      qO: $elm$core$Maybe$Nothing,
      y$: 'Hide Menu',
      ew: cfg.hX,
      tM: 1
    }), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpEl, wrapWithParent, cfg.vD), $author$project$Ui$Button$mainAppMenuExpandedButton({
      vV: 'marTop5',
      yh: $author$project$IconSvg$cashboard,
      lV: $author$project$Route$RouteUtil$isCashboardRoute(cfg.bu),
      y$: 'CashBoard',
      ew: A2($author$project$Ui$MainAppMenu$onTapCashboard, cfg.bu, cfg.DY)
    }), $author$project$Ui$Button$mainAppMenuExpandedButton({
      vV: 'marTop5',
      yh: $author$project$IconSvg$budget,
      lV: $author$project$Route$RouteUtil$isBudgetRoute(cfg.bu),
      y$: 'Budget',
      ew: A2($author$project$Ui$MainAppMenu$onTapBudget, cfg.bu, cfg.DY)
    }), $author$project$Ui$Button$mainAppMenuExpandedButton({
      vV: 'marTop5',
      yh: $author$project$IconSvg$scenarios,
      lV: $author$project$Route$RouteUtil$isScenariosRoute(cfg.bu),
      y$: 'Scenarios',
      ew: A3($author$project$Ui$MainAppMenu$onTapBranchLink, cfg.DY, cfg.bu, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios))
    }), $author$project$Ui$Button$mainAppMenuExpandedButton({
      vV: 'marTop5',
      yh: $author$project$IconSvg$accounts,
      lV: $author$project$Route$RouteUtil$isAccountsRoute(cfg.bu),
      y$: 'Accounts',
      ew: A3($author$project$Ui$MainAppMenu$onTapBranchLink, cfg.DY, cfg.bu, $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$FinancialAccountsRoute))
    }), $author$project$Ui$Button$mainAppMenuExpandedButton({
      vV: 'marTop5 marBottom7',
      yh: $author$project$IconSvg$settings,
      lV: $author$project$Route$RouteUtil$isSettingsRoute(cfg.bu),
      y$: 'Settings',
      ew: A3($author$project$Ui$MainAppMenu$onTapBranchLink, cfg.DY, cfg.bu, $author$project$Route$CompanyRoute$Settings(0))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('borderTopHairline')]), _List_fromArray([$author$project$Ui$MainAppMenu$feedbackContactTermsConditionsButtons({
      pC: cfg.hX,
      ql: cfg.hX,
      tV: cfg.hX
    })]))]));
  };

  var $author$project$IconSvg$arrowRight_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 8L17.885 10.115L26.255 18.5L8 18.5L8 21.5L26.255 21.5L17.87 29.87L20 32L32 20L20 8Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$arrowRight = function (classes) {
    return $author$project$IconSvg$arrowRight_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$Button$mainAppMenuShrunkenButtons = function (config) {
    var selected = config.lV ? {
      vV: 'secondary70Back'
    } : {
      vV: 'primary0Back'
    };
    return $author$project$Ui$Button$button({
      kG: A2($elm$core$String$join, ' ', _List_fromArray(['minH6 circle w6 h6 noBorder heading4Bold flexCenter', selected.vV, config.vV])),
      pD: config.yh('w4 primary20Fill'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(config.ew)
    });
  };

  var $author$project$Ui$MainAppMenu$mainAppMenuShrunken = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.vV), $elm$html$Html$Attributes$class('center flexColumn')]), _List_fromArray([$author$project$Ui$Button$button({
      kG: 'minH6 circle w6 h6 noBorder heading4Bold marTop5',
      pD: $author$project$IconSvg$arrowRight('w3 gray40Fill'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.hX)
    }), $author$project$Ui$Button$mainAppMenuShrunkenButtons({
      vV: 'marTop5',
      yh: $author$project$IconSvg$cashboard,
      lV: $author$project$Route$RouteUtil$isCashboardRoute(cfg.bu),
      ew: A2($author$project$Ui$MainAppMenu$onTapCashboard, cfg.bu, cfg.DY)
    }), $author$project$Ui$Button$mainAppMenuShrunkenButtons({
      vV: 'marTop5',
      yh: $author$project$IconSvg$budget,
      lV: $author$project$Route$RouteUtil$isBudgetRoute(cfg.bu),
      ew: A2($author$project$Ui$MainAppMenu$onTapBudget, cfg.bu, cfg.DY)
    }), $author$project$Ui$Button$mainAppMenuShrunkenButtons({
      vV: 'marTop5',
      yh: $author$project$IconSvg$scenarios,
      lV: $author$project$Route$RouteUtil$isScenariosRoute(cfg.bu),
      ew: A3($author$project$Ui$MainAppMenu$onTapBranchLink, cfg.DY, cfg.bu, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios))
    }), $author$project$Ui$Button$mainAppMenuShrunkenButtons({
      vV: 'marTop5',
      yh: $author$project$IconSvg$accounts,
      lV: $author$project$Route$RouteUtil$isAccountsRoute(cfg.bu),
      ew: A3($author$project$Ui$MainAppMenu$onTapBranchLink, cfg.DY, cfg.bu, $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$FinancialAccountsRoute))
    }), $author$project$Ui$Button$mainAppMenuShrunkenButtons({
      vV: 'marTop5',
      yh: $author$project$IconSvg$settings,
      lV: $author$project$Route$RouteUtil$isSettingsRoute(cfg.bu),
      ew: A3($author$project$Ui$MainAppMenu$onTapBranchLink, cfg.DY, cfg.bu, $author$project$Route$CompanyRoute$Settings(0))
    })]));
  };

  var $author$project$UiWrappers$MainAppWrap$leftSideBar = function (cfg) {
    var classes = 'noFlexShrink primary0Back borderRightHairline scrollTarget pad2';
    var _v0 = cfg.l7;

    switch (_v0) {
      case 0:
        return $author$project$ElmFramework$Lib$Util$noOpEl;

      case 1:
        return $author$project$Ui$MainAppMenu$mainAppMenuShrunken({
          vV: classes,
          bu: cfg.bu,
          mS: cfg.mS,
          hX: cfg.mW,
          DY: cfg.DY
        });

      default:
        return $author$project$Ui$MainAppMenu$mainAppMenuExpanded({
          vD: cfg.vD,
          vV: classes,
          bu: cfg.bu,
          mS: cfg.mS,
          hX: cfg.mW,
          DY: cfg.DY
        });
    }
  };

  var $author$project$IconSvg$comments_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M14.7351 27.7713L15.6065 28.2371C16.9568 28.959 18.4648 29.3356 19.996 29.3333L20 29.3333C25.1548 29.3333 29.3333 25.1548 29.3333 20C29.3333 14.8452 25.1548 10.6667 20 10.6667C14.8452 10.6667 10.6667 14.8452 10.6667 20V20.004C10.6644 21.5352 11.041 23.0432 11.7629 24.3935L12.2287 25.2649L11.5124 28.4876L14.7351 27.7713ZM8.00001 32L9.41121 25.6508C8.48185 23.9125 7.99705 21.9712 8.00001 20C8.00001 13.3724 13.3724 8 20 8C26.6276 8 32 13.3724 32 20C32 26.6276 26.6276 32 20 32C18.0288 32.003 16.0875 31.5181 14.3492 30.5888L8.00001 32Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$comments = function (classes) {
    return $author$project$IconSvg$comments_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$UiWrappers$MainAppWrap$rightSideBar = function (cfg) {
    var sidebarEl = F2(function (sidebarContent, titleBar) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w41 primary0Back borderLeftHairline scrollTarget padTop3 padLeft3 padRight3 relative')]), _Utils_ap(titleBar, sidebarContent));
    });
    var _v0 = cfg.s9;

    if (!_v0.$) {
      switch (_v0.a.$) {
        case 0:
          var onTapBlocks = _v0.a.a.BQ;
          var onTapMessages = _v0.a.a.BU;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn padRight5 padLeft3 padTop14 center')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(onTapBlocks), _List_fromArray([$elm$html$Html$Attributes$class('radius0 minW9 minH9 primary0Back borderSolid borderHairlineWidth gray10Border')]), _List_fromArray([$author$project$IconSvg$blocks('primary30Fill w5')])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(onTapMessages), _List_fromArray([$elm$html$Html$Attributes$class('radius0 minW9 minH9 primary0Back borderSolid borderHairlineWidth gray10Border marTop5')]), _List_fromArray([$author$project$IconSvg$comments('primary30Fill w5')]))]));

        case 1:
          var sidebar = _v0.a.a;
          var showPlacedComment = sidebar.Bj ? A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(sidebar.De), _List_fromArray([$elm$html$Html$Attributes$class('circle w3 h3 primary30Back')]), _List_fromArray([sidebar.Dd('primary0Fill w3')])) : A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(sidebar.De), _List_Nil, _List_fromArray([sidebar.Dd('primary30Fill w3')]));
          return A2(sidebarEl, sidebar.pD, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter flex1')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(sidebar.za), _List_Nil, _List_fromArray([sidebar.y9('primary30Fill w3')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 padLeft4h padRight4h heading4Bold primary30 center')]), _List_fromArray([$elm$html$Html$text(sidebar.t1)])), showPlacedComment]))]));

        case 2:
          var sidebar = _v0.a.a;
          var alignTitle = sidebar.yY ? ' center' : '';
          return A2(sidebarEl, sidebar.pD, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(sidebar.ew), _List_Nil, _List_fromArray([sidebar.yh('primary30Fill w3')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 padLeft2 heading4Bold primary30' + alignTitle)]), _List_fromArray([$elm$html$Html$text(sidebar.t1)]))]))]));

        default:
          var sidebar = _v0.a.a;
          return A2(sidebarEl, sidebar.pD, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 padRight2 heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(sidebar.t1)])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(sidebar.ew), _List_Nil, _List_fromArray([sidebar.yh('primary30Fill w3')]))]))]));
      }
    } else {
      return $author$project$ElmFramework$Lib$Util$noOpEl;
    }
  };

  var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');

  var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');

  var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');

  var $elm$svg$Svg$Attributes$maskUnits = _VirtualDom_attribute('maskUnits');

  var $author$project$AssetsSvg$logo2_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 144 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$cx('20'), $elm$svg$Svg$Attributes$cy('20'), $elm$svg$Svg$Attributes$r('20'), $elm$svg$Svg$Attributes$fill('#EFF0FE')]), _List_Nil), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('path-2-outside-1'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('9.39062'), $elm$svg$Svg$Attributes$y('8.21875'), $elm$svg$Svg$Attributes$width('20'), $elm$svg$Svg$Attributes$height('24'), $elm$svg$Svg$Attributes$fill('black')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$x('9.39062'), $elm$svg$Svg$Attributes$y('8.21875'), $elm$svg$Svg$Attributes$width('20'), $elm$svg$Svg$Attributes$height('24')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M28.7508 22.4281H24.5414C24.9615 22.6773 25.3529 22.98 25.7068 23.3307C26.8222 24.4415 27.437 25.9191 27.437 27.4911V31.2491H18.4822C17.3901 31.2491 16.3301 31.0355 15.3328 30.6154C14.3694 30.2095 13.5043 29.6291 12.7607 28.8885C12.0172 28.148 11.4345 27.2863 11.0269 26.3268C10.6051 25.3334 10.3906 24.2777 10.3906 23.19V15.8234C10.3906 14.9315 10.5658 14.0663 10.9125 13.2528C11.2468 12.4659 11.7258 11.7609 12.3335 11.1539C12.9412 10.5468 13.6508 10.0715 14.4409 9.73858C15.2577 9.39321 16.1264 9.21875 17.0219 9.21875C17.8995 9.21875 18.7503 9.38609 19.5528 9.71722C21.0417 10.3047 22.4234 11.25 23.6638 12.5353C24.7559 13.664 25.7444 15.0579 26.6005 16.6744C28.0501 19.4159 28.6131 21.8264 28.6364 21.9278L28.7508 22.4281ZM27.7016 21.6092C27.4621 20.7671 26.8865 18.9691 25.8623 17.0375C25.0437 15.4923 24.1017 14.166 23.0633 13.0943L23.0597 13.0908C23.0789 13.1318 23.0971 13.1739 23.115 13.2155C23.1204 13.228 23.1258 13.2404 23.1312 13.2528C23.4779 14.0663 23.6531 14.9315 23.6531 15.8234C23.6531 16.7153 23.4779 17.5805 23.133 18.3941C22.7987 19.1809 22.3215 19.8859 21.712 20.493C21.2669 20.9362 20.7682 21.3101 20.2231 21.6092H21.5315H27.7016ZM17.0219 10.0377C15.4704 10.0377 14.0119 10.6394 12.9144 11.7324C11.817 12.8255 11.2128 14.2782 11.2128 15.8234C11.2128 17.3687 11.817 18.8213 12.9144 19.9144C14.0119 21.0075 15.4704 21.6092 17.0219 21.6092C18.5733 21.6092 20.0318 21.0075 21.1293 19.9144C22.2268 18.8213 22.8309 17.3687 22.8309 15.8234C22.8309 14.2782 22.2268 12.8255 21.1293 11.7324C20.5984 11.2037 19.9836 10.7907 19.3133 10.5041C19.1435 10.4346 18.9701 10.3706 18.7968 10.3118C18.2301 10.132 17.6332 10.0377 17.0219 10.0377ZM18.4822 30.432H26.6148V27.4911C26.6148 26.1399 26.0858 24.867 25.1259 23.911C24.1661 22.955 22.8899 22.4281 21.5315 22.4281H20.0211H17.0219C16.1264 22.4281 15.2577 22.2536 14.4409 21.91C13.6508 21.5771 12.943 21.1018 12.3335 20.4947C11.8885 20.0515 11.5131 19.5548 11.2128 19.0118V23.19C11.2128 24.1674 11.4059 25.1162 11.783 26.0081C12.1494 26.8698 12.6731 27.6442 13.3416 28.31C14.0101 28.9758 14.7876 29.4974 15.6527 29.8623C16.5482 30.2397 17.5009 30.432 18.4822 30.432ZM20.7116 14.5999C20.7116 15.6431 19.859 16.4923 18.8116 16.4923C17.7642 16.4923 16.9116 15.6431 16.9116 14.5999C16.9116 13.5567 17.7624 12.7075 18.8116 12.7075C19.8608 12.7075 20.7116 13.5567 20.7116 14.5999ZM19.8894 14.5999C19.8894 14.0089 19.4068 13.5264 18.8116 13.5264C18.2182 13.5264 17.7338 14.0089 17.7338 14.5999C17.7338 15.1909 18.2182 15.6734 18.8116 15.6734C19.405 15.6734 19.8894 15.1909 19.8894 14.5999Z')]), _List_Nil)])), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M28.7508 22.4281H24.5414C24.9615 22.6773 25.3529 22.98 25.7068 23.3307C26.8222 24.4415 27.437 25.9191 27.437 27.4911V31.2491H18.4822C17.3901 31.2491 16.3301 31.0355 15.3328 30.6154C14.3694 30.2095 13.5043 29.6291 12.7607 28.8885C12.0172 28.148 11.4345 27.2863 11.0269 26.3268C10.6051 25.3334 10.3906 24.2777 10.3906 23.19V15.8234C10.3906 14.9315 10.5658 14.0663 10.9125 13.2528C11.2468 12.4659 11.7258 11.7609 12.3335 11.1539C12.9412 10.5468 13.6508 10.0715 14.4409 9.73858C15.2577 9.39321 16.1264 9.21875 17.0219 9.21875C17.8995 9.21875 18.7503 9.38609 19.5528 9.71722C21.0417 10.3047 22.4234 11.25 23.6638 12.5353C24.7559 13.664 25.7444 15.0579 26.6005 16.6744C28.0501 19.4159 28.6131 21.8264 28.6364 21.9278L28.7508 22.4281ZM27.7016 21.6092C27.4621 20.7671 26.8865 18.9691 25.8623 17.0375C25.0437 15.4923 24.1017 14.166 23.0633 13.0943L23.0597 13.0908C23.0789 13.1318 23.0971 13.1739 23.115 13.2155C23.1204 13.228 23.1258 13.2404 23.1312 13.2528C23.4779 14.0663 23.6531 14.9315 23.6531 15.8234C23.6531 16.7153 23.4779 17.5805 23.133 18.3941C22.7987 19.1809 22.3215 19.8859 21.712 20.493C21.2669 20.9362 20.7682 21.3101 20.2231 21.6092H21.5315H27.7016ZM17.0219 10.0377C15.4704 10.0377 14.0119 10.6394 12.9144 11.7324C11.817 12.8255 11.2128 14.2782 11.2128 15.8234C11.2128 17.3687 11.817 18.8213 12.9144 19.9144C14.0119 21.0075 15.4704 21.6092 17.0219 21.6092C18.5733 21.6092 20.0318 21.0075 21.1293 19.9144C22.2268 18.8213 22.8309 17.3687 22.8309 15.8234C22.8309 14.2782 22.2268 12.8255 21.1293 11.7324C20.5984 11.2037 19.9836 10.7907 19.3133 10.5041C19.1435 10.4346 18.9701 10.3706 18.7968 10.3118C18.2301 10.132 17.6332 10.0377 17.0219 10.0377ZM18.4822 30.432H26.6148V27.4911C26.6148 26.1399 26.0858 24.867 25.1259 23.911C24.1661 22.955 22.8899 22.4281 21.5315 22.4281H20.0211H17.0219C16.1264 22.4281 15.2577 22.2536 14.4409 21.91C13.6508 21.5771 12.943 21.1018 12.3335 20.4947C11.8885 20.0515 11.5131 19.5548 11.2128 19.0118V23.19C11.2128 24.1674 11.4059 25.1162 11.783 26.0081C12.1494 26.8698 12.6731 27.6442 13.3416 28.31C14.0101 28.9758 14.7876 29.4974 15.6527 29.8623C16.5482 30.2397 17.5009 30.432 18.4822 30.432ZM20.7116 14.5999C20.7116 15.6431 19.859 16.4923 18.8116 16.4923C17.7642 16.4923 16.9116 15.6431 16.9116 14.5999C16.9116 13.5567 17.7624 12.7075 18.8116 12.7075C19.8608 12.7075 20.7116 13.5567 20.7116 14.5999ZM19.8894 14.5999C19.8894 14.0089 19.4068 13.5264 18.8116 13.5264C18.2182 13.5264 17.7338 14.0089 17.7338 14.5999C17.7338 15.1909 18.2182 15.6734 18.8116 15.6734C19.405 15.6734 19.8894 15.1909 19.8894 14.5999Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M24.5414 22.4281V22.1281H23.4479L24.3884 22.6861L24.5414 22.4281ZM28.7508 22.4281V22.7281H29.1271L29.0432 22.3612L28.7508 22.4281ZM25.7068 23.3307L25.9185 23.1181L25.918 23.1176L25.7068 23.3307ZM27.437 31.2491V31.5491H27.737V31.2491H27.437ZM15.3328 30.6154L15.2163 30.8918L15.2163 30.8918L15.3328 30.6154ZM12.7607 28.8885L12.9724 28.676H12.9724L12.7607 28.8885ZM11.0269 26.3268L10.7508 26.444L10.7508 26.4441L11.0269 26.3268ZM10.9125 13.2528L11.1885 13.3704L11.1887 13.37L10.9125 13.2528ZM14.4409 9.73858L14.5574 10.015L14.5577 10.0149L14.4409 9.73858ZM19.5528 9.71722L19.4384 9.99457L19.4427 9.99628L19.5528 9.71722ZM23.6638 12.5353L23.448 12.7437L23.4482 12.7439L23.6638 12.5353ZM26.6005 16.6744L26.8657 16.5341L26.8656 16.5339L26.6005 16.6744ZM28.6364 21.9278L28.9288 21.861L28.9288 21.8609L28.6364 21.9278ZM25.8623 17.0375L25.5972 17.178L25.5973 17.1781L25.8623 17.0375ZM27.7016 21.6092V21.9092H28.0988L27.9901 21.5271L27.7016 21.6092ZM23.0633 13.0943L23.2787 12.8855L23.275 12.8817L23.0633 13.0943ZM23.0597 13.0908L23.2714 12.8782L22.788 13.218L23.0597 13.0908ZM23.115 13.2155L22.8396 13.3344L22.8396 13.3344L23.115 13.2155ZM23.1312 13.2528L23.4072 13.1351L23.4063 13.1331L23.1312 13.2528ZM23.133 18.3941L23.4091 18.5114L23.4092 18.5112L23.133 18.3941ZM21.712 20.493L21.5003 20.2804H21.5003L21.712 20.493ZM20.2231 21.6092L20.0788 21.3462L20.2231 21.9092V21.6092ZM12.9144 11.7324L13.1261 11.945L12.9144 11.7324ZM12.9144 19.9144L13.1261 19.7018L12.9144 19.9144ZM21.1293 11.7324L20.9176 11.945H20.9176L21.1293 11.7324ZM19.3133 10.5041L19.4313 10.2282L19.4268 10.2264L19.3133 10.5041ZM18.7968 10.3118L18.893 10.0276L18.8875 10.0259L18.7968 10.3118ZM26.6148 30.432V30.732H26.9148V30.432H26.6148ZM14.4409 21.91L14.3244 22.1865L14.3245 22.1866L14.4409 21.91ZM12.3335 20.4947L12.1218 20.7073L12.3335 20.4947ZM11.2128 19.0118L11.4754 18.8666L10.9128 19.0118H11.2128ZM11.783 26.0081L11.5067 26.125L11.5069 26.1255L11.783 26.0081ZM15.6527 29.8623L15.5361 30.1387L15.5362 30.1388L15.6527 29.8623ZM24.5414 22.7281H28.7508V22.1281H24.5414V22.7281ZM25.918 23.1176C25.5468 22.7497 25.1359 22.432 24.6945 22.1701L24.3884 22.6861C24.7871 22.9227 25.159 23.2102 25.4957 23.5437L25.918 23.1176ZM27.737 27.4911C27.737 25.8391 27.0902 24.2851 25.9185 23.1181L25.4951 23.5432C26.5541 24.5979 27.137 25.9991 27.137 27.4911H27.737ZM27.737 31.2491V27.4911H27.137V31.2491H27.737ZM18.4822 31.5491H27.437V30.9491H18.4822V31.5491ZM15.2163 30.8918C16.2508 31.3276 17.3503 31.5491 18.4822 31.5491V30.9491C17.4298 30.9491 16.4095 30.7434 15.4492 30.3389L15.2163 30.8918ZM12.549 29.1011C13.3199 29.8689 14.2173 30.4709 15.2163 30.8918L15.4493 30.3389C14.5214 29.948 13.6887 29.3894 12.9724 28.676L12.549 29.1011ZM10.7508 26.4441C11.1735 27.4394 11.7781 28.3333 12.549 29.1011L12.9724 28.676C12.2562 27.9626 11.6954 27.1333 11.3031 26.2095L10.7508 26.4441ZM10.0906 23.19C10.0906 24.3178 10.3131 25.4134 10.7508 26.444L11.3031 26.2095C10.8971 25.2535 10.6906 24.2377 10.6906 23.19H10.0906ZM10.0906 15.8234V23.19H10.6906V15.8234H10.0906ZM10.6366 13.1351C10.2738 13.9864 10.0906 14.8916 10.0906 15.8234H10.6906C10.6906 14.9714 10.8578 14.1463 11.1885 13.3704L10.6366 13.1351ZM12.1215 10.9416C11.487 11.5754 10.986 12.3125 10.6364 13.1355L11.1887 13.37C11.5076 12.6193 11.9646 11.9464 12.5455 11.3661L12.1215 10.9416ZM14.3244 9.46212C13.4989 9.80995 12.7568 10.307 12.1215 10.9416L12.5455 11.3661C13.1257 10.7866 13.8027 10.333 14.5574 10.015L14.3244 9.46212ZM17.0219 8.91875C16.0868 8.91875 15.1784 9.10104 14.324 9.46226L14.5577 10.0149C15.337 9.68538 16.1659 9.51875 17.0219 9.51875V8.91875ZM19.6672 9.43989C18.8279 9.0936 17.9382 8.91875 17.0219 8.91875V9.51875C17.8607 9.51875 18.6726 9.67858 19.4384 9.99454L19.6672 9.43989ZM23.8797 12.327C22.6127 11.0142 21.1959 10.043 19.6629 9.43815L19.4427 9.99628C20.8875 10.5664 22.234 11.4858 23.448 12.7437L23.8797 12.327ZM26.8656 16.5339C25.9984 14.8966 24.9941 13.4787 23.8794 12.3267L23.4482 12.7439C24.5177 13.8492 25.4903 15.2192 26.3354 16.8148L26.8656 16.5339ZM28.9288 21.8609C28.9026 21.7465 28.3324 19.308 26.8657 16.5341L26.3353 16.8146C27.7678 19.5239 28.3237 21.9063 28.3439 21.9948L28.9288 21.8609ZM29.0432 22.3612L28.9288 21.861L28.3439 21.9947L28.4583 22.495L29.0432 22.3612ZM25.5973 17.1781C26.6082 19.0846 27.1769 20.861 27.413 21.6912L27.9901 21.5271C27.7472 20.6732 27.1648 18.8536 26.1274 16.897L25.5973 17.1781ZM22.8478 13.3031C23.8636 14.3514 24.7897 15.6536 25.5972 17.178L26.1274 16.8971C25.2977 15.3309 24.3399 13.9807 23.2787 12.8856L22.8478 13.3031ZM22.848 13.3033L22.8516 13.3069L23.275 12.8817L23.2714 12.8782L22.848 13.3033ZM23.3905 13.0966C23.3728 13.0557 23.3529 13.0094 23.3314 12.9635L22.788 13.218C22.805 13.2542 22.8214 13.2921 22.8396 13.3344L23.3905 13.0966ZM23.4063 13.1331C23.4011 13.1212 23.3959 13.1091 23.3905 13.0966L22.8396 13.3344C22.845 13.3468 22.8505 13.3596 22.8561 13.3724L23.4063 13.1331ZM23.9531 15.8234C23.9531 14.8916 23.77 13.9864 23.4072 13.1351L22.8552 13.3704C23.1859 14.1463 23.3531 14.9714 23.3531 15.8234H23.9531ZM23.4092 18.5112C23.77 17.6603 23.9531 16.7552 23.9531 15.8234H23.3531C23.3531 16.6754 23.1859 17.5008 22.8568 18.277L23.4092 18.5112ZM21.9237 20.7055C22.5605 20.0713 23.0596 19.3341 23.4091 18.5114L22.8569 18.2768C22.5378 19.0278 22.0825 19.7005 21.5003 20.2804L21.9237 20.7055ZM20.3674 21.8722C20.9375 21.5594 21.4589 21.1685 21.9237 20.7055L21.5003 20.2804C21.075 20.704 20.599 21.0608 20.0788 21.3462L20.3674 21.8722ZM21.5315 21.3092H20.2231V21.9092H21.5315V21.3092ZM27.7016 21.3092H21.5315V21.9092H27.7016V21.3092ZM13.1261 11.945C14.1673 10.908 15.5496 10.3377 17.0219 10.3377V9.73766C15.3912 9.73766 13.8565 10.3707 12.7027 11.5199L13.1261 11.945ZM11.5128 15.8234C11.5128 14.3581 12.0851 12.9819 13.1261 11.945L12.7027 11.5199C11.5489 12.6691 10.9128 14.1982 10.9128 15.8234H11.5128ZM13.1261 19.7018C12.0851 18.6649 11.5128 17.2887 11.5128 15.8234H10.9128C10.9128 17.4486 11.5489 18.9777 12.7027 20.1269L13.1261 19.7018ZM17.0219 21.3092C15.5496 21.3092 14.1673 20.7388 13.1261 19.7018L12.7027 20.1269C13.8565 21.2761 15.3912 21.9092 17.0219 21.9092V21.3092ZM20.9176 19.7018C19.8765 20.7388 18.4941 21.3092 17.0219 21.3092V21.9092C18.6525 21.9092 20.1872 21.2761 21.341 20.1269L20.9176 19.7018ZM22.5309 15.8234C22.5309 17.2887 21.9587 18.6649 20.9176 19.7018L21.341 20.1269C22.4949 18.9777 23.1309 17.4486 23.1309 15.8234H22.5309ZM20.9176 11.945C21.9587 12.9819 22.5309 14.3581 22.5309 15.8234H23.1309C23.1309 14.1982 22.4949 12.6691 21.341 11.5199L20.9176 11.945ZM19.1954 10.7799C19.8306 11.0515 20.4136 11.4431 20.9176 11.945L21.341 11.5199C20.7832 10.9644 20.1366 10.5298 19.4313 10.2282L19.1954 10.7799ZM18.7005 10.5959C18.8687 10.6529 19.0363 10.7149 19.1998 10.7818L19.4268 10.2264C19.2508 10.1544 19.0716 10.0882 18.893 10.0277L18.7005 10.5959ZM17.0219 10.3377C17.6022 10.3377 18.1686 10.4272 18.706 10.5978L18.8875 10.0259C18.2917 9.83681 17.6641 9.73766 17.0219 9.73766V10.3377ZM26.6148 30.132H18.4822V30.732H26.6148V30.132ZM26.3148 27.4911V30.432H26.9148V27.4911H26.3148ZM24.9142 24.1236C25.8176 25.0234 26.3148 26.2198 26.3148 27.4911H26.9148C26.9148 26.0599 26.3539 24.7106 25.3376 23.6985L24.9142 24.1236ZM21.5315 22.7281C22.8107 22.7281 24.0107 23.2237 24.9142 24.1236L25.3376 23.6985C24.3215 22.6864 22.9691 22.1281 21.5315 22.1281V22.7281ZM20.0211 22.7281H21.5315V22.1281H20.0211V22.7281ZM17.0219 22.7281H20.0211V22.1281H17.0219V22.7281ZM14.3245 22.1866C15.1786 22.5458 16.0868 22.7281 17.0219 22.7281V22.1281C16.1659 22.1281 15.3368 21.9614 14.5572 21.6335L14.3245 22.1866ZM12.1218 20.7073C12.7586 21.3415 13.4987 21.8386 14.3244 22.1865L14.5574 21.6336C13.803 21.3157 13.1275 20.8621 12.5452 20.2822L12.1218 20.7073ZM10.9503 19.157C11.2644 19.725 11.657 20.2443 12.1218 20.7073L12.5452 20.2822C12.12 19.8586 11.7618 19.3846 11.4754 18.8666L10.9503 19.157ZM11.5128 23.19V19.0118H10.9128V23.19H11.5128ZM12.0593 25.8913C11.6978 25.0364 11.5128 24.1273 11.5128 23.19H10.9128C10.9128 24.2075 11.1139 25.1961 11.5067 26.125L12.0593 25.8913ZM13.5533 28.0974C12.9121 27.4588 12.4103 26.7167 12.0591 25.8907L11.5069 26.1255C11.8885 27.0228 12.4341 27.8295 13.1299 28.5225L13.5533 28.0974ZM15.7693 29.5859C14.9397 29.236 14.1945 28.736 13.5533 28.0974L13.1299 28.5225C13.8257 29.2155 14.6355 29.7588 15.5361 30.1387L15.7693 29.5859ZM18.4822 30.132C17.5406 30.132 16.6276 29.9476 15.7692 29.5859L15.5362 30.1388C16.4688 30.5318 17.4611 30.732 18.4822 30.732V30.132ZM18.8116 16.7923C20.0236 16.7923 21.0116 15.8099 21.0116 14.5999H20.4116C20.4116 15.4763 19.6945 16.1923 18.8116 16.1923V16.7923ZM16.6116 14.5999C16.6116 15.8099 17.5997 16.7923 18.8116 16.7923V16.1923C17.9288 16.1923 17.2116 15.4763 17.2116 14.5999H16.6116ZM18.8116 12.4075C17.5977 12.4075 16.6116 13.3901 16.6116 14.5999H17.2116C17.2116 13.7233 17.9272 13.0075 18.8116 13.0075V12.4075ZM21.0116 14.5999C21.0116 13.3901 20.0256 12.4075 18.8116 12.4075V13.0075C19.6961 13.0075 20.4116 13.7233 20.4116 14.5999H21.0116ZM18.8116 13.8264C19.242 13.8264 19.5894 14.1754 19.5894 14.5999H20.1894C20.1894 13.8424 19.5717 13.2264 18.8116 13.2264V13.8264ZM18.0338 14.5999C18.0338 14.1757 18.3828 13.8264 18.8116 13.8264V13.2264C18.0537 13.2264 17.4338 13.842 17.4338 14.5999H18.0338ZM18.8116 15.3734C18.3828 15.3734 18.0338 15.0241 18.0338 14.5999H17.4338C17.4338 15.3578 18.0537 15.9734 18.8116 15.9734V15.3734ZM19.5894 14.5999C19.5894 15.0241 19.2405 15.3734 18.8116 15.3734V15.9734C19.5696 15.9734 20.1894 15.3578 20.1894 14.5999H19.5894Z'), $elm$svg$Svg$Attributes$fill('#3721E6'), $elm$svg$Svg$Attributes$mask('url(#path-2-outside-1)')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M48 12.1172H59.4023V14.2734H54.832V27.2344H52.5586V14.2734H48V12.1172Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M66.4688 16.3125C67.0625 16.3125 67.6211 16.4297 68.1445 16.6641C68.6758 16.8984 69.1367 17.2188 69.5273 17.625C69.9258 18.0312 70.2344 18.5234 70.4531 19.1016C70.6797 19.6719 70.793 20.3047 70.793 21V27.2344H68.6367V21C68.6367 20.6484 68.5664 20.3125 68.4258 19.9922C68.293 19.6719 68.1094 19.3906 67.875 19.1484C67.6484 18.9062 67.3828 18.7148 67.0781 18.5742C66.7734 18.4258 66.4531 18.3516 66.1172 18.3516C65.75 18.3516 65.4062 18.4258 65.0859 18.5742C64.7656 18.7148 64.4844 18.9062 64.2422 19.1484C64 19.3906 63.8086 19.6719 63.668 19.9922C63.5352 20.3047 63.4688 20.6406 63.4688 21V27.2344H61.3125V12.1172H63.4688V17.5195C63.6953 17.293 63.9531 17.0898 64.2422 16.9102C64.5 16.7695 64.8164 16.6367 65.1914 16.5117C65.5664 16.3789 65.9922 16.3125 66.4688 16.3125Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M82.9102 24.1172C82.7305 24.5625 82.5039 24.9805 82.2305 25.3711C81.957 25.7617 81.6289 26.1055 81.2461 26.4023C80.8633 26.6992 80.418 26.9336 79.9102 27.1055C79.4102 27.2695 78.8477 27.3516 78.2227 27.3516C77.5039 27.3516 76.832 27.2188 76.207 26.9531C75.582 26.6797 75.0352 26.3008 74.5664 25.8164C74.0977 25.3242 73.7305 24.7422 73.4648 24.0703C73.1992 23.3984 73.0664 22.6523 73.0664 21.832C73.0664 21.0195 73.1992 20.2773 73.4648 19.6055C73.7305 18.9336 74.0898 18.3555 74.543 17.8711C74.9961 17.3789 75.5312 16.9961 76.1484 16.7227C76.7656 16.4492 77.418 16.3125 78.1055 16.3125C78.793 16.3125 79.4453 16.4492 80.0625 16.7227C80.6797 16.9961 81.2148 17.3789 81.668 17.8711C82.1211 18.3555 82.4805 18.9336 82.7461 19.6055C83.0117 20.2773 83.1445 21.0195 83.1445 21.832C83.1445 21.957 83.1367 22.082 83.1211 22.207C83.1055 22.3242 83.0898 22.4258 83.0742 22.5117C83.0586 22.6211 83.043 22.7148 83.0273 22.793H75.3398C75.3711 23.1289 75.4688 23.4492 75.6328 23.7539C75.7969 24.0586 76 24.3281 76.2422 24.5625C76.4922 24.7891 76.7891 24.9727 77.1328 25.1133C77.4766 25.2461 77.8398 25.3125 78.2227 25.3125C78.8789 25.3125 79.3984 25.1719 79.7812 24.8906C80.1719 24.6094 80.4531 24.3516 80.625 24.1172H82.9102ZM78.1055 18.3516C77.3867 18.3516 76.7773 18.5977 76.2773 19.0898C75.7852 19.5742 75.4727 20.2109 75.3398 21H81.1055C80.9805 20.2188 80.6602 19.582 80.1445 19.0898C79.6367 18.5977 78.957 18.3516 78.1055 18.3516Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M96.5859 12.1172C97.2422 12.1172 97.8594 12.2461 98.4375 12.5039C99.0234 12.7539 99.5312 13.0977 99.9609 13.5352C100.398 13.9648 100.742 14.4727 100.992 15.0586C101.25 15.6367 101.379 16.2539 101.379 16.9102C101.379 17.5664 101.25 18.1875 100.992 18.7734C100.742 19.3594 100.398 19.8672 99.9609 20.2969C99.5312 20.7266 99.0234 21.0703 98.4375 21.3281C97.8594 21.5859 97.2422 21.7148 96.5859 21.7148H93.3398V27.2344H91.0664V12.1172H96.5859ZM96.5859 19.5586C96.9219 19.5586 97.2383 19.4922 97.5352 19.3594C97.8398 19.2188 98.1094 19.0273 98.3438 18.7852C98.5781 18.543 98.7617 18.2617 98.8945 17.9414C99.0352 17.6211 99.1055 17.2773 99.1055 16.9102C99.1055 16.5586 99.0352 16.2227 98.8945 15.9023C98.7617 15.582 98.5781 15.3047 98.3438 15.0703C98.1094 14.8281 97.8398 14.6367 97.5352 14.4961C97.2383 14.3477 96.9219 14.2734 96.5859 14.2734H93.3398V19.5586H96.5859Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M107.988 27.3516C107.379 27.3516 106.812 27.2383 106.289 27.0117C105.773 26.7773 105.316 26.457 104.918 26.0508C104.527 25.6367 104.219 25.1445 103.992 24.5742C103.773 23.9961 103.664 23.3633 103.664 22.6758V16.4297H105.82V22.6758C105.82 23.043 105.887 23.3867 106.02 23.707C106.16 24.0273 106.344 24.3086 106.57 24.5508C106.805 24.7852 107.074 24.9727 107.379 25.1133C107.684 25.2461 108.004 25.3125 108.34 25.3125C108.691 25.3125 109.027 25.2461 109.348 25.1133C109.668 24.9727 109.949 24.7852 110.191 24.5508C110.434 24.3086 110.625 24.0273 110.766 23.707C110.914 23.3867 110.988 23.043 110.988 22.6758V16.4297H113.145V27.2344H111.586L111.105 26.1562C110.895 26.3828 110.645 26.582 110.355 26.7539C110.098 26.9102 109.773 27.0508 109.383 27.1758C109 27.293 108.535 27.3516 107.988 27.3516Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M130.77 27.2344H128.613V18.4688H124.652V27.2344H122.496V18.4688H118.535V27.2344H116.379V18.4688H115.055V16.4297H116.379V16.1953C116.379 15.6172 116.461 15.1016 116.625 14.6484C116.797 14.1875 117.031 13.8008 117.328 13.4883C117.633 13.168 117.988 12.918 118.395 12.7383C118.809 12.5586 119.254 12.4688 119.73 12.4688C119.91 12.4688 120.07 12.4844 120.211 12.5156C120.359 12.5391 120.488 12.5664 120.598 12.5977C120.723 12.6445 120.836 12.6836 120.938 12.7148V14.6367C120.875 14.6211 120.801 14.6055 120.715 14.5898C120.637 14.5742 120.555 14.5586 120.469 14.543C120.383 14.5273 120.297 14.5195 120.211 14.5195C119.734 14.5195 119.336 14.6797 119.016 15C118.695 15.3125 118.535 15.7109 118.535 16.1953V16.4297H122.496V15.7148C122.496 15.1367 122.578 14.6211 122.742 14.168C122.914 13.707 123.152 13.3203 123.457 13.0078C123.762 12.6875 124.117 12.4414 124.523 12.2695C124.93 12.0898 125.375 12 125.859 12C126.039 12 126.199 12.0117 126.34 12.0352C126.48 12.0586 126.605 12.0859 126.715 12.1172C126.84 12.1641 126.953 12.2031 127.055 12.2344V14.1562C126.992 14.1406 126.922 14.125 126.844 14.1094C126.766 14.0938 126.68 14.0781 126.586 14.0625C126.5 14.0469 126.418 14.0391 126.34 14.0391C125.863 14.0391 125.461 14.1992 125.133 14.5195C124.812 14.8398 124.652 15.2383 124.652 15.7148V16.4297H130.77V27.2344ZM129.691 14.7539C129.324 14.7539 129.012 14.6289 128.754 14.3789C128.504 14.1211 128.379 13.8047 128.379 13.4297C128.379 13.0625 128.504 12.7539 128.754 12.5039C129.012 12.2461 129.324 12.1172 129.691 12.1172C130.059 12.1172 130.371 12.2461 130.629 12.5039C130.887 12.7539 131.016 13.0625 131.016 13.4297C131.016 13.7969 130.887 14.1094 130.629 14.3672C130.371 14.625 130.059 14.7539 129.691 14.7539Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M138.82 16.3125C139.414 16.3125 139.973 16.4297 140.496 16.6641C141.027 16.8984 141.488 17.2188 141.879 17.625C142.27 18.0312 142.578 18.5234 142.805 19.1016C143.031 19.6719 143.145 20.3047 143.145 21V27.2344H140.988V21C140.988 20.6484 140.918 20.3125 140.777 19.9922C140.645 19.6719 140.461 19.3906 140.227 19.1484C139.992 18.9062 139.723 18.7148 139.418 18.5742C139.113 18.4258 138.793 18.3516 138.457 18.3516C138.09 18.3516 137.746 18.4258 137.426 18.5742C137.105 18.7148 136.824 18.9062 136.582 19.1484C136.348 19.3906 136.16 19.6719 136.02 19.9922C135.887 20.3047 135.82 20.6406 135.82 21V27.2344H133.664V16.4297H135.223L135.703 17.5195C135.914 17.293 136.16 17.0898 136.441 16.9102C136.699 16.7695 137.023 16.6367 137.414 16.5117C137.805 16.3789 138.273 16.3125 138.82 16.3125Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil)]));
  };

  var $author$project$AssetsSvg$logo2 = function (classes) {
    return $author$project$AssetsSvg$logo2_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Model$Image$distance = F2(function (imgWidth, goalUnitWidth) {
    return $elm$core$Basics$abs(imgWidth - goalUnitWidth);
  });
  var $elm_community$list_extra$List$Extra$minimumBy = F2(function (f, ls) {
    var minBy = F2(function (x, _v1) {
      var y = _v1.a;
      var fy = _v1.b;
      var fx = f(x);
      return _Utils_cmp(fx, fy) < 0 ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
    });

    if (ls.b) {
      if (!ls.b.b) {
        var l_ = ls.a;
        return $elm$core$Maybe$Just(l_);
      } else {
        var l_ = ls.a;
        var ls_ = ls.b;
        return $elm$core$Maybe$Just(A3($elm$core$List$foldl, minBy, _Utils_Tuple2(l_, f(l_)), ls_).a);
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Model$Image$fromPhysicalWidthPixels = F3(function (image, sizer, goalWidth) {
    return A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$minimumBy, $elm$core$Tuple$first, A2($elm$core$List$map, function (transformation) {
      return _Utils_Tuple2(A2($author$project$Model$Image$distance, sizer(transformation), goalWidth), transformation);
    }, image)));
  });
  var $author$project$Model$Image$goalFromUnits = F2(function (_v0, goalUnitSize) {
    var unitSize = _v0.j6;
    var pixelRatio = _v0.sA;
    return $elm$core$Basics$round(goalUnitSize * unitSize * pixelRatio);
  });
  var $author$project$Model$Image$transformationFromUnitWidth = F3(function (browser, goalWidth, image) {
    return A3($author$project$Model$Image$fromPhysicalWidthPixels, image, function ($) {
      return $.FE;
    }, A2($author$project$Model$Image$goalFromUnits, browser, goalWidth));
  });
  var $author$project$Model$Image$fromUnitWidth = F3(function (browser, goalWidth, image) {
    return A2($elm$core$Maybe$map, function ($) {
      return $.Fh;
    }, A3($author$project$Model$Image$transformationFromUnitWidth, browser, goalWidth, image));
  });

  var $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart = function (cfg) {
    return A3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg, cfg.FH, cfg.vV, A2($elm$core$Maybe$withDefault, '', A3($author$project$Model$Image$fromUnitWidth, cfg.vz, cfg.FF, cfg.yj)));
  };

  var $author$project$Ui$Avatar$avatar = function (cfg) {
    return $elm$core$List$isEmpty(cfg.u2) ? cfg.jl ? A3($elm$html$Html$node, 'to-do', _List_Nil, _List_Nil) : A3($elm$html$Html$node, 'to-do', _List_Nil, _List_Nil) : $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      vz: cfg.vz,
      vV: 'circle',
      yj: cfg.u2,
      FF: cfg.FF,
      FH: A2($elm$core$String$join, ' ', _List_fromArray(['relative square circle', A3($author$project$ElmFramework$Lib$Util$ifElse, '', '', cfg.jl), cfg.vV]))
    });
  };

  var $author$project$Types$User$toInitials = function (_v0) {
    var firstName = _v0.hu;
    var lastName = _v0.hI;

    var _v1 = _Utils_Tuple2(A2($elm$core$String$left, 1, firstName), A2($elm$core$String$left, 1, lastName));

    if (_v1.a === '') {
      if (_v1.b === '') {
        return '';
      } else {
        var theLastName = _v1.b;
        return theLastName;
      }
    } else {
      if (_v1.b === '') {
        var theFirstName = _v1.a;
        return theFirstName;
      } else {
        var theFirstName = _v1.a;
        var theLastName = _v1.b;
        return _Utils_ap(theFirstName, theLastName);
      }
    }
  };

  var $author$project$Ui$Avatar$avatarOrInitials = function (cfg) {
    return $elm$core$List$isEmpty(cfg.Fl.u2) ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('square circle flexCenter uppercase'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text($author$project$Types$User$toInitials(cfg.Fl))])) : $author$project$Ui$Avatar$avatar({
      u2: cfg.Fl.u2,
      vz: cfg.vz,
      vV: cfg.vV,
      jl: cfg.jl,
      FF: cfg.FF
    });
  };

  var $author$project$UiWrappers$MainAppWrap$userBtn = function (cfg) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.mS($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$UserProfileRoute))), _List_fromArray([$elm$html$Html$Attributes$class('flexRow fullHeight flexAlignCenter padRight4 padLeft2')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text($author$project$Types$User$toFullName(cfg.DY.Fl))])), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$Ui$Avatar$avatarOrInitials({
      vz: cfg.vz,
      vV: 'w4 heading4Bold primary20 gray10Back',
      jl: true,
      Fl: cfg.DY.Fl,
      FF: 4
    })]));
  };

  var $author$project$UiWrappers$MainAppWrap$topAppBar = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter h8 padLeft4 primary0Back borderBottomHairline')]), _List_fromArray([$author$project$AssetsSvg$logo2('h5'), $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$UiWrappers$MainAppWrap$userBtn(cfg)]));
  };

  var $author$project$UiWrappers$MainAppWrap$mainAppWrap = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexColumn primary10Back')]), _List_fromArray([$author$project$UiWrappers$MainAppWrap$topAppBar(cfg), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 flexRow noOverflow')]), _List_fromArray([$author$project$UiWrappers$MainAppWrap$leftSideBar(cfg), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1'), $elm$html$Html$Attributes$class(cfg.wc)]), cfg.pD), $author$project$UiWrappers$MainAppWrap$rightSideBar(cfg)])), $author$project$UiWrappers$MainAppWrap$bottomBar(cfg)]));
  };

  var $author$project$UiWrappers$MainAppWrapSpecific$Msg$SetBusinessSearchInput = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$SelectSearchInput$onDebouncedInput = function (tag) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'debouncedInput', A2($elm$json$Json$Decode$map, tag, A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string)));
  };

  var $author$project$ElmFramework$Lib$Ui$SelectSearchInput$selectSearchInput = function (config) {
    var toListItem = function (item) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.w2), $author$project$ElmFramework$Lib$Util$onTap(config.BE(item))]), _List_fromArray([$elm$html$Html$text(config.t3(item))]));
    };

    return A3($elm$html$Html$node, 'select-search-input', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block', ' ', config.kG]))))]), _List_fromArray([A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class(config.y1)]), _List_fromArray([A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class('hidden'), $elm$html$Html$Attributes$type_('checkbox')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['flexRow flexAlignCenter', ' ', config.DJ]))))]), function () {
      var _v0 = config.ia;

      if (_v0.$ === 1) {
        return _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.DL)]), _List_fromArray([$elm$html$Html$text(config.DK)])), config.Cd]);
      } else {
        var selected = _v0.a;
        return _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.DM)]), _List_fromArray([$elm$html$Html$text(config.t3(selected))])), config.Cd]);
      }
    }()), A3($elm$html$Html$node, 'dropdown-wrapper', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block maxH0 noOverflow', ' ', config.xg]))))]), _List_fromArray([A3($elm$html$Html$node, 'dropdown-element', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block', ' ', config.xa]))))]), _List_fromArray([A3($elm$html$Html$node, 'debounced-input', _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'debounce-time', $elm$core$String$fromInt(config.wA)), $elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block relative', ' ', config.yy])))), $author$project$ElmFramework$Lib$Ui$SelectSearchInput$onDebouncedInput(config.Aw)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Input$input({
      fx: $elm$core$Maybe$Nothing,
      kG: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block', ' ', config.ys]))),
      k_: config.yM,
      qU: 0,
      e_: config.e_,
      e3: config.yt,
      gx: config.yW,
      Fw: config.yw
    }), $author$project$IconSvg$search('absolute centerY left0 w3 h3 marLeft1 gray20Fill noPointerEvents')])), A3($elm$html$Html$node, 'dropdown-body', _List_fromArray([$elm$html$Html$Attributes$class(config.wR)]), function () {
      var _v1 = config.C7;

      if (!_v1.$) {
        var results = _v1.a;
        return A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('No Results Found')]))]), A2($elm$core$List$map, toListItem, results), $elm$core$List$isEmpty(results));
      } else {
        return _List_fromArray([config.Eb]);
      }
    }())]))]))]))]));
  };

  var $author$project$Ui$SelectSearchInput$selectSearchInput = function (config) {
    var toBodyClasses = function () {
      var _v0 = config.C7;

      if (!_v0.$) {
        var results = _v0.a;
        return A3($author$project$ElmFramework$Lib$Util$ifElse, 'heading4Bold gray40 padTop3 padBottom3', 'padTop1h padBottom1h', $elm$core$List$isEmpty(results));
      } else {
        return 'padTop1h padBottom1h';
      }
    }();

    return $author$project$ElmFramework$Lib$Ui$SelectSearchInput$selectSearchInput({
      kG: A2($elm$core$String$join, ' ', _List_fromArray(['radius0 primary10Back primary30', config.kG])),
      wA: 300,
      wR: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['block heading4Bold', ' ', toBodyClasses]))),
      w2: 'alignCenter padTop1h padBottom1h pointer ellipsis maxW20',
      xa: 'padLeft2 padRight2',
      xg: '',
      ys: 'h6 padLeft5 padRight1 heading4Bold placeholderGray20 fullWidth fullHeight maxW20',
      yt: config.yt,
      yw: config.yw,
      yy: 'fullWidth borderHairlineWidth borderSolid gray20Border radius0',
      yM: config.yM,
      yW: config.yW,
      y1: 'heading5Bold fullWidth fullHeight',
      Aw: config.Aw,
      e_: config.e_,
      BE: config.BE,
      Cd: $author$project$IconSvg$down('w3 h3 primary30Fill'),
      C7: config.C7,
      DJ: 'minH6 padLeft2 padRight2 spaceBetween pointer',
      DK: config.DK,
      DL: 'gray20',
      DM: 'primary30 maxW20 ellipsis',
      ia: config.ia,
      Eb: $author$project$Ui$SimpleSpinner$simpleSpinner,
      t3: config.C6
    });
  };

  var $author$project$UiWrappers$MainAppWrapSpecific$View$toBusinessChooser = F3(function (topState, session, companies) {
    var onSelect = function (company) {
      var _v0 = company.pa;

      if (!_v0.$) {
        var scenarioId = _v0.a;
        return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$fromCompany, scenarioId, company), $author$project$Route$CashboardRoute$CashboardHome)));
      } else {
        return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, 'Please pick a base scenario first', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))]));
      }
    };

    return $author$project$Ui$SelectSearchInput$selectSearchInput({
      kG: '',
      yt: 'search...',
      yw: topState.o_.zi.ph,
      yM: false,
      yW: false,
      Aw: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MainAppWrapSpecificMsg), $author$project$UiWrappers$MainAppWrapSpecific$Msg$SetBusinessSearchInput),
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MainAppWrapSpecificMsg), $author$project$UiWrappers$MainAppWrapSpecific$Msg$SetBusinessSearchInput),
      BE: onSelect,
      C6: function ($) {
        return $.zL;
      },
      C7: $elm$core$Maybe$Just(A2($elm$core$List$filter, function (c) {
        return A2($elm$core$String$contains, topState.o_.zi.ph, $elm$core$String$toLower(c.zL));
      }, companies)),
      DK: 'Select Business',
      ia: A2($elm$core$Maybe$andThen, function (id) {
        return A2($author$project$Types$UserSession$toCompany, id, session);
      }, $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)))
    });
  });
  var $author$project$ElmFramework$Lib$Util$getItemsFromDict = F2(function (list, anyDict) {
    var reducer = F2(function (k, acc) {
      return A2($elm$core$Maybe$withDefault, acc, A2($elm$core$Maybe$map, function (v) {
        return A2($elm$core$List$cons, v, acc);
      }, A2($turboMaCk$any_dict$Dict$Any$get, k, anyDict)));
    });
    return A3($elm$core$List$foldl, reducer, _List_Nil, list);
  });
  var $author$project$Types$UserSession$toCompaniesForUser = F2(function (userId, session) {
    return function (userCompanies) {
      return A2($author$project$ElmFramework$Lib$Util$getItemsFromDict, userCompanies, session.v5);
    }(A2($elm$core$List$map, function ($) {
      return $.b9;
    }, A2($author$project$ElmFramework$Lib$PivotDict$getById1, userId, session.ue)));
  });

  var $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific = function (cfg) {
    return $author$project$UiWrappers$MainAppWrap$mainAppWrap({
      vw: cfg.vw,
      vz: cfg.eG.vz,
      vD: A2($elm$core$Maybe$map, A2($author$project$UiWrappers$MainAppWrapSpecific$View$toBusinessChooser, cfg.eG, cfg.DY), A2($elm_community$maybe_extra$Maybe$Extra$filter, function (companies) {
        return $elm$core$List$length(companies) > 1;
      }, $elm$core$Maybe$Just(A2($author$project$Types$UserSession$toCompaniesForUser, cfg.DY.Fl.F, cfg.DY)))),
      pD: cfg.pD,
      wc: 'scrollTarget ' + cfg.wc,
      bu: $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(cfg.eG.tc),
      l7: function () {
        var _v0 = _Utils_Tuple2(cfg.D6, cfg.eG.o_.zi.qh);

        if (!_v0.a) {
          return 0;
        } else {
          if (_v0.b) {
            return 2;
          } else {
            return 1;
          }
        }
      }(),
      mS: $author$project$ElmFramework$MsgCmd$msgCmd.Dn,
      mW: $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MainAppWrapSpecificMsg($author$project$UiWrappers$MainAppWrapSpecific$Msg$ToggleLeftSidebar)),
      s9: cfg.s9,
      DY: cfg.DY
    });
  };

  var $author$project$Views$Routed$BlocksBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: cfg.vw,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marTop5 marLeft5 marRight19')]), cfg.pD)]),
        wc: 'scrollTarget',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Types$Filters$HideAllQuickEdits = {
    $: 1
  };

  var $author$project$Types$Filters$withoutQuickEdits = function (filters) {
    return _Utils_update(filters, {
      h0: $elm$core$Maybe$Just($author$project$Types$Filters$HideAllQuickEdits)
    });
  };

  var $author$project$Views$Routed$BlocksBranch$blocksView = function (cfg) {
    var state = cfg.eG.o_.vl;
    var selectedBlocks = state.to;

    var toBlockElement = function (block) {
      var toBlockDetailsRoute = function (blockId) {
        return cfg.jb ? $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksClassificationDetails(blockId)))) : $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlockBasicDetails(blockId))));
      };

      var parentBlock = A2($author$project$Types$Company$toParentBuildingBlock, block, cfg.j);
      var onTapScenarioIcon = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
        return $.F;
      }, toBlockDetailsRoute), parentBlock);
      return $author$project$Ui$FinancialBlock$financialBlock({
        iz: A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$Ui$Summary$Summary$toShortSummaryFromBlock, cfg.j, block), A2($author$project$Ui$Summary$Summary$toSummaryFromBlock, cfg.j, block), cfg.jb),
        vV: 'flex1 mar1 minW0',
        i4: $author$project$Types$BuildingBlock$isFinancial(block),
        yS: _Utils_eq(cfg.eG.o_.qC.nl, $author$project$Types$BuildingBlock$unwrapBuildingBlockId(block.F)),
        ja: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$always(true), A2($turboMaCk$any_set$Set$Any$get, block.F, selectedBlocks))),
        jb: cfg.jb,
        jc: true,
        zL: block.zL,
        hT: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$DeleteBlock, cfg.j, block.F))),
        hU: $author$project$TopMsg$msgBlocks(A2($author$project$Ui$Blocks$Msg$OnDuplicate, cfg.j.F, block.F)),
        hW: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks(A2($author$project$Route$BlocksRoute$EditBlock, block.F, 0)))),
        BE: $author$project$TopMsg$msgBlocks($author$project$Ui$Blocks$Msg$OnSelectBlock(block.F)),
        jq: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$BuildingBlock$unwrapBuildingBlockId(block.F))),
        jr: onTapScenarioIcon,
        js: toBlockDetailsRoute(block.F),
        jI: A2($author$project$Views$Routed$BlocksBranch$parentNameOrClassName, parentBlock, cfg.j),
        db: function () {
          var toScenarioBtn = function (scenario) {
            return {
              y$: scenario.zL,
              ew: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, scenario.F, 0))))
            };
          };

          return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map(toScenarioBtn), A2($author$project$Types$Company$toScenariosForBlock, block.F, cfg.j)));
        }()
      });
    };

    var blockElements = function () {
      var blocks = A2($elm$core$Maybe$withDefault, _List_Nil, A4($author$project$Types$Company$toBuildingBlocksFiltered, $author$project$Types$Filters$withoutQuickEdits(state.qo), $elm$core$Maybe$Just(1), $elm$core$Maybe$Just(cfg.eG.EM), cfg.j));

      if (cfg.jb) {
        var toTitleView = function (label) {
          return $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
            vV: 'center primary30 marTop2',
            y$: label
          });
        };

        var description = function (block) {
          return A2($elm$core$Maybe$withDefault, 'Unallocated', A2($elm$core$Maybe$map, function (_v1) {
            var division = _v1.a;
            var _class = _v1.b;
            return division.zL + (' - ' + _class.zL);
          }, A2($elm$core$Maybe$andThen, function (id) {
            return A2($author$project$Types$Company$toAllocationClass, id, cfg.j);
          }, $author$project$Types$BuildingBlock$toAllocationClassId(block))));
        };

        return A2($elm$core$List$concatMap, function (_v0) {
          var head = _v0.a;
          var tail = _v0.b;
          return A2($elm$core$List$cons, toTitleView(head.a), A2($elm$core$List$cons, toBlockElement(head.b), A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, toBlockElement), tail)));
        }, A2($elm_community$list_extra$List$Extra$gatherEqualsBy, $elm$core$Tuple$first, A2($elm$core$List$sortBy, $elm$core$Tuple$first, A2($elm$core$List$map, function (block) {
          return _Utils_Tuple2(description(block), block);
        }, blocks))));
      } else {
        var blocksPerRow = function () {
          var sidebarWidth = function () {
            var _v2 = cfg.eG.o_.qC.l7;

            switch (_v2) {
              case 0:
                return 0;

              case 1:
                return 14;

              default:
                return 29;
            }
          }();

          var elementWidth = 40;
          var availableWidth = $author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits(cfg.eG.vz);
          return A2($elm$core$Basics$max, 1, $elm$core$Basics$floor((availableWidth - sidebarWidth) / elementWidth));
        }();

        var topUpWithEmptyElements = function (nodes) {
          var emptyElement = $author$project$ElmFramework$Lib$Util$spacer('flex1 mar1');
          return _Utils_cmp($elm$core$List$length(nodes), blocksPerRow) < 0 ? _Utils_ap(nodes, A2($elm$core$List$repeat, blocksPerRow - $elm$core$List$length(nodes), emptyElement)) : nodes;
        };

        return A2($elm$core$List$map, $elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class('flexRow')])), A2($elm$core$List$map, topUpWithEmptyElements, A2($elm_community$list_extra$List$Extra$greedyGroupsOf, blocksPerRow, A2($elm$core$List$map, toBlockElement, blocks))));
      }
    }();

    var addBlockBtn = $author$project$Ui$Button$button({
      kG: 'absolute bottom8 right11 primary20Back  w6 h6 radius0',
      pD: $author$project$IconSvg$add('primary0Fill w3'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$CreateBlock(0)))))
    });
    var blocksContentEl = $elm$core$List$isEmpty(blockElements) ? !$krisajenkins$remotedata$RemoteData$isSuccess(cfg.j.pg) ? _List_Nil : $author$project$Types$Filters$textSearchActive(state.qo) ? _List_fromArray([$author$project$Ui$EmptyStateView$emptyStateView({
      pi: $elm$core$Maybe$Nothing,
      tQ: $elm$core$Maybe$Nothing,
      t1: 'No results for your query.'
    })]) : _List_fromArray([$author$project$Ui$EmptyStateView$emptyStateView({
      pi: $elm$core$Maybe$Just(_Utils_Tuple2('+ Create a New Block', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$CreateBlock(0)))))),
      tQ: $elm$core$Maybe$Nothing,
      t1: 'It looks like you haven\'t created any blocks yet.'
    })]) : _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('mar-1')]), blockElements), addBlockBtn]);
    return $author$project$Views$Routed$BlocksBranch$viewLayer({
      vw: A2($author$project$Views$Routed$BlocksBranch$bottomBar, selectedBlocks, cfg.j.F),
      pD: function () {
        var filterMsg = cfg.jb ? $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksClassification(true)))) : $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksBasic(true))));
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$BlocksBranch$topContentElements, cfg.j, cfg.eG, filterMsg)]), blocksContentEl]));
      }(),
      s9: $elm$core$Maybe$Nothing,
      DY: cfg.DY,
      eG: cfg.eG
    });
  };

  var $author$project$Views$Routed$EditBuldingBlockBranch$activeDialog = function (blockState) {
    var _v0 = blockState.gZ;

    if (_v0.$ === 1) {
      return _List_Nil;
    } else {
      if (!_v0.a) {
        var _v1 = _v0.a;
        return _List_Nil;
      } else {
        var _v2 = _v0.a;
        return _List_Nil;
      }
    }
  };

  var $author$project$Global$Model$DeleteCategoryDialog = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$EditBasicBlockAllocationClassNestedSelectFinishCreate = 0;
  var $author$project$Remote$RequestMsg$EditBasicBlockAllocationClassNestedSelectFinishUpdate = 0;
  var $author$project$Remote$RequestMsg$EditBasicBlockInternalOppositeAllocationClassNestedSelectFinishCreate = 1;
  var $author$project$Remote$RequestMsg$EditBasicBlockInternalOppositeAllocationClassNestedSelectFinishUpdate = 1;
  var $author$project$Ui$Block$Msg$OnTapAllocation = {
    $: 3
  };

  var $author$project$Ui$SwitchBlockLabeled$SwitchLabelLeft = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$ClassAllocationNestedSelect$toAllocationClassId = function (hierarchyItem) {
    if (!hierarchyItem.$) {
      return $elm$core$Maybe$Nothing;
    } else {
      var allocationClass = hierarchyItem.a;
      return $elm$core$Maybe$Just(allocationClass.F);
    }
  };

  var $author$project$Ui$ClassAllocationNestedSelect$mapToExternalState = function (state) {
    return {
      kR: state.kR,
      xi: A2($elm$core$Maybe$andThen, $author$project$Ui$ClassAllocationNestedSelect$toAllocationClassId, state.xi),
      k3: state.k3,
      yK: state.yK,
      f8: state.f8,
      rm: state.rm,
      ia: A2($elm$core$Maybe$andThen, $author$project$Ui$ClassAllocationNestedSelect$toAllocationClassId, state.ia)
    };
  };

  var $author$project$Ui$ClassAllocationNestedSelect$AllocationClassItem = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$ClassAllocationNestedSelect$toHierarchyItem = F2(function (company, classId) {
    return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Ui$ClassAllocationNestedSelect$AllocationClassItem, $elm$core$Tuple$second), A2($author$project$Types$Company$toAllocationClass, classId, company));
  });
  var $author$project$Ui$ClassAllocationNestedSelect$mapToInternalState = F2(function (company, state) {
    return {
      kR: state.kR,
      xi: A2($elm$core$Maybe$andThen, $author$project$Ui$ClassAllocationNestedSelect$toHierarchyItem(company), state.xi),
      k3: state.k3,
      yK: state.yK,
      f8: state.f8,
      rm: state.rm,
      ia: A2($elm$core$Maybe$andThen, $author$project$Ui$ClassAllocationNestedSelect$toHierarchyItem(company), state.ia)
    };
  });
  var $author$project$Remote$RequestMsg$CreateAllocationClass = F3(function (a, b, c) {
    return {
      $: 30,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$CreateAllocationClassReq$CreateAllocationClassReq = F2(function (name, parentId) {
    return {
      zL: name,
      dG: parentId
    };
  });

  var $author$project$Ui$ClassAllocationNestedSelect$UnchoosableItem = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$UpdateAllocationClass = F3(function (a, b, c) {
    return {
      $: 31,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$Types$UpdateAllocationClassReq$UpdateAllocationClassReq = F3(function (name, id, parentId) {
    return {
      F: id,
      zL: name,
      dG: parentId
    };
  });
  var $author$project$Ui$ClassAllocationNestedSelect$shouldShowAsChildOf = F2(function (parent, potentialChild) {
    var _v0 = _Utils_Tuple2(parent, potentialChild);

    if (_v0.a.$ === 1) {
      if (_v0.b.$ === 1) {
        var parentClass = _v0.a.a;
        var class2 = _v0.b.a;
        var _v1 = class2.cW;

        if (!_v1.$) {
          var parentId = _v1.a;
          return _Utils_eq(parentId, parentClass.F);
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  var $author$project$Ui$ClassAllocationNestedSelect$toOptions = function (cfg) {
    var shouldFilterOutClassesWithAccounts = cfg.tt;
    var company = cfg.j;
    var onRequestMsg = cfg.r_;
    var classesWithoutAccountsFilter = $elm$core$List$filter(A2($elm$core$Basics$composeR, function ($) {
      return $.lo;
    }, $elm_community$maybe_extra$Maybe$Extra$isNothing));

    var classHierarchyItemsWithoutAccountsFilter = function (hierarchyItems) {
      var hierarchyItemShouldStayInList = function (hierarchyItem) {
        if (!hierarchyItem.$) {
          return true;
        } else {
          var _class = hierarchyItem.a;
          return $elm_community$maybe_extra$Maybe$Extra$isNothing(_class.lo);
        }
      };

      return A2($elm$core$List$filter, hierarchyItemShouldStayInList, hierarchyItems);
    };

    var toDivisionOption = function (division) {
      var toTopAllocationClassTree = F2(function (remainingDependentBlocksAndAllocationClasses, currItem) {
        var onEdit = function () {
          if (!currItem.$) {
            return $elm$core$Maybe$Nothing;
          } else {
            var allocationClass = currItem.a;
            return $elm$core$Maybe$Just(function (inputString) {
              return onRequestMsg(A3($author$project$Remote$RequestMsg$UpdateAllocationClass, cfg.hV, company.F, A3($author$project$Api$Types$UpdateAllocationClassReq$UpdateAllocationClassReq, $elm$core$Maybe$Just(inputString), allocationClass.F, allocationClass.cW)));
            });
          }
        }();

        var onDelete = function () {
          if (!currItem.$) {
            return $elm$core$Maybe$Nothing;
          } else {
            var allocationClass = currItem.a;
            return A2($elm$core$Maybe$map, function (f) {
              return f(allocationClass.F);
            }, cfg.Ax);
          }
        }();

        var createAction = function () {
          if (!currItem.$) {
            return $elm$core$Maybe$Nothing;
          } else {
            var allocationClass = currItem.a;
            return $elm$core$Maybe$Just({
              vF: '+ Add New Category',
              gi: function (inputString) {
                return onRequestMsg(A3($author$project$Remote$RequestMsg$CreateAllocationClass, cfg.mH, company.F, A2($author$project$Api$Types$CreateAllocationClassReq$CreateAllocationClassReq, inputString, allocationClass.F)));
              }
            });
          }
        }();

        var _v0 = A2($elm$core$List$partition, $author$project$Ui$ClassAllocationNestedSelect$shouldShowAsChildOf(currItem), A4($author$project$ElmFramework$Lib$Util$ifElse, classHierarchyItemsWithoutAccountsFilter, $elm$core$Basics$identity, shouldFilterOutClassesWithAccounts, remainingDependentBlocksAndAllocationClasses));

        var directDescendants = _v0.a;
        var remaining = _v0.b;
        return {
          vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, A2($elm$core$List$map, toTopAllocationClassTree(remaining), directDescendants), createAction)),
          kN: $elm$core$Maybe$Nothing,
          Ax: onDelete,
          hV: onEdit,
          jM: true,
          Fw: currItem
        };
      });

      var _v4 = A2($elm$core$List$partition, A2($elm$core$Basics$composeR, function ($) {
        return $.cW;
      }, $elm_community$maybe_extra$Maybe$Extra$isNothing), A4($author$project$ElmFramework$Lib$Util$ifElse, classesWithoutAccountsFilter, $elm$core$Basics$identity, shouldFilterOutClassesWithAccounts, $turboMaCk$any_dict$Dict$Any$values(division.oX)));

      var allocationClassesWithNoParent = _v4.a;
      var allocationClassesWithParent = _v4.b;
      var childAllocationClasses = A2($elm$core$List$map, $author$project$Ui$ClassAllocationNestedSelect$AllocationClassItem, allocationClassesWithParent);
      return {
        vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, A2($elm$core$List$map, A2($elm$core$Basics$composeL, toTopAllocationClassTree(childAllocationClasses), $author$project$Ui$ClassAllocationNestedSelect$AllocationClassItem), allocationClassesWithNoParent), $elm$core$Maybe$Nothing)),
        kN: $elm$core$Maybe$Nothing,
        Ax: $elm$core$Maybe$Nothing,
        hV: $elm$core$Maybe$Nothing,
        jM: false,
        Fw: $author$project$Ui$ClassAllocationNestedSelect$UnchoosableItem(division.zL)
      };
    };

    var toTheOptions = function (divisions) {
      var divisionsWithAllocationClasses = A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
        return $.oX;
      }, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$isEmpty, $elm$core$Basics$not)), $turboMaCk$any_dict$Dict$Any$values(divisions));
      return A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, A2($elm$core$List$map, toDivisionOption, divisionsWithAllocationClasses), $elm$core$Maybe$Nothing);
    };

    return A2($elm$core$Maybe$map, toTheOptions, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO));
  };

  var $author$project$Ui$ClassAllocationNestedSelect$toString = function (item) {
    if (!item.$) {
      var name = item.a;
      return name;
    } else {
      var allocationClass = item.a;
      return allocationClass.zL;
    }
  };

  var $author$project$Ui$ClassAllocationNestedSelect$classAllocationNestedSelect = function (cfg) {
    var tag = cfg.b3;
    var state = cfg.Ej;
    return $author$project$Ui$NestedSelect$nestedSelect({
      vV: cfg.vV,
      yI: true,
      zO: '',
      e0: $author$project$Ui$ClassAllocationNestedSelect$toOptions({
        j: cfg.j,
        mH: cfg.mH,
        Ax: cfg.Ax,
        hV: cfg.hV,
        r_: cfg.r$,
        tt: cfg.tt
      }),
      e3: cfg.e3,
      nY: cfg.nY,
      Ej: A2($author$project$Ui$ClassAllocationNestedSelect$mapToInternalState, cfg.j, state),
      b3: A2($elm$core$Basics$composeR, $author$project$Ui$ClassAllocationNestedSelect$mapToExternalState, tag),
      fd: $elm$core$Basics$eq,
      t3: $author$project$Ui$ClassAllocationNestedSelect$toString
    });
  };

  var $author$project$Ui$FinancialAccountDropdownSelector$onSelect = F2(function (state, _v0) {
    var account = _v0.b;
    return _Utils_update(state, {
      ia: $elm$core$Maybe$Just(account.F)
    });
  });
  var $author$project$Ui$FinancialAccountDropdownSelector$onSetInput = F2(function (state, string) {
    return _Utils_update(state, {
      W: string
    });
  });

  var $author$project$Ui$FinancialAccountDropdownSelector$resultToString = function (_v0) {
    var division = _v0.a;
    var account = _v0.b;
    return division.zL + (' - ' + account.zL);
  };

  var $author$project$Types$Company$toFinancialAccounts = function (company) {
    var toFinancialAccountsInDivision = function (division) {
      return A2($elm$core$List$map, function (financialAccount) {
        return _Utils_Tuple2(division, financialAccount);
      }, $turboMaCk$any_dict$Dict$Any$values(division.qp));
    };

    return A2($elm$core$Maybe$map, $elm$core$List$concat, A2($elm$core$Maybe$map, $elm$core$List$map(toFinancialAccountsInDivision), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO))));
  };

  var $author$project$Ui$FinancialAccountDropdownSelector$financialAccountDropdownSelector = function (cfg) {
    var state = cfg.Ej;
    return $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
      kG: cfg.vV,
      pY: 'Select Account',
      yM: false,
      yW: false,
      Ac: $elm$core$Maybe$Just(cfg.r6(_Utils_update(state, {
        ia: $elm$core$Maybe$Nothing
      }))),
      Ar: $elm$core$Maybe$Nothing,
      Aw: $elm$core$Maybe$Nothing,
      e_: A2($elm$core$Basics$composeL, cfg.r6, $author$project$Ui$FinancialAccountDropdownSelector$onSetInput(cfg.Ej)),
      BE: A2($elm$core$Basics$composeL, cfg.r6, $author$project$Ui$FinancialAccountDropdownSelector$onSelect(cfg.Ej)),
      e3: 'Select account',
      C5: $elm$core$Basics$always($author$project$ElmFramework$Lib$Util$noOpEl),
      C6: $author$project$Ui$FinancialAccountDropdownSelector$resultToString,
      C7: A2($elm$core$Maybe$map, $elm$core$List$filter(A2($elm$core$Basics$composeR, $author$project$Ui$FinancialAccountDropdownSelector$resultToString, A2($elm$core$Basics$composeR, $elm$core$String$toLower, $elm$core$String$contains($elm$core$String$toLower(cfg.Ej.W))))), $author$project$Types$Company$toFinancialAccounts(cfg.j)),
      ia: A2($elm$core$Maybe$andThen, function (accountId) {
        return A2($author$project$Types$Company$toFinancialAccount, accountId, cfg.j);
      }, cfg.Ej.ia),
      Fw: cfg.Ej.W
    });
  };

  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$moneyPayloadReqToMoneyPayload = function (req) {
    return {
      kg: req.kg,
      pb: req.pb,
      fE: req.fE,
      V: req.V
    };
  };

  var $author$project$Ui$Sections$plainSectionButton = F2(function (classes, content) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back radius0'), $elm$html$Html$Attributes$class(classes)]), content);
  });

  var $author$project$IconSvg$less_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('8'), $elm$svg$Svg$Attributes$y('18'), $elm$svg$Svg$Attributes$width('24'), $elm$svg$Svg$Attributes$height('4')]), _List_Nil)]));
  };

  var $author$project$IconSvg$less = function (classes) {
    return $author$project$IconSvg$less_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$Block$EditBasicBlock$sectionExtendedOrShrunken = function (cfg) {
    var addOrLessIcon = cfg.hF ? $author$project$IconSvg$less : $author$project$IconSvg$add;
    return $author$project$Ui$Button$button({
      kG: 'fullWidth pad4',
      pD: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
        vV: 'left w15',
        y$: cfg.y$
      }), cfg.g8, addOrLessIcon('primary30Fill w3')])),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.tU)
    });
  };

  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreDifferent = F2(function (div1, div2) {
    return !_Utils_eq(div1.F, div2.F);
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame = F2(function (div1, div2) {
    return _Utils_eq(div1.F, div2.F);
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toClearIf = F5(function (maybeCurrentDivision, shouldClear, maybeDivision, clearState, oldState) {
    return A3($author$project$ElmFramework$Lib$Util$ifElse, clearState, oldState, A2($elm$core$Maybe$withDefault, false, A3($elm$core$Maybe$map2, shouldClear, maybeCurrentDivision, maybeDivision)));
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toCurrentDivisions = F2(function (company, payload) {
    return {
      kf: A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
        return A2($author$project$Types$Company$toAllocationClass, id, company);
      }, payload.kf.ia)),
      bS: A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
        return A2($author$project$Types$Company$toFinancialAccount, id, company);
      }, payload.bS.ia)),
      iZ: A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
        return A2($author$project$Types$Company$toAllocationClass, id, company);
      }, payload.iZ.ia)),
      bU: A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
        return A2($author$project$Types$Company$toFinancialAccount, id, company);
      }, payload.bU.ia))
    };
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setAllocationClass = F3(function (company, payload, val) {
    var division = A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toCurrentDivisions, company, payload);
    var clearIf = $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toClearIf(A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toAllocationClass, id, company);
    }, val.ia)));
    return _Utils_update(payload, {
      kf: val,
      bS: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreDifferent, division.bS, $author$project$Ui$FinancialAccountDropdownSelector$init, payload.bS),
      iZ: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.iZ, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init, payload.iZ),
      bU: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.bU, $author$project$Ui$FinancialAccountDropdownSelector$init, payload.bU)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setAllocationFinancialAccountId = F3(function (company, payload, val) {
    var division = A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toCurrentDivisions, company, payload);
    var clearIf = $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toClearIf(A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toFinancialAccount, id, company);
    }, val.ia)));
    return _Utils_update(payload, {
      kf: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreDifferent, division.kf, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init, payload.kf),
      bS: val,
      iZ: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.iZ, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init, payload.iZ),
      bU: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.bU, $author$project$Ui$FinancialAccountDropdownSelector$init, payload.bU)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setInternalOppositeAllocationClassId = F3(function (company, payload, val) {
    var division = A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toCurrentDivisions, company, payload);
    var clearIf = $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toClearIf(A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toAllocationClass, id, company);
    }, val.ia)));
    return _Utils_update(payload, {
      kf: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.kf, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init, payload.kf),
      bS: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.bS, $author$project$Ui$FinancialAccountDropdownSelector$init, payload.bS),
      iZ: val,
      bU: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreDifferent, division.bU, $author$project$Ui$FinancialAccountDropdownSelector$init, payload.bU)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setInternalOppositeFinancialAccountId = F3(function (company, payload, val) {
    var division = A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toCurrentDivisions, company, payload);
    var clearIf = $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toClearIf(A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toFinancialAccount, id, company);
    }, val.ia)));
    return _Utils_update(payload, {
      kf: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.kf, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init, payload.kf),
      bS: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreSame, division.bS, $author$project$Ui$FinancialAccountDropdownSelector$init, payload.bS),
      iZ: A4(clearIf, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$divisionsAreDifferent, division.iZ, $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init, payload.iZ),
      bU: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setIsInternalTransaction = F3(function (company, payload, val) {
    var selectedAllocationClassHasAccount = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, function ($) {
      return $.lo;
    }, $elm_community$maybe_extra$Maybe$Extra$isJust)), A2($elm$core$Maybe$andThen, function (id) {
      return A2($author$project$Types$Company$toAllocationClass, id, company);
    }, $author$project$Ui$ClassAllocationNestedSelect$toSelection(payload.kf)));

    var newAllocationClass = function () {
      var _v0 = _Utils_Tuple3(payload.f6, val, selectedAllocationClassHasAccount);

      if (!_v0.a && _v0.b && !_v0.c.$ && _v0.c.a) {
        return $author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$init;
      } else {
        return payload.kf;
      }
    }();

    return _Utils_update(payload, {
      kf: newAllocationClass,
      f6: val
    });
  });
  var $author$project$Ui$Block$EditBasicBlock$showBetweenText = F2(function (isExtended, label) {
    return isExtended ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil) : $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
      vV: ' marLeft3 secondary0 flex1 left',
      y$: label
    });
  });

  var $author$project$Ui$SwitchBlockLabeled$switchBlockLabeled = function (cfg) {
    var showLabel = function () {
      var _v0 = cfg.y$;

      if (!_v0.$) {
        var label = _v0.a;
        return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular primary30 padLeft2 padRight1')]), _List_fromArray([$elm$html$Html$text(label)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle w2 h2 primary30Back primary0 heading4Regular flexCenter')]), _List_fromArray([$elm$html$Html$text('?')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), $author$project$Ui$Switch$switch({
          vV: '',
          hE: cfg.yC,
          yW: false,
          tU: cfg.ew
        })]);
      } else {
        var label = _v0.a;
        return _List_fromArray([$author$project$Ui$Switch$switch({
          vV: '',
          hE: cfg.yC,
          yW: false,
          tU: cfg.ew
        }), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold padLeft2')]), _List_fromArray([$elm$html$Html$text(label)]))]);
      }
    }();

    return A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class('borderHairlineWidth borderSolid gray10Border radius0 inlineFlexRow flexAlignCenter padTop1h padBottom1h padLeft2 padRight2 pointer'), $elm$html$Html$Attributes$class(cfg.vV)]), showLabel);
  };

  var $author$project$Types$MoneyOrThing$toCurrency = function (moneyOrThing) {
    if (!moneyOrThing.$) {
      var currency_enum = moneyOrThing.a;
      return $elm$core$Maybe$Just(currency_enum);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Block$EditBasicBlock$allocationPattern = function (cfg) {
    var classes = 'flexRow flexAlignCenter marTop4';
    var allocationClassHasFinancialAccount = $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm$core$Maybe$andThen, function ($) {
      return $.lo;
    }, A2($elm$core$Maybe$map, $elm$core$Tuple$second, A3($elm_community$maybe_extra$Maybe$Extra$andThen2, $author$project$Types$Company$toAllocationClass, cfg.y.cU.kf.ia, $elm$core$Maybe$Just(cfg.j)))));
    var showInternalTransaction = cfg.y.cU.f6 && !allocationClassHasFinancialAccount ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'minW18 left',
      y$: 'Opposite Class:'
    }), $author$project$Ui$ClassAllocationNestedSelect$classAllocationNestedSelect({
      vV: 'flex1',
      j: cfg.j,
      mH: $elm$core$Maybe$Just(1),
      Ax: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgGlobal, $author$project$Global$Msg$ShowDialog), $author$project$Global$Model$DeleteCategoryDialog), function (id) {
        return {
          fu: id,
          j: cfg.j
        };
      })),
      hV: $elm$core$Maybe$Just(1),
      r$: $author$project$TopMsg$requestMsg,
      e3: 'Select Classification',
      nY: $elm$core$Maybe$Nothing,
      tt: false,
      Ej: cfg.y.cU.iZ,
      b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload(cfg.y)), A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setInternalOppositeAllocationClassId, cfg.j, cfg.y.cU))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'minW18 left',
      y$: 'Opposite Acc:'
    }), $author$project$Ui$FinancialAccountDropdownSelector$financialAccountDropdownSelector({
      vV: 'flex1',
      j: cfg.j,
      r6: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload(cfg.y)), A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setInternalOppositeFinancialAccountId, cfg.j, cfg.y.cU)),
      Ej: cfg.y.cU.bU
    })]))])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    var showContent = cfg.eG.o_.vh.kh || cfg.et ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft4 padRight4 padBottom4')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'minW18 left',
      y$: 'Classification:'
    }), $author$project$Ui$ClassAllocationNestedSelect$classAllocationNestedSelect({
      vV: 'flex1 minW42',
      j: cfg.j,
      mH: $elm$core$Maybe$Just(0),
      Ax: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgGlobal, $author$project$Global$Msg$ShowDialog), $author$project$Global$Model$DeleteCategoryDialog), function (id) {
        return {
          fu: id,
          j: cfg.j
        };
      })),
      hV: $elm$core$Maybe$Just(0),
      r$: $author$project$TopMsg$requestMsg,
      e3: 'Select Classification',
      nY: $elm$core$Maybe$Nothing,
      tt: cfg.y.cU.f6,
      Ej: cfg.y.cU.kf,
      b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload(cfg.y)), A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setAllocationClass, cfg.j, cfg.y.cU))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'minW18 left',
      y$: 'Account:'
    }), $author$project$Ui$FinancialAccountDropdownSelector$financialAccountDropdownSelector({
      vV: 'flex1',
      j: cfg.j,
      r6: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload(cfg.y)), A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setAllocationFinancialAccountId, cfg.j, cfg.y.cU)),
      Ej: cfg.y.cU.bS
    })])), $author$project$Ui$SwitchBlockLabeled$switchBlockLabeled({
      vV: 'fullWidth marTop3 primary10Back ' + A3($author$project$ElmFramework$Lib$Util$ifElse, ' o5 noPointerEvents', '', allocationClassHasFinancialAccount),
      yC: cfg.y.cU.f6,
      y$: $author$project$Ui$SwitchBlockLabeled$SwitchLabelLeft('This is an internal transaction'),
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload, cfg.y, A3($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setIsInternalTransaction, cfg.j, cfg.y.cU, !cfg.y.cU.f6)))
    }), showInternalTransaction])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return A2($author$project$Ui$Sections$plainSectionButton, 'marTop2', function () {
      if (cfg.et) {
        return _List_fromArray([showContent]);
      } else {
        var summary = function () {
          var allocationClassData = A2($elm$core$Maybe$andThen, function ($) {
            return $.kg;
          }, A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$moneyPayloadReqToMoneyPayload, A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toMoneyPayloadReq(cfg.y.cU), $author$project$Types$MoneyOrThing$toCurrency(cfg.y.hO)))));
          return A2($elm$core$Maybe$andThen, $author$project$Ui$Summary$Summary$toSummaryFromAllocationClassData(cfg.j), allocationClassData);
        }();

        return _List_fromArray([$author$project$Ui$Block$EditBasicBlock$sectionExtendedOrShrunken({
          g8: A2($author$project$Ui$Block$EditBasicBlock$showBetweenText, cfg.eG.o_.vh.kh, A2($elm$core$Maybe$withDefault, 'Allocate this block to add it to a scenario.', summary)),
          hF: cfg.eG.o_.vh.kh,
          y$: 'Allocation',
          tU: $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$OnTapAllocation)
        }), showContent]);
      }
    }());
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$IntParser = 0;
  var $author$project$Ui$Block$Msg$OnTapBase = {
    $: 0
  };

  var $author$project$IconSvg$calendar_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M27.3333 10.4H28.5556C29.9 10.4 31 11.48 31 12.8V29.6C31 30.92 29.9 32 28.5556 32H11.4444C10.0878 32 9 30.92 9 29.6L9.01222 12.8C9.01222 11.48 10.0878 10.4 11.4444 10.4H12.6667V8H15.1111V10.4H24.8889V8H27.3333V10.4ZM11.4443 29.6001H28.5555V17.6001H11.4443V29.6001ZM28.5555 15.1998H11.4443V12.7998H28.5555V15.1998ZM26.1109 21.2002H19.9998V27.2002H26.1109V21.2002Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$calendar = function (classes) {
    return $author$project$IconSvg$calendar_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$DateInput$DateInput$CloseDatePicker = {
    $: 3
  };

  var $author$project$Ui$DateInput$DateInput$DateInputChanged = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$DateInput$DateInput$InputFieldFocused = {
    $: 2
  };

  var $elm$html$Html$Events$onFocus = function (msg) {
    return A2($elm$html$Html$Events$on, 'focus', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$ElmFramework$Lib$Ui$Input$inputWithFocus = function (config) {
    return A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$type_($author$project$ElmFramework$Lib$Ui$Input$toInputTypeString(config.qU)), $elm$html$Html$Attributes$required(config.gx), $elm$html$Html$Attributes$disabled(config.k_), $elm$html$Html$Attributes$placeholder(config.e3), $elm$html$Html$Attributes$value(config.Fw), $elm$html$Html$Events$onInput(config.e_), $elm$html$Html$Events$onFocus(config.A$), A2($elm$html$Html$Attributes$attribute, 'autocomplete', $author$project$ElmFramework$Lib$Ui$Input$toAutocompleteString(config.fx))]), _List_Nil);
  };

  var $author$project$Ui$InputComponent$inputFocusField = function (config) {
    var descriptionAboveInput = function () {
      var _v0 = config.E;

      if (!_v0.$) {
        var description = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bottom0h gray40 heading5Bold')]), _List_fromArray([$elm$html$Html$text(description)]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.vV)]), _List_fromArray([descriptionAboveInput, $author$project$ElmFramework$Lib$Ui$Input$inputWithFocus({
      fx: config.fx,
      kG: 'padLeft2 padRight2 borderHairlineWidth gray20Border placeholderGray40 heading5Bold borderSolid fullWidth h6 radius0 primary0Back primary30',
      k_: config.k_,
      qU: config.qU,
      A$: config.A$,
      e_: config.e_,
      e3: config.e3,
      gx: config.gx,
      Fw: config.Fw
    })]));
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$isOpen = function (_v0) {
    var status = _v0.Y;

    if (status.$ === 1) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$DateInput$DateInput$isOpen = function (dateInputModel) {
    return $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$isOpen(dateInputModel.ca.d1);
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix = 'elm-datetimepicker-single--';
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$datePickerId = 'date-picker-component';
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$NextMonth = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$PrevMonth = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$Icon = $elm$core$Basics$identity;

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$defaultAttributes = function (name) {
    return {
      kG: $elm$core$Maybe$Just('feather feather-' + name),
      aB: 24,
      jR: '',
      oo: 2,
      oI: '0 0 24 24'
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$makeBuilder = F2(function (name, src) {
    return {
      iw: $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$defaultAttributes(name),
      jU: src
    };
  });

  var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');

  var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronLeft = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$makeBuilder, 'chevron-left', _List_fromArray([A2($elm$svg$Svg$polyline, _List_fromArray([$elm$svg$Svg$Attributes$points('15 18 9 12 15 6')]), _List_Nil)]));
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronRight = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$makeBuilder, 'chevron-right', _List_fromArray([A2($elm$svg$Svg$polyline, _List_fromArray([$elm$svg$Svg$Attributes$points('9 18 15 12 9 6')]), _List_Nil)]));

  var $elm$html$Html$Events$onClick = function (msg) {
    return A2($elm$html$Html$Events$on, 'click', $elm$json$Json$Decode$succeed(msg));
  };

  var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;

  var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');

  var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml = F2(function (attributes, _v0) {
    var src = _v0.jU;
    var attrs = _v0.iw;
    var strSize = $elm$core$String$fromFloat(attrs.aB);

    var baseAttributes = _List_fromArray([$elm$svg$Svg$Attributes$fill('none'), $elm$svg$Svg$Attributes$height(_Utils_ap(strSize, attrs.jR)), $elm$svg$Svg$Attributes$width(_Utils_ap(strSize, attrs.jR)), $elm$svg$Svg$Attributes$stroke('currentColor'), $elm$svg$Svg$Attributes$strokeLinecap('round'), $elm$svg$Svg$Attributes$strokeLinejoin('round'), $elm$svg$Svg$Attributes$strokeWidth($elm$core$String$fromFloat(attrs.oo)), $elm$svg$Svg$Attributes$viewBox(attrs.oI)]);

    var combinedAttributes = _Utils_ap(function () {
      var _v1 = attrs.kG;

      if (!_v1.$) {
        var c = _v1.a;
        return A2($elm$core$List$cons, $elm$svg$Svg$Attributes$class(c), baseAttributes);
      } else {
        return baseAttributes;
      }
    }(), attributes);

    return A2($elm$svg$Svg$svg, combinedAttributes, A2($elm$core$List$map, $elm$svg$Svg$map($elm$core$Basics$never), src));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$timeOfDayFromPosix = F2(function (zone, posix) {
    return _Utils_Tuple2(A2($elm$time$Time$toHour, zone, posix), A2($elm$time$Time$toMinute, zone, posix));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$posixWithinPickerDayBoundaries = F3(function (zone, pickerDay, selection) {
    var _v0 = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$timeOfDayFromPosix, zone, pickerDay.Ef);

    var startHour = _v0.a;
    var startMinute = _v0.b;

    var _v1 = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$timeOfDayFromPosix, zone, selection);

    var selectionHour = _v1.a;
    var selectionMinute = _v1.b;

    var _v2 = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$timeOfDayFromPosix, zone, pickerDay.dR);

    var endHour = _v2.a;
    var endMinute = _v2.b;
    return _Utils_eq(startHour, selectionHour) && _Utils_cmp(startMinute, selectionMinute) < 1 || _Utils_cmp(startHour, selectionHour) < 0 && _Utils_cmp(selectionHour, endHour) < 0 || _Utils_eq(selectionHour, endHour) && _Utils_cmp(selectionMinute, endMinute) < 1;
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$SingleUtilities$selectDay = F3(function (zone, previousSelectionTuple, selectedPickerDay) {
    if (selectedPickerDay.k_) {
      return previousSelectionTuple;
    } else {
      if (!previousSelectionTuple.$) {
        var _v1 = previousSelectionTuple.a;
        var previousSelection = _v1.b;
        return A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$posixWithinPickerDayBoundaries, zone, selectedPickerDay, previousSelection) ? $elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$setTimeOfDay, zone, A2($elm$time$Time$toHour, zone, previousSelection), A2($elm$time$Time$toMinute, zone, previousSelection), selectedPickerDay.Ef))) : $elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.Ef));
      } else {
        return $elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.Ef));
      }
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update = F3(function (settings, msg, _v0) {
    var model = _v0;
    var _v1 = model.Y;

    if (_v1.$ === 1) {
      switch (msg.$) {
        case 0:
          return _Utils_Tuple2(_Utils_update(model, {
            du: model.du + 1
          }), $elm$core$Maybe$Nothing);

        case 1:
          return _Utils_Tuple2(_Utils_update(model, {
            du: model.du - 1
          }), $elm$core$Maybe$Nothing);

        case 2:
          return _Utils_Tuple2(_Utils_update(model, {
            du: model.du + 12
          }), $elm$core$Maybe$Nothing);

        case 3:
          return _Utils_Tuple2(_Utils_update(model, {
            du: model.du - 12
          }), $elm$core$Maybe$Nothing);

        case 4:
          var pickerDay = msg.a;
          return _Utils_Tuple2(_Utils_update(model, {
            f$: $elm$core$Maybe$Just(pickerDay)
          }), $elm$core$Maybe$Nothing);

        case 5:
          return _Utils_Tuple2(_Utils_update(model, {
            f$: $elm$core$Maybe$Nothing
          }), $elm$core$Maybe$Nothing);

        default:
          var pickerDay = msg.a;

          var _v3 = A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$SingleUtilities$selectDay, settings.by, model.eA, pickerDay);

          if (!_v3.$) {
            var _v4 = _v3.a;
            var newPickerDay = _v4.a;
            var newSelection = _v4.b;
            return _Utils_Tuple2(_Utils_update(model, {
              eA: $elm$core$Maybe$Just(_Utils_Tuple2(newPickerDay, newSelection))
            }), $elm$core$Maybe$Just(newSelection));
          } else {
            return _Utils_Tuple2(_Utils_update(model, {
              eA: $elm$core$Maybe$Nothing
            }), $elm$core$Maybe$Nothing);
          }

      }
    } else {
      return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize = F2(function (size, _v0) {
    var attrs = _v0.iw;
    var src = _v0.jU;
    return {
      iw: _Utils_update(attrs, {
        aB: size
      }),
      jU: src
    };
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewMonthHeader = F3(function (settings, model, time) {
    var yearName = $elm$core$String$fromInt(A2($elm$time$Time$toYear, settings.by, time));
    var monthName = settings.qy(A2($elm$time$Time$toMonth, settings.by, time));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-row')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('previous-month'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$PrevMonth, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 18, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronLeft))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-text')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('month')]), _List_fromArray([$elm$html$Html$text(settings.n7 ? monthName : monthName + (' ' + yearName))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('next-month'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$NextMonth, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 18, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronRight))]))]));
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$generateListOfWeekDay = function (firstWeekDay) {
    switch (firstWeekDay) {
      case 0:
        return _List_fromArray([0, 1, 2, 3, 4, 5, 6]);

      case 1:
        return _List_fromArray([1, 2, 3, 4, 5, 6, 0]);

      case 2:
        return _List_fromArray([2, 3, 4, 5, 6, 0, 1]);

      case 3:
        return _List_fromArray([3, 4, 5, 6, 0, 1, 2]);

      case 4:
        return _List_fromArray([4, 5, 6, 0, 1, 2, 3]);

      case 5:
        return _List_fromArray([5, 6, 0, 1, 2, 3, 4]);

      default:
        return _List_fromArray([6, 0, 1, 2, 3, 4, 5]);
    }
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewHeaderDay = F2(function (formatDay, day) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-day')]), _List_fromArray([$elm$html$Html$text(formatDay(day))]));
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewWeekHeader = function (settings) {
    return settings.tw ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-week')]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewHeaderDay(settings.qx), $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$generateListOfWeekDay(settings.lq))) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$NextYear = {
    $: 2
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$PrevYear = {
    $: 3
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronsLeft = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$makeBuilder, 'chevrons-left', _List_fromArray([A2($elm$svg$Svg$polyline, _List_fromArray([$elm$svg$Svg$Attributes$points('11 17 6 12 11 7')]), _List_Nil), A2($elm$svg$Svg$polyline, _List_fromArray([$elm$svg$Svg$Attributes$points('18 17 13 12 18 7')]), _List_Nil)]));
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronsRight = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$makeBuilder, 'chevrons-right', _List_fromArray([A2($elm$svg$Svg$polyline, _List_fromArray([$elm$svg$Svg$Attributes$points('13 17 18 12 13 7')]), _List_Nil), A2($elm$svg$Svg$polyline, _List_fromArray([$elm$svg$Svg$Attributes$points('6 17 11 12 6 7')]), _List_Nil)]));
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewYearHeader = F3(function (settings, model, time) {
    var yearName = $elm$core$String$fromInt(A2($elm$time$Time$toYear, settings.by, time));
    return settings.n7 ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-row')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('previous-year'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$PrevYear, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 12, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronsLeft))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-text')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('year')]), _List_fromArray([$elm$html$Html$text(yearName)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('next-year'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$NextYear, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 12, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronsRight))]))])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewCalendarHeader = F3(function (settings, model, time) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-header')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewMonthHeader, settings, model, time), A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewYearHeader, settings, model, time), $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewWeekHeader(settings)]));
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$showHoveredIfEnabled = function (hovered) {
    return hovered.k_ ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(hovered);
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$determineDateTime = F3(function (zone, selectionTuple, hoveredDay) {
    var hovered = A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$showHoveredIfEnabled, hoveredDay);

    if (!hovered.$) {
      var h = hovered.a;
      return A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$SingleUtilities$selectDay, zone, selectionTuple, h);
    } else {
      return selectionTuple;
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$timeIsStartOfDay = F2(function (settings, time) {
    var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, time);

    var hour = _v0.yc;
    var minute = _v0.zE;
    return !hour && !minute;
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDate = F2(function (settings, dateTime) {
    return A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2(settings.kU, settings.by, dateTime))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDateTime = F4(function (settings, timeStringFn, classString, dateTime) {
    return A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2(settings.kU, settings.by, dateTime)), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(_Utils_ap($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix, classString))]), _List_fromArray([$elm$html$Html$text(A2(timeStringFn, settings.by, dateTime))]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDateOrDateTime = F2(function (settings, dateTime) {
    return A2($elm$core$Maybe$withDefault, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDate, settings, dateTime), A2($elm$core$Maybe$map, function (timePickerSettings) {
      return A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$timeIsStartOfDay, settings, dateTime) ? A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDate, settings, dateTime) : A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDateTime, settings, timePickerSettings.ou, 'selection-time', dateTime);
    }, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$getTimePickerSettings(settings)));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewEmpty = A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('')]));
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$determineDateTimeView = F2(function (settings, selectionTuple) {
    if (selectionTuple.$ === 1) {
      return $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewEmpty;
    } else {
      var _v1 = selectionTuple.a;
      var selection = _v1.b;
      return A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDateOrDateTime, settings, selection);
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewFooter = F4(function (settings, timePickerVisible, baseDay, model) {
    var displayTime = A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$determineDateTime, settings.by, model.eA, model.f$);
    var displayTimeView = A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$determineDateTimeView, settings, displayTime);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'footer')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'time-picker-container')]), _List_fromArray([function () {
      var _v0 = settings.j$;
      return $elm$html$Html$text('');
    }()])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'date-display-container')]), _List_fromArray([displayTimeView]))]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$ClearHoveredDay = {
    $: 5
  };

  var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
    return $elm_community$list_extra$List$Extra$findIndex($elm$core$Basics$eq(x));
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$calculatePad = F3(function (firstWeekDay, monthStartDay, isFrontPad) {
    var listOfWeekday = $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$generateListOfWeekDay(firstWeekDay);

    var calculatedPadInt = function () {
      var _v0 = A2($elm_community$list_extra$List$Extra$elemIndex, monthStartDay, listOfWeekday);

      if (!_v0.$) {
        var val = _v0.a;
        return isFrontPad ? -val : 7 - val;
      } else {
        return 0;
      }
    }();

    return calculatedPadInt;
  });
  var $justinmimbs$time_extra$Time$Extra$ceiling = F3(function (interval, zone, posix) {
    var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
    return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$monthDataToPickerDays = F4(function (zone, isDisabledFn, allowableTimesFn, posixList) {
    return A2($elm$core$List$map, function (posix) {
      return A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$pickerDayFromPosix, zone, isDisabledFn, allowableTimesFn, posix);
    }, posixList);
  });
  var $justinmimbs$time_extra$Time$Extra$rangeHelp = F6(function (interval, step, zone, until, revList, current) {
    rangeHelp: while (true) {
      if (_Utils_cmp($elm$time$Time$posixToMillis(current), $elm$time$Time$posixToMillis(until)) < 0) {
        var $temp$interval = interval,
            $temp$step = step,
            $temp$zone = zone,
            $temp$until = until,
            $temp$revList = A2($elm$core$List$cons, current, revList),
            $temp$current = A4($justinmimbs$time_extra$Time$Extra$add, interval, step, zone, current);
        interval = $temp$interval;
        step = $temp$step;
        zone = $temp$zone;
        until = $temp$until;
        revList = $temp$revList;
        current = $temp$current;
        continue rangeHelp;
      } else {
        return $elm$core$List$reverse(revList);
      }
    }
  });
  var $justinmimbs$time_extra$Time$Extra$range = F5(function (interval, step, zone, start, until) {
    return A6($justinmimbs$time_extra$Time$Extra$rangeHelp, interval, A2($elm$core$Basics$max, 1, step), zone, until, _List_Nil, A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, start));
  });
  var $elm_community$list_extra$List$Extra$splitAt = F2(function (n, xs) {
    return _Utils_Tuple2(A2($elm$core$List$take, n, xs), A2($elm$core$List$drop, n, xs));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$splitIntoWeeks = F2(function (weeks, days) {
    splitIntoWeeks: while (true) {
      if ($elm$core$List$length(days) <= 7) {
        return A2($elm$core$List$cons, days, weeks);
      } else {
        var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, 7, days);

        var week = _v0.a;
        var restOfDays = _v0.b;
        var newWeeks = A2($elm$core$List$cons, week, weeks);
        var $temp$weeks = newWeeks,
            $temp$days = restOfDays;
        weeks = $temp$weeks;
        days = $temp$days;
        continue splitIntoWeeks;
      }
    }
  });
  var $elm$time$Time$toWeekday = F2(function (zone, time) {
    var _v0 = A2($elm$core$Basics$modBy, 7, A2($elm$time$Time$flooredDiv, A2($elm$time$Time$toAdjustedMinutes, zone, time), 60 * 24));

    switch (_v0) {
      case 0:
        return 3;

      case 1:
        return 4;

      case 2:
        return 5;

      case 3:
        return 6;

      case 4:
        return 0;

      case 5:
        return 1;

      default:
        return 2;
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$monthData = F5(function (zone, isDisabledFn, firstWeekDay, allowableTimesFn, time) {
    var monthStart = A3($justinmimbs$time_extra$Time$Extra$floor, 2, zone, time);
    var monthStartDay = A2($elm$time$Time$toWeekday, zone, monthStart);
    var nextMonthStart = A3($justinmimbs$time_extra$Time$Extra$ceiling, 2, zone, A4($justinmimbs$time_extra$Time$Extra$add, 11, 1, zone, monthStart));
    var nextMonthStartDay = A2($elm$time$Time$toWeekday, zone, nextMonthStart);
    var frontPad = A5($justinmimbs$time_extra$Time$Extra$range, 11, 1, zone, A4($justinmimbs$time_extra$Time$Extra$add, 11, A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$calculatePad, firstWeekDay, monthStartDay, true), zone, monthStart), monthStart);
    var endPad = A5($justinmimbs$time_extra$Time$Extra$range, 11, 1, zone, nextMonthStart, A4($justinmimbs$time_extra$Time$Extra$add, 11, A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$calculatePad, firstWeekDay, nextMonthStartDay, false), zone, nextMonthStart));
    return $elm$core$List$reverse(A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$splitIntoWeeks, _List_Nil, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$monthDataToPickerDays, zone, isDisabledFn, allowableTimesFn, _Utils_ap(frontPad, _Utils_ap(A5($justinmimbs$time_extra$Time$Extra$range, 11, 1, zone, monthStart, nextMonthStart), endPad)))));
  });

  var $elm$html$Html$Events$onMouseOut = function (msg) {
    return A2($elm$html$Html$Events$on, 'mouseout', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$SetDay = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$SetHoveredDay = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $elm$html$Html$Events$onMouseOver = function (msg) {
    return A2($elm$html$Html$Events$on, 'mouseover', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Styles$singleDayClasses = F5(function (classPrefix, isHidden, isDisabled, isPicked, isToday) {
    return isHidden ? classPrefix + ('calendar-day ' + (classPrefix + 'hidden')) : isDisabled ? classPrefix + ('calendar-day ' + (classPrefix + 'disabled')) : isPicked ? classPrefix + ('calendar-day ' + (classPrefix + 'picked')) : isToday ? classPrefix + ('calendar-day ' + (classPrefix + 'today')) : classPrefix + 'calendar-day';
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDay = F4(function (settings, model, currentMonth, day) {
    var isPicked = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (_v0) {
      var pickerDay = _v0.a;
      return _Utils_eq(pickerDay, day);
    }, model.eA));
    var isFocused = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (fday) {
      return _Utils_eq(A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$generatePickerDay, settings, fday), day);
    }, settings.qv));
    var dayParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, day.Ef);
    var dayClasses = A5($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Styles$singleDayClasses, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix, !_Utils_eq(dayParts.zG, currentMonth), day.k_, isPicked, isFocused);
    return A2($elm$html$Html$button, _List_fromArray([$elm$html$Html$Attributes$type_('button'), $elm$html$Html$Attributes$disabled(day.k_), $elm$html$Html$Attributes$class(dayClasses), $author$project$ElmFramework$Lib$Util$onTap(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$SetDay(day), model))), $elm$html$Html$Events$onMouseOver(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$SetHoveredDay(day), model)))]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(dayParts.wz))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewWeek = F4(function (settings, currentMonth, model, week) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-week')]), A2($elm$core$List$map, A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewDay, settings, model, currentMonth), week));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewMonth = F3(function (settings, model, viewTime) {
    var currentMonth = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, viewTime).zG;
    var allowedTimesOfDayFn = A2($elm$core$Maybe$map, function ($) {
      return $.ki;
    }, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$getTimePickerSettings(settings));
    var weeks = A5($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$monthData, settings.by, settings.i2, settings.lq, allowedTimesOfDayFn, viewTime);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-month'), $elm$html$Html$Events$onMouseOut(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$ClearHoveredDay, model)))]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewWeek, settings, currentMonth, model), weeks))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$view = F2(function (settings, _v0) {
    var model = _v0;
    var _v1 = model.Y;

    if (_v1.$ === 1) {
      var timePickerVisible = _v1.a;
      var baseDay = _v1.b;
      var offsetTime = A4($justinmimbs$time_extra$Time$Extra$add, 2, model.du, settings.by, baseDay.Ef);
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$datePickerId), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'picker-container minW28')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$classPrefix + 'calendar-container')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewCalendarHeader, settings, model, offsetTime), A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewMonth, settings, model, offsetTime)])), A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$viewFooter, settings, timePickerVisible, baseDay, model)]));
    } else {
      return $elm$html$Html$text('');
    }
  });
  var $author$project$Ui$DateInput$DateInput$dateInputView = F3(function (tag, state, zone) {
    var settings = $author$project$Ui$DateInput$DateInput$getDateInputSettings(zone);
    return A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onClickAway(tag($author$project$Ui$DateInput$DateInput$CloseDatePicker))]), _List_Nil, $author$project$Ui$DateInput$DateInput$isOpen(state)), _List_fromArray([$elm$html$Html$Attributes$class('primary10Back flex1 flexColumn')]), _List_fromArray([$author$project$Ui$InputComponent$inputFocusField({
      fx: $elm$core$Maybe$Nothing,
      vV: '',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      A$: tag($author$project$Ui$DateInput$DateInput$InputFieldFocused),
      e_: A2($elm$core$Basics$composeL, tag, $author$project$Ui$DateInput$DateInput$DateInputChanged),
      e3: 'DD-MM-YYYY',
      gx: false,
      Fw: A2($elm$core$Maybe$withDefault, '', state.ca.iM)
    }), A2($elm$html$Html$map, tag, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$SingleDatePicker$view, settings, state.ca.d1)])))]));
  });
  var $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses = 'padRight2 minW16 left';
  var $author$project$ElmFramework$Lib$Ui$Slider$InputLeft = 0;

  var $author$project$ElmFramework$Lib$Ui$Slider$Regular = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$Input$affixedInput = function (config) {
    var value = A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('transparent whiteSpaceNormal')]), _List_fromArray([$elm$html$Html$text(config.Fw)]));
    var affix = A3($elm$html$Html$node, 'affix-element', _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock'), $elm$html$Html$Attributes$class(config.uB), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', config.kj && $elm$core$String$isEmpty(config.Fw))]))]), _List_fromArray([$elm$html$Html$text(A3($author$project$ElmFramework$Lib$Util$ifElse, '', config.uD, !config.kj && $elm$core$String$isEmpty(config.Fw)))]));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block relative'), $elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('showAffixOnFocus', config.kj)])), A2($elm$html$Html$Attributes$style, 'min-width', config.zB), A2($elm$html$Html$Attributes$style, 'max-width', config.zp)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Input$input_custom({
      fx: $elm$core$Maybe$Nothing,
      kG: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['relative fullWidth', ' ', config.ys]))),
      k_: config.yM,
      F: config.F,
      qU: 0,
      e_: config.e_,
      e3: config.e3,
      gx: config.yW,
      Fw: config.Fw
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread noOverflow whiteSpaceNoWrap noPointerEvents')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(config.uC)]), A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([affix, value]), _List_fromArray([value, affix]), config.yT))]))]));
  };

  var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
  var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');

  var $elm$html$Html$Attributes$step = function (n) {
    return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$sliderView = function (config) {
    var clampedValue = A2($elm$core$Basics$min, A2($elm$core$Basics$max, config.m, config.Fw), config.l);
    var ratio = (clampedValue - config.m) / (config.l - config.m);
    var thumbMovementStyle = A3($elm$core$Basics$apL, $elm$core$String$replace('{{verticalCorrection}}'), $elm$core$String$fromFloat(-100 + ratio * 100), A3($elm$core$Basics$apL, $elm$core$String$replace('{{horizontalCorrection}}'), $elm$core$String$fromFloat(ratio * -100), A3($elm$core$Basics$apR, config.eT, A2($author$project$ElmFramework$Lib$Util$ifElse, function ($) {
      return $.gT;
    }, function ($) {
      return $.f_;
    }), {
      f_: 'translateX({{horizontalCorrection}}%)',
      gT: 'translateY({{verticalCorrection}}%)'
    })));
    var thumbWrapperMovementStyle = A3($elm$core$Basics$apL, $elm$core$String$replace('{{verticalMovement}}'), $elm$core$String$fromFloat(100 - ratio * 100), A3($elm$core$Basics$apL, $elm$core$String$replace('{{horizontalMovement}}'), $elm$core$String$fromFloat(ratio * 100), A3($elm$core$Basics$apR, config.eT, A2($author$project$ElmFramework$Lib$Util$ifElse, function ($) {
      return $.gT;
    }, function ($) {
      return $.f_;
    }), {
      f_: 'translateX({{horizontalMovement}}%) translateZ(1px)',
      gT: 'translateY({{verticalMovement}}%) translateZ(1px)'
    })));
    var trackMovementStyle = A3($elm$core$Basics$apR, config.eT, A2($author$project$ElmFramework$Lib$Util$ifElse, A2($elm$core$Basics$composeR, function ($) {
      return $.gT;
    }, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, '{{verticalMovement}}', $elm$core$String$fromFloat(100 - ratio * 100)), A2($elm$core$String$replace, '{{verticalCorrection}}', $elm$core$String$fromFloat(ratio * 3 - 1.5)))), A2($elm$core$Basics$composeR, function ($) {
      return $.f_;
    }, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, '{{horizontalMovement}}', $elm$core$String$fromFloat(-100 + ratio * 100)), A2($elm$core$String$replace, '{{horizontalCorrection}}', $elm$core$String$fromFloat(3 - ratio * 3))))), {
      f_: 'translateX({{horizontalMovement}}%) translateX({{horizontalCorrection}}px)',
      gT: 'translateY({{verticalMovement}}%) translateY({{verticalCorrection}}px)'
    });

    var _v0 = function () {
      var verticalClasses = {
        ys: 'block fullHeight o0 pointer',
        dg: 'inlineBlock relative fullHeight',
        dk: 'inlineBlock circle',
        dl: 'absoluteSpread noPointerEvents',
        dp: 'block w1 fullHeight promoteLayerGpuLayer noOverflow',
        dq: 'block fullWidth fullHeight',
        dr: 'absoluteSpread flexCenter noPointerEvents'
      };
      var horizontalClasses = {
        ys: 'block h2 fullWidth o0 pointer',
        dg: 'block relative fullWidth fullHeight',
        dk: ' absoluteSpread inlineBlock circle',
        dl: 'absoluteSpread noPointerEvents',
        dp: 'block h1 fullWidth promoteLayerGpuLayer noOverflow',
        dq: 'block fullWidth fullHeight',
        dr: 'absoluteSpread flexCenter noPointerEvents'
      };
      return A3($author$project$ElmFramework$Lib$Util$ifElse, verticalClasses, horizontalClasses, config.eT);
    }();

    var sliderClasses = _v0.dg;
    var inputClasses = _v0.ys;
    var trackWrapperClasses = _v0.dr;
    var trackClasses = _v0.dp;
    var trackFillClasses = _v0.dq;
    var thumbWrapperClasses = _v0.dl;
    var thumbClasses = _v0.dk;
    return A3($elm$html$Html$node, 'slider-element', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray([sliderClasses, ' ', config.dg]))))]), _List_fromArray([A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$class(inputClasses), A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('range'), A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(config.yM), A2($elm$core$List$cons, $elm$html$Html$Attributes$min($elm$core$String$fromFloat(config.m)), A2($elm$core$List$cons, $elm$html$Html$Attributes$max($elm$core$String$fromFloat(config.l)), A2($elm$core$List$cons, $elm$html$Html$Attributes$value($elm$core$String$fromFloat(config.Fw)), A2($elm$core$List$cons, $elm$html$Html$Attributes$step($elm$core$String$fromFloat(config.eb)), A2($elm$core$List$cons, $elm$html$Html$Events$onInput(config.e_), A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'orient', 'vertical')]), _List_Nil, config.eT))))))))), _List_Nil), A3($elm$html$Html$node, 'track-wrapper', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray([trackWrapperClasses, ' ', config.dr]))))]), _List_fromArray([A3($elm$html$Html$node, 'track-element', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray([trackClasses, ' ', config.dp]))))]), _List_fromArray([A3($elm$html$Html$node, 'fill-element', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray([trackFillClasses, ' ', config.dq])))), A2($elm$html$Html$Attributes$style, 'transform', trackMovementStyle)]), _List_Nil)]))])), A3($elm$html$Html$node, 'thumb-wrapper', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray([thumbWrapperClasses, ' ', config.dl])))), A2($elm$html$Html$Attributes$style, 'transform', thumbWrapperMovementStyle)]), _List_fromArray([A3($elm$html$Html$node, 'thumb-element', _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray([thumbClasses, ' ', config.dk])))), A2($elm$html$Html$Attributes$style, 'transform', thumbMovementStyle)]), _List_Nil)]))]));
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$sliderView({
      yM: config.yM,
      eT: false,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: config.dg,
      eb: config.eb,
      dk: config.dk,
      dl: config.dl,
      dp: config.dp,
      dq: config.dq,
      dr: config.dr,
      Fw: config.Fw
    });
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$parseByVariant = function (variant) {
    if (!variant) {
      return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Maybe$andThen($elm$core$String$toFloat), $elm$core$Maybe$map($elm$core$String$fromInt)), $elm$core$String$toInt);
    } else {
      return $elm$core$String$toFloat;
    }
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$horizontalSliderWithInput = function (config) {
    var sliderElement = $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider({
      yM: config.yM,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: config.dg,
      eb: config.eb,
      dk: config.dk,
      dl: config.dl,
      dp: config.dp,
      dq: config.dq,
      dr: config.dr,
      Fw: A2($elm$core$Maybe$withDefault, config.m, A2($author$project$ElmFramework$Lib$Ui$Slider$parseByVariant, config.ui, config.Fw))
    });

    var inputElement = function () {
      var _v1 = config.tW;

      switch (_v1.$) {
        case 0:
          var inputConfig = _v1.a;
          return $author$project$ElmFramework$Lib$Ui$Input$customAttributesInput({
            uZ: _List_fromArray([A2($elm$html$Html$Attributes$style, 'width', inputConfig.zp)]),
            fx: $elm$core$Maybe$Nothing,
            kG: config.gK,
            k_: config.yM,
            qU: 0,
            e_: config.e_,
            e3: '',
            gx: config.yW,
            Fw: config.Fw
          });

        case 1:
          var affixedInputConfig = _v1.a;
          return $author$project$ElmFramework$Lib$Ui$Input$affixedInput({
            uB: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['absolute centerY fullRight', ' ', affixedInputConfig.uB]))),
            uC: 'padTop1h padBottom1h absoluteCenter',
            uD: affixedInputConfig.uD,
            kj: false,
            kG: 'lineHeightNormal',
            F: '',
            ys: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['padTop1h padBottom1h center', ' ', config.gK]))),
            yM: config.yM,
            yT: true,
            yW: config.yW,
            zp: affixedInputConfig.zp,
            zB: affixedInputConfig.zB,
            e_: config.e_,
            e3: '',
            Fw: config.Fw
          });

        default:
          var affixedInputConfig = _v1.a;
          return $author$project$ElmFramework$Lib$Ui$Input$affixedInput({
            uB: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['absolute centerY fullLeft', ' ', affixedInputConfig.uB]))),
            uC: 'padTop1h padBottom1h absoluteCenter',
            uD: affixedInputConfig.uD,
            kj: false,
            kG: 'lineHeightNormal',
            F: '',
            ys: $elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['padTop1h padBottom1h center', ' ', config.gK]))),
            yM: config.yM,
            yT: false,
            yW: config.yW,
            zp: affixedInputConfig.zp,
            zB: affixedInputConfig.zB,
            e_: config.e_,
            e3: '',
            Fw: config.Fw
          });
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['flexRow flexAlignCenter gapRow2', ' ', config.kG]))))]), function () {
      var _v0 = config.yu;

      if (!_v0) {
        return _List_fromArray([inputElement, sliderElement]);
      } else {
        return _List_fromArray([sliderElement, inputElement]);
      }
    }());
  };

  var $author$project$Ui$Slider$horizontalSliderInputLeft = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$horizontalSliderWithInput({
      kG: config.kG,
      yu: 0,
      yM: config.yM,
      yW: config.yW,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: '',
      eb: config.eb,
      gK: 'padLeft2 padRight2 padTop1h padBottom1h radius0 borderSolid borderWidth1 gray20Border',
      tW: $author$project$ElmFramework$Lib$Ui$Slider$Regular({
        zn: config.qR,
        zp: config.iX
      }),
      dk: 'primary30Back',
      dl: '',
      dp: 'gray10Back',
      dq: 'secondary0Back',
      dr: '',
      Fw: config.Fw,
      ui: config.ui
    });
  };

  var $author$project$Api$GraphqlSchema$Enum$Currency_enum$list = _List_fromArray([0]);

  var $author$project$Types$MoneyOrThing$toString = function (moneyOrThing) {
    if (!moneyOrThing.$) {
      var currency = moneyOrThing.a;
      return $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString(currency);
    } else {
      var unit = moneyOrThing.a;
      return unit;
    }
  };

  var $author$project$Ui$MoneyOrThingInput$moneyOrThingInput = function (cfg) {
    var currInputThing = function () {
      var _v0 = cfg.Fw;

      if (!_v0.$) {
        return _List_Nil;
      } else {
        var unit = _v0.a;
        return _List_fromArray([$author$project$Types$MoneyOrThing$Thing(unit)]);
      }
    }();

    return $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
      kG: cfg.kG,
      pY: '',
      yM: false,
      yW: true,
      Ac: $elm$core$Maybe$Nothing,
      Ar: $elm$core$Maybe$Nothing,
      Aw: $elm$core$Maybe$Nothing,
      e_: A2($elm$core$Basics$composeL, cfg.si, $author$project$Types$MoneyOrThing$Thing),
      BE: cfg.si,
      e3: 'Enter Unit',
      C5: $elm$core$Basics$always($author$project$ElmFramework$Lib$Util$noOpEl),
      C6: $author$project$Types$MoneyOrThing$toString,
      C7: $elm$core$Maybe$Just(_Utils_ap(currInputThing, A2($elm$core$List$map, $author$project$Types$MoneyOrThing$Money, $author$project$Api$GraphqlSchema$Enum$Currency_enum$list))),
      ia: $elm$core$Maybe$Nothing,
      Fw: $author$project$Types$MoneyOrThing$toString(cfg.Fw)
    });
  };

  var $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$list = _List_fromArray([0, 1, 2, 3, 4, 5]);

  var $author$project$Ui$RepeatPeriodNestedSelect$toString = function (repeat_period_enum) {
    switch (repeat_period_enum) {
      case 0:
        return 'Day';

      case 1:
        return 'Half month';

      case 2:
        return 'Month';

      case 3:
        return 'Quarter';

      case 4:
        return 'Week';

      default:
        return 'Year';
    }
  };

  var $author$project$Ui$RepeatPeriodNestedSelect$repeatPeriodNestedSelect = function (cfg) {
    return $author$project$Ui$DropdownSelect$dropdownSelect({
      vV: 'w18 marLeft2',
      yI: false,
      e0: $author$project$Api$GraphqlSchema$Enum$Repeat_period_enum$list,
      e3: 'Choose...',
      Ej: cfg.Ej,
      b3: cfg.b3,
      fd: $elm$core$Basics$eq,
      EU: $author$project$Ui$RepeatPeriodNestedSelect$toString
    });
  };

  var $author$project$ElmFramework$Lib$ViewModelStringTo$set = F2(function (string, _v0) {
    var state = _v0;
    return _Utils_update(state, {
      Fw: string
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setBaseValue = F2(function (editingBasicPayload, string) {
    return _Utils_update(editingBasicPayload, {
      g5: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, string, editingBasicPayload.g5)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setEndAtCount = F2(function (editingRepeatPattern, val) {
    var endAt = editingRepeatPattern.hn;
    return _Utils_update(editingRepeatPattern, {
      hn: _Utils_update(endAt, {
        k: $elm$core$Maybe$Just(val),
        iL: $elm$core$Maybe$Nothing
      })
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setEndAtDate = F2(function (editingRepeatPattern, val) {
    var endAt = editingRepeatPattern.hn;
    var count = _Utils_eq(val.Fw, $elm$core$Maybe$Nothing) ? endAt.k : $elm$core$Maybe$Nothing;
    return _Utils_update(editingRepeatPattern, {
      hn: _Utils_update(endAt, {
        k: count,
        iL: $elm$core$Maybe$Just(val)
      })
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setEvery = F2(function (editingRepeatPattern, val) {
    return _Utils_update(editingRepeatPattern, {
      ao: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, val, editingRepeatPattern.ao)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyOrThing = F2(function (block, val) {
    return _Utils_update(block, {
      hO: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setPeriod = F2(function (editingRepeatPattern, val) {
    return _Utils_update(editingRepeatPattern, {
      ap: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setRepeatPattern = F2(function (editingBasicPayload, editingRepeatPattern) {
    return _Utils_update(editingBasicPayload, {
      h2: editingRepeatPattern
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setStartOn = F2(function (block, val) {
    return _Utils_update(block, {
      bw: val
    });
  });

  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toBaseValue = function (block) {
    var _v0 = block.g7;

    if (!_v0.$) {
      if (!_v0.a) {
        var _v1 = _v0.a;
        return $elm$core$Result$toMaybe($author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(block.fD.g5));
      } else {
        var _v2 = _v0.a;
        return $elm$core$Maybe$Nothing;
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$basicPayloadReqToBasicPayload = function (req) {
    var seasonalityInBlockReqToSeasonalityInBlock = function (sreq) {
      if (!sreq.$) {
        var id = sreq.a;
        return $author$project$Types$SeasonalityInBlock$SeasonalityPreset(id);
      } else {
        var list = sreq.a;
        return $author$project$Types$SeasonalityInBlock$SeasonalityValue($elm$core$Array$fromList(list));
      }
    };

    return {
      g5: req.g5,
      fZ: req.fZ,
      h2: req.h2,
      bK: A2($elm$core$Maybe$map, seasonalityInBlockReqToSeasonalityInBlock, req.bK)
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$derivativePayloadReqToDerivativePayload = function (req) {
    return {
      hk: req.hk,
      ho: req.ho,
      r: req.r,
      t: req.t,
      gM: req.gM
    };
  };

  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toBlockType = F2(function (company, editing) {
    var _v0 = _Utils_Tuple2(editing.g7, editing.hO);

    if (!_v0.a.$) {
      if (!_v0.a.a) {
        if (!_v0.b.$) {
          var _v1 = _v0.a.a;
          var currency = _v0.b.a;
          return A3($elm$core$Maybe$map2, F2(function (basic, money) {
            return $author$project$Types$BuildingBlock$BasicMoney($krisajenkins$remotedata$RemoteData$succeed(_Utils_Tuple2(basic, money)));
          }), A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingBasicPayload$basicPayloadReqToBasicPayload, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, company, editing.fD))), A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$moneyPayloadReqToMoneyPayload, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toMoneyPayloadReq, editing.cU, currency))));
        } else {
          var _v2 = _v0.a.a;
          var thingDesc = _v0.b.a;
          return A3($elm$core$Maybe$map2, F2(function (basic, thing) {
            return $author$project$Types$BuildingBlock$BasicThing($krisajenkins$remotedata$RemoteData$succeed(_Utils_Tuple2(basic, thing)));
          }), A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingBasicPayload$basicPayloadReqToBasicPayload, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, company, editing.fD))), $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingThingPayload$toThingPayload, editing.eD, thingDesc)));
        }
      } else {
        if (!_v0.b.$) {
          var _v3 = _v0.a.a;
          var currency = _v0.b.a;
          return A4($elm$core$Maybe$map3, F3(function (derivative, money, derivativeMoney) {
            return $author$project$Types$BuildingBlock$DerivativeMoney($krisajenkins$remotedata$RemoteData$succeed(_Utils_Tuple3(derivative, money, derivativeMoney)));
          }), A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$derivativePayloadReqToDerivativePayload, $elm$core$Result$toMaybe($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq(editing.d2))), $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingMoneyPayload$toMoneyPayloadReq, editing.cU, currency)), $elm$core$Result$toMaybe($author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$toDerivativeMoneyPayload(editing.fP)));
        } else {
          var _v4 = _v0.a.a;
          var thingDesc = _v0.b.a;
          return A3($elm$core$Maybe$map2, F2(function (derivative, thing) {
            return $author$project$Types$BuildingBlock$DerivativeThing($krisajenkins$remotedata$RemoteData$succeed(_Utils_Tuple2(derivative, thing)));
          }), A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$derivativePayloadReqToDerivativePayload, $elm$core$Result$toMaybe($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq(editing.d2))), $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingThingPayload$toThingPayload, editing.eD, thingDesc)));
        }
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndAfterCount = function (editingRepeatPattern) {
    return A2($elm$core$Maybe$andThen, $elm$core$String$toInt, editingRepeatPattern.hn.k);
  };

  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndDateInputModel = F2(function (zone, pattern) {
    return A2($elm$core$Maybe$withDefault, A2($author$project$Ui$DateInput$DateInput$initClosedDateInput, zone, $elm$core$Maybe$Nothing), pattern.hn.iL);
  });

  var $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw = function (_v0) {
    var value = _v0.Fw;
    return value;
  };

  var $author$project$Ui$DateInput$DateInput$updateShort = F4(function (zone, currTime, dateInputModel, dateInputMsg) {
    return $author$project$Ui$DateInput$DateInput$updateDateInput({
      vd: currTime,
      wy: dateInputMsg,
      zF: dateInputModel,
      by: zone
    });
  });

  var $author$project$Ui$Block$EditBasicBlock$basePattern = function (cfg) {
    var state = cfg.eG.o_.vh;
    var classes = 'flexRow flexAlignCenter marTop4';
    var expandedSection = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative padLeft4 padRight4 padBottom4 z1')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Base Value:'
    }), $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'flex1',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(state.bv)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setBaseValue(state.bv.fD)),
      e3: '',
      gx: true,
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(state.bv.fD.g5)
    }), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$Ui$MoneyOrThingInput$moneyOrThingInput({
      kG: 'flex1',
      si: A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyOrThing(state.bv)),
      Fw: cfg.y.hO
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Start Date:'
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative fullWidth')]), _List_fromArray([A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setStartOn(cfg.y)), A3($author$project$Ui$DateInput$DateInput$updateShort, cfg.eG.by, cfg.eG.EM, cfg.y.bw)), cfg.y.bw, cfg.eG.by), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('absolute right2 bottom1h w3 h3')]), _List_fromArray([$author$project$IconSvg$calendar(' w3 primary30Fill')]))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Repeat Every:'
    }), $author$project$Ui$Slider$horizontalSliderInputLeft({
      kG: 'fontSize3 flex1',
      qR: '20%',
      iX: '8rem',
      yM: false,
      yW: false,
      l: 100.0,
      m: 0.0,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setRepeatPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setEvery(cfg.y.fD.h2)),
      eb: 1.0,
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(cfg.y.fD.h2.ao),
      ui: 0
    }), $author$project$Ui$RepeatPeriodNestedSelect$repeatPeriodNestedSelect({
      Ej: cfg.y.fD.h2.ap,
      b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setRepeatPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setPeriod(cfg.y.fD.h2))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'End After:'
    }), $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'flex1 maxW7',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setRepeatPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setEndAtCount(cfg.y.fD.h2)),
      e3: '',
      gx: false,
      Fw: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$fromInt, $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndAfterCount(cfg.y.fD.h2))
    }), $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'padLeft2 padRight2',
      y$: 'occurrences, or end on'
    }), A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setRepeatPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$setEndAtDate(cfg.y.fD.h2)), A3($author$project$Ui$DateInput$DateInput$updateShort, cfg.eG.by, cfg.eG.EM, A2($author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndDateInputModel, cfg.eG.by, cfg.y.fD.h2))), A2($author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndDateInputModel, cfg.eG.by, cfg.y.fD.h2), cfg.eG.by)]))]));
    return A2($author$project$Ui$Sections$plainSectionButton, 'marTop2', function () {
      if (cfg.et) {
        return _List_fromArray([expandedSection]);
      } else {
        var repeatPattern = $elm$core$Result$toMaybe($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toRepeatPattern(cfg.y.fD));
        var fraction = $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toBaseValue(cfg.y);
        var blockTypeHydrated = A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlockHydrated$toHydratedType, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toBlockType, cfg.j, cfg.y));
        var summary = A5($elm$core$Maybe$map4, $author$project$Ui$Summary$Summary$toSummaryFromBasePattern, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, cfg.eG.by, cfg.y), fraction, repeatPattern, blockTypeHydrated);
        return _List_fromArray([$author$project$Ui$Block$EditBasicBlock$sectionExtendedOrShrunken({
          g8: A2($author$project$Ui$Block$EditBasicBlock$showBetweenText, state.ku, A2($elm$core$Maybe$withDefault, 'Add a base pattern to this block.', summary)),
          hF: state.ku,
          y$: 'Base Pattern',
          tU: $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$OnTapBase)
        }), A3($author$project$ElmFramework$Lib$Util$ifElse, expandedSection, $author$project$ElmFramework$Lib$Util$noOpEl, state.ku)]);
      }
    }());
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$FloatParser = 1;
  var $author$project$Ui$Block$Msg$OnTapGrowth = {
    $: 1
  };

  var $author$project$Ui$Button$buttonSelect = function (config) {
    var selected = config.yC ? {
      vV: 'primary0 gradient0Back'
    } : {
      vV: 'primary30 gray10Back'
    };
    return $author$project$Ui$Button$button({
      kG: A2($elm$core$String$join, ' ', _List_fromArray(['radius0 noBorder heading4Bold padLeft2 padRight2', selected.vV, config.vV])),
      pD: $elm$html$Html$text(config.y$),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(config.ew)
    });
  };

  var $author$project$Ui$Button$buttonSelectShort = function (cfg) {
    return $author$project$Ui$Button$buttonSelect({
      vV: cfg.vV + ' minH5',
      yC: cfg.yC,
      y$: cfg.y$,
      ew: cfg.ew
    });
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$InputRight = 1;

  var $author$project$ElmFramework$Lib$Ui$Slider$Suffixed = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Slider$horizontalSliderSuffixedInputRight = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$horizontalSliderWithInput({
      kG: config.kG,
      yu: 1,
      yM: config.yM,
      yW: config.yW,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: '',
      eb: config.eb,
      gK: 'radius0 borderSolid borderWidth1 gray10Border',
      tW: $author$project$ElmFramework$Lib$Ui$Slider$Suffixed({
        uB: config.tR,
        uD: config.tS,
        zp: config.iX,
        zB: config.qS
      }),
      dk: 'primary30Back',
      dl: '',
      dp: 'gray10Back',
      dq: 'secondary0Back',
      dr: '',
      Fw: config.Fw,
      ui: config.ui
    });
  };

  var $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setEvery = F2(function (editingGrowthPattern, val) {
    return _Utils_update(editingGrowthPattern, {
      ao: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, val, editingGrowthPattern.ao)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern = F2(function (editingBasicPayload, editingGrowthPattern) {
    return _Utils_update(editingBasicPayload, {
      fZ: editingGrowthPattern
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setPeriod = F2(function (editingGrowthPattern, val) {
    return _Utils_update(editingGrowthPattern, {
      ap: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setRate = F2(function (editingGrowthPattern, val) {
    return _Utils_update(editingGrowthPattern, {
      bR: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, val, editingGrowthPattern.bR)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setStartOn = F2(function (editingGrowthPattern, val) {
    return _Utils_update(editingGrowthPattern, {
      bw: val
    });
  });

  var $author$project$Ui$Block$EditBasicBlock$growthPattern = function (cfg) {
    var classes = 'flexRow flexAlignCenter marTop3';
    var showContent = cfg.eG.o_.vh.lz || cfg.et ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft4 padRight4 padBottom4')]), _List_fromArray([$author$project$Ui$Slider$horizontalSliderSuffixedInputRight({
      kG: 'heading4Bold primary30 marTop3',
      iX: '20%',
      qS: '3ch',
      yM: false,
      yW: false,
      l: 100.0,
      m: 0.0,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setRate(cfg.y.fD.fZ)),
      eb: 1.0,
      tR: '',
      tS: '%',
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(cfg.y.fD.fZ.bR),
      ui: 1
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'padRight3',
      y$: 'Every'
    }), $author$project$Ui$Slider$horizontalSliderSuffixedInputRight({
      kG: 'heading4Bold primary30 flex1',
      iX: '100%',
      qS: '5rem',
      yM: false,
      yW: false,
      l: 100.0,
      m: 0.0,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setEvery(cfg.y.fD.fZ)),
      eb: 1.0,
      tR: '',
      tS: '',
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(cfg.y.fD.fZ.ao),
      ui: 0
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop4 left')]), _List_fromArray([$author$project$Ui$Button$buttonSelectShort({
      vV: '',
      yC: cfg.y.fD.fZ.ap === 2,
      y$: 'Week',
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload, cfg.y, A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern, cfg.y.fD, A2($author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setPeriod, cfg.y.fD.fZ, 2))))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2h',
      yC: !cfg.y.fD.fZ.ap,
      y$: 'Month',
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload, cfg.y, A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern, cfg.y.fD, A2($author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setPeriod, cfg.y.fD.fZ, 0))))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2h',
      yC: cfg.y.fD.fZ.ap === 1,
      y$: 'Quarter',
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload, cfg.y, A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern, cfg.y.fD, A2($author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setPeriod, cfg.y.fD.fZ, 1))))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2h',
      yC: cfg.y.fD.fZ.ap === 3,
      y$: 'Year',
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload, cfg.y, A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern, cfg.y.fD, A2($author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setPeriod, cfg.y.fD.fZ, 3))))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'padRight9',
      y$: 'Starting On'
    }), A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setGrowthPattern(cfg.y.fD)), $author$project$Types$EditingBuildingBlock$EditingGrowthPattern$setStartOn(cfg.y.fD.fZ)), A3($author$project$Ui$DateInput$DateInput$updateShort, cfg.eG.by, cfg.eG.EM, cfg.y.fD.fZ.bw)), cfg.y.fD.fZ.bw, cfg.eG.by)]))])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return A2($author$project$Ui$Sections$plainSectionButton, 'marTop2 betweenPhoneDesktopWidth', function () {
      if (cfg.et) {
        return _List_fromArray([showContent]);
      } else {
        var summary = function () {
          var growthPattern_ = A2($elm$core$Maybe$andThen, function ($) {
            return $.fZ;
          }, A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingBasicPayload$basicPayloadReqToBasicPayload, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, cfg.j, cfg.y.fD))));
          return A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromGrowthPattern, growthPattern_);
        }();

        return _List_fromArray([$author$project$Ui$Block$EditBasicBlock$sectionExtendedOrShrunken({
          g8: A2($author$project$Ui$Block$EditBasicBlock$showBetweenText, cfg.eG.o_.vh.lz, A2($elm$core$Maybe$withDefault, 'Add a growth to this block.', summary)),
          hF: cfg.eG.o_.vh.lz,
          y$: 'Growth',
          tU: $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$OnTapGrowth)
        }), showContent]);
      }
    }());
  };

  var $author$project$Ui$TimeTransformation$Util$PrimaryTheme = 0;

  var $author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetChanged = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetPressEnded = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetPressed = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Msg$HoverEnded = {
    $: 6
  };
  var $author$project$Ui$TimeTransformation$Msg$NoOp = {
    $: 2
  };
  var $author$project$Ui$TimeTransformation$InputGraph$Msg$SelectionEnded = {
    $: 5
  };

  var $JoshuaHall$elm_fraction$Fraction$reciprocal = function (_v0) {
    var numerator = _v0.a;
    var denominator = _v0.b;
    return A2($JoshuaHall$elm_fraction$Fraction$create, denominator, numerator);
  };

  var $JoshuaHall$elm_fraction$Fraction$divide = F2(function (fraction1, fraction2) {
    return A2($elm$core$Maybe$map, $JoshuaHall$elm_fraction$Fraction$multiply(fraction1), $JoshuaHall$elm_fraction$Fraction$reciprocal(fraction2));
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$eventFullKeyed = F2(function (eventHandlers, attrs) {
    var toAttrs = function (_v0) {
      var eventEmitterAttributes = _v0;
      return eventEmitterAttributes;
    };

    var normalizedHandlers = $elm$core$List$concat(A2($elm$core$List$map, toAttrs, eventHandlers));
    return A2($elm$html$Html$Keyed$node, 'event-full', _Utils_ap(normalizedHandlers, attrs));
  });

  var $author$project$Ui$TimeTransformation$InputGraph$Util$getRatioSumOfInputValues = function (state) {
    return A3($elm$core$List$foldl, F2(function (_v0, acc) {
      var inputValue = _v0.b;

      if (!inputValue.$) {
        return acc;
      } else {
        var ratio = inputValue.a;
        return A2($JoshuaHall$elm_fraction$Fraction$add, acc, ratio);
      }
    }), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), $turboMaCk$any_dict$Dict$Any$toList(state.yx));
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$getSumOfInputValues = F2(function (state, values) {
    var _v0 = A2($author$project$Ui$TimeTransformation$InputGraph$Util$getSumOfValuesInSelectedInterval, state, values);

    if (!_v0.$) {
      var sumOfValues = _v0.a;
      return A2($JoshuaHall$elm_fraction$Fraction$equal, sumOfValues, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1)) ? $author$project$Types$TimeTransformationBackend$Ratio($author$project$Ui$TimeTransformation$InputGraph$Util$getRatioSumOfInputValues(state)) : $author$project$Types$TimeTransformationBackend$CurrencyValue(A2($author$project$Ui$TimeTransformation$InputGraph$Util$getValueSumOfInputValues, sumOfValues, state));
    } else {
      return $author$project$Types$TimeTransformationBackend$Ratio($author$project$Ui$TimeTransformation$InputGraph$Util$getRatioSumOfInputValues(state));
    }
  });

  var $author$project$Ui$TimeTransformation$Util$getThemeValues = function (theme) {
    if (!theme) {
      return {
        u5: 'whiteBack',
        o5: 'gray20Back',
        u9: 'gray10Back',
        vb: 'secondary0Back',
        vc: 'gray20Back',
        yd: 'gray20Back',
        qI: 'gray20Back',
        qJ: 'primary30Back',
        ye: 'gray0Back',
        yZ: 'afterGray40Back',
        lX: 'afterPrimary30Back',
        DD: 'scrollHoverPrimary',
        tp: 'gray10Back',
        DT: 'afterPrimary30Back',
        E8: 'secondary10Back',
        E9: 'primary30',
        Fa: 'secondary0'
      };
    } else {
      return {
        u5: 'gray10Back',
        o5: 'gray40Back',
        u9: 'gray20Back',
        vb: 'secondary0Back',
        vc: 'gray40Back',
        yd: 'gray40Back',
        qI: 'graph10Back',
        qJ: 'primary30Back',
        ye: 'graph10Back',
        yZ: 'afterGray40Back',
        lX: 'afterPrimary30Back',
        DD: 'scrollHoverSecondary',
        tp: 'graph0Back',
        DT: 'afterPrimary30Back',
        E8: 'whiteBack',
        E9: 'gray40',
        Fa: 'gray40'
      };
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$isSelecting = function (status) {
    switch (status.$) {
      case 2:
        return true;

      case 3:
        return true;

      default:
        return false;
    }
  };

  var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
  var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;

  var $author$project$Ui$TimeTransformation$InputGraph$Util$InputValue = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$OutputValue = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$SelectionValue = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$Util$calculateHeightPercent = F2(function (max, value) {
    return A2($elm$core$Maybe$withDefault, 0.0, A2($elm$core$Maybe$map, $JoshuaHall$elm_fraction$Fraction$toFloat, A2($JoshuaHall$elm_fraction$Fraction$divide, value, max)));
  });

  var $author$project$Ui$TimeTransformation$InputGraph$Util$extractInputValueFromValueType = function (valueType) {
    switch (valueType.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        var currencyOrRatioAmount = valueType.a;
        return $elm$core$Maybe$Just(currencyOrRatioAmount);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$extractValueFromValueType = function (valueType) {
    switch (valueType.$) {
      case 0:
        var currencyOrRatioAmount = valueType.a;
        return currencyOrRatioAmount;

      case 1:
        var currencyOrRatioAmount = valueType.a;
        return currencyOrRatioAmount;

      default:
        var currencyOrRatioAmount = valueType.a;
        return currencyOrRatioAmount;
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$isIdle = function (status) {
    switch (status.$) {
      case 0:
        return true;

      case 1:
        var selectedDate = status.a.DO;
        return $elm_community$maybe_extra$Maybe$Extra$isNothing(selectedDate);

      default:
        return false;
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$toHoverTarget = function (status) {
    switch (status.$) {
      case 1:
        var hoverDate = status.a.hC;
        return $elm$core$Maybe$Just(hoverDate);

      case 2:
        var date = status.a;
        return $elm$core$Maybe$Just(date);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$TimeTransformation$Util$LabelConfig = F4(function (value, position, isShown, isSelected) {
    return {
      lV: isSelected,
      q7: isShown,
      Cu: position,
      Fw: value
    };
  });
  var $author$project$Ui$TimeTransformation$Util$Left = 0;
  var $author$project$Ui$TimeTransformation$Util$Right = 1;
  var $author$project$Ui$TimeTransformation$Util$isFarEnoughOppositeAlignmentClose = F3(function (correction, a, b) {
    var diff = correction + A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, a, b);
    return _Utils_cmp(diff, -10) < 0 || diff > 0;
  });
  var $author$project$Ui$TimeTransformation$Util$isFarEnoughOppositeAlignmentFar = F3(function (correction, a, b) {
    var diff = correction + A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, a, b);
    return diff < 0 || diff > 10;
  });
  var $author$project$Ui$TimeTransformation$Util$isFarEnoughSameAlignment = F3(function (correction, a, b) {
    var diff = correction + $elm$core$Basics$abs(A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, a, b));
    return diff > 4;
  });
  var $author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther = F2(function (a, b) {
    var _v0 = _Utils_Tuple2(a.aK, b.aK);

    if (!_v0.a) {
      if (!_v0.b) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return A3($author$project$Ui$TimeTransformation$Util$isFarEnoughSameAlignment, -1, a.iL, b.iL);
      } else {
        var _v3 = _v0.a;
        var _v4 = _v0.b;
        return A3($author$project$Ui$TimeTransformation$Util$isFarEnoughOppositeAlignmentClose, 0, a.iL, b.iL);
      }
    } else {
      if (!_v0.b) {
        var _v5 = _v0.a;
        var _v6 = _v0.b;
        return A3($author$project$Ui$TimeTransformation$Util$isFarEnoughOppositeAlignmentFar, 0, a.iL, b.iL);
      } else {
        var _v7 = _v0.a;
        var _v8 = _v0.b;
        return A3($author$project$Ui$TimeTransformation$Util$isFarEnoughSameAlignment, -1, a.iL, b.iL);
      }
    }
  });

  var $author$project$Ui$TimeTransformation$InputGraph$Util$graphLabelConfig = function (_v0) {
    var date = _v0.iL;
    var graph = _v0.d4;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var _v1 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var graphStartPosix = _v1.a;
    var graphEndPosix = _v1.b;

    var _v2 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), $author$project$Types$SimpleDate$toDateString(date));

    var datePosix = _v2.a;
    var dateString = _v2.b;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    return _Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.xv)) ? _Utils_update(result, {
      Cu: 1
    }) : _Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.Eg)) ? result : _Utils_update(result, {
      lV: false,
      q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu)
    });
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$hoveringLabelConfig = function (_v0) {
    var date = _v0.iL;
    var hover = _v0.hB;
    var graph = _v0.d4;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);
    var isFarEnoughFromHover = F2(function (alignment, hoverAlignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date)
      }, {
        aK: hoverAlignment,
        iL: A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, hover)
      });
    });

    var _v1 = _Utils_Tuple3($author$project$Types$SimpleDate$toDateString(date), $author$project$Types$SimpleDate$toDateString(hover), $author$project$Types$SimpleDate$toDateString(graph.xv));

    var dateString = _v1.a;
    var hoverString = _v1.b;
    var graphEndString = _v1.c;
    var hoverLabelAlignment = A3($author$project$ElmFramework$Lib$Util$ifElse, 1, 0, _Utils_eq(hoverString, graphEndString));

    var _v2 = _Utils_Tuple3(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var datePosix = _v2.a;
    var graphStartPosix = _v2.b;
    var graphEndPosix = _v2.c;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    if (_Utils_eq(dateString, hoverString)) {
      return _Utils_update(result, {
        lV: true,
        Cu: hoverLabelAlignment
      });
    } else {
      if (_Utils_eq(dateString, graphEndString)) {
        var position = 1;
        return _Utils_update(result, {
          q7: A2(isFarEnoughFromHover, position, hoverLabelAlignment),
          Cu: position
        });
      } else {
        if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.Eg))) {
          return _Utils_update(result, {
            q7: A2(isFarEnoughFromHover, result.Cu, hoverLabelAlignment)
          });
        } else {
          return _Utils_update(result, {
            lV: false,
            q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu) && A2(isFarEnoughFromHover, result.Cu, hoverLabelAlignment)
          });
        }
      }
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$hoveringWithSelectionLabelConfig = function (_v0) {
    var date = _v0.iL;
    var hover = _v0.hB;
    var graph = _v0.d4;
    var selection = _v0.ib;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var _v1 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, hover), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selection));

    var hoverPosix = _v1.a;
    var selectionPosix = _v1.b;

    var _v2 = _Utils_Tuple2(A3($author$project$ElmFramework$Lib$Util$ifElse, 1, 0, _Utils_eq($author$project$Types$SimpleDate$toDateString(hover), $author$project$Types$SimpleDate$toDateString(graph.xv))), A3($author$project$ElmFramework$Lib$Util$ifElse, 1, 0, _Utils_eq($author$project$Types$SimpleDate$toDateString(selection), $author$project$Types$SimpleDate$toDateString(graph.xv))));

    var hoverLabelAlignment = _v2.a;
    var selectionLabelAlignment = _v2.b;

    var _v3 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var graphStartPosix = _v3.a;
    var graphEndPosix = _v3.b;

    var _v4 = _Utils_Tuple2($author$project$Types$SimpleDate$toDateString(date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date));

    var dateString = _v4.a;
    var datePosix = _v4.b;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    var isFarEnoughFromHover = F2(function (alignment, hoverAlignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: hoverAlignment,
        iL: hoverPosix
      });
    });
    var isFarEnoughFromSelection = F2(function (alignment, selectionAlignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: selectionAlignment,
        iL: selectionPosix
      });
    });

    if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(hover))) {
      return _Utils_update(result, {
        Cu: hoverLabelAlignment
      });
    } else {
      if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(selection))) {
        return _Utils_update(result, {
          q7: A2(isFarEnoughFromHover, selectionLabelAlignment, hoverLabelAlignment),
          Cu: selectionLabelAlignment
        });
      } else {
        if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.xv))) {
          var position = 1;
          return _Utils_update(result, {
            q7: A2(isFarEnoughFromHover, position, hoverLabelAlignment) && A2(isFarEnoughFromSelection, position, selectionLabelAlignment),
            Cu: position
          });
        } else {
          if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.Eg))) {
            return _Utils_update(result, {
              q7: A2(isFarEnoughFromHover, result.Cu, hoverLabelAlignment) && A2(isFarEnoughFromSelection, result.Cu, selectionLabelAlignment)
            });
          } else {
            return _Utils_update(result, {
              lV: false,
              q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu) && A2(isFarEnoughFromHover, result.Cu, hoverLabelAlignment) && A2(isFarEnoughFromSelection, result.Cu, selectionLabelAlignment)
            });
          }
        }
      }
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$withSelectionLabelConfig = function (_v0) {
    var date = _v0.iL;
    var graph = _v0.d4;
    var selection = _v0.ib;
    var selectionLabelAlignment = A3($author$project$ElmFramework$Lib$Util$ifElse, 1, 0, _Utils_eq($author$project$Types$SimpleDate$toDateString(selection), $author$project$Types$SimpleDate$toDateString(graph.xv)));
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var _v1 = _Utils_Tuple3($author$project$Types$SimpleDate$toDateString(date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selection));

    var dateString = _v1.a;
    var datePosix = _v1.b;
    var selectionPosix = _v1.c;
    var isFarEnoughFromSelection = F2(function (alignment, selectionAlignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: selectionAlignment,
        iL: selectionPosix
      });
    });

    var _v2 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var graphStartPosix = _v2.a;
    var graphEndPosix = _v2.b;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(selection))) {
      return _Utils_update(result, {
        Cu: selectionLabelAlignment
      });
    } else {
      if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.xv))) {
        var position = 1;
        return _Utils_update(result, {
          q7: A2(isFarEnoughFromSelection, position, selectionLabelAlignment),
          Cu: position
        });
      } else {
        if (_Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(graph.Eg))) {
          return _Utils_update(result, {
            q7: A2(isFarEnoughFromSelection, result.Cu, selectionLabelAlignment)
          });
        } else {
          return _Utils_update(result, {
            lV: false,
            q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu) && A2(isFarEnoughFromSelection, result.Cu, selectionLabelAlignment)
          });
        }
      }
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$toInputGraphLabelConfig = function (_v0) {
    var date = _v0.iL;
    var graph = _v0.d4;
    var selection = _v0.ib;
    var hover = _v0.hB;

    var _v1 = _Utils_Tuple2(selection, hover);

    if (!_v1.a.$) {
      if (!_v1.b.$) {
        var selectedTarget = _v1.a.a;
        var hoverTarget = _v1.b.a;
        return $author$project$Ui$TimeTransformation$InputGraph$Util$hoveringWithSelectionLabelConfig({
          iL: date,
          d4: graph,
          hB: hoverTarget,
          ib: selectedTarget
        });
      } else {
        var selectedTarget = _v1.a.a;
        var _v2 = _v1.b;
        return $author$project$Ui$TimeTransformation$InputGraph$Util$withSelectionLabelConfig({
          iL: date,
          d4: graph,
          ib: selectedTarget
        });
      }
    } else {
      if (!_v1.b.$) {
        var _v3 = _v1.a;
        var hoverTarget = _v1.b.a;
        return $author$project$Ui$TimeTransformation$InputGraph$Util$hoveringLabelConfig({
          iL: date,
          d4: graph,
          hB: hoverTarget
        });
      } else {
        var _v4 = _v1.a;
        var _v5 = _v1.b;
        return $author$project$Ui$TimeTransformation$InputGraph$Util$graphLabelConfig({
          iL: date,
          d4: graph
        });
      }
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$toSelectedDate = function (status) {
    switch (status.$) {
      case 1:
        var selectedDate = status.a.DO;
        return selectedDate;

      case 2:
        var date = status.a;
        return $elm$core$Maybe$Just(date);

      case 3:
        var date = status.a;
        return $elm$core$Maybe$Just(date);

      case 4:
        var date = status.a;
        return $elm$core$Maybe$Just(date);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$TimeTransformation$Util$currencyToSymbol = function (currency) {
    return '$';
  };

  var $author$project$Ui$TimeTransformation$InputGraph$DateItem$toLabelsHtml = function (config) {
    var state = config.Ej;
    var inputValue = config.yw;
    var colorClass = A3($author$project$ElmFramework$Lib$Util$ifElse, 'gray60', 'primary30', config.q4);

    var _v0 = function () {
      if (!inputValue.$) {
        var value = inputValue.a;
        var percent = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $JoshuaHall$elm_fraction$Fraction$multiply(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 100, 1)), $JoshuaHall$elm_fraction$Fraction$toFloat), A2($elm$core$Maybe$andThen, $JoshuaHall$elm_fraction$Fraction$divide(value), config.jW));
        return {
          nc: 'heading5Regular gray60',
          nd: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, function (s) {
            return s + '%';
          }, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale), $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString), $myrho$elm_round$Round$round(2)), percent)),
          ne: A2($elm$core$Maybe$withDefault, 0.0, percent),
          oG: colorClass,
          oH: $elm$core$String$concat(_List_fromArray([A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$Util$currencyToSymbol, config.bq)), $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(value))))]))
        };
      } else {
        var ratio = inputValue.a;
        var percent = $JoshuaHall$elm_fraction$Fraction$toFloat(A2($JoshuaHall$elm_fraction$Fraction$multiply, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 100, 1), ratio));
        return {
          nc: colorClass,
          nd: function (s) {
            return s + '%';
          }(A3($elm$core$Basics$composeL, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale, $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString, A2($myrho$elm_round$Round$round, 2, percent))),
          ne: percent,
          oG: 'heading5Regular gray60',
          oH: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (sum) {
            return $elm$core$String$concat(_List_fromArray([A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$Util$currencyToSymbol, config.bq)), $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(A2($JoshuaHall$elm_fraction$Fraction$multiply, ratio, sum)))))]));
          }, config.jW))
        };
      }
    }();

    var valueString = _v0.oH;
    var valueLabelClass = _v0.oG;
    var percentString = _v0.nd;
    var percentLabelClass = _v0.nc;
    var percentValue = _v0.ne;

    var percentLabel = function (percent) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('block lineHeightNormal'), $elm$html$Html$Attributes$class(percentLabelClass)]), _List_fromArray([$elm$html$Html$text(percent)]));
    };

    var wrapper = function (html) {
      var top = $elm$core$String$fromFloat(A3($elm$core$Basics$clamp, 0, 50, 100 - config.x7 * 100)) + '%';
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock absolute right top0 h4 z1 noPointerEvents'), A2($elm$html$Html$Attributes$style, 'top', top)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block heading5Bold left padLeft1h'), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, 'error10Color', 'primary30', percentValue > 100))]), html)]));
    };

    var valueLabel = function (value) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('block lineHeightNormal'), $elm$html$Html$Attributes$class(valueLabelClass)]), _List_fromArray([$elm$html$Html$text(value)]));
    };

    var _v2 = _Utils_Tuple2(valueString, percentString);

    if (_v2.a === '') {
      if (_v2.b === '') {
        return _List_Nil;
      } else {
        var percentLabelString = _v2.b;
        return _List_fromArray([wrapper(_List_fromArray([percentLabel(percentLabelString)]))]);
      }
    } else {
      if (_v2.b === '') {
        var valueLabelString = _v2.a;
        return config.jP ? _List_fromArray([wrapper(_List_fromArray([valueLabel(valueLabelString)]))]) : _List_Nil;
      } else {
        var valueLabelString = _v2.a;
        var percentLabelString = _v2.b;
        return config.jP ? _List_fromArray([wrapper(_List_fromArray([valueLabel(valueLabelString), percentLabel(percentLabelString)]))]) : _List_fromArray([wrapper(_List_fromArray([percentLabel(percentLabelString)]))]);
      }
    }
  };

  var $elm$html$Html$Events$onMouseEnter = function (msg) {
    return A2($elm$html$Html$Events$on, 'mouseenter', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$Ui$TimeTransformation$Util$onPrimaryButtonMouseDownWithOptions = F2(function (_v0, msg) {
    var stopPropagation = _v0.tH;
    var preventDefault = _v0.sJ;
    return A2($elm$html$Html$Events$custom, 'mousedown', A2($elm$json$Json$Decode$map, function (_v2) {
      return {
        zu: msg,
        sJ: preventDefault,
        tH: stopPropagation
      };
    }, A2($elm$json$Json$Decode$andThen, function (button) {
      if (!button) {
        return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
      } else {
        return $elm$json$Json$Decode$fail('not primary');
      }
    }, A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int))));
  });

  var $author$project$Ui$TimeTransformation$Util$onPrimaryButtonMouseDown = function (msg) {
    return A2($author$project$Ui$TimeTransformation$Util$onPrimaryButtonMouseDownWithOptions, {
      sJ: false,
      tH: false
    }, msg);
  };

  var $author$project$Types$SimpleDate$toDateStringLong = function (_v0) {
    var year = _v0.FP;
    var month = _v0.zG;
    var day = _v0.wz;
    var yearString = $elm$core$String$fromInt(year);

    var monthString = function () {
      switch (month) {
        case 0:
          return 'Jan';

        case 1:
          return 'Feb';

        case 2:
          return 'Mar';

        case 3:
          return 'Apr';

        case 4:
          return 'May';

        case 5:
          return 'Jun';

        case 6:
          return 'Jul';

        case 7:
          return 'Aug';

        case 8:
          return 'Sep';

        case 9:
          return 'Oct';

        case 10:
          return 'Nov';

        default:
          return 'Dec';
      }
    }();

    var dayString = A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(day));
    return A2($elm$core$String$join, '-', _List_fromArray([dayString, monthString, yearString]));
  };

  var $author$project$Ui$TimeTransformation$DateItem$viewDateItem = F2(function (extraHtml, config) {
    var labelConfig = config.y2;

    var labelPositionClassesString = function () {
      var _v1 = labelConfig.Cu;

      if (!_v1) {
        return 'right1';
      } else {
        return 'left1';
      }
    }();

    var _v0 = labelConfig.q7 ? labelConfig.lV ? _Utils_Tuple3('primary30', 'item-primary', config.tY.DT) : labelConfig.Fw.wz === 1 ? _Utils_Tuple3('gray20', 'item-gray', config.tY.yZ) : _Utils_Tuple3('o0 noPointerEvents', 'none', '') : _Utils_Tuple3('o0 noPointerEvents', 'none', '');

    var labelColorClassString = _v0.a;
    var underlineType = _v0.b;
    var underlineColorClass = _v0.c;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block fullHeight relative'), $elm$html$Html$Attributes$class(config.kG), A2($elm$html$Html$Attributes$style, 'cursor', A3($author$project$ElmFramework$Lib$Util$ifElse, 'col-resize', 'pointer', config.yL)), $author$project$Ui$TimeTransformation$Util$onPrimaryButtonMouseDown(config.Ba), $elm$html$Html$Events$onMouseEnter(config.Bb)]), A2($elm$core$List$cons, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn justifyEnd fullHeight padBottom1'), A2($elm$html$Html$Attributes$attribute, 'underlineType', underlineType), $elm$html$Html$Attributes$class(underlineColorClass)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block fullWidth minH1 radius1'), $elm$html$Html$Attributes$class(config.vZ), A2($elm$html$Html$Attributes$style, 'height', $elm$core$String$concat(_List_fromArray([$elm$core$String$fromFloat(config.x7 * 100), '%'])))]), _List_Nil)])), labelConfig.q7 ? A2($elm$core$List$cons, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block heading5Bold absolute bottom-3 whiteSpaceNoWrap'), $elm$html$Html$Attributes$class(labelPositionClassesString), $elm$html$Html$Attributes$class(labelColorClassString)]), _List_fromArray([$elm$html$Html$text($author$project$Types$SimpleDate$toDateStringLong(labelConfig.Fw))])), extraHtml) : extraHtml));
  });
  var $author$project$Ui$TimeTransformation$InputGraph$DateItem$viewDateItem = F2(function (inputLabelsCfg, config) {
    var state = inputLabelsCfg.Ej;
    var sumOfValuesInSelectedInterval = inputLabelsCfg.jW;
    var showValueLabel = inputLabelsCfg.jP;
    var labels = F2(function (input, isOutput) {
      return $author$project$Ui$TimeTransformation$InputGraph$DateItem$toLabelsHtml({
        bq: inputLabelsCfg.bq,
        x7: config.x7,
        yw: input,
        q4: isOutput,
        jP: showValueLabel,
        Ej: state,
        jW: sumOfValuesInSelectedInterval
      });
    });

    var defaultLabelBehaviour = function () {
      var _v3 = inputLabelsCfg.Fw;

      if (!_v3.$) {
        var valueType = _v3.a;

        switch (valueType.$) {
          case 0:
            return _List_Nil;

          case 1:
            var currencyOrRatioAmount = valueType.a;
            return A2(labels, currencyOrRatioAmount, false);

          default:
            var currencyOrRatioAmount = valueType.a;
            return A2(labels, currencyOrRatioAmount, true);
        }
      } else {
        return _List_Nil;
      }
    }();

    return A2($author$project$Ui$TimeTransformation$DateItem$viewDateItem, function () {
      var _v0 = state.yv;

      switch (_v0.$) {
        case 0:
          return defaultLabelBehaviour;

        case 1:
          var selectedDate = _v0.a.DO;

          if (!selectedDate.$) {
            var date = selectedDate.a;
            return _Utils_eq($author$project$Types$SimpleDate$toDateString(config.y2.Fw), $author$project$Types$SimpleDate$toDateString(date)) ? _List_Nil : defaultLabelBehaviour;
          } else {
            return defaultLabelBehaviour;
          }

        case 2:
          return defaultLabelBehaviour;

        case 3:
          var simpleDate = _v0.a;
          var maybeInputValue = _v0.b;

          if (_Utils_eq($author$project$Types$SimpleDate$toDateString(config.y2.Fw), $author$project$Types$SimpleDate$toDateString(simpleDate))) {
            if (!maybeInputValue.$) {
              var movingInputValue = maybeInputValue.a;
              return A2(labels, movingInputValue, false);
            } else {
              return _List_Nil;
            }
          } else {
            return defaultLabelBehaviour;
          }

        default:
          var simpleDate = _v0.a;
          return _Utils_eq($author$project$Types$SimpleDate$toDateString(config.y2.Fw), $author$project$Types$SimpleDate$toDateString(simpleDate)) ? _List_Nil : defaultLabelBehaviour;
      }
    }(), config);
  });
  var $author$project$Ui$TimeTransformation$InputGraph$DateItem$viewKeyedDateItem = F2(function (inputLabelsConfig, config) {
    var labelConfig = config.y2;
    return _Utils_Tuple2($author$project$Types$SimpleDate$toDateString(labelConfig.Fw), A2($author$project$Ui$TimeTransformation$InputGraph$DateItem$viewDateItem, inputLabelsConfig, config));
  });

  var $author$project$Ui$TimeTransformation$InputGraph$View$mapToHtml = function (config) {
    var shouldShowSelectionGraphValues = $elm_community$maybe_extra$Maybe$Extra$isNothing(config.jW) && $author$project$Ui$TimeTransformation$InputGraph$Util$isIdle(config.Ej.yv) && $turboMaCk$any_dict$Dict$Any$isEmpty(config.Ej.yx);

    var renderValueDict = function () {
      if (shouldShowSelectionGraphValues) {
        return A2($turboMaCk$any_dict$Dict$Any$map, F2(function (_v9, v) {
          return $author$project$Ui$TimeTransformation$InputGraph$Util$SelectionValue($author$project$Types$TimeTransformationBackend$CurrencyValue(v));
        }), config.uh);
      } else {
        var outputValues = A2($turboMaCk$any_dict$Dict$Any$map, F2(function (_v11, v) {
          return $author$project$Ui$TimeTransformation$InputGraph$Util$OutputValue($author$project$Types$TimeTransformationBackend$CurrencyValue(v));
        }), config.Ck);
        var inputValues = A2($turboMaCk$any_dict$Dict$Any$map, F2(function (_v10, v) {
          return $author$project$Ui$TimeTransformation$InputGraph$Util$InputValue(v);
        }), config.Ej.yx);
        return A2($turboMaCk$any_dict$Dict$Any$union, inputValues, outputValues);
      }
    }();

    var maybeMaxVal = shouldShowSelectionGraphValues ? function (maxResult) {
      return A2($JoshuaHall$elm_fraction$Fraction$equal, maxResult, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(maxResult);
    }(function (maxResult) {
      return A2($elm$core$Maybe$withDefault, maxResult, A2($elm$core$Maybe$map, $author$project$Types$Fraction$max(maxResult), config.jW));
    }(A3($turboMaCk$any_dict$Dict$Any$foldl, F3(function (_v8, a, b) {
      return A2($author$project$Types$Fraction$max, a, b);
    }), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), config.uh))) : config.jW;

    var toHeightPercent = function (maybeValue) {
      if (!maybeValue.$) {
        var value = maybeValue.a;

        if (!value.$) {
          var v = value.a;
          return A2($elm$core$Maybe$withDefault, 0.0, A2($elm$core$Maybe$map, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$Ui$TimeTransformation$Util$calculateHeightPercent, v), maybeMaxVal));
        } else {
          var ratio = value.a;
          return $JoshuaHall$elm_fraction$Fraction$toFloat(ratio);
        }
      } else {
        return 0.0;
      }
    };

    var days = 1 + A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, config.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, config.xv));
    var getFilteredListByInterval = F2(function (mapper, anyDict) {
      return A2($elm$core$List$indexedMap, F2(function (index, posix) {
        var date = A2($author$project$Types$SimpleDate$fromPosix, $elm$time$Time$utc, A4($justinmimbs$time_extra$Time$Extra$add, 11, index, $elm$time$Time$utc, posix));
        return _Utils_Tuple2(date, A2($elm$core$Maybe$map, mapper, A2($turboMaCk$any_dict$Dict$Any$get, date, anyDict)));
      }), A2($elm$core$List$repeat, days, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, config.Eg)));
    });
    var renderValues = A2(getFilteredListByInterval, $elm$core$Basics$identity, function () {
      var _v4 = config.Ej.yv;

      if (_v4.$ === 3) {
        var simpleDate = _v4.a;
        var maybeInputValue = _v4.b;

        if (!maybeInputValue.$) {
          var inputValue = maybeInputValue.a;
          return A3($turboMaCk$any_dict$Dict$Any$insert, simpleDate, $author$project$Ui$TimeTransformation$InputGraph$Util$InputValue(inputValue), renderValueDict);
        } else {
          return renderValueDict;
        }
      } else {
        return renderValueDict;
      }
    }());

    var _v0 = _Utils_Tuple2($author$project$Ui$TimeTransformation$InputGraph$Util$toHoverTarget(config.Ej.yv), $author$project$Ui$TimeTransformation$InputGraph$Util$toSelectedDate(config.Ej.yv));

    var hoverTarget = _v0.a;
    var selectionDate = _v0.b;
    var getColorClass = F2(function (date, maybeValueType) {
      if (_Utils_eq(selectionDate, $elm$core$Maybe$Just(date))) {
        return config.tY.qJ;
      } else {
        if (_Utils_eq(hoverTarget, $elm$core$Maybe$Just(date))) {
          return config.tY.qJ;
        } else {
          if (!maybeValueType.$) {
            switch (maybeValueType.a.$) {
              case 0:
                return config.tY.o5;

              case 1:
                return config.tY.vb;

              default:
                return config.tY.o5;
            }
          } else {
            return config.tY.u9;
          }
        }
      }
    });

    var labelConfigFor = function (date) {
      return $author$project$Ui$TimeTransformation$InputGraph$Util$toInputGraphLabelConfig({
        iL: date,
        d4: {
          xv: config.xv,
          Eg: config.Eg
        },
        hB: hoverTarget,
        ib: selectionDate
      });
    };

    return A2($elm$core$List$map, function (_v1) {
      var date = _v1.a;
      var maybeValueType = _v1.b;

      var _v2 = _Utils_Tuple2(A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$InputGraph$Util$extractValueFromValueType, maybeValueType), A2($elm$core$Maybe$andThen, $author$project$Ui$TimeTransformation$InputGraph$Util$extractInputValueFromValueType, maybeValueType));

      var maybeValueForHeight = _v2.a;
      var maybeValueForMsg = _v2.b;
      return A2($author$project$Ui$TimeTransformation$InputGraph$DateItem$viewKeyedDateItem, {
        bq: config.bq,
        jP: $elm_community$maybe_extra$Maybe$Extra$isJust(config.qV),
        Ej: config.Ej,
        jW: config.jW,
        Fw: maybeValueType
      }, {
        kG: 'w2 padLeft0h padRight0h',
        vZ: A2(getColorClass, date, maybeValueType),
        x7: toHeightPercent(maybeValueForHeight),
        yL: config.q6,
        y2: labelConfigFor(date),
        Ba: config.Ba(_Utils_Tuple2(date, maybeValueForMsg)),
        Bb: config.Bb(_Utils_Tuple2(date, maybeValueForMsg)),
        tY: config.tY
      });
    }, renderValues);
  };

  var $author$project$ElmFramework$Lib$Ui$EventFull$onDocumentMouseUpEmitter = function (msg) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'onDocumentMouseUp', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$ElmFramework$Lib$Ui$EventFull$onDocumentMouseUp = function (msg) {
    return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-document-mouse-up', 'true'), $author$project$ElmFramework$Lib$Ui$EventFull$onDocumentMouseUpEmitter(msg)]);
  };

  var $elm$html$Html$Events$onMouseLeave = function (msg) {
    return A2($elm$html$Html$Events$on, 'mouseleave', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$Types$Currency$toCurrencyString = function (currency) {
    return 'USD';
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Util$toMovingItem = function (status) {
    switch (status.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        return $elm$core$Maybe$Nothing;

      case 2:
        return $elm$core$Maybe$Nothing;

      case 3:
        var simpleDate = status.a;
        var maybeInputValue = status.b;
        return $elm$core$Maybe$Just(_Utils_Tuple2(simpleDate, maybeInputValue));

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$TimeTransformation$InputGraph$Msg$RatioInputChanged = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$TimeTransformation$InputGraph$Msg$ValueInputChanged = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$TimeTransformation$InputGraph$Util$onMouseUpNoBubble = function (msg) {
    return A2($elm$html$Html$Events$stopPropagationOn, 'mouseup', $elm$json$Json$Decode$succeed(_Utils_Tuple2(msg, true)));
  };

  var $author$project$Ui$TimeTransformation$InputGraph$View$toInputsHtml = function (config) {
    var parentTag = config.ss;
    var state = config.Ej;
    var date = config.iL;

    var currencyToPaddingClass = function (currency) {
      return 'padLeft2h';
    };

    var _v0 = function () {
      var _v1 = A2($turboMaCk$any_dict$Dict$Any$get, date, state.yx);

      if (!_v1.$) {
        if (!_v1.a.$) {
          var value = _v1.a.a;
          var percentValue = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $JoshuaHall$elm_fraction$Fraction$multiply(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 100, 1)), $JoshuaHall$elm_fraction$Fraction$toFloat), A2($elm$core$Maybe$andThen, $JoshuaHall$elm_fraction$Fraction$divide(value), config.jW));
          return _Utils_Tuple3(state.iY, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString, $myrho$elm_round$Round$round(2)), percentValue)), A2($elm$core$Maybe$withDefault, 0.0, percentValue));
        } else {
          var ratio = _v1.a.a;
          return _Utils_Tuple3(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString, $myrho$elm_round$Round$round(2)), $JoshuaHall$elm_fraction$Fraction$toFloat), $JoshuaHall$elm_fraction$Fraction$multiply(ratio)), config.jW)), state.iY, 100.0 * $JoshuaHall$elm_fraction$Fraction$toFloat(ratio));
        }
      } else {
        return _Utils_Tuple3(state.iY, state.iY, 0.0);
      }
    }();

    var valueInputString = _v0.a;
    var percentInputString = _v0.b;
    var percentInputValue = _v0.c;
    return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock absolute right top0 h10 z1 noPointerEvents'), A2($elm$html$Html$Attributes$style, 'left', '-15rem'), A2($elm$html$Html$Attributes$style, 'width', '30rem')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock sticky right0')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block yesPointerEvents gapColumn1'), $elm$html$Html$Events$onMouseEnter(parentTag(A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$Ui$TimeTransformation$Msg$InputGraphMsg($author$project$Ui$TimeTransformation$InputGraph$Msg$HoverEnded), $author$project$Ui$TimeTransformation$Msg$NoOp, config.lT)))]), _Utils_ap(config.n6 ? _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$Ui$TimeTransformation$InputGraph$Util$onMouseUpNoBubble(parentTag($author$project$Ui$TimeTransformation$Msg$NoOp))]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Input$affixedInput({
      uB: 'padLeft1q',
      uC: 'flexRow flexAlignCenter padTop0h padBottom0h',
      uD: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Ui$TimeTransformation$Util$currencyToSymbol, config.bq)),
      kj: true,
      kG: $elm$core$String$concat(_List_fromArray(['borderSolid borderWidth1 heading5Bold radius0 ', A3($author$project$ElmFramework$Lib$Util$ifElse, 'secondary50 secondary50Border', 'gray40 focusWithinPrimary30 gray20Border focusWithinSecondary0Border', percentInputValue > 100)])),
      F: 'input-graph-value-input',
      ys: $elm$core$String$concat(_List_fromArray([A2($elm$core$Maybe$withDefault, 'padLeft1q', A2($elm$core$Maybe$map, currencyToPaddingClass, config.bq)), ' padTop0h padBottom0h heading5Bold placeholderFix hidePlaceholderOnFocus'])),
      yM: false,
      yT: true,
      yW: false,
      zp: '13rem',
      zB: '13rem',
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, parentTag, $author$project$Ui$TimeTransformation$Msg$InputGraphMsg), $author$project$Ui$TimeTransformation$InputGraph$Msg$ValueInputChanged(date)),
      e3: 'Cash amount',
      Fw: valueInputString
    })]))]) : _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$author$project$Ui$TimeTransformation$InputGraph$Util$onMouseUpNoBubble(parentTag($author$project$Ui$TimeTransformation$Msg$NoOp))]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Input$affixedInput({
      uB: 'padLeft1q',
      uC: 'flexRow flexAlignCenter padTop0h padBottom0h',
      uD: '%',
      kj: true,
      kG: $elm$core$String$concat(_List_fromArray(['borderSolid borderWidth1 heading5Bold radius0 ', A3($author$project$ElmFramework$Lib$Util$ifElse, 'secondary50 secondary50Border', 'gray40 focusWithinPrimary30 gray20Border focusWithinSecondary0Border', percentInputValue > 100)])),
      F: 'input-graph-percent-input',
      ys: 'padLeft1q padTop0h padBottom0h heading5Bold hidePlaceholderOnFocus',
      yM: false,
      yT: false,
      yW: false,
      zp: '13rem',
      zB: '13rem',
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, parentTag, $author$project$Ui$TimeTransformation$Msg$InputGraphMsg), $author$project$Ui$TimeTransformation$InputGraph$Msg$RatioInputChanged(date)),
      e3: 'Percentage',
      Fw: percentInputString
    })]))])))]))]))]);
  };

  var $author$project$Ui$TimeTransformation$InputGraph$View$viewStickyInputs = function (cfg) {
    var parentTag = cfg.ss;
    var state = cfg.Ej;

    var _v0 = _Utils_Tuple2(_List_fromArray([$elm$html$Html$Attributes$class('o0')]), _List_Nil);

    var defaultAttributes = _v0.a;
    var defaultHtml = _v0.b;

    var _v1 = function () {
      var _v2 = state.yv;

      switch (_v2.$) {
        case 0:
          return _Utils_Tuple2(defaultAttributes, defaultHtml);

        case 1:
          var selectedDate = _v2.a.DO;

          if (!selectedDate.$) {
            var date = selectedDate.a;
            var positionLeft = A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, cfg.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date));
            return _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(positionLeft * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', '1rem'), A2($elm$html$Html$Attributes$attribute, 'underlineType', 'selection-primary'), $elm$html$Html$Attributes$class(cfg.tY.tp), $elm$html$Html$Attributes$class(cfg.tY.DT)]), $author$project$Ui$TimeTransformation$InputGraph$View$toInputsHtml({
              bq: cfg.bq,
              iL: date,
              lT: true,
              ss: parentTag,
              n6: cfg.n5,
              Ej: state,
              jW: cfg.jW
            }));
          } else {
            return _Utils_Tuple2(defaultAttributes, defaultHtml);
          }

        case 2:
          return _Utils_Tuple2(defaultAttributes, defaultHtml);

        case 3:
          return _Utils_Tuple2(defaultAttributes, defaultHtml);

        default:
          var date = _v2.a;
          var positionLeft = A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, cfg.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date));
          return _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(positionLeft * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', '1rem'), A2($elm$html$Html$Attributes$attribute, 'underlineType', 'selection-primary'), $elm$html$Html$Attributes$class(cfg.tY.tp), $elm$html$Html$Attributes$class(cfg.tY.DT)]), $author$project$Ui$TimeTransformation$InputGraph$View$toInputsHtml({
            bq: cfg.bq,
            iL: date,
            lT: false,
            ss: parentTag,
            n6: cfg.n5,
            Ej: state,
            jW: cfg.jW
          }));
      }
    }();

    var attributes = _v1.a;
    var html = _v1.b;
    return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('inlineBlock absolute top0 bottom1 w0 radius0'), attributes), html);
  };

  var $author$project$Ui$TimeTransformation$InputGraph$View$inputGraph_ = function (parentTag) {
    return function (showPercentageBox) {
      return function (classes) {
        return function (graphStartDate) {
          return function (graphEndDate) {
            return function (maybeCurrency) {
              return function (state) {
                return function (valuesDict) {
                  return function (outputValuesDict) {
                    return function (theme_) {
                      var theme = $author$project$Ui$TimeTransformation$Util$getThemeValues(theme_);
                      var sumOfValuesInSelectedInterval = A2($author$project$Ui$TimeTransformation$InputGraph$Util$getSumOfValuesInSelectedInterval, state, valuesDict);
                      var maybeMovingItem = $author$project$Ui$TimeTransformation$InputGraph$Util$toMovingItem(state.yv);
                      var isCurrentlySelecting = $author$project$Ui$TimeTransformation$InputGraph$Util$isSelecting(state.yv);

                      var hoverAttributes = function () {
                        var _v8 = $author$project$Ui$TimeTransformation$InputGraph$Util$toHoverTarget(state.yv);

                        if (!_v8.$) {
                          var hoverDate = _v8.a;

                          var hoverPositionLeft = function (_v9) {
                            return A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graphStartDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, hoverDate));
                          };

                          return _List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(hoverPositionLeft(0) * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', '1rem'), $elm$html$Html$Attributes$class(theme.ye)]);
                        } else {
                          return _List_Nil;
                        }
                      }();

                      var _v0 = A2($elm$core$Tuple$mapSecond, $elm$core$Maybe$withDefault(0.0), function () {
                        var _v1 = A2($author$project$Ui$TimeTransformation$InputGraph$Util$getSumOfInputValues, state, valuesDict);

                        if (!_v1.$) {
                          var inputValueSum = _v1.a;

                          var draggingValue = function () {
                            var _v2 = state.yv;

                            if (_v2.$ === 3 && !_v2.b.$) {
                              var inputValue = _v2.b.a;

                              if (!inputValue.$) {
                                var value = inputValue.a;
                                return $elm$core$Maybe$Just(value);
                              } else {
                                var ratio = inputValue.a;
                                return A2($elm$core$Maybe$map, $JoshuaHall$elm_fraction$Fraction$multiply(ratio), sumOfValuesInSelectedInterval);
                              }
                            } else {
                              return $elm$core$Maybe$Nothing;
                            }
                          }();

                          var sumOfInputValues = A2($JoshuaHall$elm_fraction$Fraction$add, inputValueSum, A2($elm$core$Maybe$withDefault, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), draggingValue));
                          var ratioOfInputToValues = A2($elm$core$Maybe$andThen, $JoshuaHall$elm_fraction$Fraction$divide(sumOfInputValues), sumOfValuesInSelectedInterval);
                          return _Utils_Tuple2($elm$core$Maybe$Just($JoshuaHall$elm_fraction$Fraction$toFloat(sumOfInputValues)), A2($elm$core$Maybe$map, $JoshuaHall$elm_fraction$Fraction$toFloat, ratioOfInputToValues));
                        } else {
                          var ratioSum = _v1.a;

                          var draggingValue = function () {
                            var _v4 = state.yv;

                            if (_v4.$ === 3 && !_v4.b.$) {
                              var inputValue = _v4.b.a;

                              if (!inputValue.$) {
                                return A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1);
                              } else {
                                var ratio = inputValue.a;
                                return ratio;
                              }
                            } else {
                              return A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1);
                            }
                          }();

                          return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just($JoshuaHall$elm_fraction$Fraction$toFloat(A2($JoshuaHall$elm_fraction$Fraction$add, ratioSum, draggingValue))));
                        }
                      }());

                      var inputValueTotalForSelectionInterval = _v0.a;
                      var percentageOfSelectionIntervalTotal = _v0.b;
                      var fillDistance = (A2($elm$core$Basics$min, 1.0, percentageOfSelectionIntervalTotal) - 1.0) * 100;
                      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(theme.u5), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow heading5Regular')]), function () {
                        if (!showPercentageBox) {
                          return _List_fromArray([$author$project$ElmFramework$Lib$Util$noOpEl]);
                        } else {
                          var total = A2($elm$core$Maybe$withDefault, 0.0, inputValueTotalForSelectionInterval);
                          var isError = percentageOfSelectionIntervalTotal > 1;
                          return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock padTop0h padBottom0h marRight2'), $elm$html$Html$Attributes$class(theme.E9)]), _List_fromArray([$elm$html$Html$text('Amount Allocated:')])), A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('relative verticalAlignTop noOverflow inlineBlock padLeft1 padRight1 padTop0h padBottom0h radius0'), isError ? _List_fromArray([$elm$html$Html$Attributes$class('secondary50 secondary51Back')]) : _List_fromArray([$elm$html$Html$Attributes$class(theme.E8), $elm$html$Html$Attributes$class(theme.Fa)])), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread secondary11Back radius0'), A2($elm$html$Html$Attributes$style, 'transform', $elm$core$String$concat(_List_fromArray(['translateX(', $elm$core$String$fromFloat(A3($author$project$ElmFramework$Lib$Util$ifElse, -100, fillDistance, isError)), '%)'])))]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative inlineBlock heading5Bold marRight0h')]), _List_fromArray([$elm$html$Html$text($author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString(A2($myrho$elm_round$Round$round, 2, total))))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative inlineBlock')]), _List_fromArray([$elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Types$Currency$toCurrencyString, maybeCurrency)))]))]))]))]);
                        }
                      }()), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop4 overflowXAuto'), $elm$html$Html$Attributes$class(theme.DD)]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFullKeyed, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onDocumentMouseUp(parentTag(function () {
                        var _v6 = state.yv;

                        switch (_v6.$) {
                          case 0:
                            return $author$project$Ui$TimeTransformation$Msg$NoOp;

                          case 1:
                            return $author$project$Ui$TimeTransformation$Msg$NoOp;

                          case 2:
                            return $author$project$Ui$TimeTransformation$Msg$InputGraphMsg($author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetPressEnded(valuesDict));

                          case 3:
                            return $author$project$Ui$TimeTransformation$Msg$InputGraphMsg($author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetPressEnded(valuesDict));

                          default:
                            return $author$project$Ui$TimeTransformation$Msg$InputGraphMsg($author$project$Ui$TimeTransformation$InputGraph$Msg$SelectionEnded);
                        }
                      }()))]), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('relative inlineFlexRow h16 marLeft10 padRight15 marBottom6 borderBottomHairline gray10Border'), A2($elm$core$List$cons, $elm$html$Html$Events$onMouseLeave(parentTag(function () {
                        var _v7 = state.yv;

                        switch (_v7.$) {
                          case 0:
                            return $author$project$Ui$TimeTransformation$Msg$NoOp;

                          case 1:
                            return $author$project$Ui$TimeTransformation$Msg$InputGraphMsg($author$project$Ui$TimeTransformation$InputGraph$Msg$HoverEnded);

                          case 2:
                            return $author$project$Ui$TimeTransformation$Msg$InputGraphMsg($author$project$Ui$TimeTransformation$InputGraph$Msg$SelectionEnded);

                          case 3:
                            return $author$project$Ui$TimeTransformation$Msg$NoOp;

                          default:
                            return $author$project$Ui$TimeTransformation$Msg$NoOp;
                        }
                      }())), A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([A2($elm$html$Html$Attributes$style, 'cursor', 'col-resize')]), _List_Nil, isCurrentlySelecting))), A2($elm$core$List$cons, _Utils_Tuple2('input-graph-hover-element', A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('inlineBlock absolute top0 bottom1 w0 radius0'), hoverAttributes), _List_Nil)), A2($elm$core$List$cons, _Utils_Tuple2('input-graph-sticky-inputs', A2($elm$html$Html$Lazy$lazy, $author$project$Ui$TimeTransformation$InputGraph$View$viewStickyInputs, {
                        bq: maybeCurrency,
                        xv: graphEndDate,
                        ss: parentTag,
                        n5: $elm_community$maybe_extra$Maybe$Extra$isJust(inputValueTotalForSelectionInterval),
                        Eg: graphStartDate,
                        Ej: state,
                        jW: sumOfValuesInSelectedInterval,
                        tY: theme
                      })), $author$project$Ui$TimeTransformation$InputGraph$View$mapToHtml({
                        bq: maybeCurrency,
                        xv: graphEndDate,
                        qV: inputValueTotalForSelectionInterval,
                        q6: isCurrentlySelecting,
                        zH: maybeMovingItem,
                        Ba: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, parentTag, $author$project$Ui$TimeTransformation$Msg$InputGraphMsg), $author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetPressed), $elm$core$Tuple$first),
                        Bb: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, parentTag, $author$project$Ui$TimeTransformation$Msg$InputGraphMsg), $author$project$Ui$TimeTransformation$InputGraph$Msg$AssignmentTargetChanged), $elm$core$Tuple$first),
                        Ck: outputValuesDict,
                        Eg: graphStartDate,
                        Ej: state,
                        jW: sumOfValuesInSelectedInterval,
                        tY: theme,
                        uh: valuesDict
                      }))))]))]));
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };

  var $elm$virtual_dom$VirtualDom$lazy8 = _VirtualDom_lazy8;
  var $elm$html$Html$Lazy$lazy8 = $elm$virtual_dom$VirtualDom$lazy8;

  var $author$project$Ui$TimeTransformation$InputGraph$View$inputGraph = function (cfg) {
    return A9($elm$html$Html$Lazy$lazy8, A2($author$project$Ui$TimeTransformation$InputGraph$View$inputGraph_, cfg.ss, cfg.D8), cfg.vV, cfg.Eg, cfg.xv, cfg.bq, cfg.Ej, cfg.uh, cfg.Ck, cfg.tY);
  };

  var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
  var $elm$html$Html$Lazy$lazy7 = $elm$virtual_dom$VirtualDom$lazy7;
  var $author$project$Ui$TimeTransformation$SelectionGraph$Msg$HoverEnded = {
    $: 3
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Msg$SelectionChanged = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Msg$SelectionEnded = {
    $: 2
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Msg$SelectionStarted = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$SlideSelectMultiple$PrimaryDarkSelectWhiteBackShort = 1;
  var $author$project$Ui$TimeTransformation$SelectionGraph$View$cashAccrualPattern = F2(function (selected, onPick) {
    return $author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
      vV: 'flex1',
      v_: $elm$core$Maybe$Just(1),
      wm: selected,
      hH: _List_fromArray([_Utils_Tuple2(1, 'Cash'), _Utils_Tuple2(0, 'Accrual')]),
      BE: onPick,
      BP: ''
    });
  });

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$isHovering = function (status) {
    if (status.$ === 1) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$graphLabelConfig = function (_v0) {
    var date = _v0.iL;
    var graph = _v0.d4;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var _v1 = _Utils_Tuple3(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var datePosix = _v1.a;
    var graphStartPosix = _v1.b;
    var graphEndPosix = _v1.c;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    var _v2 = _Utils_Tuple3($elm$time$Time$posixToMillis(datePosix), $elm$time$Time$posixToMillis(graphStartPosix), $elm$time$Time$posixToMillis(graphEndPosix));

    var dateMillis = _v2.a;
    var graphStartMillis = _v2.b;
    var graphEndMillis = _v2.c;
    return _Utils_eq(dateMillis, graphEndMillis) ? _Utils_update(result, {
      Cu: 1
    }) : _Utils_eq(dateMillis, graphStartMillis) ? result : _Utils_update(result, {
      lV: false,
      q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu)
    });
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$hoveringLabelConfig = function (_v0) {
    var date = _v0.iL;
    var hover = _v0.hB;
    var graph = _v0.d4;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var isFarEnoughFromHover = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date)
      }, {
        aK: 0,
        iL: A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, hover)
      });
    };

    var dateString = $author$project$Types$SimpleDate$toDateString(date);

    var _v1 = _Utils_Tuple3(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var datePosix = _v1.a;
    var graphStartPosix = _v1.b;
    var graphEndPosix = _v1.c;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    var _v2 = _Utils_Tuple3($elm$time$Time$posixToMillis(datePosix), $elm$time$Time$posixToMillis(graphStartPosix), $elm$time$Time$posixToMillis(graphEndPosix));

    var dateMillis = _v2.a;
    var graphStartMillis = _v2.b;
    var graphEndMillis = _v2.c;
    return _Utils_eq(dateString, $author$project$Types$SimpleDate$toDateString(hover)) ? result : _Utils_eq(dateMillis, graphEndMillis) ? _Utils_update(result, {
      Cu: 1
    }) : _Utils_eq(dateMillis, graphStartMillis) ? _Utils_update(result, {
      q7: isFarEnoughFromHover(result.Cu)
    }) : _Utils_update(result, {
      lV: false,
      q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu) && isFarEnoughFromHover(result.Cu)
    });
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$hoveringWithSelectionLabelConfig = function (_v0) {
    var date = _v0.iL;
    var hover = _v0.hB;
    var graph = _v0.d4;
    var selection = _v0.ib;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var _v1 = _Utils_Tuple3(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var datePosix = _v1.a;
    var graphStartPosix = _v1.b;
    var graphEndPosix = _v1.c;

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    var _v2 = _Utils_Tuple2($elm$time$Time$posixToMillis(graphStartPosix), $elm$time$Time$posixToMillis(graphEndPosix));

    var graphStartMillis = _v2.a;
    var graphEndMillis = _v2.b;

    var _v3 = _Utils_Tuple3(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, hover), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selection.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selection.xv));

    var hoverPosix = _v3.a;
    var startPosix = _v3.b;
    var endPosix = _v3.c;
    var isFarEnoughFromHover = F2(function (alignment, hoverAlignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: hoverAlignment,
        iL: hoverPosix
      });
    });

    var _v4 = _Utils_Tuple3($elm$time$Time$posixToMillis(hoverPosix), $elm$time$Time$posixToMillis(startPosix), $elm$time$Time$posixToMillis(endPosix));

    var hoverMillis = _v4.a;
    var startMillis = _v4.b;
    var endMillis = _v4.c;

    var _v5 = _Utils_Tuple2($elm$time$Time$posixToMillis(datePosix), $elm$core$Basics$floor(startMillis + (endMillis - startMillis) / 2));

    var dateMillis = _v5.a;
    var centerMillis = _v5.b;
    var hoverLabelAlignment = _Utils_cmp(hoverMillis, centerMillis) < 1 ? 0 : 1;

    var isFarEnoughFromSelection = function (dateAlignment) {
      var _v6 = function () {
        if (!hoverLabelAlignment) {
          return _Utils_Tuple2(endPosix, 1);
        } else {
          return _Utils_Tuple2(startPosix, 0);
        }
      }();

      var selectionPosix = _v6.a;
      var selectionAlignment = _v6.b;
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: dateAlignment,
        iL: datePosix
      }, {
        aK: selectionAlignment,
        iL: selectionPosix
      });
    };

    if (_Utils_eq(dateMillis, hoverMillis)) {
      return _Utils_update(result, {
        Cu: hoverLabelAlignment
      });
    } else {
      if (_Utils_eq(dateMillis, startMillis) && hoverLabelAlignment === 1) {
        return result;
      } else {
        if (_Utils_eq(dateMillis, endMillis) && !hoverLabelAlignment) {
          return _Utils_update(result, {
            Cu: 1
          });
        } else {
          if (_Utils_eq(dateMillis, graphEndMillis)) {
            var dateAlignment = 1;
            return _Utils_update(result, {
              q7: A2(isFarEnoughFromHover, dateAlignment, hoverLabelAlignment) && isFarEnoughFromSelection(dateAlignment),
              Cu: dateAlignment
            });
          } else {
            if (_Utils_eq(dateMillis, graphStartMillis)) {
              return _Utils_update(result, {
                q7: A2(isFarEnoughFromHover, result.Cu, hoverLabelAlignment) && isFarEnoughFromSelection(result.Cu)
              });
            } else {
              return _Utils_update(result, {
                lV: false,
                q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu) && A2(isFarEnoughFromHover, result.Cu, hoverLabelAlignment) && isFarEnoughFromSelection(result.Cu)
              });
            }
          }
        }
      }
    }
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$withSelectionLabelConfig = function (_v0) {
    var date = _v0.iL;
    var graph = _v0.d4;
    var selection = _v0.ib;
    var result = A4($author$project$Ui$TimeTransformation$Util$LabelConfig, date, 0, true, true);

    var _v1 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selection.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, selection.xv));

    var selectionStartPosix = _v1.a;
    var selectionEndPosix = _v1.b;

    var _v2 = _Utils_Tuple2($elm$time$Time$posixToMillis(selectionStartPosix), $elm$time$Time$posixToMillis(selectionEndPosix));

    var selectionStartMillis = _v2.a;
    var selectionEndMillis = _v2.b;

    var _v3 = _Utils_Tuple3(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.Eg), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graph.xv));

    var datePosix = _v3.a;
    var graphStartPosix = _v3.b;
    var graphEndPosix = _v3.c;

    var isFarEnoughFromSelectionEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: selectionEndPosix
      });
    };

    var isFarEnoughFromSelectionStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: selectionStartPosix
      });
    };

    var isFarEnoughFromGraphEnd = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 1,
        iL: graphEndPosix
      });
    };

    var isFarEnoughFromGraphStart = function (alignment) {
      return A2($author$project$Ui$TimeTransformation$Util$areDateLabelsFarEnoughFromEachOther, {
        aK: alignment,
        iL: datePosix
      }, {
        aK: 0,
        iL: graphStartPosix
      });
    };

    var _v4 = _Utils_Tuple3($elm$time$Time$posixToMillis(datePosix), $elm$time$Time$posixToMillis(graphStartPosix), $elm$time$Time$posixToMillis(graphEndPosix));

    var dateMillis = _v4.a;
    var graphStartMillis = _v4.b;
    var graphEndMillis = _v4.c;

    if (_Utils_eq(dateMillis, selectionStartMillis)) {
      return result;
    } else {
      if (_Utils_eq(dateMillis, selectionEndMillis)) {
        return _Utils_update(result, {
          Cu: 1
        });
      } else {
        if (_Utils_eq(dateMillis, graphEndMillis)) {
          var position = 1;
          return _Utils_update(result, {
            q7: isFarEnoughFromSelectionEnd(position),
            Cu: position
          });
        } else {
          if (_Utils_eq(dateMillis, graphStartMillis)) {
            return _Utils_update(result, {
              q7: isFarEnoughFromSelectionStart(result.Cu)
            });
          } else {
            return _Utils_update(result, {
              lV: false,
              q7: date.wz === 1 && isFarEnoughFromGraphStart(result.Cu) && isFarEnoughFromGraphEnd(result.Cu) && isFarEnoughFromSelectionStart(result.Cu) && isFarEnoughFromSelectionEnd(result.Cu)
            });
          }
        }
      }
    }
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$toSelectionGraphLabelConfig = function (_v0) {
    var date = _v0.iL;
    var graph = _v0.d4;
    var selection = _v0.ib;
    var hover = _v0.hB;

    var _v1 = _Utils_Tuple2(selection, hover);

    if (!_v1.a.$) {
      if (!_v1.b.$) {
        var interval = _v1.a.a;
        var hoverTarget = _v1.b.a;
        return $author$project$Ui$TimeTransformation$SelectionGraph$Util$hoveringWithSelectionLabelConfig({
          iL: date,
          d4: graph,
          hB: hoverTarget,
          ib: interval
        });
      } else {
        var interval = _v1.a.a;
        var _v2 = _v1.b;
        return $author$project$Ui$TimeTransformation$SelectionGraph$Util$withSelectionLabelConfig({
          iL: date,
          d4: graph,
          ib: interval
        });
      }
    } else {
      if (!_v1.b.$) {
        var _v3 = _v1.a;
        var hoverTarget = _v1.b.a;
        return $author$project$Ui$TimeTransformation$SelectionGraph$Util$hoveringLabelConfig({
          iL: date,
          d4: graph,
          hB: hoverTarget
        });
      } else {
        var _v4 = _v1.a;
        var _v5 = _v1.b;
        return $author$project$Ui$TimeTransformation$SelectionGraph$Util$graphLabelConfig({
          iL: date,
          d4: graph
        });
      }
    }
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$DateItem$viewDateItem = function (config) {
    return A2($author$project$Ui$TimeTransformation$DateItem$viewDateItem, _List_Nil, config);
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$DateItem$viewKeyedDateItem = function (config) {
    var labelConfig = config.y2;
    return _Utils_Tuple2($author$project$Types$SimpleDate$toDateString(labelConfig.Fw), $author$project$Ui$TimeTransformation$SelectionGraph$DateItem$viewDateItem(config));
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$View$mapToHtml = function (config) {
    var labelConfigFor = function (date) {
      return $author$project$Ui$TimeTransformation$SelectionGraph$Util$toSelectionGraphLabelConfig({
        iL: date,
        d4: config.qE,
        hB: config.iV,
        ib: config.n_
      });
    };

    var colorClassFor = F2(function (date, heightPercent) {
      var _v1 = config.n_;

      if (!_v1.$) {
        var startDate = _v1.a.Eg;
        var endDate = _v1.a.xv;
        var isPartOfSelection = A3($author$project$Types$SimpleDate$isWithinInterval, startDate, endDate, date);
        var defaultBehaviour = heightPercent > 0 ? isPartOfSelection ? config.tY.vb : config.tY.o5 : isPartOfSelection ? config.tY.vc : config.tY.u9;
        var _v2 = config.iV;

        if (!_v2.$) {
          var hoverTarget = _v2.a;

          var _v3 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, startDate)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, endDate)));

          var startMillis = _v3.a;
          var endMillis = _v3.b;
          var centerMillis = $elm$core$Basics$floor((startMillis + endMillis) / 2);

          var _v4 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, hoverTarget)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, date)));

          var hoverMillis = _v4.a;
          var dateMillis = _v4.b;

          var _v5 = _Utils_Tuple2(_Utils_cmp(hoverMillis, startMillis) < 0 || _Utils_cmp(endMillis, hoverMillis) < 0, _Utils_cmp(startMillis, hoverMillis) < 0 && _Utils_cmp(hoverMillis, endMillis) < 0);

          var isHoverOutside = _v5.a;
          var isHoverInside = _v5.b;

          var isDateHoverInsideInsideNewPotentialSelection = function (millis) {
            return _Utils_cmp(hoverMillis, centerMillis) < 1 ? _Utils_cmp(hoverMillis, millis) < 1 && _Utils_cmp(millis, endMillis) < 1 : _Utils_cmp(startMillis, millis) < 1 && _Utils_cmp(millis, hoverMillis) < 1;
          };

          var isDateHoverInsideOutsideNewPotentialSelection = function (millis) {
            return _Utils_cmp(hoverMillis, centerMillis) < 1 ? _Utils_cmp(startMillis, millis) < 1 && _Utils_cmp(millis, hoverMillis) < 0 : _Utils_cmp(hoverMillis, millis) < 0 && _Utils_cmp(millis, endMillis) < 1;
          };

          var isDateHoverOutside = function (millis) {
            return _Utils_cmp(hoverMillis, millis) < 1 && _Utils_cmp(millis, startMillis) < 0 || _Utils_cmp(endMillis, millis) < 0 && _Utils_cmp(millis, hoverMillis) < 1;
          };

          return _Utils_eq(hoverTarget, startDate) || _Utils_eq(hoverTarget, endDate) ? defaultBehaviour : isHoverOutside && isDateHoverOutside(dateMillis) ? config.tY.qJ : isHoverInside ? isDateHoverInsideOutsideNewPotentialSelection(dateMillis) ? config.tY.yd : isDateHoverInsideInsideNewPotentialSelection(dateMillis) ? heightPercent > 0 ? config.tY.vb : config.tY.u9 : defaultBehaviour : defaultBehaviour;
        } else {
          return defaultBehaviour;
        }
      } else {
        return _Utils_eq(config.iV, $elm$core$Maybe$Just(date)) ? config.tY.qJ : heightPercent > 0 ? config.tY.o5 : config.tY.u9;
      }
    });
    return A2($elm$core$List$map, function (_v0) {
      var date = _v0.a;
      var value = _v0.b;
      var heightPercent = A2($author$project$Ui$TimeTransformation$Util$calculateHeightPercent, config.rp, value);
      return $author$project$Ui$TimeTransformation$SelectionGraph$DateItem$viewKeyedDateItem({
        kG: 'w2 padLeft0h padRight0h',
        vZ: A2(colorClassFor, date, heightPercent),
        x7: heightPercent,
        yL: config.q6,
        y2: labelConfigFor(date),
        Ba: config.Ba(_Utils_Tuple2(date, value)),
        Bb: config.Bb(_Utils_Tuple2(date, value)),
        tY: config.tY
      });
    }, config.ir);
  };

  var $elm$html$Html$Events$onMouseUp = function (msg) {
    return A2($elm$html$Html$Events$on, 'mouseup', $elm$json$Json$Decode$succeed(msg));
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$shouldCursorResize = function (status) {
    switch (status.$) {
      case 0:
        return false;

      case 1:
        var existingSelection = status.a.qe;

        if (!existingSelection.$) {
          return false;
        } else {
          return true;
        }

      case 2:
        return true;

      case 3:
        return true;

      default:
        return false;
    }
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$Util$toHoverTarget = function (status) {
    switch (status.$) {
      case 1:
        var newSelectionValue = status.a.eX;
        return $elm$core$Maybe$Just(newSelectionValue);

      case 2:
        var newSelectionValue = status.a.eX;
        return $elm$core$Maybe$Just(newSelectionValue);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph_ = F9(function (parentTag, maybeCashAccrualConfig, classes, state, maybeCurrency, graphStartDate, graphEndDate, valuesDict, theme_) {
    var theme = $author$project$Ui$TimeTransformation$Util$getThemeValues(theme_);
    var selectedInterval = $author$project$Ui$TimeTransformation$SelectionGraph$Util$toSelectedInterval(state.DS);
    var selectionLength = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, function (_v15) {
      var startDate = _v15.Eg;
      var endDate = _v15.xv;
      var diff = A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, startDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, endDate));
      return diff + 1;
    }, selectedInterval));
    var selectionPositionLeft = A2($elm$core$Maybe$map, function (_v14) {
      var startDate = _v14.Eg;
      var diff = A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graphStartDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, startDate));
      return diff;
    }, selectedInterval);

    var selectionAttributes = function () {
      if (!selectionPositionLeft.$) {
        var positionLeft = selectionPositionLeft.a;
        return _List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(positionLeft * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat(selectionLength * 2 - 1) + 'rem'), A2($elm$html$Html$Attributes$attribute, 'underlineType', 'selection-primary'), $elm$html$Html$Attributes$class(theme.tp), $elm$html$Html$Attributes$class(theme.DT)]);
      } else {
        return _List_fromArray([$elm$html$Html$Attributes$class('o0')]);
      }
    }();

    var isCurrentlySelecting = $author$project$Ui$TimeTransformation$SelectionGraph$Util$shouldCursorResize(state.DS);
    var isCurrentlyHovering = $author$project$Ui$TimeTransformation$SelectionGraph$Util$isHovering(state.DS);
    var hoverTarget = $author$project$Ui$TimeTransformation$SelectionGraph$Util$toHoverTarget(state.DS);

    var cashAccrualElement = function () {
      if (!maybeCashAccrualConfig.$) {
        var cashAccrualConfig = maybeCashAccrualConfig.a;
        return A2($author$project$Ui$TimeTransformation$SelectionGraph$View$cashAccrualPattern, cashAccrualConfig.pb, cashAccrualConfig.gi);
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var _v0 = function () {
      var _v1 = _Utils_Tuple3(hoverTarget, selectedInterval, selectionPositionLeft);

      _v1$2: while (true) {
        if (!_v1.a.$) {
          if (!_v1.b.$) {
            if (!_v1.c.$) {
              var simpleDate = _v1.a.a;
              var startDate = _v1.b.a.Eg;
              var endDate = _v1.b.a.xv;
              var selectionLeft = _v1.c.a;

              var hoverPositionLeft = function (_v5) {
                return A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graphStartDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, simpleDate));
              };

              var hoverLengthToStart = function (_v4) {
                return $elm$core$Basics$abs(A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, simpleDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, startDate)));
              };

              var hoverLengthToEnd = function (_v3) {
                return $elm$core$Basics$abs(A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, endDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, simpleDate)));
              };

              var _v2 = _Utils_Tuple3($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, simpleDate)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, startDate)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, endDate)));

              var hoverMillis = _v2.a;
              var selectionStartMillis = _v2.b;
              var selectionEndMillis = _v2.c;
              var selectionCenterMillis = $elm$core$Basics$floor(selectionStartMillis + (selectionEndMillis - selectionStartMillis) / 2);
              return _Utils_cmp(hoverMillis, selectionStartMillis) < 0 ? _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(hoverPositionLeft(0) * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat((hoverLengthToStart(0) + selectionLength) * 2 - 1) + 'rem'), $elm$html$Html$Attributes$class(theme.ye)]), true) : _Utils_cmp(selectionStartMillis, hoverMillis) < 0 && _Utils_cmp(hoverMillis, selectionEndMillis) < 0 ? _Utils_cmp(hoverMillis, selectionCenterMillis) < 1 ? _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(hoverPositionLeft(0) * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat(hoverLengthToEnd(0) * 2 + 1) + 'rem'), $elm$html$Html$Attributes$class(theme.qI)]), false) : _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(selectionLeft * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat(hoverLengthToStart(0) * 2 + 1) + 'rem'), $elm$html$Html$Attributes$class(theme.qI)]), false) : _Utils_cmp(hoverMillis, selectionEndMillis) > 0 ? _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(selectionLeft * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat((hoverLengthToEnd(0) + selectionLength) * 2 - 1) + 'rem'), $elm$html$Html$Attributes$class(theme.ye)]), true) : _Utils_Tuple2(_List_Nil, false);
            } else {
              break _v1$2;
            }
          } else {
            var simpleDate = _v1.a.a;
            var _v6 = _v1.b;
            var hoverPositionLeft = A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graphStartDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, simpleDate));
            return _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$style, 'left', $elm$core$String$fromFloat(hoverPositionLeft * 2 + 0.5) + 'rem'), A2($elm$html$Html$Attributes$style, 'width', '1rem'), $elm$html$Html$Attributes$class(theme.ye)]), true);
          }
        } else {
          break _v1$2;
        }
      }

      return _Utils_Tuple2(_List_Nil, false);
    }();

    var hoverAttributes = _v0.a;
    var shouldPutSelectionOverHover = _v0.b;
    var hoverAndSelectHtml = (shouldPutSelectionOverHover ? $elm$core$List$reverse : $elm$core$Basics$identity)(_List_fromArray([_Utils_Tuple2('selection-graph-selection-element', A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('inlineBlock absolute top0 bottom1 w0 radius0'), selectionAttributes), _List_Nil)), _Utils_Tuple2('selection-graph-hover-element', A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('inlineBlock absolute top0 bottom1 w0 radius0'), hoverAttributes), _List_Nil))]));

    var _v7 = _Utils_Tuple2(A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graphStartDate), A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, graphEndDate));

    var startDatePosix = _v7.a;
    var endDatePosix = _v7.b;

    var days = function (d) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, 0, d + 1, !d);
    }(A4($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc, startDatePosix, endDatePosix));

    var values = function () {
      var buildInterval = F2(function (index, posix) {
        return _Utils_Tuple2(A2($author$project$Types$SimpleDate$fromPosix, $elm$time$Time$utc, A4($justinmimbs$time_extra$Time$Extra$add, 11, index, $elm$time$Time$utc, posix)), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1));
      });
      return $turboMaCk$any_dict$Dict$Any$toList(A2($turboMaCk$any_dict$Dict$Any$union, A2($turboMaCk$any_dict$Dict$Any$filter, F2(function (k, _v11) {
        return A2($author$project$Types$SimpleDate$isLaterOrEqualWith, graphStartDate, k);
      }), valuesDict), A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$SimpleDate$toDateString, A2($elm$core$List$indexedMap, buildInterval, A2($elm$core$List$repeat, days, startDatePosix)))));
    }();

    var selectionValue = A2($elm$core$Maybe$withDefault, A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), A2($elm$core$Maybe$map, function (_v9) {
      var startDate = _v9.Eg;
      var endDate = _v9.xv;
      return A3($elm$core$List$foldl, F2(function (x, acc) {
        return A2($JoshuaHall$elm_fraction$Fraction$add, x, acc);
      }), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), A2($elm$core$List$filterMap, function (_v10) {
        var date = _v10.a;
        var value = _v10.b;
        return A3($author$project$Types$SimpleDate$isWithinInterval, startDate, endDate, date) ? $elm$core$Maybe$Just(value) : $elm$core$Maybe$Nothing;
      }, values));
    }, selectedInterval));
    var valuesMax = A3($elm$core$List$foldl, F2(function (_v8, acc) {
      var x = _v8.b;
      return A2($author$project$Types$Fraction$max, x, acc);
    }), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 0, 1), values);
    var maxValue = A2($author$project$Types$Fraction$max, selectionValue, valuesMax);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(theme.u5), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow heading5Regular')]), A2($elm$core$List$cons, cashAccrualElement, A2($elm$core$List$cons, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock marRight2'), $elm$html$Html$Attributes$class(theme.E9)]), _List_fromArray([$elm$html$Html$text('Amount Selected:')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock padLeft1 padRight1 padTop0h padBottom0h radius0'), $elm$html$Html$Attributes$class(theme.E8), $elm$html$Html$Attributes$class(theme.Fa)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock heading5Bold marRight0h')]), _List_fromArray([$elm$html$Html$text($author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$removeExtraZerosFromFloatString(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(selectionValue)))))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock')]), _List_fromArray([$elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Types$Currency$toCurrencyString, maybeCurrency)))]))]))]))])))), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('overflowXAuto marTop4'), $elm$html$Html$Attributes$class(theme.DD)]), _List_fromArray([A3($elm$html$Html$Keyed$node, 'div', A2($elm$core$List$cons, $elm$html$Html$Attributes$class('relative inlineFlexRow h16 marLeft10 padRight15 marBottom6 borderBottomHairline gray10Border'), A2($elm$core$List$cons, $elm$html$Html$Events$onMouseUp(parentTag($author$project$Ui$TimeTransformation$Msg$SelectionGraphMsg($author$project$Ui$TimeTransformation$SelectionGraph$Msg$SelectionEnded))), A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([A2($elm$html$Html$Attributes$style, 'cursor', 'col-resize')]), _List_Nil, isCurrentlySelecting))), $elm$core$List$concat(_List_fromArray([_List_fromArray([_Utils_Tuple2('selection-graph-overlay', A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, 'fixedSpread', '', isCurrentlySelecting || isCurrentlyHovering)), $elm$html$Html$Events$onMouseEnter(parentTag(A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$Ui$TimeTransformation$Msg$SelectionGraphMsg($author$project$Ui$TimeTransformation$SelectionGraph$Msg$HoverEnded), $author$project$Ui$TimeTransformation$Msg$NoOp, isCurrentlyHovering)))]), _List_Nil))]), hoverAndSelectHtml, $author$project$Ui$TimeTransformation$SelectionGraph$View$mapToHtml({
      qE: {
        xv: graphEndDate,
        Eg: graphStartDate
      },
      iV: hoverTarget,
      q6: isCurrentlySelecting,
      rp: maxValue,
      Ba: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, parentTag, $author$project$Ui$TimeTransformation$Msg$SelectionGraphMsg), $author$project$Ui$TimeTransformation$SelectionGraph$Msg$SelectionStarted), $elm$core$Tuple$first),
      Bb: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, parentTag, $author$project$Ui$TimeTransformation$Msg$SelectionGraphMsg), $author$project$Ui$TimeTransformation$SelectionGraph$Msg$SelectionChanged), $elm$core$Tuple$first),
      n_: selectedInterval,
      tY: theme,
      ir: values
    })])))]))]));
  });

  var $author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph = function (cfg) {
    return A8($elm$html$Html$Lazy$lazy7, A2($author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph_, cfg.ss, cfg.vL), cfg.vV, cfg.Ej, cfg.bq, cfg.Eg, cfg.xv, cfg.uh, cfg.tY);
  };

  var $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasis = F2(function (editingMoneyPayload, val) {
    return _Utils_update(editingMoneyPayload, {
      pb: val
    });
  });

  var $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$shouldShowInputChart = function (selectionStatus) {
    switch (selectionStatus.$) {
      case 0:
        return false;

      case 1:
        var existingSelection = selectionStatus.a.qe;
        return $elm_community$maybe_extra$Maybe$Extra$isJust(existingSelection);

      case 2:
        var existingSelection = selectionStatus.a.qe;
        return $elm_community$maybe_extra$Maybe$Extra$isJust(existingSelection);

      case 3:
        return true;

      default:
        return true;
    }
  };

  var $author$project$Types$SimpleDate$fromMillis = A2($elm$core$Basics$composeR, $elm$time$Time$millisToPosix, $author$project$Types$SimpleDate$fromPosix($elm$time$Time$utc));
  var $author$project$Types$SimpleDate$addMillis = F2(function (millis, simpleDate) {
    return $author$project$Types$SimpleDate$fromMillis(millis + $author$project$Types$SimpleDate$toMillis(simpleDate));
  });
  var $author$project$Types$RepeatPeriod$day = 24 * 60 * 60 * 1000;

  var $author$project$Types$RepeatPeriod$toMillis = function (repeat_period_enum) {
    switch (repeat_period_enum) {
      case 0:
        return $author$project$Types$RepeatPeriod$day;

      case 1:
        return 15 * $author$project$Types$RepeatPeriod$day;

      case 2:
        return 30 * $author$project$Types$RepeatPeriod$day;

      case 3:
        return 91 * $author$project$Types$RepeatPeriod$day;

      case 4:
        return 7 * $author$project$Types$RepeatPeriod$day;

      default:
        return 365 * $author$project$Types$RepeatPeriod$day;
    }
  };

  var $author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndDate = F3(function (zone, currDate, pattern) {
    var fromDate = A2($elm$core$Maybe$andThen, $author$project$Ui$DateInput$DateInput$toSimpleDate(zone), pattern.hn.iL);
    var fromCount = A4($elm$core$Maybe$map3, F3(function (every, period, count) {
      return A2($author$project$Types$SimpleDate$addMillis, every * $author$project$Types$RepeatPeriod$toMillis(period) * count, currDate);
    }), $elm$core$Result$toMaybe($author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(pattern.ao)), pattern.ap.ia, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, pattern.hn.k));
    return A2($elm_community$maybe_extra$Maybe$Extra$or, fromCount, fromDate);
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toEndDate = F3(function (zone, startDate, block) {
    var _v0 = block.g7;

    if (!_v0.$) {
      if (_v0.a === 1) {
        var _v1 = _v0.a;
        return A2($elm$core$Maybe$withDefault, A2($author$project$Types$SimpleDate$addMillis, 60 * 24 * 60 * 60 * 1000, startDate), A2($author$project$Ui$DateInput$DateInput$toSimpleDate, zone, block.d2.ho));
      } else {
        var _v2 = _v0.a;
        return A2($elm$core$Maybe$withDefault, A2($author$project$Types$SimpleDate$addMillis, 60 * 24 * 60 * 60 * 1000, startDate), A3($author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndDate, zone, startDate, block.fD.h2));
      }
    } else {
      return A2($elm$core$Maybe$withDefault, A2($author$project$Types$SimpleDate$addMillis, 60 * 24 * 60 * 60 * 1000, startDate), A3($author$project$Types$EditingBuildingBlock$EditingRepeatPattern$toEndDate, zone, startDate, block.fD.h2));
    }
  });

  var $author$project$Ui$Block$MoneyBlockBasisTimeTransformView$moneyBlockBasisTimeTransformView = function (cfg) {
    var nowSimpleDate = A2($author$project$Types$SimpleDate$fromPosix, cfg.eG.by, cfg.eG.EM);

    var defaultStartDate = function () {
      var _v3 = _Utils_Tuple2(A2($elm$core$Maybe$withDefault, nowSimpleDate, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, cfg.eG.by, cfg.y)), _Utils_update(nowSimpleDate, {
        FP: nowSimpleDate.FP - 1
      }));

      var startOn = _v3.a;
      var aYearAgo = _v3.b;

      var _v4 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, startOn)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, aYearAgo)));

      var startOnMillis = _v4.a;
      var aYearAgoMillis = _v4.b;
      return _Utils_cmp(startOnMillis, aYearAgoMillis) < 0 ? aYearAgo : startOn;
    }();

    var defaultEndDate = function () {
      var _v1 = _Utils_Tuple2(A3($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toEndDate, cfg.eG.by, defaultStartDate, cfg.y), _Utils_update(nowSimpleDate, {
        FP: nowSimpleDate.FP + 1
      }));

      var endOn = _v1.a;
      var inAYear = _v1.b;

      var _v2 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, endOn)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, inAYear)));

      var endOnMillis = _v2.a;
      var inAYearMillis = _v2.b;
      return _Utils_cmp(endOnMillis, inAYearMillis) > 0 ? inAYear : endOn;
    }();

    var _v0 = _Utils_Tuple2(_Utils_update(defaultStartDate, {
      FP: defaultStartDate.FP - 1
    }), _Utils_update(defaultEndDate, {
      FP: defaultEndDate.FP + 1
    }));

    var startDate = _v0.a;
    var endDate = _v0.b;
    var inputChart = $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$shouldShowInputChart(cfg.y.cU.fE.DS) ? $author$project$Ui$TimeTransformation$InputGraph$View$inputGraph({
      vV: 'marTop2 pad4',
      bq: $author$project$Types$MoneyOrThing$toCurrency(cfg.y.hO),
      xv: endDate,
      Ck: cfg.Cj,
      ss: cfg.tZ,
      D8: true,
      Eg: startDate,
      Ej: cfg.y.cU.fE,
      tY: 0,
      uh: cfg.yx
    }) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph({
      vL: $elm$core$Maybe$Just({
        pb: cfg.y.cU.pb,
        gi: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingMoneyPayload$setBasis(cfg.y.cU))
      }),
      vV: 'pad4',
      bq: $author$project$Types$MoneyOrThing$toCurrency(cfg.y.hO),
      xv: endDate,
      ss: cfg.tZ,
      Eg: startDate,
      Ej: cfg.y.cU.fE,
      tY: 0,
      uh: cfg.yx
    }), inputChart]));
  };

  var $author$project$Global$Model$CreateSeasonalityPreset = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Model$DeleteSeasonalityPreset = F2(function (a, b) {
    return {
      $: 9,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$EditBasicBlockSeasonalityPresetNestedSelectFinishRename = 0;
  var $author$project$Ui$Block$Msg$OnTapSeasonality = {
    $: 2
  };
  var $author$project$Global$Model$UpdateSeasonalityPreset = F4(function (a, b, c, d) {
    return {
      $: 8,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Types$MonthAdjustments$getMonthAdjustment = F2(function (key, arr) {
    return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$ViewModelStringToInt$empty($author$project$Types$SimpleDate$monthToString($justinmimbs$date$Date$numberToMonth(key + 1))), A2($elm$core$Array$get, key, arr));
  });

  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$isEditingSeasonalityClear = function (editingSeasonality) {
    var emptyEditingSeasonalityValues = function (_v1) {
      return A2($elm$core$List$filterMap, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty, $elm$core$Result$toMaybe), $elm$core$Array$toList($author$project$Types$EditingBuildingBlock$EditingSeasonality$empty.dW));
    };

    var editingSeasonalityValues = function (_v0) {
      return A2($elm$core$List$filterMap, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty, $elm$core$Result$toMaybe), $elm$core$Array$toList(editingSeasonality.dW));
    };

    return $elm_community$maybe_extra$Maybe$Extra$isNothing(editingSeasonality.sH.ia) && _Utils_eq(emptyEditingSeasonalityValues(0), editingSeasonalityValues(0));
  };

  var $author$project$Types$EditingBuildingBlock$EditingSeasonality$isSeasonalityModifiedAndValid = F3(function (company, seasonalityId, editingSeasonality) {
    var maybeSelectedSeasonalityPreset = A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(seasonalityId), $krisajenkins$remotedata$RemoteData$toMaybe(company.ti));
    var getSeasonalityPresetValues = A2($elm$core$Basics$composeR, function ($) {
      return $.dW;
    }, $elm$core$Array$toList);
    var getEditingSeasonalityValues = A2($elm$core$Basics$composeR, function ($) {
      return $.dW;
    }, A2($elm$core$Basics$composeR, $elm$core$Array$toList, $elm$core$List$filterMap(A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty, $elm$core$Result$toMaybe))));
    return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, getSeasonalityPresetValues, $elm$core$Basics$eq(getEditingSeasonalityValues(editingSeasonality))), maybeSelectedSeasonalityPreset));
  });
  var $author$project$Ui$DropdownSelect$toOptionCustom = F2(function (_v0, a) {
    var onDelete = _v0.Ax;
    var onEdit = _v0.hV;
    return {
      vU: $elm$core$Maybe$Nothing,
      kN: $elm$core$Maybe$Nothing,
      Ax: A2($elm$core$Maybe$map, function (f) {
        return f(a);
      }, onDelete),
      hV: A2($elm$core$Maybe$map, function (f) {
        return f(a);
      }, onEdit),
      jM: true,
      Fw: a
    };
  });

  var $author$project$Ui$DropdownSelect$dropdownSelectCustom = function (cfg) {
    var optionList = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, $elm$core$Maybe$Nothing), $elm$core$List$map($author$project$Ui$DropdownSelect$toOptionCustom({
      Ax: cfg.Ax,
      hV: cfg.hV
    }))), cfg.e0);
    return $author$project$Ui$NestedSelect$nestedSelect({
      vV: cfg.vV,
      yI: cfg.yI,
      zO: '',
      e0: optionList,
      e3: cfg.e3,
      nY: cfg.nY,
      Ej: cfg.Ej,
      b3: cfg.b3,
      fd: cfg.fd,
      t3: cfg.EU
    });
  };

  var $author$project$Ui$SeasonalityPresetNestedSelect$mapToExternalState = function (state) {
    return {
      kR: state.kR,
      xi: A2($elm$core$Maybe$map, function ($) {
        return $.F;
      }, state.xi),
      k3: state.k3,
      yK: state.yK,
      f8: state.f8,
      rm: state.rm,
      ia: A2($elm$core$Maybe$map, function ($) {
        return $.F;
      }, state.ia)
    };
  };

  var $author$project$Ui$SeasonalityPresetNestedSelect$toSeasonalityPreset = F2(function (company, seasonalityPresetId) {
    return A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(seasonalityPresetId), $krisajenkins$remotedata$RemoteData$toMaybe(company.ti));
  });
  var $author$project$Ui$SeasonalityPresetNestedSelect$mapToInternalState = F2(function (company, state) {
    return {
      kR: state.kR,
      xi: A2($elm$core$Maybe$andThen, $author$project$Ui$SeasonalityPresetNestedSelect$toSeasonalityPreset(company), state.xi),
      k3: state.k3,
      yK: state.yK,
      f8: state.f8,
      rm: state.rm,
      ia: A2($elm$core$Maybe$andThen, $author$project$Ui$SeasonalityPresetNestedSelect$toSeasonalityPreset(company), state.ia)
    };
  });

  var $author$project$Ui$SeasonalityPresetNestedSelect$toOptions = function (company) {
    return A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.ti));
  };

  var $author$project$Ui$SeasonalityPresetNestedSelect$seasonalityPresetDropdownSelect = function (cfg) {
    return $author$project$Ui$DropdownSelect$dropdownSelectCustom({
      vV: cfg.vV,
      yI: false,
      Ax: A2($elm$core$Maybe$map, function (f) {
        return function (s) {
          return f(s.F);
        };
      }, cfg.Ax),
      hV: cfg.hV,
      e0: $author$project$Ui$SeasonalityPresetNestedSelect$toOptions(cfg.j),
      e3: cfg.e3,
      nY: cfg.nY,
      Ej: A2($author$project$Ui$SeasonalityPresetNestedSelect$mapToInternalState, cfg.j, cfg.Ej),
      b3: A2($elm$core$Basics$composeR, $author$project$Ui$SeasonalityPresetNestedSelect$mapToExternalState, cfg.b3),
      fd: F2(function (a, b) {
        return _Utils_eq(a.F, b.F);
      }),
      EU: function ($) {
        return $.dH;
      }
    });
  };

  var $elm_community$array_extra$Array$Extra$update = F3(function (n, f, a) {
    var element = A2($elm$core$Array$get, n, a);

    if (element.$ === 1) {
      return a;
    } else {
      var element_ = element.a;
      return A3($elm$core$Array$set, n, f(element_), a);
    }
  });
  var $author$project$Types$MonthAdjustments$setMonthAdjustment = F3(function (key, arr, val) {
    return A3($elm_community$array_extra$Array$Extra$update, key, $author$project$ElmFramework$Lib$ViewModelStringTo$set(val), arr);
  });

  var $author$project$Ui$Button$textButtonCustom = function (cfg) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.gi), _List_fromArray([$elm$html$Html$Attributes$class(cfg.vV), $elm$html$Html$Attributes$disabled(cfg.yM), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2(cfg.k$, cfg.yM)]))]), _List_fromArray([$elm$html$Html$text(cfg.kz)]));
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$verticalSlider = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$sliderView({
      yM: config.yM,
      eT: true,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: config.dg,
      eb: config.eb,
      dk: config.dk,
      dl: config.dl,
      dp: config.dp,
      dq: config.dq,
      dr: config.dr,
      Fw: config.Fw
    });
  };

  var $author$project$ElmFramework$Lib$Ui$Slider$verticalSliderWithInput = function (config) {
    var sliderElement = $author$project$ElmFramework$Lib$Ui$Slider$verticalSlider({
      yM: config.yM,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: config.dg,
      eb: config.eb,
      dk: config.dk,
      dl: config.dl,
      dp: config.dp,
      dq: config.dq,
      dr: config.dr,
      Fw: A2($elm$core$Maybe$withDefault, config.m, A2($author$project$ElmFramework$Lib$Ui$Slider$parseByVariant, config.ui, config.Fw))
    });

    var inputElement = function () {
      var _v0 = config.tW;

      switch (_v0.$) {
        case 0:
          var inputConfig = _v0.a;
          return $author$project$ElmFramework$Lib$Ui$Input$customAttributesInput({
            uZ: _List_fromArray([A2($elm$html$Html$Attributes$style, 'max-width', inputConfig.zp), A2($elm$html$Html$Attributes$style, 'max-height', inputConfig.zn), A2($elm$html$Html$Attributes$style, 'font-weight', 'inherit')]),
            fx: $elm$core$Maybe$Nothing,
            kG: config.gK,
            k_: config.yM,
            qU: 0,
            e_: config.e_,
            e3: '',
            gx: config.yW,
            Fw: config.Fw
          });

        case 1:
          var affixedInputConfig = _v0.a;
          return $author$project$ElmFramework$Lib$Ui$Input$affixedInput({
            uB: affixedInputConfig.uB,
            uC: '',
            uD: affixedInputConfig.uD,
            kj: false,
            kG: '',
            F: '',
            ys: config.gK,
            yM: config.yM,
            yT: true,
            yW: config.yW,
            zp: affixedInputConfig.zp,
            zB: affixedInputConfig.zB,
            e_: config.e_,
            e3: '',
            Fw: config.Fw
          });

        default:
          var affixedInputConfig = _v0.a;
          return $author$project$ElmFramework$Lib$Ui$Input$affixedInput({
            uB: affixedInputConfig.uB,
            uC: '',
            uD: affixedInputConfig.uD,
            kj: false,
            kG: '',
            F: '',
            ys: config.gK,
            yM: config.yM,
            yT: false,
            yW: config.yW,
            zp: affixedInputConfig.zp,
            zB: affixedInputConfig.zB,
            e_: config.e_,
            e3: '',
            Fw: config.Fw
          });
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($elm_community$string_extra$String$Extra$clean($elm$core$String$concat(_List_fromArray(['inlineFlexColumn flexAlignCenter ', ' ', config.kG]))))]), _List_fromArray([sliderElement, inputElement]));
  };

  var $author$project$Ui$Slider$verticalSliderInputBottom = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$verticalSliderWithInput({
      kG: config.kG,
      yM: config.yM,
      yW: config.yW,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: '',
      eb: config.eb,
      gK: 'center padTop1 padBottom1 marTop2 radius0 borderSolid borderWidth1 gray10Border',
      tW: $author$project$ElmFramework$Lib$Ui$Slider$Regular({
        zn: config.qR,
        zp: config.iX
      }),
      dk: 'primary30Back',
      dl: '',
      dp: 'gray20Back',
      dq: 'gradient0Back',
      dr: '',
      Fw: config.Fw,
      ui: config.ui
    });
  };

  var $author$project$Ui$Block$EditBasicBlock$seasonalityPattern = function (cfg) {
    var classes = function (label) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('verticalText primary30 heading5Regular h6')]), _List_fromArray([$elm$html$Html$text(label)]));
    };

    var verticalSliderElement = function (arg) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter minH60')]), _List_fromArray([arg.pD, classes(arg.zG)]));
    };

    var _v0 = _Utils_Tuple3(cfg.eG.o_.vh.bv, cfg.eG.o_.vh.bv.fD, cfg.eG.o_.vh.bv.fD.bK);

    var editingBlock = _v0.a;
    var basicPayload = _v0.b;
    var seasonality = _v0.c;
    var onSetEditingSeasonality = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload(editingBlock)), $author$project$Types$EditingBuildingBlock$EditingBasicPayload$setSeasonality(basicPayload));
    var aMonth = F3(function (monthName, onInput, value) {
      var verticalSliderClasses = 'heading5Bold flex1 ' + A2($elm$core$Maybe$withDefault, 'gray40', A2($elm$core$Maybe$andThen, function (v) {
        return v !== 100 ? $elm$core$Maybe$Just('primary30') : $elm$core$Maybe$Nothing;
      }, $elm$core$Result$toMaybe($author$project$ElmFramework$Lib$ViewModelStringTo$parseNonEmpty(value))));
      return verticalSliderElement({
        pD: $author$project$Ui$Slider$verticalSliderInputBottom({
          kG: verticalSliderClasses,
          qR: '4rem',
          iX: '4rem',
          yM: false,
          yW: false,
          l: 200.0,
          m: 0.0,
          e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, onSetEditingSeasonality, $author$project$Types$EditingBuildingBlock$EditingSeasonality$setMonthAdjustments(seasonality)), onInput(seasonality.dW)),
          eb: 1.0,
          Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(value),
          ui: 0
        }),
        zG: monthName
      });
    });

    var showContent = function () {
      if (cfg.eG.o_.vh.nX || cfg.et) {
        var areInputsClear = $author$project$Types$EditingBuildingBlock$EditingSeasonality$isEditingSeasonalityClear(cfg.eG.o_.vh.bv.fD.bK);
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft6 padRight6 padBottom6')]), _List_fromArray([$author$project$Ui$SeasonalityPresetNestedSelect$seasonalityPresetDropdownSelect({
          vV: 'flexColumn flexAlignStart marTop3',
          j: cfg.j,
          Ax: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgGlobal, A2($elm$core$Basics$composeL, $author$project$Global$Msg$ShowDialog, $author$project$Global$Model$DeleteSeasonalityPreset(cfg.j.F)))),
          hV: $elm$core$Maybe$Just(F2(function (s, inputString) {
            return $elm$core$String$isEmpty(inputString) ? A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Pre-set must have a name', _List_Nil) : $author$project$TopMsg$requestMsg(A4($author$project$Remote$RequestMsg$UpdateSeasonalityPreset, $elm$core$Maybe$Just(0), cfg.j.F, s.F, A2($author$project$Api$Types$UpdateSeasonalityReq$UpdateSeasonalityPresetReq, inputString, $author$project$Types$EditingBuildingBlock$EditingSeasonality$fromSeasonalityPreset(s).dW)));
          })),
          e3: 'No pre-set selected',
          nY: $elm$core$Maybe$Just('Select Pre-set'),
          Ej: cfg.eG.o_.vh.bv.fD.bK.sH,
          b3: A2($elm$core$Basics$composeL, onSetEditingSeasonality, $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPreset(seasonality))
        }), A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween marTop6')]), A2($elm$core$List$indexedMap, F2(function (index, monthString) {
          return _Utils_Tuple2(monthString, A3(aMonth, monthString, $author$project$Types$MonthAdjustments$setMonthAdjustment(index), A2($author$project$Types$MonthAdjustments$getMonthAdjustment, index, cfg.y.fD.bK.dW)));
        }), A2($elm$core$List$map, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$numberToMonth, $author$project$Types$SimpleDate$monthToString), A2($elm$core$List$range, 1, 12)))), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter primary30 heading5Bold marTop3')]), _List_fromArray([$author$project$Ui$Button$textButtonCustom({
          kz: 'Clear',
          vV: 'pad2',
          k$: 'gray40',
          yM: areInputsClear,
          gi: onSetEditingSeasonality(A3($author$project$ElmFramework$Lib$Util$flip, $author$project$Types$EditingBuildingBlock$EditingSeasonality$setPreset, A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, $elm$core$Maybe$Nothing, seasonality.sH), A2($author$project$Types$EditingBuildingBlock$EditingSeasonality$setMonthAdjustments, seasonality, $author$project$Types$MonthAdjustments$empty)))
        }), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('|')])), $author$project$Ui$Button$textButtonCustom({
          kz: 'Save',
          vV: 'pad2',
          k$: 'gray40',
          yM: A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function (selectedSeasonalityPresetId) {
            return A3($author$project$Types$EditingBuildingBlock$EditingSeasonality$isSeasonalityModifiedAndValid, cfg.j, selectedSeasonalityPresetId, cfg.eG.o_.vh.bv.fD.bK);
          }, cfg.eG.o_.vh.bv.fD.bK.sH.ia)),
          gi: A2($elm$core$Maybe$withDefault, $author$project$TopMsg$msgGlobal($author$project$Global$Msg$NoOp), A2($elm$core$Maybe$andThen, function (selectedSeasonalityPresetId) {
            var maybeSelectedSeasonalityPreset = A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(selectedSeasonalityPresetId), $krisajenkins$remotedata$RemoteData$toMaybe(cfg.j.ti));
            return A2($elm$core$Maybe$map, function (seasonalityPreset) {
              return $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A4($author$project$Global$Model$UpdateSeasonalityPreset, cfg.j.F, seasonalityPreset.F, seasonalityPreset.dH, cfg.eG.o_.vh.bv.fD.bK.dW)));
            }, maybeSelectedSeasonalityPreset);
          }, cfg.eG.o_.vh.bv.fD.bK.sH.ia))
        }), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('|')])), $author$project$Ui$Button$textButtonCustom({
          kz: 'Save As',
          vV: 'pad2',
          k$: 'gray40',
          yM: areInputsClear,
          gi: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$CreateSeasonalityPreset, cfg.j.F, cfg.y.fD.bK.dW)))
        })]))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($author$project$Ui$Sections$plainSectionButton, 'marTop2', function () {
      if (cfg.et) {
        return _List_fromArray([showContent]);
      } else {
        var summary = function () {
          var seasonalityInBlock = A2($elm$core$Maybe$andThen, function ($) {
            return $.bK;
          }, A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingBasicPayload$basicPayloadReqToBasicPayload, $elm$core$Result$toMaybe(A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$toBasicPayloadReq, cfg.j, cfg.y.fD))));
          return A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromSeasonality(cfg.j), seasonalityInBlock);
        }();

        return _List_fromArray([$author$project$Ui$Block$EditBasicBlock$sectionExtendedOrShrunken({
          g8: A2($author$project$Ui$Block$EditBasicBlock$showBetweenText, cfg.eG.o_.vh.nX, A2($elm$core$Maybe$withDefault, 'Add seasonality to this block.', summary)),
          hF: cfg.eG.o_.vh.nX,
          y$: 'Seasonality',
          tU: $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$OnTapSeasonality)
        }), showContent]);
      }
    }());
  };

  var $author$project$Ui$Block$EditBasicBlock$basicBlockElements = function (cfg) {
    var timeTransformation = function () {
      var _v0 = cfg.y.hO;

      if (!_v0.$) {
        return $author$project$Ui$Block$MoneyBlockBasisTimeTransformView$moneyBlockBasisTimeTransformView({
          y: cfg.y,
          j: cfg.j,
          yx: cfg.y.cU.iy.ve,
          mS: cfg.mS,
          bs: cfg.bs,
          Cj: cfg.y.cU.iy.ox,
          tZ: A2($elm$core$Basics$composeL, cfg.p0, $author$project$Types$EditingBuildingBlock$Msg$MoneyBasisTransformMsg),
          eG: cfg.eG
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return _Utils_Tuple2(A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Block$EditBasicBlock$basePattern(cfg), $author$project$Ui$Block$EditBasicBlock$seasonalityPattern(cfg), $author$project$Ui$Block$EditBasicBlock$growthPattern(cfg)])), timeTransformation);
  };

  var $author$project$Ui$SlideSelectMultiple$GraySelectWhiteBack = 3;

  var $author$project$Ui$DerivativeBlockNestedSelect$toDerivativeOf = function (hierarchyItem) {
    switch (hierarchyItem.$) {
      case 0:
        return $elm$core$Maybe$Nothing;

      case 1:
        var allocationClass = hierarchyItem.a;
        return $elm$core$Maybe$Just($author$project$Types$BuildingBlock$BaseAllocationClass(allocationClass.F));

      default:
        var buildingBlock = hierarchyItem.a;
        return $elm$core$Maybe$Just($author$project$Types$BuildingBlock$BaseBlock(buildingBlock.F));
    }
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$mapToExternalState = function (state) {
    return {
      kR: state.kR,
      xi: A2($elm$core$Maybe$andThen, $author$project$Ui$DerivativeBlockNestedSelect$toDerivativeOf, state.xi),
      k3: state.k3,
      yK: state.yK,
      f8: state.f8,
      rm: state.rm,
      ia: A2($elm$core$Maybe$andThen, $author$project$Ui$DerivativeBlockNestedSelect$toDerivativeOf, state.ia)
    };
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$AllocationClassItem = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$BlockItem = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$toHierarchyItem = F2(function (company, derivativeOf) {
    if (!derivativeOf.$) {
      var buildingBlockId = derivativeOf.a;
      return A2($elm$core$Maybe$map, $author$project$Ui$DerivativeBlockNestedSelect$BlockItem, A2($author$project$Types$Company$toBuildingBlock, buildingBlockId, company));
    } else {
      var allocationClassId = derivativeOf.a;
      return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Ui$DerivativeBlockNestedSelect$AllocationClassItem, $elm$core$Tuple$second), A2($author$project$Types$Company$toAllocationClass, allocationClassId, company));
    }
  });
  var $author$project$Ui$DerivativeBlockNestedSelect$mapToInternalState = F2(function (company, state) {
    return {
      kR: state.kR,
      xi: A2($elm$core$Maybe$andThen, $author$project$Ui$DerivativeBlockNestedSelect$toHierarchyItem(company), state.xi),
      k3: state.k3,
      yK: state.yK,
      f8: state.f8,
      rm: state.rm,
      ia: A2($elm$core$Maybe$andThen, $author$project$Ui$DerivativeBlockNestedSelect$toHierarchyItem(company), state.ia)
    };
  });

  var $author$project$Ui$DerivativeBlockNestedSelect$UnchoosableItem = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Util$isJustTrue = function (maybeBool) {
    return _Utils_eq(maybeBool, $elm$core$Maybe$Just(true));
  };

  var $author$project$Types$BuildingBlock$isUnallocatedBlock = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        var remoteData = _v0.a;

        var _v1 = $krisajenkins$remotedata$RemoteData$toMaybe(remoteData);

        if (!_v1.$) {
          var _v2 = _v1.a;
          var moneyPayload = _v2.b;
          return $elm$core$Maybe$Just($elm_community$maybe_extra$Maybe$Extra$isNothing(moneyPayload.kg));
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 2:
        var remoteData = _v0.a;

        var _v3 = $krisajenkins$remotedata$RemoteData$toMaybe(remoteData);

        if (!_v3.$) {
          var _v4 = _v3.a;
          var moneyPayload = _v4.b;
          return $elm$core$Maybe$Just($elm_community$maybe_extra$Maybe$Extra$isNothing(moneyPayload.kg));
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 1:
        return $elm$core$Maybe$Just(true);

      default:
        return $elm$core$Maybe$Just(true);
    }
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$shouldShowAsChildOf = F2(function (parent, potentialChild) {
    var _v0 = _Utils_Tuple2(parent, potentialChild);

    switch (_v0.a.$) {
      case 1:
        switch (_v0.b.$) {
          case 1:
            var parentClass = _v0.a.a;
            var class2 = _v0.b.a;
            var _v1 = class2.cW;

            if (!_v1.$) {
              var parentId = _v1.a;
              return _Utils_eq(parentId, parentClass.F);
            } else {
              return false;
            }

          case 2:
            var parentClass = _v0.a.a;
            var block = _v0.b.a;

            var _v2 = $author$project$Types$BuildingBlock$toAllocationClassId(block);

            if (!_v2.$) {
              var allocationClassId = _v2.a;
              return _Utils_eq(parentClass.F, allocationClassId);
            } else {
              var _v3 = $author$project$Types$BuildingBlock$toInternalOppositeAllocationClassId(block);

              if (!_v3.$) {
                var allocationClassId = _v3.a;
                return _Utils_eq(parentClass.F, allocationClassId);
              } else {
                return false;
              }
            }

          default:
            return false;
        }

      case 2:
        return false;

      default:
        return false;
    }
  });
  var $author$project$Ui$DerivativeBlockNestedSelect$toOptions = F2(function (maybeCurrentBlockId, company) {
    var toDivisionOption = F2(function (blocks, division) {
      var toTopAllocationClassTree = F2(function (remainingDependentBlocksAndAllocationClasses, currItem) {
        var _v1 = A2($elm$core$List$partition, $author$project$Ui$DerivativeBlockNestedSelect$shouldShowAsChildOf(currItem), remainingDependentBlocksAndAllocationClasses);

        var directDescendants = _v1.a;
        var remaining = _v1.b;

        var allocationClassChildren = function (list) {
          return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, list, $elm$core$Maybe$Nothing)), $elm$core$List$isEmpty(list));
        }(A2($elm$core$List$map, toTopAllocationClassTree(remaining), directDescendants));

        return {
          vU: allocationClassChildren,
          kN: $elm$core$Maybe$Nothing,
          Ax: $elm$core$Maybe$Nothing,
          hV: $elm$core$Maybe$Nothing,
          jM: true,
          Fw: currItem
        };
      });

      var _v2 = A2($elm$core$List$partition, A2($elm$core$Basics$composeR, function ($) {
        return $.cW;
      }, $elm_community$maybe_extra$Maybe$Extra$isNothing), $turboMaCk$any_dict$Dict$Any$values(division.oX));

      var allocationClassesWithNoParent = _v2.a;
      var allocationClassesWithParent = _v2.b;

      var dependentBlocksAndAllocationClasses = _Utils_ap(A2($elm$core$List$map, $author$project$Ui$DerivativeBlockNestedSelect$BlockItem, blocks), A2($elm$core$List$map, $author$project$Ui$DerivativeBlockNestedSelect$AllocationClassItem, allocationClassesWithParent));

      var divisionChildren = function (list) {
        return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, list, $elm$core$Maybe$Nothing)), $elm$core$List$isEmpty(list));
      }(A2($elm$core$List$map, A2($elm$core$Basics$composeL, toTopAllocationClassTree(dependentBlocksAndAllocationClasses), $author$project$Ui$DerivativeBlockNestedSelect$AllocationClassItem), allocationClassesWithNoParent));

      return {
        vU: divisionChildren,
        kN: $elm$core$Maybe$Nothing,
        Ax: $elm$core$Maybe$Nothing,
        hV: $elm$core$Maybe$Nothing,
        jM: false,
        Fw: $author$project$Ui$DerivativeBlockNestedSelect$UnchoosableItem(division.zL)
      };
    });
    var toTheOptions = F2(function (divisions, blocks) {
      var toUnallocatedBlock = function (buildingBlock) {
        return {
          vU: $elm$core$Maybe$Nothing,
          kN: $elm$core$Maybe$Nothing,
          Ax: $elm$core$Maybe$Nothing,
          hV: $elm$core$Maybe$Nothing,
          jM: true,
          Fw: $author$project$Ui$DerivativeBlockNestedSelect$BlockItem(buildingBlock)
        };
      };

      var excludeCurrentBlock = F2(function (currBlockId, theBlocks) {
        return A2($elm$core$List$filter, function (b) {
          return !_Utils_eq(b.F, currBlockId);
        }, theBlocks);
      });
      var divisionsWithAllocationClasses = A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
        return $.oX;
      }, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$isEmpty, $elm$core$Basics$not)), $turboMaCk$any_dict$Dict$Any$values(divisions));

      var _v0 = A2($elm$core$List$partition, A2($elm$core$Basics$composeR, $author$project$Types$BuildingBlock$isUnallocatedBlock, $author$project$ElmFramework$Lib$Util$isJustTrue), A4($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, excludeCurrentBlock, maybeCurrentBlockId, $turboMaCk$any_dict$Dict$Any$values(blocks)));

      var unallocatedBlocks = _v0.a;
      var allocatedBlocks = _v0.b;
      var unallocatedBlocksGroup = $elm$core$List$isEmpty(unallocatedBlocks) ? _List_Nil : _List_fromArray([{
        vU: $elm$core$Maybe$Just(A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, A2($elm$core$List$map, toUnallocatedBlock, unallocatedBlocks), $elm$core$Maybe$Nothing)),
        kN: $elm$core$Maybe$Just($author$project$IconSvg$blocks('w3 marRight1 gray20Fill')),
        Ax: $elm$core$Maybe$Nothing,
        hV: $elm$core$Maybe$Nothing,
        jM: false,
        Fw: $author$project$Ui$DerivativeBlockNestedSelect$UnchoosableItem('Unallocated Blocks')
      }]);
      return A2($author$project$ElmFramework$Lib$Ui$NestedSelect$Option$OptionList, _Utils_ap(A2($elm$core$List$map, toDivisionOption(allocatedBlocks), divisionsWithAllocationClasses), unallocatedBlocksGroup), $elm$core$Maybe$Nothing);
    });
    return A3($elm$core$Maybe$map2, toTheOptions, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO), $krisajenkins$remotedata$RemoteData$toMaybe(company.pg));
  });

  var $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$fromString = function (enumString____) {
    switch (enumString____) {
      case 'ASSET':
        return $elm$core$Maybe$Just(0);

      case 'EQUITY':
        return $elm$core$Maybe$Just(1);

      case 'EXPENSE_COGS':
        return $elm$core$Maybe$Just(2);

      case 'EXPENSE_OPERATING':
        return $elm$core$Maybe$Just(3);

      case 'EXPENSE_OTHER':
        return $elm$core$Maybe$Just(4);

      case 'INCOME':
        return $elm$core$Maybe$Just(5);

      case 'INCOME_OTHER':
        return $elm$core$Maybe$Just(6);

      case 'LIABILITY':
        return $elm$core$Maybe$Just(7);

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$System_allocation_class_enum$toString = function (_enum) {
    switch (_enum) {
      case 0:
        return 'Assets';

      case 1:
        return 'Equity';

      case 2:
        return 'Cost of Goods Sold';

      case 3:
        return 'Operating Expense';

      case 4:
        return 'Other Expense';

      case 5:
        return 'Income';

      case 6:
        return 'Other Income';

      default:
        return 'Liabilities';
    }
  };

  var $author$project$Types$AllocationClass$toSanitizedName = function (allocationClass) {
    return A2($elm$core$Maybe$withDefault, allocationClass.zL, A2($elm$core$Maybe$map, $author$project$Types$System_allocation_class_enum$toString, $author$project$Api$GraphqlSchema$Enum$System_allocation_class_enum$fromString(allocationClass.zL)));
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$toString = function (item) {
    switch (item.$) {
      case 0:
        var name = item.a;
        return name;

      case 1:
        var allocationClass = item.a;
        return $author$project$Types$AllocationClass$toSanitizedName(allocationClass);

      default:
        var buildingBlock = item.a;
        return '⧉ ' + buildingBlock.zL;
    }
  };

  var $author$project$Ui$DerivativeBlockNestedSelect$derivativeBlockNestedSelect = function (cfg) {
    return $author$project$Ui$NestedSelect$nestedSelect({
      vV: cfg.vV,
      yI: true,
      zO: '',
      e0: A2($author$project$Ui$DerivativeBlockNestedSelect$toOptions, cfg.wl, cfg.j),
      e3: 'Select Base',
      nY: $elm$core$Maybe$Nothing,
      Ej: A2($author$project$Ui$DerivativeBlockNestedSelect$mapToInternalState, cfg.j, cfg.Ej),
      b3: A2($elm$core$Basics$composeR, $author$project$Ui$DerivativeBlockNestedSelect$mapToExternalState, cfg.b3),
      fd: $elm$core$Basics$eq,
      t3: $author$project$Ui$DerivativeBlockNestedSelect$toString
    });
  };

  var $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$setBaseBasis = F2(function (payload, val) {
    return _Utils_update(payload, {
      fB: $elm$core$Maybe$Just(val)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativeMoneyPayload = F2(function (block, val) {
    return _Utils_update(block, {
      fP: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setDerivativeOf = F2(function (payload, val) {
    return _Utils_update(payload, {
      hk: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setEndOn = F2(function (payload, val) {
    return _Utils_update(payload, {
      ho: val
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setMultiplier = F2(function (payload, string) {
    return _Utils_update(payload, {
      r: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, string, payload.r)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setPer = F2(function (payload, string) {
    return _Utils_update(payload, {
      t: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, string, payload.t)
    });
  });

  var $author$project$Types$BuildingBlock$toBasis = function (buildingBlock) {
    return A2($elm$core$Maybe$map, function ($) {
      return $.pb;
    }, $author$project$Types$BuildingBlock$toMoneyPayload(buildingBlock));
  };

  var $author$project$Types$Company$toBaseBasis = F2(function (derivativeOf, company) {
    if (!derivativeOf.$) {
      var buildingBlockId = derivativeOf.a;
      return A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlock$toBasis, A2($author$project$Types$Company$toBuildingBlock, buildingBlockId, company));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$Types$BuildingBlock$toUnit = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        var remoteData = _v0.a;
        return A2($elm$core$Maybe$map, function (_v1) {
          var money = _v1.b;
          return $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString(money.V);
        }, $krisajenkins$remotedata$RemoteData$toMaybe(remoteData));

      case 1:
        var remoteData = _v0.a;
        return A2($elm$core$Maybe$map, function (_v2) {
          var thing = _v2.b;
          return thing.V;
        }, $krisajenkins$remotedata$RemoteData$toMaybe(remoteData));

      case 2:
        var remoteData = _v0.a;
        return A2($elm$core$Maybe$map, function (_v3) {
          var money = _v3.b;
          return $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString(money.V);
        }, $krisajenkins$remotedata$RemoteData$toMaybe(remoteData));

      default:
        var remoteData = _v0.a;
        return A2($elm$core$Maybe$map, function (_v4) {
          var thing = _v4.b;
          return thing.V;
        }, $krisajenkins$remotedata$RemoteData$toMaybe(remoteData));
    }
  };

  var $author$project$Ui$Block$EditDerivativeBlock$baseSection = function (cfg) {
    var baseUnitName = function () {
      var _v0 = $author$project$Ui$DerivativeBlockNestedSelect$toSelection(cfg.y.d2.hk);

      if (_v0.$ === 1) {
        return 'Base unit';
      } else {
        if (!_v0.a.$) {
          var blockId = _v0.a.a;
          return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlock$toUnit, A2($author$project$Types$Company$toBuildingBlock, blockId, cfg.j)));
        } else {
          return 'USD';
        }
      }
    }();

    var expandedContent = cfg.eG.o_.vh.ku || cfg.et ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft4 padRight4 padBottom4')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Base:'
    }), $author$project$Ui$DerivativeBlockNestedSelect$derivativeBlockNestedSelect({
      vV: 'flex1',
      j: cfg.j,
      wl: cfg.iO,
      Ej: cfg.y.d2.hk,
      b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setDerivativeOf(cfg.y.d2))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('hidden flexRow flexAlignCenter  marTop4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Type:'
    }), $author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
      vV: 'flex1',
      v_: $elm$core$Maybe$Just(3),
      wm: A2($elm$core$Maybe$withDefault, 1, A2($elm_community$maybe_extra$Maybe$Extra$orElse, A2($elm$core$Maybe$andThen, function (derivativeOf) {
        return A2($author$project$Types$Company$toBaseBasis, derivativeOf, cfg.j);
      }, $author$project$Ui$DerivativeBlockNestedSelect$toSelection(cfg.y.d2.hk)), cfg.y.fP.fB)),
      hH: _List_fromArray([_Utils_Tuple2(1, 'Cash'), _Utils_Tuple2(0, 'Accrual')]),
      BE: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativeMoneyPayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingDerivativeMoneyPayload$setBaseBasis(cfg.y.fP)),
      BP: 'minH4 padLeft4 padRight4'
    }), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$ElmFramework$Lib$Util$spacer('flex1')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter  marTop4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Period:'
    }), A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setStartOn(cfg.y)), A3($author$project$Ui$DateInput$DateInput$updateShort, cfg.eG.by, cfg.eG.EM, cfg.y.bw)), cfg.y.bw, cfg.eG.by), $author$project$ElmFramework$Lib$Util$spacer('w2'), A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setEndOn(cfg.y.d2)), A3($author$project$Ui$DateInput$DateInput$updateShort, cfg.eG.by, cfg.eG.EM, cfg.y.d2.ho)), cfg.y.d2.ho, cfg.eG.by)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Multiplier:'
    }), $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'flex1',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setMultiplier(cfg.y.d2)),
      e3: '',
      gx: false,
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(cfg.y.d2.r)
    }), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$Ui$MoneyOrThingInput$moneyOrThingInput({
      kG: 'flex1',
      si: A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setMoneyOrThing(cfg.y)),
      Fw: cfg.y.hO
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: $author$project$Ui$Block$EditBasicBlock$formItemLabelClasses,
      y$: 'Per:'
    }), $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'flex1',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setDerivativePayload(cfg.y)), $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$setPer(cfg.y.d2)),
      e3: '',
      gx: false,
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(cfg.y.d2.t)
    }), $author$project$ElmFramework$Lib$Util$spacer('w2'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 left heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(baseUnitName)]))]))])) : $author$project$ElmFramework$Lib$Util$noOpEl;

    if (cfg.et) {
      return expandedContent;
    } else {
      var blockTypeHydrated = A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlockHydrated$toHydratedType, A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toBlockType, cfg.j, cfg.y));
      var summary = A4($elm$core$Maybe$map3, $author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload(cfg.j), A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toStartOn, cfg.eG.by, cfg.y), blockTypeHydrated, A2($elm$core$Maybe$map, $author$project$Types$EditingBuildingBlock$EditingDerivativePayload$derivativePayloadReqToDerivativePayload, $elm$core$Result$toMaybe($author$project$Types$EditingBuildingBlock$EditingDerivativePayload$toDerivativePayloadReq(cfg.y.d2))));
      return A2($author$project$Ui$Sections$plainSectionButton, 'marTop2 betweenPhoneDesktopWidth', _List_fromArray([$author$project$Ui$Block$EditBasicBlock$sectionExtendedOrShrunken({
        g8: A2($author$project$Ui$Block$EditBasicBlock$showBetweenText, cfg.eG.o_.vh.ku, A2($elm$core$Maybe$withDefault, 'Define a base to the block.', summary)),
        hF: cfg.eG.o_.vh.ku,
        y$: 'Base Pattern',
        tU: $author$project$TopMsg$msgBlock($author$project$Ui$Block$Msg$OnTapBase)
      }), expandedContent]));
    }
  };

  var $author$project$Ui$TimeTransformation$Util$SecondaryTheme = 1;

  var $author$project$Ui$Block$DerivativeBlockTimeTransformView$derivativeBlockTimeTransformView = function (cfg) {
    var nowSimpleDate = A2($author$project$Types$SimpleDate$fromPosix, cfg.eG.by, cfg.eG.EM);

    var defaultStartDate = function () {
      var _v3 = _Utils_Tuple2(A2($elm$core$Maybe$withDefault, nowSimpleDate, A2($author$project$Ui$DateInput$DateInput$toSimpleDate, cfg.eG.by, cfg.y.bw)), _Utils_update(nowSimpleDate, {
        FP: nowSimpleDate.FP - 1
      }));

      var startOn = _v3.a;
      var aYearAgo = _v3.b;

      var _v4 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, startOn)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, aYearAgo)));

      var startOnMillis = _v4.a;
      var aYearAgoMillis = _v4.b;
      return _Utils_cmp(startOnMillis, aYearAgoMillis) < 0 ? aYearAgo : startOn;
    }();

    var defaultEndDate = function () {
      var _v1 = _Utils_Tuple2(A2($elm$core$Maybe$withDefault, A2($author$project$Types$SimpleDate$addMillis, 60 * 24 * 60 * 60 * 1000, defaultStartDate), A2($author$project$Ui$DateInput$DateInput$toSimpleDate, cfg.eG.by, cfg.y.d2.ho)), _Utils_update(nowSimpleDate, {
        FP: nowSimpleDate.FP + 1
      }));

      var endOn = _v1.a;
      var inAYear = _v1.b;

      var _v2 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, endOn)), $elm$time$Time$posixToMillis(A2($author$project$Types$SimpleDate$toPosix, cfg.eG.by, inAYear)));

      var endOnMillis = _v2.a;
      var inAYearMillis = _v2.b;
      return _Utils_cmp(endOnMillis, inAYearMillis) > 0 ? inAYear : endOn;
    }();

    var _v0 = _Utils_Tuple2(_Utils_update(defaultStartDate, {
      FP: defaultStartDate.FP - 1
    }), _Utils_update(defaultEndDate, {
      FP: defaultEndDate.FP + 1
    }));

    var startDate = _v0.a;
    var endDate = _v0.b;
    var inputChart = $author$project$Ui$TimeTransformation$SelectionGraph$SelectionStatus$shouldShowInputChart(cfg.y.d2.gM.DS) ? $author$project$Ui$TimeTransformation$InputGraph$View$inputGraph({
      vV: 'marTop2 pad4',
      bq: $author$project$Types$MoneyOrThing$toCurrency(cfg.y.hO),
      xv: endDate,
      Ck: cfg.y.d2.j5.ox,
      ss: cfg.tZ,
      D8: true,
      Eg: startDate,
      Ej: cfg.y.d2.gM,
      tY: 1,
      uh: cfg.y.d2.j5.ve
    }) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph({
      vL: $elm$core$Maybe$Nothing,
      vV: 'pad4',
      bq: $author$project$Types$MoneyOrThing$toCurrency(cfg.y.hO),
      xv: endDate,
      ss: cfg.tZ,
      Eg: startDate,
      Ej: cfg.y.d2.gM,
      tY: 1,
      uh: cfg.y.d2.j5.ve
    }), inputChart]));
  };

  var $author$project$Ui$Block$EditDerivativeBlock$derivativeBlockElements = function (cfg) {
    var moneyBlockTimeTransformInputValues = $turboMaCk$any_dict$Dict$Any$isEmpty(cfg.y.d2.j5.ox) ? cfg.y.d2.j5.ve : cfg.y.d2.j5.ox;

    var moneyBlockTimeTransform = function () {
      var _v0 = cfg.y.hO;

      if (!_v0.$) {
        return $author$project$Ui$Block$MoneyBlockBasisTimeTransformView$moneyBlockBasisTimeTransformView({
          y: cfg.y,
          j: cfg.j,
          yx: moneyBlockTimeTransformInputValues,
          mS: cfg.mS,
          bs: cfg.bs,
          Cj: cfg.y.cU.iy.ox,
          tZ: A2($elm$core$Basics$composeL, cfg.p0, $author$project$Types$EditingBuildingBlock$Msg$MoneyBasisTransformMsg),
          eG: cfg.eG
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return _Utils_Tuple2($author$project$Ui$Block$EditDerivativeBlock$baseSection(cfg), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Block$DerivativeBlockTimeTransformView$derivativeBlockTimeTransformView({
      y: cfg.y,
      tZ: A2($elm$core$Basics$composeL, cfg.p0, $author$project$Types$EditingBuildingBlock$Msg$DerivativeTimeTransformMsg),
      eG: cfg.eG
    }), $author$project$ElmFramework$Lib$Util$spacer('h4'), moneyBlockTimeTransform])));
  };

  var $author$project$Ui$Sections$plainSection = F2(function (classes, content) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back pad5 radius0'), $elm$html$Html$Attributes$class(classes)]), content);
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicOrDerivative = F2(function (block, val) {
    return _Utils_update(block, {
      g7: $elm$core$Maybe$Just(val)
    });
  });
  var $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setName = F2(function (block, val) {
    return _Utils_update(block, {
      zL: A2($author$project$ElmFramework$Lib$ViewModelStringTo$set, val, block.zL)
    });
  });
  var $author$project$Types$Company$toScenarioIdsForBuildingBlock = F2(function (company, blockId) {
    return A2($elm$core$List$map, function ($) {
      return $.e8;
    }, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$ElmFramework$Lib$PivotDict$getById2(blockId), $krisajenkins$remotedata$RemoteData$toMaybe(company.nT))));
  });

  var $author$project$Ui$Button$basicButtonMiddle = function (config) {
    return $author$project$Ui$Button$basicButtonVeryBasic({
      kG: config.kG + ' minH5',
      vY: config.vY,
      yh: config.yh,
      yM: config.yM,
      f9: config.f9,
      y$: config.y$
    });
  };

  var $author$project$UiWrappers$WithTopActionBar$toSidebarContent = function (cfg) {
    switch (cfg.$) {
      case 0:
        var theCfg = cfg.a;
        return _Utils_ap(_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom3 heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(theCfg.t1)]))]), theCfg.pD);

      case 1:
        var theCfg = cfg.a;
        return _Utils_ap(_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marBottom3')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(theCfg.z6), _List_Nil, _List_fromArray([$author$project$IconSvg$arrowLeft('primary30Fill w3')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 padLeft2 heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(theCfg.t1)]))]))]), theCfg.pD);

      default:
        var theCfg = cfg.a;
        return _Utils_ap(_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marBottom3')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(theCfg.t1)])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(theCfg.Aj), _List_fromArray([$elm$html$Html$Attributes$class('padLeft2')]), _List_fromArray([$author$project$IconSvg$close('primary30Fill w3')]))]))]), theCfg.pD);
    }
  };

  var $author$project$Ui$Block$EditBuildingBlockView$withTopActionBarCustom = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexColumn primary10Back')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth fullHeight flexRow padLeft7 padRight7 padTop2 padBottom2')]), cfg.oR), cfg.oW ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w44')]), _List_Nil) : $author$project$ElmFramework$Lib$Util$noOpEl]))])), function () {
      var _v0 = cfg.ta;

      if (!_v0.$) {
        var sidebarCfg = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 flexRow noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('desktopWidthCenter padTop6 padLeft2 padRight2 padBottom6 fullHeight')]), cfg.g9)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w43 scrollTarget flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 marTop16 pad3 primary0Back')]), $author$project$UiWrappers$WithTopActionBar$toSidebarContent(sidebarCfg))]))]));
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullHeight')]), cfg.g9);
      }
    }()]));
  };

  var $author$project$Ui$Block$EditBuildingBlockView$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$Ui$Block$EditBuildingBlockView$withTopActionBarCustom({
        oR: _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'padLeft2 padRight2',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.rd),
          y$: cfg.rc
        }), $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
          kG: '',
          vY: A3($author$project$ElmFramework$Lib$Util$ifElse, 0, 1, cfg.s6),
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.s8),
          y$: cfg.s7
        })]),
        oW: false,
        g9: cfg.g9,
        ta: cfg.s9
      })
    });
  };

  var $author$project$Ui$Block$EditBuildingBlockView$createEditBlock = function (cfg) {
    var viewTitle = $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: 'padLeft2',
      y$: A3($author$project$ElmFramework$Lib$Util$ifElse, 'Create a New Block', 'Edit block', $elm_community$maybe_extra$Maybe$Extra$isNothing(cfg.iO))
    });
    var nameSection = A2($author$project$Ui$Sections$plainSection, '', _List_fromArray([$author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'left',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      qW: false,
      e_: A2($elm$core$Basics$composeL, cfg.bs, $author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setName(cfg.y)),
      e3: 'Add Block Name',
      gx: false,
      Fw: $author$project$ElmFramework$Lib$ViewModelStringTo$toRaw(cfg.y.zL)
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: '',
      y$: 'Block Type:'
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2h',
      yC: _Utils_eq(cfg.y.g7, $elm$core$Maybe$Just(0)),
      y$: 'Basic Block',
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicOrDerivative, cfg.y, 0))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft3',
      yC: _Utils_eq(cfg.y.g7, $elm$core$Maybe$Just(1)),
      y$: 'Derivative Block',
      ew: cfg.bs(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicOrDerivative, cfg.y, 1))
    })]))]));

    var allocationSection = function () {
      var _v7 = _Utils_Tuple2(cfg.y.hO, cfg.y.g7);

      if (!_v7.a.$ && !_v7.b.$) {
        return $author$project$Ui$Block$EditBasicBlock$allocationPattern({
          y: cfg.y,
          j: cfg.j,
          p0: cfg.p0,
          et: false,
          mS: cfg.mS,
          bs: cfg.bs,
          eG: cfg.eG
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var _v0 = function () {
      var _v1 = _Utils_Tuple2(A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$toCreateBuildingBlockReq, cfg.j, cfg.y), cfg.iO);

      if (!_v1.a.$) {
        if (_v1.b.$ === 1) {
          var req = _v1.a.a;
          var _v2 = _v1.b;
          return _Utils_Tuple2(cfg.r8(req), true);
        } else {
          var req = _v1.a.a;
          var blockId = _v1.b.a;
          var scenariosWithOriginalBlock = A2($author$project$Types$Company$toScenarioIdsForBuildingBlock, cfg.j, blockId);
          var multipleScenarios = $elm$core$List$length(scenariosWithOriginalBlock) > 1;
          return !multipleScenarios ? _Utils_Tuple2(cfg.r8(req), true) : function (request) {
            return _Utils_Tuple2(request, true);
          }($author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A4($author$project$Global$Model$EditMasterBlock, cfg.j, blockId, $elm$core$Maybe$Nothing, scenariosWithOriginalBlock))));
        }
      } else {
        var err = _v1.a.a;
        return _Utils_Tuple2(A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil), false);
      }
    }();

    var submitMsg = _v0.a;
    var rightButtonHilight = _v0.b;

    var _v3 = function () {
      var _v4 = cfg.y.g7;

      if (!_v4.$) {
        if (!_v4.a) {
          var _v5 = _v4.a;
          return $author$project$Ui$Block$EditBasicBlock$basicBlockElements({
            y: cfg.y,
            j: cfg.j,
            p0: cfg.p0,
            et: false,
            mS: cfg.mS,
            bs: cfg.bs,
            eG: cfg.eG
          });
        } else {
          var _v6 = _v4.a;
          return $author$project$Ui$Block$EditDerivativeBlock$derivativeBlockElements({
            y: cfg.y,
            j: cfg.j,
            iO: cfg.iO,
            p0: cfg.p0,
            et: false,
            mS: cfg.mS,
            bs: cfg.bs,
            eG: cfg.eG
          });
        }
      } else {
        return _Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl);
      }
    }();

    var blockSectionsLeft = _v3.a;
    var blockSectionsRight = _v3.b;
    return $author$project$Ui$Block$EditBuildingBlockView$viewLayer({
      g9: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn fullHeight')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullHeight flexRow gapRow2 padLeft7 padRight7')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW72 scrollTarget padTop16 marBottom10 padBottom2')]), _List_fromArray([nameSection, blockSectionsLeft, allocationSection])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget padTop6 marBottom10 padBottom2')]), _List_fromArray([viewTitle, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop6')]), _List_fromArray([blockSectionsRight]))]))]))]))]),
      rc: 'Cancel & Back',
      rd: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
      s6: rightButtonHilight,
      s7: 'Save Block',
      s8: submitMsg,
      s9: $elm$core$Maybe$Nothing,
      eG: cfg.eG
    });
  };

  var $author$project$Views$Routed$EditBuldingBlockBranch$editBuildingBlockBranch = function (cfg) {
    var editBlockLayer = $author$project$Ui$Block$EditBuildingBlockView$createEditBlock({
      y: cfg.bv,
      j: cfg.j,
      iO: cfg.iO,
      p0: cfg.p0,
      mS: cfg.mS,
      bs: cfg.bs,
      r8: cfg.r8,
      eG: cfg.eG
    });
    var _v0 = cfg.kx;

    if (!_v0) {
      return _List_fromArray([editBlockLayer]);
    } else {
      return $elm$core$List$concat(_List_fromArray([_List_fromArray([editBlockLayer]), _List_Nil, $author$project$Views$Routed$EditBuldingBlockBranch$activeDialog(cfg.eG.o_.vh)]));
    }
  };

  var $author$project$Ui$ComponentsPreview$Msg$NoOp = {
    $: 41
  };

  var $author$project$Types$BuildingBlock$toCurrency = function (buildingBlock) {
    return A2($elm$core$Maybe$map, function ($) {
      return $.V;
    }, $author$project$Types$BuildingBlock$toMoneyPayload(buildingBlock));
  };

  var $author$project$Types$RepeatPattern$getEndAtCount = function (endAt) {
    if (!endAt.$) {
      var i = endAt.a;
      return $elm$core$Maybe$Just(i);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$RepeatPattern$getEndAtDate = function (endAt) {
    if (!endAt.$) {
      return $elm$core$Maybe$Nothing;
    } else {
      var d = endAt.a;
      return $elm$core$Maybe$Just(d);
    }
  };

  var $author$project$Types$BuildingBlock$isDerivative = function (block) {
    var _v0 = block.kw;

    switch (_v0.$) {
      case 3:
        return true;

      case 2:
        return true;

      default:
        return false;
    }
  };

  var $author$project$Types$BuildingBlock$toBasicPayload = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 0:
        if (_v0.a.$ === 3) {
          var _v1 = _v0.a.a;
          var basicPayload = _v1.a;
          return $elm$core$Maybe$Just(basicPayload);
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 1:
        if (_v0.a.$ === 3) {
          var _v2 = _v0.a.a;
          var basicPayload = _v2.a;
          return $elm$core$Maybe$Just(basicPayload);
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 2:
        return $elm$core$Maybe$Nothing;

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$BuildingBlock$toDerivativePayload = function (buildingBlock) {
    var _v0 = buildingBlock.kw;

    switch (_v0.$) {
      case 2:
        if (_v0.a.$ === 3) {
          var _v1 = _v0.a.a;
          var derivativePayload = _v1.a;
          return $elm$core$Maybe$Just(derivativePayload);
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 3:
        if (_v0.a.$ === 3) {
          var _v2 = _v0.a.a;
          var derivativePayload = _v2.a;
          return $elm$core$Maybe$Just(derivativePayload);
        } else {
          return $elm$core$Maybe$Nothing;
        }

      case 0:
        return $elm$core$Maybe$Nothing;

      default:
        return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Types$BuildingBlock$toEndDate = function (block) {
    if ($author$project$Types$BuildingBlock$isDerivative(block)) {
      return A2($elm$core$Maybe$map, function ($) {
        return $.ho;
      }, $author$project$Types$BuildingBlock$toDerivativePayload(block));
    } else {
      var maybeRepeatPattern = A2($elm$core$Maybe$map, function ($) {
        return $.h2;
      }, $author$project$Types$BuildingBlock$toBasicPayload(block));
      var fromDate = A2($elm$core$Basics$composeR, function ($) {
        return $.hn;
      }, $author$project$Types$RepeatPattern$getEndAtDate);

      var fromCount = function (repeatPattern) {
        return A2($elm$core$Maybe$map, function (count) {
          return A2($author$project$Types$SimpleDate$addMillis, repeatPattern.ao * $author$project$Types$RepeatPeriod$toMillis(repeatPattern.ap) * count, block.bw);
        }, $author$project$Types$RepeatPattern$getEndAtCount(repeatPattern.hn));
      };

      return A2($elm_community$maybe_extra$Maybe$Extra$or, A2($elm$core$Maybe$andThen, fromDate, maybeRepeatPattern), A2($elm$core$Maybe$andThen, fromCount, maybeRepeatPattern));
    }
  };

  var $author$project$Ui$OverLaysView$scenarioBlockDetailsOverlay = F3(function (topState, company, blockId) {
    var scenarios = A2($elm$core$Maybe$withDefault, _List_Nil, A2($author$project$Types$Company$toScenariosForBlock, blockId, company));
    var maybeBlock = A2($author$project$Types$Company$toBuildingBlock, blockId, company);
    var name = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, maybeBlock));
    var parentName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, A2($elm$core$Maybe$andThen, function (child) {
      return A2($author$project$Types$Company$toParentBuildingBlock, child, company);
    }, maybeBlock)));
    var description = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromBlock(company), maybeBlock));
    var blocksState = topState.o_.vl;

    var baseFlowResponseForCurrBlock = function () {
      var _v2 = blocksState.o9;

      if (!_v2.$) {
        var _v3 = _v2.a;
        var responseForBlock = _v3.a;
        var response = _v3.b;
        return _Utils_eq(responseForBlock, blockId) ? $elm$core$Maybe$Just(response) : $elm$core$Maybe$Nothing;
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var baseGraph = function () {
      var _v0 = _Utils_Tuple3(maybeBlock, baseFlowResponseForCurrBlock, A2($elm$core$Maybe$andThen, $author$project$Types$BuildingBlock$toEndDate, maybeBlock));

      if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
        var block = _v0.a.a;
        var response = _v0.b.a;
        var endDate = _v0.c.a;
        return $author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph({
          vL: $elm$core$Maybe$Nothing,
          vV: '',
          bq: $author$project$Types$BuildingBlock$toCurrency(block),
          xv: endDate,
          ss: function (_v1) {
            return $author$project$TopMsg$msgGlobal($author$project$Global$Msg$NoOp);
          },
          Eg: block.bw,
          Ej: $author$project$Ui$TimeTransformation$Model$empty,
          tY: 0,
          uh: $author$project$Api$Types$CharacterizeTimeTransformResponse$toValueOnDateDictFromFlowElem(response.ve)
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$WindowModal$windowModal({
        iw: _List_fromArray([$elm$html$Html$Attributes$class('z3')]),
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight3 marLeft3 flexColumn maxW62')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'marTop3 marBottom1',
          y$: 'Description:'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular primary30 marBottom3 ')]), _List_fromArray([$elm$html$Html$text(description)])), $author$project$UiWrappers$WindowModal$lineSeparator])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight3 marLeft3 flexColumn maxW62')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'marTop3 marBottom1',
          y$: 'Parent Block:'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold secondary0 marBottom3')]), _List_fromArray([$elm$html$Html$text(parentName)])), $author$project$UiWrappers$WindowModal$lineSeparator])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight3 marLeft3 flexColumn maxW62')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'marTop3 marBottom1',
          y$: 'Scenarios:'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular primary30 marBottom3 marLeft-0h marRight-0h')]), A2($elm$core$List$map, function (scenario) {
          return $author$project$Ui$FinancialBlock$scenarioLabel({
            y$: scenario.zL,
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          });
        }, scenarios)), $author$project$UiWrappers$WindowModal$lineSeparator])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight3 marLeft3 flexColumn maxW62')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'marTop3 marBottom1',
          y$: 'Base Graph:'
        }), baseGraph, $author$project$UiWrappers$WindowModal$lineSeparator])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight3 marLeft3 flexColumn maxW62')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween heading4Bold primary20 padTop1')]), _List_fromArray([$author$project$Ui$Button$textButton({
          kz: 'Edit Block',
          vV: ' fullWidth padTop1 padBottom2',
          gi: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Blocks(A2($author$project$Route$BlocksRoute$EditBlock, blockId, 0))))
        }), $author$project$Ui$Button$textButton({
          kz: 'Duplicate Block',
          vV: ' fullWidth padTop1 padBottom2',
          gi: $author$project$TopMsg$msgBlocks(A2($author$project$Ui$Blocks$Msg$OnDuplicate, company.F, blockId))
        }), $author$project$Ui$Button$textButton({
          kz: 'Delete Block',
          vV: ' fullWidth padTop1 padBottom2 secondary50',
          gi: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$DeleteBlock, company, blockId)))
        })]))]))]),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: name
      })
    });
  });
  var $author$project$Types$Filters$ClearFilters = {
    $: 7
  };
  var $author$project$UiWrappers$SlideOverRight$CloseBtnOnTheRight = 1;

  var $author$project$Types$Filters$UpdateAuthors = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$Filters$UpdateClassification = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$Filters$UpdateScenarios = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$UserSession$toUser = F2(function (session, id) {
    var thisUser = _Utils_eq(id, session.Fl.F) ? $elm$core$Maybe$Just(session.Fl) : $elm$core$Maybe$Nothing;
    return A2($elm_community$maybe_extra$Maybe$Extra$orElse, thisUser, A2($turboMaCk$any_dict$Dict$Any$get, id, session.Ft));
  });

  var $author$project$Ui$ScenarioBlocksFilters$scenarioBlocksFilters = function (_v0) {
    var company = _v0.j;
    var session = _v0.DY;
    var tag = _v0.b3;
    var filters = _v0.qo;
    var onRequestMsgTag = _v0.r$;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop4')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text('Filter by Author')])), function () {
      var toName = function (id) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Types$User$toFullName, A2($author$project$Types$UserSession$toUser, session, id)));
      };

      var authorDict = A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$User$unwrapUserId, A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)), A2($elm$core$List$map, function (id) {
        return _Utils_Tuple2(id, toName(id));
      }, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$map(F2(function (_v2, v) {
        return v.cC;
      })), $krisajenkins$remotedata$RemoteData$toMaybe(company.pg)))))));
      var userIds = A2($elm_community$list_extra$List$Extra$uniqueBy, $author$project$Types$User$unwrapUserId, $turboMaCk$any_dict$Dict$Any$keys(authorDict));
      return $author$project$Ui$SwitchDropdown$switchDropdown({
        uE: 'All Authors',
        kG: 'w35',
        zy: $elm$core$Maybe$Nothing,
        zT: 'No Author Selected',
        Ad: tag($author$project$Types$Filters$UpdateAuthors($turboMaCk$any_set$Set$Any$removeAll(filters.g0))),
        BF: tag($author$project$Types$Filters$UpdateAuthors(A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$User$unwrapUserId, userIds))),
        BX: F2(function (id, _v1) {
          return tag($author$project$Types$Filters$UpdateAuthors(A2($turboMaCk$any_set$Set$Any$toggle, id, filters.g0)));
        }),
        e0: $elm$core$Maybe$Just(authorDict),
        e3: 'Choose...',
        ia: filters.g0,
        t3: $elm$core$Basics$identity
      });
    }(), $author$project$Ui$ClassAllocationNestedSelect$classAllocationNestedSelect({
      vV: 'marTop3 w35',
      j: company,
      mH: $elm$core$Maybe$Nothing,
      Ax: $elm$core$Maybe$Nothing,
      hV: $elm$core$Maybe$Nothing,
      r$: onRequestMsgTag,
      e3: 'Choose...',
      nY: $elm$core$Maybe$Just('Filter by Classification'),
      tt: false,
      Ej: filters.hc,
      b3: A2($elm$core$Basics$composeR, $author$project$Types$Filters$UpdateClassification, tag)
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40 marTop3')]), _List_fromArray([$elm$html$Html$text('Filter by Scenario')])), function () {
      var maybeScenarios = $krisajenkins$remotedata$RemoteData$toMaybe(company.db);
      var scenarioIds = A2($elm$core$List$append, _List_fromArray([$elm$core$Maybe$Nothing]), A2($elm$core$List$map, A2($elm$core$Basics$composeR, function ($) {
        return $.F;
      }, $elm$core$Maybe$Just), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, maybeScenarios))));
      var scenarioInfo = A3($turboMaCk$any_dict$Dict$Any$insert, $elm$core$Maybe$Nothing, _Utils_Tuple2('Unassigned Blocks', $elm$core$Maybe$Nothing), A2($turboMaCk$any_dict$Dict$Any$map, F2(function (_v4, v) {
        return _Utils_Tuple2(v.zL, $elm$core$Maybe$Just(v.F));
      }), A2($turboMaCk$any_dict$Dict$Any$fromList, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Types$Scenario$unwrapScenarioId), $elm$core$Maybe$withDefault('')), A2($elm$core$List$map, $elm$core$Tuple$mapFirst($elm$core$Maybe$Just), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$toList, maybeScenarios))))));
      return $author$project$Ui$SwitchDropdown$switchDropdown({
        uE: 'All Scenarios',
        kG: 'w35',
        zy: $elm$core$Maybe$Nothing,
        zT: 'No Scenario Selected',
        Ad: tag($author$project$Types$Filters$UpdateScenarios($turboMaCk$any_set$Set$Any$removeAll(filters.db))),
        BF: tag($author$project$Types$Filters$UpdateScenarios(A2($turboMaCk$any_set$Set$Any$fromList, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Types$Scenario$unwrapScenarioId), $elm$core$Maybe$withDefault('')), scenarioIds))),
        BX: F2(function (id, _v3) {
          return tag($author$project$Types$Filters$UpdateScenarios(A2($turboMaCk$any_set$Set$Any$toggle, id, filters.db)));
        }),
        e0: $elm$core$Maybe$Just(scenarioInfo),
        e3: 'Choose...',
        ia: filters.db,
        t3: $elm$core$Tuple$first
      });
    }()]));
  };

  var $author$project$UiWrappers$SlideOverRight$titleBar = function (cfg) {
    var _v0 = cfg.tM;

    if (!_v0) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop5 padBottom5')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.Aj), _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock marRight2 middle')]), _List_fromArray([$author$project$IconSvg$arrowLeft('w4 primary30Fill marLeft-0h')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary30 middle')]), _List_fromArray([$elm$html$Html$text(cfg.t1)]))]));
    } else {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter padTop5 padBottom3')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary30')]), _List_fromArray([$elm$html$Html$text(cfg.t1)])), $author$project$ElmFramework$Lib$Util$spacer('flex1'), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.Aj), _List_fromArray([$elm$html$Html$Attributes$class('marLeft5')]), _List_fromArray([$author$project$IconSvg$close('w3 gray40Fill')]))]));
    }
  };

  var $author$project$UiWrappers$SlideOverRight$theModal = function (cfg) {
    return A2($author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr, _List_fromArray([$elm$html$Html$Attributes$class('block absolute top0 right0 bottom0 padRight5 padBottom5 padLeft5 primary0Back scrollTarget z3'), $elm$html$Html$Attributes$class(cfg.vV)]), A2($elm$core$List$cons, $author$project$UiWrappers$SlideOverRight$titleBar(cfg), cfg.pD));
  };

  var $author$project$UiWrappers$SlideOverRight$slideOverRight = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread'), $author$project$ElmFramework$Lib$Util$onTap(cfg.Aj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread primary30Back o2')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread')]), _List_fromArray([$author$project$UiWrappers$SlideOverRight$theModal(cfg)]))]));
  };

  var $author$project$Ui$OverLaysView$scenarioBlocksFiltersOverlay = F3(function (session, company, topState) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$SlideOverRight$slideOverRight({
        vV: '',
        pD: _List_fromArray([$author$project$Ui$ScenarioBlocksFilters$scenarioBlocksFilters({
          j: company,
          qo: topState.o_.vl.qo,
          r$: $author$project$TopMsg$requestMsg,
          DY: session,
          b3: A2($elm$core$Basics$composeR, $author$project$Ui$Blocks$Msg$OnFilterUpdate, $author$project$TopMsg$msgBlocks)
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop6')]), _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgBlocks($author$project$Ui$Blocks$Msg$OnFilterUpdate($author$project$Types$Filters$ClearFilters))),
          y$: 'Clear All'
        })]))]),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        tM: 1,
        t1: 'Filters'
      })
    });
  });

  var $author$project$Views$Routed$BlocksBranch$blocksBranch = function (cfg) {
    var _v0 = cfg.kx;

    switch (_v0.$) {
      case 0:
        if (_v0.a) {
          return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$BlocksBranch$blocksView({
            j: cfg.j,
            jb: false,
            DY: cfg.DY,
            eG: cfg.eG
          })]), _List_fromArray([A3($author$project$Ui$OverLaysView$scenarioBlocksFiltersOverlay, cfg.DY, cfg.j, cfg.eG)])]));
        } else {
          return _List_fromArray([$author$project$Views$Routed$BlocksBranch$blocksView({
            j: cfg.j,
            jb: false,
            DY: cfg.DY,
            eG: cfg.eG
          })]);
        }

      case 2:
        var blockId = _v0.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$BlocksBranch$blocksView({
          j: cfg.j,
          jb: false,
          DY: cfg.DY,
          eG: cfg.eG
        })]), _List_fromArray([A3($author$project$Ui$OverLaysView$scenarioBlockDetailsOverlay, cfg.eG, cfg.j, blockId)])]));

      case 3:
        var blockId = _v0.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$BlocksBranch$blocksView({
          j: cfg.j,
          jb: true,
          DY: cfg.DY,
          eG: cfg.eG
        })]), _List_fromArray([A3($author$project$Ui$OverLaysView$scenarioBlockDetailsOverlay, cfg.eG, cfg.j, blockId)])]));

      case 1:
        if (_v0.a) {
          return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$BlocksBranch$blocksView({
            j: cfg.j,
            jb: true,
            DY: cfg.DY,
            eG: cfg.eG
          })]), _List_fromArray([A3($author$project$Ui$OverLaysView$scenarioBlocksFiltersOverlay, cfg.DY, cfg.j, cfg.eG)])]));
        } else {
          return _List_fromArray([$author$project$Views$Routed$BlocksBranch$blocksView({
            j: cfg.j,
            jb: true,
            DY: cfg.DY,
            eG: cfg.eG
          })]);
        }

      case 4:
        var editBuildingBlockRoute = _v0.a;
        return $author$project$Views$Routed$EditBuldingBlockBranch$editBuildingBlockBranch({
          kx: editBuildingBlockRoute,
          j: cfg.j,
          bv: cfg.eG.o_.vh.bv,
          iO: $elm$core$Maybe$Nothing,
          p0: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BlockMsg), $author$project$Ui$Block$Msg$EditingBlockMsg),
          mS: A2($elm$core$Basics$composeL, cfg.mS, $author$project$Route$BlocksRoute$CreateBlock),
          bs: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BlockMsg), $author$project$Ui$Block$Msg$SetEditingBlock),
          r8: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg), $author$project$Remote$RequestMsg$CreateBlock(cfg.j.F)),
          eG: cfg.eG
        });

      default:
        var blockId = _v0.a;
        var editBuildingBlockRoute = _v0.b;
        return $author$project$Views$Routed$EditBuldingBlockBranch$editBuildingBlockBranch({
          kx: editBuildingBlockRoute,
          j: cfg.j,
          bv: cfg.eG.o_.vh.bv,
          iO: $elm$core$Maybe$Just(blockId),
          p0: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BlockMsg), $author$project$Ui$Block$Msg$EditingBlockMsg),
          mS: A2($elm$core$Basics$composeL, cfg.mS, $author$project$Route$BlocksRoute$EditBlock(blockId)),
          bs: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BlockMsg), $author$project$Ui$Block$Msg$SetEditingBlock),
          r8: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg), A3($author$project$Remote$RequestMsg$UpdateBlock, cfg.j.F, $elm$core$Maybe$Nothing, blockId)), $author$project$Api$Types$EditBlockReq$fromCreateBlockReqWithDefaultMultipleScenariosAction),
          eG: cfg.eG
        });
    }
  };

  var $author$project$Ui$Budget$Msg$OnMouseEnterComment = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Budget$Msg$OnMouseEnterPeriod = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Ui$Budget$Msg$OnMouseLeaveChart = {
    $: 8
  };

  var $author$project$Ui$Budget$Msg$OnTapComment = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Ui$Budget$Msg$OnTapPeriod = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Budget$Msg$OnYAxisSourceChanged = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Budget$Msg$ToggleExpandRow = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Button$IconAfterLabel = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$UsersTable$TextDarkBackgroundDark = 2;
  var $author$project$Ui$UsersTable$TextLightBackgroundLight = 1;

  var $author$project$IconSvg$arrowDown_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M32 20L29.885 17.885L21.5 26.255V8H18.5V26.255L10.13 17.87L8 20L20 32L32 20Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$arrowDown = function (classes) {
    return $author$project$IconSvg$arrowDown_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$Chart$BarAndLineChart$BarChart = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$Chart$BarAndLineChart$BoundsAutomaticWithDefaults = $elm$core$Basics$identity;
  var $author$project$Ui$Chart$BarAndLineChart$LabelsAndGuidesCount = $elm$core$Basics$identity;
  var $author$project$Ui$Chart$DoubleBarChart$Legend = 1;
  var $author$project$Ui$Chart$DoubleBarChart$Main = 2;
  var $author$project$Ui$Chart$DoubleBarChart$YAxis = 0;

  var $elm$svg$Svg$Attributes$alignmentBaseline = _VirtualDom_attribute('alignment-baseline');

  var $ianmackenzie$elm_geometry$Geometry$Types$Vector2d = $elm$core$Basics$identity;
  var $ianmackenzie$elm_geometry$Vector2d$minus = F2(function (_v0, _v1) {
    var v2 = _v0;
    var v1 = _v1;
    return {
      is: v1.is - v2.is,
      oK: v1.oK - v2.oK
    };
  });
  var $ianmackenzie$elm_geometry$Vector2d$plus = F2(function (_v0, _v1) {
    var v2 = _v0;
    var v1 = _v1;
    return {
      is: v1.is + v2.is,
      oK: v1.oK + v2.oK
    };
  });
  var $ianmackenzie$elm_geometry$Vector2d$scaleBy = F2(function (k, _v0) {
    var v = _v0;
    return {
      is: k * v.is,
      oK: k * v.oK
    };
  });
  var $folkertdev$one_true_path_experiment$Curve$cardinalPointHelper = F5(function (k, p0, p1, p2, p) {
    return _Utils_Tuple3(A2($ianmackenzie$elm_geometry$Vector2d$plus, p1, A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, k, A2($ianmackenzie$elm_geometry$Vector2d$minus, p0, p2))), A2($ianmackenzie$elm_geometry$Vector2d$plus, p2, A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, k, A2($ianmackenzie$elm_geometry$Vector2d$minus, p, p1))), p2);
  });
  var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;

  var $ianmackenzie$elm_units$Quantity$float = function (value) {
    return value;
  };

  var $ianmackenzie$elm_geometry$Vector2d$xy = F2(function (_v0, _v1) {
    var x = _v0;
    var y = _v1;
    return {
      is: x,
      oK: y
    };
  });
  var $ianmackenzie$elm_geometry$Vector2d$fromTuple = F2(function (toQuantity, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return A2($ianmackenzie$elm_geometry$Vector2d$xy, toQuantity(x), toQuantity(y));
  });
  var $folkertdev$one_true_path_experiment$Curve$mapTriplet = F2(function (f, _v0) {
    var a = _v0.a;
    var b = _v0.b;
    var c = _v0.c;
    return _Utils_Tuple3(f(a), f(b), f(c));
  });

  var $ianmackenzie$elm_units$Quantity$toFloat = function (_v0) {
    var value = _v0;
    return value;
  };

  var $ianmackenzie$elm_geometry$Vector2d$xComponent = function (_v0) {
    var v = _v0;
    return v.is;
  };

  var $ianmackenzie$elm_geometry$Vector2d$yComponent = function (_v0) {
    var v = _v0;
    return v.oK;
  };

  var $ianmackenzie$elm_geometry$Vector2d$toTuple = F2(function (fromQuantity, vector) {
    return _Utils_Tuple2(fromQuantity($ianmackenzie$elm_geometry$Vector2d$xComponent(vector)), fromQuantity($ianmackenzie$elm_geometry$Vector2d$yComponent(vector)));
  });
  var $folkertdev$one_true_path_experiment$Curve$cardinalPoint = F5(function (k, p0, p1, p2, p) {
    return A2($folkertdev$one_true_path_experiment$Curve$mapTriplet, $ianmackenzie$elm_geometry$Vector2d$toTuple($ianmackenzie$elm_units$Quantity$toFloat), A5($folkertdev$one_true_path_experiment$Curve$cardinalPointHelper, k, A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p0), A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p1), A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p2), A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p)));
  });

  var $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo = $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo;
  var $folkertdev$one_true_path_experiment$SubPath$Empty = {
    $: 1
  };
  var $folkertdev$one_true_path_experiment$SubPath$empty = $folkertdev$one_true_path_experiment$SubPath$Empty;

  var $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $folkertdev$one_true_path_experiment$LowLevel$Command$lineTo = $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo;
  var $folkertdev$one_true_path_experiment$LowLevel$Command$MoveTo = $elm$core$Basics$identity;
  var $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo = $elm$core$Basics$identity;

  var $folkertdev$one_true_path_experiment$SubPath$SubPath = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $folkertdev$elm_deque$Deque$Deque = $elm$core$Basics$identity;

  var $folkertdev$elm_deque$Internal$fromList = function (list) {
    return $folkertdev$elm_deque$Internal$rebalance({
      cN: list,
      c$: _List_Nil,
      cb: $elm$core$List$length(list),
      cc: 0
    });
  };

  var $folkertdev$elm_deque$Deque$fromList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $folkertdev$elm_deque$Internal$fromList);
  var $folkertdev$one_true_path_experiment$SubPath$with = F2(function (moveto, drawtos) {
    return $folkertdev$one_true_path_experiment$SubPath$SubPath({
      pW: $folkertdev$elm_deque$Deque$fromList(drawtos),
      rx: moveto
    });
  });
  var $folkertdev$one_true_path_experiment$Curve$cardinal = F2(function (tension, points) {
    var k = (1 - tension) / 6;
    var helper = F2(function (acc, remainingPoints) {
      helper: while (true) {
        if (remainingPoints.b && remainingPoints.b.b && remainingPoints.b.b.b) {
          if (remainingPoints.b.b.b.b) {
            var p0 = remainingPoints.a;
            var _v1 = remainingPoints.b;
            var p1 = _v1.a;
            var _v2 = _v1.b;
            var p2 = _v2.a;
            var _v3 = _v2.b;
            var p3 = _v3.a;
            var rest = _v3.b;
            var $temp$acc = A2($elm$core$List$cons, A5($folkertdev$one_true_path_experiment$Curve$cardinalPoint, k, p0, p1, p2, p3), acc),
                $temp$remainingPoints = A2($elm$core$List$cons, p1, A2($elm$core$List$cons, p2, A2($elm$core$List$cons, p3, rest)));
            acc = $temp$acc;
            remainingPoints = $temp$remainingPoints;
            continue helper;
          } else {
            var p0 = remainingPoints.a;
            var _v4 = remainingPoints.b;
            var p1 = _v4.a;
            var _v5 = _v4.b;
            var p2 = _v5.a;
            return $elm$core$List$reverse(A2($elm$core$List$cons, A5($folkertdev$one_true_path_experiment$Curve$cardinalPoint, k, p0, p1, p2, p1), acc));
          }
        } else {
          return _List_Nil;
        }
      }
    });

    if (points.b && points.b.b) {
      if (!points.b.b.b) {
        var p0 = points.a;
        var _v7 = points.b;
        var p1 = _v7.a;
        return A2($folkertdev$one_true_path_experiment$SubPath$with, $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0), _List_fromArray([$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(_List_fromArray([p1]))]));
      } else {
        var p0 = points.a;
        var _v8 = points.b;
        var p1 = _v8.a;
        var _v9 = _v8.b;
        var p2 = _v9.a;
        var rest = _v9.b;
        return A2($folkertdev$one_true_path_experiment$SubPath$with, $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0), _List_fromArray([$folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo(A2($elm$core$List$cons, A5($folkertdev$one_true_path_experiment$Curve$cardinalPoint, k, p1, p0, p1, p2), A2(helper, _List_Nil, points)))]));
      }
    } else {
      return $folkertdev$one_true_path_experiment$SubPath$empty;
    }
  });
  var $elm$core$Basics$sqrt = _Basics_sqrt;
  var $ianmackenzie$elm_units$Quantity$zero = 0;

  var $ianmackenzie$elm_geometry$Vector2d$length = function (_v0) {
    var v = _v0;
    var largestComponent = A2($elm$core$Basics$max, $elm$core$Basics$abs(v.is), $elm$core$Basics$abs(v.oK));

    if (!largestComponent) {
      return $ianmackenzie$elm_units$Quantity$zero;
    } else {
      var scaledY = v.oK / largestComponent;
      var scaledX = v.is / largestComponent;
      var scaledLength = $elm$core$Basics$sqrt(scaledX * scaledX + scaledY * scaledY);
      return scaledLength * largestComponent;
    }
  };

  var $folkertdev$one_true_path_experiment$Curve$catmullRomDistance = F3(function (alpha, p1, p2) {
    var _v0 = $ianmackenzie$elm_geometry$Vector2d$length(A2($ianmackenzie$elm_geometry$Vector2d$minus, p2, p1));

    var length = _v0;
    var l23_2a = A2($elm$core$Basics$pow, length * length, alpha);
    return _Utils_Tuple2($elm$core$Basics$sqrt(l23_2a), l23_2a);
  });
  var $folkertdev$one_true_path_experiment$Curve$epsilon = 1.0e-12;
  var $folkertdev$one_true_path_experiment$Curve$catmullRomPointHelper = F5(function (alpha, p0, p1, p2, p3) {
    var _v0 = A3($folkertdev$one_true_path_experiment$Curve$catmullRomDistance, alpha, p2, p3);

    var l23_a = _v0.a;
    var l23_2a = _v0.b;

    var _v1 = A3($folkertdev$one_true_path_experiment$Curve$catmullRomDistance, alpha, p1, p2);

    var l12_a = _v1.a;
    var l12_2a = _v1.b;

    var helper2 = function (p) {
      var m = 3 * l23_a * (l23_a + l12_a);
      var b = 2 * l23_2a + 3 * l23_a * l12_a + l12_2a;
      return A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, 1 / m, A2($ianmackenzie$elm_geometry$Vector2d$plus, A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, -l12_2a, p3), A2($ianmackenzie$elm_geometry$Vector2d$plus, A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, l23_2a, p1), A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, b, p))));
    };

    var control2 = _Utils_cmp(l23_a, $folkertdev$one_true_path_experiment$Curve$epsilon) > 0 ? helper2(p2) : p2;

    var _v2 = A3($folkertdev$one_true_path_experiment$Curve$catmullRomDistance, alpha, p0, p1);

    var l01_a = _v2.a;
    var l01_2a = _v2.b;

    var helper1 = function (p) {
      var n = 3 * l01_a * (l01_a + l12_a);
      var a = 2 * l01_2a + 3 * l01_a * l12_a + l12_2a;
      return A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, 1 / n, A2($ianmackenzie$elm_geometry$Vector2d$plus, A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, l01_2a, p2), A2($ianmackenzie$elm_geometry$Vector2d$minus, A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, l12_2a, p0), A2($ianmackenzie$elm_geometry$Vector2d$scaleBy, a, p))));
    };

    var control1 = _Utils_cmp(l01_a, $folkertdev$one_true_path_experiment$Curve$epsilon) > 0 ? helper1(p1) : p1;
    return _Utils_Tuple3(control1, control2, p2);
  });
  var $folkertdev$one_true_path_experiment$Curve$catmullRomPoint = F5(function (alpha, p0, p1, p2, p3) {
    return A2($folkertdev$one_true_path_experiment$Curve$mapTriplet, $ianmackenzie$elm_geometry$Vector2d$toTuple($ianmackenzie$elm_units$Quantity$toFloat), A5($folkertdev$one_true_path_experiment$Curve$catmullRomPointHelper, alpha, A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p0), A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p1), A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p2), A2($ianmackenzie$elm_geometry$Vector2d$fromTuple, $ianmackenzie$elm_units$Quantity$float, p3)));
  });
  var $folkertdev$one_true_path_experiment$Curve$reverseAccumulatorAppendClose = F2(function (accumulator, close) {
    return A3($elm$core$List$foldl, $elm$core$List$cons, close, accumulator);
  });
  var $folkertdev$one_true_path_experiment$Curve$catmullRomHelper = F4(function (alpha, ending, points, accumulator) {
    catmullRomHelper: while (true) {
      if (points.b && points.b.b && points.b.b.b) {
        if (!points.b.b.b.b) {
          var p0 = points.a;
          var _v1 = points.b;
          var p1 = _v1.a;
          var _v2 = _v1.b;
          var p2 = _v2.a;
          return A2($folkertdev$one_true_path_experiment$Curve$reverseAccumulatorAppendClose, accumulator, A3(ending, p0, p1, p2));
        } else {
          var p0 = points.a;
          var _v3 = points.b;
          var p1 = _v3.a;
          var _v4 = _v3.b;
          var p2 = _v4.a;
          var _v5 = _v4.b;
          var p = _v5.a;
          var rest = _v5.b;
          var $temp$alpha = alpha,
              $temp$ending = ending,
              $temp$points = A2($elm$core$List$cons, p1, A2($elm$core$List$cons, p2, A2($elm$core$List$cons, p, rest))),
              $temp$accumulator = A2($elm$core$List$cons, A5($folkertdev$one_true_path_experiment$Curve$catmullRomPoint, alpha, p0, p1, p2, p), accumulator);
          alpha = $temp$alpha;
          ending = $temp$ending;
          points = $temp$points;
          accumulator = $temp$accumulator;
          continue catmullRomHelper;
        }
      } else {
        return _List_Nil;
      }
    }
  });
  var $folkertdev$one_true_path_experiment$Curve$catmullRom = F2(function (alpha, points) {
    if (!alpha) {
      return A2($folkertdev$one_true_path_experiment$Curve$cardinal, 0, points);
    } else {
      if (points.b && points.b.b) {
        if (!points.b.b.b) {
          var p1 = points.a;
          var _v1 = points.b;
          var p2 = _v1.a;
          return A2($folkertdev$one_true_path_experiment$SubPath$with, $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p1), _List_fromArray([$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(_List_fromArray([p2]))]));
        } else {
          var p0 = points.a;
          var _v2 = points.b;
          var p1 = _v2.a;
          var _v3 = _v2.b;
          var p2 = _v3.a;
          var rest = _v3.b;
          var ending = F3(function (q0, q1, q2) {
            return _List_fromArray([A5($folkertdev$one_true_path_experiment$Curve$catmullRomPoint, alpha, q0, q1, q2, q2)]);
          });
          return A2($folkertdev$one_true_path_experiment$SubPath$with, $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0), _List_fromArray([$folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo(A4($folkertdev$one_true_path_experiment$Curve$catmullRomHelper, alpha, ending, A2($elm$core$List$cons, p0, points), _List_Nil))]));
        }
      } else {
        return $folkertdev$one_true_path_experiment$SubPath$empty;
      }
    }
  });
  var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');

  var $elm$svg$Svg$Attributes$dominantBaseline = _VirtualDom_attribute('dominant-baseline');

  var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');

  var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');

  var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
  var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');

  var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');

  var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');

  var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');

  var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;

  var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');

  var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');

  var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');

  var $author$project$Ui$Chart$BarAndLineChart$chartLegend = F2(function (config, data) {
    return A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$class('chart-legend')]), A2($elm$core$List$filterMap, function (_v0) {
      var index = _v0.a;
      var item = _v0.b;
      var textY = $elm$core$String$fromFloat(2);
      var textX = $elm$core$String$fromFloat(48);
      var groupY = $elm$core$String$fromFloat(config.dZ - 18);
      var groupX = $elm$core$String$fromFloat(config.fb - config.je * (index + 1));

      switch (item.$) {
        case 0:
          var name = item.a.zL;
          var fill = item.a.ln;
          return $elm$core$Maybe$Just(A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$transform('translate(' + (groupX + (',' + (groupY + ')'))))]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$fill(fill), $elm$svg$Svg$Attributes$width('40'), $elm$svg$Svg$Attributes$height('16'), $elm$svg$Svg$Attributes$rx('4')]), _List_Nil), A2($elm$svg$Svg$text_, _List_fromArray([$elm$svg$Svg$Attributes$textAnchor('start'), $elm$svg$Svg$Attributes$dominantBaseline('hanging'), $elm$svg$Svg$Attributes$transform('translate(' + (textX + (',' + (textY + ')')))), $elm$svg$Svg$Attributes$fontFamily('Karla, sans-serif'), $elm$svg$Svg$Attributes$fontSize('12px')]), _List_fromArray([$elm$svg$Svg$text(name)]))])));

        case 1:
          var name = item.a.zL;
          var strokeStopA = item.a.tK;
          var strokeStopB = item.a.tL;
          return $elm$core$Maybe$Just(A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$transform('translate(' + (groupX + (',' + (groupY + ')'))))]), _List_fromArray([A2($elm$svg$Svg$defs, _List_Nil, _List_fromArray([A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id(config.F + ('-legend-stroke-gradient' + $elm$core$String$fromInt(index)))]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0%'), $elm$svg$Svg$Attributes$stopColor(strokeStopA)]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('100%'), $elm$svg$Svg$Attributes$stopColor(strokeStopB)]), _List_Nil)]))])), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$stroke('url(#' + (config.F + ('-legend-stroke-gradient' + ($elm$core$String$fromInt(index) + ')')))), $elm$svg$Svg$Attributes$fill('none'), $elm$svg$Svg$Attributes$strokeWidth('4'), $elm$svg$Svg$Attributes$d('M 0,8 L 40,7.99')]), _List_Nil), A2($elm$svg$Svg$text_, _List_fromArray([$elm$svg$Svg$Attributes$textAnchor('start'), $elm$svg$Svg$Attributes$dominantBaseline('hanging'), $elm$svg$Svg$Attributes$transform('translate(' + (textX + (',' + (textY + ')')))), $elm$svg$Svg$Attributes$fontFamily('sans-serif'), $elm$svg$Svg$Attributes$fontFamily('Karla, sans-serif'), $elm$svg$Svg$Attributes$fontSize('12px')]), _List_fromArray([$elm$svg$Svg$text(name)]))])));

        default:
          return $elm$core$Maybe$Nothing;
      }
    }, config.re ? A2($elm$core$List$indexedMap, F2(function (index, item) {
      return _Utils_Tuple2(index, item);
    }), data) : _List_Nil));
  });
  var $elm$svg$Svg$foreignObject = $elm$svg$Svg$trustedNode('foreignObject');
  var $author$project$Ui$Chart$BarAndLineChart$indexOfPrime = F3(function (list, item, index) {
    indexOfPrime: while (true) {
      if (!list.b) {
        return -1;
      } else {
        var first = list.a;
        var rest = list.b;

        if (_Utils_eq(first, item)) {
          return index;
        } else {
          var $temp$list = rest,
              $temp$item = item,
              $temp$index = index + 1;
          list = $temp$list;
          item = $temp$item;
          index = $temp$index;
          continue indexOfPrime;
        }
      }
    }
  });
  var $author$project$Ui$Chart$BarAndLineChart$indexOf = F2(function (list, item) {
    return A3($author$project$Ui$Chart$BarAndLineChart$indexOfPrime, list, item, 0);
  });
  var $author$project$Ui$Chart$BarAndLineChart$labelsAndGuidesRounded = F5(function (defaultCount, yAxisLowerBounds, yAxisUpperBounds, yAxisRange, valueToLabel) {
    var unroundedUnit = yAxisRange / (defaultCount - 1);
    var x = $elm$core$Basics$ceiling(A2($elm$core$Basics$logBase, 10, unroundedUnit) - 1);
    var power10x = A2($elm$core$Basics$pow, 10, x);
    var unit = power10x * $elm$core$Basics$ceiling(unroundedUnit / power10x);
    var bothPositiveAndNegative = yAxisLowerBounds < 0 && yAxisUpperBounds > 0;
    var baseList = A2($elm$core$List$map, function (multiple) {
      var value = yAxisLowerBounds + unit * multiple;
      return {
        hy: true,
        y$: valueToLabel(value),
        Fw: value
      };
    }, A2($elm$core$List$range, 0, defaultCount - 1));
    return bothPositiveAndNegative && !A2($elm$core$List$any, function (_v0) {
      var value = _v0.Fw;
      return !value;
    }, baseList) ? $elm$core$List$concat(_List_fromArray([A2($elm$core$List$filter, function (_v1) {
      var value = _v1.Fw;
      return $elm$core$Basics$abs(value / yAxisRange) > 0.1;
    }, baseList), _List_fromArray([{
      hy: true,
      y$: valueToLabel(0),
      Fw: 0
    }])])) : baseList;
  });
  var $author$project$Ui$Chart$BarAndLineChart$labelsAndGuidesDefault = $author$project$Ui$Chart$BarAndLineChart$labelsAndGuidesRounded;
  var $elm$core$List$map3 = _List_map3;

  var $elm$core$List$maximum = function (list) {
    if (list.b) {
      var x = list.a;
      var xs = list.b;
      return $elm$core$Maybe$Just(A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $elm$core$List$minimum = function (list) {
    if (list.b) {
      var x = list.a;
      var xs = list.b;
      return $elm$core$Maybe$Just(A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Chart$BarAndLineChart$CategoryEventData = F9(function (offsetX, offsetY, pageX, pageY, chartId, seriesId, name, value, category) {
    return {
      ek: category,
      po: chartId,
      zL: name,
      rH: offsetX,
      rI: offsetY,
      sp: pageX,
      sq: pageY,
      DX: seriesId,
      Fw: value
    };
  });
  var $author$project$Ui$Chart$BarAndLineChart$decodeApply = F2(function (value, partial) {
    return A2($elm$json$Json$Decode$andThen, function (p) {
      return A2($elm$json$Json$Decode$map, p, value);
    }, partial);
  });
  var $author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForCategory = F5(function (chartId, seriesId, name, value, category) {
    return A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(category), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(value), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(name), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(seriesId), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(chartId), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['pageY']), $elm$json$Json$Decode$int), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['pageX']), $elm$json$Json$Decode$int), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['offsetY']), $elm$json$Json$Decode$int), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['offsetX']), $elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Ui$Chart$BarAndLineChart$CategoryEventData))))))))));
  });
  var $author$project$Ui$Chart$BarAndLineChart$FloatingIndicatorEventData = F8(function (offsetX, offsetY, pageX, pageY, chartId, value, category, floatingIndicatorData) {
    return {
      ek: category,
      po: chartId,
      qu: floatingIndicatorData,
      rH: offsetX,
      rI: offsetY,
      sp: pageX,
      sq: pageY,
      Fw: value
    };
  });
  var $author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForFloatingIndicator = F4(function (chartId, value, category, floatingIndicatorData) {
    return A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(floatingIndicatorData), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(category), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(value), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, $elm$json$Json$Decode$succeed(chartId), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['pageY']), $elm$json$Json$Decode$int), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['pageX']), $elm$json$Json$Decode$int), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['offsetY']), $elm$json$Json$Decode$int), A2($author$project$Ui$Chart$BarAndLineChart$decodeApply, A2($elm$json$Json$Decode$at, _List_fromArray(['offsetX']), $elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Ui$Chart$BarAndLineChart$FloatingIndicatorEventData)))))))));
  });
  var $author$project$Ui$Chart$BarAndLineChart$padListTransformingEnds = F3(function (list, transformFirst, transformLast) {
    var last = $elm$core$List$head($elm$core$List$reverse(list));
    var first = $elm$core$List$head(list);

    if (first.$ === 1) {
      return _List_Nil;
    } else {
      var f = first.a;

      if (last.$ === 1) {
        return _List_Nil;
      } else {
        var l = last.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([transformFirst(f)]), list, _List_fromArray([transformLast(l)])]));
      }
    }
  });
  var $author$project$Ui$Chart$BarAndLineChart$roundedRectangleDown = F6(function (fill, radius, x, y, width, height) {
    var radiusStr = $elm$core$String$fromFloat(radius);
    return A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$stroke('none'), $elm$svg$Svg$Attributes$fill(fill), $elm$svg$Svg$Attributes$d('' + ('M' + ($elm$core$String$fromFloat(x) + (',' + ($elm$core$String$fromFloat(y) + ' '))) + ('h' + ($elm$core$String$fromFloat(width) + ' ') + ('v' + ($elm$core$String$fromFloat(-height - radius) + ' ') + ('a' + (radiusStr + (',' + (radiusStr + (' 0 0 1 -' + (radiusStr + (',' + (radiusStr + ' '))))))) + ('h' + ($elm$core$String$fromFloat(-width + radius + radius) + ' ') + ('a' + (radiusStr + (',' + (radiusStr + (' 0 0 1 -' + (radiusStr + (',-' + (radiusStr + ' '))))))) + ('v' + ($elm$core$String$fromFloat(height + radius) + ' ') + 'z'))))))))]), _List_Nil);
  });
  var $author$project$Ui$Chart$BarAndLineChart$roundedRectangleUp = F6(function (fill, radius, x, y, width, height) {
    var radiusStr = $elm$core$String$fromFloat(radius);
    return A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$stroke('none'), $elm$svg$Svg$Attributes$fill(fill), $elm$svg$Svg$Attributes$d('' + ('M' + ($elm$core$String$fromFloat(x) + (',' + ($elm$core$String$fromFloat(y) + ' '))) + ('h' + ($elm$core$String$fromFloat(width) + ' ') + ('v' + ($elm$core$String$fromFloat(-height + radius) + ' ') + ('a' + (radiusStr + (',' + (radiusStr + (' 0 0 0 -' + (radiusStr + (',-' + (radiusStr + ' '))))))) + ('h' + ($elm$core$String$fromFloat(-width + radius + radius) + ' ') + ('a' + (radiusStr + (',' + (radiusStr + (' 0 0 0 -' + (radiusStr + (',' + (radiusStr + ' '))))))) + ('v' + ($elm$core$String$fromFloat(height - radius) + ' ') + 'z'))))))))]), _List_Nil);
  });
  var $author$project$Ui$Chart$BarAndLineChart$scale = F3(function (_v0, height, value) {
    var upper = _v0.gQ;
    var lower = _v0.eW;
    var range = upper - lower;
    var adjusted = value - lower;
    return adjusted / range * height;
  });

  var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');

  var $folkertdev$elm_deque$Deque$empty = $folkertdev$elm_deque$Internal$empty;
  var $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath = {
    $: 4
  };

  var $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $folkertdev$one_true_path_experiment$LowLevel$Command$merge = F2(function (instruction1, instruction2) {
    var _v0 = _Utils_Tuple2(instruction1, instruction2);

    _v0$5: while (true) {
      switch (_v0.a.$) {
        case 0:
          if (!_v0.b.$) {
            var p1 = _v0.a.a;
            var p2 = _v0.b.a;
            return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(_Utils_ap(p1, p2)));
          } else {
            break _v0$5;
          }

        case 1:
          if (_v0.b.$ === 1) {
            var p1 = _v0.a.a;
            var p2 = _v0.b.a;
            return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(_Utils_ap(p1, p2)));
          } else {
            break _v0$5;
          }

        case 2:
          if (_v0.b.$ === 2) {
            var p1 = _v0.a.a;
            var p2 = _v0.b.a;
            return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(_Utils_ap(p1, p2)));
          } else {
            break _v0$5;
          }

        case 3:
          if (_v0.b.$ === 3) {
            var p1 = _v0.a.a;
            var p2 = _v0.b.a;
            return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(_Utils_ap(p1, p2)));
          } else {
            break _v0$5;
          }

        default:
          if (_v0.b.$ === 4) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath);
          } else {
            break _v0$5;
          }

      }
    }

    return $elm$core$Result$Err(_Utils_Tuple2(instruction1, instruction2));
  });

  var $folkertdev$elm_deque$Internal$toList = function (deque) {
    return _Utils_ap(deque.cN, $elm$core$List$reverse(deque.c$));
  };

  var $folkertdev$elm_deque$Deque$unwrap = function (_v0) {
    var boundedDeque = _v0;
    return boundedDeque;
  };

  var $folkertdev$elm_deque$Deque$toList = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$toList, $folkertdev$elm_deque$Deque$unwrap);

  var $folkertdev$one_true_path_experiment$SubPath$compressHelper = function (drawtos) {
    var folder = F2(function (instruction, _v3) {
      var previous = _v3.a;
      var accum = _v3.b;

      var _v2 = A2($folkertdev$one_true_path_experiment$LowLevel$Command$merge, previous, instruction);

      if (!_v2.$) {
        var merged = _v2.a;
        return _Utils_Tuple2(merged, accum);
      } else {
        return _Utils_Tuple2(instruction, A2($elm$core$List$cons, previous, accum));
      }
    });

    var _v0 = $folkertdev$elm_deque$Deque$toList(drawtos);

    if (!_v0.b) {
      return $folkertdev$elm_deque$Deque$empty;
    } else {
      var first = _v0.a;
      var rest = _v0.b;
      return $folkertdev$elm_deque$Deque$fromList($elm$core$List$reverse(function (_v1) {
        var a = _v1.a;
        var b = _v1.b;
        return A2($elm$core$List$cons, a, b);
      }(A3($elm$core$List$foldl, folder, _Utils_Tuple2(first, _List_Nil), rest))));
    }
  };

  var $folkertdev$one_true_path_experiment$SubPath$compress = function (subpath) {
    if (subpath.$ === 1) {
      return $folkertdev$one_true_path_experiment$SubPath$Empty;
    } else {
      var data = subpath.a;
      return $folkertdev$one_true_path_experiment$SubPath$SubPath(_Utils_update(data, {
        pW: $folkertdev$one_true_path_experiment$SubPath$compressHelper(data.pW)
      }));
    }
  };

  var $folkertdev$svg_path_lowlevel$Path$LowLevel$DecimalPlaces = $elm$core$Basics$identity;
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces = $elm$core$Basics$identity;
  var $folkertdev$one_true_path_experiment$SubPath$defaultConfig = {
    iN: $elm$core$Maybe$Nothing,
    ji: false
  };
  var $folkertdev$one_true_path_experiment$SubPath$optionFolder = F2(function (option, config) {
    if (!option.$) {
      var n = option.a;
      return _Utils_update(config, {
        iN: $elm$core$Maybe$Just(n)
      });
    } else {
      return _Utils_update(config, {
        ji: true
      });
    }
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$Absolute = 1;
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath = {
    $: 8
  };
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });

  var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo = function (drawto) {
    switch (drawto.$) {
      case 0:
        var coordinates = drawto.a;
        return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo, 1, coordinates);

      case 1:
        var coordinates = drawto.a;
        return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo, 1, coordinates);

      case 2:
        var coordinates = drawto.a;
        return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo, 1, coordinates);

      case 3:
        var _arguments = drawto.a;
        return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc, 1, _arguments);

      default:
        return $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath;
    }
  };

  var $folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo = function (_v0) {
    var target = _v0;
    return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo, 1, target);
  };

  var $folkertdev$one_true_path_experiment$SubPath$toLowLevel = function (subpath) {
    if (subpath.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var moveto = subpath.a.rx;
      var drawtos = subpath.a.pW;
      return $elm$core$Maybe$Just({
        pW: A2($elm$core$List$map, $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo, $folkertdev$elm_deque$Deque$toList(drawtos)),
        rx: $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo(moveto)
      });
    }
  };

  var $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig = {
    hw: $elm$core$String$fromFloat
  };
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo = F2(function (n, value) {
    if (!n) {
      return $elm$core$String$fromInt($elm$core$Basics$round(value));
    } else {
      var sign = value < 0.0 ? '-' : '';
      var exp = A2($elm$core$Basics$pow, 10, n);
      var raised = $elm$core$Basics$abs($elm$core$Basics$round(value * exp));
      var decimals = raised % exp;
      return !decimals ? _Utils_ap(sign, $elm$core$String$fromInt(raised / exp | 0)) : sign + ($elm$core$String$fromInt(raised / exp | 0) + ('.' + $elm$core$String$fromInt(decimals)));
    }
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder = F2(function (option, config) {
    var n = option;
    return _Utils_update(config, {
      hw: $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo(n)
    });
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions = A2($elm$core$List$foldl, $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder, $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig);

  var $folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty = function (command) {
    switch (command.$) {
      case 0:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 1:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 2:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 3:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 4:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 5:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 6:
        var mode = command.a;
        var coordinates = command.b;
        return $elm$core$List$isEmpty(coordinates);

      case 7:
        var mode = command.a;
        var _arguments = command.b;
        return $elm$core$List$isEmpty(_arguments);

      default:
        return false;
    }
  };

  var $elm$core$Char$toLower = _Char_toLower;
  var $elm$core$Char$toUpper = _Char_toUpper;
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter = F2(function (mode, character) {
    if (mode === 1) {
      return $elm$core$String$fromChar($elm$core$Char$toUpper(character));
    } else {
      return $elm$core$String$fromChar($elm$core$Char$toLower(character));
    }
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate = F2(function (config, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return config.hw(x) + (',' + config.hw(y));
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2 = F2(function (config, _v0) {
    var c1 = _v0.a;
    var c2 = _v0.b;
    return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2));
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3 = F2(function (config, _v0) {
    var c1 = _v0.a;
    var c2 = _v0.b;
    var c3 = _v0.c;
    return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + (A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c3))));
  });

  var $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags = function (_v0) {
    var arcFlag = _v0.a;
    var direction = _v0.b;

    var _v1 = _Utils_Tuple2(arcFlag, direction);

    if (_v1.a === 1) {
      if (!_v1.b) {
        var _v2 = _v1.a;
        var _v3 = _v1.b;
        return _Utils_Tuple2(1, 0);
      } else {
        var _v6 = _v1.a;
        var _v7 = _v1.b;
        return _Utils_Tuple2(1, 1);
      }
    } else {
      if (!_v1.b) {
        var _v4 = _v1.a;
        var _v5 = _v1.b;
        return _Utils_Tuple2(0, 0);
      } else {
        var _v8 = _v1.a;
        var _v9 = _v1.b;
        return _Utils_Tuple2(0, 1);
      }
    }
  };

  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument = F2(function (config, _v0) {
    var radii = _v0.ey;
    var xAxisRotate = _v0.eh;
    var arcFlag = _v0.km;
    var direction = _v0.kZ;
    var target = _v0.d_;

    var _v1 = $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags(_Utils_Tuple2(arcFlag, direction));

    var arc = _v1.a;
    var sweep = _v1.b;
    return A2($elm$core$String$join, ' ', _List_fromArray([A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, radii), $elm$core$String$fromFloat(xAxisRotate), $elm$core$String$fromInt(arc), $elm$core$String$fromInt(sweep), A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, target)]));
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo = F2(function (config, command) {
    if ($folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty(command)) {
      return '';
    } else {
      switch (command.$) {
        case 0:
          var mode = command.a;
          var coordinates = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'L'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config), coordinates)));

        case 1:
          var mode = command.a;
          var coordinates = command.b;
          return $elm$core$List$isEmpty(coordinates) ? '' : _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'H'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));

        case 2:
          var mode = command.a;
          var coordinates = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'V'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));

        case 3:
          var mode = command.a;
          var coordinates = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'C'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3(config), coordinates)));

        case 4:
          var mode = command.a;
          var coordinates = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'S'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config), coordinates)));

        case 5:
          var mode = command.a;
          var coordinates = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'Q'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config), coordinates)));

        case 6:
          var mode = command.a;
          var coordinates = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'T'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config), coordinates)));

        case 7:
          var mode = command.a;
          var _arguments = command.b;
          return _Utils_ap(A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'A'), A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument(config), _arguments)));

        default:
          return 'Z';
      }
    }
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo = F2(function (config, _v0) {
    var mode = _v0.a;
    var coordinate = _v0.b;

    if (mode === 1) {
      return 'M' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
    } else {
      return 'm' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
    }
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath = F2(function (config, _v0) {
    var moveto = _v0.rx;
    var drawtos = _v0.pW;
    return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo, config, moveto) + (' ' + A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo(config), drawtos)));
  });
  var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith = F2(function (options, subpaths) {
    var config = $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions(options);
    return A2($elm$core$String$join, ' ', A2($elm$core$List$map, $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath(config), subpaths));
  });
  var $folkertdev$one_true_path_experiment$SubPath$toStringWith = F2(function (options, subpath) {
    var config = A3($elm$core$List$foldl, $folkertdev$one_true_path_experiment$SubPath$optionFolder, $folkertdev$one_true_path_experiment$SubPath$defaultConfig, options);

    var lowLevelOptions = function () {
      var _v0 = config.iN;

      if (_v0.$ === 1) {
        return _List_Nil;
      } else {
        var n = _v0.a;
        return _List_fromArray([$folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces(n)]);
      }
    }();

    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith(lowLevelOptions), $elm$core$List$singleton), $folkertdev$one_true_path_experiment$SubPath$toLowLevel((config.ji ? $folkertdev$one_true_path_experiment$SubPath$compress : $elm$core$Basics$identity)(subpath))));
  });

  var $folkertdev$one_true_path_experiment$SubPath$toString = function (subpath) {
    return A2($folkertdev$one_true_path_experiment$SubPath$toStringWith, _List_Nil, subpath);
  };

  var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');

  var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');

  var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');

  var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');

  var $author$project$Ui$Chart$BarAndLineChart$chart = F2(function (config, data) {
    var yAxisBounds = function () {
      var _v21 = config.cd.vy;
      var b = _v21;
      var allValues = A2($elm$core$List$concatMap, function (item) {
        switch (item.$) {
          case 0:
            var values = item.a.ir;
            return A2($elm$core$List$filterMap, $elm$core$Basics$identity, values);

          case 1:
            var values = item.a.ir;
            return values;

          default:
            var value = item.a.Fw;
            return _List_fromArray([value]);
        }
      }, data);
      var lower = A2($elm$core$Maybe$withDefault, b.eW, $elm$core$List$minimum($elm$core$List$concat(_List_fromArray([_List_fromArray([b.eW]), allValues]))));
      var upper = A2($elm$core$Maybe$withDefault, b.gQ, $elm$core$List$maximum($elm$core$List$concat(_List_fromArray([_List_fromArray([b.gQ]), allValues]))));
      return {
        eW: lower,
        gQ: upper
      };
    }();

    var yAxisRange = yAxisBounds.gQ - yAxisBounds.eW;

    var labelsAndGuides = function () {
      var _v20 = config.cd.y3;
      var count = _v20;
      return A5($author$project$Ui$Chart$BarAndLineChart$labelsAndGuidesDefault, count, yAxisBounds.eW, yAxisBounds.gQ, yAxisRange, config.cd.Fy);
    }();

    var guideColor = '#f6eff0';
    var chartVerticalArea = config.dZ - config.dv.x6 - config.ro;
    var scaleInstance = A2($author$project$Ui$Chart$BarAndLineChart$scale, yAxisBounds, chartVerticalArea);
    var chartHorizontalArea = config.fb - config.cd.FE;
    var chartBaselineY = config.dZ - config.dv.x6;
    var categoryCount = A2($elm$core$Maybe$withDefault, 1, $elm$core$List$maximum(A2($elm$core$List$cons, $elm$core$List$length(config.dv.hb), A2($elm$core$List$map, function (item) {
      switch (item.$) {
        case 0:
          var values = item.a.ir;
          return $elm$core$List$length(values);

        case 1:
          var values = item.a.ir;
          return $elm$core$List$length(values);

        default:
          return 1;
      }
    }, data))));
    var categoryWidth = chartHorizontalArea / categoryCount;
    var barRadius = 4;
    var barGroupCount = A2($elm$core$Basics$max, 1, A3($elm$core$List$foldr, F2(function (item, barCount) {
      if (!item.$) {
        return barCount + 1;
      } else {
        return barCount;
      }
    }), 0, data));
    var barWidth = categoryWidth / (barGroupCount + 1 + (barGroupCount - 1) * 0.25);
    var barSpacingWithinGroups = barGroupCount <= 1 ? 0 : (categoryWidth - barWidth * (barGroupCount + 1)) / (barGroupCount - 1);
    var barBottomY = yAxisBounds.eW < 0 ? chartBaselineY - scaleInstance(0) : chartBaselineY;
    return A2($elm$html$Html$div, A2($elm$core$List$append, _List_fromArray([$elm$html$Html$Attributes$id(config.F)]), config.kM), _List_fromArray([A2($elm$svg$Svg$svg, A2($elm$core$List$append, _List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 ' + ($elm$core$String$fromFloat(config.fb) + (' ' + $elm$core$String$fromFloat(config.dZ)))), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpAttr, $elm$html$Html$Events$onMouseLeave, config.rT)]), config.os), $elm$core$List$concat(_List_fromArray([_List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$class('chart-guides')]), A2($elm$core$List$filterMap, function (item) {
      var _v0 = item.hy;

      if (!_v0) {
        return $elm$core$Maybe$Nothing;
      } else {
        return $elm$core$Maybe$Just(A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$stroke(guideColor), $elm$svg$Svg$Attributes$fill('none'), $elm$svg$Svg$Attributes$d('' + ('M' + ($elm$core$String$fromFloat(config.cd.FE) + (',' + ($elm$core$String$fromFloat(chartBaselineY - scaleInstance(item.Fw)) + ' '))) + ('h' + ($elm$core$String$fromFloat(chartHorizontalArea) + ' '))))]), _List_Nil));
      }
    }, labelsAndGuides))]), _List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$class('chart-x-axis-labels')]), A2($elm$core$List$indexedMap, F2(function (categoryIndex, category) {
      var y = $elm$core$String$fromFloat(chartBaselineY + 10);
      var x = $elm$core$String$fromFloat(categoryIndex * categoryWidth + config.cd.FE + (categoryWidth - barWidth) / 2);
      return A2($elm$svg$Svg$text_, _List_fromArray([$elm$svg$Svg$Attributes$textAnchor('start'), $elm$svg$Svg$Attributes$alignmentBaseline('middle'), $elm$svg$Svg$Attributes$transform('translate(' + (x + (',' + (y + ') rotate(90)')))), $elm$svg$Svg$Attributes$fill(config.dv.vP(category)), $elm$svg$Svg$Attributes$fontFamily('Karla, sans-serif')]), _List_fromArray([$elm$svg$Svg$text(config.dv.vQ(category))]));
    }), config.dv.hb))]), _List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$class('chart-y-axis-labels')]), A2($elm$core$List$filterMap, function (item) {
      var _v1 = item.y$ !== '';

      if (!_v1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var y = chartBaselineY - scaleInstance(item.Fw);
        var x = config.cd.FE - 20;
        return $elm$core$Maybe$Just(A2($elm$svg$Svg$text_, _List_fromArray([$elm$svg$Svg$Attributes$x($elm$core$String$fromFloat(x)), $elm$svg$Svg$Attributes$y($elm$core$String$fromFloat(y)), $elm$svg$Svg$Attributes$textAnchor('end'), $elm$svg$Svg$Attributes$dominantBaseline('central'), $elm$svg$Svg$Attributes$fill('#b8c0cd'), $elm$svg$Svg$Attributes$fontFamily('Karla, sans-serif')]), _List_fromArray([$elm$svg$Svg$text(item.y$)])));
      }
    }, labelsAndGuides))]), A2($elm$core$List$indexedMap, F2(function (barGroupIndex, item) {
      if (!item.$) {
        var id = item.a.F;
        var name = item.a.zL;
        var values = item.a.ir;
        var tooltips = item.a.t7;
        var fill = item.a.ln;
        var highlights = item.a.x9;
        var valuesAnnotatedWithMaybes = A2($elm$core$List$indexedMap, F2(function (valueIndex, _v6) {
          var maybeValue = _v6.a;
          var maybeTooltip = _v6.b;
          var category = _v6.c;

          if (maybeValue.$ === 1) {
            return $elm$core$Maybe$Nothing;
          } else {
            var value = maybeValue.a;
            var highlight = $elm$core$List$head(A2($elm$core$List$filter, function (h) {
              return _Utils_eq(h.ek, category);
            }, highlights));

            var fillUsing = function () {
              if (!highlight.$) {
                var h = highlight.a;
                return h.vY;
              } else {
                return fill;
              }
            }();

            var barX = config.cd.FE + valueIndex * categoryWidth + barGroupIndex * (barWidth + barSpacingWithinGroups);
            var barHeight = scaleInstance(value) - scaleInstance(0);
            return $elm$core$Maybe$Just({
              o6: barHeight,
              o7: barX,
              ek: category,
              qn: fillUsing,
              lP: valueIndex,
              jh: maybeTooltip,
              Fw: value
            });
          }
        }), A4($elm$core$List$map3, F3(function (a, b, c) {
          return _Utils_Tuple3(a, b, c);
        }), values, tooltips, config.dv.hb));
        var valuesAnnotated = A2($elm$core$List$filterMap, $elm$core$Basics$identity, valuesAnnotatedWithMaybes);
        return A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$id(config.F + ('-' + id)), $elm$svg$Svg$Attributes$class('chart-bar')]), A2($elm$core$List$map, function (_v3) {
          var value = _v3.Fw;
          var category = _v3.ek;
          var barX = _v3.o7;
          var barHeight = _v3.o6;
          var fillUsing = _v3.qn;
          var maybeTooltip = _v3.jh;
          return A2($elm$svg$Svg$g, _List_fromArray([A2($elm$html$Html$Events$on, 'mouseenter', A2($elm$json$Json$Decode$andThen, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail(''), $elm$json$Json$Decode$succeed), A2($elm$json$Json$Decode$map, config.mJ, A5($author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForCategory, config.F, id, name, value, category)))), A2($elm$html$Html$Events$on, 'click', A2($elm$json$Json$Decode$andThen, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail(''), $elm$json$Json$Decode$succeed), A2($elm$json$Json$Decode$map, config.Ae, A5($author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForCategory, config.F, id, name, value, category))))]), $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([$elm$core$Maybe$Just(A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width($elm$core$String$fromFloat(categoryWidth)), $elm$svg$Svg$Attributes$height($elm$core$String$fromFloat(config.dZ)), $elm$svg$Svg$Attributes$fill('#0000'), $elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromFloat(barX - categoryWidth / 2) + (',' + ($elm$core$String$fromFloat(0) + ')'))))]), _List_Nil)), !barHeight ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A6(value > 0 ? $author$project$Ui$Chart$BarAndLineChart$roundedRectangleUp : $author$project$Ui$Chart$BarAndLineChart$roundedRectangleDown, fillUsing, barRadius, barX, barBottomY, barWidth, barHeight)), function () {
            if (maybeTooltip.$ === 1) {
              return $elm$core$Maybe$Nothing;
            } else {
              return $elm$core$Maybe$Just(A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromFloat(barX + categoryWidth / 6) + (',' + ($elm$core$String$fromFloat(chartBaselineY) + ')'))))]), _List_fromArray([A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$style('filter: drop-shadow(0px 1px 3px #0254);'), $elm$svg$Svg$Attributes$r('8'), $elm$svg$Svg$Attributes$fill(config.hM.ra)]), _List_Nil), A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$r('4'), $elm$svg$Svg$Attributes$fill(config.hM.tz)]), _List_Nil)])));
            }
          }(), function () {
            if (maybeTooltip.$ === 1) {
              return $elm$core$Maybe$Nothing;
            } else {
              var tooltip = maybeTooltip.a;
              return $elm$core$Maybe$Just(A2($elm$svg$Svg$foreignObject, _List_fromArray([$elm$svg$Svg$Attributes$width('500'), $elm$svg$Svg$Attributes$height('100%'), $elm$svg$Svg$Attributes$style('overflow: visible;'), $elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromInt($elm$core$Basics$round(barX)) + (',' + ($elm$core$String$fromFloat(chartBaselineY) + ')'))))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/1999/xhtml'), A2($elm$html$Html$Attributes$style, 'position', 'absolute'), A2($elm$html$Html$Attributes$style, 'left', '9px'), A2($elm$html$Html$Attributes$style, 'top', '8px')]), _List_fromArray([tooltip]))])));
            }
          }()])));
        }, valuesAnnotated));
      } else {
        return A2($elm$svg$Svg$g, _List_Nil, _List_Nil);
      }
    }), A2($elm$core$List$filter, function (item) {
      if (!item.$) {
        return true;
      } else {
        return false;
      }
    }, data)), A2($elm$core$List$indexedMap, F2(function (lineChartIndex, item) {
      if (item.$ === 1) {
        var id = item.a.F;
        var name = item.a.zL;
        var values = item.a.ir;
        var tooltips = item.a.t7;
        var strokeStopA = item.a.tK;
        var strokeStopB = item.a.tL;
        var fillStopA = item.a.xI;
        var fillStopB = item.a.xJ;
        var strokeWidth = item.a.oo;
        var valuesAnnotatedWithoutPadding = A2($elm$core$List$indexedMap, F2(function (valueIndex, _v15) {
          var value = _v15.a;
          var maybeTooltip = _v15.b;
          var category = _v15.c;
          var y = chartBaselineY - scaleInstance(value);
          var x = config.cd.FE + valueIndex * categoryWidth + (categoryWidth - barWidth) / 2;
          return {
            ek: category,
            lP: valueIndex,
            jh: maybeTooltip,
            Fw: value,
            is: x,
            oK: y
          };
        }), A4($elm$core$List$map3, function (value) {
          return function (maybeTooltip) {
            return function (category) {
              return _Utils_Tuple3(value, maybeTooltip, category);
            };
          };
        }, values, tooltips, config.dv.hb));
        var valuesAnnotated = A3($author$project$Ui$Chart$BarAndLineChart$padListTransformingEnds, valuesAnnotatedWithoutPadding, function (value) {
          return _Utils_update(value, {
            is: config.cd.FE
          });
        }, function (value) {
          return _Utils_update(value, {
            is: config.fb
          });
        });
        var smoothedPath = $folkertdev$one_true_path_experiment$SubPath$toString(A2($folkertdev$one_true_path_experiment$Curve$catmullRom, 0.5, A2($elm$core$List$map, function (_v14) {
          var x = _v14.is;
          var y = _v14.oK;
          var index = _v14.lP;
          return !index ? _Utils_Tuple2(x, y + 0.00001) : _Utils_Tuple2(x, y);
        }, valuesAnnotated)));
        return A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$id(config.F + ('-' + id)), $elm$svg$Svg$Attributes$class('chart-line')]), _List_fromArray([A2($elm$svg$Svg$defs, _List_Nil, _List_fromArray([A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id(config.F + ('-chart-line-gradient' + $elm$core$String$fromInt(lineChartIndex)))]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0%'), $elm$svg$Svg$Attributes$stopColor(strokeStopA)]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('100%'), $elm$svg$Svg$Attributes$stopColor(strokeStopB)]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id(config.F + ('-chart-fill-gradient' + $elm$core$String$fromInt(lineChartIndex))), $elm$svg$Svg$Attributes$x1('0'), $elm$svg$Svg$Attributes$x2('0'), $elm$svg$Svg$Attributes$y1('0'), $elm$svg$Svg$Attributes$y2('1')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0%'), $elm$svg$Svg$Attributes$stopColor(fillStopA)]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('100%'), $elm$svg$Svg$Attributes$stopColor(fillStopB)]), _List_Nil)]))])), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fill('none'), $elm$svg$Svg$Attributes$stroke('url(#' + (config.F + ('-chart-line-gradient' + ($elm$core$String$fromInt(lineChartIndex) + ')')))), $elm$svg$Svg$Attributes$strokeWidth($elm$core$String$fromFloat(strokeWidth)), $elm$svg$Svg$Attributes$d(smoothedPath)]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fill('url(#' + (config.F + ('-chart-fill-gradient' + ($elm$core$String$fromInt(lineChartIndex) + ')')))), $elm$svg$Svg$Attributes$stroke('none'), $elm$svg$Svg$Attributes$style('pointer-events: none;'), $elm$svg$Svg$Attributes$d(smoothedPath + (' L ' + ($elm$core$String$fromFloat(config.fb) + (',' + ($elm$core$String$fromFloat(config.dZ - config.dv.x6) + (' L ' + ($elm$core$String$fromFloat(config.cd.FE) + (',' + ($elm$core$String$fromFloat(config.dZ - config.dv.x6) + ' Z')))))))))]), _List_Nil), A2($elm$svg$Svg$g, _List_Nil, A2($elm$core$List$map, function (_v11) {
          var x = _v11.is;
          var y = _v11.oK;
          var value = _v11.Fw;
          var maybeTooltip = _v11.jh;
          var category = _v11.ek;
          return A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$class('chart-hover-indicator'), A2($elm$html$Html$Events$on, 'mouseenter', A2($elm$json$Json$Decode$andThen, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail(''), $elm$json$Json$Decode$succeed), A2($elm$json$Json$Decode$map, config.mJ, A5($author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForCategory, config.F, id, name, value, category)))), A2($elm$html$Html$Events$on, 'click', A2($elm$json$Json$Decode$andThen, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Decode$fail(''), $elm$json$Json$Decode$succeed), A2($elm$json$Json$Decode$map, config.Ae, A5($author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForCategory, config.F, id, name, value, category))))]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([$elm$core$Maybe$Just(A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width($elm$core$String$fromFloat(categoryWidth)), $elm$svg$Svg$Attributes$height($elm$core$String$fromFloat(config.dZ)), $elm$svg$Svg$Attributes$fill('#0000'), $elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromFloat(x - categoryWidth / 2) + (',' + ($elm$core$String$fromFloat(0) + ')'))))]), _List_Nil)), function () {
            if (maybeTooltip.$ === 1) {
              return $elm$core$Maybe$Nothing;
            } else {
              return $elm$core$Maybe$Just(A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromFloat(x) + (',' + ($elm$core$String$fromFloat(y) + ')'))))]), _List_fromArray([A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$style('filter: drop-shadow(0px 1px 3px #0254);'), $elm$svg$Svg$Attributes$r('8'), $elm$svg$Svg$Attributes$fill(config.hM.ra)]), _List_Nil), A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$r('4'), $elm$svg$Svg$Attributes$fill(config.hM.tz)]), _List_Nil)])));
            }
          }(), function () {
            if (maybeTooltip.$ === 1) {
              return $elm$core$Maybe$Nothing;
            } else {
              var tooltip = maybeTooltip.a;
              return $elm$core$Maybe$Just(A2($elm$svg$Svg$foreignObject, _List_fromArray([$elm$svg$Svg$Attributes$width('200'), $elm$svg$Svg$Attributes$height('100%'), $elm$svg$Svg$Attributes$style('overflow: visible;'), $elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromFloat(x) + (',' + ($elm$core$String$fromFloat(y) + ')'))))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/1999/xhtml'), A2($elm$html$Html$Attributes$style, 'position', 'absolute'), A2($elm$html$Html$Attributes$style, 'left', '9px'), A2($elm$html$Html$Attributes$style, 'top', '8px')]), _List_fromArray([tooltip]))])));
            }
          }()])));
        }, valuesAnnotatedWithoutPadding))]));
      } else {
        return A2($elm$svg$Svg$g, _List_Nil, _List_Nil);
      }
    }), A2($elm$core$List$filter, function (item) {
      if (item.$ === 1) {
        return true;
      } else {
        return false;
      }
    }, data)), _List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$class('chart-floating-indicators')]), A2($elm$core$List$filterMap, function (item) {
      if (item.$ === 2) {
        var value = item.a.Fw;
        var category = item.a.ek;
        var fill = item.a.ln;
        var barIndex = item.a.va;
        var floatingIndicatorData = item.a.qu;
        var y = $elm$core$String$fromFloat(chartBaselineY - scaleInstance(value) - 30);
        var categoryIndex = A2($author$project$Ui$Chart$BarAndLineChart$indexOf, config.dv.hb, category);
        var x = $elm$core$String$fromFloat(config.cd.FE + categoryIndex * categoryWidth - 9 + barWidth / 2 + barIndex * (barWidth + barSpacingWithinGroups));
        return $elm$core$Maybe$Just(A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('m 17.899927,9.0314085 c 0,-4.9147979 -3.984265,-8.8980605 -8.9000388,-8.8980605 -4.9158109,0 -8.9000377,3.9832626 -8.9000377,8.8980605 0,2.9073455 2.3377246,7.4542745 7.0122392,13.6427705 l 0.3154491,0.414344 0.1039039,0.125581 c 0.6823268,0.757494 1.8432842,0.876161 2.6680113,0.247239 0.140532,-0.106781 0.266114,-0.2324 0.373008,-0.37282 4.885126,-6.399127 7.327688,-11.08549 7.327688,-14.0571145 z M 8.9998882,10.019314 c 1.0927098,0 1.9777618,-0.8850594 1.9777618,-1.9767973 0,-1.091738 -0.885052,-1.9777875 -1.9777618,-1.9777875 -1.0927472,0 -1.9777987,0.8860495 -1.9777987,1.9777875 0,1.0917379 0.8850515,1.9767973 1.9777987,1.9767973 z'), $elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$fill(fill), $elm$svg$Svg$Attributes$stroke('#fff'), $elm$svg$Svg$Attributes$strokeWidth('2'), $elm$svg$Svg$Attributes$transform('translate(' + (x + (',' + (y + ')')))), A2($elm$html$Html$Events$on, 'click', A2($elm$json$Json$Decode$map, config.rR, A4($author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForFloatingIndicator, config.F, value, category, floatingIndicatorData))), A2($elm$html$Html$Events$on, 'mouseover', A2($elm$json$Json$Decode$map, config.rS, A4($author$project$Ui$Chart$BarAndLineChart$mouseEventDecoderForFloatingIndicator, config.F, value, category, floatingIndicatorData)))]), _List_Nil));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, data))]), _List_fromArray([A2($author$project$Ui$Chart$BarAndLineChart$chartLegend, config, data)])])))]));
  });
  var $author$project$Ui$Chart$BarAndLineChart$chartLegendStandalone = F2(function (config, data) {
    var count = A3($elm$core$List$foldr, function (item) {
      return function (accum) {
        switch (item.$) {
          case 0:
            return accum + 1;

          case 1:
            return accum + 1;

          default:
            return accum;
        }
      };
    }, 0, data);
    return A2($elm$html$Html$div, A2($elm$core$List$append, _List_fromArray([$elm$html$Html$Attributes$id(config.F)]), config.kM), _List_fromArray([A2($elm$svg$Svg$svg, A2($elm$core$List$append, _List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 ' + ($elm$core$String$fromFloat(config.je * count) + ' 18'))]), config.os), _List_fromArray([A2($author$project$Ui$Chart$BarAndLineChart$chartLegend, _Utils_update(config, {
      dZ: 18,
      fb: config.je * count
    }), data)]))]));
  });

  var $author$project$Ui$Chart$DoubleBarChart$doubleBarChart = function (cfg) {
    var yAxisWidth = 70;
    var xAxisHeight = 140;
    var svgWidth = 30 * $elm$core$List$length(cfg.ir);
    var svgHeight = 300;
    var marginTop = 30;

    var produceChart = function (section) {
      var displayTypes = _List_fromArray([$author$project$Ui$Chart$BarAndLineChart$BarChart({
        ln: '#5E2CDF',
        x9: _List_Nil,
        F: 'bar-1',
        zL: 'Budget',
        t7: A2($elm$core$List$map, function (value) {
          return value.yf;
        }, cfg.ir),
        ir: A2($elm$core$List$map, function (value) {
          return value.u7;
        }, cfg.ir)
      }), $author$project$Ui$Chart$BarAndLineChart$BarChart({
        ln: '#CED5DF',
        x9: _List_Nil,
        F: 'bar-2',
        zL: 'Scenario',
        t7: A2($elm$core$List$map, $elm$core$Basics$always($elm$core$Maybe$Nothing), cfg.ir),
        ir: A2($elm$core$List$map, function (value) {
          return value.u8;
        }, cfg.ir)
      })]);

      var config = {
        kM: function () {
          var _v1 = cfg.DE;

          if (!_v1.$) {
            switch (section) {
              case 2:
                return _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%')]);

              case 0:
                return _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%')]);

              default:
                return _List_fromArray([$elm$html$Html$Attributes$class('right marTop-6')]);
            }
          } else {
            return _List_Nil;
          }
        }(),
        F: function () {
          var _v3 = cfg.DE;

          if (!_v3.$) {
            switch (section) {
              case 2:
                return 'svg-example-main';

              case 0:
                return 'svg-example-yaxis';

              default:
                return 'svg-example-legend';
            }
          } else {
            return 'svg-example';
          }
        }(),
        je: 150,
        re: cfg.D7 && ($elm_community$maybe_extra$Maybe$Extra$isNothing(cfg.DE) || section === 1),
        hM: {
          ra: '#fff',
          tz: '#001078'
        },
        ro: marginTop,
        Ae: $elm$core$Basics$always($elm$core$Maybe$Nothing),
        rR: function (click) {
          return click.qu.ew;
        },
        rS: function (hover) {
          return hover.qu.Bb;
        },
        rT: cfg.mL,
        mJ: function (hovering) {
          return A2($elm$core$Maybe$map, function (onHover) {
            return onHover({
              iL: hovering.ek.iL
            });
          }, hovering.ek.Bb);
        },
        os: function () {
          var _v5 = cfg.DE;

          if (!_v5.$) {
            switch (section) {
              case 2:
                return _List_fromArray([$elm$svg$Svg$Attributes$style('height: 100%; direction: ltr; margin-right: -' + ($elm$core$String$fromInt(yAxisWidth) + 'px')), $elm$svg$Svg$Attributes$viewBox($elm$core$String$fromInt(yAxisWidth) + (' 0 ' + ($elm$core$String$fromFloat(svgWidth) + (' ' + $elm$core$String$fromInt(svgHeight)))))]);

              case 0:
                return _List_fromArray([$elm$svg$Svg$Attributes$style('height: 100%;'), $elm$svg$Svg$Attributes$viewBox('0 0 ' + ($elm$core$String$fromInt(yAxisWidth) + (' ' + $elm$core$String$fromInt(svgHeight))))]);

              default:
                return _List_fromArray([$elm$svg$Svg$Attributes$style('height: 18px;')]);
            }
          } else {
            return _List_fromArray([$elm$svg$Svg$Attributes$style('width: 100%; max-height: ' + ($elm$core$String$fromFloat(svgHeight) + 'px'))]);
          }
        }(),
        dZ: svgHeight,
        fb: svgWidth,
        dv: {
          hb: cfg.ir,
          vP: function (category) {
            var _v7 = category.yf;

            if (_v7.$ === 1) {
              return '#b8c0cd';
            } else {
              return '#001078';
            }
          },
          vQ: function (category) {
            var _v8 = category.iL;
            var day = _v8.wz;
            var month = _v8.zG;
            var year = _v8.FP;
            var _v9 = cfg.wv;

            if (!_v9.$) {
              var format = _v9.a;
              return A2($justinmimbs$date$Date$format, format, A3($justinmimbs$date$Date$fromCalendarDate, year, month, day));
            } else {
              return $author$project$Types$SimpleDate$toDateStringLong(category.iL);
            }
          },
          x6: xAxisHeight
        },
        cd: {
          vy: {
            eW: 0,
            gQ: 1
          },
          y3: 5,
          Fy: function (value) {
            return $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromInt(value | 0));
          },
          FE: yAxisWidth
        }
      };
      return section === 1 ? A2($author$project$Ui$Chart$BarAndLineChart$chartLegendStandalone, config, displayTypes) : A2($author$project$Ui$Chart$BarAndLineChart$chart, config, displayTypes);
    };

    var _v0 = cfg.DE;

    if (!_v0.$) {
      var scrollableConfig = _v0.a;
      return A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', scrollableConfig.x6), A2($elm$html$Html$Attributes$style, 'display', 'flex'), A2($elm$html$Html$Attributes$style, 'flex-direction', 'row')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'position', 'relative')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%'), A2($elm$html$Html$Attributes$style, 'text-align', 'center')]), _List_fromArray([produceChart(0)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative flex1 noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullHeight fullWidth scrollTargetX')]), _List_fromArray([produceChart(2)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('chartGradientLeft absolute left0 top0 bottom0 noPointerEvents')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('chartGradientRight absolute right0 top0 bottom0 noPointerEvents')]), _List_Nil)]))])), A2($elm$html$Html$div, _List_Nil, cfg.D7 ? _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([produceChart(1)]))]) : _List_Nil)]))]));
    } else {
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([produceChart(2)]));
    }
  };

  var $author$project$Types$Currency$toFormattedFromFloat = F2(function (currency, _float) {
    return A2($author$project$Types$Currency$toFormattedFromString, currency, A2($myrho$elm_round$Round$round, 2, _float));
  });
  var $author$project$Types$Currency$maybeToFormattedFromFloat = F2(function (currency, _float) {
    if (!currency.$) {
      var currency_ = currency.a;
      return A2($author$project$Types$Currency$toFormattedFromFloat, currency_, _float);
    } else {
      return A2($myrho$elm_round$Round$round, 2, _float);
    }
  });

  var $author$project$ElmFramework$Lib$Util$shortenFloat = function (_float) {
    var length = $elm$core$String$length($elm$core$String$fromInt($elm$core$Basics$abs($elm$core$Basics$round(_float))));
    return length > 6 ? {
      oq: $elm$core$Maybe$Just('M'),
      Fv: _float / 1000000
    } : length > 3 ? {
      oq: $elm$core$Maybe$Just('K'),
      Fv: _float / 1000
    } : {
      oq: $elm$core$Maybe$Nothing,
      Fv: _float
    };
  };

  var $elm$html$Html$table = _VirtualDom_node('table');

  var $elm$html$Html$tbody = _VirtualDom_node('tbody');

  var $elm$html$Html$td = _VirtualDom_node('td');

  var $elm$html$Html$th = _VirtualDom_node('th');

  var $elm$html$Html$thead = _VirtualDom_node('thead');

  var $elm$html$Html$tr = _VirtualDom_node('tr');

  var $author$project$Ui$Chart$BudgetChart$tooltipBodyTabular = F2(function (reportingCurrency, data) {
    var rowView = F3(function (key, cfg, isCurrency) {
      var toText = function (fraction) {
        var _v0 = function () {
          if (!isCurrency) {
            return _Utils_Tuple3($elm$core$Maybe$Nothing, $JoshuaHall$elm_fraction$Fraction$toFloat(fraction), $elm$core$Maybe$Just('%'));
          } else {
            var shortened = $author$project$ElmFramework$Lib$Util$shortenFloat($JoshuaHall$elm_fraction$Fraction$toFloat(fraction));
            return _Utils_Tuple3($elm$core$Maybe$Just(reportingCurrency), shortened.Fv, shortened.oq);
          }
        }();

        var currency = _v0.a;
        var amount = _v0.b;
        var suffix = _v0.c;
        return _List_fromArray([$elm$html$Html$text(_Utils_ap(A2($author$project$Types$Currency$maybeToFormattedFromFloat, currency, amount), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$append(' '), suffix)))]);
      };

      return A2($elm$html$Html$tr, _List_Nil, _List_fromArray([A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray20 padRight2')]), _List_fromArray([$elm$html$Html$text(key + ':')])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold primary0')]), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, toText, cfg.fF)), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold primary0')]), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, toText, cfg.Dw))]));
    });

    var headingRow = function () {
      var mainHeadCell = F2(function (title, classes) {
        return _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('minW9 left fontSize2'), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([$elm$html$Html$text(title)]))]);
      });

      var emptyHeadCell = _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_Nil)]);

      return _Utils_ap(emptyHeadCell, _Utils_ap(A2(mainHeadCell, 'Budget', 'secondary0 padRight2 '), A2(mainHeadCell, 'Scenario', 'gray40')));
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 padTop1h padBottom1h primary30Back inlineBlock')]), _List_fromArray([A2($elm$html$Html$table, _List_Nil, _List_fromArray([A2($elm$html$Html$thead, _List_Nil, _List_fromArray([A2($elm$html$Html$tr, _List_Nil, headingRow)])), A2($elm$html$Html$tbody, _List_Nil, _List_fromArray([A3(rowView, 'Revenue ', data.C9, true), A3(rowView, 'Gross Margin ', data.x0, false), A3(rowView, 'Operating Margin ', data.Ce, false), A3(rowView, 'Net Profit Margin ', data.zQ, false)]))]))]));
  });
  var $author$project$Ui$Chart$BudgetChart$toTooltipView = F2(function (reportingCurrency, _v0) {
    var budgetScenarioMetrics = _v0.vB;
    var comparisonScenarioMetrics = _v0.v6;
    return A2($author$project$Ui$Chart$BudgetChart$tooltipBodyTabular, reportingCurrency, {
      x0: {
        fF: budgetScenarioMetrics.x0,
        Dw: A2($elm$core$Maybe$andThen, function ($) {
          return $.x0;
        }, comparisonScenarioMetrics)
      },
      zQ: {
        fF: budgetScenarioMetrics.zQ,
        Dw: A2($elm$core$Maybe$andThen, function ($) {
          return $.zQ;
        }, comparisonScenarioMetrics)
      },
      Ce: {
        fF: budgetScenarioMetrics.Ce,
        Dw: A2($elm$core$Maybe$andThen, function ($) {
          return $.Ce;
        }, comparisonScenarioMetrics)
      },
      C9: {
        fF: $elm$core$Maybe$Just(budgetScenarioMetrics.C9),
        Dw: A2($elm$core$Maybe$map, function ($) {
          return $.C9;
        }, comparisonScenarioMetrics)
      }
    });
  });
  var $author$project$Ui$Chart$BudgetChart$toValue = F2(function (cfg, balancePeriod) {
    var toBarVal = A2($elm$core$Basics$composeR, function () {
      var _v0 = cfg.ka;

      switch (_v0) {
        case 0:
          return function ($) {
            return $.C9;
          };

        case 1:
          return function ($) {
            return $.x1;
          };

        case 2:
          return function ($) {
            return $.Cf;
          };

        default:
          return function ($) {
            return $.zP;
          };
      }
    }(), $JoshuaHall$elm_fraction$Fraction$toFloat);

    var hovering = function (hoveringOnPeriod) {
      return _Utils_eq(hoveringOnPeriod.ap.xw, balancePeriod.ap.xw) ? $elm$core$Maybe$Just(A2($author$project$Ui$Chart$BudgetChart$toTooltipView, cfg.b0, hoveringOnPeriod)) : $elm$core$Maybe$Nothing;
    };

    return {
      u7: $elm$core$Maybe$Just(toBarVal(balancePeriod.vB)),
      u8: A2($elm$core$Maybe$map, toBarVal, balancePeriod.v6),
      iL: balancePeriod.ap.xw,
      yf: A2($elm$core$Maybe$andThen, hovering, cfg.qM),
      Bb: A2($elm$core$Maybe$map, function (onMouseEnter) {
        return $elm$core$Basics$always(onMouseEnter(balancePeriod));
      }, cfg.rW)
    };
  });

  var $author$project$Ui$Chart$BudgetChart$budgetChart = function (cfg) {
    return $author$project$Ui$Chart$DoubleBarChart$doubleBarChart({
      wv: $elm$core$Maybe$Just('MMM-YY'),
      mL: cfg.mL,
      DE: $elm$core$Maybe$Just({
        x6: '340px',
        zp: 'auto'
      }),
      D7: true,
      ir: A2($elm$core$List$map, $author$project$Ui$Chart$BudgetChart$toValue(cfg), cfg.wx.Cn)
    });
  };

  var $author$project$AssetsSvg$logoPuffin_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 14 16'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M13.3344 9.59353H10.2773C10.5824 9.77454 10.8667 9.99434 11.1237 10.249C11.9337 11.0558 12.3803 12.129 12.3803 13.2706V16H5.87664C5.08349 16 4.31369 15.8448 3.58933 15.5397C2.88964 15.2449 2.26135 14.8234 1.72132 14.2856C1.1813 13.7477 0.758109 13.1219 0.462135 12.425C0.155776 11.7036 0 10.9369 0 10.1469V4.79677C0 4.14901 0.127217 3.52065 0.379055 2.92978C0.621805 2.3583 0.969705 1.8463 1.41107 1.40541C1.85243 0.964525 2.36779 0.619313 2.94157 0.377535C3.53481 0.126707 4.16571 0 4.81607 0C5.45345 0 6.07136 0.121535 6.65422 0.36202C7.73557 0.788687 8.73902 1.47523 9.63993 2.40873C10.4331 3.22844 11.151 4.24081 11.7728 5.41479C12.8255 7.4059 13.2345 9.15652 13.2513 9.23022L13.3344 9.59353ZM12.5724 8.99879C12.3985 8.38723 11.9805 7.08137 11.2366 5.67854C10.6421 4.55628 9.95797 3.59305 9.20376 2.81471L9.20116 2.81212C9.21514 2.84195 9.22834 2.87254 9.24137 2.90273C9.24529 2.91179 9.24919 2.92082 9.25308 2.92978C9.50492 3.52065 9.63214 4.14901 9.63214 4.79677C9.63214 5.44452 9.50492 6.07289 9.25438 6.66376C9.01163 7.23523 8.66503 7.74723 8.22237 8.18812C7.89913 8.51006 7.53695 8.78158 7.14102 8.99879H8.09126H12.5724ZM4.81607 0.594747C3.68929 0.594747 2.63002 1.03176 1.83296 1.82562C1.03591 2.61947 0.597141 3.6745 0.597141 4.79677C0.597141 5.91903 1.03591 6.97406 1.83296 7.76792C2.63002 8.56178 3.68929 8.99879 4.81607 8.99879C5.94285 8.99879 7.00212 8.56178 7.79918 7.76792C8.59623 6.97406 9.035 5.91903 9.035 4.79677C9.035 3.6745 8.59623 2.61947 7.79918 1.82562C7.41363 1.44162 6.96707 1.14166 6.48028 0.933495C6.35695 0.883071 6.23103 0.836525 6.10511 0.793859C5.69361 0.663273 5.26003 0.594747 4.81607 0.594747ZM5.87664 15.4065H11.7831V13.2706C11.7831 12.2893 11.3989 11.3648 10.7018 10.6705C10.0047 9.97624 9.07784 9.59353 8.09126 9.59353H6.99434H4.81607C4.16571 9.59353 3.53481 9.46683 2.94157 9.21729C2.36779 8.97551 1.85373 8.6303 1.41107 8.18941C1.08783 7.86747 0.815227 7.50675 0.597141 7.1124V10.1469C0.597141 10.8567 0.737339 11.5459 1.01124 12.1936C1.27736 12.8194 1.65771 13.3818 2.14322 13.8654C2.62872 14.3489 3.1934 14.7278 3.8217 14.9928C4.47206 15.2669 5.16397 15.4065 5.87664 15.4065ZM7.49329 3.90714C7.49329 4.6648 6.87408 5.28152 6.11337 5.28152C5.35267 5.28152 4.73346 4.6648 4.73346 3.90714C4.73346 3.14948 5.35137 2.53276 6.11337 2.53276C6.87537 2.53276 7.49329 3.14948 7.49329 3.90714ZM6.89614 3.90714C6.89614 3.47789 6.54565 3.1275 6.11337 3.1275C5.68239 3.1275 5.3306 3.47789 5.3306 3.90714C5.3306 4.33639 5.68239 4.68678 6.11337 4.68678C6.54435 4.68678 6.89614 4.33639 6.89614 3.90714Z'), $elm$svg$Svg$Attributes$fill('#3721E6')]), _List_Nil)]));
  };

  var $author$project$AssetsSvg$logoPuffin = function (classes) {
    return $author$project$AssetsSvg$logoPuffin_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$UsersTable$infoTag = function (cfg) {
    var showIcon = cfg.yh ? $author$project$AssetsSvg$logoPuffin('h2 padRight1') : $author$project$ElmFramework$Lib$Util$noOpEl;

    var classes = function () {
      var _v0 = cfg.EI;

      switch (_v0) {
        case 0:
          return 'secondary60Back primary30';

        case 1:
          return 'secondary70Back secondary0';

        default:
          return 'gray20Back primary30';
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxRadius heading4Bold padTop1 padBottom1 padLeft2 padRight2 minH4 inlineFlex flexAlignCenter'), $elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([showIcon, $elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$Api$GraphqlSchema$Enum$Basis_enum$list = _List_fromArray([0, 1]);

  var $author$project$Types$Currency$maybeToFormattedFromString = F2(function (currency, string) {
    if (!currency.$) {
      var currency_ = currency.a;
      return A2($author$project$Types$Currency$toFormattedFromString, currency_, string);
    } else {
      return string;
    }
  });

  var $author$project$Views$Routed$BudgetBranch$budgetGraphSection = function (cfg) {
    var infoTagElements = function () {
      var stripTrailingZero = function (value) {
        var _v2 = A2($elm$core$String$split, '.', value);

        _v2$2: while (true) {
          if (_v2.b) {
            if (!_v2.b.b) {
              var first = _v2.a;
              return first;
            } else {
              if (!_v2.b.b.b) {
                var first = _v2.a;
                var _v3 = _v2.b;
                var second = _v3.a;

                var _v4 = $elm$core$String$toList(second);

                if (_v4.b && _v4.b.b && '0' === _v4.b.a && !_v4.b.b.b) {
                  if ('0' === _v4.a) {
                    var _v5 = _v4.b;
                    return first;
                  } else {
                    var a = _v4.a;
                    var _v6 = _v4.b;
                    return _Utils_ap(first, $elm$core$String$fromList(_List_fromArray(['.', a])));
                  }
                } else {
                  return value;
                }
              } else {
                break _v2$2;
              }
            }
          } else {
            break _v2$2;
          }
        }

        return value;
      };

      var toTag = function (tagCfg) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineFlexColumn flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30')]), _List_fromArray([$elm$html$Html$text(tagCfg.y$)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow gapRow1')]), _List_fromArray([$author$project$Ui$UsersTable$infoTag({
          vV: '',
          yh: false,
          y$: _Utils_ap(A2($author$project$Types$Currency$maybeToFormattedFromString, tagCfg.jw, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale(stripTrailingZero(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(tagCfg.oE))))), tagCfg.oq),
          EI: 1
        }), $author$project$Ui$UsersTable$infoTag({
          vV: '',
          yh: false,
          y$: _Utils_ap(A2($author$project$Types$Currency$maybeToFormattedFromString, tagCfg.jw, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale(stripTrailingZero(A2($myrho$elm_round$Round$round, 2, $JoshuaHall$elm_fraction$Fraction$toFloat(tagCfg.oF))))), tagCfg.oq),
          EI: 2
        })]))]));
      };

      var usdPrefixTag = F3(function (label, value1, value2) {
        return toTag({
          y$: label,
          jw: $elm$core$Maybe$Just(0),
          oq: '',
          oE: value1,
          oF: value2
        });
      });
      var percentSuffixTag = F3(function (label, value1, value2) {
        return toTag({
          y$: label,
          jw: $elm$core$Maybe$Nothing,
          oq: '%',
          oE: value1,
          oF: value2
        });
      });
      var _v1 = cfg.C0;

      if (!_v1.$) {
        var scenarioFinancials = _v1.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop5 marBottom2 scrollTargetX noScrollbar')]), $elm$core$List$singleton(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow gapRow6')]), $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([$elm$core$Maybe$Just(A3(usdPrefixTag, 'Revenue:', scenarioFinancials.E6.C9, scenarioFinancials.E7.C9)), A3($elm$core$Maybe$map2, percentSuffixTag('Gross Margin:'), scenarioFinancials.E6.x0, scenarioFinancials.E7.x0), A3($elm$core$Maybe$map2, percentSuffixTag('Operating Margin:'), scenarioFinancials.E6.Ce, scenarioFinancials.E7.Ce), A3($elm$core$Maybe$map2, percentSuffixTag('Net Profit Margin:'), scenarioFinancials.E6.zQ, scenarioFinancials.E7.zQ)])))));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var downloadDataBtn = $author$project$Ui$Button$basicButtonMiddle({
      kG: '',
      vY: 1,
      yh: $elm$core$Maybe$Just($author$project$Ui$Button$IconAfterLabel($author$project$IconSvg$arrowDown)),
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
      y$: 'Download Data'
    });

    var budgetChartEl = function () {
      var _v0 = cfg.C0;

      if (!_v0.$) {
        var scenarioFinancials = _v0.a;
        return $author$project$Ui$Chart$BudgetChart$budgetChart({
          v3: _List_Nil,
          wx: scenarioFinancials,
          qG: cfg.qG,
          qM: cfg.qM,
          Bc: cfg.Bc,
          rW: cfg.rW,
          mL: cfg.mL,
          BR: cfg.BR,
          BV: cfg.BV,
          b0: cfg.b0,
          ka: cfg.ka
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var basisSelector = $author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
      vV: 'minW38',
      v_: $elm$core$Maybe$Just(1),
      wm: cfg.pb,
      hH: A2($elm$core$List$map, function (i) {
        return _Utils_Tuple2(i, $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString(i));
      }, $author$project$Api$GraphqlSchema$Enum$Basis_enum$list),
      BE: cfg.BG,
      BP: 'minH4'
    });
    return A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Budget Graph'
    })])), basisSelector, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 right')]), _List_fromArray([downloadDataBtn]))])), infoTagElements, budgetChartEl]));
  };

  var $author$project$Ui$Button$budgetScenarioTypeButton = function (config) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.f9, _List_fromArray([$elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, '', '', config.yM)), $elm$html$Html$Attributes$class('noBorder heading4Bold opacityTransition'), $elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$disabled(config.yM)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter secondary0Back radius0 minH6 pad0h')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 flex1 padLeft2 padRight2 whiteSpaceNoWrap gapRow1')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular')]), _List_fromArray([$elm$html$Html$text(config.qq)])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(config.tk)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 gray10Back radius0 padTop1 padBottom1 padLeft2 padRight2 whiteSpaceNoWrap')]), _List_fromArray([$elm$html$Html$text(config.EK)]))]))]));
  };

  var $author$project$Types$BudgetQuery$clearDivisions = function (query) {
    return _Utils_update(query, {
      eO: _List_Nil
    });
  };

  var $author$project$Util$BudgetQueryInRoute$clearDivisions = function (route) {
    if (route.$ === 5 && route.b.$ === 1) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Budget, $author$project$Types$BudgetQuery$clearDivisions(query), subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  };

  var $author$project$TopMsg$msgBudget = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$BudgetMsg);
  var $author$project$Types$BudgetQuery$selectAllDivisions = F2(function (val, query) {
    return _Utils_update(query, {
      eO: val
    });
  });
  var $author$project$Util$BudgetQueryInRoute$selectAllDivisions = F2(function (route, divisionIds) {
    if (route.$ === 5 && route.b.$ === 1) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Budget, A2($author$project$Types$BudgetQuery$selectAllDivisions, divisionIds, query), subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  });
  var $author$project$Types$BudgetQuery$setBasis = F2(function (val, query) {
    return _Utils_update(query, {
      pb: val
    });
  });
  var $author$project$Util$BudgetQueryInRoute$setBasis = F2(function (route, basis) {
    return A2($author$project$Util$BudgetQueryInRoute$mapBudgetQueryInRoute, $author$project$Types$BudgetQuery$setBasis(basis), route);
  });
  var $author$project$ElmFramework$Lib$Util$toggleInList = F2(function (item, list) {
    return A2($elm$core$List$member, item, list) ? A2($elm_community$list_extra$List$Extra$remove, item, list) : A2($elm$core$List$cons, item, list);
  });
  var $author$project$Types$BudgetQuery$toggleDivision = F2(function (val, query) {
    return _Utils_update(query, {
      eO: A2($author$project$ElmFramework$Lib$Util$toggleInList, val, query.eO)
    });
  });
  var $author$project$Util$BudgetQueryInRoute$toggleDivision = F2(function (route, divisionId) {
    if (route.$ === 5 && route.b.$ === 1) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      var newQuery = A2($author$project$Types$BudgetQuery$toggleDivision, divisionId, query);
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Budget, newQuery, subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  });

  var $elm$html$Html$Attributes$colspan = function (n) {
    return A2(_VirtualDom_attribute, 'colspan', $elm$core$String$fromInt(n));
  };

  var $author$project$Util$concatIndexMap = F2(function (f, list) {
    return $elm$core$List$concat(A2($elm$core$List$indexedMap, f, list));
  });
  var $elm_community$list_extra$List$Extra$groupsOfWithStep = F3(function (size, step, xs) {
    var xs_ = A2($elm$core$List$drop, step, xs);
    var thisGroup = A2($elm$core$List$take, size, xs);

    var okayLength = _Utils_eq(size, $elm$core$List$length(thisGroup));

    var okayArgs = size > 0 && step > 0;
    return okayArgs && okayLength ? A2($elm$core$List$cons, thisGroup, A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, step, xs_)) : _List_Nil;
  });
  var $elm_community$list_extra$List$Extra$groupsOf = F2(function (size, xs) {
    return A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, size, xs);
  });

  var $author$project$Ui$NestedTable$NestedTable$monthView = function (_v0) {
    var month = _v0.zG;
    return A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('center padRight0h padLeft0h'), $elm$html$Html$Attributes$colspan(2)]), _List_fromArray([$elm$html$Html$text($author$project$Types$SimpleDate$monthToString(month))]));
  };

  var $author$project$Ui$NestedTable$NestedTable$isRowExpanded = F2(function (path, expandedRows) {
    return A2($turboMaCk$any_set$Set$Any$member, path, expandedRows);
  });
  var $author$project$Ui$NestedTable$NestedTable$percentView = A2($elm$core$Basics$composeR, $JoshuaHall$elm_fraction$Fraction$toFloat, A2($elm$core$Basics$composeR, $elm$core$String$fromFloat, A2($elm$core$Basics$composeR, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale, A2($elm$core$Basics$composeR, A2($author$project$ElmFramework$Lib$Util$flip, $elm$core$Basics$append, '%'), $elm$html$Html$text))));

  var $author$project$Ui$NestedTable$NestedTable$ttValueView = function (maybeCell) {
    return A2($elm$html$Html$td, _List_Nil, function () {
      var _v0 = A2($elm$core$Maybe$map, function ($) {
        return $.Fw;
      }, maybeCell);

      if (!_v0.$) {
        if (!_v0.a.$) {
          var maybeVal = _v0.a.a;

          if (!maybeVal.$) {
            var val = maybeVal.a;
            return _List_fromArray([$elm$html$Html$text(A2($author$project$Types$Currency$toFormattedFromString, 0, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$toStringFromFraction(val))))]);
          } else {
            return _List_Nil;
          }
        } else {
          var maybeVal = _v0.a.a;

          if (!maybeVal.$) {
            var val = maybeVal.a;
            return _List_fromArray([$author$project$Ui$NestedTable$NestedTable$percentView(val)]);
          } else {
            return _List_Nil;
          }
        }
      } else {
        return _List_Nil;
      }
    }());
  };

  var $author$project$IconSvg$up_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 24 15')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M2.82 15L12 5.72874L21.18 15L24 12.1457L12 0L0 12.1457L2.82 15Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$up = function (classes) {
    return $author$project$IconSvg$up_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$NestedTable$NestedTable$rowView = F4(function (rowPath, expandedRows, toggleRowMsg, _v0) {
    var cells = _v0.vR;
    var children = _v0.vU;
    var label = _v0.y$;
    var rowToggleBtn = $elm$core$List$isEmpty(children) ? $author$project$ElmFramework$Lib$Util$noOpEl : $author$project$Ui$Button$button({
      kG: 'w2 h2 flexCenter marRight1',
      pD: A2($author$project$Ui$NestedTable$NestedTable$isRowExpanded, rowPath, expandedRows) ? $author$project$IconSvg$up('specialW primary30Fill') : $author$project$IconSvg$down('w2 primary30Fill'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(toggleRowMsg(rowPath))
    });
    var parentRowPath = A2($elm$core$List$take, $elm$core$List$length(rowPath) - 1, rowPath);
    var lastchildRowPath = $elm$core$List$reverse(A2($elm$core$List$cons, 1000, $elm$core$List$reverse(rowPath)));
    var lastchild = $elm$core$List$head($elm$core$List$reverse(children));
    var lastChildClasses = _Utils_eq(A2($elm$core$List$drop, $elm$core$List$length(rowPath) - 1, rowPath), _List_fromArray([1000])) ? ' lastChild ' : ' noTlastChild ';
    var isParentlastChildClasses = _Utils_eq(A2($elm$core$List$drop, $elm$core$List$length(parentRowPath) - 1, parentRowPath), _List_fromArray([1000])) ? ' parentIsLastChild ' : ' parentIsNotLastChild ';
    var grandParentRowPath = A2($elm$core$List$take, $elm$core$List$length(parentRowPath) - 1, parentRowPath);
    var isGrandParentlastChildClasses = _Utils_eq(A2($elm$core$List$drop, $elm$core$List$length(grandParentRowPath) - 1, grandParentRowPath), _List_fromArray([1000])) ? ' grandParentIsLastChild ' : ' grandParentIsNotLastChild ';

    var getChildren = function (row) {
      var rowChildren = function () {
        if (!row.$) {
          var data = row.a;
          return data.vU;
        } else {
          return _List_Nil;
        }
      }();

      return rowChildren;
    };

    var expandedRowClasses = $elm$core$List$isEmpty(children) ? '' : A2($author$project$Ui$NestedTable$NestedTable$isRowExpanded, rowPath, expandedRows) ? 'rowExpanded' : '';
    var childrenCountExeptLastChild2 = $elm$core$List$length(getChildren(lastchild)) - 1;
    var lastchildrenRows2 = A2($author$project$Ui$NestedTable$NestedTable$isRowExpanded, lastchildRowPath, expandedRows) ? $elm$core$List$length(A2($elm$core$List$append, A2($author$project$Util$concatIndexMap, function (rowIndex) {
      return A3($author$project$Ui$NestedTable$NestedTable$rowView, A2($elm$core$List$append, lastchildRowPath, _List_fromArray([rowIndex])), expandedRows, toggleRowMsg);
    }, A2($elm$core$List$take, childrenCountExeptLastChild2, getChildren(lastchild))), A2($author$project$Util$concatIndexMap, function (_v2) {
      return A3($author$project$Ui$NestedTable$NestedTable$rowView, A2($elm$core$List$append, lastchildRowPath, _List_fromArray([1000])), expandedRows, toggleRowMsg);
    }, A2($elm$core$List$drop, childrenCountExeptLastChild2, getChildren(lastchild))))) : 0;
    var childrenCountExeptLastChild = $elm$core$List$length(children) - 1;
    var childrenRows = A2($author$project$Ui$NestedTable$NestedTable$isRowExpanded, rowPath, expandedRows) ? A2($elm$core$List$append, A2($author$project$Util$concatIndexMap, function (rowIndex) {
      return A3($author$project$Ui$NestedTable$NestedTable$rowView, A2($elm$core$List$append, rowPath, _List_fromArray([rowIndex])), expandedRows, toggleRowMsg);
    }, A2($elm$core$List$take, childrenCountExeptLastChild, children)), A2($author$project$Util$concatIndexMap, function (_v1) {
      return A3($author$project$Ui$NestedTable$NestedTable$rowView, A2($elm$core$List$append, rowPath, _List_fromArray([1000])), expandedRows, toggleRowMsg);
    }, A2($elm$core$List$drop, childrenCountExeptLastChild, children))) : _List_Nil;
    var countOfAllExpandedChildren = $elm$core$List$length(childrenRows);
    var countOfUnits = countOfAllExpandedChildren - lastchildrenRows2;
    var firstCell = A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter ' + (isParentlastChildClasses + isGrandParentlastChildClasses)), A2($elm$html$Html$Attributes$style, 'max-width', '12vw')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('nestingLine '), A2($elm$html$Html$Attributes$style, 'height', $elm$core$String$fromFloat(countOfUnits * 8) + 'rem')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle1  ' + lastChildClasses)]), _List_Nil), rowToggleBtn, A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' ellipsis heading4Bold ')]), _List_fromArray([$elm$html$Html$text(label)]))]));
    var thisRow = A2($elm$html$Html$tr, _List_fromArray([$elm$html$Html$Attributes$class(' primary10Back tableRowspace ' + expandedRowClasses), A2($elm$html$Html$Attributes$attribute, 'row-path', $author$project$Ui$NestedTable$NestedTable$serializePath(rowPath)), A2($elm$html$Html$Attributes$attribute, 'indent-level', $elm$core$String$fromInt($elm$core$List$length(rowPath) - 1)), A2($elm$html$Html$Attributes$attribute, 'nestingLineUnits', $elm$core$String$fromFloat(countOfUnits)), A2($elm$html$Html$Attributes$attribute, 'allChildren', $elm$core$String$fromFloat(countOfAllExpandedChildren)), A2($elm$html$Html$Attributes$attribute, 'lastChildChildren', $elm$core$String$fromFloat(lastchildrenRows2))]), A2($elm$core$List$cons, firstCell, A2($elm$core$List$map, $author$project$Ui$NestedTable$NestedTable$ttValueView, cells)));
    return A2($elm$core$List$cons, thisRow, childrenRows);
  });

  var $author$project$Ui$NestedTable$NestedTable$nestedTable2 = function (_v0) {
    var data = _v0.wx;
    var expandedRows = _v0.iR;
    var toggleRowMsg = _v0.j2;

    var totalCells = _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('w14 secondary0')]), _List_fromArray([$elm$html$Html$text('Budget')])), A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('w14 gray40')]), _List_fromArray([$elm$html$Html$text('Scenario')])), A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('w14')]), _List_fromArray([$elm$html$Html$text('Difference')]))]);

    var totalCell = _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$colspan(3), $elm$html$Html$Attributes$class('center')]), _List_fromArray([$elm$html$Html$text('Total')]))]);

    var toRowView = F2(function (rowIndex, row) {
      return A4($author$project$Ui$NestedTable$NestedTable$rowView, _List_fromArray([rowIndex]), expandedRows, toggleRowMsg, row);
    });
    var monthRows = A2($elm$core$List$map, $author$project$Ui$NestedTable$NestedTable$monthView, A2($elm$core$List$filterMap, $elm$core$List$head, A2($elm_community$list_extra$List$Extra$groupsOf, 2, data.cD)));

    var emptyHeadCell = _List_fromArray([A2($elm$html$Html$th, _List_Nil, _List_Nil)]);

    var headingRow = _Utils_ap(emptyHeadCell, _Utils_ap(monthRows, totalCell));

    var budgetScenarioRows = A2($elm$core$List$indexedMap, F2(function (i, _v1) {
      var _v2 = A3($author$project$ElmFramework$Lib$Util$ifElse, _Utils_Tuple2('Budget', 'secondary0'), _Utils_Tuple2('Scenario', 'gray40'), !A2($elm$core$Basics$modBy, 2, i));

      var textString = _v2.a;
      var colorClass = _v2.b;
      return A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('minW14 center'), $elm$html$Html$Attributes$class(colorClass)]), _List_fromArray([$elm$html$Html$text(textString)]));
    }), data.cD);

    var subHeadingRow = _Utils_ap(emptyHeadCell, _Utils_ap(budgetScenarioRows, totalCells));

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('scrollableNestedTable2 fullMaxWidth scrollTargetX heading4Regular marTop5 primary30')]), _List_fromArray([A2($elm$html$Html$table, _List_Nil, _List_fromArray([A2($elm$html$Html$thead, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular')]), _List_fromArray([A2($elm$html$Html$tr, _List_Nil, headingRow), A2($elm$html$Html$tr, _List_Nil, subHeadingRow)])), A2($elm$html$Html$tbody, _List_Nil, A2($author$project$Util$concatIndexMap, toRowView, data.tf))]))]));
  };

  var $author$project$Views$Routed$BudgetBranch$transactionSummaryTableSection = function (cfg) {
    var theNestedTable = function () {
      var _v0 = cfg.Ew;

      if (!_v0.$) {
        var summary = _v0.a;
        return $author$project$Ui$NestedTable$NestedTable$nestedTable2({
          wx: summary,
          iR: cfg.qi,
          j2: cfg.BY
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Transaction Summary'
    }), $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$Ui$Button$basicButtonMiddle({
      kG: '',
      vY: 1,
      yh: $elm$core$Maybe$Just($author$project$Ui$Button$IconAfterLabel($author$project$IconSvg$arrowDown)),
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
      y$: 'Download Data'
    })])), theNestedTable]));
  };

  var $author$project$Ui$Chart$BudgetChart$yAxisSourceList = _List_fromArray([0, 1, 2, 3]);

  var $author$project$Views$Routed$BudgetBranch$budgetContent = function (cfg) {
    var titleEl = $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Budget'
    });
    var scenarioTypeSelectorBtn = $author$project$Ui$Button$budgetScenarioTypeButton({
      kG: 'flex3',
      qq: 'Budget compared to:',
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, A2($author$project$Route$CompanyRoute$Budget, cfg.sR, 1)))),
      tk: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', function (scenario) {
        return scenario.zL;
      }, A2($author$project$Types$Company$toScenario, cfg.sR.pA, cfg.j)),
      EK: 'Change'
    });
    var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(cfg.eG.tc);

    var divisionsMultiSelect = function () {
      var maybeDivisions = $krisajenkins$remotedata$RemoteData$toMaybe(cfg.j.eO);
      return $author$project$Ui$SwitchDropdown$switchDropdown({
        uE: 'All Divisions',
        kG: 'flex3 minW0',
        zy: $elm$core$Maybe$Nothing,
        zT: 'No Division Selected',
        Ad: $author$project$Util$BudgetQueryInRoute$clearDivisions(currRoute),
        BF: A2($author$project$Util$BudgetQueryInRoute$selectAllDivisions, currRoute, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$toList, $elm$core$List$map(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
          return $.F;
        }))), maybeDivisions))),
        BX: F2(function (id, _v0) {
          return A2($author$project$Util$BudgetQueryInRoute$toggleDivision, currRoute, id);
        }),
        e0: maybeDivisions,
        e3: 'Divisions',
        ia: A2($elm$core$Maybe$withDefault, $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
          return $.eO;
        }, $turboMaCk$any_set$Set$Any$fromList($author$project$Types$Division$unwrapDivisionId)), $author$project$Route$RouteUtil$toBudgetQuery(currRoute))),
        t3: function ($) {
          return $.zL;
        }
      });
    }();

    var yAxisSourceDropdown = $author$project$Ui$DropdownSelect$dropdownSelect({
      vV: 'flex3',
      yI: false,
      e0: $author$project$Ui$Chart$BudgetChart$yAxisSourceList,
      e3: 'Choose...',
      Ej: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, A2($elm$core$Maybe$map, function ($) {
        return $.ka;
      }, $author$project$Route$RouteUtil$toBudgetQuery(currRoute)), cfg.eG.o_.vC.ut),
      b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBudget, $author$project$Ui$Budget$Msg$OnYAxisSourceChanged),
      fd: $elm$core$Basics$eq,
      EU: $author$project$Ui$Chart$BudgetChart$yAxisSourceToString
    });
    return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([titleEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop5 flexRow')]), _List_fromArray([divisionsMultiSelect, $author$project$ElmFramework$Lib$Util$spacer('w2'), yAxisSourceDropdown, $author$project$ElmFramework$Lib$Util$spacer('flex2'), scenarioTypeSelectorBtn])), $author$project$Views$Routed$BudgetBranch$budgetGraphSection({
      pb: cfg.sR.pb,
      qG: cfg.Ej.qG,
      qM: cfg.Ej.qN,
      Bc: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBudget, $author$project$Ui$Budget$Msg$OnMouseEnterComment)),
      rW: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBudget, $author$project$Ui$Budget$Msg$OnMouseEnterPeriod)),
      mL: $elm$core$Maybe$Just($author$project$TopMsg$msgBudget($author$project$Ui$Budget$Msg$OnMouseLeaveChart)),
      BG: $author$project$Util$BudgetQueryInRoute$setBasis(currRoute),
      BR: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBudget, $author$project$Ui$Budget$Msg$OnTapComment)),
      BV: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBudget, $author$project$Ui$Budget$Msg$OnTapPeriod)),
      b0: cfg.j.b0,
      C0: A2($elm$core$Maybe$map, function ($) {
        return $.vA;
      }, cfg.Ej.C0),
      ka: cfg.sR.ka
    }), $author$project$Views$Routed$BudgetBranch$transactionSummaryTableSection({
      qi: cfg.Ej.qi,
      BY: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBudget, $author$project$Ui$Budget$Msg$ToggleExpandRow),
      Ew: A2($elm$core$Maybe$map, function ($) {
        return $.Fb;
      }, cfg.Ej.C0)
    })]))]);
  };

  var $author$project$Views$Routed$BudgetBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$BudgetBranch$budgetView = function (cfg) {
    return $author$project$Views$Routed$BudgetBranch$viewLayer({
      pD: $author$project$Views$Routed$BudgetBranch$budgetContent(cfg),
      s9: $elm$core$Maybe$Nothing,
      DY: cfg.DY,
      eG: cfg.eG
    });
  };

  var $author$project$Ui$Scenarios$Msg$OnUpdateTextSearch = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Global$Model$DeleteScenario = F2(function (a, b) {
    return {
      $: 18,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Model$DuplicateScenario = F2(function (a, b) {
    return {
      $: 17,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$SetAsBudgetScenario = F2(function (a, b) {
    return {
      $: 49,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$UpdateScenario = F2(function (a, b) {
    return {
      $: 43,
      a: a,
      b: b
    };
  });
  var $author$project$Types$Filters$filterScenarios = F2(function (filters, scenarios) {
    var filterer = function (scenario) {
      return A2($author$project$Types$Filters$textSearchChecker, scenario.zL, filters.j_) && A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $elm$core$Basics$eq(scenario.yN), filters.br));
    };

    return A2($elm$core$List$filter, filterer, scenarios);
  });

  var $author$project$Route$BudgetRoute$isChooseBudgetScenarioRoute = function (budgetRoute) {
    return budgetRoute === 1;
  };

  var $author$project$Route$CashboardRoute$isChooseScenarioRoute = function (cashboardRoute) {
    return _Utils_eq(cashboardRoute, $author$project$Route$CashboardRoute$ChooseScenario);
  };

  var $author$project$Remote$RequestMsg$DisableScenario = F2(function (a, b) {
    return {
      $: 47,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$EnableScenario = F2(function (a, b) {
    return {
      $: 46,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Lib$Ui$Button$NoAction = {
    $: 2
  };

  var $author$project$Ui$SwitchBlockLabeled$SwitchLabelRight = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$ScenariosOptionsSingleBlock$badge = function (label) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold gradient0Back primary0 padLeft1 padRight1 flexRow flaxAlignCenter radius0 absolute  top0 moveTop50 ')]), _List_fromArray([$elm$html$Html$text(label)]));
  };

  var $author$project$Types$Role$isAbleTo = F3(function (authMetadata, permission, role) {
    if (authMetadata.$ === 3) {
      var a = authMetadata.a;
      return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$List$member(permission), A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$eq(role)), a))));
    } else {
      return false;
    }
  });
  var $author$project$Types$UserSession$isAbleDoToInCompany = F4(function (authMetadata, companyId, permission, thisUserSession) {
    var _v0 = thisUserSession.x_;

    if (_v0 === 2) {
      return true;
    } else {
      return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($author$project$Types$Role$isAbleTo, authMetadata, permission), A2($elm$core$Maybe$map, function ($) {
        return $.gz;
      }, A3($author$project$ElmFramework$Lib$PivotDict$getItem, thisUserSession.Fl.F, companyId, thisUserSession.ue))));
    }
  });

  var $samhstn$time_format$Time$Format$monthToString = function (month) {
    switch (month) {
      case 0:
        return 'Jan';

      case 1:
        return 'Feb';

      case 2:
        return 'Mar';

      case 3:
        return 'Apr';

      case 4:
        return 'May';

      case 5:
        return 'Jun';

      case 6:
        return 'Jul';

      case 7:
        return 'Aug';

      case 8:
        return 'Sep';

      case 9:
        return 'Oct';

      case 10:
        return 'Nov';

      default:
        return 'Dec';
    }
  };

  var $samhstn$time_format$Time$Format$replace = F3(function (substr, newstr, str) {
    return A2($elm$core$String$join, newstr, A2($elm$core$String$split, substr, str));
  });

  var $samhstn$time_format$Time$Format$toOrd = function (n) {
    switch (n) {
      case 1:
        return '1st';

      case 2:
        return '2st';

      case 3:
        return '3rd';

      case 21:
        return '21st';

      case 22:
        return '22st';

      case 23:
        return '23rd';

      case 31:
        return '31st';

      default:
        return $elm$core$String$fromInt(n) + 'th';
    }
  };

  var $samhstn$time_format$Time$Format$weekdayToString = function (weekday) {
    switch (weekday) {
      case 0:
        return 'Mon';

      case 1:
        return 'Tue';

      case 2:
        return 'Wed';

      case 3:
        return 'Thu';

      case 4:
        return 'Fri';

      case 5:
        return 'Sat';

      default:
        return 'Sun';
    }
  };

  var $samhstn$time_format$Time$Format$format = F3(function (zone, formatStr, millis) {
    var posix = $elm$time$Time$millisToPosix(millis);

    var formatFunc = function (f) {
      return $elm$core$String$fromInt(A2(f, zone, posix));
    };

    return A3($samhstn$time_format$Time$Format$replace, 'Weekday', $samhstn$time_format$Time$Format$weekdayToString(A2($elm$time$Time$toWeekday, zone, posix)), A3($samhstn$time_format$Time$Format$replace, 'Year', formatFunc($elm$time$Time$toYear), A3($samhstn$time_format$Time$Format$replace, 'Month', $samhstn$time_format$Time$Format$monthToString(A2($elm$time$Time$toMonth, zone, posix)), A3($samhstn$time_format$Time$Format$replace, 'Day', formatFunc($elm$time$Time$toDay), A3($samhstn$time_format$Time$Format$replace, 'ordDay', $samhstn$time_format$Time$Format$toOrd(A2($elm$time$Time$toDay, zone, posix)), A3($samhstn$time_format$Time$Format$replace, 'padDay', A3($elm$core$String$padLeft, 2, '0', formatFunc($elm$time$Time$toDay)), A3($samhstn$time_format$Time$Format$replace, 'Hour', formatFunc($elm$time$Time$toHour), A3($samhstn$time_format$Time$Format$replace, 'padHour', A3($elm$core$String$padLeft, 2, '0', formatFunc($elm$time$Time$toHour)), A3($samhstn$time_format$Time$Format$replace, 'Minute', formatFunc($elm$time$Time$toMinute), A3($samhstn$time_format$Time$Format$replace, 'padMinute', A3($elm$core$String$padLeft, 2, '0', formatFunc($elm$time$Time$toMinute)), A3($samhstn$time_format$Time$Format$replace, 'Second', formatFunc($elm$time$Time$toSecond), A3($samhstn$time_format$Time$Format$replace, 'padSecond', A3($elm$core$String$padLeft, 2, '0', formatFunc($elm$time$Time$toSecond)), A3($samhstn$time_format$Time$Format$replace, 'Millis', formatFunc($elm$time$Time$toMillis), A3($samhstn$time_format$Time$Format$replace, 'padMillis', A3($elm$core$String$padLeft, 3, '0', formatFunc($elm$time$Time$toMillis)), formatStr))))))))))))));
  });
  var $author$project$Ui$TimeRepresentation$toUSFormattedDate = F2(function (zone, posix) {
    return A3($samhstn$time_format$Time$Format$format, zone, 'padDay, Month Year', $elm$time$Time$posixToMillis(posix));
  });

  var $author$project$Ui$ScenariosOptionsSingleBlock$scenariosOptionsSingleBlock = function (cfg) {
    var _switch = function () {
      var isAbleToSwitch = A4($author$project$Types$UserSession$isAbleDoToInCompany, cfg.u0, cfg.b9, 37, cfg.DY);

      var _v5 = cfg.Dw.yC ? _Utils_Tuple2('Active', $author$project$Remote$RequestMsg$DisableScenario) : _Utils_Tuple2('Inactive', $author$project$Remote$RequestMsg$EnableScenario);

      var label = _v5.a;
      var requestMessage = _v5.b;
      return $author$project$Ui$SwitchBlockLabeled$switchBlockLabeled({
        vV: 'primary30 noLeftRadius noRightRadius transparentBorderLeft transparentBorderRight transparentBorderBottom ' + A3($author$project$ElmFramework$Lib$Util$ifElse, '', ' o5 noPointerEvents', isAbleToSwitch),
        yC: cfg.Dw.yC,
        y$: $author$project$Ui$SwitchBlockLabeled$SwitchLabelRight(label),
        ew: $author$project$TopMsg$requestMsg(A2(requestMessage, cfg.b9, cfg.Dw.F))
      });
    }();

    var scenarioTypeLabel = function () {
      if (cfg.Dw.yC) {
        var _v4 = _Utils_Tuple2(cfg.yG, cfg.yH);

        if (!_v4.a) {
          if (!_v4.b) {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          } else {
            return $author$project$Ui$ScenariosOptionsSingleBlock$badge('Budget Scenario');
          }
        } else {
          if (!_v4.b) {
            return $author$project$Ui$ScenariosOptionsSingleBlock$badge('Base Scenario');
          } else {
            return $author$project$Ui$ScenariosOptionsSingleBlock$badge('Base & Budget Scenario');
          }
        }
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var popoverMenuButtons = function () {
      var setAsBudget = A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(cfg.Dw.yC), A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!cfg.yH), $elm$core$Maybe$Just({
        y$: 'Set as Budget Scenario',
        ew: cfg.BJ,
        tY: 0
      })));
      var setAsBase = A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(cfg.Dw.yC), A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!cfg.yG), $elm$core$Maybe$Just({
        y$: 'Set as Base Scenario',
        ew: cfg.BI,
        tY: 0
      })));
      var publishScenario = A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!cfg.Dw.yU), $elm$core$Maybe$Just({
        y$: 'Publish Scenario',
        ew: cfg.Bk,
        tY: 0
      }));
      var moveToDrafts = A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!cfg.Dw.yN), $elm$core$Maybe$Just({
        y$: 'Move to Drafts',
        ew: cfg.Bd,
        tY: 0
      }));
      var editScenario = $elm$core$Maybe$Just({
        y$: 'Edit Scenario ',
        ew: cfg.AU,
        tY: 0
      });
      var duplicateScenario = $elm$core$Maybe$Just({
        y$: 'Duplicate Scenario',
        ew: cfg.AP,
        tY: 0
      });
      var deleteScenario = $elm$core$Maybe$Just({
        y$: 'Delete Scenario',
        ew: cfg.AJ,
        tY: 1
      });
      return $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([editScenario, duplicateScenario, publishScenario, moveToDrafts, setAsBudget, setAsBase, deleteScenario]));
    }();

    var headerBtnHandler = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Ui$Button$NoAction, A2($elm$core$Maybe$map, function (tag) {
      return $author$project$ElmFramework$Lib$Ui$Button$Button(tag(cfg.Dw.F));
    }, cfg.A3));
    var creatorName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Types$User$toFullName, A2($author$project$Types$UserSession$toUser, cfg.DY, cfg.Dw.cC)));
    var creationDate = A2($author$project$Ui$TimeRepresentation$toUSFormattedDate, cfg.by, A2($author$project$Types$SimpleDate$toPosix, cfg.by, cfg.Dw.tB));

    var _v0 = function () {
      var _v1 = cfg.Dw.Fg;

      if (!_v1.$) {
        var _v2 = _v1.a;
        var userId = _v2.a;
        var date = _v2.b;

        var _v3 = A2($author$project$Types$UserSession$toUser, cfg.DY, userId);

        if (!_v3.$) {
          var user = _v3.a;
          return _Utils_Tuple2($author$project$Types$User$toFullName(user), A2($author$project$Ui$TimeRepresentation$toUSFormattedDate, cfg.by, date));
        } else {
          return _Utils_Tuple2('', '');
        }
      } else {
        return _Utils_Tuple2('', '');
      }
    }();

    var updaterName = _v0.a;
    var updateDate = _v0.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flex1 radius0 whiteBack relative borderSolid borderHairlineWidth gray10Border'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, headerBtnHandler, _List_fromArray([$elm$html$Html$Attributes$class('pad2 flexRow flexAlignCenter spaceBetween gray10Back')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text(cfg.Dw.zL)])), scenarioTypeLabel, A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.sd), _List_Nil, _List_fromArray([$author$project$IconSvg$dots('w3 primary30Fill')]))])), A3($elm$core$Basics$composeR, $elm$core$String$trim, A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not), cfg.Dw.E) ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 pad2 heading5Regular primary30 gray10Border borderBottomHairline')]), _List_fromArray([$elm$html$Html$text(cfg.Dw.E)])) : $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray60 pad2')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text(' Created by ' + creatorName)])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text(creationDate)]))])), A3($elm$core$Basics$composeR, $elm$core$String$trim, A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not), updaterName) ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray60 pad2')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop1')]), _List_fromArray([$elm$html$Html$text('Last Updated by ' + updaterName)])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text(updateDate)]))])) : $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$noOpEl])), _switch, $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: popoverMenuButtons,
      vV: 'right3 top4 z1',
      f8: cfg.yS,
      E3: cfg.sd
    })]));
  };

  var $author$project$Api$Types$UpdateScenarioReq$empty = function (scenarioId) {
    return {
      vk: $elm$core$Maybe$Nothing,
      E: $elm$core$Maybe$Nothing,
      br: $elm$core$Maybe$Nothing,
      la: $elm$core$Maybe$Nothing,
      F: scenarioId,
      yC: $elm$core$Maybe$Nothing,
      rf: $elm$core$Maybe$Nothing,
      zL: $elm$core$Maybe$Nothing,
      sQ: $elm$core$Maybe$Nothing,
      de: $elm$core$Maybe$Nothing,
      df: $elm$core$Maybe$Nothing,
      tB: $elm$core$Maybe$Nothing
    };
  };

  var $author$project$Api$Types$UpdateScenarioReq$setAsDraft = F2(function (scenarioId, isDraft) {
    var req = $author$project$Api$Types$UpdateScenarioReq$empty(scenarioId);
    return _Utils_update(req, {
      br: $elm$core$Maybe$Just(isDraft)
    });
  });

  var $author$project$Route$Route$toBudgetRoute = function (route) {
    if (route.$ === 5) {
      var companyRoute = route.b;

      if (companyRoute.$ === 1) {
        var budgetRoute = companyRoute.b;
        return $elm$core$Maybe$Just(budgetRoute);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$ScenarioRows$scenarioRows = function (cfg) {
    var toScenarioView = function (scenario) {
      return $author$project$Ui$ScenariosOptionsSingleBlock$scenariosOptionsSingleBlock({
        u0: cfg.eG.o_.CT.tb,
        vV: 'flex1 mar1 minW0',
        b9: cfg.j.F,
        yG: _Utils_eq($elm$core$Maybe$Just(scenario.F), cfg.j.pa),
        yH: _Utils_eq($elm$core$Maybe$Just(scenario.F), cfg.j.pe),
        yS: _Utils_eq(cfg.eG.o_.qC.nl, $author$project$Types$Scenario$unwrapScenarioId(scenario.F)),
        AJ: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$DeleteScenario, cfg.j.F, scenario))),
        AP: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$DuplicateScenario, cfg.j.F, scenario))),
        AU: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, scenario.F, 0)))),
        A3: cfg.A3,
        Bd: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateScenario, cfg.j.F, A2($author$project$Api$Types$UpdateScenarioReq$setAsDraft, scenario.F, true))),
        Bk: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
        BI: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SetAsBaseScenario, cfg.j.F, scenario.F)),
        BJ: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SetAsBudgetScenario, cfg.j.F, scenario.F)),
        sd: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$Scenario$unwrapScenarioId(scenario.F))),
        Dw: scenario,
        DY: cfg.DY,
        tU: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        by: $elm$time$Time$utc
      });
    };

    var scenariosPerRow = function () {
      var isChooseScenarioOverlay = function () {
        var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(cfg.eG.tc);
        return A2($elm$core$Maybe$withDefault, false, A2($elm_community$maybe_extra$Maybe$Extra$orElse, A2($elm$core$Maybe$map, $author$project$Route$BudgetRoute$isChooseBudgetScenarioRoute, $author$project$Route$Route$toBudgetRoute(currRoute)), A2($elm$core$Maybe$map, $author$project$Route$CashboardRoute$isChooseScenarioRoute, $author$project$Route$Route$toCashboardRoute(currRoute))));
      }();

      var totalWidth = isChooseScenarioOverlay ? $author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits(cfg.eG.vz) * 0.6 : $author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits(cfg.eG.vz);
      var elementWidth = 29;

      var availableWidth = function () {
        if (isChooseScenarioOverlay) {
          return totalWidth;
        } else {
          var sidebarWidth = function () {
            var _v0 = cfg.eG.o_.qC.l7;

            switch (_v0) {
              case 0:
                return 0;

              case 1:
                return 14;

              default:
                return 29;
            }
          }();

          return totalWidth - sidebarWidth;
        }
      }();

      return A2($elm$core$Basics$max, 1, $elm$core$Basics$floor(availableWidth / elementWidth));
    }();

    var topUpWithEmptyElements = function (nodes) {
      var emptyElement = $author$project$ElmFramework$Lib$Util$spacer('flex1 mar1');
      return _Utils_cmp($elm$core$List$length(nodes), scenariosPerRow) < 0 ? _Utils_ap(nodes, A2($elm$core$List$repeat, scenariosPerRow - $elm$core$List$length(nodes), emptyElement)) : nodes;
    };

    return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map($elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class('flexRow')]))), A2($elm$core$Maybe$map, $elm$core$List$map(topUpWithEmptyElements), A2($elm$core$Maybe$map, $elm_community$list_extra$List$Extra$greedyGroupsOf(scenariosPerRow), A2($elm$core$Maybe$map, $elm$core$List$map(toScenarioView), A2($elm$core$Maybe$map, $author$project$Types$Filters$filterScenarios(cfg.qo), A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(cfg.j.db))))))));
  };

  var $author$project$Ui$ScenarioRows$scenarioRowsElement = function (cfg) {
    var rows = $author$project$Ui$ScenarioRows$scenarioRows({
      j: cfg.j,
      qo: cfg.qo,
      A3: cfg.A3,
      DY: cfg.DY,
      eG: cfg.eG
    });

    var element = function () {
      if ($elm$core$List$isEmpty(rows)) {
        var textSearchActive = $author$project$Types$Filters$textSearchActive(cfg.eG.o_.DC.qo);
        return !$krisajenkins$remotedata$RemoteData$isSuccess(cfg.j.db) ? _List_Nil : textSearchActive ? _List_fromArray([$author$project$Ui$EmptyStateView$emptyStateView({
          pi: $elm$core$Maybe$Nothing,
          tQ: $elm$core$Maybe$Nothing,
          t1: 'No results for your query.'
        })]) : _List_fromArray([$author$project$Ui$EmptyStateView$emptyStateView({
          pi: $elm$core$Maybe$Just(_Utils_Tuple2('+ Create a New Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(0)))))),
          tQ: $elm$core$Maybe$Nothing,
          t1: 'It looks like you haven\'t created any scenarios yet.'
        })]);
      } else {
        return rows;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.vV)]), element);
  };

  var $author$project$Ui$OverLaysView$cashboardAndBudgetOverLay = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$SlideOverRight$slideOverRight({
        vV: 'takeMoreThenHalf',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween marBottom4')]), _List_fromArray([$author$project$Ui$Input$inputWithIcon({
          vV: 'minW38',
          yh: $author$project$IconSvg$search,
          e3: 'Search',
          gx: false,
          b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenarios, $author$project$Ui$Scenarios$Msg$OnUpdateTextSearch), $author$project$Types$Filters$UpdateTextSearch),
          P: 'text',
          Fw: cfg.eG.o_.DC.qo.j_
        }), $author$project$Ui$Button$basicButtonMiddle({
          kG: '',
          vY: 0,
          yh: $elm$core$Maybe$Just($author$project$Ui$Button$CommonIcon($author$project$IconSvg$add)),
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(0))))),
          y$: 'Create a New Scenario'
        })])), $author$project$Ui$ScenarioRows$scenarioRowsElement({
          vV: 'marLeft-1',
          j: cfg.j,
          qo: cfg.eG.o_.DC.qo,
          A3: $elm$core$Maybe$Just(cfg.BC),
          DY: cfg.DY,
          eG: cfg.eG
        })]),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        tM: 1,
        t1: 'Switch Scenario'
      })
    });
  };

  var $author$project$Views$Routed$BudgetBranch$budgetBranch = function (cfg) {
    var session = cfg.DY;
    var company = cfg.j;
    var topState = cfg.eG;
    var query = cfg.sR;
    var _v0 = cfg.tc;

    if (!_v0) {
      return _List_fromArray([$author$project$Views$Routed$BudgetBranch$budgetView(cfg)]);
    } else {
      return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$BudgetBranch$budgetView(cfg)]), _List_fromArray([$author$project$Ui$OverLaysView$cashboardAndBudgetOverLay({
        j: company,
        BC: function (scenarioId) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Budget, A2($author$project$Types$BudgetQuery$setComparisonScenarioId, scenarioId, query), 0)));
        },
        DY: session,
        eG: topState
      })])]));
    }
  };

  var $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer = {
    $: 0
  };

  var $author$project$Ui$Cashboard$Msg$Allocation = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$BasePattern = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$ScenarioBlock$BottomInteractionSwitch = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Cashboard$Model$ConfirmMultipleQuickEdits = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$DiscardAllScenarioQuickEdits = F2(function (a, b) {
    return {
      $: 56,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$DiscardScenarioQuickEdits = F3(function (a, b, c) {
    return {
      $: 55,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$ScenarioBlock$Dots = 0;
  var $author$project$Remote$RequestMsg$EditScenarioBlockRelationship = F2(function (a, b) {
    return {
      $: 52,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$ScenarioBlock$Editing = 0;

  var $author$project$Ui$Cashboard$Msg$Growth = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$ScenarioBlock$None = {
    $: 1
  };

  var $author$project$Ui$Cashboard$Msg$OnQuickEdit = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnUpdateBlockFilters = function (a) {
    return {
      $: 11,
      a: a
    };
  };

  var $author$project$UiWrappers$MainAppWrap$RightTitleIcon = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$UiWrappers$MainAppWrap$SaveQuickEditsBottomBar = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$Seasonality = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$CommentsAndBuildingBlocksRightSideBarContent$commentsAndBuildingBlocksRightSideBarContent = function (cfg) {
    var showDescriptionBlockTitle = function () {
      var _v0 = cfg.pS;

      if (!_v0.$) {
        var label = _v0.a;
        return $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'padTop3',
          y$: label
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padBottom3')]), _List_fromArray([$author$project$Ui$Button$basicButton({
      kG: 'fullWidth marBottom1 marTop3',
      vY: 0,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.BT),
      y$: cfg.kz
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop3')]), _List_fromArray([$author$project$Ui$Input$inputWithIcon({
      vV: 'flex1 padRight2',
      yh: $author$project$IconSvg$search,
      e3: 'Search',
      gx: false,
      b3: cfg.r3,
      P: 'text',
      Fw: cfg.qo.j_
    }), A2($author$project$Ui$FilterButton$filterButton, cfg.qo, cfg.sc)])), showDescriptionBlockTitle, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3')]), cfg.pD)]));
  };

  var $elm_community$list_extra$List$Extra$notMember = function (x) {
    return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$member(x));
  };

  var $elm_community$list_extra$List$Extra$filterNot = F2(function (pred, list) {
    return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred), list);
  });

  var $elm_community$string_extra$String$Extra$isBlank = function (string) {
    return A2($elm$regex$Regex$contains, $elm_community$string_extra$String$Extra$regexFromString('^\\s*$'), string);
  };

  var $elm_community$string_extra$String$Extra$nonBlank = function (string) {
    return $elm_community$string_extra$String$Extra$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
  };

  var $author$project$Ui$Summary$InteractiveSummary$seasonalityTooltip = F2(function (company, maybeSeasonalityInBlock) {
    var createString = F2(function (month, value) {
      return month + (': ' + (value + '%'));
    });

    var toTooltip = function (seasonalityInBlock) {
      var arrayToTooltip = A2($elm$core$Basics$composeR, $elm$core$Array$toList, A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$filterNot($elm$core$Basics$eq(100)), A2($elm$core$Basics$composeR, $elm$core$List$indexedMap(F2(function (index, value) {
        return A2(createString, $author$project$Types$SimpleDate$monthToString($justinmimbs$date$Date$numberToMonth(index + 1)), $elm$core$String$fromInt(value));
      })), A2($elm$core$Basics$composeR, $elm$core$String$join(', '), A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$nonBlank, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Ui$Tooltip$tooltip(0)), $elm$core$Maybe$withDefault($author$project$ElmFramework$Lib$Util$noOpEl)))))));

      if (!seasonalityInBlock.$) {
        var seasonalityId = seasonalityInBlock.a;
        var maybeSeasonalityPreset = A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(seasonalityId), $krisajenkins$remotedata$RemoteData$toMaybe(company.ti));

        if (!maybeSeasonalityPreset.$) {
          var seasonalityPreset = maybeSeasonalityPreset.a;
          return arrayToTooltip(seasonalityPreset.dW);
        } else {
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        }
      } else {
        var array = seasonalityInBlock.a;
        return arrayToTooltip(array);
      }
    };

    return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, toTooltip, maybeSeasonalityInBlock));
  });

  var $author$project$Ui$Summary$InteractiveSummary$toInteractiveSummaryFromBlock = function (cfg) {
    var classes = $elm$html$Html$Attributes$class('heading5Bold primary30');

    var toElement = function (txt) {
      return A2($elm$html$Html$span, _List_fromArray([classes]), _List_fromArray([$elm$html$Html$text(txt)]));
    };

    var toInteractiveElement = F2(function (msg, txt) {
      return A2($elm$html$Html$span, _List_fromArray([classes, $elm$html$Html$Attributes$class('pointer'), $author$project$ElmFramework$Lib$Util$onTap(msg)]), _List_fromArray([$elm$html$Html$text(txt)]));
    });
    var toInteractiveSummaryFromBasicPayload = F4(function (company, startOn, blockTypeHydrated, payload) {
      return $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([$elm$core$Maybe$Just(A2(toInteractiveElement, cfg.z7, A4($author$project$Ui$Summary$Summary$toSummaryFromBasePattern, startOn, payload.g5, payload.h2, blockTypeHydrated))), A2($elm$core$Maybe$map, function (a) {
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('relative pointer'), $author$project$ElmFramework$Lib$Util$onTap(cfg.BD)]), _List_fromArray([a, A2($author$project$Ui$Summary$InteractiveSummary$seasonalityTooltip, company, payload.bK)]));
      }, A2($elm$core$Maybe$map, toElement, A2($elm$core$Maybe$map, $elm$core$String$append(', '), A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromSeasonality(company), payload.bK)))), A2($elm$core$Maybe$map, toInteractiveElement(cfg.A2), A2($elm$core$Maybe$map, $elm$core$String$append(', '), A2($elm$core$Maybe$map, $author$project$Ui$Summary$Summary$toSummaryFromGrowthPattern, payload.fZ)))]));
    });
    var toInteractiveSummaryFromMoneyPayload = F3(function (company, blockTypeHydrated, _v5) {
      var basisTransform = _v5.fE;
      var allocationClassData = _v5.kg;
      return $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([A2($elm$core$Maybe$map, toElement, A2($elm$core$Maybe$map, $elm$core$String$append(', '), A2($author$project$Ui$Summary$Summary$toSummaryFromTimeTransformation, basisTransform, blockTypeHydrated))), A2($elm$core$Maybe$map, toInteractiveElement(cfg.z3), A2($elm$core$Maybe$map, $elm$core$String$append(', '), A2($elm$core$Maybe$andThen, $author$project$Ui$Summary$Summary$toSummaryFromAllocationClassData(company), allocationClassData)))]));
    });

    var elements = function () {
      var _v0 = cfg.y.kw;

      switch (_v0.$) {
        case 0:
          if (_v0.a.$ === 3) {
            var _v1 = _v0.a.a;
            var basicPayload = _v1.a;
            var moneyPayload = _v1.b;
            return $elm$core$List$concat(_List_fromArray([A4(toInteractiveSummaryFromBasicPayload, cfg.j, cfg.y.bw, A2($author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated, basicPayload, moneyPayload), basicPayload), A3(toInteractiveSummaryFromMoneyPayload, cfg.j, A2($author$project$Types$BuildingBlockHydrated$BasicMoneyHydrated, basicPayload, moneyPayload), moneyPayload)]));
          } else {
            return _List_fromArray([toElement('Basic-money block')]);
          }

        case 1:
          if (_v0.a.$ === 3) {
            var _v2 = _v0.a.a;
            var basicPayload = _v2.a;
            var thingPayload = _v2.b;
            return $elm$core$List$concat(_List_fromArray([A4(toInteractiveSummaryFromBasicPayload, cfg.j, cfg.y.bw, A2($author$project$Types$BuildingBlockHydrated$BasicThingHydrated, basicPayload, thingPayload), basicPayload)]));
          } else {
            return _List_fromArray([toElement('Basic-thing block')]);
          }

        case 2:
          if (_v0.a.$ === 3) {
            var _v3 = _v0.a.a;
            var derivativePayload = _v3.a;
            var moneyPayload = _v3.b;
            var derivativeMoneyPayload = _v3.c;
            return $elm_community$maybe_extra$Maybe$Extra$values($elm$core$List$concat(_List_fromArray([$elm$core$List$singleton($elm$core$Maybe$Just(A2(toInteractiveElement, cfg.z7, A4($author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload, cfg.j, cfg.y.bw, A3($author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated, derivativePayload, moneyPayload, derivativeMoneyPayload), derivativePayload)))), A2($elm$core$List$map, $elm$core$Maybe$Just, A3(toInteractiveSummaryFromMoneyPayload, cfg.j, A3($author$project$Types$BuildingBlockHydrated$DerivativeMoneyHydrated, derivativePayload, moneyPayload, derivativeMoneyPayload), moneyPayload)), $elm$core$List$singleton(A2($elm$core$Maybe$map, toElement, A2($elm$core$Maybe$map, $elm$core$String$append(', '), $author$project$Ui$Summary$Summary$toSummaryFromDerivativeMoneyPayload(derivativeMoneyPayload))))])));
          } else {
            return _List_fromArray([toElement('Derivative-money block')]);
          }

        default:
          if (_v0.a.$ === 3) {
            var _v4 = _v0.a.a;
            var derivativePayload = _v4.a;
            var thingPayload = _v4.b;
            return _List_fromArray([toElement($author$project$Ui$Summary$Summary$toSummaryFromThingPayload(thingPayload)), toElement(' '), toElement(A4($author$project$Ui$Summary$Summary$toSummaryFromDerivativePayload, cfg.j, cfg.y.bw, A2($author$project$Types$BuildingBlockHydrated$DerivativeThingHydrated, derivativePayload, thingPayload), derivativePayload))]);
          } else {
            return _List_fromArray([toElement('Derivative-thing block')]);
          }

      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom2')]), elements);
  };

  var $author$project$Ui$ScenarioBlock$toPopupMenu = function (cfg) {
    var dotsCheck = function () {
      var _v0 = cfg.wM;
      return _List_fromArray([$author$project$IconSvg$dots('')]);
    }();

    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.sd), _List_fromArray([$elm$html$Html$Attributes$class('w3 primary30Fill')]), dotsCheck);
  };

  var $author$project$Ui$ScenarioBlock$toPopupOptions = function (cfg) {
    return $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: _List_fromArray([{
        y$: 'Edit Block',
        ew: cfg.hW,
        tY: 0
      }, {
        y$: 'Duplicate Block',
        ew: cfg.hU,
        tY: 0
      }, {
        y$: 'Delete Block',
        ew: cfg.hT,
        tY: 1
      }]),
      vV: 'absolute right0 top4 z1',
      f8: cfg.yS,
      E3: cfg.sd
    });
  };

  var $author$project$ElmFramework$Lib$Ui$Tooltip$Bottom = 1;

  var $author$project$Ui$ScenarioBlock$toTheBottomInteraction = function (cfg) {
    var changesOptionPart = function () {
      var _v1 = _Utils_Tuple3(cfg.vj, cfg.By, cfg.BA);

      if (!_v1.b.$ && !_v1.c.$) {
        var _v2 = _v1.a;
        var onReverseChanges = _v1.b.a;
        var onSaveChanges = _v1.c.a;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(onReverseChanges), _List_fromArray([$elm$html$Html$Attributes$class('w3 gray70Fill marRight1 relative')]), _List_fromArray([$author$project$IconSvg$update(''), A2($author$project$Ui$Tooltip$tooltip, 1, 'Revert Changes')])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(onSaveChanges), _List_fromArray([$elm$html$Html$Attributes$class('w3 primary30Fill')]), _List_fromArray([$author$project$IconSvg$check('')]))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var _v0 = cfg.vx;

    if (_v0.$ === 1) {
      return $author$project$ElmFramework$Lib$Util$noOpEl;
    } else {
      var isActive = _v0.a;
      var onTap = _v0.b;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([$author$project$Ui$Switch$switch({
        vV: '',
        hE: isActive,
        yW: false,
        tU: onTap
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 heading5Bold marLeft1 ')]), _List_fromArray([isActive ? $elm$html$Html$text('Active') : $elm$html$Html$text('Inactive')]))])), changesOptionPart]));
    }
  };

  var $author$project$Ui$ScenarioBlock$scenarioBlock = function (cfg) {
    var theIcon = _Utils_eq(A2($elm$core$Maybe$map, function ($) {
      return $.x4;
    }, cfg.qY), $elm$core$Maybe$Just(true)) ? $author$project$IconSvg$blocks('w3 marRight1 secondary40Fill') : $author$project$ElmFramework$Lib$Util$noOpEl;
    var theBottomInteraction = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, $author$project$Ui$ScenarioBlock$toTheBottomInteraction, cfg.qY));

    var summary = function () {
      var _v1 = cfg.qY;

      if (_v1.$ === 1) {
        var addBlockButton = function () {
          var _v2 = cfg.pi;

          if (_v2.$ === 1) {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          } else {
            var _v3 = _v2.a;
            var tag = _v3.a;
            var description = _v3.b;
            return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(tag), _List_fromArray([$elm$html$Html$Attributes$class('fullWidth pad1 radius0 marTop2 gray10Back heading4Bold primary30Fill')]), _List_fromArray([$elm$html$Html$text(description)]));
          }
        }();

        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold primary30')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Ui$Summary$Summary$toSummaryFromBlock, cfg.j, cfg.y)), addBlockButton]));
      } else {
        var interactive = _v1.a;
        return $author$project$Ui$Summary$InteractiveSummary$toInteractiveSummaryFromBlock({
          y: cfg.y,
          j: cfg.j,
          z3: interactive.z3,
          z7: interactive.z7,
          A2: interactive.A2,
          BD: interactive.BD,
          by: cfg.by
        });
      }
    }();

    var popupOptions = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, $author$project$Ui$ScenarioBlock$toPopupOptions, cfg.qY));
    var popupMenu = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, $author$project$Ui$ScenarioBlock$toPopupMenu, cfg.qY));

    var blockKind = function () {
      var _v0 = cfg.tO;

      if (!_v0.$) {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary10Back pad3 marTop2')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marBottom1')]), _List_fromArray([theIcon, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 primary30 heading4Bold')]), _List_fromArray([$elm$html$Html$text(cfg.y.zL)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([popupMenu, popupOptions]))])), blockKind, summary, theBottomInteraction]));
  };

  var $author$project$Types$Company$toBuildingBlocksForScenario = F4(function (maybeFilters, now, scenarioId, company) {
    return A2($elm$core$Maybe$map, $elm$core$List$map($elm$core$Tuple$first), A4($author$project$Types$Company$toBuildingBlocksAndRelationshipsForScenario, maybeFilters, now, scenarioId, company));
  });
  var $author$project$Types$Company$toOriginalBuildingBlockId = F3(function (scenarioId, company, blockId) {
    return A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, function ($) {
      return $.q5;
    }, A3($author$project$Types$Company$toScenarioBlockRelationShip, scenarioId, blockId, company)));
  });
  var $author$project$TopMsg$toSaveQuickEditForSingleScenarioMsg = F3(function (companyId, scenarioId, blockId) {
    return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SaveBlockQuickEditsForScenario, companyId, {
      dM: blockId,
      e8: scenarioId,
      ud: _List_fromArray([scenarioId])
    }));
  });
  var $author$project$TopMsg$toSaveQuickEditMsg = F4(function (company, scenarioId, block, originalBlockId) {
    var scenariosWithOriginalBlock = A2($author$project$Types$Company$toScenarioIdsForBuildingBlock, company, originalBlockId);
    var multipleScenarios = $elm$core$List$length(scenariosWithOriginalBlock) > 1;
    return multipleScenarios ? A4($author$project$TopMsg$toSaveQuickEditForMultipleScenariosMsg, company, scenarioId, block, scenariosWithOriginalBlock) : A3($author$project$TopMsg$toSaveQuickEditForSingleScenarioMsg, company.F, scenarioId, block.F);
  });

  var $author$project$Views$Routed$BuildingBlocksBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: cfg.vw,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Types$Filters$ShowQuickEditsForUser = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$Filters$withQuickEdits = F2(function (userId, filters) {
    return _Utils_update(filters, {
      h0: $elm$core$Maybe$Just($author$project$Types$Filters$ShowQuickEditsForUser(userId))
    });
  });
  var $author$project$Views$Routed$BuildingBlocksBranch$cashBoardBuildingBlockView = F5(function (session, topState, company, query, cashboardContent) {
    var toScenarioBlock = function (block) {
      var onSaveChanges = function (originalBlockId) {
        return A4($author$project$TopMsg$toSaveQuickEditMsg, company, query.Dw, block, originalBlockId);
      };

      var isQuickEdit = A3($author$project$Types$Company$isQuickEdit, company, query.Dw, block.F);
      var onReverseChanges = isQuickEdit ? $elm$core$Maybe$Just($author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$DiscardScenarioQuickEdits, company.F, query.Dw, block.F))) : $elm$core$Maybe$Nothing;

      var bottomInteraction = function () {
        var _v0 = A3($author$project$Types$Company$toScenarioBlockRelationShip, query.Dw, block.F, company);

        if (_v0.$ === 1) {
          return $author$project$Ui$ScenarioBlock$None;
        } else {
          var relation = _v0.a;
          var request = {
            dM: relation.dM,
            F: relation.F,
            yO: !relation.la,
            e8: relation.e8
          };
          return A2($author$project$Ui$ScenarioBlock$BottomInteractionSwitch, relation.la, $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$EditScenarioBlockRelationship, company.F, request)));
        }
      }();

      return $author$project$Ui$ScenarioBlock$scenarioBlock({
        y: block,
        pi: $elm$core$Maybe$Nothing,
        j: company,
        qY: $elm$core$Maybe$Just({
          vj: 0,
          vx: bottomInteraction,
          wM: 0,
          x4: false,
          yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$BuildingBlock$unwrapBuildingBlockId(block.F)),
          z3: $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$OnQuickEdit($author$project$Ui$Cashboard$Msg$Allocation(block))),
          z7: $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$OnQuickEdit($author$project$Ui$Cashboard$Msg$BasePattern(block))),
          hT: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$DeleteBlock, company, block.F))),
          hU: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CloneBlock, company.F, block.F)),
          hW: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Blocks(A2($author$project$Route$BlocksRoute$EditBlock, block.F, 0)))),
          A2: $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$OnQuickEdit($author$project$Ui$Cashboard$Msg$Growth(block))),
          By: onReverseChanges,
          BA: A2($elm$core$Maybe$map, onSaveChanges, A3($author$project$Types$Company$toOriginalBuildingBlockId, query.Dw, company, block.F)),
          BD: $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$OnQuickEdit($author$project$Ui$Cashboard$Msg$Seasonality(block))),
          sd: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$BuildingBlock$unwrapBuildingBlockId(block.F)))
        }),
        tO: $elm$core$Maybe$Just('Retail'),
        by: $elm$time$Time$utc
      });
    };

    var state = topState.o_.vO;

    var bottomBar = function () {
      var quickEdits = function () {
        var blocksWithoutQuickEdits = A2($elm$core$Maybe$withDefault, _List_Nil, A4($author$project$Types$Company$toBuildingBlocksForScenario, $elm$core$Maybe$Just($author$project$Types$Filters$withoutQuickEdits(state.pd)), $elm$core$Maybe$Just(topState.EM), query.Dw, company));
        var blocksWithQuickEdits = A2($elm$core$Maybe$withDefault, _List_Nil, A4($author$project$Types$Company$toBuildingBlocksForScenario, $elm$core$Maybe$Just(A2($author$project$Types$Filters$withQuickEdits, session.Fl.F, state.pd)), $elm$core$Maybe$Just(topState.EM), query.Dw, company));
        return A2($elm$core$List$filter, function (block) {
          return A2($elm_community$list_extra$List$Extra$notMember, block, blocksWithoutQuickEdits);
        }, blocksWithQuickEdits);
      }();

      var quickEditCount = $elm$core$List$length(quickEdits);

      if (quickEditCount <= 0) {
        return $elm$core$Maybe$Nothing;
      } else {
        var onSave = $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Just($author$project$Ui$Cashboard$Model$ConfirmMultipleQuickEdits(quickEdits))));
        var onRevert = $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DiscardAllScenarioQuickEdits, company.F, query.Dw));
        return $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$SaveQuickEditsBottomBar({
          k: quickEditCount,
          r0: onRevert,
          r2: onSave
        }));
      }
    }();

    return $author$project$Views$Routed$BuildingBlocksBranch$viewLayer({
      vw: bottomBar,
      pD: $elm$core$List$concat(_List_fromArray([cashboardContent])),
      sR: query,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightTitleIcon({
        pD: _List_fromArray([$author$project$Ui$CommentsAndBuildingBlocksRightSideBarContent$commentsAndBuildingBlocksRightSideBarContent({
          kz: '+ Add a new Block',
          pD: A2($elm$core$Maybe$withDefault, _List_fromArray([$author$project$ElmFramework$Lib$Util$noOpEl]), A2($elm$core$Maybe$map, $elm$core$List$map(toScenarioBlock), A2($elm$core$Maybe$map, $author$project$Types$Sorters$sort(1), A4($author$project$Types$Company$toBuildingBlocksForScenario, $elm$core$Maybe$Just(A2($author$project$Types$Filters$withQuickEdits, session.Fl.F, state.pd)), $elm$core$Maybe$Just(topState.EM), query.Dw, company)))),
          pS: $elm$core$Maybe$Nothing,
          qo: state.pd,
          r3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$OnUpdateBlockFilters), $author$project$Types$Filters$UpdateTextSearch),
          sc: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$BuildingBlocks(1)))),
          BT: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$CreateBlock(0))))
        })]),
        yh: $author$project$IconSvg$close,
        ew: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Building Blocks'
      })),
      DY: session,
      eG: topState
    });
  });

  var $author$project$UiWrappers$MainAppWrap$RightIconTitle = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$Filters$UpdateAge = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Types$Filters$Last3Months = 2;
  var $author$project$Types$Filters$Last7Days = 0;
  var $author$project$Types$Filters$LastMonth = 1;

  var $author$project$Types$Filters$ageList = _List_fromArray([0, 1, 2]);

  var $author$project$Types$Filters$ageToString = function (age) {
    switch (age) {
      case 0:
        return 'Last 7 Days';

      case 1:
        return 'Last Month';

      default:
        return 'Last 3 Months';
    }
  };

  var $author$project$Ui$Cashboard$Comment$View$ageSelect = F3(function (classes, state, tag) {
    return $author$project$Ui$DropdownSelect$dropdownSelect({
      vV: classes,
      yI: true,
      e0: $author$project$Types$Filters$ageList,
      e3: 'Choose...',
      Ej: state,
      b3: tag,
      fd: $elm$core$Basics$eq,
      EU: $author$project$Types$Filters$ageToString
    });
  });
  var $author$project$Views$Routed$BuildingBlocksBranch$cashboardBuildingBlocksFiltersView = F5(function (session, company, topState, query, cashboardContent) {
    var state = topState.o_.vO;
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$OnUpdateBlockFilters);
    return $author$project$Views$Routed$BuildingBlocksBranch$viewLayer({
      vw: $elm$core$Maybe$Nothing,
      pD: cashboardContent,
      sR: query,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightIconTitle({
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop4 padBottom6')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text('Filter by Author')])), function () {
          var toName = function (id) {
            return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Types$User$toFullName, A2($author$project$Types$UserSession$toUser, session, id)));
          };

          var authorDict = A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$User$unwrapUserId, A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)), A2($elm$core$List$map, function (id) {
            return _Utils_Tuple2(id, toName(id));
          }, A2($elm_community$list_extra$List$Extra$uniqueBy, $author$project$Types$User$unwrapUserId, A2($elm$core$List$map, function ($) {
            return $.cC;
          }, A2($elm$core$Maybe$withDefault, _List_Nil, A4($author$project$Types$Company$toBuildingBlocksForScenario, $elm$core$Maybe$Just(A2($author$project$Types$Filters$withQuickEdits, session.Fl.F, state.pd)), $elm$core$Maybe$Just(topState.EM), query.Dw, company)))))));
          var userIds = $turboMaCk$any_dict$Dict$Any$keys(authorDict);
          return $author$project$Ui$SwitchDropdown$switchDropdown({
            uE: 'All Authors',
            kG: 'w35',
            zy: $elm$core$Maybe$Nothing,
            zT: 'No Author Selected',
            Ad: sendMessage($author$project$Types$Filters$UpdateAuthors($turboMaCk$any_set$Set$Any$removeAll(state.pd.g0))),
            BF: sendMessage($author$project$Types$Filters$UpdateAuthors(A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$User$unwrapUserId, userIds))),
            BX: F2(function (id, _v0) {
              return sendMessage($author$project$Types$Filters$UpdateAuthors(A2($turboMaCk$any_set$Set$Any$toggle, id, state.pd.g0)));
            }),
            e0: $elm$core$Maybe$Just(authorDict),
            e3: 'Choose...',
            ia: state.pd.g0,
            t3: $elm$core$Basics$identity
          });
        }(), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text('Filter by Date')])), A3($author$project$Ui$Cashboard$Comment$View$ageSelect, '', state.pd.ft, A2($elm$core$Basics$composeL, sendMessage, $author$project$Types$Filters$UpdateAge))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'w16',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(sendMessage($author$project$Types$Filters$ClearFilters)),
          y$: 'Clear All'
        }), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
          kG: 'w16',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df),
          y$: 'Apply'
        })]))]),
        yh: $author$project$IconSvg$arrowLeft,
        yY: false,
        ew: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Filters'
      })),
      DY: session,
      eG: topState
    });
  });
  var $author$project$Remote$RequestMsg$CloneScenarioPreservingQuickEdits = F2(function (a, b) {
    return {
      $: 57,
      a: a,
      b: b
    };
  });

  var $elm$core$List$tail = function (list) {
    if (list.b) {
      var x = list.a;
      var xs = list.b;
      return $elm$core$Maybe$Just(xs);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$OverLaysView$confirmMultipleQuickEditsOverlay = F3(function (company, scenarioId, blocks) {
    var onSaveInScenario = function () {
      var _v0 = function () {
        var toBlockScenarioIdsTuple = function (block) {
          var scenarioIdsWithOriginalBlock = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Types$Company$toScenarioIdsForBuildingBlock(company), A3($author$project$Types$Company$toOriginalBuildingBlockId, scenarioId, company, block.F)));
          return _Utils_Tuple2(block, scenarioIdsWithOriginalBlock);
        };

        return A2($elm$core$List$partition, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Basics$eq(_List_fromArray([scenarioId]))), A2($elm$core$List$map, toBlockScenarioIdsTuple, blocks));
      }();

      var single = _v0.a;
      var multiple = _v0.b;
      var initialMultipleMessage = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (_v1) {
        var block = _v1.a;
        var scenarios = _v1.b;
        return _List_fromArray([A4($author$project$TopMsg$toSaveQuickEditForMultipleScenariosMsg, company, scenarioId, block, scenarios)]);
      }, $elm$core$List$head(multiple)));
      var remainingMultiples = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$TopMsg$msgCashboard), $author$project$Ui$Cashboard$Msg$SetEditingMasterBlocks), $elm$core$List$tail(multiple)));
      var singleMessages = A2($elm$core$List$map, A2($author$project$TopMsg$toSaveQuickEditForSingleScenarioMsg, company.F, scenarioId), A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, function ($) {
        return $.F;
      }), single));
      return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_Utils_ap(singleMessages, _Utils_ap(initialMultipleMessage, remainingMultiples)));
    }();

    var onCancel = $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Nothing));
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$WindowModal$windowModal({
        iw: _List_fromArray([$elm$html$Html$Attributes$class('z5')]),
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop5 marBottom5')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'maxW46 center marAuto',
          y$: 'You have edited some blocks. Would you like to save these changes?'
        })])), $author$project$UiWrappers$WindowModal$lineSeparator, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad3 flexRow')]), _List_fromArray([$author$project$Ui$Button$basicButton({
          kG: '',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onCancel),
          y$: 'Cancel'
        }), $author$project$ElmFramework$Lib$Util$spacer('flex1 minW3'), $author$project$Ui$Button$basicButton({
          kG: '',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CloneScenarioPreservingQuickEdits, company.F, scenarioId))),
          y$: 'Save as New Scenario'
        }), $author$project$ElmFramework$Lib$Util$spacer('flex1 minW3'), $author$project$Ui$Button$basicButton({
          kG: '',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onSaveInScenario),
          y$: 'Save in Scenario'
        })]))]),
        Aj: onCancel,
        t1: 'Save Changes'
      })
    });
  });
  var $author$project$Ui$Cashboard$Msg$OnQuickEditConfirm = F4(function (a, b, c, d) {
    return {
      $: 14,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Ui$OverLaysView$quickEditOverlay = F6(function (company, scenarioId, blockId, editingBlock, title, editView) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Apply',
        as: 'Cancel',
        pD: _List_fromArray([editView]),
        av: $author$project$TopMsg$msgCashboard(A4($author$project$Ui$Cashboard$Msg$OnQuickEditConfirm, scenarioId, blockId, editingBlock, company)),
        aw: $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Nothing)),
        Aj: $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$SetOverlay($elm$core$Maybe$Nothing)),
        t1: title
      })
    });
  });
  var $author$project$Views$Routed$BuildingBlocksBranch$toQuickEditOverlay = F4(function (scenarioId, company, topState, overlay) {
    var editViewDerivative = F2(function (view, blockId) {
      return view({
        y: topState.o_.vh.bv,
        j: company,
        iO: $elm$core$Maybe$Just(blockId),
        p0: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$EditingBlockMsg),
        et: true,
        mS: function (_v2) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Df;
        },
        bs: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$SetEditingBlock),
        eG: topState
      });
    });

    var editViewBasic = function (view) {
      return view({
        y: topState.o_.vh.bv,
        j: company,
        p0: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$EditingBlockMsg),
        et: true,
        mS: function (_v1) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Df;
        },
        bs: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgBlock, $author$project$Ui$Block$Msg$SetEditingBlock),
        eG: topState
      });
    };

    switch (overlay.$) {
      case 0:
        var blockId = overlay.a;
        return A6($author$project$Ui$OverLaysView$quickEditOverlay, company, scenarioId, blockId, topState.o_.vh.bv, 'Edit Seasonality Pattern', editViewBasic($author$project$Ui$Block$EditBasicBlock$seasonalityPattern));

      case 1:
        var blockId = overlay.a;
        return A6($author$project$Ui$OverLaysView$quickEditOverlay, company, scenarioId, blockId, topState.o_.vh.bv, 'Edit Growth Pattern', editViewBasic($author$project$Ui$Block$EditBasicBlock$growthPattern));

      case 2:
        var blockId = overlay.a;

        var view = function () {
          var isDerivative = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Types$BuildingBlock$isDerivative, A2($author$project$Types$Company$toBuildingBlock, blockId, company)));
          return isDerivative ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3')]), _List_fromArray([A2(editViewDerivative, $author$project$Ui$Block$EditDerivativeBlock$baseSection, blockId)])) : editViewBasic($author$project$Ui$Block$EditBasicBlock$basePattern);
        }();

        return A6($author$project$Ui$OverLaysView$quickEditOverlay, company, scenarioId, blockId, topState.o_.vh.bv, 'Edit Base Pattern', view);

      case 3:
        var blockId = overlay.a;
        return A6($author$project$Ui$OverLaysView$quickEditOverlay, company, scenarioId, blockId, topState.o_.vh.bv, 'Edit Allocation Pattern', editViewBasic($author$project$Ui$Block$EditBasicBlock$allocationPattern));

      default:
        var blocks = overlay.a;
        return A3($author$project$Ui$OverLaysView$confirmMultipleQuickEditsOverlay, company, scenarioId, blocks);
    }
  });
  var $author$project$Views$Routed$BuildingBlocksBranch$buildingBlocksBranch = F7(function (branch, session, topState, company, query, cashboardContent, overlay) {
    if (!branch) {
      return _List_fromArray([A5($author$project$Views$Routed$BuildingBlocksBranch$cashBoardBuildingBlockView, session, topState, company, query, cashboardContent), A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer, A2($elm$core$Maybe$map, A3($author$project$Views$Routed$BuildingBlocksBranch$toQuickEditOverlay, query.Dw, company, topState), overlay))]);
    } else {
      return _List_fromArray([A5($author$project$Views$Routed$BuildingBlocksBranch$cashboardBuildingBlocksFiltersView, session, company, topState, query, cashboardContent)]);
    }
  });

  var $author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnMouseEnterPeriod = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnMouseLeaveChart = {
    $: 7
  };

  var $author$project$Ui$Cashboard$Msg$OnReportingIntervalChanged = function (a) {
    return {
      $: 12,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnTapComment = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnTapPeriod = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$ToggleExpandRow = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnProjectionChartViewport = function (a) {
    return {
      $: 18,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Enum$Account_type_enum$list = _List_fromArray([0, 1]);

  var $author$project$Ui$Chart$LineBarChart$RedLineTheme = 0;

  var $author$project$Ui$Chart$BarAndLineChart$FloatingIndicator = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Chart$LineBarChart$Legend = 1;

  var $author$project$Ui$Chart$BarAndLineChart$LineChart = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Chart$LineBarChart$Main = 2;
  var $author$project$Ui$Chart$LineBarChart$YAxis = 0;

  var $author$project$ElmFramework$Lib$Ui$EventFull$onSelfSize = function (tag) {
    return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-self-size', 'true'), $author$project$ElmFramework$Lib$Ui$EventFull$onSizeEmitter(tag)]);
  };

  var $author$project$Ui$Chart$LineBarChart$lineBarChart = function (cfg) {
    var yAxisWidth = 70;
    var xAxisHeight = 140;
    var svgWidth = 30 * $elm$core$List$length(cfg.ir);
    var svgHeight = 340;
    var pins = A2($elm$core$List$filterMap, function (value) {
      return A2($elm$core$Maybe$map, function (pin) {
        return $author$project$Ui$Chart$BarAndLineChart$FloatingIndicator({
          va: 0,
          ek: value,
          ln: pin.lU ? '#00f' : '#aeb7c6',
          qu: pin,
          Fw: value.ri
        });
      }, value.sz);
    }, cfg.ir);

    var onViewport = function (size) {
      return cfg.mZ({
        x6: size.x6,
        FE: size.FE
      });
    };

    var marginTop = 30;

    var produceChart = function (section) {
      var displayTypes = $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Ui$Chart$BarAndLineChart$BarChart({
        ln: '#d0cfd8',
        x9: A2($elm$core$List$filterMap, function (value) {
          return value.q2 ? $elm$core$Maybe$Just({
            ek: value,
            vY: '#3f25e1'
          }) : $elm$core$Maybe$Nothing;
        }, cfg.ir),
        F: 'bar-1',
        zL: 'Actual',
        t7: A2($elm$core$List$map, $elm$core$Basics$always($elm$core$Maybe$Nothing), cfg.ir),
        ir: A2($elm$core$List$map, function (value) {
          return value.o4;
        }, cfg.ir)
      }), $author$project$Ui$Chart$BarAndLineChart$LineChart({
        xI: function () {
          var _v7 = cfg.zd;

          if (!_v7) {
            return '#f07e755e';
          } else {
            return '#2979f25e';
          }
        }(),
        xJ: function () {
          var _v8 = cfg.zd;

          if (!_v8) {
            return '#f07e7500';
          } else {
            return '#2979f200';
          }
        }(),
        F: 'line-1',
        zL: 'Projected',
        tK: function () {
          var _v9 = cfg.zd;

          if (!_v9) {
            return '#ee746c';
          } else {
            return '#5e2cdf';
          }
        }(),
        tL: function () {
          var _v10 = cfg.zd;

          if (!_v10) {
            return '#f7461a';
          } else {
            return '#5e2cdf';
          }
        }(),
        oo: 2.5,
        t7: A2($elm$core$List$map, function (value) {
          return value.yf;
        }, cfg.ir),
        ir: A2($elm$core$List$map, function (value) {
          return value.ri;
        }, cfg.ir)
      })]), pins]));
      var config = {
        kM: function () {
          var _v1 = cfg.DE;

          if (!_v1.$) {
            switch (section) {
              case 2:
                return _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%')]);

              case 0:
                return _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%')]);

              default:
                return _List_fromArray([$elm$html$Html$Attributes$class('right marTop-6')]);
            }
          } else {
            return _List_Nil;
          }
        }(),
        F: function () {
          var _v3 = cfg.DE;

          if (!_v3.$) {
            switch (section) {
              case 2:
                return 'svg-example-main';

              case 0:
                return 'svg-example-yaxis';

              default:
                return 'svg-example-legend';
            }
          } else {
            return 'svg-example';
          }
        }(),
        je: 150,
        re: cfg.D7 && ($elm_community$maybe_extra$Maybe$Extra$isNothing(cfg.DE) || section === 1),
        hM: {
          ra: '#fff',
          tz: '#001078'
        },
        ro: marginTop,
        Ae: function (click) {
          return A2($elm$core$Maybe$map, function (onTap) {
            return onTap({
              iL: click.ek.iL
            });
          }, click.ek.ew);
        },
        rR: function (click) {
          return click.qu.ew;
        },
        rS: function (hover) {
          return hover.qu.Bb;
        },
        rT: cfg.mL,
        mJ: function (hovering) {
          return A2($elm$core$Maybe$map, function (onHover) {
            return onHover({
              iL: hovering.ek.iL
            });
          }, hovering.ek.Bb);
        },
        os: function () {
          var _v5 = cfg.DE;

          if (!_v5.$) {
            switch (section) {
              case 2:
                return _List_fromArray([$elm$svg$Svg$Attributes$style('height: 100%; direction: ltr;'), $elm$svg$Svg$Attributes$viewBox($elm$core$String$fromInt(yAxisWidth) + (' 0 ' + ($elm$core$String$fromFloat(svgWidth) + (' ' + $elm$core$String$fromInt(svgHeight)))))]);

              case 0:
                return _List_fromArray([$elm$svg$Svg$Attributes$style('height: 100%;'), $elm$svg$Svg$Attributes$viewBox('0 0 ' + ($elm$core$String$fromInt(yAxisWidth) + (' ' + $elm$core$String$fromInt(svgHeight))))]);

              default:
                return _List_fromArray([$elm$svg$Svg$Attributes$style('height: 18px;')]);
            }
          } else {
            return _List_fromArray([$elm$svg$Svg$Attributes$style('width: 100%; max-height: ' + ($elm$core$String$fromFloat(svgHeight) + 'px'))]);
          }
        }(),
        dZ: svgHeight,
        fb: svgWidth,
        dv: {
          hb: cfg.ir,
          vP: function (category) {
            return $elm_community$maybe_extra$Maybe$Extra$isJust(category.yf) || category.q2 ? '#001078' : '#b8c0cd';
          },
          vQ: function (category) {
            return $author$project$Types$SimpleDate$toDateStringLong(category.iL);
          },
          x6: xAxisHeight
        },
        cd: {
          vy: {
            eW: 0,
            gQ: 1
          },
          y3: 5,
          Fy: function (value) {
            return $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromInt(value | 0));
          },
          FE: yAxisWidth
        }
      };
      return section === 1 ? A2($author$project$Ui$Chart$BarAndLineChart$chartLegendStandalone, config, displayTypes) : A2($author$project$Ui$Chart$BarAndLineChart$chart, config, displayTypes);
    };

    var _v0 = cfg.DE;

    if (!_v0.$) {
      var scrollableConfig = _v0.a;
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', scrollableConfig.x6), A2($elm$html$Html$Attributes$style, 'display', 'flex'), A2($elm$html$Html$Attributes$style, 'flex-direction', 'row')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'position', 'relative')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', '100%'), A2($elm$html$Html$Attributes$style, 'text-align', 'center')]), _List_fromArray([produceChart(0)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative flex1 noOverflow')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onSelfSize(onViewport)]), _List_fromArray([$elm$html$Html$Attributes$class('fullHeight fullWidth scrollTargetX')]), _List_fromArray([produceChart(2)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('chartGradientLeft absolute left0 top0 bottom0 noPointerEvents')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('chartGradientRight absolute right0 top0 bottom0 noPointerEvents')]), _List_Nil)]))])), A2($elm$html$Html$div, _List_Nil, cfg.D7 ? _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([produceChart(1)]))]) : _List_Nil)]));
    } else {
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([produceChart(2)]));
    }
  };

  var $author$project$Types$SimpleDateRange$doRangesIntersect = F2(function (range1, range2) {
    return A2($author$project$Types$SimpleDate$isLaterOrEqualWith, range1.Ef, range2.Ef) ? A2($author$project$Types$SimpleDate$isLaterOrEqualWith, range2.Ef, range1.xw) : A2($author$project$Types$SimpleDate$isLaterOrEqualWith, range1.Ef, range2.xw);
  });
  var $author$project$Types$SimpleDate$toMiddleDate = F2(function (start, end) {
    return $author$project$Types$SimpleDate$fromMillis(($author$project$Types$SimpleDate$toMillis(end) - $author$project$Types$SimpleDate$toMillis(start)) / 2 | 0);
  });

  var $author$project$Types$SimpleDateRange$toMiddleDate = function (_v0) {
    var start = _v0.Ef;
    var endInclusive = _v0.xw;
    return A2($author$project$Types$SimpleDate$toMiddleDate, start, endInclusive);
  };

  var $author$project$Types$SimpleDateRange$isMiddleOfPeriodInPeriod = F2(function (range, rangeWithMiddle) {
    return A3($author$project$Types$SimpleDate$isWithinInterval, range.Ef, range.xw, $author$project$Types$SimpleDateRange$toMiddleDate(rangeWithMiddle));
  });
  var $author$project$Ui$Chart$ProjectionChart$toTooltipView = F2(function (reportingCurrency, balancePeriod) {
    var toMoneyString = function (fraction) {
      var amount = $author$project$ElmFramework$Lib$Util$shortenFloat($JoshuaHall$elm_fraction$Fraction$toFloat(fraction));
      var suffix = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$append(' '), amount.oq);
      var val = A2($author$project$Types$Currency$toFormattedFromFloat, reportingCurrency, amount.Fv);
      return _Utils_ap(val, suffix);
    };

    var keyVal = F2(function (key, val) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap'), A2($elm$html$Html$Attributes$style, 'letter-spacing', '.1em')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray20 heading5Regular')]), _List_fromArray([$elm$html$Html$text(key + ': ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading5Bold')]), _List_fromArray([$elm$html$Html$text(val)]))]));
    });

    var metricsView = function (balancePeriodMetrics) {
      if (!balancePeriodMetrics.$) {
        var runway = balancePeriodMetrics.a.tg;

        if (!runway.$) {
          var theRunway = runway.a;
          return A2(keyVal, 'Cash Runway', $elm$core$String$fromInt(theRunway) + (' ' + A3($author$project$ElmFramework$Lib$Util$ifElse, 'day', 'days', theRunway === 1)));
        } else {
          return A2(keyVal, 'Cash Runway', 'You\'re good!');
        }
      } else {
        var record = balancePeriodMetrics.a;
        return A2(keyVal, 'Cash/Credit Ratio', $elm$core$String$fromFloat(record.vM));
      }
    };

    var projectionErrView = function (fraction) {
      return A2(keyVal, 'Error', toMoneyString(fraction));
    };

    var cashOrCredit = function () {
      var _v1 = balancePeriod.zx;

      if (!_v1.$) {
        return 'Cash';
      } else {
        return 'Credit';
      }
    }();

    var actualPositionView = function (position) {
      var key = function () {
        var _v0 = position.Cv;

        if (!_v0) {
          return 'Actual ' + cashOrCredit;
        } else {
          return 'Assumed ' + cashOrCredit;
        }
      }();

      return A2(keyVal, key, toMoneyString(position.Cu));
    };

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 padTop1h padBottom1h primary30Back inlineBlock')]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A2($elm$core$Maybe$map, actualPositionView, balancePeriod.kd), $elm$core$Maybe$Just(A2(keyVal, 'Projected ' + cashOrCredit, toMoneyString(balancePeriod.np))), $elm$core$Maybe$Just(metricsView(balancePeriod.zx)), A2($elm$core$Maybe$map, projectionErrView, balancePeriod.CC), $elm$core$Maybe$Just(A2(keyVal, 'Sum', toMoneyString(balancePeriod.or)))])));
  });
  var $author$project$Ui$Chart$ProjectionChart$toValue = F2(function (cfg, balancePeriod) {
    var toBarVal = function (position) {
      return $JoshuaHall$elm_fraction$Fraction$toFloat(position.Cu);
    };

    var maybeCommentIndicator = A4($elm$core$Maybe$map3, F3(function (onTap, onMouseEnter, comment) {
      return {
        lU: false,
        Bb: onMouseEnter(comment),
        ew: onTap(comment)
      };
    }), cfg.BR, cfg.Bc, A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, function ($) {
      return $.ap;
    }, A2($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Types$SimpleDateRange$isMiddleOfPeriodInPeriod(balancePeriod.ap))), cfg.v3));

    var hovering = function (hoveringOnPeriod) {
      return _Utils_eq(hoveringOnPeriod.ap.xw, balancePeriod.ap.xw) ? $elm$core$Maybe$Just(A2($author$project$Ui$Chart$ProjectionChart$toTooltipView, cfg.b0, hoveringOnPeriod)) : $elm$core$Maybe$Nothing;
    };

    return {
      o4: A2($elm$core$Maybe$map, toBarVal, balancePeriod.kd),
      iL: balancePeriod.ap.xw,
      yf: A2($elm$core$Maybe$andThen, hovering, cfg.qM),
      q2: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Types$SimpleDateRange$doRangesIntersect(balancePeriod.ap), cfg.ya),
      ri: $JoshuaHall$elm_fraction$Fraction$toFloat(balancePeriod.np),
      Bb: A2($elm$core$Maybe$map, function (onMouseEnter) {
        return $elm$core$Basics$always(onMouseEnter(balancePeriod));
      }, cfg.rW),
      ew: A2($elm$core$Maybe$map, function (onTap) {
        return $elm$core$Basics$always(onTap(balancePeriod));
      }, cfg.BV),
      sz: maybeCommentIndicator
    };
  });

  var $author$project$Ui$Chart$ProjectionChart$projectionChart = function (cfg) {
    return $author$project$Ui$Chart$LineBarChart$lineBarChart({
      zd: 0,
      mL: cfg.mL,
      mZ: cfg.mZ,
      DE: $elm$core$Maybe$Just({
        x6: '340px',
        zp: 'auto'
      }),
      D7: true,
      ir: A2($elm$core$List$map, $author$project$Ui$Chart$ProjectionChart$toValue(cfg), cfg.wx.Cn),
      FA: cfg.FA
    });
  };

  var $author$project$Views$Routed$CashboardBranch$cashboardChartSection = function (cfg) {
    var projectionChartEl = function () {
      var _v1 = cfg.C0;

      if (!_v1.$) {
        var cashboardDetails = _v1.a;
        return $author$project$Ui$Chart$ProjectionChart$projectionChart({
          v3: _List_Nil,
          wx: cashboardDetails,
          ya: cfg.ya,
          qM: cfg.qM,
          Bc: cfg.Bc,
          rW: cfg.rW,
          mL: cfg.mL,
          BR: cfg.BR,
          BV: cfg.BV,
          mZ: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg), $author$project$Ui$Cashboard$Msg$OnProjectionChartViewport),
          b0: cfg.b0,
          FA: cfg.pp
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var infoTagElements = function () {
      var toTag = function (label) {
        return $author$project$Ui$UsersTable$infoTag({
          vV: '',
          yh: false,
          y$: label,
          EI: 1
        });
      };

      var runwayTag = function (runway) {
        return toTag(A3($elm$core$String$replace, '{{days}}', $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromInt(runway)), 'Cash runway, {{days}} days'));
      };

      var minBalanceTag = function (minBalance) {
        return toTag(A3($elm$core$String$replace, '{{date}}', $author$project$Types$SimpleDate$toDateStringLong(minBalance.z_), A3($elm$core$String$replace, '{{amount}}', A2($author$project$Types$Currency$toFormattedFromString, 0, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$toStringFromFraction(minBalance.p))), 'Min cash, {{amount}} on {{date}}')));
      };

      var maxBalanceTag = function (maxBalance) {
        return toTag(A3($elm$core$String$replace, '{{date}}', $author$project$Types$SimpleDate$toDateStringLong(maxBalance.z_), A3($elm$core$String$replace, '{{amount}}', A2($author$project$Types$Currency$toFormattedFromString, 0, $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($author$project$Ui$TimeTransformation$Util$toStringFromFraction(maxBalance.p))), 'Max cash, {{amount}} on {{date}}')));
      };

      var cashOnHandTag = function (cashOnHand) {
        return toTag(A3($elm$core$String$replace, '{{days}}', $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromInt(cashOnHand)), 'Cash on hand, {{days}} more days'));
      };

      var _v0 = A2($elm$core$Maybe$map, function ($) {
        return $.DA;
      }, cfg.C0);

      if (!_v0.$) {
        if (!_v0.a.$) {
          var minBalance = _v0.a.a.zA;
          var runway = _v0.a.a.tg;
          var cashOnHand = _v0.a.a.pm;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop5 gapRow1')]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([$elm$core$Maybe$Just(minBalanceTag(minBalance)), A2($elm$core$Maybe$map, runwayTag, runway), A2($elm$core$Maybe$map, cashOnHandTag, cashOnHand)])));
        } else {
          var maxBalance = _v0.a.a.zl;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop5 gapRow1')]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([$elm$core$Maybe$Just(maxBalanceTag(maxBalance))])));
        }
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    var downloadDataBtn = $author$project$Ui$Button$basicButtonMiddle({
      kG: '',
      vY: 1,
      yh: $elm$core$Maybe$Just($author$project$Ui$Button$IconAfterLabel($author$project$IconSvg$arrowDown)),
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
      y$: 'Download Data'
    });
    var basisSelector = $author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
      vV: 'minW38',
      v_: $elm$core$Maybe$Just(1),
      wm: cfg.pb,
      hH: A2($elm$core$List$map, function (i) {
        return _Utils_Tuple2(i, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString(i));
      }, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$list),
      BE: cfg.BG,
      BP: 'minH4'
    });
    return A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Cash Basis'
    })])), basisSelector, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 right')]), _List_fromArray([downloadDataBtn]))])), infoTagElements, projectionChartEl]));
  };

  var $author$project$Types$CashboardQuery$clearDivisions = function (query) {
    return _Utils_update(query, {
      eO: _List_Nil
    });
  };

  var $author$project$Util$CashboardQueryInRoute$clearDivisions = function (route) {
    if (route.$ === 5 && !route.b.$) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$CashboardQuery$clearDivisions(query), subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  };

  var $author$project$Types$Division$divisionDictToDivisionIdSet = A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$toList, A2($elm$core$Basics$composeR, $elm$core$List$map(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
    return $.F;
  })), $turboMaCk$any_set$Set$Any$fromList($author$project$Types$Division$unwrapDivisionId)));

  var $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$list = _List_fromArray([0, 1]);

  var $author$project$Ui$Button$scenarioTypeButton = function (config) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.f9, _List_fromArray([$elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, '', '', config.yM)), $elm$html$Html$Attributes$class('noBorder heading4Bold opacityTransition'), $elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$disabled(config.yM)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter secondary0Back radius0 minH6 pad0h')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 flex1 padLeft2 padRight2 whiteSpaceNoWrap')]), _List_fromArray([$elm$html$Html$text(config.qq)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary30 gray10Back radius0 padTop1 padBottom1 padLeft2 padRight2 whiteSpaceNoWrap')]), _List_fromArray([$elm$html$Html$text(config.tk)]))]))]));
  };

  var $author$project$Types$CashboardQuery$selectAllDivisions = F2(function (val, query) {
    return _Utils_update(query, {
      eO: val
    });
  });
  var $author$project$Util$CashboardQueryInRoute$selectAllDivisions = F2(function (route, divisionIds) {
    if (route.$ === 5 && !route.b.$) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$selectAllDivisions, divisionIds, query), subRoute)));
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  });
  var $author$project$Types$CashboardQuery$setAccountType = F2(function (val, query) {
    return _Utils_update(query, {
      it: val
    });
  });
  var $author$project$Util$CashboardQueryInRoute$setAccountType = F2(function (route, account_type_enum) {
    return A2($author$project$Util$CashboardQueryInRoute$mapCashboardQueryInRoute, $author$project$Types$CashboardQuery$setAccountType(account_type_enum), route);
  });
  var $elm_community$string_extra$String$Extra$changeCase = F2(function (mutator, word) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (_v0) {
      var head = _v0.a;
      var tail = _v0.b;
      return A2($elm$core$String$cons, mutator(head), tail);
    }, $elm$core$String$uncons(word)));
  });

  var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
    return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
  };

  var $author$project$Ui$Cashboard$Msg$ClearCashboardQueryResponse = {
    $: 1
  };
  var $author$project$Types$CashboardQuery$toggleDivision = F2(function (val, query) {
    return _Utils_update(query, {
      eO: A2($author$project$ElmFramework$Lib$Util$toggleInList, val, query.eO)
    });
  });
  var $author$project$Util$CashboardQueryInRoute$toggleDivision = F2(function (route, divisionId) {
    if (route.$ === 5 && !route.b.$) {
      var companyId = route.a;
      var _v1 = route.b;
      var query = _v1.a;
      var subRoute = _v1.b;
      var newQuery = A2($author$project$Types$CashboardQuery$toggleDivision, divisionId, query);
      var replaceRoute = $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, A2($author$project$Route$CompanyRoute$Cashboard, newQuery, subRoute)));
      return $elm$core$List$isEmpty(newQuery.eO) ? $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([replaceRoute, $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$CashboardMsg($author$project$Ui$Cashboard$Msg$ClearCashboardQueryResponse))])) : replaceRoute;
    } else {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Do(route);
    }
  });

  var $author$project$Ui$NestedTable$NestedTable$dateView = function (date) {
    return A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('minW14 right padRight0h padLeft0h')]), _List_fromArray([$elm$html$Html$text($author$project$Types$SimpleDate$toDateStringLong(date))]));
  };

  var $author$project$Ui$NestedTable$NestedTable$nestedTable = function (_v0) {
    var data = _v0.wx;
    var expandedRows = _v0.iR;
    var toggleRowMsg = _v0.j2;
    var toRowView = F2(function (rowIndex, row) {
      return A4($author$project$Ui$NestedTable$NestedTable$rowView, _List_fromArray([rowIndex]), expandedRows, toggleRowMsg, row);
    });

    var grandTotalCell = _List_fromArray([A2($elm$html$Html$th, _List_Nil, _List_fromArray([$elm$html$Html$text('Grand total')]))]);

    var emptyHeadCell = _List_fromArray([A2($elm$html$Html$th, _List_Nil, _List_Nil)]);

    var datesHeadingRows = A2($elm$core$List$map, $author$project$Ui$NestedTable$NestedTable$dateView, data.cD);

    var headingRow = _Utils_ap(emptyHeadCell, _Utils_ap(datesHeadingRows, grandTotalCell));

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('scrollableNestedTable fullMaxWidth scrollTargetX heading4Regular marTop5 primary30')]), _List_fromArray([A2($elm$html$Html$table, _List_Nil, _List_fromArray([A2($elm$html$Html$thead, _List_fromArray([$elm$html$Html$Attributes$class('gray40 heading5Regular')]), _List_fromArray([A2($elm$html$Html$tr, _List_Nil, headingRow)])), A2($elm$html$Html$tbody, _List_Nil, A2($author$project$Util$concatIndexMap, toRowView, data.tf))]))]));
  };

  var $author$project$Views$Routed$CashboardBranch$transactionSummaryTableSection = function (cfg) {
    var theNestedTable = function () {
      var _v0 = cfg.Ew;

      if (!_v0.$) {
        var summary = _v0.a;
        return $author$project$Ui$NestedTable$NestedTable$nestedTable({
          wx: summary,
          iR: cfg.qi,
          j2: cfg.BY
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Transaction Summary'
    }), $author$project$ElmFramework$Lib$Util$spacer('w3'), cfg.yz, $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$Ui$Button$basicButtonMiddle({
      kG: '',
      vY: 1,
      yh: $elm$core$Maybe$Just($author$project$Ui$Button$IconAfterLabel($author$project$IconSvg$arrowDown)),
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
      y$: 'Download Data'
    })])), theNestedTable]));
  };

  var $author$project$Views$Routed$CashboardBranch$cashboardContent = function (cfg) {
    var titleEl = $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Cashboard'
    });
    var scenarioTypeSelectorBtn = $author$project$Ui$Button$scenarioTypeButton({
      kG: 'flex3',
      qq: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', function ($) {
        return $.zL;
      }, A2($author$project$Types$Company$toScenario, cfg.sR.Dw, cfg.j)),
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, A2($author$project$Route$CompanyRoute$Cashboard, cfg.sR, $author$project$Route$CashboardRoute$ChooseScenario)))),
      tk: 'Switch Scenario'
    });
    var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(cfg.eG.tc);

    var divisionsMultiSelect = function () {
      var setCommentDivisions = function (val) {
        return $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected(val)));
      };

      var toggleCommentDivisions = function (id) {
        return setCommentDivisions(A2($turboMaCk$any_set$Set$Any$toggle, id, A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Division$unwrapDivisionId, cfg.sR.eO)));
      };

      var maybeDivisions = $krisajenkins$remotedata$RemoteData$toMaybe(cfg.j.eO);
      return $author$project$Ui$SwitchDropdown$switchDropdown({
        uE: 'All Divisions',
        kG: 'flex3 minW0',
        zy: $elm$core$Maybe$Nothing,
        zT: 'No Division Selected',
        Ad: $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$Util$CashboardQueryInRoute$clearDivisions(currRoute), setCommentDivisions($turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId))])),
        BF: function (divisionIdList) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([A2($author$project$Util$CashboardQueryInRoute$selectAllDivisions, currRoute, divisionIdList), setCommentDivisions(A2($elm$core$Maybe$withDefault, $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId), A2($elm$core$Maybe$map, $author$project$Types$Division$divisionDictToDivisionIdSet, maybeDivisions)))]));
        }(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$toList, $elm$core$List$map(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
          return $.F;
        }))), maybeDivisions))),
        BX: F2(function (id, _v0) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([A2($author$project$Util$CashboardQueryInRoute$toggleDivision, currRoute, id), toggleCommentDivisions(id)]));
        }),
        e0: maybeDivisions,
        e3: 'Divisions',
        ia: A2($elm$core$Maybe$withDefault, $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
          return $.eO;
        }, $turboMaCk$any_set$Set$Any$fromList($author$project$Types$Division$unwrapDivisionId)), $author$project$Route$RouteUtil$toCashboardQuery(currRoute))),
        t3: function ($) {
          return $.zL;
        }
      });
    }();

    var intervalDropdown = $author$project$Ui$DropdownSelect$dropdownSelect({
      vV: '',
      yI: false,
      e0: $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$list,
      e3: 'Choose...',
      Ej: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, A2($elm$core$Maybe$map, function ($) {
        return $.jD;
      }, $author$project$Route$RouteUtil$toCashboardQuery(currRoute)), cfg.eG.o_.vO.sY),
      b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$OnReportingIntervalChanged),
      fd: $elm$core$Basics$eq,
      EU: A2($elm$core$Basics$composeR, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString, A2($elm$core$Basics$composeR, $elm$core$String$toLower, $elm_community$string_extra$String$Extra$toSentenceCase))
    });
    return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([titleEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop5 flexRow')]), _List_fromArray([divisionsMultiSelect, $author$project$ElmFramework$Lib$Util$spacer('flex5'), scenarioTypeSelectorBtn]))])), $author$project$Views$Routed$CashboardBranch$cashboardChartSection({
      pb: cfg.sR.it,
      pp: cfg.Ej.pp,
      ya: cfg.Ej.ya,
      qM: cfg.Ej.qN,
      Bc: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg), $author$project$Ui$Cashboard$Msg$OnMouseEnterComment), $elm$core$Maybe$Just)),
      rW: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg), $author$project$Ui$Cashboard$Msg$OnMouseEnterPeriod)),
      mL: $elm$core$Maybe$Just($author$project$ElmFramework$Msg$AppMsg($author$project$Msg$CashboardMsg($author$project$Ui$Cashboard$Msg$OnMouseLeaveChart))),
      BG: $author$project$Util$CashboardQueryInRoute$setAccountType(currRoute),
      BR: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg), $author$project$Ui$Cashboard$Msg$OnTapComment)),
      BV: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg), $author$project$Ui$Cashboard$Msg$OnTapPeriod)),
      b0: cfg.j.b0,
      C0: A2($elm$core$Maybe$map, function ($) {
        return $.vN;
      }, cfg.Ej.C0)
    }), $author$project$Views$Routed$CashboardBranch$transactionSummaryTableSection({
      qi: cfg.Ej.qi,
      yz: intervalDropdown,
      BY: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$CashboardMsg), $author$project$Ui$Cashboard$Msg$ToggleExpandRow),
      Ew: A2($elm$core$Maybe$map, function ($) {
        return $.Fb;
      }, cfg.Ej.C0)
    })]);
  };

  var $author$project$UiWrappers$MainAppWrap$RightVerticalMenu = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Views$Routed$CashboardBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$CashboardBranch$cashboardView = function (cfg) {
    return $author$project$Views$Routed$CashboardBranch$viewLayer({
      pD: $author$project$Views$Routed$CashboardBranch$cashboardContent(cfg),
      sR: cfg.sR,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightVerticalMenu({
        BQ: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, A2($author$project$Route$CompanyRoute$Cashboard, cfg.sR, $author$project$Route$CashboardRoute$BuildingBlocks(0)))),
        BU: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, cfg.j.F, A2($author$project$Route$CompanyRoute$Cashboard, cfg.sR, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CommentsRoute))))
      })),
      DY: cfg.DY,
      eG: cfg.eG
    });
  };

  var $author$project$Ui$Cashboard$Comment$Msg$FiltersChanged = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Types$Filters$UpdateArchived = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Types$Filters$UpdateReviews = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$SwitchLabelLeft$switchLabelLeft = function (cfg) {
    return A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter pointer heading4Bold spaceBetween primary30'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.y1)]), _List_fromArray([$elm$html$Html$text(cfg.y$)])), $author$project$Ui$Switch$switch({
      vV: '',
      hE: cfg.yC,
      yW: false,
      tU: cfg.ew
    })]));
  };

  var $author$project$Types$Company$toBaseScenario = function (company) {
    return A2($elm$core$Maybe$andThen, function (baseScenarioId) {
      return A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(baseScenarioId), $krisajenkins$remotedata$RemoteData$toMaybe(company.db));
    }, company.pa);
  };

  var $author$project$Types$Company$toReview = F2(function (reviewId, company) {
    return A2($elm_community$list_extra$List$Extra$findMap, function (scenario) {
      return A2($turboMaCk$any_dict$Dict$Any$get, reviewId, scenario.c9);
    }, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.db))));
  });

  var $author$project$Views$Routed$CommentsBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$CommentsBranch$cashBoardCommentFiltersView = F4(function (session, company, topState, cashboardContent) {
    var state = topState.o_.vO.v1;
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$CommentMessage);
    var switchDropdownSelect = F5(function (getter, unwrapId, toString, selected, filterMessage) {
      var idDict = A2($turboMaCk$any_dict$Dict$Any$fromList, unwrapId, A2($elm$core$List$map, function (a) {
        return _Utils_Tuple2(a, a);
      }, A2($elm_community$list_extra$List$Extra$uniqueBy, unwrapId, $elm_community$maybe_extra$Maybe$Extra$values(A2($elm$core$List$map, getter, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, A2($elm$core$Maybe$map, function ($) {
        return $.bH;
      }, $author$project$Types$Company$toBaseScenario(company)))))))));
      return $author$project$Ui$SwitchDropdown$switchDropdown({
        uE: 'All',
        kG: 'flex1',
        zy: $elm$core$Maybe$Nothing,
        zT: '',
        Ad: sendMessage($author$project$Ui$Cashboard$Comment$Msg$FiltersChanged(filterMessage($turboMaCk$any_set$Set$Any$empty(unwrapId)))),
        BF: sendMessage($author$project$Ui$Cashboard$Comment$Msg$FiltersChanged(filterMessage(A2($turboMaCk$any_set$Set$Any$fromList, unwrapId, $turboMaCk$any_dict$Dict$Any$values(idDict))))),
        BX: F2(function (id, _v0) {
          return sendMessage($author$project$Ui$Cashboard$Comment$Msg$FiltersChanged(filterMessage(A2($turboMaCk$any_set$Set$Any$toggle, id, selected))));
        }),
        e0: $elm$core$Maybe$Just(idDict),
        e3: 'Choose...',
        ia: selected,
        t3: toString
      });
    });
    return $author$project$Views$Routed$CommentsBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightIconTitle({
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w41 padTop4 padBottom6')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text('Filter by Date')])), A3($author$project$Ui$Cashboard$Comment$View$ageSelect, '', state.qo.ft, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Cashboard$Comment$Msg$FiltersChanged), $author$project$Types$Filters$UpdateAge)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40 marTop3')]), _List_fromArray([$elm$html$Html$text('Filter by Review')])), A5(switchDropdownSelect, function ($) {
          return $.c8;
        }, $author$project$Types$Review$unwrapReviewId, function (reviewId) {
          return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function ($) {
            return $.zL;
          }, A2($author$project$Types$Company$toReview, reviewId, company)));
        }, state.qo.c9, $author$project$Types$Filters$UpdateReviews), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40 marTop3')]), _List_fromArray([$elm$html$Html$text('Filter by Author')])), A5(switchDropdownSelect, A2($elm$core$Basics$composeR, function ($) {
          return $.cC;
        }, $elm$core$Maybe$Just), $author$project$Types$User$unwrapUserId, A2($elm$core$Basics$composeR, $author$project$Types$UserSession$toUser(session), A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Types$User$toFullName), $elm$core$Maybe$withDefault(''))), state.qo.g0, $author$project$Types$Filters$UpdateAuthors)])), $author$project$Ui$SwitchLabelLeft$switchLabelLeft({
          vV: '',
          yC: state.qo.iv,
          y$: 'View Archived Comments',
          y1: 'padRight5',
          ew: sendMessage($author$project$Ui$Cashboard$Comment$Msg$FiltersChanged($author$project$Types$Filters$UpdateArchived(!state.qo.iv)))
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padTop6')]), _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(sendMessage($author$project$Ui$Cashboard$Comment$Msg$FiltersChanged($author$project$Types$Filters$ClearFilters))),
          y$: 'Clear All'
        }), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df),
          y$: 'Apply'
        })]))]),
        yh: $author$project$IconSvg$arrowLeft,
        yY: false,
        ew: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Filters'
      })),
      DY: session,
      eG: topState
    });
  });

  var $author$project$Ui$Cashboard$Comment$Msg$CommentTyped = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$CreateComment = F2(function (a, b) {
    return {
      $: 58,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Button$InactiveButtonColor = 3;

  var $author$project$Ui$Cashboard$Comment$Msg$CommentHovered = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$CommentBlock$DarkBackground = 1;
  var $author$project$Remote$RequestMsg$EditComment = F3(function (a, b, c) {
    return {
      $: 59,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$CommentBlock$LightBackground = 0;
  var $author$project$Ui$CommentBlock$WhiteBackground = 2;
  var $elm_community$maybe_extra$Maybe$Extra$oneOf = F2(function (fmbs, a) {
    oneOf: while (true) {
      if (!fmbs.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var fmb = fmbs.a;
        var rest = fmbs.b;

        var _v1 = fmb(a);

        if (!_v1.$) {
          var b = _v1.a;
          return $elm$core$Maybe$Just(b);
        } else {
          var $temp$fmbs = rest,
              $temp$a = a;
          fmbs = $temp$fmbs;
          a = $temp$a;
          continue oneOf;
        }
      }
    }
  });

  var $ryannhg$date_format$DateFormat$Relative$defaultInSomeDays = function (days) {
    return days < 2 ? 'tomorrow' : 'in ' + ($elm$core$String$fromInt(days) + ' days');
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultInSomeHours = function (hours) {
    return hours < 2 ? 'in an hour' : 'in ' + ($elm$core$String$fromInt(hours) + ' hours');
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultInSomeMinutes = function (minutes) {
    return minutes < 2 ? 'in a minute' : 'in ' + ($elm$core$String$fromInt(minutes) + ' minutes');
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultInSomeMonths = function (months) {
    return months < 2 ? 'in a month' : 'in ' + ($elm$core$String$fromInt(months) + ' months');
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultInSomeSeconds = function (seconds) {
    return seconds < 30 ? 'in a few seconds' : 'in ' + ($elm$core$String$fromInt(seconds) + ' seconds');
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultInSomeYears = function (years) {
    return years < 2 ? 'in a year' : 'in ' + ($elm$core$String$fromInt(years) + ' years');
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultRightNow = 'right now';

  var $ryannhg$date_format$DateFormat$Relative$defaultSomeDaysAgo = function (days) {
    return days < 2 ? 'yesterday' : $elm$core$String$fromInt(days) + ' days ago';
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultSomeHoursAgo = function (hours) {
    return hours < 2 ? 'an hour ago' : $elm$core$String$fromInt(hours) + ' hours ago';
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultSomeMinutesAgo = function (minutes) {
    return minutes < 2 ? 'a minute ago' : $elm$core$String$fromInt(minutes) + ' minutes ago';
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultSomeMonthsAgo = function (months) {
    return months < 2 ? 'last month' : $elm$core$String$fromInt(months) + ' months ago';
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultSomeSecondsAgo = function (seconds) {
    return seconds < 30 ? 'just now' : $elm$core$String$fromInt(seconds) + ' seconds ago';
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultSomeYearsAgo = function (years) {
    return years < 2 ? 'last year' : $elm$core$String$fromInt(years) + ' years ago';
  };

  var $ryannhg$date_format$DateFormat$Relative$defaultRelativeOptions = {
    lJ: $ryannhg$date_format$DateFormat$Relative$defaultInSomeDays,
    lK: $ryannhg$date_format$DateFormat$Relative$defaultInSomeHours,
    lL: $ryannhg$date_format$DateFormat$Relative$defaultInSomeMinutes,
    lM: $ryannhg$date_format$DateFormat$Relative$defaultInSomeMonths,
    lN: $ryannhg$date_format$DateFormat$Relative$defaultInSomeSeconds,
    lO: $ryannhg$date_format$DateFormat$Relative$defaultInSomeYears,
    nN: $ryannhg$date_format$DateFormat$Relative$defaultRightNow,
    oi: $ryannhg$date_format$DateFormat$Relative$defaultSomeDaysAgo,
    oj: $ryannhg$date_format$DateFormat$Relative$defaultSomeHoursAgo,
    ok: $ryannhg$date_format$DateFormat$Relative$defaultSomeMinutesAgo,
    ol: $ryannhg$date_format$DateFormat$Relative$defaultSomeMonthsAgo,
    om: $ryannhg$date_format$DateFormat$Relative$defaultSomeSecondsAgo,
    on: $ryannhg$date_format$DateFormat$Relative$defaultSomeYearsAgo
  };
  var $ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions = F6(function (seconds, minutes, hours, days, months, years) {
    return {
      pP: days,
      qH: hours,
      ru: minutes,
      rw: months,
      tm: seconds,
      uu: years
    };
  });
  var $ryannhg$date_format$DateFormat$Relative$relativeTimeWithFunctions = F3(function (zone, millis, functions) {
    var seconds = millis / 1000 | 0;
    var posix = $elm$time$Time$millisToPosix(millis);
    var minutes = seconds / 60 | 0;
    var hours = minutes / 60 | 0;
    var days = hours / 24 | 0;
    return minutes < 1 ? functions.tm(A2($elm$time$Time$toSecond, zone, posix)) : hours < 1 ? functions.ru(A2($elm$time$Time$toMinute, zone, posix)) : hours < 24 ? functions.qH(A2($elm$time$Time$toHour, zone, posix)) : days < 30 ? functions.pP(days) : days < 365 ? functions.rw(days / 30 | 0) : functions.uu(days / 365 | 0);
  });
  var $ryannhg$date_format$DateFormat$Relative$toMilliseconds = $elm$time$Time$posixToMillis;
  var $ryannhg$date_format$DateFormat$Relative$relativeTimeWithOptions = F3(function (options, start, end) {
    var differenceInMilliseconds = $ryannhg$date_format$DateFormat$Relative$toMilliseconds(end) - $ryannhg$date_format$DateFormat$Relative$toMilliseconds(start);
    return !differenceInMilliseconds ? options.nN : A3($ryannhg$date_format$DateFormat$Relative$relativeTimeWithFunctions, $elm$time$Time$utc, $elm$core$Basics$abs(differenceInMilliseconds), differenceInMilliseconds < 0 ? A6($ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions, options.om, options.ok, options.oj, options.oi, options.ol, options.on) : A6($ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions, options.lN, options.lL, options.lK, options.lJ, options.lM, options.lO));
  });
  var $ryannhg$date_format$DateFormat$Relative$relativeTime = $ryannhg$date_format$DateFormat$Relative$relativeTimeWithOptions($ryannhg$date_format$DateFormat$Relative$defaultRelativeOptions);

  var $author$project$Ui$CommentBlock$commentBlock = function (cfg) {
    var repliesCount = !cfg.CY ? $author$project$ElmFramework$Lib$Util$noOpEl : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray40 heading5Bold padTop3')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(cfg.CY) + (' Repl' + A3($author$project$ElmFramework$Lib$Util$ifElse, 'ies', 'y', cfg.CY > 1)))]));

    var popoverMenuPart = function () {
      var roleDependent = F2(function (permission, option) {
        return A4($author$project$Types$UserSession$isAbleDoToInCompany, cfg.eG.o_.CT.tb, cfg.b9, permission, cfg.DY) ? $elm$core$Maybe$Just(option) : $elm$core$Maybe$Nothing;
      });

      var isCreator = function (option) {
        return _Utils_eq(cfg.DY.Fl.F, cfg.U.cC) ? $elm$core$Maybe$Just(option) : $elm$core$Maybe$Nothing;
      };

      var isActive = $elm$core$Basics$always(!cfg.U.Y);
      return $author$project$Ui$PopoverMenu$showHidePopoverMenu({
        vG: $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([A2($elm_community$maybe_extra$Maybe$Extra$filter, isActive, A2($elm_community$maybe_extra$Maybe$Extra$oneOf, _List_fromArray([isCreator, roleDependent(27), roleDependent(26)]), {
          y$: 'Archive Comment',
          ew: cfg.z5,
          tY: 0
        })), A2($elm_community$maybe_extra$Maybe$Extra$filter, isActive, A2($elm_community$maybe_extra$Maybe$Extra$oneOf, _List_fromArray([isCreator, roleDependent(27), roleDependent(26)]), {
          y$: 'Edit Comment',
          ew: cfg.AR,
          tY: 0
        })), A2($elm_community$maybe_extra$Maybe$Extra$filter, A2($elm$core$Basics$composeR, isActive, $elm$core$Basics$or(_Utils_eq(A2(roleDependent, 27, true), $elm$core$Maybe$Just(true)))), A2($elm_community$maybe_extra$Maybe$Extra$oneOf, _List_fromArray([isCreator, roleDependent(8), roleDependent(27), roleDependent(26)]), {
          y$: 'Delete Comment',
          ew: cfg.AD,
          tY: 1
        }))])),
        vV: 'absolute right3 top4 ',
        f8: cfg.yS,
        E3: cfg.sd
      });
    }();

    var onClickClasses = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Util$onTap, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$core$List$cons($elm$html$Html$Attributes$class('pointer')))), cfg.Ae));
    var modifiedCreatedAt = _Utils_cmp($elm$time$Time$posixToMillis(cfg.zX), $elm$time$Time$posixToMillis(cfg.U.iK)) < 0 ? cfg.zX : cfg.U.iK;

    var backgroundType = function () {
      var _v0 = cfg.v7;

      switch (_v0) {
        case 0:
          return 'primary10Back pad2';

        case 1:
          return 'gray10Back pad2';

        default:
          return 'primary0back';
      }
    }();

    var authorInfo = function (classes) {
      return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Types$User$toFullName, A2($elm$core$Basics$composeR, $elm$html$Html$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$html$Html$span(_List_fromArray([$elm$html$Html$Attributes$class(classes)]))))), A2($author$project$Types$UserSession$toUser, cfg.DY, cfg.U.cC)));
    };

    return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('relative'), $elm$html$Html$Attributes$class(backgroundType), $elm$html$Html$Attributes$class(cfg.vV), $elm$html$Html$Events$onMouseEnter(cfg.A4($elm$core$Maybe$Just(cfg.U))), $elm$html$Html$Events$onMouseLeave(cfg.A4($elm$core$Maybe$Nothing))]), onClickClasses), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold flexRow ')]), _List_fromArray([authorInfo('primary30 flex1'), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.sd), _List_Nil, _List_fromArray([$author$project$IconSvg$dots('w3 primary30Fill')]))])), popoverMenuPart, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray40 heading5Bold padBottom1')]), _List_fromArray([$elm$html$Html$text(A2($ryannhg$date_format$DateFormat$Relative$relativeTime, cfg.zX, modifiedCreatedAt))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary30 ')]), _List_fromArray([$elm$html$Html$text(cfg.U.U)])), repliesCount]));
  };

  var $author$project$Types$Filters$filterComments = F3(function (filters, now, comments) {
    var filterer = function (comment) {
      return A2($author$project$Types$Filters$textSearchChecker, comment.U, filters.j_) && ($turboMaCk$any_set$Set$Any$isEmpty(filters.c9) || A2($elm$core$List$member, true, A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$eq(comment.c8)), $turboMaCk$any_set$Set$Any$toList(filters.c9)))) && (_Utils_eq(filters.gw, $elm$core$Maybe$Nothing) && _Utils_eq(comment.bi, $elm$core$Maybe$Nothing) || _Utils_eq(comment.bi, filters.gw) || _Utils_eq($elm$core$Maybe$Just(comment.F), filters.gw)) && (!comment.Y || filters.iv) && A2($author$project$Types$Filters$toChecker, filters.ft.ia, A2($author$project$Types$Filters$ageChecker, now, comment.iK));
    };

    return A2($elm$core$List$filter, filterer, comments);
  });

  var $author$project$Types$Review$isPublished = function (status) {
    if (status.$ === 2) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$CashboardRoute$isReviewsRoute = function (cashboardRoute) {
    if (cashboardRoute.$ === 4) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$CommentsRoute$toReplyCommentId = function (subRoute) {
    if (subRoute.$ === 1) {
      var commentId = subRoute.a;
      return $elm$core$Maybe$Just(commentId);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };

  var $author$project$Ui$Cashboard$Comment$View$commentRows = F5(function (session, company, topState, query, filters) {
    var state = topState.o_.vO.v1;
    var reviews = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, A2($elm$core$Maybe$map, function ($) {
      return $.c9;
    }, A2($author$project$Types$Company$toScenario, query.Dw, company))));
    var isReviewsRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$CashboardRoute$isReviewsRoute, $author$project$Route$Route$toCashboardRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc))));
    var isRepliesRoute = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Route$CommentsRoute$isCommentRepliesRoute, A2($elm$core$Maybe$andThen, $author$project$Route$CashboardRoute$toCommentsRoute, $author$project$Route$Route$toCashboardRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)))));
    var allComments = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, A2($elm$core$Maybe$map, function ($) {
      return $.bH;
    }, A2($author$project$Types$Company$toScenario, query.Dw, company))));

    var commentsUserCanSee = function () {
      var unPublished = function (comment) {
        var _v1 = comment.c8;

        if (_v1.$ === 1) {
          return false;
        } else {
          var reviewId = _v1.a;
          return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
            return $.Y;
          }, A2($elm$core$Basics$composeR, $author$project$Types$Review$isPublished, $elm$core$Basics$not)), A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, function ($) {
            return $.F;
          }, $elm$core$Basics$eq(reviewId)), reviews)));
        }
      };

      var isReplyToReview = function (comment) {
        return !_Utils_eq(comment.bi, $elm$core$Maybe$Nothing) && !_Utils_eq(comment.c8, $elm$core$Maybe$Nothing);
      };

      return A2($elm_community$list_extra$List$Extra$filterNot, function (comment) {
        return unPublished(comment) && !isReviewsRoute && !isReplyToReview(comment);
      }, allComments);
    }();

    var commentGroups = A2($elm$core$List$map, function (_v0) {
      var a = _v0.a;
      var b = _v0.b;
      return A2($elm$core$List$cons, a, b);
    }, A2($elm_community$list_extra$List$Extra$gatherEqualsBy, function ($) {
      return $.c8;
    }, A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, function ($) {
      return $.iK;
    }, $elm$time$Time$posixToMillis), A3($author$project$Types$Filters$filterComments, filters, topState.EM, commentsUserCanSee))));
    var replyTo = A2($elm$core$Maybe$map, $author$project$Types$User$toFullName, A2($elm$core$Maybe$andThen, $author$project$Types$UserSession$toUser(session), A2($elm$core$Maybe$map, function ($) {
      return $.cC;
    }, A2($elm$core$Maybe$andThen, function (id) {
      return A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, function ($) {
        return $.F;
      }, $elm$core$Basics$eq(id)), allComments);
    }, A2($elm$core$Maybe$andThen, $author$project$Route$CommentsRoute$toReplyCommentId, A2($elm$core$Maybe$andThen, $author$project$Route$CashboardRoute$toCommentsRoute, $author$project$Route$Route$toCashboardRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc))))))));

    var toCommentBlock = function (comment) {
      var repliesCount = A2($elm_community$list_extra$List$Extra$count, A2($elm$core$Basics$composeR, function ($) {
        return $.bi;
      }, $elm$core$Basics$eq($elm$core$Maybe$Just(comment.F))), allComments);
      var onClick = isRepliesRoute ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CommentReplies(comment.F))))));
      var isSelected = !_Utils_eq(state.f$, $elm$core$Maybe$Nothing) ? _Utils_eq(state.f$, $elm$core$Maybe$Just(comment.F)) : A2($elm$core$Maybe$withDefault, false, A3($elm$core$Maybe$map2, $author$project$Types$SimpleDateRange$doRangesIntersect, topState.o_.vO.ya, comment.ap));
      var archiveCommentReq = {
        U: comment.U,
        cD: $elm$core$Maybe$Nothing,
        eO: $elm$core$Maybe$Nothing,
        bi: $elm$core$Maybe$Nothing,
        c8: $elm$core$Maybe$Nothing,
        Y: $elm$core$Maybe$Just(1)
      };
      return $author$project$Ui$CommentBlock$commentBlock({
        vV: 'marTop2',
        U: comment,
        b9: company.F,
        v7: A3($author$project$ElmFramework$Lib$Util$ifElse, 2, A3($author$project$ElmFramework$Lib$Util$ifElse, 1, 0, isSelected), isRepliesRoute),
        yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$Comment$unwrapCommentId(comment.F)),
        zX: topState.EM,
        z5: $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$EditComment, company.F, comment.F, archiveCommentReq)),
        Ae: onClick,
        AD: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$DeleteComment(comment.F))))),
        AR: $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$EditComment(comment.F))))), $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$CommentTyped(comment.U))), $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected(comment.eO)))])),
        A4: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$CommentMessage), $author$project$Ui$Cashboard$Comment$Msg$CommentHovered),
        sd: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$Comment$unwrapCommentId(comment.F))),
        CY: repliesCount,
        bi: replyTo,
        DY: session,
        eG: topState
      });
    };

    var toCommentBlockGroups = function (commentGroup) {
      var separationBars = isRepliesRoute ? $elm$core$List$intersperse(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2 hairLineHeight gray10Back')]), _List_Nil)) : $elm$core$Basics$identity;
      var reviewInfo = isReviewsRoute || isRepliesRoute ? $author$project$ElmFramework$Lib$Util$noOpEl : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40 marTop3')]), $elm$core$List$singleton($elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Independent', A2($elm$core$Maybe$map, function ($) {
        return $.zL;
      }, A2($elm$core$Maybe$andThen, function (reviewId) {
        return A2($author$project$Types$Company$toReview, reviewId, company);
      }, A2($elm_community$list_extra$List$Extra$findMap, function ($) {
        return $.c8;
      }, commentGroup)))))));
      return _List_fromArray([reviewInfo, A2($elm$html$Html$div, _List_Nil, separationBars(A2($elm$core$List$map, toCommentBlock, commentGroup)))]);
    };

    return $elm$core$List$concat(A2($elm$core$List$map, toCommentBlockGroups, commentGroups));
  });

  var $author$project$Views$Routed$CommentsBranch$divider = function (classes) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('hairLineHeight gray10Back'), $elm$html$Html$Attributes$class(classes)]), _List_Nil);
  };

  var $elm$html$Html$Attributes$rows = function (n) {
    return A2(_VirtualDom_attribute, 'rows', $elm$core$String$fromInt(n));
  };

  var $elm$html$Html$textarea = _VirtualDom_node('textarea');

  var $author$project$ElmFramework$Lib$Ui$TextAreaSelfSize$textAreaSelfSize = function (config) {
    var showBorder = config.vv ? ' padLeft2 padRight2 padTop1h padBottom1h borderHairlineWidth borderSolid gray20Border radius0' : ' noBorder';
    return A3($elm$html$Html$node, 'textarea-self-size', _List_fromArray([$elm$html$Html$Attributes$class(config.dJ)]), _List_fromArray([A2($elm$html$Html$textarea, _List_fromArray([$elm$html$Html$Attributes$rows(1), $elm$html$Html$Attributes$class('minH6 maxH15 fullWidth heading4Bold  placeholderGray20 primary30 ' + (config.kG + showBorder)), $elm$html$Html$Attributes$required(config.gx), $elm$html$Html$Attributes$disabled(config.k_), $elm$html$Html$Attributes$placeholder(config.e3), $elm$html$Html$Attributes$value(config.Fw), $elm$html$Html$Events$onInput(config.e_)]), _List_Nil)]));
  };

  var $author$project$Types$Filters$withReplies = F2(function (replies, filters) {
    return _Utils_update(filters, {
      gw: $elm$core$Maybe$Just(replies)
    });
  });
  var $author$project$Views$Routed$CommentsBranch$cashboardCommentReplies = F6(function (commentId, session, company, topState, cashboardContent, query) {
    var state = topState.o_.vO.v1;
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$CommentMessage);
    var filter = A2($author$project$Types$Filters$withReplies, commentId, $author$project$Types$Filters$empty);

    var createCommentReq = function () {
      var maybeComment = A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(commentId), A2($elm$core$Maybe$map, function ($) {
        return $.bH;
      }, A2($author$project$Types$Company$toScenario, query.Dw, company)));
      return {
        U: state.EH,
        cD: $elm$core$Maybe$Nothing,
        eO: $elm$core$Maybe$Nothing,
        bi: $elm$core$Maybe$Just(commentId),
        c8: A2($elm$core$Maybe$andThen, function ($) {
          return $.c8;
        }, maybeComment),
        e8: query.Dw
      };
    }();

    var onPost = $elm$core$String$isEmpty($elm$core$String$trim(state.EH)) ? A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please provide a comment', _List_Nil) : $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CreateComment, company.F, createCommentReq));
    return $author$project$Views$Routed$CommentsBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightIconTitle({
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w41')]), A5($author$project$Ui$Cashboard$Comment$View$commentRows, session, company, topState, query, filter)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('sticky bottom0 primary0Back')]), _List_fromArray([$author$project$Views$Routed$CommentsBranch$divider('marTop7'), $author$project$ElmFramework$Lib$Ui$TextAreaSelfSize$textAreaSelfSize({
          vv: false,
          kG: 'marTop2',
          k_: false,
          e_: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Cashboard$Comment$Msg$CommentTyped),
          e3: 'Reply',
          gx: false,
          Fw: state.EH,
          dJ: ''
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padTop4')]), _List_fromArray([function () {
          var _v0 = $elm$core$String$isEmpty(state.EH) ? _Utils_Tuple2(true, 3) : _Utils_Tuple2(false, 0);

          var isDisabled = _v0.a;
          var color = _v0.b;
          return $author$project$Ui$Button$basicButtonMiddle({
            kG: 'flex1 marBottom3',
            vY: color,
            yh: $elm$core$Maybe$Nothing,
            yM: isDisabled,
            f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onPost),
            y$: 'Post'
          });
        }()]))]))]),
        yh: $author$project$IconSvg$arrowLeft,
        yY: false,
        ew: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: ''
      })),
      DY: session,
      eG: topState
    });
  });

  var $author$project$Ui$CommentsAndBuildingBlocksRightSideBarContent$commentsRightSideBarContent = function (cfg) {
    var showDescriptionBlockTitle = function () {
      var _v0 = cfg.pS;

      if (!_v0.$) {
        var label = _v0.a;
        return $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'padTop3',
          y$: label
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padBottom3')]), _List_fromArray([$author$project$Ui$Button$basicButton({
      kG: 'fullWidth marBottom1 marTop3 block',
      vY: 1,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.BS),
      y$: cfg.xM
    }), $author$project$Ui$Button$basicButton({
      kG: 'fullWidth marBottom1 block',
      vY: 0,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.BW),
      y$: cfg.DG
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop3')]), _List_fromArray([$author$project$Ui$Input$inputWithIcon({
      vV: 'flex1 padRight2',
      yh: $author$project$IconSvg$search,
      e3: 'Search',
      gx: false,
      b3: cfg.r3,
      P: 'text',
      Fw: cfg.qo.j_
    }), A2($author$project$Ui$FilterButton$filterButton, cfg.qo, cfg.sc)])), showDescriptionBlockTitle, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3')]), cfg.pD)]));
  };

  var $author$project$Views$Routed$CommentsBranch$cashboardCommentsView = F5(function (session, topState, company, query, cashboardContent) {
    var filters = topState.o_.vO.v1.qo;
    return $author$project$Views$Routed$CommentsBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightTitleIcon({
        pD: _List_fromArray([$author$project$Ui$CommentsAndBuildingBlocksRightSideBarContent$commentsRightSideBarContent({
          pD: A5($author$project$Ui$Cashboard$Comment$View$commentRows, session, company, topState, query, filters),
          pS: $elm$core$Maybe$Nothing,
          qo: filters,
          xM: 'Go to Reviews',
          r3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$CommentMessage), $author$project$Ui$Cashboard$Comment$Msg$FiltersChanged), $author$project$Types$Filters$UpdateTextSearch),
          sc: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CommentsFilters)))),
          BS: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$ChooseReview))))),
          BW: $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$CreateIndependentComment))))), $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected(A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Division$unwrapDivisionId, query.eO)))), $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$CommentTyped('')))])),
          DG: '+ Add a new Comment'
        })]),
        yh: $author$project$IconSvg$close,
        ew: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Comments'
      })),
      DY: session,
      eG: topState
    });
  });

  var $author$project$UiWrappers$MainAppWrap$RightIconTitleIcon = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Comment$View$divisionsMultiSelect = F3(function (selected, sendMessage, company) {
    var maybeDivisions = $krisajenkins$remotedata$RemoteData$toMaybe(company.eO);
    return $author$project$Ui$SwitchDropdown$switchDropdown({
      uE: 'All',
      kG: 'flex1',
      zy: $elm$core$Maybe$Nothing,
      zT: 'General',
      Ad: sendMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected($turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId))),
      BF: sendMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected(A2($elm$core$Maybe$withDefault, $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId), A2($elm$core$Maybe$map, $author$project$Types$Division$divisionDictToDivisionIdSet, maybeDivisions)))),
      BX: F2(function (id, _v0) {
        return sendMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected(A2($turboMaCk$any_set$Set$Any$toggle, id, selected)));
      }),
      e0: maybeDivisions,
      e3: 'General',
      ia: selected,
      t3: function ($) {
        return $.zL;
      }
    });
  });

  var $author$project$IconSvg$pin_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20.5 8C15.8007 8 12 11.756 12 16.4C12 22.7 20.5 32 20.5 32C20.5 32 29 22.7 29 16.4C29 11.756 25.1993 8 20.5 8ZM14.4285 16.3999C14.4285 13.0879 17.1485 10.3999 20.4999 10.3999C23.8513 10.3999 26.5713 13.0879 26.5713 16.3999C26.5713 19.8559 23.0742 25.0279 20.4999 28.2559C17.9742 25.0519 14.4285 19.8199 14.4285 16.3999ZM17.4642 16.3999C17.4642 14.743 18.8233 13.3999 20.4999 13.3999C21.5845 13.3999 22.5866 13.9717 23.1289 14.8999C23.6712 15.8281 23.6712 16.9717 23.1289 17.8999C22.5866 18.8281 21.5845 19.3999 20.4999 19.3999C18.8233 19.3999 17.4642 18.0568 17.4642 16.3999Z')]), _List_Nil)]));
  };

  var $author$project$IconSvg$pin = function (classes) {
    return $author$project$IconSvg$pin_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Views$Routed$CommentsBranch$cashboardEditComment = F6(function (commentId, session, company, topState, cashboardContent, query) {
    var state = topState.o_.vO.v1;
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$CommentMessage);
    var editCommentReq = {
      U: state.EH,
      cD: $elm$core$Maybe$Nothing,
      eO: $elm$core$Maybe$Just(state.eO),
      bi: $elm$core$Maybe$Nothing,
      c8: $elm$core$Maybe$Nothing,
      Y: $elm$core$Maybe$Nothing
    };
    return $author$project$Views$Routed$CommentsBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightIconTitleIcon({
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop4 padBottom6')]), _List_fromArray([A3($author$project$Ui$Cashboard$Comment$View$divisionsMultiSelect, state.eO, sendMessage, company), $author$project$ElmFramework$Lib$Ui$TextAreaSelfSize$textAreaSelfSize({
          vv: false,
          kG: '',
          k_: false,
          e_: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Cashboard$Comment$Msg$CommentTyped),
          e3: 'Comment context for edit',
          gx: true,
          Fw: state.EH,
          dJ: 'block padTop4'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padTop4')]), _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df),
          y$: 'Cancel'
        }), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$EditComment, company.F, commentId, editCommentReq))),
          y$: 'Save'
        })]))]))]),
        y9: $author$project$IconSvg$arrowLeft,
        za: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        Bj: false,
        Dd: $author$project$IconSvg$pin,
        De: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Edit comment'
      })),
      DY: session,
      eG: topState
    });
  });

  var $author$project$Views$Routed$CreateCommentBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$CreateCommentBranch$cashboardChooseReviewView = F3(function (session, topState, cashboardContent) {
    return $author$project$Views$Routed$CreateCommentBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Nothing,
      DY: session,
      eG: topState
    });
  });
  var $author$project$Views$Routed$CreateCommentBranch$cashboardConfirmDeletingReview = F3(function (session, topState, cashboardContent) {
    return $author$project$Views$Routed$CreateCommentBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Nothing,
      DY: session,
      eG: topState
    });
  });
  var $author$project$Ui$Cashboard$Comment$Msg$DatePicked = F3(function (a, b, c) {
    return {
      $: 3,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$Cashboard$Comment$Msg$DateToggled = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$RangeDateInput$RangeDateInput$toSimpleDateRange = F2(function (zone, value) {
    return A2($elm$core$Maybe$map, function (_v0) {
      var start = _v0.Ef;
      var end = _v0.dR;
      return {
        dR: A2($author$project$Types$SimpleDate$fromPosix, zone, end),
        Ef: A2($author$project$Types$SimpleDate$fromPosix, zone, start)
      };
    }, value);
  });
  var $author$project$Ui$RangeDateInput$RangeDateInput$DateInputChanged = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$RangeDateInput$RangeDateInput$End = 1;
  var $author$project$Ui$RangeDateInput$RangeDateInput$Start = 0;

  var $author$project$Ui$RangeDateInput$RangeDateInput$getEndDateInputString = function (_v0) {
    var endString = _v0.b;
    return A2($elm$core$Maybe$withDefault, '', endString);
  };

  var $author$project$Ui$RangeDateInput$RangeDateInput$getStartDateInputString = function (_v0) {
    var startString = _v0.a;
    return A2($elm$core$Maybe$withDefault, '', startString);
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$FirstCal = 0;
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix = 'elm-datetimepicker-duration--';
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$datePickerId = 'date-picker-component';
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$NextMonthFirstCalendar = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$PrevMonthFirstCalendar = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$processSelection = F2(function (model, _v0) {
    var startSelectionTuple = _v0.a;
    var endSelectionTuple = _v0.b;
    var newDuration = A3($elm$core$Maybe$map2, F2(function (_v1, _v2) {
      var startSelection = _v1.b;
      var endSelection = _v2.b;
      return _Utils_Tuple2(startSelection, endSelection);
    }), startSelectionTuple, endSelectionTuple);
    return _Utils_Tuple2(_Utils_update(model, {
      eP: endSelectionTuple,
      fa: startSelectionTuple
    }), newDuration);
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$selectDay = F4(function (zone, previousStartSelectionTuple, previousEndSelectionTuple, selectedPickerDay) {
    if (selectedPickerDay.k_) {
      return _Utils_Tuple2(previousStartSelectionTuple, previousEndSelectionTuple);
    } else {
      var _v0 = _Utils_Tuple2(previousStartSelectionTuple, previousEndSelectionTuple);

      if (!_v0.a.$) {
        if (!_v0.b.$) {
          var _v1 = _v0.a.a;
          var startPickerDay = _v1.a;
          var previousSelectionStart = _v1.b;
          var _v2 = _v0.b.a;
          var endPickerDay = _v2.a;
          var previousSelectionEnd = _v2.b;
          return _Utils_eq(startPickerDay, selectedPickerDay) && _Utils_eq(selectedPickerDay, endPickerDay) ? _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(startPickerDay, previousSelectionStart)), $elm$core$Maybe$Nothing) : _Utils_eq(startPickerDay, selectedPickerDay) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(_Utils_Tuple2(endPickerDay, previousSelectionEnd))) : _Utils_eq(endPickerDay, selectedPickerDay) ? _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(startPickerDay, previousSelectionStart)), $elm$core$Maybe$Nothing) : _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.Ef)), $elm$core$Maybe$Nothing);
        } else {
          var _v3 = _v0.a.a;
          var startPickerDay = _v3.a;
          var selectionStart = _v3.b;
          var _v4 = _v0.b;
          return _Utils_eq(startPickerDay, selectedPickerDay) || _Utils_cmp($elm$time$Time$posixToMillis(startPickerDay.Ef), $elm$time$Time$posixToMillis(selectedPickerDay.Ef)) < 0 ? _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(startPickerDay, selectionStart)), $elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.dR))) : A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$posixWithinPickerDayBoundaries, zone, selectedPickerDay, selectionStart) ? _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$setTimeOfDay, zone, A2($elm$time$Time$toHour, zone, selectionStart), A2($elm$time$Time$toMinute, zone, selectionStart), selectedPickerDay.Ef))), $elm$core$Maybe$Just(_Utils_Tuple2(startPickerDay, startPickerDay.dR))) : _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.Ef)), $elm$core$Maybe$Just(_Utils_Tuple2(startPickerDay, startPickerDay.dR)));
        }
      } else {
        if (!_v0.b.$) {
          var _v5 = _v0.a;
          var _v6 = _v0.b.a;
          var endPickerDay = _v6.a;
          var selectionEnd = _v6.b;
          return _Utils_eq(endPickerDay, selectedPickerDay) || _Utils_cmp($elm$time$Time$posixToMillis(endPickerDay.Ef), $elm$time$Time$posixToMillis(selectedPickerDay.dR)) > 0 ? _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.Ef)), $elm$core$Maybe$Just(_Utils_Tuple2(endPickerDay, selectionEnd))) : A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$posixWithinPickerDayBoundaries, zone, selectedPickerDay, selectionEnd) ? _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(endPickerDay, endPickerDay.Ef)), $elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$setTimeOfDay, zone, A2($elm$time$Time$toHour, zone, selectionEnd), A2($elm$time$Time$toMinute, zone, selectionEnd), selectedPickerDay.dR)))) : _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(endPickerDay, endPickerDay.Ef)), $elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.dR)));
        } else {
          var _v7 = _v0.a;
          var _v8 = _v0.b;
          return _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(selectedPickerDay, selectedPickerDay.Ef)), $elm$core$Maybe$Nothing);
        }
      }
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update = F3(function (settings, msg, _v0) {
    var model = _v0;
    var _v1 = model.Y;

    if (_v1.$ === 1) {
      switch (msg.$) {
        case 0:
          return _Utils_Tuple2(_Utils_update(model, {
            du: A2($elm$core$Tuple$mapFirst, function (x) {
              return x + 1;
            }, model.du)
          }), $elm$core$Maybe$Nothing);

        case 1:
          return _Utils_Tuple2(_Utils_update(model, {
            du: A2($elm$core$Tuple$mapFirst, function (x) {
              return x - 1;
            }, model.du)
          }), $elm$core$Maybe$Nothing);

        case 2:
          return _Utils_Tuple2(_Utils_update(model, {
            du: A2($elm$core$Tuple$mapFirst, function (x) {
              return x + 12;
            }, model.du)
          }), $elm$core$Maybe$Nothing);

        case 3:
          return _Utils_Tuple2(_Utils_update(model, {
            du: A2($elm$core$Tuple$mapFirst, function (x) {
              return x - 12;
            }, model.du)
          }), $elm$core$Maybe$Nothing);

        case 4:
          var pickerDay = msg.a;
          return _Utils_Tuple2(_Utils_update(model, {
            f$: $elm$core$Maybe$Just(pickerDay)
          }), $elm$core$Maybe$Nothing);

        case 5:
          return _Utils_Tuple2(_Utils_update(model, {
            f$: $elm$core$Maybe$Nothing
          }), $elm$core$Maybe$Nothing);

        default:
          var pickerDay = msg.a;
          return A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$processSelection, model, A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$selectDay, settings.by, model.fa, model.eP, pickerDay));
      }
    } else {
      return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewMonthHeader = F4(function (settings, model, time, calView) {
    var yearName = $elm$core$String$fromInt(A2($elm$time$Time$toYear, settings.by, time));
    var monthName = settings.qy(A2($elm$time$Time$toMonth, settings.by, time));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-row')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('previous-month'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$PrevMonthFirstCalendar, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 18, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronLeft))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-text')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('month')]), _List_fromArray([$elm$html$Html$text(settings.n7 ? monthName : monthName + (' ' + yearName))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('next-month'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$NextMonthFirstCalendar, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 18, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronRight))]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewHeaderDay = F2(function (formatDay, day) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-day')]), _List_fromArray([$elm$html$Html$text(formatDay(day))]));
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewWeekHeader = function (settings) {
    return settings.tw ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-week')]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewHeaderDay(settings.qx), $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$generateListOfWeekDay(settings.lq))) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$NextYearFirstCalendar = {
    $: 2
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$PrevYearFirstCalendar = {
    $: 3
  };
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewYearHeader = F4(function (settings, model, time, calView) {
    var yearName = $elm$core$String$fromInt(A2($elm$time$Time$toYear, settings.by, time));
    return settings.n7 ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-row')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('previous-year'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$PrevYearFirstCalendar, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 12, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronsLeft))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-text')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('year')]), _List_fromArray([$elm$html$Html$text(yearName)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('next-year'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header-chevron'), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$NextYearFirstCalendar, model)))]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$toHtml, _List_Nil, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$withSize, 12, $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Icons$chevronsRight))]))])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewCalendarHeader = F4(function (settings, model, viewTime, calView) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-header')]), _List_fromArray([A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewMonthHeader, settings, model, viewTime, calView), A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewYearHeader, settings, model, viewTime, calView), $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewWeekHeader(settings)]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$ClearHoveredDay = {
    $: 5
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$SetHoveredDay = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$SetRange = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$isDayBetweenDates = F3(function (day, dateOne, dateTwo) {
    return _Utils_cmp($elm$time$Time$posixToMillis(dateOne.Ef), $elm$time$Time$posixToMillis(day.dR)) > 0 && _Utils_cmp($elm$time$Time$posixToMillis(day.Ef), $elm$time$Time$posixToMillis(dateTwo.dR)) > 0 || _Utils_cmp($elm$time$Time$posixToMillis(dateOne.dR), $elm$time$Time$posixToMillis(day.Ef)) < 0 && _Utils_cmp($elm$time$Time$posixToMillis(day.dR), $elm$time$Time$posixToMillis(dateTwo.Ef)) < 0;
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$dayPickedOrBetween = F4(function (zone, day, hovered, _v0) {
    var startSelectionTuple = _v0.a;
    var endSelectionTuple = _v0.b;

    var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);

    if (_v1.a.$ === 1) {
      if (_v1.b.$ === 1) {
        var _v2 = _v1.a;
        var _v3 = _v1.b;
        return _Utils_Tuple2(false, false);
      } else {
        var _v6 = _v1.a;
        var _v7 = _v1.b.a;
        var endPickerDay = _v7.a;
        var between = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (h) {
          return A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$isDayBetweenDates, day, endPickerDay, h);
        }, hovered));
        return _Utils_Tuple2(_Utils_eq(day, endPickerDay), between);
      }
    } else {
      if (_v1.b.$ === 1) {
        var _v4 = _v1.a.a;
        var startPickerDay = _v4.a;
        var _v5 = _v1.b;
        var between = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (h) {
          return A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$isDayBetweenDates, day, startPickerDay, h);
        }, hovered));
        return _Utils_Tuple2(_Utils_eq(day, startPickerDay), between);
      } else {
        var _v8 = _v1.a.a;
        var startPickerDay = _v8.a;
        var _v9 = _v1.b.a;
        var endPickerDay = _v9.a;
        return _Utils_Tuple2(_Utils_eq(day, startPickerDay) || _Utils_eq(day, endPickerDay), A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$isDayBetweenDates, day, startPickerDay, endPickerDay));
      }
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Styles$durationDayClasses = F6(function (classPrefix, isHidden, isDisabled, isPicked, isToday, isBetween) {
    return isHidden ? classPrefix + ('calendar-day ' + (classPrefix + 'hidden')) : isDisabled ? classPrefix + ('calendar-day ' + (classPrefix + 'disabled')) : isPicked ? classPrefix + ('calendar-day ' + (classPrefix + 'picked')) : isBetween && isToday ? classPrefix + ('calendar-day ' + (classPrefix + 'today-between')) : isToday ? classPrefix + ('calendar-day ' + (classPrefix + 'today')) : isBetween ? classPrefix + ('calendar-day ' + (classPrefix + 'between')) : classPrefix + 'calendar-day';
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDay = F4(function (settings, model, currentMonth, day) {
    var isFocused = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (fday) {
      return _Utils_eq(A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$generatePickerDay, settings, fday), day);
    }, settings.qv));
    var dayParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, day.Ef);

    var _v0 = A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$dayPickedOrBetween, settings.by, day, model.f$, _Utils_Tuple2(model.fa, model.eP));

    var isPicked = _v0.a;
    var isBetween = _v0.b;
    var dayClasses = A6($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Styles$durationDayClasses, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix, !_Utils_eq(dayParts.zG, currentMonth), day.k_, isPicked, isFocused, isBetween);
    return A2($elm$html$Html$button, _List_fromArray([$elm$html$Html$Attributes$type_('button'), $elm$html$Html$Attributes$disabled(day.k_), $elm$html$Html$Attributes$class(dayClasses), $elm$html$Html$Events$onClick(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$SetRange(day), model))), $elm$html$Html$Events$onMouseOver(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$SetHoveredDay(day), model)))]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(dayParts.wz))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewWeek = F4(function (settings, model, currentMonth, week) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-week')]), A2($elm$core$List$map, A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDay, settings, model, currentMonth), week));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewMonth = F3(function (settings, model, viewTime) {
    var currentMonth = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, viewTime).zG;
    var allowedTimesOfDayFn = A2($elm$core$Maybe$map, function ($) {
      return $.ki;
    }, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$getTimePickerSettings(settings));
    var weeks = A5($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$Utilities$monthData, settings.by, settings.i2, settings.lq, allowedTimesOfDayFn, viewTime);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar-month'), $elm$html$Html$Events$onMouseOut(settings.es(A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$update, settings, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$ClearHoveredDay, model)))]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewWeek, settings, model, currentMonth), weeks))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewCalendar = F4(function (settings, model, viewTime, calView) {
    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewCalendarHeader, settings, model, viewTime, calView), A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewMonth, settings, model, viewTime)]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$previewSelection = F4(function (zone, previousStartSelectionTuple, previousEndSelectionTuple, hoveredPickerDay) {
    var _v0 = _Utils_Tuple2(previousStartSelectionTuple, previousEndSelectionTuple);

    if (!_v0.a.$ && !_v0.b.$) {
      var startSelectionTuple = _v0.a.a;
      var endSelectionTuple = _v0.b.a;
      return _Utils_Tuple2($elm$core$Maybe$Just(startSelectionTuple), $elm$core$Maybe$Just(endSelectionTuple));
    } else {
      return A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$selectDay, zone, previousStartSelectionTuple, previousEndSelectionTuple, hoveredPickerDay);
    }
  });

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$showHoveredIfEnabled = function (hovered) {
    return hovered.k_ ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(hovered);
  };

  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$determineDateTimeRange = F4(function (zone, startSelectionTuple, endSelectionTuple, hoveredDay) {
    var hovered = A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$showHoveredIfEnabled, hoveredDay);

    if (!hovered.$) {
      var h = hovered.a;
      return A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$Internal$DurationUtilities$previewSelection, zone, startSelectionTuple, endSelectionTuple, h);
    } else {
      return _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$End = 1;
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$Start = 0;
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$timeIsEndOfDay = F2(function (settings, time) {
    var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, time);

    var hour = _v0.yc;
    var minute = _v0.zE;
    return hour === 23 && minute === 59;
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$timeIsStartOfDay = F2(function (settings, time) {
    var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.by, time);

    var hour = _v0.yc;
    var minute = _v0.zE;
    return !hour && !minute;
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDate = F2(function (settings, dateTime) {
    return A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2(settings.kU, settings.by, dateTime))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateTime = F4(function (settings, timeStringFn, classString, dateTime) {
    return A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2(settings.kU, settings.by, dateTime)), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(_Utils_ap($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix, classString))]), _List_fromArray([$elm$html$Html$text(A2(timeStringFn, settings.by, dateTime))]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateOrDateTime = F3(function (settings, startOrEnd, dateTime) {
    return A2($elm$core$Maybe$withDefault, A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDate, settings, dateTime), A2($elm$core$Maybe$map, function (timePickerSettings) {
      if (!startOrEnd) {
        return A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$timeIsStartOfDay, settings, dateTime) ? A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDate, settings, dateTime) : A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateTime, settings, timePickerSettings.ou, 'selection-time', dateTime);
      } else {
        return A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$timeIsEndOfDay, settings, dateTime) ? A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDate, settings, dateTime) : A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateTime, settings, timePickerSettings.ou, 'selection-time', dateTime);
      }
    }, $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$getTimePickerSettings(settings)));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewEmpty = A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('')]));
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$determineDateTimeView = F3(function (settings, startSelectionTuple, endSelectionTuple) {
    var _v0 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);

    if (_v0.a.$ === 1) {
      if (_v0.b.$ === 1) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewEmpty;
      } else {
        var _v5 = _v0.a;
        var _v6 = _v0.b.a;
        var endSelection = _v6.b;
        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(' - '), A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateOrDateTime, settings, 1, endSelection)]));
      }
    } else {
      if (_v0.b.$ === 1) {
        var _v3 = _v0.a.a;
        var startSelection = _v3.b;
        var _v4 = _v0.b;
        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateOrDateTime, settings, 0, startSelection), $elm$html$Html$text(' - ')]));
      } else {
        var _v7 = _v0.a.a;
        var startPickerDay = _v7.a;
        var startSelection = _v7.b;
        var _v8 = _v0.b.a;
        var endPickerDay = _v8.a;
        var endSelection = _v8.b;
        return _Utils_eq(startPickerDay, endPickerDay) && A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$timeIsStartOfDay, settings, startSelection) && A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$timeIsEndOfDay, settings, endSelection) ? A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDate, settings, startSelection) : A2($elm$html$Html$span, _List_Nil, _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateOrDateTime, settings, 0, startSelection), $elm$html$Html$text(' - '), A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewDateOrDateTime, settings, 1, endSelection)]));
      }
    }
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewFooter = F4(function (settings, timePickerVisible, baseDay, model) {
    var _v0 = A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$determineDateTimeRange, settings.by, model.fa, model.eP, model.f$);

    var startSelectionTuple = _v0.a;
    var endSelectionTuple = _v0.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'footer')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'time-pickers-container')]), _List_fromArray([function () {
      var _v1 = settings.j$;
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'date-display-container-no-pickers')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$determineDateTimeView, settings, startSelectionTuple, endSelectionTuple)]))]));
    }()]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$view = F2(function (settings, _v0) {
    var model = _v0;
    var _v1 = model.Y;

    if (_v1.$ === 1) {
      var timePickerVisible = _v1.a;
      var baseDay = _v1.b;
      var leftViewTime = A4($justinmimbs$time_extra$Time$Extra$add, 2, model.du.a, settings.by, baseDay.Ef);
      var _v2 = settings.pk;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$datePickerId), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'picker-container')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$id('calendar-container'), $elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'calendar')]), _List_fromArray([A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewCalendar, settings, model, leftViewTime, 0)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$classPrefix + 'footer-container')]), _List_fromArray([A4($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$viewFooter, settings, timePickerVisible, baseDay, model)]))]));
    } else {
      return $elm$html$Html$text('');
    }
  });
  var $author$project$Ui$RangeDateInput$RangeDateInput$viewRangeDateInput = F3(function (_v0, _v1, zone) {
    var startLabel = _v0.Ei;
    var endLabel = _v0.xx;
    var internalState = _v1.ca;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary10Back pad1 flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween marBottom2')]), _List_fromArray([$author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'marRight3',
      E: $elm$core$Maybe$Just(startLabel),
      k_: false,
      qU: 0,
      qW: true,
      e_: $author$project$Ui$RangeDateInput$RangeDateInput$DateInputChanged(0),
      e3: 'dd-MM-YYYY',
      gx: false,
      Fw: $author$project$Ui$RangeDateInput$RangeDateInput$getStartDateInputString(internalState.iM)
    }), $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: '',
      E: $elm$core$Maybe$Just(endLabel),
      k_: false,
      qU: 0,
      qW: true,
      e_: $author$project$Ui$RangeDateInput$RangeDateInput$DateInputChanged(1),
      e3: 'dd-MM-YYYY',
      gx: false,
      Fw: $author$project$Ui$RangeDateInput$RangeDateInput$getEndDateInputString(internalState.iM)
    })])), A2($author$project$ElmFramework$Lib$Ui$DateTimePicker$DurationDatePicker$view, $author$project$Ui$RangeDateInput$RangeDateInput$getRangeDateInputSettings(zone), internalState.d1)]));
  });
  var $author$project$Views$Routed$CreateCommentBranch$cashboardCreateCommentView = F6(function (reviewId, session, company, topState, cashboardContent, query) {
    var state = topState.o_.vO.v1;
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$CommentMessage);
    var dateRangePicker = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, $elm$html$Html$map(A2($elm$core$Basics$composeL, sendMessage, A2($author$project$Ui$Cashboard$Comment$Msg$DatePicked, topState.by, topState.EM))), A2($elm$core$Maybe$map, function (dateModel) {
      return A3($author$project$Ui$RangeDateInput$RangeDateInput$viewRangeDateInput, {
        xx: 'To',
        Ei: 'From'
      }, dateModel, topState.by);
    }, state.iL)));

    var createCommentReq = function () {
      var simpleDateRange = A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
        return $.Fw;
      }, $author$project$Ui$RangeDateInput$RangeDateInput$toSimpleDateRange(topState.by)), state.iL);
      return {
        U: state.EH,
        cD: A3($elm$core$Maybe$map2, $author$project$Types$SimpleDateRange$SimpleDateClosedRange, A2($elm$core$Maybe$map, function ($) {
          return $.Ef;
        }, simpleDateRange), A2($elm$core$Maybe$map, function ($) {
          return $.dR;
        }, simpleDateRange)),
        eO: $elm$core$Maybe$Just($turboMaCk$any_set$Set$Any$toList(state.eO)),
        bi: $elm$core$Maybe$Nothing,
        c8: reviewId,
        e8: query.Dw
      };
    }();

    return $author$project$Views$Routed$CreateCommentBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightIconTitleIcon({
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop4 padBottom6')]), _List_fromArray([A3($author$project$Ui$Cashboard$Comment$View$divisionsMultiSelect, state.eO, sendMessage, company), $author$project$Ui$SwitchLabelLeft$switchLabelLeft({
          vV: 'marTop4',
          yC: $elm_community$maybe_extra$Maybe$Extra$isJust(state.iL),
          y$: 'Assign Date to comment',
          y1: '',
          ew: sendMessage(A2($author$project$Ui$Cashboard$Comment$Msg$DateToggled, topState.by, topState.EM))
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3')]), _List_fromArray([dateRangePicker])), $author$project$ElmFramework$Lib$Ui$TextAreaSelfSize$textAreaSelfSize({
          vv: false,
          kG: '',
          k_: false,
          e_: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Cashboard$Comment$Msg$CommentTyped),
          e3: 'Add a comment',
          gx: false,
          Fw: state.EH,
          dJ: 'block padTop4'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padTop4')]), _List_fromArray([function () {
          var _v0 = $elm$core$String$isEmpty(state.EH) ? _Utils_Tuple2(true, 3) : _Utils_Tuple2(false, 1);

          var isDisabled = _v0.a;
          var color = _v0.b;
          return $author$project$Ui$Button$basicButtonMiddle({
            kG: 'flex1',
            vY: color,
            yh: $elm$core$Maybe$Nothing,
            yM: isDisabled,
            f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CreateComment, company.F, createCommentReq))),
            y$: 'Post'
          });
        }()]))]))]),
        y9: $author$project$IconSvg$arrowLeft,
        za: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        Bj: false,
        Dd: $elm$core$Basics$always($author$project$IconSvg$pin('hidden')),
        De: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Add a comment'
      })),
      DY: session,
      eG: topState
    });
  });
  var $author$project$Views$Routed$CreateCommentBranch$cashboardCreateReview = F3(function (session, topState, cashboardContent) {
    return $author$project$Views$Routed$CreateCommentBranch$viewLayer({
      pD: cashboardContent,
      s9: $elm$core$Maybe$Nothing,
      DY: session,
      eG: topState
    });
  });

  var $author$project$Ui$Cashboard$Msg$OnUpdateReviewFilters = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Ui$Cashboard$Msg$OnUpdateReviewSorter = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$RequestReviewApproval = F2(function (a, b) {
    return {
      $: 62,
      a: a,
      b: b
    };
  });
  var $elm$core$String$pad = F3(function (n, _char, string) {
    var half = (n - $elm$core$String$length(string)) / 2;
    return _Utils_ap(A2($elm$core$String$repeat, $elm$core$Basics$ceiling(half), $elm$core$String$fromChar(_char)), _Utils_ap(string, A2($elm$core$String$repeat, $elm$core$Basics$floor(half), $elm$core$String$fromChar(_char))));
  });

  var $author$project$ElmFramework$Lib$Util$toNumberFromMonth = function (month) {
    switch (month) {
      case 0:
        return 1;

      case 1:
        return 2;

      case 2:
        return 3;

      case 3:
        return 4;

      case 4:
        return 5;

      case 5:
        return 6;

      case 6:
        return 7;

      case 7:
        return 8;

      case 8:
        return 9;

      case 9:
        return 10;

      case 10:
        return 11;

      default:
        return 12;
    }
  };

  var $author$project$ElmFramework$Lib$Util$toMonthAsNumber = F2(function (zone, posix) {
    return $author$project$ElmFramework$Lib$Util$toNumberFromMonth(A2($elm$time$Time$toMonth, zone, posix));
  });
  var $author$project$Ui$TimeRepresentation$toUSFormattedDateWithSlashes = F2(function (zone, posix) {
    return A2($elm$core$String$join, '/', _List_fromArray([A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($elm$time$Time$toDay, zone, posix))), A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($author$project$ElmFramework$Lib$Util$toMonthAsNumber, zone, posix))), $elm$core$String$fromInt(A2($elm$time$Time$toYear, zone, posix))]));
  });

  var $author$project$Ui$ReviewRow$reviewRow = function (cfg) {
    var statusTheme = function () {
      var _v0 = cfg.Dc;

      switch (_v0.$) {
        case 0:
          return {
            ix: 'secondary0Back',
            vY: 'secondary0',
            EH: 'In progress'
          };

        case 1:
          return {
            ix: 'secondary40Back',
            vY: 'secondary40',
            EH: 'Waiting for approval'
          };

        default:
          return {
            ix: 'secondary0Back',
            vY: 'secondary0',
            EH: 'Published'
          };
      }
    }();

    var popoverMenuPart = function () {
      var sendForApprovalOption = function (onSendForApproval) {
        return _Utils_eq(cfg.Dc, $author$project$Types$Review$Pending) ? $elm$core$Maybe$Just({
          y$: 'Send for Approval',
          ew: onSendForApproval,
          tY: 0
        }) : $elm$core$Maybe$Nothing;
      };

      var deleteOption = function (onDeleteReview) {
        return {
          y$: 'Delete Review',
          ew: onDeleteReview,
          tY: 1
        };
      };

      return $author$project$Ui$PopoverMenu$showHidePopoverMenu({
        vG: $elm_community$maybe_extra$Maybe$Extra$values(_List_fromArray([$elm$core$Maybe$Just({
          y$: 'Open Review',
          ew: cfg.Bh,
          tY: 0
        }), A2($elm$core$Maybe$andThen, sendForApprovalOption, cfg.BH), A2($elm$core$Maybe$map, deleteOption, cfg.AH)])),
        vV: 'right0 fullTop z1',
        f8: cfg.yS,
        E3: cfg.sd
      });
    }();

    return A2($elm$html$Html$div, _List_fromArray([$author$project$ElmFramework$Lib$Util$onTap(cfg.Bh), $elm$html$Html$Attributes$class('flexRow flexCenter spaceBetween fullWidth pad2 marTop3 primary10Back borderHairline radius0 primary30 heading4Bold pointer')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex3 noOverflow')]), _List_fromArray([$elm$html$Html$text(cfg.Db)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex3 marLeft2 heading4Regular')]), _List_fromArray([$elm$html$Html$text('Created by '), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold')]), _List_fromArray([$elm$html$Html$text(cfg.cC)])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(' on ' + A2($author$project$Ui$TimeRepresentation$toUSFormattedDateWithSlashes, cfg.by, cfg.wk))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex2 flexRow spaceBetween marLeft2 relative')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap'), $elm$html$Html$Attributes$class(statusTheme.vY)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock w1 h1 circle marRight1'), $elm$html$Html$Attributes$class(statusTheme.ix)]), _List_Nil), $elm$html$Html$text(statusTheme.EH)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.sd), _List_fromArray([$elm$html$Html$Attributes$class('w3 h3')]), _List_fromArray([$author$project$IconSvg$dots('primary30Fill')])), popoverMenuPart]))]))]));
  };

  var $author$project$Types$Sorters$sorterToList = _List_fromArray([0, 1]);

  var $author$project$Types$Sorters$sorterToString = function (sorter) {
    if (!sorter) {
      return 'Sort By: Date Created';
    } else {
      return 'Sort By: Name';
    }
  };

  var $elm_community$maybe_extra$Maybe$Extra$unpack = F3(function (_default, f, m) {
    if (m.$ === 1) {
      return _default(0);
    } else {
      var a = m.a;
      return f(a);
    }
  });
  var $author$project$Ui$OverLaysView$chooseReviewOverLay = F4(function (session, query, company, topState) {
    var state = topState.o_.vO;
    var reviews = A2($elm$core$Maybe$withDefault, _List_Nil, A3($elm$core$Maybe$map2, $author$project$Types$Sorters$sort, state.s4.ia, $elm$core$Maybe$Just(A3($elm_community$maybe_extra$Maybe$Extra$unpack, $elm$core$Basics$always(_List_Nil), $turboMaCk$any_dict$Dict$Any$values, A2($elm$core$Maybe$map, function ($) {
      return $.c9;
    }, $author$project$Types$Company$toBaseScenario(company))))));
    var isAbleToSendForApproval = A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 25, session) || A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 26, session) || A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 27, session);
    var isAbleToDeleteReview = A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 24, session);

    var toReviewRow = function (review) {
      var onSendForApproval = isAbleToSendForApproval ? $elm$core$Maybe$Just($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RequestReviewApproval, company.F, review.F))) : $elm$core$Maybe$Nothing;
      var onDeleteReview = isAbleToDeleteReview ? $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$ConfirmDeletingReview(review.F))))))) : $elm$core$Maybe$Nothing;
      return $author$project$Ui$ReviewRow$reviewRow({
        cC: A2($elm$core$Maybe$withDefault, 'Unknown', A2($elm$core$Maybe$map, $author$project$Types$User$toFullName, A2($author$project$Types$UserSession$toUser, session, review.cC))),
        wk: review.iK,
        yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$Review$unwrapReviewId(review.F)),
        AH: onDeleteReview,
        Bh: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Reviews($author$project$Route$ReviewsRoute$Review($author$project$Route$ReviewRoute$ReviewRoute(review.F)))))),
        BH: onSendForApproval,
        sd: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$Review$unwrapReviewId(review.F))),
        Db: review.zL,
        Dc: review.Y,
        by: $elm$time$Time$utc
      });
    };

    var reviewRows = A2($elm$core$List$map, toReviewRow, reviews);
    var isAbleToCreateReview = A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 23, session);
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$SlideOverRight$slideOverRight({
        vV: 'takeMoreThenHalf',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([$author$project$Ui$Input$inputWithIcon({
          vV: 'flex1',
          yh: $author$project$IconSvg$search,
          e3: 'Search',
          gx: false,
          b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$OnUpdateReviewFilters), $author$project$Types$Filters$UpdateTextSearch),
          P: 'text',
          Fw: state.s3.j_
        }), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$Ui$DropdownSelect$dropdownSelect({
          vV: 'flex1',
          yI: false,
          e0: $author$project$Types$Sorters$sorterToList,
          e3: '',
          Ej: state.s4,
          b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$OnUpdateReviewSorter),
          fd: $elm$core$Basics$eq,
          EU: $author$project$Types$Sorters$sorterToString
        }), $author$project$ElmFramework$Lib$Util$spacer('w2'), isAbleToCreateReview ? $author$project$Ui$Button$basicButton({
          kG: '',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$CreateReview)))))),
          y$: 'Start a New Review'
        }) : $author$project$ElmFramework$Lib$Util$noOpEl])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop6')]), reviewRows)]),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        tM: 1,
        t1: 'Reviews'
      })
    });
  });
  var $author$project$UiWrappers$SlideOverRight$BackBtnOnTheLeft = 0;
  var $author$project$Remote$RequestMsg$DeleteReview = F2(function (a, b) {
    return {
      $: 64,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OverLaysView$confirmDeletingReviewOverLay = F2(function (companyId, reviewId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$SlideOverRight$slideOverRight({
        vV: 'minW65',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Regular primary30 padTop2')]), _List_fromArray([$elm$html$Html$text('Are you sure you want to delete this review?')])), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'padTop3 gray40',
          y$: 'All comments from the review will be deleted.'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop4')]), _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df),
          y$: 'Cancel'
        }), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
          kG: 'flex1',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteReview, companyId, reviewId))),
          y$: 'Delete Review'
        })]))]),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        tM: 0,
        t1: 'Delete Review'
      })
    });
  });
  var $author$project$Remote$RequestMsg$CreateReview = F3(function (a, b, c) {
    return {
      $: 61,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$OverLaysView$createReviewOverLay = F3(function (topState, companyId, scenarioId) {
    var state = topState.o_.vO;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$SlideOverRight$slideOverRight({
        vV: 'minW65',
        pD: _List_fromArray([$author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: '',
          E: $elm$core$Maybe$Just('Name'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgCashboard, $author$project$Ui$Cashboard$Msg$SetNewReviewName),
          e3: 'Enter new review\'s name',
          gx: false,
          Fw: state.rD
        }), $author$project$Ui$Button$basicButton({
          kG: 'fullWidth marTop5',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$CreateReview, companyId, scenarioId, state.rD))),
          y$: 'Start a New Review'
        })]),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        tM: 0,
        t1: 'Start a new review'
      })
    });
  });
  var $author$project$Views$Routed$CreateCommentBranch$createCommentBranch = F6(function (branch, session, query, company, topState, cashboardContent) {
    switch (branch.$) {
      case 0:
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$CreateCommentBranch$cashboardChooseReviewView, session, topState, cashboardContent)]), _List_fromArray([A4($author$project$Ui$OverLaysView$chooseReviewOverLay, session, query, company, topState)])]));

      case 1:
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$CreateCommentBranch$cashboardCreateReview, session, topState, cashboardContent)]), _List_fromArray([A3($author$project$Ui$OverLaysView$createReviewOverLay, topState, company.F, query.Dw)])]));

      case 2:
        var reviewId = branch.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$CreateCommentBranch$cashboardConfirmDeletingReview, session, topState, cashboardContent)]), _List_fromArray([A2($author$project$Ui$OverLaysView$confirmDeletingReviewOverLay, company.F, reviewId)])]));

      case 3:
        var reviewId = branch.a;
        return _List_fromArray([A6($author$project$Views$Routed$CreateCommentBranch$cashboardCreateCommentView, $elm$core$Maybe$Just(reviewId), session, company, topState, cashboardContent, query)]);

      default:
        return _List_fromArray([A6($author$project$Views$Routed$CreateCommentBranch$cashboardCreateCommentView, $elm$core$Maybe$Nothing, session, company, topState, cashboardContent, query)]);
    }
  });
  var $author$project$Remote$RequestMsg$DeleteComment = F2(function (a, b) {
    return {
      $: 60,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OverLaysView$deleteCommentConfirmationDialog = F2(function (companyId, commentId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Delete This Comment',
        as: 'Cancel',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: '',
          y$: 'Are you sure you want to delete this comment?'
        }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
          y$: 'This action cannot be undone.'
        })]))]),
        av: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$DeleteComment, companyId, commentId)),
        aw: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Delete Comment?'
      })
    });
  });
  var $author$project$Views$Routed$CommentsBranch$commentsBranch = F6(function (branch, session, topState, company, query, cashboardContent) {
    switch (branch.$) {
      case 0:
        return _List_fromArray([A5($author$project$Views$Routed$CommentsBranch$cashboardCommentsView, session, topState, company, query, cashboardContent)]);

      case 1:
        var commentId = branch.a;
        return _List_fromArray([A6($author$project$Views$Routed$CommentsBranch$cashboardCommentReplies, commentId, session, company, topState, cashboardContent, query)]);

      case 2:
        return _List_fromArray([A4($author$project$Views$Routed$CommentsBranch$cashBoardCommentFiltersView, session, company, topState, cashboardContent)]);

      case 3:
        var createCommentRoute = branch.a;
        return A6($author$project$Views$Routed$CreateCommentBranch$createCommentBranch, createCommentRoute, session, query, company, topState, cashboardContent);

      case 4:
        var commentId = branch.a;
        return _List_fromArray([A6($author$project$Views$Routed$CommentsBranch$cashboardEditComment, commentId, session, company, topState, cashboardContent, query)]);

      default:
        var commentId = branch.a;
        return _List_fromArray([A5($author$project$Views$Routed$CommentsBranch$cashboardCommentsView, session, topState, company, query, cashboardContent), A2($author$project$Ui$OverLaysView$deleteCommentConfirmationDialog, company.F, commentId)]);
    }
  });
  var $author$project$ElmFramework$Lib$Util$bottomAppSpacer = A3($elm$html$Html$node, 'spacer', _List_fromArray([$elm$html$Html$Attributes$class('block'), A2($elm$html$Html$Attributes$attribute, 'style', 'height: env(safe-area-inset-bottom); height: constant(safe-area-inset-bottom)')]), _List_Nil);

  var $author$project$Ui$Button$styledButton = function (config) {
    var buttonStyleClass = function () {
      var _v0 = config.vY;

      switch (_v0) {
        case 0:
          return 'primary20Back';

        case 1:
          return 'secondary10Back secondary20';

        case 2:
          return '';

        case 3:
          return 'gray10Back gray40';

        case 4:
          return 'primary80Back primary0';

        default:
          return 'gray60';
      }
    }();

    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.f9, _List_fromArray([$elm$html$Html$Attributes$class(buttonStyleClass), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, '', '', config.yM)), $elm$html$Html$Attributes$class('opacityTransition'), $elm$html$Html$Attributes$class(config.kG), $elm$html$Html$Attributes$disabled(config.yM)]), _List_fromArray([config.pD]));
  };

  var $author$project$Ui$Button$stickyBottomBtn = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTopAuto pad3 padTop4 marLeft-3 marRight-3 center'), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, 'gradient10Back', ' ', config.yP)), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('noPointerEvents', config.yM)]))]), _List_fromArray([$author$project$Ui$Button$styledButton({
      kG: 'fullWidth phoneWidthCenter minH6 radius0 noBorder heading4Bold primary0',
      vY: config.vY,
      pD: $elm$html$Html$text(config.EH),
      yM: config.yM,
      f9: config.vE
    }), $author$project$ElmFramework$Lib$Util$bottomAppSpacer]));
  };

  var $author$project$Ui$CashboardReviewsView$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: cfg.s5,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Types$Filters$withReview = F2(function (reviewId, filters) {
    return _Utils_update(filters, {
      c9: A2($turboMaCk$any_set$Set$Any$insert, reviewId, filters.c9)
    });
  });
  var $author$project$Ui$CashboardReviewsView$cashBoardReviewsView = F6(function (reviewId, session, query, company, topState, cashboardContent) {
    var reviewStatus = A2($elm$core$Maybe$map, function ($) {
      return $.Y;
    }, A2($author$project$Types$Company$toReview, reviewId, company));
    var reviewName = A2($elm$core$Maybe$withDefault, 'Review Name', A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, A2($author$project$Types$Company$toReview, reviewId, company)));

    var button = function (classes) {
      var isAbleToSendForApproval = A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 25, session) || A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 26, session) || A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 27, session);
      var isAbleToApproveReview = A4($author$project$Types$UserSession$isAbleDoToInCompany, topState.o_.CT.tb, company.F, 22, session);

      var options = function () {
        _v1$2: while (true) {
          if (!reviewStatus.$) {
            switch (reviewStatus.a.$) {
              case 0:
                var _v2 = reviewStatus.a;
                return isAbleToSendForApproval ? $elm$core$Maybe$Just(_Utils_Tuple2('Request Review Approval', $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RequestReviewApproval, company.F, reviewId))))) : $elm$core$Maybe$Nothing;

              case 1:
                return isAbleToApproveReview ? $elm$core$Maybe$Just(_Utils_Tuple2('Approve Review', $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Reviews($author$project$Route$ReviewsRoute$Review($author$project$Route$ReviewRoute$ApproveReview(reviewId))))))))) : $elm$core$Maybe$Nothing;

              default:
                break _v1$2;
            }
          } else {
            break _v1$2;
          }
        }

        return $elm$core$Maybe$Nothing;
      }();

      return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (_v0) {
        var text = _v0.a;
        var buttonHandler = _v0.b;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$Ui$Button$stickyBottomBtn({
          vE: buttonHandler,
          vY: 0,
          yM: false,
          yP: true,
          EH: text
        })]));
      }, options));
    };

    return $author$project$Ui$CashboardReviewsView$viewLayer({
      pD: cashboardContent,
      sR: query,
      s5: $elm$core$Maybe$Just($author$project$UiWrappers$MainAppWrap$RightIconTitleIcon({
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w41 marTop3')]), _List_fromArray([$author$project$Ui$Button$basicButton({
          kG: 'fullWidth marBottom2',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df),
          y$: 'Exit Review'
        }), A2($elm$html$Html$div, _List_Nil, A5($author$project$Ui$Cashboard$Comment$View$commentRows, session, company, topState, query, A2($author$project$Types$Filters$withReview, reviewId, $author$project$Types$Filters$empty)))])), button('absolute bottom0 sticky fullWidth')]),
        y9: $author$project$IconSvg$arrowLeft,
        za: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        Bj: false,
        Dd: $author$project$IconSvg$add,
        De: $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, query, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$CreateCommentForReview(reviewId)))))), $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$DivisionsSelected(A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Division$unwrapDivisionId, query.eO)))), $author$project$TopMsg$msgCashboard($author$project$Ui$Cashboard$Msg$CommentMessage($author$project$Ui$Cashboard$Comment$Msg$CommentTyped('')))])),
        t1: reviewName
      })),
      DY: session,
      eG: topState
    });
  });
  var $author$project$Remote$RequestMsg$ApproveReview = F2(function (a, b) {
    return {
      $: 63,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OverLaysView$approveReviewConfirmationDialog = F2(function (companyId, reviewId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Approve Review',
        as: 'Cancel',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 marRight10 center padTop4 padBottom3 maxW46')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: '',
          y$: 'Are you sure you want to approve this review?'
        }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'gray40 padTop2 padLeft2 padRight2 justifyCenterLine',
          y$: 'After approval, this review will be sent to the client.'
        })]))]),
        av: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$ApproveReview, companyId, reviewId)),
        aw: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Approve Review'
      })
    });
  });
  var $author$project$Views$Routed$ReviewBranch$reviewBranch = F6(function (branch, cashboardQuery, session, company, topState, cashboardContent) {
    switch (branch.$) {
      case 0:
        var reviewId = branch.a;
        return _List_fromArray([A6($author$project$Ui$CashboardReviewsView$cashBoardReviewsView, reviewId, session, cashboardQuery, company, topState, cashboardContent)]);

      case 1:
        var reviewId = branch.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A6($author$project$Ui$CashboardReviewsView$cashBoardReviewsView, reviewId, session, cashboardQuery, company, topState, cashboardContent)]), _List_fromArray([A2($author$project$Ui$OverLaysView$approveReviewConfirmationDialog, company.F, reviewId)])]));

      default:
        return _List_Nil;
    }
  });
  var $author$project$Views$Routed$ReviewsBranch$reviewsBranch = F6(function (session, branch, cashboardQuery, company, topState, cashboardContent) {
    if (!branch.$) {
      var reviewId = branch.a;
      return _List_fromArray([A6($author$project$Ui$CashboardReviewsView$cashBoardReviewsView, reviewId, session, cashboardQuery, company, topState, cashboardContent)]);
    } else {
      var reviewRoute = branch.a;
      return A6($author$project$Views$Routed$ReviewBranch$reviewBranch, reviewRoute, cashboardQuery, session, company, topState, cashboardContent);
    }
  });
  var $author$project$Views$Routed$CashboardBranch$theCashboardOverlays = F4(function (session, company, topState, query) {
    var _v0 = 'specialOverlay';

    if (_v0 === 'specialOverlay') {
      return _List_fromArray([$author$project$Ui$OverLaysView$cashboardAndBudgetOverLay({
        j: company,
        BC: function (scenarioId) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, A2($author$project$Route$CompanyRoute$Cashboard, A2($author$project$Types$CashboardQuery$setScenario, scenarioId, query), $author$project$Route$CashboardRoute$CashboardHome)));
        },
        DY: session,
        eG: topState
      })]);
    } else {
      return _List_Nil;
    }
  });

  var $author$project$Views$Routed$CashboardBranch$cashboardBranch = function (cfg) {
    var _v0 = cfg.tc;

    switch (_v0.$) {
      case 0:
        return _List_fromArray([$author$project$Views$Routed$CashboardBranch$cashboardView(cfg)]);

      case 1:
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$CashboardBranch$cashboardView(cfg)]), A4($author$project$Views$Routed$CashboardBranch$theCashboardOverlays, cfg.DY, cfg.j, cfg.eG, cfg.sR)]));

      case 2:
        var buildingBlocksRoute = _v0.a;
        return A7($author$project$Views$Routed$BuildingBlocksBranch$buildingBlocksBranch, buildingBlocksRoute, cfg.DY, cfg.eG, cfg.j, cfg.sR, $author$project$Views$Routed$CashboardBranch$cashboardContent(cfg), cfg.Ej.sn);

      case 3:
        var commentsRoute = _v0.a;
        return A6($author$project$Views$Routed$CommentsBranch$commentsBranch, commentsRoute, cfg.DY, cfg.eG, cfg.j, cfg.sR, $author$project$Views$Routed$CashboardBranch$cashboardContent(cfg));

      default:
        var reviewsRoute = _v0.a;
        return A6($author$project$Views$Routed$ReviewsBranch$reviewsBranch, cfg.DY, reviewsRoute, cfg.sR, cfg.j, cfg.eG, $author$project$Views$Routed$CashboardBranch$cashboardContent(cfg));
    }
  };

  var $author$project$Ui$Accounts$Add$Msg$BalanceTyped = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$Confirmed = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$CurrencySelected = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$DateSelected = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$DivisionSelected = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$DivisionTyped = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$MinMaxAdviceTyped = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$NameTyped = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Add$Msg$TypeSelected = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$Company$toDivisions = function (company) {
    return A2($elm$core$Maybe$map, $turboMaCk$any_dict$Dict$Any$values, $krisajenkins$remotedata$RemoteData$toMaybe(company.eO));
  };

  var $author$project$Ui$OverLaysView$accountDivisionElement = function (cfg) {
    var divisions = function () {
      var filter = function (division_) {
        return $elm$core$String$isEmpty(cfg.pU) || A2($elm$core$String$startsWith, $elm$core$String$toLower(cfg.pU), $elm$core$String$toLower(division_.zL));
      };

      return A2($elm$core$Maybe$map, $elm$core$List$filter(filter), $author$project$Types$Company$toDivisions(cfg.j));
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth marLeft4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
      vV: 'gray40',
      y$: 'Division Name'
    }), $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
      kG: '',
      pY: '',
      yM: false,
      yW: false,
      Ac: $elm$core$Maybe$Nothing,
      Ar: $elm$core$Maybe$Nothing,
      Aw: $elm$core$Maybe$Nothing,
      e_: cfg.e_,
      BE: cfg.BE,
      e3: 'Division',
      C5: function (_v0) {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      },
      C6: function ($) {
        return $.zL;
      },
      C7: divisions,
      ia: cfg.R,
      Fw: cfg.pU
    })]));
  };

  var $author$project$Ui$OverLaysView$accountMinMaxAdviceElement = F3(function (onInput, value, type_) {
    var description = function () {
      if (!type_.$) {
        if (!type_.a.$) {
          var _v1 = type_.a;
          return 'Target Minimum Balance';
        } else {
          return 'Target Maximum Balance';
        }
      } else {
        return 'Target Balance';
      }
    }();

    return $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'fullWidth',
      E: $elm$core$Maybe$Just(description),
      k_: false,
      qU: 0,
      qW: true,
      e_: onInput,
      e3: '$ 00.00',
      gx: false,
      Fw: value
    });
  });
  var $author$project$Ui$OverLaysView$accountNameElement = F2(function (onInput, name) {
    return $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'fullWidth',
      E: $elm$core$Maybe$Just('Account Name'),
      k_: false,
      qU: 0,
      qW: true,
      e_: onInput,
      e3: 'Enter Name',
      gx: false,
      Fw: A2($elm$core$Maybe$withDefault, '', name)
    });
  });

  var $author$project$Ui$Button$buttonSelectHigh = function (cfg) {
    return $author$project$Ui$Button$buttonSelect({
      vV: cfg.vV + ' minH6',
      yC: cfg.yC,
      y$: cfg.y$,
      ew: cfg.ew
    });
  };

  var $author$project$Types$AccountType$toString = function (accountType) {
    if (!accountType.$) {
      return 'Cash';
    } else {
      var creditSubType = accountType.a;

      if (!creditSubType) {
        return 'Credit Card';
      } else {
        return 'Line of Credit';
      }
    }
  };

  var $author$project$Ui$OverLaysView$accountTypesElement = F2(function (onTap, type_) {
    var accountTypes = function (classes) {
      return A2($elm$core$List$map, function (type__) {
        return $author$project$Ui$Button$buttonSelectHigh({
          vV: classes,
          yC: _Utils_eq(type_, $elm$core$Maybe$Just(type__)),
          y$: $author$project$Types$AccountType$toString(type__),
          ew: onTap(type__)
        });
      }, _List_fromArray([$author$project$Types$AccountType$Cash, $author$project$Types$AccountType$Credit(0), $author$project$Types$AccountType$Credit(1)]));
    };

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
      vV: 'primary30',
      y$: 'Account Type:'
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marLeft4h marTop4 marBottom3 marRight-3')]), accountTypes('marRight3 h5'))]));
  });
  var $author$project$Ui$OverLaysView$addNewAccountFinancialAccountsOverlay = F2(function (company, topState) {
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, $author$project$Ui$Accounts$Msg$OnAddAccountMsg);
    var model = topState.o_.uz.oS;

    var currency = function (classes) {
      return A2($elm$core$List$map, function (currency_) {
        return $author$project$Ui$Button$buttonSelectHigh({
          vV: classes,
          yC: _Utils_eq(model.bq, $elm$core$Maybe$Just(currency_)),
          y$: $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString(currency_),
          ew: sendMessage($author$project$Ui$Accounts$Add$Msg$CurrencySelected(currency_))
        });
      }, $author$project$Api$GraphqlSchema$Enum$Currency_enum$list);
    };

    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Add New Account',
        as: 'Cancel',
        pD: _List_fromArray([A2($author$project$Ui$OverLaysView$accountTypesElement, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$TypeSelected), model.P), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom4')]), _List_fromArray([A2($author$project$Ui$OverLaysView$accountNameElement, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$NameTyped), model.zL), $author$project$Ui$OverLaysView$accountDivisionElement({
          j: company,
          R: model.R,
          pU: model.pU,
          e_: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$DivisionTyped),
          BE: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$DivisionSelected)
        })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom4')]), _List_fromArray([$author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'marRight4 fullWidth',
          E: $elm$core$Maybe$Just('Opening Balance'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$BalanceTyped),
          e3: '$ 00.00',
          gx: false,
          Fw: A2($elm$core$Maybe$withDefault, '', model.o3)
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow fullWidth marTop3')]), currency('marRight3 h5'))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom4')]), _List_fromArray([A3($author$project$Ui$OverLaysView$accountMinMaxAdviceElement, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$MinMaxAdviceTyped), A2($elm$core$Maybe$withDefault, '', model.rs), model.P), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth marLeft4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
          vV: 'gray40',
          y$: 'Opening Date'
        }), A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Add$Msg$DateSelected), model.iL, topState.by)]))]))]),
        av: sendMessage($author$project$Ui$Accounts$Add$Msg$Confirmed(company.F)),
        aw: sendMessage($author$project$Ui$Accounts$Add$Msg$Canceled),
        Aj: sendMessage($author$project$Ui$Accounts$Add$Msg$Canceled),
        t1: 'Add New Account'
      })
    });
  });
  var $author$project$Remote$RequestMsg$DeleteFinancialAccount = F3(function (a, b, c) {
    return {
      $: 35,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$OverLaysView$deleteAccountBalanceFinancialAccountsOverlay = F2(function (company, accountId) {
    var maybeDivisionId = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, function ($) {
      return $.F;
    }), A2($author$project$Types$Company$toFinancialAccount, accountId, company));

    var message = function () {
      if (!maybeDivisionId.$) {
        var divisionId = maybeDivisionId.a;
        return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$DeleteFinancialAccount, company.F, divisionId, accountId));
      } else {
        return $author$project$ElmFramework$MsgCmd$msgCmd.Df;
      }
    }();

    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Delete Account',
        as: 'Cancel',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW46 flexColumn flexAlignCenter justifyCenter marRight9 marLeft9 marTop4 marBottom5 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'center marBottom2',
          y$: 'Are you sure you want to delete this account?'
        }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'gray40 center',
          y$: 'This action cannot be undone.'
        })]))]),
        av: message,
        aw: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Delete Account'
      })
    });
  });
  var $author$project$Ui$Accounts$Edit$Msg$Confirmed = F3(function (a, b, c) {
    return {
      $: 6,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$Ui$Accounts$Edit$Msg$DivisionSelected = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Edit$Msg$DivisionTyped = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Edit$Msg$MinMaxAdviceTyped = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Edit$Msg$NameTyped = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Edit$Msg$TypeSelected = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$OverLaysView$editAccountInfoFinancialAccountsOverlay = F3(function (company, topState, accountId) {
    var sendMessage = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, $author$project$Ui$Accounts$Msg$OnEditAccountMsg);
    var model = topState.o_.uz.p_;

    var _v0 = function () {
      var _v1 = A2($author$project$Types$Company$toFinancialAccount, accountId, company);

      if (!_v1.$) {
        var _v2 = _v1.a;
        var division_ = _v2.a;
        var account_ = _v2.b;
        return _Utils_Tuple2($elm$core$Maybe$Just(division_), $elm$core$Maybe$Just(account_));
      } else {
        return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
      }
    }();

    var divisionUnedited = _v0.a;
    var accountUnedited = _v0.b;
    var minMaxAdvice = A2($elm_community$maybe_extra$Maybe$Extra$or, model.rs, A2($elm$core$Maybe$map, $elm$core$String$fromFloat, A2($elm$core$Maybe$map, $JoshuaHall$elm_fraction$Fraction$toFloat, A2($elm$core$Maybe$andThen, function ($) {
      return $.dx;
    }, accountUnedited))));
    var name = A2($elm_community$maybe_extra$Maybe$Extra$or, model.zL, A2($elm$core$Maybe$map, function ($) {
      return $.zL;
    }, accountUnedited));
    var type_ = A2($elm_community$maybe_extra$Maybe$Extra$or, model.P, A2($elm$core$Maybe$map, function ($) {
      return $.it;
    }, accountUnedited));
    var division = A2($elm_community$maybe_extra$Maybe$Extra$or, model.R, divisionUnedited);

    var onAcceptTap = function () {
      var _v3 = A2($elm$core$Maybe$map, function ($) {
        return $.F;
      }, division);

      if (!_v3.$) {
        var divisionId = _v3.a;
        return sendMessage(A3($author$project$Ui$Accounts$Edit$Msg$Confirmed, company.F, divisionId, accountId));
      } else {
        return sendMessage($author$project$Ui$Accounts$Edit$Msg$Canceled);
      }
    }();

    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Save',
        as: 'Cancel',
        pD: _List_fromArray([A2($author$project$Ui$OverLaysView$accountTypesElement, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Edit$Msg$TypeSelected), type_), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom4')]), _List_fromArray([A2($author$project$Ui$OverLaysView$accountNameElement, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Edit$Msg$NameTyped), name), $author$project$Ui$OverLaysView$accountDivisionElement({
          j: company,
          R: division,
          pU: model.pU,
          e_: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Edit$Msg$DivisionTyped),
          BE: A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Edit$Msg$DivisionSelected)
        })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom4')]), _List_fromArray([A3($author$project$Ui$OverLaysView$accountMinMaxAdviceElement, A2($elm$core$Basics$composeL, sendMessage, $author$project$Ui$Accounts$Edit$Msg$MinMaxAdviceTyped), A2($elm$core$Maybe$withDefault, '', minMaxAdvice), type_)]))]),
        av: onAcceptTap,
        aw: sendMessage($author$project$Ui$Accounts$Edit$Msg$Canceled),
        Aj: sendMessage($author$project$Ui$Accounts$Edit$Msg$Canceled),
        t1: 'Edit Account Information'
      })
    });
  });

  var $author$project$Route$FinancialAccountsRoute$DeleteFinancialAccount = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Msg$OnAccountHistoryChartViewport = function (a) {
    return {
      $: 10,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Msg$OnChartMouseEnterBalance = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Msg$OnChartTapBalance = F4(function (a, b, c, d) {
    return {
      $: 6,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });

  var $author$project$Ui$Accounts$Msg$OnCloseGraph = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Accounts$Msg$OnLeaveChart = {
    $: 8
  };
  var $author$project$Ui$Accounts$Msg$OnOpenGraph = F3(function (a, b, c) {
    return {
      $: 2,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$Ui$Accounts$Msg$OnUpdateTextSearch = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $elm_community$list_extra$List$Extra$last = function (items) {
    last: while (true) {
      if (!items.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        if (!items.b.b) {
          var x = items.a;
          return $elm$core$Maybe$Just(x);
        } else {
          var rest = items.b;
          var $temp$items = rest;
          items = $temp$items;
          continue last;
        }
      }
    }
  };

  var $author$project$ElmFramework$Lib$OrderedCollection$last = function (_v0) {
    var list = _v0.aA;
    return $elm_community$list_extra$List$Extra$last(list);
  };

  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$last = function (endlessList) {
    return $author$project$ElmFramework$Lib$OrderedCollection$last(endlessList.aq);
  };

  var $author$project$Types$FinancialAccount$toLatestBalance = function (account) {
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$last, $krisajenkins$remotedata$RemoteData$toMaybe(account.fy));
  };

  var $author$project$Ui$AccountRow$accountRow = function (cfg) {
    var updateType = cfg.yF ? ' Automatically by ' : ' By: ';
    var onToggleGraph = cfg.q1 ? cfg.A0 : cfg.A1;
    var latestBalance = $author$project$Types$FinancialAccount$toLatestBalance(cfg.uy);
    var lastBalanceUpdatedByToString = F2(function (session, update) {
      if (update.$ === 1) {
        var system = update.a;
        return $elm$core$Maybe$Just(system);
      } else {
        var userId = update.a;
        return A2($elm$core$Maybe$map, $author$project$Types$User$toFullName, A2($author$project$Types$UserSession$toUser, session, userId));
      }
    });
    var updateInfo = A2($elm$core$Maybe$withDefault, _List_fromArray([$author$project$ElmFramework$Lib$Util$noOpEl]), A2($elm$core$Maybe$map, function (updated) {
      return _List_fromArray([$elm$html$Html$text('Last Updated' + (updateType + (updated.pj + (' on ' + A2($author$project$Ui$TimeRepresentation$toUSFormattedDateWithSlashes, cfg.by, updated.o$)))))]);
    }, A2($elm$core$Maybe$andThen, function (updated) {
      return A3($elm$core$Maybe$map2, F2(function (at, by) {
        return {
          o$: at,
          pj: by
        };
      }), $elm$core$Maybe$Just(updated.o$), A2(lastBalanceUpdatedByToString, cfg.DY, updated.pj));
    }, cfg.uy.y5)));
    var graphStyle = cfg.q1 ? {
      o2: 'primary30Back',
      ln: 'primary0Fill'
    } : {
      o2: 'primary0Back',
      ln: 'primary30Fill'
    };
    var editInfo = {
      y$: 'Edit Info',
      ew: cfg.AT,
      tY: 0
    };
    var deleteAccount = {
      y$: 'Delete Account',
      ew: cfg.Ay,
      tY: 1
    };
    var popoverMenuPart = $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: _List_fromArray([editInfo, deleteAccount]),
      vV: 'right1 top6h z1',
      f8: cfg.yS,
      E3: cfg.sd
    });

    var balanceSign = function () {
      if (!latestBalance.$) {
        var balance = latestBalance.a;
        return balance.gY > 0 ? '+' : balance.gY < 0 ? '-' : '';
      } else {
        return '';
      }
    }();

    var toBalanceAmount = function (amountString) {
      return A3($elm$core$String$replace, '{balance}', amountString, A3($elm$core$String$replace, '{plusMinus}', balanceSign, A3($elm$core$String$replace, '{currency}', $author$project$Api$GraphqlSchema$Enum$Currency_enum$toString(cfg.uy.bq), '{currency} {plusMinus}{balance}')));
    };

    var balanceInfo = A2($elm$core$Maybe$withDefault, _List_fromArray([$author$project$ElmFramework$Lib$Util$noOpEl]), A2($elm$core$Maybe$map, function (balance) {
      return _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('Balance on ' + (A2($author$project$Ui$TimeRepresentation$toUSFormattedDate, cfg.by, balance.iL) + ': '))])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold secondary0')]), _List_fromArray([$elm$html$Html$text(toBalanceAmount(balance.p))]))]);
    }, A2($elm$core$Maybe$map, function (balance) {
      return {
        p: $elm$core$String$fromFloat($elm$core$Basics$abs(balance.gY)),
        iL: A2($author$project$Types$SimpleDate$toPosix, $elm$time$Time$utc, balance.o$)
      };
    }, latestBalance)));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad3 flexRow spaceBetween flexAlignCenter heading4Regular primary30 radius0 whiteBack borderSolid borderHairlineWidth gray10Border'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' padBottom1 flexRow ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold flex2xthird minW26')]), _List_fromArray([$elm$html$Html$text(cfg.uy.zL)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Regular padLeft2 minW14')]), _List_fromArray([$elm$html$Html$text($author$project$Types$AccountType$toString(cfg.uy.it))]))])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text(cfg.R.zL)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft5 flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom1')]), balanceInfo), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray40 heading5Bold')]), updateInfo)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft3 h5 w5 radius0'), $elm$html$Html$Attributes$class(graphStyle.o2)]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(onToggleGraph), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter justifyCenter fullWidth fullHeight')]), _List_fromArray([$author$project$IconSvg$graph('w3 ' + graphStyle.ln)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft6 flexRow flexAlignCenter')]), _List_fromArray([$author$project$Ui$Switch$switch({
      vV: '',
      hE: cfg.yC,
      yW: false,
      tU: cfg.ew
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft6 relative ')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.sd), _List_fromArray([$elm$html$Html$Attributes$class('w5')]), _List_fromArray([$author$project$IconSvg$dots('primary30Fill ')])), popoverMenuPart]))]))]));
  };

  var $author$project$Ui$Chart$LineBarChart$BlueLineTheme = 1;

  var $author$project$Types$SimpleDate$addSeconds = function (seconds) {
    return $author$project$Types$SimpleDate$addMillis(1000 * seconds);
  };

  var $author$project$Types$SimpleDate$addMinutes = function (minutes) {
    return $author$project$Types$SimpleDate$addSeconds(60 * minutes);
  };

  var $author$project$Types$SimpleDate$addHours = function (hours) {
    return $author$project$Types$SimpleDate$addMinutes(60 * hours);
  };

  var $author$project$Types$SimpleDate$addDays = function (days) {
    return $author$project$Types$SimpleDate$addHours(24 * days);
  };

  var $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$generateFutureValues = F2(function (numberNeeded, lastBalance) {
    var toExtraValue = function (value) {
      return {
        o4: $elm$core$Maybe$Nothing,
        iL: value.iL,
        yf: $elm$core$Maybe$Nothing,
        q2: false,
        ri: value.o3,
        Bb: $elm$core$Maybe$Nothing,
        ew: $elm$core$Maybe$Nothing,
        sz: $elm$core$Maybe$Nothing
      };
    };

    return A2($elm$core$List$indexedMap, F2(function (index, date) {
      return toExtraValue(_Utils_update(lastBalance, {
        iL: A2($author$project$Types$SimpleDate$addDays, index, date)
      }));
    }), A2($elm$core$List$repeat, numberNeeded, lastBalance.iL));
  });
  var $author$project$Types$SimpleDate$daysBetween = F3(function (zone, date1, date2) {
    return A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, A2($author$project$Types$SimpleDate$toPosix, zone, date1), A2($author$project$Types$SimpleDate$toPosix, zone, date2));
  });

  var $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$generateSteppedValues = function (cfg) {
    var repeatValuesUntilDate = F2(function (balance, untilSimpleDate) {
      var daysNeeded = A3($author$project$Types$SimpleDate$daysBetween, cfg.by, balance.o$, untilSimpleDate);
      return A2($elm$core$List$indexedMap, F2(function (index, bal) {
        return _Utils_update(bal, {
          o$: A2($author$project$Types$SimpleDate$addDays, index, bal.o$)
        });
      }), A2($elm$core$List$repeat, daysNeeded, balance));
    });

    var step = function (balances) {
      if (!balances.b) {
        return _List_Nil;
      } else {
        if (!balances.b.b) {
          var head = balances.a;
          var today = A2($author$project$Types$SimpleDate$fromPosix, cfg.by, cfg.zX);
          return _Utils_eq(head.o$, today) ? _List_fromArray([head]) : _Utils_ap(A2(repeatValuesUntilDate, head, today), _List_fromArray([_Utils_update(head, {
            o$: today
          })]));
        } else {
          var head = balances.a;
          var _v1 = balances.b;
          var next = _v1.a;
          var tail = _v1.b;
          return _Utils_ap(A2(repeatValuesUntilDate, head, next.o$), step(A2($elm$core$List$cons, next, tail)));
        }
      }
    };

    return step(cfg.wx);
  };

  var $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$sortData = function (data) {
    return A2($elm$core$List$sortBy, function (datum) {
      return $author$project$Types$SimpleDate$toMillis(datum.o$);
    }, data);
  };

  var $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$toTooltipView = function (balance) {
    var keyVal = F2(function (key, val) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap'), A2($elm$html$Html$Attributes$style, 'letter-spacing', '.2em')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray20 heading4Regular')]), _List_fromArray([$elm$html$Html$text(key + ': ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading4Bold')]), _List_fromArray([$elm$html$Html$text(val)]))]));
    });

    var content = function () {
      var _v0 = balance.jZ;

      if (_v0.$ === 1) {
        return _List_fromArray([A2(keyVal, 'Balance', $elm$core$String$fromFloat(balance.gY))]);
      } else {
        var originalBalance = _v0.a;
        return _List_fromArray([A2(keyVal, 'New Balance', $elm$core$String$fromFloat(balance.gY)), A2(keyVal, 'Original Balance', $elm$core$String$fromFloat(originalBalance))]);
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 primary30Back inlineBlock')]), content);
  };

  var $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$toValue = F2(function (cfg, balance) {
    var hovering = function (hoveringBalance) {
      return _Utils_eq(hoveringBalance.o$, balance.o$) ? $elm$core$Maybe$Just($author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$toTooltipView(hoveringBalance)) : $elm$core$Maybe$Nothing;
    };

    return {
      o4: $elm$core$Maybe$Nothing,
      iL: balance.o$,
      yf: A2($elm$core$Maybe$andThen, hovering, cfg.qL),
      q2: false,
      ri: balance.gY,
      Bb: A2($elm$core$Maybe$map, function (mouseEnter) {
        return $elm$core$Basics$always(mouseEnter(balance));
      }, cfg.rV),
      ew: A2($elm$core$Maybe$map, function (onTap) {
        return $elm$core$Basics$always(onTap(balance));
      }, cfg.sa),
      sz: $elm$core$Maybe$Nothing
    };
  });

  var $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$financialAccountBalanceHistoryChart = function (cfg) {
    var width = A2($elm$core$Maybe$map, function (viewport) {
      return viewport.FE;
    }, cfg.FA);
    var valuesNeededToFillChart = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, function (w) {
      return w / 30 | 0;
    }, width));
    var sortedData = $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$sortData(cfg.wx);
    var steppedValues = A2($elm$core$List$map, $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$toValue(cfg), $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$generateSteppedValues({
      wx: sortedData,
      zX: cfg.zX,
      by: cfg.by
    }));

    var lastBalance = function () {
      var _v0 = $elm$core$List$head($elm$core$List$reverse(sortedData));

      if (!_v0.$) {
        var value = _v0.a;
        return {
          o3: value.gY,
          iL: value.o$
        };
      } else {
        return {
          o3: 0,
          iL: A2($author$project$Types$SimpleDate$fromPosix, cfg.by, cfg.zX)
        };
      }
    }();

    var futureValuesNeeded = A2($elm$core$Basics$max, 0, valuesNeededToFillChart - $elm$core$List$length(steppedValues));
    var futureValues = A2($author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$generateFutureValues, futureValuesNeeded, lastBalance);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteBack')]), _List_fromArray([$author$project$Ui$Chart$LineBarChart$lineBarChart({
      zd: 1,
      mL: cfg.mL,
      mZ: cfg.mZ,
      DE: $elm$core$Maybe$Just({
        x6: '340px',
        zp: 'auto'
      }),
      D7: false,
      ir: _Utils_ap(steppedValues, futureValues),
      FA: cfg.FA
    })]));
  };

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$BlackColorSubtitle = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Views$Routed$FinancialAccountsBranch$routeAddAccount = function (companyId) {
    return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$AddFinancialAccount)));
  };

  var $author$project$Views$Routed$FinancialAccountsBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: $elm$core$Maybe$Nothing,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$FinancialAccountsBranch$financialAccountsEmptyState = F3(function (companyId, topState, session) {
    return $author$project$Views$Routed$FinancialAccountsBranch$viewLayer({
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter fullWidth spaceBetween ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Accounts'
      }), $author$project$Ui$Button$basicButton({
        kG: ' marRight15',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Views$Routed$FinancialAccountsBranch$routeAddAccount(companyId)),
        y$: '+ Add New Account'
      })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter relative marTop6')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg, 'w46 h46', 'maxW46', $author$project$AssetsImg$assets.yl), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft14')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
        pv: 'black',
        vV: '',
        tQ: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$TitleTypes$BlackColorSubtitle('Add an account manually or sync Puffin with your accounting software.')),
        t1: 'It looks like you haven’t added an account yet.'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter')]), _List_fromArray([$author$project$Ui$Button$basicButton({
        kG: '',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Views$Routed$FinancialAccountsBranch$routeAddAccount(companyId)),
        y$: '+ Create a New Account'
      }), $author$project$Ui$Button$basicButton({
        kG: '',
        vY: 1,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Settings(3)))),
        y$: 'Sync with acounting software'
      })]))]))]))]),
      DY: session,
      eG: topState
    });
  });
  var $author$project$Types$Company$toFinancialAccountsFiltered = F2(function (filters, company) {
    var filterer = function (_v0) {
      var division = _v0.a;
      var financialAccount = _v0.b;
      return A2($elm$core$String$contains, $elm$core$String$toLower(filters.j_), $elm$core$String$toLower(financialAccount.zL)) || A2($elm$core$String$contains, $elm$core$String$toLower(filters.j_), $elm$core$String$toLower($author$project$Types$AccountType$toString(financialAccount.it))) || A2($elm$core$String$contains, $elm$core$String$toLower(filters.j_), $elm$core$String$toLower(division.zL));
    };

    return A2($elm$core$Maybe$map, $elm$core$List$filter(filterer), $author$project$Types$Company$toFinancialAccounts(company));
  });

  var $author$project$ElmFramework$Lib$OrderedCollection$toList = function (_v0) {
    var list = _v0.aA;
    return list;
  };

  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toList = function (endlessList) {
    return $author$project$ElmFramework$Lib$OrderedCollection$toList(endlessList.aq);
  };

  var $author$project$Views$Routed$FinancialAccountsBranch$financialAccounts = F3(function (company, topState, session) {
    var toAccounts = A2($elm$core$Basics$composeR, $author$project$Types$Company$toFinancialAccountsFiltered({
      j_: topState.o_.uz.j_
    }), $elm$core$Maybe$withDefault(_List_Nil));

    var toAccountRow = function (_v0) {
      var division = _v0.a;
      var account = _v0.b;
      var toggleEnabledState = {
        oO: $elm$core$Maybe$Just(account.zL),
        it: $elm$core$Maybe$Nothing,
        dx: $elm$core$Maybe$Nothing,
        bq: $elm$core$Maybe$Nothing,
        R: division.F,
        F: account.F,
        yO: $elm$core$Maybe$Just(!account.la)
      };
      var showGraph = A2($turboMaCk$any_set$Set$Any$member, account.F, topState.o_.uz.tv);
      var balances = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toList, $krisajenkins$remotedata$RemoteData$toMaybe(account.fy)));
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom3')]), _List_fromArray([$author$project$Ui$AccountRow$accountRow({
        uy: account,
        vV: '',
        R: division,
        yC: account.la,
        yF: true,
        q1: showGraph,
        yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$FinancialAccount$unwrapFinancialAccountId(account.F)),
        Ay: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$DeleteFinancialAccount(account.F)))),
        AT: $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$EditFinancialAccount(account.F)))),
        A0: $author$project$TopMsg$msgAccounts($author$project$Ui$Accounts$Msg$OnCloseGraph(account.F)),
        A1: $author$project$TopMsg$msgAccounts(A3($author$project$Ui$Accounts$Msg$OnOpenGraph, company.F, division.F, account.F)),
        ew: $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$EditFinancialAccount, false, company.F, toggleEnabledState)),
        sd: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$FinancialAccount$unwrapFinancialAccountId(account.F))),
        DY: session,
        by: $elm$time$Time$utc
      }), showGraph ? $author$project$Ui$Chart$FinancialAccountBalanceHistoryChart$financialAccountBalanceHistoryChart({
        wx: balances,
        qL: topState.o_.uz.qK,
        zX: topState.EM,
        rV: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, $author$project$Ui$Accounts$Msg$OnChartMouseEnterBalance)),
        mL: $elm$core$Maybe$Just($author$project$TopMsg$msgAccounts($author$project$Ui$Accounts$Msg$OnLeaveChart)),
        sa: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, A3($author$project$Ui$Accounts$Msg$OnChartTapBalance, company.F, division.F, account.F))),
        mZ: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, $author$project$Ui$Accounts$Msg$OnAccountHistoryChartViewport),
        FA: topState.o_.uz.oN,
        by: topState.by
      }) : $author$project$ElmFramework$Lib$Util$noOpEl]));
    };

    var toAccountRows = $elm$core$List$map(toAccountRow);
    var textSearchActive = !$elm$core$String$isEmpty($elm$core$String$trim(topState.o_.uz.j_));
    var accountsLoaded = $krisajenkins$remotedata$RemoteData$isSuccess(company.eO);
    var accountRows = toAccountRows(toAccounts(company));
    return $elm$core$List$isEmpty(accountRows) && !textSearchActive && accountsLoaded ? A3($author$project$Views$Routed$FinancialAccountsBranch$financialAccountsEmptyState, company.F, topState, session) : $author$project$Views$Routed$FinancialAccountsBranch$viewLayer({
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter fullWidth spaceBetween ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: '',
        y$: 'Accounts'
      }), $author$project$Ui$Input$inputWithIcon({
        vV: 'w70 whiteBack marLeft10 ',
        yh: $author$project$IconSvg$search,
        e3: 'Search',
        gx: false,
        b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgAccounts, $author$project$Ui$Accounts$Msg$OnUpdateTextSearch),
        P: 'text',
        Fw: topState.o_.uz.j_
      })])), $author$project$Ui$Button$basicButton({
        kG: ' marRight15 ',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Views$Routed$FinancialAccountsBranch$routeAddAccount(company.F)),
        y$: '+ Add New Account'
      })])), $elm$core$List$isEmpty(accountRows) && textSearchActive ? !accountsLoaded ? $author$project$ElmFramework$Lib$Util$noOpEl : A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$EmptyStateView$emptyStateView({
        pi: $elm$core$Maybe$Nothing,
        tQ: $elm$core$Maybe$Nothing,
        t1: 'No results for your query.'
      })])) : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marTop5h marRight15')]), accountRows)]),
      DY: session,
      eG: topState
    });
  });
  var $author$project$Views$Routed$FinancialAccountsBranch$financialAccountsBranch = F4(function (branch, company, topState, session) {
    switch (branch.$) {
      case 0:
        return _List_fromArray([A3($author$project$Views$Routed$FinancialAccountsBranch$financialAccounts, company, topState, session)]);

      case 1:
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$FinancialAccountsBranch$financialAccounts, company, topState, session)]), _List_fromArray([A2($author$project$Ui$OverLaysView$addNewAccountFinancialAccountsOverlay, company, topState)])]));

      case 2:
        var financialAccountId = branch.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$FinancialAccountsBranch$financialAccounts, company, topState, session)]), _List_fromArray([A3($author$project$Ui$OverLaysView$editAccountInfoFinancialAccountsOverlay, company, topState, financialAccountId)])]));

      default:
        var financialAccountId = branch.a;
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([A3($author$project$Views$Routed$FinancialAccountsBranch$financialAccounts, company, topState, session)]), _List_fromArray([A2($author$project$Ui$OverLaysView$deleteAccountBalanceFinancialAccountsOverlay, company, financialAccountId)])]));
    }
  });
  var $author$project$Remote$RequestMsg$CreateScenario = F2(function (a, b) {
    return {
      $: 42,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$Scenario$Msg$SetEditingScenario = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$Scenario$Msg$OnBlocksFiltersUpdate = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Types$EditingScenario$EditingScenario$addBlock = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      bX: A3($turboMaCk$any_dict$Dict$Any$insert, val, $author$project$Types$EditingScenario$EditingScenario$AddBlock({
        yO: true
      }), editingScenario.bX)
    });
  });
  var $author$project$Types$EditingScenario$EditingScenario$toCreateScenarioReq = F3(function (zone, isDraft, editingScenario) {
    var toCreateReq = function (startAt) {
      return {
        vk: $author$project$Types$EditingScenario$EditingScenario$toAddBlockOverrides(editingScenario),
        E: editingScenario.E,
        br: isDraft,
        la: true,
        yC: $elm$core$Maybe$Nothing,
        rf: editingScenario.rf,
        zL: editingScenario.zL,
        sQ: true,
        de: editingScenario.de,
        df: editingScenario.df,
        tB: startAt
      };
    };

    return A2($elm$core$Result$map, toCreateReq, A2($elm$core$Result$fromMaybe, 'Please provide starting date', A2($author$project$Ui$DateInput$DateInput$toSimpleDate, zone, editingScenario.tB)));
  });
  var $author$project$Ui$OverLaysView$cancelEditingOverlay = F4(function (zone, editingScenario, onSubmit, onCancel) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Cancel Scenario',
        as: 'Save as Draft',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop4 marLeft12 marRight12 marBottom3')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'center maxW46',
          y$: 'Are you sure you want to cancel? All changes added to this scenario will be lost.'
        }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'padTop2 padBottom2 gray40 center',
          y$: 'This action cannot be undone.'
        })]))]),
        av: onCancel,
        aw: function () {
          var _v0 = A3($author$project$Types$EditingScenario$EditingScenario$toCreateScenarioReq, zone, true, editingScenario);

          if (!_v0.$) {
            var req = _v0.a;
            return onSubmit(req);
          } else {
            var err = _v0.a;
            return $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Df]));
          }
        }(),
        Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
        t1: 'Cancel'
      })
    });
  });
  var $author$project$Route$EditScenarioRoute$ConfirmCancelScenarioEdit = 4;
  var $author$project$Ui$Scenario$Msg$OnTapBasicInfo = {
    $: 12
  };
  var $author$project$TopMsg$msgScenario = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ScenarioMsg);
  var $author$project$Ui$Scenario$Msg$NoOp = {
    $: 9
  };

  var $author$project$Ui$Scenario$Msg$SetProjectionAccountType = function (a) {
    return {
      $: 7,
      a: a
    };
  };

  var $author$project$Ui$Scenario$Msg$SetProjectionDivisions = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$Scenario$Msg$SetProjectionReportingInterval = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Ui$Scenario$Msg$ToggleExpandRow = function (a) {
    return {
      $: 8,
      a: a
    };
  };

  var $author$project$Ui$Scenario$Msg$ToggleProjectionDivision = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$darkDescriptionTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold gray90'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text(cfg.y$)]));
  };

  var $author$project$Types$EditingScenario$EditingScenario$setDescription = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      E: val
    });
  });
  var $author$project$Types$EditingScenario$EditingScenario$setLength = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      rf: val
    });
  });
  var $author$project$Types$EditingScenario$EditingScenario$setName = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      zL: val
    });
  });
  var $author$project$Types$EditingScenario$EditingScenario$setSetAsBase = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      de: val
    });
  });
  var $author$project$Types$EditingScenario$EditingScenario$setSetAsBudget = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      df: val
    });
  });
  var $author$project$Types$EditingScenario$EditingScenario$setStartAt = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      tB: val
    });
  });
  var $author$project$ElmFramework$Lib$Util$conditionalAttr = F2(function (attribute, shouldAdd) {
    return shouldAdd ? attribute : $author$project$ElmFramework$Lib$Util$noOpAttr;
  });

  var $author$project$ElmFramework$Feature$Platform$Platform$selectTextContent = _Platform_outgoingPort('selectTextContent', $elm$json$Json$Encode$string);

  var $author$project$Ui$Textarea$textarea = function (config) {
    return A3($elm$html$Html$node, 'gg-textarea', _List_fromArray([$elm$html$Html$Attributes$class('block'), $elm$html$Html$Attributes$class(config.vV)]), _List_fromArray([A2($elm$html$Html$textarea, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth h8 padLeft2 padTop1 padRight1 placeholderGray20 heading5Bold borderHairlineWidth borderSolid gray20Border radius0 noResize primary30'), $elm$html$Html$Attributes$id(config.yi), A2($author$project$ElmFramework$Lib$Util$conditionalAttr, $elm$html$Html$Events$onFocus(config.wK($author$project$ElmFramework$Feature$Platform$Platform$selectTextContent(config.yi))), config.D5), $elm$html$Html$Attributes$value(config.Fv), $elm$html$Html$Events$onInput(config.A5), $elm$html$Html$Attributes$placeholder(config.EJ), $elm$html$Html$Attributes$required(config.yW), A2($author$project$ElmFramework$Lib$Util$conditionalAttr, A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'), config.D4), A2($author$project$ElmFramework$Lib$Util$conditionalAttr, A2($elm$html$Html$Attributes$attribute, 'data-enable-grammerly', 'false'), config.D4), A2($author$project$ElmFramework$Lib$Util$conditionalAttr, A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'), config.D4)]), _List_Nil)]));
  };

  var $author$project$Ui$ScenariosBasicContentView$scenariosBasicContentView = function (_v0) {
    var company = _v0.j;
    var topState = _v0.eG;
    var toggleSection = _v0.E4;
    var editingScenarioId = _v0.p6;
    var onSetEditingScenario = _v0.r5;
    var state = topState.o_.DB;
    var maybeDivisions = $krisajenkins$remotedata$RemoteData$toMaybe(company.eO);
    var intervalDropdown = $author$project$Ui$DropdownSelect$dropdownSelect({
      vV: '',
      yI: false,
      e0: $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$list,
      e3: 'Choose...',
      Ej: state.ns,
      b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenario, $author$project$Ui$Scenario$Msg$SetProjectionReportingInterval),
      fd: $elm$core$Basics$eq,
      EU: $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString
    });
    var editingScenario = state.p5;
    var scenarioNameInput = $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'left',
      E: $elm$core$Maybe$Nothing,
      k_: false,
      qU: 0,
      qW: false,
      e_: A2($elm$core$Basics$composeL, onSetEditingScenario, $author$project$Types$EditingScenario$EditingScenario$setName(editingScenario)),
      e3: 'Scenario\'s Name',
      gx: true,
      Fw: editingScenario.zL
    });
    var showBasicInfoContentExtended = state.qk ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Textarea$textarea({
      vV: 'maxW90',
      wK: function (_v2) {
        return $author$project$TopMsg$msgScenario($author$project$Ui$Scenario$Msg$NoOp);
      },
      yi: 'someIdentifier',
      yW: false,
      zW: '',
      A5: A2($elm$core$Basics$composeL, onSetEditingScenario, $author$project$Types$EditingScenario$EditingScenario$setDescription(editingScenario)),
      D4: true,
      D5: false,
      EJ: 'Enter Description',
      Fv: editingScenario.E
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop4 marBottom4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: 'padRight2h',
      y$: 'Start Date:'
    }), A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, onSetEditingScenario, $author$project$Types$EditingScenario$EditingScenario$setStartAt(editingScenario)), A3($author$project$Ui$DateInput$DateInput$updateShort, topState.by, topState.EM, editingScenario.tB)), editingScenario.tB, topState.by), $author$project$ElmFramework$Lib$Util$spacer('w5'), $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: '',
      y$: 'Length (months):'
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft3h',
      yC: !editingScenario.rf,
      y$: '6',
      ew: onSetEditingScenario(A2($author$project$Types$EditingScenario$EditingScenario$setLength, editingScenario, 0))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2',
      yC: editingScenario.rf === 1,
      y$: '9',
      ew: onSetEditingScenario(A2($author$project$Types$EditingScenario$EditingScenario$setLength, editingScenario, 1))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2',
      yC: editingScenario.rf === 2,
      y$: '12',
      ew: onSetEditingScenario(A2($author$project$Types$EditingScenario$EditingScenario$setLength, editingScenario, 2))
    }), $author$project$Ui$Button$buttonSelectShort({
      vV: 'marLeft2',
      yC: editingScenario.rf === 3,
      y$: '24',
      ew: onSetEditingScenario(A2($author$project$Types$EditingScenario$EditingScenario$setLength, editingScenario, 3))
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([$author$project$Ui$SwitchBlockLabeled$switchBlockLabeled({
      vV: 'primary10Back',
      yC: editingScenario.de,
      y$: $author$project$Ui$SwitchBlockLabeled$SwitchLabelRight('Set as Base Scenario'),
      ew: onSetEditingScenario(A2($author$project$Types$EditingScenario$EditingScenario$setSetAsBase, editingScenario, !editingScenario.de))
    }), $author$project$ElmFramework$Lib$Util$spacer('w6'), $author$project$Ui$SwitchBlockLabeled$switchBlockLabeled({
      vV: 'primary10Back',
      yC: editingScenario.df,
      y$: $author$project$Ui$SwitchBlockLabeled$SwitchLabelRight('Set as Budget Scenario'),
      ew: onSetEditingScenario(A2($author$project$Types$EditingScenario$EditingScenario$setSetAsBudget, editingScenario, !editingScenario.df))
    })]))])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    var divisionsMultiSelect = $author$project$Ui$SwitchDropdown$switchDropdown({
      uE: 'All Divisions',
      kG: 'flex1',
      zy: $elm$core$Maybe$Nothing,
      zT: 'No Division Selected',
      Ad: $author$project$TopMsg$msgScenario($author$project$Ui$Scenario$Msg$SetProjectionDivisions(_List_Nil)),
      BF: A3($elm$core$Basics$composeL, $author$project$TopMsg$msgScenario, $author$project$Ui$Scenario$Msg$SetProjectionDivisions, A2($elm$core$List$map, function ($) {
        return $.F;
      }, A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, maybeDivisions))),
      BX: F2(function (id, _v1) {
        return $author$project$TopMsg$msgScenario($author$project$Ui$Scenario$Msg$ToggleProjectionDivision(id));
      }),
      e0: maybeDivisions,
      e3: 'Divisions',
      ia: state.nr,
      t3: function ($) {
        return $.zL;
      }
    });
    var addLessIcon = state.qk ? $author$project$IconSvg$less : $author$project$IconSvg$add;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: 'padBottom6',
      y$: A3($author$project$ElmFramework$Lib$Util$ifElse, 'Edit Scenario', 'Create a New Scenario', $elm_community$maybe_extra$Maybe$Extra$isJust(editingScenarioId))
    }), A2($author$project$Ui$Sections$plainSection, '', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween padBottom4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$darkDescriptionTitle({
      vV: '',
      y$: 'Basic Info'
    }), $author$project$Ui$Button$button({
      kG: '',
      pD: addLessIcon('primary30Fill w3'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(toggleSection)
    })])), scenarioNameInput, showBasicInfoContentExtended])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop6')]), _List_fromArray([divisionsMultiSelect, $author$project$ElmFramework$Lib$Util$spacer('flex1')])), $author$project$Views$Routed$CashboardBranch$cashboardChartSection({
      pb: state.nq,
      pp: $elm$core$Maybe$Nothing,
      ya: $elm$core$Maybe$Nothing,
      qM: $elm$core$Maybe$Nothing,
      Bc: $elm$core$Maybe$Nothing,
      rW: $elm$core$Maybe$Nothing,
      mL: $elm$core$Maybe$Nothing,
      BG: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenario, $author$project$Ui$Scenario$Msg$SetProjectionAccountType),
      BR: $elm$core$Maybe$Nothing,
      BV: $elm$core$Maybe$Nothing,
      b0: company.b0,
      C0: A2($elm$core$Maybe$map, function ($) {
        return $.vN;
      }, state.sP)
    }), $author$project$Views$Routed$CashboardBranch$transactionSummaryTableSection({
      qi: state.qi,
      yz: intervalDropdown,
      BY: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenario, $author$project$Ui$Scenario$Msg$ToggleExpandRow),
      Ew: A2($elm$core$Maybe$map, function ($) {
        return $.Fb;
      }, state.sP)
    })]));
  };

  var $author$project$Types$EditingScenario$EditingScenario$toEditScenarioReq = F4(function (zone, isDraft, existingRelationships, editingScenario) {
    var toEditReq = function (startAt) {
      return {
        vk: A2($author$project$Types$EditingScenario$EditingScenario$toDesiredBlocks, $elm$core$Maybe$Just(existingRelationships), editingScenario),
        E: editingScenario.E,
        br: isDraft,
        la: true,
        yC: $elm$core$Maybe$Nothing,
        rf: editingScenario.rf,
        zL: editingScenario.zL,
        sQ: true,
        de: editingScenario.de,
        df: editingScenario.df,
        tB: startAt
      };
    };

    return A2($elm$core$Result$map, toEditReq, A2($elm$core$Result$fromMaybe, 'Please provide starting date', A2($author$project$Ui$DateInput$DateInput$toSimpleDate, zone, editingScenario.tB)));
  });

  var $author$project$UiWrappers$WithTopActionBar$withTopActionBar = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexColumn primary10Back')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth desktopWidthCenter flexRow padLeft2 padRight2 padTop3 padBottom3')]), cfg.oR), cfg.oW ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w44')]), _List_Nil) : $author$project$ElmFramework$Lib$Util$noOpEl]))])), function () {
      var _v0 = cfg.ta;

      if (!_v0.$) {
        var sidebarCfg = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 flexRow noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('desktopWidthCenter padTop6 padLeft2 padRight2 padBottom6')]), cfg.g9)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w43 scrollTarget flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 marTop16 pad3 primary0Back')]), $author$project$UiWrappers$WithTopActionBar$toSidebarContent(sidebarCfg))]))]));
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop6 padBottom6')]), cfg.g9)]));
      }
    }()]));
  };

  var $author$project$Ui$EditScenarioView$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$WithTopActionBar$withTopActionBar({
        oR: _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
          kG: 'padLeft2 padRight2',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.rd),
          y$: cfg.rc
        }), $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
          kG: '',
          vY: A3($author$project$ElmFramework$Lib$Util$ifElse, 0, 1, cfg.oM),
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.s8),
          y$: cfg.s7
        })]),
        oW: true,
        g9: cfg.g9,
        ta: cfg.s9
      })
    });
  };

  var $author$project$Ui$EditScenarioView$editScenarioView = function (_v0) {
    var company = _v0.j;
    var topState = _v0.eG;
    var rightSidebar = _v0.ta;
    var onSubmit = _v0.r8;
    var onCancel = _v0.Aa;
    var editingScenarioId = _v0.p6;
    var onSetEditingScenario = _v0.r5;
    var maybeExistingScenarioBlocksRelationships = A3($elm$core$Maybe$map2, $author$project$ElmFramework$Lib$PivotDict$getById1, editingScenarioId, $krisajenkins$remotedata$RemoteData$toMaybe(company.nT));
    var editingScenario = topState.o_.DB.p5;

    var scenarioModified = function () {
      var scenario = A2($elm$core$Maybe$andThen, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$Types$Company$toScenario, company), editingScenarioId);

      var editingScenarioWithFixedOverrides = function () {
        var validOverride = F2(function (blockId, override) {
          if (!override.$) {
            var isEnabled = override.a.yO;
            return isEnabled ? A2($elm$core$List$any, A2($elm$core$Basics$composeR, function ($) {
              return $.dM;
            }, A2($elm$core$Basics$composeR, $elm$core$Basics$eq(blockId), $elm$core$Basics$not)), A2($elm$core$Maybe$withDefault, _List_Nil, maybeExistingScenarioBlocksRelationships)) : false;
          } else {
            return A2($elm$core$List$any, A2($elm$core$Basics$composeR, function ($) {
              return $.dM;
            }, $elm$core$Basics$eq(blockId)), A2($elm$core$Maybe$withDefault, _List_Nil, maybeExistingScenarioBlocksRelationships));
          }
        });
        var overrides = A2($turboMaCk$any_dict$Dict$Any$filter, F2(function (blockId, override) {
          return A2(validOverride, blockId, override);
        }), editingScenario.bX);
        return _Utils_update(editingScenario, {
          bX: overrides
        });
      }();

      var editingScenarioOriginal = A2($elm$core$Maybe$map, A2($author$project$Types$EditingScenario$EditingScenario$fromScenario, topState.by, company), scenario);
      return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $elm$core$Basics$neq(editingScenarioWithFixedOverrides), editingScenarioOriginal));
    }();

    var _v1 = function () {
      if (!maybeExistingScenarioBlocksRelationships.$) {
        var scenarioBlockRelationships = maybeExistingScenarioBlocksRelationships.a;

        var _v3 = A4($author$project$Types$EditingScenario$EditingScenario$toEditScenarioReq, topState.by, false, scenarioBlockRelationships, editingScenario);

        if (!_v3.$) {
          var req = _v3.a;
          return _Utils_Tuple2(onSubmit(req), true);
        } else {
          var err = _v3.a;
          return _Utils_Tuple2(A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil), false);
        }
      } else {
        var _v4 = A3($author$project$Types$EditingScenario$EditingScenario$toCreateScenarioReq, topState.by, false, editingScenario);

        if (!_v4.$) {
          var req = _v4.a;
          return _Utils_Tuple2(onSubmit(req), true);
        } else {
          var err = _v4.a;
          return _Utils_Tuple2(A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil), false);
        }
      }
    }();

    var submitHandler = _v1.a;
    var accentRightButton = _v1.b;
    return $author$project$Ui$EditScenarioView$viewLayer({
      oM: accentRightButton,
      g9: _List_fromArray([$author$project$Ui$ScenariosBasicContentView$scenariosBasicContentView({
        j: company,
        p6: editingScenarioId,
        r5: onSetEditingScenario,
        E4: $author$project$TopMsg$msgScenario($author$project$Ui$Scenario$Msg$OnTapBasicInfo),
        eG: topState
      })]),
      rc: 'Cancel',
      rd: function () {
        if (!scenarioModified) {
          return onCancel;
        } else {
          if (!editingScenarioId.$) {
            var scenarioId = editingScenarioId.a;
            return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, scenarioId, 4))));
          } else {
            return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(4))));
          }
        }
      }(),
      s7: 'Save Scenario',
      s8: submitHandler,
      s9: rightSidebar,
      eG: topState
    });
  };

  var $author$project$Types$EditingScenario$EditingScenario$RemoveBlock = {
    $: 1
  };
  var $author$project$Types$EditingScenario$EditingScenario$removeBlock = F2(function (editingScenario, val) {
    return _Utils_update(editingScenario, {
      bX: A3($turboMaCk$any_dict$Dict$Any$insert, val, $author$project$Types$EditingScenario$EditingScenario$RemoveBlock, editingScenario.bX)
    });
  });

  var $author$project$UiWrappers$WithTopActionBar$TitledSidebar = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$EditScenarioView$rightSideBarBuildingBlocksEmptyState = function (onEditScenarioSubRoute) {
    return $author$project$UiWrappers$WithTopActionBar$TitledSidebar({
      pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('center')]), _List_fromArray([A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src($author$project$AssetsImg$assets.yk), A2($elm$html$Html$Attributes$style, 'max-width', '50%'), A2($elm$html$Html$Attributes$style, 'max-height', '50%')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Regular gray90 padTop4h')]), _List_fromArray([$elm$html$Html$text('Add the first building block to this scenario')])), $author$project$Ui$Button$basicButtonMiddle({
        kG: 'fullWidth marTop4',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onEditScenarioSubRoute(2)),
        y$: '+ Add a building block'
      })]))]),
      t1: 'Building Blocks'
    });
  };

  var $author$project$UiWrappers$WithTopActionBar$CloseBtnSidebar = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$EditingScenario$EditingScenario$isBlockAdded = F2(function (buildingBlockId, editingScenario) {
    var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, buildingBlockId, editingScenario.bX);

    if (!_v0.$) {
      if (!_v0.a.$) {
        return true;
      } else {
        var _v1 = _v0.a;
        return false;
      }
    } else {
      return false;
    }
  });

  var $author$project$Ui$EditScenarioView$rightSideBarChooseBuildingBlocks = function (_v0) {
    var topState = _v0.eG;
    var company = _v0.j;
    var session = _v0.DY;
    var selectedBlocks = _v0.to;
    var filters = _v0.qo;
    var onAddBlock = _v0.z1;
    var onRemoveBlock = _v0.rZ;
    var searchInput = $author$project$Ui$Input$inputWithIcon({
      vV: 'padRight2',
      yh: $author$project$IconSvg$search,
      e3: 'Search',
      gx: false,
      b3: A2($elm$core$Basics$composeR, $author$project$Types$Filters$UpdateTextSearch, A2($elm$core$Basics$composeR, $author$project$Ui$Scenario$Msg$OnBlocksFiltersUpdate, $author$project$TopMsg$msgScenario)),
      P: 'text',
      Fw: topState.o_.DB.pd.j_
    });
    var editingScenario = topState.o_.DB.p5;

    var toBlockEl = function (block) {
      var wasBlockAdded = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$List$member(block), selectedBlocks));
      var button = A2($author$project$Types$EditingScenario$EditingScenario$isBlockAdded, block.F, editingScenario) || wasBlockAdded ? _Utils_Tuple2(onRemoveBlock(block.F), 'Remove block from scenario') : _Utils_Tuple2(onAddBlock(block.F), 'Use block on scenario');
      return $author$project$Ui$ScenarioBlock$scenarioBlock({
        y: block,
        pi: $elm$core$Maybe$Just(button),
        j: company,
        qY: $elm$core$Maybe$Nothing,
        tO: $elm$core$Maybe$Just('Retail'),
        by: $elm$time$Time$utc
      });
    };

    var filteredBlocksList = A2($elm$core$List$map, toBlockEl, A2($elm$core$Maybe$withDefault, _List_Nil, A4($author$project$Types$Company$toBuildingBlocksFiltered, A2($author$project$Types$Filters$withQuickEdits, session.Fl.F, filters), $elm$core$Maybe$Just(1), $elm$core$Maybe$Nothing, company)));
    var addBlockBtn = $author$project$Ui$Button$basicButtonMiddle({
      kG: 'fullWidth',
      vY: 0,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$CreateBlock(0))))),
      y$: '+ Create a New Block'
    });
    return $author$project$UiWrappers$WithTopActionBar$CloseBtnSidebar({
      pD: _List_fromArray([addBlockBtn, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop3')]), _List_fromArray([searchInput, A2($author$project$Ui$FilterButton$filterButton, topState.o_.DB.pd, $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(1)))))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3')]), filteredBlocksList)]),
      Aj: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
      t1: 'Building Blocks'
    });
  };

  var $author$project$Ui$EditScenarioView$rightSideBarCurrentBlocks = function (cfg) {
    var toBlockEl = function (_v0) {
      var block = _v0.a;
      var isEnabled = _v0.b.yO;
      return $author$project$Ui$ScenarioBlock$scenarioBlock({
        y: block,
        pi: $elm$core$Maybe$Just(_Utils_Tuple2(cfg.rZ(block.F), 'Remove block from scenario')),
        j: cfg.j,
        qY: $elm$core$Maybe$Nothing,
        tO: $elm$core$Maybe$Just('Retail'),
        by: $elm$time$Time$utc
      });
    };

    return $author$project$UiWrappers$WithTopActionBar$TitledSidebar({
      pD: _List_fromArray([$author$project$Ui$CommentsAndBuildingBlocksRightSideBarContent$commentsAndBuildingBlocksRightSideBarContent({
        kz: '+ Add more blocks',
        pD: A2($elm$core$List$map, toBlockEl, cfg.vk),
        pS: $elm$core$Maybe$Nothing,
        qo: cfg.qo,
        r3: cfg.r3,
        sc: cfg.rQ(1),
        BT: cfg.rQ(2)
      })]),
      t1: 'Building Blocks'
    });
  };

  var $author$project$UiWrappers$WithTopActionBar$BackBtnSidebar = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$EditScenarioView$rightSideBarFiltersState = F3(function (topState, company, session) {
    return $elm$core$Maybe$Just($author$project$UiWrappers$WithTopActionBar$BackBtnSidebar({
      pD: _List_fromArray([$author$project$Ui$ScenarioBlocksFilters$scenarioBlocksFilters({
        j: company,
        qo: topState.o_.DB.pd,
        r$: $author$project$TopMsg$requestMsg,
        DY: session,
        b3: A2($elm$core$Basics$composeR, $author$project$Ui$Scenario$Msg$OnBlocksFiltersUpdate, $author$project$TopMsg$msgScenario)
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop6')]), _List_fromArray([$author$project$Ui$Button$basicButtonMiddle({
        kG: 'flex1',
        vY: 1,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgScenario($author$project$Ui$Scenario$Msg$OnBlocksFiltersUpdate($author$project$Types$Filters$ClearFilters))),
        y$: 'Clear All'
      }), $author$project$ElmFramework$Lib$Util$spacer('w3'), $author$project$Ui$Button$basicButtonMiddle({
        kG: 'flex1',
        vY: 0,
        yh: $elm$core$Maybe$Nothing,
        yM: false,
        f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df),
        y$: 'Apply'
      })]))]),
      z6: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
      t1: 'Filters'
    }));
  });
  var $author$project$Types$EditingScenario$EditingScenario$setBlockIsEnabled = F3(function (editingScenario, isEnabled, blockId) {
    var val = $author$project$Types$EditingScenario$EditingScenario$AddBlock({
      yO: isEnabled
    });
    return _Utils_update(editingScenario, {
      bX: A3($turboMaCk$any_dict$Dict$Any$insert, blockId, val, editingScenario.bX)
    });
  });

  var $author$project$Views$Routed$EditScenarioBranch$editScenarioBranch = function (cfg) {
    var state = cfg.eG.o_.DB;

    var selectedBlocks = function () {
      var addBlockOverrides = function () {
        var toBuildingBlockWithOverride = function (override) {
          return A2($elm$core$Maybe$map, function (block) {
            return _Utils_Tuple2(block, {
              yO: override.yO
            });
          }, A2($author$project$Types$Company$toBuildingBlock, override.dM, cfg.j));
        };

        return A2($elm$core$List$filterMap, toBuildingBlockWithOverride, $author$project$Types$EditingScenario$EditingScenario$toAddBlockOverrides(cfg.eG.o_.DB.p5));
      }();

      var _v2 = cfg.p6;

      if (!_v2.$) {
        var editingScenarioId = _v2.a;
        var maybeBlocksAndRelationships = A2($elm$core$Maybe$map, $elm$core$List$sortBy(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, function ($) {
          return $.zL;
        }, $elm$core$String$toLower))), A4($author$project$Types$Company$toBuildingBlocksAndRelationshipsForScenario, $elm$core$Maybe$Just(A2($author$project$Types$Filters$withQuickEdits, cfg.DY.Fl.F, state.pd)), $elm$core$Maybe$Nothing, editingScenarioId, cfg.j));

        if (!maybeBlocksAndRelationships.$) {
          var blocksAndRelationships = maybeBlocksAndRelationships.a;

          var toBlockWithOverride = function (_v8) {
            var block = _v8.a;
            var relationship = _v8.b;

            var _v6 = A2($turboMaCk$any_dict$Dict$Any$get, block.F, state.p5.bX);

            if (!_v6.$) {
              if (!_v6.a.$) {
                var isEnabled = _v6.a.a.yO;
                return $elm$core$Maybe$Just(_Utils_Tuple2(block, {
                  yO: isEnabled
                }));
              } else {
                var _v7 = _v6.a;
                return $elm$core$Maybe$Nothing;
              }
            } else {
              return $elm$core$Maybe$Just(_Utils_Tuple2(block, {
                yO: relationship.la
              }));
            }
          };

          var fromRelationships = A2($elm$core$List$filterMap, toBlockWithOverride, blocksAndRelationships);

          var fromOverrides = function () {
            var doesNotExistInRelationships = function (_v5) {
              var blockCandidate = _v5.a;
              return A2($elm$core$List$any, function (_v4) {
                var block = _v4.a;
                return _Utils_eq(block.F, blockCandidate.F);
              }, blocksAndRelationships);
            };

            return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, doesNotExistInRelationships), addBlockOverrides);
          }();

          return $elm$core$Maybe$Just(_Utils_ap(fromOverrides, fromRelationships));
        } else {
          return $elm$core$Maybe$Nothing;
        }
      } else {
        return $elm$core$Maybe$Just(addBlockOverrides);
      }
    }();

    var maybeNormalSidebar = function () {
      if (!selectedBlocks.$) {
        if (!selectedBlocks.a.b) {
          return $elm$core$Maybe$Just($author$project$Ui$EditScenarioView$rightSideBarBuildingBlocksEmptyState(cfg.rQ));
        } else {
          var blocks = selectedBlocks.a;
          return $elm$core$Maybe$Just($author$project$Ui$EditScenarioView$rightSideBarCurrentBlocks({
            vk: blocks,
            j: cfg.j,
            qo: state.pd,
            rQ: cfg.rQ,
            rZ: A2($elm$core$Basics$composeL, cfg.r5, $author$project$Types$EditingScenario$EditingScenario$removeBlock(state.p5)),
            r3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenario, $author$project$Ui$Scenario$Msg$OnBlocksFiltersUpdate), $author$project$Types$Filters$UpdateTextSearch),
            BK: F2(function (isEnabled, blockId) {
              return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ScenarioMsg($author$project$Ui$Scenario$Msg$SetEditingScenario(A3($author$project$Types$EditingScenario$EditingScenario$setBlockIsEnabled, state.p5, isEnabled, blockId))));
            }),
            eG: cfg.eG
          }));
        }
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var _v0 = cfg.Er;

    switch (_v0) {
      case 0:
        return _List_fromArray([$author$project$Ui$EditScenarioView$editScenarioView({
          j: cfg.j,
          p6: cfg.p6,
          Aa: cfg.Aa,
          r5: cfg.r5,
          r8: cfg.r8,
          ta: maybeNormalSidebar,
          eG: cfg.eG
        })]);

      case 1:
        return _List_fromArray([$author$project$Ui$EditScenarioView$editScenarioView({
          j: cfg.j,
          p6: cfg.p6,
          Aa: cfg.Aa,
          r5: cfg.r5,
          r8: cfg.r8,
          ta: A3($author$project$Ui$EditScenarioView$rightSideBarFiltersState, cfg.eG, cfg.j, cfg.DY),
          eG: cfg.eG
        })]);

      case 2:
        return _List_fromArray([$author$project$Ui$EditScenarioView$editScenarioView({
          j: cfg.j,
          p6: cfg.p6,
          Aa: cfg.Aa,
          r5: cfg.r5,
          r8: cfg.r8,
          ta: $elm$core$Maybe$Just($author$project$Ui$EditScenarioView$rightSideBarChooseBuildingBlocks({
            j: cfg.j,
            qo: cfg.eG.o_.DB.pd,
            z1: A2($elm$core$Basics$composeL, cfg.r5, $author$project$Types$EditingScenario$EditingScenario$addBlock(state.p5)),
            rZ: A2($elm$core$Basics$composeL, cfg.r5, $author$project$Types$EditingScenario$EditingScenario$removeBlock(state.p5)),
            to: A2($elm$core$Maybe$map, $elm$core$List$map($elm$core$Tuple$first), selectedBlocks),
            DY: cfg.DY,
            eG: cfg.eG
          })),
          eG: cfg.eG
        })]);

      case 3:
        return _List_fromArray([$author$project$Ui$EditScenarioView$editScenarioView({
          j: cfg.j,
          p6: cfg.p6,
          Aa: cfg.Aa,
          r5: cfg.r5,
          r8: cfg.r8,
          ta: maybeNormalSidebar,
          eG: cfg.eG
        })]);

      default:
        return _List_fromArray([$author$project$Ui$EditScenarioView$editScenarioView({
          j: cfg.j,
          p6: cfg.p6,
          Aa: cfg.Aa,
          r5: cfg.r5,
          r8: cfg.r8,
          ta: maybeNormalSidebar,
          eG: cfg.eG
        }), A4($author$project$Ui$OverLaysView$cancelEditingOverlay, cfg.eG.by, state.p5, cfg.r8, cfg.Aa)]);
    }
  };

  var $author$project$Api$Types$UpdateScenarioReq$fromCreateScenarioReq = F2(function (scenarioId, createScenarioReq) {
    return {
      vk: $elm$core$Maybe$Just(createScenarioReq.vk),
      E: $elm$core$Maybe$Just(createScenarioReq.E),
      br: $elm$core$Maybe$Just(createScenarioReq.br),
      la: $elm$core$Maybe$Just(createScenarioReq.la),
      F: scenarioId,
      yC: createScenarioReq.yC,
      rf: $elm$core$Maybe$Just(createScenarioReq.rf),
      zL: $elm$core$Maybe$Just(createScenarioReq.zL),
      sQ: $elm$core$Maybe$Just(createScenarioReq.sQ),
      de: $elm$core$Maybe$Just(createScenarioReq.de),
      df: $elm$core$Maybe$Just(createScenarioReq.df),
      tB: $elm$core$Maybe$Just(createScenarioReq.tB)
    };
  });

  var $author$project$Route$RouteUtil$isCreateScenarioRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 2 && route.b.a.$ === 2) {
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$RouteUtil$isEditScenarioRoute = function (route) {
    if (route.$ === 5 && route.b.$ === 2 && route.b.a.$ === 3) {
      var _v1 = route.b.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$Scenarios$Msg$OnViewChanged = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Views$Routed$ScenariosBranch$topContentElements = F2(function (companyId, topState) {
    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary30')]), _List_fromArray([$elm$html$Html$text('Scenarios & Blocks')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop5 marBottom7')]), _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
      vV: 'w46',
      v_: $elm$core$Maybe$Just(0),
      wm: $author$project$Types$SelectScenariosOrBlocks$fromRoute($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)),
      hH: _List_fromArray([_Utils_Tuple2(0, 'Scenarios'), _Utils_Tuple2(1, 'Blocks')]),
      BE: function (curr) {
        return $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Types$SelectScenariosOrBlocks$toRoute, companyId, curr));
      },
      BP: 'minH6'
    }), $author$project$ElmFramework$Lib$Util$spacer('flex1'), $author$project$Ui$Input$inputWithIcon({
      vV: 'flex1 whiteBack w34',
      yh: $author$project$IconSvg$search,
      e3: 'Search for a Scenario',
      gx: false,
      b3: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenarios, $author$project$Ui$Scenarios$Msg$OnUpdateTextSearch), $author$project$Types$Filters$UpdateTextSearch),
      P: 'text',
      Fw: topState.o_.DC.qo.j_
    }), function () {
      var scenariosRoute = A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios));
      var draftsRoute = A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Drafts));

      var options = _List_fromArray([_Utils_Tuple2('Show: All', scenariosRoute), _Utils_Tuple2('Show: Drafts', draftsRoute)]);

      var selected = A2($elm_community$list_extra$List$Extra$find, function (_v0) {
        var route = _v0.b;
        return _Utils_eq(route, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc));
      }, options);
      return $author$project$Ui$DropdownSelect$dropdownSelect({
        vV: 'marLeft2 w22',
        yI: false,
        e0: options,
        e3: '',
        Ej: A2($author$project$ElmFramework$Lib$Ui$NestedSelect$NestedSelectState$setSelected, selected, topState.o_.DC.um),
        b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgScenarios, $author$project$Ui$Scenarios$Msg$OnViewChanged),
        fd: $elm$core$Basics$eq,
        EU: $elm$core$Tuple$first
      });
    }()]))]));
  });

  var $author$project$Views$Routed$ScenariosBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marTop5 marLeft5 marRight19')]), cfg.pD)]),
        wc: 'scrollTarget',
        s9: cfg.s9,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$ScenariosBranch$scenariosBasic = F4(function (session, company, topState, filters) {
    var addScenarioBtn = $author$project$Ui$Button$button({
      kG: 'absolute bottom8 right11 primary20Back  w6 h6 radius0',
      pD: $author$project$IconSvg$add('primary0Fill w3'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(0)))))
    });
    return $author$project$Views$Routed$ScenariosBranch$viewLayer({
      pD: _List_fromArray([A2($author$project$Views$Routed$ScenariosBranch$topContentElements, company.F, topState), addScenarioBtn, $author$project$Ui$ScenarioRows$scenarioRowsElement({
        vV: 'mar-1',
        j: company,
        qo: filters,
        A3: $elm$core$Maybe$Nothing,
        DY: session,
        eG: topState
      })]),
      s9: $elm$core$Maybe$Nothing,
      DY: session,
      eG: topState
    });
  });
  var $author$project$Types$Filters$withDrafts = F2(function (draft, filters) {
    return _Utils_update(filters, {
      br: $elm$core$Maybe$Just(draft)
    });
  });

  var $author$project$Views$Routed$ScenariosBranch$scenariosBranch = function (cfg) {
    var _v0 = cfg.Er;

    switch (_v0.$) {
      case 0:
        return _List_fromArray([A4($author$project$Views$Routed$ScenariosBranch$scenariosBasic, cfg.DY, cfg.j, cfg.eG, cfg.eG.o_.DC.qo)]);

      case 1:
        return _List_fromArray([A4($author$project$Views$Routed$ScenariosBranch$scenariosBasic, cfg.DY, cfg.j, cfg.eG, A2($author$project$Types$Filters$withDrafts, true, cfg.eG.o_.DC.qo))]);

      case 2:
        var editScenarioRoute = _v0.a;
        return $author$project$Views$Routed$EditScenarioBranch$editScenarioBranch({
          j: cfg.j,
          p6: $elm$core$Maybe$Nothing,
          Aa: A2($author$project$ElmFramework$MsgCmd$msgCmd.Dh, A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)), $author$project$Route$RouteUtil$isCreateScenarioRoute),
          rQ: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$MsgCmd$msgCmd.Dn, $author$project$Route$Route$SelectedCompany(cfg.j.F)), $author$project$Route$CompanyRoute$Scenarios), $author$project$Route$ScenariosRoute$CreateScenario),
          r5: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ScenarioMsg), $author$project$Ui$Scenario$Msg$SetEditingScenario),
          r8: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg), $author$project$Remote$RequestMsg$CreateScenario(cfg.j.F)),
          DY: cfg.DY,
          Er: editScenarioRoute,
          eG: cfg.eG
        });

      default:
        var id = _v0.a;
        var editScenarioRoute = _v0.b;
        return $author$project$Views$Routed$EditScenarioBranch$editScenarioBranch({
          j: cfg.j,
          p6: $elm$core$Maybe$Just(id),
          Aa: A2($author$project$ElmFramework$MsgCmd$msgCmd.Dh, A2($author$project$Route$Route$SelectedCompany, cfg.j.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)), $author$project$Route$RouteUtil$isEditScenarioRoute),
          rQ: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$MsgCmd$msgCmd.Dn, $author$project$Route$Route$SelectedCompany(cfg.j.F)), $author$project$Route$CompanyRoute$Scenarios), $author$project$Route$ScenariosRoute$EditScenario(id)),
          r5: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ScenarioMsg), $author$project$Ui$Scenario$Msg$SetEditingScenario),
          r8: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg), $author$project$Remote$RequestMsg$UpdateScenario(cfg.j.F)), $author$project$Api$Types$UpdateScenarioReq$fromCreateScenarioReq(id)),
          DY: cfg.DY,
          Er: editScenarioRoute,
          eG: cfg.eG
        });
    }
  };

  var $author$project$Ui$EditingCompany$View$CompanyInfo = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$View$Settings = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$Msg$RequestedCountryPredictions = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$EditingCompany$Msg$RequestedPlacePredictions = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$Msg$RequestedTimeZonePredictions = F2(function (a, b) {
    return {
      $: 6,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$EditingCompany$Msg$SelectedAddress = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$EditingCompany$Msg$SelectedCountry = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$Msg$SelectedTimezone = function (a) {
    return {
      $: 5,
      a: a
    };
  };

  var $author$project$ElmFramework$Lib$Timezone$formatTimeParts = function (_v0) {
    var year = _v0.FP;
    var month = _v0.zG;
    var day = _v0.wz;
    var hour = _v0.yc;
    var minute = _v0.zE;
    return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(hour)) + (':' + (A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(minute)) + (', ' + ($elm$core$String$fromInt(year) + ('-' + (A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$monthToNumber(month))) + ('-' + A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(day)))))))));
  };

  var $author$project$Ui$InputComponent$inputSearchDropdownDescription = function (cfg) {
    var showDescription = function () {
      var _v0 = cfg.E;

      if (!_v0.$) {
        var description = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bottom0h gray40 heading5Bold')]), _List_fromArray([$elm$html$Html$text(description)]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([showDescription, $author$project$Ui$InputSearchDropdown$inputSearchDropdown({
      kG: cfg.kG,
      pY: cfg.pY,
      yM: cfg.yM,
      yW: cfg.yW,
      zS: $author$project$ElmFramework$Lib$Util$noOpEl,
      Ac: cfg.Ac,
      Ar: cfg.Ar,
      Aw: $elm$core$Maybe$Just(cfg.Aw),
      e_: cfg.e_,
      BE: cfg.BE,
      e3: cfg.e3,
      C5: cfg.C5,
      C6: cfg.C6,
      C7: cfg.C7,
      ia: cfg.ia,
      Fw: cfg.Fw
    })]));
  };

  var $author$project$Ui$InfoTooltipTrigger$infoTooltipTrigger = function (string) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative circle w2 h2 primary30Back primary0 heading6Bold flexCenter lineH2em')]), _List_fromArray([$elm$html$Html$text('?'), A2($author$project$Ui$Tooltip$tooltip, 1, string)]));
  };

  var $author$project$Ui$EditingCompany$View$infoSign = function (label) {
    return $author$project$Ui$InfoTooltipTrigger$infoTooltipTrigger(label);
  };

  var $author$project$Ui$EditingCompany$View$preferencesCategoryTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop2'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
      vV: cfg.j1,
      y$: cfg.y$
    }), $author$project$Ui$EditingCompany$View$infoSign(cfg.j3)]));
  };

  var $author$project$Types$EditingCompany$setAddressSearch = F2(function (company, val) {
    return _Utils_update(company, {
      jJ: val
    });
  });

  var $author$project$Types$EditingCompany$setAllowInterdivisionTransactions = function (company) {
    return _Utils_update(company, {
      uG: !company.uG
    });
  };

  var $author$project$Types$EditingCompany$setCity = F2(function (company, val) {
    return _Utils_update(company, {
      pu: val
    });
  });
  var $author$project$Types$EditingCompany$setCountrySearchText = F2(function (company, val) {
    return _Utils_update(company, {
      iI: val
    });
  });
  var $author$project$Types$EditingCompany$setDefaultTimeInterval = F2(function (company, val) {
    return _Utils_update(company, {
      wE: val
    });
  });
  var $author$project$Types$EditingCompany$setEndOfWeekConvention = F2(function (company, val) {
    return _Utils_update(company, {
      xy: val
    });
  });
  var $author$project$Types$EditingCompany$setName = F2(function (company, val) {
    return _Utils_update(company, {
      zL: val
    });
  });
  var $author$project$Types$EditingCompany$setNumber = F2(function (company, val) {
    return _Utils_update(company, {
      rE: val
    });
  });
  var $author$project$Types$EditingCompany$setNumberOfEmployees = F2(function (company, val) {
    return _Utils_update(company, {
      zY: val
    });
  });
  var $author$project$Types$EditingCompany$setState = F2(function (company, val) {
    return _Utils_update(company, {
      Ej: val
    });
  });
  var $author$project$Types$EditingCompany$setStreet = F2(function (company, val) {
    return _Utils_update(company, {
      tI: val
    });
  });
  var $author$project$Types$EditingCompany$setTimeZoneSearchText = F2(function (company, val) {
    return _Utils_update(company, {
      j0: val
    });
  });
  var $author$project$Types$EditingCompany$setZipCode = F2(function (company, val) {
    return _Utils_update(company, {
      FS: val
    });
  });
  var $author$project$Ui$SectionBar$showInfo = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary30Back w2 h2 white circle flexRow flexAlignCenter justifyCenter')]), _List_fromArray([$elm$html$Html$text('?')]));

  var $author$project$Types$Country$unwrapCountryCode = function (_v0) {
    var string = _v0;
    return string;
  };

  var $author$project$Api$Types$UpdateCompanyReq$fromEditingCompany = function (editingCompany) {
    var updateCompanyRequest = F2(function (timeZoneId, countryCode) {
      return {
        bW: {
          pu: $elm$core$Maybe$Just(editingCompany.pu),
          pG: $elm$core$Maybe$Just($author$project$Types$Country$unwrapCountryCode(countryCode)),
          pH: $elm$core$Maybe$Just(editingCompany.Ej),
          qD: $elm$core$Maybe$Nothing,
          rE: $elm$core$Maybe$Just(editingCompany.rE),
          sF: $elm$core$Maybe$Just(editingCompany.FS),
          tI: $elm$core$Maybe$Just(editingCompany.tI)
        },
        b_: editingCompany.uG,
        zL: editingCompany.zL,
        b0: editingCompany.b0,
        b1: editingCompany.wE,
        b2: editingCompany.xy,
        aB: function () {
          var _v5 = editingCompany.zY;

          switch (_v5) {
            case 0:
              return 2;

            case 1:
              return 1;

            case 2:
              return 0;

            case 3:
              return 3;

            default:
              return 4;
          }
        }(),
        dm: timeZoneId
      };
    });

    var _v0 = _Utils_Tuple2(editingCompany.DQ, editingCompany.DN);

    if (_v0.a.$ === 1) {
      if (_v0.b.$ === 1) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return $elm$core$Result$Err('Please select timezone and country');
      } else {
        var _v3 = _v0.a;
        return $elm$core$Result$Err('Please select timezone');
      }
    } else {
      if (_v0.b.$ === 1) {
        var _v4 = _v0.b;
        return $elm$core$Result$Err('Please select country');
      } else {
        var selectedTimeZone = _v0.a.a;
        var selectedCountry = _v0.b.a;
        return $elm$core$Result$Ok(A2(updateCompanyRequest, selectedTimeZone.F, selectedCountry.pw));
      }
    }
  };

  var $author$project$Ui$EditingCompany$View$submitMsgForSettings = F2(function (editingCompany, onSaveCompany) {
    var _v0 = $author$project$Api$Types$UpdateCompanyReq$fromEditingCompany(editingCompany);

    if (!_v0.$) {
      var req = _v0.a;
      return onSaveCompany(req);
    } else {
      var err = _v0.a;
      return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
    }
  });

  var $author$project$Ui$EditingCompany$View$view = function (_v0) {
    var topState = _v0.eG;
    var setCompanyMsg = _v0.D_;
    var usedIn = _v0.Fk;
    var sessionStatus = _v0.DZ;

    var toEditingCompanyMsg = function () {
      if (!usedIn.$) {
        return A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSettings, $author$project$Ui$Settings$Msg$EditingCompanyMsg);
      } else {
        return A2($elm$core$Basics$composeL, $author$project$TopMsg$msgOnboardingCompany, $author$project$Ui$OnboardingCompany$Msg$EditingCompanyMsg);
      }
    }();

    var time = topState.EM;

    var editingCompany = function () {
      if (!usedIn.$) {
        return topState.o_.D0.xj;
      } else {
        return topState.o_.Cb.Ca;
      }
    }();

    var numberInput = function (classes) {
      return $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: classes,
        E: $elm$core$Maybe$Just('Number'),
        k_: false,
        qU: 0,
        qW: true,
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setNumber(editingCompany)),
        e3: 'Number',
        gx: false,
        Fw: editingCompany.rE
      });
    };

    var numberOfEmployeesInput = function () {
      var isActive = F2(function (field, input) {
        return _Utils_eq(field, input);
      });
      return _List_fromArray([$author$project$Ui$Button$buttonSelectHigh({
        vV: 'marLeft4h',
        yC: A2(isActive, 0, editingCompany.zY),
        y$: '1-10',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setNumberOfEmployees, editingCompany, 0))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: 'marLeft3',
        yC: A2(isActive, 1, editingCompany.zY),
        y$: '10-25',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setNumberOfEmployees, editingCompany, 1))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: 'marLeft3',
        yC: A2(isActive, 2, editingCompany.zY),
        y$: '25-50',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setNumberOfEmployees, editingCompany, 2))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: 'marLeft3',
        yC: A2(isActive, 3, editingCompany.zY),
        y$: '50-100',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setNumberOfEmployees, editingCompany, 3))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: 'marLeft3',
        yC: A2(isActive, 4, editingCompany.zY),
        y$: '100 +',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setNumberOfEmployees, editingCompany, 4))
      })]);
    }();

    var searchAddressInput = function (classes) {
      return $author$project$Ui$InputComponent$inputSearchDropdownDescription({
        kG: 'z3',
        vV: classes,
        E: $elm$core$Maybe$Just('Search address'),
        pY: '',
        yM: false,
        yW: false,
        Ac: $elm$core$Maybe$Just(setCompanyMsg(A2($author$project$Types$EditingCompany$setAddressSearch, editingCompany, ''))),
        Ar: $elm$core$Maybe$Nothing,
        Aw: A2($elm$core$Basics$composeL, toEditingCompanyMsg, $author$project$Ui$EditingCompany$Msg$RequestedPlacePredictions),
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setAddressSearch(editingCompany)),
        BE: A2($elm$core$Basics$composeL, toEditingCompanyMsg, $author$project$Ui$EditingCompany$Msg$SelectedAddress(sessionStatus)),
        e3: 'Search Address',
        C5: $elm$core$Basics$always($author$project$IconSvg$update('w3 gray20Fill')),
        C6: function ($) {
          return $.sB;
        },
        C7: editingCompany.ke,
        ia: $elm$core$Maybe$Nothing,
        Fw: editingCompany.jJ
      });
    };

    var stateInput = function (classes) {
      return $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: classes,
        E: $elm$core$Maybe$Just('State'),
        k_: false,
        qU: 0,
        qW: true,
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setState(editingCompany)),
        e3: 'State',
        gx: false,
        Fw: editingCompany.Ej
      });
    };

    var streetInput = function (classes) {
      return $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: classes,
        E: $elm$core$Maybe$Just('Street Address'),
        k_: false,
        qU: 0,
        qW: true,
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setStreet(editingCompany)),
        e3: 'Street Address',
        gx: false,
        Fw: editingCompany.tI
      });
    };

    var timezoneInput = $author$project$Ui$InputComponent$inputSearchDropdownDescription({
      kG: 'z3',
      vV: 'marTop3',
      E: $elm$core$Maybe$Just('Time zone'),
      pY: 'Time zones with their current time',
      yM: false,
      yW: false,
      Ac: $elm$core$Maybe$Nothing,
      Ar: $elm$core$Maybe$Nothing,
      Aw: A2($elm$core$Basics$composeL, toEditingCompanyMsg, $author$project$Ui$EditingCompany$Msg$RequestedTimeZonePredictions(sessionStatus)),
      e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setTimeZoneSearchText(editingCompany)),
      BE: A2($elm$core$Basics$composeL, toEditingCompanyMsg, $author$project$Ui$EditingCompany$Msg$SelectedTimezone),
      e3: 'Enter your company time zone',
      C5: $elm$core$Basics$always($author$project$IconSvg$update('w3 gray20Fill')),
      C6: function (timeZone) {
        return A3($elm$core$String$replace, '/', ' / ', A3($elm$core$String$replace, '_', ' ', $author$project$Types$TimeZone$unwrapTimeZoneId(timeZone.F) + (', ' + ($author$project$ElmFramework$Lib$Timezone$formatTimeParts(A2($justinmimbs$time_extra$Time$Extra$posixToParts, $elm$time$Time$utc, time)) + (', UTC ' + (editingCompany.j0 === '' ? timeZone.Ee : timeZone.ws))))));
      },
      C7: editingCompany.ov,
      ia: editingCompany.DQ,
      Fw: editingCompany.j0
    });
    var weekEndingConventionInput = F2(function (containerClasses, buttonClasses) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(containerClasses)]), _List_fromArray([$author$project$Ui$Button$buttonSelectHigh({
        vV: buttonClasses,
        yC: editingCompany.xy === 6,
        y$: 'Sunday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 6))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: buttonClasses,
        yC: !editingCompany.xy,
        y$: 'Monday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 0))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: buttonClasses,
        yC: editingCompany.xy === 1,
        y$: 'Tuesday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 1))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: buttonClasses,
        yC: editingCompany.xy === 2,
        y$: 'Wednesday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 2))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: buttonClasses,
        yC: editingCompany.xy === 3,
        y$: 'Thursday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 3))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: buttonClasses,
        yC: editingCompany.xy === 4,
        y$: 'Friday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 4))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: '',
        yC: editingCompany.xy === 5,
        y$: 'Saturday',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setEndOfWeekConvention, editingCompany, 5))
      })]));
    });

    var zipCodeInput = function (classes) {
      return $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: classes,
        E: $elm$core$Maybe$Just('ZIP Code'),
        k_: false,
        qU: 0,
        qW: true,
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setZipCode(editingCompany)),
        e3: 'ZIP Code',
        gx: false,
        Fw: editingCompany.FS
      });
    };

    var defaultTimeIntervalInput = function (classes) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$Ui$Button$buttonSelectHigh({
        vV: 'marRight3',
        yC: editingCompany.wE === 1,
        y$: 'Weekly',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setDefaultTimeInterval, editingCompany, 1))
      }), $author$project$Ui$Button$buttonSelectHigh({
        vV: '',
        yC: !editingCompany.wE,
        y$: 'Monthly',
        ew: setCompanyMsg(A2($author$project$Types$EditingCompany$setDefaultTimeInterval, editingCompany, 0))
      })]));
    };

    var countryInput = function (classes) {
      return $author$project$Ui$InputComponent$inputSearchDropdownDescription({
        kG: 'z3',
        vV: classes,
        E: $elm$core$Maybe$Just('Country'),
        pY: 'Recently Used',
        yM: false,
        yW: false,
        Ac: $elm$core$Maybe$Nothing,
        Ar: $elm$core$Maybe$Nothing,
        Aw: A2($elm$core$Basics$composeL, toEditingCompanyMsg, $author$project$Ui$EditingCompany$Msg$RequestedCountryPredictions(sessionStatus)),
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setCountrySearchText(editingCompany)),
        BE: A2($elm$core$Basics$composeL, toEditingCompanyMsg, $author$project$Ui$EditingCompany$Msg$SelectedCountry),
        e3: 'Country',
        C5: $elm$core$Basics$always($author$project$IconSvg$update('w3 gray20Fill')),
        C6: function ($) {
          return $.xO;
        },
        C7: editingCompany.kP,
        ia: editingCompany.DN,
        Fw: editingCompany.iI
      });
    };

    var companyNameInput = $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: '',
      E: $elm$core$Maybe$Just('Company Name'),
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setName(editingCompany)),
      e3: 'Company Name',
      gx: false,
      Fw: editingCompany.zL
    });

    var cityInput = function (classes) {
      return $author$project$Ui$InputComponent$inputField({
        fx: $elm$core$Maybe$Nothing,
        vV: classes,
        E: $elm$core$Maybe$Just('City'),
        k_: false,
        qU: 0,
        qW: true,
        e_: A2($elm$core$Basics$composeL, setCompanyMsg, $author$project$Types$EditingCompany$setCity(editingCompany)),
        e3: 'City',
        gx: false,
        Fw: editingCompany.pu
      });
    };

    var allowInterdivisionTransactionsToggle = $author$project$Ui$Switch$switch({
      vV: '',
      hE: editingCompany.uG,
      yW: true,
      tU: setCompanyMsg($author$project$Types$EditingCompany$setAllowInterdivisionTransactions(editingCompany))
    });

    if (!usedIn.$) {
      var settingsView = usedIn.a;

      if (!settingsView.$) {
        var onSaveCompany = settingsView.a;
        return _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'padBottom2',
          y$: 'Company info'
        }), companyNameInput, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter padTop4')]), _Utils_ap(_List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: '',
          y$: 'Number of employees:'
        })]), numberOfEmployeesInput)), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'marTop5 padBottom2',
          y$: 'Street Address'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexItemsPerRow1 padTop3 spaceBetween')]), _List_fromArray([searchAddressInput('')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexItemsPerRow2 padTop3 spaceBetween')]), _List_fromArray([streetInput('padRight3'), numberInput('')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexItemsPerRow2 padTop3 spaceBetween')]), _List_fromArray([countryInput('padRight3'), stateInput('')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexItemsPerRow2 padTop3')]), _List_fromArray([cityInput('padRight3'), zipCodeInput('')])), $author$project$Ui$Button$basicButtonVeryBasic({
          kG: 'minH5 marTop5 minW28',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(A2($author$project$Ui$EditingCompany$View$submitMsgForSettings, editingCompany, onSaveCompany)),
          y$: 'Save Changes'
        })]);
      } else {
        var onSaveCompany = settingsView.a;
        return _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'marBottom5',
          y$: 'Preferences'
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marBottom3')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: '',
          y$: 'Time Zone'
        }), $author$project$ElmFramework$Lib$Util$spacer('minW1'), $author$project$Ui$SectionBar$showInfo])), timezoneInput, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marTop5 marBottom6')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marBottom3')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: '',
          y$: 'Week Ending Convention:'
        }), $author$project$ElmFramework$Lib$Util$spacer('minW1h'), $author$project$Ui$SectionBar$showInfo])), A2(weekEndingConventionInput, '', 'marRight3')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom6 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'marBottom3',
          y$: 'Default Time Interval:'
        }), defaultTimeIntervalInput('')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marLeft18 w hidden')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: 'marBottom3',
          y$: 'Currency:'
        })]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom3 flexAlignCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
          vV: '',
          y$: 'Inter-Division Transactions'
        }), $author$project$ElmFramework$Lib$Util$spacer('minW1h'), $author$project$Ui$SectionBar$showInfo])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([allowInterdivisionTransactionsToggle, $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'primary30 marLeft6',
          y$: 'Allow Inter-division transactions to appear in summaries that involve both divisions of concern.'
        })]))])), $author$project$Ui$Button$basicButtonVeryBasic({
          kG: 'minH5 marTop5 minW28',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(A2($author$project$Ui$EditingCompany$View$submitMsgForSettings, editingCompany, onSaveCompany)),
          y$: 'Save Changes'
        })]);
      }
    } else {
      return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative'), $elm$html$Html$Attributes$class('maxW108 marAuto')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
        pv: 'center',
        vV: '',
        tQ: $elm$core$Maybe$Nothing,
        t1: 'Tell us more about your company'
      }), A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'padBottom2',
        y$: 'Company info'
      }), companyNameInput, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter padTop4')]), _Utils_ap(_List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
        vV: '',
        y$: 'Number of employees:'
      })]), numberOfEmployeesInput))])), A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'padBottom2',
        y$: 'Address'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('spaceBetween justifyCenter')]), _List_fromArray([searchAddressInput('')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padTop3')]), _List_fromArray([streetInput('flex1'), $author$project$ElmFramework$Lib$Util$spacer('w3'), numberInput('flex1'), $author$project$ElmFramework$Lib$Util$spacer('w3'), countryInput('flex1')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padTop3')]), _List_fromArray([stateInput('flex1'), $author$project$ElmFramework$Lib$Util$spacer('w3'), cityInput('flex1'), $author$project$ElmFramework$Lib$Util$spacer('w3'), zipCodeInput('flex1')]))])), A2($author$project$Ui$Sections$plainSection, 'marTop5', _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'padBottom2',
        y$: 'Reporting Preferences'
      }), $author$project$Ui$EditingCompany$View$preferencesCategoryTitle({
        vV: '',
        y$: 'Time Zone',
        j1: 'padRight1',
        j3: 'some tooltip here'
      }), timezoneInput, $author$project$Ui$EditingCompany$View$preferencesCategoryTitle({
        vV: 'marTop5',
        y$: 'Week Ending Convention:',
        j1: 'padRight1h',
        j3: 'some tooltip here'
      }), A2(weekEndingConventionInput, 'flexRow spaceBetween marTop3', ''), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop6')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
        vV: 'marRight19h',
        y$: 'Default Time Interval:'
      }), $author$project$ElmFramework$Lib$Ui$TitleTypes$descriptionTitle({
        vV: 'block hidden',
        y$: 'Currency:'
      })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop3')]), _List_fromArray([defaultTimeIntervalInput('marRight14h')])), $author$project$Ui$EditingCompany$View$preferencesCategoryTitle({
        vV: 'marTop6',
        y$: 'Inter-Division Transactions',
        j1: 'padRight2',
        j3: 'some tooltip here'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop2')]), _List_fromArray([allowInterdivisionTransactionsToggle, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular primary30 padLeft6')]), _List_fromArray([$elm$html$Html$text('Allow inter-division transactions to appear in summaries that involve both divisions of concern.')]))]))]))]))]);
    }
  };

  var $author$project$Route$RouteUtil$isCompanyInfo = function (route) {
    if (route.$ === 5 && route.b.$ === 5 && !route.b.a) {
      var _v1 = route.b.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$RouteUtil$isCompanyUsers = function (route) {
    if (route.$ === 5 && route.b.$ === 5 && route.b.a === 2) {
      var _v1 = route.b.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$RouteUtil$isPreferences = function (route) {
    if (route.$ === 5 && route.b.$ === 5 && route.b.a === 1) {
      var _v1 = route.b.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Route$RouteUtil$isSyncAccount = function (route) {
    if (route.$ === 5 && route.b.$ === 5 && route.b.a === 3) {
      var _v1 = route.b.a;
      return true;
    } else {
      return false;
    }
  };

  var $author$project$Ui$Button$settingsButtonSelect = function (config) {
    var selected = config.lV ? {
      vV: 'primary0 secondary0Back'
    } : {
      vV: 'gray60 primary0Back'
    };
    return $author$project$Ui$Button$button({
      kG: A2($elm$core$String$join, ' ', _List_fromArray(['block fullWidth minH7 radius0 noBorder heading4Bold left padLeft2 padRight2', selected.vV, config.vV])),
      pD: $elm$html$Html$text(config.y$),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(config.ew)
    });
  };

  var $author$project$Ui$MainAppMenu$toCompanyRoute = F2(function (route, companyRoute) {
    if (route.$ === 5) {
      var companyId = route.a;
      return $elm$core$Maybe$Just(A2($author$project$Route$Route$SelectedCompany, companyId, companyRoute));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });

  var $author$project$Ui$SettingsMenu$settingsMenu = function (cfg) {
    var routeTo = function (companyRoute) {
      return $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($elm$core$Maybe$withDefault, $author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$UserProfileRoute), A2($author$project$Ui$MainAppMenu$toCompanyRoute, cfg.bu, companyRoute)));
    };

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('minH14 flexRow flexAlignCenter heading3Bold primary30')]), _List_fromArray([$elm$html$Html$text('Settings')])), $author$project$Ui$Button$settingsButtonSelect({
      vV: '',
      lV: $author$project$Route$RouteUtil$isCompanyInfo(cfg.bu),
      y$: 'Company Info',
      ew: routeTo($author$project$Route$CompanyRoute$Settings(0))
    }), $author$project$Ui$Button$settingsButtonSelect({
      vV: 'marTop5',
      lV: $author$project$Route$RouteUtil$isPreferences(cfg.bu),
      y$: 'Preferences',
      ew: routeTo($author$project$Route$CompanyRoute$Settings(1))
    }), $author$project$Ui$Button$settingsButtonSelect({
      vV: 'marTop5',
      lV: $author$project$Route$RouteUtil$isCompanyUsers(cfg.bu),
      y$: 'Company Users',
      ew: routeTo($author$project$Route$CompanyRoute$Settings(2))
    }), $author$project$Ui$Button$settingsButtonSelect({
      vV: 'marTop5',
      lV: $author$project$Route$RouteUtil$isSyncAccount(cfg.bu),
      y$: 'Divisions',
      ew: routeTo($author$project$Route$CompanyRoute$Settings(3))
    })]));
  };

  var $author$project$Views$Routed$SettingsBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('scrollTarget padLeft5 padRight5')]), _List_fromArray([$author$project$Ui$SettingsMenu$settingsMenu({
          bu: $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(cfg.eG.tc)
        })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget padRight5 padBottom5')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH14'), A2($author$project$Ui$Sections$plainSection, 'maxWidthDesktop', cfg.pD)]))]),
        wc: 'flexRow',
        s9: $elm$core$Maybe$Nothing,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$SettingsBranch$companyInfo = function (_v0) {
    var onSaveCompany = _v0.BB;
    var setCompanyMsg = _v0.D_;
    var topState = _v0.eG;
    var sessionStatus = _v0.DZ;
    var session = _v0.DY;
    var viewConfig = {
      DZ: sessionStatus,
      D_: setCompanyMsg,
      eG: topState,
      Fk: $author$project$Ui$EditingCompany$View$Settings($author$project$Ui$EditingCompany$View$CompanyInfo(onSaveCompany))
    };
    var content = $author$project$Ui$EditingCompany$View$view(viewConfig);
    return $author$project$Views$Routed$SettingsBranch$viewLayer({
      pD: content,
      DY: session,
      eG: topState
    });
  };

  var $author$project$Remote$RequestMsg$InviteUserToCompany = F2(function (a, b) {
    return {
      $: 18,
      a: a,
      b: b
    };
  });
  var $author$project$Types$EditingUsers$setEmail = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      iP: val
    });
  });
  var $author$project$Types$EditingUsers$setLastName = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      hI: val
    });
  });
  var $author$project$Types$EditingUsers$setName = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      zL: val
    });
  });
  var $author$project$Types$EditingUsers$setRole = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      mq: $elm$core$Maybe$Just(val)
    });
  });
  var $author$project$Types$EditingUsers$setSearchRole = F2(function (editingUsers, val) {
    return _Utils_update(editingUsers, {
      nV: val
    });
  });

  var $author$project$Ui$EditingUsers$View$addUsersForm = function (_v0) {
    var topState = _v0.eG;
    var session = _v0.DY;
    var companyId = _v0.b9;
    var setEditingUsers = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUsers, $author$project$Ui$EditingUsers$Msg$SetEditingUsers);
    var row = $elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignEnd marBottom5')]));
    var editingUsers = topState.o_.xn;
    var name = editingUsers.zL;
    var lastName = editingUsers.hI;
    var email = editingUsers.iP;
    var maybeSelectedRole = editingUsers.mq;
    var searchRole = editingUsers.nV;
    var emailInput = $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'marRight1h ',
      E: $elm$core$Maybe$Just('Email'),
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, setEditingUsers, $author$project$Types$EditingUsers$setEmail(editingUsers)),
      e3: 'Enter Email',
      gx: false,
      Fw: email
    });
    var lastNameInput = $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'marRight1h  ',
      E: $elm$core$Maybe$Just('Last Name'),
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, setEditingUsers, $author$project$Types$EditingUsers$setLastName(editingUsers)),
      e3: 'Last Name',
      gx: false,
      Fw: lastName
    });

    var maybeInviteUserReq = function () {
      var requiredStringInputsNotEmpty = editingUsers.zL !== '' && editingUsers.hI !== '' && editingUsers.iP !== '';

      var _v3 = _Utils_Tuple2(maybeSelectedRole, requiredStringInputsNotEmpty);

      if (!_v3.a.$ && _v3.b) {
        var selectedRole = _v3.a.a;
        return $elm$core$Maybe$Just({
          iP: editingUsers.iP,
          hu: editingUsers.zL,
          hI: editingUsers.hI,
          gz: selectedRole
        });
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();

    var submitMsg = function () {
      if (!maybeInviteUserReq.$) {
        var inviteUserRequest = maybeInviteUserReq.a;
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$InviteUserToCompany, companyId, inviteUserRequest));
      } else {
        return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please enter email, name, last name and choose a role', _List_Nil);
      }
    }();

    var inviteUserButton = A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Button$basicButton({
      kG: ' primary0 minW17',
      vY: 0,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(submitMsg),
      y$: 'Invite User'
    })]));
    var nameInput = $author$project$Ui$InputComponent$inputField({
      fx: $elm$core$Maybe$Nothing,
      vV: 'marRight1h  ',
      E: $elm$core$Maybe$Just('First Name'),
      k_: false,
      qU: 0,
      qW: true,
      e_: A2($elm$core$Basics$composeL, setEditingUsers, $author$project$Types$EditingUsers$setName(editingUsers)),
      e3: 'Name',
      gx: false,
      Fw: name
    });
    var selectUserRoleInput = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marRight1h ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$tinyDescriptionTitle({
      vV: 'gray40',
      y$: 'Role'
    }), $author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
      kG: '',
      pY: 'Recently Used',
      yM: false,
      yW: false,
      Ac: $elm$core$Maybe$Nothing,
      Ar: $elm$core$Maybe$Nothing,
      Aw: $elm$core$Maybe$Nothing,
      e_: A2($elm$core$Basics$composeL, setEditingUsers, $author$project$Types$EditingUsers$setSearchRole(editingUsers)),
      BE: A2($elm$core$Basics$composeL, setEditingUsers, $author$project$Types$EditingUsers$setRole(editingUsers)),
      e3: 'Select User Role',
      C5: function (_v1) {
        return $author$project$IconSvg$update('h3 w3 gray20Fill');
      },
      C6: $author$project$Types$Role$toString,
      C7: $elm$core$Maybe$Just($author$project$Types$Role$inviteUserList),
      ia: maybeSelectedRole,
      Fw: searchRole
    })]));
    return _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: 'marBottom2',
      y$: 'Company Users'
    }), row(_List_fromArray([emailInput, nameInput, lastNameInput, selectUserRoleInput, inviteUserButton]))]);
  };

  var $author$project$Types$EditingUsers$CompanyUserExisting = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Types$EditingUsers$CompanyUserInvitation = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$EditingUsers$Msg$EditInvitationClicked = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Ui$EditingUsers$Msg$EditUserClicked = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Global$Model$Remove = function (a) {
    return {
      $: 6,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$RemoveUserFromCompany = F2(function (a, b) {
    return {
      $: 23,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$EditingUsers$Msg$ResendInviteClicked = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$RevokeInvitation = F2(function (a, b) {
    return {
      $: 21,
      a: a,
      b: b
    };
  });

  var $author$project$Ui$UsersTable$UserStatusAccepted = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$UsersTable$UserStatusPendingWithEmail = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$UsersTable$UserStatusPuffinTeamMember = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$Role$isCustomer = function (role) {
    return role === 4 || role === 5 || role === 6;
  };

  var $author$project$Types$Role$isPuffinUser = function (role) {
    return !role || role === 1 || role === 2;
  };

  var $author$project$Types$UserCompany$usersAndRolesInCompany = F3(function (companyId, users, userCompanyList) {
    return A2($elm$core$List$filterMap, function (_v1) {
      var userId = _v1.a;
      var role = _v1.b;

      var _v2 = A2($turboMaCk$any_dict$Dict$Any$get, userId, users);

      if (!_v2.$) {
        var user = _v2.a;
        return $elm$core$Maybe$Just(_Utils_Tuple2(user, role));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, A2($elm$core$List$map, function (_v0) {
      var userId = _v0.oD;
      var role = _v0.gz;
      return _Utils_Tuple2(userId, role);
    }, A2($author$project$ElmFramework$Lib$PivotDict$getById2, companyId, userCompanyList)));
  });

  var $author$project$AssetsSvg$avatars_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 32 32'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$cx('16'), $elm$svg$Svg$Attributes$cy('16'), $elm$svg$Svg$Attributes$r('16'), $elm$svg$Svg$Attributes$fill('#CED5DF')]), _List_Nil), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('mask0'), A2($elm$html$Html$Attributes$attribute, 'mask-type', 'alpha'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('0'), $elm$svg$Svg$Attributes$y('0'), $elm$svg$Svg$Attributes$width('32'), $elm$svg$Svg$Attributes$height('32')]), _List_fromArray([A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$cx('16'), $elm$svg$Svg$Attributes$cy('16'), $elm$svg$Svg$Attributes$r('16'), $elm$svg$Svg$Attributes$fill('#C4C4C4')]), _List_Nil)])), A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$mask('url(#mask0)')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M16.0026 20.6667C18.9481 20.6667 21.3359 18.2789 21.3359 15.3333C21.3359 12.3878 18.9481 10 16.0026 10C13.0571 10 10.6693 12.3878 10.6693 15.3333C10.6693 18.2789 13.0571 20.6667 16.0026 20.6667Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M16.0026 43.3333C21.8936 43.3333 26.6693 38.5577 26.6693 32.6667C26.6693 26.7756 21.8936 22 16.0026 22C10.1116 22 5.33594 26.7756 5.33594 32.6667C5.33594 38.5577 10.1116 43.3333 16.0026 43.3333Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil)]))]));
  };

  var $author$project$AssetsSvg$avatars = function (classes) {
    return $author$project$AssetsSvg$avatars_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$UsersTable$dotsButton = function (onTogglePopupMenu) {
    return $author$project$Ui$Button$button({
      kG: '',
      pD: $author$project$IconSvg$dots('primary30Fill h4'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(onTogglePopupMenu)
    });
  };

  var $author$project$Ui$UsersTable$dotsMenuPopUp = function (cfg) {
    return $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: _List_fromArray([{
        y$: cfg.i7 ? 'Edit Invitation' : 'Edit User',
        ew: cfg.hV,
        tY: 0
      }, {
        y$: cfg.i7 ? 'Revoke Invitation' : 'Remove User',
        ew: cfg.Ax,
        tY: 1
      }]),
      vV: 'right0 z1 ',
      f8: cfg.f8,
      E3: cfg.E3
    });
  };

  var $author$project$Ui$UsersTable$userStatusAccepted = function (cfg) {
    var popoverMenu = $author$project$Ui$UsersTable$dotsMenuPopUp({
      i7: false,
      f8: cfg.yS,
      Ax: cfg.Ax,
      hV: cfg.hV,
      E3: cfg.se
    });
    return A2($elm$html$Html$tr, _List_fromArray([$elm$html$Html$Attributes$class('h8 primary10Back')]), _List_fromArray([A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('center w7 radiusLeft0')]), _List_fromArray([function () {
      var _v0 = cfg.u2;

      if (!_v0.b) {
        return $author$project$AssetsSvg$avatars('h4 gray10Fill');
      } else {
        return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          vz: cfg.vz,
          vV: 'circle',
          yj: cfg.u2,
          FF: 4.5,
          FH: 'inlineBlock relative w4 h4'
        });
      }
    }()])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 padLeft1')]), _List_fromArray([$elm$html$Html$text(cfg.zL)])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 padLeft1h'), $elm$html$Html$Attributes$colspan(3)]), _List_fromArray([$elm$html$Html$text(cfg.iP)])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 right padLeft1h')]), _List_fromArray([$elm$html$Html$text($author$project$Types$Role$toString(cfg.gz))])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('radiusRight0 w8 center')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock relative')]), _List_fromArray([$author$project$Ui$UsersTable$dotsButton(cfg.se), popoverMenu]))]))]));
  };

  var $author$project$Ui$Button$basicButtonShort = function (config) {
    return $author$project$Ui$Button$basicButtonVeryBasic({
      kG: config.kG + ' minH4',
      vY: config.vY,
      yh: config.yh,
      yM: config.yM,
      f9: config.f9,
      y$: config.y$
    });
  };

  var $author$project$Ui$UsersTable$userStatusPendingWithEmail = function (cfg) {
    var clickOnDotsMenu = $author$project$Ui$UsersTable$dotsMenuPopUp({
      i7: true,
      f8: cfg.yS,
      Ax: cfg.Ax,
      hV: cfg.hV,
      E3: cfg.se
    });
    return A2($elm$html$Html$tr, _List_fromArray([$elm$html$Html$Attributes$class('h8 primary10Back')]), _List_fromArray([A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('center radiusLeft0')]), _List_fromArray([$author$project$AssetsSvg$avatars('h4 gray10Fill')])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 padLeft1')]), _List_fromArray([$elm$html$Html$text(cfg.iP)])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('w3h padLeft1h')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle w1 h1 secondary40Back')]), _List_Nil)])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold secondary40')]), _List_fromArray([$elm$html$Html$text('Pending')])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('center')]), _List_fromArray([$author$project$Ui$Button$basicButtonShort({
      kG: 'primary30',
      vY: 1,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.Bv),
      y$: 'Resend Invite'
    })])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 center right padLeft1h')]), _List_fromArray([$elm$html$Html$text($author$project$Types$Role$toString(cfg.gz))])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('radiusRight0 w8 center')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock relative')]), _List_fromArray([$author$project$Ui$UsersTable$dotsButton(cfg.se), clickOnDotsMenu]))]))]));
  };

  var $author$project$Ui$UsersTable$TextDarkBackgroundMedium = 0;

  var $author$project$Ui$UsersTable$userStatusPuffinTeamMember = function (_v0) {
    var name = _v0.zL;
    var role = _v0.gz;
    var avatar = _v0.u2;
    var browser = _v0.vz;
    return A2($elm$html$Html$tr, _List_fromArray([$elm$html$Html$Attributes$class('h8 gray10Back ')]), _List_fromArray([A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('center w7 radiusLeft0')]), _List_fromArray([function () {
      if (!avatar.b) {
        return $author$project$AssetsSvg$avatars('h4 gray10Fill');
      } else {
        return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          vz: browser,
          vV: 'circle',
          yj: avatar,
          FF: 4.5,
          FH: 'inlineBlock relative w4 h4'
        });
      }
    }()])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 padLeft1')]), _List_fromArray([$elm$html$Html$text(name)])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('padLeft1h'), $elm$html$Html$Attributes$colspan(3)]), _List_fromArray([$author$project$Ui$UsersTable$infoTag({
      vV: 'center',
      yh: true,
      y$: 'Puffin User',
      EI: 0
    })])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 right padLeft1h')]), _List_fromArray([$elm$html$Html$text($author$project$Types$Role$toString(role))])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('w8 radiusRight0 center')]), _List_Nil)]));
  };

  var $author$project$Ui$UsersTable$toUserRow = F2(function (browser, status) {
    switch (status.$) {
      case 0:
        var cfg = status.a;
        return $author$project$Ui$UsersTable$userStatusPendingWithEmail({
          iP: cfg.iP,
          yS: cfg.yS,
          Ax: cfg.Ax,
          hV: cfg.hV,
          Bv: cfg.Bv,
          se: cfg.se,
          gz: cfg.gz
        });

      case 1:
        var cfg = status.a;
        return $author$project$Ui$UsersTable$userStatusAccepted({
          u2: cfg.u2,
          vz: browser,
          iP: cfg.iP,
          yS: cfg.yS,
          zL: cfg.zL,
          Ax: cfg.Ax,
          hV: cfg.hV,
          se: cfg.se,
          gz: cfg.gz
        });

      default:
        var name = status.a.zL;
        var role = status.a.gz;
        var avatar = status.a.u2;
        return $author$project$Ui$UsersTable$userStatusPuffinTeamMember({
          u2: avatar,
          vz: browser,
          zL: name,
          gz: role
        });
    }
  });

  var $author$project$Ui$UsersTable$usersTable = function (cfg) {
    return A2($elm$html$Html$table, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth tableRowSpacing'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$tbody, _List_Nil, A2($elm$core$List$map, $author$project$Ui$UsersTable$toUserRow(cfg.vz), cfg.Ft))]));
  };

  var $author$project$Ui$EditingUsers$View$companyUsers = function (_v0) {
    var topState = _v0.eG;
    var session = _v0.DY;
    var company = _v0.j;
    var usersAndRolesInCompany = A3($author$project$Types$UserCompany$usersAndRolesInCompany, company.F, session.Ft, session.ue);

    var title = function (titleText) {
      return $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'marBottom2',
        y$: titleText
      });
    };

    var invitations = A2($elm$core$List$filterMap, function (_v2) {
      var invitationId = _v2.a;
      var invitation = _v2.b;
      var removeMsg = A2($author$project$Remote$RequestMsg$RevokeInvitation, company.F, invitationId);

      var userWithEmail = function (email) {
        return $elm$core$Maybe$Just($author$project$Ui$UsersTable$UserStatusPendingWithEmail({
          iP: email,
          yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$Invitation$unwrapInvitationId(invitationId)),
          Ax: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$Remove({
            pz: $author$project$Types$EditingUsers$CompanyUserInvitation(invitationId),
            sV: removeMsg
          }))),
          hV: $author$project$TopMsg$msgEditingUsers($author$project$Ui$EditingUsers$Msg$EditInvitationClicked({
            b9: company.F,
            iP: email,
            i_: invitation
          })),
          Bv: $author$project$TopMsg$msgEditingUsers($author$project$Ui$EditingUsers$Msg$ResendInviteClicked({
            b9: company.F,
            iP: email,
            i_: invitation
          })),
          se: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$Invitation$unwrapInvitationId(invitationId))),
          gz: invitation.gz
        }));
      };

      return _Utils_eq(invitation.Y, $author$project$Types$Invitation$Pending) ? A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, userWithEmail, invitation.iP)) : $elm$core$Maybe$Nothing;
    }, $turboMaCk$any_dict$Dict$Any$toList(A2($krisajenkins$remotedata$RemoteData$withDefault, $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$Invitation$unwrapInvitationId), company.q_)));
    var existingUsers = A2($elm$core$List$filterMap, function (_v1) {
      var user = _v1.a;
      var role = _v1.b;

      var userName = _Utils_ap(user.hu, A2($elm$core$String$left, 1, user.hI));

      var removeMsg = A2($author$project$Remote$RequestMsg$RemoveUserFromCompany, company.F, user.F);
      var avatarUrlList = A2($elm$core$List$map, function ($) {
        return $.Fh;
      }, user.u2);
      var avatar = A2($elm$core$List$map, function (avatarUrl) {
        return {
          x6: 200,
          Fh: avatarUrl,
          FE: 200
        };
      }, avatarUrlList);
      return $author$project$Types$Role$isCustomer(role) ? $elm$core$Maybe$Just($author$project$Ui$UsersTable$UserStatusAccepted({
        u2: avatar,
        iP: user.iP,
        yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$User$unwrapUserId(user.F)),
        zL: _Utils_ap(user.hu, A2($elm$core$String$left, 1, user.hI)),
        Ax: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$Remove({
          pz: $author$project$Types$EditingUsers$CompanyUserExisting(user.F),
          sV: removeMsg
        }))),
        hV: $author$project$TopMsg$msgEditingUsers($author$project$Ui$EditingUsers$Msg$EditUserClicked({
          b9: company.F,
          yq: role,
          Fl: user
        })),
        se: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$User$unwrapUserId(user.F))),
        gz: role
      })) : $author$project$Types$Role$isPuffinUser(role) ? $elm$core$Maybe$Just($author$project$Ui$UsersTable$UserStatusPuffinTeamMember({
        u2: avatar,
        zL: userName,
        gz: role
      })) : $elm$core$Maybe$Nothing;
    }, usersAndRolesInCompany);
    var usersTable = $author$project$Ui$UsersTable$usersTable({
      vz: topState.vz,
      vV: '',
      Ft: _Utils_ap(invitations, existingUsers)
    });
    return _List_fromArray([title('Company Users'), usersTable]);
  };

  var $author$project$Ui$EditingUsers$View$view = function (_v0) {
    var topState = _v0.eG;
    var company = _v0.j;
    var session = _v0.DY;
    return _Utils_ap($author$project$Ui$EditingUsers$View$addUsersForm({
      b9: company.F,
      DY: session,
      eG: topState
    }), $author$project$Ui$EditingUsers$View$companyUsers({
      j: company,
      DY: session,
      eG: topState
    }));
  };

  var $author$project$Views$Routed$CompanyUsersBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('scrollTarget padLeft5 padRight5')]), _List_fromArray([$author$project$Ui$SettingsMenu$settingsMenu({
          bu: $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(cfg.eG.tc)
        })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget padRight5 padBottom5')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH14'), A2($author$project$Ui$Sections$plainSection, 'maxWidthDesktop', cfg.pD)]))]),
        wc: 'flexRow',
        s9: $elm$core$Maybe$Nothing,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$CompanyUsersBranch$companyUsersBranch = F3(function (session, company, topState) {
    return _List_fromArray([$author$project$Views$Routed$CompanyUsersBranch$viewLayer({
      pD: $author$project$Ui$EditingUsers$View$view({
        j: company,
        DY: session,
        eG: topState
      }),
      DY: session,
      eG: topState
    })]);
  });

  var $author$project$Global$Model$AddDivision = function (a) {
    return {
      $: 15,
      a: a
    };
  };

  var $author$project$Global$Model$DeleteDivision = F2(function (a, b) {
    return {
      $: 11,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Model$EditDivision = F2(function (a, b) {
    return {
      $: 14,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Button$GreenBackgroundColor = 4;

  var $author$project$Ui$Settings$Msg$SetEditingDivision = function (a) {
    return {
      $: 3,
      a: a
    };
  };

  var $author$project$Remote$RequestMsg$SyncDivision = F3(function (a, b, c) {
    return {
      $: 29,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Global$Model$UnLinkDivision = F3(function (a, b, c) {
    return {
      $: 12,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$IconSvg$alert_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox(' 0 0 16 13 ')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M15.2008 12.6L8.00078 0L0.800781 12.6H15.2008ZM8.65538 10.6103H7.34629V9.28396H8.65538V10.6103ZM7.34629 7.95809H8.65538V5.30546H7.34629V7.95809Z'), $elm$svg$Svg$Attributes$fill('#E42526'), $elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd')]), _List_Nil)]));
  };

  var $author$project$IconSvg$alert = function (classes) {
    return $author$project$IconSvg$alert_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$DivisionRow$iconPart = function (icon) {
    return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marRight1 w3 h3 flexRow flexAlignCenter justifyCenter')]), icon);
  };

  var $author$project$IconSvg$qbIcon_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 16 16')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M8.00078 15.2008C11.9772 15.2008 15.2008 11.9772 15.2008 8.00078C15.2008 4.02433 11.9772 0.800781 8.00078 0.800781C4.02433 0.800781 0.800781 4.02433 0.800781 8.00078C0.800781 11.9772 4.02433 15.2008 8.00078 15.2008Z'), $elm$svg$Svg$Attributes$fill('#2CA01C')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M2.80078 8.00077C2.80078 9.54717 4.05438 10.8008 5.60078 10.8008H6.00078V9.76077H5.60078C4.63022 9.76077 3.84078 8.97133 3.84078 8.00077C3.84078 7.03037 4.63022 6.24077 5.60078 6.24077H6.5619V11.6808C6.5619 12.2552 7.0275 12.7208 7.6019 12.7208V5.20077H5.60078C4.05438 5.20077 2.80078 6.45453 2.80078 8.00077ZM10.4024 5.20125H10.0024V6.24125H10.4024C11.3726 6.24125 12.1624 7.03085 12.1624 8.00125C12.1624 8.97165 11.3726 9.76125 10.4024 9.76125H9.44078V4.32125C9.44078 3.74685 8.97518 3.28125 8.40078 3.28125V10.8012H10.4024C11.9486 10.8012 13.2024 9.54765 13.2024 8.00125C13.2024 6.45485 11.9486 5.20125 10.4024 5.20125Z'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd')]), _List_Nil)]));
  };

  var $author$project$IconSvg$qbIcon = function (classes) {
    return $author$project$IconSvg$qbIcon_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$IconSvg$updateDivision_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 16 16')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M15.2008 0.800781V6.40078H9.60078L11.9608 4.04078C10.9448 3.03278 9.54478 2.40078 8.00078 2.40078C4.91278 2.40078 2.40078 4.91278 2.40078 8.00078C2.40078 11.0888 4.91278 13.6008 8.00078 13.6008C11.0888 13.6008 13.6008 11.0888 13.6008 8.00078H15.2008C15.2008 11.9768 11.9768 15.2008 8.00078 15.2008C4.02478 15.2008 0.800781 11.9768 0.800781 8.00078C0.800781 4.02478 4.02478 0.800781 8.00078 0.800781C9.99278 0.800781 11.7928 1.60878 13.0888 2.91278L15.2008 0.800781ZM7.20085 8.80085V4.80085H8.40085V8.12085L11.2168 9.79285L10.6008 10.8168L7.20085 8.80085Z'), $elm$svg$Svg$Attributes$fill('#AEB7C6')]), _List_Nil)]));
  };

  var $author$project$IconSvg$updateDivision = function (classes) {
    return $author$project$IconSvg$updateDivision_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$DivisionRow$divisionRow = function (cfg) {
    var unSyncDivisionButton = function (onUnSyncDivision) {
      return {
        y$: 'Pause Syncing',
        ew: onUnSyncDivision,
        tY: 0
      };
    };

    var unLinkDivisionButton = function (onUnlinkDivision) {
      return {
        y$: 'Unlink Division',
        ew: onUnlinkDivision,
        tY: 0
      };
    };

    var syncDivisionButton = function (onSyncDivision) {
      return {
        y$: 'Resume Syncing',
        ew: onSyncDivision,
        tY: 0
      };
    };

    var statusIcon = function () {
      var _v1 = cfg.pV;

      switch (_v1) {
        case 0:
          return $author$project$ElmFramework$Lib$Util$noOpEl;

        case 1:
          return $author$project$Ui$DivisionRow$iconPart(_List_fromArray([$author$project$IconSvg$alert('w2')]));

        case 2:
          return $author$project$Ui$DivisionRow$iconPart(_List_fromArray([$author$project$IconSvg$updateDivision('w2 ')]));

        default:
          return $author$project$Ui$DivisionRow$iconPart(_List_fromArray([$author$project$IconSvg$qbIcon('w2 ')]));
      }
    }();

    var reAuthorizeDivisionButton = function (onReAuthorizeDivision) {
      return {
        y$: 'Re-Authorize Division',
        ew: onReAuthorizeDivision,
        tY: 0
      };
    };

    var overlayDivisionName = cfg.pV === 3 && cfg.q0 ? A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, $elm$html$Html$text, cfg.so))])) : $author$project$ElmFramework$Lib$Util$noOpEl;

    var linkDivisionButton = function (onLinkDivision) {
      return {
        y$: 'Link Division',
        ew: onLinkDivision,
        tY: 0
      };
    };

    var editInfoButton = $elm$core$Maybe$Just({
      y$: 'Edit Info',
      ew: cfg.AT,
      tY: 0
    });
    var divisionStyle = cfg.pV === 3 ? 'secondary80' : 'primary30';

    var deleteDivisionButton = function (onDeleteDivision) {
      return {
        y$: 'Delete Division',
        ew: onDeleteDivision,
        tY: 1
      };
    };

    var popoverMenuButtons = function () {
      var _v0 = cfg.pV;

      switch (_v0) {
        case 0:
          return _List_fromArray([editInfoButton, A2($elm$core$Maybe$map, linkDivisionButton, cfg.rU), A2($elm$core$Maybe$map, deleteDivisionButton, cfg.rO)]);

        case 1:
          return _List_fromArray([editInfoButton, A2($elm$core$Maybe$map, reAuthorizeDivisionButton, cfg.rY), A2($elm$core$Maybe$map, syncDivisionButton, cfg.r9), A2($elm$core$Maybe$map, unSyncDivisionButton, cfg.sg), A2($elm$core$Maybe$map, unLinkDivisionButton, cfg.sf), A2($elm$core$Maybe$map, deleteDivisionButton, cfg.rO)]);

        case 2:
          return _List_fromArray([editInfoButton]);

        default:
          return _List_fromArray([editInfoButton, A2($elm$core$Maybe$map, syncDivisionButton, cfg.r9), A2($elm$core$Maybe$map, unSyncDivisionButton, cfg.sg), A2($elm$core$Maybe$map, unLinkDivisionButton, cfg.sf), A2($elm$core$Maybe$map, deleteDivisionButton, cfg.rO)]);
      }
    }();

    var popoverMenuPart = $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: $elm_community$maybe_extra$Maybe$Extra$values(popoverMenuButtons),
      vV: 'absolute right0 top4 z1',
      f8: cfg.yS,
      E3: cfg.ew
    });
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter marTop3 padTop2h padBottom2h padRight2 padLeft2 primary10Back radius0 '), $elm$html$Html$Attributes$class(divisionStyle)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn minW24 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([statusIcon, A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ')]), _List_fromArray([$elm$html$Html$text(cfg.k2)]))])), overlayDivisionName])), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
      vV: '',
      y$: cfg.tn
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold  flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight6')]), _List_fromArray([$elm$html$Html$text(cfg.pE + (' Employee' + A3($author$project$ElmFramework$Lib$Util$ifElse, '', 's', cfg.pE === '1')))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.ew), _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$IconSvg$dots('w4 primary30Fill')])), popoverMenuPart]))]))]));
  };

  var $author$project$Ui$EditingDivision$Model$empty = {
    xt: '',
    an: {
      nU: '',
      Fw: $elm$core$Maybe$Nothing
    },
    zL: ''
  };

  var $author$project$AssetsSvg$qb_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 8 20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M11.332 19.9987C11.332 22.576 13.4214 24.6653 15.9987 24.6653H16.6654V22.932H15.9987C14.3811 22.932 13.0654 21.6163 13.0654 19.9987C13.0654 18.3813 14.3811 17.0653 15.9987 17.0653H17.6006V26.132C17.6006 27.0893 18.3766 27.8653 19.3339 27.8653V15.332H15.9987C13.4214 15.332 11.332 17.4216 11.332 19.9987ZM24.0014 15.3328H23.3347V17.0661H24.0014C25.6184 17.0661 26.9347 18.3821 26.9347 19.9995C26.9347 21.6168 25.6184 22.9328 24.0014 22.9328H22.3987V13.8661C22.3987 12.9088 21.6227 12.1328 20.6654 12.1328V24.6661H24.0014C26.5784 24.6661 28.668 22.5768 28.668 19.9995C28.668 17.4221 26.5784 15.3328 24.0014 15.3328Z'), $elm$svg$Svg$Attributes$fill('#2CA01C')]), _List_Nil)]));
  };

  var $author$project$AssetsSvg$qb = function (classes) {
    return $author$project$AssetsSvg$qb_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Views$Routed$SettingsBranch$divisions = F2(function (topState, company) {
    var toDivisionRow = function (division) {
      var unLinkDivision = function (accountingDivisionId) {
        return $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A3($author$project$Global$Model$UnLinkDivision, company.F, accountingDivisionId, $elm$core$Maybe$Nothing)));
      };

      var syncDivision = F2(function (sync, accountingDivisionId) {
        return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$SyncDivision, company.F, accountingDivisionId, sync));
      });
      var maybeAccountingDivisionId = A2($elm$core$Maybe$map, function ($) {
        return $.F;
      }, division.ju);
      var linkDivision = $author$project$TopMsg$msgRemote(A2($author$project$Remote$Msg$OpenQuickBooksAccounting, company.F, $elm$core$Maybe$Just(division.F)));
      var isDivisionSynced = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function ($) {
        return $.EC;
      }, division.ju));
      var isDivisionLinked = !_Utils_eq(division.ju, $elm$core$Maybe$Nothing);
      var hasErrorStatus = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
        return $.y7;
      }, $elm$core$Basics$eq(0)), division.ju));
      return $author$project$Ui$DivisionRow$divisionRow({
        pE: A2($elm$core$Maybe$withDefault, '0', A2($elm$core$Maybe$map, $elm$core$String$fromInt, division.xt)),
        k2: division.zL,
        pV: $author$project$Types$Division$toDivisionStatus(division),
        q0: isDivisionSynced,
        yS: _Utils_eq(topState.o_.qC.nl, $author$project$Types$Division$unwrapDivisionId(division.F)),
        rO: A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!isDivisionLinked), $elm$core$Maybe$Just($author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$DeleteDivision, company.F, division))))),
        AT: $author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$SetEditingDivision($elm$core$Maybe$Just($author$project$Ui$EditingDivision$Model$fromDivision(division)))), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$EditDivision, company.F, division)))])),
        rU: A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(linkDivision), isDivisionLinked),
        rY: A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Just(linkDivision), $elm$core$Maybe$Nothing, hasErrorStatus),
        r9: A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!isDivisionSynced), A2($elm$core$Maybe$map, syncDivision(true), maybeAccountingDivisionId)),
        ew: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu($author$project$Types$Division$unwrapDivisionId(division.F))),
        sf: A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(isDivisionLinked), A2($elm$core$Maybe$map, unLinkDivision, maybeAccountingDivisionId)),
        sg: A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(isDivisionSynced), A2($elm$core$Maybe$map, syncDivision(false), maybeAccountingDivisionId)),
        so: A2($elm$core$Maybe$map, function ($) {
          return $.zL;
        }, division.ju),
        tn: A2($elm$core$Maybe$withDefault, '', division.an)
      });
    };

    var divisionRows = A2($elm$core$List$map, toDivisionRow, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Types$Company$toDivisions(company)));
    return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween marBottom4 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
      vV: '',
      y$: 'Divisions'
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter ')]), _List_fromArray([$author$project$Ui$Button$basicButton({
      kG: ' primary0',
      vY: 4,
      yh: $elm$core$Maybe$Just($author$project$Ui$Button$CommonIcon($author$project$AssetsSvg$qb)),
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgRemote(A2($author$project$Remote$Msg$OpenQuickBooksAccounting, company.F, $elm$core$Maybe$Nothing))),
      y$: 'Add a division with Quickbooks'
    }), $author$project$Ui$Button$basicButton({
      kG: ' primary0 marLeft2',
      vY: 0,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.zJ(_List_fromArray([$author$project$TopMsg$msgSettings($author$project$Ui$Settings$Msg$SetEditingDivision($elm$core$Maybe$Just($author$project$Ui$EditingDivision$Model$empty))), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$AddDivision(company.F)))]))),
      y$: 'Add a Division Manually'
    })]))])), !_Utils_eq(divisionRows, _List_Nil) ? A2($elm$html$Html$div, _List_Nil, divisionRows) : !$krisajenkins$remotedata$RemoteData$isSuccess(company.eO) ? $author$project$ElmFramework$Lib$Util$noOpEl : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter relative marTop4')]), _List_fromArray([A3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg, 'w30 h30', 'maxW30', $author$project$AssetsImg$assets.yl), $author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
      pv: '',
      vV: 'marLeft10',
      tQ: $elm$core$Maybe$Nothing,
      t1: 'It looks like you haven\'t added any divisions yet.'
    })]))]);
  });

  var $author$project$Ui$EditingCompany$View$Preferences = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Views$Routed$SettingsBranch$preferencesView = function (_v0) {
    var onSaveCompany = _v0.BB;
    var setCompanyMsg = _v0.D_;
    var topState = _v0.eG;
    var session = _v0.DY;
    var sessionStatus = _v0.DZ;
    var viewConfig = {
      DZ: sessionStatus,
      D_: setCompanyMsg,
      eG: topState,
      Fk: $author$project$Ui$EditingCompany$View$Settings($author$project$Ui$EditingCompany$View$Preferences(onSaveCompany))
    };
    var content = $author$project$Ui$EditingCompany$View$view(viewConfig);
    return $author$project$Views$Routed$SettingsBranch$viewLayer({
      pD: content,
      DY: session,
      eG: topState
    });
  };

  var $author$project$Views$Routed$SettingsBranch$thePreferencesOverlays = function () {
    var _v0 = '';

    if (_v0 === 'specialOverlay') {
      return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
        Fz: $author$project$UiWrappers$DialogModal$dialogModal({
          ar: 'Accept',
          as: 'Cancel',
          pD: _List_fromArray([$elm$html$Html$text('bro')]),
          av: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          aw: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
          Aj: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          t1: 'some title'
        })
      })]);
    } else {
      return _List_Nil;
    }
  }();

  var $author$project$Views$Routed$SettingsBranch$settingsBranch = function (_v0) {
    var onSaveCompany = _v0.BB;
    var setCompanyMsg = _v0.D_;
    var settingsRoute = _v0.D$;
    var sessionStatus = _v0.DZ;
    var session = _v0.DY;
    var topState = _v0.eG;
    var company = _v0.j;

    switch (settingsRoute) {
      case 0:
        return _List_fromArray([$author$project$Views$Routed$SettingsBranch$companyInfo({
          BB: onSaveCompany,
          DY: session,
          DZ: sessionStatus,
          D_: setCompanyMsg,
          eG: topState
        })]);

      case 1:
        return $elm$core$List$concat(_List_fromArray([_List_fromArray([$author$project$Views$Routed$SettingsBranch$preferencesView({
          BB: onSaveCompany,
          DY: session,
          DZ: sessionStatus,
          D_: setCompanyMsg,
          eG: topState
        })]), $author$project$Views$Routed$SettingsBranch$thePreferencesOverlays]));

      case 2:
        return A3($author$project$Views$Routed$CompanyUsersBranch$companyUsersBranch, session, company, topState);

      default:
        return _List_fromArray([$author$project$Views$Routed$SettingsBranch$viewLayer({
          pD: A2($author$project$Views$Routed$SettingsBranch$divisions, topState, company),
          DY: session,
          eG: topState
        })]);
    }
  };

  var $author$project$Views$Routed$CompanyBranch$companyBranch = function (cfg) {
    var _v0 = cfg.kx;

    switch (_v0.$) {
      case 0:
        var cashboardQuery = _v0.a;
        var cashboardRoute = _v0.b;
        return $author$project$Views$Routed$CashboardBranch$cashboardBranch({
          j: cfg.j,
          sR: cashboardQuery,
          tc: cashboardRoute,
          DY: cfg.DY,
          Ej: cfg.eG.o_.vO,
          eG: cfg.eG
        });

      case 1:
        var budgetQuery = _v0.a;
        var budgetRoute = _v0.b;
        return $author$project$Views$Routed$BudgetBranch$budgetBranch({
          j: cfg.j,
          sR: budgetQuery,
          tc: budgetRoute,
          DY: cfg.DY,
          Ej: cfg.eG.o_.vC,
          eG: cfg.eG
        });

      case 2:
        var scenariosRoute = _v0.a;
        return $author$project$Views$Routed$ScenariosBranch$scenariosBranch({
          j: cfg.j,
          DY: cfg.DY,
          Er: scenariosRoute,
          eG: cfg.eG
        });

      case 4:
        var financialAccountsRoute = _v0.a;
        return A4($author$project$Views$Routed$FinancialAccountsBranch$financialAccountsBranch, financialAccountsRoute, cfg.j, cfg.eG, cfg.DY);

      case 5:
        var settingsRoute = _v0.a;
        return $author$project$Views$Routed$SettingsBranch$settingsBranch({
          j: cfg.j,
          BB: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg), $author$project$Remote$RequestMsg$UpdateCompany(cfg.j.F)),
          DY: cfg.DY,
          DZ: cfg.DZ,
          D_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$SettingsMsg), $author$project$Ui$Settings$Msg$EditingCompanyMsg), $author$project$Ui$EditingCompany$Msg$SetEditingCompany),
          D$: settingsRoute,
          eG: cfg.eG
        });

      default:
        var blocksRoute = _v0.a;
        return $author$project$Views$Routed$BlocksBranch$blocksBranch({
          kx: blocksRoute,
          j: cfg.j,
          mS: A2($elm$core$Basics$composeL, cfg.mS, $author$project$Route$CompanyRoute$Blocks),
          DY: cfg.DY,
          eG: cfg.eG
        });
    }
  };

  var $author$project$Route$LegalRoute$LegalRouteCookies = 2;
  var $author$project$Ui$SlideSelectMultiple$PrimaryLightSelectGrayBack = 2;

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$bigTitle = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.pv), $elm$html$Html$Attributes$class('heading1Bold48 primary30')]), _List_fromArray([$elm$html$Html$text(config.t1)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop2 gray60 heading3Regular')]), _List_fromArray([$elm$html$Html$text(config.tQ)]))]));
  };

  var $author$project$UiWrappers$TermsAndConditions$termsAndConditions = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread betweenPhoneDesktopWidth marTop10')]), _List_fromArray([cfg.pD]));
  };

  var $author$project$Views$Routed$LegalBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$TermsAndConditions$termsAndConditions({
        pD: A2($elm$html$Html$div, _List_Nil, cfg.pD)
      })
    });
  };

  var $author$project$Views$Routed$LegalBranch$cookiesView = F2(function (topState, currItem) {
    return $author$project$Views$Routed$LegalBranch$viewLayer({
      pD: _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
        vV: '',
        v_: $elm$core$Maybe$Just(2),
        wm: currItem,
        hH: _List_fromArray([_Utils_Tuple2(0, 'Terms & Conditions'), _Utils_Tuple2(1, 'Privacy policy'), _Utils_Tuple2(2, 'Cookies')]),
        BE: function (routeSelected) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(routeSelected));
        },
        BP: ''
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop7')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$bigTitle({
        pv: '',
        vV: 'center',
        tQ: 'Updated on 20 Jan 2020',
        t1: 'Cookies'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW90 flexColumn')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'padTop7',
        y$: 'Definitions'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray60 padTop2')]), _List_fromArray([$elm$html$Html$text('Description goes here...')]))]))]))]),
      eG: topState
    });
  });
  var $author$project$Views$Routed$LegalBranch$privacyPolicyView = F2(function (topState, currItem) {
    return $author$project$Views$Routed$LegalBranch$viewLayer({
      pD: _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
        vV: '',
        v_: $elm$core$Maybe$Just(2),
        wm: currItem,
        hH: _List_fromArray([_Utils_Tuple2(0, 'Terms & Conditions'), _Utils_Tuple2(1, 'Privacy policy'), _Utils_Tuple2(2, 'Cookies')]),
        BE: function (routeSelected) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(routeSelected));
        },
        BP: ''
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop7')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$bigTitle({
        pv: '',
        vV: 'center',
        tQ: 'Updated on 20 Jan 2020',
        t1: 'Privacy policy'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW90 flexColumn')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'padTop7',
        y$: 'Definitions'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray60 padTop2')]), _List_fromArray([$elm$html$Html$text('Description goes here...')]))]))]))]),
      eG: topState
    });
  });
  var $author$project$Views$Routed$LegalBranch$termsOfUseView = F2(function (topState, currItem) {
    return $author$project$Views$Routed$LegalBranch$viewLayer({
      pD: _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
        vV: '',
        v_: $elm$core$Maybe$Just(2),
        wm: currItem,
        hH: _List_fromArray([_Utils_Tuple2(0, 'Terms & Conditions'), _Utils_Tuple2(1, 'Privacy policy'), _Utils_Tuple2(2, 'Cookies')]),
        BE: function (routeSelected) {
          return $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(routeSelected));
        },
        BP: ''
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop7')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$bigTitle({
        pv: '',
        vV: 'center',
        tQ: 'Updated on 20 Jan 2020',
        t1: 'Terms & Conditions'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW90 flexColumn')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
        vV: 'padTop7',
        y$: 'Definitions'
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray60 padTop2')]), _List_fromArray([$elm$html$Html$text('Description goes here...')]))]))]))]),
      eG: topState
    });
  });
  var $author$project$Views$Routed$LegalBranch$legalBranch = F3(function (branch, topState, currItem) {
    switch (branch) {
      case 0:
        return _List_fromArray([A2($author$project$Views$Routed$LegalBranch$termsOfUseView, topState, 0)]);

      case 1:
        return _List_fromArray([A2($author$project$Views$Routed$LegalBranch$privacyPolicyView, topState, 1)]);

      default:
        return _List_fromArray([A2($author$project$Views$Routed$LegalBranch$cookiesView, topState, 2)]);
    }
  });

  var $author$project$Ui$OnboardingProgressBar$progressBar = function (config) {
    var circleBar = function (cfg) {
      var circle = function (color) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle w2 h2 borderSolid borderWidth0h primary0Border z1'), $elm$html$Html$Attributes$class(color)]), _List_Nil);
      };

      var bar = function (atr) {
        var showCompleteStep = function () {
          var _v1 = atr.iE;

          if (!_v1.$) {
            var completeStepClass = _v1.a;
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread secondary0Back h0h maxRadiusRight'), $elm$html$Html$Attributes$class(completeStepClass)]), _List_Nil);
          } else {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          }
        }();

        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('h0h marLeft-0h marRight-0h flex1 gray10Back relative')]), _List_fromArray([showCompleteStep]));
      };

      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW97 padLeft10 padRight10')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter padBottom1')]), _List_fromArray([circle(cfg.fJ), bar({
        iE: cfg.gH
      }), circle(cfg.fL), bar({
        iE: cfg.gJ
      }), circle(cfg.fK), bar({
        iE: cfg.gI
      }), circle(cfg.fI)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween heading5Bold marLeft-4 marRight-5h')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.gb)]), _List_fromArray([$elm$html$Html$text('Company Info')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft2'), $elm$html$Html$Attributes$class(cfg.gd)]), _List_fromArray([$elm$html$Html$text('Users')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft5'), $elm$html$Html$Attributes$class(cfg.gc)]), _List_fromArray([$elm$html$Html$text('Division')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.ga)]), _List_fromArray([$elm$html$Html$text('Create Scenario')]))]))]));
    };

    var completeStepProgress = function () {
      var _v0 = config.wn;

      switch (_v0) {
        case 1:
          return circleBar({
            fI: 'gray10Back',
            fJ: 'secondary0Back',
            fK: 'gray10Back',
            fL: 'gray10Back',
            ga: 'gray40',
            gb: 'primary30',
            gc: 'gray40',
            gd: 'gray40',
            gH: $elm$core$Maybe$Just('takeHalf'),
            gI: $elm$core$Maybe$Nothing,
            gJ: $elm$core$Maybe$Nothing
          });

        case 2:
          return circleBar({
            fI: 'gray10Back',
            fJ: 'secondary0Back',
            fK: 'gray10Back',
            fL: 'secondary0Back',
            ga: 'gray40',
            gb: 'primary30',
            gc: 'gray40',
            gd: 'primary30',
            gH: $elm$core$Maybe$Just('fullWidth'),
            gI: $elm$core$Maybe$Nothing,
            gJ: $elm$core$Maybe$Just('takeHalf')
          });

        case 3:
          return circleBar({
            fI: 'gray10Back',
            fJ: 'secondary0Back',
            fK: 'secondary0Back',
            fL: 'secondary0Back',
            ga: 'gray40',
            gb: 'primary30',
            gc: 'primary30',
            gd: 'primary30',
            gH: $elm$core$Maybe$Just('fullWidth'),
            gI: $elm$core$Maybe$Just('takeHalf'),
            gJ: $elm$core$Maybe$Just('fullWidth')
          });

        case 4:
          return circleBar({
            fI: 'secondary0Back',
            fJ: 'secondary0Back',
            fK: 'secondary0Back',
            fL: 'secondary0Back',
            ga: 'primary30',
            gb: 'primary30',
            gc: 'primary30',
            gd: 'primary30',
            gH: $elm$core$Maybe$Just('fullWidth'),
            gI: $elm$core$Maybe$Just('fullWidth'),
            gJ: $elm$core$Maybe$Just('fullWidth')
          });

        default:
          return circleBar({
            fI: 'gray10Back',
            fJ: 'gray10Back',
            fK: 'gray10Back',
            fL: 'gray10Back',
            ga: 'gray40',
            gb: 'gray40',
            gc: 'gray40',
            gd: 'gray40',
            gH: $elm$core$Maybe$Nothing,
            gI: $elm$core$Maybe$Nothing,
            gJ: $elm$core$Maybe$Nothing
          });
      }
    }();

    return completeStepProgress;
  };

  var $author$project$Views$Routed$OnboardingCompanyBranch$actionBarComponents = function (cfg) {
    var showBackButton = function () {
      var _v0 = cfg.g2;

      if (!_v0.$) {
        var backButton = _v0.a;
        return $author$project$Ui$Button$basicButton({
          kG: 'primary0 w15',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: backButton,
          y$: 'Back'
        });
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w15')]), _List_Nil);
      }
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter fullWidth')]), _List_fromArray([showBackButton, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_fromArray([$author$project$Ui$OnboardingProgressBar$progressBar({
      wn: cfg.wn
    })])), $author$project$Ui$Button$basicButton({
      kG: 'primary0 w15',
      vY: 0,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: cfg.hR,
      y$: 'Next'
    })]));
  };

  var $author$project$Remote$RequestMsg$OnboardCompanyWithUser = function (a) {
    return {
      $: 9,
      a: a
    };
  };

  var $author$project$Ui$EditingCompany$View$OnboardingCompany = {
    $: 1
  };
  var $author$project$Remote$RequestMsg$UpdateCompanyInOnboarding = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Api$Types$OnboardCompanyAndUserReq$fromEditingCompany = F2(function (user, editingCompany) {
    var transformUser = function (_v6) {
      var firstName = _v6.hu;
      var lastName = _v6.hI;
      var email = _v6.iP;
      return {
        iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(email),
        hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(firstName),
        hI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(lastName),
        ng: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
        nh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
      };
    };

    var onboardCompanyForExistingUserReq = F2(function (timeZone, countryCode) {
      return {
        bW: {
          pu: $elm$core$Maybe$Just(editingCompany.pu),
          pG: $elm$core$Maybe$Just($author$project$Types$Country$unwrapCountryCode(countryCode)),
          pH: $elm$core$Maybe$Just(editingCompany.Ej),
          qD: $elm$core$Maybe$Nothing,
          rE: $elm$core$Maybe$Just(editingCompany.rE),
          sF: $elm$core$Maybe$Just(editingCompany.FS),
          tI: $elm$core$Maybe$Just(editingCompany.tI)
        },
        b_: editingCompany.uG,
        zL: editingCompany.zL,
        b0: editingCompany.b0,
        b1: editingCompany.wE,
        b2: editingCompany.xy,
        aB: function () {
          var _v5 = editingCompany.zY;

          switch (_v5) {
            case 0:
              return 2;

            case 1:
              return 1;

            case 2:
              return 0;

            case 3:
              return 3;

            default:
              return 4;
          }
        }(),
        dm: timeZone,
        Fl: transformUser(user)
      };
    });

    var _v0 = _Utils_Tuple2(editingCompany.DQ, editingCompany.DN);

    if (_v0.a.$ === 1) {
      if (_v0.b.$ === 1) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return $elm$core$Result$Err('Please fill in the missing fields');
      } else {
        var _v3 = _v0.a;
        return $elm$core$Result$Err('Please select timezone');
      }
    } else {
      if (_v0.b.$ === 1) {
        var _v4 = _v0.b;
        return $elm$core$Result$Err('Please select country');
      } else {
        var selectedTimeZone = _v0.a.a;
        var selectedCountry = _v0.b.a;
        return $elm$core$Result$Ok(A2(onboardCompanyForExistingUserReq, selectedTimeZone, selectedCountry.pw));
      }
    }
  });
  var $author$project$Api$Types$OnboardCompanyForExistingUserReq$fromEditingCompany = F2(function (userId, editingCompany) {
    var onboardCompanyForExistingUserReq = F2(function (timeZone, countryCode) {
      return {
        bW: {
          pu: $elm$core$Maybe$Just(editingCompany.pu),
          pG: $elm$core$Maybe$Just($author$project$Types$Country$unwrapCountryCode(countryCode)),
          pH: $elm$core$Maybe$Just(editingCompany.Ej),
          qD: $elm$core$Maybe$Nothing,
          rE: $elm$core$Maybe$Just(editingCompany.rE),
          sF: $elm$core$Maybe$Just(editingCompany.FS),
          tI: $elm$core$Maybe$Just(editingCompany.tI)
        },
        b_: editingCompany.uG,
        zL: editingCompany.zL,
        b0: editingCompany.b0,
        b1: editingCompany.wE,
        b2: editingCompany.xy,
        aB: function () {
          var _v5 = editingCompany.zY;

          switch (_v5) {
            case 0:
              return 2;

            case 1:
              return 1;

            case 2:
              return 0;

            case 3:
              return 3;

            default:
              return 4;
          }
        }(),
        dm: timeZone,
        oD: userId
      };
    });

    var _v0 = _Utils_Tuple2(editingCompany.DQ, editingCompany.DN);

    if (_v0.a.$ === 1) {
      if (_v0.b.$ === 1) {
        var _v1 = _v0.a;
        var _v2 = _v0.b;
        return $elm$core$Result$Err('Please fill in the missing fields');
      } else {
        var _v3 = _v0.a;
        return $elm$core$Result$Err('Please select timezone');
      }
    } else {
      if (_v0.b.$ === 1) {
        var _v4 = _v0.b;
        return $elm$core$Result$Err('Please select country');
      } else {
        var selectedTimeZone = _v0.a.a;
        var selectedCountry = _v0.b.a;
        return $elm$core$Result$Ok(A2(onboardCompanyForExistingUserReq, selectedTimeZone, selectedCountry.pw));
      }
    }
  });

  var $author$project$Views$Routed$OnboardingCompanyBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$WithTopActionBar$withTopActionBar({
        oR: cfg.gX,
        oW: false,
        g9: cfg.pD,
        ta: $elm$core$Maybe$Nothing
      })
    });
  };

  var $author$project$Views$Routed$OnboardingCompanyBranch$companyInfoView = F2(function (sessionStatus, topModel) {
    var viewConfig = {
      DZ: sessionStatus,
      D_: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Msg$sendOnboardingCompanyMsg, $author$project$Ui$OnboardingCompany$Msg$EditingCompanyMsg), $author$project$Ui$EditingCompany$Msg$SetEditingCompany),
      eG: topModel,
      Fk: $author$project$Ui$EditingCompany$View$OnboardingCompany
    };
    var onboardingCompany = topModel.o_.Cb.Ca;

    var onboardToUpdateRequest = function (request) {
      return {
        bW: request.bW,
        b_: request.b_,
        zL: request.zL,
        b0: request.b0,
        b1: request.b1,
        b2: request.b2,
        aB: request.aB,
        dm: request.dm.F
      };
    };

    var submitMsg = function () {
      switch (sessionStatus.$) {
        case 2:
          var authUser = sessionStatus.a;
          var request = A2($author$project$Api$Types$OnboardCompanyAndUserReq$fromEditingCompany, authUser.Fl, onboardingCompany);

          if (!request.$) {
            var req = request.a;
            return $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$OnboardCompanyWithUser(req));
          } else {
            var err = request.a;
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
          }

        case 3:
          var session = sessionStatus.a;
          var request = A2($author$project$Api$Types$OnboardCompanyForExistingUserReq$fromEditingCompany, session.Fl.F, onboardingCompany);

          var _v2 = _Utils_Tuple2(request, $author$project$Views$Routed$OnboardingCompanyBranch$toLatestCompany(sessionStatus));

          if (!_v2.a.$) {
            if (!_v2.b.$) {
              var req = _v2.a.a;
              var company = _v2.b.a;
              return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateCompanyInOnboarding, company.F, onboardToUpdateRequest(req)));
            } else {
              return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Fail to fetch company for user', _List_Nil);
            }
          } else {
            var err = _v2.a.a;
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, err, _List_Nil);
          }

        default:
          return A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Can\'t access user ID', _List_Nil);
      }
    }();

    var content = $author$project$Ui$EditingCompany$View$view(viewConfig);
    return _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$viewLayer({
      gX: _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$actionBarComponents({
        g2: $elm$core$Maybe$Nothing,
        wn: 1,
        hR: $author$project$ElmFramework$Lib$Ui$Button$Button(submitMsg)
      })]),
      pD: content
    })]);
  });

  var $author$project$Views$Routed$OnboardingCompanyBranch$titledSections = function (cfg) {
    var topElements = _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
      pv: 'center',
      vV: '',
      tQ: $elm$core$Maybe$Nothing,
      t1: cfg.t1
    })]);

    var toSectionFromCfg = function (content) {
      return A2($author$project$Ui$Sections$plainSection, 'marTop5', content);
    };

    var sections = A2($elm$core$List$map, toSectionFromCfg, cfg.jK);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative'), $elm$html$Html$Attributes$class(cfg.vV)]), _Utils_ap(topElements, sections));
  };

  var $author$project$Views$Routed$OnboardingCompanyBranch$createScenarioView = F2(function (sessionStatus, _v0) {
    return _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$viewLayer({
      gX: _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$actionBarComponents({
        g2: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df)),
        wn: 4,
        hR: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$RouteToOnboardedHome(sessionStatus)))
      })]),
      pD: _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$titledSections({
        vV: 'maxW118 marAuto',
        jK: _List_fromArray([_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src($author$project$AssetsImg$assets.yl), A2($elm$html$Html$Attributes$style, 'max-width', '30%'), A2($elm$html$Html$Attributes$style, 'max-height', '30%')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft10 maxW54')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
          pv: '',
          vV: '',
          tQ: $elm$core$Maybe$Nothing,
          t1: 'Get started by creating your first scenario.'
        }), $author$project$Ui$Button$basicButton({
          kG: 'w34 primary0 marTop4',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, 'company-id', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))),
          y$: '+ Create a New Scenario'
        })]))]))])]),
        oh: $elm$core$Maybe$Nothing,
        t1: 'Create your first scenario'
      })])
    })]);
  });
  var $author$project$Views$Routed$OnboardingCompanyBranch$divisionView = F2(function (sessionStatus, topModel) {
    return _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$viewLayer({
      gX: _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$actionBarComponents({
        g2: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df)),
        wn: 3,
        hR: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$RouteToOnboardedHome(sessionStatus)))
      })]),
      pD: _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$titledSections({
        vV: 'maxW118 marAuto',
        jK: function () {
          var _v0 = $author$project$Views$Routed$OnboardingCompanyBranch$toLatestCompany(sessionStatus);

          if (_v0.$ === 1) {
            return _List_fromArray([_List_fromArray([$author$project$ElmFramework$Lib$Util$noOpEl])]);
          } else {
            var company = _v0.a;
            return _List_fromArray([A2($author$project$Views$Routed$SettingsBranch$divisions, topModel, company)]);
          }
        }(),
        oh: function () {
          var _v1 = $author$project$Views$Routed$OnboardingCompanyBranch$toLatestCompany(sessionStatus);

          if (_v1.$ === 1) {
            return $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(3)));
          } else {
            var company = _v1.a;
            return $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, company.F, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios))));
          }
        }(),
        t1: 'Division'
      })])
    })]);
  });

  var $author$project$Views$Routed$OnboardingCompanyBranch$onboardingCompanyBranch = function (_v0) {
    var sessionStatus = _v0.DZ;
    var route = _v0.tc;
    var topState = _v0.eG;

    switch (route) {
      case 0:
        return A2($author$project$Views$Routed$OnboardingCompanyBranch$companyInfoView, sessionStatus, topState);

      case 1:
        return _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$viewLayer({
          gX: _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$actionBarComponents({
            g2: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Df)),
            wn: 2,
            hR: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Msg$sendOnboardingCompanyMsg($author$project$Ui$OnboardingCompany$Msg$ClickedNext(1)))
          })]),
          pD: function () {
            var _v2 = $author$project$Views$Routed$OnboardingCompanyBranch$toLatestCompany(sessionStatus);

            if (!_v2.$) {
              var company = _v2.a;

              var sections = function () {
                if (sessionStatus.$ === 3) {
                  var session = sessionStatus.a;
                  return _List_fromArray([$author$project$Ui$EditingUsers$View$view({
                    j: company,
                    DY: session,
                    eG: topState
                  })]);
                } else {
                  return _List_fromArray([_List_fromArray([$elm$html$Html$text('Invalid state')])]);
                }
              }();

              return _List_fromArray([$author$project$Views$Routed$OnboardingCompanyBranch$titledSections({
                vV: 'desktopWidthCenter',
                jK: sections,
                oh: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(2))),
                t1: 'Add users to your account'
              })]);
            } else {
              return _List_Nil;
            }
          }()
        })]);

      case 2:
        return A2($author$project$Views$Routed$OnboardingCompanyBranch$divisionView, sessionStatus, topState);

      default:
        return A2($author$project$Views$Routed$OnboardingCompanyBranch$createScenarioView, sessionStatus, topState);
    }
  };

  var $author$project$Views$Routed$RouteWithDataView$routeWithDataView = function (cfg) {
    return _List_Nil;
  };

  var $author$project$Views$Routed$RouteWithQueryView$routeWithQueryView = function (cfg) {
    return _List_Nil;
  };

  var $author$project$Views$Routed$SubRoute1Variant1View$subRoute1Variant1View = function (cfg) {
    return _List_Nil;
  };

  var $author$project$Views$Routed$SubRoute1Variant2View$subRoute1Variant2View = function (cfg) {
    return _List_Nil;
  };

  var $author$project$Views$Routed$SubRoute1Branch$subRoute1Branch = function (cfg) {
    var _v0 = cfg.Es;

    if (!_v0.$) {
      return $author$project$Views$Routed$SubRoute1Variant1View$subRoute1Variant1View({
        jT: cfg.jT,
        Ej: cfg.Ej
      });
    } else {
      return $author$project$Views$Routed$SubRoute1Variant2View$subRoute1Variant2View({
        jT: cfg.jT,
        Ej: cfg.Ej
      });
    }
  };

  var $author$project$Views$Routed$SubRoute2Variant1View$subRoute2Variant1View = function (cfg) {
    return _List_Nil;
  };

  var $author$project$Views$Routed$RouteWithSubSubRouteBranch$routeWithSubSubRouteBranch = function (cfg) {
    var _v0 = cfg.Et;

    if (!_v0.$) {
      return $author$project$Views$Routed$SubRoute2Variant1View$subRoute2Variant1View({
        jT: cfg.jT,
        Ej: cfg.Ej
      });
    } else {
      var subRoute1 = _v0.a;
      return $author$project$Views$Routed$SubRoute1Branch$subRoute1Branch({
        jT: cfg.jT,
        Ej: cfg.Ej,
        Es: subRoute1
      });
    }
  };

  var $author$project$Views$Routed$SampleRouteView$sampleRouteView = function (cfg) {
    return _List_Nil;
  };

  var $author$project$Types$Mock$user = {
    u2: _List_Nil,
    iP: 'user@email.com',
    xs: true,
    hu: 'Firstname',
    F: 'userId',
    hI: 'Lastname',
    ng: $elm$core$Maybe$Nothing
  };
  var $author$project$Types$Mock$session = {
    u_: {
      hr: 300000,
      d5: 'idToken',
      e6: 'refreshToken'
    },
    v5: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$Company$unwrapCompanyId),
    x_: 7,
    Fl: $author$project$Types$Mock$user,
    ue: $author$project$ElmFramework$Lib$PivotDict$fromList({
      aA: _List_Nil,
      d8: $author$project$Types$User$unwrapUserId,
      eB: $author$project$Types$Company$unwrapCompanyId,
      eE: function ($) {
        return $.oD;
      },
      eF: function ($) {
        return $.b9;
      }
    }),
    Ft: $author$project$Types$User$emptyUserDict
  };
  var $author$project$Ui$UserProfile$Msg$CloseEmailChangeConfirmed = {
    $: 9
  };

  var $author$project$ElmFramework$Lib$Ui$TitleTypes$emailChangeSentDescriptionTitle = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular gray40 center'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('We have sent a confirmation email to ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary30')]), _List_fromArray([$elm$html$Html$text(cfg.iP)])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('. Please confirm your email to proceed with the change!')]))]));
  };

  var $author$project$Ui$OverLaysView$routeToRootUserProfile = $author$project$ElmFramework$MsgCmd$msgCmd.Dj($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$UserProfileRoute));

  var $author$project$Ui$OverLaysView$changeEmailSentUserProfileOverlay = function (userProfile) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$WindowModal$windowModal({
        iw: _List_fromArray([$elm$html$Html$Attributes$class('z3')]),
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter maxW50 justifyCenter marRight7 marLeft7 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'maxW46 center marTop3 marBottom2',
          y$: 'Email sent!'
        }), $author$project$ElmFramework$Lib$Ui$TitleTypes$emailChangeSentDescriptionTitle({
          vV: '',
          iP: userProfile.rC
        }), $author$project$Ui$Button$basicButton({
          kG: 'w26 marBottom19 marTop4 ',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgUserProfile($author$project$Ui$UserProfile$Msg$CloseEmailChangeConfirmed)),
          y$: 'Back'
        })]))]),
        Aj: $author$project$Ui$OverLaysView$routeToRootUserProfile,
        t1: 'Edit Email'
      })
    });
  };

  var $author$project$Ui$UserProfile$Msg$ChangeEmailClicked = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });
  var $author$project$Types$UserProfile$setNewEmail = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      rC: val
    });
  });

  var $author$project$Ui$UserProfile$Msg$SetUserProfile = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$OverLaysView$setUserProfileMsg = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgUserProfile, $author$project$Ui$UserProfile$Msg$SetUserProfile);
  var $author$project$Ui$OverLaysView$changeEmailUserProfileOverlay = F2(function (session, userProfile) {
    var newEmail = userProfile.rC;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$DialogModal$dialogModal({
        ar: 'Send',
        as: 'Cancel',
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter maxW50 justifyCenter marRight7 marLeft7 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
          vV: 'maxW46 center marTop3 marBottom2',
          y$: 'We will need to confirm your new email.'
        }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
          vV: 'gray40 center',
          y$: 'Add your new e-mail and we will send a confirmation message to proceed with the change!'
        }), $author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'fullWidth marTop5 marBottom6',
          E: $elm$core$Maybe$Just('Enter your New e-mail'),
          k_: false,
          qU: 1,
          qW: true,
          e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setNewEmail(userProfile)),
          e3: 'Enter e-mail',
          gx: false,
          Fw: newEmail
        })]))]),
        av: $author$project$TopMsg$msgUserProfile(A2($author$project$Ui$UserProfile$Msg$ChangeEmailClicked, session, newEmail)),
        aw: $author$project$Ui$OverLaysView$routeToRootUserProfile,
        Aj: $author$project$Ui$OverLaysView$routeToRootUserProfile,
        t1: 'Edit Email'
      })
    });
  });
  var $author$project$Ui$UserProfile$Msg$ChangePassword = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $author$project$Types$UserProfile$setNewPassword = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      jk: val
    });
  });
  var $author$project$Types$UserProfile$setRepeatNewPassword = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      jC: val
    });
  });
  var $author$project$Ui$OverLaysView$changePasswordUserProfileOverlay = F2(function (session, userProfile) {
    var newPassword = userProfile.jk;
    var repeatNewPassword = userProfile.jC;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: function () {
        var submitMsg = _Utils_eq(newPassword, repeatNewPassword) ? $author$project$TopMsg$msgUserProfile(A2($author$project$Ui$UserProfile$Msg$ChangePassword, session, newPassword)) : A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please enter email, name, last name and choose a role', _List_Nil);
        return $author$project$UiWrappers$DialogModal$dialogModal({
          ar: 'Save',
          as: 'Cancel',
          pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter maxW50 justifyCenter marRight7 marLeft7 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
            vV: 'maxW46 center marTop3 marBottom2',
            y$: 'We will need to confirm your new password.'
          }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
            vV: 'gray40 center',
            y$: 'Please enter your new password below to confirm the change.'
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Nothing,
            vV: 'fullWidth marTop3',
            E: $elm$core$Maybe$Just('Enter new password'),
            k_: false,
            qU: 2,
            qW: true,
            e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setNewPassword(userProfile)),
            e3: 'Enter new password',
            gx: false,
            Fw: newPassword
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Nothing,
            vV: 'fullWidth marTop2 marBottom6',
            E: $elm$core$Maybe$Just('Repeat new password'),
            k_: false,
            qU: 2,
            qW: true,
            e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setRepeatNewPassword(userProfile)),
            e3: 'Repeat new password',
            gx: false,
            Fw: repeatNewPassword
          })]))]),
          av: submitMsg,
          aw: $author$project$Ui$OverLaysView$routeToRootUserProfile,
          Aj: $author$project$Ui$OverLaysView$routeToRootUserProfile,
          t1: 'Edit Password'
        });
      }()
    });
  });

  var $author$project$Ui$UserProfile$Msg$ConfirmCredentials = function (a) {
    return {
      $: 2,
      a: a
    };
  };

  var $author$project$Types$UserProfile$setConfirmCredentialsEmail = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      iF: val
    });
  });
  var $author$project$Types$UserProfile$setConfirmCredentialsPassword = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      iG: val
    });
  });
  var $author$project$Ui$OverLaysView$confirmCredentialsUserProfileOverlay = F3(function (session, userProfile, nextRoute) {
    var confirmCredentialsEmail = userProfile.iF;
    var confirmCredentialsPassword = userProfile.iG;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: function () {
        var submitMsg = $elm$core$String$length(confirmCredentialsPassword) > 0 ? $author$project$TopMsg$msgUserProfile($author$project$Ui$UserProfile$Msg$ConfirmCredentials({
          iP: confirmCredentialsEmail,
          zR: nextRoute,
          sv: confirmCredentialsPassword,
          DY: session
        })) : A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'Please enter email, name, last name and choose a role', _List_Nil);
        return $author$project$UiWrappers$DialogModal$dialogModal({
          ar: 'Ok',
          as: 'Cancel',
          pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter maxW50 justifyCenter marRight7 marLeft7 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
            vV: 'maxW46 center marTop3 marBottom2',
            y$: 'Please enter your credentials before we can proceed.'
          }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
            vV: 'gray40 center',
            y$: 'We need to verify your identity for this operation.'
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Nothing,
            vV: 'fullWidth marTop3',
            E: $elm$core$Maybe$Just('E-mail'),
            k_: false,
            qU: 1,
            qW: true,
            e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setConfirmCredentialsEmail(userProfile)),
            e3: 'E-mail',
            gx: false,
            Fw: confirmCredentialsEmail
          }), $author$project$Ui$InputComponent$inputField({
            fx: $elm$core$Maybe$Nothing,
            vV: 'fullWidth marTop2 marBottom6',
            E: $elm$core$Maybe$Just('Password'),
            k_: false,
            qU: 2,
            qW: true,
            e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setConfirmCredentialsPassword(userProfile)),
            e3: 'Password',
            gx: false,
            Fw: confirmCredentialsPassword
          })]))]),
          av: submitMsg,
          aw: $author$project$Ui$OverLaysView$routeToRootUserProfile,
          Aj: $author$project$Ui$OverLaysView$routeToRootUserProfile,
          t1: 'Enter credentials'
        });
      }()
    });
  });
  var $author$project$Remote$RequestMsg$DeleteMyAccount = {
    $: 14
  };

  var $author$project$Types$UserProfile$toggleSwitch1 = function (userProfile) {
    return _Utils_update(userProfile, {
      ig: !userProfile.ig
    });
  };

  var $author$project$Types$UserProfile$toggleSwitch2 = function (userProfile) {
    return _Utils_update(userProfile, {
      ih: !userProfile.ih
    });
  };

  var $author$project$Types$UserProfile$toggleSwitch3 = function (userProfile) {
    return _Utils_update(userProfile, {
      ii: !userProfile.ii
    });
  };

  var $author$project$Ui$OverLaysView$deleteAccountUserProfileOverlay = function (userProfile) {
    var switch1 = userProfile.ig;
    var switch2 = userProfile.ih;
    var switch3 = userProfile.ii;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: function () {
        var submitMsg = !switch1 || !switch2 || !switch3 ? A3($author$project$ElmFramework$MsgCmd$msgCmd.ec, $elm$core$Maybe$Nothing, 'You can\'t delete your account unless you accept all conditions', _List_Nil) : $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$DeleteMyAccount);
        return $author$project$UiWrappers$DialogModal$dialogModal({
          ar: 'Remove User',
          as: 'Cancel',
          pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter maxW50 justifyCenter marRight7 marLeft7 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
            vV: 'maxW46 center marTop3 marBottom2',
            y$: 'Are you sure you want to delete your account?'
          }), $author$project$ElmFramework$Lib$Ui$TitleTypes$smallDescriptionTitle({
            vV: 'gray40 center',
            y$: 'All your personal and business data will be deleted.'
          }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w46 marBottom1 marTop5')]), _List_fromArray([$author$project$Ui$SwitchLabelLeft$switchLabelLeft({
            vV: 'marBottom3',
            yC: switch1,
            y$: 'Delete all my accounts and scenarios.',
            y1: '',
            ew: $author$project$Ui$OverLaysView$setUserProfileMsg($author$project$Types$UserProfile$toggleSwitch1(userProfile))
          }), $author$project$Ui$SwitchLabelLeft$switchLabelLeft({
            vV: 'marBottom3',
            yC: switch2,
            y$: 'Delete all my business info.',
            y1: '',
            ew: $author$project$Ui$OverLaysView$setUserProfileMsg($author$project$Types$UserProfile$toggleSwitch2(userProfile))
          }), $author$project$Ui$SwitchLabelLeft$switchLabelLeft({
            vV: 'marBottom3',
            yC: switch3,
            y$: 'Delete all my personal info.',
            y1: '',
            ew: $author$project$Ui$OverLaysView$setUserProfileMsg($author$project$Types$UserProfile$toggleSwitch3(userProfile))
          })]))]))]),
          av: submitMsg,
          aw: $author$project$Ui$OverLaysView$routeToRootUserProfile,
          Aj: $author$project$Ui$OverLaysView$routeToRootUserProfile,
          t1: 'Delete Account'
        });
      }()
    });
  };

  var $author$project$Ui$UserProfile$Msg$LogoutClicked = {
    $: 10
  };
  var $author$project$Ui$ComponentsPreview$Msg$NextStepFrom = {
    $: 6
  };

  var $author$project$Remote$RequestMsg$UpdateSelf = function (a) {
    return {
      $: 13,
      a: a
    };
  };

  var $author$project$Ui$Button$buttonContentIcon = function (cfg) {
    var spacing = A2($elm$core$Maybe$withDefault, '0h', cfg.qO);

    var _v0 = function () {
      var _v1 = cfg.tM;

      switch (_v1) {
        case 0:
          return _Utils_Tuple2('primary20', 'primary20Fill marLeft' + spacing);

        case 1:
          return _Utils_Tuple2('', '');

        default:
          return _Utils_Tuple2('gray60', 'gray60Fill marLeft' + spacing);
      }
    }();

    var btnClasses = _v0.a;
    var iconClasses = _v0.b;
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.ew), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter heading4Regular'), $elm$html$Html$Attributes$class(btnClasses), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([$elm$html$Html$text(cfg.y$), cfg.yh('w3 ' + iconClasses)]));
  };

  var $author$project$Ui$DisabledInputBtn$disabledInputBtn = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray40 heading5Bold')]), _List_fromArray([$elm$html$Html$text(cfg.zL)])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.hV), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween gray10Back gray40 heading4Bold radius0  padTop1h padBottom1h padRight2 padLeft2 ')]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(cfg.EH)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$IconSvg$edit('primary30Fill w3')]))]))]));
  };

  var $author$project$Types$UserProfile$setLastName = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      hI: val
    });
  });
  var $author$project$Types$UserProfile$setName = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      zL: val
    });
  });
  var $author$project$Types$UserProfile$setPhoneNumber = F2(function (userProfile, val) {
    return _Utils_update(userProfile, {
      ng: val
    });
  });

  var $author$project$Views$Routed$UserProfileBranch$viewLayer = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Fz: $author$project$UiWrappers$MainAppWrapSpecific$View$mainAppWrapSpecific({
        vw: $elm$core$Maybe$Nothing,
        pD: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 scrollTarget')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('minH5'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom5 marLeft5 marRight5')]), cfg.pD)]))]),
        wc: 'flexRow noOverflow',
        s9: $elm$core$Maybe$Nothing,
        DY: cfg.DY,
        D6: true,
        eG: cfg.eG
      })
    });
  };

  var $author$project$Views$Routed$UserProfileBranch$userProfileView = F2(function (session, topState) {
    return $author$project$Views$Routed$UserProfileBranch$viewLayer({
      pD: function () {
        var updatePhotoInput = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w22')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle relative w22 h22 heroBold gray10Back flexRow flexAlignCenter primary20 justifyCenter marTop2 marBottom4')]), _List_fromArray([$elm$html$Html$text('UN')])), $author$project$Ui$Button$basicButton({
          kG: 'fullWidth  ',
          vY: 1,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NextStepFrom)),
          y$: 'Update Photo'
        })]));

        var title = function (titleText) {
          return $author$project$ElmFramework$Lib$Ui$TitleTypes$smallTitle({
            vV: '',
            y$: titleText
          });
        };

        var logOutButton = $author$project$Ui$Button$buttonContentIcon({
          vV: 'marRight15',
          yh: $author$project$IconSvg$arrowRight,
          qO: $elm$core$Maybe$Nothing,
          y$: 'Log Out',
          ew: $author$project$TopMsg$msgUserProfile($author$project$Ui$UserProfile$Msg$LogoutClicked),
          tM: 2
        });
        var deleteAccountInput = $author$project$Ui$Button$textButton({
          kz: 'Delete My Account',
          vV: 'heading4Bold gray40',
          gi: $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$ConfirmCredentials($author$project$Route$UserProfileRoute$DeleteAccount)))
        });
        var container2 = $elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop3')]));
        var container1 = $elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter spaceBetween')]));
        var changePasswordInput = $author$project$Ui$Button$textButton({
          kz: 'Change Password',
          vV: 'heading4Bold primary30 marBottom7',
          gi: $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$ConfirmCredentials($author$project$Route$UserProfileRoute$ChangePassword)))
        });
        var userProfile = topState.o_.Fo;
        var name = userProfile.zL;
        var lastName = userProfile.hI;
        var phoneNumber = userProfile.ng;
        var currentEmail = userProfile.wq;
        var emailInput = $author$project$Ui$DisabledInputBtn$disabledInputBtn({
          vV: 'fullWidth marBottom5',
          zL: 'E-mail',
          hV: $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$ConfirmCredentials($author$project$Route$UserProfileRoute$ChangeEmail))),
          EH: currentEmail
        });
        var selfUpdateReq = {
          hu: name,
          hI: lastName,
          ng: phoneNumber
        };
        var submitMsg = $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UpdateSelf(selfUpdateReq));
        var saveChangesButton = $author$project$Ui$Button$basicButton({
          kG: 'fullWidth  ',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button(submitMsg),
          y$: 'Save Changes'
        });
        var lastNameInput = $author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'fullWidth marBottom2',
          E: $elm$core$Maybe$Just('Last Name'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setLastName(userProfile)),
          e3: 'Last Name',
          gx: false,
          Fw: lastName
        });
        var nameInput = $author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'fullWidth marBottom2',
          E: $elm$core$Maybe$Just('Name'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setName(userProfile)),
          e3: 'Name',
          gx: false,
          Fw: name
        });
        var phoneNumberInput = $author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: 'fullWidth marBottom14',
          E: $elm$core$Maybe$Just('Phone Number'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, $author$project$Ui$OverLaysView$setUserProfileMsg, $author$project$Types$UserProfile$setPhoneNumber(userProfile)),
          e3: '000 000',
          gx: false,
          Fw: phoneNumber
        });
        return _List_fromArray([container1(_List_fromArray([title('Account settings'), logOutButton])), container2(_List_fromArray([updatePhotoInput, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignStart marLeft14')]), _List_fromArray([nameInput, emailInput, changePasswordInput, deleteAccountInput])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w46 flexColumn flexAlignStart marLeft9')]), _List_fromArray([lastNameInput, phoneNumberInput, saveChangesButton]))]))]);
      }(),
      DY: session,
      eG: topState
    });
  });
  var $author$project$Views$Routed$UserProfileBranch$userProfileBranch = F3(function (userProfileRoute, session, topState) {
    var userProfile = topState.o_.Fo;

    switch (userProfileRoute.$) {
      case 4:
        var nextRoute = userProfileRoute.a;
        return _List_fromArray([A2($author$project$Views$Routed$UserProfileBranch$userProfileView, session, topState), A3($author$project$Ui$OverLaysView$confirmCredentialsUserProfileOverlay, session, userProfile, nextRoute)]);

      case 0:
        return _List_fromArray([A2($author$project$Views$Routed$UserProfileBranch$userProfileView, session, topState)]);

      case 1:
        return _List_fromArray([A2($author$project$Views$Routed$UserProfileBranch$userProfileView, session, topState), function () {
          var _v1 = userProfile.gZ;

          if (!_v1.$) {
            var _v2 = _v1.a;
            return $author$project$Ui$OverLaysView$changeEmailSentUserProfileOverlay(userProfile);
          } else {
            return A2($author$project$Ui$OverLaysView$changeEmailUserProfileOverlay, session, userProfile);
          }
        }()]);

      case 2:
        return _List_fromArray([A2($author$project$Views$Routed$UserProfileBranch$userProfileView, session, topState), A2($author$project$Ui$OverLaysView$changePasswordUserProfileOverlay, session, userProfile)]);

      default:
        return _List_fromArray([A2($author$project$Views$Routed$UserProfileBranch$userProfileView, session, topState), $author$project$Ui$OverLaysView$deleteAccountUserProfileOverlay(userProfile)]);
    }
  });

  var $author$project$Ui$ComponentsPreview$Msg$Action = function (a) {
    return {
      $: 32,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Enum$PositionType$Actual = 0;
  var $author$project$Ui$Button$ButtonContentIconStrong = 0;
  var $author$project$Types$CashOrCredit$Credit = 1;

  var $author$project$Ui$ComponentsPreview$Msg$DateInputMsg = function (a) {
    return {
      $: 15,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$FilterInputSearchDropdownResults = function (a) {
    return {
      $: 26,
      a: a
    };
  };

  var $author$project$Ui$SectionBar$Grayish = 0;
  var $author$project$Ui$SectionBar$Growth = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $justinmimbs$time_extra$Time$Extra$Monday = 4;

  var $author$project$Ui$ComponentsPreview$Msg$NestedSelectChanged = function (a) {
    return {
      $: 28,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$NoAction = 0;

  var $author$project$Ui$ComponentsPreview$Msg$OnCreateNew = function (a) {
    return {
      $: 27,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnInput = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnInputSearchDropdownSelect = function (a) {
    return {
      $: 24,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnSelectCashOrCredit = function (a) {
    return {
      $: 34,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnSelectLegal = function (a) {
    return {
      $: 33,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnSelectScenariosOrBlocks = function (a) {
    return {
      $: 35,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnSlide = function (a) {
    return {
      $: 21,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnSlideWithInput = function (a) {
    return {
      $: 22,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnTap = {
    $: 2
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnTapDotMenu = {
    $: 3
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnTapWeekday = function (a) {
    return {
      $: 4,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch = {
    $: 23
  };

  var $author$project$Types$CashboardQuery$PeriodMetricsCash = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$RangeDateInputMsg = function (a) {
    return {
      $: 16,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$SwitchSelectClearedAll = {
    $: 39
  };
  var $author$project$Ui$ComponentsPreview$Msg$SwitchSelectSelectedAll = {
    $: 38
  };

  var $author$project$Ui$ComponentsPreview$Msg$SwitchSelectToggled = function (a) {
    return {
      $: 40,
      a: a
    };
  };

  var $author$project$Ui$ComponentsPreview$Msg$ToggleExpandRow = function (a) {
    return {
      $: 37,
      a: a
    };
  };

  var $justinmimbs$time_extra$Time$Extra$Wednesday = 6;

  var $author$project$AssetsSvg$qbLogo1_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 248 48'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M246.57 36.3802C246.57 35.8753 246.14 35.6913 245.7 35.6913H244.875V38.0409H245.297V37.0583H245.599L246.149 38.0404H246.662L246.03 37.0117C246.359 36.9383 246.57 36.7181 246.57 36.3788L246.57 36.3802ZM245.297 36.719V36.0494H245.681C245.902 36.0494 246.149 36.1134 246.149 36.3703C246.149 36.6546 245.875 36.7186 245.636 36.7186H245.298L245.297 36.719ZM245.69 34.792C244.536 34.792 243.603 35.719 243.603 36.8753C243.603 38.0315 244.536 38.9402 245.69 38.9402C246.844 38.9402 247.779 38.032 247.779 36.8753C247.779 35.7186 246.844 34.792 245.69 34.792ZM245.69 38.6367C244.72 38.6367 243.932 37.8386 243.932 36.8753C243.932 35.9026 244.72 35.1134 245.69 35.1134C246.662 35.1134 247.449 35.9026 247.449 36.8753C247.449 37.8386 246.662 38.6371 245.69 38.6371V38.6367ZM111.34 35.144C108.285 35.144 106.745 32.4099 106.745 29.7651C106.745 27.1214 108.416 24.503 111.193 24.503C112.494 24.503 114.138 25.1571 114.784 26.0762L118.018 22.848C116.453 21.1953 113.957 20.2089 111.193 20.2089C105.569 20.2089 101.487 24.2527 101.487 29.824C101.487 35.4851 105.524 39.4395 111.304 39.4395C114.054 39.4395 116.595 38.6329 118.102 37.0099L114.956 33.6277C114.23 34.5143 112.707 35.1444 111.34 35.1444V35.144ZM93.2536 38.9261H98.2713V20.7209H93.2536V38.9261ZM84.1297 30.7021C84.1297 32.8414 82.738 35.1444 80.1438 35.1444C78.1439 35.1444 77.0767 33.7153 77.0767 30.7755V20.7209H72.0575V32.0197C72.0575 35.7797 73.9302 39.439 78.9372 39.439C81.2984 39.439 83.2762 37.5764 84.2729 36.2014H84.3481V38.9261H89.1461V20.7209H84.1283V30.7021H84.1297ZM63.0065 23.0324H62.8952C62.1859 22.2466 60.2663 20.2089 57.1479 20.2089C52.032 20.2089 48.0898 24.2211 48.0898 29.7506C48.0898 35.3647 51.7276 39.439 56.9075 39.439C59.2592 39.439 61.4682 38.1901 62.7491 36.7379H62.8233V47.8908H67.8411V20.7209H63.0065V23.0324ZM58.1348 35.144C55.032 35.144 53.2687 32.4306 53.2687 29.751C53.2687 27.1877 54.8878 24.4296 58.1348 24.4296C61.1211 24.4296 62.9694 27.2296 62.9694 29.8235C62.9694 32.4386 61.161 35.144 58.1353 35.144H58.1348ZM172.426 20.2084C166.717 20.2084 162.573 24.2211 162.573 29.7506C162.573 35.472 166.809 39.488 172.426 39.488C178.042 39.488 182.279 35.4334 182.279 29.7506C182.279 24.2211 178.135 20.2084 172.426 20.2084H172.426ZM172.426 35.144C169.154 35.144 167.663 32.3487 167.663 29.751C167.663 27.1877 169.154 24.4296 172.426 24.4296C175.698 24.4296 177.188 27.1873 177.188 29.7506C177.188 32.3482 175.698 35.1435 172.425 35.1435L172.426 35.144ZM235.157 27.7209C232.574 27.103 231.664 26.7703 231.664 25.7233C231.664 24.2786 233.491 23.9614 234.318 23.9614C235.875 23.9614 237.634 24.8931 238.296 25.7779L241.255 22.9336C239.886 21.2113 237.195 20.2089 234.355 20.2089C230.723 20.2089 226.91 22.0381 226.91 26.1261C226.91 29.6367 229.656 30.6955 232.344 31.3402C235.176 32.0014 236.186 32.4837 236.186 33.6273C236.186 35.312 234.277 35.5873 233.621 35.5873C231.979 35.5873 230.077 34.6461 229.051 33.4254L226.005 36.5195C227.669 38.3689 230.517 39.4809 233.438 39.4809C238.343 39.4809 241.254 37.1383 241.254 33.2724C241.254 29.5736 237.691 28.3299 235.156 27.7214L235.157 27.7209ZM225.671 20.7204H219.2L212.721 28.2748H212.61V10.688H207.592V38.9256H212.61V29.9468H212.721L219.443 38.9256H226.045L218.234 28.9764L225.671 20.7204ZM151.266 20.2075C148.971 20.2075 147.28 21.2127 145.684 22.711H145.59V10.6875H140.574V38.9256H145.371V36.3524H145.446C146.577 38.2113 148.825 39.4386 151.156 39.4386C156.336 39.4386 160.262 35.3633 160.262 29.7501C160.262 24.2207 156.383 20.208 151.266 20.208L151.266 20.2075ZM150.279 35.144C147.253 35.144 145.444 32.4381 145.444 29.823C145.444 27.2291 147.293 24.4291 150.279 24.4291C153.526 24.4291 155.141 27.1868 155.141 29.7501C155.141 32.4301 153.382 35.143 150.279 35.143V35.144ZM138.685 20.7204H132.214L125.736 28.2748H125.624V10.688H120.607V38.9256H125.624V29.9468H125.736L132.457 38.9256H139.06L131.249 28.9764L138.685 20.7204ZM194.474 20.2075C188.765 20.2075 184.621 24.2207 184.621 29.7501C184.621 35.4715 188.857 39.4875 194.474 39.4875C200.09 39.4875 204.326 35.4329 204.326 29.7501C204.326 24.2207 200.182 20.208 194.473 20.208L194.474 20.2075ZM194.474 35.144C191.202 35.144 189.711 32.3477 189.711 29.7501C189.711 27.1873 191.202 24.4291 194.474 24.4291C197.746 24.4291 199.236 27.1868 199.236 29.7501C199.236 32.3477 197.746 35.143 194.473 35.143L194.474 35.144Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M21.3121 42.4584C32.9854 42.4584 42.4485 32.9774 42.4485 21.2819C42.4485 9.5865 32.9854 0.105469 21.3121 0.105469C9.63885 0.105469 0.175781 9.5865 0.175781 21.2819C0.175781 32.9774 9.63885 42.4584 21.3121 42.4584Z'), $elm$svg$Svg$Attributes$fill('#2CA01C')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M6.04297 21.2794C6.04297 25.8276 9.72305 29.5147 14.2627 29.5147H15.4369V26.4559H14.2627C11.4135 26.4559 9.096 24.134 9.096 21.2794C9.096 18.4253 11.4135 16.1029 14.2627 16.1029H17.0841V32.1029C17.0841 33.7923 18.451 35.1617 20.1372 35.1617V13.0441H14.2627C9.72305 13.0441 6.04297 16.7316 6.04297 21.2794ZM28.3583 13.0455H27.184V16.1043H28.3583C31.2065 16.1043 33.5249 18.4267 33.5249 21.2808C33.5249 24.1349 31.2065 26.4573 28.3583 26.4573H25.5354V10.4573C25.5354 8.76785 24.1686 7.39844 22.4824 7.39844V29.5161H28.3583C32.8974 29.5161 36.578 25.829 36.578 21.2808C36.578 16.7326 32.8974 13.0455 28.3583 13.0455Z'), $elm$svg$Svg$Attributes$fill('#FAFAFA')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M68.7851 4.92749C69.5564 4.92749 70.1815 4.30067 70.1815 3.52844C70.1815 2.75573 69.5568 2.12891 68.7851 2.12891C68.0139 2.12891 67.3882 2.75573 67.3882 3.52844C67.3882 4.3002 68.0139 4.92749 68.7851 4.92749ZM60.4508 5.87008C59.084 5.87008 57.9858 6.7002 57.5819 7.62632H57.5429V6.14067H55.348V15.4037H57.6589V10.3091C57.6589 9.07432 58.3522 7.80091 59.8148 7.80091C61.2991 7.80091 61.5494 9.17032 61.5494 10.2706V15.4037H63.8604V9.61455C63.8604 7.72279 62.859 5.87055 60.4503 5.87055L60.4508 5.87008ZM50.668 15.4033H52.9789V6.1402H50.668V15.4033ZM92.6979 4.92797C93.4696 4.92797 94.0947 4.30067 94.0947 3.52844C94.0947 2.75573 93.4701 2.12891 92.6983 2.12891C91.928 2.12891 91.3024 2.75573 91.3024 3.52844C91.3024 4.3002 91.9271 4.92749 92.6988 4.92749L92.6979 4.92797ZM88.9511 6.13502V8.18679H91.5429V15.4028H93.8547V8.18726H96.446V6.13549H88.9511V6.13502ZM85.0207 15.4028H87.3316V6.1402H85.0207V15.4033V15.4028ZM65.0379 8.18726H67.6292V15.4033H69.9401V8.18726H72.5314V6.13549H65.0374V8.18726H65.0379ZM80.343 11.2353C80.343 12.4701 79.6492 13.7435 78.1861 13.7435C76.7028 13.7435 76.4529 12.3741 76.4529 11.2729V6.14067H74.1411V11.9298C74.1411 13.8216 75.1425 15.6738 77.5511 15.6738C78.9179 15.6738 80.016 14.8442 80.42 13.9176H80.459V15.4037H82.6548V6.1402H80.3439V11.2353H80.343Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil)]));
  };

  var $author$project$AssetsSvg$qbLogo1 = function (classes) {
    return $author$project$AssetsSvg$qbLogo1_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };

  var $author$project$Ui$Button$appButton = function (cfg) {
    return $author$project$Ui$Button$button({
      kG: 'primary10Back h13 borderSolid radius0 borderHairlineWidth gray20Border fullWidth ' + cfg.vV,
      pD: $author$project$AssetsSvg$qbLogo1('h6'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.f9)
    });
  };

  var $author$project$Types$Mock$block = {
    kw: $author$project$Types$BuildingBlock$BasicMoney($krisajenkins$remotedata$RemoteData$NotAsked),
    iK: $elm$time$Time$millisToPosix(38294834),
    cC: 'userId',
    F: 'block-id',
    zL: 'String',
    bw: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 15),
    oB: $elm$time$Time$millisToPosix(38294834)
  };
  var $author$project$Types$Mock$budgetQuery = {
    pb: 1,
    pA: 'f9613f31-a253-4604-9452-f4993d1ff869',
    eO: _List_Nil,
    ka: 0
  };
  var $author$project$Types$Mock$cashboardQuery = {
    it: 0,
    eO: _List_Nil,
    jD: 1,
    Dw: 'f9613f31-a253-4604-9452-f4993d1ff869'
  };
  var $author$project$Types$Mock$comment = {
    U: 'M dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ',
    iK: $elm$time$Time$millisToPosix(395745238),
    cC: 'user-id',
    eO: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Division$unwrapDivisionId),
    F: 'comment-id',
    ap: $elm$core$Maybe$Nothing,
    bi: $elm$core$Maybe$Nothing,
    c8: $elm$core$Maybe$Nothing,
    Y: 0
  };
  var $author$project$ElmFramework$Lib$Util$nbsp = $elm$html$Html$text(' ');
  var $author$project$Ui$Comment$toPaddedNumber = F2(function (padding, theNumber) {
    return A3($elm$core$String$padLeft, padding, '0', $elm$core$String$fromInt(theNumber));
  });

  var $author$project$Ui$Comment$comment = function (cfg) {
    var showPopUpMenu = $author$project$Ui$PopoverMenu$showHidePopoverMenu({
      vG: _List_fromArray([{
        y$: 'Archive Comment',
        ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
        tY: 0
      }, {
        y$: 'Edit Comment',
        ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
        tY: 0
      }, {
        y$: 'Delete Comment',
        ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
        tY: 1
      }]),
      vV: 'absolute right3 top4 ',
      f8: cfg.yS,
      E3: cfg.tU
    });
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 primary10Back relative')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 heading5Bold')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray40')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Ui$Comment$toPaddedNumber, 2, cfg.rE))])), $author$project$ElmFramework$Lib$Util$nbsp, A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary30')]), _List_fromArray([$elm$html$Html$text(cfg.zL)]))])), $author$project$Ui$Button$button({
      kG: '',
      pD: $author$project$IconSvg$dots('w3 primary30Fill'),
      f9: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.tU)
    })])), showPopUpMenu]));
  };

  var $author$project$Types$Mock$division = {
    oX: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$AllocationClass$unwrapAllocationClassId),
    xt: $elm$core$Maybe$Just(1),
    qp: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$FinancialAccount$unwrapFinancialAccountId),
    F: '',
    an: $elm$core$Maybe$Just('Industry'),
    zL: 'Test Division',
    ju: $elm$core$Maybe$Nothing
  };

  var $author$project$Ui$DivisionBar$divisionBar = function (cfg) {
    var reConnect = !cfg.yJ ? A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.ew), _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 borderWidth2 circle gray40Border borderSolid marRight2')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold gray40')]), _List_fromArray([$elm$html$Html$text('Reconnect Division')]))])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    var activeTheme = cfg.yC ? ' primary30' : ' gray40';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter pad3 whiteBack ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ' + activeTheme)]), _List_fromArray([$elm$html$Html$text(cfg.k2)])), reConnect, A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween pointer')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold padRight3' + activeTheme)]), _List_fromArray([$elm$html$Html$text(cfg.y$)])), $author$project$Ui$Switch$switch({
      vV: '',
      hE: cfg.yC,
      yW: false,
      tU: cfg.ew
    })]))]));
  };

  var $author$project$Types$TransactionSummary$CurrencyValue = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$TransactionSummary$Row = $elm$core$Basics$identity;
  var $author$project$Ui$NestedTable$NestedTable$exampleData = {
    cD: _List_fromArray([$author$project$Types$SimpleDate$fromMillis(1632585451554), $author$project$Types$SimpleDate$fromMillis(1632685551554)]),
    tf: _List_fromArray([{
      vR: _List_fromArray([$elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
      }), $elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
      }), $elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
      })]),
      vU: _List_Nil,
      y$: 'abc'
    }, {
      vR: _List_fromArray([$elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
      }), $elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
      }), $elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
      })]),
      vU: _List_fromArray([{
        vR: _List_fromArray([$elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
        })]),
        vU: _List_fromArray([{
          vR: _List_fromArray([$elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
          })]),
          vU: _List_fromArray([{
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-1-1-1'
          }, {
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-1-1-2'
          }, {
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-1-1-3'
          }, {
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-1-1-4'
          }]),
          y$: 'def-1-1'
        }, {
          vR: _List_fromArray([$elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
          })]),
          vU: _List_Nil,
          y$: 'def-1-2'
        }]),
        y$: 'def-1'
      }, {
        vR: _List_fromArray([$elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
        })]),
        vU: _List_fromArray([{
          vR: _List_fromArray([$elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
          })]),
          vU: _List_fromArray([{
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-2-1-1'
          }, {
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-2-1-2'
          }]),
          y$: 'def-2-1'
        }, {
          vR: _List_fromArray([$elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
          })]),
          vU: _List_Nil,
          y$: 'def-2-2'
        }]),
        y$: 'def-2'
      }, {
        vR: _List_fromArray([$elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
        })]),
        vU: _List_Nil,
        y$: 'def-3'
      }, {
        vR: _List_fromArray([$elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
        }), $elm$core$Maybe$Just({
          Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
        })]),
        vU: _List_fromArray([{
          vR: _List_fromArray([$elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
          })]),
          vU: _List_fromArray([{
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-4-1-1'
          }]),
          y$: 'def-4-1'
        }, {
          vR: _List_fromArray([$elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
          }), $elm$core$Maybe$Just({
            Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
          })]),
          vU: _List_fromArray([{
            vR: _List_fromArray([$elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
            }), $elm$core$Maybe$Just({
              Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
            })]),
            vU: _List_Nil,
            y$: 'def-4-2-1'
          }]),
          y$: 'def-4-2'
        }]),
        y$: 'def-4'
      }]),
      y$: 'def'
    }, {
      vR: _List_fromArray([$elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
      }), $elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 1)))
      }), $elm$core$Maybe$Just({
        Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3, 1)))
      })]),
      vU: _List_Nil,
      y$: 'ghi'
    }])
  };
  var $author$project$Ui$NestedTable$NestedTable$exampleView = F2(function (msg, expandedRows) {
    return $author$project$Ui$NestedTable$NestedTable$nestedTable({
      wx: $author$project$Ui$NestedTable$NestedTable$exampleData,
      iR: expandedRows,
      j2: msg
    });
  });

  var $author$project$Ui$NestedTable$NestedTable$exampleData2 = function () {
    var c = $elm$core$Maybe$Just({
      Fw: $author$project$Types$TransactionSummary$CurrencyValue($elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1, 1)))
    });
    var rz = {
      vR: _List_fromArray([c, c, c, c, c, c, c, c, c, c, c, c, c]),
      vU: _List_Nil,
      y$: 'abc'
    };
    return {
      cD: _List_fromArray([$author$project$Types$SimpleDate$fromMillis(1632585451554), $author$project$Types$SimpleDate$fromMillis(1632685551554), $author$project$Types$SimpleDate$fromMillis(1632585451554), $author$project$Types$SimpleDate$fromMillis(1632685551554), $author$project$Types$SimpleDate$fromMillis(1632685551554), $author$project$Types$SimpleDate$fromMillis(1632585451554), $author$project$Types$SimpleDate$fromMillis(1632685551554), $author$project$Types$SimpleDate$fromMillis(1632685551554), $author$project$Types$SimpleDate$fromMillis(1632585451554), $author$project$Types$SimpleDate$fromMillis(1632685551554)]),
      tf: _List_fromArray([rz, rz, rz, rz, rz])
    };
  }();

  var $author$project$Ui$NestedTable$NestedTable$exampleView2 = F2(function (msg, expandedRows) {
    return $author$project$Ui$NestedTable$NestedTable$nestedTable2({
      wx: $author$project$Ui$NestedTable$NestedTable$exampleData2,
      iR: expandedRows,
      j2: msg
    });
  });
  var $author$project$Types$Mock$financialAccount = {
    it: $author$project$Types$AccountType$Cash,
    dx: $elm$core$Maybe$Nothing,
    fy: $krisajenkins$remotedata$RemoteData$NotAsked,
    bq: 0,
    la: true,
    F: '',
    y5: $elm$core$Maybe$Nothing,
    zL: 'Financial Test Account'
  };

  var $author$project$Ui$Slider$horizontalSlider = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider({
      yM: config.yM,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: config.kG,
      eb: config.eb,
      dk: 'primary30Back',
      dl: '',
      dp: 'gray10Back',
      dq: 'secondary0Back',
      dr: '',
      Fw: config.Fw
    });
  };

  var $author$project$Ui$Input$inputBtn = function (cfg) {
    var background = 'gray10Back';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative'), $elm$html$Html$Attributes$class(cfg.vV)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray40')]), _List_fromArray([$elm$html$Html$text(cfg.y$)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth h6 padLeft2 padRight2 placeholderGray40 heading4Bold borderHairlineWidth borderSolid gray10Border noOverflow radius0 primary30 pointer'), $elm$html$Html$Attributes$class(background), $elm$html$Html$Attributes$value(cfg.Fw), $elm$html$Html$Attributes$type_(cfg.P), $elm$html$Html$Attributes$required(cfg.gx), $elm$html$Html$Attributes$placeholder(cfg.e3), $author$project$ElmFramework$Lib$Util$onTap(cfg.gW)]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute right2 top0 bottom0 flexCenter pointer')]), _List_fromArray([cfg.yh('w3 primary30Fill')]))]))]));
  };

  var $author$project$ElmFramework$Lib$Ui$Table$TableRow = F2(function (rowHeader, rowData) {
    return {
      nR: rowData,
      te: rowHeader
    };
  });
  var $author$project$ElmFramework$Lib$Ui$Table$mockData = {
    x5: _List_fromArray(['Revenue', 'Jan, 10 2020', 'Jan, 10 2020', 'Jan, 10 2020', 'Jan, 10 2020', 'Jan, 10 2020']),
    tf: _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$Table$TableRow, $elm$core$Maybe$Just('Channel Name'), _List_fromArray([12456.0, -1256.0, 56.0, 56.0, 56.0])), A2($author$project$ElmFramework$Lib$Ui$Table$TableRow, $elm$core$Maybe$Just('Channel Name'), _List_fromArray([12456.0, -1256.0, 56.0, 56.0, 56.0])), A2($author$project$ElmFramework$Lib$Ui$Table$TableRow, $elm$core$Maybe$Just('Channel Name'), _List_fromArray([12456.0, -1256.0, 56.0, 56.0, 56.0])), A2($author$project$ElmFramework$Lib$Ui$Table$TableRow, $elm$core$Maybe$Just('Channel Name'), _List_fromArray([12456.0, -1256.0, 56.0, 56.0, 56.0])), A2($author$project$ElmFramework$Lib$Ui$Table$TableRow, $elm$core$Maybe$Just('Channel Name'), _List_fromArray([12456.0, -1256.0, 56.0, 56.0, 56.0]))])
  };
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn = F2(function (label, onTap) {
    return $author$project$Ui$Button$textButton({
      kz: label,
      vV: 'mar1 heading4Regular block',
      gi: onTap
    });
  });
  var $author$project$Types$Mock$scenario = {
    bH: $author$project$Types$Comment$toCommentDictFromList(_List_Nil),
    cC: 'user-id',
    E: 'String',
    F: 'scenario-id',
    yC: true,
    yN: false,
    yU: true,
    rf: 0,
    zL: 'String',
    c9: $author$project$Types$Review$toReviewDictFromList(_List_Nil),
    tB: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 15),
    Fg: $elm$core$Maybe$Nothing
  };

  var $elm$html$Html$h2 = _VirtualDom_node('h2');

  var $author$project$Ui$SectionBar$selectedMessageContainer = function (message) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('noMar secondary0 heading5Bold')]), message);
  };

  var $author$project$Ui$SectionBar$unselectedMessageContainer = function (info) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray60 heading4Regular')]), _List_fromArray([$elm$html$Html$text(info)]));
  };

  var $author$project$Ui$SectionBar$sectionBar = function (cfg) {
    var toggleSection = !cfg.yR ? $author$project$IconSvg$add : $author$project$IconSvg$less;

    var sectionName = function () {
      var _v3 = cfg.DI;
      return 'Growth';
    }();

    var message = function () {
      if (!cfg.yR && cfg.DH) {
        var _v1 = cfg.DI;
        var percentage = _v1.a;
        var every = _v1.b;
        var period = _v1.c;
        var date = _v1.d;
        return $author$project$Ui$SectionBar$selectedMessageContainer(_List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular')]), _List_fromArray([$elm$html$Html$text('Growing ')])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(percentage) + '%')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular')]), _List_fromArray([$elm$html$Html$text(' every ')])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(every) + (' ' + period))])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular')]), _List_fromArray([$elm$html$Html$text(' Starting on ')])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2($author$project$Ui$TimeRepresentation$toUSFormattedDateWithSlashes, cfg.by, date))]))]));
      } else {
        if (!cfg.yR && !cfg.DH) {
          var _v2 = cfg.DI;
          return $author$project$Ui$SectionBar$unselectedMessageContainer('Add a growth pattern to this block.');
        } else {
          if (cfg.yR && false) {
            return $author$project$Ui$SectionBar$showInfo;
          } else {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          }
        }
      }
    }();

    var backgroundColor = function () {
      var _v0 = cfg.u5;
      return 'gray10Back';
    }();

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padBottom3 padTop3 padLeft4 padRight4 flexRow spaceBetween flexAlignCenter '), $elm$html$Html$Attributes$class(backgroundColor)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary30 marRight2h minW13')]), _List_fromArray([$elm$html$Html$text(sectionName)])), message])), A3($author$project$ElmFramework$Lib$Ui$Button$button, $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.BZ), _List_fromArray([$elm$html$Html$Attributes$class('w3')]), _List_fromArray([toggleSection('primary30Fill')]))]));
  };

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius2 mar2 black blackBorder phoneWidthCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad1 fontSize1')]), _List_fromArray([$elm$html$Html$text(cfg.t1)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad1')]), cfg.K)]));
  };

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius2 mar2 black blackBorder desktopWidthCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad1 fontSize1')]), _List_fromArray([$elm$html$Html$text(cfg.t1)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad1')]), cfg.K)]));
  };

  var $author$project$ElmFramework$Lib$Ui$Table$tableHeader = function (cfg) {
    var defaultHeaderClass = '';
    var defaultHeaderCellsClass = 'heading5Bold minW13 flexAlignCenter gray40 marBottom2';
    var aggregateHeaderCellsClass = 'heading5Bold minW15 primary30 marBottom2 whiteBack right aggregate';

    var _v0 = function () {
      var _v1 = cfg.kH;

      if (!_v1.$) {
        var classes = _v1.a;
        var headerCells = classes.lC === '' ? defaultHeaderCellsClass : classes.lC;
        var header = classes.lD === '' ? defaultHeaderClass : classes.lD;
        return _Utils_Tuple2(header, headerCells);
      } else {
        return _Utils_Tuple2('', defaultHeaderCellsClass);
      }
    }();

    var headerClass = _v0.a;
    var headerCellsClass = _v0.b;
    return A2($elm$html$Html$tr, _List_fromArray([$elm$html$Html$Attributes$class(headerClass)]), _Utils_ap(A2($elm$core$List$indexedMap, F2(function (index, header) {
      var align_ = !index ? 'left padLeft2 ' : 'right ';

      var classes = _Utils_ap(align_, headerCellsClass);

      return A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class(classes)]), _List_fromArray([$elm$html$Html$text(header)]));
    }), cfg.wx.x5), _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class(aggregateHeaderCellsClass)]), _List_fromArray([$elm$html$Html$text('Grand Total')]))])));
  };

  var $elm$core$List$sum = function (numbers) {
    return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
  };

  var $author$project$ElmFramework$Lib$Ui$Table$toCellText = function (num) {
    var plusOrMinus = num < 0 ? '- $ ' + A3($elm$core$String$replace, '-', '', $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromFloat(num))) : '+ $ ' + $author$project$Ui$TimeTransformation$Util$numStringToUsLocale($elm$core$String$fromFloat(num));
    var cellText = A2($elm$core$String$contains, '.', plusOrMinus) ? plusOrMinus : plusOrMinus + '.00';
    return cellText;
  };

  var $author$project$ElmFramework$Lib$Ui$Table$tableAggregateRow = F2(function (row, cls) {
    return A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class(cls + ' aggregate')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text($author$project$ElmFramework$Lib$Ui$Table$toCellText($elm$core$List$sum(row)))]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$Table$tableCell = F2(function (cell, cls) {
    return A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('h4')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cls)]), _List_fromArray([$elm$html$Html$text($author$project$ElmFramework$Lib$Ui$Table$toCellText(cell))]))]));
  });
  var $author$project$ElmFramework$Lib$Ui$Table$tableRow = F3(function (index, row, classes) {
    var defaultRowHeaderClass = 'heading4Bold minW16 primary30 pad2';
    var defaultRowClass = !A2($elm$core$Basics$modBy, 2, index) ? 'whiteBack' : 'gray10Back';
    var defaultRowCellsClass = 'heading4Regular flexAlignCenter right primary30 gray10Border w14';
    var aggregateCellClass = defaultRowClass + ' aggregate primary20 heading4Bold right ';

    var _v0 = function () {
      if (!classes.$) {
        var cls = classes.a;
        var rowHeaderCls = cls.nS === '' ? defaultRowHeaderClass : cls.nS;
        var rowCls = cls.nQ === '' ? defaultRowClass : cls.nQ;
        var rowCellsCls = cls.nP === '' ? defaultRowCellsClass : cls.nP;
        return _Utils_Tuple3(rowHeaderCls, rowCls, rowCellsCls);
      } else {
        return _Utils_Tuple3(defaultRowHeaderClass, defaultRowClass, defaultRowCellsClass);
      }
    }();

    var rowHeaderClass = _v0.a;
    var rowClass = _v0.b;
    var rowCellsClass = _v0.c;

    var header = function () {
      var _v2 = row.te;

      if (!_v2.$) {
        var headerText = _v2.a;
        return A2($elm$html$Html$td, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(rowHeaderClass)]), _List_fromArray([$elm$html$Html$text(headerText)]))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();

    return A2($elm$html$Html$tr, _List_fromArray([$elm$html$Html$Attributes$class(rowClass)]), _Utils_ap(A2($elm$core$List$cons, header, A2($elm$core$List$map, function (d) {
      return A2($author$project$ElmFramework$Lib$Ui$Table$tableCell, d, rowCellsClass);
    }, row.nR)), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$Table$tableAggregateRow, row.nR, aggregateCellClass)])));
  });

  var $author$project$ElmFramework$Lib$Ui$Table$tableRows = function (cfg) {
    return A2($elm$core$List$indexedMap, F2(function (i, d) {
      return A3($author$project$ElmFramework$Lib$Ui$Table$tableRow, i, d, cfg.kH);
    }), cfg.wx.tf);
  };

  var $author$project$ElmFramework$Lib$Ui$Table$table = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('tableWrap relative scrollTargetX')]), _List_fromArray([A2($elm$html$Html$table, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap'), $elm$html$Html$Attributes$class(cfg.kG)]), A2($elm$core$List$cons, $author$project$ElmFramework$Lib$Ui$Table$tableHeader(cfg), $author$project$ElmFramework$Lib$Ui$Table$tableRows(cfg)))]));
  };

  var $author$project$Ui$Chart$ProjectionChart$tooltipBodyTabular = function (data) {
    var rowView = F3(function (key, cfg, symbol) {
      return A2($elm$html$Html$tr, _List_Nil, _List_fromArray([A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray20 padRight2')]), _List_fromArray([$elm$html$Html$text(key + ':')])), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('bodyBold primary0')]), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, function (val) {
        return _List_fromArray([$elm$html$Html$text($author$project$Ui$TimeTransformation$Util$toStringFromFraction(val) + (' ' + symbol))]);
      }, cfg.fF)), A2($elm$html$Html$td, _List_fromArray([$elm$html$Html$Attributes$class('bodyBold primary0')]), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, function (val) {
        return _List_fromArray([$elm$html$Html$text($author$project$Ui$TimeTransformation$Util$toStringFromFraction(val) + (' ' + symbol))]);
      }, cfg.Dw))]));
    });
    var mainHeadCell = F2(function (title, classes) {
      return _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('minW9 left'), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([$elm$html$Html$text(title)]))]);
    });

    var emptyHeadCell = _List_fromArray([A2($elm$html$Html$th, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_Nil)]);

    var headingRow = _Utils_ap(emptyHeadCell, _Utils_ap(A2(mainHeadCell, 'Budget', 'secondary0 padRight2 '), A2(mainHeadCell, 'Scenario', 'gray40')));

    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 primary30Back inlineBlock')]), _List_fromArray([A2($elm$html$Html$table, _List_Nil, _List_fromArray([A2($elm$html$Html$thead, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold')]), _List_fromArray([A2($elm$html$Html$tr, _List_Nil, headingRow)])), A2($elm$html$Html$tbody, _List_Nil, _List_fromArray([A3(rowView, 'Revenue ', data.C9, 'k'), A3(rowView, 'Gross Margin ', data.x0, '%'), A3(rowView, 'Operating Margin ', data.Ce, '%'), A3(rowView, 'Net Margin ', data.zQ, '%')]))]))]));
  };

  var $author$project$ElmFramework$Lib$Ui$UserProfileImg$userProfileImg = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenterColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary30')]), _List_fromArray([$elm$html$Html$text('Account Settings')])), function () {
      var _v0 = cfg.u2;

      if (!_v0.b) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle w22 h22 gray10Back heroBold primary20 flexCenter marTop5')]), _List_fromArray([$elm$html$Html$text('UN')]));
      } else {
        return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          vz: cfg.vz,
          vV: 'circle',
          yj: cfg.u2,
          FF: 4.5,
          FH: 'inlineBlock relative w22 h22'
        });
      }
    }(), $author$project$Ui$Button$basicButtonVeryBasic({
      kG: 'minH5 marTop4',
      vY: 1,
      yh: $elm$core$Maybe$Nothing,
      yM: false,
      f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
      y$: 'Update Photo'
    })]));
  };

  var $author$project$Types$Mock$valuesOnDates = A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$SimpleDate$toDateString, _List_fromArray([_Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 15), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 19), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 4000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 26), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 30), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 1, 11), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 4, 11), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 500, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 4, 21), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 4, 18), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 500, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 4, 29), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1500, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 9, 3), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2500, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 9, 10), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3500, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 9, 13), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 200, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 9, 23), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 400, 1))]));

  var $author$project$Ui$Slider$verticalSlider = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$verticalSlider({
      yM: config.yM,
      l: config.l,
      m: config.m,
      e_: config.e_,
      dg: config.kG,
      eb: config.eb,
      dk: 'primary30Back',
      dl: '',
      dp: 'gray20Back',
      dq: 'gradient0Back',
      dr: '',
      Fw: config.Fw
    });
  };

  var $author$project$ElmFramework$Feature$Browser$Browser$toHeightInUnits = function (_v0) {
    var height = _v0.x6;
    var unitSize = _v0.j6;
    return height / unitSize;
  };

  var $author$project$ElmFramework$Feature$Browser$Browser$isLargerThan = F2(function (browser, _v0) {
    var minWidth = _v0.a;
    var minHeight = _v0.b;
    return _Utils_cmp($author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits(browser), minWidth) > 0 && _Utils_cmp($author$project$ElmFramework$Feature$Browser$Browser$toHeightInUnits(browser), minHeight) > 0;
  });

  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$shouldDetachFromEdges = function (browser) {
    return A2($author$project$ElmFramework$Feature$Browser$Browser$isLargerThan, browser, _Utils_Tuple2(54, 60));
  };

  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBottomSpacer = F2(function (heightUnits, browser) {
    var heightClass = $author$project$ElmFramework$Lib$Ui$NavBarBottom$shouldDetachFromEdges(browser) ? 'h' + $elm$core$String$fromInt(heightUnits + 2) : 'h' + $elm$core$String$fromInt(heightUnits);
    return A3($elm$html$Html$node, 'nav-bar-bottom-spacer', _List_fromArray([$elm$html$Html$Attributes$class('block')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$bottomAppSpacer, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(heightClass)]), _List_Nil)]));
  });
  var $author$project$Ui$NavBarBottom$navBarHeight = 6;
  var $author$project$Ui$NavBarBottom$navBarBottomSpacer = $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBottomSpacer($author$project$Ui$NavBarBottom$navBarHeight);
  var $author$project$UiPrimitives$ScrollTarget$behindBars = F5(function (browser, isViewport, background, env, content) {
    return A3($elm$html$Html$node, 'behind-bars', _List_fromArray([$elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('absoluteSpread scrollTarget', isViewport)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative fullMinHeight'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('noOverflow', !isViewport)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread')]), _List_fromArray([background])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _Utils_ap(content, _List_fromArray([$author$project$Ui$NavBarBottom$navBarBottomSpacer(browser)])))]))]));
  });

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$wrap = function (cfg) {
    return A5($author$project$UiPrimitives$ScrollTarget$behindBars, cfg.vz, true, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread white')]), _List_Nil), cfg.xz, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), cfg.pB)]));
  };

  var $author$project$Ui$ComponentsPreview$ComponentsPreview$view = F3(function (env, browser, topState) {
    return $author$project$Ui$ComponentsPreview$ComponentsPreview$wrap({
      vz: browser,
      pB: _List_fromArray([$author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([A2($author$project$Ui$NestedTable$NestedTable$exampleView2, A2($elm$core$Basics$composeR, $author$project$Ui$ComponentsPreview$Msg$ToggleExpandRow, $author$project$TopMsg$msgComponentsPreview), topState.o_.v8.hQ)]),
        t1: 'Nested table 2'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([A3($author$project$Ui$DateInput$DateInput$dateInputView, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$DateInputMsg), topState.o_.v8.iL, topState.by)]),
        t1: 'Single Date picker'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$SwitchDropdown$switchDropdown({
          uE: 'All',
          kG: '',
          zy: $elm$core$Maybe$Nothing,
          zT: 'None',
          Ad: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$SwitchSelectClearedAll),
          BF: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$SwitchSelectSelectedAll),
          BX: F2(function (key, _v0) {
            return $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$SwitchSelectToggled(key));
          }),
          e0: topState.o_.v8.jY,
          e3: 'Choose Value',
          ia: topState.o_.v8.eC,
          t3: $elm$core$Basics$identity
        })]),
        t1: 'switchDropdown'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$InfoTooltipTrigger$infoTooltipTrigger('Some tooltip label')]),
        t1: 'Tooltip'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Sign In', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Register', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Auth($author$project$Route$Route$Register($elm$core$Maybe$Nothing)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Forgot Password', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Onboard > Company Info', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(0))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Onboard > Add Users', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(1))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Onboard > Division', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(2))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Onboard > Create Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$OnboardingCompany(3))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Cashboard Home', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$CashboardHome)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Choose Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$ChooseScenario)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Building Blocks', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$BuildingBlocks(0))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Building Blocks > Building Blocks Filters', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$BuildingBlocks(1))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Comments Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CommentsRoute))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Comments Replies', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CommentReplies('comment-id')))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Comments Filters', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CommentsFilters))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Create Comment > Choose Review', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$ChooseReview)))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Create Comment > Create Review', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$CreateReview)))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Create Comment > Confirm Deleting Review', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$ConfirmDeletingReview('review -id'))))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Create Comment > Create Comment For Review', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$CreateCommentForReview('review -id'))))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Cashboard > Comments > Create Comment > Create Independent Comment', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Cashboard, $author$project$Types$Mock$cashboardQuery, $author$project$Route$CashboardRoute$Comments($author$project$Route$CommentsRoute$CreateComment($author$project$Route$CreateCommentRoute$CreateIndependentComment)))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Budget > Budget Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Budget, $author$project$Types$Mock$budgetQuery, 0)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Budget > Choose Budget Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', A2($author$project$Route$CompanyRoute$Budget, $author$project$Types$Mock$budgetQuery, 1)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Scenarios', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Create Scenario > Edit Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(0))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Create Scenario > Building Block Filters', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(1))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Create Scenario > Building Block Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(2))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Create Scenario > Edit Master Block', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(3))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Create Scenario > Delete Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$CreateScenario(4))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Edit Scenario > Edit Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, 'scenario-id', 0))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Edit Scenario > Building Block Filters', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, 'scenario-id', 1))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Edit Scenario > Building Block Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, 'scenario-id', 2))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Edit Scenario > Edit Master Block', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, 'scenario-id', 3))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Scenarios > Edit Scenario > Delete Scenario', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Scenarios(A2($author$project$Route$ScenariosRoute$EditScenario, 'scenario-id', 4))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Blocks Basic', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksBasic(false))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Blocks Classification', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksClassification(false))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Block Basic Details', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlockBasicDetails('building-block-id'))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Block Classification Details', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$BlocksClassificationDetails('building-block-id'))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Create Block > Edit Building Block Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$CreateBlock(0))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Create Block > Delete Block', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks($author$project$Route$BlocksRoute$CreateBlock(1))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Edit Block > Edit Building Block Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks(A2($author$project$Route$BlocksRoute$EditBlock, 'building-block-id', 0))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Blocks > Edit Block > Delete Block', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Blocks(A2($author$project$Route$BlocksRoute$EditBlock, 'building-block-id', 1))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Financial Accounts > Financial Accounts Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$FinancialAccountsRoute)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Financial Accounts > Add Financial Account', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$AddFinancialAccount)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Financial Accounts > Edit Financial Account', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$EditFinancialAccount('financial-account-id'))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Financial Accounts > Delete Financial Account', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$FinancialAccounts($author$project$Route$FinancialAccountsRoute$DeleteFinancialAccount('financial-account-id'))))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Settings > Company Info', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Settings(0)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Settings > Preferences', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Settings(1)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Settings > Company Users > Company Users Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Settings(2)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Company > Settings > Divisions', $author$project$ElmFramework$MsgCmd$msgCmd.Dn(A2($author$project$Route$Route$SelectedCompany, '93e34eda-95a9-4377-a950-df31ee1bb1c6', $author$project$Route$CompanyRoute$Settings(3)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'User Profile > User Profile Route', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$UserProfileRoute))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'User Profile > User Profile Route > Change Email ', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$ChangeEmail))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'User Profile > User Profile Route > Change Password', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$ChangePassword))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'User Profile > User Profile Route > Delete Account', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$UserProfile($author$project$Route$UserProfileRoute$DeleteAccount))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Legal > Legal Route > Legal Route Terms of Use', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(0))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Legal > Legal Route > Legal Route Privacy Policy', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(1))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Legal > Legal Route > Legal Route Cookies', $author$project$ElmFramework$MsgCmd$msgCmd.Dn($author$project$Route$Route$Legal(2)))]),
        t1: 'Routes'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([A2($elm$html$Html$map, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$TimeTransformation$SelectionGraph$View$selectionGraph({
          vL: $elm$core$Maybe$Nothing,
          vV: '',
          bq: $elm$core$Maybe$Nothing,
          xv: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 11, 31),
          ss: $author$project$Ui$ComponentsPreview$Msg$TimeTransformationMsg,
          Eg: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 1),
          Ej: topState.o_.v8.$9,
          tY: 0,
          uh: $author$project$Types$Mock$valuesOnDates
        }))]),
        t1: 'TimeTransformation - Selection'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([A2($elm$html$Html$map, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$TimeTransformation$InputGraph$View$inputGraph({
          vV: '',
          bq: $elm$core$Maybe$Nothing,
          xv: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 11, 31),
          Ck: A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$SimpleDate$toDateString, _List_fromArray([_Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 1, 15), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 1000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 1, 19), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 4000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 1, 26), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2000, 1)), _Utils_Tuple2(A3($author$project$Types$SimpleDate$SimpleDate, 2020, 1, 30), A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 3000, 1))])),
          ss: $author$project$Ui$ComponentsPreview$Msg$TimeTransformationMsg,
          D8: true,
          Eg: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 1),
          Ej: topState.o_.v8.$9,
          tY: 0,
          uh: $author$project$Types$Mock$valuesOnDates
        }))]),
        t1: 'TimeTransformation - Assignment'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$RangeDateInputMsg), A3($author$project$Ui$RangeDateInput$RangeDateInput$viewRangeDateInput, {
          xx: 'End Date',
          Ei: 'Start Date'
        }, topState.o_.v8.jy, topState.by))]),
        t1: 'Range Date picker'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$ElmFramework$Lib$Ui$Table$table({
          kG: 'marTop2',
          kH: $elm$core$Maybe$Nothing,
          wx: $author$project$ElmFramework$Lib$Ui$Table$mockData
        })]),
        t1: 'table'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Button$buttonContentIcon({
          vV: 'marLeft3',
          yh: $author$project$IconSvg$close,
          qO: $elm$core$Maybe$Nothing,
          y$: 'Close',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTap),
          tM: 0
        }), $author$project$Ui$Button$buttonContentIcon({
          vV: 'marLeft3',
          yh: $author$project$IconSvg$arrowRight,
          qO: $elm$core$Maybe$Nothing,
          y$: 'Skip Step',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTap),
          tM: 2
        }), $author$project$Ui$Button$buttonContentIcon({
          vV: 'marLeft3',
          yh: $author$project$IconSvg$close,
          qO: $elm$core$Maybe$Nothing,
          y$: '',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTap),
          tM: 2
        })]),
        t1: 'buttonContentIcon'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Button$basicButton({
          kG: 'fullWidth primary0',
          vY: 0,
          yh: $elm$core$Maybe$Nothing,
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NextStepFrom)),
          y$: 'Button primary'
        })]),
        t1: 'buttonPrimary'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Button$buttonSelectHigh({
          vV: '',
          yC: _Utils_eq(topState.o_.v8.i1, $elm$core$Maybe$Just(4)),
          y$: 'Wednesday',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTapWeekday(4))
        }), $author$project$Ui$Button$buttonSelectHigh({
          vV: 'marLeft2',
          yC: _Utils_eq(topState.o_.v8.i1, $elm$core$Maybe$Just(6)),
          y$: 'Wednesday',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTapWeekday(6))
        })]),
        t1: 'buttonSelect'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$InputComponent$inputField({
          fx: $elm$core$Maybe$Nothing,
          vV: '',
          E: $elm$core$Maybe$Just('New Name'),
          k_: false,
          qU: 0,
          qW: true,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInput),
          e3: 'New Name',
          gx: false,
          Fw: topState.o_.v8.yw
        })]),
        t1: 'textInput'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Comment$comment({
          v2: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
          iK: $elm$time$Time$millisToPosix(1620557035602),
          yS: topState.o_.v8.h_,
          zL: 'Mike M.',
          rE: 1,
          CY: 2,
          tU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTapDotMenu)
        })]),
        t1: 'comment'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Slider$horizontalSlider({
          kG: '',
          yM: false,
          l: 100.0,
          m: 0.0,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnSlide),
          eb: 1.0,
          Fw: topState.o_.v8.jS
        })]),
        t1: 'horizontalSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Slider$horizontalSliderInputLeft({
          kG: 'fontSize3',
          qR: '20%',
          iX: '3ch',
          yM: false,
          yW: false,
          l: 100.0,
          m: 0.0,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnSlideWithInput),
          eb: 1.0,
          Fw: topState.o_.v8.ty,
          ui: 0
        })]),
        t1: 'horizontalSliderInputLeft'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Slider$horizontalSliderSuffixedInputRight({
          kG: 'fontSize3',
          iX: '20%',
          qS: '3ch',
          yM: false,
          yW: false,
          l: 100.0,
          m: 0.0,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnSlideWithInput),
          eb: 1.0,
          tR: '',
          tS: '%',
          Fw: topState.o_.v8.ty,
          ui: 0
        })]),
        t1: 'horizontalSliderSuffixedInputRight'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Slider$verticalSlider({
          kG: '',
          yM: false,
          l: 100.0,
          m: 0.0,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnSlide),
          eb: 1.0,
          Fw: topState.o_.v8.jS
        })]),
        t1: 'verticalSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Slider$verticalSliderInputBottom({
          kG: 'fontSize3 w8',
          qR: '20%',
          iX: '6ch',
          yM: false,
          yW: false,
          l: 100.0,
          m: 0.0,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnSlideWithInput),
          eb: 1.0,
          Fw: topState.o_.v8.ty,
          ui: 0
        })]),
        t1: 'verticalSliderInputBottom'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$ElmFramework$Lib$Ui$TitleTypes$mainTitleSubtitle({
          pv: '',
          vV: '',
          tQ: $elm$core$Maybe$Just($author$project$ElmFramework$Lib$Ui$TitleTypes$GrayColorSubtitle('Social and ecological entrepreneurs, change-makers, movers, dreamers. We are here for you!  ')),
          t1: 'Create an Account'
        })]),
        t1: 'titleSubtitle'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Input$inputWithIcon({
          vV: '',
          yh: $author$project$IconSvg$search,
          e3: 'Placeholder',
          gx: false,
          b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInput),
          P: 'text',
          Fw: topState.o_.v8.yw
        })]),
        t1: 'inputWithIcon'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Switch$switch({
          vV: '',
          hE: topState.o_.v8.fc,
          yW: true,
          tU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch)
        })]),
        t1: 'switch'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$ComponentsPreview$ComponentsPreview$signInRegisterOption({
          kz: 'Sign In Instead',
          gi: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTap),
          tX: 'Already have an account?'
        })]),
        t1: 'signInRegisterOption'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Button$buttonIconContentBasic({
          vV: '',
          yh: $author$project$IconSvg$arrowLeft,
          qO: $elm$core$Maybe$Nothing,
          y$: 'Back',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTap),
          tM: 2
        })]),
        t1: 'buttonIconContentBasic'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Textarea$textarea({
          vV: '',
          wK: function (_v1) {
            return $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp);
          },
          yi: 'someIdentifier',
          yW: false,
          zW: '',
          A5: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInput),
          D4: false,
          D5: false,
          EJ: 'Enter Description',
          Fv: topState.o_.v8.yw
        })]),
        t1: 'textArea'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Input$inputBtn({
          gW: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$Action(0)),
          vV: '',
          yh: $author$project$IconSvg$edit,
          y$: 'E-mail',
          e3: 'namelastname@email.com',
          gx: false,
          P: 'email',
          Fw: ''
        })]),
        t1: 'disabledInputbtn'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$OnboardingProgressBar$progressBar({
          wn: 1
        })]),
        t1: 'progressBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$InputSearchDropdown$inputSearchDropdownBasic({
          kG: '',
          pY: 'Recently Used',
          yM: false,
          yW: false,
          Ac: $elm$core$Maybe$Nothing,
          Ar: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnCreateNew)),
          Aw: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$FilterInputSearchDropdownResults)),
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInput),
          BE: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInputSearchDropdownSelect),
          e3: 'Placeholder',
          C5: function (_v2) {
            return $author$project$IconSvg$update('h3 w3 gray20Fill');
          },
          C6: $elm$core$Basics$identity,
          C7: topState.o_.v8.hD,
          ia: topState.o_.v8.jN,
          Fw: topState.o_.v8.yw
        })]),
        t1: 'inputSearchDropdown'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$SelectSearchInput$selectSearchInput({
          kG: '',
          yt: 'search...',
          yw: topState.o_.v8.yw,
          yM: false,
          yW: false,
          Aw: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$FilterInputSearchDropdownResults),
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInput),
          BE: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInputSearchDropdownSelect),
          C6: $elm$core$Basics$identity,
          C7: topState.o_.v8.hD,
          DK: 'Select Business',
          ia: topState.o_.v8.jN
        })]),
        t1: 'selectSearchInput'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$ElmFramework$Lib$Ui$TextAreaSelfSize$textAreaSelfSize({
          vv: true,
          kG: '',
          k_: false,
          e_: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$OnInput),
          e3: 'Type something...',
          gx: false,
          Fw: topState.o_.v8.yw,
          dJ: 'block'
        })]),
        t1: 'framework - textAreaSelfSize'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$ScenarioBlock$scenarioBlock({
          y: $author$project$Types$Mock$block,
          pi: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp), 'Use block on scenario')),
          j: $author$project$Types$Mock$company,
          qY: $elm$core$Maybe$Nothing,
          tO: $elm$core$Maybe$Just('Retail'),
          by: $elm$time$Time$utc
        }), $author$project$Ui$ScenarioBlock$scenarioBlock({
          y: $author$project$Types$Mock$block,
          pi: $elm$core$Maybe$Nothing,
          j: $author$project$Types$Mock$company,
          qY: $elm$core$Maybe$Just({
            vj: 0,
            vx: A2($author$project$Ui$ScenarioBlock$BottomInteractionSwitch, topState.o_.v8.fc, $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch)),
            wM: 0,
            x4: true,
            yS: topState.o_.qC.nl === 'preview',
            z3: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            z7: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            hT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            hU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            hW: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            A2: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            By: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
            BA: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
            BD: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            sd: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$TogglePopupMenu('preview'))
          }),
          tO: $elm$core$Maybe$Just('Retail'),
          by: $elm$time$Time$utc
        })]),
        t1: 'scenarioBlock'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$ScenariosOptionsSingleBlock$scenariosOptionsSingleBlock({
          u0: $krisajenkins$remotedata$RemoteData$NotAsked,
          vV: '',
          b9: $author$project$Types$Mock$company.F,
          yG: true,
          yH: true,
          yS: topState.o_.v8.h_,
          AJ: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          AP: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          AU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          A3: $elm$core$Maybe$Nothing,
          Bd: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          Bk: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BI: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BJ: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          sd: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnTapDotMenu),
          Dw: $author$project$Types$Mock$scenario,
          DY: $author$project$Types$Mock$session,
          tU: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
          by: $elm$time$Time$utc
        })]),
        t1: 'scenariosOptionsSingleBlock'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$SwitchLabelLeft$switchLabelLeft({
          vV: '',
          yC: topState.o_.v8.fc,
          y$: 'Delete all my accounts and scenarios.',
          y1: '',
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch)
        })]),
        t1: 'switchLabelLeft'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$SwitchBlockLabeled$switchBlockLabeled({
          vV: 'primary10Back',
          yC: topState.o_.v8.fc,
          y$: $author$project$Ui$SwitchBlockLabeled$SwitchLabelRight('Set as Budget Scenario'),
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch)
        })]),
        t1: 'switchBlockLabeled'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Button$appButton({
          vV: '',
          f9: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NextStepFrom)
        })]),
        t1: 'appButton'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$UsersTable$infoTag({
          vV: '',
          yh: true,
          y$: 'Puffin User',
          EI: 0
        })]),
        t1: 'infoTag'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$UsersTable$usersTable({
          vz: browser,
          vV: '',
          Ft: _List_fromArray([$author$project$Ui$UsersTable$UserStatusPendingWithEmail({
            iP: 'dgjhsgdhsg@gmail.com',
            yS: false,
            Ax: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            hV: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            Bv: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
            se: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
            gz: 6
          }), $author$project$Ui$UsersTable$UserStatusAccepted({
            u2: _List_fromArray([{
              x6: 200,
              Fh: 'https://gravatar.com/avatar/0153c52b54ffab750d06c005926b19d8?s=400&d=robohash&r=x',
              FE: 200
            }]),
            iP: 'dhjshdjeh@gmail.com',
            yS: false,
            zL: 'Bla Bla',
            Ax: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            hV: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
            se: $author$project$ElmFramework$MsgCmd$msgCmd.Df,
            gz: 5
          }), $author$project$Ui$UsersTable$UserStatusPuffinTeamMember({
            u2: _List_Nil,
            zL: 'Bla bla',
            gz: 1
          })])
        })]),
        t1: 'newUserRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$NestedSelect$nestedSelect({
          vV: '',
          yI: true,
          zO: '',
          e0: $elm$core$Maybe$Just(topState.o_.v8.dX),
          e3: 'Choose...',
          nY: $elm$core$Maybe$Just('Filter by Date'),
          Ej: topState.o_.v8.d6,
          b3: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgComponentsPreview, $author$project$Ui$ComponentsPreview$Msg$NestedSelectChanged),
          fd: $elm$core$Basics$eq,
          t3: $elm$core$Basics$identity
        })]),
        t1: 'nestedSelect'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$DivisionBar$divisionBar({
          k2: 'Division’s name',
          yC: false,
          yJ: false,
          y$: 'Sync Division',
          Bq: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
        })]),
        t1: 'divisionBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$ReviewRow$reviewRow({
          cC: 'Mark L.',
          wk: $elm$time$Time$millisToPosix(1610000000000),
          yS: true,
          AH: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          Bh: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BH: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          sd: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          Db: 'Review’s Name',
          Dc: $author$project$Types$Review$Pending,
          by: $elm$time$Time$utc
        })]),
        t1: 'reviewRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
          vV: '',
          v_: $elm$core$Maybe$Just(2),
          wm: topState.o_.v8.l8,
          hH: _List_fromArray([_Utils_Tuple2(0, 'Terms & Conditions'), _Utils_Tuple2(1, 'Privacy policy'), _Utils_Tuple2(2, 'Cookies')]),
          BE: function (curr) {
            return $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnSelectLegal(curr));
          },
          BP: ''
        })]),
        t1: 'slideSelectMultiple'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$ElmFramework$Lib$Ui$UserProfileImg$userProfileImg({
          u2: _List_fromArray([{
            x6: 200,
            Fh: 'https://gravatar.com/avatar/0153c52b54ffab750d06c005926b19d8?s=400&d=robohash&r=x',
            FE: 200
          }]),
          vz: browser
        })]),
        t1: 'userImg'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Button$scenarioTypeButton({
          kG: '',
          qq: 'Scenario\'s Name',
          yM: false,
          f9: $author$project$ElmFramework$Lib$Ui$Button$Submit,
          tk: 'Switch Scenario'
        })]),
        t1: 'scenarioTypeButton'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
          vV: '',
          v_: $elm$core$Maybe$Just(3),
          wm: topState.o_.v8.kB,
          hH: _List_fromArray([_Utils_Tuple2(0, 'Cash'), _Utils_Tuple2(1, 'Credit')]),
          BE: function (curr) {
            return $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnSelectCashOrCredit(curr));
          },
          BP: 'minH4'
        }), $author$project$Ui$SlideSelectMultiple$slideSelectMultiple({
          vV: 'marTop2',
          v_: $elm$core$Maybe$Just(0),
          wm: topState.o_.v8.kc,
          hH: _List_fromArray([_Utils_Tuple2(0, 'Scenarios'), _Utils_Tuple2(1, 'Blocks')]),
          BE: function (curr) {
            return $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$OnSelectScenariosOrBlocks(curr));
          },
          BP: ''
        })]),
        t1: 'slideSelect'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$CommentBlock$commentBlock({
          vV: '',
          U: $author$project$Types$Mock$comment,
          b9: $author$project$Types$Mock$company.F,
          v7: 0,
          yS: true,
          zX: $elm$time$Time$millisToPosix(1610172800000),
          z5: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          Ae: $elm$core$Maybe$Nothing,
          AD: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          AR: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          A4: $elm$core$Basics$always($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          sd: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          CY: 5,
          bi: $elm$core$Maybe$Nothing,
          DY: $author$project$Types$Mock$session,
          eG: topState
        })]),
        t1: 'commentBlock'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$DisabledInputBtn$disabledInputBtn({
          vV: '',
          zL: 'E-mail',
          hV: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          EH: 'namelastname@email.com'
        })]),
        t1: 'disabledInputBtn'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$SectionBar$sectionBar({
          u5: 0,
          yR: false,
          BZ: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          DH: true,
          DI: A4($author$project$Ui$SectionBar$Growth, 20, 30, 'Weeks', $elm$time$Time$millisToPosix(1610000000000)),
          by: $elm$time$Time$utc
        })]),
        t1: 'sectionBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$AccountRow$accountRow({
          uy: $author$project$Types$Mock$financialAccount,
          vV: '',
          R: $author$project$Types$Mock$division,
          yC: true,
          yF: true,
          q1: true,
          yS: true,
          Ay: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          AT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          A0: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          A1: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          sd: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          DY: $author$project$Types$Mock$session,
          by: $elm$time$Time$utc
        })]),
        t1: 'accountRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$DivisionRow$divisionRow({
          pE: '00',
          k2: 'Division Name',
          pV: 3,
          q0: true,
          yS: true,
          rO: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          AT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          rU: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          rY: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          r9: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          sf: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          sg: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          so: $elm$core$Maybe$Just('Overlay Division Name'),
          tn: 'Sector Goe Here'
        }), $author$project$Ui$DivisionRow$divisionRow({
          pE: '00',
          k2: 'Division Name',
          pV: 2,
          q0: true,
          yS: true,
          rO: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          AT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          rU: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          rY: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          r9: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          sf: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          sg: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          so: $elm$core$Maybe$Nothing,
          tn: 'Sector Goe Here'
        })]),
        t1: 'divisionRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$FinancialBlock$financialBlock({
          iz: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod adipiscing elit.',
          vV: '',
          i4: true,
          yS: true,
          ja: false,
          jb: false,
          jc: false,
          zL: 'Block name',
          hT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hW: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BE: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jq: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jr: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          js: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jI: $elm$core$Maybe$Just('tooltip'),
          db: _List_fromArray([{
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }])
        }), $author$project$Ui$FinancialBlock$financialBlock({
          iz: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod adipiscing elit.',
          vV: '',
          i4: true,
          yS: false,
          ja: true,
          jb: false,
          jc: true,
          zL: 'Block Name',
          hT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hW: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BE: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jq: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jr: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          js: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jI: $elm$core$Maybe$Just('tooltip'),
          db: _List_fromArray([{
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }])
        })]),
        t1: 'financialBlock'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([$author$project$Ui$FinancialBlock$financialBlock({
          iz: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod adipiscing elit.',
          vV: '',
          i4: true,
          yS: true,
          ja: false,
          jb: true,
          jc: false,
          zL: 'Block name',
          hT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hW: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BE: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jq: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jr: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          js: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jI: $elm$core$Maybe$Just('tooltip'),
          db: _List_fromArray([{
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }])
        }), $author$project$Ui$FinancialBlock$financialBlock({
          iz: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod adipiscing elit.',
          vV: '',
          i4: true,
          yS: false,
          ja: true,
          jb: true,
          jc: true,
          zL: 'Block Name',
          hT: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hU: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          hW: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          BE: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jq: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jr: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          js: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp),
          jI: $elm$core$Maybe$Just('tooltip'),
          db: _List_fromArray([{
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }, {
            y$: 'Scenario Long Name',
            ew: $author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }])
        })]),
        t1: 'financialBlockRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([A2($author$project$Ui$Chart$ProjectionChart$toTooltipView, 0, {
          kd: $elm$core$Maybe$Just({
            Cu: A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 14, 10),
            Cv: 0
          }),
          zx: $author$project$Types$CashboardQuery$PeriodMetricsCash({
            pm: $elm$core$Maybe$Nothing,
            tg: $elm$core$Maybe$Just(1)
          }),
          ap: {
            xw: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 29),
            Ef: A3($author$project$Types$SimpleDate$SimpleDate, 2020, 0, 24)
          },
          np: A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 14, 10),
          CC: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 2, 2)),
          or: A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 14, 10)
        })]),
        t1: 'Chart Tooltip: Ui.Chart.ProjectionChart.toTooltipView'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        K: _List_fromArray([$author$project$Ui$Chart$ProjectionChart$tooltipBodyTabular({
          x0: {
            fF: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 40, 1)),
            Dw: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 30, 1))
          },
          zQ: {
            fF: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 22, 1)),
            Dw: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 20, 1))
          },
          Ce: {
            fF: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 20, 1)),
            Dw: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 25, 1))
          },
          C9: {
            fF: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 20, 1)),
            Dw: $elm$core$Maybe$Just(A2($JoshuaHall$elm_fraction$Fraction$createUnsafe, 22, 1))
          }
        })]),
        t1: 'Chart Tooltip: Ui.Chart.ProjectionChart.tooltipBodyTabular'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrapWide({
        K: _List_fromArray([A2($author$project$Ui$NestedTable$NestedTable$exampleView, A2($elm$core$Basics$composeR, $author$project$Ui$ComponentsPreview$Msg$ToggleExpandRow, $author$project$TopMsg$msgComponentsPreview), topState.o_.v8.hQ)]),
        t1: 'Nested table'
      })]),
      xz: env,
      Ej: topState.o_.v8
    });
  });

  var $author$project$Views$Routed$RoutedViews$routedViews = function (cfg) {
    var maybeSession = $author$project$Remote$Model$toSession(cfg.Ej.o_.CT);
    var _v0 = cfg.tc;

    switch (_v0.$) {
      case 0:
        var authStep = _v0.a;
        return A2($author$project$Views$Routed$AuthBranch$authBranch, authStep, cfg.Ej);

      case 1:
        return _List_Nil;

      case 4:
        var branch = _v0.a;
        return $author$project$Views$Routed$OnboardingCompanyBranch$onboardingCompanyBranch({
          tc: branch,
          DZ: cfg.Ej.o_.CT.EL,
          eG: cfg.Ej
        });

      case 7:
        var branch = _v0.a;
        return A3($author$project$Views$Routed$LegalBranch$legalBranch, branch, cfg.Ej, cfg.wm);

      case 5:
        var companyId = _v0.a;
        var branch = _v0.b;
        var sessionStatus = cfg.Ej.o_.CT.EL;
        var maybeCompany = A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
          return $.v5;
        }, $turboMaCk$any_dict$Dict$Any$get(companyId)), maybeSession);

        var _v1 = _Utils_Tuple2(maybeSession, maybeCompany);

        if (!_v1.a.$ && !_v1.b.$) {
          var session = _v1.a.a;
          var company = _v1.b.a;
          return $author$project$Views$Routed$CompanyBranch$companyBranch({
            kx: branch,
            j: company,
            mS: A2($elm$core$Basics$composeL, $author$project$ElmFramework$MsgCmd$msgCmd.Dn, $author$project$Route$Route$SelectedCompany(companyId)),
            DY: session,
            DZ: sessionStatus,
            eG: cfg.Ej
          });
        } else {
          return $author$project$Views$Routed$CompanyBranch$companyBranch({
            kx: branch,
            j: $author$project$Types$Mock$company,
            mS: A2($elm$core$Basics$composeL, $author$project$ElmFramework$MsgCmd$msgCmd.Dn, $author$project$Route$Route$SelectedCompany(companyId)),
            DY: $author$project$Types$Mock$session,
            DZ: sessionStatus,
            eG: cfg.Ej
          });
        }

      case 6:
        var userProfileRoute = _v0.a;

        if (!maybeSession.$) {
          var session = maybeSession.a;
          return A3($author$project$Views$Routed$UserProfileBranch$userProfileBranch, userProfileRoute, session, cfg.Ej);
        } else {
          return A3($author$project$Views$Routed$UserProfileBranch$userProfileBranch, userProfileRoute, $author$project$Types$Mock$session, cfg.Ej);
        }

      case 3:
        return _List_Nil;

      case 8:
        return _List_Nil;

      case 10:
        return _List_Nil;

      case 9:
        return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
          Fz: A3($author$project$Ui$ComponentsPreview$ComponentsPreview$view, cfg.Ej.xz, cfg.Ej.vz, cfg.Ej)
        })]);

      case 11:
        return $author$project$Views$Routed$SampleRouteView$sampleRouteView({
          Ej: cfg.Ej.o_
        });

      case 12:
        var userId = _v0.a;
        return $author$project$Views$Routed$RouteWithDataView$routeWithDataView({
          Ej: cfg.Ej.o_,
          oD: userId
        });

      case 13:
        var queryType = _v0.a;
        return $author$project$Views$Routed$RouteWithQueryView$routeWithQueryView({
          CJ: queryType,
          Ej: cfg.Ej.o_
        });

      case 14:
        var someData = _v0.a;
        var subRoute1 = _v0.b;
        return $author$project$Views$Routed$SubRoute1Branch$subRoute1Branch({
          jT: someData,
          Ej: cfg.Ej.o_,
          Es: subRoute1
        });

      case 15:
        var someData = _v0.a;
        var subRoute2 = _v0.b;
        return $author$project$Views$Routed$RouteWithSubSubRouteBranch$routeWithSubSubRouteBranch({
          jT: someData,
          Ej: cfg.Ej.o_,
          Et: subRoute2
        });

      default:
        return _List_Nil;
    }
  };

  var $author$project$MainModule$shouldWhiteSplashBackground = function (route) {
    if (!route.$) {
      return false;
    } else {
      return true;
    }
  };

  var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');

  var $elm$svg$Svg$Attributes$clipPathUnits = _VirtualDom_attribute('clipPathUnits');

  var $author$project$Ui$SquircleSvg$squircleSvg = A2($elm$svg$Svg$svg, _List_fromArray([$elm$svg$Svg$Attributes$class(''), $elm$svg$Svg$Attributes$viewBox('0 0 1 1')]), _List_fromArray([A2($elm$svg$Svg$clipPath, _List_fromArray([$elm$svg$Svg$Attributes$id('squirclePath'), $elm$svg$Svg$Attributes$clipPathUnits('objectBoundingBox')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M0.5 0C0.0714286 0 -2.77778e-09 0.0714286 0 0.500001C-2.77778e-09 0.928573 0.0714286 1 0.5 1C0.928571 1 1 0.928573 1 0.500001C1 0.0714286 0.928571 0 0.5 0Z')]), _List_Nil)]))]));
  var $author$project$AssetsSvg$svgDefinitions = A2($elm$svg$Svg$svg, _List_Nil, _List_fromArray([A2($elm$svg$Svg$defs, _List_Nil, _List_Nil)]));
  var $author$project$IconSvg$svgDefinitions = A2($elm$svg$Svg$svg, _List_Nil, _List_fromArray([A2($elm$svg$Svg$defs, _List_Nil, _List_Nil)]));

  var $author$project$Ui$OnboardingCompany$Model$isBusy = function (state) {
    var _v0 = state.kT;

    if (!_v0.$) {
      return false;
    } else {
      return true;
    }
  };

  var $author$project$Remote$Model$isInteracting = function (remote) {
    var _v0 = remote.EL;

    switch (_v0.$) {
      case 0:
        return false;

      case 1:
        return true;

      case 2:
        return false;

      default:
        return false;
    }
  };

  var $author$project$Remote$Model$isMutating = function (remote) {
    return A2($elm$core$List$any, function ($) {
      return $.eS;
    }, remote.gp);
  };

  var $author$project$MainModule$theCurtain = F2(function (_v0, currRoute) {
    var appState = _v0.o_;

    var _v1 = function () {
      switch (currRoute.$) {
        case 0:
          return _Utils_Tuple2(false, false);

        case 1:
          return _Utils_Tuple2(true, true);

        case 3:
          return _Utils_Tuple2(true, false);

        case 7:
          return _Utils_Tuple2(true, false);

        case 8:
          return _Utils_Tuple2(true, false);

        case 2:
          return _Utils_Tuple2(true, false);

        case 9:
          return _Utils_Tuple2(true, false);

        case 10:
          return _Utils_Tuple2(true, false);

        case 11:
          return _Utils_Tuple2(true, false);

        case 12:
          return _Utils_Tuple2(true, false);

        case 13:
          return _Utils_Tuple2(true, false);

        case 14:
          return _Utils_Tuple2(true, false);

        case 15:
          return _Utils_Tuple2(true, false);

        case 4:
          return _Utils_Tuple2(true, false);

        case 5:
          return _Utils_Tuple2(true, false);

        default:
          return _Utils_Tuple2(true, false);
      }
    }();

    var isBright = _v1.a;
    var shouldShowForRoute = _v1.b;
    return A2($author$project$Ui$Curtain$curtain, isBright, shouldShowForRoute || $author$project$Remote$Model$isMutating(appState.CT) || $author$project$Remote$Model$isInteracting(appState.CT) || $author$project$Ui$OnboardingCompany$Model$isBusy(appState.Cb));
  });

  var $author$project$ElmFramework$Lib$TransitionableViewLayers$transitionableViewLayers = function (list) {
    var toView = function (kind) {
      if (!kind.$) {
        return A2($elm$html$Html$div, _List_Nil, _List_Nil);
      } else {
        var view = kind.a.Fz;
        return view;
      }
    };

    return A2($elm$core$List$map, toView, list.y8);
  };

  var $author$project$Ui$PreventLandscapeSplash$view = A2($elm$html$Html$div, _List_Nil, _List_Nil);

  var $author$project$MainModule$view = function (topState) {
    var appState = topState.o_;
    var env = topState.xz;
    var browser = topState.vz;
    var geolocationAndPermissions = topState.xS;
    var pushNotificationsPermissions = topState.CH;
    var route = topState.tc;
    var zone = topState.by;
    var time = topState.EM;
    var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route);
    var currItem = 0;
    var backgroundColorSplash = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread whiteBack'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !$author$project$MainModule$shouldWhiteSplashBackground(currRoute))]))]), _List_Nil);
    return A3($elm$html$Html$node, 'top-app-node', _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread noOverflow')]), _Utils_ap(_List_fromArray([$author$project$Ui$SquircleSvg$squircleSvg, $author$project$AssetsSvg$svgDefinitions, $author$project$IconSvg$svgDefinitions, backgroundColorSplash]), _Utils_ap($author$project$ElmFramework$Lib$TransitionableViewLayers$transitionableViewLayers({
      y8: $author$project$Views$Routed$RoutedViews$routedViews({
        wm: currItem,
        tc: currRoute,
        Ej: topState
      })
    }), _List_fromArray([$author$project$MainModule$modal(topState), A2($author$project$MainModule$theCurtain, topState, currRoute), $author$project$Ui$PreventLandscapeSplash$view]))));
  };

  var $author$project$Ui$Block$Msg$ReceiveBasicMoneyCharacterization = F3(function (a, b, c) {
    return {
      $: 8,
      a: a,
      b: b,
      c: c
    };
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCharacterizeTimeTransformInput = function (_v1) {
    var input____ = _v1;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('flowOf', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString, input____.dT))), _Utils_Tuple2('inputFlowsOf', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfInputFlowsDescriptorInput(input____.dU))), _Utils_Tuple2('range', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c_, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hd;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('startOn', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.bw))), _Utils_Tuple2('timeTransformInput', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeTimeTransformInput(input____.im)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfInputFlowsDescriptorInput = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('basicBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ct, $author$project$Api$GraphqlSchema$InputObject$encodeBasicBlockDescriptorInput)), _Utils_Tuple2('blockId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dM, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('characterizeTimeTransformInput', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fG, $author$project$Api$GraphqlSchema$InputObject$encodeCharacterizeTimeTransformInput)), _Utils_Tuple2('derivativeBlockDescriptor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bM, $author$project$Api$GraphqlSchema$InputObject$encodeDerivativeBlockDescriptorInput))]));
  };

  var $author$project$Api$GraphqlSchema$Object$TimeTransformsQuery$characterizeTimeTransform = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'characterizeTimeTransform', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCharacterizeTimeTransformInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$TimeTransformCharacterization$baseTimeSeries = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'baseTimeSeries', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$GraphqlSchema$Object$CharacterizeTimeTransformSuccessPayload$characterization = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'characterization', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Types$FlowElem$FlowElem = F2(function (at, qty) {
    return {
      o$: at,
      CI: qty
    };
  });
  var $author$project$Api$GraphqlSchema$Object$FlowElem$at = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.LocalDate', 'at', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).b8.wB);
  var $author$project$Api$GraphqlSchema$Object$FlowElem$qty = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'qty', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$Schema$flowElem = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$FlowElem$qty, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$FlowElem$at, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$FlowElem$FlowElem)));

  var $author$project$Api$GraphqlSchema$Union$CharacterizeTimeTransformPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CharacterizeTimeTransformSuccessPayload', selections____.mG), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Types$CharacterizeTimeTransformResponse$fromCharacterizeTimeTransformSuccessPayloadSchema = F2(function (baseTimeSeries, transformedTimeSeries) {
    return {
      ve: $author$project$Api$Types$CharacterizeTimeTransformResponse$toValueOnDateDictFromFlowElem(baseTimeSeries),
      ox: $author$project$Api$Types$CharacterizeTimeTransformResponse$toValueOnDateDictFromFlowElem(transformedTimeSeries)
    };
  });

  var $author$project$Api$GraphqlSchema$Object$TimeTransformCharacterization$transformedTimeSeries = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'transformedTimeSeries', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$Schema$characterizeTimeTransformPayload = function () {
    var characterizeTimeTransformSuccessPayload = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeTransformCharacterization$transformedTimeSeries($author$project$Api$Schema$flowElem), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TimeTransformCharacterization$baseTimeSeries($author$project$Api$Schema$flowElem), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$CharacterizeTimeTransformResponse$fromCharacterizeTimeTransformSuccessPayloadSchema)));
    return $author$project$Api$GraphqlSchema$Union$CharacterizeTimeTransformPayload$fragments({
      mG: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$CharacterizeTimeTransformSuccessPayload$characterization(characterizeTimeTransformSuccessPayload)),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
  }();

  var $author$project$Api$Api$queryRequestTaskNamed = function (name) {
    return A2($author$project$Api$Api$requestTask, $elm$core$Maybe$Just(name), $dillonkearns$elm_graphql$Graphql$Http$queryRequest);
  };

  var $author$project$Api$GraphqlSchema$Query$timeTransforms = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'timeTransforms', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$InputObject$CharacterizeTimeTransformInput = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$InputObject$OneOfInputFlowsDescriptorInput = $elm$core$Basics$identity;

  var $author$project$Api$Types$CharacterizeTimeTransformReq$toInput = function (req) {
    return {
      dT: req.rv,
      dU: $author$project$Api$Types$CharacterizeTimeTransformReq$toInputFlowsOf(req.qT),
      c_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bw: req.bw,
      im: $author$project$Api$Types$TimeTransformationReq$toTimeTransformInput(req.gM)
    };
  };

  var $author$project$Api$Types$CharacterizeTimeTransformReq$toInputFlowsOf = function (baseDescriptor) {
    switch (baseDescriptor.$) {
      case 0:
        var derivativeBlockDescriptorInput = baseDescriptor.a;
        return {
          ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          dM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          fG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          bM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(derivativeBlockDescriptorInput)
        };

      case 1:
        var basicBlockDescriptorInput = baseDescriptor.a;
        return {
          ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(basicBlockDescriptorInput),
          dM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          fG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          bM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };

      case 2:
        var characterizeTimeTransformReq = baseDescriptor.a;
        return {
          ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          dM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          fG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$Types$CharacterizeTimeTransformReq$toInput(characterizeTimeTransformReq)),
          bM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };

      default:
        var id = baseDescriptor.a;
        return {
          ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          dM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Types$BuildingBlock$unwrapBuildingBlockId(id)),
          fG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          bM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        };
    }
  };

  var $author$project$Api$Api$characterizeTimeTransform = F5(function (operationName, req, tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A4($author$project$Api$Api$queryRequestTaskNamed, operationName, url, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$timeTransforms(A2($author$project$Api$GraphqlSchema$Object$TimeTransformsQuery$characterizeTimeTransform, {
      W: $author$project$Api$Types$CharacterizeTimeTransformReq$toInput(req)
    }, $author$project$Api$Schema$characterizeTimeTransformPayload))));
  });
  var $author$project$Ui$Block$StateWatch$characterizeBasicMoneyBlock = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    var company = _v0.c;
    return _Utils_Tuple3(state, A5($author$project$Api$Api$characterizeTimeTransform, 'CharacterizeBasicMoneyBlock', req, A2($author$project$Ui$Block$Msg$ReceiveBasicMoneyCharacterization, company, req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });
  var $author$project$Ui$Block$Msg$ReceiveDerivativeCharacterization = F2(function (a, b) {
    return {
      $: 9,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Block$StateWatch$characterizeDerivativeBlock = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    return _Utils_Tuple3(state, A5($author$project$Api$Api$characterizeTimeTransform, 'CharacterizeDerivativeBlockTimeTransform', req, $author$project$Ui$Block$Msg$ReceiveDerivativeCharacterization(req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });
  var $author$project$Ui$Block$Msg$ReceiveDerivativeMoneyCharacterization = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Block$StateWatch$characterizeDerivativeMoneyTransformation = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    return _Utils_Tuple3(state, A5($author$project$Api$Api$characterizeTimeTransform, 'CharacterizeDerivativeBlockBasisTransform', req, $author$project$Ui$Block$Msg$ReceiveDerivativeMoneyCharacterization(req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });
  var $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild = F3(function (_v0, topState, _v1) {
    var toValue = _v0.t5;
    var handler = _v0.hz;
    var old = _v1.eY;
    var _new = _v1.d7;

    var _v2 = A2(toValue, topState.d7, _new);

    if (!_v2.$) {
      var newValue = _v2.a;
      return !_Utils_eq(A2(toValue, topState.eY, old), $elm$core$Maybe$Just(newValue)) ? $elm$core$Maybe$Just(A3(handler, topState.d7, _new, newValue)) : $elm$core$Maybe$Nothing;
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Ui$Block$Msg$ReceiveBaseFlow = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeTimeTransformBaseFlowInput = function (_v0) {
    var input____ = _v0;
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('flowOf', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Block_of_enum$toString, input____.dT))), _Utils_Tuple2('inputFlowsOf', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfInputFlowsDescriptorInput(input____.dU))), _Utils_Tuple2('range', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c_, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hd;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('startOn', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.bw)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$TimeTransformsQuery$baseFlow = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'baseFlow', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeTimeTransformBaseFlowInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$Types$BaseFlowResponse$BaseFlowResponse = function (baseTimeSeries) {
    return {
      ve: baseTimeSeries
    };
  };

  var $author$project$Api$GraphqlSchema$Object$BaseFlowSuccessPayload$baseTimeSeries = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'baseTimeSeries', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$GraphqlSchema$Union$BaseFlowPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BaseFlowSuccessPayload', selections____.mE), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O)]));
  };

  var $author$project$Api$Schema$baseFlowPayload = function () {
    var theBaseFlowPayload = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BaseFlowSuccessPayload$baseTimeSeries($author$project$Api$Schema$flowElem), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$BaseFlowResponse$BaseFlowResponse));
    return $author$project$Api$GraphqlSchema$Union$BaseFlowPayload$fragments({
      mE: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, theBaseFlowPayload),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message)
    });
  }();

  var $author$project$Api$GraphqlSchema$InputObject$TimeTransformBaseFlowInput = $elm$core$Basics$identity;

  var $author$project$Api$Types$BaseFlowReq$toInput = function (req) {
    return {
      dT: req.rv,
      dU: $author$project$Api$Types$CharacterizeTimeTransformReq$toInputFlowsOf(req.o8),
      c_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      bw: req.bw
    };
  };

  var $author$project$Api$Api$baseFlow = F4(function (req, tag, url, idToken) {
    return A2($elm$core$Task$attempt, tag, A4($author$project$Api$Api$queryRequestTaskNamed, 'BaseFlow', url, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$timeTransforms(A2($author$project$Api$GraphqlSchema$Object$TimeTransformsQuery$baseFlow, {
      W: $author$project$Api$Types$BaseFlowReq$toInput(req)
    }, $author$project$Api$Schema$baseFlowPayload))));
  });
  var $author$project$Ui$Block$StateWatch$getBaseFlow = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    return _Utils_Tuple3(state, A4($author$project$Api$Api$baseFlow, req, $author$project$Ui$Block$Msg$ReceiveBaseFlow(req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });

  var $author$project$Ui$Block$StateWatch$isAppropriateRoute = function (topState) {
    var _v0 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

    _v0$2: while (true) {
      if (_v0.$ === 5 && _v0.b.$ === 3) {
        switch (_v0.b.a.$) {
          case 4:
            return $elm$core$Maybe$Just(0);

          case 5:
            var _v1 = _v0.b.a;
            return $elm$core$Maybe$Just(0);

          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }

    return $elm$core$Maybe$Nothing;
  };

  var $TSFoster$elm_tuple_extra$Tuple3$join = F3(function (a, b, c) {
    return _Utils_Tuple3(a, b, c);
  });

  var $author$project$Ui$Block$StateWatch$toCompany = function (topState) {
    return A3($elm_community$maybe_extra$Maybe$Extra$andThen2, $turboMaCk$any_dict$Dict$Any$get, $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc)), A2($elm$core$Maybe$map, function ($) {
      return $.v5;
    }, $author$project$Remote$Model$toSession(topState.o_.CT)));
  };

  var $author$project$Ui$Block$StateWatch$watchers = _List_fromArray([$author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Block$StateWatch$getBaseFlow,
    t5: F2(function (topState, state) {
      var maybeCompany = $author$project$Ui$Block$StateWatch$toCompany(topState);
      return A2($elm$core$Maybe$andThen, $elm$core$Basics$always(A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, $author$project$Remote$Model$toAuth(topState.o_.CT), A2($elm$core$Maybe$andThen, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$Ui$Block$Model$toBaseFlowReq, state), maybeCompany))), $author$project$Ui$Block$StateWatch$isAppropriateRoute(topState));
    })
  }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Block$StateWatch$characterizeBasicMoneyBlock,
    t5: F2(function (topState, state) {
      var maybeCompany = $author$project$Ui$Block$StateWatch$toCompany(topState);
      return A2($elm$core$Maybe$andThen, $elm$core$Basics$always(A4($elm$core$Maybe$map3, $TSFoster$elm_tuple_extra$Tuple3$join, $author$project$Remote$Model$toAuth(topState.o_.CT), A2($elm$core$Maybe$andThen, A2($author$project$ElmFramework$Lib$Util$flip, $author$project$Ui$Block$Model$toBasicMoneyCharacterizeReq, state), maybeCompany), maybeCompany)), $author$project$Ui$Block$StateWatch$isAppropriateRoute(topState));
    })
  }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Block$StateWatch$characterizeDerivativeBlock,
    t5: F2(function (topState, state) {
      return A2($elm$core$Maybe$andThen, $elm$core$Basics$always(A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, $author$project$Remote$Model$toAuth(topState.o_.CT), $author$project$Ui$Block$Model$toDerivativeCharacterizeReq(state))), $author$project$Ui$Block$StateWatch$isAppropriateRoute(topState));
    })
  }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Block$StateWatch$characterizeDerivativeMoneyTransformation,
    t5: F2(function (topState, state) {
      return A2($elm$core$Maybe$andThen, $elm$core$Basics$always(A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, $author$project$Remote$Model$toAuth(topState.o_.CT), $author$project$Ui$Block$Model$toDerivativeMoneyCharacterizeReq(state))), $author$project$Ui$Block$StateWatch$isAppropriateRoute(topState));
    })
  }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: F3(function (_v0, state, maybeSelectedSeasonalityPreset) {
      return _Utils_Tuple3(_Utils_update(state, {
        bv: A2($author$project$Types$EditingBuildingBlock$EditingBuildingBlock$setBasicPayload, state.bv, A2($author$project$Types$EditingBuildingBlock$EditingBasicPayload$setSeasonality, state.bv.fD, $author$project$Types$EditingBuildingBlock$EditingSeasonality$fromSeasonalityPreset(maybeSelectedSeasonalityPreset)))
      }), $elm$core$Platform$Cmd$none, _List_Nil);
    }),
    t5: F2(function (topState, state) {
      return A2($elm$core$Maybe$andThen, function (seasonalityPresetId) {
        var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.tc);

        if (_v1.$ === 5) {
          var companyId = _v1.a;
          return A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(seasonalityPresetId), A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
            return $.ti;
          }, $krisajenkins$remotedata$RemoteData$toMaybe), A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(companyId), A2($elm$core$Maybe$map, function ($) {
            return $.v5;
          }, $author$project$Remote$Model$toSession(topState.o_.CT)))));
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }, state.bv.fD.bK.sH.ia);
    })
  })]);

  var $author$project$Ui$Blocks$Msg$ReceiveBaseFlow = F3(function (a, b, c) {
    return {
      $: 6,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$Blocks$StateWatch$getBaseFlow = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    var blockId = _v0.c;
    return _Utils_Tuple3(state, A4($author$project$Api$Api$baseFlow, req, A2($author$project$Ui$Blocks$Msg$ReceiveBaseFlow, blockId, req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });

  var $author$project$Ui$Blocks$StateWatch$watchers = _List_fromArray([$author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Blocks$StateWatch$getBaseFlow,
    t5: F2(function (topState, _v0) {
      return A4($elm$core$Maybe$map3, $TSFoster$elm_tuple_extra$Tuple3$join, $author$project$Remote$Model$toAuth(topState.o_.CT), $author$project$Ui$Blocks$Util$toBaseFlowReq(topState), A2($elm$core$Maybe$map, $elm$core$Tuple$second, $author$project$Ui$Blocks$Util$toBlockIdFromRoute(topState)));
    })
  })]);

  var $author$project$Ui$Budget$Msg$ReceiveBudgetQueryResponse = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Api$Types$BudgetResponse$BudgetResponse = F2(function (budgetDetails, transactionSummary) {
    return {
      vA: budgetDetails,
      Fb: transactionSummary
    };
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeBudgetInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('basis', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Basis_enum$toString, input____.pb))), _Utils_Tuple2('comparisonScenarioId', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.pA))), _Utils_Tuple2('divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioQuery$budget = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'budget', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeBudgetInput)]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$BudgetSuccess$budgetDetails = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'budgetDetails', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Union$BudgetPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BudgetSuccess', selections____.z9), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioCalculationError', selections____.mT), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioCalculationError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Types$ScenarioFinancials$KeyMetrics = F7(function (grossMargin, grossProfit, netIncome, netMargin, operatingMargin, operatingProfit, revenue) {
    return {
      x0: grossMargin,
      x1: grossProfit,
      zP: netIncome,
      zQ: netMargin,
      Ce: operatingMargin,
      Cf: operatingProfit,
      C9: revenue
    };
  });
  var $author$project$Types$ScenarioFinancials$PeriodFinancials = F3(function (period, budgetScenarioMetrics, comparisonScenarioMetrics) {
    return {
      vB: budgetScenarioMetrics,
      v6: comparisonScenarioMetrics,
      ap: period
    };
  });
  var $author$project$Types$ScenarioFinancials$ScenarioFinancials = F3(function (periods, totalBudgetScenarioMetrics, totalComparisonScenarioMetrics) {
    return {
      Cn: periods,
      E6: totalBudgetScenarioMetrics,
      E7: totalComparisonScenarioMetrics
    };
  });

  var $author$project$Api$GraphqlSchema$Object$PeriodFinancials$budgetScenarioMetrics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'budgetScenarioMetrics', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$PeriodFinancials$comparisonScenarioMetrics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'comparisonScenarioMetrics', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$grossMargin = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Decimal)', 'grossMargin', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB));
  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$grossProfit = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'grossProfit', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$netIncome = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'netIncome', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$netMargin = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Decimal)', 'netMargin', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB));
  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$operatingMargin = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Decimal)', 'operatingMargin', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB));
  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$operatingProfit = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'operatingProfit', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$GraphqlSchema$Object$PeriodFinancials$period = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Period', 'period', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).hd.wB);

  var $author$project$Api$GraphqlSchema$Object$ScenarioFinancials$periods = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'periods', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$GraphqlSchema$Object$KeyMetrics$revenue = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'revenue', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);

  var $author$project$Api$GraphqlSchema$Object$ScenarioFinancials$totalBudgetScenarioMetrics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'totalBudgetScenarioMetrics', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioFinancials$totalComparisonScenarioMetrics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'totalComparisonScenarioMetrics', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Schema$scenarioFinancials = function () {
    var keyMetrics = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$revenue, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$operatingProfit, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$operatingMargin, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$netMargin, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$netIncome, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$grossProfit, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$KeyMetrics$grossMargin, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$ScenarioFinancials$KeyMetrics))))))));
    var periodFinancials = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PeriodFinancials$comparisonScenarioMetrics(keyMetrics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PeriodFinancials$budgetScenarioMetrics(keyMetrics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PeriodFinancials$period, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$ScenarioFinancials$PeriodFinancials))));
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioFinancials$totalComparisonScenarioMetrics(keyMetrics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioFinancials$totalBudgetScenarioMetrics(keyMetrics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioFinancials$periods(periodFinancials), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$ScenarioFinancials$ScenarioFinancials))));
  }();

  var $author$project$Api$GraphqlSchema$Query$scenarioLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'scenarioLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.F, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });

  var $author$project$Api$GraphqlSchema$Object$BudgetSuccess$transactionSummary = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'transactionSummary', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Types$TransactionSummary$TransactionSummary = F2(function (rows, dates) {
    return {
      cD: dates,
      tf: rows
    };
  });

  var $author$project$Api$GraphqlSchema$Object$TransactionSummary$headingRow = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'headingRow', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$TransactionSummaryHeadingRow$periods = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List Api.ScalarCodecs.LocalDate)', 'periods', _List_Nil, $elm$json$Json$Decode$list($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).b8.wB));
  var $author$project$Api$Schema$headingSummaryRow = $author$project$Api$GraphqlSchema$Object$TransactionSummaryHeadingRow$periods;

  var $author$project$Api$GraphqlSchema$Object$TransactionSummary$rows = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'rows', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Types$TransactionSummary$Cell = function (value) {
    return {
      Fw: value
    };
  };

  var $author$project$Api$GraphqlSchema$Interface$TransactionSummaryValue$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TransactionSummaryDollarValue', selections____.mX), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TransactionSummaryPctValue', selections____.mY)]));
  };

  var $author$project$Api$GraphqlSchema$Object$TransactionSummaryDollarValue$value = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Decimal)', 'value', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB));
  var $author$project$Api$Schema$transactionSummaryDollarValue = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$TransactionSummary$CurrencyValue, $author$project$Api$GraphqlSchema$Object$TransactionSummaryDollarValue$value);

  var $author$project$Types$TransactionSummary$Ratio = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Object$TransactionSummaryPctValue$value = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Decimal)', 'value', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB));
  var $author$project$Api$Schema$transactionSummaryPctValue = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$TransactionSummary$Ratio, $author$project$Api$GraphqlSchema$Object$TransactionSummaryPctValue$value);
  var $author$project$Api$Schema$cashboardQueryCell = $author$project$Api$GraphqlSchema$Interface$TransactionSummaryValue$fragments({
    mX: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$TransactionSummary$Cell, $author$project$Api$Schema$transactionSummaryDollarValue),
    mY: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Types$TransactionSummary$Cell, $author$project$Api$Schema$transactionSummaryPctValue)
  });

  var $author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$cells = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cells', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, A2($elm$core$Basics$composeR, $elm$json$Json$Decode$nullable, $elm$json$Json$Decode$list)));
  };

  var $author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$children = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'children', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(function (constant, _v0) {
    var objectFields = _v0.a;
    var objectDecoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, objectFields, A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, $elm$json$Json$Decode$succeed(constant), objectDecoder));
  });
  var $author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$label = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'label', _List_Nil, $elm$json$Json$Decode$string);

  var $author$project$Api$Schema$transactionSummaryRow = function () {
    var transactionSummaryRowSelection = function (childrenSelection) {
      return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$label, childrenSelection(A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$cells($author$project$Api$Schema$cashboardQueryCell), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F3(function (cells, children, label) {
        return {
          vR: cells,
          vU: children,
          y$: label
        };
      })))));
    };

    var transactionSummaryRowChildrensChildren = transactionSummaryRowSelection($dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded(_List_Nil));
    var transactionSummaryRowChildren = transactionSummaryRowSelection($dillonkearns$elm_graphql$Graphql$SelectionSet$with($author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$children(transactionSummaryRowChildrensChildren)));
    return transactionSummaryRowSelection($dillonkearns$elm_graphql$Graphql$SelectionSet$with($author$project$Api$GraphqlSchema$Object$TransactionSummaryRow$children(transactionSummaryRowChildren)));
  }();

  var $author$project$Api$Schema$transactionSummary = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TransactionSummary$headingRow($author$project$Api$Schema$headingSummaryRow), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$TransactionSummary$rows($author$project$Api$Schema$transactionSummaryRow), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$TransactionSummary$TransactionSummary)));
  var $author$project$Api$Api$calculateBudget = F5(function (scenarioId, req, tag, url, idToken) {
    var calculateBudgetResponse = function () {
      var budgetResponse = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BudgetSuccess$transactionSummary($author$project$Api$Schema$transactionSummary), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BudgetSuccess$budgetDetails($author$project$Api$Schema$scenarioFinancials), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$BudgetResponse$BudgetResponse)));
      return $author$project$Api$GraphqlSchema$Union$BudgetPayload$fragments({
        z9: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, budgetResponse),
        M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
        N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
        O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
        mT: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioCalculationError$message),
        bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
      });
    }();

    var calculateBudgetTask = A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$scenarioLogic, {
      F: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Scenario$unwrapScenarioId, scenarioId)
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioQuery$budget, {
      W: {
        pb: req.pb,
        pA: A2($author$project$Api$ScalarCodecs$toUuid, $author$project$Types$Scenario$unwrapScenarioId, req.pA),
        eO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($elm$core$List$map, $author$project$Api$ScalarCodecs$toUuid($author$project$Types$Division$unwrapDivisionId), req.eO))
      }
    }, calculateBudgetResponse)));
    return A2($elm$core$Task$attempt, tag, A2($elm$core$Task$mapError, $author$project$Api$Api$sanitizeErrType, calculateBudgetTask));
  });
  var $author$project$Ui$Budget$StateWatch$calculateBudget = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    var scenarioId = _v0.c;
    return _Utils_Tuple3(state, A5($author$project$Api$Api$calculateBudget, scenarioId, req, $author$project$Ui$Budget$Msg$ReceiveBudgetQueryResponse(req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });

  var $author$project$Ui$Budget$StateWatch$watchers = _List_fromArray([$author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Budget$StateWatch$calculateBudget,
    t5: F2(function (_v0, _v1) {
      var appState = _v0.o_;
      var route = _v0.tc;
      var maybeBudgetScenario = A2($elm$core$Maybe$andThen, function ($) {
        return $.pe;
      }, A3($elm_community$maybe_extra$Maybe$Extra$andThen2, $author$project$Types$UserSession$toCompany, $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route)), $author$project$Remote$Model$toSession(appState.CT)));
      return A4($elm$core$Maybe$map3, F3(function (a, b, c) {
        return _Utils_Tuple3(a, b, c);
      }), $author$project$Remote$Model$toAuth(appState.CT), $author$project$Route$RouteUtil$toBudgetQuery($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route)), maybeBudgetScenario);
    })
  })]);

  var $author$project$Ui$Cashboard$StateWatch$CalculateProjectionDiff = F4(function (auth, query, company, relationships) {
    return {
      u_: auth,
      j: company,
      sR: query,
      CS: relationships
    };
  });
  var $author$project$Ui$Cashboard$Msg$ReceiveCashboardQueryResponse = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeCashboardPersistentScenarioInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accountType', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString, input____.it))), _Utils_Tuple2('divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('reportingInterval', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString, input____.jD)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioQuery$cashboard = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cashboard', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCashboardPersistentScenarioInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Types$CashboardResponse = F2(function (cashboardDetails, transactionSummary) {
    return {
      vN: cashboardDetails,
      Fb: transactionSummary
    };
  });

  var $author$project$Api$GraphqlSchema$Object$CashboardSuccess$cashboardDetails = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cashboardDetails', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Types$CashboardQuery$CashboardDetails = F3(function (periods, projectionErr, scenarioMetrics) {
    return {
      Cn: periods,
      CC: projectionErr,
      DA: scenarioMetrics
    };
  });

  var $author$project$Api$GraphqlSchema$Object$CashboardDetails$metrics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'metrics', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Schema$ApiPeriodDetailsBalance = F4(function (sumOfFlows, actualPosition, projectedPosition, projectedErr) {
    return {
      kd: actualPosition,
      sO: projectedErr,
      np: projectedPosition,
      or: sumOfFlows
    };
  });

  var $author$project$Api$GraphqlSchema$Object$Balances$actualPosition = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'actualPosition', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };

  var $author$project$Types$CashboardQuery$BalancePeriodPosition = F2(function (position, positionType) {
    return {
      Cu: position,
      Cv: positionType
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Position$position = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'position', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$GraphqlSchema$Enum$PositionType$Projected = 1;
  var $author$project$Api$GraphqlSchema$Enum$PositionType$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ACTUAL':
        return $elm$json$Json$Decode$succeed(0);

      case 'PROJECTED':
        return $elm$json$Json$Decode$succeed(1);

      default:
        return $elm$json$Json$Decode$fail('Invalid PositionType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Position$positionType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PositionType.PositionType', 'positionType', _List_Nil, $author$project$Api$GraphqlSchema$Enum$PositionType$decoder);
  var $author$project$Api$Schema$position = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Position$positionType, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Position$position, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$CashboardQuery$BalancePeriodPosition)));
  var $author$project$Api$GraphqlSchema$Object$Balances$projectedPosition = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'projectedPosition', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$GraphqlSchema$Object$Balances$projectionError = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Decimal)', 'projectionError', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB));
  var $author$project$Api$GraphqlSchema$Object$Balances$sumOfFlows = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'sumOfFlows', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$Schema$balance = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Balances$projectionError, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Balances$projectedPosition, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Balances$actualPosition($author$project$Api$Schema$position), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Balances$sumOfFlows, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$ApiPeriodDetailsBalance)))));

  var $author$project$Api$GraphqlSchema$Object$PeriodDetails$balances = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'balances', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$PeriodDetails$metrics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'metrics', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$GraphqlSchema$Object$PeriodDetails$period = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Period', 'period', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).hd.wB);

  var $author$project$Api$GraphqlSchema$Union$PeriodMetrics$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PeriodCashMetrics', selections____.mP), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PeriodCreditMetrics', selections____.mQ)]));
  };

  var $author$project$Api$GraphqlSchema$Object$PeriodCashMetrics$cashOnHand = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Int)', 'cashOnHand', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
  var $author$project$Api$GraphqlSchema$Object$PeriodCashMetrics$cashRunway = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Int)', 'cashRunway', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
  var $author$project$Api$Schema$periodCashMetrics = A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, F2(function (coh, cr) {
    return $author$project$Types$CashboardQuery$PeriodMetricsCash({
      pm: coh,
      tg: cr
    });
  }), $author$project$Api$GraphqlSchema$Object$PeriodCashMetrics$cashOnHand, $author$project$Api$GraphqlSchema$Object$PeriodCashMetrics$cashRunway);

  var $author$project$Types$CashboardQuery$PeriodMetricsCredit = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Object$PeriodCreditMetrics$cashCreditRatio = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'cashCreditRatio', _List_Nil, $elm$json$Json$Decode$float);
  var $author$project$Api$Schema$periodCreditMetrics = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, function (ccr) {
    return $author$project$Types$CashboardQuery$PeriodMetricsCredit({
      vM: ccr
    });
  }, $author$project$Api$GraphqlSchema$Object$PeriodCreditMetrics$cashCreditRatio);
  var $author$project$Api$Schema$periodMetrics = $author$project$Api$GraphqlSchema$Union$PeriodMetrics$fragments({
    mP: $author$project$Api$Schema$periodCashMetrics,
    mQ: $author$project$Api$Schema$periodCreditMetrics
  });
  var $author$project$Api$Schema$periodDetails = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PeriodDetails$metrics($author$project$Api$Schema$periodMetrics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PeriodDetails$period, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PeriodDetails$balances($author$project$Api$Schema$balance), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F3(function (apiBalance, period, metrics) {
    return {
      kd: apiBalance.kd,
      zx: metrics,
      ap: period,
      np: apiBalance.np,
      CC: apiBalance.sO,
      or: apiBalance.or
    };
  })))));

  var $author$project$Api$GraphqlSchema$Object$CashboardDetails$periods = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'periods', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };

  var $author$project$Api$GraphqlSchema$Object$CashboardDetails$projectionError = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'projectionError', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);

  var $author$project$Api$GraphqlSchema$Union$ScenarioMetrics$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioCashMetrics', selections____.mU), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioCreditMetrics', selections____.mV)]));
  };

  var $author$project$Types$CashboardQuery$ScenarioMetricsCash = function (a) {
    return {
      $: 0,
      a: a
    };
  };

  var $author$project$Types$CashboardQuery$BalanceLimit = F2(function (amount, on) {
    return {
      p: amount,
      z_: on
    };
  });
  var $author$project$Api$GraphqlSchema$Object$BalanceLimit$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Decimal', 'amount', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).eN.wB);
  var $author$project$Api$GraphqlSchema$Object$BalanceLimit$on = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.LocalDate', 'on', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).b8.wB);
  var $author$project$Api$Schema$balanceLimit = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BalanceLimit$on, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BalanceLimit$amount, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$CashboardQuery$BalanceLimit)));
  var $author$project$Api$GraphqlSchema$Object$ScenarioCashMetrics$cashOnHand = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Int)', 'cashOnHand', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
  var $author$project$Api$GraphqlSchema$Object$ScenarioCashMetrics$cashRunway = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Int)', 'cashRunway', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));

  var $author$project$Api$GraphqlSchema$Object$ScenarioCashMetrics$minBalance = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'minBalance', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Schema$scenarioCashMetrics = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioCashMetrics$cashOnHand, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioCashMetrics$cashRunway, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioCashMetrics$minBalance($author$project$Api$Schema$balanceLimit), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F3(function (minBal, runWay, cashOnHand) {
    return $author$project$Types$CashboardQuery$ScenarioMetricsCash({
      pm: cashOnHand,
      zA: minBal,
      tg: runWay
    });
  })))));

  var $author$project$Types$CashboardQuery$ScenarioMetricsCredit = function (a) {
    return {
      $: 1,
      a: a
    };
  };

  var $author$project$Api$GraphqlSchema$Object$ScenarioCreditMetrics$maxBalance = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'maxBalance', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Schema$scenarioCreditMetrics = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ScenarioCreditMetrics$maxBalance($author$project$Api$Schema$balanceLimit), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(function (maxBalance) {
    return $author$project$Types$CashboardQuery$ScenarioMetricsCredit({
      zl: maxBalance
    });
  }));
  var $author$project$Api$Schema$scenarioMetrics = $author$project$Api$GraphqlSchema$Union$ScenarioMetrics$fragments({
    mU: $author$project$Api$Schema$scenarioCashMetrics,
    mV: $author$project$Api$Schema$scenarioCreditMetrics
  });
  var $author$project$Api$Schema$cashboardDetails = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CashboardDetails$metrics($author$project$Api$Schema$scenarioMetrics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $JoshuaHall$elm_fraction$Fraction$toFloat, $author$project$Api$GraphqlSchema$Object$CashboardDetails$projectionError), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CashboardDetails$periods($author$project$Api$Schema$periodDetails), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$CashboardQuery$CashboardDetails))));

  var $author$project$Api$GraphqlSchema$Object$CashboardSuccess$transactionSummary = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'transactionSummary', _List_Nil, object____, $elm$core$Basics$identity);
  };

  var $author$project$Api$Schema$cashboardSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CashboardSuccess$transactionSummary($author$project$Api$Schema$transactionSummary), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CashboardSuccess$cashboardDetails($author$project$Api$Schema$cashboardDetails), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Types$CashboardResponse)));

  var $author$project$Api$GraphqlSchema$Union$CashboardPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CashboardSuccess', selections____.rK), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.M), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.N), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.O), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioCalculationError', selections____.mT), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ScenarioNotFound', selections____.bJ)]));
  };

  var $author$project$Api$Api$calculateProjection = F5(function (_v0, _v1, tag, url, idToken) {
    var accountType = _v1.it;
    var divisions = _v1.eO;
    var reportingInterval = _v1.jD;
    var scenario = _v1.Dw;
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$scenarioLogic, {
      F: $author$project$Api$Schema$uuidFromString($author$project$Types$Scenario$unwrapScenarioId(scenario))
    }, A2($author$project$Api$GraphqlSchema$Object$ScenarioQuery$cashboard, {
      W: {
        it: accountType,
        eO: $elm$core$List$isEmpty(divisions) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Types$Division$unwrapDivisionId, $author$project$Api$Schema$uuidFromString), divisions)),
        jD: reportingInterval
      }
    }, $author$project$Api$GraphqlSchema$Union$CashboardPayload$fragments({
      rK: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$cashboardSuccess),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      mT: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioCalculationError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    })))));
  });
  var $author$project$Ui$Cashboard$StateWatch$calculateProjection = F3(function (topState, state, _v0) {
    var auth = _v0.u_;
    var query = _v0.sR;
    var company = _v0.j;
    return _Utils_Tuple3(state, A5($author$project$Api$Api$calculateProjection, company, query, $author$project$Ui$Cashboard$Msg$ReceiveCashboardQueryResponse(query), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });
  var $author$project$Ui$Cashboard$StateWatch$redirectToScenarios = F3(function (topState, state, companyId) {
    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.E0, $elm$core$Maybe$Nothing, 'Please choose a base scenario first', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Do(A2($author$project$Route$Route$SelectedCompany, companyId, $author$project$Route$CompanyRoute$Scenarios($author$project$Route$ScenariosRoute$Scenarios)))]));
  });
  var $author$project$Ui$Cashboard$StateWatch$toRelationships = F3(function (route, remote, time) {
    var maybeSession = $author$project$Remote$Model$toSession(remote);
    var maybeScenarioId = A2($elm$core$Maybe$map, function ($) {
      return $.Dw;
    }, $author$project$Route$RouteUtil$toCashboardQuery(route));
    var maybeFilters = A3($elm$core$Maybe$map2, $author$project$Types$Filters$withQuickEdits, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.Fl;
    }, function ($) {
      return $.F;
    }), maybeSession), $elm$core$Maybe$Just($author$project$Types$Filters$empty));
    var maybeCompany = A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, A3($elm$core$Maybe$map2, $author$project$Types$UserSession$toCompany, $author$project$Route$RouteUtil$toCompanyId(route), $author$project$Remote$Model$toSession(remote)));
    var maybeBlocksAndRelationships = A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, A4($elm$core$Maybe$map3, function (filters) {
      return A2($author$project$Types$Company$toBuildingBlocksAndRelationshipsForScenario, $elm$core$Maybe$Just(filters), $elm$core$Maybe$Just(time));
    }, maybeFilters, maybeScenarioId, maybeCompany));
    return A2($elm$core$Maybe$map, $elm$core$List$map(function (_v0) {
      var block = _v0.a;
      var rel = _v0.b;
      return {
        vi: block.oB,
        yO: rel.la
      };
    }), maybeBlocksAndRelationships);
  });

  var $author$project$Ui$Cashboard$StateWatch$watchers = _List_fromArray([$author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Cashboard$StateWatch$calculateProjection,
    t5: F2(function (_v0, _v1) {
      var appState = _v0.o_;
      var route = _v0.tc;
      var time = _v0.EM;
      return A5($elm$core$Maybe$map4, $author$project$Ui$Cashboard$StateWatch$CalculateProjectionDiff, $author$project$Remote$Model$toAuth(appState.CT), $author$project$Route$RouteUtil$toCashboardQuery($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route)), $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route)), A3($author$project$Ui$Cashboard$StateWatch$toRelationships, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route), appState.CT, time));
    })
  }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Cashboard$StateWatch$redirectToScenarios,
    t5: F2(function (_v2, _v3) {
      var appState = _v2.o_;
      var route = _v2.tc;

      var _v4 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route);

      if (_v4.$ === 5 && !_v4.b.$) {
        var companyId = _v4.a;
        var _v5 = _v4.b;
        return A2($elm$core$Maybe$map, $elm$core$Basics$always(companyId), A2($elm_community$maybe_extra$Maybe$Extra$filter, A2($elm$core$Basics$composeR, function ($) {
          return $.pa;
        }, $elm_community$maybe_extra$Maybe$Extra$isNothing), A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(companyId), A2($elm$core$Maybe$map, function ($) {
          return $.v5;
        }, $author$project$Remote$Model$toSession(appState.CT)))));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    })
  })]);

  var $author$project$Ui$Scenario$Msg$ReceiveCashboardQueryResponse = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });

  var $author$project$Api$GraphqlSchema$InputObject$encodeScenarioCalcDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('length', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.rf))), _Utils_Tuple2('scenarioBlocks', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeCashboardScenarioBlockInput)(input____.Dy))), _Utils_Tuple2('startAt', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.b8;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.tB)))]));
  };

  var $author$project$Api$GraphqlSchema$InputObject$encodeCashboardScenarioCalcDescriptorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accountType', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Account_type_enum$toString, input____.it))), _Utils_Tuple2('divisions', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs)))), _Utils_Tuple2('reportingInterval', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Reporting_interval_enum$toString, input____.jD))), _Utils_Tuple2('scenarioCalcDescriptor', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeScenarioCalcDescriptorInput(input____.Dz)))]));
  };

  var $author$project$Api$GraphqlSchema$Object$CashboardQuery$cashboard = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cashboard', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.W, $author$project$Api$GraphqlSchema$InputObject$encodeCashboardScenarioCalcDescriptorInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Query$cashboardLogic = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cashboardLogic', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'companyId', requiredArgs____.b9, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.L;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$calculateProjectionDirectly = F5(function (companyId, req, tag, url, idToken) {
    var toBlockDesc = function (blockId) {
      return {
        dM: $author$project$Types$BuildingBlock$unwrapBuildingBlockId(blockId),
        la: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
        CK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
        CL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
      };
    };

    var input = {
      it: req.it,
      eO: $elm$core$List$isEmpty(req.eO) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Types$Division$unwrapDivisionId, $author$project$Api$Schema$uuidFromString), req.eO)),
      jD: req.jD,
      Dz: {
        rf: $author$project$Types$Scenario$scenarioLengthToNoOfMonths(req.rf),
        Dy: A2($elm$core$List$map, toBlockDesc, req.vk),
        tB: req.tB
      }
    };
    var fragments = {
      rK: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$cashboardSuccess),
      M: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      N: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      O: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      mT: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioCalculationError$message),
      bJ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ScenarioNotFound$message)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, url, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Query$cashboardLogic, {
      b9: $author$project$Types$Company$unwrapCompanyId(companyId)
    }, A2($author$project$Api$GraphqlSchema$Object$CashboardQuery$cashboard, {
      W: input
    }, $author$project$Api$GraphqlSchema$Union$CashboardPayload$fragments(fragments)))));
  });
  var $author$project$Ui$Scenario$StateWatch$calculateProjection = F3(function (topState, state, _v0) {
    var auth = _v0.a;
    var req = _v0.b;
    var companyId = _v0.c;
    return _Utils_Tuple3(state, A5($author$project$Api$Api$calculateProjectionDirectly, companyId, req, $author$project$Ui$Scenario$Msg$ReceiveCashboardQueryResponse(req), topState.o_.qC.dy.oZ, auth.d5), _List_Nil);
  });

  var $author$project$Ui$Scenario$StateWatch$watchers = _List_fromArray([$author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$diffChild({
    hz: $author$project$Ui$Scenario$StateWatch$calculateProjection,
    t5: F2(function (_v0, state) {
      var zone = _v0.by;
      var appState = _v0.o_;
      var route = _v0.tc;
      var theCashboardQueryDirect = A2($elm$core$Maybe$andThen, A3($author$project$Ui$Scenario$Model$toCashboardQueryDirect, zone, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route), state), $author$project$Remote$Model$toSession(appState.CT));
      return A4($elm$core$Maybe$map3, F3(function (a, b, c) {
        return _Utils_Tuple3(a, b, c);
      }), $author$project$Remote$Model$toAuth(appState.CT), theCashboardQueryDirect, $author$project$Route$RouteUtil$toCompanyId($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route)));
    })
  })]);

  var $author$project$MainModule$config = {
    u6: function (_v0) {
      return 0;
    },
    xY: false,
    yp: $author$project$MainModule$init,
    y_: $elm$core$Basics$always(_List_Nil),
    Ak: F2(function (state, route) {
      return A3($author$project$MainModule$onNewRouteMsgs, state, state.tc, route);
    }),
    AX: F2(function (_v1, _v2) {
      return _List_Nil;
    }),
    AZ: F2(function (_v3, _v4) {
      return _List_Nil;
    }),
    Be: F2(function (geoPoint, _v5) {
      return $author$project$MulticastMessages$onNewGeolocation($author$project$Model$Geo$GpsTypeGeolocation(geoPoint));
    }),
    Bi: F2(function (_v6, _v7) {
      return _List_Nil;
    }),
    Bl: $author$project$PushMsgRouter$pushMsgRouter,
    Bm: F2(function (_v8, _v9) {
      return _List_Nil;
    }),
    Bx: F2(function (state, route) {
      return _Utils_ap(A3($author$project$MainModule$onNewRouteMsgs, state, state.tc, route), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (rt) {
        return _List_fromArray([$author$project$Msg$sendRemoteMsg(A2($author$project$Remote$Msg$RefreshUserToken, $elm$core$Maybe$Nothing, rt))]);
      }, $author$project$Remote$Model$toRefreshToken(state.o_.CT))));
    }),
    BO: F3(function (_v10, _v11, _v12) {
      return _List_Nil;
    }),
    Cq: function (_v13) {
      return {
        uI: 'Tap to reload',
        uJ: 'New version ready to go!',
        xT: 'Please let us locate you',
        xU: 'Your location is unavailable at the moment',
        xV: 'Make sure your location services are ON and try again',
        xW: 'Locating you took too long',
        CG: 'Push notifications do not seem to be supported on your device',
        D2: 'Copied to clipboard'
      };
    },
    Dt: $author$project$MainModule$routingConfig,
    El: $elm$core$List$concat(_List_fromArray([$author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          vh: childState
        });
      }),
      ry: $author$project$Msg$BlockMsg,
      uo: $author$project$Ui$Block$StateWatch$stateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          Cb: childState
        });
      }),
      ry: $author$project$Msg$OnboardingCompanyMsg,
      uo: $author$project$Ui$OnboardingCompany$StateWatch$switchUpStateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$map({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          vh: childState
        });
      }),
      ry: $author$project$Msg$BlockMsg,
      t4: A2($elm$core$Basics$composeR, function ($) {
        return $.o_;
      }, function ($) {
        return $.vh;
      }),
      uo: $author$project$Ui$Block$StateWatch$watchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$map({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          vl: childState
        });
      }),
      ry: $author$project$Msg$BlocksMsg,
      t4: A2($elm$core$Basics$composeR, function ($) {
        return $.o_;
      }, function ($) {
        return $.vl;
      }),
      uo: $author$project$Ui$Blocks$StateWatch$watchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          DB: childState
        });
      }),
      ry: $author$project$Msg$ScenarioMsg,
      uo: $author$project$Ui$Scenario$StateWatch$switchUpStateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$map({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          vO: childState
        });
      }),
      ry: $author$project$Msg$CashboardMsg,
      t4: A2($elm$core$Basics$composeR, function ($) {
        return $.o_;
      }, function ($) {
        return $.vO;
      }),
      uo: $author$project$Ui$Cashboard$StateWatch$watchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$map({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          DB: childState
        });
      }),
      ry: $author$project$Msg$ScenarioMsg,
      t4: A2($elm$core$Basics$composeR, function ($) {
        return $.o_;
      }, function ($) {
        return $.DB;
      }),
      uo: $author$project$Ui$Scenario$StateWatch$watchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$map({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          vC: childState
        });
      }),
      ry: $author$project$Msg$BudgetMsg,
      t4: A2($elm$core$Basics$composeR, function ($) {
        return $.o_;
      }, function ($) {
        return $.vC;
      }),
      uo: $author$project$Ui$Budget$StateWatch$watchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          vC: childState
        });
      }),
      ry: $author$project$Msg$BudgetMsg,
      uo: $author$project$Ui$Budget$StateWatch$stateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          CT: childState
        });
      }),
      ry: $author$project$Msg$RemoteMsg,
      uo: $author$project$Remote$StateWatch$stateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, _v14) {
        return appState;
      }),
      ry: $elm$core$Basics$identity,
      uo: $author$project$Ui$Idle$StateWatch$stateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          D0: childState
        });
      }),
      ry: $author$project$Msg$SettingsMsg,
      uo: $author$project$Ui$Settings$StateWatch$stateWatchers
    }), $author$project$ElmFramework$Feature$Auth$StateWatch$StateWatch$onSwitchUp({
      ps: F2(function (appState, childState) {
        return _Utils_update(appState, {
          Fo: childState
        });
      }),
      ry: $author$project$Msg$UserProfileMsg,
      uo: $author$project$Ui$UserProfile$StateWatch$stateWatchers
    })])),
    Ev: $author$project$MainModule$subscriptions,
    EN: 60000,
    Ff: $author$project$Update$update,
    Fz: $author$project$MainModule$view
  };
  var $author$project$MainModule$main = $author$project$ElmFramework$Main$app($author$project$MainModule$config);

  _Platform_export({
    'MainModule': {
      'init': $author$project$MainModule$main(A2($elm$json$Json$Decode$andThen, function (elmFrameworkArgs) {
        return A2($elm$json$Json$Decode$andThen, function (appArgs) {
          return $elm$json$Json$Decode$succeed({
            uH: appArgs,
            k4: elmFrameworkArgs
          });
        }, A2($elm$json$Json$Decode$field, 'appArgs', A2($elm$json$Json$Decode$andThen, function (preFetchedStaticData) {
          return A2($elm$json$Json$Decode$andThen, function (persistedStaticData) {
            return A2($elm$json$Json$Decode$andThen, function (persisted) {
              return A2($elm$json$Json$Decode$andThen, function (configArgs) {
                return $elm$json$Json$Decode$succeed({
                  v9: configArgs,
                  Co: persisted,
                  Cp: persistedStaticData,
                  Cw: preFetchedStaticData
                });
              }, A2($elm$json$Json$Decode$field, 'configArgs', A2($elm$json$Json$Decode$andThen, function (termsOfUseUrl) {
                return A2($elm$json$Json$Decode$andThen, function (privacyPolicyUrl) {
                  return A2($elm$json$Json$Decode$andThen, function (googleMaps) {
                    return A2($elm$json$Json$Decode$andThen, function (firebase) {
                      return A2($elm$json$Json$Decode$andThen, function (facebookId) {
                        return A2($elm$json$Json$Decode$andThen, function (appUrl) {
                          return A2($elm$json$Json$Decode$andThen, function (apiUrl) {
                            return $elm$json$Json$Decode$succeed({
                              oZ: apiUrl,
                              uK: appUrl,
                              xH: facebookId,
                              xL: firebase,
                              x$: googleMaps,
                              Cy: privacyPolicyUrl,
                              EG: termsOfUseUrl
                            });
                          }, A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
                        }, A2($elm$json$Json$Decode$field, 'appUrl', $elm$json$Json$Decode$string));
                      }, A2($elm$json$Json$Decode$field, 'facebookId', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'firebase', A2($elm$json$Json$Decode$andThen, function (apiKey) {
                      return $elm$json$Json$Decode$succeed({
                        oY: apiKey
                      });
                    }, A2($elm$json$Json$Decode$field, 'apiKey', $elm$json$Json$Decode$string))));
                  }, A2($elm$json$Json$Decode$field, 'googleMaps', A2($elm$json$Json$Decode$andThen, function (placesApiKey) {
                    return $elm$json$Json$Decode$succeed({
                      Cs: placesApiKey
                    });
                  }, A2($elm$json$Json$Decode$field, 'placesApiKey', $elm$json$Json$Decode$string))));
                }, A2($elm$json$Json$Decode$field, 'privacyPolicyUrl', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'termsOfUseUrl', $elm$json$Json$Decode$string))));
            }, A2($elm$json$Json$Decode$field, 'persisted', A2($elm$json$Json$Decode$andThen, function (auth) {
              return $elm$json$Json$Decode$succeed({
                u_: auth
              });
            }, A2($elm$json$Json$Decode$field, 'auth', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A2($elm$json$Json$Decode$andThen, function (refreshToken) {
              return A2($elm$json$Json$Decode$andThen, function (idToken) {
                return A2($elm$json$Json$Decode$andThen, function (expiresIn) {
                  return $elm$json$Json$Decode$succeed({
                    hr: expiresIn,
                    d5: idToken,
                    e6: refreshToken
                  });
                }, A2($elm$json$Json$Decode$field, 'expiresIn', $elm$json$Json$Decode$int));
              }, A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string)))]))))));
          }, A2($elm$json$Json$Decode$field, 'persistedStaticData', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)]))));
        }, A2($elm$json$Json$Decode$field, 'preFetchedStaticData', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)]))))));
      }, A2($elm$json$Json$Decode$field, 'elmFrameworkArgs', A2($elm$json$Json$Decode$andThen, function (timezoneOffset) {
        return A2($elm$json$Json$Decode$andThen, function (navigationLocation) {
          return A2($elm$json$Json$Decode$andThen, function (geolocationAccessAllowed) {
            return A2($elm$json$Json$Decode$andThen, function (env) {
              return A2($elm$json$Json$Decode$andThen, function (currTime) {
                return A2($elm$json$Json$Decode$andThen, function (browser) {
                  return $elm$json$Json$Decode$succeed({
                    vz: browser,
                    wo: currTime,
                    xz: env,
                    xR: geolocationAccessAllowed,
                    zN: navigationLocation,
                    EQ: timezoneOffset
                  });
                }, A2($elm$json$Json$Decode$field, 'browser', A2($elm$json$Json$Decode$andThen, function (width) {
                  return A2($elm$json$Json$Decode$andThen, function (unitSize) {
                    return A2($elm$json$Json$Decode$andThen, function (pixelRatio) {
                      return A2($elm$json$Json$Decode$andThen, function (height) {
                        return $elm$json$Json$Decode$succeed({
                          x6: height,
                          sA: pixelRatio,
                          j6: unitSize,
                          FE: width
                        });
                      }, A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
                    }, A2($elm$json$Json$Decode$field, 'pixelRatio', $elm$json$Json$Decode$float));
                  }, A2($elm$json$Json$Decode$field, 'unitSize', $elm$json$Json$Decode$int));
                }, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))));
              }, A2($elm$json$Json$Decode$field, 'currTime', $elm$json$Json$Decode$int));
            }, A2($elm$json$Json$Decode$field, 'env', A2($elm$json$Json$Decode$andThen, function (supportsWebShare) {
              return A2($elm$json$Json$Decode$andThen, function (supportsWebPayments) {
                return A2($elm$json$Json$Decode$andThen, function (pwaInstallStatus) {
                  return A2($elm$json$Json$Decode$andThen, function (isWeb) {
                    return A2($elm$json$Json$Decode$andThen, function (isProd) {
                      return A2($elm$json$Json$Decode$andThen, function (isIos) {
                        return A2($elm$json$Json$Decode$andThen, function (isHybridIos) {
                          return A2($elm$json$Json$Decode$andThen, function (isHybridAndroid) {
                            return A2($elm$json$Json$Decode$andThen, function (isHybrid) {
                              return A2($elm$json$Json$Decode$andThen, function (isDev) {
                                return A2($elm$json$Json$Decode$andThen, function (isAndroid) {
                                  return A2($elm$json$Json$Decode$andThen, function (isActiveDevelopment) {
                                    return $elm$json$Json$Decode$succeed({
                                      i$: isActiveDevelopment,
                                      i0: isAndroid,
                                      i3: isDev,
                                      yQ: isHybrid,
                                      i5: isHybridAndroid,
                                      i6: isHybridIos,
                                      i8: isIos,
                                      i9: isProd,
                                      jd: isWeb,
                                      jx: pwaInstallStatus,
                                      jX: supportsWebPayments,
                                      Ey: supportsWebShare
                                    });
                                  }, A2($elm$json$Json$Decode$field, 'isActiveDevelopment', $elm$json$Json$Decode$bool));
                                }, A2($elm$json$Json$Decode$field, 'isAndroid', $elm$json$Json$Decode$bool));
                              }, A2($elm$json$Json$Decode$field, 'isDev', $elm$json$Json$Decode$bool));
                            }, A2($elm$json$Json$Decode$field, 'isHybrid', $elm$json$Json$Decode$bool));
                          }, A2($elm$json$Json$Decode$field, 'isHybridAndroid', $elm$json$Json$Decode$bool));
                        }, A2($elm$json$Json$Decode$field, 'isHybridIos', $elm$json$Json$Decode$bool));
                      }, A2($elm$json$Json$Decode$field, 'isIos', $elm$json$Json$Decode$bool));
                    }, A2($elm$json$Json$Decode$field, 'isProd', $elm$json$Json$Decode$bool));
                  }, A2($elm$json$Json$Decode$field, 'isWeb', $elm$json$Json$Decode$bool));
                }, A2($elm$json$Json$Decode$field, 'pwaInstallStatus', $elm$json$Json$Decode$bool));
              }, A2($elm$json$Json$Decode$field, 'supportsWebPayments', $elm$json$Json$Decode$bool));
            }, A2($elm$json$Json$Decode$field, 'supportsWebShare', $elm$json$Json$Decode$bool))));
          }, A2($elm$json$Json$Decode$field, 'geolocationAccessAllowed', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)]))));
        }, A2($elm$json$Json$Decode$field, 'navigationLocation', A2($elm$json$Json$Decode$andThen, function (search) {
          return A2($elm$json$Json$Decode$andThen, function (protocol) {
            return A2($elm$json$Json$Decode$andThen, function (port_) {
              return A2($elm$json$Json$Decode$andThen, function (pathname) {
                return A2($elm$json$Json$Decode$andThen, function (origin) {
                  return A2($elm$json$Json$Decode$andThen, function (href) {
                    return A2($elm$json$Json$Decode$andThen, function (hostname) {
                      return A2($elm$json$Json$Decode$andThen, function (host) {
                        return A2($elm$json$Json$Decode$andThen, function (hash) {
                          return $elm$json$Json$Decode$succeed({
                            lB: hash,
                            lE: host,
                            lF: hostname,
                            lG: href,
                            m$: origin,
                            nb: pathname,
                            nm: port_,
                            nt: protocol,
                            nU: search
                          });
                        }, A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
                      }, A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
                  }, A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
          }, A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
        }, A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
      }, A2($elm$json$Json$Decode$field, 'timezoneOffset', $elm$json$Json$Decode$int)))))(0)
    }
  });
})(this);